(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 87179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cn/common.json": [
		53275,
		275
	],
	"./en/common.json": [
		40464,
		464
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87179;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 86360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ convertIcon; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/env.js
const BASE_CLASS_PREFIX = 'semi';
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/components/Icon.js
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



// import '../styles/icons.css';
const Icon = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      svg,
      spin = false,
      rotate,
      style,
      className,
      prefixCls = BASE_CLASS_PREFIX,
      type,
      size = 'default'
    } = props,
    restProps = __rest(props, ["svg", "spin", "rotate", "style", "className", "prefixCls", "type", "size"]);
  const classes = classnames_default()(`${prefixCls}-icon`, {
    [`${prefixCls}-icon-extra-small`]: size === 'extra-small',
    [`${prefixCls}-icon-small`]: size === 'small',
    [`${prefixCls}-icon-default`]: size === 'default',
    [`${prefixCls}-icon-large`]: size === 'large',
    [`${prefixCls}-icon-extra-large`]: size === 'extra-large',
    [`${prefixCls}-icon-spinning`]: spin === true,
    [`${prefixCls}-icon-${type}`]: Boolean(type)
  }, className);
  const outerStyle = {};
  if (Number.isSafeInteger(rotate)) {
    outerStyle.transform = `rotate(${rotate}deg)`;
  }
  Object.assign(outerStyle, style);
  return /*#__PURE__*/react.createElement("span", Object.assign({
    role: "img",
    ref: ref,
    "aria-label": type,
    className: classes,
    style: outerStyle
  }, restProps), svg);
});
// @ts-ignore used to judge whether it is a semi-icon in semi-ui
// custom icon case
Icon.elementType = 'Icon';
const convertIcon = (Svg, iconType) => {
  const InnerIcon = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/react.createElement(Icon, Object.assign({
    svg: /*#__PURE__*/react.createElement(Svg),
    type: iconType,
    ref: ref
  }, props)));
  // @ts-ignore used to judge whether it is a semi-icon in semi-ui 
  // builtin icon case
  InnerIcon.elementType = 'Icon';
  return InnerIcon;
};

/* harmony default export */ var components_Icon = ((/* unused pure expression or super */ null && (Icon)));

/***/ }),

/***/ 52689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86360);


function SvgComponent(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2782 4.23933C16.864 4.82511 16.864 5.77486 16.2782 6.36065L10.6213 12.0175L16.2782 17.6744C16.864 18.2601 16.864 19.2099 16.2782 19.7957C15.6924 20.3815 14.7426 20.3815 14.1569 19.7957L7.43934 13.0782C6.85355 12.4924 6.85355 11.5426 7.43934 10.9568L14.1569 4.23933C14.7426 3.65354 15.6924 3.65354 16.2782 4.23933Z",
    fill: "currentColor"
  }));
}
const IconComponent = (0,_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* .convertIcon */ .A)(SvgComponent, 'chevron_left');
/* harmony default export */ __webpack_exports__["Z"] = (IconComponent);

/***/ }),

/***/ 85957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ breadcrumb; },
  "zx": function() { return /* reexport */ es_button; },
  "XZ": function() { return /* reexport */ es_checkbox; },
  "cO": function() { return /* reexport */ checkboxGroup; },
  "UO": function() { return /* reexport */ collapse; },
  "zF": function() { return /* reexport */ collapsible; },
  "l0": function() { return /* reexport */ baseForm; },
  "Ee": function() { return /* reexport */ es_image; },
  "II": function() { return /* reexport */ es_input; },
  "P_": function() { return /* reexport */ notification; },
  "tl": function() { return /* reexport */ Pagination; },
  "J2": function() { return /* reexport */ popover; },
  "Ph": function() { return /* reexport */ es_select; },
  "Uu": function() { return /* reexport */ SideSheet; },
  "Jm": function() { return /* reexport */ tabs_TabPane; },
  "mQ": function() { return /* reexport */ tabs; },
  "FN": function() { return /* reexport */ es_toast; },
  "mp": function() { return /* reexport */ tree; },
  "mP": function() { return /* reexport */ treeSelect; }
});

// UNUSED EXPORTS: Anchor, ArrayField, AutoComplete, Avatar, AvatarGroup, BackTop, Badge, Banner, BaseComponent, BaseFoundation, ButtonGroup, Calendar, Card, CardGroup, Carousel, Cascader, Col, ConfigProvider, DatePicker, Descriptions, Divider, Dropdown, DropdownDivider, DropdownItem, DropdownMenu, Empty, Highlight, Icon, IconButton, ImagePreview, InputGroup, InputNumber, Layout, List, LocaleConsumer, LocaleProvider, Modal, Nav, NavItem, OverflowList, Popconfirm, Progress, Radio, RadioGroup, Rating, Row, ScrollItem, ScrollList, Skeleton, Slider, Space, Spin, SplitButtonGroup, Step, Steps, SubNav, Switch, Table, Tag, TagGroup, TagInput, TextArea, TimePicker, Timeline, ToastFactory, Tooltip, Transfer, Typography, Upload, semiGlobal, useFieldApi, useFieldState, useFormApi, useFormState, withField, withFormApi, withFormState

// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var isFunction = __webpack_require__(23560);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/base/env.js
const BASE_CLASS_PREFIX = 'semi';
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/breadcrumb/constants.js

const cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-breadcrumb`
};
const constants_strings = {
  MORE_TYPE: ['default', 'popover']
};

// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/log.js
/* provided dependency */ var process = __webpack_require__(83454);

const log = function (text) {
  if (get_default()(process, 'env.NODE_ENV') === 'development') {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    console.log(text, ...rest);
  }
};
/* harmony default export */ var utils_log = (log);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/base/foundation.js

/**
 * The Semi Foundation / Adapter architecture split was inspired by Material Component For Web. （https://github.com/material-components/material-components-web）
 * We re-implemented our own code based on the principle and added more functions we need according to actual needs.
 *
 */

class BaseFoundation {
  /** @return enum{css className} */
  /* istanbul ignore next */
  static get cssClasses() {
    // Classes extending Foundation should implement this method to return an object which exports every
    // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'component--active'}
    return {};
  }
  /** @return enum{strings} */
  /* istanbul ignore next */
  static get strings() {
    // Classes extending Foundation should implement this method to return an object which exports all
    // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
    return {};
  }
  /** @return enum{numbers} */
  /* istanbul ignore next */
  static get numbers() {
    // Classes extending Foundation should implement this method to return an object which exports all
    // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
    return {};
  }
  static get defaultAdapter() {
    return {
      getProp: (noop_default()),
      getProps: (noop_default()),
      getState: (noop_default()),
      getStates: (noop_default()),
      setState: (noop_default()),
      getContext: (noop_default()),
      getContexts: (noop_default()),
      getCache: (noop_default()),
      setCache: (noop_default()),
      getCaches: (noop_default()),
      stopPropagation: (noop_default()),
      persistEvent: (noop_default())
    };
  }
  constructor(adapter) {
    this._adapter = Object.assign(Object.assign({}, BaseFoundation.defaultAdapter), adapter);
  }
  getProp(key) {
    return this._adapter.getProp(key);
  }
  getProps() {
    return this._adapter.getProps();
  }
  getState(key) {
    return this._adapter.getState(key);
  }
  getStates() {
    return this._adapter.getStates();
  }
  setState(states, cb) {
    return this._adapter.setState(Object.assign({}, states), cb);
  }
  getContext(key) {
    return this._adapter.getContext(key);
  }
  /* istanbul ignore next */
  getContexts() {
    return this._adapter.getContexts();
  }
  /* istanbul ignore next */
  getCaches() {
    return this._adapter.getCaches();
  }
  getCache(key) {
    return this._adapter.getCache(key);
  }
  setCache(key, value) {
    return key && this._adapter.setCache(key, value);
  }
  stopPropagation(e) {
    this._adapter.stopPropagation(e);
  }
  // Determine whether a controlled component
  _isControlledComponent() {
    let key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
    const props = this.getProps();
    const isControlComponent = (key in props);
    return isControlComponent;
  }
  // Does the user have incoming props, eg: _isInProps (value)
  _isInProps(key) {
    const props = this.getProps();
    return key in props;
  }
  init(lifecycle) {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
  }
  destroy() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
  }
  /* istanbul ignore next */
  log(text) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    utils_log(text, ...rest);
  }
  _persistEvent(e) {
    // only work for react adapter for now
    this._adapter.persistEvent(e);
  }
}
/* harmony default export */ var foundation = (BaseFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/keyCode.js
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 */
const keyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  /**
   * END
   */
  END: 35,
  /**
   * HOME
   */
  HOME: 36,
  /**
   * LEFT
   */
  LEFT: 37,
  /**
   * UP
   */
  UP: 38,
  /**
   * RIGHT
   */
  RIGHT: 39,
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  /**
   * DASH
   */
  DASH: 189,
  /**
   * EQUALS
   */
  EQUALS: 187,
  /**
   * COMMA
   */
  COMMA: 188,
  /**
   * PERIOD
   */
  PERIOD: 190,
  /**
   * SLASH
   */
  SLASH: 191,
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  /**
   * WIN_IME
   */
  WIN_IME: 229
};
const ENTER_KEY = 'Enter';
const TAB_KEY = 'Tab';
const ESC_KEY = 'Escape';
/* harmony default export */ var utils_keyCode = (keyCode);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isEnterPress.js


function isEnterPress(e) {
  return get_default()(e, 'key') === ENTER_KEY ? true : false;
}
/* harmony default export */ var utils_isEnterPress = (isEnterPress);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/breadcrumb/foundation.js


class BreadcrumbFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  handleClick(info, event) {
    this._adapter.notifyClick(info, event);
  }
  handleExpand(clickEvent) {
    this._adapter.expandCollapsed(clickEvent);
  }
  /**
   * A11y: simulate clear button click
   */
  handleExpandEnterPress(keyboardEvent) {
    if (utils_isEnterPress(keyboardEvent)) {
      this.handleExpand(keyboardEvent);
    }
  }
  genRoutes(routes) {
    return routes.map(route => {
      if (typeof route !== 'object') {
        return {
          name: route,
          _origin: {
            name: route
          }
        };
      }
      let config = {};
      config._origin = route;
      return Object.assign(Object.assign({}, config), route);
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/warning.js
function warning(flag, info) {
  if (flag) {
    console.warn(`Warning: ${info}`);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/function.js
/**
 * no operation
 */
function function_noop() {}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/getDataAttr.js
function getDataAttr(props) {
  return Object.keys(props).reduce((prev, key) => {
    if (key.substr(0, 5) === 'data-') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_base/baseComponent.js
/**
 * The Semi Foundation / Adapter architecture split was inspired by Material Component For Web. （https://github.com/material-components/material-components-web）
 * We re-implemented our own code based on the principle and added more functions we need according to actual needs.
 */



const {
  hasOwnProperty: baseComponent_hasOwnProperty
} = Object.prototype;
// eslint-disable-next-line
class BaseComponent extends react.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line
    this.isControlled = key => Boolean(key && this.props && typeof this.props === 'object' && baseComponent_hasOwnProperty.call(this.props, key));
    this.cache = {};
    this.foundation = null;
  }
  componentDidMount() {
    this.foundation && typeof this.foundation.init === 'function' && this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation && typeof this.foundation.destroy === 'function' && this.foundation.destroy();
    this.cache = {};
  }
  get adapter() {
    return {
      getContext: key => {
        if (this.context && key) {
          return this.context[key];
        }
      },
      getContexts: () => this.context,
      getProp: key => this.props[key],
      // return all props
      getProps: () => this.props,
      getState: key => this.state[key],
      getStates: () => this.state,
      setState: (states, cb) => this.setState(Object.assign({}, states), cb),
      getCache: key => key && this.cache[key],
      getCaches: () => this.cache,
      setCache: (key, value) => key && (this.cache[key] = value),
      stopPropagation: e => {
        try {
          e.stopPropagation();
          e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
        } catch (error) {}
      },
      persistEvent: e => {
        e && e.persist && typeof e.persist === 'function' ? e.persist() : null;
      }
    };
  }
  log(text) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return utils_log(text, ...rest);
  }
  getDataAttr(props) {
    return getDataAttr(props);
  }
}
BaseComponent.propTypes = {};
BaseComponent.defaultProps = {};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/configProvider/context.js

const ConfigContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var context = (ConfigContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tooltip/constants.js

const constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-tooltip`
};
const tooltip_constants_strings = {
  POSITION_SET: ['top', 'topLeft', 'topRight', 'left', 'leftTop', 'leftBottom', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'leftTopOver', 'rightTopOver', 'leftBottomOver', 'rightBottomOver'],
  TRIGGER_SET: ['hover', 'focus', 'click', 'custom', 'contextMenu'],
  STATUS_DISABLED: 'disabled',
  STATUS_LOADING: 'loading'
};
const numbers = {
  ARROW_BOUNDING: {
    offsetX: 0,
    offsetY: 2,
    width: 24,
    height: 7
  },
  DEFAULT_Z_INDEX: 1060,
  MOUSE_ENTER_DELAY: 50,
  MOUSE_LEAVE_DELAY: 50,
  SPACING: 8,
  MARGIN: 0
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/popover/constants.js


const popover_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-popover`,
  ARROW: `${BASE_CLASS_PREFIX}-popover-icon-arrow`
};
const popover_constants_strings = {
  POSITION_SET: ['top', 'topLeft', 'topRight', 'left', 'leftTop', 'leftBottom', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'leftTopOver', 'rightTopOver'],
  TRIGGER_SET: ['hover', 'focus', 'click', 'custom', 'contextMenu'],
  DEFAULT_ARROW_STYLE: {
    borderOpacity: '1',
    backgroundColor: 'var(--semi-color-bg-3)',
    // borderColor: 'var(--semi-color-shadow)',
    borderColor: 'var(--semi-color-border)'
  }
};
const constants_numbers = {
  ARROW_BOUNDING: Object.assign(Object.assign({}, numbers.ARROW_BOUNDING), {
    offsetY: 6,
    offsetX: 0,
    height: 8
  }),
  SPACING: 4,
  SPACING_WITH_ARROW: 10,
  DEFAULT_Z_INDEX: 1030
};

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__(66073);
var each_default = /*#__PURE__*/__webpack_require__.n(each);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isNullOrUndefined.js
/**
 * Whether null or undefined
 * @param {*} value
 * @returns  {boolean}
 */
function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/Event.js

class Event {
  constructor() {
    this._eventMap = new Map();
  }
  on(event, callback) {
    if (event && typeof callback === 'function') {
      this._eventMap.has(event) || this._eventMap.set(event, []);
      this._eventMap.get(event).push(callback);
    }
    return this;
  }
  once(event, callback) {
    var _this = this;
    if (event && typeof callback === 'function') {
      const fn = function () {
        callback(...arguments);
        _this.off(event, fn);
      };
      this.on(event, fn);
    }
  }
  off(event, callback) {
    if (event) {
      if (typeof callback === 'function') {
        const callbacks = this._eventMap.get(event);
        if (Array.isArray(callbacks) && callbacks.length) {
          let index = -1;
          while ((index = callbacks.findIndex(cb => cb === callback)) > -1) {
            callbacks.splice(index, 1);
          }
        }
      } else if (isNullOrUndefined(callback)) {
        this._eventMap.delete(event);
      }
    }
    return this;
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!this._eventMap.has(event)) {
      return false;
    }
    const callbacks = [...this._eventMap.get(event)];
    // clone to avoid someone writing  the logic of deleting callback in callbacks into his or her callback code, for example the once func above
    callbacks.forEach(callback => callback(...args));
    return true;
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/dom.js

/**
 *
 * @param {HTMLElement} parentNode
 * @param  {...HTMLElement} nodes
 *
 * @param {HTMLElement}
 */
function append(parentNode) {
  for (var _len = arguments.length, nodes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    nodes[_key - 1] = arguments[_key];
  }
  for (const node of nodes) {
    parentNode.appendChild(node);
  }
  return parentNode;
}
/**
 *
 * @param {HTMLElement} parentNode
 * @param  {...HTMLElement} nodes
 *
 * @param {HTMLElement}
 */
function prepend(parentNode) {
  for (var _len2 = arguments.length, nodes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    nodes[_key2 - 1] = arguments[_key2];
  }
  if (parentNode.children && parentNode.children.length) {
    const firstNode = parentNode.children[0];
    for (const node of nodes) {
      parentNode.insertBefore(node, firstNode);
    }
  } else {
    append(parentNode, ...nodes);
  }
  return parentNode;
}
/**
 *
 * @param {DOMRect} domRect
 * @returns {object|undefined}
 */
function convertDOMRectToObject(domRect) {
  if (domRect && typeof domRect === 'object') {
    if (typeof domRect.toJSON === 'function') {
      return domRect.toJSON();
    } else {
      const keys = ['left', 'top', 'right', 'bottom', 'width', 'height'];
      return keys.reduce((obj, key) => {
        obj[key] = domRect[key];
        return obj;
      }, {});
    }
  }
  return undefined;
}

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/a11y.js

function handlePrevent(event) {
  event.stopPropagation();
  event.preventDefault();
}
function isPrintableCharacter(string) {
  return string.length === 1 && string.match(/\S/);
}
// set focus to the target item in item list
function setFocusToItem(itemNodes, targetItem) {
  for (let i = 0; i < itemNodes.length; i++) {
    if (itemNodes[i] === targetItem) {
      itemNodes[i].tabIndex = 0;
      itemNodes[i].focus();
    } else {
      itemNodes[i].tabIndex = -1;
    }
  }
}
// set focus to the first item in item list
function setFocusToFirstItem(itemNodes) {
  itemNodes.length > 0 && setFocusToItem(itemNodes, itemNodes[0]);
}
// set focus to the last item in item list
function setFocusToLastItem(itemNodes) {
  itemNodes.length > 0 && setFocusToItem(itemNodes, itemNodes[itemNodes.length - 1]);
}
// set focus to the previous item in item list
function setFocusToPreviousMenuItem(itemNodes, currentItem) {
  let newMenuItem, index;
  if (itemNodes.length > 0) {
    if (currentItem === itemNodes[0]) {
      newMenuItem = itemNodes[itemNodes.length - 1];
    } else {
      index = itemNodes.indexOf(currentItem);
      newMenuItem = itemNodes[index - 1];
    }
    setFocusToItem(itemNodes, newMenuItem);
  }
}
// set focus to the next item in item list
function setFocusToNextMenuitem(itemNodes, currentItem) {
  let newMenuItem, index;
  if (itemNodes.length > 0) {
    if (currentItem === itemNodes[itemNodes.length - 1]) {
      newMenuItem = itemNodes[0];
    } else {
      index = itemNodes.indexOf(currentItem);
      newMenuItem = itemNodes[index + 1];
    }
    setFocusToItem(itemNodes, newMenuItem);
  }
}
function findIndexByCharacter(itemList, curItem, firstCharList, char) {
  let start, index;
  if (!itemList || !firstCharList || !char || char.length > 1) {
    return -1;
  }
  char = char.toLowerCase();
  // Get start index for search based on position of currentItem
  start = itemList.indexOf(curItem) + 1;
  if (start >= itemList.length) {
    start = 0;
  }
  // Check remaining menu items in the menu
  index = firstCharList.indexOf(char, start);
  // If not found in remaining menu items, check from beginning
  if (index === -1) {
    index = firstCharList.indexOf(char, 0);
  }
  return index >= 0 ? index : -1;
}
function getAncestorNodeByRole(curElement, role) {
  if (!curElement) {
    return null;
  }
  while (curElement.parentElement && get_default()(curElement.parentElement, 'attributes.role.value', '') !== role) {
    curElement = curElement.parentElement;
  }
  return curElement.parentElement;
}
// According to the Id, find the corresponding data-popupid element
function getMenuButton(focusableEle, Id) {
  for (let i = 0; i < focusableEle.length; i++) {
    const curAriDescribedby = focusableEle[i].attributes['data-popupid'];
    if (curAriDescribedby && curAriDescribedby.value === Id) {
      return focusableEle[i];
    }
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tooltip/foundation.js




const REGS = {
  TOP: /top/i,
  RIGHT: /right/i,
  BOTTOM: /bottom/i,
  LEFT: /left/i
};
const defaultRect = {
  left: 0,
  top: 0,
  height: 0,
  width: 0,
  scrollLeft: 0,
  scrollTop: 0
};
class foundation_Tooltip extends foundation {
  constructor(adapter) {
    var _this;
    super(Object.assign({}, adapter));
    _this = this;
    this.removePortal = () => {
      this._adapter.removePortal();
    };
    this.setDisplayNone = (displayNone, cb) => {
      this._adapter.setDisplayNone(displayNone, cb);
    };
    this.updateStateIfCursorOnTrigger = trigger => {
      var _a, _b;
      if ((_a = trigger === null || trigger === void 0 ? void 0 : trigger.matches) === null || _a === void 0 ? void 0 : _a.call(trigger, ":hover")) {
        const eventNames = this._adapter.getEventName();
        const triggerEventSet = this.getState("triggerEventSet");
        (_b = triggerEventSet[eventNames.mouseEnter]) === null || _b === void 0 ? void 0 : _b.call(triggerEventSet);
      }
    };
    this.onResize = () => {
      // this.log('resize');
      // rePosition when window resize
      this.calcPosition();
    };
    this.delayShow = () => {
      const mouseEnterDelay = this.getProp('mouseEnterDelay');
      this.clearDelayTimer();
      if (mouseEnterDelay > 0) {
        this._timer = setTimeout(() => {
          this.show();
          this.clearDelayTimer();
        }, mouseEnterDelay);
      } else {
        this.show();
      }
    };
    this.show = () => {
      const content = this.getProp('content');
      const trigger = this.getProp('trigger');
      const clickTriggerToHide = this.getProp('clickTriggerToHide');
      const {
        visible,
        displayNone
      } = this.getStates();
      if (displayNone) {
        this.setDisplayNone(false);
      }
      if (visible) {
        return;
      }
      this.clearDelayTimer();
      /**
       * If you emit an event in setState callback, you need to place the event listener function before setState to execute.
       * This is to avoid event registration being executed later than setState callback when setState is executed in setTimeout.
       * internal-issues:1402#note_38969412
       */
      this._adapter.on('portalInserted', () => {
        this.calcPosition();
      });
      if (trigger === "hover") {
        const checkTriggerIsHover = () => {
          const triggerDOM = this._adapter.getTriggerDOM();
          if (trigger && !triggerDOM.matches(":hover")) {
            this.hide();
          }
          this._adapter.off("portalInserted", checkTriggerIsHover);
        };
        this._adapter.on('portalInserted', checkTriggerIsHover);
      }
      this._adapter.on('positionUpdated', () => {
        this._togglePortalVisible(true);
      });
      this._adapter.insertPortal(content, {
        left: -9999,
        top: -9999
      }); // offscreen rendering
      if (trigger === 'custom') {
        this._adapter.registerClickOutsideHandler(() => {});
      }
      /**
       * trigger类型是click时，仅当portal被插入显示后，才绑定clickOutsideHandler
       * 因为handler需要绑定在document上。如果在constructor阶段绑定
       * 当一个页面中有多个容器实例时，一次click会触发多个容器的handler
       *
       * When the trigger type is click, clickOutsideHandler is bound only after the portal is inserted and displayed
       * Because the handler needs to be bound to the document. If you bind during the constructor phase
       * When there are multiple container instances in a page, one click triggers the handler of multiple containers
       */
      if (trigger === 'click' || clickTriggerToHide || trigger === 'contextMenu') {
        this._adapter.registerClickOutsideHandler(this.hide);
      }
      this._bindScrollEvent();
      this._bindResizeEvent();
    };
    /**
     * 耦合的东西比较多，稍微罗列一下：
     *
     * - 根据 trigger 和 wrapper 的 boundingClient 计算当前的 left、top、transform-origin
     * - 根据当前的 position 和 wrapper 的 boundingClient 决定是否需要自动调整位置
     * - 根据当前的 position、trigger 的 boundingClient 以及 motion.handleStyle 调整当前的 style
     *
     * There are many coupling things, a little list:
     *
     * - calculate the current left, top, and transfer-origin according to the boundingClient of trigger and wrapper
     * - decide whether to automatically adjust the position according to the current position and the boundingClient of wrapper
     * - adjust the current style according to the current position, the boundingClient of trigger and motion.handle Style
     */
    this.calcPosition = function (triggerRect, wrapperRect, containerRect) {
      let shouldUpdatePos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      triggerRect = (isEmpty_default()(triggerRect) ? _this._adapter.getTriggerBounding() : triggerRect) || Object.assign({}, defaultRect);
      containerRect = (isEmpty_default()(containerRect) ? _this._adapter.getPopupContainerRect() : containerRect) || Object.assign({}, defaultRect);
      wrapperRect = (isEmpty_default()(wrapperRect) ? _this._adapter.getWrapperBounding() : wrapperRect) || Object.assign({}, defaultRect);
      // console.log('containerRect: ', containerRect, 'triggerRect: ', triggerRect, 'wrapperRect: ', wrapperRect);
      let style = _this.calcPosStyle({
        triggerRect,
        wrapperRect,
        containerRect
      });
      let position = _this.getProp('position');
      if (_this.getProp('autoAdjustOverflow')) {
        // console.log('style: ', style, '\ntriggerRect: ', triggerRect, '\nwrapperRect: ', wrapperRect);
        const {
          position: adjustedPos,
          isHeightOverFlow,
          isWidthOverFlow
        } = _this.adjustPosIfNeed(position, style, triggerRect, wrapperRect, containerRect);
        if (position !== adjustedPos || isHeightOverFlow || isWidthOverFlow) {
          position = adjustedPos;
          style = _this.calcPosStyle({
            triggerRect,
            wrapperRect,
            containerRect,
            position,
            spacing: null,
            isOverFlow: [isHeightOverFlow, isWidthOverFlow]
          });
        }
      }
      if (shouldUpdatePos && _this._mounted) {
        // this._adapter.updatePlacementAttr(style.position);
        _this._adapter.setPosition(Object.assign(Object.assign({}, style), {
          position
        }));
      }
      return style;
    };
    this.delayHide = () => {
      const mouseLeaveDelay = this.getProp('mouseLeaveDelay');
      this.clearDelayTimer();
      if (mouseLeaveDelay > 0) {
        this._timer = setTimeout(() => {
          // console.log('delayHide for ', mouseLeaveDelay, ' ms, ', ...args);
          this.hide();
          this.clearDelayTimer();
        }, mouseLeaveDelay);
      } else {
        this.hide();
      }
    };
    this.hide = () => {
      this.clearDelayTimer();
      this._togglePortalVisible(false);
      this._adapter.off('portalInserted');
      this._adapter.off('positionUpdated');
    };
    this.handleContainerKeydown = event => {
      const {
        guardFocus,
        closeOnEsc
      } = this.getProps();
      switch (event && event.key) {
        case "Escape":
          closeOnEsc && this._handleEscKeyDown(event);
          break;
        case "Tab":
          if (guardFocus) {
            const container = this._adapter.getContainer();
            const focusableElements = this._adapter.getFocusableElements(container);
            const focusableNum = focusableElements.length;
            if (focusableNum) {
              // Shift + Tab will move focus backward
              if (event.shiftKey) {
                this._handleContainerShiftTabKeyDown(focusableElements, event);
              } else {
                this._handleContainerTabKeyDown(focusableElements, event);
              }
            }
          }
          break;
        default:
          break;
      }
    };
    this._timer = null;
  }
  init() {
    const {
      wrapperId
    } = this.getProps();
    this._mounted = true;
    this._bindEvent();
    this._shouldShow();
    this._initContainerPosition();
    if (!wrapperId) {
      this._adapter.setId();
    }
  }
  destroy() {
    this._mounted = false;
    this.unBindEvent();
  }
  _bindEvent() {
    const trigger = this.getProp('trigger'); // get trigger type
    const {
      triggerEventSet,
      portalEventSet
    } = this._generateEvent(trigger);
    this._bindTriggerEvent(triggerEventSet);
    this._bindPortalEvent(portalEventSet);
    this._bindResizeEvent();
  }
  unBindEvent() {
    this._adapter.unregisterClickOutsideHandler();
    this.unBindResizeEvent();
    this.unBindScrollEvent();
    clearTimeout(this._timer);
  }
  _bindTriggerEvent(triggerEventSet) {
    this._adapter.registerTriggerEvent(triggerEventSet);
  }
  _bindPortalEvent(portalEventSet) {
    this._adapter.registerPortalEvent(portalEventSet);
  }
  _bindResizeEvent() {
    this._adapter.registerResizeHandler(this.onResize);
  }
  unBindResizeEvent() {
    this._adapter.unregisterResizeHandler(this.onResize);
  }
  _adjustPos() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let isVertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let adjustType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'reverse';
    let concatPos = arguments.length > 3 ? arguments[3] : undefined;
    switch (adjustType) {
      case 'reverse':
        return this._reversePos(position, isVertical);
      case 'expand':
        // only happens when position is top/bottom/left/right
        return this._expandPos(position, concatPos);
      case 'reduce':
        // only happens when position other than top/bottom/left/right
        return this._reducePos(position);
      default:
        return this._reversePos(position, isVertical);
    }
  }
  _reversePos() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let isVertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isVertical) {
      if (REGS.TOP.test(position)) {
        return position.replace('top', 'bottom').replace('Top', 'Bottom');
      } else if (REGS.BOTTOM.test(position)) {
        return position.replace('bottom', 'top').replace('Bottom', 'Top');
      }
    } else if (REGS.LEFT.test(position)) {
      return position.replace('left', 'right').replace('Left', 'Right');
    } else if (REGS.RIGHT.test(position)) {
      return position.replace('right', 'left').replace('Right', 'Left');
    }
    return position;
  }
  _expandPos() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let concatPos = arguments.length > 1 ? arguments[1] : undefined;
    return position.concat(concatPos);
  }
  _reducePos() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // if cur position consists of two directions, remove the last position
    const found = ['Top', 'Bottom', 'Left', 'Right'].find(pos => position.endsWith(pos));
    return found ? position.replace(found, '') : position;
  }
  clearDelayTimer() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  _generateEvent(types) {
    const eventNames = this._adapter.getEventName();
    const triggerEventSet = {
      // bind esc keydown on trigger for a11y
      [eventNames.keydown]: event => {
        this._handleTriggerKeydown(event);
      }
    };
    let portalEventSet = {};
    switch (types) {
      case 'focus':
        triggerEventSet[eventNames.focus] = () => {
          this.delayShow();
        };
        triggerEventSet[eventNames.blur] = () => {
          this.delayHide();
        };
        portalEventSet = triggerEventSet;
        break;
      case 'click':
        triggerEventSet[eventNames.click] = () => {
          // this.delayShow();
          this.show();
        };
        portalEventSet = {};
        // Click outside needs special treatment, can not be directly tied to the trigger Element, need to be bound to the document
        break;
      case 'hover':
        triggerEventSet[eventNames.mouseEnter] = () => {
          // console.log(e);
          this.setCache('isClickToHide', false);
          this.delayShow();
          // this.show('trigger');
        };

        triggerEventSet[eventNames.mouseLeave] = () => {
          // console.log(e);
          this.delayHide();
          // this.hide('trigger');
        };
        // bind focus to hover trigger for a11y
        triggerEventSet[eventNames.focus] = () => {
          const {
            disableFocusListener
          } = this.getProps();
          !disableFocusListener && this.delayShow();
        };
        triggerEventSet[eventNames.blur] = () => {
          const {
            disableFocusListener
          } = this.getProps();
          !disableFocusListener && this.delayHide();
        };
        portalEventSet = Object.assign({}, triggerEventSet);
        if (this.getProp('clickToHide')) {
          portalEventSet[eventNames.click] = () => {
            this.setCache('isClickToHide', true);
            this.hide();
          };
          portalEventSet[eventNames.mouseEnter] = () => {
            if (this.getCache('isClickToHide')) {
              return;
            }
            this.delayShow();
          };
        }
        break;
      case 'custom':
        // when trigger type is 'custom', no need to bind eventHandler
        // show/hide completely depend on props.visible which change by user
        break;
      case 'contextMenu':
        triggerEventSet[eventNames.contextMenu] = e => {
          e.preventDefault();
          this.show();
        };
        // Click outside needs special treatment, can not be directly tied to the trigger Element, need to be bound to the document
        break;
      default:
        break;
    }
    return {
      triggerEventSet,
      portalEventSet
    };
  }
  _shouldShow() {
    const visible = this.getProp('visible');
    if (visible) {
      this.show();
    } else {
      // this.hide();
    }
  }
  _togglePortalVisible(isVisible) {
    const nowVisible = this.getState('visible');
    if (nowVisible !== isVisible) {
      this._adapter.togglePortalVisible(isVisible, () => {
        if (isVisible) {
          this._adapter.setInitialFocus();
        }
        this._adapter.notifyVisibleChange(isVisible);
      });
    }
  }
  _roundPixel(pixel) {
    if (typeof pixel === 'number') {
      return Math.round(pixel);
    }
    return pixel;
  }
  calcTransformOrigin(position, triggerRect, translateX, translateY) {
    if (position && triggerRect && translateX != null && translateY != null) {
      if (this.getProp('transformFromCenter')) {
        if (['topLeft', 'bottomLeft'].includes(position)) {
          return `${this._roundPixel(triggerRect.width / 2)}px ${-translateY * 100}%`;
        }
        if (['topRight', 'bottomRight'].includes(position)) {
          return `calc(100% - ${this._roundPixel(triggerRect.width / 2)}px) ${-translateY * 100}%`;
        }
        if (['leftTop', 'rightTop'].includes(position)) {
          return `${-translateX * 100}% ${this._roundPixel(triggerRect.height / 2)}px`;
        }
        if (['leftBottom', 'rightBottom'].includes(position)) {
          return `${-translateX * 100}% calc(100% - ${this._roundPixel(triggerRect.height / 2)}px)`;
        }
      }
      return `${-translateX * 100}% ${-translateY * 100}%`;
    }
    return null;
  }
  calcPosStyle(props) {
    var _a;
    const {
      spacing,
      isOverFlow
    } = props;
    const {
      innerWidth
    } = window;
    const triggerRect = (isEmpty_default()(props.triggerRect) ? props.triggerRect : this._adapter.getTriggerBounding()) || Object.assign({}, defaultRect);
    const containerRect = (isEmpty_default()(props.containerRect) ? props.containerRect : this._adapter.getPopupContainerRect()) || Object.assign({}, defaultRect);
    const wrapperRect = (isEmpty_default()(props.wrapperRect) ? props.wrapperRect : this._adapter.getWrapperBounding()) || Object.assign({}, defaultRect);
    const position = props.position != null ? props.position : this.getProp('position');
    const RAW_SPACING = spacing != null ? spacing : this.getProp('spacing');
    const {
      arrowPointAtCenter,
      showArrow,
      arrowBounding
    } = this.getProps();
    const pointAtCenter = showArrow && arrowPointAtCenter;
    let SPACING = RAW_SPACING;
    let ANO_SPACING = 0;
    if (typeof RAW_SPACING !== 'number') {
      // extended spacing api with {x: number, y: number}, the axes of the spacing is determined based on the position
      const isTopOrBottom = position.includes('top') || position.includes('bottom');
      SPACING = isTopOrBottom ? RAW_SPACING.y : RAW_SPACING.x;
      ANO_SPACING = isTopOrBottom ? RAW_SPACING.x : RAW_SPACING.y;
    }
    const horizontalArrowWidth = get_default()(arrowBounding, 'width', 24);
    const verticalArrowHeight = get_default()(arrowBounding, 'width', 24);
    const arrowOffsetY = get_default()(arrowBounding, 'offsetY', 0);
    const positionOffsetX = 6;
    const positionOffsetY = 6;
    // You must use left/top when rendering, using right/bottom does not render the element position correctly
    // Use left/top + translate to achieve tooltip positioning perfectly without knowing the size of the tooltip expansion layer
    let left;
    let top;
    let translateX = 0; // Container x-direction translation distance
    let translateY = 0; // Container y-direction translation distance
    const middleX = triggerRect.left + triggerRect.width / 2;
    const middleY = triggerRect.top + triggerRect.height / 2;
    const offsetXWithArrow = positionOffsetX + horizontalArrowWidth / 2;
    const offsetYWithArrow = positionOffsetY + verticalArrowHeight / 2;
    const heightDifference = wrapperRect.height - containerRect.height;
    const widthDifference = wrapperRect.width - containerRect.width;
    const offsetHeight = heightDifference > 0 ? heightDifference : 0;
    const offsetWidth = widthDifference > 0 ? widthDifference : 0;
    const isHeightOverFlow = isOverFlow && isOverFlow[0];
    const isWidthOverFlow = isOverFlow && isOverFlow[1];
    const isTriggerNearLeft = middleX - containerRect.left < containerRect.right - middleX;
    const isTriggerNearTop = middleY - containerRect.top < containerRect.bottom - middleY;
    const isWrapperWidthOverflow = wrapperRect.width > innerWidth;
    const scaled = Math.abs((wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) - ((_a = this._adapter.getContainer()) === null || _a === void 0 ? void 0 : _a.clientWidth)) > 1;
    if (scaled) {
      SPACING = SPACING * wrapperRect.width / this._adapter.getContainer().clientWidth;
    }
    switch (position) {
      case 'top':
        // left = middleX;
        // top = triggerRect.top - SPACING;
        left = isWidthOverFlow ? isTriggerNearLeft ? containerRect.left + wrapperRect.width / 2 : containerRect.right - wrapperRect.width / 2 + offsetWidth : middleX + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.bottom + offsetHeight : triggerRect.top - SPACING;
        translateX = -0.5;
        translateY = -1;
        break;
      case 'topLeft':
        // left = pointAtCenter ? middleX - offsetXWithArrow : triggerRect.left;
        // top = triggerRect.top - SPACING;
        left = isWidthOverFlow ? isWrapperWidthOverflow ? containerRect.left : containerRect.right - wrapperRect.width : pointAtCenter ? middleX - offsetXWithArrow + ANO_SPACING : triggerRect.left + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.bottom + offsetHeight : triggerRect.top - SPACING;
        translateY = -1;
        break;
      case 'topRight':
        // left = pointAtCenter ? middleX + offsetXWithArrow : triggerRect.right;
        // top = triggerRect.top - SPACING;
        left = isWidthOverFlow ? containerRect.right + offsetWidth : pointAtCenter ? middleX + offsetXWithArrow + ANO_SPACING : triggerRect.right + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.bottom + offsetHeight : triggerRect.top - SPACING;
        translateY = -1;
        translateX = -1;
        break;
      case 'left':
        // left = triggerRect.left - SPACING;
        // top = middleY;
        // left = isWidthOverFlow? containerRect.right - SPACING : triggerRect.left - SPACING;
        left = isWidthOverFlow ? containerRect.right + offsetWidth - SPACING + offsetXWithArrow : triggerRect.left - SPACING;
        top = isHeightOverFlow ? isTriggerNearTop ? containerRect.top + wrapperRect.height / 2 : containerRect.bottom - wrapperRect.height / 2 + offsetHeight : middleY + ANO_SPACING;
        translateX = -1;
        translateY = -0.5;
        break;
      case 'leftTop':
        // left = triggerRect.left - SPACING;
        // top = pointAtCenter ? middleY - offsetYWithArrow : triggerRect.top;
        left = isWidthOverFlow ? containerRect.right + offsetWidth - SPACING + offsetXWithArrow : triggerRect.left - SPACING;
        top = isHeightOverFlow ? containerRect.top : pointAtCenter ? middleY - offsetYWithArrow + ANO_SPACING : triggerRect.top + ANO_SPACING;
        translateX = -1;
        break;
      case 'leftBottom':
        // left = triggerRect.left - SPACING;
        // top = pointAtCenter ? middleY + offsetYWithArrow : triggerRect.bottom;
        left = isWidthOverFlow ? containerRect.right + offsetWidth - SPACING + offsetXWithArrow : triggerRect.left - SPACING;
        top = isHeightOverFlow ? containerRect.bottom + offsetHeight : pointAtCenter ? middleY + offsetYWithArrow + ANO_SPACING : triggerRect.bottom + ANO_SPACING;
        translateX = -1;
        translateY = -1;
        break;
      case 'bottom':
        // left = middleX;
        // top = triggerRect.top + triggerRect.height + SPACING;
        left = isWidthOverFlow ? isTriggerNearLeft ? containerRect.left + wrapperRect.width / 2 : containerRect.right - wrapperRect.width / 2 + offsetWidth : middleX + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.top + offsetYWithArrow - SPACING : triggerRect.top + triggerRect.height + SPACING;
        translateX = -0.5;
        break;
      case 'bottomLeft':
        // left = pointAtCenter ? middleX - offsetXWithArrow : triggerRect.left;
        // top = triggerRect.bottom + SPACING;
        left = isWidthOverFlow ? isWrapperWidthOverflow ? containerRect.left : containerRect.right - wrapperRect.width : pointAtCenter ? middleX - offsetXWithArrow + ANO_SPACING : triggerRect.left + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.top + offsetYWithArrow - SPACING : triggerRect.top + triggerRect.height + SPACING;
        break;
      case 'bottomRight':
        // left = pointAtCenter ? middleX + offsetXWithArrow : triggerRect.right;
        // top = triggerRect.bottom + SPACING;
        left = isWidthOverFlow ? containerRect.right + offsetWidth : pointAtCenter ? middleX + offsetXWithArrow + ANO_SPACING : triggerRect.right + ANO_SPACING;
        top = isHeightOverFlow ? containerRect.top + offsetYWithArrow - SPACING : triggerRect.top + triggerRect.height + SPACING;
        translateX = -1;
        break;
      case 'right':
        // left = triggerRect.right + SPACING;
        // top = middleY;
        left = isWidthOverFlow ? containerRect.left - SPACING + offsetXWithArrow : triggerRect.right + SPACING;
        top = isHeightOverFlow ? isTriggerNearTop ? containerRect.top + wrapperRect.height / 2 : containerRect.bottom - wrapperRect.height / 2 + offsetHeight : middleY + ANO_SPACING;
        translateY = -0.5;
        break;
      case 'rightTop':
        // left = triggerRect.right + SPACING;
        // top = pointAtCenter ? middleY - offsetYWithArrow : triggerRect.top;
        left = isWidthOverFlow ? containerRect.left - SPACING + offsetXWithArrow : triggerRect.right + SPACING;
        top = isHeightOverFlow ? containerRect.top : pointAtCenter ? middleY - offsetYWithArrow + ANO_SPACING : triggerRect.top + ANO_SPACING;
        break;
      case 'rightBottom':
        // left = triggerRect.right + SPACING;
        // top = pointAtCenter ? middleY + offsetYWithArrow : triggerRect.bottom;
        left = isWidthOverFlow ? containerRect.left - SPACING + offsetXWithArrow : triggerRect.right + SPACING;
        top = isHeightOverFlow ? containerRect.bottom + offsetHeight : pointAtCenter ? middleY + offsetYWithArrow + ANO_SPACING : triggerRect.bottom + ANO_SPACING;
        translateY = -1;
        break;
      case 'leftTopOver':
        left = triggerRect.left - SPACING;
        top = triggerRect.top - SPACING;
        break;
      case 'rightTopOver':
        left = triggerRect.right + SPACING;
        top = triggerRect.top - SPACING;
        translateX = -1;
        break;
      case 'leftBottomOver':
        left = triggerRect.left - SPACING;
        top = triggerRect.bottom + SPACING;
        translateY = -1;
        break;
      case 'rightBottomOver':
        left = triggerRect.right + SPACING;
        top = triggerRect.bottom + SPACING;
        translateX = -1;
        translateY = -1;
        break;
      default:
        break;
    }
    const transformOrigin = this.calcTransformOrigin(position, triggerRect, translateX, translateY); // Transform origin
    const _containerIsBody = this._adapter.containerIsBody();
    // Calculate container positioning relative to window
    left = left - containerRect.left;
    top = top - containerRect.top;
    if (scaled) {
      left /= wrapperRect.width / this._adapter.getContainer().clientWidth;
    }
    if (scaled) {
      top /= wrapperRect.height / this._adapter.getContainer().clientHeight;
    }
    /**
     * container为body时，如果position不为relative或absolute，这时trigger计算出的top/left会根据html定位（initial containing block）
     * 此时如果body有margin，则计算出的位置相对于body会有问题 fix issue #1368
     *
     * When container is body, if position is not relative or absolute, then the top/left calculated by trigger will be positioned according to html
     * At this time, if the body has a margin, the calculated position will have a problem relative to the body fix issue #1368
     */
    if (_containerIsBody && !this._adapter.containerIsRelativeOrAbsolute()) {
      const documentEleRect = this._adapter.getDocumentElementBounding();
      // Represents the left of the body relative to html
      left += containerRect.left - documentEleRect.left;
      // Represents the top of the body relative to html
      top += containerRect.top - documentEleRect.top;
    }
    // ContainerRect.scrollLeft to solve the inner scrolling of the container
    left = _containerIsBody ? left : left + containerRect.scrollLeft;
    top = _containerIsBody ? top : top + containerRect.scrollTop;
    const triggerHeight = triggerRect.height;
    if (this.getProp('showArrow') && !arrowPointAtCenter && triggerHeight <= (verticalArrowHeight / 2 + arrowOffsetY) * 2) {
      const offsetY = triggerHeight / 2 - (arrowOffsetY + verticalArrowHeight / 2);
      if ((position.includes('Top') || position.includes('Bottom')) && !position.includes('Over')) {
        top = position.includes('Top') ? top + offsetY : top - offsetY;
      }
    }
    // The left/top value here must be rounded, otherwise it will cause the small triangle to shake
    const style = {
      left: this._roundPixel(left),
      top: this._roundPixel(top)
    };
    let transform = '';
    if (translateX != null) {
      transform += `translateX(${translateX * 100}%) `;
      Object.defineProperty(style, 'translateX', {
        enumerable: false,
        value: translateX
      });
    }
    if (translateY != null) {
      transform += `translateY(${translateY * 100}%) `;
      Object.defineProperty(style, 'translateY', {
        enumerable: false,
        value: translateY
      });
    }
    if (transformOrigin != null) {
      style.transformOrigin = transformOrigin;
    }
    if (transform) {
      style.transform = transform;
    }
    return style;
  }
  isLR() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return position.includes('left') || position.includes('right');
  }
  isTB() {
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return position.includes('top') || position.includes('bottom');
  }
  isReverse(rowSpace, reverseSpace, size) {
    // 原空间不足，反向空间足够
    // Insufficient original space, enough reverse space
    return rowSpace < size && reverseSpace > size;
  }
  isOverFlow(rowSpace, reverseSpace, size) {
    // 原空间且反向空间都不足
    // The original space and the reverse space are not enough
    return rowSpace < size && reverseSpace < size;
  }
  isHalfOverFlow(posSpace, negSpace, size) {
    // 正半空间或者负半空间不足，即表示有遮挡，需要偏移
    // Insufficient positive half space or negative half space means that there is occlusion and needs to be offset
    return posSpace < size || negSpace < size;
  }
  isHalfAllEnough(posSpace, negSpace, size) {
    // 正半空间和负半空间都足够，即表示可以从 topLeft/topRight 变成 top
    // Both positive and negative half-spaces are sufficient, which means you can change from topLeft/topRight to top
    return posSpace >= size || negSpace >= size;
  }
  getReverse(viewOverFlow, containerOverFlow, shouldReverseView, shouldReverseContainer) {
    /**
     * 基于视口和容器一起判断，以下几种情况允许从原方向转到反方向，以判断是否应该由top->bottom为例子
     *
     * 1. 视口上下空间不足 且 容器上空间❌下空间✅
     * 2. 视口上空间❌下空间✅
     *
     * Based on the judgment of the viewport and the container, the following situations are allowed to turn from the original direction to the opposite direction
     * to judge whether it should be top->bottom as an example
     * 1. There is insufficient space above and below the viewport and the space above the container ❌ the space below ✅
     * 2. The space above the viewport ❌ the space below ✅ and the space above and below the container is insufficient
     * 3. Viewport upper space ❌ lower space✅ and container upper space ❌ lower space✅
     */
    return viewOverFlow && shouldReverseContainer || shouldReverseView;
  }
  // place the dom correctly
  adjustPosIfNeed(position, style, triggerRect, wrapperRect, containerRect) {
    const {
      innerWidth,
      innerHeight
    } = window;
    const {
      margin
    } = this.getProps();
    const marginLeft = typeof margin === 'number' ? margin : margin.marginLeft;
    const marginTop = typeof margin === 'number' ? margin : margin.marginTop;
    const marginRight = typeof margin === 'number' ? margin : margin.marginRight;
    const marginBottom = typeof margin === 'number' ? margin : margin.marginBottom;
    let isHeightOverFlow = false;
    let isWidthOverFlow = false;
    const raw_spacing = this.getProp('spacing');
    let spacing = raw_spacing;
    let ano_spacing = 0;
    if (typeof raw_spacing !== 'number') {
      // extended spacing api with {x: number, y: number}, the axes of the spacing is determined based on the position
      const isTopOrBottom = position.includes('top') || position.includes('bottom');
      spacing = isTopOrBottom ? raw_spacing.y : raw_spacing.x;
      ano_spacing = isTopOrBottom ? raw_spacing.x : raw_spacing.y;
    }
    if (wrapperRect.width > 0 && wrapperRect.height > 0) {
      // let clientLeft = left + translateX * wrapperRect.width - containerRect.scrollLeft;
      // let clientTop = top + translateY * wrapperRect.height - containerRect.scrollTop;
      // if (this._adapter.containerIsBody() || this._adapter.containerIsRelative()) {
      //     clientLeft += containerRect.left;
      //     clientTop += containerRect.top;
      // }
      // const clientRight = clientLeft + wrapperRect.width;
      // const clientBottom = clientTop + wrapperRect.height;
      // The relative position of the elements on the screen
      // https://lf3-static.bytednsdoc.com/obj/eden-cn/ptlz_zlp/ljhwZthlaukjlkulzlp/tooltip-pic.svg
      const clientLeft = triggerRect.left;
      const clientRight = triggerRect.right;
      const clientTop = triggerRect.top;
      const clientBottom = triggerRect.bottom;
      const restClientLeft = innerWidth - clientLeft;
      const restClientTop = innerHeight - clientTop;
      const restClientRight = innerWidth - clientRight;
      const restClientBottom = innerHeight - clientBottom;
      const widthIsBigger = wrapperRect.width > triggerRect.width;
      const heightIsBigger = wrapperRect.height > triggerRect.height;
      // The wrapperR ect.top|bottom equivalent cannot be directly used here for comparison, which is easy to cause jitter
      // 基于视口的微调判断
      // Fine-tuning judgment based on viewport
      const shouldViewReverseTop = clientTop - marginTop < wrapperRect.height + spacing && restClientBottom - marginBottom > wrapperRect.height + spacing;
      const shouldViewReverseLeft = clientLeft - marginLeft < wrapperRect.width + spacing && restClientRight - marginRight > wrapperRect.width + spacing;
      const shouldViewReverseBottom = restClientBottom - marginBottom < wrapperRect.height + spacing && clientTop - marginTop > wrapperRect.height + spacing;
      const shouldViewReverseRight = restClientRight - marginRight < wrapperRect.width + spacing && clientLeft - marginLeft > wrapperRect.width + spacing;
      const shouldViewReverseTopOver = restClientTop - marginBottom < wrapperRect.height + spacing && clientBottom - marginTop > wrapperRect.height + spacing;
      const shouldViewReverseBottomOver = clientBottom - marginTop < wrapperRect.height + spacing && restClientTop - marginBottom > wrapperRect.height + spacing;
      const shouldViewReverseTopSide = restClientTop < wrapperRect.height + ano_spacing && clientBottom > wrapperRect.height + ano_spacing;
      const shouldViewReverseBottomSide = clientBottom < wrapperRect.height + ano_spacing && restClientTop > wrapperRect.height + ano_spacing;
      const shouldViewReverseLeftSide = restClientLeft < wrapperRect.width + ano_spacing && clientRight > wrapperRect.width + ano_spacing;
      const shouldViewReverseRightSide = clientRight < wrapperRect.width + ano_spacing && restClientLeft > wrapperRect.width + ano_spacing;
      const shouldReverseTopOver = restClientTop < wrapperRect.height + spacing && clientBottom > wrapperRect.height + spacing;
      const shouldReverseBottomOver = clientBottom < wrapperRect.height + spacing && restClientTop > wrapperRect.height + spacing;
      const shouldReverseLeftOver = restClientLeft < wrapperRect.width && clientRight > wrapperRect.width;
      const shouldReverseRightOver = clientRight < wrapperRect.width && restClientLeft > wrapperRect.width;
      // 基于容器的微调判断
      // Fine-tuning judgment based on container
      const clientTopInContainer = clientTop - containerRect.top;
      const clientLeftInContainer = clientLeft - containerRect.left;
      const clientBottomInContainer = clientTopInContainer + triggerRect.height;
      const clientRightInContainer = clientLeftInContainer + triggerRect.width;
      const restClientBottomInContainer = containerRect.bottom - clientBottom;
      const restClientRightInContainer = containerRect.right - clientRight;
      const restClientTopInContainer = restClientBottomInContainer + triggerRect.height;
      const restClientLeftInContainer = restClientRightInContainer + triggerRect.width;
      // 当原空间不足，反向空间足够时，可以反向。
      // When the original space is insufficient and the reverse space is sufficient, the reverse can be performed.
      const shouldContainerReverseTop = this.isReverse(clientTopInContainer - marginTop, restClientBottomInContainer - marginBottom, wrapperRect.height + spacing);
      const shouldContainerReverseLeft = this.isReverse(clientLeftInContainer - marginLeft, restClientRightInContainer - marginRight, wrapperRect.width + spacing);
      const shouldContainerReverseBottom = this.isReverse(restClientBottomInContainer - marginBottom, clientTopInContainer - marginTop, wrapperRect.height + spacing);
      const shouldContainerReverseRight = this.isReverse(restClientRightInContainer - marginRight, clientLeftInContainer - marginLeft, wrapperRect.width + spacing);
      const shouldContainerReverseTopOver = this.isReverse(restClientTopInContainer - marginBottom, clientBottomInContainer - marginTop, wrapperRect.height + spacing);
      const shouldContainerReverseBottomOver = this.isReverse(clientBottomInContainer - marginTop, restClientTopInContainer - marginBottom, wrapperRect.height + spacing);
      const shouldContainerReverseTopSide = this.isReverse(restClientTopInContainer, clientBottomInContainer, wrapperRect.height + ano_spacing);
      const shouldContainerReverseBottomSide = this.isReverse(clientBottomInContainer, restClientTopInContainer, wrapperRect.height + ano_spacing);
      const shouldContainerReverseLeftSide = this.isReverse(restClientLeftInContainer, clientRightInContainer, wrapperRect.width + ano_spacing);
      const shouldContainerReverseRightSide = this.isReverse(clientRightInContainer, restClientLeftInContainer, wrapperRect.width + ano_spacing);
      const halfHeight = triggerRect.height / 2;
      const halfWidth = triggerRect.width / 2;
      // 视口, 原空间与反向空间是否都不足判断
      // Viewport, whether the original space and the reverse space are insufficient to judge
      const isViewYOverFlow = this.isOverFlow(clientTop - marginTop, restClientBottom - marginBottom, wrapperRect.height + spacing);
      const isViewXOverFlow = this.isOverFlow(clientLeft - marginLeft, restClientRight - marginRight, wrapperRect.width + spacing);
      const isViewYOverFlowSide = this.isOverFlow(clientBottom - marginTop, restClientTop - marginBottom, wrapperRect.height + spacing);
      const isViewXOverFlowSide = this.isOverFlow(clientRight - marginLeft, restClientLeft - marginRight, wrapperRect.width + spacing);
      const isViewYOverFlowSideHalf = this.isHalfOverFlow(clientBottom - halfHeight, restClientTop - halfHeight, (wrapperRect.height + ano_spacing) / 2);
      const isViewXOverFlowSideHalf = this.isHalfOverFlow(clientRight - halfWidth, restClientLeft - halfWidth, (wrapperRect.width + ano_spacing) / 2);
      const isViewYEnoughSideHalf = this.isHalfAllEnough(clientBottom - halfHeight, restClientTop - halfHeight, (wrapperRect.height + ano_spacing) / 2);
      const isViewXEnoughSideHalf = this.isHalfAllEnough(clientRight - halfWidth, restClientLeft - halfWidth, (wrapperRect.width + ano_spacing) / 2);
      // 容器, 原空间与反向空间是否都不足判断
      // container, whether the original space and the reverse space are insufficient to judge
      const isContainerYOverFlow = this.isOverFlow(clientTopInContainer - marginTop, restClientBottomInContainer - marginBottom, wrapperRect.height + spacing);
      const isContainerXOverFlow = this.isOverFlow(clientLeftInContainer - marginLeft, restClientRightInContainer - marginRight, wrapperRect.width + spacing);
      const isContainerYOverFlowSide = this.isOverFlow(clientBottomInContainer - marginTop, restClientTopInContainer - marginBottom, wrapperRect.height + spacing);
      const isContainerXOverFlowSide = this.isOverFlow(clientRightInContainer - marginLeft, restClientLeftInContainer - marginRight, wrapperRect.width + spacing);
      const isContainerYOverFlowSideHalf = this.isHalfOverFlow(clientBottomInContainer - halfHeight, restClientTopInContainer - halfHeight, (wrapperRect.height + ano_spacing) / 2);
      const isContainerXOverFlowSideHalf = this.isHalfOverFlow(clientRightInContainer - halfWidth, restClientLeftInContainer - halfWidth, (wrapperRect.width + ano_spacing) / 2);
      const isContainerYEnoughSideHalf = this.isHalfAllEnough(clientBottomInContainer - halfHeight, restClientTopInContainer - halfHeight, (wrapperRect.height + ano_spacing) / 2);
      const isContainerXEnoughSideHalf = this.isHalfAllEnough(clientRightInContainer - halfWidth, restClientLeftInContainer - halfWidth, (wrapperRect.width + ano_spacing) / 2);
      // 综合 viewport + container 判断微调，即视口 + 容器都放置不行时才能考虑位置调整
      // Comprehensive viewport + container judgment fine-tuning, that is, the position adjustment can only be considered when the viewport + container cannot be placed.
      const shouldReverseTop = this.getReverse(isViewYOverFlow, isContainerYOverFlow, shouldViewReverseTop, shouldContainerReverseTop);
      const shouldReverseLeft = this.getReverse(isViewXOverFlow, isContainerXOverFlow, shouldViewReverseLeft, shouldContainerReverseLeft);
      const shouldReverseBottom = this.getReverse(isViewYOverFlow, isContainerYOverFlow, shouldViewReverseBottom, shouldContainerReverseBottom);
      const shouldReverseRight = this.getReverse(isViewXOverFlow, isContainerXOverFlow, shouldViewReverseRight, shouldContainerReverseRight);
      // const shouldReverseTopOver = this.getReverse(isViewYOverFlowSide, isContainerYOverFlowSide, shouldViewReverseTopOver, shouldContainerReverseTopOver);
      // const shouldReverseBottomOver = this.getReverse(isViewYOverFlowSide, isContainerYOverFlowSide, shouldViewReverseBottomOver, shouldContainerReverseBottomOver);
      const shouldReverseTopSide = this.getReverse(isViewYOverFlowSide, isContainerYOverFlowSide, shouldViewReverseTopSide, shouldContainerReverseTopSide);
      const shouldReverseBottomSide = this.getReverse(isViewYOverFlowSide, isContainerYOverFlowSide, shouldViewReverseBottomSide, shouldContainerReverseBottomSide);
      const shouldReverseLeftSide = this.getReverse(isViewXOverFlowSide, isContainerXOverFlowSide, shouldViewReverseLeftSide, shouldContainerReverseLeftSide);
      const shouldReverseRightSide = this.getReverse(isViewXOverFlowSide, isContainerXOverFlowSide, shouldViewReverseRightSide, shouldContainerReverseRightSide);
      const isYOverFlowSideHalf = isViewYOverFlowSideHalf && isContainerYOverFlowSideHalf;
      const isXOverFlowSideHalf = isViewXOverFlowSideHalf && isContainerXOverFlowSideHalf;
      switch (position) {
        case 'top':
          if (shouldReverseTop) {
            position = this._adjustPos(position, true);
          }
          if (isXOverFlowSideHalf && (shouldReverseLeftSide || shouldReverseRightSide)) {
            position = this._adjustPos(position, true, 'expand', shouldReverseLeftSide ? 'Right' : 'Left');
          }
          break;
        case 'topLeft':
          if (shouldReverseTop) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseLeftSide && widthIsBigger) {
            position = this._adjustPos(position);
          }
          if (isWidthOverFlow && (isViewXEnoughSideHalf || isContainerXEnoughSideHalf)) {
            position = this._adjustPos(position, true, 'reduce');
          }
          break;
        case 'topRight':
          if (shouldReverseTop) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseRightSide && widthIsBigger) {
            position = this._adjustPos(position);
          }
          if (isWidthOverFlow && (isViewXEnoughSideHalf || isContainerXEnoughSideHalf)) {
            position = this._adjustPos(position, true, 'reduce');
          }
          break;
        case 'left':
          if (shouldReverseLeft) {
            position = this._adjustPos(position);
          }
          if (isYOverFlowSideHalf && (shouldReverseTopSide || shouldReverseBottomSide)) {
            position = this._adjustPos(position, false, 'expand', shouldReverseTopSide ? 'Bottom' : 'Top');
          }
          break;
        case 'leftTop':
          if (shouldReverseLeft) {
            position = this._adjustPos(position);
          }
          if (shouldReverseTopSide && heightIsBigger) {
            position = this._adjustPos(position, true);
          }
          if (isHeightOverFlow && (isViewYEnoughSideHalf || isContainerYEnoughSideHalf)) {
            position = this._adjustPos(position, false, 'reduce');
          }
          break;
        case 'leftBottom':
          if (shouldReverseLeft) {
            position = this._adjustPos(position);
          }
          if (shouldReverseBottomSide && heightIsBigger) {
            position = this._adjustPos(position, true);
          }
          if (isHeightOverFlow && (isViewYEnoughSideHalf || isContainerYEnoughSideHalf)) {
            position = this._adjustPos(position, false, 'reduce');
          }
          break;
        case 'bottom':
          if (shouldReverseBottom) {
            position = this._adjustPos(position, true);
          }
          if (isXOverFlowSideHalf && (shouldReverseLeftSide || shouldReverseRightSide)) {
            position = this._adjustPos(position, true, 'expand', shouldReverseLeftSide ? 'Right' : 'Left');
          }
          break;
        case 'bottomLeft':
          if (shouldReverseBottom) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseLeftSide && widthIsBigger) {
            position = this._adjustPos(position);
          }
          if (isWidthOverFlow && (isViewXEnoughSideHalf || isContainerXEnoughSideHalf)) {
            position = this._adjustPos(position, true, 'reduce');
          }
          break;
        case 'bottomRight':
          if (shouldReverseBottom) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseRightSide && widthIsBigger) {
            position = this._adjustPos(position);
          }
          if (isWidthOverFlow && (isViewXEnoughSideHalf || isContainerXEnoughSideHalf)) {
            position = this._adjustPos(position, true, 'reduce');
          }
          break;
        case 'right':
          if (shouldReverseRight) {
            position = this._adjustPos(position);
          }
          if (isYOverFlowSideHalf && (shouldReverseTopSide || shouldReverseBottomSide)) {
            position = this._adjustPos(position, false, 'expand', shouldReverseTopSide ? 'Bottom' : 'Top');
          }
          break;
        case 'rightTop':
          if (shouldReverseRight) {
            position = this._adjustPos(position);
          }
          if (shouldReverseTopSide && heightIsBigger) {
            position = this._adjustPos(position, true);
          }
          if (isHeightOverFlow && (isViewYEnoughSideHalf || isContainerYEnoughSideHalf)) {
            position = this._adjustPos(position, false, 'reduce');
          }
          break;
        case 'rightBottom':
          if (shouldReverseRight) {
            position = this._adjustPos(position);
          }
          if (shouldReverseBottomSide && heightIsBigger) {
            position = this._adjustPos(position, true);
          }
          if (isHeightOverFlow && (isViewYEnoughSideHalf || isContainerYEnoughSideHalf)) {
            position = this._adjustPos(position, false, 'reduce');
          }
          break;
        case 'leftTopOver':
          if (shouldReverseTopOver) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseLeftOver) {
            position = this._adjustPos(position);
          }
          break;
        case 'leftBottomOver':
          if (shouldReverseBottomOver) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseLeftOver) {
            position = this._adjustPos(position);
          }
          break;
        case 'rightTopOver':
          if (shouldReverseTopOver) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseRightOver) {
            position = this._adjustPos(position);
          }
          break;
        case 'rightBottomOver':
          if (shouldReverseBottomOver) {
            position = this._adjustPos(position, true);
          }
          if (shouldReverseRightOver) {
            position = this._adjustPos(position);
          }
          break;
        default:
          break;
      }
      // 判断溢出 Judgment overflow
      // 上下方向 top and bottom
      if (this.isTB(position)) {
        isHeightOverFlow = isViewYOverFlow && isContainerYOverFlow;
        // Related PR: https://github.com/DouyinFE/semi-design/pull/1297
        // If clientRight or restClientRight less than 0, means that the left and right parts of the trigger are blocked
        // Then the display of the wrapper will also be affected, make width overflow to offset the wrapper
        if (position === 'top' || position === 'bottom') {
          isWidthOverFlow = isViewXOverFlowSideHalf && isContainerXOverFlowSideHalf || clientRight < 0 || restClientRight < 0;
        } else {
          isWidthOverFlow = isViewXOverFlowSide && isContainerXOverFlowSide || clientRight < 0 || restClientRight < 0;
        }
      }
      // 左右方向 left and right
      if (this.isLR(position)) {
        isWidthOverFlow = isViewXOverFlow && isContainerXOverFlow;
        // If clientTop or restClientTop less than 0, means that the top and bottom parts of the trigger are blocked
        // Then the display of the wrapper will also be affected, make height overflow to offset the wrapper
        if (position === 'left' || position === 'right') {
          isHeightOverFlow = isViewYOverFlowSideHalf && isContainerYOverFlowSideHalf || clientTop < 0 || restClientTop < 0;
        } else {
          isHeightOverFlow = isViewYOverFlowSide && isContainerYOverFlowSide || clientTop < 0 || restClientTop < 0;
        }
      }
    }
    return {
      position,
      isHeightOverFlow,
      isWidthOverFlow
    };
  }
  _bindScrollEvent() {
    this._adapter.registerScrollHandler(() => this.calcPosition());
    // Capture scroll events on the window to determine whether the current scrolling area (e.target) will affect the positioning of the pop-up layer relative to the viewport when scrolling
    // (By determining whether the e.target contains the triggerDom of the current tooltip) If so, the pop-up layer will also be affected and needs to be repositioned
  }

  unBindScrollEvent() {
    this._adapter.unregisterScrollHandler();
  }
  _initContainerPosition() {
    this._adapter.updateContainerPosition();
  }
  _handleTriggerKeydown(event) {
    const {
      closeOnEsc,
      disableArrowKeyDown
    } = this.getProps();
    const container = this._adapter.getContainer();
    const focusableElements = this._adapter.getFocusableElements(container);
    const focusableNum = focusableElements.length;
    switch (event && event.key) {
      case "Escape":
        handlePrevent(event);
        closeOnEsc && this._handleEscKeyDown(event);
        break;
      case "ArrowUp":
        // when disableArrowKeyDown is true, disable tooltip's arrow keyboard event action
        !disableArrowKeyDown && focusableNum && this._handleTriggerArrowUpKeydown(focusableElements, event);
        break;
      case "ArrowDown":
        !disableArrowKeyDown && focusableNum && this._handleTriggerArrowDownKeydown(focusableElements, event);
        break;
      default:
        break;
    }
  }
  /**
   * focus trigger
   *
   * when trigger is 'focus' or 'hover', onFocus is bind to show popup
   * if we focus trigger, popup will show again
   *
   * 如果 trigger 是 focus 或者 hover，则它绑定了 onFocus，这里我们如果重新 focus 的话，popup 会再次打开
   * 因此 returnFocusOnClose 只支持 click trigger
   */
  focusTrigger() {
    const {
      trigger,
      returnFocusOnClose,
      preventScroll
    } = this.getProps();
    if (returnFocusOnClose && trigger !== 'custom') {
      const triggerNode = this._adapter.getTriggerNode();
      if (triggerNode && 'focus' in triggerNode) {
        triggerNode.focus({
          preventScroll
        });
      }
    }
  }
  _handleEscKeyDown(event) {
    const {
      trigger
    } = this.getProps();
    if (trigger !== 'custom') {
      // Move the focus into the trigger first and then close the pop-up layer 
      // to avoid the problem of opening the pop-up layer again when the focus returns to the trigger in the case of hover and focus
      this.focusTrigger();
      this.hide();
    }
    this._adapter.notifyEscKeydown(event);
  }
  _handleContainerTabKeyDown(focusableElements, event) {
    const {
      preventScroll
    } = this.getProps();
    const activeElement = this._adapter.getActiveElement();
    const isLastCurrentFocus = focusableElements[focusableElements.length - 1] === activeElement;
    if (isLastCurrentFocus) {
      focusableElements[0].focus({
        preventScroll
      });
      event.preventDefault(); // prevent browser default tab move behavior
    }
  }

  _handleContainerShiftTabKeyDown(focusableElements, event) {
    const {
      preventScroll
    } = this.getProps();
    const activeElement = this._adapter.getActiveElement();
    const isFirstCurrentFocus = focusableElements[0] === activeElement;
    if (isFirstCurrentFocus) {
      focusableElements[focusableElements.length - 1].focus({
        preventScroll
      });
      event.preventDefault(); // prevent browser default tab move behavior
    }
  }

  _handleTriggerArrowDownKeydown(focusableElements, event) {
    const {
      preventScroll
    } = this.getProps();
    focusableElements[0].focus({
      preventScroll
    });
    event.preventDefault(); // prevent browser default scroll behavior
  }

  _handleTriggerArrowUpKeydown(focusableElements, event) {
    const {
      preventScroll
    } = this.getProps();
    focusableElements[focusableElements.length - 1].focus({
      preventScroll
    });
    event.preventDefault(); // prevent browser default scroll behavior
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/uuid.js
function getUuid(prefix) {
  return `${prefix}-${new Date().getTime()}-${Math.random()}`;
}
// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
function getUuidv4() {
  var _a, _b;
  try {
    // @ts-ignore
    return (_b = (_a = crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) === null || _a === void 0 ? void 0 : _a.call(crypto)) !== null && _b !== void 0 ? _b : String(1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (Number(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(c) / 4).toString(16));
  } catch (err) {
    return getUuid('semi');
  }
}
/**
 * Get a random id with prefix, it not strictly guarantee id uniqueness
 *
 * Note: the return value of getUuid is too long, we need a short one
 *
 * @example
 * getUuidShort({ prefix: 'semi' }) => 'semi-46dinzc'
 * getUuidShort({ prefix: '' }) => '0eer2i0'
 * getUuidShort({ prefix: 'semi', length: 4 }) => 'semi-8jts'
 */
function getUuidShort() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    prefix = '',
    length = 7
  } = options;
  const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
  const total = characters.length;
  let randomId = '';
  for (let i = 0; i < length; i++) {
    const random = Math.floor(Math.random() * total);
    randomId += characters.charAt(random);
  }
  return prefix ? `${prefix}-${randomId}` : randomId;
}

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isElement.js
/* istanbul ignore next */
function isElement(obj) {
  try {
    // Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {
    // Browsers not supporting W3 DOM2 don't have HTMLElement and
    // an exception is thrown and we end up here. Testing some
    // properties that all elements have (works on IE7)
    return typeof obj === 'object' && obj.nodeType === 1 && typeof obj.style === 'object' && typeof obj.ownerDocument === 'object';
  }
}
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(36968);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeepWith.js
var cloneDeepWith = __webpack_require__(53888);
var cloneDeepWith_default = /*#__PURE__*/__webpack_require__.n(cloneDeepWith);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/getHighlight.js
 // Modified version based on 'highlight-words-core'
const escapeRegExpFn = string => string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
/**
   * Examine text for any matches.
   * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
   * @return { start:number, end:number }[]
   */
const findChunks = _ref => {
  let {
    autoEscape,
    caseSensitive,
    searchWords,
    sourceString
  } = _ref;
  return searchWords.filter(searchWord => searchWord) // Remove empty words
  .reduce((chunks, searchWord) => {
    if (autoEscape) {
      searchWord = escapeRegExpFn(searchWord);
    }
    const regex = new RegExp(searchWord, caseSensitive ? 'g' : 'gi');
    let match;
    while (match = regex.exec(sourceString)) {
      const start = match.index;
      const end = regex.lastIndex;
      // We do not return zero-length matches
      if (end > start) {
        chunks.push({
          highlight: false,
          start,
          end
        });
      }
      // Prevent browsers like Firefox from getting stuck in an infinite loop
      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
      if (match.index === regex.lastIndex) {
        regex.lastIndex++;
      }
    }
    return chunks;
  }, []);
};
/**
   * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
   * @return {start:number, end:number}[]
   */
const combineChunks = _ref2 => {
  let {
    chunks
  } = _ref2;
  chunks = chunks.sort((first, second) => first.start - second.start).reduce((processedChunks, nextChunk) => {
    // First chunk just goes straight in the array...
    if (processedChunks.length === 0) {
      return [nextChunk];
    } else {
      // ... subsequent chunks get checked to see if they overlap...
      const prevChunk = processedChunks.pop();
      if (nextChunk.start <= prevChunk.end) {
        // It may be the case that prevChunk completely surrounds nextChunk, so take the
        // largest of the end indeces.
        const endIndex = Math.max(prevChunk.end, nextChunk.end);
        processedChunks.push({
          highlight: false,
          start: prevChunk.start,
          end: endIndex
        });
      } else {
        processedChunks.push(prevChunk, nextChunk);
      }
      return processedChunks;
    }
  }, []);
  return chunks;
};
/**
   * Given a set of chunks to highlight, create an additional set of chunks
   * to represent the bits of text between the highlighted text.
   * @param chunksToHighlight {start:number, end:number}[]
   * @param totalLength number
   * @return {start:number, end:number, highlight:boolean}[]
   */
const fillInChunks = _ref3 => {
  let {
    chunksToHighlight,
    totalLength
  } = _ref3;
  const allChunks = [];
  const append = (start, end, highlight) => {
    if (end - start > 0) {
      allChunks.push({
        start,
        end,
        highlight
      });
    }
  };
  if (chunksToHighlight.length === 0) {
    append(0, totalLength, false);
  } else {
    let lastIndex = 0;
    chunksToHighlight.forEach(chunk => {
      append(lastIndex, chunk.start, false);
      append(chunk.start, chunk.end, true);
      lastIndex = chunk.end;
    });
    append(lastIndex, totalLength, false);
  }
  return allChunks;
};
/**
 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
 *
    findAll ['z'], 'aaazaaazaaa'
        result #=> [
            { start: 0, end: 3, highlight: false }
            { start: 3, end: 4, highlight: true }
            { start: 4, end: 7, highlight: false }
            { start: 7, end: 8, highlight: true }
            { start: 8, end: 11, highlight: false }
        ]

    findAll ['do', 'dollar'], 'aaa do dollar aaa'
        #=> chunks: [
                { start: 4, end: 6 },
                { start: 7, end: 9 },
                { start: 7, end: 13 },
            ]
        #=> chunksToHight: [
                { start: 4, end: 6 },
                { start: 7, end: 13 },
            ]
        #=> result: [
                { start: 0, end: 4, highlight: false },
                { start: 4, end: 6, highlight: true },
                { start: 6, end: 7, highlight: false },
                { start: 7, end: 13, highlight: true },
                { start: 13, end: 17, highlight: false },
            ]

 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
 */
const findAll = _ref4 => {
  let {
    autoEscape = true,
    caseSensitive = false,
    searchWords,
    sourceString
  } = _ref4;
  if (isString_default()(searchWords)) {
    searchWords = [searchWords];
  }
  const chunks = findChunks({
    autoEscape,
    caseSensitive,
    searchWords,
    sourceString
  });
  const chunksToHighlight = combineChunks({
    chunks
  });
  const result = fillInChunks({
    chunksToHighlight,
    totalLength: sourceString ? sourceString.length : 0
  });
  return result;
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_utils/semi-global.js
class SemiGlobal {
  constructor() {
    this.config = {};
  }
}
/* harmony default export */ var semi_global = (new SemiGlobal());
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_utils/index.js
/* provided dependency */ var _utils_process = __webpack_require__(83454);



var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};





/**
 * stop propagation
 *
 * @param {React.MouseEvent<HTMLElement>} e React mouse event object
 * @param {boolean} noImmediate Skip stopping immediate propagation
 */
function stopPropagation(e, noImmediate) {
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation();
  }
  if (!noImmediate && e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
    e.nativeEvent.stopImmediatePropagation();
  }
}
function cloneDeep(value, customizer) {
  return cloneDeepWith_default()(value, v => {
    if (typeof customizer === 'function') {
      return customizer(v);
    }
    if (typeof v === 'function' || /*#__PURE__*/react.isValidElement(v)) {
      return v;
    }
    if (Object.prototype.toString.call(v) === '[object Error]') {
      return v;
    }
    // it is tricky
    // when array length beyond max length, array.length will be 0
    if (Array.isArray(v) && v.length === 0) {
      const keys = Object.keys(v);
      if (keys.length) {
        const newArray = [];
        keys.forEach(key => {
          set_default()(newArray, key, v[key]);
        });
        // internal-issues:887
        try {
          warning(get_default()(_utils_process, 'env.NODE_ENV') !== 'production', `[Semi] You may use an out-of-bounds array. In some cases, your program may not behave as expected.
                    The maximum length of an array is 4294967295.
                    Please check whether the array subscript in your data exceeds the maximum value of the JS array subscript`);
        } catch (e) {}
        return newArray;
      } else {
        return undefined;
      }
    }
    return undefined;
  });
}
/**
 * [getHighLightTextHTML description]
 *
 * @param   {string} sourceString [source content text]
 * @param   {Array<string>} searchWords [keywords to be highlighted]
 * @param   {object} option
 * @param   {true}      option.highlightTag [The tag wrapped by the highlighted content, mark is used by default]
 * @param   {true}      option.highlightClassName
 * @param   {true}      option.highlightStyle
 * @param   {boolean}   option.caseSensitive
 *
 * @return  {Array<object>}
 */
const getHighLightTextHTML = _ref => {
  let {
    sourceString = '',
    searchWords = [],
    option = {
      autoEscape: true,
      caseSensitive: false
    }
  } = _ref;
  const chunks = findAll(Object.assign({
    sourceString,
    searchWords
  }, option));
  const markEle = option.highlightTag || 'mark';
  const highlightClassName = option.highlightClassName || '';
  const highlightStyle = option.highlightStyle || {};
  return chunks.map((chunk, index) => {
    const {
      end,
      start,
      highlight
    } = chunk;
    const text = sourceString.substr(start, end - start);
    if (highlight) {
      return /*#__PURE__*/react.createElement(markEle, {
        style: highlightStyle,
        className: highlightClassName,
        key: text + index
      }, text);
    } else {
      return text;
    }
  });
};
/**
 * register matchFn and unMatchFn callback while media query
 * @param {string} media media string
 * @param {object} param param object
 * @returns function
 */
const registerMediaQuery = (media, _ref2) => {
  let {
    match,
    unmatch,
    callInInit = true
  } = _ref2;
  if (typeof window !== 'undefined') {
    const mediaQueryList = window.matchMedia(media);
    function handlerMediaChange(e) {
      if (e.matches) {
        match && match(e);
      } else {
        unmatch && unmatch(e);
      }
    }
    callInInit && handlerMediaChange(mediaQueryList);
    if (Object.prototype.hasOwnProperty.call(mediaQueryList, 'addEventListener')) {
      mediaQueryList.addEventListener('change', handlerMediaChange);
      return () => mediaQueryList.removeEventListener('change', handlerMediaChange);
    }
    mediaQueryList.addListener(handlerMediaChange);
    return () => mediaQueryList.removeListener(handlerMediaChange);
  }
  return () => undefined;
};
/**
 * Determine whether the incoming element is a built-in icon
 * @param icon 元素
 * @returns boolean
 */
const isSemiIcon = icon => /*#__PURE__*/react.isValidElement(icon) && get_default()(icon.type, 'elementType') === 'Icon';
function getActiveElement() {
  return document ? document.activeElement : null;
}
function isNodeContainsFocus(node) {
  const activeElement = getActiveElement();
  return activeElement === node || node.contains(activeElement);
}
function getFocusableElements(node) {
  if (!isElement(node)) {
    return [];
  }
  const focusableSelectorsList = ["input:not([disabled]):not([tabindex='-1'])", "textarea:not([disabled]):not([tabindex='-1'])", "button:not([disabled]):not([tabindex='-1'])", "a[href]:not([tabindex='-1'])", "select:not([disabled]):not([tabindex='-1'])", "area[href]:not([tabindex='-1'])", "iframe:not([tabindex='-1'])", "object:not([tabindex='-1'])", "*[tabindex]:not([tabindex='-1'])", "*[contenteditable]:not([tabindex='-1'])"];
  const focusableSelectorsStr = focusableSelectorsList.join(',');
  // we are not filtered elements which are invisible
  const focusableElements = Array.from(node.querySelectorAll(focusableSelectorsStr));
  return focusableElements;
}
function runAfterTicks(func, numberOfTicks) {
  return __awaiter(this, void 0, void 0, function* () {
    if (numberOfTicks === 0) {
      yield func();
      return;
    } else {
      yield new Promise(resolve => {
        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
          yield runAfterTicks(func, numberOfTicks - 1);
          resolve();
        }), 0);
      });
      return;
    }
  });
}
function getScrollbarWidth() {
  if (globalThis && Object.prototype.toString.call(globalThis) === '[object Window]') {
    return window.innerWidth - document.documentElement.clientWidth;
  }
  return 0;
}
function getDefaultPropsFromGlobalConfig(componentName) {
  let semiDefaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getFromGlobalConfig = () => {
    var _a, _b;
    return ((_b = (_a = semi_global === null || semi_global === void 0 ? void 0 : semi_global.config) === null || _a === void 0 ? void 0 : _a.overrideDefaultProps) === null || _b === void 0 ? void 0 : _b[componentName]) || {};
  };
  return new Proxy(Object.assign({}, semiDefaultProps), {
    get(target, key, receiver) {
      const defaultPropsFromGlobal = getFromGlobalConfig();
      if (key in defaultPropsFromGlobal) {
        return defaultPropsFromGlobal[key];
      }
      return Reflect.get(target, key, receiver);
    },
    set(target, key, value, receiver) {
      return Reflect.set(target, key, value, receiver);
    },
    ownKeys() {
      const defaultPropsFromGlobal = getFromGlobalConfig();
      return Array.from(new Set([...Reflect.ownKeys(semiDefaultProps), ...Object.keys(defaultPropsFromGlobal)]));
    },
    getOwnPropertyDescriptor(target, key) {
      const defaultPropsFromGlobal = getFromGlobalConfig();
      if (key in defaultPropsFromGlobal) {
        return Reflect.getOwnPropertyDescriptor(defaultPropsFromGlobal, key);
      } else {
        return Reflect.getOwnPropertyDescriptor(target, key);
      }
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_portal/index.js






// import '@douyinfe/semi-foundation/lib/es/_portal/portal.css';
const defaultGetContainer = () => document.body;
class Portal extends react.PureComponent {
  constructor(props, context) {
    var _this;
    super(props);
    _this = this;
    this.initContainer = function (context) {
      let catchError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _a, _b;
      try {
        let container = undefined;
        if (!_this.el || !((_a = _this.state) === null || _a === void 0 ? void 0 : _a.container) || !Array.from(_this.state.container.childNodes).includes(_this.el)) {
          _this.el = document.createElement('div');
          const getContainer = _this.props.getPopupContainer || context.getPopupContainer || defaultGetContainer;
          const portalContainer = getContainer();
          portalContainer.appendChild(_this.el);
          _this.addStyle(_this.props.style);
          _this.addClass(_this.props.prefixCls, context, _this.props.className);
          container = portalContainer;
          return container;
        }
      } catch (e) {
        if (!catchError) {
          throw e;
        }
      }
      return (_b = _this.state) === null || _b === void 0 ? void 0 : _b.container;
    };
    this.addStyle = function () {
      let style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.el) {
        for (const key of Object.keys(style)) {
          _this.el.style[key] = style[key];
        }
      }
    };
    this.addClass = function (prefixCls) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.context;
      const {
        direction
      } = context;
      for (var _len = arguments.length, classNames = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        classNames[_key - 2] = arguments[_key];
      }
      const cls = classnames_default()(prefixCls, ...classNames, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
      });
      if (_this.el) {
        _this.el.className = cls;
      }
    };
    this.state = {
      container: this.initContainer(context, true)
    };
  }
  componentDidMount() {
    const container = this.initContainer(this.context);
    if (container !== this.state.container) {
      this.setState({
        container
      });
    }
  }
  componentDidUpdate(prevProps) {
    // visible callback
    const {
      didUpdate
    } = this.props;
    if (didUpdate) {
      didUpdate(prevProps);
    }
  }
  componentWillUnmount() {
    const {
      container
    } = this.state;
    if (container) {
      container.removeChild(this.el);
    }
  }
  render() {
    const {
      state,
      props
    } = this;
    if (state.container) {
      return /*#__PURE__*/(0,react_dom.createPortal)(props.children, this.el);
    }
    return null;
  }
}
Portal.contextType = context;
Portal.defaultProps = {
  // getPopupContainer: () => document.body,
  prefixCls: `${BASE_CLASS_PREFIX}-portal`
};
Portal.propTypes = {
  children: (prop_types_default()).node,
  prefixCls: (prop_types_default()).string,
  getPopupContainer: (prop_types_default()).func,
  className: (prop_types_default()).string,
  didUpdate: (prop_types_default()).func
};
/* harmony default export */ var _portal = (Portal);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tooltip/TriangleArrow.js
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

const TriangleArrow = props => {
  const {
      className,
      style
    } = props,
    restProps = __rest(props, ["className", "style"]);
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    "aria-hidden": true,
    className: className,
    style: style
  }, restProps, {
    width: "24",
    height: "7",
    viewBox: "0 0 24 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24 0V1C20 1 18.5 2 16.5 4C14.5 6 14 7 12 7C10 7 9.5 6 7.5 4C5.5 2 4 1 0 1V0H24Z"
  }));
};
/* harmony default export */ var tooltip_TriangleArrow = (TriangleArrow);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tooltip/TriangleArrowVertical.js
var TriangleArrowVertical_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

const TriangleArrowVertical = props => {
  const {
      className,
      style
    } = props,
    restProps = TriangleArrowVertical_rest(props, ["className", "style"]);
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    "aria-hidden": true,
    className: className,
    style: style
  }, restProps, {
    width: "7",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 0L1 0C1 4, 2 5.5, 4 7.5S7,10 7,12S6 14.5, 4 16.5S1,20 1,24L0 24L0 0z"
  }));
};
/* harmony default export */ var tooltip_TriangleArrowVertical = (TriangleArrowVertical);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tooltip/ArrowBoundingShape.js

/* harmony default export */ var ArrowBoundingShape = (prop_types_default().shape({
  offsetX: (prop_types_default()).number,
  offsetY: (prop_types_default()).number,
  width: (prop_types_default()).number,
  height: (prop_types_default()).number
}));
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_cssAnimation/index.js


class CSSAnimation extends react.Component {
  constructor(props) {
    super(props);
    this.handleAnimationStart = () => {
      var _a, _b;
      (_b = (_a = this.props).onAnimationStart) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    this.handleAnimationEnd = () => {
      this.setState({
        currentClassName: this.props.endClassName,
        extraStyle: {
          animationFillMode: this.props.fillMode
        },
        isAnimating: false
      }, () => {
        var _a, _b;
        (_b = (_a = this.props).onAnimationEnd) === null || _b === void 0 ? void 0 : _b.call(_a, false);
      });
    };
    this.state = {
      currentClassName: this.props.startClassName,
      extraStyle: {
        animationFillMode: this.props.fillMode
      },
      isAnimating: true
    };
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    // The purpose is to shield the impact of the presence or absence of animation on the other semi component life cycle.
    // In order to make the component side do not need to manually call the next life cycle function when there is no animation,
    // so when there is no animation , it is logically (and only logically) regarded as an animation with a duration of 0.
    (_b = (_a = this.props).onAnimationStart) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (!this.props.motion) {
      (_d = (_c = this.props).onAnimationEnd) === null || _d === void 0 ? void 0 : _d.call(_c, false);
      this.setState({
        isAnimating: false
      });
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const changedKeys = Object.keys(this.props).filter(key => !isEqual_default()(this.props[key], prevProps[key]));
    if (changedKeys.includes("animationState")) {}
    if (changedKeys.includes("startClassName") || changedKeys.includes('replayKey') || changedKeys.includes("motion")) {
      this.setState({
        currentClassName: this.props.startClassName,
        extraStyle: {
          animationFillMode: this.props.fillMode
        },
        isAnimating: true
      }, () => {
        var _a, _b, _c, _d;
        (_b = (_a = this.props).onAnimationStart) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!this.props.motion) {
          (_d = (_c = this.props).onAnimationEnd) === null || _d === void 0 ? void 0 : _d.call(_c, this.state.isAnimating);
          this.setState({
            isAnimating: false
          });
        }
      });
    }
  }
  render() {
    var _a;
    if (this.props.motion) {
      return this.props.children({
        animationClassName: (_a = this.state.currentClassName) !== null && _a !== void 0 ? _a : "",
        animationStyle: this.state.extraStyle,
        animationEventsNeedBind: {
          onAnimationStart: this.handleAnimationStart,
          onAnimationEnd: this.handleAnimationEnd
        },
        isAnimating: this.state.isAnimating
      });
    } else {
      return this.props.children({
        animationClassName: "",
        animationStyle: {},
        animationEventsNeedBind: {},
        isAnimating: this.state.isAnimating
      });
    }
  }
}
CSSAnimation.defaultProps = {
  motion: true,
  replayKey: ""
};
// const mergeAnimationFunction = (eventHandleFunctions: AnimationEventsNeedBind[]) => {
//     //merge function in objects
//     const mergedFunction = {};
//     eventHandleFunctions.forEach(eventHandleFunction => {
//         Object.keys(eventHandleFunction).forEach(key => {
//             if (mergedFunction[key]) {
//                 const oldFunction = mergedFunction[key];
//                 mergedFunction[key] = (e) => {
//                     eventHandleFunction[key](e);
//                     oldFunction(e);
//                 };
//             } else {
//                 mergedFunction[key] = eventHandleFunction[key];
//             }
//         });
//     });
//     return mergedFunction;
// };
// export { mergeAnimationFunction };
/* harmony default export */ var _cssAnimation = (CSSAnimation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tooltip/index.js








var tooltip_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











// import '@douyinfe/semi-foundation/lib/es/tooltip/tooltip.css';









const prefix = constants_cssClasses.PREFIX;
const positionSet = tooltip_constants_strings.POSITION_SET;
const triggerSet = tooltip_constants_strings.TRIGGER_SET;
const blockDisplays = ['flex', 'block', 'table', 'flow-root', 'grid'];
const tooltip_defaultGetContainer = () => document.body;
class Tooltip extends BaseComponent {
  constructor(props) {
    super(props);
    this.setContainerEl = node => this.containerEl = {
      current: node
    };
    this.isSpecial = elem => {
      if (isElement(elem)) {
        return Boolean(elem.disabled);
      } else if ( /*#__PURE__*/(0,react.isValidElement)(elem)) {
        const disabled = get_default()(elem, 'props.disabled');
        if (disabled) {
          return tooltip_constants_strings.STATUS_DISABLED;
        }
        const loading = get_default()(elem, 'props.loading');
        /* Only judge the loading state of the Button, and no longer judge other components */
        const isButton = !isEmpty_default()(elem) && !isEmpty_default()(elem.type) && (get_default()(elem, 'type.elementType') === 'Button' || get_default()(elem, 'type.elementType') === 'IconButton');
        if (loading && isButton) {
          return tooltip_constants_strings.STATUS_LOADING;
        }
      }
      return false;
    };
    // willEnter = () => {
    // this.foundation.calcPosition();
    // this.setState({ visible: true });
    // };
    this.didLeave = () => {
      if (this.props.keepDOM) {
        this.foundation.setDisplayNone(true);
      } else {
        this.foundation.removePortal();
      }
      this.foundation.unBindEvent();
    };
    this.renderIcon = () => {
      const {
        placement
      } = this.state;
      const {
        showArrow,
        prefixCls,
        style
      } = this.props;
      let icon = null;
      const triangleCls = classnames_default()([`${prefixCls}-icon-arrow`]);
      const bgColor = get_default()(style, 'backgroundColor');
      const iconComponent = placement.includes('left') || placement.includes('right') ? /*#__PURE__*/react.createElement(tooltip_TriangleArrowVertical, null) : /*#__PURE__*/react.createElement(tooltip_TriangleArrow, null);
      if (showArrow) {
        if ( /*#__PURE__*/(0,react.isValidElement)(showArrow)) {
          icon = showArrow;
        } else {
          icon = /*#__PURE__*/react.cloneElement(iconComponent, {
            className: triangleCls,
            style: {
              color: bgColor,
              fill: 'currentColor'
            }
          });
        }
      }
      return icon;
    };
    this.handlePortalInnerClick = e => {
      if (this.props.clickToHide) {
        this.foundation.hide();
      }
      if (this.props.stopPropagation) {
        stopPropagation(e);
      }
    };
    this.handlePortalMouseDown = e => {
      if (this.props.stopPropagation) {
        stopPropagation(e);
      }
    };
    this.handlePortalFocus = e => {
      if (this.props.stopPropagation) {
        stopPropagation(e);
      }
    };
    this.handlePortalBlur = e => {
      if (this.props.stopPropagation) {
        stopPropagation(e);
      }
    };
    this.handlePortalInnerKeyDown = e => {
      this.foundation.handleContainerKeydown(e);
    };
    this.renderContentNode = content => {
      const contentProps = {
        initialFocusRef: this.initialFocusRef
      };
      return !isFunction_default()(content) ? content : content(contentProps);
    };
    this.renderPortal = () => {
      const {
        containerStyle = {},
        visible,
        portalEventSet,
        placement,
        displayNone,
        transitionState,
        id,
        isPositionUpdated
      } = this.state;
      const {
        prefixCls,
        content,
        showArrow,
        style,
        motion,
        role,
        zIndex
      } = this.props;
      const contentNode = this.renderContentNode(content);
      const {
        className: propClassName
      } = this.props;
      const direction = this.context.direction;
      const className = classnames_default()(propClassName, {
        [`${prefixCls}-wrapper`]: true,
        [`${prefixCls}-wrapper-show`]: visible,
        [`${prefixCls}-with-arrow`]: Boolean(showArrow),
        [`${prefixCls}-rtl`]: direction === 'rtl'
      });
      const icon = this.renderIcon();
      const portalInnerStyle = omit_default()(containerStyle, motion ? ['transformOrigin'] : undefined);
      const transformOrigin = get_default()(containerStyle, 'transformOrigin');
      const userOpacity = get_default()(style, 'opacity', null);
      const opacity = userOpacity ? userOpacity : 1;
      const inner = /*#__PURE__*/react.createElement(_cssAnimation, {
        fillMode: "forwards",
        animationState: transitionState,
        motion: motion && isPositionUpdated,
        startClassName: transitionState === 'enter' ? `${prefix}-animation-show` : `${prefix}-animation-hide`,
        onAnimationEnd: () => {
          var _a, _b;
          if (transitionState === 'leave') {
            this.didLeave();
            (_b = (_a = this.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
          }
        }
      }, _ref => {
        let {
          animationStyle,
          animationClassName,
          animationEventsNeedBind
        } = _ref;
        return /*#__PURE__*/react.createElement("div", Object.assign({
          className: classnames_default()(className, animationClassName),
          style: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, animationStyle), displayNone ? {
            display: "none"
          } : {}), {
            transformOrigin
          }), style), userOpacity ? {
            opacity: isPositionUpdated ? opacity : "0"
          } : {})
        }, portalEventSet, animationEventsNeedBind, {
          role: role,
          "x-placement": placement,
          id: id
        }), /*#__PURE__*/react.createElement("div", {
          className: `${prefix}-content`
        }, contentNode), icon);
      });
      return /*#__PURE__*/react.createElement(_portal, {
        getPopupContainer: this.props.getPopupContainer,
        style: {
          zIndex
        }
      }, /*#__PURE__*/react.createElement("div", {
        // listen keyboard event, don't move tabIndex -1
        tabIndex: -1,
        className: `${BASE_CLASS_PREFIX}-portal-inner`,
        style: portalInnerStyle,
        ref: this.setContainerEl,
        onClick: this.handlePortalInnerClick,
        onFocus: this.handlePortalFocus,
        onBlur: this.handlePortalBlur,
        onMouseDown: this.handlePortalMouseDown,
        onKeyDown: this.handlePortalInnerKeyDown
      }, inner));
    };
    this.wrapSpan = elem => {
      const {
        wrapperClassName
      } = this.props;
      const display = get_default()(elem, 'props.style.display');
      const block = get_default()(elem, 'props.block');
      const isStringElem = typeof elem == 'string';
      const style = {};
      if (!isStringElem) {
        style.display = 'inline-block';
      }
      if (block || blockDisplays.includes(display)) {
        style.width = '100%';
      }
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      return /*#__PURE__*/react.createElement("span", {
        className: wrapperClassName,
        style: style
      }, elem);
    };
    this.mergeEvents = (rawEvents, events) => {
      const mergedEvents = {};
      each_default()(events, (handler, key) => {
        if (typeof handler === 'function') {
          mergedEvents[key] = function () {
            handler(...arguments);
            if (rawEvents && typeof rawEvents[key] === 'function') {
              rawEvents[key](...arguments);
            }
          };
        }
      });
      return mergedEvents;
    };
    this.getPopupId = () => {
      return this.state.id;
    };
    this.state = {
      visible: false,
      /**
       *
       * Note: The transitionState parameter is equivalent to isInsert
       */
      transitionState: '',
      triggerEventSet: {},
      portalEventSet: {},
      containerStyle: {
        // zIndex: props.zIndex,
      },
      isInsert: false,
      placement: props.position || 'top',
      transitionStyle: {},
      isPositionUpdated: false,
      id: props.wrapperId,
      displayNone: false
    };
    this.foundation = new foundation_Tooltip(this.adapter);
    this.eventManager = new Event();
    this.triggerEl = /*#__PURE__*/react.createRef();
    this.containerEl = /*#__PURE__*/react.createRef();
    this.initialFocusRef = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
    this.resizeHandler = null;
    this.isWrapped = false; // Identifies whether a span element is wrapped
    this.containerPosition = undefined;
  }
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      // @ts-ignore
      on: function () {
        return _this.eventManager.on(...arguments);
      },
      // @ts-ignore
      off: function () {
        return _this.eventManager.off(...arguments);
      },
      insertPortal: (content, _a) => {
        var {
            position
          } = _a,
          containerStyle = tooltip_rest(_a, ["position"]);
        this.setState({
          isInsert: true,
          transitionState: 'enter',
          containerStyle: Object.assign(Object.assign({}, this.state.containerStyle), containerStyle)
        }, () => {
          setTimeout(() => {
            // waiting child component mounted
            this.eventManager.emit('portalInserted');
          }, 0);
        });
      },
      removePortal: () => {
        this.setState({
          isInsert: false,
          isPositionUpdated: false
        });
      },
      getEventName: () => ({
        mouseEnter: 'onMouseEnter',
        mouseLeave: 'onMouseLeave',
        mouseOut: 'onMouseOut',
        mouseOver: 'onMouseOver',
        click: 'onClick',
        focus: 'onFocus',
        blur: 'onBlur',
        keydown: 'onKeyDown',
        contextMenu: 'onContextMenu'
      }),
      registerTriggerEvent: triggerEventSet => {
        this.setState({
          triggerEventSet
        });
      },
      registerPortalEvent: portalEventSet => {
        this.setState({
          portalEventSet
        });
      },
      getTriggerBounding: () => {
        // It may be a React component or an html element
        // There is no guarantee that triggerE l.current can get the real dom, so call findDOMNode to ensure that you can get the real dom
        const triggerDOM = this.adapter.getTriggerNode();
        this.triggerEl.current = triggerDOM;
        return triggerDOM && triggerDOM.getBoundingClientRect();
      },
      // Gets the outer size of the specified container
      getPopupContainerRect: () => {
        const container = this.getPopupContainer();
        let rect = null;
        if (container && isElement(container)) {
          const boundingRect = convertDOMRectToObject(container.getBoundingClientRect());
          rect = Object.assign(Object.assign({}, boundingRect), {
            scrollLeft: container.scrollLeft,
            scrollTop: container.scrollTop
          });
        }
        return rect;
      },
      containerIsBody: () => {
        const container = this.getPopupContainer();
        return container === document.body;
      },
      containerIsRelative: () => {
        const container = this.getPopupContainer();
        const computedStyle = window.getComputedStyle(container);
        return computedStyle.getPropertyValue('position') === 'relative';
      },
      containerIsRelativeOrAbsolute: () => ['relative', 'absolute'].includes(this.containerPosition),
      // Get the size of the pop-up layer
      getWrapperBounding: () => {
        const el = this.containerEl && this.containerEl.current;
        return el && el.getBoundingClientRect();
      },
      getDocumentElementBounding: () => document.documentElement.getBoundingClientRect(),
      setPosition: _a => {
        var {
            position
          } = _a,
          style = tooltip_rest(_a, ["position"]);
        this.setState({
          containerStyle: Object.assign(Object.assign({}, this.state.containerStyle), style),
          placement: position,
          isPositionUpdated: true
        }, () => {
          this.eventManager.emit('positionUpdated');
        });
      },
      setDisplayNone: (displayNone, cb) => {
        this.setState({
          displayNone
        }, cb);
      },
      updatePlacementAttr: placement => {
        this.setState({
          placement
        });
      },
      togglePortalVisible: (visible, cb) => {
        const willUpdateStates = {};
        willUpdateStates.transitionState = visible ? 'enter' : 'leave';
        willUpdateStates.visible = visible;
        this.mounted && this.setState(willUpdateStates, () => {
          cb();
        });
      },
      registerClickOutsideHandler: cb => {
        if (this.clickOutsideHandler) {
          this.adapter.unregisterClickOutsideHandler();
        }
        this.clickOutsideHandler = e => {
          if (!this.mounted) {
            return false;
          }
          let el = this.triggerEl && this.triggerEl.current;
          let popupEl = this.containerEl && this.containerEl.current;
          el = react_dom.findDOMNode(el);
          popupEl = react_dom.findDOMNode(popupEl);
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          const isClickTriggerToHide = this.props.clickTriggerToHide ? el && el.contains(target) || path.includes(el) : false;
          if (el && !el.contains(target) && popupEl && !popupEl.contains(target) && !(path.includes(popupEl) || path.includes(el)) || isClickTriggerToHide) {
            this.props.onClickOutSide(e);
            cb();
          }
        };
        window.addEventListener('mousedown', this.clickOutsideHandler);
      },
      unregisterClickOutsideHandler: () => {
        if (this.clickOutsideHandler) {
          window.removeEventListener('mousedown', this.clickOutsideHandler);
          this.clickOutsideHandler = null;
        }
      },
      registerResizeHandler: cb => {
        if (this.resizeHandler) {
          this.adapter.unregisterResizeHandler();
        }
        this.resizeHandler = throttle_default()(e => {
          if (!this.mounted) {
            return false;
          }
          cb(e);
        }, 10);
        window.addEventListener('resize', this.resizeHandler, false);
      },
      unregisterResizeHandler: () => {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler, false);
          this.resizeHandler = null;
        }
      },
      notifyVisibleChange: visible => {
        this.props.onVisibleChange(visible);
      },
      registerScrollHandler: rePositionCb => {
        if (this.scrollHandler) {
          this.adapter.unregisterScrollHandler();
        }
        this.scrollHandler = throttle_default()(e => {
          if (!this.mounted) {
            return false;
          }
          const triggerDOM = this.adapter.getTriggerNode();
          const isRelativeScroll = e.target.contains(triggerDOM);
          if (isRelativeScroll) {
            const scrollPos = {
              x: e.target.scrollLeft,
              y: e.target.scrollTop
            };
            rePositionCb(scrollPos);
          }
        }, 10); // When it is greater than 16ms, it will be very obvious
        window.addEventListener('scroll', this.scrollHandler, true);
      },
      unregisterScrollHandler: () => {
        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler, true);
          this.scrollHandler = null;
        }
      },
      canMotion: () => Boolean(this.props.motion),
      updateContainerPosition: () => {
        const container = this.getPopupContainer();
        if (container && isElement(container)) {
          // getComputedStyle need first parameter is Element type
          const computedStyle = window.getComputedStyle(container);
          const position = computedStyle.getPropertyValue('position');
          this.containerPosition = position;
        }
      },
      getContainerPosition: () => this.containerPosition,
      getContainer: () => this.containerEl && this.containerEl.current,
      getTriggerNode: () => {
        let triggerDOM = this.triggerEl.current;
        if (!isElement(this.triggerEl.current)) {
          triggerDOM = react_dom.findDOMNode(this.triggerEl.current);
        }
        return triggerDOM;
      },
      getFocusableElements: node => {
        return getFocusableElements(node);
      },
      getActiveElement: () => {
        return getActiveElement();
      },
      setInitialFocus: () => {
        const {
          preventScroll
        } = this.props;
        const focusRefNode = get_default()(this, 'initialFocusRef.current');
        if (focusRefNode && 'focus' in focusRefNode) {
          focusRefNode.focus({
            preventScroll
          });
        }
      },
      notifyEscKeydown: event => {
        this.props.onEscKeyDown(event);
      },
      setId: () => {
        this.setState({
          id: getUuidShort()
        });
      },
      getTriggerDOM: () => {
        if (this.triggerEl.current) {
          return react_dom.findDOMNode(this.triggerEl.current);
        } else {
          return null;
        }
      }
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.getPopupContainer = this.props.getPopupContainer || this.context.getPopupContainer || tooltip_defaultGetContainer;
    this.foundation.init();
    runAfterTicks(() => {
      let triggerEle = this.triggerEl.current;
      if (triggerEle) {
        if (!(triggerEle instanceof HTMLElement)) {
          triggerEle = (0,react_dom.findDOMNode)(triggerEle);
        }
      }
      this.foundation.updateStateIfCursorOnTrigger(triggerEle);
    }, 1);
  }
  componentWillUnmount() {
    this.mounted = false;
    this.foundation.destroy();
  }
  /**
   * focus on tooltip trigger
   */
  focusTrigger() {
    this.foundation.focusTrigger();
  }
  /** for transition - end */
  rePosition() {
    return this.foundation.calcPosition();
  }
  componentDidUpdate(prevProps, prevState) {
    warning(this.props.mouseLeaveDelay < this.props.mouseEnterDelay, "[Semi Tooltip] 'mouseLeaveDelay' cannot be less than 'mouseEnterDelay', which may cause the dropdown layer to not be hidden.");
    if (prevProps.visible !== this.props.visible) {
      if (['hover', 'focus'].includes(this.props.trigger)) {
        this.props.visible ? this.foundation.delayShow() : this.foundation.delayHide();
      } else {
        this.props.visible ? this.foundation.show() : this.foundation.hide();
      }
    }
    if (!isEqual_default()(prevProps.rePosKey, this.props.rePosKey)) {
      this.rePosition();
    }
  }
  render() {
    const {
      isInsert,
      triggerEventSet,
      visible,
      id
    } = this.state;
    const {
      wrapWhenSpecial,
      role,
      trigger
    } = this.props;
    let {
      children
    } = this.props;
    const childrenStyle = Object.assign({}, get_default()(children, 'props.style'));
    const extraStyle = {};
    if (wrapWhenSpecial) {
      const isSpecial = this.isSpecial(children);
      if (isSpecial) {
        childrenStyle.pointerEvents = 'none';
        if (isSpecial === tooltip_constants_strings.STATUS_DISABLED) {
          extraStyle.cursor = 'not-allowed';
        }
        children = /*#__PURE__*/(0,react.cloneElement)(children, {
          style: childrenStyle
        });
        if (trigger !== 'custom') {
          // no need to wrap span when trigger is custom, cause it don't need bind event
          children = this.wrapSpan(children);
        }
        this.isWrapped = true;
      } else if (! /*#__PURE__*/(0,react.isValidElement)(children)) {
        children = this.wrapSpan(children);
        this.isWrapped = true;
      }
    }
    let ariaAttribute = {};
    // Take effect when used by Popover component
    if (role === 'dialog') {
      ariaAttribute['aria-expanded'] = visible ? 'true' : 'false';
      ariaAttribute['aria-haspopup'] = 'dialog';
      ariaAttribute['aria-controls'] = id;
    } else {
      ariaAttribute['aria-describedby'] = id;
    }
    // The incoming children is a single valid element, otherwise wrap a layer with span
    const newChild = /*#__PURE__*/react.cloneElement(children, Object.assign(Object.assign(Object.assign(Object.assign({}, ariaAttribute), children.props), this.mergeEvents(children.props, triggerEventSet)), {
      style: Object.assign(Object.assign({}, get_default()(children, 'props.style')), extraStyle),
      className: classnames_default()(get_default()(children, 'props.className')),
      // to maintain refs with callback
      ref: node => {
        // Keep your own reference
        this.triggerEl.current = node;
        // Call the original ref, if any
        const {
          ref
        } = children;
        // this.log('tooltip render() - get ref', ref);
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref && typeof ref === 'object') {
          ref.current = node;
        }
      },
      tabIndex: children.props.tabIndex || 0,
      'data-popupid': id
    }));
    // If you do not add a layer of div, in order to bind the events and className in the tooltip, you need to cloneElement children, but this time it may overwrite the children's original ref reference
    // So if the user adds ref to the content, you need to use callback ref: https://github.com/facebook/react/issues/8873
    return /*#__PURE__*/react.createElement(react.Fragment, null, isInsert ? this.renderPortal() : null, newChild);
  }
}
Tooltip.contextType = context;
Tooltip.propTypes = {
  children: (prop_types_default()).node,
  motion: (prop_types_default()).bool,
  autoAdjustOverflow: (prop_types_default()).bool,
  position: prop_types_default().oneOf(positionSet),
  getPopupContainer: (prop_types_default()).func,
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  trigger: prop_types_default().oneOf(triggerSet).isRequired,
  className: (prop_types_default()).string,
  wrapperClassName: (prop_types_default()).string,
  clickToHide: (prop_types_default()).bool,
  // used with trigger === hover, private
  clickTriggerToHide: (prop_types_default()).bool,
  visible: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  content: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  prefixCls: (prop_types_default()).string,
  onVisibleChange: (prop_types_default()).func,
  onClickOutSide: (prop_types_default()).func,
  spacing: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  margin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  showArrow: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).node]),
  zIndex: (prop_types_default()).number,
  rePosKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  arrowBounding: ArrowBoundingShape,
  transformFromCenter: (prop_types_default()).bool,
  arrowPointAtCenter: (prop_types_default()).bool,
  stopPropagation: (prop_types_default()).bool,
  // private
  role: (prop_types_default()).string,
  wrapWhenSpecial: (prop_types_default()).bool,
  guardFocus: (prop_types_default()).bool,
  returnFocusOnClose: (prop_types_default()).bool,
  preventScroll: (prop_types_default()).bool,
  keepDOM: (prop_types_default()).bool
};
Tooltip.__SemiComponentName__ = "Tooltip";
Tooltip.defaultProps = getDefaultPropsFromGlobalConfig(Tooltip.__SemiComponentName__, {
  arrowBounding: numbers.ARROW_BOUNDING,
  autoAdjustOverflow: true,
  arrowPointAtCenter: true,
  trigger: 'hover',
  transformFromCenter: true,
  position: 'top',
  prefixCls: prefix,
  role: 'tooltip',
  mouseEnterDelay: numbers.MOUSE_ENTER_DELAY,
  mouseLeaveDelay: numbers.MOUSE_LEAVE_DELAY,
  motion: true,
  onVisibleChange: (noop_default()),
  onClickOutSide: (noop_default()),
  spacing: numbers.SPACING,
  margin: numbers.MARGIN,
  showArrow: true,
  wrapWhenSpecial: true,
  zIndex: numbers.DEFAULT_Z_INDEX,
  closeOnEsc: false,
  guardFocus: false,
  returnFocusOnClose: false,
  onEscKeyDown: (noop_default()),
  disableFocusListener: false,
  disableArrowKeyDown: false,
  keepDOM: false
});
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/popover/Arrow.js

var Arrow_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const Arrow = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
      position = '',
      className,
      arrowStyle,
      popStyle
    } = props,
    rest = Arrow_rest(props, ["position", "className", "arrowStyle", "popStyle"]);
  const isVertical = position.indexOf('top') === 0 || position.indexOf('bottom') === 0;
  const cls = classnames_default()(className, popover_constants_cssClasses.ARROW);
  const borderOpacity = get_default()(arrowStyle, 'borderOpacity', popover_constants_strings.DEFAULT_ARROW_STYLE.borderOpacity);
  const bgColor = get_default()(arrowStyle, 'backgroundColor', get_default()(popStyle, 'backgroundColor', popover_constants_strings.DEFAULT_ARROW_STYLE.backgroundColor));
  const borderColor = get_default()(arrowStyle, 'borderColor', get_default()(popStyle, 'borderColor', popover_constants_strings.DEFAULT_ARROW_STYLE.borderColor));
  const wrapProps = Object.assign(Object.assign({}, rest), {
    width: constants_numbers.ARROW_BOUNDING.width,
    height: constants_numbers.ARROW_BOUNDING.height,
    xmlns: 'http://www.w3.org/2000/svg',
    className: cls
  });
  return isVertical ? /*#__PURE__*/react.createElement("svg", Object.assign({}, wrapProps), /*#__PURE__*/react.createElement("path", {
    d: "M0 0.5L0 1.5C4 1.5, 5.5 3, 7.5 5S10,8 12,8S14.5 7, 16.5 5S20,1.5 24,1.5L24 0.5L0 0.5z",
    fill: borderColor,
    opacity: borderOpacity
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 0L0 1C4 1, 5.5 2, 7.5 4S10,7 12,7S14.5  6, 16.5 4S20,1 24,1L24 0L0 0z",
    fill: bgColor
  })) : /*#__PURE__*/react.createElement("svg", Object.assign({}, wrapProps), /*#__PURE__*/react.createElement("path", {
    d: "M0.5 0L1.5 0C1.5 4, 3 5.5, 5 7.5S8,10 8,12S7 14.5, 5 16.5S1.5,20 1.5,24L0.5 24L0.5 0z",
    fill: borderColor,
    opacity: borderOpacity
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 0L1 0C1 4, 2 5.5, 4 7.5S7,10 7,12S6 14.5, 4 16.5S1,20 1,24L0 24L0 0z",
    fill: bgColor
  }));
};
Arrow.propTypes = {
  position: (prop_types_default()).string,
  className: (prop_types_default()).string,
  arrowStyle: (prop_types_default()).object,
  popStyle: (prop_types_default()).object
};
/* harmony default export */ var popover_Arrow = (Arrow);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/popover/index.js


var popover_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/popover/popover.css';


const popover_positionSet = popover_constants_strings.POSITION_SET;
const popover_triggerSet = popover_constants_strings.TRIGGER_SET;
class Popover extends react.PureComponent {
  constructor(props) {
    super(props);
    /**
     * focus on tooltip trigger
     */
    this.focusTrigger = () => {
      var _a;
      (_a = this.tooltipRef.current) === null || _a === void 0 ? void 0 : _a.focusTrigger();
    };
    this.renderPopCard = _ref => {
      let {
        initialFocusRef
      } = _ref;
      const {
        content,
        contentClassName,
        prefixCls
      } = this.props;
      const {
        direction
      } = this.context;
      const popCardCls = classnames_default()(prefixCls, contentClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
      });
      const contentNode = this.renderContentNode({
        initialFocusRef,
        content
      });
      return /*#__PURE__*/react.createElement("div", {
        className: popCardCls
      }, /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-content`
      }, contentNode));
    };
    this.renderContentNode = props => {
      const {
        initialFocusRef,
        content
      } = props;
      const contentProps = {
        initialFocusRef
      };
      return !isFunction_default()(content) ? content : content(contentProps);
    };
    this.tooltipRef = /*#__PURE__*/react.createRef();
  }
  render() {
    const _a = this.props,
      {
        children,
        prefixCls,
        showArrow,
        arrowStyle = {},
        arrowBounding,
        position,
        style,
        trigger
      } = _a,
      attr = popover_rest(_a, ["children", "prefixCls", "showArrow", "arrowStyle", "arrowBounding", "position", "style", "trigger"]);
    let {
      spacing
    } = this.props;
    const arrowProps = {
      position,
      className: '',
      popStyle: style,
      arrowStyle
    };
    const arrow = showArrow ? /*#__PURE__*/react.createElement(popover_Arrow, Object.assign({}, arrowProps)) : false;
    if (isNullOrUndefined(spacing)) {
      spacing = showArrow ? constants_numbers.SPACING_WITH_ARROW : constants_numbers.SPACING;
    }
    const role = trigger === 'click' || trigger === 'custom' ? 'dialog' : 'tooltip';
    return /*#__PURE__*/react.createElement(Tooltip, Object.assign({
      guardFocus: true,
      ref: this.tooltipRef
    }, attr, {
      trigger: trigger,
      position: position,
      style: style,
      content: this.renderPopCard,
      prefixCls: prefixCls,
      spacing: spacing,
      showArrow: arrow,
      arrowBounding: arrowBounding,
      role: role
    }), children);
  }
}
Popover.contextType = context;
Popover.propTypes = {
  children: (prop_types_default()).node,
  content: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  visible: (prop_types_default()).bool,
  autoAdjustOverflow: (prop_types_default()).bool,
  motion: (prop_types_default()).bool,
  position: prop_types_default().oneOf(popover_positionSet),
  // getPopupContainer: PropTypes.func,
  margin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  trigger: prop_types_default().oneOf(popover_triggerSet).isRequired,
  contentClassName: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  onVisibleChange: (prop_types_default()).func,
  onClickOutSide: (prop_types_default()).func,
  style: (prop_types_default()).object,
  spacing: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  zIndex: (prop_types_default()).number,
  showArrow: (prop_types_default()).bool,
  arrowStyle: prop_types_default().shape({
    borderColor: (prop_types_default()).string,
    backgroundColor: (prop_types_default()).string,
    borderOpacity: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
  }),
  arrowPointAtCenter: (prop_types_default()).bool,
  arrowBounding: (prop_types_default()).object,
  prefixCls: (prop_types_default()).string,
  guardFocus: (prop_types_default()).bool,
  disableArrowKeyDown: (prop_types_default()).bool
};
Popover.__SemiComponentName__ = "Popover";
Popover.defaultProps = getDefaultPropsFromGlobalConfig(Popover.__SemiComponentName__, {
  arrowBounding: constants_numbers.ARROW_BOUNDING,
  showArrow: false,
  autoAdjustOverflow: true,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  motion: true,
  trigger: 'hover',
  cancelText: 'No',
  okText: 'Yes',
  position: 'bottom',
  prefixCls: popover_constants_cssClasses.PREFIX,
  onClickOutSide: (noop_default()),
  onEscKeyDown: (noop_default()),
  closeOnEsc: true,
  returnFocusOnClose: true,
  guardFocus: true,
  disableFocusListener: true
});
/* harmony default export */ var popover = (Popover);
// EXTERNAL MODULE: ./node_modules/lodash/isNull.js
var isNull = __webpack_require__(45220);
var isNull_default = /*#__PURE__*/__webpack_require__.n(isNull);
// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__(52353);
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/breadcrumb/itemFoundation.js

class BreadcrumbItemFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  handleClick(item, e) {
    // Trigger its own onClick first, then trigger the parent
    this._adapter.notifyClick(item, e);
    this._adapter.notifyParent(item, e);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/breadcrumb/bread-context.js

const BreadContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var bread_context = (BreadContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/typography/constants.js

const typography_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-typography`
};
const typography_constants_strings = {
  WEIGHT: ['light', 'regular', 'medium', 'semibold', 'bold', "default"],
  TYPE: ['primary', 'secondary', 'danger', 'warning', 'success', 'tertiary', 'quaternary'],
  SIZE: ['normal', 'small', "inherit"],
  SPACING: ['normal', 'extended'],
  HEADING: [1, 2, 3, 4, 5, 6],
  RULE: ['text', 'numbers', 'bytes-decimal', 'bytes-binary', 'percentages', 'exponential'],
  TRUNCATE: ['ceil', 'floor', 'round']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/typography.js
var typography_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




// import '@douyinfe/semi-foundation/lib/es/typography/typography.css';
const prefixCls = typography_constants_cssClasses.PREFIX;
class Typography extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        component,
        className,
        children,
        forwardRef
      } = _a,
      rest = typography_rest(_a, ["component", "className", "children", "forwardRef"]);
    const Component = component;
    const classNames = classnames_default()(prefixCls, className);
    return /*#__PURE__*/react.createElement(Component, Object.assign({
      className: classNames,
      ref: forwardRef
    }, rest), children);
  }
}
Typography.defaultProps = {
  component: 'article',
  style: {},
  className: ''
};
Typography.propTypes = {
  component: (prop_types_default()).string,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string
};
/* harmony default export */ var typography = (Typography);
// EXTERNAL MODULE: ./node_modules/copy-text-to-clipboard/index.js
var copy_text_to_clipboard = __webpack_require__(735);
var copy_text_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_text_to_clipboard);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/locale/context.js

const LocaleContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var locale_context = (LocaleContext);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '不到 1 秒',
    other: '不到 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分钟',
  lessThanXMinutes: {
    one: '不到 1 分钟',
    other: '不到 {{count}} 分钟'
  },
  xMinutes: {
    one: '1 分钟',
    other: '{{count}} 分钟'
  },
  xHours: {
    one: '1 小时',
    other: '{{count}} 小时'
  },
  aboutXHours: {
    one: '大约 1 小时',
    other: '大约 {{count}} 小时'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大约 1 个星期',
    other: '大约 {{count}} 个星期'
  },
  xWeeks: {
    one: '1 个星期',
    other: '{{count}} 个星期'
  },
  aboutXMonths: {
    one: '大约 1 个月',
    other: '大约 {{count}} 个月'
  },
  xMonths: {
    one: '1 个月',
    other: '{{count}} 个月'
  },
  aboutXYears: {
    one: '大约 1 年',
    other: '大约 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超过 1 年',
    other: '超过 {{count}} 年'
  },
  almostXYears: {
    one: '将近 1 年',
    other: '将近 {{count}} 年'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + '内';
    } else {
      return result + '前';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatLong/index.js

var dateFormats = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var timeFormats = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate_toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate_toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js


function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatRelative/index.js

function checkWeek(date, baseDate, options) {
  var baseFormat = 'eeee p';
  if (isSameUTCWeek(date, baseDate, options)) {
    return baseFormat; // in same week
  } else if (date.getTime() > baseDate.getTime()) {
    return "'下个'" + baseFormat; // in next week
  }

  return "'上个'" + baseFormat; // in last week
}

var formatRelativeLocale = {
  lastWeek: checkWeek,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: checkWeek,
  // days after tomorrow, maybe in this week or next week
  other: 'PP p'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
  var format = formatRelativeLocale[token];
  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }
  return format;
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/localize/index.js

var eraValues = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
};
var monthValues = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var dayValues = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var dayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  switch (options === null || options === void 0 ? void 0 : options.unit) {
    case 'date':
      return number.toString() + '日';
    case 'hour':
      return number.toString() + '时';
    case 'minute':
      return number.toString() + '分';
    case 'second':
      return number.toString() + '秒';
    default:
      return '第 ' + number.toString();
  }
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/match/index.js


var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
  any: [/^(前)/i, /^(公元)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
};
var parseQuarterPatterns = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var matchMonthPatterns = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var matchDayPatterns = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var matchDayPeriodPatterns = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */
var locale = {
  code: 'zh-CN',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var zh_CN = (locale);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/locale/source/zh_CN.js

const local = {
  code: 'zh-CN',
  dateFnsLocale: zh_CN,
  Pagination: {
    pageSize: '每页条数：${pageSize}',
    total: '总页数：${total}',
    jumpTo: '跳至',
    page: '页'
  },
  Modal: {
    confirm: '确定',
    cancel: '取消'
  },
  Tabs: {
    more: "更多"
  },
  TimePicker: {
    placeholder: {
      time: '请选择时间',
      timeRange: '请选择时间范围'
    },
    begin: '开始时间',
    end: '结束时间',
    hour: '时',
    minute: '分',
    second: '秒',
    AM: '上午',
    PM: '下午'
  },
  DatePicker: {
    placeholder: {
      date: '请选择日期',
      dateTime: '请选择日期及时间',
      dateRange: ['开始日期', '结束日期'],
      dateTimeRange: ['开始日期', '结束日期'],
      monthRange: ['开始月份', '结束月份']
    },
    presets: '快捷选择',
    footer: {
      confirm: '确定',
      cancel: '取消'
    },
    selectDate: '返回选择日期',
    selectTime: '选择时间',
    year: '年',
    month: '月',
    day: '日',
    monthText: '${year}年 ${month}',
    months: {
      1: '1月',
      2: '2月',
      3: '3月',
      4: '4月',
      5: '5月',
      6: '6月',
      7: '7月',
      8: '8月',
      9: '9月',
      10: '10月',
      11: '11月',
      12: '12月'
    },
    // timepicker scrollwheel里只需要展示[1、2……]，所以这里的fullMonths根据UI定制了
    fullMonths: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12'
    },
    weeks: {
      Mon: '一',
      Tue: '二',
      Wed: '三',
      Thu: '四',
      Fri: '五',
      Sat: '六',
      Sun: '日'
    },
    localeFormatToken: {
      FORMAT_SWITCH_DATE: 'yyyy-MM-dd'
    }
  },
  Navigation: {
    collapseText: '收起侧边栏',
    expandText: '展开侧边栏'
  },
  Popconfirm: {
    confirm: '确定',
    cancel: '取消'
  },
  Table: {
    emptyText: '暂无数据',
    pageText: '显示第 ${currentStart} 条-第 ${currentEnd} 条，共 ${total} 条'
  },
  Select: {
    emptyText: '暂无数据',
    createText: '创建'
  },
  Cascader: {
    emptyText: '暂无数据'
  },
  Tree: {
    emptyText: '暂无数据',
    searchPlaceholder: '搜索'
  },
  List: {
    emptyText: '暂无数据'
  },
  Calendar: {
    allDay: '全天',
    AM: '上午${time}时',
    PM: '下午${time}时',
    datestring: '日',
    remaining: '还有${remained}项'
  },
  Upload: {
    mainText: '点击上传文件或拖拽文件到这里',
    illegalTips: '不支持此类型文件',
    legalTips: '松手开始上传',
    retry: '重试',
    replace: '替换文件',
    clear: '清空',
    selectedFiles: '已选择文件',
    illegalSize: '文件尺寸不合法',
    fail: '上传失败'
  },
  TreeSelect: {
    searchPlaceholder: '搜索'
  },
  Typography: {
    copy: '复制',
    copied: '复制成功',
    expand: '展开',
    collapse: '收起'
  },
  Transfer: {
    emptyLeft: '暂无数据',
    emptySearch: '无搜索结果',
    emptyRight: '暂无内容，可从左侧勾选',
    placeholder: '搜索',
    clear: '清空',
    selectAll: '全选',
    clearSelectAll: '取消全选',
    total: '总个数：${total}',
    selected: '已选个数：${total}'
  },
  Form: {
    optional: '（可选）'
  },
  Image: {
    preview: '预览',
    loading: '加载中',
    loadError: '加载失败',
    prevTip: '上一张',
    nextTip: '下一张',
    zoomInTip: '放大',
    zoomOutTip: '缩小',
    rotateTip: '旋转',
    downloadTip: '下载',
    adaptiveTip: '适应页面',
    originTip: '原始尺寸'
  }
};
// 中文
/* harmony default export */ var source_zh_CN = (local);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/locale/localeConsumer.js






class LocaleConsumer extends react.Component {
  renderChildren(localeData, children) {
    const {
      componentName
    } = this.props;
    let locale = localeData;
    if (!(localeData === null || localeData === void 0 ? void 0 : localeData.code)) {
      locale = source_zh_CN;
    }
    /**
     * dateFnsLocale is used to format the date into a local date
     * example:
     *  import { zhCN } from "date-fns/locale";
     *  format(new Date("2021-04-29"), "yyyy-MM-dd EEEE")
     *      => '2021-04-29 Thursday' (默认 locale 为 en-US)
     *  format(new Date('2021-04-29'), "yyyy-MM-dd EEEE", { locale: zhCN })
     *      => '2021-04-29 星期四'
     */
    const defaultFnsLocale = get_default()(source_zh_CN, 'dateFnsLocale');
    const dateFnsLocale = get_default()(locale, 'dateFnsLocale', defaultFnsLocale);
    return children(locale[componentName], locale.code, dateFnsLocale);
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/react.createElement(context.Consumer, null, _ref => {
      let {
        locale
      } = _ref;
      return /*#__PURE__*/react.createElement(locale_context.Consumer, null, localeData => this.renderChildren(locale || localeData, children));
    });
  }
}
LocaleConsumer.propTypes = {
  componentName: (prop_types_default()).string.isRequired,
  children: (prop_types_default()).any
};
LocaleConsumer.defaultProps = {
  componentName: ''
};
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/components/Icon.js + 1 modules
var Icon = __webpack_require__(86360);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconTick.js


function SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3516 4.2652C22.0336 4.73552 22.2052 5.66964 21.7348 6.35162L11.7348 20.8516C11.4765 21.2262 11.0622 21.4632 10.6084 21.4961C10.1546 21.529 9.71041 21.3541 9.40082 21.0207L2.90082 14.0207C2.33711 13.4136 2.37226 12.4645 2.97933 11.9008C3.5864 11.3371 4.53549 11.3723 5.0992 11.9793L10.3268 17.6091L19.2652 4.64842C19.7355 3.96644 20.6696 3.79487 21.3516 4.2652Z",
    fill: "currentColor"
  }));
}
const IconComponent = (0,Icon/* convertIcon */.A)(SvgComponent, 'tick');
/* harmony default export */ var IconTick = (IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconCopy.js


function IconCopy_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M7 4C7 2.89543 7.89543 2 9 2H20C21.1046 2 22 2.89543 22 4V15C22 16.1046 21.1046 17 20 17H19V8C19 6 18 5 16 5H7V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5 7C3.89543 7 3 7.89543 3 9V19C3 20.1046 3.89543 21 5 21H15C16.1046 21 17 20.1046 17 19V9C17 7.89543 16.1046 7 15 7H5Z",
    fill: "currentColor"
  }));
}
const IconCopy_IconComponent = (0,Icon/* convertIcon */.A)(IconCopy_SvgComponent, 'copy');
/* harmony default export */ var IconCopy = (IconCopy_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/copyable.js










const copyable_prefixCls = typography_constants_cssClasses.PREFIX;
class Copyable extends react.PureComponent {
  constructor(props) {
    super(props);
    this.copy = e => {
      const {
        content,
        duration,
        onCopy
      } = this.props;
      const res = copy_text_to_clipboard_default()(content);
      onCopy && onCopy(e, content, res);
      this.setCopied(content, duration);
    };
    this.setCopied = (item, timer) => {
      this.setState({
        copied: true,
        item
      });
      this._timeId = setTimeout(() => {
        this.resetCopied();
      }, timer * 1000);
    };
    this.resetCopied = () => {
      if (this._timeId) {
        clearTimeout(this._timeId);
        this._timeId = null;
        this.setState({
          copied: false,
          item: ''
        });
      }
    };
    this.renderSuccessTip = () => {
      const {
        successTip
      } = this.props;
      if (typeof successTip !== 'undefined') {
        return successTip;
      }
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Typography"
      }, locale => /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement(IconTick, null), locale.copied));
    };
    this.renderCopyIcon = () => {
      const {
        icon
      } = this.props;
      const copyProps = {
        role: "button",
        tabIndex: 0,
        onClick: this.copy,
        onKeyPress: e => utils_isEnterPress(e) && this.copy(e)
      };
      {/* TODO: replace `a` tag with `span` in next major version
         NOTE: may have effect on style */
      }
      const defaultIcon =
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      react.createElement("a", {
        className: `${copyable_prefixCls}-action-copy-icon`
      }, /*#__PURE__*/react.createElement(IconCopy, Object.assign({
        onClick: this.copy
      }, copyProps)));
      return /*#__PURE__*/react.isValidElement(icon) ? /*#__PURE__*/react.cloneElement(icon, copyProps) : defaultIcon;
    };
    this.state = {
      copied: false,
      item: ''
    };
  }
  componentWillUnmount() {
    if (this._timeId) {
      clearTimeout(this._timeId);
      this._timeId = null;
    }
  }
  render() {
    const {
      style,
      className,
      forwardRef,
      copyTip
    } = this.props;
    const {
      copied
    } = this.state;
    const finalCls = classnames_default()(className, {
      [`${copyable_prefixCls}-action-copy`]: !copied,
      [`${copyable_prefixCls}-action-copied`]: copied
    });
    return /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Typography"
    }, locale => /*#__PURE__*/react.createElement("span", {
      style: Object.assign({
        marginLeft: '4px'
      }, style),
      className: finalCls,
      ref: forwardRef
    }, copied ? this.renderSuccessTip() : /*#__PURE__*/react.createElement(Tooltip, {
      content: typeof copyTip !== 'undefined' ? copyTip : locale.copy
    }, this.renderCopyIcon())));
  }
}
Copyable.propTypes = {
  content: (prop_types_default()).string,
  onCopy: (prop_types_default()).func,
  successTip: (prop_types_default()).node,
  copyTip: (prop_types_default()).node,
  duration: (prop_types_default()).number,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  icon: (prop_types_default()).node
};
Copyable.defaultProps = {
  content: '',
  onCopy: function_noop,
  duration: 3,
  style: {},
  className: ''
};
/* harmony default export */ var typography_copyable = (Copyable);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/util.js



/**
 * The logic of JS for text truncation is referenced from antd typography
 * https://github.com/ant-design/ant-design/blob/master/components/typography/util.tsx
 *
 * For more thinking and analysis about this function, please refer to Feishu document
 * https://bytedance.feishu.cn/docs/doccnqovjjyoKm2U5O13bj30aTh
 */
let ellipsisContainer;
function pxToNumber(value) {
  if (!value) {
    return 0;
  }
  const match = value.match(/^\d*(\.\d*)?/);
  return match ? Number(match[0]) : 0;
}
function styleToString(style) {
  // There are some different behavior between Firefox & Chrome.
  // We have to handle this ourself.
  const styleNames = Array.prototype.slice.apply(style);
  return styleNames.map(name => `${name}: ${style.getPropertyValue(name)};`).join('');
}
const getRenderText = function (originEle, rows) {
  let content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let fixedContent = arguments.length > 3 ? arguments[3] : undefined;
  let ellipsisStr = arguments.length > 4 ? arguments[4] : undefined;
  let suffix = arguments.length > 5 ? arguments[5] : undefined;
  let ellipsisPos = arguments.length > 6 ? arguments[6] : undefined;
  if (content.length === 0) {
    return '';
  }
  if (!ellipsisContainer) {
    ellipsisContainer = document.createElement('div');
    ellipsisContainer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ellipsisContainer);
  }
  // Get origin style
  const originStyle = window.getComputedStyle(originEle);
  const originCSS = styleToString(originStyle);
  const lineHeight = pxToNumber(originStyle.lineHeight);
  const maxHeight = Math.round(lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom));
  // Set shadow
  ellipsisContainer.setAttribute('style', originCSS);
  ellipsisContainer.style.position = 'fixed';
  ellipsisContainer.style.left = '0';
  ellipsisContainer.style.height = 'auto';
  ellipsisContainer.style.top = '-999999px';
  ellipsisContainer.style.zIndex = '-1000';
  // clean up css overflow
  ellipsisContainer.style.textOverflow = 'clip';
  ellipsisContainer.style.webkitLineClamp = 'none';
  // Render fake container
  react_dom.render( /*#__PURE__*/react.createElement(react.Fragment, null), ellipsisContainer);
  // Check if ellipsis in measure div is enough for content
  function inRange() {
    // If content does not wrap due to line break strategy, width should be judged to determine whether it's in range
    const widthInRange = ellipsisContainer.scrollWidth <= ellipsisContainer.offsetWidth;
    const heightInRange = ellipsisContainer.scrollHeight < maxHeight;
    return rows === 1 ? widthInRange && heightInRange : heightInRange;
  }
  // ========================= Find match ellipsis content =========================
  // Create origin content holder
  const ellipsisContentHolder = document.createElement('span');
  const textNode = document.createTextNode(content);
  ellipsisContentHolder.appendChild(textNode);
  if (suffix.length > 0) {
    const ellipsisTextNode = document.createTextNode(suffix);
    ellipsisContentHolder.appendChild(ellipsisTextNode);
  }
  ellipsisContainer.appendChild(ellipsisContentHolder);
  // Expand node needs to be added only when text needTruncated
  Object.values(omit_default()(fixedContent, 'expand')).map(node => node && ellipsisContainer.appendChild(node.cloneNode(true)));
  function appendExpandNode() {
    ellipsisContainer.innerHTML = '';
    ellipsisContainer.appendChild(ellipsisContentHolder);
    Object.values(fixedContent).map(node => node && ellipsisContainer.appendChild(node.cloneNode(true)));
  }
  function getCurrentText(text, pos) {
    const end = text.length;
    if (!pos) {
      return ellipsisStr;
    }
    if (ellipsisPos === 'end') {
      return text.slice(0, pos) + ellipsisStr;
    }
    return text.slice(0, pos) + ellipsisStr + text.slice(end - pos, end);
  }
  // Get maximum text
  function measureText(textNode, fullText) {
    let startLoc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let endLoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fullText.length;
    let lastSuccessLoc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    const midLoc = Math.floor((startLoc + endLoc) / 2);
    const currentText = getCurrentText(fullText, midLoc);
    textNode.textContent = currentText;
    // console.log('calculating....', currentText);
    if (startLoc >= endLoc - 1 && endLoc > 0) {
      // Loop when step is small
      for (let step = endLoc; step >= startLoc; step -= 1) {
        const currentStepText = getCurrentText(fullText, step);
        textNode.textContent = currentStepText;
        if (inRange()) {
          return currentStepText;
        }
      }
    } else if (endLoc === 0) {
      return ellipsisStr;
    }
    if (inRange()) {
      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
    }
    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
  }
  let resText = content;
  // First judge whether the total length of fullText, plus suffix (possible)
  // and copied icon (possible) meets expectations？ 
  // If it does not meet expectations, add an expand button to find the largest  content that meets size limit
  // 首先判断总文本长度，加上可能有的 suffix，复制按钮长度，看结果是否符合预期
  // 如果不符合预期，则再加上展开按钮，找最大符合尺寸的内容
  if (!inRange()) {
    appendExpandNode();
    resText = measureText(textNode, content, 0, ellipsisPos === 'middle' ? Math.floor(content.length / 2) : content.length);
  }
  ellipsisContainer.innerHTML = '';
  return resText;
};
/* harmony default export */ var util = (getRenderText);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/context.js

const SizeContext = /*#__PURE__*/react.createContext('normal');
/* harmony default export */ var typography_context = (SizeContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/resizeObserver/index.js




var ObserverProperty;
(function (ObserverProperty) {
  ObserverProperty["Width"] = "width";
  ObserverProperty["Height"] = "height";
  ObserverProperty["All"] = "all";
})(ObserverProperty || (ObserverProperty = {}));
class ReactResizeObserver extends BaseComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.formerPropertyValue = new Map();
    this.getElement = () => {
      try {
        // using findDOMNode for two reasons:
        // 1. cloning to insert a ref is unwieldy and not performant.
        // 2. ensure that we resolve to an actual DOM node (instead of any JSX ref instance).
        return (0,react_dom.findDOMNode)(this.childNode || this);
      } catch (error) {
        // swallow error if findDOMNode is run on unmounted component.
        return null;
      }
    };
    this.handleResizeEventTriggered = entries => {
      var _a, _b, _c, _d;
      if (this.props.observerProperty === ObserverProperty.All) {
        (_b = (_a = this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, entries);
      } else {
        const finalEntries = [];
        for (const entry of entries) {
          if (this.formerPropertyValue.has(entry.target)) {
            if (entry.contentRect[this.props.observerProperty] !== this.formerPropertyValue.get(entry.target)) {
              this.formerPropertyValue.set(entry.target, entry.contentRect[this.props.observerProperty]);
              finalEntries.push(entry);
            }
          } else {
            this.formerPropertyValue.set(entry.target, entry.contentRect[this.props.observerProperty]);
            finalEntries.push(entry);
          }
        }
        if (finalEntries.length > 0) {
          (_d = (_c = this.props).onResize) === null || _d === void 0 ? void 0 : _d.call(_c, finalEntries);
        }
      }
    };
    this.observeElement = function () {
      let force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const element = _this.getElement();
      if (!_this.observer) {
        _this.observer = new ResizeObserver(_this.handleResizeEventTriggered);
      }
      if (!(element && element instanceof Element)) {
        // stop everything if not defined
        _this.observer.disconnect();
        return;
      }
      if (element === _this.element && !force) {
        // abort if given same element -- nothing to update (unless forced)
        return;
      } else {
        // clear observer list if new element
        _this.observer.disconnect();
        // remember element reference for next time
        _this.element = element;
      }
      // observer callback is invoked immediately when observing new elements
      _this.observer.observe(element);
      if (_this.props.observeParent && element.parentNode && element.parentNode.ownerDocument && element.parentNode.ownerDocument.defaultView && element.parentNode instanceof element.parentNode.ownerDocument.defaultView.HTMLElement) {
        _this._parentNode = element.parentNode;
        _this.observer.observe(_this._parentNode);
      }
    };
    this.mergeRef = (ref, node) => {
      this.childNode = node;
      if (typeof ref === 'function') {
        ref(node);
      } else if (typeof ref === 'object' && ref && 'current' in ref) {
        ref.current = node;
      }
    };
    if (globalThis['ResizeObserver']) {
      this.observer = new ResizeObserver(this.handleResizeEventTriggered);
    }
  }
  componentDidMount() {
    var _a;
    (_a = this.observeElement) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  componentDidUpdate(prevProps) {
    var _a;
    (_a = this.observeElement) === null || _a === void 0 ? void 0 : _a.call(this, this.props.observeParent !== prevProps.observeParent);
  }
  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
      this.element = null;
    }
  }
  render() {
    const child = react.Children.only(this.props.children);
    const {
      ref
    } = child;
    return /*#__PURE__*/react.cloneElement(child, {
      ref: node => this.mergeRef(ref, node)
    });
  }
}
ReactResizeObserver.propTypes = {
  onResize: (prop_types_default()).func,
  observeParent: (prop_types_default()).bool,
  observerProperty: (prop_types_default()).string,
  delayTick: (prop_types_default()).number
};
ReactResizeObserver.defaultProps = {
  onResize: () => {},
  observeParent: false,
  observerProperty: "all",
  delayTick: 0
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/base.js






var base_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var base_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};















const base_prefixCls = typography_constants_cssClasses.PREFIX;
const ELLIPSIS_STR = '...';
const wrapperDecorations = (props, content) => {
  const {
    mark,
    code,
    underline,
    strong,
    link,
    disabled
  } = props;
  let wrapped = content;
  const wrap = (isNeeded, tag) => {
    let wrapProps = {};
    if (!isNeeded) {
      return;
    }
    if (typeof isNeeded === 'object') {
      wrapProps = Object.assign({}, isNeeded);
    }
    wrapped = /*#__PURE__*/react.createElement(tag, wrapProps, wrapped);
  };
  wrap(mark, 'mark');
  wrap(code, 'code');
  wrap(underline && !link, 'u');
  wrap(strong, 'strong');
  wrap(props.delete, 'del');
  wrap(link, disabled ? 'span' : 'a');
  return wrapped;
};
class Base extends react.Component {
  constructor(props) {
    super(props);
    this.observerTakingEffect = false;
    this.onResize = entries => base_awaiter(this, void 0, void 0, function* () {
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
      }
      return new Promise(resolve => {
        this.rafId = window.requestAnimationFrame(() => base_awaiter(this, void 0, void 0, function* () {
          yield this.getEllipsisState();
          resolve();
        }));
      });
    });
    // if it needs to use js overflowed:
    // 1. text is expandable 2. expandText need to be shown  3. has extra operation 4. text need to ellipse from mid
    this.canUseCSSEllipsis = () => {
      const {
        copyable
      } = this.props;
      const {
        expandable,
        expandText,
        pos,
        suffix
      } = this.getEllipsisOpt();
      return !expandable && isUndefined_default()(expandText) && !copyable && pos === 'end' && !suffix.length;
    };
    /**
     * whether truncated
     *  rows < = 1 if there is overflow content, return true
     *  rows > 1 if there is overflow height, return true
     * @param {Number} rows
     * @returns {Boolean}
     */
    this.shouldTruncated = rows => {
      if (!rows || rows < 1) {
        return false;
      }
      const updateOverflow = rows <= 1 ? this.compareSingleRow() : this.wrapperRef.current.scrollHeight > this.wrapperRef.current.offsetHeight;
      return updateOverflow;
    };
    /**
     * 通过将 content 给到 Range 对象，借助 Range 的 getBoundingClientRect 拿到 content 的准确 width
     * 不受 css ellipsis 与否的影响
     * By giving the content to the Range object, get the exact width of the content with the help of Range's getBoundingClientRect
     * Not affected by css ellipsis or not
     * https://github.com/DouyinFE/semi-design/issues/1731
     */
    this.compareSingleRow = () => {
      if (!(document && document.createRange)) {
        return false;
      }
      const containerNode = this.wrapperRef.current;
      const containerWidth = containerNode.getBoundingClientRect().width;
      const childNodes = Array.from(containerNode.childNodes);
      const range = document.createRange();
      const contentWidth = childNodes.reduce((acc, node) => {
        var _a;
        range.selectNodeContents(node);
        return acc + ((_a = range.getBoundingClientRect().width) !== null && _a !== void 0 ? _a : 0);
      }, 0);
      range.detach();
      return contentWidth > containerWidth;
    };
    this.showTooltip = () => {
      var _a, _b;
      const {
        isOverflowed,
        isTruncated,
        expanded
      } = this.state;
      const {
        showTooltip,
        expandable,
        expandText
      } = this.getEllipsisOpt();
      const canUseCSSEllipsis = this.canUseCSSEllipsis();
      // If the css is truncated, use isOverflowed to judge. If the css is truncated, use isTruncated to judge.
      const overflowed = !expanded && (canUseCSSEllipsis ? isOverflowed : isTruncated);
      const noExpandText = !expandable && isUndefined_default()(expandText);
      const show = noExpandText && overflowed && showTooltip;
      if (!show) {
        return show;
      }
      const defaultOpts = {
        type: 'tooltip'
      };
      if (typeof showTooltip === 'object') {
        if (showTooltip.type && showTooltip.type.toLowerCase() === 'popover') {
          return merge_default()({
            opts: {
              // style: { width: '240px' },
              showArrow: true
            }
          }, showTooltip, {
            opts: {
              className: classnames_default()({
                [`${base_prefixCls}-ellipsis-popover`]: true,
                [(_a = showTooltip === null || showTooltip === void 0 ? void 0 : showTooltip.opts) === null || _a === void 0 ? void 0 : _a.className]: Boolean((_b = showTooltip === null || showTooltip === void 0 ? void 0 : showTooltip.opts) === null || _b === void 0 ? void 0 : _b.className)
              })
            }
          });
        }
        return Object.assign(Object.assign({}, defaultOpts), showTooltip);
      }
      return defaultOpts;
    };
    this.onHover = () => {
      const canUseCSSEllipsis = this.canUseCSSEllipsis();
      if (canUseCSSEllipsis) {
        const {
          rows,
          suffix,
          pos
        } = this.getEllipsisOpt();
        const updateOverflow = this.shouldTruncated(rows);
        // isOverflowed needs to be updated to show tooltip when using css ellipsis
        this.setState({
          isOverflowed: updateOverflow,
          isTruncated: false
        });
        return undefined;
      }
    };
    this.getEllipsisState = () => base_awaiter(this, void 0, void 0, function* () {
      const {
        rows,
        suffix,
        pos
      } = this.getEllipsisOpt();
      const {
        children
      } = this.props;
      // wait until element mounted
      if (!this.wrapperRef || !this.wrapperRef.current) {
        yield this.onResize();
        return;
      }
      const {
        expanded
      } = this.state;
      const canUseCSSEllipsis = this.canUseCSSEllipsis();
      if (canUseCSSEllipsis) {
        // const updateOverflow = this.shouldTruncated(rows);
        // // isOverflowed needs to be updated to show tooltip when using css ellipsis
        // this.setState({
        //     isOverflowed: updateOverflow,
        //     isTruncated: false
        // });
        return;
      }
      // If children is null, css/js truncated flag isTruncate is false
      if (isNull_default()(children)) {
        return new Promise(resolve => {
          this.setState({
            isTruncated: false,
            isOverflowed: false
          }, resolve);
        });
      }
      // Currently only text truncation is supported, if there is non-text, 
      // both css truncation and js truncation should throw a warning
      warning('children' in this.props && typeof children !== 'string', "[Semi Typography] Only children with pure text could be used with ellipsis at this moment.");
      if (!rows || rows < 0 || expanded) {
        return;
      }
      const extraNode = {
        expand: this.expandRef.current,
        copy: this.copyRef && this.copyRef.current
      };
      // Perform type conversion on children to prevent component crash due to non-string type of children
      // https://github.com/DouyinFE/semi-design/issues/2167
      const realChildren = Array.isArray(children) ? children.join('') : String(children);
      const content = util(this.wrapperRef.current, rows, realChildren, extraNode, ELLIPSIS_STR, suffix, pos);
      return new Promise(resolve => {
        this.setState({
          isOverflowed: false,
          ellipsisContent: content,
          isTruncated: realChildren !== content
        }, resolve);
      });
    });
    /**
     * Triggered when the fold button is clicked to save the latest expanded state
     * @param {Event} e
     */
    this.toggleOverflow = e => {
      const {
        onExpand,
        expandable,
        collapsible
      } = this.getEllipsisOpt();
      const {
        expanded
      } = this.state;
      onExpand && onExpand(!expanded, e);
      if (expandable && !expanded || collapsible && expanded) {
        this.setState({
          expanded: !expanded
        });
      }
    };
    this.getEllipsisOpt = () => {
      const {
        ellipsis
      } = this.props;
      if (!ellipsis) {
        return {};
      }
      const opt = Object.assign({
        rows: 1,
        expandable: false,
        pos: 'end',
        suffix: '',
        showTooltip: false,
        collapsible: false,
        expandText: ellipsis.expandable ? this.expandStr : undefined,
        collapseText: ellipsis.collapsible ? this.collapseStr : undefined
      }, typeof ellipsis === 'object' ? ellipsis : null);
      return opt;
    };
    this.renderExpandable = () => {
      const {
        expanded,
        isTruncated
      } = this.state;
      if (!isTruncated) return null;
      const {
        expandText,
        expandable,
        collapseText,
        collapsible
      } = this.getEllipsisOpt();
      const noExpandText = !expandable && isUndefined_default()(expandText);
      const noCollapseText = !collapsible && isUndefined_default()(collapseText);
      let text;
      if (!expanded && !noExpandText) {
        text = expandText;
      } else if (expanded && !noCollapseText) {
        text = collapseText;
      }
      if (!noExpandText || !noCollapseText) {
        return (
          /*#__PURE__*/
          // TODO: replace `a` tag with `span` in next major version
          // NOTE: may have effect on style
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          react.createElement("a", {
            role: "button",
            tabIndex: 0,
            className: `${base_prefixCls}-ellipsis-expand`,
            key: "expand",
            ref: this.expandRef,
            "aria-label": text,
            onClick: this.toggleOverflow,
            onKeyPress: e => utils_isEnterPress(e) && this.toggleOverflow(e)
          }, text)
        );
      }
      return null;
    };
    /**
     * 获取文本的缩略class和style
     *
     * 截断类型：
     *  - 当设置中间截断（pos='middle')、可展开（expandable)、有后缀（suffix 非空）、可复制（copyable），启用 JS 截断策略
     *  - 非以上场景，启用 CSS 截断策略
     * 相关变量
     *  props:
     *      - ellipsis:
     *          - rows
     *          - expandable
     *          - pos
     *          - suffix
     *  state:
     *      - isOverflowed，文本是否处于overflow状态
     *      - expanded，文本是否处于折叠状态
     *      - isTruncated，文本是否被js截断
     *
     * Get the abbreviated class and style of the text
     *
     * Truncation type:
     *  -When setting middle ellipsis (pos='middle')、expandable、suffix is not empty、copyable, the JS ellipsis strategy is enabled
     *  -Otherwise, enable the CSS ellipsis strategy
     * related variables
     *  props:
     *      -ellipsis:
     *          -rows
     *          -expandable
     *          -pos
     *          -suffix
     *  state:
     *      -isOverflowed, whether the text is in an overflow state
     *      -expanded, whether the text is in a collapsed state
     *      -isTruncated, whether the text is truncated by js
     * @returns {Object}
     */
    this.getEllipsisStyle = () => {
      const {
        ellipsis,
        component
      } = this.props;
      if (!ellipsis) {
        return {
          ellipsisCls: '',
          ellipsisStyle: {}
          // ellipsisAttr: {}
        };
      }

      const {
        rows
      } = this.getEllipsisOpt();
      const {
        expanded
      } = this.state;
      const useCSS = !expanded && this.canUseCSSEllipsis();
      const ellipsisCls = classnames_default()({
        [`${base_prefixCls}-ellipsis`]: true,
        [`${base_prefixCls}-ellipsis-single-line`]: rows === 1,
        [`${base_prefixCls}-ellipsis-multiple-line`]: rows > 1,
        // component === 'span', Text component, It should be externally displayed inline
        [`${base_prefixCls}-ellipsis-multiple-line-text`]: rows > 1 && component === 'span',
        [`${base_prefixCls}-ellipsis-overflow-ellipsis`]: rows === 1 && useCSS,
        // component === 'span', Text component, It should be externally displayed inline
        [`${base_prefixCls}-ellipsis-overflow-ellipsis-text`]: rows === 1 && useCSS && component === 'span'
      });
      const ellipsisStyle = useCSS && rows > 1 ? {
        WebkitLineClamp: rows
      } : {};
      return {
        ellipsisCls,
        ellipsisStyle
      };
    };
    this.renderEllipsisText = opt => {
      const {
        suffix
      } = opt;
      const {
        children
      } = this.props;
      const {
        isTruncated,
        expanded,
        ellipsisContent
      } = this.state;
      if (expanded || !isTruncated) {
        return /*#__PURE__*/react.createElement("span", {
          onMouseEnter: this.onHover
        }, children, suffix && suffix.length ? suffix : null);
      }
      return /*#__PURE__*/react.createElement("span", {
        onMouseEnter: this.onHover
      }, ellipsisContent, suffix);
    };
    this.state = {
      editable: false,
      copied: false,
      // ellipsis
      // if text is overflow in container
      isOverflowed: false,
      ellipsisContent: props.children,
      expanded: false,
      // if text is truncated with js
      isTruncated: false,
      prevChildren: null
    };
    this.wrapperRef = /*#__PURE__*/react.createRef();
    this.expandRef = /*#__PURE__*/react.createRef();
    this.copyRef = /*#__PURE__*/react.createRef();
  }
  componentDidMount() {
    if (this.props.ellipsis) {
      // runAfterTicks: make sure start observer on the next tick
      this.onResize().then(() => runAfterTicks(() => this.observerTakingEffect = true, 1));
    }
  }
  static getDerivedStateFromProps(props, prevState) {
    const {
      prevChildren
    } = prevState;
    const newState = {};
    newState.prevChildren = props.children;
    if (props.ellipsis && prevChildren !== props.children) {
      // reset ellipsis state if children update
      newState.isOverflowed = false;
      newState.ellipsisContent = props.children;
      newState.expanded = false;
      newState.isTruncated = true;
    }
    return newState;
  }
  componentDidUpdate(prevProps) {
    // Render was based on outdated refs and needs to be rerun
    if (this.props.children !== prevProps.children) {
      this.forceUpdate();
      if (this.props.ellipsis) {
        this.onResize();
      }
    }
  }
  componentWillUnmount() {
    if (this.rafId) {
      window.cancelAnimationFrame(this.rafId);
    }
  }
  renderOperations() {
    return /*#__PURE__*/react.createElement(react.Fragment, null, this.renderExpandable(), this.renderCopy());
  }
  renderCopy() {
    var _a;
    const {
      copyable,
      children
    } = this.props;
    if (!copyable) {
      return null;
    }
    // If it is configured in the content of copyable, the copied content will be the content in copyable
    const willCopyContent = (_a = copyable === null || copyable === void 0 ? void 0 : copyable.content) !== null && _a !== void 0 ? _a : children;
    let copyContent;
    let hasObject = false;
    if (Array.isArray(willCopyContent)) {
      copyContent = '';
      willCopyContent.forEach(value => {
        if (typeof value === 'object') {
          hasObject = true;
        }
        copyContent += String(value);
      });
    } else if (typeof willCopyContent !== 'object') {
      copyContent = String(willCopyContent);
    } else {
      hasObject = true;
      copyContent = String(willCopyContent);
    }
    warning(hasObject, 'Content to be copied in Typography is a object, it will case a [object Object] mistake when copy to clipboard.');
    const copyConfig = Object.assign({
      content: copyContent,
      duration: 3
    }, typeof copyable === 'object' ? copyable : null);
    return /*#__PURE__*/react.createElement(typography_copyable, Object.assign({}, copyConfig, {
      forwardRef: this.copyRef
    }));
  }
  renderIcon() {
    const {
      icon,
      size
    } = this.props;
    const realSize = size === 'inherit' ? this.context : size;
    if (!icon) {
      return null;
    }
    const iconSize = realSize === 'small' ? 'small' : 'default';
    return /*#__PURE__*/react.createElement("span", {
      className: `${base_prefixCls}-icon`,
      "x-semi-prop": "icon"
    }, isSemiIcon(icon) ? /*#__PURE__*/react.cloneElement(icon, {
      size: iconSize
    }) : icon);
  }
  renderContent() {
    const _a = this.props,
      {
        component,
        children,
        className,
        type,
        spacing,
        disabled,
        style,
        ellipsis,
        icon,
        size,
        link,
        heading,
        weight
      } = _a,
      rest = base_rest(_a, ["component", "children", "className", "type", "spacing", "disabled", "style", "ellipsis", "icon", "size", "link", "heading", "weight"]);
    const textProps = omit_default()(rest, ['strong', 'editable', 'mark', 'copyable', 'underline', 'code',
    // 'link',
    'delete']);
    const realSize = size === 'inherit' ? this.context : size;
    const iconNode = this.renderIcon();
    const ellipsisOpt = this.getEllipsisOpt();
    const {
      ellipsisCls,
      ellipsisStyle
    } = this.getEllipsisStyle();
    let textNode = ellipsis ? this.renderEllipsisText(ellipsisOpt) : children;
    const linkCls = classnames_default()({
      [`${base_prefixCls}-link-text`]: link,
      [`${base_prefixCls}-link-underline`]: this.props.underline && link
    });
    textNode = wrapperDecorations(this.props, /*#__PURE__*/react.createElement(react.Fragment, null, iconNode, this.props.link ? /*#__PURE__*/react.createElement("span", {
      className: linkCls
    }, textNode) : textNode));
    const hTagReg = /^h[1-6]$/;
    const isHeader = isString_default()(heading) && hTagReg.test(heading);
    const wrapperCls = classnames_default()(className, ellipsisCls, {
      // [`${prefixCls}-primary`]: !type || type === 'primary',
      [`${base_prefixCls}-${type}`]: type && !link,
      [`${base_prefixCls}-${realSize}`]: realSize,
      [`${base_prefixCls}-link`]: link,
      [`${base_prefixCls}-disabled`]: disabled,
      [`${base_prefixCls}-${spacing}`]: spacing,
      [`${base_prefixCls}-${heading}`]: isHeader,
      [`${base_prefixCls}-${heading}-weight-${weight}`]: isHeader && weight && isNaN(Number(weight))
    });
    const textStyle = Object.assign(Object.assign({}, isNaN(Number(weight)) ? {} : {
      fontWeight: weight
    }), style);
    return /*#__PURE__*/react.createElement(typography, Object.assign({
      className: wrapperCls,
      style: Object.assign(Object.assign({}, textStyle), ellipsisStyle),
      component: component,
      forwardRef: this.wrapperRef
    }, textProps), textNode, this.renderOperations());
  }
  renderTipWrapper() {
    const {
      children
    } = this.props;
    const showTooltip = this.showTooltip();
    const content = this.renderContent();
    if (showTooltip) {
      const {
        type,
        opts,
        renderTooltip
      } = showTooltip;
      if (isFunction_default()(renderTooltip)) {
        return renderTooltip(children, content);
      } else if (type.toLowerCase() === 'popover') {
        return /*#__PURE__*/react.createElement(popover, Object.assign({
          content: children,
          position: "top"
        }, opts), content);
      }
      return /*#__PURE__*/react.createElement(Tooltip, Object.assign({
        content: children,
        position: "top"
      }, opts), content);
    } else {
      return content;
    }
  }
  render() {
    var _this = this;
    const {
      size
    } = this.props;
    const realSize = size === 'inherit' ? this.context : size;
    const content = /*#__PURE__*/react.createElement(typography_context.Provider, {
      value: realSize
    }, /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Typography"
    }, locale => {
      this.expandStr = locale.expand;
      this.collapseStr = locale.collapse;
      return this.renderTipWrapper();
    }));
    if (this.props.ellipsis) {
      return /*#__PURE__*/react.createElement(ReactResizeObserver, {
        onResize: function () {
          if (_this.observerTakingEffect) {
            _this.onResize(...arguments);
          }
        },
        observeParent: true,
        observerProperty: ObserverProperty.Width
      }, content);
    }
    return content;
  }
}
Base.propTypes = {
  children: (prop_types_default()).node,
  copyable: prop_types_default().oneOfType([prop_types_default().shape({
    text: (prop_types_default()).string,
    onCopy: (prop_types_default()).func,
    successTip: (prop_types_default()).node,
    copyTip: (prop_types_default()).node
  }), (prop_types_default()).bool]),
  delete: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  // editable: PropTypes.bool,
  ellipsis: prop_types_default().oneOfType([prop_types_default().shape({
    rows: (prop_types_default()).number,
    expandable: (prop_types_default()).bool,
    expandText: (prop_types_default()).string,
    onExpand: (prop_types_default()).func,
    suffix: (prop_types_default()).string,
    showTooltip: prop_types_default().oneOfType([prop_types_default().shape({
      type: (prop_types_default()).string,
      opts: (prop_types_default()).object
    }), (prop_types_default()).bool]),
    collapsible: (prop_types_default()).bool,
    collapseText: (prop_types_default()).string,
    pos: prop_types_default().oneOf(['end', 'middle'])
  }), (prop_types_default()).bool]),
  mark: (prop_types_default()).bool,
  underline: (prop_types_default()).bool,
  link: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  spacing: prop_types_default().oneOf(typography_constants_strings.SPACING),
  strong: (prop_types_default()).bool,
  size: prop_types_default().oneOf(typography_constants_strings.SIZE),
  type: prop_types_default().oneOf(typography_constants_strings.TYPE),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  icon: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).string]),
  heading: (prop_types_default()).string,
  component: (prop_types_default()).string
};
Base.defaultProps = {
  children: null,
  copyable: false,
  delete: false,
  disabled: false,
  // editable: false,
  ellipsis: false,
  icon: '',
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  spacing: 'normal',
  size: 'normal',
  style: {},
  className: ''
};
Base.contextType = typography_context;
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/text.js




class Text extends react.PureComponent {
  render() {
    return /*#__PURE__*/react.createElement(Base, Object.assign({
      component: 'span'
    }, this.props));
  }
}
Text.propTypes = {
  copyable: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  delete: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  icon: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).string]),
  ellipsis: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  mark: (prop_types_default()).bool,
  underline: (prop_types_default()).bool,
  link: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  strong: (prop_types_default()).bool,
  type: prop_types_default().oneOf(typography_constants_strings.TYPE),
  size: prop_types_default().oneOf(typography_constants_strings.SIZE),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  code: (prop_types_default()).bool,
  component: (prop_types_default()).string,
  weight: (prop_types_default()).number
};
Text.defaultProps = {
  copyable: false,
  delete: false,
  disabled: false,
  icon: '',
  // editable: false,
  ellipsis: false,
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  style: {},
  size: 'normal',
  className: ''
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/title.js
var title_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




class Title extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        heading
      } = _a,
      rest = title_rest(_a, ["heading"]);
    const component = typography_constants_strings.HEADING.indexOf(heading) !== -1 ? `h${heading}` : 'h1';
    // Passing headings to support custom components
    return /*#__PURE__*/react.createElement(Base, Object.assign({
      component: component,
      heading: component
    }, rest));
  }
}
Title.propTypes = {
  copyable: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  delete: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  // editable: PropTypes.bool,
  ellipsis: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  mark: (prop_types_default()).bool,
  link: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  underline: (prop_types_default()).bool,
  strong: (prop_types_default()).bool,
  type: prop_types_default().oneOf(typography_constants_strings.TYPE),
  heading: prop_types_default().oneOf(typography_constants_strings.HEADING),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  component: (prop_types_default()).string,
  weight: prop_types_default().oneOfType([prop_types_default().oneOf(typography_constants_strings.WEIGHT), (prop_types_default()).number])
};
Title.defaultProps = {
  copyable: false,
  delete: false,
  disabled: false,
  // editable: false,
  ellipsis: false,
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  heading: 1,
  style: {},
  className: ''
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/paragraph.js





const paragraph_prefixCls = typography_constants_cssClasses.PREFIX;
class Paragraph extends react.PureComponent {
  render() {
    const {
      className
    } = this.props;
    const paragraphCls = classnames_default()(className, `${paragraph_prefixCls}-paragraph`);
    return /*#__PURE__*/react.createElement(Base, Object.assign({
      component: 'p'
    }, this.props, {
      className: paragraphCls
    }));
  }
}
Paragraph.propTypes = {
  copyable: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  delete: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  // editable: PropTypes.bool,
  ellipsis: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  mark: (prop_types_default()).bool,
  link: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  underline: (prop_types_default()).bool,
  strong: (prop_types_default()).bool,
  type: prop_types_default().oneOf(typography_constants_strings.TYPE),
  size: prop_types_default().oneOf(typography_constants_strings.SIZE),
  spacing: prop_types_default().oneOf(typography_constants_strings.SPACING),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  component: (prop_types_default()).string
};
Paragraph.defaultProps = {
  copyable: false,
  delete: false,
  disabled: false,
  // editable: false,
  ellipsis: false,
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  size: 'normal',
  spacing: 'normal',
  style: {},
  className: ''
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/typography/formatNumeral.js
class FormatNumeral {
  constructor(content, rule, precision, truncate, parser) {
    // A collection of methods for formatting numbers;  Methods key: Rule (strings.RULE);  Not included: 'text' & 'numbers'
    this.ruleMethods = {
      'bytes-decimal': value => {
        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let i = 0;
        while (value >= 1000) {
          value /= 1000;
          i++;
        }
        return `${this.truncatePrecision(value)} ${units[i]}`;
      },
      'bytes-binary': value => {
        const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let i = 0;
        while (value >= 1024) {
          value /= 1024;
          i++;
        }
        return `${this.truncatePrecision(value)} ${units[i]}`;
      },
      percentages: value => {
        // The rules here have been modified in version v2.30.0
        return `${this.truncatePrecision(value * 100)}%`;
      },
      exponential: value => {
        const vExponential = value.toExponential(this.precision + 2);
        const vArr = vExponential.split('e');
        return `${this.truncatePrecision(Number(vArr[0]))}e${vArr[1]}`;
      }
    };
    // A collection of methods for truncating numbers; Methods key: Truncate (strings.Truncate);
    this.truncateMethods = {
      ceil: Math.ceil,
      floor: Math.floor,
      round: Math.round
    };
    this.isDiyParser = typeof parser !== 'undefined';
    this.content = content;
    this.rule = rule;
    this.precision = precision;
    this.truncate = truncate;
    this.parser = parser;
  }
  // Formatting numbers within a string.
  format() {
    // Executed when a custom method exists
    if (this.isDiyParser) {
      return this.parser(this.content);
    }
    //  When the `rule` is `text`, only the `truncatePrecision` method is executed for numeric processing.
    if (this.rule === 'text') {
      return extractNumbers(this.content).map(item => checkIsNumeral(item) ? this.truncatePrecision(item) : item).join('');
    }
    // Separate extraction of numbers when `rule` is `numbers`.
    if (this.rule === 'numbers') {
      return extractNumbers(this.content).filter(item => checkIsNumeral(item)).map(item => this.truncatePrecision(item)).join(',');
    }
    // Run formatting methods that exist.
    return extractNumbers(this.content).map(item => checkIsNumeral(item) ? this.ruleMethods[this.rule](Number(item)) : item).join('');
  }
  truncatePrecision(content) {
    // Truncation and selection of rounding methods for processing. function from: truncateMethods
    const cTruncated = this.truncateMethods[this.truncate](Number(content) * Math.pow(10, this.precision)) / Math.pow(10, this.precision);
    const cArr = cTruncated.toString().split('.');
    // is an integer then the end number is normalised
    if (cArr.length === 1) {
      return cTruncated.toFixed(this.precision);
    }
    const cTLength = cArr[1].length;
    // Fill in any missing `0` at the end.
    if (cTLength < this.precision) {
      return `${cArr[0]}.${cArr[1]}${'0'.repeat(this.precision - cTLength)}`;
    }
    return cTruncated.toString();
  }
}
// Separate numbers from strings, the `-` symbol is a numeric prefix not allowed on its own.
function extractNumbers(content) {
  const reg = /(-?[0-9]*\.?[0-9]+([eE]-?[0-9]+)?)|([^-\d\.]+)/g;
  return content.match(reg) || [];
}
function checkIsNumeral(str) {
  return !(isNaN(Number(str)) || str.replace(/\s+/g, '') === '');
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/numeral.js





class Numeral extends react.PureComponent {
  // Traverse the entire virtual DOM using a depth-first traversal algorithm, then format each piece. (in react)
  formatNodeDFS(node) {
    if (!Array.isArray(node)) {
      node = [node];
    }
    // Because the property is read-only, an object is returned for overwriting rather than directly modifying the object's contents.
    node = node.map(item => {
      if (typeof item === 'string' || typeof item === 'number') {
        // Formatting the digital content of nodes.
        return new FormatNumeral(String(item), this.props.rule, this.props.precision, this.props.truncate, this.props.parser).format();
      }
      if (typeof item === 'function') {
        return this.formatNodeDFS(item());
      }
      if (typeof item === 'object' && 'children' in item['props']) {
        return Object.assign(Object.assign({}, item), {
          props: Object.assign(Object.assign({}, item['props']), {
            children: this.formatNodeDFS(item['props']['children'])
          })
        });
      }
      return item;
    });
    return node.length === 1 ? node[0] : node;
  }
  render() {
    // Deep copy and remove props that are not needed by the Base component.
    const baseProps = Object.assign({}, this.props);
    delete baseProps.rule;
    delete baseProps.parser;
    // Each piece of content in the virtual DOM is formatted by the `formatNumeral` function.
    baseProps.children = this.formatNodeDFS(this.props.children);
    return /*#__PURE__*/react.createElement(Base, Object.assign({
      component: 'span'
    }, baseProps));
  }
}
Numeral.propTypes = {
  rule: prop_types_default().oneOf(typography_constants_strings.RULE),
  precision: (prop_types_default()).number,
  truncate: prop_types_default().oneOf(typography_constants_strings.TRUNCATE),
  parser: (prop_types_default()).func,
  copyable: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  delete: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  icon: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).string]),
  mark: (prop_types_default()).bool,
  underline: (prop_types_default()).bool,
  link: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).bool]),
  strong: (prop_types_default()).bool,
  type: prop_types_default().oneOf(typography_constants_strings.TYPE),
  size: prop_types_default().oneOf(typography_constants_strings.SIZE),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  code: (prop_types_default()).bool,
  component: (prop_types_default()).string
};
Numeral.defaultProps = {
  rule: 'text',
  precision: 0,
  truncate: 'round',
  parser: undefined,
  copyable: false,
  delete: false,
  icon: '',
  mark: false,
  underline: false,
  strong: false,
  link: false,
  type: 'primary',
  style: {},
  size: 'normal',
  className: ''
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/typography/index.js





const typography_Typography = typography;
typography_Typography.Text = Text;
typography_Typography.Title = Title;
typography_Typography.Paragraph = Paragraph;
typography_Typography.Numeral = Numeral;

/* harmony default export */ var es_typography = (typography_Typography);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/breadcrumb/item.js












const clsPrefix = cssClasses.PREFIX;
class BreadcrumbItem extends BaseComponent {
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      notifyClick: function () {
        _this.props.onClick(...arguments);
      },
      notifyParent: function () {
        _this.context.onClick(...arguments);
      }
    });
  }
  constructor(props) {
    super(props);
    this.renderIcon = () => {
      const iconType = this.props.icon;
      const {
        compact
      } = this.context;
      const iconSize = compact ? 'small' : 'default';
      const className = `${clsPrefix}-item-icon`;
      if ( /*#__PURE__*/react.isValidElement(iconType)) {
        //@ts-ignore
        return /*#__PURE__*/react.cloneElement(iconType, {
          className,
          size: iconSize
        });
      }
      return iconType;
    };
    this.getTooltipOpt = () => {
      const {
        showTooltip
      } = this.context;
      if (!showTooltip) {
        return {
          width: 150,
          ellipsisPos: 'end'
        };
      }
      const defaultOpts = {
        width: 150,
        ellipsisPos: 'end',
        opts: {
          autoAdjustOverflow: true,
          position: 'top'
        }
      };
      if (typeof showTooltip === 'object') {
        return merge_default()(defaultOpts, showTooltip);
      }
      return defaultOpts;
    };
    this.getItemInfo = () => {
      let itemInfo = {};
      const {
        route,
        children,
        href
      } = this.props;
      const hasHref = !isUndefined_default()(href) && !isNull_default()(href);
      if (route) {
        itemInfo = route;
      } else {
        itemInfo.name = children;
        if (hasHref) {
          itemInfo.href = href;
        }
      }
      return itemInfo;
    };
    this.renderBreadItem = () => {
      const {
        children
      } = this.props;
      const {
        compact
      } = this.context;
      const showTooltip = this.getTooltipOpt();
      const icon = this.renderIcon();
      if (Boolean(children) && typeof children === 'string') {
        const {
          opts,
          ellipsisPos,
          width
        } = showTooltip;
        return /*#__PURE__*/react.createElement(react.Fragment, null, icon, /*#__PURE__*/react.createElement("span", {
          className: `${clsPrefix}-item-title`
        }, /*#__PURE__*/react.createElement(es_typography.Text, {
          ellipsis: {
            showTooltip: opts ? {
              opts
            } : false,
            pos: ellipsisPos
          },
          // icon={this.renderIcon(icon)}
          style: {
            maxWidth: width
          },
          size: compact ? 'small' : 'normal'
        }, children)));
      }
      return /*#__PURE__*/react.createElement(react.Fragment, null, icon, children ? /*#__PURE__*/react.createElement("span", {
        className: `${clsPrefix}-item-title ${clsPrefix}-item-title-inline`
      }, children) : null);
    };
    this.renderItem = () => {
      const {
        href,
        active,
        noLink
      } = this.props;
      const hasHref = href !== null && typeof href !== 'undefined';
      const itemCls = classnames_default()({
        [`${clsPrefix}-item`]: true,
        [`${clsPrefix}-item-active`]: active,
        [`${clsPrefix}-item-link`]: !noLink
      });
      const itemInner = this.renderBreadItem();
      const tag = active || !hasHref ? 'span' : 'a';
      const itemInfo = this.getItemInfo();
      return /*#__PURE__*/react.createElement(tag, {
        className: itemCls,
        onClick: e => this.foundation.handleClick(itemInfo, e),
        href
      }, itemInner);
    };
    this.foundation = new BreadcrumbItemFoundation(this.adapter);
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const {
      active,
      shouldRenderSeparator
      // children,
    } = this.props;
    const pageLabel = active ? {
      'aria-current': 'page'
    } : {};
    const item = this.renderItem();
    const separator = this.props.separator || /*#__PURE__*/react.createElement("span", {
      className: `${clsPrefix}-separator`
    }, this.context.separator);
    const wrapperCLs = classnames_default()({
      [`${clsPrefix}-item-wrap`]: true
      // [`${clsPrefix}-item-wrap-iconOnly`]: !!children && this.props.icon,
    });

    return /*#__PURE__*/react.createElement("span", Object.assign({
      className: wrapperCLs
    }, pageLabel, this.getDataAttr(this.props)), item, shouldRenderSeparator && separator);
  }
}
BreadcrumbItem.isBreadcrumbItem = true;
BreadcrumbItem.contextType = bread_context;
BreadcrumbItem.propTypes = {
  onClick: (prop_types_default()).func,
  route: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).string]),
  name: (prop_types_default()).string,
  children: (prop_types_default()).node,
  active: (prop_types_default()).bool,
  shouldRenderSeparator: (prop_types_default()).bool,
  icon: (prop_types_default()).node,
  separator: (prop_types_default()).node,
  noLink: (prop_types_default()).bool
};
BreadcrumbItem.defaultProps = {
  onClick: function_noop,
  shouldRenderSeparator: true
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconMore.js


function IconMore_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M7 12C7 13.3807 5.88071 14.5 4.5 14.5C3.11929 14.5 2 13.3807 2 12C2 10.6193 3.11929 9.5 4.5 9.5C5.88071 9.5 7 10.6193 7 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.5 14.5C20.8807 14.5 22 13.3807 22 12C22 10.6193 20.8807 9.5 19.5 9.5C18.1193 9.5 17 10.6193 17 12C17 13.3807 18.1193 14.5 19.5 14.5Z",
    fill: "currentColor"
  }));
}
const IconMore_IconComponent = (0,Icon/* convertIcon */.A)(IconMore_SvgComponent, 'more');
/* harmony default export */ var IconMore = (IconMore_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/breadcrumb/index.js







// import '@douyinfe/semi-foundation/lib/es/breadcrumb/breadcrumb.css';






const breadcrumb_clsPrefix = cssClasses.PREFIX;
class Breadcrumb extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleCollapse = (template, itemsLen) => {
      const {
        maxItemCount,
        renderMore,
        moreType
      } = this.props;
      const hasRenderMore = isFunction_default()(renderMore);
      const restItem = template.slice(1, itemsLen - maxItemCount + 1);
      const spread = /*#__PURE__*/react.createElement("span", {
        className: `${breadcrumb_clsPrefix}-collapse`,
        key: `more-${itemsLen}`
      }, /*#__PURE__*/react.createElement("span", {
        className: `${breadcrumb_clsPrefix}-item-wrap`
      }, /*#__PURE__*/react.createElement("span", {
        role: "button",
        tabIndex: 0,
        "aria-label": "Expand breadcrumb items",
        className: `${breadcrumb_clsPrefix}-item ${breadcrumb_clsPrefix}-item-more`,
        onClick: item => this.foundation.handleExpand(item),
        onKeyPress: e => this.foundation.handleExpandEnterPress(e)
      }, hasRenderMore && renderMore(restItem), !hasRenderMore && moreType === 'default' && /*#__PURE__*/react.createElement(IconMore, null), !hasRenderMore && moreType === 'popover' && this.renderPopoverMore(restItem)), /*#__PURE__*/react.createElement("span", {
        className: `${breadcrumb_clsPrefix}-separator`,
        "x-semi-prop": "separator"
      }, this.props.separator)));
      template.splice(1, itemsLen - maxItemCount, spread);
      return template;
    };
    this.renderRouteItems = (items, shouldCollapse, moreTypeIsPopover) => {
      const {
        renderItem,
        renderMore,
        maxItemCount
      } = this.props;
      const restItemLength = items.length - maxItemCount;
      const hasRenderMore = isFunction_default()(renderMore);
      const template = items.map((route, idx) => {
        const key = route._origin.key || `item-${route.name || route.path}-${idx}`;
        const inCollapseArea = idx > 0 && idx <= restItemLength;
        return /*#__PURE__*/react.createElement(BreadcrumbItem, Object.assign({}, route, {
          key: key,
          active: this.props.activeIndex !== undefined ? this.props.activeIndex === idx : idx === items.length - 1,
          route: route._origin,
          shouldRenderSeparator: idx !== items.length - 1 && !(shouldCollapse && (hasRenderMore || moreTypeIsPopover) && inCollapseArea)
        }), renderItem ? renderItem(route._origin) : route.name);
      });
      return template;
    };
    this.renderList = () => {
      const {
        routes,
        children,
        autoCollapse,
        maxItemCount,
        renderMore,
        moreType
      } = this.props;
      const {
        isCollapsed
      } = this.state;
      const hasRoutes = routes && routes.length > 0;
      const items = hasRoutes ? this.foundation.genRoutes(routes) : react.Children.toArray(children);
      let template;
      const itemLength = items.length; // children length
      const restItemLength = itemLength - maxItemCount; // Omitted children items
      const shouldCollapse = items && autoCollapse && itemLength > maxItemCount && isCollapsed; // Whether the number of children exceeds, need to collapse
      const hasRenderMore = isFunction_default()(renderMore); // Whether the user passes in the renderMore method
      const moreTypeIsPopover = moreType === 'popover';
      if (hasRoutes) {
        template = this.renderRouteItems(items, shouldCollapse, moreTypeIsPopover);
      } else {
        template = items.map((item, idx) => {
          const inCollapseArea = idx > 0 && idx <= restItemLength;
          if (!item) {
            return item;
          }
          warning(item.type && !item.type.isBreadcrumbItem, '[Semi Breadcrumb]: Only accepts Breadcrumb.Item as its children');
          return /*#__PURE__*/react.cloneElement(item, {
            key: `${idx}-item`,
            active: this.props.activeIndex !== undefined ? this.props.activeIndex === idx : idx === items.length - 1,
            shouldRenderSeparator: idx !== items.length - 1 && !(shouldCollapse && (hasRenderMore || moreTypeIsPopover) && inCollapseArea)
          });
        });
      }
      if (shouldCollapse) {
        return this.handleCollapse(template, items.length);
      }
      return template;
    };
    this.onClick = (info, event) => {
      this.foundation.handleClick(info, event);
    };
    this.foundation = new BreadcrumbFoundation(this.adapter);
    this.state = {
      isCollapsed: true
    };
    this.onClick = this.onClick.bind(this);
  }
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      notifyClick: function () {
        _this.props.onClick(...arguments);
      },
      expandCollapsed: () => this.setState({
        isCollapsed: false
      })
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  renderPopoverMore(restItem) {
    const {
      separator
    } = this.props;
    const content = /*#__PURE__*/react.createElement(react.Fragment, null, restItem.map((item, idx) => /*#__PURE__*/react.createElement(react.Fragment, {
      key: `restItem-${idx}`
    }, item, idx !== restItem.length - 1 && /*#__PURE__*/react.createElement("span", {
      className: `${breadcrumb_clsPrefix}-restItem`
    }, separator))));
    return /*#__PURE__*/react.createElement(popover, {
      content: content,
      style: {
        padding: 12
      },
      showArrow: true
    }, /*#__PURE__*/react.createElement(IconMore, null));
  }
  render() {
    const breadcrumbs = this.renderList();
    const {
      compact,
      className,
      style,
      separator,
      showTooltip
    } = this.props;
    const sizeCls = classnames_default()(className, {
      [`${breadcrumb_clsPrefix}-wrapper`]: true,
      [`${breadcrumb_clsPrefix}-wrapper-compact`]: compact,
      [`${breadcrumb_clsPrefix}-wrapper-loose`]: !compact
    });
    return /*#__PURE__*/react.createElement(bread_context.Provider, {
      value: {
        onClick: this.onClick,
        showTooltip,
        compact,
        separator
      }
    }, /*#__PURE__*/react.createElement("nav", Object.assign({
      "aria-label": this.props['aria-label'],
      className: sizeCls,
      style: style
    }, this.getDataAttr(this.props)), breadcrumbs));
  }
}
Breadcrumb.contextType = bread_context;
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.propTypes = {
  activeIndex: (prop_types_default()).number,
  routes: (prop_types_default()).array,
  onClick: (prop_types_default()).func,
  separator: (prop_types_default()).node,
  compact: (prop_types_default()).bool,
  children: (prop_types_default()).node,
  style: (prop_types_default()).object,
  renderItem: (prop_types_default()).func,
  showTooltip: prop_types_default().oneOfType([prop_types_default().shape({
    width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    ellipsisPos: prop_types_default().oneOf(['end', 'middle']),
    opts: (prop_types_default()).object
  }), (prop_types_default()).bool]),
  className: (prop_types_default()).string,
  autoCollapse: (prop_types_default()).bool,
  maxItemCount: (prop_types_default()).number,
  /* Customize the contents of the ellipsis area */
  renderMore: (prop_types_default()).func,
  /* Type of ellipsis area */
  moreType: prop_types_default().oneOf(constants_strings.MORE_TYPE),
  'aria-label': (prop_types_default()).string
};
Breadcrumb.defaultProps = {
  routes: [],
  onClick: function_noop,
  renderItem: undefined,
  separator: '/',
  compact: true,
  showTooltip: {
    width: 150,
    ellipsisPos: 'end'
  },
  autoCollapse: true,
  moreType: 'default',
  maxItemCount: 4,
  'aria-label': 'Breadcrumb'
};
/* harmony default export */ var breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/button/constants.js

const button_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-button`
};
const button_constants_strings = {
  sizes: ['default', 'small', 'large'],
  iconPositions: ['left', 'right'],
  htmlTypes: ['button', 'reset', 'submit'],
  btnTypes: ['primary', 'secondary', 'tertiary', 'warning', 'danger'],
  themes: ['solid', 'borderless', 'light'],
  DEFAULT_ICON_SIZE: 'default',
  DEFAULT_ICON_POSITION: 'left'
};
const button_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/button/Button.js

var Button_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




// import '@douyinfe/semi-foundation/lib/es/button/button.css';


const btnSizes = button_constants_strings.sizes;
const {
  htmlTypes,
  btnTypes
} = button_constants_strings;
// TODO: icon configuration
class Button_Button extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        children,
        block,
        htmlType,
        loading,
        circle,
        className,
        style,
        disabled,
        size,
        theme,
        type,
        prefixCls,
        iconPosition
      } = _a,
      attr = Button_rest(_a, ["children", "block", "htmlType", "loading", "circle", "className", "style", "disabled", "size", "theme", "type", "prefixCls", "iconPosition"]);
    const baseProps = Object.assign(Object.assign({
      disabled
    }, omit_default()(attr, ['x-semi-children-alias'])), {
      className: classnames_default()(prefixCls, {
        [`${prefixCls}-${type}`]: !disabled && type,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-size-large`]: size === 'large',
        [`${prefixCls}-size-small`]: size === 'small',
        // [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-light`]: theme === 'light',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-circle`]: circle,
        [`${prefixCls}-borderless`]: theme === 'borderless',
        [`${prefixCls}-outline`]: theme === "outline",
        [`${prefixCls}-${type}-disabled`]: disabled && type
      }, className),
      type: htmlType,
      'aria-disabled': disabled
    });
    const xSemiProps = {};
    if (!(className && className.includes('-with-icon'))) {
      xSemiProps['x-semi-prop'] = this.props['x-semi-children-alias'] || 'children';
    }
    return /*#__PURE__*/react.createElement("button", Object.assign({}, baseProps, {
      onClick: this.props.onClick,
      onMouseDown: this.props.onMouseDown,
      style: style
    }), /*#__PURE__*/react.createElement("span", Object.assign({
      className: classnames_default()(`${prefixCls}-content`, this.props.contentClassName),
      onClick: e => disabled && e.stopPropagation()
    }, xSemiProps), children));
  }
}
Button_Button.defaultProps = {
  disabled: false,
  size: 'default',
  type: 'primary',
  theme: 'light',
  block: false,
  htmlType: 'button',
  onMouseDown: function_noop,
  onClick: function_noop,
  onMouseEnter: function_noop,
  onMouseLeave: function_noop,
  prefixCls: button_constants_cssClasses.PREFIX
};
Button_Button.propTypes = {
  children: (prop_types_default()).node,
  disabled: (prop_types_default()).bool,
  prefixCls: (prop_types_default()).string,
  style: (prop_types_default()).object,
  size: prop_types_default().oneOf(btnSizes),
  type: prop_types_default().oneOf(btnTypes),
  block: (prop_types_default()).bool,
  onClick: (prop_types_default()).func,
  onMouseDown: (prop_types_default()).func,
  circle: (prop_types_default()).bool,
  loading: (prop_types_default()).bool,
  htmlType: prop_types_default().oneOf(htmlTypes),
  theme: prop_types_default().oneOf(button_constants_strings.themes),
  className: (prop_types_default()).string,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  'aria-label': (prop_types_default()).string,
  contentClassName: (prop_types_default()).string
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/icons/constants.js

const icons_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-icon`
};
const icons_constants_strings = {
  SIZE: ['extra-small', 'small', 'default', 'large', 'extra-large', 'custom'],
  // use in svg xhref. No need to respond to the change of prefixCls, always constant
  ICON_PREFIX: 'semi-icon-'
};
const icons_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/spin/icon.js
var icon_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


let _id = -1;
function icon_Icon() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
      id: propsId,
      className
    } = props,
    rest = icon_rest(props, ["id", "className"]);
  let _propsId = propsId;
  if (isNullOrUndefined(_propsId)) {
    _id++;
    _propsId = _id;
  }
  const id = `linearGradient-${_propsId}`;
  return /*#__PURE__*/react.createElement("svg", Object.assign({}, rest, {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 36 36",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    "data-icon": "spin"
  }), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: id
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: "0",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: "0.50",
    offset: "39.9430698%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  }))), /*#__PURE__*/react.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("rect", {
    fillOpacity: "0.01",
    fill: "none",
    x: "0",
    y: "0",
    width: "36",
    height: "36"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34,18 C34,9.163444 26.836556,2 18,2 C11.6597233,2 6.18078805,5.68784135 3.59122325,11.0354951",
    stroke: `url(#${id})`,
    strokeWidth: "4",
    strokeLinecap: "round"
  })));
}
/* harmony default export */ var spin_icon = (icon_Icon);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/iconButton/index.js

var iconButton_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/button/iconButton.css';
const iconSizes = icons_constants_strings.SIZE;
// TODO: add a buttonGroup component
// TODO: icon configuration
class IconButton extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        children: originChildren,
        iconPosition,
        iconSize,
        iconStyle,
        style: originStyle,
        icon,
        noHorizontalPadding,
        theme,
        className,
        prefixCls,
        loading
      } = _a,
      otherProps = iconButton_rest(_a, ["children", "iconPosition", "iconSize", "iconStyle", "style", "icon", "noHorizontalPadding", "theme", "className", "prefixCls", "loading"]);
    const style = Object.assign({}, originStyle);
    // TODO: review check
    if (Array.isArray(noHorizontalPadding)) {
      noHorizontalPadding.includes('left') && (style.paddingLeft = 0);
      noHorizontalPadding.includes('right') && (style.paddingRight = 0);
    } else if (noHorizontalPadding === true) {
      style.paddingLeft = 0;
      style.paddingRight = 0;
    } else if (typeof noHorizontalPadding === 'string') {
      noHorizontalPadding === 'left' && (style.paddingLeft = 0);
      noHorizontalPadding === 'right' && (style.paddingRight = 0);
    }
    let finalChildren = null;
    let IconElem = null;
    if (loading && !otherProps.disabled) {
      IconElem = /*#__PURE__*/react.createElement(spin_icon, null);
    } else if ( /*#__PURE__*/react.isValidElement(icon)) {
      IconElem = icon;
    }
    const btnTextCls = classnames_default()({
      [`${prefixCls}-content-left`]: iconPosition === 'right',
      [`${prefixCls}-content-right`]: iconPosition === 'left'
    });
    const xSemiProp = this.props['x-semi-children-alias'] || 'children';
    const children = originChildren != null ? /*#__PURE__*/react.createElement("span", {
      className: btnTextCls,
      "x-semi-prop": xSemiProp
    }, originChildren) : null;
    if (iconPosition === 'left') {
      finalChildren = /*#__PURE__*/react.createElement(react.Fragment, null, IconElem, children);
    } else {
      finalChildren = /*#__PURE__*/react.createElement(react.Fragment, null, children, IconElem);
    }
    const iconBtnCls = classnames_default()(className, `${prefixCls}-with-icon`, {
      [`${prefixCls}-with-icon-only`]: children == null || children === '',
      [`${prefixCls}-loading`]: loading
    });
    return /*#__PURE__*/react.createElement(Button_Button, Object.assign({}, otherProps, {
      className: iconBtnCls,
      theme: theme,
      style: style
    }), finalChildren);
  }
}
IconButton.defaultProps = {
  iconPosition: button_constants_strings.DEFAULT_ICON_POSITION,
  prefixCls: button_constants_cssClasses.PREFIX,
  loading: false,
  noHorizontalPadding: false,
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default())
};
IconButton.elementType = "IconButton";
IconButton.propTypes = {
  iconStyle: (prop_types_default()).object,
  style: (prop_types_default()).object,
  loading: (prop_types_default()).bool,
  prefixCls: (prop_types_default()).string,
  icon: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).string, (prop_types_default()).node]),
  iconSize: prop_types_default().oneOf(iconSizes),
  noHorizontalPadding: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string, (prop_types_default()).array]),
  children: (prop_types_default()).node,
  theme: (prop_types_default()).string,
  iconPosition: prop_types_default().oneOf(button_constants_strings.iconPositions),
  className: (prop_types_default()).string,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func
};
/* harmony default export */ var iconButton = (IconButton);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/button/index.js




class Button extends react.PureComponent {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(props);
  }
  render() {
    const props = Object.assign({}, this.props);
    const hasIcon = Boolean(props.icon);
    const isLoading = Boolean(props.loading);
    const isDisabled = Boolean(props.disabled);
    if (hasIcon || isLoading && !isDisabled) {
      return /*#__PURE__*/react.createElement(iconButton, Object.assign({}, props));
    } else {
      return /*#__PURE__*/react.createElement(Button_Button, Object.assign({}, props));
    }
  }
}
Button.__SemiComponentName__ = "Button";
Button.propTypes = Object.assign(Object.assign({}, Button_Button.propTypes), iconButton.propTypes);
Button.defaultProps = getDefaultPropsFromGlobalConfig(Button.__SemiComponentName__);
Button.elementType = 'Button';
/* harmony default export */ var es_button = (Button);
// EXTERNAL MODULE: ./node_modules/lodash/isBoolean.js
var isBoolean = __webpack_require__(51584);
var isBoolean_default = /*#__PURE__*/__webpack_require__.n(isBoolean);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/checkbox/constants.js

const checkboxClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-checkbox`,
  INNER: `${BASE_CLASS_PREFIX}-checkbox-inner`,
  TEXT: `${BASE_CLASS_PREFIX}-checkbox-text`,
  INPUT: `${BASE_CLASS_PREFIX}-checkbox-input`,
  CHECKED: `${BASE_CLASS_PREFIX}-checkbox-checked`,
  DISABLED: `${BASE_CLASS_PREFIX}-checkbox-disabled`,
  BUTTON: `${BASE_CLASS_PREFIX}-checkbox-button`,
  WRAPPER: ''
};
const checkboxGroupClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-checkboxGroup`,
  INNER: `${BASE_CLASS_PREFIX}-checkboxGroup-inner`,
  TEXT: `${BASE_CLASS_PREFIX}-checkboxGroup-text`,
  INPUT: `${BASE_CLASS_PREFIX}-checkboxGroup-input`,
  CHECKED: `${BASE_CLASS_PREFIX}-checkboxGroup-checked`,
  DISABLED: `${BASE_CLASS_PREFIX}-checkboxGroup-disabled`
};
const checkbox_constants_strings = {
  DIRECTION_SET: ['horizontal', 'vertical'],
  TYPE_DEFAULT: 'default',
  TYPE_CARD: 'card',
  TYPE_PURECARD: 'pureCard',
  DEFAULT_DIRECTION: 'vertical'
};
const checkbox_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/checkbox/checkboxFoundation.js



class CheckboxFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.clickState = false;
    this.handleFocusVisible = event => {
      const {
        target
      } = event;
      try {
        if (this.clickState) {
          this.clickState = false;
          return;
        }
        if (target.matches(':focus-visible')) {
          this._adapter.setFocusVisible(true);
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Checkbox] The current browser does not support the focus-visible');
      }
    };
    this.handleBlur = () => {
      this.clickState = false;
      this._adapter.setFocusVisible(false);
    };
  }
  init() {
    const {
      children,
      extra,
      extraId,
      addonId
    } = this.getProps();
    if (children && !addonId) {
      this._adapter.setAddonId();
    }
    if (extra && !extraId) {
      this._adapter.setExtraId();
    }
  }
  notifyChange(checked, e) {
    const cbValue = this._adapter.generateEvent(checked, e);
    this._adapter.notifyChange(cbValue);
  }
  handleChange(e) {
    const disabled = this.getProp('disabled');
    if (disabled) {
      return;
    }
    if ((e === null || e === void 0 ? void 0 : e.type) === 'click') {
      this.clickState = true;
    }
    this._adapter.focusCheckboxEntity();
    const isInGroup = this._adapter.getIsInGroup();
    if (isInGroup) {
      const groupDisabled = this._adapter.getGroupDisabled();
      if (!groupDisabled) {
        this.handleChangeInGroup(e);
      }
      return;
    }
    const checked = this.getState('checked');
    const newChecked = !checked;
    if (this._isControlledComponent('checked')) {
      this.notifyChange(newChecked, e);
    } else {
      this.setChecked(newChecked);
      this.notifyChange(newChecked, e);
    }
  }
  handleChangeInGroup(e) {
    const {
      value
    } = this.getProps();
    const groupValue = this._adapter.getGroupValue();
    const checked = groupValue.includes(value);
    const newChecked = !checked;
    const event = this._adapter.generateEvent(newChecked, e);
    this._adapter.notifyChange(event);
    this._adapter.notifyGroupChange(event);
  }
  handleEnterPress(e) {
    if (utils_isEnterPress(e)) {
      this.handleChange(e);
    }
  }
  setChecked(checked) {
    this._adapter.setNativeControlChecked(checked);
  }
  destroy() {}
}
/* harmony default export */ var checkboxFoundation = (CheckboxFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/checkbox/context.js

const Context = /*#__PURE__*/react.createContext({});

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconCheckboxTick.js


function IconCheckboxTick_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4111 7.30848C18.0692 7.81171 18.1947 8.75312 17.6915 9.41119L11.1915 17.9112C10.909 18.2806 10.4711 18.4981 10.0061 18.5C9.54105 18.5019 9.10143 18.288 8.81592 17.9209L5.31592 13.4209C4.80731 12.767 4.92512 11.8246 5.57904 11.316C6.23296 10.8074 7.17537 10.9252 7.68398 11.5791L9.98988 14.5438L15.3084 7.58884C15.8116 6.93077 16.7531 6.80525 17.4111 7.30848Z",
    fill: "currentColor"
  }));
}
const IconCheckboxTick_IconComponent = (0,Icon/* convertIcon */.A)(IconCheckboxTick_SvgComponent, 'checkbox_tick');
/* harmony default export */ var IconCheckboxTick = (IconCheckboxTick_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconCheckboxIndeterminate.js


function IconCheckboxIndeterminate_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M5 12.5C5 11.6716 5.67157 11 6.5 11H17.5C18.3284 11 19 11.6716 19 12.5C19 13.3284 18.3284 14 17.5 14H6.5C5.67157 14 5 13.3284 5 12.5Z",
    fill: "currentColor"
  }));
}
const IconCheckboxIndeterminate_IconComponent = (0,Icon/* convertIcon */.A)(IconCheckboxIndeterminate_SvgComponent, 'checkbox_indeterminate');
/* harmony default export */ var IconCheckboxIndeterminate = (IconCheckboxIndeterminate_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/checkbox/checkboxInner.js







class CheckboxInner extends react.PureComponent {
  blur() {
    this.inputEntity.blur();
  }
  focus() {
    const {
      preventScroll
    } = this.props;
    this.inputEntity.focus({
      preventScroll
    });
  }
  render() {
    const {
      indeterminate,
      checked,
      disabled,
      prefixCls,
      name,
      isPureCardType,
      addonId,
      extraId,
      focusInner,
      onInputFocus,
      onInputBlur
    } = this.props;
    const prefix = prefixCls || checkboxClasses.PREFIX;
    const wrapper = classnames_default()({
      [`${prefix}-inner`]: true,
      [`${prefix}-inner-checked`]: Boolean(checked),
      [`${prefix}-inner-pureCardType`]: isPureCardType
    }, checkboxClasses.WRAPPER);
    const inner = classnames_default()({
      [`${prefix}-inner-display`]: true,
      [`${prefix}-focus`]: focusInner,
      [`${prefix}-focus-border`]: focusInner && !checked
    });
    const icon = checked ? /*#__PURE__*/react.createElement(IconCheckboxTick, null) : indeterminate ? /*#__PURE__*/react.createElement(IconCheckboxIndeterminate, null) : null;
    const inputProps = {
      type: "checkbox",
      'aria-label': this.props['aria-label'],
      'aria-disabled': disabled,
      'aria-checked': checked,
      'aria-labelledby': addonId,
      'aria-describedby': extraId || this.props['aria-describedby'],
      'aria-invalid': this.props['aria-invalid'],
      'aria-errormessage': this.props['aria-errormessage'],
      'aria-required': this.props['aria-required'],
      className: checkboxClasses.INPUT,
      onChange: (noop_default()),
      checked: checked,
      disabled: disabled,
      onFocus: onInputFocus,
      onBlur: onInputBlur
    };
    name && (inputProps['name'] = name);
    return /*#__PURE__*/react.createElement("span", {
      className: wrapper
    }, /*#__PURE__*/react.createElement("input", Object.assign({}, inputProps, {
      ref: ref => {
        this.inputEntity = ref;
      }
    })), /*#__PURE__*/react.createElement("span", {
      className: inner
    }, icon));
  }
}
CheckboxInner.contextType = Context;
CheckboxInner.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  checked: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  children: (prop_types_default()).node,
  grouped: (prop_types_default()).bool,
  value: (prop_types_default()).any,
  isPureCardType: (prop_types_default()).bool,
  addonId: (prop_types_default()).string,
  extraId: (prop_types_default()).string,
  focusInner: (prop_types_default()).bool,
  onInputFocus: (prop_types_default()).func,
  onInputBlur: (prop_types_default()).func,
  preventScroll: (prop_types_default()).bool
};
CheckboxInner.defaultProps = {
  onChange: (noop_default())
};
/* harmony default export */ var checkboxInner = (CheckboxInner);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/checkbox/checkbox.js










// import '@douyinfe/semi-foundation/lib/es/checkbox/checkbox.css';


class Checkbox extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setNativeControlChecked: checked => {
        this.setState({
          checked
        });
      },
      notifyChange: cbContent => {
        const {
          onChange
        } = this.props;
        onChange && onChange(cbContent);
      },
      generateEvent: (checked, e) => {
        const {
          props
        } = this;
        const cbValue = {
          target: Object.assign(Object.assign({}, props), {
            checked
          }),
          stopPropagation: () => {
            e.stopPropagation();
          },
          preventDefault: () => {
            e.preventDefault();
          },
          nativeEvent: {
            stopImmediatePropagation: () => {
              if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
                e.nativeEvent.stopImmediatePropagation();
              }
            }
          }
        };
        return cbValue;
      },
      getIsInGroup: () => this.isInGroup(),
      getGroupValue: () => this.context && this.context.checkboxGroup.value || [],
      notifyGroupChange: cbContent => {
        this.context.checkboxGroup.onChange(cbContent);
      },
      getGroupDisabled: () => this.context && this.context.checkboxGroup.disabled,
      setAddonId: () => {
        this.setState({
          addonId: getUuidShort({
            prefix: 'addon'
          })
        });
      },
      setExtraId: () => {
        this.setState({
          extraId: getUuidShort({
            prefix: 'extra'
          })
        });
      },
      setFocusVisible: focusVisible => {
        this.setState({
          focusVisible
        });
      },
      focusCheckboxEntity: () => {
        this.focus();
      }
    });
  }
  constructor(props) {
    super(props);
    this.handleChange = e => this.foundation.handleChange(e);
    this.handleEnterPress = e => this.foundation.handleEnterPress(e);
    this.handleFocusVisible = event => {
      this.foundation.handleFocusVisible(event);
    };
    this.handleBlur = event => {
      this.foundation.handleBlur();
    };
    const checked = false;
    this.state = {
      checked: props.checked || props.defaultChecked || checked,
      addonId: props.addonId,
      extraId: props.extraId,
      focusVisible: false
    };
    this.checkboxEntity = null;
    this.foundation = new checkboxFoundation(this.adapter);
  }
  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      if (isUndefined_default()(this.props.checked)) {
        this.foundation.setChecked(false);
      } else if (isBoolean_default()(this.props.checked)) {
        this.foundation.setChecked(this.props.checked);
      }
    }
  }
  isInGroup() {
    // Why do we need to determine whether there is a value in props?
    // If there is no value in the props of the checkbox in the context of the checkboxGroup, 
    // it will be considered not to belong to the checkboxGroup。
    return Boolean(this.context && this.context.checkboxGroup && 'value' in this.props);
  }
  focus() {
    this.checkboxEntity && this.checkboxEntity.focus();
  }
  blur() {
    this.checkboxEntity && this.checkboxEntity.blur();
  }
  render() {
    const {
      disabled,
      style,
      prefixCls,
      className,
      indeterminate,
      children,
      onMouseEnter,
      onMouseLeave,
      extra,
      value,
      role,
      tabIndex,
      id,
      type
    } = this.props;
    const {
      checked,
      addonId,
      extraId,
      focusVisible
    } = this.state;
    const props = {
      checked,
      disabled
    };
    const inGroup = this.isInGroup();
    if (inGroup) {
      if (this.context.checkboxGroup.value) {
        const realChecked = (this.context.checkboxGroup.value || []).includes(value);
        props.checked = realChecked;
      }
      if (this.context.checkboxGroup.disabled) {
        props.disabled = this.context.checkboxGroup.disabled || this.props.disabled;
      }
      const {
        isCardType,
        isPureCardType
      } = this.context.checkboxGroup;
      props.isCardType = isCardType;
      props.isPureCardType = isPureCardType;
      props['name'] = this.context.checkboxGroup.name;
    } else {
      props.isPureCardType = type === checkbox_constants_strings.TYPE_PURECARD;
      props.isCardType = type === checkbox_constants_strings.TYPE_CARD || props.isPureCardType;
    }
    const prefix = prefixCls || checkboxClasses.PREFIX;
    const focusOuter = props.isCardType || props.isPureCardType;
    const wrapper = classnames_default()(prefix, {
      [`${prefix}-disabled`]: props.disabled,
      [`${prefix}-indeterminate`]: indeterminate,
      [`${prefix}-checked`]: props.checked,
      [`${prefix}-unChecked`]: !props.checked,
      [`${prefix}-cardType`]: props.isCardType,
      [`${prefix}-cardType_disabled`]: props.disabled && props.isCardType,
      [`${prefix}-cardType_unDisabled`]: !(props.disabled && props.isCardType),
      [`${prefix}-cardType_checked`]: props.isCardType && props.checked && !props.disabled,
      [`${prefix}-cardType_checked_disabled`]: props.isCardType && props.checked && props.disabled,
      [className]: Boolean(className),
      [`${prefix}-focus`]: focusVisible && focusOuter
    });
    const extraCls = classnames_default()(`${prefix}-extra`, {
      [`${prefix}-cardType_extra_noChildren`]: props.isCardType && !children
    });
    const name = inGroup && this.context.checkboxGroup.name;
    const xSemiPropChildren = this.props['x-semi-children-alias'] || 'children';
    const renderContent = () => {
      if (!children && !extra) {
        return null;
      }
      return /*#__PURE__*/react.createElement("div", {
        className: `${prefix}-content`
      }, children ? /*#__PURE__*/react.createElement("span", {
        id: addonId,
        className: `${prefix}-addon`,
        "x-semi-prop": xSemiPropChildren
      }, children) : null, extra ? /*#__PURE__*/react.createElement("div", {
        id: extraId,
        className: extraCls,
        "x-semi-prop": "extra"
      }, extra) : null);
    };
    return (
      /*#__PURE__*/
      // label is better than span, however span is here which is to solve gitlab issue #364
      react.createElement("span", Object.assign({
        role: role,
        tabIndex: tabIndex,
        style: style,
        className: wrapper,
        id: id,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: this.handleChange,
        onKeyPress: this.handleEnterPress,
        "aria-labelledby": this.props['aria-labelledby']
      }, this.getDataAttr(this.props)), /*#__PURE__*/react.createElement(checkboxInner, Object.assign({}, this.props, props, {
        addonId: children && addonId,
        extraId: extra && extraId,
        isPureCardType: props.isPureCardType,
        ref: ref => {
          this.checkboxEntity = ref;
        },
        focusInner: focusVisible && !focusOuter,
        onInputFocus: this.handleFocusVisible,
        onInputBlur: this.handleBlur
      })), renderContent())
    );
  }
}
Checkbox.contextType = Context;
Checkbox.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  // Specifies whether it is currently selected
  checked: (prop_types_default()).bool,
  // Initial check
  defaultChecked: (prop_types_default()).bool,
  // Failure state
  disabled: (prop_types_default()).bool,
  // Set indeterminate state, only responsible for style control
  indeterminate: (prop_types_default()).bool,
  // Callback function when changing
  onChange: (prop_types_default()).func,
  value: (prop_types_default()).any,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  prefixCls: (prop_types_default()).string,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  extra: (prop_types_default()).node,
  index: (prop_types_default()).number,
  'aria-label': (prop_types_default()).string,
  tabIndex: (prop_types_default()).number,
  preventScroll: (prop_types_default()).bool,
  type: (prop_types_default()).string
};
Checkbox.defaultProps = {
  defaultChecked: false,
  indeterminate: false,
  onChange: (noop_default()),
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default()),
  type: 'default'
};
Checkbox.elementType = 'Checkbox';
/* harmony default export */ var checkbox_checkbox = (Checkbox);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/checkbox/checkboxGroupFoundation.js


class CheckboxGroupFoundation extends foundation {
  static get checkboxGroupDefaultAdapter() {
    return {};
  }
  constructor(adapter) {
    super(Object.assign(Object.assign({}, CheckboxGroupFoundation.checkboxGroupDefaultAdapter), adapter));
  }
  init() {
    const {
      defaultValue,
      value
    } = this.getProps();
    if (typeof defaultValue !== 'undefined' && !Array.isArray(defaultValue)) {
      warning(true, 'Warning: [Semi CheckboxGroup] defaultValue should be an Array');
    }
    if (typeof value !== 'undefined' && !Array.isArray(value)) {
      warning(true, 'Warning: [Semi CheckboxGroup] value should be an Array');
    }
  }
  notifyChange(value) {
    this._adapter.notifyChange(value);
  }
  handleChange(evt) {
    const prevValue = this.getState('value');
    let newValue = [];
    if (!Array.isArray(prevValue)) {
      newValue = [prevValue];
    }
    if (evt.target.checked) {
      newValue = [...prevValue, evt.target.value];
    } else {
      newValue = prevValue.filter((itm, idx) => itm !== evt.target.value);
    }
    const isControlledMode = ('value' in this.getProps());
    if (isControlledMode) {
      // Controlled mode only needs to notify
      this.notifyChange(newValue);
    } else {
      // In uncontrolled mode, update the value in the state, and then notify
      this._adapter.updateGroupValue(newValue);
      this.notifyChange(newValue);
    }
  }
  getFormatName() {
    const propName = this.getProp('name');
    const defaultName = 'default';
    return propName || defaultName;
  }
  handlePropValueChange(newPropValue) {
    if (Array.isArray(newPropValue)) {
      this._adapter.updateGroupValue(newPropValue);
    } else {
      // to adjust reset in Form.CheckboxGroup
      if (typeof newPropValue === 'undefined') {
        this._adapter.updateGroupValue([]);
      }
      warning(true, 'Warning: [Semi CheckboxGroup] value should be an Array');
    }
  }
  destroy() {}
}
/* harmony default export */ var checkboxGroupFoundation = (CheckboxGroupFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/checkbox/checkboxGroup.js









class CheckboxGroup extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      updateGroupValue: value => {
        this.setState({
          value
        });
      },
      notifyChange: value => {
        this.props.onChange && this.props.onChange(value);
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue
    };
    this.foundation = new checkboxGroupFoundation(this.adapter);
    this.onChange = this.onChange.bind(this);
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentDidUpdate(prevProps) {
    if (!isEqual_default()(prevProps.value, this.props.value)) {
      this.foundation.handlePropValueChange(this.props.value);
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  onChange(evt) {
    this.foundation.handleChange(evt);
  }
  render() {
    const {
      children,
      options,
      prefixCls,
      direction,
      className,
      id,
      style,
      type,
      disabled
    } = this.props;
    const isPureCardType = type === checkbox_constants_strings.TYPE_PURECARD;
    const isCardType = type === checkbox_constants_strings.TYPE_CARD || isPureCardType;
    const prefix = prefixCls || checkboxGroupClasses.PREFIX;
    const prefixClsDisplay = classnames_default()({
      [prefix]: true,
      [`${prefix}-wrapper`]: true,
      [`${prefix}-${direction}`]: direction,
      [`${prefix}-${direction}-cardType`]: direction && isCardType,
      [`${prefix}-${direction}-pureCardType`]: direction && isPureCardType
    }, className);
    const realValue = this.state.value.slice();
    let inner;
    if (options) {
      inner = (options || []).map((option, index) => {
        if (typeof option === 'string') {
          return /*#__PURE__*/react.createElement(checkbox_checkbox, {
            role: "listitem",
            key: index,
            disabled: this.props.disabled,
            value: option,
            prefixCls: prefixCls
          }, option);
        } else {
          return /*#__PURE__*/react.createElement(checkbox_checkbox, {
            role: "listitem",
            key: index,
            disabled: option.disabled || this.props.disabled,
            value: option.value,
            prefixCls: prefixCls,
            extra: option.extra,
            className: option.className,
            style: option.style,
            onChange: option.onChange
          }, option.label);
        }
      });
    } else if (children) {
      inner = react.Children.toArray(children).map((itm, index) => /*#__PURE__*/react.cloneElement(itm, {
        key: index,
        role: 'listitem'
      }));
    }
    return /*#__PURE__*/react.createElement("div", Object.assign({
      id: id,
      role: "list",
      "aria-label": this.props['aria-label'],
      className: prefixClsDisplay,
      style: style,
      "aria-labelledby": this.props['aria-labelledby'],
      "aria-describedby": this.props['aria-describedby']
    }, this.getDataAttr(this.props)), /*#__PURE__*/react.createElement(Context.Provider, {
      value: {
        checkboxGroup: {
          onChange: this.onChange,
          value: realValue,
          disabled: this.props.disabled,
          name: this.foundation.getFormatName(),
          isCardType,
          isPureCardType
        }
      }
    }, inner));
  }
}
CheckboxGroup.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  defaultValue: (prop_types_default()).array,
  disabled: (prop_types_default()).bool,
  name: (prop_types_default()).string,
  options: (prop_types_default()).array,
  value: (prop_types_default()).array,
  onChange: (prop_types_default()).func,
  children: (prop_types_default()).node,
  prefixCls: (prop_types_default()).string,
  direction: prop_types_default().oneOf(checkbox_constants_strings.DIRECTION_SET),
  className: (prop_types_default()).string,
  type: prop_types_default().oneOf([checkbox_constants_strings.TYPE_DEFAULT, checkbox_constants_strings.TYPE_CARD, checkbox_constants_strings.TYPE_PURECARD]),
  style: (prop_types_default()).object
};
CheckboxGroup.defaultProps = {
  disabled: false,
  onChange: () => {},
  type: checkbox_constants_strings.TYPE_DEFAULT,
  defaultValue: [],
  direction: checkbox_constants_strings.DEFAULT_DIRECTION
};
/* harmony default export */ var checkboxGroup = (CheckboxGroup);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/checkbox/index.js


class CheckboxWithGroup extends checkbox_checkbox {}
CheckboxWithGroup.Group = checkboxGroup;

/* harmony default export */ var es_checkbox = (CheckboxWithGroup);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/collapse/constants.js

const collapse_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-collapse`
};
const collapse_constants_strings = {
  iconPosition: ['left', 'right']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/collapse/foundation.js

class CollapseFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  initActiveKey() {
    const {
      defaultActiveKey,
      activeKey,
      accordion
    } = this.getProps();
    let activeKeyList = activeKey ? activeKey : defaultActiveKey;
    if (accordion) {
      activeKeyList = Array.isArray(activeKeyList) ? activeKeyList[0] : activeKeyList;
    }
    if (activeKeyList && activeKeyList.length) {
      activeKeyList = Array.isArray(activeKeyList) ? activeKeyList : [activeKeyList];
      return activeKeyList;
    }
    return [];
    // this._adapter.initActiveSet(activeKeyList);
  }

  handleChange(newKey, e) {
    const {
      activeKey,
      accordion
    } = this.getProps();
    const {
      activeSet
    } = this.getStates();
    let newSet = new Set(activeSet);
    if (newSet.has(newKey)) {
      newSet.delete(newKey);
    } else {
      if (accordion) {
        newSet = new Set([newKey]);
      } else {
        newSet.add(newKey);
      }
    }
    this._adapter.handleChange([...newSet.values()], e);
    if (typeof activeKey === 'undefined') {
      this._adapter.addActiveKey(newSet);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/collapsible/foundation.js

class CollapsibleFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.updateDOMInRenderTree = isInRenderTree => {
      this._adapter.setDOMInRenderTree(isInRenderTree);
    };
    this.updateDOMHeight = domHeight => {
      this._adapter.setDOMHeight(domHeight);
    };
    this.updateVisible = visible => {
      this._adapter.setVisible(visible);
    };
    this.updateIsTransitioning = isTransitioning => {
      this._adapter.setIsTransitioning(isTransitioning);
    };
  }
}
/* harmony default export */ var collapsible_foundation = (CollapsibleFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/collapsible/constants.js

const collapsible_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-collapsible`
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/collapsible/index.js







// import '@douyinfe/semi-foundation/lib/es/collapsible/collapsible.css';

class Collapsible extends BaseComponent {
  constructor(props) {
    super(props);
    this.domRef = /*#__PURE__*/react.createRef();
    this.hasBeenRendered = false;
    this.handleResize = entryList => {
      const entry = entryList[0];
      if (entry) {
        const entryInfo = Collapsible.getEntryInfo(entry);
        this.foundation.updateDOMHeight(entryInfo.height);
        this.foundation.updateDOMInRenderTree(entryInfo.isShown);
      }
    };
    this.isChildrenInRenderTree = () => {
      if (this.domRef.current) {
        return this.domRef.current.offsetHeight > 0;
      }
      return false;
    };
    this.state = {
      domInRenderTree: false,
      domHeight: 0,
      visible: this.props.isOpen,
      isTransitioning: false
    };
    this.foundation = new collapsible_foundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setDOMInRenderTree: domInRenderTree => {
        if (this.state.domInRenderTree !== domInRenderTree) {
          this.setState({
            domInRenderTree
          });
        }
      },
      setDOMHeight: domHeight => {
        if (this.state.domHeight !== domHeight) {
          this.setState({
            domHeight
          });
        }
      },
      setVisible: visible => {
        if (this.state.visible !== visible) {
          this.setState({
            visible
          });
        }
      },
      setIsTransitioning: isTransitioning => {
        if (this.state.isTransitioning !== isTransitioning) {
          this.setState({
            isTransitioning
          });
        }
      }
    });
  }
  componentDidMount() {
    super.componentDidMount();
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.domRef.current);
    const domInRenderTree = this.isChildrenInRenderTree();
    this.foundation.updateDOMInRenderTree(domInRenderTree);
    if (domInRenderTree) {
      this.foundation.updateDOMHeight(this.domRef.current.scrollHeight);
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const changedPropKeys = Object.keys(this.props).filter(key => !isEqual_default()(this.props[key], prevProps[key]));
    const changedStateKeys = Object.keys(this.state).filter(key => !isEqual_default()(this.state[key], prevState[key]));
    if (changedPropKeys.includes("reCalcKey")) {
      this.foundation.updateDOMHeight(this.domRef.current.scrollHeight);
    }
    if (changedStateKeys.includes("domInRenderTree") && this.state.domInRenderTree) {
      this.foundation.updateDOMHeight(this.domRef.current.scrollHeight);
    }
    if (changedPropKeys.includes("isOpen")) {
      if (this.props.isOpen || !this.props.motion) {
        this.foundation.updateVisible(this.props.isOpen);
      }
    }
    if (this.props.motion && prevProps.isOpen !== this.props.isOpen) {
      this.foundation.updateIsTransitioning(true);
    }
  }
  componentWillUnmount() {
    super.componentWillUnmount();
    this.resizeObserver.disconnect();
  }
  render() {
    const wrapperStyle = Object.assign({
      overflow: 'hidden',
      height: this.props.isOpen ? this.state.domHeight : this.props.collapseHeight,
      opacity: this.props.isOpen || !this.props.fade || this.props.collapseHeight !== 0 ? 1 : 0,
      transitionDuration: `${this.props.motion && this.state.isTransitioning ? this.props.duration : 0}ms`
    }, this.props.style);
    const wrapperCls = classnames_default()(`${collapsible_constants_cssClasses.PREFIX}-wrapper`, {
      [`${collapsible_constants_cssClasses.PREFIX}-transition`]: this.props.motion && this.state.isTransitioning
    }, this.props.className);
    const shouldRender = this.props.keepDOM && (this.props.lazyRender ? this.hasBeenRendered : true) || this.props.collapseHeight !== 0 || this.state.visible || this.props.isOpen;
    if (shouldRender && !this.hasBeenRendered) {
      this.hasBeenRendered = true;
    }
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: wrapperCls,
      style: wrapperStyle,
      onTransitionEnd: () => {
        var _a, _b;
        if (!this.props.isOpen) {
          this.foundation.updateVisible(false);
        }
        this.foundation.updateIsTransitioning(false);
        (_b = (_a = this.props).onMotionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    }, this.getDataAttr(this.props)), /*#__PURE__*/react.createElement("div", {
      "x-semi-prop": "children",
      ref: this.domRef,
      style: {
        overflow: 'hidden'
      },
      id: this.props.id
    }, shouldRender && this.props.children));
  }
}
Collapsible.__SemiComponentName__ = "Collapsible";
Collapsible.defaultProps = getDefaultPropsFromGlobalConfig(Collapsible.__SemiComponentName__, {
  isOpen: false,
  duration: 250,
  motion: true,
  keepDOM: false,
  lazyRender: false,
  collapseHeight: 0,
  fade: false
});
Collapsible.getEntryInfo = entry => {
  //judge whether parent or self display none
  let inRenderTree;
  if (entry.borderBoxSize) {
    inRenderTree = !(entry.borderBoxSize[0].blockSize === 0 && entry.borderBoxSize[0].inlineSize === 0);
  } else {
    inRenderTree = !(entry.contentRect.height === 0 && entry.contentRect.width === 0);
  }
  let height = 0;
  if (entry.borderBoxSize) {
    height = Math.ceil(entry.borderBoxSize[0].blockSize);
  } else {
    const target = entry.target;
    height = target.clientHeight;
  }
  return {
    isShown: inRenderTree,
    height
  };
};
Collapsible.propTypes = {
  motion: (prop_types_default()).bool,
  children: (prop_types_default()).node,
  isOpen: (prop_types_default()).bool,
  duration: (prop_types_default()).number,
  keepDOM: (prop_types_default()).bool,
  collapseHeight: (prop_types_default()).number,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  reCalcKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
/* harmony default export */ var collapsible = (Collapsible);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/collapse/collapse-context.js

const CollapseContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var collapse_context = (CollapseContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconChevronDown.js


function IconChevronDown_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08045 7.59809C4.66624 7.01231 5.61599 7.01231 6.20177 7.59809L11.8586 13.2549L17.5155 7.59809C18.1013 7.01231 19.051 7.01231 19.6368 7.59809C20.2226 8.18388 20.2226 9.13363 19.6368 9.71941L12.9193 16.4369C12.3335 17.0227 11.3838 17.0227 10.798 16.4369L4.08045 9.71941C3.49467 9.13363 3.49467 8.18388 4.08045 7.59809Z",
    fill: "currentColor"
  }));
}
const IconChevronDown_IconComponent = (0,Icon/* convertIcon */.A)(IconChevronDown_SvgComponent, 'chevron_down');
/* harmony default export */ var IconChevronDown = (IconChevronDown_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconChevronUp.js


function IconChevronUp_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.637 16.4369C19.0513 17.0227 18.1015 17.0227 17.5157 16.4369L11.8589 10.7801L6.20202 16.4369C5.61623 17.0227 4.66648 17.0227 4.0807 16.4369C3.49491 15.8511 3.49491 14.9014 4.0807 14.3156L10.7982 7.59809C11.384 7.01231 12.3337 7.01231 12.9195 7.59809L19.637 14.3156C20.2228 14.9014 20.2228 15.8511 19.637 16.4369Z",
    fill: "currentColor"
  }));
}
const IconChevronUp_IconComponent = (0,Icon/* convertIcon */.A)(IconChevronUp_SvgComponent, 'chevron_up');
/* harmony default export */ var IconChevronUp = (IconChevronUp_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/collapse/item.js
var item_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








class CollapsePanel extends react.PureComponent {
  constructor() {
    super(...arguments);
    this.headerExpandIconTriggerRef = /*#__PURE__*/react.createRef();
    this.ariaID = "";
    this.handleClick = (itemKey, e) => {
      var _a;
      // Judge user click Icon or Header
      // Don't mount this func into icon span wrapper, or get triggered twice because of event propagation
      if (this.context.clickHeaderToExpand || ((_a = this.headerExpandIconTriggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
        this.context.onClick(itemKey, e);
      }
    };
  }
  componentDidMount() {
    this.ariaID = getUuidShort({});
  }
  renderHeader(active) {
    let expandIconEnable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const {
      showArrow,
      header,
      extra
    } = this.props;
    let {
      expandIcon,
      collapseIcon
    } = this.context;
    const {
      expandIconPosition
    } = this.context;
    if (typeof expandIcon === 'undefined') {
      expandIcon = /*#__PURE__*/react.createElement(IconChevronDown, null);
    }
    if (typeof collapseIcon === 'undefined') {
      collapseIcon = /*#__PURE__*/react.createElement(IconChevronUp, null);
    }
    const icon = /*#__PURE__*/react.createElement("span", {
      ref: this.headerExpandIconTriggerRef,
      "aria-hidden": 'true',
      className: classnames_default()([`${collapse_constants_cssClasses.PREFIX}-header-icon`, {
        [`${collapse_constants_cssClasses.PREFIX}-header-iconDisabled`]: !expandIconEnable
      }])
    }, expandIconEnable ? active ? collapseIcon : expandIcon : expandIcon);
    const iconPosLeft = expandIconPosition === 'left';
    if (typeof header === 'string') {
      return /*#__PURE__*/react.createElement(react.Fragment, null, showArrow && (iconPosLeft ? icon : null), /*#__PURE__*/react.createElement("span", null, header), /*#__PURE__*/react.createElement("span", {
        className: `${collapse_constants_cssClasses.PREFIX}-header-right`
      }, /*#__PURE__*/react.createElement("span", null, extra), showArrow && (iconPosLeft ? null : icon)));
    }
    return /*#__PURE__*/react.createElement(react.Fragment, null, showArrow && (iconPosLeft ? icon : null), header, showArrow && (iconPosLeft ? null : icon));
  }
  render() {
    const _a = this.props,
      {
        className,
        children,
        itemKey,
        reCalcKey,
        header,
        extra,
        showArrow,
        disabled
      } = _a,
      restProps = item_rest(_a, ["className", "children", "itemKey", "reCalcKey", "header", "extra", "showArrow", "disabled"]);
    const {
      keepDOM,
      expandIconPosition,
      activeSet,
      motion,
      lazyRender
    } = this.context;
    const active = activeSet.has(itemKey);
    const itemCls = classnames_default()(className, {
      [`${collapse_constants_cssClasses.PREFIX}-item`]: true
    });
    const headerCls = classnames_default()({
      [`${collapse_constants_cssClasses.PREFIX}-header`]: true,
      [`${collapse_constants_cssClasses.PREFIX}-header-disabled`]: disabled,
      [`${collapse_constants_cssClasses.PREFIX}-header-iconLeft`]: expandIconPosition === 'left'
    });
    const contentCls = classnames_default()({
      [`${collapse_constants_cssClasses.PREFIX}-content`]: true
    });
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: itemCls
    }, restProps), /*#__PURE__*/react.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: headerCls,
      "aria-disabled": disabled,
      "aria-expanded": active ? 'true' : 'false',
      "aria-owns": this.ariaID,
      onClick: e => !disabled && this.handleClick(itemKey, e)
    }, this.renderHeader(active, children !== undefined && !disabled)), children && /*#__PURE__*/react.createElement(collapsible, {
      lazyRender: lazyRender,
      isOpen: active,
      keepDOM: keepDOM,
      motion: motion,
      onMotionEnd: this.props.onMotionEnd,
      reCalcKey: reCalcKey
    }, /*#__PURE__*/react.createElement("div", {
      className: contentCls,
      "aria-hidden": !active,
      id: this.ariaID
    }, /*#__PURE__*/react.createElement("div", {
      className: `${collapse_constants_cssClasses.PREFIX}-content-wrapper`
    }, children))));
  }
}
CollapsePanel.contextType = collapse_context;
CollapsePanel.propTypes = {
  itemKey: (prop_types_default()).string,
  extra: (prop_types_default()).node,
  header: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).node]),
  className: (prop_types_default()).string,
  reCalcKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  showArrow: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool
};
CollapsePanel.defaultProps = {
  showArrow: true,
  disabled: false
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/collapse/index.js

var collapse_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/collapse/collapse.css';



class Collapse extends BaseComponent {
  constructor(props) {
    super(props);
    this.onChange = (activeKey, e) => {
      this.foundation.handleChange(activeKey, e);
    };
    this.foundation = new CollapseFoundation(this.adapter);
    const initKeys = this.foundation.initActiveKey();
    this.state = {
      activeSet: new Set(initKeys)
    };
    this.onChange = this.onChange.bind(this);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      handleChange: (activeKey, e) => this.props.onChange(activeKey, e),
      addActiveKey: activeSet => this.setState({
        activeSet
      })
    });
  }
  static getDerivedStateFromProps(props, state) {
    if (props.activeKey) {
      const keys = Array.isArray(props.activeKey) ? props.activeKey : [props.activeKey];
      const newSet = new Set(keys);
      if (!isEqual_default()(newSet, state.activeSet)) {
        return Object.assign(Object.assign({}, state), {
          activeSet: newSet
        });
      }
      return state;
    }
    return state;
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const _a = this.props,
      {
        defaultActiveKey,
        lazyRender,
        accordion,
        style,
        motion,
        className,
        keepDOM,
        expandIconPosition,
        expandIcon,
        collapseIcon,
        children,
        clickHeaderToExpand
      } = _a,
      rest = collapse_rest(_a, ["defaultActiveKey", "lazyRender", "accordion", "style", "motion", "className", "keepDOM", "expandIconPosition", "expandIcon", "collapseIcon", "children", "clickHeaderToExpand"]);
    const clsPrefix = classnames_default()(collapse_constants_cssClasses.PREFIX, className);
    const {
      activeSet
    } = this.state;
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: clsPrefix,
      style: style
    }, this.getDataAttr(this.props)), /*#__PURE__*/react.createElement(collapse_context.Provider, {
      value: {
        activeSet,
        expandIcon,
        collapseIcon,
        clickHeaderToExpand,
        keepDOM,
        expandIconPosition,
        onClick: this.onChange,
        motion,
        lazyRender
      }
    }, children));
  }
}
Collapse.Panel = CollapsePanel;
Collapse.propTypes = {
  activeKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  defaultActiveKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  accordion: (prop_types_default()).bool,
  clickHeaderToExpand: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  expandIcon: (prop_types_default()).node,
  collapseIcon: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  keepDOM: (prop_types_default()).bool,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  expandIconPosition: prop_types_default().oneOf(collapse_constants_strings.iconPosition),
  lazyRender: (prop_types_default()).bool
};
Collapse.__SemiComponentName__ = 'Collapse';
Collapse.defaultProps = getDefaultPropsFromGlobalConfig(Collapse.__SemiComponentName__, {
  defaultActiveKey: '',
  clickHeaderToExpand: true,
  onChange: function_noop,
  expandIconPosition: 'right',
  lazyRender: false
});
/* harmony default export */ var collapse = (Collapse);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(81763);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/input/constants.js

const input_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-input`
};
const input_constants_strings = {
  SIZE: ['small', 'large', 'default'],
  DEFAULT_SIZE: 'default',
  STATUS: ['default', 'error', 'warning', 'success'],
  CLEARBTN_CLICKED_EVENT_FLAG: '__fromClearBtn',
  MODE: ['password']
};
const input_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/input/foundation.js








class InputFoundation extends foundation {
  static get inputDefaultAdapter() {
    return {
      notifyChange: (noop_default()),
      setValue: (noop_default())
      // toggleAllowClear: noop,
    };
  }

  constructor(adapter) {
    super(Object.assign(Object.assign({}, InputFoundation.inputDefaultAdapter), adapter));
  }
  destroy() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  setDisable() {}
  setValue(value) {
    this._adapter.setValue(value);
  }
  handleChange(value, e) {
    const {
      maxLength,
      minLength,
      getValueLength
    } = this._adapter.getProps();
    let nextValue = value;
    if (maxLength && isFunction_default()(getValueLength)) {
      nextValue = this.handleVisibleMaxLength(value);
    }
    if (minLength && isFunction_default()(getValueLength)) {
      this.handleVisibleMinLength(nextValue);
    }
    if (this._isControlledComponent()) {
      /**
       * If it is a controlled component, directly notify the caller of the modified value.
       * Truncate the input value from the input box if the input value exceeds the maximum length limit.
       *  Even in controlled components, characters that exceed the length limit cannot be entered through the input box.
       */
      this._adapter.notifyChange(nextValue, e);
    } else {
      this._adapter.setValue(nextValue);
      this._adapter.notifyChange(nextValue, e);
      // this.checkAllowClear(value);
    }
  }
  /**
   * Modify minLength to trigger browser check for minimum length
   * Controlled mode is not checked
   * @param {String} value
   */
  handleVisibleMinLength(value) {
    const {
      minLength,
      getValueLength
    } = this._adapter.getProps();
    const {
      minLength: stateMinLength
    } = this._adapter.getStates();
    if (isNumber_default()(minLength) && minLength >= 0 && isFunction_default()(getValueLength) && isString_default()(value)) {
      const valueLength = getValueLength(value);
      if (valueLength < minLength) {
        const newMinLength = value.length + (minLength - valueLength);
        newMinLength !== stateMinLength && this._adapter.setMinLength(newMinLength);
      } else {
        stateMinLength !== minLength && this._adapter.setMinLength(minLength);
      }
    }
  }
  /**
   * Handle input emoji characters beyond maxLength
   * Controlled mode is not checked
   * @param {String} value
   */
  handleVisibleMaxLength(value) {
    const {
      maxLength,
      getValueLength
    } = this._adapter.getProps();
    if (isNumber_default()(maxLength) && maxLength >= 0 && isFunction_default()(getValueLength) && isString_default()(value)) {
      const valueLength = getValueLength(value);
      if (valueLength > maxLength) {
        console.warn('[Semi Input] The input character is truncated because the input length exceeds the maximum length limit');
        const truncatedValue = this.handleTruncateValue(value, maxLength);
        return truncatedValue;
      } else {
        return value;
      }
    }
  }
  /**
   * Truncate input values based on maximum length
   * @param {String} value
   * @param {Number} maxLength
   * @returns {String}
   */
  handleTruncateValue(value, maxLength) {
    const {
      getValueLength
    } = this._adapter.getProps();
    if (isFunction_default()(getValueLength)) {
      let truncatedValue = '';
      for (let i = 1, len = value.length; i <= len; i++) {
        const currentValue = value.slice(0, i);
        if (getValueLength(currentValue) > maxLength) {
          return truncatedValue;
        } else {
          truncatedValue = currentValue;
        }
      }
      return truncatedValue;
    } else {
      return value.slice(0, maxLength);
    }
  }
  handleClear(e) {
    let eventObj = e;
    const value = '';
    // let input = this._adapter.getInput();
    if (this._isControlledComponent('value')) {
      this._adapter.setState({
        isFocus: false
      });
    } else {
      this._adapter.setState({
        value: '',
        isFocus: false
      });
    }
    if (!eventObj || typeof eventObj !== 'object') {
      eventObj = {};
    }
    set_default()(eventObj, input_constants_strings.CLEARBTN_CLICKED_EVENT_FLAG, true); // this is useful for DateInput
    this._adapter.notifyChange(value, eventObj);
    this._adapter.notifyClear(eventObj);
    if (eventObj) {
      // When input is in popover and popover needs to judge clickOutSide, such as TreeSelect
      // If the click event bubbles up, it will mistakenly trigger clickOutSide's judgment.
      // At the same time, because the clear icon is not in the dom tree after clicking, and clickOutSide uses dom.contain (e.target), it will be considered as clicking on the outside, which will cause the floating layer to fold
      // So we need to stop the incident from bubbling up
      this.stopPropagation(eventObj);
    }
  }
  /**
   * trigger when click input wrapper
   * @param {Event} e
   */
  handleClick(e) {
    const {
      disabled
    } = this._adapter.getProps();
    const {
      isFocus
    } = this._adapter.getStates();
    if (disabled || isFocus) {
      return;
    }
    // do not handle bubbling up events
    if (this._adapter.isEventTarget(e)) {
      this._adapter.focusInput();
      this._adapter.toggleFocusing(true);
    }
  }
  handleModeChange(mode) {
    if (mode === 'password') {
      this._adapter.setEyeClosed(true);
    } else {
      this._adapter.setEyeClosed(false);
    }
  }
  handleClickEye(e) {
    const eyeClosed = this._adapter.getState('eyeClosed');
    this._adapter.focusInput();
    this._adapter.toggleFocusing(true);
    this._adapter.setEyeClosed(!eyeClosed);
  }
  handleInputType(type) {
    const mode = this._adapter.getProp('mode');
    const eyeClosed = this._adapter.getState('eyeClosed');
    if (mode === 'password') {
      return eyeClosed ? 'password' : 'text';
    }
    return type;
  }
  handleMouseDown(e) {
    e.preventDefault();
  }
  handleMouseUp(e) {
    e.preventDefault();
  }
  handleBlur(e) {
    const {
      value
    } = this.getStates();
    this._adapter.toggleFocusing(false);
    this._adapter.notifyBlur(value, e);
  }
  handleFocus(e) {
    const {
      value
    } = this.getStates();
    this._adapter.toggleFocusing(true);
    // this.checkAllowClear(this.getState('value'), true);
    this._adapter.notifyFocus(value, e);
  }
  handleInput(e) {
    this._adapter.notifyInput(e);
  }
  handleKeyDown(e) {
    this._adapter.notifyKeyDown(e);
  }
  handleKeyUp(e) {
    this._adapter.notifyKeyUp(e);
  }
  handleKeyPress(e) {
    this._adapter.notifyKeyPress(e);
    if (e.key === ENTER_KEY) {
      this._adapter.notifyEnterPress(e);
    }
  }
  isAllowClear() {
    const {
      value,
      isFocus,
      isHovering
    } = this._adapter.getStates();
    const {
      showClear,
      disabled,
      showClearIgnoreDisabled
    } = this._adapter.getProps();
    const allowClear = value && showClear && (!disabled || showClearIgnoreDisabled) && (isFocus || isHovering);
    return allowClear;
  }
  handleClickPrefixOrSuffix(e) {
    const {
      disabled
    } = this._adapter.getProps();
    const {
      isFocus
    } = this._adapter.getStates();
    if (!disabled && !isFocus) {
      this._adapter.focusInput();
      this._adapter.toggleFocusing(true);
    }
  }
  /**
   * Blocking mousedown events prevents input from losing focus
   * @param {Event} e
   */
  handlePreventMouseDown(e) {
    if (e && isFunction_default()(e.preventDefault)) {
      e.preventDefault();
    }
  }
  /**
   * A11y: simulate password button click
   */
  handleModeEnterPress(e) {
    // trigger by Enter or Space key
    if (['Enter', ' '].includes(e === null || e === void 0 ? void 0 : e.key)) {
      this.handlePreventMouseDown(e);
      this.handleClickEye(e);
    }
  }
}
/* harmony default export */ var input_foundation = (InputFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconClear.js


function IconClear_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM17.0352 16.8626C16.4597 17.4585 15.5101 17.4751 14.9142 16.8996L12.0368 14.121L9.25822 16.9984C8.68274 17.5943 7.73314 17.6109 7.13722 17.0354C6.5413 16.4599 6.52472 15.5103 7.1002 14.9144L9.87883 12.037L7.00147 9.2584C6.40555 8.68293 6.38897 7.73332 6.96445 7.1374C7.53992 6.54148 8.48953 6.52491 9.08545 7.10038L11.9628 9.87901L14.7414 7.00165C15.3169 6.40573 16.2665 6.38916 16.8624 6.96463C17.4584 7.54011 17.4749 8.48971 16.8995 9.08563L14.1208 11.963L16.9982 14.7416C17.5941 15.3171 17.6107 16.2667 17.0352 16.8626Z",
    fill: "currentColor"
  }));
}
const IconClear_IconComponent = (0,Icon/* convertIcon */.A)(IconClear_SvgComponent, 'clear');
/* harmony default export */ var IconClear = (IconClear_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconEyeClosedSolid.js


function IconEyeClosedSolid_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7071 3.70711C22.0976 3.31658 22.0976 2.68342 21.7071 2.29289C21.3166 1.90237 20.6834 1.90237 20.2929 2.29289L17.3135 5.27233C15.8114 4.50566 14.0321 4 12 4C5 4 1 10 1 12C1 13.1757 2.38219 15.7335 4.94345 17.6423L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L21.7071 3.70711ZM7.8284 14.7574L9.29237 13.2934C9.10495 12.9018 9 12.4631 9 12C9 10.3431 10.3431 9 12 9C12.4631 9 12.9018 9.10495 13.2934 9.29237L14.7574 7.8284C13.967 7.30488 13.0191 7 12 7C9.23858 7 7 9.23858 7 12C7 13.0191 7.30488 13.967 7.8284 14.7574Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 20C10.7789 20 9.64914 19.8174 8.61594 19.5054L11.1871 16.9342C11.4516 16.9775 11.7232 17 12 17C14.7614 17 17 14.7614 17 12C17 11.7232 16.9775 11.4516 16.9342 11.1871L20.5032 7.61808C22.1342 9.27317 23 11.0695 23 12C23 14 19 20 12 20Z",
    fill: "currentColor"
  }));
}
const IconEyeClosedSolid_IconComponent = (0,Icon/* convertIcon */.A)(IconEyeClosedSolid_SvgComponent, 'eye_closed_solid');
/* harmony default export */ var IconEyeClosedSolid = (IconEyeClosedSolid_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconEyeOpened.js


function IconEyeOpened_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C5 4 1 10 1 12C1 14 5 20 12 20C19 20 23 14 23 12C23 10 19 4 12 4ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "currentColor"
  }));
}
const IconEyeOpened_IconComponent = (0,Icon/* convertIcon */.A)(IconEyeOpened_SvgComponent, 'eye_opened');
/* harmony default export */ var IconEyeOpened = (IconEyeOpened_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/input/index.js




var input_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/input/input.css';

const input_prefixCls = input_constants_cssClasses.PREFIX;
const sizeSet = input_constants_strings.SIZE;
const statusSet = input_constants_strings.STATUS;
const modeSet = input_constants_strings.MODE;
class Input extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleClear = e => {
      this.foundation.handleClear(e);
    };
    this.handleClick = e => {
      this.foundation.handleClick(e);
    };
    this.handleMouseOver = e => {
      this.setState({
        isHovering: true
      });
    };
    this.handleMouseLeave = e => {
      this.setState({
        isHovering: false
      });
    };
    this.handleModeChange = mode => {
      this.foundation.handleModeChange(mode);
    };
    this.handleClickEye = e => {
      this.foundation.handleClickEye(e);
    };
    this.handleMouseDown = e => {
      this.foundation.handleMouseDown(e);
    };
    this.handleMouseUp = e => {
      this.foundation.handleMouseUp(e);
    };
    this.handleModeEnterPress = e => {
      this.foundation.handleModeEnterPress(e);
    };
    this.handleClickPrefixOrSuffix = e => {
      this.foundation.handleClickPrefixOrSuffix(e);
    };
    this.handlePreventMouseDown = e => {
      this.foundation.handlePreventMouseDown(e);
    };
    const initValue = 'value' in props ? props.value : props.defaultValue;
    this.state = {
      value: initValue,
      cachedValue: props.value,
      disabled: false,
      props: {},
      isFocus: false,
      isHovering: false,
      eyeClosed: props.mode === 'password',
      minLength: props.minLength
    };
    this.inputRef = /*#__PURE__*/react.createRef();
    this.prefixRef = /*#__PURE__*/react.createRef();
    this.suffixRef = /*#__PURE__*/react.createRef();
    this.foundation = new input_foundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setValue: value => this.setState({
        value
      }),
      setEyeClosed: value => this.setState({
        eyeClosed: value
      }),
      toggleFocusing: isFocus => {
        this.setState({
          isFocus
        });
      },
      focusInput: () => {
        const {
          preventScroll
        } = this.props;
        const input = this.inputRef && this.inputRef.current;
        input && input.focus({
          preventScroll
        });
      },
      toggleHovering: isHovering => this.setState({
        isHovering
      }),
      getIfFocusing: () => this.state.isFocus,
      notifyChange: (cbValue, e) => this.props.onChange(cbValue, e),
      notifyBlur: (val, e) => this.props.onBlur(e),
      notifyFocus: (val, e) => this.props.onFocus(e),
      notifyInput: e => this.props.onInput(e),
      notifyKeyPress: e => this.props.onKeyPress(e),
      notifyKeyDown: e => this.props.onKeyDown(e),
      notifyKeyUp: e => this.props.onKeyUp(e),
      notifyEnterPress: e => this.props.onEnterPress(e),
      notifyClear: e => this.props.onClear(e),
      setMinLength: minLength => this.setState({
        minLength
      }),
      isEventTarget: e => e && e.target === e.currentTarget
    });
  }
  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    if (props.value !== state.cachedValue) {
      willUpdateStates.value = props.value;
      willUpdateStates.cachedValue = props.value;
    }
    return willUpdateStates;
  }
  componentDidUpdate(prevProps) {
    const {
      mode
    } = this.props;
    if (prevProps.mode !== mode) {
      this.handleModeChange(mode);
    }
  }
  componentDidMount() {
    // autofocus is changed from the original support of input to the support of manually calling the focus method,
    // so that preventScroll can still take effect under the setting of autofocus
    const {
      disabled,
      autoFocus,
      preventScroll
    } = this.props;
    if (!disabled && (autoFocus || this.props['autofocus'])) {
      this.inputRef.current.focus({
        preventScroll
      });
    }
  }
  renderPrepend() {
    const {
      addonBefore
    } = this.props;
    if (addonBefore) {
      const prefixWrapperCls = classnames_default()({
        [`${input_prefixCls}-prepend`]: true,
        [`${input_prefixCls}-prepend-text`]: addonBefore && isString_default()(addonBefore),
        [`${input_prefixCls}-prepend-icon`]: isSemiIcon(addonBefore)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: prefixWrapperCls,
        "x-semi-prop": "addonBefore"
      }, addonBefore);
    }
    return null;
  }
  renderAppend() {
    const {
      addonAfter
    } = this.props;
    if (addonAfter) {
      const prefixWrapperCls = classnames_default()({
        [`${input_prefixCls}-append`]: true,
        [`${input_prefixCls}-append-text`]: addonAfter && isString_default()(addonAfter),
        [`${input_prefixCls}-append-icon`]: isSemiIcon(addonAfter)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: prefixWrapperCls,
        "x-semi-prop": "addonAfter"
      }, addonAfter);
    }
    return null;
  }
  renderClearBtn() {
    const clearCls = classnames_default()(`${input_prefixCls}-clearbtn`);
    const {
      clearIcon
    } = this.props;
    const allowClear = this.foundation.isAllowClear();
    // use onMouseDown to fix issue 1203
    if (allowClear) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        react.createElement("div", {
          className: clearCls,
          onMouseDown: this.handleClear
        }, clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, null))
      );
    }
    return null;
  }
  renderModeBtn() {
    const {
      eyeClosed
    } = this.state;
    const {
      mode,
      disabled
    } = this.props;
    const modeCls = classnames_default()(`${input_prefixCls}-modebtn`);
    const modeIcon = eyeClosed ? /*#__PURE__*/react.createElement(IconEyeClosedSolid, null) : /*#__PURE__*/react.createElement(IconEyeOpened, null);
    // alway show password button for a11y
    const showModeBtn = mode === 'password' && !disabled;
    const ariaLabel = eyeClosed ? 'Show password' : 'Hidden password';
    if (showModeBtn) {
      return /*#__PURE__*/react.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel,
        className: modeCls,
        onClick: this.handleClickEye,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onKeyPress: this.handleModeEnterPress
      }, modeIcon);
    }
    return null;
  }
  renderPrefix() {
    const {
      prefix,
      insetLabel,
      insetLabelId
    } = this.props;
    const labelNode = prefix || insetLabel;
    if (!labelNode) {
      return null;
    }
    const prefixWrapperCls = classnames_default()({
      [`${input_prefixCls}-prefix`]: true,
      [`${input_prefixCls}-inset-label`]: insetLabel,
      [`${input_prefixCls}-prefix-text`]: labelNode && isString_default()(labelNode),
      [`${input_prefixCls}-prefix-icon`]: isSemiIcon(labelNode)
    });
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      react.createElement("div", {
        className: prefixWrapperCls,
        onMouseDown: this.handlePreventMouseDown,
        onClick: this.handleClickPrefixOrSuffix,
        id: insetLabelId,
        "x-semi-prop": "prefix,insetLabel"
      }, labelNode)
    );
  }
  renderSuffix(suffixAllowClear) {
    const {
      suffix,
      hideSuffix
    } = this.props;
    if (!suffix) {
      return null;
    }
    const suffixWrapperCls = classnames_default()({
      [`${input_prefixCls}-suffix`]: true,
      [`${input_prefixCls}-suffix-text`]: suffix && isString_default()(suffix),
      [`${input_prefixCls}-suffix-icon`]: isSemiIcon(suffix),
      [`${input_prefixCls}-suffix-hidden`]: suffixAllowClear && Boolean(hideSuffix)
    });
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      react.createElement("div", {
        className: suffixWrapperCls,
        onMouseDown: this.handlePreventMouseDown,
        onClick: this.handleClickPrefixOrSuffix,
        "x-semi-prop": "suffix"
      }, suffix)
    );
  }
  getInputRef() {
    const {
      forwardRef
    } = this.props;
    if (!isUndefined_default()(forwardRef)) {
      if (typeof forwardRef === 'function') {
        return node => {
          forwardRef(node);
          this.inputRef = {
            current: node
          };
        };
      } else if (Object.prototype.toString.call(forwardRef) === '[object Object]') {
        this.inputRef = forwardRef;
        return forwardRef;
      }
    }
    return this.inputRef;
  }
  render() {
    const _a = this.props,
      {
        addonAfter,
        addonBefore,
        autoFocus,
        clearIcon,
        className,
        disabled,
        defaultValue,
        placeholder,
        prefix,
        mode,
        insetLabel,
        insetLabelId,
        validateStatus,
        type,
        readonly,
        size,
        suffix,
        style,
        showClear,
        onEnterPress,
        onClear,
        hideSuffix,
        inputStyle,
        forwardRef,
        maxLength,
        getValueLength,
        preventScroll,
        borderless,
        showClearIgnoreDisabled,
        onlyBorder
      } = _a,
      rest = input_rest(_a, ["addonAfter", "addonBefore", "autoFocus", "clearIcon", "className", "disabled", "defaultValue", "placeholder", "prefix", "mode", "insetLabel", "insetLabelId", "validateStatus", "type", "readonly", "size", "suffix", "style", "showClear", "onEnterPress", "onClear", "hideSuffix", "inputStyle", "forwardRef", "maxLength", "getValueLength", "preventScroll", "borderless", "showClearIgnoreDisabled", "onlyBorder"]);
    const {
      value,
      isFocus,
      minLength: stateMinLength
    } = this.state;
    const suffixAllowClear = this.foundation.isAllowClear();
    const suffixIsIcon = isSemiIcon(suffix);
    const ref = this.getInputRef();
    const wrapperPrefix = `${input_prefixCls}-wrapper`;
    const wrapperCls = classnames_default()(wrapperPrefix, className, {
      [`${input_prefixCls}-wrapper__with-prefix`]: prefix || insetLabel,
      [`${input_prefixCls}-wrapper__with-suffix`]: suffix,
      [`${input_prefixCls}-wrapper__with-suffix-hidden`]: suffixAllowClear && Boolean(hideSuffix),
      [`${input_prefixCls}-wrapper__with-suffix-icon`]: suffixIsIcon,
      [`${input_prefixCls}-wrapper__with-append`]: addonBefore,
      [`${input_prefixCls}-wrapper__with-prepend`]: addonAfter,
      [`${input_prefixCls}-wrapper__with-append-only`]: addonBefore && !addonAfter,
      [`${input_prefixCls}-wrapper__with-prepend-only`]: !addonBefore && addonAfter,
      [`${wrapperPrefix}-readonly`]: readonly,
      [`${wrapperPrefix}-disabled`]: disabled,
      [`${wrapperPrefix}-warning`]: validateStatus === 'warning',
      [`${wrapperPrefix}-error`]: validateStatus === 'error',
      [`${wrapperPrefix}-focus`]: isFocus,
      [`${wrapperPrefix}-clearable`]: showClear,
      [`${wrapperPrefix}-modebtn`]: mode === 'password',
      [`${wrapperPrefix}-hidden`]: type === 'hidden',
      [`${wrapperPrefix}-${size}`]: size,
      [`${input_prefixCls}-borderless`]: borderless,
      [`${input_prefixCls}-only_border`]: onlyBorder !== undefined && onlyBorder !== null
    });
    const inputCls = classnames_default()(input_prefixCls, {
      [`${input_prefixCls}-${size}`]: size,
      [`${input_prefixCls}-disabled`]: disabled,
      [`${input_prefixCls}-sibling-clearbtn`]: this.foundation.isAllowClear(),
      [`${input_prefixCls}-sibling-modebtn`]: mode === 'password'
    });
    const inputValue = value === null || value === undefined ? '' : value;
    const inputProps = Object.assign(Object.assign({}, rest), {
      style: inputStyle,
      className: inputCls,
      disabled,
      readOnly: readonly,
      type: this.foundation.handleInputType(type),
      placeholder: placeholder,
      onInput: e => this.foundation.handleInput(e),
      onChange: e => this.foundation.handleChange(e.target.value, e),
      onFocus: e => this.foundation.handleFocus(e),
      onBlur: e => this.foundation.handleBlur(e),
      onKeyUp: e => this.foundation.handleKeyUp(e),
      onKeyDown: e => this.foundation.handleKeyDown(e),
      onKeyPress: e => this.foundation.handleKeyPress(e),
      value: inputValue
    });
    if (!isFunction_default()(getValueLength)) {
      inputProps.maxLength = maxLength;
    }
    if (stateMinLength) {
      inputProps.minLength = stateMinLength;
    }
    if (validateStatus === 'error') {
      inputProps['aria-invalid'] = 'true';
    }
    let wrapperStyle = Object.assign({}, style);
    if (onlyBorder !== undefined) {
      wrapperStyle = Object.assign({
        borderWidth: onlyBorder
      }, style);
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      react.createElement("div", {
        className: wrapperCls,
        style: wrapperStyle,
        onMouseEnter: e => this.handleMouseOver(e),
        onMouseLeave: e => this.handleMouseLeave(e),
        onClick: e => this.handleClick(e)
      }, this.renderPrepend(), this.renderPrefix(), /*#__PURE__*/react.createElement("input", Object.assign({}, inputProps, {
        ref: ref
      })), this.renderClearBtn(), this.renderSuffix(suffixAllowClear), this.renderModeBtn(), this.renderAppend())
    );
  }
}
Input.propTypes = {
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  addonBefore: (prop_types_default()).node,
  addonAfter: (prop_types_default()).node,
  clearIcon: (prop_types_default()).node,
  prefix: (prop_types_default()).node,
  suffix: (prop_types_default()).node,
  mode: prop_types_default().oneOf(modeSet),
  value: (prop_types_default()).any,
  defaultValue: (prop_types_default()).any,
  disabled: (prop_types_default()).bool,
  readonly: (prop_types_default()).bool,
  autoFocus: (prop_types_default()).bool,
  type: (prop_types_default()).string,
  showClear: (prop_types_default()).bool,
  hideSuffix: (prop_types_default()).bool,
  placeholder: (prop_types_default()).any,
  size: prop_types_default().oneOf(sizeSet),
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  validateStatus: prop_types_default().oneOf(statusSet),
  onClear: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onInput: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  onKeyUp: (prop_types_default()).func,
  onKeyPress: (prop_types_default()).func,
  onEnterPress: (prop_types_default()).func,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  inputStyle: (prop_types_default()).object,
  getValueLength: (prop_types_default()).func,
  preventScroll: (prop_types_default()).bool,
  borderless: (prop_types_default()).bool
};
Input.defaultProps = {
  addonBefore: '',
  addonAfter: '',
  prefix: '',
  suffix: '',
  readonly: false,
  type: 'text',
  showClear: false,
  hideSuffix: false,
  placeholder: '',
  size: 'default',
  className: '',
  onClear: (noop_default()),
  onChange: (noop_default()),
  onBlur: (noop_default()),
  onFocus: (noop_default()),
  onInput: (noop_default()),
  onKeyDown: (noop_default()),
  onKeyUp: (noop_default()),
  onKeyPress: (noop_default()),
  onEnterPress: (noop_default()),
  validateStatus: 'default',
  borderless: false
};
const ForwardInput = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/react.createElement(Input, Object.assign({}, props, {
  forwardRef: ref
})));
/* harmony default export */ var es_input = (ForwardInput);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/notification/notificationListFoundation.js

class NotificationListFoundation extends foundation {
  addNotice(opts) {
    // let notices = this._adapter.getNotices();
    const notices = this._adapter.getNotices();
    // opts = { ...opts, id };
    // if (opts.duration) {
    //     setTimeout(() => {
    //         this.removeNotice(opts.id);
    //     }, opts.duration * 1000);
    // }
    this._adapter.updateNotices([opts, ...notices]);
    // return id;
  }

  has(id) {
    return this._adapter.getNotices().some(notice => notice.id === id);
  }
  update(id, noticeOpts) {
    let notices = this._adapter.getNotices();
    notices = notices.map(notice => notice.id === id ? Object.assign(Object.assign({}, notice), noticeOpts) : notice);
    const updatedItems = notices.filter(notice => notice.id === id);
    this._adapter.updateNotices(notices, [], updatedItems);
  }
  removeNotice(id) {
    let notices = this._adapter.getNotices();
    // let notices = this._adapter.getNotices();
    const removedItems = [];
    notices = notices.filter(notice => {
      if (notice.id === id) {
        removedItems.push(notice);
        return false;
      }
      return true;
    });
    this._adapter.updateNotices(notices, removedItems); // This must be updated at the same time https://github.com/facebook/react/issues/12312
  }

  destroyAll() {
    const notices = this._adapter.getNotices();
    if (notices.length > 0) {
      this._adapter.updateNotices([], notices);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/notification/constants.js

const notification_constants_cssClasses = {
  WRAPPER: `${BASE_CLASS_PREFIX}-notification-wrapper`,
  LIST: `${BASE_CLASS_PREFIX}-notification-list`,
  NOTICE: `${BASE_CLASS_PREFIX}-notification-notice`
};
const notification_constants_strings = {
  types: ['warning', 'success', 'info', 'error', 'default'],
  themes: ['normal', 'light'],
  directions: ['ltr', 'rtl']
};
const notification_constants_numbers = {
  duration: 3 // default close time, unit: s
};


;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/notification/notificationFoundation.js


class NotificationFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, NotificationFoundation.defaultAdapter), adapter));
    this._timer = null;
    this._id = null; // cache id
  }

  init() {
    this._startCloseTimer();
    this._id = this.getProp('id');
  }
  destroy() {
    this._clearCloseTimer();
  }
  _startCloseTimer() {
    // unit: s
    const duration = this.getProp('duration');
    if (duration && isNumber_default()(duration)) {
      this._timer = setTimeout(() => {
        this.close(); // call parent to remove itself
      }, duration * 1000);
    }
  }
  close(e) {
    if (e) {
      e.stopPropagation();
    }
    this._adapter.notifyWrapperToRemove(this._id);
    this._adapter.notifyClose();
  }
  _clearCloseTimer() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  restartCloseTimer() {
    this._clearCloseTimer();
    this._startCloseTimer();
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconAlertTriangle.js


function IconAlertTriangle_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2268 2.3986L1.52616 19.0749C0.831449 20.4064 1.79747 22 3.29933 22H20.7007C22.2025 22 23.1686 20.4064 22.4739 19.0749L13.7732 2.3986C13.0254 0.965441 10.9746 0.965442 10.2268 2.3986ZM13.1415 14.0101C13.0603 14.5781 12.5739 15 12.0001 15C11.4263 15 10.9398 14.5781 10.8586 14.0101L10.2829 9.97992C10.1336 8.93495 10.9445 8.00002 12.0001 8.00002C13.0556 8.00002 13.8665 8.93495 13.7172 9.97992L13.1415 14.0101ZM13.5001 18.5C13.5001 19.3284 12.8285 20 12.0001 20C11.1716 20 10.5001 19.3284 10.5001 18.5C10.5001 17.6716 11.1716 17 12.0001 17C12.8285 17 13.5001 17.6716 13.5001 18.5Z",
    fill: "currentColor"
  }));
}
const IconAlertTriangle_IconComponent = (0,Icon/* convertIcon */.A)(IconAlertTriangle_SvgComponent, 'alert_triangle');
/* harmony default export */ var IconAlertTriangle = (IconAlertTriangle_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconTickCircle.js


function IconTickCircle_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM17.8831 9.82235L11.6854 17.4112C11.4029 17.7806 10.965 17.9981 10.5 18C10.035 18.0019 9.59533 17.788 9.30982 17.421L5.81604 13.4209C5.30744 12.767 5.42524 11.8246 6.07916 11.316C6.73308 10.8074 7.67549 10.9252 8.1841 11.5791L10.4838 14.0439L15.5 8C16.0032 7.34193 16.9446 7.21641 17.6027 7.71964C18.2608 8.22287 18.3863 9.16428 17.8831 9.82235Z",
    fill: "currentColor"
  }));
}
const IconTickCircle_IconComponent = (0,Icon/* convertIcon */.A)(IconTickCircle_SvgComponent, 'tick_circle');
/* harmony default export */ var IconTickCircle = (IconTickCircle_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconInfoCircle.js


function IconInfoCircle_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7ZM9 10.75C9 10.3358 9.33579 10 9.75 10H12.5C13.0523 10 13.5 10.4477 13.5 11V16.5H14.25C14.6642 16.5 15 16.8358 15 17.25C15 17.6642 14.6642 18 14.25 18H9.75C9.33579 18 9 17.6642 9 17.25C9 16.8358 9.33579 16.5 9.75 16.5H10.5V11.5H9.75C9.33579 11.5 9 11.1642 9 10.75Z",
    fill: "currentColor"
  }));
}
const IconInfoCircle_IconComponent = (0,Icon/* convertIcon */.A)(IconInfoCircle_SvgComponent, 'info_circle');
/* harmony default export */ var IconInfoCircle = (IconInfoCircle_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconAlertCircle.js


function IconAlertCircle_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19C12.8284 19 13.5 18.3284 13.5 17.5ZM12 5C10.9138 5 10.0507 5.91244 10.1109 6.99692L10.4168 12.5023C10.4635 13.3426 11.1584 14 12 14C12.8416 14 13.5365 13.3426 13.5832 12.5023L13.8891 6.99692C13.9493 5.91244 13.0862 5 12 5Z",
    fill: "currentColor"
  }));
}
const IconAlertCircle_IconComponent = (0,Icon/* convertIcon */.A)(IconAlertCircle_SvgComponent, 'alert_circle');
/* harmony default export */ var IconAlertCircle = (IconAlertCircle_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconClose.js


function IconClose_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M17.6568 19.7782C18.2426 20.3639 19.1924 20.3639 19.7782 19.7782C20.3639 19.1924 20.3639 18.2426 19.7782 17.6568L14.1213 12L19.7782 6.34313C20.3639 5.75734 20.3639 4.8076 19.7782 4.22181C19.1924 3.63602 18.2426 3.63602 17.6568 4.22181L12 9.87866L6.34313 4.22181C5.75734 3.63602 4.8076 3.63602 4.22181 4.22181C3.63602 4.8076 3.63602 5.75734 4.22181 6.34313L9.87866 12L4.22181 17.6568C3.63602 18.2426 3.63602 19.1924 4.22181 19.7782C4.8076 20.3639 5.75734 20.3639 6.34313 19.7782L12 14.1213L17.6568 19.7782Z",
    fill: "currentColor"
  }));
}
const IconClose_IconComponent = (0,Icon/* convertIcon */.A)(IconClose_SvgComponent, 'close');
/* harmony default export */ var IconClose = (IconClose_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/notification/notice.js

var notice_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const notice_prefixCls = notification_constants_cssClasses.NOTICE;
const {
  duration
} = notification_constants_numbers;
const {
  types,
  themes,
  directions
} = notification_constants_strings;
class Notice extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      notifyWrapperToRemove: id => {
        this.props.close(id);
      },
      notifyClose: () => {
        this.props.onClose();
        this.props.onHookClose && this.props.onHookClose();
      }
    });
  }
  constructor(props) {
    super(props);
    this.clearCloseTimer = () => {
      this.foundation._clearCloseTimer();
    };
    this.startCloseTimer = () => {
      this.foundation._startCloseTimer();
    };
    this.close = e => {
      this.props.onCloseClick(this.props.id);
      this.foundation.close(e);
    };
    this.notifyClick = e => {
      this.props.onClick(e);
    };
    this.state = {
      visible: true
    };
    this.foundation = new NotificationFoundation(this.adapter);
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  renderTypeIcon() {
    const {
      type,
      icon
    } = this.props;
    const iconMap = {
      warning: /*#__PURE__*/react.createElement(IconAlertTriangle, {
        size: "large"
      }),
      success: /*#__PURE__*/react.createElement(IconTickCircle, {
        size: "large"
      }),
      info: /*#__PURE__*/react.createElement(IconInfoCircle, {
        size: "large"
      }),
      error: /*#__PURE__*/react.createElement(IconAlertCircle, {
        size: "large"
      })
    };
    let iconType = iconMap[type];
    const iconCls = classnames_default()({
      [`${notice_prefixCls}-icon`]: true,
      [`${notice_prefixCls}-${type}`]: true
    });
    if (icon) {
      iconType = icon;
    }
    if (iconType) {
      return /*#__PURE__*/react.createElement("div", {
        className: iconCls,
        "x-semi-prop": "icon"
      }, isSemiIcon(iconType) ? /*#__PURE__*/react.cloneElement(iconType, {
        size: iconType.props.size || 'large'
      }) : iconType);
    }
    return null;
  }
  render() {
    const direction = this.props.direction || this.context.direction;
    const defaultPosition = direction === 'rtl' ? 'topLeft' : 'topRight';
    const _a = this.props,
      {
        content,
        title,
        theme,
        position = defaultPosition,
        type,
        id,
        onCloseClick,
        className,
        showClose,
        style
      } = _a,
      attr = notice_rest(_a, ["content", "title", "theme", "position", "type", "id", "onCloseClick", "className", "showClose", "style"]);
    const {
      visible
    } = this.state;
    const wrapper = classnames_default()(notice_prefixCls, className, {
      [`${notice_prefixCls}-close`]: !visible,
      [`${notice_prefixCls}-icon-show`]: types.includes(type),
      [`${notice_prefixCls}-${type}`]: true,
      [`${notice_prefixCls}-${theme}`]: theme === 'light',
      [`${notice_prefixCls}-rtl`]: direction === 'rtl'
    });
    const titleID = getUuidShort({});
    return /*#__PURE__*/react.createElement("div", {
      className: wrapper,
      style: style,
      onMouseEnter: this.clearCloseTimer,
      onMouseLeave: this.startCloseTimer,
      onClick: this.notifyClick,
      "aria-labelledby": titleID,
      role: 'alert',
      onAnimationEnd: this.props.onAnimationEnd,
      onAnimationStart: this.props.onAnimationStart
    }, /*#__PURE__*/react.createElement("div", null, this.renderTypeIcon()), /*#__PURE__*/react.createElement("div", {
      className: `${notice_prefixCls}-inner`
    }, /*#__PURE__*/react.createElement("div", {
      className: `${notice_prefixCls}-content-wrapper`
    }, title ? /*#__PURE__*/react.createElement("div", {
      id: titleID,
      className: `${notice_prefixCls}-title`,
      "x-semi-prop": "title"
    }, title) : '', content ? /*#__PURE__*/react.createElement("div", {
      className: `${notice_prefixCls}-content`,
      "x-semi-prop": "content"
    }, content) : ''), showClose && /*#__PURE__*/react.createElement(iconButton, {
      className: `${notice_prefixCls}-icon-close`,
      type: "tertiary",
      icon: /*#__PURE__*/react.createElement(IconClose, null),
      theme: "borderless",
      size: "small",
      onClick: this.close
    })));
  }
}
Notice.contextType = context;
Notice.propTypes = {
  duration: (prop_types_default()).number,
  id: (prop_types_default()).string,
  title: (prop_types_default()).node,
  content: (prop_types_default()).node,
  type: prop_types_default().oneOf(types),
  theme: prop_types_default().oneOf(themes),
  icon: (prop_types_default()).node,
  onClick: (prop_types_default()).func,
  onClose: (prop_types_default()).func,
  onCloseClick: (prop_types_default()).func,
  showClose: (prop_types_default()).bool,
  // private props
  close: (prop_types_default()).func,
  direction: prop_types_default().oneOf(directions)
};
Notice.__SemiComponentName__ = "Notification";
Notice.defaultProps = getDefaultPropsFromGlobalConfig(Notice.__SemiComponentName__, {
  duration,
  id: '',
  close: (noop_default()),
  onClose: (noop_default()),
  onClick: (noop_default()),
  onCloseClick: (noop_default()),
  content: '',
  title: '',
  showClose: true,
  theme: 'normal'
});
/* harmony default export */ var notification_notice = (Notice);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/notification/useNotification/HookNotice.js
var HookNotice_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


const HookNotice = (_a, ref) => {
  var {
      afterClose
    } = _a,
    config = HookNotice_rest(_a, ["afterClose"]);
  const [visible, setVisible] = (0,react.useState)(true);
  const close = () => {
    setVisible(false);
  };
  react.useImperativeHandle(ref, () => ({
    close: () => {
      setVisible(false);
    }
  }));
  (0,react.useEffect)(() => {
    if (!visible) {
      afterClose(String(config.id));
    }
  }, [visible]);
  return visible ? /*#__PURE__*/react.createElement(notification_notice, Object.assign({}, config, {
    onHookClose: close
  })) : null;
};
/* harmony default export */ var useNotification_HookNotice = (/*#__PURE__*/react.forwardRef(HookNotice));
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/notification/useNotification/index.js




// import '@douyinfe/semi-foundation/lib/es/notification/notification.css';

// TODO: Automatic folding + unfolding function when there are more than N
const defaultConfig = {
  duration: 3,
  position: 'topRight',
  motion: true,
  content: '',
  title: '',
  zIndex: 1010
};
function usePatchElement() {
  const [elements, setElements] = (0,react.useState)([]);
  function patchElement(element, config) {
    setElements(originElements => [{
      element,
      config
    }, ...originElements]);
    return id => {
      setElements(originElements => originElements.filter(_ref => {
        let {
          config: configOfCurrentElement
        } = _ref;
        return configOfCurrentElement.id !== id;
      }));
    };
  }
  function renderList() {
    const noticesInPosition = {
      top: [],
      topLeft: [],
      topRight: [],
      bottom: [],
      bottomLeft: [],
      bottomRight: []
    };
    elements.forEach(_ref2 => {
      let {
        element,
        config
      } = _ref2;
      const {
        position
      } = config;
      noticesInPosition[position].push(element);
    });
    return Object.entries(noticesInPosition).map(obj => {
      const pos = obj[0];
      const notices = obj[1];
      // @ts-ignore
      // eslint-disable-next-line react/no-unknown-property
      return Array.isArray(notices) && notices.length ? /*#__PURE__*/react.createElement("div", {
        key: pos,
        className: classnames_default()(notification_constants_cssClasses.LIST),
        placement: pos
      }, notices) : null;
    });
  }
  return [renderList(), patchElement];
}
function useNotification() {
  const [elements, patchElement] = usePatchElement();
  const noticeRef = new Map();
  const addNotice = config => {
    const id = getUuid('semi_notice_');
    const mergeConfig = Object.assign(Object.assign({}, config), {
      id
    });
    let closeFunc;
    const ref = ele => {
      noticeRef.set(id, ele);
    };
    const notice = /*#__PURE__*/react.createElement(useNotification_HookNotice, Object.assign({
      key: id
    }, mergeConfig, {
      afterClose: instanceID => closeFunc(instanceID),
      ref: ref
    }));
    closeFunc = patchElement(notice, Object.assign({}, mergeConfig));
    return id;
  };
  const removeElement = instanceID => {
    const ele = noticeRef.get(instanceID);
    ele && ele.close();
  };
  return [{
    success: config => addNotice(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), {
      type: 'success'
    })),
    info: config => addNotice(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), {
      type: 'info'
    })),
    error: config => addNotice(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), {
      type: 'error'
    })),
    warning: config => addNotice(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), {
      type: 'warning'
    })),
    open: config => addNotice(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), {
      type: 'default'
    })),
    close: removeElement
  }, /*#__PURE__*/react.createElement(react.Fragment, null, elements)];
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/notification/index.js









// import '@douyinfe/semi-foundation/lib/es/notification/notification.css';



let ref = null;
const notification_defaultConfig = {
  duration: 3,
  position: 'topRight',
  motion: true,
  content: '',
  title: '',
  zIndex: 1010
};
class NotificationList extends BaseComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.add = noticeOpts => this.foundation.addNotice(noticeOpts);
    this.has = id => this.foundation.has(id);
    this.remove = id => {
      this.foundation.removeNotice(String(id));
    };
    this.update = (id, opts) => {
      return this.foundation.update(id, opts);
    };
    this.destroyAll = () => this.foundation.destroyAll();
    this.renderNoticeInPosition = function (notices, position) {
      let removedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      let updatedItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      const className = classnames_default()(notification_constants_cssClasses.LIST);
      // TODO notifyOnClose
      if (notices.length) {
        const style = _this.setPosInStyle(notices[0]);
        return (
          /*#__PURE__*/
          // @ts-ignore
          react.createElement("div", {
            placement: position,
            key: position,
            className: className,
            style: style
          }, notices.map((notice, index) => {
            const isRemoved = removedItems.find(removedItem => removedItem.id === notice.id) !== undefined;
            return /*#__PURE__*/react.createElement(_cssAnimation, {
              key: notice.id,
              animationState: isRemoved ? "leave" : "enter",
              startClassName: `${notification_constants_cssClasses.NOTICE}-animation-${isRemoved ? "hide" : "show"}_${position}`
            }, _ref => {
              let {
                animationClassName,
                animationEventsNeedBind,
                isAnimating
              } = _ref;
              return isRemoved && !isAnimating ? null : /*#__PURE__*/react.createElement(notification_notice, Object.assign({}, notice, {
                ref: notice => {
                  if (notice && updatedItems.some(item => item.id === notice.props.id)) {
                    notice.foundation.restartCloseTimer();
                  }
                },
                className: classnames_default()({
                  [notice.className]: Boolean(notice.className),
                  [animationClassName]: true
                })
              }, animationEventsNeedBind, {
                style: Object.assign({}, notice.style),
                close: _this.remove
              }));
            });
          }))
        );
      }
      return null;
    };
    this.state = {
      notices: [],
      removedItems: [],
      updatedItems: []
    };
    this.noticeStorage = [];
    this.removeItemStorage = [];
    this.foundation = new NotificationListFoundation(this.adapter);
  }
  get adapter() {
    var _this2 = this;
    return Object.assign(Object.assign({}, super.adapter), {
      updateNotices: function (notices) {
        let removedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let updatedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        _this2.noticeStorage = [...notices];
        _this2.removeItemStorage = [...removedItems];
        // setState is async sometimes and react often merges state, so use "this" , make sure other code always get right data.
        _this2.setState({
          notices,
          removedItems,
          updatedItems
        });
      },
      getNotices: () => this.noticeStorage
    });
  }
  static addNotice(notice) {
    var _a;
    notice = Object.assign(Object.assign({}, notification_defaultConfig), notice);
    const id = (_a = notice.id) !== null && _a !== void 0 ? _a : getUuid('notification');
    if (!ref) {
      const {
        getPopupContainer
      } = notice;
      const div = document.createElement('div');
      if (!this.wrapperId) {
        this.wrapperId = getUuid('notification-wrapper').slice(0, 32);
      }
      div.className = notification_constants_cssClasses.WRAPPER;
      div.id = this.wrapperId;
      div.style.zIndex = String(typeof notice.zIndex === 'number' ? notice.zIndex : notification_defaultConfig.zIndex);
      if (getPopupContainer) {
        const container = getPopupContainer();
        container.appendChild(div);
      } else {
        document.body.appendChild(div);
      }
      react_dom.render( /*#__PURE__*/react.createElement(NotificationList, {
        ref: instance => ref = instance
      }), div, () => {
        ref.add(Object.assign(Object.assign({}, notice), {
          id
        }));
      });
    } else {
      if (ref.has(`${id}`)) {
        ref.update(id, notice);
      } else {
        ref.add(Object.assign(Object.assign({}, notice), {
          id
        }));
      }
    }
    return id;
  }
  static removeNotice(id) {
    if (ref) {
      ref.remove(id);
    }
    return id;
  }
  static info(opts) {
    return this.addNotice(Object.assign(Object.assign({}, opts), {
      type: 'info'
    }));
  }
  static success(opts) {
    return this.addNotice(Object.assign(Object.assign({}, opts), {
      type: 'success'
    }));
  }
  static error(opts) {
    return this.addNotice(Object.assign(Object.assign({}, opts), {
      type: 'error'
    }));
  }
  static warning(opts) {
    return this.addNotice(Object.assign(Object.assign({}, opts), {
      type: 'warning'
    }));
  }
  static open(opts) {
    return this.addNotice(Object.assign(Object.assign({}, opts), {
      type: 'default'
    }));
  }
  static close(id) {
    return this.removeNotice(id);
  }
  static destroyAll() {
    if (ref) {
      ref.destroyAll();
      const wrapper = document.querySelector(`#${this.wrapperId}`);
      react_dom.unmountComponentAtNode(wrapper);
      wrapper && wrapper.parentNode.removeChild(wrapper);
      ref = null;
      this.wrapperId = null;
    }
  }
  static config(opts) {
    ['top', 'left', 'bottom', 'right'].map(pos => {
      if (pos in opts) {
        notification_defaultConfig[pos] = opts[pos];
      }
    });
    if (typeof opts.zIndex === 'number') {
      notification_defaultConfig.zIndex = opts.zIndex;
    }
    if (typeof opts.duration === 'number') {
      notification_defaultConfig.duration = opts.duration;
    }
    if (typeof opts.position === 'string') {
      notification_defaultConfig.position = opts.position;
    }
  }
  setPosInStyle(noticeInstance) {
    const style = {};
    ['top', 'left', 'bottom', 'right'].forEach(pos => {
      if (pos in noticeInstance) {
        const val = noticeInstance[pos];
        style[pos] = typeof val === 'number' ? `${val}px` : val;
      }
    });
    return style;
  }
  render() {
    let {
      notices
    } = this.state;
    const {
      removedItems,
      updatedItems
    } = this.state;
    notices = Array.from(new Set([...notices, ...removedItems]));
    const noticesInPosition = {
      top: [],
      topLeft: [],
      topRight: [],
      bottom: [],
      bottomLeft: [],
      bottomRight: []
    };
    notices.forEach(notice => {
      const direction = notice.direction || this.context.direction;
      const defaultPosition = direction === 'rtl' ? 'topLeft' : 'topRight';
      const position = notice.position || defaultPosition;
      noticesInPosition[position].push(notice);
    });
    const noticesList = Object.entries(noticesInPosition).map(obj => {
      const pos = obj[0];
      const noticesInPos = obj[1];
      return this.renderNoticeInPosition(noticesInPos, pos, removedItems, updatedItems);
    });
    return /*#__PURE__*/react.createElement(react.Fragment, null, noticesList);
  }
}
NotificationList.contextType = context;
NotificationList.propTypes = {
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  direction: prop_types_default().oneOf(notification_constants_strings.directions)
};
NotificationList.defaultProps = {};
NotificationList.useNotification = useNotification;
/* harmony default export */ var notification = (NotificationList);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function memoize_one_esm_isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!memoize_one_esm_isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

;// CONCATENATED MODULE: ./node_modules/react-window/dist/index.esm.js







// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex,
      data = _ref.data,
      rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (false) {}

function createGridComponent(_ref2) {
  var _class;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized(_this));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoize_one_esm(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoize_one_esm(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);

          var isRtl = direction === 'rtl';
          itemStyleCache[key] = style = {
            position: 'absolute',
            left: isRtl ? undefined : _offset,
            right: isRtl ? _offset : undefined,
            top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
            height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
            width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoize_one_esm(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
          // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
          // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
          // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            switch (getRTLOffsetType()) {
              case 'negative':
                calculatedScrollLeft = -scrollLeft;
                break;

              case 'positive-descending':
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          switch (getRTLOffsetType()) {
            case 'negative':
              outerRef.scrollLeft = -scrollLeft;
              break;

            case 'positive-ascending':
              outerRef.scrollLeft = scrollLeft;
              break;

            default:
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push((0,react.createElement)(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return (0,react.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(react.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _class;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (false) {}
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        // Because we only take into account the scrollbar size when calculating minOffset
        // this value can be larger than maxOffset when at the end of the list
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (false) {}
  }
});

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (false) {}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoize_one_esm(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoize_one_esm(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoize_one_esm(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var _this$props2 = this.props,
          itemCount = _this$props2.itemCount,
          layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.
      // This is an edge case for lists; normally they only scroll in the dominant direction.

      var scrollbarSize = 0;

      if (this._outerRef) {
        var outerRef = this._outerRef;

        if (layout === 'vertical') {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }

      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          initialScrollOffset = _this$props3.initialScrollOffset,
          layout = _this$props3.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props,
          direction = _this$props4.direction,
          layout = _this$props4.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          direction = _this$props5.direction,
          height = _this$props5.height,
          innerRef = _this$props5.innerRef,
          innerElementType = _this$props5.innerElementType,
          innerTagName = _this$props5.innerTagName,
          itemCount = _this$props5.itemCount,
          itemData = _this$props5.itemData,
          _this$props5$itemKey = _this$props5.itemKey,
          itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey,
          layout = _this$props5.layout,
          outerElementType = _this$props5.outerElementType,
          outerTagName = _this$props5.outerTagName,
          style = _this$props5.style,
          useIsScrolling = _this$props5.useIsScrolling,
          width = _this$props5.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push((0,react.createElement)(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return (0,react.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props,
          itemCount = _this$props6.itemCount,
          overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(react.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (false) { var isHorizontal; }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (false) {}
  }
});

var FixedSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(width / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(height / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (false) {}
  }
});

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (false) {}
  }
});

// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }

  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }

  return false;
}

var _excluded = (/* unused pure expression or super */ null && (["style"])),
    _excluded2 = (/* unused pure expression or super */ null && (["style"]));
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo

function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style,
      prevRest = _objectWithoutPropertiesLoose(prevProps, _excluded);

  var nextStyle = nextProps.style,
      nextRest = _objectWithoutPropertiesLoose(nextProps, _excluded2);

  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate

function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/pagination/constants.js

const pagination_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-page`
};
const pagination_constants_strings = {};
const pagination_constants_numbers = {
  PAGE_SHOW_MAX: 7,
  REST_PAGE_SHOW_MAX: 5,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTION: [10, 20, 40, 100],
  REST_PAGE_MAX_SIZE: 1000000
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/pagination/foundation.js


class PaginationFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    const {
      currentPage,
      total,
      pageSize
    } = this.getStates();
    // If pageSize is set, pageSizeOpts does not work
    this._updateDisabled({
      currentPage,
      total,
      pageSize
    });
    this._updatePageList({
      currentPage,
      total,
      pageSize
    });
    this._registerEventHandler();
  }
  destroy() {
    this._unregisterEventHandler();
  }
  _registerEventHandler() {
    this._adapter.registerKeyDownHandler(this.handleKeyDown);
  }
  _unregisterEventHandler() {
    this._adapter.unregisterKeyDownHandler(this.handleKeyDown);
  }
  _updateDisabled(pageInfo) {
    const {
      currentPage,
      total,
      pageSize
    } = pageInfo;
    const totalPageNum = this._getTotalPageNumber(total, pageSize);
    let prevIsDisabled = false;
    let nextIsDisabled = false;
    if (currentPage === 1) {
      prevIsDisabled = true;
      nextIsDisabled = totalPageNum < 2;
    } else if (currentPage === totalPageNum) {
      prevIsDisabled = false;
      nextIsDisabled = true;
    }
    this._adapter.setDisabled(prevIsDisabled, nextIsDisabled);
  }
  goPage(targetPageIndex) {
    if (targetPageIndex === '...') {
      return;
    }
    const {
      pageSize,
      currentPage
    } = this.getStates();
    const isControlComponent = this._isInProps('currentPage');
    if (targetPageIndex === currentPage) {
      return;
    }
    if (!isControlComponent) {
      this.updatePage(targetPageIndex);
      this._adapter.notifyPageChange(targetPageIndex);
      this._adapter.notifyChange(targetPageIndex, pageSize);
    } else {
      this._adapter.notifyPageChange(targetPageIndex);
      this._adapter.notifyChange(targetPageIndex, pageSize);
    }
  }
  updatePage() {
    let targetPageIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    let total = arguments.length > 1 ? arguments[1] : undefined;
    let pageSize = arguments.length > 2 ? arguments[2] : undefined;
    // maybe undefined or null
    if (total === null || typeof total === 'undefined') {
      total = this.getState('total');
    }
    if (pageSize === null || typeof pageSize === 'undefined') {
      pageSize = this.getState('pageSize');
    }
    this._updateDisabled({
      currentPage: targetPageIndex,
      total,
      pageSize
    });
    this._updatePageList({
      currentPage: targetPageIndex,
      total,
      pageSize
    });
    this._adapter.updateTotal(total);
    this._adapter.setCurrentPage(targetPageIndex);
    this._adapter.updatePageSize(pageSize);
  }
  updateAllPageNumbers(total, pageSize) {
    // only need to update in small size
    const {
      size,
      hoverShowPageSelect,
      disabled
    } = this.getProps();
    if (size !== 'small' || !hoverShowPageSelect || disabled) {
      return;
    } else {
      const pageNumbers = Array.from({
        length: Math.ceil(total / pageSize)
      }, (v, i) => i + 1);
      this._adapter.updateAllPageNumbers(pageNumbers);
    }
  }
  goPrev() {
    const {
      currentPage
    } = this.getStates();
    if (currentPage > 1) {
      this.goPage(currentPage - 1);
    }
  }
  goNext() {
    const {
      currentPage,
      total,
      pageSize
    } = this.getStates();
    const totalPageNum = this._getTotalPageNumber(total, pageSize);
    if (currentPage <= totalPageNum - 1) {
      this.goPage(currentPage + 1);
    }
  }
  _updatePageList(pageListInfo) {
    const {
      currentPage,
      total,
      pageSize
    } = pageListInfo;
    let pageList = [];
    let restLeftPageList = []; // pages before ...
    let restRightPageList = []; // pages after ...
    /** Pager truncation logic (t is the total number of pages, c is the current page):
         - No need to truncate when t<=7 pages
         - When t>7
             - When c<4, the fourth is a truncation symbol (...)
             - When c=4, the sixth is the truncation symbol (...)
             - When 4<c<t-3, the second and sixth are truncation symbols (...)
             - When t-3<=c<=t, the second is the truncation symbol (...), followed by the 5th from the bottom-the 1st from the bottom
         Truncation character + number, the total number is 7
         分页器截断逻辑（t为总页数，c为当前页）：
        - t<=7 页的时候不需要截断
        - 当 t>7 时
            - 当 c<4 时，第4个为截断符号（...）
            - 当 c=4 时，第6个为截断符号（...）
            - 当 4<c<t-3 时，第2个与第6个为截断符号（...）
            - 当 t-3<=c<=t 时，第 2 个为截断符号（...），后面为倒数第5个-倒数第1个
        截断符+数字 总共个数为7个
    */
    const totalPageNum = this._getTotalPageNumber(total, pageSize);
    const {
      PAGE_SHOW_MAX,
      REST_PAGE_MAX_SIZE
    } = pagination_constants_numbers;
    if (totalPageNum <= PAGE_SHOW_MAX) {
      pageList = Array.from({
        length: totalPageNum
      }, (v, i) => i + 1);
      restLeftPageList = [];
      restRightPageList = [];
    } else {
      switch (true) {
        case currentPage < 4:
          pageList = [1, 2, 3, 4, '...', totalPageNum - 1, totalPageNum];
          // length: (totalPageNum - 1) - 4
          restRightPageList = Array.from({
            length: Math.min(totalPageNum - 6, REST_PAGE_MAX_SIZE)
          }, (v, i) => i + 5);
          restLeftPageList = [];
          break;
        case currentPage === 4:
          pageList = [1, 2, 3, 4, 5, '...', totalPageNum];
          restRightPageList = Array.from({
            length: Math.min(totalPageNum - 6, REST_PAGE_MAX_SIZE)
          }, (v, i) => i + 6);
          restLeftPageList = [];
          break;
        case 4 < currentPage && currentPage < totalPageNum - 3:
          const middle = Array.from({
            length: 3
          }, (v, i) => currentPage + (i - 1));
          pageList = [1].concat('...', middle, '...', totalPageNum);
          // length: total-(currentPage+1)-1
          restRightPageList = Array.from({
            length: Math.min(totalPageNum - currentPage - 2, REST_PAGE_MAX_SIZE)
          }, (v, i) => currentPage + i + 2);
          restLeftPageList = Array.from({
            length: Math.min(currentPage - 3, REST_PAGE_MAX_SIZE)
          }, (v, i) => i + 2);
          break;
        case currentPage - 3 <= currentPage && currentPage <= totalPageNum:
          const right = Array.from({
            length: 5
          }, (v, i) => totalPageNum - (4 - i));
          pageList = [1, '...'].concat(right);
          restRightPageList = [];
          restLeftPageList = Array.from({
            length: Math.min(right[0] - 2, REST_PAGE_MAX_SIZE)
          }, (v, i) => i + 2);
          break;
        default:
          break;
      }
    }
    this._adapter.setPageList({
      pageList,
      restLeftPageList,
      restRightPageList
    });
    // this._adapter.setRestLeftPageList(restLeftPageList);
    // this._adapter.setRestRightPageList(restRightPageList);
  }

  changePageSize(newPageSize) {
    const {
      pageSize
    } = this.getStates();
    this._adapter.updatePageSize(newPageSize);
    this._adapter.notifyPageSizeChange(newPageSize);
    const {
      total,
      currentPage
    } = this.getStates();
    // After converting the switching page capacity, which page is the current page
    const currentPageFirstItemIndex = (currentPage - 1) * pageSize + 1;
    const newCurrentPage = Math.ceil(currentPageFirstItemIndex / newPageSize);
    this.updatePage(newCurrentPage, total, newPageSize);
    if (currentPage !== newCurrentPage) {
      this._adapter.notifyPageChange(newCurrentPage);
    }
    this._adapter.notifyChange(newCurrentPage, newPageSize);
  }
  // TODO handle tab/enter events
  handleKeyDown() {}
  // If pageSize is not in the Opts array, insert it
  pageSizeInOpts() {
    const {
      pageSizeOpts
    } = this.getProps();
    const {
      pageSize
    } = this.getStates();
    const newPageSizeOpts = [...pageSizeOpts];
    if (newPageSizeOpts.indexOf(pageSize) === -1) {
      const firstLargerIndex = newPageSizeOpts.findIndex(el => el > pageSize);
      newPageSizeOpts.splice(firstLargerIndex, 0, pageSize);
    }
    return newPageSizeOpts;
  }
  handleQuickJumpNumberChange(targetPage) {
    this._adapter.updateQuickJumpPage(targetPage);
  }
  _handleQuickJump(quickJumpPage) {
    let page = Number(quickJumpPage);
    const {
      pageSize,
      total
    } = this.getStates();
    const totalPageNum = this._getTotalPageNumber(total, pageSize);
    if (Number.isNaN(page)) {
      return;
    }
    // If the user input is greater than totalPage
    if (page > totalPageNum) {
      page = totalPageNum;
    }
    if (page <= 0) {
      page = 1;
    }
    // clear inputnumber
    this._adapter.updateQuickJumpPage('');
    this.goPage(page);
  }
  handleQuickJumpBlur() {
    const {
      quickJumpPage
    } = this.getStates();
    // no need to operate when inputnumber blur & quickJumpPage is empty
    if (typeof quickJumpPage === 'string' && quickJumpPage || typeof quickJumpPage === 'number') {
      this._handleQuickJump(quickJumpPage);
    }
  }
  handleQuickJumpEnterPress(targetPage) {
    this._handleQuickJump(targetPage);
  }
  _getTotalPageNumber(total, pageSize) {
    const totalPageNum = Math.ceil(total / pageSize);
    return totalPageNum;
  }
}
/* harmony default export */ var pagination_foundation = (PaginationFoundation);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconChevronLeft.js
var IconChevronLeft = __webpack_require__(52689);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconChevronRight.js


function IconChevronRight_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43934 19.7957C6.85355 19.2099 6.85355 18.2601 7.43934 17.6744L13.0962 12.0175L7.43934 6.36065C6.85355 5.77486 6.85355 4.82511 7.43934 4.23933C8.02513 3.65354 8.97487 3.65354 9.56066 4.23933L16.2782 10.9568C16.864 11.5426 16.864 12.4924 16.2782 13.0782L9.56066 19.7957C8.97487 20.3815 8.02513 20.3815 7.43934 19.7957Z",
    fill: "currentColor"
  }));
}
const IconChevronRight_IconComponent = (0,Icon/* convertIcon */.A)(IconChevronRight_SvgComponent, 'chevron_right');
/* harmony default export */ var IconChevronRight = (IconChevronRight_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/base/constants.js

const VALIDATE_STATUS = ['default', 'error', 'warning', 'success'];
// const VALIDATE_STATUS = ['default', 'error', 'warning', 'success', 'validating'] as const;

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/select/constants.js


const select_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-select`,
  PREFIX_OPTION: `${BASE_CLASS_PREFIX}-select-option`,
  PREFIX_GROUP: `${BASE_CLASS_PREFIX}-select-group`
};
const select_constants_strings = {
  SIZE_SET: ['small', 'large', 'default'],
  POSITION_SET: tooltip_constants_strings.POSITION_SET,
  MODE_SELECT: 'select',
  MODE_AUTOCOMPLETE: 'autoComplete',
  // MODE_TAGS: 'tags',
  STATUS: VALIDATE_STATUS,
  SEARCH_POSITION_TRIGGER: 'trigger',
  SEARCH_POSITION_DROPDOWN: 'dropdown'
};
const select_constants_numbers = {
  LIST_HEIGHT: 270
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/select/foundation.js




var foundation_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







class SelectFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    // keyboard event listner
    this._keydownHandler = null;
  }
  init() {
    this._setDropdownWidth();
    const isDefaultOpen = this.getProp('defaultOpen');
    const isOpen = this.getProp('open');
    const originalOptions = this._collectOptions();
    this._setDefaultSelection(originalOptions);
    if (isDefaultOpen || isOpen) {
      this.open(undefined, originalOptions);
    }
    const autoFocus = this.getProp('autoFocus');
    if (autoFocus) {
      this.focus();
    }
  }
  focus() {
    const isFilterable = this._isFilterable();
    const isMultiple = this._isMultiple();
    this._adapter.updateFocusState(true);
    this._adapter.setIsFocusInContainer(false);
    if (isFilterable && isMultiple) {
      // when filter and multiple, only focus input
      this.focusInput();
    } else if (isFilterable && !isMultiple) {
      // when filter and not multiple, only show input and focus input
      this.toggle2SearchInput(true);
    } else {
      this._focusTrigger();
    }
  }
  _focusTrigger() {
    this._adapter.focusTrigger();
    // this.bindKeyBoardEvent();
  }

  destroy() {
    this._adapter.unregisterClickOutsideHandler();
    // this.unBindKeyBoardEvent();
  }

  _setDropdownWidth() {
    const {
      style,
      dropdownMatchSelectWidth
    } = this.getProps();
    let width;
    if (dropdownMatchSelectWidth) {
      if (style && isNumber_default()(style.width)) {
        width = style.width;
      } else if (style && isString_default()(style.width) && !style.width.includes('%')) {
        width = style.width;
      } else {
        width = this._adapter.getTriggerWidth();
      }
      this._adapter.setOptionWrapperWidth(width);
    }
  }
  _collectOptions() {
    const originalOptions = this._adapter.getOptionsFromChildren();
    this._adapter.updateOptions(originalOptions);
    // Reposition the drop-down layer
    this._adapter.rePositionDropdown();
    return originalOptions;
  }
  _setDefaultSelection(originalOptions) {
    let {
      value
    } = this.getProps();
    const {
      defaultValue
    } = this.getProps();
    if (this._isControlledComponent()) {
      // do nothing
    } else {
      value = defaultValue;
    }
    this._update(value, originalOptions);
  }
  // call when props.optionList change
  handleOptionListChange() {
    const newOptionList = this._collectOptions();
    const {
      selections
    } = this.getStates();
    this.updateOptionsActiveStatus(selections, newOptionList);
    // reset focusIndex
    const {
      defaultActiveFirstOption
    } = this.getProps();
    if (defaultActiveFirstOption) {
      this._adapter.updateFocusIndex(0);
    }
  }
  // In uncontrolled mode, when props.optionList change,
  // but already had defaultValue or choose some option
  handleOptionListChangeHadDefaultValue() {
    const selections = this.getState('selections');
    let value;
    const {
      onChangeWithObject
    } = this.getProps();
    const isMultiple = this._isMultiple();
    switch (true) {
      case isMultiple && Boolean(selections.size):
        try {
          value = [...selections].map(item =>
          // At this point item1 is directly the object
          onChangeWithObject ? item[1] : item[1].value);
        } catch (error) {
          value = [];
        }
        break;
      case isMultiple && !selections.size:
        value = [];
        break;
      case !isMultiple && Boolean(selections.size):
        try {
          value = onChangeWithObject ? [...selections][0][1] : [...selections][0][1].value;
        } catch (error) {}
        break;
      case !isMultiple && !selections.size:
        break;
      default:
        break;
    }
    const originalOptions = this._adapter.getOptionsFromChildren();
    this._update(value, originalOptions);
  }
  // call when props.value change
  handleValueChange(value) {
    const {
      allowCreate,
      autoClearSearchValue,
      remote
    } = this.getProps();
    const {
      inputValue
    } = this.getStates();
    let originalOptions;
    // AllowCreate and controlled mode, no need to re-collect optionList
    if (allowCreate && this._isControlledComponent()) {
      originalOptions = this.getState('options');
      originalOptions.forEach(item => item._show = true);
    } else {
      // originalOptions = this.getState('options');
      // The options in state cannot be used directly here,
      // because it is possible to update the optionList and props.value at the same time, and the options in state are still old at this time
      originalOptions = this._adapter.getOptionsFromChildren();
    }
    // Multi-selection, controlled mode, you need to reposition the drop-down menu after updating
    this._adapter.rePositionDropdown();
    if (this._isFilterable() && !autoClearSearchValue && inputValue && !remote) {
      originalOptions = this._filterOption(originalOptions, inputValue);
    }
    this._update(value, originalOptions);
  }
  // Update the selected item in the selection box
  _update(propValue, originalOptions) {
    let selections;
    if (!this._isMultiple()) {
      // Radio
      selections = this._updateSingle(propValue, originalOptions);
    } else {
      selections = this._updateMultiple(propValue, originalOptions);
      this.updateOverflowItemCount(selections.size);
    }
    // Update the text in the selection box
    this._adapter.updateSelection(selections);
    // Update the selected item in the drop-down box
    this.updateOptionsActiveStatus(selections, originalOptions);
  }
  // Optionally selected updates (when components are mounted, or after value changes)
  _updateSingle(propValue, originalOptions) {
    const selections = new Map();
    const {
      onChangeWithObject
    } = this.getProps();
    // When onChangeWithObject is true, the defaultValue or Value passed by the props should be the object, which corresponds to the result returned by onChange, so the value of the object needs to be taken as a judgment comparison
    const selectedValue = onChangeWithObject && typeof propValue !== 'undefined' ? propValue.value : propValue;
    const selectedOptions = originalOptions.filter(option => option.value === selectedValue);
    const noMatchOptionInList = !selectedOptions.length && typeof selectedValue !== 'undefined' && selectedValue !== null;
    // If the current value, there is a matching option in the optionList
    if (selectedOptions.length) {
      const selectedOption = selectedOptions[0];
      const optionExist = Object.assign({}, selectedOption);
      // if (onChangeWithObject) {
      //     OptionExist = {... propValue }; // value is the object with the'value 'Key
      // }
      selections.set(optionExist.label, optionExist);
    } else if (noMatchOptionInList) {
      // If the current value does not have a corresponding item in the optionList, construct an option and update it to the selection. However, it does not need to be inserted into the list
      let optionNotExist = {
        value: propValue,
        label: propValue,
        _notExist: true,
        _scrollIndex: -1
      };
      if (onChangeWithObject) {
        optionNotExist = Object.assign(Object.assign({}, propValue), {
          _notExist: true,
          _scrollIndex: -1
        });
      }
      selections.set(optionNotExist.label, optionNotExist);
    }
    return selections;
  }
  // Multi-selected option update (when the component is mounted, or after the value changes)
  _updateMultiple(propValue, originalOptions) {
    const nowSelections = this.getState('selections');
    let selectedOptionList = [];
    // Multiple selection is to determine whether it is an array to avoid the problem of defaultValue/value incoming string error
    const propValueIsArray = Array.isArray(propValue);
    this.checkMultipleProps();
    // If N values are currently selected, the corresponding option data is retrieved from the current selections for retrieval. Because these selected options may not exist in the new optionList
    if (nowSelections.size) {
      selectedOptionList = [...nowSelections].map(item => item[1]);
    }
    const selections = new Map();
    let selectedValues = propValue;
    const {
      onChangeWithObject
    } = this.getProps();
    // When onChangeWithObject is true
    if (onChangeWithObject && propValueIsArray) {
      selectedValues = propValue.map(item => item.value);
    }
    if (propValueIsArray && selectedValues.length) {
      selectedValues.forEach((selectedValue, i) => {
        // The current value exists in the current optionList
        const index = originalOptions.findIndex(option => option.value === selectedValue);
        if (index !== -1) {
          selections.set(originalOptions[index].label, originalOptions[index]);
        } else {
          // The current value exists in the optionList that has been selected before the change, and does not exist in the current optionList, then directly take the corresponding value from the selections, no need to construct a new option
          const indexInSelectedList = selectedOptionList.findIndex(option => option.value === selectedValue);
          if (indexInSelectedList !== -1) {
            const option = selectedOptionList[indexInSelectedList];
            if (onChangeWithObject) {
              // Although the value is the same and can be found in selections, it cannot ensure that other items remain unchanged. A comparison is made.
              // https://github.com/DouyinFE/semi-design/pull/2139
              const optionCompare = Object.assign({}, propValue[i]);
              if (isEqual_default()(optionCompare, option)) {
                selections.set(option.label, option);
              } else {
                selections.set(optionCompare.label, optionCompare);
              }
            } else {
              selections.set(option.label, option);
            }
          } else {
            // The current value does not exist in the current optionList or the list before the change. Construct an option and update it to the selection
            let optionNotExist = {
              value: selectedValue,
              label: selectedValue,
              _notExist: true
            };
            onChangeWithObject ? optionNotExist = Object.assign(Object.assign({}, propValue[i]), {
              _notExist: true
            }) : null;
            selections.set(optionNotExist.label, Object.assign(Object.assign({}, optionNotExist), {
              _scrollIndex: -1
            }));
          }
        }
      });
    }
    return selections;
  }
  _isMultiple() {
    return this.getProp('multiple');
  }
  _isDisabled() {
    return this.getProp('disabled');
  }
  _isFilterable() {
    return Boolean(this.getProp('filter')); // filter can be boolean or function
  }

  handleClick(e) {
    const {
      clickToHide
    } = this.getProps();
    const {
      isOpen
    } = this.getStates();
    const isDisabled = this._isDisabled();
    if (isDisabled) {
      return;
    } else if (!isOpen) {
      this.open();
      this._notifyFocus(e);
    } else if (isOpen && clickToHide) {
      this.close({
        event: e
      });
    } else if (isOpen && !clickToHide) {
      this.focusInput();
    }
  }
  open(acInput, originalOptions) {
    const isFilterable = this._isFilterable();
    const options = originalOptions || this.getState('options');
    // When searchable, when the drop-down box expands
    if (isFilterable) {
      // Also clears the options filter to show all candidates
      // Options created dynamically but not selected are also filtered out
      const sugInput = '';
      const newOptions = this._filterOption(options, sugInput).filter(item => !item._inputCreateOnly);
      this._adapter.updateOptions(newOptions);
      this.toggle2SearchInput(true);
    } else {
      // whether it is a filter or not, isFocus is guaranteed to be true when open
      this._adapter.updateFocusState(true);
    }
    this._adapter.openMenu(() => {
      const {
        searchPosition,
        autoFocus
      } = this.getProps();
      if (autoFocus && searchPosition === select_constants_strings.SEARCH_POSITION_DROPDOWN) {
        this._adapter.focusDropdownInput();
      }
    });
    this._setDropdownWidth();
    this._adapter.notifyDropdownVisibleChange(true);
    this.bindKeyBoardEvent();
    this._adapter.registerClickOutsideHandler(e => {
      this.close({
        event: e
      });
      this._notifyBlur(e);
      this._adapter.updateFocusState(false);
    });
  }
  toggle2SearchInput(isShow) {
    if (isShow) {
      this._adapter.toggleInputShow(isShow, () => this.focusInput());
    } else {
      // only when choose the option and close the panel, the input can be hide
      this._adapter.toggleInputShow(isShow, () => undefined);
    }
  }
  close(closeConfig) {
    // to support A11y, closing the panel trigger does not necessarily lose focus
    const {
      event,
      closeCb,
      notToggleInput
    } = closeConfig || {};
    this._adapter.closeMenu();
    this._adapter.notifyDropdownVisibleChange(false);
    this._adapter.setIsFocusInContainer(false);
    // this.unBindKeyBoardEvent();
    // this._notifyBlur(e);
    // this._adapter.updateFocusState(false);
    this._adapter.unregisterClickOutsideHandler();
    const isFilterable = this._isFilterable();
    // notToggleInput will only be true when in controlled mode - handleSingeleSelect process
    if (isFilterable && !notToggleInput) {
      this.toggle2SearchInput(false);
    }
    this._adapter.once('popoverClose', () => {
      if (isFilterable) {
        this.clearInput(event);
      }
      if (closeCb) {
        closeCb();
      }
    });
  }
  onSelect(option, optionIndex, event) {
    const isDisabled = this._isDisabled();
    if (isDisabled) {
      return;
    }
    // If the allowCreate dynamically created option is selected, onCreate needs to be triggered
    if (option._inputCreateOnly) {
      this._adapter.notifyCreate(option);
    }
    const isMultiple = this._isMultiple();
    if (!isMultiple) {
      this._handleSingleSelect(option, event);
      this._focusTrigger();
    } else {
      this._handleMultipleSelect(option, event);
    }
    this._adapter.updateFocusIndex(optionIndex);
  }
  _handleSingleSelect(_a, event) {
    var {
        value,
        label
      } = _a,
      rest = foundation_rest(_a, ["value", "label"]);
    const selections = new Map().set(label, Object.assign({
      value,
      label
    }, rest));
    // First trigger onSelect, then trigger onChange
    this._notifySelect(value, Object.assign({
      value,
      label
    }, rest));
    // If it is a controlled component, directly notify
    // Make sure that the operations of updating updateOptions are done after the animation ends
    // otherwise the content will be updated when the popup layer is not collapsed, and it looks like it will flash once when it is closed
    const isFilterable = this._isFilterable();
    if (this._isControlledComponent()) {
      this.close({
        event: event,
        notToggleInput: true,
        closeCb: () => {
          // trigger props.onChange -> update props.value -> updateSelection
          this._notifyChange(selections);
          // make sure toggleSearchInput update after updateSelection in controlled mode, otherwise text in inactive DOM will update quicker than selection, looks like flash text
          if (isFilterable) {
            this.toggle2SearchInput(false);
          }
        }
      });
    } else {
      this._adapter.updateSelection(selections);
      // notify user
      this._notifyChange(selections);
      this.close({
        event: event,
        closeCb: () => {
          // Update the selected item in the drop-down box
          this.updateOptionsActiveStatus(selections);
        }
      });
    }
  }
  _handleMultipleSelect(_a, event) {
    var {
        value,
        label
      } = _a,
      rest = foundation_rest(_a, ["value", "label"]);
    const maxLimit = this._adapter.getMaxLimit();
    const selections = this._adapter.getSelections();
    const {
      autoClearSearchValue
    } = this.getProps();
    if (selections.has(label)) {
      this._notifyDeselect(value, Object.assign({
        value,
        label
      }, rest));
      selections.delete(label);
    } else if (maxLimit && selections.size === maxLimit) {
      this._adapter.notifyMaxLimit(Object.assign({
        value,
        label
      }, omit_default()(rest, '_scrollIndex')));
      return;
    } else {
      this._notifySelect(value, Object.assign({
        value,
        label
      }, rest));
      selections.set(label, Object.assign({
        value,
        label
      }, rest));
    }
    if (this._isControlledComponent()) {
      // Controlled components, directly notified
      this._notifyChange(selections);
      if (this._isFilterable()) {
        if (autoClearSearchValue) {
          this.clearInput(event);
        }
        this.focusInput();
      }
    } else {
      // Uncontrolled components, update ui
      this._adapter.updateSelection(selections);
      this.updateOverflowItemCount(selections.size);
      // In multi-select mode, the drop-down pop-up layer is repositioned every time the value is changed, because the height selection of the selection box may have changed
      this._adapter.rePositionDropdown();
      let {
        options
      } = this.getStates();
      // Searchable filtering, when selected, resets Input
      if (this._isFilterable()) {
        // When filter active，if autoClearSearchValue is true，reset input after select
        if (autoClearSearchValue) {
          this.clearInput(event);
          // At the same time, the filtering of options is also cleared, in order to show all candidates
          const sugInput = '';
          options = this._filterOption(options, sugInput);
        }
        this.focusInput();
      }
      this.updateOptionsActiveStatus(selections, options);
      this._notifyChange(selections);
    }
  }
  clearSelected() {
    const selections = new Map();
    if (this._isControlledComponent()) {
      this._notifyChange(selections);
      this._adapter.notifyClear();
    } else {
      this._adapter.updateSelection(selections);
      this.updateOptionsActiveStatus(selections);
      this._notifyChange(selections);
      this._adapter.notifyClear();
    }
    // when call manually by ref method
    const {
      isOpen
    } = this.getStates();
    if (isOpen) {
      this._adapter.rePositionDropdown();
    }
  }
  // Update the selected item in the drop-down box
  updateOptionsActiveStatus(selections) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getState('options');
    const {
      allowCreate
    } = this.getProps();
    const newOptions = options.map(option => {
      if (selections.has(option.label)) {
        option._selected = true;
        if (allowCreate) {
          delete option._inputCreateOnly;
        }
      } else {
        if (option._inputCreateOnly) {
          option._show = false;
        }
        option._selected = false;
      }
      return option;
    });
    this._adapter.updateOptions(newOptions);
  }
  removeTag(item) {
    const selections = this._adapter.getSelections();
    selections.delete(item.label);
    if (this._isControlledComponent()) {
      this._notifyDeselect(item.value, item);
      this._notifyChange(selections);
    } else {
      this._notifyDeselect(item.value, item);
      this._adapter.updateSelection(selections);
      this.updateOverflowItemCount(selections.size);
      this.updateOptionsActiveStatus(selections);
      // Repostion drop-down layer, because the selection may have changed the number of rows, resulting in a height change
      this._adapter.rePositionDropdown();
      this._notifyChange(selections);
    }
  }
  // The reason why event input is optional is that clearInput may be manually called by the user through ref
  clearInput(event) {
    const {
      inputValue
    } = this.getStates();
    // only when input is not null, select should notifySearch and updateOptions
    if (inputValue !== '') {
      this._adapter.updateInputValue('');
      this._adapter.notifySearch('', event);
      // reset options filter
      const {
        options
      } = this.getStates();
      const {
        remote
      } = this.getProps();
      let optionsAfterFilter = options;
      if (!remote) {
        optionsAfterFilter = this._filterOption(options, '');
      }
      this._adapter.updateOptions(optionsAfterFilter);
    }
  }
  focusInput() {
    this._adapter.focusInput();
    this._adapter.updateFocusState(true);
    this._adapter.setIsFocusInContainer(false);
  }
  handleInputChange(sugInput, event) {
    // Input is a controlled component, so the value needs to be updated
    this._adapter.updateInputValue(sugInput);
    const {
      options,
      isOpen
    } = this.getStates();
    const {
      allowCreate,
      remote
    } = this.getProps();
    let optionsAfterFilter = options;
    if (!remote) {
      // Filter options based on input
      optionsAfterFilter = this._filterOption(options, sugInput);
    }
    // When allowClear is true, an entry can be created. You need to include the current input as a new Option input
    optionsAfterFilter = this._createOptionByInput(allowCreate, optionsAfterFilter, sugInput);
    this._adapter.updateOptions(optionsAfterFilter);
    this._adapter.notifySearch(sugInput, event);
    // In multi-select mode, the drop-down box is repositioned each time you enter, because it may cause a line break as the input changes
    if (this._isMultiple()) {
      this._adapter.rePositionDropdown();
    }
  }
  _filterOption(originalOptions, sugInput) {
    const filter = this.getProp('filter');
    if (!filter) {
      // 1. No filtering
      return originalOptions;
    } else if (typeof filter === 'boolean' && filter) {
      // 2. When true, the default filter is used
      const input = sugInput.toLowerCase();
      return originalOptions.map(option => {
        const label = option.label.toString().toLowerCase();
        const groupLabel = option._parentGroup && option._parentGroup.label;
        const matchOption = label.includes(input);
        const matchGroup = isString_default()(groupLabel) && groupLabel.toLowerCase().includes(input);
        if (matchOption || matchGroup) {
          option._show = true;
        } else {
          option._show = false;
        }
        return option;
      });
    } else if (typeof filter === 'function') {
      // 3. When passing in a custom function, use a custom function for filtering
      return originalOptions.map(option => {
        filter(sugInput, option) ? option._show = true : option._show = false;
        return option;
      });
    }
    return undefined;
  }
  _createOptionByInput(allowCreate, optionsAfterFilter, sugInput) {
    if (allowCreate) {
      if (sugInput) {
        // optionsAfterFilter clone ??? needClone ?
        const newOptionByInput = {
          _show: true,
          _selected: false,
          value: sugInput,
          label: sugInput,
          // True indicates that the option was dynamically created during user filtering
          _inputCreateOnly: true
        };
        let createOptionIndex = -1;
        let matchOptionIndex = -1;
        optionsAfterFilter.forEach((option, index) => {
          if (!option._show && !option._inputCreateOnly) {
            return;
          }
          // The matching algorithm is not necessarily through labels?
          if (option.label === sugInput) {
            matchOptionIndex = index;
          }
          if (option._inputCreateOnly) {
            createOptionIndex = index;
            option.value = sugInput;
            option.label = sugInput;
            option._show = true;
          }
        });
        if (createOptionIndex === -1 && matchOptionIndex === -1) {
          optionsAfterFilter.push(newOptionByInput);
        }
        if (matchOptionIndex !== -1) {
          optionsAfterFilter = optionsAfterFilter.filter(item => !item._inputCreateOnly);
        }
      } else {
        // Delete input unselected items
        optionsAfterFilter = optionsAfterFilter.filter(item => !item._inputCreateOnly);
      }
    }
    // TODO Promise supports asynchronous creation
    return optionsAfterFilter;
  }
  bindKeyBoardEvent() {
    this._keydownHandler = event => {
      this._handleKeyDown(event);
    };
    this._adapter.registerKeyDown(this._keydownHandler);
  }
  unBindKeyBoardEvent() {
    if (this._keydownHandler) {
      this._adapter.unregisterKeyDown();
    }
  }
  // When searchPosition is trigger, the keyboard events bind to the outer trigger div
  // When searchPosition is dropdown, the popup and the outer trigger div are not parent- child relationships, keyboard events bind to the dorpdown input
  _handleKeyDown(event) {
    const key = event.keyCode;
    const {
      loading,
      filter,
      multiple,
      disabled
    } = this.getProps();
    const {
      isOpen
    } = this.getStates();
    if (loading || disabled) {
      return;
    }
    switch (key) {
      case utils_keyCode.UP:
        // Prevent Input's cursor from following
        // Prevent Input cursor from following
        event.preventDefault();
        this._handleArrowKeyDown(-1);
        break;
      case utils_keyCode.DOWN:
        // Prevent Input's cursor from following
        // Prevent Input cursor from following
        event.preventDefault();
        this._handleArrowKeyDown(1);
        break;
      case utils_keyCode.BACKSPACE:
        this._handleBackspaceKeyDown();
        break;
      case utils_keyCode.ENTER:
        // internal-issues:302
        // prevent trigger form’s submit when use in form
        handlePrevent(event);
        this._handleEnterKeyDown(event);
        break;
      case utils_keyCode.ESC:
        isOpen && this.close({
          event: event
        });
        filter && !multiple && this._focusTrigger();
        break;
      case utils_keyCode.TAB:
        // check if slot have focusable element
        this._handleTabKeyDown(event);
        break;
      default:
        break;
    }
  }
  handleContainerKeyDown(event) {
    // when focus in contanier, handle the key down
    const key = event.keyCode;
    const {
      isOpen
    } = this.getStates();
    switch (key) {
      case utils_keyCode.TAB:
        isOpen && this._handleTabKeyDown(event);
        break;
      default:
        break;
    }
  }
  _getEnableFocusIndex(offset) {
    const {
      focusIndex,
      options
    } = this.getStates();
    const visibleOptions = options.filter(item => item._show);
    // let visibleOptions = options;
    const optionsLength = visibleOptions.length;
    let index = focusIndex + offset;
    if (index < 0) {
      index = optionsLength - 1;
    }
    if (index >= optionsLength) {
      index = 0;
    }
    // avoid newIndex option is disabled
    if (offset > 0) {
      let nearestActiveOption = -1;
      for (let i = 0; i < visibleOptions.length; i++) {
        const optionIsActive = !visibleOptions[i].disabled;
        if (optionIsActive) {
          nearestActiveOption = i;
        }
        if (nearestActiveOption >= index) {
          break;
        }
      }
      index = nearestActiveOption;
    } else {
      let nearestActiveOption = visibleOptions.length;
      for (let i = optionsLength - 1; i >= 0; i--) {
        const optionIsActive = !visibleOptions[i].disabled;
        if (optionIsActive) {
          nearestActiveOption = i;
        }
        if (nearestActiveOption <= index) {
          break;
        }
      }
      index = nearestActiveOption;
    }
    // console.log('new:' + index);
    this._adapter.updateFocusIndex(index);
    this._adapter.updateScrollTop(index);
  }
  _handleArrowKeyDown(offset) {
    const {
      isOpen
    } = this.getStates();
    isOpen ? this._getEnableFocusIndex(offset) : this.open();
  }
  _handleTabKeyDown(event) {
    const {
      isOpen
    } = this.getStates();
    this._adapter.updateFocusState(false);
    if (isOpen) {
      const container = this._adapter.getContainer();
      const focusableElements = this._adapter.getFocusableElements(container);
      const focusableNum = focusableElements.length;
      if (focusableNum > 0) {
        // Shift + Tab will move focus backward
        if (event.shiftKey) {
          this._handlePanelOpenShiftTabKeyDown(focusableElements, event);
        } else {
          this._handlePanelOpenTabKeyDown(focusableElements, event);
        }
      } else {
        // there are no focusable elements inside the container, tab to next element and trigger blur
        this.close({
          event: event
        });
        this._notifyBlur(event);
      }
    } else {
      // tab or shift tab to next element and trigger blur
      this._notifyBlur(event);
    }
  }
  _handlePanelOpenTabKeyDown(focusableElements, event) {
    const activeElement = this._adapter.getActiveElement();
    const isFocusInContainer = this._adapter.getIsFocusInContainer();
    if (!isFocusInContainer) {
      // focus in trigger, set next focus to the first element in container
      focusableElements[0].focus();
      this._adapter.setIsFocusInContainer(true);
      handlePrevent(event);
    } else if (activeElement === focusableElements[focusableElements.length - 1]) {
      // focus in the last element in container, focus back to trigger and close panel
      this._focusTrigger();
      this.close({
        event
      });
      handlePrevent(event);
    }
  }
  _handlePanelOpenShiftTabKeyDown(focusableElements, event) {
    const activeElement = this._adapter.getActiveElement();
    const isFocusInContainer = this._adapter.getIsFocusInContainer();
    if (!isFocusInContainer) {
      // focus in trigger, close the panel, shift tab to previe element and trigger blur
      this.close({
        event
      });
      this._notifyBlur(event);
    } else if (activeElement === focusableElements[0]) {
      // focus in the first element in container, focus back to trigger
      this._focusTrigger();
      this._adapter.setIsFocusInContainer(false);
      handlePrevent(event);
    }
  }
  _handleEnterKeyDown(event) {
    const {
      isOpen,
      options,
      focusIndex
    } = this.getStates();
    if (!isOpen) {
      this.open();
    } else {
      if (focusIndex !== -1) {
        const visibleOptions = options.filter(item => item._show);
        const {
          length
        } = visibleOptions;
        // fix issue 1201
        if (length <= focusIndex) {
          return;
        }
        if (visibleOptions && length) {
          const selectedOption = visibleOptions[focusIndex];
          if (selectedOption.disabled) {
            return;
          }
          this.onSelect(selectedOption, focusIndex, event);
        }
      } else {
        this.close({
          event
        });
      }
    }
  }
  _handleBackspaceKeyDown() {
    if (this._isMultiple()) {
      const selections = this._adapter.getSelections();
      const {
        inputValue
      } = this.getStates();
      const length = selections.size;
      if (length && !inputValue) {
        const keys = [...selections.keys()];
        let index = length - 1;
        let targetLabel = keys[index];
        let targetItem = selections.get(targetLabel);
        let isAllDisabled = false;
        // can skip disabled item when remove trigger by backspace
        if (targetItem.disabled && index === 0) {
          return;
        }
        while (targetItem.disabled && index !== 0) {
          index = index - 1;
          targetLabel = keys[index];
          targetItem = selections.get(targetLabel);
          if (index == 0 && targetItem.disabled) {
            isAllDisabled = true;
          }
        }
        if (!isAllDisabled) {
          this.removeTag(targetItem);
        }
      }
    }
  }
  _notifyChange(selections) {
    const {
      onChangeWithObject
    } = this.getProps();
    const stateSelections = this.getState('selections');
    let notifyVal;
    const selectionsProps = [...selections.values()];
    const isMultiple = this._isMultiple();
    const hasChange = this._diffSelections(selections, stateSelections, isMultiple);
    if (!hasChange) {
      return;
    }
    switch (true) {
      case onChangeWithObject:
        this._notifyChangeWithObject(selections);
        break;
      case !onChangeWithObject && !isMultiple:
        notifyVal = selectionsProps.length ? selectionsProps[0].value : undefined;
        this._adapter.notifyChange(notifyVal);
        break;
      case !onChangeWithObject && isMultiple:
        notifyVal = selectionsProps.length ? selectionsProps.map(props => props.value) : [];
        this._adapter.notifyChange(notifyVal);
        break;
      default:
        break;
    }
  }
  _removeInternalKey(option) {
    let newOption = Object.assign({}, option);
    delete newOption._parentGroup;
    delete newOption._show;
    delete newOption._selected;
    delete newOption._scrollIndex;
    delete newOption._keyInJsx;
    if ('_keyInOptionList' in newOption) {
      newOption.key = newOption._keyInOptionList;
      delete newOption._keyInOptionList;
    }
    return newOption;
  }
  _notifySelect(value, option) {
    const newOption = this._removeInternalKey(option);
    this._adapter.notifySelect(value, newOption);
  }
  _notifyDeselect(value, option) {
    const newOption = this._removeInternalKey(option);
    this._adapter.notifyDeselect(value, newOption);
  }
  _diffSelections(selections, oldSelections, isMultiple) {
    let diff = true;
    if (!isMultiple) {
      const selectionProps = [...selections.values()];
      const oldSelectionProps = [...oldSelections.values()];
      const optionLabel = selectionProps[0] ? selectionProps[0].label : selectionProps[0];
      const oldOptionLabel = oldSelectionProps[0] ? oldSelectionProps[0].label : oldSelectionProps[0];
      diff = !isEqual_default()(optionLabel, oldOptionLabel);
    } else {
      // When multiple selection, there is no scene where the value is different between the two operations
    }
    return diff;
  }
  // When onChangeWithObject is true, the onChange input parameter is not only value, but also label and other parameters
  _notifyChangeWithObject(selections) {
    const stateSelections = this.getState('selections');
    const values = [];
    for (const item of selections.entries()) {
      let val = Object.assign({
        label: item[0]
      }, item[1]);
      val = this._removeInternalKey(val);
      values.push(val);
    }
    if (!this._isMultiple()) {
      this._adapter.notifyChange(values[0]);
    } else {
      this._adapter.notifyChange(values);
    }
  }
  // Scenes that may trigger blur：
  // 1、clickOutSide
  // 2、 tab to next element/ shift tab to previous element
  // 3、[remove when add a11y] click option / press enter, and then select complete（when multiple is false 
  // 4、[remove when add a11y] press esc when dropdown list open 
  _notifyBlur(e) {
    this._adapter.notifyBlur(e);
  }
  // Scenes that may trigger focus:
  // 1、click selection
  _notifyFocus(e) {
    this._adapter.notifyFocus(e);
  }
  handleMouseEnter(e) {
    this._adapter.updateHovering(true);
    this._adapter.notifyMouseEnter(e);
  }
  handleMouseLeave(e) {
    this._adapter.updateHovering(false);
    this._adapter.notifyMouseLeave(e);
  }
  handleClearClick(e) {
    const {
      filter,
      searchPosition
    } = this.getProps();
    if (filter && searchPosition === select_constants_strings.SEARCH_POSITION_TRIGGER) {
      this.clearInput(e);
    }
    // after click showClear button, the select need to be focused
    this.focus();
    this.clearSelected();
    // prevent this click open dropdown
    e.stopPropagation();
  }
  handleKeyPress(e) {
    if (e && e.key === ENTER_KEY) {
      this.handleClick(e);
    }
  }
  /* istanbul ignore next */
  handleClearBtnEnterPress(e) {
    if (utils_isEnterPress(e)) {
      this.handleClearClick(e);
    }
  }
  handleOptionMouseEnter(optionIndex) {
    this._adapter.updateFocusIndex(optionIndex);
  }
  handleListScroll(e) {
    this._adapter.notifyListScroll(e);
  }
  handleTriggerFocus(e) {
    this.bindKeyBoardEvent();
    // close the tag in multiple select did not trigger select focus, but trigger TriggerFocus, so not need to updateFocusState in this function
    // this._adapter.updateFocusState(true);
    this._adapter.setIsFocusInContainer(false);
  }
  handleTriggerBlur(e) {
    const {
      filter,
      autoFocus
    } = this.getProps();
    const {
      isOpen,
      isFocus
    } = this.getStates();
    // Under normal circumstances, blur will be accompanied by clickOutsideHandler, so the notify of blur can be called uniformly in clickOutsideHandler
    // But when autoFocus or the panel is close, because clickOutsideHandler is not register or unregister, you need to listen for the trigger's blur and trigger the notify callback
    if (isFocus && !isOpen) {
      this._notifyBlur(e);
      this._adapter.updateFocusState(false);
    }
  }
  handleInputBlur(e) {
    const {
      filter,
      autoFocus
    } = this.getProps();
    const isMultiple = this._isMultiple();
    if (autoFocus && filter && !isMultiple) {
      // under this condition, when input blur, hide the input
      this.toggle2SearchInput(false);
    }
  }
  selectAll() {
    const {
      options
    } = this.getStates();
    const {
      onChangeWithObject
    } = this.getProps();
    let selectedValues = [];
    const isMultiple = this._isMultiple();
    if (!isMultiple) {
      console.warn(`[Semi Select]: It seems that you have called the selectAll method in the single-selection Select.
                Please note that this is not a legal way to use it`);
      return;
    }
    if (onChangeWithObject) {
      selectedValues = options;
    } else {
      selectedValues = options.map(option => option.value);
    }
    this.handleValueChange(selectedValues);
    this._adapter.notifyChange(selectedValues);
  }
  /**
   * Check whether the props
   *  -defaultValue/value in multiple selection mode is array
   * @param {Object} props
   */
  checkMultipleProps(props) {
    if (this._isMultiple()) {
      const currentProps = props ? props : this.getProps();
      const {
        defaultValue,
        value
      } = currentProps;
      const selectedValues = value || defaultValue;
      if (!isNullOrUndefined(selectedValues) && !Array.isArray(selectedValues)) {
        /* istanbul ignore next */
        warning(true, '[Semi Select] defaultValue/value should be array type in multiple mode');
      }
    }
  }
  updateScrollTop() {
    this._adapter.updateScrollTop();
  }
  updateOverflowItemCount(selectionLength, overFlowCount) {
    const {
      maxTagCount,
      ellipsisTrigger
    } = this.getProps();
    if (!ellipsisTrigger) {
      return;
    }
    if (overFlowCount) {
      this._adapter.updateOverflowItemCount(overFlowCount);
    } else if (typeof maxTagCount === 'number') {
      if (selectionLength - maxTagCount > 0) {
        this._adapter.updateOverflowItemCount(selectionLength - maxTagCount);
      } else {
        this._adapter.updateOverflowItemCount(0);
      }
    }
  }
  updateIsFullTags() {
    const {
      isFullTags
    } = this.getStates();
    if (!isFullTags) {
      this._adapter.setState({
        isFullTags: true
      });
    }
  }
  handlePopoverClose() {
    this._adapter.emit('popoverClose');
  }
  // need to remove focus style of option when user hover slot
  handleSlotMouseEnter() {
    this._adapter.updateFocusIndex(-1);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tag/constants.js

const tag_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-tag`
};
const tag_constants_strings = {
  TAG_SIZE: ['default', 'small', 'large'],
  TAG_COLOR: ['grey', 'red', 'pink', 'purple', 'violet', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'white'],
  TAG_TYPE: ['light', 'solid', 'ghost'],
  AVATAR_SHAPE: ['square', 'circle']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/avatar/constants.js

const avatar_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-avatar`
};
const avatar_constants_strings = {
  SHAPE: ['circle', 'square'],
  SIZE: ['extra-extra-small', 'extra-small', 'small', 'default', 'medium', 'large', 'extra-large'],
  COLOR: ['grey', 'red', 'pink', 'purple', 'violet', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'white'],
  OVERLAP_FROM: ['start', 'end']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/avatar/foundation.js


class AvatarFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.handleFocusVisible = event => {
      const {
        target
      } = event;
      try {
        if (target.matches(':focus-visible')) {
          this._adapter.setFocusVisible(true);
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Avatar] The current browser does not support the focus-visible');
      }
    };
    this.handleBlur = () => {
      this._adapter.setFocusVisible(false);
    };
    this.changeScale = () => {
      const {
        gap
      } = this.getProps();
      const node = this._adapter.getAvatarNode();
      const stringNode = node === null || node === void 0 ? void 0 : node.firstChild;
      const [nodeWidth, stringNodeWidth] = [(node === null || node === void 0 ? void 0 : node.offsetWidth) || 0, (stringNode === null || stringNode === void 0 ? void 0 : stringNode.offsetWidth) || 0];
      if (nodeWidth !== 0 && stringNodeWidth !== 0 && gap * 2 < nodeWidth) {
        const scale = nodeWidth - gap * 2 > stringNodeWidth ? 1 : (nodeWidth - gap * 2) / stringNodeWidth;
        this._adapter.setScale(scale);
      }
    };
  }
  init() {
    const {
      children
    } = this.getProps();
    if (typeof children === "string") {
      this.changeScale();
    }
  }
  destroy() {}
  handleImgLoadError() {
    const {
      onError
    } = this.getProps();
    const errorFlag = onError ? onError() : undefined;
    if (errorFlag !== false) {
      this._adapter.notifyImgState(false);
    }
  }
  handleEnter(e) {
    this._adapter.notifyEnter(e);
  }
  handleLeave(e) {
    this._adapter.notifyLeave(e);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/avatar/TopSlotSvg.js


const TopSlotSvg = _ref => {
  let {
    gradientStart,
    gradientEnd
  } = _ref;
  const id = getUuidShort();
  return /*#__PURE__*/react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "51",
    height: "52",
    viewBox: "0 0 51 52",
    fill: "none"
  }, /*#__PURE__*/react.createElement("g", {
    filter: "url(#filter0_d_6_2)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M40.4918 46.5592C44.6795 43.176 46.261 34.1333 47.5301 25.6141C49.5854 11.8168 39.6662 1 25.8097 1C11.2857 1 3 11.4279 3 25.3518C3 33.7866 6.29361 43.8947 10.4602 46.5592C12.5868 47.9192 12.5868 47.9051 25.8097 47.9192C38.3651 47.9282 38.5352 48.14 40.4918 46.5592Z",
    fill: `url(#${id})`
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("filter", {
    id: "filter0_d_6_2",
    x: "0.789215",
    y: "0.447304",
    width: "49.2216",
    height: "51.3549",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dy: "1.65809"
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: "1.10539"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_2"
  }), /*#__PURE__*/react.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_2",
    result: "shape"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: id,
    x1: "17.671",
    y1: "31.7392",
    x2: "17.671",
    y2: "47.9333",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: gradientStart
  }), /*#__PURE__*/react.createElement("stop", {
    offset: "1",
    stopColor: gradientEnd
  }))));
};
/* harmony default export */ var avatar_TopSlotSvg = (TopSlotSvg);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/avatar/index.js
var avatar_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





// import '@douyinfe/semi-foundation/lib/es/avatar/avatar.css';





const avatar_sizeSet = avatar_constants_strings.SIZE;
const shapeSet = avatar_constants_strings.SHAPE;
const colorSet = avatar_constants_strings.COLOR;
const avatar_prefixCls = avatar_constants_cssClasses.PREFIX;

class Avatar extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleFocusVisible = event => {
      this.foundation.handleFocusVisible(event);
    };
    this.handleBlur = event => {
      this.foundation.handleBlur();
    };
    this.getContent = () => {
      const {
        children,
        onClick,
        imgAttr,
        src,
        srcSet,
        alt
      } = this.props;
      const {
        isImgExist
      } = this.state;
      let content = children;
      const clickable = onClick !== function_noop;
      const isImg = src && isImgExist;
      const a11yFocusProps = {
        tabIndex: 0,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocusVisible,
        onBlur: this.handleBlur
      };
      if (isImg) {
        const finalAlt = clickable ? `clickable Avatar: ${alt}` : alt;
        const imgBasicProps = Object.assign(Object.assign({
          src,
          srcSet,
          onError: this.handleError
        }, imgAttr), {
          className: classnames_default()({
            [`${avatar_prefixCls}-no-focus-visible`]: clickable
          })
        });
        const imgProps = clickable ? Object.assign(Object.assign({}, imgBasicProps), a11yFocusProps) : imgBasicProps;
        content = /*#__PURE__*/react.createElement("img", Object.assign({
          alt: finalAlt
        }, imgProps));
      } else if (typeof children === 'string') {
        const tempAlt = alt !== null && alt !== void 0 ? alt : children;
        const finalAlt = clickable ? `clickable Avatar: ${tempAlt}` : tempAlt;
        const props = {
          role: 'img',
          'aria-label': finalAlt,
          className: classnames_default()(`${avatar_prefixCls}-label`, {
            [`${avatar_prefixCls}-no-focus-visible`]: clickable
          })
        };
        const finalProps = clickable ? Object.assign(Object.assign({}, props), a11yFocusProps) : props;
        const stringStyle = {
          transform: `scale(${this.state.scale})`
        };
        content = /*#__PURE__*/react.createElement("span", {
          className: `${avatar_prefixCls}-content`,
          style: stringStyle
        }, /*#__PURE__*/react.createElement("span", Object.assign({}, finalProps, {
          "x-semi-prop": "children"
        }), children));
      }
      return content;
    };
    this.renderBottomSlot = () => {
      var _a, _b;
      if (!this.props.bottomSlot) {
        return null;
      }
      if (this.props.bottomSlot.render) {
        return this.props.bottomSlot.render();
      }
      const renderContent = (_a = this.props.bottomSlot.render) !== null && _a !== void 0 ? _a : () => {
        var _a;
        const style = {};
        if (this.props.bottomSlot.bgColor) {
          style['backgroundColor'] = this.props.bottomSlot.bgColor;
        }
        if (this.props.bottomSlot.textColor) {
          style['color'] = this.props.bottomSlot.textColor;
        }
        return /*#__PURE__*/react.createElement("span", {
          style: style,
          className: classnames_default()(`${avatar_prefixCls}-bottom_slot-shape_${this.props.bottomSlot.shape}`, `${avatar_prefixCls}-bottom_slot-shape_${this.props.bottomSlot.shape}-${this.props.size}`, (_a = this.props.bottomSlot.className) !== null && _a !== void 0 ? _a : "")
        }, this.props.bottomSlot.text);
      };
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()([`${avatar_prefixCls}-bottom_slot`]),
        style: (_b = this.props.bottomSlot.style) !== null && _b !== void 0 ? _b : {}
      }, renderContent());
    };
    this.renderTopSlot = () => {
      var _a, _b, _c, _d;
      if (!this.props.topSlot) {
        return null;
      }
      if (this.props.topSlot.render) {
        return this.props.topSlot.render();
      }
      const textStyle = {};
      if (this.props.topSlot.textColor) {
        textStyle['color'] = this.props.topSlot.textColor;
      }
      return /*#__PURE__*/react.createElement("div", {
        style: (_a = this.props.topSlot.style) !== null && _a !== void 0 ? _a : {},
        className: classnames_default()([`${avatar_prefixCls}-top_slot-wrapper`, (_b = this.props.topSlot.className) !== null && _b !== void 0 ? _b : "", {
          [`${avatar_prefixCls}-animated`]: this.props.contentMotion
        }])
      }, /*#__PURE__*/react.createElement("div", {
        className: classnames_default()([`${avatar_prefixCls}-top_slot-bg`, `${avatar_prefixCls}-top_slot-bg-${this.props.size}`])
      }, /*#__PURE__*/react.createElement("div", {
        className: classnames_default()([`${avatar_prefixCls}-top_slot-bg-svg`, `${avatar_prefixCls}-top_slot-bg-svg-${this.props.size}`])
      }, /*#__PURE__*/react.createElement(avatar_TopSlotSvg, {
        gradientStart: (_c = this.props.topSlot.gradientStart) !== null && _c !== void 0 ? _c : "var(--semi-color-primary)",
        gradientEnd: (_d = this.props.topSlot.gradientEnd) !== null && _d !== void 0 ? _d : "var(--semi-color-primary)"
      }))), /*#__PURE__*/react.createElement("div", {
        className: classnames_default()([`${avatar_prefixCls}-top_slot`])
      }, /*#__PURE__*/react.createElement("div", {
        style: textStyle,
        className: classnames_default()([`${avatar_prefixCls}-top_slot-content`, `${avatar_prefixCls}-top_slot-content-${this.props.size}`])
      }, this.props.topSlot.text)));
    };
    this.state = {
      isImgExist: true,
      hoverContent: '',
      focusVisible: false,
      scale: 1
    };
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.getContent = this.getContent.bind(this);
    this.avatarRef = /*#__PURE__*/react.createRef();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      notifyImgState: isImgExist => {
        this.setState({
          isImgExist
        });
      },
      notifyEnter: e => {
        const {
          hoverMask
        } = this.props;
        const hoverContent = hoverMask;
        this.setState({
          hoverContent
        }, () => {
          const {
            onMouseEnter
          } = this.props;
          onMouseEnter && onMouseEnter(e);
        });
      },
      notifyLeave: e => {
        this.setState({
          hoverContent: ''
        }, () => {
          const {
            onMouseLeave
          } = this.props;
          onMouseLeave && onMouseLeave(e);
        });
      },
      setFocusVisible: focusVisible => {
        this.setState({
          focusVisible
        });
      },
      setScale: scale => {
        this.setState({
          scale
        });
      },
      getAvatarNode: () => {
        var _a;
        return (_a = this.avatarRef) === null || _a === void 0 ? void 0 : _a.current;
      }
    });
  }
  componentDidMount() {
    this.foundation = new AvatarFoundation(this.adapter);
    this.foundation.init();
  }
  componentDidUpdate(prevProps) {
    if (this.props.src && this.props.src !== prevProps.src) {
      const image = new Image(0, 0);
      image.src = this.props.src;
      image.onload = () => {
        this.setState({
          isImgExist: true
        });
      };
      image.onerror = () => {
        this.setState({
          isImgExist: false
        });
      };
      image.onabort = () => {
        this.setState({
          isImgExist: false
        });
      };
    }
    if (typeof this.props.children === "string" && this.props.children !== prevProps.children) {
      this.foundation.changeScale();
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  onEnter(e) {
    this.foundation.handleEnter(e);
  }
  onLeave(e) {
    this.foundation.handleLeave(e);
  }
  handleError() {
    this.foundation.handleImgLoadError();
  }
  handleKeyDown(event) {
    const {
      onClick
    } = this.props;
    switch (event.key) {
      case "Enter":
        onClick(event);
        handlePrevent(event);
        break;
      case 'Escape':
        event.target.blur();
        break;
      default:
        break;
    }
  }
  render() {
    var _a;
    const _b = this.props,
      {
        shape,
        children,
        size,
        color,
        className,
        hoverMask,
        onClick,
        imgAttr,
        src,
        srcSet,
        style,
        alt,
        gap,
        bottomSlot,
        topSlot,
        border,
        contentMotion
      } = _b,
      others = avatar_rest(_b, ["shape", "children", "size", "color", "className", "hoverMask", "onClick", "imgAttr", "src", "srcSet", "style", "alt", "gap", "bottomSlot", "topSlot", "border", "contentMotion"]);
    const {
      isImgExist,
      hoverContent,
      focusVisible
    } = this.state;
    let customStyle = {};
    if (!avatar_constants_strings.SIZE.includes(size)) {
      customStyle = {
        width: size,
        height: size
      };
    }
    customStyle = Object.assign(Object.assign({}, customStyle), style);
    const shouldWrap = bottomSlot || topSlot || border;
    const mouseEvent = {
      onClick: onClick,
      onMouseEnter: this.onEnter,
      onMouseLeave: this.onLeave
    };
    const isImg = src && isImgExist;
    const avatarCls = classnames_default()(avatar_prefixCls, {
      [`${avatar_prefixCls}-${shape}`]: shape,
      [`${avatar_prefixCls}-${size}`]: size,
      [`${avatar_prefixCls}-${color}`]: color && !isImg,
      [`${avatar_prefixCls}-img`]: isImg,
      [`${avatar_prefixCls}-focus`]: focusVisible,
      [`${avatar_prefixCls}-animated`]: contentMotion
    }, className);
    const hoverRender = hoverContent ? /*#__PURE__*/react.createElement("div", {
      className: `${avatar_prefixCls}-hover`,
      "x-semi-prop": "hoverContent"
    }, hoverContent) : null;
    let avatar = /*#__PURE__*/react.createElement("span", Object.assign({}, others, {
      style: shouldWrap ? {} : customStyle,
      className: avatarCls
    }, shouldWrap ? {} : mouseEvent, {
      role: 'listitem',
      ref: this.avatarRef
    }), this.getContent(), hoverRender);
    if (border) {
      const borderStyle = {};
      if (typeof border === 'object' && (border === null || border === void 0 ? void 0 : border.color)) {
        borderStyle['borderColor'] = border === null || border === void 0 ? void 0 : border.color;
      }
      avatar = /*#__PURE__*/react.createElement("div", {
        style: Object.assign({
          position: "relative"
        }, customStyle)
      }, avatar, /*#__PURE__*/react.createElement("span", {
        style: borderStyle,
        className: classnames_default()([`${avatar_prefixCls}-additionalBorder`, `${avatar_prefixCls}-additionalBorder-${size}`, {
          [`${avatar_prefixCls}-${shape}`]: shape
        }])
      }), typeof this.props.border === 'object' && this.props.border.motion && /*#__PURE__*/react.createElement("span", {
        style: borderStyle,
        className: classnames_default()([`${avatar_prefixCls}-additionalBorder`, `${avatar_prefixCls}-additionalBorder-${size}`, {
          [`${avatar_prefixCls}-${shape}`]: shape,
          [`${avatar_prefixCls}-additionalBorder-animated`]: typeof this.props.border === 'object' && ((_a = this.props.border) === null || _a === void 0 ? void 0 : _a.motion)
        }])
      }));
    }
    if (shouldWrap) {
      return /*#__PURE__*/react.createElement("span", Object.assign({
        className: classnames_default()([`${avatar_prefixCls}-wrapper`]),
        style: customStyle
      }, mouseEvent), avatar, topSlot && ["extra-small", "small", "default", "medium", "large", "extra-large"].includes(size) && shape === "circle" && this.renderTopSlot(), bottomSlot && ["extra-small", "small", "default", "medium", "large", "extra-large"].includes(size) && this.renderBottomSlot());
    } else {
      return avatar;
    }
  }
}
Avatar.__SemiComponentName__ = "Avatar";
Avatar.defaultProps = getDefaultPropsFromGlobalConfig(Avatar.__SemiComponentName__, {
  size: 'medium',
  color: 'grey',
  shape: 'circle',
  gap: 3,
  onClick: function_noop,
  onMouseEnter: function_noop,
  onMouseLeave: function_noop
});
Avatar.propTypes = {
  children: (prop_types_default()).node,
  color: prop_types_default().oneOf(colorSet),
  shape: prop_types_default().oneOf(shapeSet),
  size: prop_types_default().oneOf(avatar_sizeSet),
  hoverMask: (prop_types_default()).node,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  gap: (prop_types_default()).number,
  imgAttr: (prop_types_default()).object,
  src: (prop_types_default()).string,
  srcSet: (prop_types_default()).string,
  alt: (prop_types_default()).string,
  onError: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  bottomSlot: prop_types_default().shape({
    render: (prop_types_default()).func,
    shape: prop_types_default().oneOf(['circle', 'square']),
    text: (prop_types_default()).node,
    bgColor: (prop_types_default()).string,
    textColor: (prop_types_default()).string,
    className: (prop_types_default()).string,
    style: (prop_types_default()).object
  }),
  topSlot: prop_types_default().shape({
    render: (prop_types_default()).func,
    gradientStart: (prop_types_default()).string,
    gradientEnd: (prop_types_default()).string,
    text: (prop_types_default()).node,
    textColor: (prop_types_default()).string,
    className: (prop_types_default()).string,
    style: (prop_types_default()).object
  }),
  border: prop_types_default().oneOfType([prop_types_default().shape({
    color: (prop_types_default()).string,
    motion: (prop_types_default()).bool
  }), (prop_types_default()).bool]),
  contentMotion: (prop_types_default()).bool
};
Avatar.elementType = 'Avatar';
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tag/index.js

var tag_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/tag/tag.css';


const tag_prefixCls = tag_constants_cssClasses.PREFIX;
const tagColors = tag_constants_strings.TAG_COLOR;
const tagSize = tag_constants_strings.TAG_SIZE;
const tagType = tag_constants_strings.TAG_TYPE;
const avatarShapeSet = tag_constants_strings.AVATAR_SHAPE;
class Tag extends react.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };
    this.close = this.close.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  // any other way to achieve this?
  static getDerivedStateFromProps(nextProps) {
    if ('visible' in nextProps) {
      return {
        visible: nextProps.visible
      };
    }
    return null;
  }
  setVisible(visible) {
    if (!('visible' in this.props)) {
      this.setState({
        visible
      });
    }
  }
  close(e, value, tagKey) {
    const {
      onClose
    } = this.props;
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClose && onClose(value, e, tagKey);
    // when user call e.preventDefault() in onClick callback, tag will not hidden
    if (e.defaultPrevented) {
      return;
    }
    this.setVisible(false);
  }
  handleKeyDown(event) {
    const {
      closable,
      onClick,
      onKeyDown
    } = this.props;
    switch (event.key) {
      case "Backspace":
      case "Delete":
        closable && this.close(event, this.props.children, this.props.tagKey);
        handlePrevent(event);
        break;
      case "Enter":
        onClick(event);
        handlePrevent(event);
        break;
      case 'Escape':
        event.target.blur();
        break;
      default:
        break;
    }
    onKeyDown && onKeyDown(event);
  }
  renderAvatar() {
    const {
      avatarShape,
      avatarSrc
    } = this.props;
    const avatar = /*#__PURE__*/react.createElement(Avatar, {
      src: avatarSrc,
      shape: avatarShape
    });
    return avatar;
  }
  render() {
    const _a = this.props,
      {
        tagKey,
        children,
        size,
        color,
        closable,
        visible,
        onClose,
        onClick,
        className,
        type,
        shape,
        avatarSrc,
        avatarShape,
        tabIndex,
        prefixIcon,
        suffixIcon
      } = _a,
      attr = tag_rest(_a, ["tagKey", "children", "size", "color", "closable", "visible", "onClose", "onClick", "className", "type", "shape", "avatarSrc", "avatarShape", "tabIndex", "prefixIcon", "suffixIcon"]);
    const {
      visible: isVisible
    } = this.state;
    const clickable = onClick !== Tag.defaultProps.onClick || closable;
    // only when the Tag is clickable or closable, the value of tabIndex is allowed to be passed in. 
    const a11yProps = {
      role: 'button',
      tabIndex: tabIndex || 0,
      onKeyDown: this.handleKeyDown
    };
    const baseProps = Object.assign(Object.assign({}, attr), {
      onClick,
      tabIndex: tabIndex,
      className: classnames_default()(tag_prefixCls, {
        [`${tag_prefixCls}-default`]: size === 'default',
        [`${tag_prefixCls}-small`]: size === 'small',
        [`${tag_prefixCls}-large`]: size === 'large',
        [`${tag_prefixCls}-square`]: shape === 'square',
        [`${tag_prefixCls}-circle`]: shape === 'circle',
        [`${tag_prefixCls}-${type}`]: type,
        [`${tag_prefixCls}-${color}-${type}`]: color && type,
        [`${tag_prefixCls}-closable`]: closable,
        [`${tag_prefixCls}-invisible`]: !isVisible,
        [`${tag_prefixCls}-avatar-${avatarShape}`]: avatarSrc
      }, className)
    });
    const wrapProps = clickable ? Object.assign(Object.assign({}, baseProps), a11yProps) : baseProps;
    const closeIcon = closable ?
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    react.createElement("div", {
      className: `${tag_prefixCls}-close`,
      onClick: e => this.close(e, children, tagKey)
    }, /*#__PURE__*/react.createElement(IconClose, {
      size: "small"
    })) : null;
    const stringChild = isString_default()(children);
    const contentCls = classnames_default()(`${tag_prefixCls}-content`, `${tag_prefixCls}-content-${stringChild ? 'ellipsis' : 'center'}`);
    return /*#__PURE__*/react.createElement("div", Object.assign({
      "aria-label": this.props['aria-label'] || stringChild ? `${closable ? 'Closable ' : ''}Tag: ${children}` : ''
    }, wrapProps), prefixIcon ? /*#__PURE__*/react.createElement("div", {
      className: `${tag_prefixCls}-prefix-icon`
    }, prefixIcon) : null, avatarSrc ? this.renderAvatar() : null, /*#__PURE__*/react.createElement("div", {
      className: contentCls
    }, children), suffixIcon ? /*#__PURE__*/react.createElement("div", {
      className: `${tag_prefixCls}-suffix-icon`
    }, suffixIcon) : null, closeIcon);
  }
}
Tag.defaultProps = {
  size: tagSize[0],
  color: tagColors[0],
  closable: false,
  // visible: true,
  type: tagType[0],
  onClose: () => undefined,
  onClick: () => undefined,
  onMouseEnter: () => undefined,
  style: {},
  className: '',
  shape: 'square',
  avatarShape: 'square',
  prefixIcon: null,
  suffixIcon: null
};
Tag.propTypes = {
  children: (prop_types_default()).node,
  tagKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  size: prop_types_default().oneOf(tagSize),
  color: prop_types_default().oneOf(tagColors),
  type: prop_types_default().oneOf(tagType),
  closable: (prop_types_default()).bool,
  visible: (prop_types_default()).bool,
  onClose: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  prefixIcon: (prop_types_default()).node,
  suffixIcon: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  avatarSrc: (prop_types_default()).string,
  avatarShape: prop_types_default().oneOf(avatarShapeSet),
  'aria-label': (prop_types_default()).string
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tag/group.js






const group_prefixCls = tag_constants_cssClasses.PREFIX;
const group_tagSize = tag_constants_strings.TAG_SIZE;
const group_avatarShapeSet = tag_constants_strings.AVATAR_SHAPE;
class TagGroup extends react.PureComponent {
  renderNTag(n, restTags) {
    const {
      size,
      showPopover,
      popoverProps,
      onPlusNMouseEnter
    } = this.props;
    let nTag = /*#__PURE__*/react.createElement(Tag, {
      closable: false,
      size: size,
      color: "grey",
      style: {
        backgroundColor: 'transparent'
      },
      key: "_+n",
      onMouseEnter: onPlusNMouseEnter
    }, "+", n);
    if (showPopover) {
      nTag = /*#__PURE__*/react.createElement(popover, Object.assign({
        showArrow: true,
        content: restTags,
        trigger: "hover",
        position: "top",
        autoAdjustOverflow: true,
        className: `${group_prefixCls}-rest-group-popover`
      }, popoverProps, {
        key: "_+n_Popover"
      }), nTag);
    }
    return nTag;
  }
  renderMergeTags(tags) {
    const {
      maxTagCount,
      tagList,
      restCount
    } = this.props;
    const n = restCount ? restCount : tagList.length - maxTagCount;
    let renderTags = tags;
    const normalTags = tags.slice(0, maxTagCount);
    const restTags = tags.slice(maxTagCount);
    let nTag = null;
    if (n > 0) {
      nTag = this.renderNTag(n, restTags);
      normalTags.push(nTag);
      renderTags = normalTags;
    }
    return renderTags;
  }
  renderAllTags() {
    const {
      tagList,
      size,
      mode,
      avatarShape,
      onTagClose
    } = this.props;
    const renderTags = tagList.map(tag => {
      if (mode === 'custom') {
        return tag;
      }
      const newTag = Object.assign({}, tag);
      if (!newTag.size) {
        newTag.size = size;
      }
      if (!newTag.avatarShape) {
        newTag.avatarShape = avatarShape;
      }
      if (!newTag.tagKey) {
        if (typeof newTag.children === 'string' || typeof newTag.children === 'number') {
          newTag.tagKey = newTag.children;
        } else {
          newTag.tagKey = Math.random();
        }
      }
      return /*#__PURE__*/react.createElement(Tag, Object.assign({}, newTag, {
        key: newTag.tagKey,
        onClose: (tagChildren, e, tagKey) => {
          if (newTag.onClose) {
            newTag.onClose(tagChildren, e, tagKey);
          }
          onTagClose && onTagClose(tagChildren, e, tagKey);
        }
      }));
    });
    return renderTags;
  }
  render() {
    const {
      style,
      className,
      maxTagCount,
      size
    } = this.props;
    const groupCls = classnames_default()({
      [`${group_prefixCls}-group`]: true,
      [`${group_prefixCls}-group-max`]: maxTagCount,
      [`${group_prefixCls}-group-small`]: size === 'small',
      [`${group_prefixCls}-group-large`]: size === 'large'
    }, className);
    const tags = this.renderAllTags();
    const tagContents = typeof maxTagCount === 'undefined' ? tags : this.renderMergeTags(tags);
    return /*#__PURE__*/react.createElement("div", {
      style: style,
      className: groupCls
    }, tagContents);
  }
}
TagGroup.defaultProps = {
  style: {},
  className: '',
  size: group_tagSize[0],
  avatarShape: 'square',
  onTagClose: () => undefined,
  onPlusNMouseEnter: () => undefined
};
TagGroup.propTypes = {
  children: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  maxTagCount: (prop_types_default()).number,
  restCount: (prop_types_default()).number,
  tagList: (prop_types_default()).array,
  size: prop_types_default().oneOf(group_tagSize),
  mode: (prop_types_default()).string,
  onTagClose: (prop_types_default()).func,
  showPopover: (prop_types_default()).bool,
  popoverProps: (prop_types_default()).object,
  avatarShape: prop_types_default().oneOf(group_avatarShapeSet)
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/overflowList/constants.js

const overflowList_constants_cssClasses = {
  PREFIX: BASE_CLASS_PREFIX + '-overflow-list'
};
const MODE_MAP = {
  COLLAPSE: 'collapse',
  SCROLL: 'scroll'
};
const BOUNDARY_MAP = {
  START: 'start',
  END: 'end'
};
const OVERFLOW_DIR = {
  NONE: 0,
  GROW: 1,
  SHRINK: 2
};
const overflowList_constants_strings = {
  BOUNDARY_SET: Object.values(BOUNDARY_MAP),
  POSITION_SET: ['vertical', 'horizontal'],
  MODE_SET: Object.values(MODE_MAP),
  MODE_MAP,
  BOUNDARY_MAP,
  OVERFLOW_DIR
};
const overflowList_constants_numbers = {
  MINIMUM_HTML_ELEMENT_WIDTH: 4
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/overflowList/intersectionObserver.js





class ReactIntersectionObserver extends react.PureComponent {
  componentDidMount() {
    const {
      items
    } = this.props;
    this.cachedKeys = Object.keys(items);
    const {
      root,
      threshold,
      rootMargin,
      option,
      onIntersect
    } = this.props;
    this.observer = new IntersectionObserver(onIntersect, Object.assign({
      root,
      threshold,
      rootMargin
    }, option));
    this.observeElement();
  }
  componentDidUpdate() {
    const {
      items
    } = this.props;
    const itemKeys = Object.keys(items);
    if (!isEqual_default()(this.cachedKeys, itemKeys)) {
      this.observeElement(true);
      this.cachedKeys = itemKeys;
    }
  }
  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
  observeElement() {
    let force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const {
      items
    } = this.props;
    if (isEmpty_default()(items)) {
      // stop everything if not defined
      this.observer.disconnect();
      return;
    }
    if (force) {
      this.observer.disconnect();
    }
    // observer callback is invoked immediately when observing new elements
    Object.keys(items).forEach(key => {
      const node = items[key];
      if (!(node && isElement(node))) {
        return;
      }
      this.observer.observe(node);
    });
  }
  render() {
    const {
      children
    } = this.props;
    return children;
  }
}
ReactIntersectionObserver.propTypes = {
  onIntersect: (prop_types_default()).func,
  option: (prop_types_default()).object,
  root: (prop_types_default()).any,
  threshold: (prop_types_default()).number,
  rootMargin: (prop_types_default()).string,
  items: (prop_types_default()).object
};
ReactIntersectionObserver.defaultProps = {
  onIntersect: () => undefined,
  threshold: 0.75,
  rootMargin: '0px',
  option: {},
  items: {}
};
;// CONCATENATED MODULE: ./node_modules/fast-copy/dist/esm/index.mjs
var toStringFunction = Function.prototype.toString;
var create = Object.create;
var toStringObject = Object.prototype.toString;
/**
 * @classdesc Fallback cache for when WeakMap is not natively supported
 */
var LegacyCache = /** @class */ (function () {
    function LegacyCache() {
        this._keys = [];
        this._values = [];
    }
    LegacyCache.prototype.has = function (key) {
        return !!~this._keys.indexOf(key);
    };
    LegacyCache.prototype.get = function (key) {
        return this._values[this._keys.indexOf(key)];
    };
    LegacyCache.prototype.set = function (key, value) {
        this._keys.push(key);
        this._values.push(value);
    };
    return LegacyCache;
}());
function createCacheLegacy() {
    return new LegacyCache();
}
function createCacheModern() {
    return new WeakMap();
}
/**
 * Get a new cache object to prevent circular references.
 */
var createCache = typeof WeakMap !== 'undefined' ? createCacheModern : createCacheLegacy;
/**
 * Get an empty version of the object with the same prototype it has.
 */
function getCleanClone(prototype) {
    if (!prototype) {
        return create(null);
    }
    var Constructor = prototype.constructor;
    if (Constructor === Object) {
        return prototype === Object.prototype ? {} : create(prototype);
    }
    if (Constructor &&
        ~toStringFunction.call(Constructor).indexOf('[native code]')) {
        try {
            return new Constructor();
        }
        catch (_a) { }
    }
    return create(prototype);
}
function getRegExpFlagsLegacy(regExp) {
    var flags = '';
    if (regExp.global) {
        flags += 'g';
    }
    if (regExp.ignoreCase) {
        flags += 'i';
    }
    if (regExp.multiline) {
        flags += 'm';
    }
    if (regExp.unicode) {
        flags += 'u';
    }
    if (regExp.sticky) {
        flags += 'y';
    }
    return flags;
}
function getRegExpFlagsModern(regExp) {
    return regExp.flags;
}
/**
 * Get the flags to apply to the copied regexp.
 */
var getRegExpFlags = /test/g.flags === 'g' ? getRegExpFlagsModern : getRegExpFlagsLegacy;
function getTagLegacy(value) {
    var type = toStringObject.call(value);
    return type.substring(8, type.length - 1);
}
function getTagModern(value) {
    return value[Symbol.toStringTag] || getTagLegacy(value);
}
/**
 * Get the tag of the value passed, so that the correct copier can be used.
 */
var getTag = typeof Symbol !== 'undefined' ? getTagModern : getTagLegacy;

var defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
var _a = Object.prototype, esm_hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
var SUPPORTS_SYMBOL = typeof getOwnPropertySymbols === 'function';
function getStrictPropertiesModern(object) {
    return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
}
/**
 * Get the properites used when copying objects strictly. This includes both keys and symbols.
 */
var getStrictProperties = SUPPORTS_SYMBOL
    ? getStrictPropertiesModern
    : getOwnPropertyNames;
/**
 * Striclty copy all properties contained on the object.
 */
function copyOwnPropertiesStrict(value, clone, state) {
    var properties = getStrictProperties(value);
    for (var index = 0, length_1 = properties.length, property = void 0, descriptor = void 0; index < length_1; ++index) {
        property = properties[index];
        if (property === 'callee' || property === 'caller') {
            continue;
        }
        descriptor = getOwnPropertyDescriptor(value, property);
        if (!descriptor) {
            // In extra edge cases where the property descriptor cannot be retrived, fall back to
            // the loose assignment.
            clone[property] = state.copier(value[property], state);
            continue;
        }
        // Only clone the value if actually a value, not a getter / setter.
        if (!descriptor.get && !descriptor.set) {
            descriptor.value = state.copier(descriptor.value, state);
        }
        try {
            defineProperty(clone, property, descriptor);
        }
        catch (error) {
            // Tee above can fail on node in edge cases, so fall back to the loose assignment.
            clone[property] = descriptor.value;
        }
    }
    return clone;
}
/**
 * Deeply copy the indexed values in the array.
 */
function copyArrayLoose(array, state) {
    var clone = new state.Constructor();
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(array, clone);
    for (var index = 0, length_2 = array.length; index < length_2; ++index) {
        clone[index] = state.copier(array[index], state);
    }
    return clone;
}
/**
 * Deeply copy the indexed values in the array, as well as any custom properties.
 */
function copyArrayStrict(array, state) {
    var clone = new state.Constructor();
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(array, clone);
    return copyOwnPropertiesStrict(array, clone, state);
}
/**
 * Copy the contents of the ArrayBuffer.
 */
function copyArrayBuffer(arrayBuffer, _state) {
    return arrayBuffer.slice(0);
}
/**
 * Create a new Blob with the contents of the original.
 */
function copyBlob(blob, _state) {
    return blob.slice(0, blob.size, blob.type);
}
/**
 * Create a new DataView with the contents of the original.
 */
function copyDataView(dataView, state) {
    return new state.Constructor(copyArrayBuffer(dataView.buffer));
}
/**
 * Create a new Date based on the time of the original.
 */
function copyDate(date, state) {
    return new state.Constructor(date.getTime());
}
/**
 * Deeply copy the keys and values of the original.
 */
function copyMapLoose(map, state) {
    var clone = new state.Constructor();
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(map, clone);
    map.forEach(function (value, key) {
        clone.set(key, state.copier(value, state));
    });
    return clone;
}
/**
 * Deeply copy the keys and values of the original, as well as any custom properties.
 */
function copyMapStrict(map, state) {
    return copyOwnPropertiesStrict(map, copyMapLoose(map, state), state);
}
function copyObjectLooseLegacy(object, state) {
    var clone = getCleanClone(state.prototype);
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(object, clone);
    for (var key in object) {
        if (esm_hasOwnProperty.call(object, key)) {
            clone[key] = state.copier(object[key], state);
        }
    }
    return clone;
}
function copyObjectLooseModern(object, state) {
    var clone = getCleanClone(state.prototype);
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(object, clone);
    for (var key in object) {
        if (esm_hasOwnProperty.call(object, key)) {
            clone[key] = state.copier(object[key], state);
        }
    }
    var symbols = getOwnPropertySymbols(object);
    for (var index = 0, length_3 = symbols.length, symbol = void 0; index < length_3; ++index) {
        symbol = symbols[index];
        if (propertyIsEnumerable.call(object, symbol)) {
            clone[symbol] = state.copier(object[symbol], state);
        }
    }
    return clone;
}
/**
 * Deeply copy the properties (keys and symbols) and values of the original.
 */
var copyObjectLoose = SUPPORTS_SYMBOL
    ? copyObjectLooseModern
    : copyObjectLooseLegacy;
/**
 * Deeply copy the properties (keys and symbols) and values of the original, as well
 * as any hidden or non-enumerable properties.
 */
function copyObjectStrict(object, state) {
    var clone = getCleanClone(state.prototype);
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(object, clone);
    return copyOwnPropertiesStrict(object, clone, state);
}
/**
 * Create a new primitive wrapper from the value of the original.
 */
function copyPrimitiveWrapper(primitiveObject, state) {
    return new state.Constructor(primitiveObject.valueOf());
}
/**
 * Create a new RegExp based on the value and flags of the original.
 */
function copyRegExp(regExp, state) {
    var clone = new state.Constructor(regExp.source, getRegExpFlags(regExp));
    clone.lastIndex = regExp.lastIndex;
    return clone;
}
/**
 * Return the original value (an identity function).
 *
 * @note
 * THis is used for objects that cannot be copied, such as WeakMap.
 */
function copySelf(value, _state) {
    return value;
}
/**
 * Deeply copy the values of the original.
 */
function copySetLoose(set, state) {
    var clone = new state.Constructor();
    // set in the cache immediately to be able to reuse the object recursively
    state.cache.set(set, clone);
    set.forEach(function (value) {
        clone.add(state.copier(value, state));
    });
    return clone;
}
/**
 * Deeply copy the values of the original, as well as any custom properties.
 */
function copySetStrict(set, state) {
    return copyOwnPropertiesStrict(set, copySetLoose(set, state), state);
}

var isArray = Array.isArray;
var esm_assign = Object.assign;
var getPrototypeOf = Object.getPrototypeOf || (function (obj) { return obj.__proto__; });
var DEFAULT_LOOSE_OPTIONS = {
    array: copyArrayLoose,
    arrayBuffer: copyArrayBuffer,
    blob: copyBlob,
    dataView: copyDataView,
    date: copyDate,
    error: copySelf,
    map: copyMapLoose,
    object: copyObjectLoose,
    regExp: copyRegExp,
    set: copySetLoose,
};
var DEFAULT_STRICT_OPTIONS = esm_assign({}, DEFAULT_LOOSE_OPTIONS, {
    array: copyArrayStrict,
    map: copyMapStrict,
    object: copyObjectStrict,
    set: copySetStrict,
});
/**
 * Get the copiers used for each specific object tag.
 */
function getTagSpecificCopiers(options) {
    return {
        Arguments: options.object,
        Array: options.array,
        ArrayBuffer: options.arrayBuffer,
        Blob: options.blob,
        Boolean: copyPrimitiveWrapper,
        DataView: options.dataView,
        Date: options.date,
        Error: options.error,
        Float32Array: options.arrayBuffer,
        Float64Array: options.arrayBuffer,
        Int8Array: options.arrayBuffer,
        Int16Array: options.arrayBuffer,
        Int32Array: options.arrayBuffer,
        Map: options.map,
        Number: copyPrimitiveWrapper,
        Object: options.object,
        Promise: copySelf,
        RegExp: options.regExp,
        Set: options.set,
        String: copyPrimitiveWrapper,
        WeakMap: copySelf,
        WeakSet: copySelf,
        Uint8Array: options.arrayBuffer,
        Uint8ClampedArray: options.arrayBuffer,
        Uint16Array: options.arrayBuffer,
        Uint32Array: options.arrayBuffer,
        Uint64Array: options.arrayBuffer,
    };
}
/**
 * Create a custom copier based on the object-specific copy methods passed.
 */
function createCopier(options) {
    var normalizedOptions = esm_assign({}, DEFAULT_LOOSE_OPTIONS, options);
    var tagSpecificCopiers = getTagSpecificCopiers(normalizedOptions);
    var array = tagSpecificCopiers.Array, object = tagSpecificCopiers.Object;
    function copier(value, state) {
        state.prototype = state.Constructor = undefined;
        if (!value || typeof value !== 'object') {
            return value;
        }
        if (state.cache.has(value)) {
            return state.cache.get(value);
        }
        state.prototype = getPrototypeOf(value);
        state.Constructor = state.prototype && state.prototype.constructor;
        // plain objects
        if (!state.Constructor || state.Constructor === Object) {
            return object(value, state);
        }
        // arrays
        if (isArray(value)) {
            return array(value, state);
        }
        var tagSpecificCopier = tagSpecificCopiers[getTag(value)];
        if (tagSpecificCopier) {
            return tagSpecificCopier(value, state);
        }
        return typeof value.then === 'function' ? value : object(value, state);
    }
    return function copy(value) {
        return copier(value, {
            Constructor: undefined,
            cache: createCache(),
            copier: copier,
            prototype: undefined,
        });
    };
}
/**
 * Create a custom copier based on the object-specific copy methods passed, defaulting to the
 * same internals as `copyStrict`.
 */
function createStrictCopier(options) {
    return createCopier(esm_assign({}, DEFAULT_STRICT_OPTIONS, options));
}
/**
 * Copy an value deeply as much as possible, where strict recreation of object properties
 * are maintained. All properties (including non-enumerable ones) are copied with their
 * original property descriptors on both objects and arrays.
 */
var copyStrict = createStrictCopier({});
/**
 * Copy an value deeply as much as possible.
 */
var index = createCopier({});


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/overflowList/foundation.js




const Boundary = overflowList_constants_strings.BOUNDARY_MAP;
const OverflowDirection = overflowList_constants_strings.OVERFLOW_DIR;
class OverflowListFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.previousY = undefined;
    this.isScrollMode = () => {
      const {
        renderMode
      } = this.getProps();
      return renderMode === 'scroll';
    };
    this.getReversedItems = () => {
      const {
        items
      } = this.getProps();
      return index(items).reverse();
    };
  }
  getOverflowItem() {
    const {
      items
    } = this.getProps();
    const {
      visibleState,
      overflow
    } = this.getStates();
    if (!this.isScrollMode()) {
      return overflow;
    }
    const visibleStateArr = items.map(_ref => {
      let {
        key
      } = _ref;
      return Boolean(visibleState.get(key));
    });
    const visibleStart = visibleStateArr.indexOf(true);
    const visibleEnd = visibleStateArr.lastIndexOf(true);
    const overflowList = [];
    overflowList[0] = visibleStart >= 0 ? items.slice(0, visibleStart) : [];
    overflowList[1] = visibleEnd >= 0 ? items.slice(visibleEnd + 1, items.length) : items;
    return overflowList;
  }
  handleIntersect(entries) {
    const visibleState = index(this.getState('visibleState'));
    const res = {};
    entries.forEach(entry => {
      const itemKey = get_default()(entry, 'target.dataset.scrollkey');
      const visible = entry.isIntersecting;
      res[itemKey] = entry;
      visibleState.set(itemKey, visible);
    });
    let someItemVisible = false;
    for (const value of visibleState.values()) {
      if (value) {
        someItemVisible = true;
        break;
      }
    }
    // Any item is visible, indicating that the List is visible
    const wholeListVisible = someItemVisible;
    // If scrolling in the vertical direction makes the List invisible, no processing is required. 
    // If this.previousY is undefined, it means that the List is mounted for the first time and will not be processed.
    const [entry1] = entries;
    const currentY = entry1.boundingClientRect.y;
    if (!wholeListVisible && this.previousY !== undefined && currentY !== this.previousY) {
      this.previousY = currentY;
      return;
    }
    this.previousY = currentY;
    this._adapter.updateVisibleState(visibleState);
    this._adapter.notifyIntersect(res);
  }
  handleCollapseOverflow() {
    const {
      minVisibleItems,
      collapseFrom
    } = this.getProps();
    const {
      overflowWidth,
      containerWidth,
      pivot: statePivot,
      overflowStatus
    } = this.getStates();
    const {
      items,
      onOverflow
    } = this.getProps();
    let itemWidths = overflowWidth,
      _pivot = 0;
    let overflowed = false;
    for (const size of this._adapter.getItemSizeMap().values()) {
      itemWidths += size;
      // 触发overflow
      if (itemWidths > containerWidth) {
        overflowed = true;
        break;
      }
      // 顺利遍历完整个列表，说明不存在overflow，直接渲染全部
      if (_pivot === items.length - 1) {
        this._adapter.updateStates({
          overflowStatus: "normal",
          pivot: items.length - 1,
          visible: items,
          overflow: []
        });
        break;
      }
      _pivot++;
    }
    if (overflowed) {
      const pivot = Math.max(minVisibleItems, _pivot);
      const isCollapseFromStart = collapseFrom === Boundary.START;
      const visible = isCollapseFromStart ? this.getReversedItems().slice(0, pivot).reverse() : items.slice(0, pivot);
      const overflow = isCollapseFromStart ? this.getReversedItems().slice(pivot).reverse() : items.slice(pivot);
      this._adapter.updateStates({
        overflowStatus: "overflowed",
        pivot: pivot,
        visible,
        overflow
      });
      // trigger onOverflow
      if (statePivot !== pivot) {
        onOverflow(overflow);
      }
      return;
    }
  }
}
/* harmony default export */ var overflowList_foundation = (OverflowListFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/overflowList/index.js











// import '@douyinfe/semi-foundation/lib/es/overflowList/overflowList.css';

const overflowList_prefixCls = overflowList_constants_cssClasses.PREFIX;
const overflowList_Boundary = overflowList_constants_strings.BOUNDARY_MAP;
const overflowList_OverflowDirection = overflowList_constants_strings.OVERFLOW_DIR;
const RenderMode = overflowList_constants_strings.MODE_MAP;
// reference to https://github.com/palantir/blueprint/blob/1aa71605/packages/core/src/components/overflow-list/overflowList.tsx#L34
class OverflowList extends BaseComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.scroller = null;
    this.spacer = null;
    this.isScrollMode = () => {
      const {
        renderMode
      } = this.props;
      return renderMode === RenderMode.SCROLL;
    };
    this.resize = function () {
      let entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _a;
      const containerWidth = (_a = entries[0]) === null || _a === void 0 ? void 0 : _a.target.clientWidth;
      _this.setState({
        containerWidth,
        overflowStatus: 'calculating'
      });
    };
    this.reintersect = entries => {
      this.foundation.handleIntersect(entries);
    };
    this.mergeRef = (ref, node, key) => {
      this.itemRefs[key] = node;
      if (typeof ref === 'function') {
        ref(node);
      } else if (typeof ref === 'object' && ref && 'current' in ref) {
        ref.current = node;
      }
    };
    this.renderOverflow = () => {
      const overflow = this.foundation.getOverflowItem();
      return this.props.overflowRenderer(overflow);
    };
    this.getItemKey = (item, defaultKey) => {
      const {
        itemKey
      } = this.props;
      if (isFunction_default()(itemKey)) {
        return itemKey(item);
      }
      return get_default()(item, itemKey || 'key', defaultKey);
    };
    this.renderItemList = () => {
      const {
        className,
        wrapperClassName,
        wrapperStyle,
        style,
        visibleItemRenderer,
        renderMode,
        collapseFrom
      } = this.props;
      const {
        visible,
        overflowStatus
      } = this.state;
      let overflow = this.renderOverflow();
      if (!this.isScrollMode()) {
        if (Array.isArray(overflow)) {
          overflow = /*#__PURE__*/react.createElement(react.Fragment, null, overflow);
        }
        if ( /*#__PURE__*/react.isValidElement(overflow)) {
          const child = /*#__PURE__*/react.cloneElement(overflow);
          overflow = /*#__PURE__*/react.createElement(ReactResizeObserver, {
            onResize: _ref => {
              let [entry] = _ref;
              this.setState({
                overflowWidth: entry.target.clientWidth,
                overflowStatus: 'calculating'
              });
            }
          }, /*#__PURE__*/react.createElement("div", {
            className: `${overflowList_prefixCls}-overflow`
          }, child));
        }
      }
      const inner = renderMode === RenderMode.SCROLL ? (() => {
        const list = [/*#__PURE__*/react.createElement("div", {
          className: classnames_default()(wrapperClassName, `${overflowList_prefixCls}-scroll-wrapper`),
          ref: ref => {
            this.scroller = ref;
          },
          style: Object.assign({}, wrapperStyle),
          key: `${overflowList_prefixCls}-scroll-wrapper`
        }, visible.map(visibleItemRenderer).map(item => {
          const {
            forwardRef,
            key
          } = item;
          return /*#__PURE__*/react.cloneElement(item, {
            ref: node => this.mergeRef(forwardRef, node, key),
            'data-scrollkey': `${key}`,
            key
          });
        }))];
        if (this.props.overflowRenderDirection === "both") {
          list.unshift(overflow[0]);
          list.push(overflow[1]);
        } else if (this.props.overflowRenderDirection === "start") {
          list.unshift(overflow[1]);
          list.unshift(overflow[0]);
        } else {
          list.push(overflow[0]);
          list.push(overflow[1]);
        }
        return list;
      })() : [collapseFrom === overflowList_Boundary.START ? overflow : null, visible.map((item, idx) => {
        const {
          key
        } = item;
        const element = visibleItemRenderer(item, idx);
        const child = /*#__PURE__*/react.cloneElement(element);
        return /*#__PURE__*/react.createElement(ReactResizeObserver, {
          key: key !== null && key !== void 0 ? key : idx,
          onResize: _ref2 => {
            let [entry] = _ref2;
            return this.onItemResize(entry, item, idx);
          }
        }, /*#__PURE__*/react.createElement("div", {
          key: key !== null && key !== void 0 ? key : idx,
          className: `${overflowList_prefixCls}-item`
        }, child));
      }), collapseFrom === overflowList_Boundary.END ? overflow : null];
      const list = /*#__PURE__*/react.createElement('div', {
        className: classnames_default()(`${overflowList_prefixCls}`, className),
        style: Object.assign(Object.assign({}, style), renderMode === RenderMode.COLLAPSE ? {
          maxWidth: '100%',
          visibility: overflowStatus === "calculating" ? "hidden" : "visible"
        } : null)
      }, ...inner);
      return list;
    };
    this.onItemResize = (entry, item, idx) => {
      const key = this.getItemKey(item, idx);
      const width = this.itemSizeMap.get(key);
      if (!width) {
        this.itemSizeMap.set(key, entry.target.clientWidth);
      } else if (width !== entry.target.clientWidth) {
        // 某个item发生resize后，重新计算
        this.itemSizeMap.set(key, entry.target.clientWidth);
        this.setState({
          overflowStatus: 'calculating'
        });
      }
      const {
        maxCount
      } = this.state;
      // 已经按照最大值maxCount渲染完毕，触发真正的渲染
      // Already rendered maxCount items, trigger the real rendering
      if (this.itemSizeMap.size === maxCount) {
        this.setState({
          overflowStatus: 'calculating'
        });
      }
    };
    this.state = {
      direction: overflowList_OverflowDirection.GROW,
      lastOverflowCount: 0,
      overflow: [],
      visible: [],
      containerWidth: 0,
      visibleState: new Map(),
      itemSizeMap: new Map(),
      overflowStatus: "calculating",
      pivot: -1,
      overflowWidth: 0,
      maxCount: 0
    };
    this.foundation = new overflowList_foundation(this.adapter);
    this.previousWidths = new Map();
    this.itemRefs = {};
    this.itemSizeMap = new Map();
  }
  static getDerivedStateFromProps(props, prevState) {
    const {
      prevProps
    } = prevState;
    const newState = {};
    newState.prevProps = props;
    const needUpdate = name => {
      return !prevProps && name in props || prevProps && !isEqual_default()(prevProps[name], props[name]);
    };
    if (needUpdate('items') || needUpdate('style')) {
      // reset visible state if the above props change.
      newState.direction = overflowList_OverflowDirection.GROW;
      newState.lastOverflowCount = 0;
      newState.maxCount = 0;
      if (props.renderMode === RenderMode.SCROLL) {
        newState.visible = props.items;
        newState.overflow = [];
      } else {
        let maxCount = props.items.length;
        if (Math.floor(prevState.containerWidth / overflowList_constants_numbers.MINIMUM_HTML_ELEMENT_WIDTH) !== 0) {
          maxCount = Math.min(maxCount, Math.floor(prevState.containerWidth / overflowList_constants_numbers.MINIMUM_HTML_ELEMENT_WIDTH));
        }
        const isCollapseFromStart = props.collapseFrom === overflowList_Boundary.START;
        const visible = isCollapseFromStart ? cloneDeep(props.items).reverse().slice(0, maxCount) : props.items.slice(0, maxCount);
        const overflow = isCollapseFromStart ? cloneDeep(props.items).reverse().slice(maxCount) : props.items.slice(maxCount);
        newState.visible = visible;
        newState.overflow = overflow;
        newState.maxCount = maxCount;
      }
      newState.pivot = -1;
      newState.overflowStatus = "calculating";
    }
    return newState;
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      updateVisibleState: visibleState => {
        this.setState({
          visibleState
        }, () => {
          var _a, _b;
          (_b = (_a = this.props).onVisibleStateChange) === null || _b === void 0 ? void 0 : _b.call(_a, visibleState);
        });
      },
      updateStates: states => {
        this.setState(Object.assign({}, states));
      },
      notifyIntersect: res => {
        this.props.onIntersect && this.props.onIntersect(res);
      },
      getItemSizeMap: () => this.itemSizeMap
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const prevItemsKeys = prevProps.items.map(item => item.key);
    const nowItemsKeys = this.props.items.map(item => item.key);
    // Determine whether to update by comparing key values
    if (!isEqual_default()(prevItemsKeys, nowItemsKeys)) {
      this.itemRefs = {};
      this.setState({
        visibleState: new Map()
      });
    }
    const {
      overflow,
      containerWidth,
      visible,
      overflowStatus
    } = this.state;
    if (this.isScrollMode() || overflowStatus !== "calculating") {
      return;
    }
    this.foundation.handleCollapseOverflow();
  }
  render() {
    const list = this.renderItemList();
    const {
      renderMode
    } = this.props;
    if (renderMode === RenderMode.SCROLL) {
      return /*#__PURE__*/react.createElement(ReactIntersectionObserver, {
        onIntersect: this.reintersect,
        root: this.scroller,
        threshold: this.props.threshold,
        items: this.itemRefs
      }, list);
    }
    return /*#__PURE__*/react.createElement(ReactResizeObserver, {
      onResize: this.resize
    }, list);
  }
}
OverflowList.__SemiComponentName__ = "OverflowList";
OverflowList.defaultProps = getDefaultPropsFromGlobalConfig(OverflowList.__SemiComponentName__, {
  collapseFrom: 'end',
  minVisibleItems: 0,
  overflowRenderer: () => null,
  renderMode: 'collapse',
  threshold: 0.75,
  visibleItemRenderer: () => null,
  onOverflow: () => null,
  overflowRenderDirection: "both"
});
OverflowList.propTypes = {
  // if render in scroll mode, key is required in items
  className: (prop_types_default()).string,
  collapseFrom: prop_types_default().oneOf(overflowList_constants_strings.BOUNDARY_SET),
  direction: prop_types_default().oneOf(overflowList_constants_strings.POSITION_SET),
  items: (prop_types_default()).array,
  minVisibleItems: (prop_types_default()).number,
  onIntersect: (prop_types_default()).func,
  onOverflow: (prop_types_default()).func,
  overflowRenderer: (prop_types_default()).func,
  renderMode: prop_types_default().oneOf(overflowList_constants_strings.MODE_SET),
  style: (prop_types_default()).object,
  threshold: (prop_types_default()).number,
  visibleItemRenderer: (prop_types_default()).func,
  wrapperClassName: (prop_types_default()).string,
  wrapperStyle: (prop_types_default()).object,
  collapseMask: (prop_types_default()).object,
  overflowRenderDirection: (prop_types_default()).string
};
/* harmony default export */ var overflowList = (OverflowList);
// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var lodash_isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(lodash_isArray);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/space/constants.js

const space_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-space`
};
const space_constants_strings = {
  ALIGN_SET: ['start', 'end', 'center', 'baseline'],
  SPACING_LOOSE: 'loose',
  SPACING_MEDIUM: 'medium',
  SPACING_TIGHT: 'tight'
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/space/utils.js

const REACT_FRAGMENT_TYPE = 'Symbol(react.fragment)';
/**
 * Flatten the children and return the processed data
 */
const flatten = children => {
  let res = [];
  react.Children.forEach(children, child => {
    if (child === undefined || child === null) {
      return;
    }
    if (Array.isArray(child)) {
      res = res.concat(flatten(child));
    } else if ( /*#__PURE__*/(0,react.isValidElement)(child) && child.type && child.type.toString() === REACT_FRAGMENT_TYPE && child.props) {
      res = res.concat(flatten(child.props.children));
    } else {
      res.push(child);
    }
  });
  return res;
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/space/index.js







// import '@douyinfe/semi-foundation/lib/es/space/space.css';


const space_prefixCls = space_constants_cssClasses.PREFIX;
class Space extends react.PureComponent {
  render() {
    const {
      children = null,
      style,
      className,
      spacing,
      wrap,
      align,
      vertical
    } = this.props;
    const isWrap = wrap && vertical ? false : wrap;
    const realStyle = Object.assign({}, style);
    let spacingHorizontalType = '';
    let spacingVerticalType = '';
    if (isString_default()(spacing)) {
      spacingHorizontalType = spacing;
      spacingVerticalType = spacing;
    } else if (isNumber_default()(spacing)) {
      realStyle.rowGap = spacing;
      realStyle.columnGap = spacing;
    } else if (isArray_default()(spacing)) {
      if (isString_default()(spacing[0])) {
        spacingHorizontalType = spacing[0];
      } else if (isNumber_default()(spacing[0])) {
        realStyle.columnGap = `${spacing[0]}px`;
      }
      if (isString_default()(spacing[1])) {
        spacingVerticalType = spacing[1];
      } else if (isNumber_default()(spacing[1])) {
        realStyle.rowGap = `${spacing[1]}px`;
      }
    }
    const classNames = classnames_default()(space_prefixCls, className, {
      [`${space_prefixCls}-align-${align}`]: align,
      [`${space_prefixCls}-vertical`]: vertical,
      [`${space_prefixCls}-horizontal`]: !vertical,
      [`${space_prefixCls}-wrap`]: isWrap,
      [`${space_prefixCls}-tight-horizontal`]: spacingHorizontalType === space_constants_strings.SPACING_TIGHT,
      [`${space_prefixCls}-tight-vertical`]: spacingVerticalType === space_constants_strings.SPACING_TIGHT,
      [`${space_prefixCls}-medium-horizontal`]: spacingHorizontalType === space_constants_strings.SPACING_MEDIUM,
      [`${space_prefixCls}-medium-vertical`]: spacingVerticalType === space_constants_strings.SPACING_MEDIUM,
      [`${space_prefixCls}-loose-horizontal`]: spacingHorizontalType === space_constants_strings.SPACING_LOOSE,
      [`${space_prefixCls}-loose-vertical`]: spacingVerticalType === space_constants_strings.SPACING_LOOSE
    });
    const childrenNodes = flatten(children);
    const dataAttributes = getDataAttr(this.props);
    return /*#__PURE__*/react.createElement("div", Object.assign({}, dataAttributes, {
      className: classNames,
      style: realStyle,
      "x-semi-prop": "children"
    }), childrenNodes);
  }
}
Space.propTypes = {
  wrap: (prop_types_default()).bool,
  align: prop_types_default().oneOf(space_constants_strings.ALIGN_SET),
  vertical: (prop_types_default()).bool,
  spacing: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array]),
  children: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string
};
Space.defaultProps = {
  vertical: false,
  wrap: false,
  spacing: 'tight',
  align: 'center'
};
/* harmony default export */ var space = (Space);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/select/utils.js
var utils_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


const generateOption = (child, parent, index, newKey) => {
  const childProps = child.props;
  if (!child || !childProps) {
    return null;
  }
  const option = Object.assign(Object.assign({
    value: childProps.value,
    // Dropdown menu rendering priority label value, children, value in turn downgrade
    label: childProps.label || childProps.children || childProps.value,
    _show: true,
    _selected: false,
    _scrollIndex: index
  }, childProps), {
    _parentGroup: parent
  });
  // Props are collected from ReactNode, after React.Children.toArray
  // no need to determine whether the key exists in child
  // Even if the user does not explicitly declare it, React will always generate a key.
  option._keyInJsx = newKey || child.key;
  return option;
};
const getOptionsFromGroup = selectChildren => {
  let optionGroups = [];
  let options = [];
  const emptyGroup = {
    label: '',
    children: [],
    _show: false
  };
  // avoid null
  let childNodes = react.Children.toArray(selectChildren);
  childNodes = childNodes.filter(childNode => childNode && childNode.props);
  let type = '';
  let optionIndex = -1;
  childNodes.forEach(child => {
    if (child.type.isSelectOption) {
      type = 'option';
      optionIndex++;
      const option = generateOption(child, undefined, optionIndex);
      emptyGroup.children.push(option);
      options.push(option);
    } else if (child.type.isSelectOptionGroup) {
      type = 'group';
      // Avoid saving children (reactNode) by... removing other props from the group except children, causing performance problems
      let _a = child.props,
        {
          children
        } = _a,
        restGroupProps = utils_rest(_a, ["children"]);
      let originKeys = [];
      if (Array.isArray(children)) {
        // if group has children > 1
        originKeys = children.map(item => item.key);
      } else {
        originKeys.push(children.key);
      }
      children = react.Children.toArray(children);
      const childrenOption = children.map((option, index) => {
        let newKey = option.key;
        if (originKeys[index] === null) {
          newKey = child.key + '' + option.key; // if option in group and didn't set key, concat parent key to avoid conflict (default generate key just like .0, .1)
        }

        optionIndex++;
        return generateOption(option, restGroupProps, optionIndex, newKey);
      });
      const group = Object.assign(Object.assign({}, child.props), {
        children: childrenOption,
        key: child.key
      });
      optionGroups.push(group);
      options = options.concat(childrenOption);
    } else {
      warning(true, '[Semi Select] The children of `Select` should be `Select.Option` or `Select.OptionGroup`');
    }
  });
  if (type === 'option') {
    optionGroups = [emptyGroup];
  }
  return {
    optionGroups,
    options
  };
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/select/virtualRow.js
const VirtualRow = _ref => {
  let {
    index,
    data,
    style
  } = _ref;
  const {
    visibleOptions,
    renderOption
  } = data;
  const option = visibleOptions[index];
  return renderOption(option, index, style);
};
/* harmony default export */ var virtualRow = (VirtualRow);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/select/option.js

var option_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








class Option extends react.PureComponent {
  onClick(_a, event) {
    var {
        value,
        label,
        children
      } = _a,
      rest = option_rest(_a, ["value", "label", "children"]);
    const {
      props
    } = this;
    const isDisabled = props.disabled;
    if (!isDisabled) {
      props.onSelect(Object.assign(Object.assign({}, rest), {
        value,
        label: label || children
      }), event);
    }
  }
  renderOptionContent(_ref) {
    let {
      config,
      children,
      inputValue,
      prefixCls
    } = _ref;
    if (isString_default()(children) && inputValue) {
      return getHighLightTextHTML(config);
    }
    return children;
  }
  render() {
    const _a = this.props,
      {
        children,
        disabled,
        value,
        selected,
        label,
        empty,
        emptyContent,
        onSelect,
        focused,
        showTick,
        className,
        style,
        onMouseEnter,
        prefixCls,
        renderOptionItem,
        inputValue,
        semiOptionId
      } = _a,
      rest = option_rest(_a, ["children", "disabled", "value", "selected", "label", "empty", "emptyContent", "onSelect", "focused", "showTick", "className", "style", "onMouseEnter", "prefixCls", "renderOptionItem", "inputValue", "semiOptionId"]);
    const optionClassName = classnames_default()(prefixCls, {
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-selected`]: selected,
      [`${prefixCls}-focused`]: focused,
      [`${prefixCls}-empty`]: empty,
      [className]: className
    });
    const selectedIconClassName = classnames_default()([`${prefixCls}-icon`]);
    if (empty) {
      if (emptyContent === null) {
        return null;
      }
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Select"
      }, locale => /*#__PURE__*/react.createElement("div", {
        className: optionClassName,
        "x-semi-prop": "emptyContent"
      }, emptyContent || locale.emptyText));
    }
    // Since there are empty, locale and other logic, the custom renderOptionItem is directly converged to the internal option instead of being placed in Select/index
    if (typeof renderOptionItem === 'function') {
      return renderOptionItem(Object.assign({
        disabled,
        focused,
        selected,
        style,
        label,
        value,
        inputValue,
        onMouseEnter: e => onMouseEnter(e),
        onClick: e => this.onClick(Object.assign({
          value,
          label,
          children
        }, rest), e),
        className
      }, rest));
    }
    const config = {
      searchWords: inputValue,
      sourceString: children,
      option: {
        highlightClassName: `${prefixCls}-keyword`
      }
    };
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events
      react.createElement("div", Object.assign({
        className: optionClassName,
        onClick: e => {
          this.onClick(Object.assign({
            value,
            label,
            children
          }, rest), e);
        },
        onMouseEnter: e => onMouseEnter && onMouseEnter(e),
        role: "option",
        id: semiOptionId,
        "aria-selected": selected ? "true" : "false",
        "aria-disabled": disabled ? "true" : "false",
        style: style
      }, getDataAttr(rest)), showTick ? /*#__PURE__*/react.createElement("div", {
        className: selectedIconClassName
      }, /*#__PURE__*/react.createElement(IconTick, null)) : null, isString_default()(children) ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-text`
      }, this.renderOptionContent({
        children,
        config,
        inputValue,
        prefixCls
      })) : children)
    );
  }
}
Option.isSelectOption = true;
Option.propTypes = {
  children: (prop_types_default()).node,
  disabled: (prop_types_default()).bool,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  selected: (prop_types_default()).bool,
  label: (prop_types_default()).node,
  empty: (prop_types_default()).bool,
  emptyContent: (prop_types_default()).node,
  onSelect: (prop_types_default()).func,
  focused: (prop_types_default()).bool,
  showTick: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  onMouseEnter: (prop_types_default()).func,
  prefixCls: (prop_types_default()).string,
  renderOptionItem: (prop_types_default()).func,
  inputValue: (prop_types_default()).string
};
Option.defaultProps = {
  prefixCls: select_constants_cssClasses.PREFIX_OPTION
};
/* harmony default export */ var select_option = (Option);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/select/optionGroup.js
var optionGroup_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





const optionGroup_prefixCls = select_constants_cssClasses.PREFIX_GROUP;
class OptionGroup extends BaseComponent {
  render() {
    const _a = this.props,
      {
        label,
        className,
        style
      } = _a,
      rest = optionGroup_rest(_a, ["label", "className", "style"]);
    const groupCls = classnames_default()(className, {
      [optionGroup_prefixCls]: true
    });
    if (!label && typeof label !== 'number') {
      return null;
    }
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: groupCls,
      style: style
    }, this.getDataAttr(rest)), label);
  }
}
OptionGroup.isSelectOptionGroup = true;
OptionGroup.propTypes = {
  children: prop_types_default().oneOfType([(prop_types_default()).array, (prop_types_default()).node]),
  label: (prop_types_default()).node,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object
};
/* harmony default export */ var optionGroup = (OptionGroup);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/spin/constants.js

const PREFIX = `${BASE_CLASS_PREFIX}-spin`;
const spin_constants_cssClasses = {
  PREFIX
};
const spin_constants_strings = {
  SIZE: ['small', 'middle', 'large']
};
const spin_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/spin/foundation.js

class SpinFoundation extends foundation {
  static get spinDefaultAdapter() {
    return {
      getProp: () => undefined,
      setLoading: val => undefined
    };
  }
  constructor(adapter) {
    super(Object.assign(Object.assign({}, SpinFoundation.spinDefaultAdapter), adapter));
  }
  updateLoadingIfNeedDelay() {
    const {
      spinning: propsSpinning,
      delay: propsDelay
    } = this._adapter.getProps();
    const {
      delay
    } = this._adapter.getStates();
    if (delay) {
      const self = this;
      this._timer = setTimeout(() => {
        self._adapter.setState({
          loading: propsSpinning,
          delay: 0
        });
      }, propsDelay);
    }
  }
  destroy() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
}
/* harmony default export */ var spin_foundation = (SpinFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/spin/index.js
var spin_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/spin/spin.css';
const spin_prefixCls = spin_constants_cssClasses.PREFIX;
class Spin extends BaseComponent {
  constructor(props) {
    super(props);
    this.foundation = new spin_foundation(this.adapter);
    this.state = {
      delay: props.delay,
      loading: true
    };
  }
  static getDerivedStateFromProps(props) {
    if (!props.delay) {
      return {
        loading: props.spinning
      };
    }
    if (props.spinning === false) {
      return {
        delay: 0,
        loading: false
      };
    }
    return {
      delay: props.delay
    };
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setLoading: value => {
        this.setState({
          loading: value
        });
      }
    });
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  renderSpin() {
    const {
      indicator,
      tip
    } = this.props;
    const {
      loading
    } = this.state;
    return loading ? /*#__PURE__*/react.createElement("div", {
      className: `${spin_prefixCls}-wrapper`
    }, indicator ? /*#__PURE__*/react.createElement("div", {
      className: `${spin_prefixCls}-animate`,
      "x-semi-prop": "indicator"
    }, indicator) : /*#__PURE__*/react.createElement(spin_icon, null), tip ? /*#__PURE__*/react.createElement("div", {
      "x-semi-prop": "tip"
    }, tip) : null) : null;
  }
  render() {
    this.foundation.updateLoadingIfNeedDelay();
    const _a = this.props,
      {
        children,
        style,
        wrapperClassName,
        childStyle,
        size
      } = _a,
      rest = spin_rest(_a, ["children", "style", "wrapperClassName", "childStyle", "size"]);
    const {
      loading
    } = this.state;
    const spinCls = classnames_default()(spin_prefixCls, wrapperClassName, {
      [`${spin_prefixCls}-${size}`]: size,
      [`${spin_prefixCls}-block`]: children,
      [`${spin_prefixCls}-hidden`]: !loading
    });
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: spinCls,
      style: style
    }, this.getDataAttr(rest)), this.renderSpin(), /*#__PURE__*/react.createElement("div", {
      className: `${spin_prefixCls}-children`,
      style: childStyle,
      "x-semi-prop": "children"
    }, children));
  }
}
Spin.propTypes = {
  size: prop_types_default().oneOf(spin_constants_strings.SIZE),
  spinning: (prop_types_default()).bool,
  children: (prop_types_default()).node,
  indicator: (prop_types_default()).node,
  delay: (prop_types_default()).number,
  tip: (prop_types_default()).node,
  wrapperClassName: (prop_types_default()).string,
  childStyle: (prop_types_default()).object,
  style: (prop_types_default()).object
};
Spin.defaultProps = {
  size: 'middle',
  spinning: true,
  children: null,
  indicator: null,
  delay: 0
};
/* harmony default export */ var spin = (Spin);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/trigger/index.js
var trigger_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


/**
 * `Trigger` is a HOC that will cover the inner of components which have popups
 */
class Trigger extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        triggerRender,
        componentName
      } = _a,
      rest = trigger_rest(_a, ["triggerRender", "componentName"]);
    return triggerRender(Object.assign({}, rest));
  }
}
Trigger.propTypes = {
  /**
   * ({ value?: any, className?: string, style?: React.CSSProperties, ... }) => React.ReactNode
   */
  triggerRender: (prop_types_default()).func.isRequired,
  /**
   * e.g. "AutoComplete", "DatePicker", ...
   */
  componentName: (prop_types_default()).string,
  componentProps: (prop_types_default()).object,
  value: (prop_types_default()).any,
  inputValue: (prop_types_default()).string,
  placeholder: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  className: (prop_types_default()).string,
  style: (prop_types_default()).object
};
/* harmony default export */ var trigger = (Trigger);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconSearch.js


function IconSearch_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C5.80558 2 2 5.80558 2 10.5C2 15.1944 5.80558 19 10.5 19C12.3054 19 13.9794 18.4371 15.356 17.4773L19.4393 21.5606C20.0251 22.1464 20.9749 22.1464 21.5606 21.5606C22.1464 20.9749 22.1464 20.0251 21.5606 19.4393L17.4773 15.356C18.4371 13.9794 19 12.3054 19 10.5C19 5.80558 15.1944 2 10.5 2ZM5 10.5C5 7.46243 7.46243 5 10.5 5C13.5376 5 16 7.46243 16 10.5C16 13.5376 13.5376 16 10.5 16C7.46243 16 5 13.5376 5 10.5Z",
    fill: "currentColor"
  }));
}
const IconSearch_IconComponent = (0,Icon/* convertIcon */.A)(IconSearch_SvgComponent, 'search');
/* harmony default export */ var IconSearch = (IconSearch_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/select/index.js






var select_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




























// import '@douyinfe/semi-foundation/lib/es/select/select.css';
const prefixcls = select_constants_cssClasses.PREFIX;
const key = 0;
// Notes: Use the label of the option as the identifier, that is, the option in Select, the value is allowed to be the same, but the label must be unique
class Select extends BaseComponent {
  constructor(props) {
    super(props);
    this.setOptionContainerEl = node => this.optionContainerEl = {
      current: node
    };
    this.handleInputChange = (value, event) => this.foundation.handleInputChange(value, event);
    this.getTagItem = (item, i, renderSelectedItem) => {
      const {
        size,
        disabled: selectDisabled
      } = this.props;
      const label = item[0];
      const {
        value
      } = item[1];
      const disabled = item[1].disabled || selectDisabled;
      const onClose = (tagContent, e) => {
        if (e && typeof e.preventDefault === 'function') {
          e.preventDefault(); // make sure that tag will not hidden immediately in controlled mode
        }

        this.foundation.removeTag({
          label,
          value
        });
      };
      const {
        content,
        isRenderInTag
      } = renderSelectedItem(item[1], {
        index: i,
        disabled,
        onClose
      });
      const basic = {
        disabled,
        closable: !disabled,
        onClose
      };
      if (isRenderInTag) {
        return /*#__PURE__*/react.createElement(Tag, Object.assign({}, basic, {
          color: "white",
          size: size || 'large',
          key: value,
          tabIndex: -1
        }), content);
      } else {
        return /*#__PURE__*/react.createElement(react.Fragment, {
          key: value
        }, content);
      }
    };
    this.state = {
      isOpen: false,
      isFocus: false,
      options: [],
      selections: new Map(),
      dropdownMinWidth: null,
      optionKey: key,
      inputValue: '',
      showInput: false,
      focusIndex: props.defaultActiveFirstOption ? 0 : -1,
      keyboardEventSet: {},
      optionGroups: [],
      isHovering: false,
      isFocusInContainer: false,
      isFullTags: false,
      overflowItemCount: 0
    };
    /* Generate random string */
    this.selectOptionListID = '';
    this.selectID = '';
    this.virtualizeListRef = /*#__PURE__*/react.createRef();
    this.inputRef = /*#__PURE__*/react.createRef();
    this.dropdownInputRef = /*#__PURE__*/react.createRef(); // only work when searchPosition = 'dropdown'
    this.triggerRef = /*#__PURE__*/react.createRef();
    this.optionsRef = /*#__PURE__*/react.createRef();
    this.optionContainerEl = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
    this.onSelect = this.onSelect.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.eventManager = new Event();
    this.foundation = new SelectFoundation(this.adapter);
  }
  get adapter() {
    var _this = this;
    const keyboardAdapter = {
      registerKeyDown: cb => {
        const keyboardEventSet = {
          onKeyDown: cb
        };
        this.setState({
          keyboardEventSet
        });
      },
      unregisterKeyDown: () => {
        this.setState({
          keyboardEventSet: {}
        });
      },
      updateFocusIndex: focusIndex => {
        this.setState({
          focusIndex
        });
      },
      scrollToFocusOption: () => {}
    };
    const filterAdapter = {
      updateInputValue: value => {
        this.setState({
          inputValue: value
        });
      },
      toggleInputShow: (showInput, cb) => {
        this.setState({
          showInput
        }, () => {
          cb();
        });
      },
      focusInput: () => {
        const {
          preventScroll
        } = this.props;
        if (this.inputRef && this.inputRef.current) {
          this.inputRef.current.focus({
            preventScroll
          });
        }
      },
      focusDropdownInput: () => {
        const {
          preventScroll
        } = this.props;
        if (this.dropdownInputRef && this.dropdownInputRef.current) {
          this.dropdownInputRef.current.focus({
            preventScroll
          });
        }
      }
    };
    const multipleAdapter = {
      notifyMaxLimit: option => this.props.onExceed(option),
      getMaxLimit: () => this.props.max,
      registerClickOutsideHandler: cb => {
        const clickOutsideHandler = e => {
          const optionInstance = this.optionsRef && this.optionsRef.current;
          const triggerDom = this.triggerRef && this.triggerRef.current;
          const optionsDom = react_dom.findDOMNode(optionInstance);
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (!(optionsDom && optionsDom.contains(target)) && !(triggerDom && triggerDom.contains(target)) && !(path.includes(triggerDom) || path.includes(optionsDom))) {
            cb(e);
          }
        };
        this.clickOutsideHandler = clickOutsideHandler;
        document.addEventListener('mousedown', clickOutsideHandler, false);
      },
      unregisterClickOutsideHandler: () => {
        if (this.clickOutsideHandler) {
          document.removeEventListener('mousedown', this.clickOutsideHandler, false);
          this.clickOutsideHandler = null;
        }
      },
      rePositionDropdown: () => {
        let {
          optionKey
        } = this.state;
        optionKey = optionKey + 1;
        this.setState({
          optionKey
        });
      },
      notifyDeselect: (value, option) => {
        delete option._parentGroup;
        this.props.onDeselect(value, option);
      }
    };
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, super.adapter), keyboardAdapter), filterAdapter), multipleAdapter), {
      on: (eventName, eventCallback) => this.eventManager.on(eventName, eventCallback),
      off: eventName => this.eventManager.off(eventName),
      once: (eventName, eventCallback) => this.eventManager.once(eventName, eventCallback),
      emit: eventName => this.eventManager.emit(eventName),
      // Collect all subitems, each item is visible by default when collected, and is not selected
      getOptionsFromChildren: function () {
        let children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.children;
        let optionGroups = [];
        let options = [];
        const {
          optionList
        } = _this.props;
        if (optionList && optionList.length) {
          options = optionList.map((itemOpt, index) => Object.assign({
            _show: true,
            _selected: false,
            _scrollIndex: index
          }, itemOpt));
          optionGroups[0] = {
            children: options,
            label: ''
          };
        } else {
          const result = getOptionsFromGroup(children);
          optionGroups = result.optionGroups;
          options = result.options;
        }
        _this.setState({
          optionGroups
        });
        return options;
      },
      updateOptions: options => {
        this.setState({
          options
        });
      },
      openMenu: cb => {
        this.setState({
          isOpen: true
        }, () => {
          cb === null || cb === void 0 ? void 0 : cb();
        });
      },
      closeMenu: () => {
        this.setState({
          isOpen: false
        });
      },
      getTriggerWidth: () => {
        const el = this.triggerRef.current;
        return el && el.getBoundingClientRect().width;
      },
      setOptionWrapperWidth: width => {
        this.setState({
          dropdownMinWidth: width
        });
      },
      updateSelection: selections => {
        this.setState({
          selections
        });
      },
      // clone Map, important!!!, prevent unexpected modify on state
      getSelections: () => new Map(this.state.selections),
      notifyChange: value => {
        this.props.onChange(value);
      },
      notifySelect: (value, option) => {
        delete option._parentGroup;
        this.props.onSelect(value, option);
      },
      notifyDropdownVisibleChange: visible => {
        this.props.onDropdownVisibleChange(visible);
      },
      notifySearch: (input, event) => {
        this.props.onSearch(input, event);
      },
      notifyCreate: input => {
        this.props.onCreate(input);
      },
      notifyMouseEnter: e => {
        this.props.onMouseEnter(e);
      },
      notifyMouseLeave: e => {
        this.props.onMouseLeave(e);
      },
      notifyFocus: event => {
        this.props.onFocus(event);
      },
      notifyBlur: event => {
        this.props.onBlur(event);
      },
      notifyClear: () => {
        this.props.onClear();
      },
      notifyListScroll: e => {
        this.props.onListScroll(e);
      },
      updateHovering: isHovering => {
        this.setState({
          isHovering
        });
      },
      updateFocusState: isFocus => {
        this.setState({
          isFocus
        });
      },
      updateOverflowItemCount: overflowItemCount => {
        this.setState({
          overflowItemCount
        });
      },
      focusTrigger: () => {
        try {
          const {
            preventScroll
          } = this.props;
          const el = this.triggerRef.current;
          el.focus({
            preventScroll
          });
        } catch (error) {}
      },
      getContainer: () => {
        return this.optionContainerEl && this.optionContainerEl.current;
      },
      getFocusableElements: node => {
        return getFocusableElements(node);
      },
      getActiveElement: () => {
        return getActiveElement();
      },
      setIsFocusInContainer: isFocusInContainer => {
        this.setState({
          isFocusInContainer
        });
      },
      getIsFocusInContainer: () => {
        return this.state.isFocusInContainer;
      },
      updateScrollTop: index => {
        let optionClassName = `.${prefixcls}-option-selected`;
        if (index !== undefined) {
          optionClassName = `.${prefixcls}-option:nth-child(${index})`;
        }
        let destNode = document.querySelector(`#${prefixcls}-${this.selectOptionListID} ${optionClassName}`);
        if (Array.isArray(destNode)) {
          destNode = destNode[0];
        }
        if (destNode) {
          /**
           * Scroll the first selected item into view.
           * The reason why ScrollIntoView is not used here is that it may cause page to move.
           */
          const destParent = destNode.parentNode;
          destParent.scrollTop = destNode.offsetTop - destParent.offsetTop - destParent.clientHeight / 2 + destNode.clientHeight / 2;
        }
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
    this.selectOptionListID = getUuidShort();
    this.selectID = this.props.id || getUuidShort();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  componentDidUpdate(prevProps, prevState) {
    const prevChildrenKeys = react.Children.toArray(prevProps.children).map(child => child.key);
    const nowChildrenKeys = react.Children.toArray(this.props.children).map(child => child.key);
    let isOptionsChanged = false;
    if (!isEqual_default()(prevChildrenKeys, nowChildrenKeys) || !isEqual_default()(prevProps.optionList, this.props.optionList)) {
      isOptionsChanged = true;
      this.foundation.handleOptionListChange();
    }
    // Add isOptionChanged: There may be cases where the value is unchanged, but the optionList is updated. At this time, the label corresponding to the value may change, and the selected item needs to be updated
    if (!isEqual_default()(this.props.value, prevProps.value) || isOptionsChanged) {
      if ('value' in this.props) {
        this.foundation.handleValueChange(this.props.value);
      } else {
        this.foundation.handleOptionListChangeHadDefaultValue();
      }
    }
  }
  renderTriggerInput() {
    const {
      size,
      multiple,
      disabled,
      inputProps,
      filter
    } = this.props;
    const inputPropsCls = get_default()(inputProps, 'className');
    const inputcls = classnames_default()(`${prefixcls}-input`, {
      [`${prefixcls}-input-single`]: !multiple,
      [`${prefixcls}-input-multiple`]: multiple
    }, inputPropsCls);
    const {
      inputValue,
      focusIndex
    } = this.state;
    const selectInputProps = Object.assign({
      value: inputValue,
      disabled,
      className: inputcls,
      onChange: this.handleInputChange
    }, inputProps);
    let style = {};
    // Multiple choice mode
    if (multiple) {
      style = {
        width: inputValue ? `${inputValue.length * 16}px` : '2px'
      };
      selectInputProps.style = style;
    }
    return /*#__PURE__*/react.createElement(es_input, Object.assign({
      ref: this.inputRef,
      size: size,
      "aria-activedescendant": focusIndex !== -1 ? `${this.selectID}-option-${focusIndex}` : '',
      onFocus: e => {
        // if multiple and filter, when use tab key to let select get focus
        // need to manual update state isFocus to let the focus style take effect
        if (multiple && Boolean(filter)) {
          this.setState({
            isFocus: true
          });
        }
        // prevent event bubbling which will fire trigger onFocus event
        e.stopPropagation();
        // e.nativeEvent.stopImmediatePropagation();
      },
      onBlur: e => this.foundation.handleInputBlur(e)
    }, selectInputProps));
  }
  renderDropdownInput() {
    const {
      size,
      multiple,
      disabled,
      inputProps,
      filter,
      searchPosition,
      searchPlaceholder
    } = this.props;
    const {
      inputValue,
      focusIndex
    } = this.state;
    const wrapperCls = classnames_default()(`${prefixcls}-dropdown-search-wrapper`, {});
    const inputPropsCls = get_default()(inputProps, 'className');
    const inputCls = classnames_default()(`${prefixcls}-dropdown-input`, {
      [`${prefixcls}-dropdown-input-single`]: !multiple,
      [`${prefixcls}-dropdown-input-multiple`]: multiple
    }, inputPropsCls);
    const selectInputProps = Object.assign(Object.assign({
      value: inputValue,
      disabled,
      className: inputCls,
      onChange: this.handleInputChange,
      placeholder: searchPlaceholder,
      showClear: true
    }, inputProps), {
      /**
       * When searchPosition is trigger, the keyboard events are bound to the outer trigger div, so there is no need to listen in input.
       * When searchPosition is dropdown, the popup and the outer trigger div are not parent- child relationships,
       * and bubbles cannot occur, so onKeydown needs to be listened in input.
       *  */
      onKeyDown: e => this.foundation._handleKeyDown(e)
    });
    return /*#__PURE__*/react.createElement("div", {
      className: wrapperCls
    }, /*#__PURE__*/react.createElement(es_input, Object.assign({
      ref: this.dropdownInputRef,
      prefix: /*#__PURE__*/react.createElement(IconSearch, null),
      "aria-activedescendant": focusIndex !== -1 ? `${this.selectID}-option-${focusIndex}` : ''
    }, selectInputProps)));
  }
  close() {
    this.foundation.close();
  }
  open() {
    this.foundation.open();
  }
  clearInput() {
    this.foundation.clearInput();
  }
  selectAll() {
    this.foundation.selectAll();
  }
  deselectAll() {
    this.foundation.clearSelected();
  }
  focus() {
    this.foundation.focus();
  }
  onSelect(option, optionIndex, e) {
    this.foundation.onSelect(option, optionIndex, e);
  }
  onClear(e) {
    e.nativeEvent.stopImmediatePropagation();
    this.foundation.handleClearClick(e);
  }
  search(value, event) {
    this.handleInputChange(value, event);
  }
  renderEmpty() {
    return /*#__PURE__*/react.createElement(select_option, {
      empty: true,
      emptyContent: this.props.emptyContent
    });
  }
  renderLoading() {
    const loadingWrapperCls = `${prefixcls}-loading-wrapper`;
    return /*#__PURE__*/react.createElement("div", {
      className: loadingWrapperCls
    }, /*#__PURE__*/react.createElement(spin, null));
  }
  renderOption(option, optionIndex, style) {
    const {
      focusIndex,
      inputValue
    } = this.state;
    const {
      renderOptionItem
    } = this.props;
    let optionContent;
    const isFocused = optionIndex === focusIndex;
    let optionStyle = style || {};
    if (option.style) {
      optionStyle = Object.assign(Object.assign({}, optionStyle), option.style);
    }
    if (option._inputCreateOnly) {
      optionContent = this.renderCreateOption(option, isFocused, optionIndex, style);
    } else {
      // use another name to make sure that 'key' in optionList still exist when we call onChange
      if ('key' in option) {
        option._keyInOptionList = option.key;
      }
      optionContent = /*#__PURE__*/react.createElement(select_option, Object.assign({
        showTick: true
      }, option, {
        selected: option._selected,
        onSelect: (v, e) => this.onSelect(v, optionIndex, e),
        focused: isFocused,
        onMouseEnter: () => this.onOptionHover(optionIndex),
        style: optionStyle,
        key: option._keyInOptionList || option._keyInJsx || option.label + option.value + optionIndex,
        renderOptionItem: renderOptionItem,
        inputValue: inputValue,
        semiOptionId: `${this.selectID}-option-${optionIndex}`
      }), option.label);
    }
    return optionContent;
  }
  renderCreateOption(option, isFocused, optionIndex, style) {
    const {
      renderCreateItem
    } = this.props;
    // default render method
    if (typeof renderCreateItem === 'undefined') {
      const defaultCreateItem = /*#__PURE__*/react.createElement(select_option, Object.assign({
        key: option.key || option.label + option.value,
        onSelect: (v, e) => this.onSelect(v, optionIndex, e),
        onMouseEnter: () => this.onOptionHover(optionIndex),
        showTick: true
      }, option, {
        focused: isFocused,
        style: style
      }), /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Select"
      }, locale => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
        className: `${prefixcls}-create-tips`
      }, locale.createText), option.value)));
      return defaultCreateItem;
    }
    const customCreateItem = renderCreateItem(option.value, isFocused, style);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
      react.createElement("div", {
        role: "button",
        "aria-label": "Use the input box to create an optional item",
        onClick: e => this.onSelect(option, optionIndex, e),
        key: option.key || option.label
      }, customCreateItem)
    );
  }
  onOptionHover(optionIndex) {
    this.foundation.handleOptionMouseEnter(optionIndex);
  }
  renderWithGroup(visibleOptions) {
    const content = [];
    const groupStatus = new Map();
    visibleOptions.forEach((option, optionIndex) => {
      const parentGroup = option._parentGroup;
      const optionContent = this.renderOption(option, optionIndex);
      if (parentGroup && !groupStatus.has(parentGroup.label)) {
        // when use with OptionGroup and group content not already insert
        const groupContent = /*#__PURE__*/react.createElement(optionGroup, Object.assign({}, parentGroup, {
          key: parentGroup.label
        }));
        groupStatus.set(parentGroup.label, true);
        content.push(groupContent);
      }
      content.push(optionContent);
    });
    return content;
  }
  renderVirtualizeList(visibleOptions) {
    const {
      virtualize
    } = this.props;
    const {
      direction
    } = this.context;
    const {
      height,
      width,
      itemSize
    } = virtualize;
    return /*#__PURE__*/react.createElement(FixedSizeList, {
      ref: this.virtualizeListRef,
      height: height || select_constants_numbers.LIST_HEIGHT,
      itemCount: visibleOptions.length,
      itemSize: itemSize,
      itemData: {
        visibleOptions,
        renderOption: this.renderOption
      },
      width: width || '100%',
      style: {
        direction
      }
    }, virtualRow);
  }
  renderOptions(children) {
    const {
      dropdownMinWidth,
      options,
      selections
    } = this.state;
    const {
      maxHeight,
      dropdownClassName,
      dropdownStyle,
      outerTopSlot,
      innerTopSlot,
      outerBottomSlot,
      innerBottomSlot,
      loading,
      virtualize,
      multiple,
      emptyContent,
      searchPosition,
      filter
    } = this.props;
    // Do a filter first, instead of directly judging in forEach, so that the focusIndex can correspond to
    const visibleOptions = options.filter(item => item._show);
    let listContent = this.renderWithGroup(visibleOptions);
    if (virtualize) {
      listContent = this.renderVirtualizeList(visibleOptions);
    }
    const style = Object.assign({
      minWidth: dropdownMinWidth
    }, dropdownStyle);
    const optionListCls = classnames_default()({
      [`${prefixcls}-option-list`]: true,
      [`${prefixcls}-option-list-chosen`]: selections.size
    });
    const isEmpty = !options.length || !options.some(item => item._show);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      react.createElement("div", {
        id: `${prefixcls}-${this.selectOptionListID}`,
        className: classnames_default()({
          // When emptyContent is null and the option is empty, there is no need for the drop-down option for the user,
          // so there is no need to set padding through this className
          [`${prefixcls}-option-list-wrapper`]: !(isEmpty && emptyContent === null)
        }, dropdownClassName),
        style: style,
        ref: this.setOptionContainerEl,
        onKeyDown: e => this.foundation.handleContainerKeyDown(e)
      }, outerTopSlot ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixcls}-option-list-outer-top-slot`,
        onMouseEnter: () => this.foundation.handleSlotMouseEnter()
      }, outerTopSlot) : null, searchPosition === select_constants_strings.SEARCH_POSITION_DROPDOWN && filter ? this.renderDropdownInput() : null, /*#__PURE__*/react.createElement("div", {
        style: {
          maxHeight: `${maxHeight}px`
        },
        className: optionListCls,
        role: "listbox",
        "aria-multiselectable": multiple,
        onScroll: e => this.foundation.handleListScroll(e)
      }, innerTopSlot ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixcls}-option-list-inner-top-slot`,
        onMouseEnter: () => this.foundation.handleSlotMouseEnter()
      }, innerTopSlot) : null, loading ? this.renderLoading() : isEmpty ? this.renderEmpty() : listContent, innerBottomSlot ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixcls}-option-list-inner-bottom-slot`,
        onMouseEnter: () => this.foundation.handleSlotMouseEnter()
      }, innerBottomSlot) : null), outerBottomSlot ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixcls}-option-list-outer-bottom-slot`,
        onMouseEnter: () => this.foundation.handleSlotMouseEnter()
      }, outerBottomSlot) : null)
    );
  }
  renderSingleSelection(selections, filterable) {
    let {
      renderSelectedItem,
      searchPosition
    } = this.props;
    const {
      placeholder
    } = this.props;
    const {
      showInput,
      inputValue
    } = this.state;
    let renderText = '';
    const selectedItems = [...selections];
    if (typeof renderSelectedItem === 'undefined') {
      renderSelectedItem = optionNode => optionNode.label;
    }
    if (selectedItems.length) {
      const selectedItem = selectedItems[0][1];
      renderText = renderSelectedItem(selectedItem);
    }
    const showInputInTrigger = searchPosition === select_constants_strings.SEARCH_POSITION_TRIGGER;
    const spanCls = classnames_default()({
      [`${prefixcls}-selection-text`]: true,
      [`${prefixcls}-selection-placeholder`]: !renderText && renderText !== 0,
      [`${prefixcls}-selection-text-hide`]: inputValue && showInput && showInputInTrigger,
      [`${prefixcls}-selection-text-inactive`]: !inputValue && showInput && showInputInTrigger // Stack Input & RenderText(opacity 0.4)
    });

    const contentWrapperCls = `${prefixcls}-content-wrapper`;
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: contentWrapperCls
    }, /*#__PURE__*/react.createElement("span", {
      className: spanCls,
      "x-semi-prop": "placeholder"
    }, renderText || renderText === 0 ? renderText : placeholder), filterable && showInput && showInputInTrigger ? this.renderTriggerInput() : null));
  }
  renderTag(item, i, isCollapseItem) {
    const {
      size,
      disabled: selectDisabled
    } = this.props;
    let {
      renderSelectedItem
    } = this.props;
    const label = item[0];
    const {
      value
    } = item[1];
    const disabled = item[1].disabled || selectDisabled;
    const onClose = (tagContent, e) => {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault(); // make sure that tag will not hidden immediately in controlled mode
      }

      this.foundation.removeTag({
        label,
        value
      });
    };
    if (typeof renderSelectedItem === 'undefined') {
      renderSelectedItem = optionNode => ({
        isRenderInTag: true,
        content: optionNode.label
      });
    }
    const {
      content,
      isRenderInTag
    } = renderSelectedItem(item[1], {
      index: i,
      disabled,
      onClose
    });
    const basic = {
      disabled,
      closable: !disabled,
      onClose
    };
    const realContent = isCollapseItem && !isFunction_default()(this.props.renderSelectedItem) ? /*#__PURE__*/react.createElement(Text, {
      size: 'small',
      ellipsis: {
        rows: 1,
        showTooltip: {
          type: 'popover',
          opts: {
            style: {
              width: 'auto',
              fontSize: 12
            }
          }
        }
      }
    }, content) : content;
    if (isRenderInTag) {
      return /*#__PURE__*/react.createElement(Tag, Object.assign({}, basic, {
        color: "white",
        size: size || 'large',
        key: value,
        style: {
          maxWidth: '100%'
        }
      }), realContent);
    } else {
      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: value
      }, realContent);
    }
  }
  renderNTag(n, restTags) {
    const {
      size,
      showRestTagsPopover,
      restTagsPopoverProps
    } = this.props;
    let nTag = /*#__PURE__*/react.createElement(Tag, {
      closable: false,
      size: size || 'large',
      color: 'grey',
      className: `${prefixcls}-content-wrapper-collapse-tag`,
      key: `_+${n}`,
      style: {
        marginRight: 0,
        flexShrink: 0
      }
    }, "+", n);
    if (showRestTagsPopover) {
      nTag = /*#__PURE__*/react.createElement(popover, Object.assign({
        showArrow: true,
        content: /*#__PURE__*/react.createElement(space, {
          spacing: 2,
          wrap: true,
          style: {
            maxWidth: '400px'
          }
        }, restTags.map((tag, index) => this.renderTag(tag, index))),
        trigger: "hover",
        position: "top",
        autoAdjustOverflow: true
      }, restTagsPopoverProps, {
        key: `_+${n}_Popover`
      }), nTag);
    }
    return nTag;
  }
  renderOverflow(items, index) {
    const isCollapse = true;
    return items.length && items[0] ? this.renderTag(items[0], index, isCollapse) : null;
  }
  handleOverflow(items) {
    const {
      overflowItemCount,
      selections
    } = this.state;
    const {
      maxTagCount
    } = this.props;
    const newOverFlowItemCount = selections.size - maxTagCount > 0 ? selections.size - maxTagCount + items.length - 1 : items.length - 1;
    if (overflowItemCount !== newOverFlowItemCount) {
      this.foundation.updateOverflowItemCount(selections.size, newOverFlowItemCount);
    }
  }
  renderCollapsedTags(selections, length) {
    const {
      overflowItemCount
    } = this.state;
    const normalTags = typeof length === 'number' ? selections.slice(0, length) : selections;
    return /*#__PURE__*/react.createElement("div", {
      className: `${prefixcls}-content-wrapper-collapse`
    }, /*#__PURE__*/react.createElement(overflowList, {
      items: normalTags,
      key: String(selections.length),
      overflowRenderer: overflowItems => this.renderOverflow(overflowItems, length - 1),
      onOverflow: overflowItems => this.handleOverflow(overflowItems),
      visibleItemRenderer: (item, index) => this.renderTag(item, index)
    }), overflowItemCount > 0 && this.renderNTag(overflowItemCount, selections.slice(selections.length - overflowItemCount)));
  }
  renderOneLineTags(selectedItems, n) {
    let {
      renderSelectedItem
    } = this.props;
    const {
      showRestTagsPopover,
      restTagsPopoverProps,
      maxTagCount
    } = this.props;
    const {
      isFullTags
    } = this.state;
    let tagContent;
    if (typeof renderSelectedItem === 'undefined') {
      renderSelectedItem = optionNode => ({
        isRenderInTag: true,
        content: optionNode.label
      });
    }
    if (showRestTagsPopover) {
      // showRestTagsPopover = true，
      const mapItems = isFullTags ? selectedItems : selectedItems.slice(0, maxTagCount);
      const tags = mapItems.map((item, i) => {
        return this.getTagItem(item, i, renderSelectedItem);
      });
      tagContent = /*#__PURE__*/react.createElement(TagGroup, {
        tagList: tags,
        maxTagCount: n,
        restCount: isFullTags ? undefined : selectedItems.length - maxTagCount,
        size: "large",
        mode: "custom",
        showPopover: showRestTagsPopover,
        popoverProps: restTagsPopoverProps,
        onPlusNMouseEnter: () => {
          this.foundation.updateIsFullTags();
        }
      });
    } else {
      // If maxTagCount is set, showRestTagsPopover is false/undefined, 
      // then there is no popover when hovering, no extra Tags are displayed, 
      // only the tags and restCount displayed in the trigger need to be passed in
      const mapItems = selectedItems.slice(0, maxTagCount);
      const tags = mapItems.map((item, i) => {
        return this.getTagItem(item, i, renderSelectedItem);
      });
      tagContent = /*#__PURE__*/react.createElement(TagGroup, {
        tagList: tags,
        maxTagCount: n,
        restCount: selectedItems.length - maxTagCount,
        size: "large",
        mode: "custom"
      });
    }
    return tagContent;
  }
  renderMultipleSelection(selections, filterable) {
    let {
      renderSelectedItem,
      searchPosition
    } = this.props;
    const {
      placeholder,
      maxTagCount,
      expandRestTagsOnClick,
      ellipsisTrigger
    } = this.props;
    const {
      inputValue,
      isOpen
    } = this.state;
    const selectedItems = [...selections];
    if (typeof renderSelectedItem === 'undefined') {
      renderSelectedItem = optionNode => ({
        isRenderInTag: true,
        content: optionNode.label
      });
    }
    const contentWrapperCls = classnames_default()({
      [`${prefixcls}-content-wrapper`]: true,
      [`${prefixcls}-content-wrapper-one-line`]: maxTagCount && !isOpen,
      [`${prefixcls}-content-wrapper-empty`]: !selectedItems.length
    });
    const spanCls = classnames_default()({
      [`${prefixcls}-selection-text`]: true,
      [`${prefixcls}-selection-placeholder`]: !selectedItems.length,
      [`${prefixcls}-selection-text-hide`]: selectedItems && selectedItems.length
    });
    const placeholderText = placeholder && !inputValue ? /*#__PURE__*/react.createElement("span", {
      className: spanCls
    }, placeholder) : null;
    const n = selectedItems.length > maxTagCount ? maxTagCount : undefined;
    const NotOneLine = !maxTagCount;
    const oneLineTags = ellipsisTrigger ? this.renderCollapsedTags(selectedItems, n) : this.renderOneLineTags(selectedItems, n);
    const tagContent = NotOneLine || expandRestTagsOnClick && isOpen ? selectedItems.map((item, i) => this.renderTag(item, i)) : oneLineTags;
    const showTriggerInput = filterable && searchPosition === select_constants_strings.SEARCH_POSITION_TRIGGER;
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: contentWrapperCls
    }, selectedItems && selectedItems.length ? tagContent : placeholderText, showTriggerInput ? this.renderTriggerInput() : null));
  }
  onMouseEnter(e) {
    this.foundation.handleMouseEnter(e);
  }
  onMouseLeave(e) {
    this.foundation.handleMouseLeave(e);
  }
  onKeyPress(e) {
    this.foundation.handleKeyPress(e);
  }
  /* Processing logic when popover visible changes */
  handlePopoverVisibleChange(status) {
    const {
      virtualize
    } = this.props;
    const {
      selections
    } = this.state;
    if (!status) {
      return;
    }
    if (virtualize) {
      let minItemIndex = -1;
      selections.forEach(item => {
        const itemIndex = get_default()(item, '_scrollIndex');
        /* When the itemIndex is legal */
        if (isNumber_default()(itemIndex) && itemIndex >= 0) {
          minItemIndex = minItemIndex !== -1 && minItemIndex < itemIndex ? minItemIndex : itemIndex;
        }
      });
      if (minItemIndex !== -1) {
        try {
          this.virtualizeListRef.current.scrollToItem(minItemIndex, 'center');
        } catch (error) {}
      }
    } else {
      this.foundation.updateScrollTop();
    }
  }
  renderSuffix() {
    const {
      suffix
    } = this.props;
    const suffixWrapperCls = classnames_default()({
      [`${prefixcls}-suffix`]: true,
      [`${prefixcls}-suffix-text`]: suffix && isString_default()(suffix),
      [`${prefixcls}-suffix-icon`]: isSemiIcon(suffix)
    });
    return /*#__PURE__*/react.createElement("div", {
      className: suffixWrapperCls,
      "x-semi-prop": "suffix"
    }, suffix);
  }
  renderPrefix() {
    const {
      prefix,
      insetLabel,
      insetLabelId
    } = this.props;
    const labelNode = prefix || insetLabel;
    const prefixWrapperCls = classnames_default()({
      [`${prefixcls}-prefix`]: true,
      [`${prefixcls}-inset-label`]: insetLabel,
      [`${prefixcls}-prefix-text`]: labelNode && isString_default()(labelNode),
      [`${prefixcls}-prefix-icon`]: isSemiIcon(labelNode)
    });
    return /*#__PURE__*/react.createElement("div", {
      className: prefixWrapperCls,
      id: insetLabelId,
      "x-semi-prop": "prefix,insetLabel"
    }, labelNode);
  }
  renderSelection() {
    const _a = this.props,
      {
        disabled,
        multiple,
        filter,
        style,
        id,
        size,
        className,
        validateStatus,
        showArrow,
        suffix,
        prefix,
        insetLabel,
        placeholder,
        triggerRender,
        arrowIcon,
        clearIcon,
        borderless
      } = _a,
      rest = select_rest(_a, ["disabled", "multiple", "filter", "style", "id", "size", "className", "validateStatus", "showArrow", "suffix", "prefix", "insetLabel", "placeholder", "triggerRender", "arrowIcon", "clearIcon", "borderless"]);
    const {
      selections,
      isOpen,
      keyboardEventSet,
      inputValue,
      isHovering,
      isFocus,
      showInput,
      focusIndex
    } = this.state;
    const useCustomTrigger = typeof triggerRender === 'function';
    const filterable = Boolean(filter); // filter（boolean || function）
    const selectionCls = useCustomTrigger ? classnames_default()(className) : classnames_default()(prefixcls, className, {
      [`${prefixcls}-borderless`]: borderless,
      [`${prefixcls}-open`]: isOpen,
      [`${prefixcls}-focus`]: isFocus,
      [`${prefixcls}-disabled`]: disabled,
      [`${prefixcls}-single`]: !multiple,
      [`${prefixcls}-multiple`]: multiple,
      [`${prefixcls}-filterable`]: filterable,
      [`${prefixcls}-small`]: size === 'small',
      [`${prefixcls}-large`]: size === 'large',
      [`${prefixcls}-error`]: validateStatus === 'error',
      [`${prefixcls}-warning`]: validateStatus === 'warning',
      [`${prefixcls}-no-arrow`]: !showArrow,
      [`${prefixcls}-with-prefix`]: prefix || insetLabel,
      [`${prefixcls}-with-suffix`]: suffix
    });
    const showClear = this.props.showClear && (selections.size || inputValue) && !disabled && (isHovering || isOpen);
    const arrowContent = showArrow ? /*#__PURE__*/react.createElement("div", {
      className: `${prefixcls}-arrow`,
      "x-semi-prop": "arrowIcon"
    }, arrowIcon) : /*#__PURE__*/react.createElement("div", {
      className: `${prefixcls}-arrow-empty`
    });
    const clear = clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, null);
    // semantics of onSearch are more in line with behavior, onChange is alias of onSearch, will be deprecate next major version
    const inner = useCustomTrigger ? /*#__PURE__*/react.createElement(trigger, {
      value: Array.from(selections.values()),
      inputValue: inputValue,
      onChange: this.handleInputChange,
      onSearch: this.handleInputChange,
      onRemove: item => this.foundation.removeTag(item),
      onClear: this.onClear,
      disabled: disabled,
      triggerRender: triggerRender,
      placeholder: placeholder,
      componentName: "Select",
      componentProps: Object.assign({}, this.props)
    }) : [/*#__PURE__*/react.createElement(react.Fragment, {
      key: "prefix"
    }, prefix || insetLabel ? this.renderPrefix() : null), /*#__PURE__*/react.createElement(react.Fragment, {
      key: "selection"
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixcls}-selection`)
    }, multiple ? this.renderMultipleSelection(selections, filterable) : this.renderSingleSelection(selections, filterable))), /*#__PURE__*/react.createElement(react.Fragment, {
      key: "clearicon"
    }, showClear ? /*#__PURE__*/react.createElement("div", {
      className: classnames_default()(`${prefixcls}-clear`),
      onClick: this.onClear
    }, clear) : arrowContent), /*#__PURE__*/react.createElement(react.Fragment, {
      key: "suffix"
    }, suffix ? this.renderSuffix() : null)];
    /**
     *
     * In disabled, searchable single-selection and display input, and searchable multi-selection
     * make combobox not focusable by tab key
     *
     * 在disabled，可搜索单选且显示input框，以及可搜索多选情况下
     * 让combobox无法通过tab聚焦
     */
    const tabIndex = disabled || filterable && showInput || filterable && multiple ? -1 : 0;
    return (
      /*#__PURE__*/
      /* eslint-disable-next-line jsx-a11y/aria-activedescendant-has-tabindex */
      react.createElement("div", Object.assign({
        role: "combobox",
        "aria-disabled": disabled,
        "aria-expanded": isOpen,
        "aria-controls": `${prefixcls}-${this.selectOptionListID}`,
        "aria-haspopup": "listbox",
        "aria-label": selections.size ? 'selected' : '',
        "aria-invalid": this.props['aria-invalid'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-required": this.props['aria-required'],
        className: selectionCls,
        ref: ref => this.triggerRef.current = ref,
        onClick: e => this.foundation.handleClick(e),
        style: style,
        id: this.selectID,
        tabIndex: tabIndex,
        "aria-activedescendant": focusIndex !== -1 ? `${this.selectID}-option-${focusIndex}` : '',
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onFocus: e => this.foundation.handleTriggerFocus(e),
        onBlur: e => this.foundation.handleTriggerBlur(e),
        onKeyPress: this.onKeyPress
      }, keyboardEventSet, this.getDataAttr(rest)), inner)
    );
  }
  render() {
    const {
      direction
    } = this.context;
    const defaultPosition = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    const {
      children,
      position = defaultPosition,
      zIndex,
      getPopupContainer,
      motion,
      autoAdjustOverflow,
      mouseLeaveDelay,
      mouseEnterDelay,
      spacing,
      stopPropagation,
      dropdownMargin
    } = this.props;
    const {
      isOpen,
      optionKey
    } = this.state;
    const optionList = this.renderOptions(children);
    const selection = this.renderSelection();
    return /*#__PURE__*/react.createElement(popover, {
      getPopupContainer: getPopupContainer,
      motion: motion,
      margin: dropdownMargin,
      autoAdjustOverflow: autoAdjustOverflow,
      mouseLeaveDelay: mouseLeaveDelay,
      mouseEnterDelay: mouseEnterDelay,
      // transformFromCenter TODO: check no such property
      zIndex: zIndex,
      ref: this.optionsRef,
      content: optionList,
      visible: isOpen,
      trigger: "custom",
      rePosKey: optionKey,
      position: position,
      spacing: spacing,
      stopPropagation: stopPropagation,
      disableArrowKeyDown: true,
      onVisibleChange: status => this.handlePopoverVisibleChange(status),
      afterClose: () => this.foundation.handlePopoverClose()
    }, selection);
  }
}
Select.contextType = context;
Select.Option = select_option;
Select.OptGroup = optionGroup;
Select.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  autoFocus: (prop_types_default()).bool,
  autoClearSearchValue: (prop_types_default()).bool,
  borderless: (prop_types_default()).bool,
  children: (prop_types_default()).node,
  clearIcon: (prop_types_default()).node,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array, (prop_types_default()).object]),
  ellipsisTrigger: (prop_types_default()).bool,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array, (prop_types_default()).object]),
  placeholder: (prop_types_default()).node,
  onChange: (prop_types_default()).func,
  multiple: (prop_types_default()).bool,
  // Whether to turn on the input box filtering function, when it is a function, it represents a custom filtering function
  filter: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  // How many tags can you choose?
  max: (prop_types_default()).number,
  // How many tabs are displayed at most, and the rest are displayed in + N
  maxTagCount: (prop_types_default()).number,
  maxHeight: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  size: prop_types_default().oneOf(select_constants_strings.SIZE_SET),
  disabled: (prop_types_default()).bool,
  emptyContent: (prop_types_default()).node,
  expandRestTagsOnClick: (prop_types_default()).bool,
  onDropdownVisibleChange: (prop_types_default()).func,
  zIndex: (prop_types_default()).number,
  position: prop_types_default().oneOf(select_constants_strings.POSITION_SET),
  onSearch: (prop_types_default()).func,
  getPopupContainer: (prop_types_default()).func,
  dropdownClassName: (prop_types_default()).string,
  dropdownStyle: (prop_types_default()).object,
  dropdownMargin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  outerTopSlot: (prop_types_default()).node,
  innerTopSlot: (prop_types_default()).node,
  inputProps: (prop_types_default()).object,
  outerBottomSlot: (prop_types_default()).node,
  innerBottomSlot: (prop_types_default()).node,
  optionList: (prop_types_default()).array,
  dropdownMatchSelectWidth: (prop_types_default()).bool,
  loading: (prop_types_default()).bool,
  defaultOpen: (prop_types_default()).bool,
  validateStatus: prop_types_default().oneOf(select_constants_strings.STATUS),
  defaultActiveFirstOption: (prop_types_default()).bool,
  triggerRender: (prop_types_default()).func,
  stopPropagation: (prop_types_default()).bool,
  searchPosition: (prop_types_default()).string,
  // motion doesn't need to be exposed
  motion: (prop_types_default()).bool,
  onChangeWithObject: (prop_types_default()).bool,
  suffix: (prop_types_default()).node,
  prefix: (prop_types_default()).node,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  showClear: (prop_types_default()).bool,
  showArrow: (prop_types_default()).bool,
  renderSelectedItem: (prop_types_default()).func,
  allowCreate: (prop_types_default()).bool,
  renderCreateItem: (prop_types_default()).func,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  clickToHide: (prop_types_default()).bool,
  onExceed: (prop_types_default()).func,
  onCreate: (prop_types_default()).func,
  remote: (prop_types_default()).bool,
  onDeselect: (prop_types_default()).func,
  // The main difference between onSelect and onChange is that when multiple selections are selected, onChange contains all options, while onSelect only contains items for the current operation
  onSelect: (prop_types_default()).func,
  autoAdjustOverflow: (prop_types_default()).bool,
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  spacing: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  virtualize: (prop_types_default()).object,
  renderOptionItem: (prop_types_default()).func,
  onListScroll: (prop_types_default()).func,
  arrowIcon: (prop_types_default()).node,
  preventScroll: (prop_types_default()).bool
  // open: PropTypes.bool,
  // tagClosable: PropTypes.bool,
};

Select.__SemiComponentName__ = "Select";
Select.defaultProps = getDefaultPropsFromGlobalConfig(Select.__SemiComponentName__, {
  stopPropagation: true,
  motion: true,
  borderless: false,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  // position: 'bottomLeft',
  filter: false,
  multiple: false,
  disabled: false,
  defaultOpen: false,
  allowCreate: false,
  placeholder: '',
  onDropdownVisibleChange: (noop_default()),
  onChangeWithObject: false,
  onChange: (noop_default()),
  onSearch: (noop_default()),
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default()),
  onDeselect: (noop_default()),
  onSelect: (noop_default()),
  onCreate: (noop_default()),
  onExceed: (noop_default()),
  onFocus: (noop_default()),
  onBlur: (noop_default()),
  onClear: (noop_default()),
  onListScroll: (noop_default()),
  maxHeight: select_constants_numbers.LIST_HEIGHT,
  dropdownMatchSelectWidth: true,
  defaultActiveFirstOption: true,
  showArrow: true,
  showClear: false,
  searchPosition: select_constants_strings.SEARCH_POSITION_TRIGGER,
  remote: false,
  autoAdjustOverflow: true,
  autoClearSearchValue: true,
  arrowIcon: /*#__PURE__*/react.createElement(IconChevronDown, {
    "aria-label": ''
  }),
  showRestTagsPopover: false,
  restTagsPopoverProps: {},
  expandRestTagsOnClick: false,
  ellipsisTrigger: false
  // Radio selection is different from the default renderSelectedItem for multiple selection, so it is not declared here
  // renderSelectedItem: (optionNode) => optionNode.label,
  // The default creator rendering is related to i18, so it is not declared here
  // renderCreateItem: (input) => input
});

/* harmony default export */ var es_select = (Select);
// EXTERNAL MODULE: ./node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(7654);
var isNaN_default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN);
// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__(13218);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);
// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(52628);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
// EXTERNAL MODULE: ./node_modules/lodash/unset.js
var unset = __webpack_require__(98601);
var unset_default = /*#__PURE__*/__webpack_require__.n(unset);
// EXTERNAL MODULE: ./node_modules/lodash/toPath.js
var toPath = __webpack_require__(30084);
var toPath_default = /*#__PURE__*/__webpack_require__.n(toPath);
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(18721);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/object.js








const pathToArrayElem = path => {
  const pathArray = toPath_default()(path);
  // internal-issues:673
  const justNumber = isNumber_default()(path) && pathArray.length === 1;
  return justNumber ? false : Number.isInteger(+pathArray[pathArray.length - 1]);
};
function isEmptyObject(target) {
  /**
   *  var a = {};
   *  var b = { c: undefined }
   *  var d = {
   *      e: function(){},
   *      f: Symbol(''),
   *  }
   *  the result of JSON.stringify(a/b/d) are same: '{}'
   *  We can use the above features to remove keys with empty values in Form
   *  But we cannot use JSON.stringify() directly, because if the input parameter of JSON.stringify includes fiberNode, it will cause an TypeError: 'Converting circular structure to JSON'
   *  So we have to mock it's behavior, also, the form value cannot have Symbol or function type, it can be ignored
   */
  if (!isObject_default()(target)) {
    return false;
  } else {
    const valuesOfTarget = values_default()(target);
    // values(a)  ->   []
    // values(b)  ->   [undefined]
    if (!valuesOfTarget.length) {
      return true; // like target: {}
    } else {
      return valuesOfTarget.every(item => typeof item === 'undefined');
    }
  }
}
function cleanup(obj, path) {
  let pull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (path.length === 0) {
    return;
  }
  const target = get_default()(obj, path);
  // remove undefined from array
  // if (Array.isArray(target) && pull) {
  //     // only remove undefined form array from right to left
  //     // Remove undefined from right to left
  //     let lastIndex = findLastIndex(target, item => !isUndefined(item));
  //     lodashRemove(target, (value, index, array) => index > lastIndex);
  // }
  // Delete object if its empty
  if (Array.isArray(target) && target.every(e => e == null)) {
    unset_default()(obj, path);
  } else if (isEmptyObject(target)) {
    unset_default()(obj, path);
  }
  // Recur
  cleanup(obj, path.slice(0, path.length - 1), pull);
}
function empty(object) {
  return values_default()(object).length === 0;
}
function object_get(object, path) {
  return get_default()(object, path);
}
function remove(object, path) {
  unset_default()(object, path);
  // a.b => [a, b]
  // arr[11].a => [arr, 11, a]
  let pathArray = toPath_default()(path);
  pathArray = pathArray.slice(0, pathArray.length - 1);
  cleanup(object, pathArray, false);
}
function object_set(object, path, value, allowEmpty) {
  if (allowEmpty) {
    return set_default()(object, path, value);
  }
  if (value !== undefined) {
    return set_default()(object, path, value);
  } else {
    // If the path is to an array leaf then we want to set to undefined
    // 将数组的叶子节点置为undefined时，例如 a.b[0]  a.b[1]  a.b[99]
    if (pathToArrayElem(path) && object_get(object, path) !== undefined) {
      set_default()(object, path, undefined);
      let pathArray = toPath_default()(path);
      pathArray = pathArray.slice(0, pathArray.length - 1);
      cleanup(object, pathArray, false);
    } else if (!pathToArrayElem(path) && object_get(object, path) !== undefined) {
      // Only delete the field if it needs to be deleted and its not a path to an array ( array leaf )
      // eg:
      /*
          When the non-array leaf node is set to undefined
          for example: a.b.c
      */
      remove(object, path);
    }
  }
}
function object_has(object, path) {
  return _has(object, path);
}
/**
 * set static properties from `srcObj` to `obj`
 * @param {object|Function} obj
 * @param {object|Function} srcObj
 * @returns {object|Function}
 */
function forwardStatics(obj, srcObj) {
  if (obj && (typeof obj === 'function' || typeof obj === 'object') && srcObj && (typeof srcObj === 'function' || typeof srcObj === 'object')) {
    Object.entries(srcObj).forEach(_ref => {
      let [key, value] = _ref;
      obj[key] = value;
    });
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isBothNaN.js
/**
 * Determine whether both values are NaN
 * @param {*} a
 * @param {*} b
 * @returns {Boolean}
 */
const isBothNaN = (a, b) => {
  const {
    isNaN
  } = Number;
  return isNaN(a) && isNaN(b);
};
/* harmony default export */ var utils_isBothNaN = (isBothNaN);
// EXTERNAL MODULE: ./node_modules/lodash/toString.js
var lodash_toString = __webpack_require__(79833);
var toString_default = /*#__PURE__*/__webpack_require__.n(lodash_toString);
// EXTERNAL MODULE: ./node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(14841);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/inputNumber/constants.js

const inputNumber_constants_cssClasses = Object.assign({}, input_constants_cssClasses);
const inputNumber_constants_numbers = Object.assign(Object.assign({}, input_constants_numbers), {
  DEFAULT_STEP: 1,
  DEFAULT_SHIFT_STEP: 10,
  DEFAULT_PRESS_TIMEOUT: 250,
  DEFAULT_PRESS_INTERVAL: 0,
  MOUSE_BUTTON_LEFT: 0
});
const inputNumber_constants_strings = Object.assign({}, input_constants_strings);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/number.js
/**
 * Solve the problem of js addition accuracy
 * e.g.
 *  0.1 + 0.2 => 0.30000000000000004
 *  plus(0.1, 0.2) => 0.3
 * @param {Number} num1
 * @param {Number} num2
 */
function plus(num1, num2) {
  const num1Digits = (num1.toString().split('.')[1] || '').length;
  const num2Digits = (num2.toString().split('.')[1] || '').length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}
function minus(num1, num2) {
  return plus(num1, -num2);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/inputNumber/foundation.js








class InputNumberFoundation extends foundation {
  init() {
    this._setInitValue();
  }
  destroy() {
    this._unregisterInterval();
    this._unregisterTimer();
    this._adapter.unregisterGlobalEvent('mouseup');
  }
  isControlled() {
    return this._isControlledComponent('value');
  }
  _doInput() {
    let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let updateCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let notifyVal = v;
    let number = v;
    let isValidNumber = true;
    const isControlled = this.isControlled();
    // console.log(v);
    if (typeof v !== 'number') {
      number = this.doParse(v, false);
      isValidNumber = !isNaN(number);
    }
    if (isValidNumber) {
      notifyVal = number;
      if (!isControlled) {
        this._adapter.setNumber(number);
      }
    }
    if (!isControlled) {
      this._adapter.setValue(v, updateCb);
    }
    if (this.getProp('keepFocus')) {
      this._adapter.setFocusing(true, () => {
        this._adapter.setClickUpOrDown(true);
      });
    }
    this.notifyChange(notifyVal, event);
  }
  _registerInterval(cb) {
    const pressInterval = this.getProp('pressInterval') || inputNumber_constants_numbers.DEFAULT_PRESS_INTERVAL;
    this._intervalHasRegistered = true;
    this._interval = setInterval(() => {
      if (typeof cb === 'function' && this._intervalHasRegistered) {
        cb();
      }
    }, pressInterval);
  }
  _unregisterInterval() {
    if (this._interval) {
      this._intervalHasRegistered = false;
      clearInterval(this._interval);
      this._interval = null;
    }
  }
  _registerTimer(cb) {
    const pressTimeout = this.getProp('pressTimeout') || inputNumber_constants_numbers.DEFAULT_PRESS_TIMEOUT;
    this._timerHasRegistered = true;
    this._timer = setTimeout(() => {
      if (this._timerHasRegistered && typeof cb === 'function') {
        cb();
      }
    }, pressTimeout);
  }
  _unregisterTimer() {
    if (this._timer) {
      this._timerHasRegistered = false;
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  handleInputFocus(e) {
    const value = this.getState('value');
    if (value !== '') {
      // let parsedStr = this.doParse(this.getState('value'));
      // this._adapter.setValue(Number(parsedStr));
    }
    this._adapter.recordCursorPosition();
    this._adapter.setFocusing(true, null);
    this._adapter.setClickUpOrDown(false);
    this._adapter.notifyFocus(e);
  }
  /**
   * Input box content update processing
   * @param {String} value
   * @param {*} event
   */
  handleInputChange(value, event) {
    // Check accuracy, adjust accuracy, adjust maximum and minimum values, call parser to parse the number
    const parsedNum = this.doParse(value, true, true, true);
    // Parser parsed number, type Number (normal number or NaN)
    const toNum = this.doParse(value, false, false, false);
    // String converted from parser parsed numbers or directly converted without parser
    const valueAfterParser = this.afterParser(value);
    this._adapter.recordCursorPosition();
    let notifyVal;
    let num = toNum;
    // The formatted input value
    let formattedNum = value;
    if (value === '') {
      if (!this.isControlled()) {
        num = null;
      }
    } else if (this.isValidNumber(toNum) && this.isValidNumber(parsedNum)) {
      notifyVal = toNum;
      formattedNum = this.doFormat(toNum, false);
    } else {
      /**
       * This logic is used to solve the problem that parsedNum is not a valid number
       */
      if (typeof toNum === 'number' && !isNaN(toNum)) {
        formattedNum = this.doFormat(toNum, false);
        // console.log(`parsedStr: `, parsedStr, `toNum: `, toNum);
        const dotIndex = valueAfterParser.lastIndexOf('.');
        const lengthAfterDot = valueAfterParser.length - 1 - dotIndex;
        const precLength = this._getPrecLen(toNum);
        if (!precLength) {
          const dotBeginStr = dotIndex > -1 ? valueAfterParser.slice(dotIndex) : '';
          formattedNum += dotBeginStr;
        } else if (precLength < lengthAfterDot) {
          for (let i = 0; i < lengthAfterDot - precLength; i++) {
            formattedNum += '0';
          }
        }
        // NOUSE:
        num = toNum;
      } else {
        /**
         * When the user enters an illegal character, it needs to go through parser and format before displaying
         * Ensure that all input is processed by parser and format
         *
         * 用户输入非法字符时，需要经过 parser 和 format 一下再显示
         * 保证所有的输入都经过 parser 和 format 处理
         */
        formattedNum = this.doFormat(valueAfterParser, false);
      }
      notifyVal = valueAfterParser;
    }
    if (!this.isControlled() && (num === null || typeof num === 'number' && !isNaN(num))) {
      this._adapter.setNumber(num);
    }
    this._adapter.setValue(this.isControlled() ? formattedNum : this.doFormat(valueAfterParser, false), () => {
      this._adapter.restoreCursor();
    });
    this.notifyChange(notifyVal, event);
  }
  handleInputKeyDown(event) {
    const code = event.keyCode;
    if (code === utils_keyCode.UP || code === utils_keyCode.DOWN) {
      this._adapter.setClickUpOrDown(true);
      this._adapter.recordCursorPosition();
      const formattedVal = code === utils_keyCode.UP ? this.add(null, event) : this.minus(null, event);
      this._doInput(formattedVal, event, () => {
        this._adapter.restoreCursor();
      });
      event.preventDefault();
    }
    this._adapter.notifyKeyDown(event);
  }
  handleInputBlur(e) {
    const currentValue = toString_default()(this.getState('value'));
    let currentNumber = this.getState('number');
    if (currentNumber != null || currentValue != null && currentValue !== '') {
      const parsedNum = this.doParse(currentValue, false, true, true);
      let numHasChanged = false;
      let strHasChanged = false;
      let willSetNum, willSetVal;
      if (this.isValidNumber(parsedNum) && currentNumber !== parsedNum) {
        willSetNum = parsedNum;
        if (!this.isControlled()) {
          currentNumber = willSetNum;
        }
        numHasChanged = true;
      }
      const currentFormattedNum = this.doFormat(currentNumber, true);
      if (currentFormattedNum !== currentValue) {
        willSetVal = currentFormattedNum;
        strHasChanged = true;
      }
      if (strHasChanged || numHasChanged) {
        const notifyVal = willSetVal != null ? willSetVal : willSetNum;
        if (willSetVal != null) {
          this._adapter.setValue(willSetVal);
          // this.notifyChange(willSetVal);
        }

        if (willSetNum != null) {
          if (!this._isControlledComponent('value')) {
            this._adapter.setNumber(willSetNum);
          }
          // this.notifyChange(willSetNum);
        }

        this.notifyChange(notifyVal, e);
      }
    }
    this._adapter.setFocusing(false);
    this._adapter.notifyBlur(e);
  }
  handleInputMouseEnter(event) {
    this._adapter.setHovering(true);
  }
  handleInputMouseLeave(event) {
    this._adapter.setHovering(false);
  }
  handleInputMouseMove(event) {
    this._adapter.setHovering(true);
  }
  handleMouseUp(e) {
    this._unregisterInterval();
    this._unregisterTimer();
    this._adapter.unregisterGlobalEvent('mouseup');
  }
  handleUpClick(event) {
    const {
      readonly
    } = this.getProps();
    if (!this._isMouseButtonLeft(event) || readonly) {
      return;
    }
    this._adapter.setClickUpOrDown(true);
    if (event) {
      this._persistEvent(event);
      event.stopPropagation();
      // Prevent native blurring events
      this._preventDefault(event);
    }
    this.upClick(event);
    // Cannot access event objects asynchronously https://reactjs.org/docs/events.html#event-pooling
    this._registerTimer(() => {
      this._registerInterval(() => {
        this.upClick(event);
      });
    });
  }
  handleDownClick(event) {
    const {
      readonly
    } = this.getProps();
    if (!this._isMouseButtonLeft(event) || readonly) {
      return;
    }
    this._adapter.setClickUpOrDown(true);
    if (event) {
      this._persistEvent(event);
      event.stopPropagation();
      this._preventDefault(event);
    }
    this.downClick(event);
    this._registerTimer(() => {
      this._registerInterval(() => {
        this.downClick(event);
      });
    });
  }
  /**
   * Whether it is a left mouse button click
   * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
   */
  _isMouseButtonLeft(event) {
    return get_default()(event, 'button') === inputNumber_constants_numbers.MOUSE_BUTTON_LEFT;
  }
  _preventDefault(event) {
    const keepFocus = this._adapter.getProp('keepFocus');
    const innerButtons = this._adapter.getProp('innerButtons');
    if (keepFocus || innerButtons) {
      event.preventDefault();
    }
  }
  handleMouseLeave(event) {
    this._adapter.registerGlobalEvent('mouseup', () => {
      this.handleMouseUp(event);
    });
  }
  upClick(event) {
    const value = this.add(null, event);
    this._doInput(value, event);
    this._adapter.notifyUpClick(value, event);
  }
  downClick(event) {
    const value = this.minus(null, event);
    this._doInput(value, event);
    this._adapter.notifyDownClick(value, event);
  }
  _setInitValue() {
    const {
      defaultValue,
      value
    } = this.getProps();
    const propsValue = this._isControlledComponent('value') ? value : defaultValue;
    const tmpNumber = this.doParse(toString_default()(propsValue), false, true, true);
    let number = null;
    if (typeof tmpNumber === 'number' && !isNaN(tmpNumber)) {
      number = tmpNumber;
    }
    const formattedValue = typeof number === 'number' ? this.doFormat(number, true) : '';
    this._adapter.setNumber(number);
    this._adapter.setValue(formattedValue);
    if (isString_default()(formattedValue) && formattedValue !== String(propsValue !== null && propsValue !== void 0 ? propsValue : '')) {
      this.notifyChange(formattedValue, null);
    }
  }
  add(step, event) {
    const pressShift = event && event.shiftKey;
    const propStep = pressShift ? this.getProp('shiftStep') : this.getProp('step');
    step = step == null ? propStep : Number(step);
    const stepAbs = Math.abs(toNumber_default()(step));
    const curVal = this.getState('number');
    let curNum = this.toNumber(curVal) || 0;
    const min = this.getProp('min');
    const max = this.getProp('max');
    const minPrecLen = this._getPrecLen(min);
    const maxPrecLen = this._getPrecLen(max);
    const curPrecLen = this._getPrecLen(curNum);
    const stepPrecLen = this._getPrecLen(step);
    const scale = Math.pow(10, Math.max(minPrecLen, maxPrecLen, curPrecLen, stepPrecLen));
    if (step < 0) {
      // Js accuracy problem
      if (Math.abs(minus(min, curNum)) >= stepAbs) {
        curNum = (curNum * scale + step * scale) / scale;
      }
    } else if (step > 0) {
      if (Math.abs(minus(max, curNum)) >= stepAbs) {
        curNum = (curNum * scale + step * scale) / scale;
      }
    }
    if (typeof min === 'number' && min > curNum) {
      curNum = min;
    }
    if (typeof max === 'number' && max < curNum) {
      curNum = max;
    }
    // console.log('scale: ', scale, 'curNum: ', curNum);
    return this.doFormat(curNum, true);
  }
  minus(step, event) {
    const pressShift = event && event.shiftKey;
    const propStep = pressShift ? this.getProp('shiftStep') : this.getProp('step');
    step = step == null ? propStep : Number(step);
    return this.add(-step, event);
  }
  /**
   * get decimal length
   * @param {number} num
   * @returns {number}
   */
  _getPrecLen(num) {
    if (typeof num !== 'string') {
      num = String(Math.abs(Number(num || '')));
    }
    const idx = num.indexOf('.') + 1;
    return idx ? num.length - idx : 0;
  }
  _adjustPrec(num) {
    const precision = this.getProp('precision');
    if (typeof precision === 'number' && num !== '' && num !== null && !Number.isNaN(Number(num))) {
      num = Number(num).toFixed(precision);
    }
    return toString_default()(num);
  }
  /**
   * format number to string
   * @param {string|number} value
   * @param {boolean} needAdjustPrec
   * @returns {string}
   */
  doFormat() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let needAdjustPrec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // if (typeof value === 'string') {
    //     return value;
    // }
    let str;
    const formatter = this.getProp('formatter');
    if (needAdjustPrec) {
      str = this._adjustPrec(value);
    } else {
      str = toString_default()(value);
    }
    if (typeof formatter === 'function') {
      str = formatter(str);
    }
    return str;
  }
  /**
   *
   * @param {number} current
   * @returns {number}
   */
  fetchMinOrMax(current) {
    const {
      min,
      max
    } = this.getProps();
    if (current < min) {
      return min;
    } else if (current > max) {
      return max;
    }
    return current;
  }
  /**
   * parse to number
   * @param {string|number} value
   * @param {boolean} needCheckPrec
   * @param {boolean} needAdjustPrec
   * @param {boolean} needAdjustMaxMin
   * @returns {number}
   */
  doParse(value) {
    let needCheckPrec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let needAdjustPrec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let needAdjustMaxMin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (typeof value === 'number') {
      if (needAdjustMaxMin) {
        value = this.fetchMinOrMax(value);
      }
      if (needAdjustPrec) {
        value = this._adjustPrec(value);
      }
      return toNumber_default()(value);
    }
    const parser = this.getProp('parser');
    if (typeof parser === 'function') {
      value = parser(value);
    }
    if (needCheckPrec && typeof value === 'string') {
      const zeroIsValid = value.indexOf('.') === -1 || value.indexOf('.') > -1 && (value === '0' || value.lastIndexOf('0') < value.length - 1);
      const dotIsValid = value.lastIndexOf('.') < value.length - 1 && value.split('').filter(v => v === '.').length < 2;
      if (!zeroIsValid || !dotIsValid
      // (this.getProp('precision') > 0 && this._getPrecLen(value) > this.getProp('precision'))
      ) {
        return NaN;
      }
    }
    if (needAdjustPrec) {
      value = this._adjustPrec(value);
    }
    if (typeof value === 'string' && value.length) {
      return needAdjustMaxMin ? this.fetchMinOrMax(toNumber_default()(value)) : toNumber_default()(value);
    }
    return NaN;
  }
  /**
   * Parsing the input value
   * @param {string} value
   * @returns {string}
   */
  afterParser(value) {
    const parser = this.getProp('parser');
    if (typeof value === 'string' && typeof parser === 'function') {
      return toString_default()(parser(value));
    }
    return toString_default()(value);
  }
  toNumber(value) {
    let needAdjustPrec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      const parser = this.getProp('parser');
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (needAdjustPrec) {
        value = this._adjustPrec(value);
      }
    }
    return toNumber_default()(value);
  }
  /**
   * Returning true requires both:
   * 1.type is number and not equal to NaN
   * 2.min < = value < = max
   * 3.length after decimal point requires < = precision | | No precision
   * @param {*} um
   * @param {*} needCheckPrec
   * @returns
   */
  isValidNumber(num) {
    let needCheckPrec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (typeof num === 'number' && !isNaN(num)) {
      const {
        min,
        max,
        precision
      } = this.getProps();
      const numPrec = this._getPrecLen(num);
      const precIsValid = needCheckPrec ? typeof precision === 'number' && numPrec <= precision || typeof precision !== 'number' : true;
      if (num >= min && num <= max && precIsValid) {
        return true;
      }
    }
    return false;
  }
  isValidString(str) {
    if (typeof str === 'string' && str.length) {
      const parsedNum = this.doParse(str);
      return this.isValidNumber(parsedNum);
    }
    return false;
  }
  notifyChange(value, e) {
    if (value == null || value === '') {
      this._adapter.notifyChange('', e);
    } else {
      const parsedNum = this.toNumber(value, true);
      if (typeof parsedNum === 'number' && !isNaN(parsedNum)) {
        // this._adapter.notifyChange(typeof value === 'number' ? parsedNum : this.afterParser(value), e);
        this._adapter.notifyChange(parsedNum, e);
        this.notifyNumberChange(parsedNum, e);
      } else {
        this._adapter.notifyChange(this.afterParser(value), e);
      }
    }
  }
  notifyNumberChange(value, e) {
    const {
      number
    } = this.getStates();
    // Does not trigger numberChange if value is not a significant number
    if (this.isValidNumber(value) && value !== number) {
      this._adapter.notifyNumberChange(value, e);
    }
  }
  updateStates(states, callback) {
    this._adapter.updateStates(states, callback);
  }
}
/* harmony default export */ var inputNumber_foundation = (InputNumberFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/inputNumber/index.js



var inputNumber_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */











// import '@douyinfe/semi-foundation/lib/es/inputNumber/inputNumber.css';
class InputNumber extends BaseComponent {
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      setValue: (value, cb) => this.setState({
        value
      }, cb),
      setNumber: (number, cb) => this.setState({
        number
      }, cb),
      setFocusing: (focusing, cb) => this.setState({
        focusing
      }, cb),
      setHovering: hovering => this.setState({
        hovering
      }),
      notifyChange: function () {
        return _this.props.onChange(...arguments);
      },
      notifyNumberChange: function () {
        return _this.props.onNumberChange(...arguments);
      },
      notifyBlur: e => this.props.onBlur(e),
      notifyFocus: e => this.props.onFocus(e),
      notifyUpClick: (value, e) => this.props.onUpClick(value, e),
      notifyDownClick: (value, e) => this.props.onDownClick(value, e),
      notifyKeyDown: e => this.props.onKeyDown(e),
      registerGlobalEvent: (eventName, handler) => {
        if (eventName && typeof handler === 'function') {
          this.adapter.unregisterGlobalEvent(eventName);
          this.adapter.setCache(eventName, handler);
          document.addEventListener(eventName, handler);
        }
      },
      unregisterGlobalEvent: eventName => {
        if (eventName) {
          const handler = this.adapter.getCache(eventName);
          document.removeEventListener(eventName, handler);
          this.adapter.setCache(eventName, null);
        }
      },
      recordCursorPosition: () => {
        // Record position
        try {
          if (this.inputNode) {
            this.cursorStart = this.inputNode.selectionStart;
            this.cursorEnd = this.inputNode.selectionEnd;
            this.currentValue = this.inputNode.value;
            this.cursorBefore = this.inputNode.value.substring(0, this.cursorStart);
            this.cursorAfter = this.inputNode.value.substring(this.cursorEnd);
          }
        } catch (e) {
          console.warn(e);
          // Fix error in Chrome:
          // Failed to read the 'selectionStart' property from 'HTMLInputElement'
          // http://stackoverflow.com/q/21177489/3040605
        }
      },

      restoreByAfter: str => {
        if (isNullOrUndefined(str)) {
          return false;
        }
        const fullStr = this.inputNode.value;
        const index = fullStr.lastIndexOf(str);
        if (index === -1) {
          return false;
        }
        if (index + str.length === fullStr.length) {
          this.adapter.fixCaret(index, index);
          return true;
        }
        return false;
      },
      restoreCursor: function () {
        let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.cursorAfter;
        if (isNullOrUndefined(str)) {
          return false;
        }
        // For loop from full str to the str with last char to map. e.g. 123
        // -> 123
        // -> 23
        // -> 3
        return Array.prototype.some.call(str, (_, start) => {
          const partStr = str.substring(start);
          return _this.adapter.restoreByAfter(partStr);
        });
      },
      fixCaret: (start, end) => {
        if (start === undefined || end === undefined || !this.inputNode || !this.inputNode.value) {
          return;
        }
        try {
          const currentStart = this.inputNode.selectionStart;
          const currentEnd = this.inputNode.selectionEnd;
          if (start !== currentStart || end !== currentEnd) {
            this.inputNode.setSelectionRange(start, end);
          }
        } catch (e) {
          // Fix error in Chrome:
          // Failed to read the 'selectionStart' property from 'HTMLInputElement'
          // http://stackoverflow.com/q/21177489/3040605
        }
      },
      setClickUpOrDown: value => {
        this.clickUpOrDown = value;
      },
      updateStates: (states, callback) => {
        this.setState(states, callback);
      }
    });
  }
  constructor(props) {
    super(props);
    this.setInputRef = node => {
      const {
        forwardedRef
      } = this.props;
      this.inputNode = node;
      if (forwardedRef && typeof forwardedRef === 'object') {
        forwardedRef.current = node;
      } else if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      }
    };
    this.handleInputFocus = e => this.foundation.handleInputFocus(e);
    this.handleInputChange = (value, event) => this.foundation.handleInputChange(value, event);
    this.handleInputBlur = e => this.foundation.handleInputBlur(e);
    this.handleInputKeyDown = e => this.foundation.handleInputKeyDown(e);
    this.handleInputMouseEnter = e => this.foundation.handleInputMouseEnter(e);
    this.handleInputMouseLeave = e => this.foundation.handleInputMouseLeave(e);
    this.handleInputMouseMove = e => this.foundation.handleInputMouseMove(e);
    this.handleUpClick = e => this.foundation.handleUpClick(e);
    this.handleDownClick = e => this.foundation.handleDownClick(e);
    this.handleMouseUp = e => this.foundation.handleMouseUp(e);
    this.handleMouseLeave = e => this.foundation.handleMouseLeave(e);
    this.renderButtons = () => {
      const {
        prefixCls,
        disabled,
        innerButtons,
        max,
        min
      } = this.props;
      const {
        hovering,
        focusing,
        number
      } = this.state;
      const notAllowedUp = disabled ? disabled : number === max;
      const notAllowedDown = disabled ? disabled : number === min;
      const suffixChildrenCls = classnames_default()(`${prefixCls}-number-suffix-btns`, {
        [`${prefixCls}-number-suffix-btns-inner`]: innerButtons,
        [`${prefixCls}-number-suffix-btns-inner-hover`]: innerButtons && hovering && !focusing
      });
      const upClassName = classnames_default()(`${prefixCls}-number-button`, `${prefixCls}-number-button-up`, {
        [`${prefixCls}-number-button-up-disabled`]: disabled,
        [`${prefixCls}-number-button-up-not-allowed`]: notAllowedUp
      });
      const downClassName = classnames_default()(`${prefixCls}-number-button`, `${prefixCls}-number-button-down`, {
        [`${prefixCls}-number-button-down-disabled`]: disabled,
        [`${prefixCls}-number-button-down-not-allowed`]: notAllowedDown
      });
      return /*#__PURE__*/react.createElement("div", {
        className: suffixChildrenCls
      }, /*#__PURE__*/react.createElement("span", {
        className: upClassName,
        onMouseDown: notAllowedUp ? (noop_default()) : this.handleUpClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/react.createElement(IconChevronUp, {
        size: "extra-small"
      })), /*#__PURE__*/react.createElement("span", {
        className: downClassName,
        onMouseDown: notAllowedDown ? (noop_default()) : this.handleDownClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/react.createElement(IconChevronDown, {
        size: "extra-small"
      })));
    };
    this.renderSuffix = () => {
      const {
        innerButtons,
        suffix
      } = this.props;
      const {
        hovering,
        focusing
      } = this.state;
      if (innerButtons && (hovering || focusing)) {
        const buttons = this.renderButtons();
        return buttons;
      }
      return suffix;
    };
    this.state = {
      value: '',
      number: null,
      focusing: Boolean(props.autofocus) || false,
      hovering: false
    };
    this.inputNode = null;
    this.foundation = new inputNumber_foundation(this.adapter);
    this.clickUpOrDown = false;
  }
  componentDidUpdate(prevProps) {
    const {
      value,
      preventScroll
    } = this.props;
    const {
      focusing
    } = this.state;
    let newValue;
    /**
     * To determine whether the front and back are equal
     * NaN need to check whether both are NaN
     */
    if (value !== prevProps.value && !utils_isBothNaN(value, prevProps.value)) {
      if (isNullOrUndefined(value) || value === '') {
        newValue = '';
        this.foundation.updateStates({
          value: newValue,
          number: null
        });
      } else {
        let valueStr = value;
        if (typeof value === 'number') {
          valueStr = this.foundation.doFormat(value);
        }
        const parsedNum = this.foundation.doParse(valueStr, false, true, true);
        const toNum = typeof value === 'number' ? value : this.foundation.doParse(valueStr, false, false, false);
        /**
         * focusing 状态为输入状态，输入状态的受控值要特殊处理
         * 如：
         *  - 输入合法值
         *      123 => input value 也应该是 123，同时需要设置 number 为 123
         *  - 输入非法值，只设置 input value，不设置非法的number
         *      abc => input value 这时是 abc，但失焦后会进行格式化
         *      100（超出范围） => input value 应该是 100，但不设置 number
         *
         * 保持输入态有三种方式
         * 1. 输入框输入
         *  - 输入可以解析为合法数字，input value根据输入值确定，失焦时更新input value
         *  - 输入不可解析为合法数字，进行格式化后显示在input框
         * 2. 键盘点击上下按钮（input value根据受控值进行更改）
         * 3. keepFocus+鼠标点击上下按钮（input value根据受控值进行更改）
         *
         * The focusing state is the input state, and the controlled value of the input state needs special treatment
         * For example:
         *  - input legal value
         *      123 = > input value should also be 123, and the number should be set to 123
         *  - input illegal value, only set the input value, do not set the illegal number
         *      abc = > input value This is abc at this time, but it will be formatted after being out of focus
         *      100 (out of range) = > input value should be 100, but no number
         *
         * There are three ways to maintain the input state
         * 1. input box input
         *  - input can be resolved into legal numbers, input value is determined according to the input value, and input value is updated when out of focus
         *  - input cannot be resolved into legal numbers, and it will be displayed in the input box after formatting
         * 2. Keyboard click on the up and down button (input value is changed according to the controlled value)
         * 3.keepFocus + mouse click on the up and down button (input value is changed according to the controlled value)
         */
        if (focusing) {
          if (this.foundation.isValidNumber(parsedNum) && parsedNum !== this.state.number) {
            const obj = {
              number: parsedNum
            };
            /**
             * If you are clicking the button, it will automatically format once
             * We need to set the status to false after trigger focus event
             */
            if (this.clickUpOrDown) {
              obj.value = this.foundation.doFormat(obj.number, true);
              newValue = obj.value;
            }
            this.foundation.updateStates(obj, () => this.adapter.restoreCursor());
          } else if (!isNaN_default()(toNum)) {
            // Update input content when controlled input is illegal and not NaN
            newValue = this.foundation.doFormat(toNum, false);
            this.foundation.updateStates({
              value: newValue
            });
          } else {
            // Update input content when controlled input NaN
            this.foundation.updateStates({
              value: valueStr
            });
          }
        } else if (this.foundation.isValidNumber(parsedNum)) {
          newValue = this.foundation.doFormat(parsedNum);
          this.foundation.updateStates({
            number: parsedNum,
            value: newValue
          });
        } else {
          // Invalid digital analog blurring effect instead of controlled failure
          newValue = '';
          this.foundation.updateStates({
            number: null,
            value: newValue
          });
        }
      }
      if (newValue && isString_default()(newValue) && newValue !== String(this.props.value)) {
        this.foundation.notifyChange(newValue, null);
      }
    }
    if (!this.clickUpOrDown) {
      return;
    }
    if (this.props.keepFocus && this.state.focusing) {
      if (document.activeElement !== this.inputNode) {
        this.inputNode.focus({
          preventScroll
        });
      }
    }
  }
  render() {
    const _a = this.props,
      {
        disabled,
        className,
        prefixCls,
        min,
        max,
        step,
        shiftStep,
        precision,
        formatter,
        parser,
        forwardedRef,
        onUpClick,
        onDownClick,
        pressInterval,
        pressTimeout,
        suffix,
        size,
        hideButtons,
        innerButtons,
        style,
        onNumberChange,
        keepFocus,
        defaultValue
      } = _a,
      rest = inputNumber_rest(_a, ["disabled", "className", "prefixCls", "min", "max", "step", "shiftStep", "precision", "formatter", "parser", "forwardedRef", "onUpClick", "onDownClick", "pressInterval", "pressTimeout", "suffix", "size", "hideButtons", "innerButtons", "style", "onNumberChange", "keepFocus", "defaultValue"]);
    const {
      value,
      number
    } = this.state;
    const inputNumberCls = classnames_default()(className, `${prefixCls}-number`, {
      [`${prefixCls}-number-size-${size}`]: size
    });
    const buttons = this.renderButtons();
    const ariaProps = {
      'aria-disabled': disabled,
      step
    };
    if (number) {
      ariaProps['aria-valuenow'] = number;
    }
    if (max !== Infinity) {
      ariaProps['aria-valuemax'] = max;
    }
    if (min !== -Infinity) {
      ariaProps['aria-valuemin'] = min;
    }
    const input = /*#__PURE__*/react.createElement("div", {
      className: inputNumberCls,
      style: style,
      onMouseMove: e => this.handleInputMouseMove(e),
      onMouseEnter: e => this.handleInputMouseEnter(e),
      onMouseLeave: e => this.handleInputMouseLeave(e)
    }, /*#__PURE__*/react.createElement(es_input, Object.assign({
      role: "spinbutton"
    }, ariaProps, rest, {
      size: size,
      disabled: disabled,
      ref: this.setInputRef,
      value: value,
      onFocus: this.handleInputFocus,
      onChange: this.handleInputChange,
      onBlur: this.handleInputBlur,
      onKeyDown: this.handleInputKeyDown,
      suffix: this.renderSuffix()
    })), hideButtons || innerButtons ? null : buttons);
    return input;
  }
}
InputNumber.propTypes = {
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  autofocus: (prop_types_default()).bool,
  clearIcon: (prop_types_default()).node,
  className: (prop_types_default()).string,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  disabled: (prop_types_default()).bool,
  formatter: (prop_types_default()).func,
  forwardedRef: (prop_types_default()).any,
  hideButtons: (prop_types_default()).bool,
  innerButtons: (prop_types_default()).bool,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  keepFocus: (prop_types_default()).bool,
  max: (prop_types_default()).number,
  min: (prop_types_default()).number,
  parser: (prop_types_default()).func,
  precision: (prop_types_default()).number,
  prefixCls: (prop_types_default()).string,
  pressInterval: (prop_types_default()).number,
  pressTimeout: (prop_types_default()).number,
  preventScroll: (prop_types_default()).bool,
  shiftStep: (prop_types_default()).number,
  step: (prop_types_default()).number,
  style: (prop_types_default()).object,
  suffix: (prop_types_default()).any,
  value: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  onBlur: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onDownClick: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  onNumberChange: (prop_types_default()).func,
  onUpClick: (prop_types_default()).func
};
InputNumber.defaultProps = {
  forwardedRef: (noop_default()),
  innerButtons: false,
  keepFocus: false,
  max: Infinity,
  min: -Infinity,
  prefixCls: inputNumber_constants_cssClasses.PREFIX,
  pressInterval: inputNumber_constants_numbers.DEFAULT_PRESS_TIMEOUT,
  pressTimeout: inputNumber_constants_numbers.DEFAULT_PRESS_TIMEOUT,
  shiftStep: inputNumber_constants_numbers.DEFAULT_SHIFT_STEP,
  size: inputNumber_constants_strings.DEFAULT_SIZE,
  step: inputNumber_constants_numbers.DEFAULT_STEP,
  onBlur: (noop_default()),
  onChange: (noop_default()),
  onDownClick: (noop_default()),
  onFocus: (noop_default()),
  onKeyDown: (noop_default()),
  onNumberChange: (noop_default()),
  onUpClick: (noop_default())
};
/* harmony default export */ var inputNumber = (forwardStatics( /*#__PURE__*/react.forwardRef(function SemiInputNumber(props, ref) {
  return /*#__PURE__*/react.createElement(InputNumber, Object.assign({}, props, {
    forwardedRef: ref
  }));
}), InputNumber));

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/pagination/index.js

var pagination_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */






// import '@douyinfe/semi-foundation/lib/es/pagination/pagination.css';









const pagination_prefixCls = pagination_constants_cssClasses.PREFIX;
const {
  Option: pagination_Option
} = es_select;
class Pagination extends BaseComponent {
  constructor(props) {
    super(props);
    const total = props.total;
    const pageSize = props.pageSize || props.pageSizeOpts[0] || pagination_constants_numbers.DEFAULT_PAGE_SIZE; // Use pageSize first, use the first of pageSizeOpts when not, use the default value when none
    const shouldFillAllNumber = props.size === 'small' && props.hoverShowPageSelect && !props.disabled;
    this.state = {
      total,
      showTotal: props.showTotal,
      currentPage: props.currentPage || props.defaultCurrentPage,
      pageSize,
      pageList: [],
      prevDisabled: false,
      nextDisabled: false,
      restLeftPageList: [],
      restRightPageList: [],
      quickJumpPage: '',
      allPageNumbers: shouldFillAllNumber ? Array.from({
        length: Math.ceil(total / pageSize)
      }, (v, i) => i + 1) : [] // only need to count in smallPage mode, when props.size = small
    };

    this.foundation = new pagination_foundation(this.adapter);
    this.renderDefaultPage = this.renderDefaultPage.bind(this);
    this.renderSmallPage = this.renderSmallPage.bind(this);
    warning(Boolean(props.showSizeChanger && props.hideOnSinglePage), '[Semi Pagination] You should not use showSizeChanger and hideOnSinglePage in ths same time. At this time, hideOnSinglePage no longer takes effect, otherwise there may be a problem that the switch entry disappears');
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setPageList: pageListState => {
        const {
          pageList,
          restLeftPageList,
          restRightPageList
        } = pageListState;
        this.setState({
          pageList,
          restLeftPageList,
          restRightPageList
        });
      },
      setDisabled: (prevIsDisabled, nextIsDisabled) => {
        this.setState({
          prevDisabled: prevIsDisabled,
          nextDisabled: nextIsDisabled
        });
      },
      updateTotal: total => this.setState({
        total
      }),
      updatePageSize: pageSize => this.setState({
        pageSize
      }),
      updateQuickJumpPage: quickJumpPage => this.setState({
        quickJumpPage
      }),
      updateAllPageNumbers: allPageNumbers => this.setState({
        allPageNumbers
      }),
      setCurrentPage: pageIndex => {
        this.setState({
          currentPage: pageIndex
        });
      },
      registerKeyDownHandler: handler => {
        document.addEventListener('keydown', handler);
      },
      unregisterKeyDownHandler: handler => {
        document.removeEventListener('keydown', handler);
      },
      notifyPageChange: pageIndex => {
        this.props.onPageChange(pageIndex);
      },
      notifyPageSizeChange: pageSize => {
        this.props.onPageSizeChange(pageSize);
      },
      notifyChange: (pageIndex, pageSize) => {
        this.props.onChange(pageIndex, pageSize);
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  componentDidUpdate(prevProps) {
    const pagerProps = {
      currentPage: this.props.currentPage,
      total: this.props.total,
      pageSize: this.props.pageSize
    };
    let pagerHasChanged = false;
    let allPageNumberNeedUpdate = false;
    if (prevProps.currentPage !== this.props.currentPage) {
      pagerHasChanged = true;
      // this.foundation.updatePage(this.props.currentPage);
    }

    if (prevProps.total !== this.props.total) {
      pagerHasChanged = true;
      allPageNumberNeedUpdate = true;
    }
    if (prevProps.pageSize !== this.props.pageSize) {
      pagerHasChanged = true;
      allPageNumberNeedUpdate = true;
    }
    if (pagerHasChanged) {
      this.foundation.updatePage(pagerProps.currentPage, pagerProps.total, pagerProps.pageSize);
    }
    if (allPageNumberNeedUpdate) {
      this.foundation.updateAllPageNumbers(pagerProps.total, pagerProps.pageSize);
    }
  }
  renderPrevBtn() {
    const {
      prevText,
      disabled
    } = this.props;
    const {
      prevDisabled
    } = this.state;
    const isDisabled = prevDisabled || disabled;
    const preClassName = classnames_default()({
      [`${pagination_prefixCls}-item`]: true,
      [`${pagination_prefixCls}-prev`]: true,
      [`${pagination_prefixCls}-item-disabled`]: isDisabled
    });
    return /*#__PURE__*/react.createElement("li", {
      role: "button",
      "aria-disabled": isDisabled ? true : false,
      "aria-label": "Previous",
      onClick: e => !isDisabled && this.foundation.goPrev(e),
      className: preClassName,
      "x-semi-prop": "prevText"
    }, prevText || /*#__PURE__*/react.createElement(IconChevronLeft/* default */.Z, {
      size: "large"
    }));
  }
  renderNextBtn() {
    const {
      nextText,
      disabled
    } = this.props;
    const {
      nextDisabled
    } = this.state;
    const isDisabled = nextDisabled || disabled;
    const nextClassName = classnames_default()({
      [`${pagination_prefixCls}-item`]: true,
      [`${pagination_prefixCls}-item-disabled`]: isDisabled,
      [`${pagination_prefixCls}-next`]: true
    });
    return /*#__PURE__*/react.createElement("li", {
      role: "button",
      "aria-disabled": isDisabled ? true : false,
      "aria-label": "Next",
      onClick: e => !isDisabled && this.foundation.goNext(e),
      className: nextClassName,
      "x-semi-prop": "nextText"
    }, nextText || /*#__PURE__*/react.createElement(IconChevronRight, {
      size: "large"
    }));
  }
  renderPageSizeSwitch(locale) {
    // rtl modify the default position
    const {
      direction
    } = this.context;
    const defaultPopoverPosition = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    const {
      showSizeChanger,
      popoverPosition = defaultPopoverPosition,
      disabled,
      popoverZIndex
    } = this.props;
    const {
      pageSize
    } = this.state;
    const switchCls = classnames_default()(`${pagination_prefixCls}-switch`);
    if (!showSizeChanger) {
      return null;
    }
    const newPageSizeOpts = this.foundation.pageSizeInOpts();
    const pageSizeToken = locale.pageSize;
    // Display pageSize in a specific language format order
    const options = newPageSizeOpts.map(size => /*#__PURE__*/react.createElement(pagination_Option, {
      value: size,
      key: size
    }, /*#__PURE__*/react.createElement("span", null, pageSizeToken.replace('${pageSize}', size.toString()))));
    return /*#__PURE__*/react.createElement("div", {
      className: switchCls
    }, /*#__PURE__*/react.createElement(es_select, {
      "aria-label": "Page size selector",
      disabled: disabled,
      onChange: newPageSize => this.foundation.changePageSize(newPageSize),
      value: pageSize,
      key: pageSize,
      position: popoverPosition || 'bottomRight',
      clickToHide: true,
      zIndex: popoverZIndex,
      dropdownClassName: `${pagination_prefixCls}-select-dropdown`
    }, options));
  }
  renderQuickJump(locale) {
    const {
      showQuickJumper,
      disabled
    } = this.props;
    const {
      quickJumpPage,
      total,
      pageSize
    } = this.state;
    if (!showQuickJumper) {
      return null;
    }
    const totalPageNum = this.foundation._getTotalPageNumber(total, pageSize);
    const isDisabled = totalPageNum === 1 || disabled;
    const quickJumpCls = classnames_default()({
      [`${pagination_prefixCls}-quickjump`]: true,
      [`${pagination_prefixCls}-quickjump-disabled`]: isDisabled
    });
    return /*#__PURE__*/react.createElement("div", {
      className: quickJumpCls
    }, /*#__PURE__*/react.createElement("span", null, locale.jumpTo), /*#__PURE__*/react.createElement(inputNumber, {
      value: quickJumpPage,
      className: `${pagination_prefixCls}-quickjump-input-number`,
      hideButtons: true,
      disabled: isDisabled,
      onBlur: e => this.foundation.handleQuickJumpBlur(),
      onEnterPress: e => this.foundation.handleQuickJumpEnterPress(e.target.value),
      onChange: v => this.foundation.handleQuickJumpNumberChange(v)
    }), /*#__PURE__*/react.createElement("span", null, locale.page));
  }
  renderPageList() {
    const {
      pageList,
      currentPage,
      restLeftPageList,
      restRightPageList
    } = this.state;
    const {
      popoverPosition,
      popoverZIndex,
      disabled
    } = this.props;
    return pageList.map((page, i) => {
      const pageListClassName = classnames_default()(`${pagination_prefixCls}-item`, {
        [`${pagination_prefixCls}-item-active`]: currentPage === page,
        [`${pagination_prefixCls}-item-all-disabled`]: disabled,
        [`${pagination_prefixCls}-item-all-disabled-active`]: currentPage === page && disabled
        // [`${prefixCls}-item-rest-opening`]: (i < 3 && isLeftRestHover && page ==='...') || (i > 3 && isRightRestHover && page === '...')
      });

      const pageEl = /*#__PURE__*/react.createElement("li", {
        key: `${page}${i}`,
        onClick: () => !disabled && this.foundation.goPage(page, i),
        className: pageListClassName,
        "aria-label": page === '...' ? 'More' : `Page ${page}`,
        "aria-current": currentPage === page ? "page" : false
      }, page);
      if (page === '...' && !disabled) {
        let content;
        i < 3 ? content = restLeftPageList : content = restRightPageList;
        return /*#__PURE__*/react.createElement(popover, {
          rePosKey: this.props.currentPage,
          trigger: "hover",
          // onVisibleChange={visible=>this.handleRestHover(visible, i < 3 ? 'left' : 'right')}
          content: this.renderRestPageList(content),
          key: `${page}${i}`,
          position: popoverPosition,
          zIndex: popoverZIndex
        }, pageEl);
      }
      return pageEl;
    });
  }
  renderRestPageList(restList) {
    // The number of pages may be tens of thousands, here is virtualized with the help of react-window
    const {
      direction
    } = this.context;
    const className = classnames_default()(`${pagination_prefixCls}-rest-item`);
    const count = restList.length;
    const row = item => {
      const {
        index,
        style
      } = item;
      const page = restList[index];
      return /*#__PURE__*/react.createElement("div", {
        role: "listitem",
        key: `${page}${index}`,
        className: className,
        onClick: () => this.foundation.goPage(page, index),
        style: style,
        "aria-label": `${page}`
      }, page);
    };
    const itemHeight = 32;
    const listHeight = count >= 5 ? itemHeight * 5 : itemHeight * count;
    return (
      /*#__PURE__*/
      // @ts-ignore skip type check cause react-window not update with @types/react 18
      react.createElement(FixedSizeList, {
        className: `${pagination_prefixCls}-rest-list`,
        itemData: restList,
        itemSize: itemHeight,
        width: 78,
        itemCount: count,
        height: listHeight,
        style: {
          direction
        }
      }, row)
    );
  }
  renderSmallPageSelect(content) {
    const allPageNumbers = this.state.allPageNumbers;
    const pageList = this.renderRestPageList(allPageNumbers);
    return /*#__PURE__*/react.createElement(popover, {
      content: pageList
    }, content);
  }
  renderSmallPage(locale) {
    const _a = this.props,
      {
        className,
        style,
        hideOnSinglePage,
        hoverShowPageSelect,
        showSizeChanger,
        disabled
      } = _a,
      rest = pagination_rest(_a, ["className", "style", "hideOnSinglePage", "hoverShowPageSelect", "showSizeChanger", "disabled"]);
    const paginationCls = classnames_default()(`${pagination_prefixCls}-small`, pagination_prefixCls, className, {
      [`${pagination_prefixCls}-disabled`]: disabled
    });
    const {
      currentPage,
      total,
      pageSize
    } = this.state;
    const totalPageNum = Math.ceil(total / pageSize);
    if (totalPageNum < 2 && hideOnSinglePage && !showSizeChanger) {
      return null;
    }
    const pageCls = classnames_default()({
      [`${pagination_prefixCls}-item`]: true,
      [`${pagination_prefixCls}-item-small`]: true,
      [`${pagination_prefixCls}-item-all-disabled`]: disabled
    });
    const content = /*#__PURE__*/react.createElement("div", {
      className: pageCls
    }, currentPage, "/", totalPageNum, " ");
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: paginationCls,
      style: style
    }, this.getDataAttr(rest)), this.renderPrevBtn(), hoverShowPageSelect && !disabled ? this.renderSmallPageSelect(content) : content, this.renderNextBtn(), this.renderQuickJump(locale));
  }
  renderDefaultPage(locale) {
    const {
      total,
      pageSize
    } = this.state;
    const _a = this.props,
      {
        showTotal,
        className,
        style,
        hideOnSinglePage,
        showSizeChanger,
        disabled
      } = _a,
      rest = pagination_rest(_a, ["showTotal", "className", "style", "hideOnSinglePage", "showSizeChanger", "disabled"]);
    const paginationCls = classnames_default()(className, `${pagination_prefixCls}`, {
      [`${pagination_prefixCls}-disabled`]: disabled
    });
    const showTotalCls = `${pagination_prefixCls}-total`;
    const totalPageNum = Math.ceil(total / pageSize);
    if (totalPageNum < 2 && hideOnSinglePage && !showSizeChanger) {
      return null;
    }
    const totalNum = Math.ceil(total / pageSize);
    const totalToken = locale.total.replace('${total}', totalNum.toString());
    return /*#__PURE__*/react.createElement("ul", Object.assign({
      className: paginationCls,
      style: style
    }, this.getDataAttr(rest)), showTotal ? /*#__PURE__*/react.createElement("span", {
      className: showTotalCls
    }, totalToken) : null, this.renderPrevBtn(), this.renderPageList(), this.renderNextBtn(), this.renderPageSizeSwitch(locale), this.renderQuickJump(locale));
  }
  render() {
    const {
      size
    } = this.props;
    return /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Pagination"
    }, locale => size === 'small' ? this.renderSmallPage(locale) : this.renderDefaultPage(locale));
  }
}
Pagination.contextType = context;
Pagination.propTypes = {
  total: (prop_types_default()).number,
  showTotal: (prop_types_default()).bool,
  pageSize: (prop_types_default()).number,
  pageSizeOpts: (prop_types_default()).array,
  size: (prop_types_default()).string,
  currentPage: (prop_types_default()).number,
  defaultCurrentPage: (prop_types_default()).number,
  onPageChange: (prop_types_default()).func,
  onPageSizeChange: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  prevText: (prop_types_default()).node,
  nextText: (prop_types_default()).node,
  showSizeChanger: (prop_types_default()).bool,
  popoverZIndex: (prop_types_default()).number,
  popoverPosition: (prop_types_default()).string,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  hideOnSinglePage: (prop_types_default()).bool,
  hoverShowPageSelect: (prop_types_default()).bool,
  showQuickJumper: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool
};
Pagination.defaultProps = {
  total: 1,
  popoverZIndex: constants_numbers.DEFAULT_Z_INDEX,
  showTotal: false,
  pageSize: null,
  pageSizeOpts: pagination_constants_numbers.PAGE_SIZE_OPTION,
  defaultCurrentPage: 1,
  size: 'default',
  onPageChange: (noop_default()),
  onPageSizeChange: (noop_default()),
  onChange: (noop_default()),
  showSizeChanger: false,
  className: '',
  hideOnSinglePage: false,
  showQuickJumper: false,
  disabled: false
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/sideSheet/constants.js

const sideSheet_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-sidesheet`,
  DIALOG: `${BASE_CLASS_PREFIX}-modal`
};
const sideSheet_constants_strings = {
  PLACEMENT: ['top', 'right', 'bottom', 'left'],
  SIZE: ['small', 'medium', 'large'],
  WIDTH: {
    small: 448,
    medium: 684,
    large: 920
  },
  HEIGHT: 448
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/sideSheet/SideSheetContent.js

var SideSheetContent_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







let uuid = 0;
const SideSheetContent_prefixCls = sideSheet_constants_cssClasses.PREFIX;
class SideSheetContent extends react.PureComponent {
  constructor() {
    super(...arguments);
    this.onMaskClick = e => {
      if (e.target === e.currentTarget) {
        this.close(e);
      }
    };
    this.close = e => {
      const {
        onClose
      } = this.props;
      onClose && onClose(e);
    };
  }
  componentDidMount() {
    this.sideSheetId = `sidesheet-${uuid++}`;
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }
  getMaskElement() {
    var _a;
    const {
      mask,
      maskStyle,
      maskClosable
    } = this.props;
    if (mask) {
      return /*#__PURE__*/react.createElement("div", Object.assign({
        "aria-hidden": true,
        key: "mask",
        className: classnames_default()(`${SideSheetContent_prefixCls}-mask`, (_a = this.props.maskClassName) !== null && _a !== void 0 ? _a : ""),
        style: maskStyle,
        onClick: maskClosable ? this.onMaskClick : null
      }, this.props.maskExtraProps));
    }
    return null;
  }
  renderHeader() {
    const {
      title,
      closable,
      headerStyle,
      closeIcon
    } = this.props;
    let header, closer;
    if (title) {
      header = /*#__PURE__*/react.createElement("div", {
        className: `${SideSheetContent_prefixCls}-title`,
        "x-semi-prop": "title"
      }, this.props.title);
    }
    if (closable) {
      const iconType = closeIcon || /*#__PURE__*/react.createElement(IconClose, null);
      closer = /*#__PURE__*/react.createElement(iconButton, {
        className: `${SideSheetContent_prefixCls}-close`,
        key: "close-btn",
        onClick: this.close,
        type: "tertiary",
        icon: iconType,
        theme: "borderless",
        size: "small"
      });
    }
    return /*#__PURE__*/react.createElement("div", {
      className: `${SideSheetContent_prefixCls}-header`,
      role: 'heading',
      "aria-level": 1,
      style: Object.assign({}, headerStyle)
    }, header, closer);
  }
  getDialogElement() {
    var _a;
    const props = SideSheetContent_rest(this.props, []);
    const style = {};
    if (props.width) {
      style.width = props.width;
      // When the mask is false, the width is set on the wrapper. At this time, sidesheet-inner does not need to set the width again, otherwise, the percentage will be accumulated repeatedly when the width is a percentage
      if (!props.mask) {
        style.width = '100%';
      }
    }
    if (props.height) {
      style.height = props.height;
    }
    const header = this.renderHeader();
    const dialogElement = /*#__PURE__*/react.createElement("div", Object.assign({
      key: "dialog-element",
      role: "dialog",
      tabIndex: -1,
      className: classnames_default()(`${SideSheetContent_prefixCls}-inner`, `${SideSheetContent_prefixCls}-inner-wrap`, (_a = this.props.dialogClassName) !== null && _a !== void 0 ? _a : "", `${SideSheetContent_prefixCls}-size-${props.size}`),
      // onMouseDown={this.onDialogMouseDown}
      style: Object.assign(Object.assign({}, props.style), style)
    }, this.props.wrapperExtraProps), /*#__PURE__*/react.createElement("div", {
      className: `${SideSheetContent_prefixCls}-content`
    }, header, /*#__PURE__*/react.createElement("div", {
      className: `${SideSheetContent_prefixCls}-body`,
      style: props.bodyStyle,
      "x-semi-prop": "children"
    }, props.children), props.footer ? /*#__PURE__*/react.createElement("div", {
      className: `${SideSheetContent_prefixCls}-footer`,
      "x-semi-prop": "footer"
    }, props.footer) : null));
    return dialogElement;
  }
  render() {
    const _a = this.props,
      {
        mask,
        className,
        width,
        onClose,
        maskStyle,
        maskClosable,
        maskClassName,
        title,
        closable,
        headerStyle,
        height,
        style,
        size,
        bodyStyle,
        dialogClassName,
        children,
        footer,
        maskExtraProps,
        wrapperExtraProps
      } = _a,
      rest = SideSheetContent_rest(_a, ["mask", "className", "width", "onClose", "maskStyle", "maskClosable", "maskClassName", "title", "closable", "headerStyle", "height", "style", "size", "bodyStyle", "dialogClassName", "children", "footer", "maskExtraProps", "wrapperExtraProps"]);
    const wrapperCls = classnames_default()(className, {
      [`${SideSheetContent_prefixCls}-fixed`]: !mask,
      [`${SideSheetContent_prefixCls}-size-${this.props.size}`]: !mask
    });
    const wrapperStyle = {};
    if (!mask && width) {
      wrapperStyle.width = width;
    }
    const dataAttr = getDataAttr(rest);
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: wrapperCls,
      style: wrapperStyle
    }, dataAttr), this.getMaskElement(), this.getDialogElement());
  }
}
SideSheetContent.propTypes = {
  onClose: (prop_types_default()).func,
  closeIcon: (prop_types_default()).node
};
SideSheetContent.defaultProps = {
  onClose: (noop_default())
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/sideSheet/sideSheetFoundation.js



class SideSheetFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, SideSheetFoundation.defaultAdapter), adapter));
    this.toggleDisplayNone = displayNone => {
      this._adapter.toggleDisplayNone(displayNone);
    };
  }
  get defaultAdapter() {
    return {
      handleCancel: (noop_default()),
      beforeShow: (noop_default()),
      afterHide: (noop_default())
    };
  }
  destroy() {
    this.afterHide();
  }
  handleCancel(e) {
    this._adapter.notifyCancel(e);
  }
  beforeShow() {
    const allowDisable = this.getProp('disableScroll');
    allowDisable && this._adapter.disabledBodyScroll();
    this._adapter.setOnKeyDownListener();
  }
  afterHide() {
    const allowDisable = this.getProp('disableScroll');
    allowDisable && this._adapter.enabledBodyScroll();
    this._adapter.removeKeyDownListener();
  }
  handleKeyDown(e) {
    const {
      closeOnEsc
    } = this.getProps();
    if (closeOnEsc && e.keyCode === utils_keyCode.ESC) {
      e.stopPropagation();
      this.handleCancel(e);
      return;
    }
  }
  onVisibleChange(visible) {
    this._adapter.notifyVisibleChange(visible);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/sideSheet/index.js

var sideSheet_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









// import '@douyinfe/semi-foundation/lib/es/sideSheet/sideSheet.css';


const sideSheet_prefixCls = sideSheet_constants_cssClasses.PREFIX;
const defaultWidthList = sideSheet_constants_strings.WIDTH;
const defaultHeight = sideSheet_constants_strings.HEIGHT;
class SideSheet extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleCancel = e => {
      this.foundation.handleCancel(e);
    };
    this.handleKeyDown = e => {
      this.foundation.handleKeyDown(e);
    };
    this.updateState = () => {
      this.foundation.toggleDisplayNone(!this.props.visible);
    };
    this.state = {
      displayNone: !this.props.visible
    };
    this.foundation = new SideSheetFoundation(this.adapter);
    this.bodyOverflow = '';
    this.scrollBarWidth = 0;
    this.originBodyWidth = '100%';
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      disabledBodyScroll: () => {
        const {
          getPopupContainer
        } = this.props;
        this.bodyOverflow = document.body.style.overflow || '';
        if (!getPopupContainer && this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = 'hidden';
          document.body.style.width = `calc(${this.originBodyWidth || '100%'} - ${this.scrollBarWidth}px)`;
        }
      },
      enabledBodyScroll: () => {
        const {
          getPopupContainer
        } = this.props;
        if (!getPopupContainer && this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = this.bodyOverflow;
          document.body.style.width = this.originBodyWidth;
        }
      },
      notifyCancel: e => {
        this.props.onCancel && this.props.onCancel(e);
      },
      notifyVisibleChange: visible => {
        this.props.afterVisibleChange(visible);
      },
      setOnKeyDownListener: () => {
        if (window) {
          window.addEventListener('keydown', this.handleKeyDown);
        }
      },
      removeKeyDownListener: () => {
        if (window) {
          window.removeEventListener('keydown', this.handleKeyDown);
        }
      },
      toggleDisplayNone: displayNone => {
        if (displayNone !== this.state.displayNone) {
          this.setState({
            displayNone: displayNone
          });
        }
      }
    });
  }
  static getDerivedStateFromProps(props, prevState) {
    const newState = {};
    if (props.visible && prevState.displayNone) {
      newState.displayNone = false;
    }
    if (!props.visible && !props.motion && !prevState.displayNone) {
      newState.displayNone = true;
    }
    return newState;
  }
  componentDidMount() {
    this.scrollBarWidth = getScrollbarWidth();
    this.originBodyWidth = document.body.style.width;
    if (this.props.visible) {
      this.foundation.beforeShow();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // hide => show
    if (!prevProps.visible && this.props.visible) {
      this.foundation.beforeShow();
    }
    // show => hide
    if (prevProps.visible && !this.props.visible) {
      this.foundation.afterHide();
    }
    if (prevState.displayNone !== this.state.displayNone) {
      this.foundation.onVisibleChange(!this.state.displayNone);
    }
  }
  componentWillUnmount() {
    if (this.props.visible) {
      this.foundation.destroy();
    }
  }
  renderContent() {
    const _a = this.props,
      {
        placement,
        className,
        children,
        width,
        height,
        motion,
        visible,
        style,
        maskStyle,
        size,
        zIndex,
        getPopupContainer,
        keepDOM
      } = _a,
      props = sideSheet_rest(_a, ["placement", "className", "children", "width", "height", "motion", "visible", "style", "maskStyle", "size", "zIndex", "getPopupContainer", "keepDOM"]);
    let wrapperStyle = {
      zIndex
    };
    if (getPopupContainer) {
      wrapperStyle = {
        zIndex,
        position: 'static'
      };
    }
    const {
      direction
    } = this.context;
    const isVertical = placement === 'left' || placement === 'right';
    const isHorizontal = placement === 'top' || placement === 'bottom';
    const sheetHeight = isHorizontal ? height ? height : defaultHeight : '100%';
    const classList = classnames_default()(sideSheet_prefixCls, className, {
      [`${sideSheet_prefixCls}-${placement}`]: placement,
      [`${sideSheet_prefixCls}-popup`]: getPopupContainer,
      [`${sideSheet_prefixCls}-horizontal`]: isHorizontal,
      [`${sideSheet_prefixCls}-rtl`]: direction === 'rtl',
      [`${sideSheet_prefixCls}-hidden`]: keepDOM && this.state.displayNone
    });
    const contentProps = Object.assign(Object.assign(Object.assign({}, isVertical ? width ? {
      width
    } : {} : {
      width: "100%"
    }), props), {
      visible,
      motion: false,
      size,
      className: classList,
      height: sheetHeight,
      onClose: this.handleCancel
    });
    const shouldRender = this.props.visible || this.props.keepDOM || this.props.motion && !this.state.displayNone /* When there is animation, we use displayNone to judge whether animation is ended and judge whether to unmount content */;
    // Since user could change animate duration , we don't know which animation end first. So we call updateState func twice.
    return /*#__PURE__*/react.createElement(_cssAnimation, {
      motion: this.props.motion,
      animationState: visible ? 'enter' : 'leave',
      startClassName: visible ? `${sideSheet_prefixCls}-animation-mask_show` : `${sideSheet_prefixCls}-animation-mask_hide`,
      onAnimationEnd: this.updateState
    }, _ref => {
      let {
        animationClassName: maskAnimationClassName,
        animationEventsNeedBind: maskAnimationEventsNeedBind
      } = _ref;
      return /*#__PURE__*/react.createElement(_cssAnimation, {
        motion: this.props.motion,
        animationState: visible ? 'enter' : 'leave',
        startClassName: visible ? `${sideSheet_prefixCls}-animation-content_show_${this.props.placement}` : `${sideSheet_prefixCls}-animation-content_hide_${this.props.placement}`,
        onAnimationEnd: this.updateState /* for no mask case*/
      }, _ref2 => {
        let {
          animationClassName,
          animationStyle,
          animationEventsNeedBind
        } = _ref2;
        return shouldRender ? /*#__PURE__*/react.createElement(_portal, {
          getPopupContainer: getPopupContainer,
          style: wrapperStyle
        }, /*#__PURE__*/react.createElement(SideSheetContent, Object.assign({}, contentProps, {
          maskExtraProps: maskAnimationEventsNeedBind,
          wrapperExtraProps: animationEventsNeedBind,
          dialogClassName: animationClassName,
          maskClassName: maskAnimationClassName,
          maskStyle: Object.assign({}, maskStyle),
          style: Object.assign(Object.assign({}, animationStyle), style)
        }), children)) : /*#__PURE__*/react.createElement(react.Fragment, null);
      });
    });
  }
  render() {
    const {
      zIndex,
      getPopupContainer,
      visible
    } = this.props;
    return this.renderContent();
  }
}
SideSheet.contextType = context;
SideSheet.propTypes = {
  bodyStyle: (prop_types_default()).object,
  headerStyle: (prop_types_default()).object,
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  closable: (prop_types_default()).bool,
  disableScroll: (prop_types_default()).bool,
  getPopupContainer: (prop_types_default()).func,
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  mask: (prop_types_default()).bool,
  maskClosable: (prop_types_default()).bool,
  maskStyle: (prop_types_default()).object,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object, (prop_types_default()).func]),
  onCancel: (prop_types_default()).func,
  placement: prop_types_default().oneOf(sideSheet_constants_strings.PLACEMENT),
  size: prop_types_default().oneOf(sideSheet_constants_strings.SIZE),
  style: (prop_types_default()).object,
  title: (prop_types_default()).node,
  visible: (prop_types_default()).bool,
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  zIndex: (prop_types_default()).number,
  afterVisibleChange: (prop_types_default()).func,
  closeOnEsc: (prop_types_default()).bool,
  footer: (prop_types_default()).node,
  keepDOM: (prop_types_default()).bool,
  'aria-label': (prop_types_default()).string
};
SideSheet.__SemiComponentName__ = "SideSheet";
SideSheet.defaultProps = getDefaultPropsFromGlobalConfig(SideSheet.__SemiComponentName__, {
  visible: false,
  motion: true,
  mask: true,
  placement: 'right',
  closable: true,
  footer: null,
  zIndex: 1000,
  maskClosable: true,
  size: 'small',
  disableScroll: true,
  closeOnEsc: false,
  afterVisibleChange: (noop_default()),
  keepDOM: false
});
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tabs/constants.js

const tabs_constants_cssClasses = {
  TABS: `${BASE_CLASS_PREFIX}-tabs`,
  TABS_BAR: `${BASE_CLASS_PREFIX}-tabs-bar`,
  TABS_BAR_LINE: `${BASE_CLASS_PREFIX}-tabs-bar-line`,
  TABS_BAR_CARD: `${BASE_CLASS_PREFIX}-tabs-bar-card`,
  TABS_BAR_BUTTON: `${BASE_CLASS_PREFIX}-tabs-bar-button`,
  TABS_BAR_EXTRA: `${BASE_CLASS_PREFIX}-tabs-bar-extra`,
  TABS_TAB: `${BASE_CLASS_PREFIX}-tabs-tab`,
  TABS_TAB_ACTIVE: `${BASE_CLASS_PREFIX}-tabs-tab-active`,
  TABS_TAB_DISABLED: `${BASE_CLASS_PREFIX}-tabs-tab-disabled`,
  TABS_CONTENT: `${BASE_CLASS_PREFIX}-tabs-content`,
  TABS_CONTENT_ANIMATED: `${BASE_CLASS_PREFIX}-tabs-content-animated`,
  TABS_CONTENT_NO_ANIMATED: `${BASE_CLASS_PREFIX}-tabs-content-no-animated`,
  TABS_PANE: `${BASE_CLASS_PREFIX}-tabs-pane`,
  TABS_PANE_INACTIVE: `${BASE_CLASS_PREFIX}-tabs-pane-inactive`,
  TABS_PANE_ACTIVE: `${BASE_CLASS_PREFIX}-tabs-pane-active`,
  TABS_PANE_MOTION_OVERLAY: `${BASE_CLASS_PREFIX}-tabs-pane-motion-overlay`,
  TABS_PANE_ANIMATING: `${BASE_CLASS_PREFIX}-tabs-pane-animating`,
  "TABS_PANE_ANIMATE_LEFT_SHOW": `${BASE_CLASS_PREFIX}-tabs-pane-animate-leftShow`,
  "TABS_PANE_ANIMATE_RIGHT_SHOW": `${BASE_CLASS_PREFIX}-tabs-pane-animate-rightShow`,
  "TABS_PANE_ANIMATE_TOP_SHOW": `${BASE_CLASS_PREFIX}-tabs-pane-animate-topShow`,
  "TABS_PANE_ANIMATE_BOTTOM_SHOW": `${BASE_CLASS_PREFIX}-tabs-pane-animate-bottomShow`
};
const tabs_constants_numbers = {
  DEFAULT_ACTIVE_KEY: 1
};
const tabs_constants_strings = {
  TYPE_MAP: ['line', 'card', 'button'],
  SIZE: ['small', 'medium', 'large'],
  POSITION_MAP: ['top', 'left']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tabs/foundation.js



class TabsFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.destroy = (noop_default());
    this.handlePrevent = event => {
      event.stopPropagation();
      event.preventDefault();
    };
    this.handleKeyDown = (event, itemKey, closable) => {
      const {
        preventScroll
      } = this.getProps();
      const tabs = [...event.target.parentNode.childNodes].filter(item => {
        return get_default()(item, 'attributes.data-tabkey.value', '').includes('semiTab') && get_default()(item, 'attributes.aria-disabled.value', '') !== "true";
      });
      switch (event.key) {
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "ArrowDown":
          this.determineOrientation(event, tabs);
          break;
        case "Backspace":
        case "Delete":
          this.handleDeleteKeyDown(event, tabs, itemKey, closable);
          break;
        case "Enter":
        case " ":
          this.handleTabClick(itemKey, event);
          this.handlePrevent(event);
          break;
        case "Home":
          tabs[0].focus({
            preventScroll
          }); // focus first tab
          this.handlePrevent(event);
          break;
        case "End":
          tabs[tabs.length - 1].focus({
            preventScroll
          }); // focus last tab
          this.handlePrevent(event);
          break;
      }
    };
  }
  init() {
    this._adapter.collectPane();
  }
  _notifyChange(activeKey) {
    const {
      activeKey: stateActiveKey
    } = this.getStates();
    if (stateActiveKey !== activeKey) {
      this._adapter.notifyChange(activeKey);
    }
  }
  handleTabClick(activeKey, event) {
    const isControlledComponent = this._isInProps('activeKey');
    if (isControlledComponent) {
      this._notifyChange(activeKey);
    } else {
      this._notifyChange(activeKey);
      this.handleNewActiveKey(activeKey);
    }
    this._adapter.notifyTabClick(activeKey, event);
  }
  handleNewActiveKey(activeKey) {
    const {
      activeKey: stateActiveKey
    } = this.getStates();
    if (stateActiveKey !== activeKey) {
      this._adapter.setNewActiveKey(activeKey);
    }
  }
  getDefaultActiveKey() {
    let activeKey;
    const props = this.getProps();
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = this._adapter.getDefaultActiveKeyFromChildren();
    }
    return activeKey;
  }
  handleTabListChange() {
    this._adapter.collectPane();
  }
  handleTabPanesChange() {
    this._adapter.collectPane();
    this._adapter.collectActiveKey();
  }
  handleTabDelete(tabKey) {
    this._adapter.notifyTabDelete(tabKey);
  }
  determineOrientation(event, tabs) {
    const {
      tabPosition
    } = this.getProps();
    const isVertical = tabPosition === 'left';
    if (isVertical) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        this.switchTabOnArrowPress(event, tabs);
        this.handlePrevent(event);
      }
    } else {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        this.switchTabOnArrowPress(event, tabs);
        this.handlePrevent(event);
      }
    }
  }
  handleDeleteKeyDown(event, tabs, itemKey, closable) {
    const {
      preventScroll
    } = this.getProps();
    if (closable) {
      this.handleTabDelete(itemKey);
      const index = tabs.indexOf(event.target);
      // Move focus to next element after deletion
      // If the element is the last removable tab, focus to its previous tab
      if (tabs.length !== 1) {
        tabs[index + 1 >= tabs.length ? index - 1 : index + 1].focus({
          preventScroll
        });
      }
    }
  }
  switchTabOnArrowPress(event, tabs) {
    const {
      preventScroll
    } = this.getProps();
    const index = tabs.indexOf(event.target);
    const direction = {
      "ArrowLeft": -1,
      "ArrowUp": -1,
      "ArrowRight": 1,
      "ArrowDown": 1
    };
    if (direction[event.key]) {
      if (index !== undefined) {
        if (tabs[index + direction[event.key]]) {
          tabs[index + direction[event.key]].focus({
            preventScroll
          });
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          tabs[tabs.length - 1].focus({
            preventScroll
          }); // focus last tab
        } else if (event.key === "ArrowRight" || event.key == "ArrowDown") {
          tabs[0].focus({
            preventScroll
          }); // focus first tab
        }
      }
    }
  }
}

/* harmony default export */ var tabs_foundation = (TabsFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/dropdown/constants.js


const dropdown_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-dropdown`,
  SELECTED: `${BASE_CLASS_PREFIX}-dropdown-item-selected`,
  DISABLED: `${BASE_CLASS_PREFIX}-dropdown-item-disabled`
};
const dropdown_constants_strings = {
  POSITION_SET: tooltip_constants_strings.POSITION_SET,
  TRIGGER_SET: ['hover', 'focus', 'click', 'custom', 'contextMenu'],
  DEFAULT_LEAVE_DELAY: 100,
  ITEM_TYPE: ['primary', 'secondary', 'tertiary', 'warning', 'danger']
};
const dropdown_constants_numbers = {
  SPACING: 4,
  NESTED_SPACING: 2
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/dropdown/foundation.js


class DropdownFoundation extends foundation {
  handleVisibleChange(visible) {
    this._adapter.setPopVisible(visible);
    this._adapter.notifyVisibleChange(visible);
    const {
      trigger
    } = this.getProps();
    if (visible && trigger === "click") {
      const popupId = this._adapter.getPopupId();
      this.setFocusToFirstMenuItem(popupId);
    }
  }
  getMenuItemNodes(id) {
    const menuWrapper = document.getElementById(id);
    // if has dropdown item, the item must wrapped by li
    return menuWrapper ? Array.from(menuWrapper.getElementsByTagName('li')).filter(item => item.ariaDisabled === "false") : null;
  }
  setFocusToFirstMenuItem(id) {
    const menuItemNodes = this.getMenuItemNodes(id);
    menuItemNodes && setFocusToFirstItem(menuItemNodes);
  }
  setFocusToLastMenuItem(id) {
    const menuItemNodes = this.getMenuItemNodes(id);
    menuItemNodes && setFocusToLastItem(menuItemNodes);
  }
  handleKeyDown(event) {
    var _a, _b;
    const id = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.attributes['data-popupid']) === null || _b === void 0 ? void 0 : _b.value;
    const {
      visible
    } = this._adapter.getStates();
    switch (event.key) {
      case ' ':
      case 'Enter':
        event.target.click();
        // user may use input to be the trigger and bind some key event on it, so do not stoppropagation
        // handlePrevent(event);
        break;
      case 'ArrowDown':
        this.setFocusToFirstMenuItem(id);
        visible && handlePrevent(event);
        break;
      case 'ArrowUp':
        this.setFocusToLastMenuItem(id);
        visible && handlePrevent(event);
        break;
      default:
        break;
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/dropdown/menuFoundation.js


class DropdownMenuFoundation extends foundation {
  constructor() {
    super(...arguments);
    this.menuItemNodes = null;
    this.firstChars = [];
  }
  handleEscape(menu) {
    const trigger = this._adapter.getContext('trigger');
    if (trigger === 'custom') {
      const menuButton = menu && getMenuButton(document.querySelectorAll(`[data-popupid]`), menu.id);
      menuButton.focus();
    }
  }
  setFocusByFirstCharacter(curItem, char) {
    const index = findIndexByCharacter(this.menuItemNodes, curItem, this.firstChars, char);
    if (index >= 0) {
      setFocusToItem(this.menuItemNodes, this.menuItemNodes[index]);
    }
  }
  onMenuKeydown(event) {
    const menu = getAncestorNodeByRole(event.target, 'tooltip');
    if (!this.menuItemNodes) {
      this.menuItemNodes = [...event.target.parentNode.getElementsByTagName('li')].filter(item => item.ariaDisabled !== "true");
    }
    if (this.firstChars.length === 0) {
      this.menuItemNodes.forEach(item => {
        var _a;
        // the menuItemNodes can be an component and not exit textContent
        this.firstChars.push((_a = item.textContent.trim()[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase());
      });
    }
    // get the currently focused menu item
    const curItem = this.menuItemNodes.find(item => item.tabIndex === 0);
    switch (event.key) {
      case ' ':
      case 'Enter':
        event.target.click();
        // user may use input to be the trigger and bind some key event on it, so do not stoppropagation
        // handlePrevent(event);
        break;
      case 'Escape':
        this.handleEscape(menu);
        break;
      case 'ArrowUp':
        setFocusToPreviousMenuItem(this.menuItemNodes, curItem);
        handlePrevent(event);
        break;
      case 'ArrowDown':
        setFocusToNextMenuitem(this.menuItemNodes, curItem);
        handlePrevent(event);
        break;
      default:
        if (isPrintableCharacter(event.key)) {
          this.setFocusByFirstCharacter(curItem, event.key);
          // it can be an input on Dropdown, handlePrevent may affect the input of the component
          // handlePrevent(event); 
        }

        break;
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/context.js

const DropdownContext = /*#__PURE__*/react.createContext({
  level: 0
});
/* harmony default export */ var dropdown_context = (DropdownContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/dropdownMenu.js
var dropdownMenu_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const dropdownMenu_prefixCls = dropdown_constants_cssClasses.PREFIX;
class DropdownMenu extends BaseComponent {
  constructor(props) {
    super(props);
    this.foundation = new DropdownMenuFoundation(this.adapter);
  }
  get adapter() {
    return Object.assign({}, super.adapter);
  }
  render() {
    const _a = this.props,
      {
        children,
        className,
        style
      } = _a,
      rest = dropdownMenu_rest(_a, ["children", "className", "style"]);
    return /*#__PURE__*/react.createElement("ul", Object.assign({
      role: "menu",
      "aria-orientation": "vertical"
    }, rest, {
      className: classnames_default()(`${dropdownMenu_prefixCls}-menu`, className),
      style: style,
      onKeyDown: e => this.foundation.onMenuKeydown(e)
    }), children);
  }
}
DropdownMenu.propTypes = {
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object
};
DropdownMenu.contextType = dropdown_context;
/* harmony default export */ var dropdownMenu = (DropdownMenu);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/dropdownItem.js








const dropdownItem_prefixCls = dropdown_constants_cssClasses.PREFIX;
class DropdownItem extends BaseComponent {
  render() {
    const {
      children,
      disabled,
      className,
      forwardRef,
      style,
      type,
      active,
      icon,
      onKeyDown,
      showTick,
      hover
    } = this.props;
    const {
      showTick: contextShowTick
    } = this.context;
    const realShowTick = contextShowTick !== null && contextShowTick !== void 0 ? contextShowTick : showTick;
    const itemclass = classnames_default()(className, {
      [`${dropdownItem_prefixCls}-item`]: true,
      [`${dropdownItem_prefixCls}-item-disabled`]: disabled,
      [`${dropdownItem_prefixCls}-item-hover`]: hover,
      [`${dropdownItem_prefixCls}-item-withTick`]: realShowTick,
      [`${dropdownItem_prefixCls}-item-${type}`]: type,
      [`${dropdownItem_prefixCls}-item-active`]: active
    });
    const events = {};
    if (!disabled) {
      ['onClick', 'onMouseEnter', 'onMouseLeave', 'onContextMenu'].forEach(eventName => {
        const isInAnotherDropdown = this.context.level !== 1;
        if (isInAnotherDropdown && eventName === "onClick") {
          events["onMouseDown"] = e => {
            var _a, _b;
            if (e.button === 0) {
              (_b = (_a = this.props)[eventName]) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }
          };
        } else {
          events[eventName] = this.props[eventName];
        }
      });
    }
    let tick = null;
    switch (true) {
      case realShowTick && active:
        tick = /*#__PURE__*/react.createElement(IconTick, null);
        break;
      case realShowTick && !active:
        tick = /*#__PURE__*/react.createElement(IconTick, {
          style: {
            color: 'transparent'
          }
        });
        break;
      default:
        tick = null;
        break;
    }
    let iconContent = null;
    if (icon) {
      iconContent = /*#__PURE__*/react.createElement("div", {
        className: `${dropdownItem_prefixCls}-item-icon`
      }, icon);
    }
    return /*#__PURE__*/react.createElement("li", Object.assign({
      role: "menuitem",
      tabIndex: -1,
      "aria-disabled": disabled
    }, events, {
      onKeyDown: onKeyDown,
      ref: ref => forwardRef(ref),
      className: itemclass,
      style: style
    }, this.getDataAttr(this.props)), tick, iconContent, children);
  }
}
DropdownItem.propTypes = {
  children: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).node]),
  name: (prop_types_default()).string,
  disabled: (prop_types_default()).bool,
  selected: (prop_types_default()).bool,
  onClick: (prop_types_default()).func,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  onContextMenu: (prop_types_default()).func,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  forwardRef: (prop_types_default()).func,
  type: prop_types_default().oneOf(dropdown_constants_strings.ITEM_TYPE),
  active: (prop_types_default()).bool,
  icon: (prop_types_default()).node
};
DropdownItem.contextType = dropdown_context;
DropdownItem.defaultProps = {
  disabled: false,
  divided: false,
  selected: false,
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default()),
  forwardRef: (noop_default())
};
DropdownItem.elementType = 'Dropdown.Item';
/* harmony default export */ var dropdownItem = (DropdownItem);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/dropdownDivider.js




const dropdownDivider_prefixCls = dropdown_constants_cssClasses.PREFIX;
const DropdownDivider = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    style,
    className
  } = props;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(`${dropdownDivider_prefixCls}-divider`, className),
    style: style
  });
};
DropdownDivider.propTypes = {
  style: (prop_types_default()).object,
  className: (prop_types_default()).string
};
/* harmony default export */ var dropdownDivider = (DropdownDivider);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/dropdownTitle.js





const dropdownTitle_prefixCls = dropdown_constants_cssClasses.PREFIX;
class DropdownTitle extends react.PureComponent {
  render() {
    const {
      className,
      style,
      children
    } = this.props;
    const {
      showTick
    } = this.context;
    const titleCls = classnames_default()({
      [`${dropdownTitle_prefixCls}-title`]: true,
      [`${dropdownTitle_prefixCls}-title-withTick`]: showTick
    }, className);
    return /*#__PURE__*/react.createElement("div", {
      className: titleCls,
      style: style
    }, children);
  }
}
DropdownTitle.propTypes = {
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object
};
DropdownTitle.contextType = dropdown_context;
/* harmony default export */ var dropdownTitle = (DropdownTitle);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/dropdown/index.js


var dropdown_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};













// import '@douyinfe/semi-foundation/lib/es/dropdown/dropdown.css';

const dropdown_positionSet = dropdown_constants_strings.POSITION_SET;
const dropdown_triggerSet = dropdown_constants_strings.TRIGGER_SET;
class Dropdown extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleVisibleChange = visible => this.foundation.handleVisibleChange(visible);
    this.state = {
      popVisible: props.visible
    };
    this.foundation = new DropdownFoundation(this.adapter);
    this.tooltipRef = /*#__PURE__*/react.createRef();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setPopVisible: popVisible => this.setState({
        popVisible
      }),
      notifyVisibleChange: visible => this.props.onVisibleChange(visible),
      getPopupId: () => this.tooltipRef.current.getPopupId()
    });
  }
  renderContent() {
    const {
      render,
      menu,
      contentClassName,
      style,
      showTick,
      prefixCls,
      trigger
    } = this.props;
    const className = classnames_default()(prefixCls, contentClassName);
    const {
      level = 0
    } = this.context;
    const contextValue = {
      showTick,
      level: level + 1,
      trigger
    };
    let content = null;
    if ( /*#__PURE__*/react.isValidElement(render)) {
      content = render;
    } else if (Array.isArray(menu)) {
      content = this.renderMenu();
    }
    return /*#__PURE__*/react.createElement(dropdown_context.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement("div", {
      className: className,
      style: style
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-content`,
      "x-semi-prop": "render"
    }, content)));
  }
  renderMenu() {
    const {
      menu
    } = this.props;
    const content = menu.map((m, index) => {
      switch (m.node) {
        case 'title':
          {
            const {
                name,
                node
              } = m,
              rest = dropdown_rest(m, ["name", "node"]);
            return /*#__PURE__*/react.createElement(Dropdown.Title, Object.assign({}, rest, {
              key: node + name + index
            }), name);
          }
        case 'item':
          {
            const {
                node,
                name
              } = m,
              rest = dropdown_rest(m, ["node", "name"]);
            return /*#__PURE__*/react.createElement(Dropdown.Item, Object.assign({}, rest, {
              key: node + name + index
            }), name);
          }
        case 'divider':
          {
            return /*#__PURE__*/react.createElement(Dropdown.Divider, {
              key: m.node + index
            });
          }
        default:
          return null;
      }
    });
    return /*#__PURE__*/react.createElement(Dropdown.Menu, null, content);
  }
  renderPopCard() {
    const {
      render,
      contentClassName,
      style,
      showTick,
      prefixCls
    } = this.props;
    const className = classnames_default()(prefixCls, contentClassName);
    const {
      level = 0
    } = this.context;
    const contextValue = {
      showTick,
      level: level + 1
    };
    return /*#__PURE__*/react.createElement(dropdown_context.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement("div", {
      className: className,
      style: style
    }, /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-content`
    }, render)));
  }
  render() {
    const _a = this.props,
      {
        children,
        position,
        trigger,
        onVisibleChange,
        zIndex,
        className,
        motion,
        margin,
        style,
        prefixCls
      } = _a,
      attr = dropdown_rest(_a, ["children", "position", "trigger", "onVisibleChange", "zIndex", "className", "motion", "margin", "style", "prefixCls"]);
    let {
      spacing
    } = this.props;
    const {
      level
    } = this.context;
    const {
      popVisible
    } = this.state;
    const pop = this.renderContent();
    if (level > 0) {
      spacing = typeof spacing === 'number' ? spacing : dropdown_constants_numbers.NESTED_SPACING;
    } else if (spacing === null || typeof spacing === 'undefined') {
      spacing = dropdown_constants_numbers.SPACING;
    }
    return /*#__PURE__*/react.createElement(Tooltip, Object.assign({
      zIndex: zIndex,
      motion: motion,
      margin: margin,
      content: pop,
      className: className,
      prefixCls: prefixCls,
      spacing: spacing,
      position: position,
      trigger: trigger,
      onVisibleChange: this.handleVisibleChange,
      showArrow: false,
      returnFocusOnClose: true,
      ref: this.tooltipRef
    }, attr), /*#__PURE__*/react.isValidElement(children) ? /*#__PURE__*/react.cloneElement(children, {
      //@ts-ignore
      className: classnames_default()(get_default()(children, 'props.className'), {
        [`${prefixCls}-showing`]: popVisible
      }),
      'aria-haspopup': true,
      'aria-expanded': popVisible,
      onKeyDown: e => {
        this.foundation.handleKeyDown(e);
        const childrenKeyDown = get_default()(children, 'props.onKeyDown');
        childrenKeyDown && childrenKeyDown(e);
      }
    }) : children);
  }
}
Dropdown.Menu = dropdownMenu;
Dropdown.Item = dropdownItem;
Dropdown.Divider = dropdownDivider;
Dropdown.Title = dropdownTitle;
Dropdown.contextType = dropdown_context;
Dropdown.propTypes = {
  children: (prop_types_default()).node,
  contentClassName: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  className: (prop_types_default()).string,
  getPopupContainer: (prop_types_default()).func,
  margin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  menu: (prop_types_default()).array,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  onVisibleChange: (prop_types_default()).func,
  prefixCls: (prop_types_default()).string,
  position: prop_types_default().oneOf(dropdown_positionSet),
  rePosKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  render: (prop_types_default()).node,
  spacing: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  showTick: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  trigger: prop_types_default().oneOf(dropdown_triggerSet),
  visible: (prop_types_default()).bool,
  zIndex: (prop_types_default()).number
};
Dropdown.__SemiComponentName__ = "Dropdown";
Dropdown.defaultProps = getDefaultPropsFromGlobalConfig(Dropdown.__SemiComponentName__, {
  onVisibleChange: (noop_default()),
  prefixCls: dropdown_constants_cssClasses.PREFIX,
  zIndex: numbers.DEFAULT_Z_INDEX,
  motion: true,
  trigger: 'hover',
  position: 'bottom',
  mouseLeaveDelay: dropdown_constants_strings.DEFAULT_LEAVE_DELAY,
  showTick: false,
  closeOnEsc: true,
  onEscKeyDown: (noop_default())
});
/* harmony default export */ var dropdown = (Dropdown);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tabs/TabItem.js
var TabItem_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




const TabItem = (props, ref) => {
  const {
      tab,
      size,
      type,
      icon,
      selected,
      closable,
      disabled,
      itemKey,
      deleteTabItem,
      tabPosition,
      handleKeyDown,
      onClick
    } = props,
    restProps = TabItem_rest(props, ["tab", "size", "type", "icon", "selected", "closable", "disabled", "itemKey", "deleteTabItem", "tabPosition", "handleKeyDown", "onClick"]);
  const closableIcon = (0,react.useMemo)(() => {
    return type === 'card' && closable ? /*#__PURE__*/react.createElement(IconClose, {
      "aria-label": "Close",
      role: "button",
      className: `${tabs_constants_cssClasses.TABS_TAB}-icon-close`,
      onClick: e => deleteTabItem(itemKey, e)
    }) : null;
  }, [type, closable, deleteTabItem, itemKey]);
  const renderIcon = (0,react.useCallback)(icon => /*#__PURE__*/react.createElement("span", {
    className: `${tabs_constants_cssClasses.TABS_BAR}-icon`
  }, icon), []);
  const handleKeyDownInItem = (0,react.useCallback)(event => {
    handleKeyDown && handleKeyDown(event, itemKey, closable);
  }, [handleKeyDown, itemKey, closable]);
  const handleItemClick = (0,react.useCallback)(e => {
    !disabled && onClick && onClick(itemKey, e);
  }, [itemKey, disabled, onClick]);
  const panelIcon = icon ? renderIcon(icon) : null;
  const className = classnames_default()(tabs_constants_cssClasses.TABS_TAB, `${tabs_constants_cssClasses.TABS_TAB}-${type}`, `${tabs_constants_cssClasses.TABS_TAB}-${tabPosition}`, `${tabs_constants_cssClasses.TABS_TAB}-single`, {
    [tabs_constants_cssClasses.TABS_TAB_ACTIVE]: selected,
    [tabs_constants_cssClasses.TABS_TAB_DISABLED]: disabled,
    [`${tabs_constants_cssClasses.TABS_TAB}-small`]: size === 'small',
    [`${tabs_constants_cssClasses.TABS_TAB}-medium`]: size === 'medium'
  });
  return /*#__PURE__*/react.createElement("div", Object.assign({
    role: "tab",
    id: `semiTab${itemKey}`,
    "data-tabkey": `semiTab${itemKey}`,
    "aria-controls": `semiTabPanel${itemKey}`,
    "aria-disabled": disabled ? 'true' : 'false',
    "aria-selected": selected ? 'true' : 'false',
    tabIndex: selected ? 0 : -1,
    onKeyDown: handleKeyDownInItem,
    onClick: handleItemClick,
    className: className
  }, restProps, {
    ref: ref
  }), panelIcon, tab, closableIcon);
};
// Why is forwardRef needed here？
// Because TabItem needs to be used in OverflowList （when tabs' type is collapsible), 
// OverflowList will pass ref to the outermost div DOM node of TabItem
const ForwardTabItem = /*#__PURE__*/(0,react.forwardRef)(TabItem);
// @ts-ignore 
ForwardTabItem.elementType = 'Tabs.TabItem';
/* harmony default export */ var tabs_TabItem = (ForwardTabItem);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tabs/TabBar.js


var TabBar_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};












class TabBar extends react.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.handleItemClick = (itemKey, e) => {
      this.props.onTabClick(itemKey, e);
    };
    this.handleKeyDown = (event, itemKey, closable) => {
      this.props.handleKeyDown(event, itemKey, closable);
    };
    this.renderTabItem = panel => {
      const {
        size,
        type,
        deleteTabItem,
        handleKeyDown,
        tabPosition
      } = this.props;
      const isSelected = this._isActive(panel.itemKey);
      return /*#__PURE__*/react.createElement(tabs_TabItem, Object.assign({}, pick_default()(panel, ['disabled', 'icon', 'itemKey', 'tab', 'closable']), {
        key: this._getBarItemKeyByItemKey(panel.itemKey),
        selected: isSelected,
        size: size,
        type: type,
        tabPosition: tabPosition,
        handleKeyDown: handleKeyDown,
        deleteTabItem: deleteTabItem,
        onClick: this.handleItemClick
      }));
    };
    this.scrollTabItemIntoViewByKey = function (key) {
      let logicalPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'nearest';
      const tabItem = document.querySelector(`[data-uuid="${_this.state.uuid}"] .${tabs_constants_cssClasses.TABS_TAB}[data-scrollkey="${key}"]`);
      tabItem === null || tabItem === void 0 ? void 0 : tabItem.scrollIntoView({
        behavior: 'smooth',
        block: logicalPosition,
        inline: logicalPosition
      });
    };
    this.scrollActiveTabItemIntoView = logicalPosition => {
      const key = this._getBarItemKeyByItemKey(this.props.activeKey);
      this.scrollTabItemIntoViewByKey(key, logicalPosition);
    };
    this.renderTabComponents = list => list.map(panel => this.renderTabItem(panel));
    this.handleArrowClick = (items, pos) => {
      const lastItem = pos === 'start' ? items.pop() : items.shift();
      if (!lastItem) {
        return;
      }
      const key = this._getBarItemKeyByItemKey(lastItem.itemKey);
      this.scrollTabItemIntoViewByKey(key);
    };
    this.renderCollapse = (items, icon, pos) => {
      const arrowCls = classnames_default()({
        [`${tabs_constants_cssClasses.TABS_BAR}-arrow-${pos}`]: pos,
        [`${tabs_constants_cssClasses.TABS_BAR}-arrow`]: true
      });
      if (isEmpty_default()(items)) {
        return /*#__PURE__*/react.createElement("div", {
          role: "presentation",
          className: arrowCls
        }, /*#__PURE__*/react.createElement(es_button, {
          disabled: true,
          icon: icon,
          theme: "borderless"
        }));
      }
      const {
        dropdownClassName,
        dropdownStyle,
        showRestInDropdown
      } = this.props;
      const {
        rePosKey
      } = this.state;
      const disabled = !items.length;
      const menu = /*#__PURE__*/react.createElement(dropdown.Menu, null, items.map(panel => {
        const {
          icon: i,
          tab,
          itemKey
        } = panel;
        const panelIcon = i ? this.renderIcon(panel.icon) : null;
        return /*#__PURE__*/react.createElement(dropdown.Item, {
          key: itemKey,
          onClick: e => this.handleItemClick(itemKey, e),
          active: this._isActive(itemKey)
        }, panelIcon, tab);
      }));
      const button = /*#__PURE__*/react.createElement("div", {
        role: "presentation",
        className: arrowCls,
        onClick: e => this.handleArrowClick(items, pos)
      }, /*#__PURE__*/react.createElement(es_button, {
        disabled: disabled,
        icon: icon,
        theme: "borderless"
      }));
      const dropdownCls = classnames_default()(dropdownClassName, {
        [`${tabs_constants_cssClasses.TABS_BAR}-dropdown`]: true
      });
      return /*#__PURE__*/react.createElement(react.Fragment, null, showRestInDropdown ? /*#__PURE__*/react.createElement(dropdown, {
        className: dropdownCls,
        clickToHide: true,
        clickTriggerToHide: true,
        key: `${rePosKey}-${pos}`,
        position: pos === 'start' ? 'bottomLeft' : 'bottomRight',
        render: disabled ? null : menu,
        showTick: true,
        style: dropdownStyle,
        trigger: 'hover',
        disableFocusListener // prevent the panel from popping up again after clicking
        : true
      }, button) : button);
    };
    this.renderOverflow = items => items.map((item, index) => {
      const pos = index === 0 ? 'start' : 'end';
      if (this.props.renderArrow) {
        return this.props.renderArrow(item, pos, () => this.handleArrowClick(item, pos));
      }
      const icon = index === 0 ? /*#__PURE__*/react.createElement(IconChevronLeft/* default */.Z, null) : /*#__PURE__*/react.createElement(IconChevronRight, null);
      return this.renderCollapse(item, icon, pos);
    });
    this.renderCollapsedTab = () => {
      const {
        list
      } = this.props;
      const renderedList = list.map(item => {
        const {
          itemKey
        } = item;
        return Object.assign({
          key: this._getBarItemKeyByItemKey(itemKey),
          active: this._isActive(itemKey)
        }, item);
      });
      return /*#__PURE__*/react.createElement(overflowList, {
        items: renderedList,
        overflowRenderDirection: this.props.arrowPosition,
        wrapperStyle: this.props.visibleTabsStyle,
        overflowRenderer: this.renderOverflow,
        renderMode: "scroll",
        className: `${tabs_constants_cssClasses.TABS_BAR}-overflow-list`,
        visibleItemRenderer: this.renderTabItem,
        onVisibleStateChange: visibleMap => {
          var _a, _b;
          const visibleMapWithItemKey = new Map();
          visibleMap.forEach((v, k) => {
            visibleMapWithItemKey.set(this._getItemKeyByBarItemKey(k), v);
          });
          (_b = (_a = this.props).onVisibleTabsChange) === null || _b === void 0 ? void 0 : _b.call(_a, visibleMapWithItemKey);
        }
      });
    };
    this.renderWithMoreTrigger = () => {
      const {
        list,
        more
      } = this.props;
      let tabElements = [];
      let moreTrigger = /*#__PURE__*/react.createElement("div", {
        className: classnames_default()({
          [`${tabs_constants_cssClasses.TABS_BAR}-more-trigger`]: true,
          [`${tabs_constants_cssClasses.TABS_BAR}-more-trigger-${this.props.type}`]: true
        })
      }, /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Tabs"
      }, (locale, localeCode) => /*#__PURE__*/react.createElement("div", {
        className: `${tabs_constants_cssClasses.TABS_BAR}-more-trigger-content`
      }, /*#__PURE__*/react.createElement("div", null, locale.more), /*#__PURE__*/react.createElement(IconChevronDown, {
        className: `${tabs_constants_cssClasses.TABS_BAR}-more-trigger-content-icon`
      }))));
      let keepCount;
      if (typeof more === "number") {
        keepCount = list.length - Math.min(more, list.length);
        tabElements = list.slice(0, keepCount).map(panel => this.renderTabItem(panel));
      } else if (typeof more === 'object') {
        keepCount = list.length - Math.min(more.count, list.length);
        tabElements = list.slice(0, keepCount).map(panel => this.renderTabItem(panel));
        if (more.render) {
          moreTrigger = more.render();
        }
      } else if (more !== undefined) {
        throw new Error("[Semi Tabs]: invalid tab props format: more");
      }
      return /*#__PURE__*/react.createElement(react.Fragment, null, tabElements, this.renderMoreDropdown(list.slice(keepCount), more === null || more === void 0 ? void 0 : more['dropdownProps'], moreTrigger));
    };
    this.renderMoreDropdown = (panels, dropDownProps, trigger) => {
      return /*#__PURE__*/react.createElement(dropdown, Object.assign({
        trigger: 'hover',
        showTick: true,
        position: 'bottomLeft',
        className: `${tabs_constants_cssClasses.TABS_BAR}-more-dropdown-${this.props.type}`,
        clickToHide: true,
        menu: panels.map(panel => ({
          node: 'item',
          name: panel.tab,
          icon: panel.icon,
          onClick: e => this.props.onTabClick(panel.itemKey, e),
          active: this.props.activeKey === panel.itemKey
        }))
      }, dropDownProps), trigger);
    };
    this._isActive = key => key === this.props.activeKey;
    this._getBarItemKeyByItemKey = key => `${key}-bar`;
    this._getItemKeyByBarItemKey = key => key.replace(/-bar$/, "");
    this.state = {
      endInd: props.list.length,
      rePosKey: 0,
      startInd: 0,
      uuid: '',
      currentVisibleItems: []
    };
  }
  componentDidMount() {
    this.setState({
      uuid: getUuidv4()
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.activeKey !== this.props.activeKey) {
      if (this.props.collapsible) {
        this.scrollActiveTabItemIntoView();
      }
    }
  }
  renderIcon(icon) {
    return /*#__PURE__*/react.createElement("span", null, icon);
  }
  renderExtra() {
    const {
      tabBarExtraContent,
      type,
      size
    } = this.props;
    const tabBarExtraContentDefaultStyle = {
      float: 'right'
    };
    const tabBarExtraContentStyle = tabBarExtraContent && tabBarExtraContent.props ? tabBarExtraContent.props.style : {};
    const extraCls = classnames_default()(tabs_constants_cssClasses.TABS_BAR_EXTRA, {
      [`${tabs_constants_cssClasses.TABS_BAR}-${type}-extra`]: type,
      [`${tabs_constants_cssClasses.TABS_BAR}-${type}-extra-${size}`]: size
    });
    if (tabBarExtraContent) {
      const tabBarStyle = Object.assign(Object.assign({}, tabBarExtraContentDefaultStyle), tabBarExtraContentStyle);
      return /*#__PURE__*/react.createElement("div", {
        className: extraCls,
        style: tabBarStyle,
        "x-semi-prop": "tabBarExtraContent"
      }, tabBarExtraContent);
    }
    return null;
  }
  render() {
    const _a = this.props,
      {
        type,
        style,
        className,
        list,
        tabPosition,
        more,
        collapsible
      } = _a,
      restProps = TabBar_rest(_a, ["type", "style", "className", "list", "tabPosition", "more", "collapsible"]);
    const classNames = classnames_default()(className, {
      [tabs_constants_cssClasses.TABS_BAR]: true,
      [tabs_constants_cssClasses.TABS_BAR_LINE]: type === 'line',
      [tabs_constants_cssClasses.TABS_BAR_CARD]: type === 'card',
      [tabs_constants_cssClasses.TABS_BAR_BUTTON]: type === 'button',
      [`${tabs_constants_cssClasses.TABS_BAR}-${tabPosition}`]: tabPosition,
      [`${tabs_constants_cssClasses.TABS_BAR}-collapse`]: collapsible
    });
    const extra = this.renderExtra();
    const contents = collapsible ? this.renderCollapsedTab() : more ? this.renderWithMoreTrigger() : this.renderTabComponents(list);
    return /*#__PURE__*/react.createElement("div", Object.assign({
      role: "tablist",
      "aria-orientation": tabPosition === "left" ? "vertical" : "horizontal",
      className: classNames,
      style: style
    }, getDataAttr(restProps), {
      "data-uuid": this.state.uuid
    }), contents, extra);
  }
}
TabBar.propTypes = {
  activeKey: (prop_types_default()).string,
  className: (prop_types_default()).string,
  collapsible: (prop_types_default()).bool,
  list: (prop_types_default()).array,
  onTabClick: (prop_types_default()).func,
  size: prop_types_default().oneOf(tabs_constants_strings.SIZE),
  style: (prop_types_default()).object,
  tabBarExtraContent: (prop_types_default()).node,
  tabPosition: prop_types_default().oneOf(tabs_constants_strings.POSITION_MAP),
  type: prop_types_default().oneOf(tabs_constants_strings.TYPE_MAP),
  closable: (prop_types_default()).bool,
  deleteTabItem: (prop_types_default()).func,
  more: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object])
};
/* harmony default export */ var tabs_TabBar = (TabBar);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tabs/tabs-context.js

const TabsContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var tabs_context = (TabsContext);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tabs/TabPane.js
var TabPane_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







class TabPane extends react.PureComponent {
  constructor() {
    super(...arguments);
    this.ref = /*#__PURE__*/(0,react.createRef)();
    // get direction from current item key to activeKey
    this.getDirection = (activeKey, itemKey, panes, lastActiveKey) => {
      if (itemKey !== null && activeKey !== null && Array.isArray(panes) && panes.length) {
        const activeIndex = panes.findIndex(pane => pane.itemKey === activeKey);
        const itemIndex = panes.findIndex(pane => pane.itemKey === itemKey);
        const lastActiveIndex = panes.findIndex(pane => pane.itemKey === lastActiveKey);
        if (activeIndex === itemIndex) {
          return lastActiveIndex > activeIndex;
        } else {
          return itemIndex < activeIndex;
        }
      }
      return false;
    };
    this.shouldRender = () => {
      const {
        itemKey
      } = this.props;
      const {
        activeKey,
        lazyRender
      } = this.context;
      const active = activeKey === itemKey;
      this._active = this._active || active;
      return lazyRender ? this._active : true;
    };
  }
  render() {
    const {
      tabPaneMotion: motion,
      tabPosition,
      prevActiveKey
    } = this.context;
    const _a = this.props,
      {
        className,
        style,
        children,
        itemKey,
        tabIndex
      } = _a,
      restProps = TabPane_rest(_a, ["className", "style", "children", "itemKey", "tabIndex"]);
    const active = this.context.activeKey === itemKey;
    const classNames = classnames_default()(className, {
      [tabs_constants_cssClasses.TABS_PANE_INACTIVE]: !active,
      [tabs_constants_cssClasses.TABS_PANE_ACTIVE]: active,
      [tabs_constants_cssClasses.TABS_PANE]: true
    });
    const shouldRender = this.shouldRender();
    const startClassName = (() => {
      const direction = this.getDirection(this.context.activeKey, itemKey, this.context.panes, prevActiveKey);
      if (tabPosition === 'top') {
        if (direction) {
          return tabs_constants_cssClasses.TABS_PANE_ANIMATE_RIGHT_SHOW;
        } else {
          return tabs_constants_cssClasses.TABS_PANE_ANIMATE_LEFT_SHOW;
        }
      } else {
        if (direction) {
          return tabs_constants_cssClasses.TABS_PANE_ANIMATE_BOTTOM_SHOW;
        } else {
          return tabs_constants_cssClasses.TABS_PANE_ANIMATE_TOP_SHOW;
        }
      }
    })();
    const isActivatedBecauseOtherTabPaneRemoved = !this.context.panes.find(tabPane => tabPane.itemKey === prevActiveKey);
    const hasMotion = motion && active && !isActivatedBecauseOtherTabPaneRemoved && !this.context.forceDisableMotion;
    return /*#__PURE__*/react.createElement("div", Object.assign({
      ref: this.ref,
      role: "tabpanel",
      id: `semiTabPanel${itemKey}`,
      "aria-labelledby": `semiTab${itemKey}`,
      className: classNames,
      style: style,
      "aria-hidden": active ? 'false' : 'true',
      tabIndex: tabIndex ? tabIndex : 0
    }, getDataAttr(restProps), {
      "x-semi-prop": "children"
    }), /*#__PURE__*/react.createElement(_cssAnimation, {
      motion: hasMotion,
      animationState: active ? "enter" : "leave",
      startClassName: startClassName
    }, _ref => {
      let {
        animationClassName,
        animationEventsNeedBind
      } = _ref;
      return /*#__PURE__*/react.createElement("div", Object.assign({
        className: classnames_default()(tabs_constants_cssClasses.TABS_PANE_MOTION_OVERLAY, animationClassName),
        "x-semi-prop": "children"
      }, animationEventsNeedBind), shouldRender ? children : null);
    }));
  }
}
TabPane.isTabPane = true;
TabPane.contextType = tabs_context;
TabPane.propTypes = {
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  children: (prop_types_default()).node,
  disabled: (prop_types_default()).bool,
  itemKey: (prop_types_default()).string,
  tab: (prop_types_default()).node,
  icon: (prop_types_default()).node,
  closable: (prop_types_default()).bool
};
/* harmony default export */ var tabs_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tabs/index.js


var tabs_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/tabs/tabs.css';





const panePickKeys = ['className', 'style', 'disabled', 'itemKey', 'tab', 'icon'];

class Tabs extends BaseComponent {
  constructor(props) {
    super(props);
    this.setContentRef = ref => {
      this.contentRef = {
        current: ref
      };
    };
    this.getPanes = () => {
      const {
        tabList,
        children
      } = this.props;
      if (Array.isArray(tabList) && tabList.length) {
        return tabList;
      }
      return react.Children.map(children, child => {
        if (child) {
          const {
            tab,
            icon,
            disabled,
            itemKey,
            closable
          } = child.props;
          return {
            tab,
            icon,
            disabled,
            itemKey,
            closable
          };
        }
        return undefined;
      });
    };
    this.onTabClick = (activeKey, event) => {
      this.foundation.handleTabClick(activeKey, event);
    };
    /* istanbul ignore next */
    this.rePosChildren = (children, activeKey) => {
      const newChildren = [];
      const falttenChildren = react.Children.toArray(children);
      if (children.length) {
        newChildren.push(...falttenChildren.filter(child => child.props && child.props.itemKey === activeKey));
        newChildren.push(...falttenChildren.filter(child => child.props && child.props.itemKey !== activeKey));
      }
      return newChildren;
    };
    this.getActiveItem = () => {
      const {
        activeKey
      } = this.state;
      const {
        children,
        tabList
      } = this.props;
      if (tabList || !Array.isArray(children)) {
        return children;
      }
      return react.Children.toArray(children).filter(pane => {
        if ( /*#__PURE__*/(0,react.isValidElement)(pane) && pane.type && pane.type.isTabPane) {
          return pane.props.itemKey === activeKey;
        }
        return true;
      });
    };
    this.deleteTabItem = (tabKey, event) => {
      event.stopPropagation();
      this.foundation.handleTabDelete(tabKey);
    };
    this.foundation = new tabs_foundation(this.adapter);
    this.state = {
      activeKey: this.foundation.getDefaultActiveKey(),
      panes: this.getPanes(),
      prevActiveKey: null,
      forceDisableMotion: false
    };
    this.contentRef = /*#__PURE__*/(0,react.createRef)();
    this.contentHeight = 'auto';
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      collectPane: () => {
        const panes = this.getPanes();
        this.setState({
          panes
        });
      },
      collectActiveKey: () => {
        const {
          tabList,
          children,
          activeKey: propsActiveKey
        } = this.props;
        if (typeof propsActiveKey !== 'undefined') {
          return;
        }
        const {
          activeKey
        } = this.state;
        const panes = this.getPanes();
        if (panes.findIndex(p => p.itemKey === activeKey) === -1) {
          if (panes.length > 0) {
            this.setState({
              activeKey: panes[0].itemKey
            });
          } else {
            this.setState({
              activeKey: ''
            });
          }
        }
      },
      notifyTabClick: (activeKey, event) => {
        this.props.onTabClick(activeKey, event);
      },
      notifyChange: activeKey => {
        this.props.onChange(activeKey);
      },
      setNewActiveKey: activeKey => {
        this.setState({
          activeKey
        });
      },
      getDefaultActiveKeyFromChildren: () => {
        const {
          tabList,
          children
        } = this.props;
        let activeKey = '';
        const list = tabList ? tabList : react.Children.toArray(children).map(child => /*#__PURE__*/(0,react.isValidElement)(child) ? child.props : null);
        list.forEach(item => {
          if (item && !activeKey && !item.disabled) {
            activeKey = item.itemKey;
          }
        });
        return activeKey;
      },
      notifyTabDelete: tabKey => {
        this.props.onTabClose && this.props.onTabClose(tabKey);
      }
    });
  }
  static getDerivedStateFromProps(props, state) {
    const states = {};
    if (!isNullOrUndefined(props.activeKey) && props.activeKey !== state.activeKey) {
      state.prevActiveKey = state.activeKey;
      states.activeKey = props.activeKey;
    }
    return states;
  }
  componentDidUpdate(prevProps, prevState) {
    // Panes state acts on tab bar, no need to compare TabPane children
    const prevChildrenProps = react.Children.toArray(prevProps.children).map(child => pick_default()( /*#__PURE__*/(0,react.isValidElement)(child) ? child.props : null, panePickKeys));
    const nowChildrenProps = react.Children.toArray(this.props.children).map(child => pick_default()( /*#__PURE__*/(0,react.isValidElement)(child) ? child.props : null, panePickKeys));
    const isTabListType = this.props.tabList || prevProps.tabList;
    if (!isEqual_default()(this.props.tabList, prevProps.tabList)) {
      this.foundation.handleTabListChange();
    }
    if (prevState.activeKey !== this.state.activeKey && prevState.activeKey !== this.state.prevActiveKey) {
      this.setState({
        prevActiveKey: prevState.activeKey
      });
    }
    if (prevProps.activeKey !== this.props.activeKey) {
      const newAddedPanelItemKey = (() => {
        const prevItemKeys = new Set(prevChildrenProps.map(p => p.itemKey));
        return nowChildrenProps.map(p => p.itemKey).filter(itemKey => !prevItemKeys.has(itemKey));
      })();
      this.setState({
        forceDisableMotion: newAddedPanelItemKey.includes(this.props.activeKey)
      });
    }
    // children变化，tabList方式使用时，啥也不用做
    // children变化，非tabList方式使用，需要重新取activeKey。TabPane可能是异步更新的，若不重新取，未设activeKey时，第一个不会自动激活
    // children changed: do nothing in tabList case
    // children changed: recalc activeKey. TabPane could be updated async. If not recalc the first panel will not be activated
    if (!isEqual_default()(prevChildrenProps, nowChildrenProps) && !isTabListType) {
      this.foundation.handleTabPanesChange();
    }
  }
  render() {
    const _a = this.props,
      {
        children,
        className,
        collapsible,
        contentStyle,
        keepDOM,
        lazyRender,
        renderTabBar,
        showRestInDropdown,
        size,
        style,
        tabBarClassName,
        tabBarExtraContent,
        tabBarStyle,
        tabPaneMotion,
        tabPosition,
        type,
        more,
        onVisibleTabsChange,
        visibleTabsStyle,
        arrowPosition,
        renderArrow
      } = _a,
      restProps = tabs_rest(_a, ["children", "className", "collapsible", "contentStyle", "keepDOM", "lazyRender", "renderTabBar", "showRestInDropdown", "size", "style", "tabBarClassName", "tabBarExtraContent", "tabBarStyle", "tabPaneMotion", "tabPosition", "type", "more", "onVisibleTabsChange", "visibleTabsStyle", "arrowPosition", "renderArrow"]);
    const {
      panes,
      activeKey
    } = this.state;
    const tabWrapperCls = classnames_default()(className, {
      [tabs_constants_cssClasses.TABS]: true,
      [`${tabs_constants_cssClasses.TABS}-${tabPosition}`]: tabPosition
    });
    const tabContentCls = classnames_default()({
      [tabs_constants_cssClasses.TABS_CONTENT]: true,
      [`${tabs_constants_cssClasses.TABS_CONTENT}-${tabPosition}`]: tabPosition
    });
    const tabBarProps = {
      activeKey,
      className: tabBarClassName,
      collapsible,
      list: panes,
      onTabClick: this.onTabClick,
      showRestInDropdown,
      size,
      style: tabBarStyle,
      tabBarExtraContent,
      tabPosition,
      type,
      deleteTabItem: this.deleteTabItem,
      handleKeyDown: this.foundation.handleKeyDown,
      more,
      onVisibleTabsChange,
      visibleTabsStyle,
      arrowPosition,
      renderArrow
    };
    const tabBar = renderTabBar ? renderTabBar(tabBarProps, tabs_TabBar) : /*#__PURE__*/react.createElement(tabs_TabBar, Object.assign({}, tabBarProps));
    const content = keepDOM ? children : this.getActiveItem();
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: tabWrapperCls,
      style: style
    }, this.getDataAttr(restProps)), tabBar, /*#__PURE__*/react.createElement(tabs_context.Provider, {
      value: {
        activeKey,
        lazyRender,
        panes,
        tabPaneMotion,
        tabPosition,
        prevActiveKey: this.state.prevActiveKey,
        forceDisableMotion: this.state.forceDisableMotion
      }
    }, /*#__PURE__*/react.createElement("div", {
      ref: this.setContentRef,
      className: tabContentCls,
      style: Object.assign({}, contentStyle)
    }, content)));
  }
}
Tabs.TabPane = tabs_TabPane;
Tabs.TabItem = tabs_TabItem;
Tabs.propTypes = {
  activeKey: (prop_types_default()).string,
  className: (prop_types_default()).string,
  collapsible: (prop_types_default()).bool,
  contentStyle: prop_types_default().oneOfType([(prop_types_default()).object]),
  defaultActiveKey: (prop_types_default()).string,
  keepDOM: (prop_types_default()).bool,
  lazyRender: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  onTabClick: (prop_types_default()).func,
  renderTabBar: (prop_types_default()).func,
  showRestInDropdown: (prop_types_default()).bool,
  size: prop_types_default().oneOf(tabs_constants_strings.SIZE),
  style: (prop_types_default()).object,
  tabBarClassName: (prop_types_default()).string,
  tabBarExtraContent: (prop_types_default()).node,
  tabBarStyle: (prop_types_default()).object,
  tabList: (prop_types_default()).array,
  tabPaneMotion: (prop_types_default()).bool,
  tabPosition: prop_types_default().oneOf(tabs_constants_strings.POSITION_MAP),
  type: prop_types_default().oneOf(tabs_constants_strings.TYPE_MAP),
  onTabClose: (prop_types_default()).func,
  preventScroll: (prop_types_default()).bool,
  more: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  arrowPosition: (prop_types_default()).string,
  renderArrow: (prop_types_default()).func
};
Tabs.__SemiComponentName__ = "Tabs";
Tabs.defaultProps = getDefaultPropsFromGlobalConfig(Tabs.__SemiComponentName__, {
  children: [],
  collapsible: false,
  keepDOM: true,
  lazyRender: false,
  onChange: () => undefined,
  onTabClick: () => undefined,
  size: 'large',
  tabPaneMotion: true,
  tabPosition: 'top',
  type: 'line',
  onTabClose: () => undefined,
  showRestInDropdown: true,
  arrowPosition: "both"
});
/* harmony default export */ var tabs = (Tabs);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/toast/toastListFoundation.js

class ToastListFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, ToastListFoundation.defaultAdapter), adapter));
    this.handleMouseInSideChange = mouseInSideChange => {
      this._adapter.handleMouseInSideChange(mouseInSideChange);
    };
    this.getInputWrapperRect = () => {
      return this._adapter.getInputWrapperRect();
    };
  }
  hasToast(id) {
    const toastList = this._adapter.getState('list');
    return toastList.map(_ref => {
      let {
        id
      } = _ref;
      return id;
    }).includes(id);
  }
  addToast(toastOpts) {
    const toastList = this._adapter.getState('list');
    // const id = getUuid('toast');
    // let toastOpts = { ...opts, id };
    // console.log(toastOpts);
    toastList.push(toastOpts);
    this._adapter.updateToast(toastList, [], []);
    // return id;
  }

  updateToast(id, toastOpts) {
    let toastList = this._adapter.getState('list');
    toastList = toastList.map(toast => toast.id === id ? Object.assign(Object.assign({}, toast), toastOpts) : toast);
    const updatedItems = toastList.filter(toast => toast.id === id);
    this._adapter.updateToast(toastList, [], updatedItems);
  }
  removeToast(id) {
    let toastList = this._adapter.getState('list');
    const removedItems = [];
    toastList = toastList.filter(toastOpts => {
      if (toastOpts.id === id) {
        removedItems.push(toastOpts);
        return false;
      }
      return true;
    });
    this._adapter.updateToast(toastList, removedItems, []);
  }
  destroyAll() {
    const toastList = this._adapter.getState('list');
    if (toastList.length > 0) {
      this._adapter.updateToast([], toastList, []);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/toast/constants.js

const constants_PREFIX = `${BASE_CLASS_PREFIX}-toast`;
const toast_constants_cssClasses = {
  PREFIX: constants_PREFIX,
  WRAPPER: `${constants_PREFIX}-wrapper`,
  LIST: `${constants_PREFIX}-list`
};
const toast_constants_strings = {
  types: ['warning', 'success', 'info', 'error', 'default'],
  themes: ['normal', 'light'],
  directions: ['ltr', 'rtl']
};
const toast_constants_numbers = {
  duration: 3 // default close time, unit: s
};


;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/toast/toastFoundation.js


class ToastFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, ToastFoundation.defaultAdapter), adapter));
    this._timer = null;
    this._id = null; // cache id
  }

  init() {
    this.startCloseTimer_();
    this._id = this._adapter.getProp('id');
  }
  destroy() {
    this.clearCloseTimer_();
  }
  startCloseTimer_() {
    // unit: s
    const duration = this._adapter.getProp('duration');
    if (duration && isNumber_default()(duration)) {
      this._timer = setTimeout(() => {
        this.close(); // call parent to remove itself
      }, duration * 1000);
    }
  }
  close(e) {
    if (e) {
      e.stopPropagation();
    }
    this._adapter.notifyWrapperToRemove(this._id);
    this._adapter.notifyClose();
  }
  clearCloseTimer_() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  restartCloseTimer() {
    this.clearCloseTimer_();
    this.startCloseTimer_();
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/toast/toast.js











const toast_prefixCls = toast_constants_cssClasses.PREFIX;
class Toast extends BaseComponent {
  constructor(props) {
    super(props);
    this.toastEle = /*#__PURE__*/react.createRef();
    this.clearCloseTimer = () => {
      this.foundation.clearCloseTimer_();
    };
    this.startCloseTimer = () => {
      this.foundation.startCloseTimer_();
    };
    this.restartCloseTimer = () => {
      this.foundation.restartCloseTimer();
    };
    this.state = {};
    this.foundation = new ToastFoundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      notifyWrapperToRemove: id => {
        this.props.close(id);
      },
      notifyClose: () => {
        this.props.onClose();
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  close(e) {
    this.foundation.close(e);
  }
  renderIcon() {
    const {
      type,
      icon
    } = this.props;
    const iconMap = {
      warning: /*#__PURE__*/react.createElement(IconAlertTriangle, null),
      success: /*#__PURE__*/react.createElement(IconTickCircle, null),
      info: /*#__PURE__*/react.createElement(IconInfoCircle, null),
      error: /*#__PURE__*/react.createElement(IconAlertCircle, null)
    };
    const iconType = iconMap[type];
    const iconSize = 'large';
    const iconCls = classnames_default()(`${toast_prefixCls}-icon`, `${toast_prefixCls}-icon-${type}`);
    if (icon) {
      return isSemiIcon(icon) ? /*#__PURE__*/react.cloneElement(icon, {
        size: iconSize,
        className: `${toast_prefixCls}-icon`
      }) : icon;
    }
    if (type && iconType) {
      return /*#__PURE__*/react.cloneElement(iconType, {
        size: iconSize,
        className: iconCls
      });
    }
    return null;
  }
  render() {
    const {
      content,
      type,
      theme,
      showClose,
      textMaxWidth,
      className,
      style
    } = this.props;
    const direction = this.props.direction || this.context.direction;
    const toastCls = classnames_default()(toast_prefixCls, className, {
      [`${toast_prefixCls}-${type}`]: true,
      [`${toast_prefixCls}-${theme}`]: theme === 'light',
      [`${toast_prefixCls}-rtl`]: direction === 'rtl'
    });
    const textStyle = {};
    textStyle.maxWidth = textMaxWidth;
    const btnTheme = 'borderless';
    const btnSize = 'small';
    const reservedIndex = this.props.positionInList ? this.props.positionInList.length - this.props.positionInList.index - 1 : 0;
    const toastEle = /*#__PURE__*/react.createElement("div", {
      ref: this.toastEle,
      role: "alert",
      "aria-label": `${type ? type : 'default'} type`,
      className: toastCls,
      style: Object.assign(Object.assign({}, style), {
        transform: `translate3d(0,0,${reservedIndex * -10}px)`
      }),
      onMouseEnter: this.clearCloseTimer,
      onMouseLeave: this.startCloseTimer,
      onAnimationStart: this.props.onAnimationStart,
      onAnimationEnd: this.props.onAnimationEnd
    }, /*#__PURE__*/react.createElement("div", {
      className: `${toast_prefixCls}-content`
    }, this.renderIcon(), /*#__PURE__*/react.createElement("span", {
      className: `${toast_prefixCls}-content-text`,
      style: textStyle,
      "x-semi-prop": "content"
    }, content), showClose && /*#__PURE__*/react.createElement("div", {
      className: `${toast_prefixCls}-close-button`
    }, /*#__PURE__*/react.createElement(iconButton, {
      onClick: e => this.close(e),
      type: "tertiary",
      icon: /*#__PURE__*/react.createElement(IconClose, {
        "x-semi-prop": "icon"
      }),
      theme: btnTheme,
      size: btnSize
    }))));
    if (this.props.stack) {
      const height = this.props.stackExpanded && this.toastEle.current && getComputedStyle(this.toastEle.current).height || 0;
      return /*#__PURE__*/react.createElement("div", {
        className: `${toast_prefixCls}-zero-height-wrapper`,
        style: {
          height
        }
      }, toastEle);
    } else {
      return toastEle;
    }
  }
}
Toast.contextType = context;
Toast.propTypes = {
  onClose: (prop_types_default()).func,
  content: (prop_types_default()).node,
  close: (prop_types_default()).func,
  duration: (prop_types_default()).number,
  theme: prop_types_default().oneOf(toast_constants_strings.themes),
  type: prop_types_default().oneOf(toast_constants_strings.types),
  textMaxWidth: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  showClose: (prop_types_default()).bool,
  stack: (prop_types_default()).bool,
  stackExpanded: (prop_types_default()).bool,
  icon: (prop_types_default()).node,
  direction: prop_types_default().oneOf(toast_constants_strings.directions)
};
Toast.__SemiComponentName__ = "Toast";
Toast.defaultProps = getDefaultPropsFromGlobalConfig(Toast.__SemiComponentName__, {
  onClose: (noop_default()),
  content: '',
  close: (noop_default()),
  duration: toast_constants_numbers.duration,
  textMaxWidth: 450,
  showClose: true,
  stack: false,
  stackExpanded: false,
  theme: 'normal'
});
/* harmony default export */ var toast = (Toast);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/toast/useToast/HookToast.js
var HookToast_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


const HookToast = (_a, ref) => {
  var {
      afterClose
    } = _a,
    config = HookToast_rest(_a, ["afterClose"]);
  const [visible, setVisible] = (0,react.useState)(true);
  const close = () => {
    setVisible(false);
  };
  react.useImperativeHandle(ref, () => ({
    close: () => {
      setVisible(false);
    }
  }));
  (0,react.useEffect)(() => {
    if (!visible) {
      afterClose(config.id);
    }
  }, [visible]);
  return visible ? /*#__PURE__*/react.createElement(toast, Object.assign({}, config, {
    close: close
  })) : null;
};
/* harmony default export */ var useToast_HookToast = (/*#__PURE__*/react.forwardRef(HookToast));
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/toast/useToast/index.js




// const ref = null;
// TODO: toast larger than N bars, automatic folding, allowing expansion, N configurable
const defaultOpts = {
  motion: true,
  zIndex: 1010,
  duration: 3
};
function useToast_usePatchElement() {
  const [elements, setElements] = react.useState([]);
  function patchElement(element, config) {
    setElements(originElements => [{
      element,
      config
    }, ...originElements]);
    return id => {
      setElements(originElements => originElements.filter(_ref => {
        let {
          config: configOfCurrentElement
        } = _ref;
        return configOfCurrentElement.id !== id;
      }));
    };
  }
  return [elements, patchElement];
}
function useToast() {
  const [elements, patchElement] = useToast_usePatchElement();
  const toastRef = (0,react.useRef)(new Map());
  const addToast = config => {
    const id = getUuid('semi_toast_');
    const mergeConfig = Object.assign(Object.assign({}, config), {
      id
    });
    let closeFunc;
    const toast = /*#__PURE__*/react.createElement(useToast_HookToast, Object.assign({}, mergeConfig, {
      key: id,
      afterClose: instanceId => closeFunc(instanceId),
      ref: data => {
        var _a;
        toastRef.current.set(id, {
          close: (_a = data === null || data === void 0 ? void 0 : data.close) !== null && _a !== void 0 ? _a : (noop_default())
        });
      }
    }));
    closeFunc = patchElement(toast, Object.assign({}, mergeConfig));
    return id;
  };
  const removeElement = id => {
    var _a;
    const {
      close
    } = (_a = toastRef.current.get(id)) !== null && _a !== void 0 ? _a : {};
    close === null || close === void 0 ? void 0 : close();
  };
  return [{
    success: config => addToast(Object.assign(Object.assign(Object.assign({}, defaultOpts), config), {
      type: 'success'
    })),
    info: config => addToast(Object.assign(Object.assign(Object.assign({}, defaultOpts), config), {
      type: 'info'
    })),
    error: config => addToast(Object.assign(Object.assign(Object.assign({}, defaultOpts), config), {
      type: 'error'
    })),
    warning: config => addToast(Object.assign(Object.assign(Object.assign({}, defaultOpts), config), {
      type: 'warning'
    })),
    open: config => addToast(Object.assign(Object.assign(Object.assign({}, defaultOpts), config), {
      type: 'default'
    })),
    close: id => removeElement(id)
  }, /*#__PURE__*/react.createElement(react.Fragment, null, Array.isArray(elements) && elements.length ? /*#__PURE__*/react.createElement(react.Fragment, null, elements.map(item => item.element)) : null)];
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/toast/index.js







// import '@douyinfe/semi-foundation/lib/es/toast/toast.css';




const createBaseToast = () => {
  var _a;
  return _a = class ToastList extends BaseComponent {
    constructor(props) {
      super(props);
      this.stack = false;
      this.innerWrapperRef = /*#__PURE__*/react.createRef();
      this.handleMouseEnter = e => {
        if (this.stack) {
          this.foundation.handleMouseInSideChange(true);
        }
      };
      this.handleMouseLeave = e => {
        var _a;
        if (this.stack) {
          const height = (_a = this.foundation.getInputWrapperRect()) === null || _a === void 0 ? void 0 : _a.height;
          if (height) {
            this.foundation.handleMouseInSideChange(false);
          }
        }
      };
      this.state = {
        list: [],
        removedItems: [],
        updatedItems: [],
        mouseInSide: false
      };
      this.foundation = new ToastListFoundation(this.adapter);
    }
    get adapter() {
      return Object.assign(Object.assign({}, super.adapter), {
        updateToast: (list, removedItems, updatedItems) => {
          this.setState({
            list,
            removedItems,
            updatedItems
          });
        },
        handleMouseInSideChange: mouseInSide => {
          this.setState({
            mouseInSide
          });
        },
        getInputWrapperRect: () => {
          var _a;
          return (_a = this.innerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        }
      });
    }
    static create(opts) {
      var _a;
      const id = (_a = opts.id) !== null && _a !== void 0 ? _a : getUuid('toast');
      // this.id = id;
      if (!ToastList.ref) {
        const div = document.createElement('div');
        if (!this.wrapperId) {
          this.wrapperId = getUuid('toast-wrapper').slice(0, 26);
        }
        div.className = toast_constants_cssClasses.WRAPPER;
        div.id = this.wrapperId;
        div.style.zIndex = String(typeof opts.zIndex === 'number' ? opts.zIndex : ToastList.defaultOpts.zIndex);
        ['top', 'left', 'bottom', 'right'].map(pos => {
          if (pos in ToastList.defaultOpts || pos in opts) {
            const val = opts[pos] ? opts[pos] : ToastList.defaultOpts[pos];
            div.style[pos] = typeof val === 'number' ? `${val}px` : val;
          }
        });
        // document.body.appendChild(div);
        if (ToastList.defaultOpts.getPopupContainer) {
          const container = ToastList.defaultOpts.getPopupContainer();
          container.appendChild(div);
        } else {
          document.body.appendChild(div);
        }
        react_dom.render( /*#__PURE__*/react.createElement(ToastList, {
          ref: instance => ToastList.ref = instance
        }), div, () => {
          ToastList.ref.add(Object.assign(Object.assign({}, opts), {
            id
          }));
          ToastList.ref.stack = Boolean(opts.stack);
        });
      } else {
        const node = document.querySelector(`#${this.wrapperId}`);
        ['top', 'left', 'bottom', 'right'].map(pos => {
          if (pos in opts) {
            node.style[pos] = typeof opts[pos] === 'number' ? `${opts[pos]}px` : opts[pos];
          }
        });
        if (Boolean(opts.stack) !== ToastList.ref.stack) {
          ToastList.ref.stack = Boolean(opts.stack);
        }
        if (ToastList.ref.has(id)) {
          ToastList.ref.update(id, Object.assign(Object.assign({}, opts), {
            id
          }));
        } else {
          ToastList.ref.add(Object.assign(Object.assign({}, opts), {
            id
          }));
        }
      }
      return id;
    }
    static close(id) {
      if (ToastList.ref) {
        ToastList.ref.remove(id);
      }
    }
    static destroyAll() {
      if (ToastList.ref) {
        ToastList.ref.destroyAll();
        const wrapper = document.querySelector(`#${this.wrapperId}`);
        react_dom.unmountComponentAtNode(wrapper);
        wrapper && wrapper.parentNode.removeChild(wrapper);
        ToastList.ref = null;
        this.wrapperId = null;
      }
    }
    static getWrapperId() {
      return this.wrapperId;
    }
    static info(opts) {
      if (typeof opts === 'string') {
        opts = {
          content: opts
        };
      }
      return this.create(Object.assign(Object.assign(Object.assign({}, ToastList.defaultOpts), opts), {
        type: 'info'
      }));
    }
    static warning(opts) {
      if (typeof opts === 'string') {
        opts = {
          content: opts
        };
      }
      return this.create(Object.assign(Object.assign(Object.assign({}, ToastList.defaultOpts), opts), {
        type: 'warning'
      }));
    }
    static error(opts) {
      if (typeof opts === 'string') {
        opts = {
          content: opts
        };
      }
      return this.create(Object.assign(Object.assign(Object.assign({}, ToastList.defaultOpts), opts), {
        type: 'error'
      }));
    }
    static success(opts) {
      if (typeof opts === 'string') {
        opts = {
          content: opts
        };
      }
      return this.create(Object.assign(Object.assign(Object.assign({}, ToastList.defaultOpts), opts), {
        type: 'success'
      }));
    }
    static config(opts) {
      ['top', 'left', 'bottom', 'right'].forEach(pos => {
        if (pos in opts) {
          ToastList.defaultOpts[pos] = opts[pos];
        }
      });
      if (typeof opts.theme === 'string' && toast_constants_strings.themes.includes(opts.theme)) {
        ToastList.defaultOpts.theme = opts.theme;
      }
      if (typeof opts.zIndex === 'number') {
        ToastList.defaultOpts.zIndex = opts.zIndex;
      }
      if (typeof opts.duration === 'number') {
        ToastList.defaultOpts.duration = opts.duration;
      }
      if (typeof opts.getPopupContainer === 'function') {
        ToastList.defaultOpts.getPopupContainer = opts.getPopupContainer;
      }
    }
    has(id) {
      return this.foundation.hasToast(id);
    }
    add(opts) {
      return this.foundation.addToast(opts);
    }
    update(id, opts) {
      return this.foundation.updateToast(id, opts);
    }
    remove(id) {
      return this.foundation.removeToast(id);
    }
    destroyAll() {
      return this.foundation.destroyAll();
    }
    render() {
      let {
        list
      } = this.state;
      const {
        removedItems,
        updatedItems
      } = this.state;
      list = Array.from(new Set([...list, ...removedItems]));
      const updatedIds = updatedItems.map(_ref => {
        let {
          id
        } = _ref;
        return id;
      });
      const refFn = toast => {
        var _a;
        if (((_a = toast === null || toast === void 0 ? void 0 : toast.foundation) === null || _a === void 0 ? void 0 : _a._id) && updatedIds.includes(toast.foundation._id)) {
          toast.foundation.restartCloseTimer();
        }
      };
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        className: classnames_default()({
          [`${toast_constants_cssClasses.PREFIX}-innerWrapper`]: true,
          [`${toast_constants_cssClasses.PREFIX}-innerWrapper-hover`]: this.state.mouseInSide
        }),
        ref: this.innerWrapperRef,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, list.map((item, index) => {
        const isRemoved = removedItems.find(removedItem => removedItem.id === item.id) !== undefined;
        return /*#__PURE__*/react.createElement(_cssAnimation, {
          key: item.id,
          motion: item.motion,
          animationState: isRemoved ? "leave" : "enter",
          startClassName: isRemoved ? `${toast_constants_cssClasses.PREFIX}-animation-hide` : `${toast_constants_cssClasses.PREFIX}-animation-show`
        }, _ref2 => {
          let {
            animationClassName,
            animationEventsNeedBind,
            isAnimating
          } = _ref2;
          return isRemoved && !isAnimating ? null : /*#__PURE__*/react.createElement(toast, Object.assign({}, item, {
            stack: this.stack,
            stackExpanded: this.state.mouseInSide,
            positionInList: {
              length: list.length,
              index
            },
            className: classnames_default()({
              [item.className]: Boolean(item.className),
              [animationClassName]: true
            })
          }, animationEventsNeedBind, {
            style: Object.assign({}, item.style),
            close: id => this.remove(id),
            ref: refFn
          }));
        });
      })));
    }
  }, _a.defaultOpts = {
    motion: true,
    zIndex: 1010,
    content: ''
  }, _a.propTypes = {
    content: (prop_types_default()).node,
    duration: (prop_types_default()).number,
    onClose: (prop_types_default()).func,
    icon: (prop_types_default()).node,
    direction: prop_types_default().oneOf(toast_constants_strings.directions),
    stack: (prop_types_default()).bool
  }, _a.defaultProps = {}, _a;
};
class ToastFactory {
  static create(config) {
    const newToast = createBaseToast();
    newToast.useToast = useToast;
    config && newToast.config(config);
    return newToast;
  }
}
/* harmony default export */ var es_toast = (ToastFactory.create());
// EXTERNAL MODULE: ./node_modules/lodash/difference.js
var difference = __webpack_require__(91966);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);
// EXTERNAL MODULE: ./node_modules/lodash/max.js
var max = __webpack_require__(6162);
var max_default = /*#__PURE__*/__webpack_require__.n(max);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tree/treeUtil.js










/**
 * Part of the utils function implementation process reference
 * https://github.com/react-component/tree/blob/master/src/util.tsx
 */
const DRAG_OFFSET = 0.45;
function getPosition(level, index) {
  return `${level}-${index}`;
}
function treeUtil_isValid(val) {
  return !isNull_default()(val) && !isUndefined_default()(val);
}
/**
 * Flat nest tree data into flatten list. This is used for virtual list render.
 * @param treeNodeList Origin data node list
 * @param expandedKeys
 * @param filteredShownKeys
 * need expanded keys, provides `true` means all expanded
 */
function flattenTreeData(treeNodeList, expandedKeys, keyMaps) {
  let filteredShownKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const flattenList = [];
  const filterSearch = Boolean(filteredShownKeys);
  const realKeyName = get_default()(keyMaps, 'key', 'key');
  const realChildrenName = get_default()(keyMaps, 'children', 'children');
  function flatten(list) {
    let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return list.map((treeNode, index) => {
      const pos = getPosition(parent ? parent.pos : '0', index);
      const mergedKey = treeNode[realKeyName];
      const otherData = {};
      if (keyMaps) {
        Object.entries(omit_default()(keyMaps, 'children')).forEach(_ref => {
          let [key, value] = _ref;
          const result = treeNode[value];
          !isUndefined_default()(result) && (otherData[key] = result);
        });
      }
      // Add FlattenDataNode into list
      const flattenNode = Object.assign(Object.assign(Object.assign({}, pick_default()(treeNode, ['key', 'label', 'value', 'icon', 'disabled', 'isLeaf'])), otherData), {
        parent,
        pos,
        children: null,
        data: treeNode,
        _innerDataTag: true,
        isEnd: [...(parent ? parent.isEnd : []), index === list.length - 1]
      });
      const isBooleanFilteredShownKeys = typeof filteredShownKeys === 'boolean';
      if (!filterSearch || !isBooleanFilteredShownKeys && filteredShownKeys.has(mergedKey)) {
        flattenList.push(flattenNode);
      }
      // Loop treeNode children
      if (expandedKeys.has(mergedKey) && (!filterSearch || !isBooleanFilteredShownKeys && filteredShownKeys.has(mergedKey))) {
        flattenNode.children = flatten(treeNode[realChildrenName] || [], flattenNode);
      } else {
        flattenNode.children = [];
      }
      return flattenNode;
    });
  }
  flatten(treeNodeList);
  return flattenList;
}
function convertJsonToData(treeJson) {
  const treeData = [];
  const traverseNode = (key, children, path, res) => {
    const currPath = [...path, key];
    const itemKey = currPath.join('-');
    const newNode = {
      key: itemKey,
      label: key,
      value: children
    };
    if (isObject_default()(children)) {
      const newChildren = [];
      Object.entries(children).forEach(c => {
        traverseNode(c[0], c[1], currPath, newChildren);
      });
      newNode.children = newChildren;
    }
    res.push(newNode);
  };
  Object.entries(treeJson).forEach(item => traverseNode(item[0], item[1], [], treeData));
  return treeData;
}
/**
 * Traverse all the data by `treeData`.
 */
function traverseDataNodes(treeNodes, callback, keyMaps) {
  const realKeyName = get_default()(keyMaps, 'key', 'key');
  const realChildrenName = get_default()(keyMaps, 'children', 'children');
  const processNode = (node, ind, parent) => {
    const children = node ? node[realChildrenName] : treeNodes;
    const pos = node ? getPosition(parent.pos, ind) : '0';
    // Process node if is not root
    if (node) {
      const nodeKey = get_default()(node, realKeyName, null);
      const data = {
        data: Object.assign({}, node),
        ind,
        pos,
        key: nodeKey !== null ? nodeKey : pos,
        parentPos: parent.node ? parent.pos : null,
        level: Number(parent.level) + 1
      };
      callback(data);
    }
    // Process children node
    if (children) {
      children.forEach((subNode, subIndex) => {
        processNode(subNode, subIndex, {
          node,
          pos,
          level: parent ? Number(parent.level) + 1 : -1
        });
      });
    }
  };
  processNode(null);
}
/* Convert data to entities map */
function convertDataToEntities(dataNodes, keyMaps) {
  const posEntities = {};
  const keyEntities = {};
  const valueEntities = {};
  const wrapper = {
    posEntities,
    keyEntities,
    valueEntities
  };
  const realValueName = get_default()(keyMaps, 'value', 'value');
  traverseDataNodes(dataNodes, data => {
    const {
      pos,
      key,
      parentPos
    } = data;
    const entity = Object.assign({}, data);
    const value = get_default()(entity, `data.${realValueName}`, null);
    if (value !== null) {
      valueEntities[value] = key;
    }
    posEntities[pos] = entity;
    keyEntities[key] = entity;
    // Fill children
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
  }, keyMaps);
  return wrapper;
}
/* Get key by value */
function findKeysForValues(valueList, valueEntities) {
  let isMultiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!treeUtil_isValid(valueList)) {
    return [];
  }
  if (!isMultiple && Array.isArray(valueList)) {
    valueList = valueList.length ? [valueList[0]] : [];
  } else if (!Array.isArray(valueList)) {
    valueList = [valueList];
  }
  if (isEmpty_default()(valueEntities)) {
    return valueList;
  }
  const res = [];
  valueList.forEach(val => {
    if (val in valueEntities) {
      res.push(valueEntities[val]);
    } else {
      // if val not in valueEntities, then value push to keys array
      val && res.push(val);
    }
  });
  return res;
}
function findDescendantKeys(selectedKeys, options) {
  let self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const res = [];
  const findChild = item => {
    if (!item) {
      return;
    }
    const {
      children
    } = item;
    const hasChildren = treeUtil_isValid(children);
    if (hasChildren) {
      children.forEach(child => {
        res.push(child.key);
        findChild(options[child.key]);
      });
    }
  };
  selectedKeys.forEach(item => {
    if (self) {
      res.push(item);
    }
    findChild(options[item]);
  });
  return res;
}
function findChildKeys(keys, options) {
  let omitKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const res = [];
  keys && keys.forEach(key => {
    const opts = options[key];
    opts && opts.children && opts.children.forEach(child => {
      if (!omitKeys.length || !omitKeys.includes(child.key)) {
        res.push(child.key);
      }
    });
  });
  return res;
}
/* istanbul ignore next */
function findLeafKeys(keys, options) {
  const res = [];
  const findChild = item => {
    if (!item) {
      return;
    }
    const {
      children
    } = item;
    const isLeaf = !treeUtil_isValid(children);
    if (isLeaf) {
      res.push(item.key);
    } else {
      children.forEach(child => {
        findChild(options[child.key]);
      });
    }
  };
  keys.forEach(item => {
    findChild(options[item]);
  });
  return res;
}
function findSiblingKeys(selectedKeys, options) {
  let self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const par = [];
  selectedKeys.forEach(item => {
    if (options[item] && options[item].parent) {
      par.push(options[item].parent.key);
    }
  });
  const res = findChildKeys(uniq_default()(par), options, self ? [] : selectedKeys);
  return res;
}
function findAncestorKeys(selectedKeys, options) {
  let self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const res = [];
  // Recursively find the parent element
  const findPar = item => {
    if (item.parent) {
      res.push(item.parent.key);
      findPar(item.parent);
    }
  };
  selectedKeys.forEach(item => {
    options[item] && findPar(options[item]);
    if (self) {
      res.push(item);
    }
  });
  return res;
}
function getSortedKeyList(keyList, keyEntities) {
  const levelMap = {};
  keyList.forEach(key => {
    if (!keyEntities[key]) {
      return;
    }
    const {
      level
    } = keyEntities[key];
    if (levelMap[level]) {
      levelMap[level].push(key);
    } else {
      levelMap[level] = [key];
    }
  });
  return levelMap;
}
function calcCheckedKeys(values, keyEntities) {
  const keyList = Array.isArray(values) ? values : [values];
  const descendantKeys = findDescendantKeys(keyList, keyEntities, true);
  /**
   * Recursively find the parent element. Because the incoming nodes are all checked,
   * their descendants must be checked. That is to say, if the descendant nodes have
   *  disabled+unchecked nodes, their ancestor nodes will definitely not be checked
   */
  const checkedKeys = new Set([...descendantKeys]);
  let halfCheckedKeys = new Set([]);
  let visited = [];
  const levelMap = getSortedKeyList(keyList, keyEntities);
  const calcCurrLevel = node => {
    const {
      key,
      parent,
      level
    } = node;
    // If the node does not have a parent node, or the node has been processed just now, no processing is done
    if (!parent || visited.includes(key)) {
      return;
    }
    const siblingKeys = findSiblingKeys([key], keyEntities);
    // visited for caching to avoid double counting
    visited = [...visited, ...siblingKeys];
    const allChecked = siblingKeys.every(siblingKey => checkedKeys.has(siblingKey));
    if (!allChecked) {
      const ancestorKeys = findAncestorKeys([key], keyEntities, false);
      halfCheckedKeys = new Set([...halfCheckedKeys, ...ancestorKeys]);
    } else {
      checkedKeys.add(parent.key);
      // IMPORTANT! parent level may not exist in original level map; if add to the end directly may destroy the hierarchical order
      if (level - 1 in levelMap && level) {
        levelMap[level - 1].push(parent.key);
      } else {
        levelMap[level - 1] = [parent.key];
      }
    }
  };
  // Loop keyList from deepest Level to topLevel, bottom up
  while (!isEmpty_default()(levelMap)) {
    const maxLevel = max_default()(Object.keys(levelMap).map(key => Number(key)));
    levelMap[maxLevel].forEach(key => calcCurrLevel(keyEntities[key]));
    delete levelMap[maxLevel];
  }
  return {
    checkedKeys,
    halfCheckedKeys
  };
}
/* Calculate the expanded node by key */
function calcExpandedKeys() {
  let keyList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let keyEntities = arguments.length > 1 ? arguments[1] : undefined;
  let autoExpandParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!Array.isArray(keyList)) {
    keyList = [keyList];
  }
  if (autoExpandParent) {
    const ancestorKeys = findAncestorKeys(keyList, keyEntities, true);
    return new Set(ancestorKeys);
  }
  return new Set(keyList);
}
/* Calculate the expanded node by value */
function calcExpandedKeysForValues(value, keyEntities, isMultiple, valueEntities) {
  const keys = findKeysForValues(value, valueEntities, isMultiple);
  return new Set(findAncestorKeys(keys, keyEntities, false));
}
function calcMotionKeys(oldKeySet, newKeySet, keyEntities) {
  let motionType = 'show';
  const oldKeys = [...oldKeySet];
  const newKeys = [...newKeySet];
  if (Math.abs(oldKeys.length - newKeys.length) !== 1) {
    return {
      motionType,
      motionKeys: []
    };
  }
  let diffKeys = [];
  if (oldKeys.length > newKeys.length) {
    motionType = 'hide';
    diffKeys = difference_default()(oldKeys, newKeys);
  } else {
    diffKeys = difference_default()(newKeys, oldKeys);
  }
  return {
    motionType: diffKeys.length === 1 ? motionType : 'show',
    motionKeys: diffKeys.length === 1 ? findDescendantKeys(diffKeys, keyEntities, false) : []
  };
}
/**
 * @returns whether option includes sugInput.
 * When filterTreeNode is a function,returns the result of filterTreeNode which called with (sugInput, target, option).
 */
function filter(sugInput, option, filterTreeNode, filterProps) {
  if (!filterTreeNode) {
    return true;
  }
  let filterFn = filterTreeNode;
  let target = option;
  if (typeof filterTreeNode === 'boolean') {
    filterFn = (targetVal, val) => {
      const input = targetVal.toLowerCase();
      return val.toString().toLowerCase().includes(input);
    };
  }
  if (filterProps) {
    target = option[filterProps];
  }
  return filterFn(sugInput, target, option);
}
function normalizedArr(val) {
  if (!Array.isArray(val)) {
    return [val];
  } else {
    return val;
  }
}
// flag is used to determine whether to return when the key does not belong to the keys in keyEntities
// export function normalizeKeyList(keyList: any, keyEntities: KeyEntities, leafOnly = false) {
function normalizeKeyList(keyList, keyEntities) {
  let leafOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let flag = arguments.length > 3 ? arguments[3] : undefined;
  const res = [];
  const keyListSet = new Set(keyList);
  if (!leafOnly) {
    keyList.forEach(key => {
      if (!keyEntities[key]) {
        if (flag) {
          res.push(key);
        }
        return;
      }
      const {
        parent
      } = keyEntities[key];
      if (parent && keyListSet.has(parent.key)) {
        return;
      }
      res.push(key);
    });
  } else {
    keyList.forEach(key => {
      if (keyEntities[key] && !treeUtil_isValid(keyEntities[key].children)) {
        res.push(key);
      }
      // when key is not in keyEntities, if flag is true, key should be push in res
      if (!keyEntities[key] && flag) {
        res.push(key);
      }
    });
  }
  return res;
}
function getMotionKeys(eventKey, expandedKeys, keyEntities) {
  const res = [];
  const getChild = itemKey => {
    keyEntities[itemKey].children && keyEntities[itemKey].children.forEach(item => {
      const {
        key
      } = item;
      res.push(key);
      if (expandedKeys.has(key)) {
        getChild(key);
      }
    });
  };
  getChild(eventKey);
  return res;
}
function calcCheckedKeysForChecked(key, keyEntities, checkedKeys, halfCheckedKeys) {
  const descendantKeys = findDescendantKeys([key], keyEntities, true);
  const nodeItem = keyEntities[key];
  checkedKeys = new Set([...checkedKeys, key]);
  const calcCurrLevel = node => {
    if (!node.parent) {
      return;
    }
    const {
      key
    } = node;
    const siblingKeys = findSiblingKeys([key], keyEntities);
    const allChecked = siblingKeys.every(key => checkedKeys.has(key));
    if (!allChecked) {
      const ancestorKeys = findAncestorKeys([key], keyEntities, false);
      halfCheckedKeys = new Set([...halfCheckedKeys, ...ancestorKeys]);
    } else {
      const par = node.parent;
      checkedKeys.add(par.key);
      calcCurrLevel(par);
    }
  };
  calcCurrLevel(nodeItem);
  return {
    checkedKeys: new Set([...checkedKeys, ...descendantKeys]),
    halfCheckedKeys
  };
}
function calcCheckedKeysForUnchecked(key, keyEntities, checkedKeys, halfCheckedKeys) {
  const descendantKeys = findDescendantKeys([key], keyEntities, true);
  const nodeItem = keyEntities[key];
  descendantKeys.forEach(descendantKey => {
    if (checkedKeys.has(descendantKey)) {
      checkedKeys.delete(descendantKey);
    }
    if (halfCheckedKeys.has(descendantKey)) {
      halfCheckedKeys.delete(descendantKey);
    }
  });
  const calcCurrLevel = node => {
    const par = node.parent;
    // no parent
    if (!par) {
      return;
    }
    // Has a parent node, and the parent node is not checked or halfChecked
    if (!checkedKeys.has(par.key) && !halfCheckedKeys.has(par.key)) {
      return;
    }
    // Has a parent node, and the parent node is checked or halfChecked
    const {
      key
    } = node;
    const siblingKeys = findSiblingKeys([key], keyEntities);
    const anyChecked = siblingKeys.some(key => checkedKeys.has(key) || halfCheckedKeys.has(key));
    const ancestorKeys = findAncestorKeys([key], keyEntities, false);
    // If there is checked or halfChecked in the sibling node, you need to change the parent node to halfChecked
    if (anyChecked) {
      ancestorKeys.forEach(itemKey => {
        if (checkedKeys.has(itemKey)) {
          checkedKeys.delete(itemKey);
          halfCheckedKeys.add(itemKey);
        }
      });
      // If there is no checked or halfChecked in the sibling node, you need to change the parent node to unchecked
    } else {
      if (checkedKeys.has(par.key)) {
        checkedKeys.delete(par.key);
      }
      if (halfCheckedKeys.has(par.key)) {
        halfCheckedKeys.delete(par.key);
      }
      calcCurrLevel(par);
    }
  };
  nodeItem && calcCurrLevel(nodeItem);
  return {
    checkedKeys,
    halfCheckedKeys
  };
}
function filterTreeData(info) {
  const {
    showFilteredOnly,
    keyEntities,
    inputValue,
    treeData,
    filterTreeNode,
    filterProps,
    prevExpandedKeys,
    keyMaps
  } = info;
  let filteredOptsKeys = [];
  filteredOptsKeys = Object.values(keyEntities).filter(item => filter(inputValue, item.data, filterTreeNode, filterProps)).map(item => item.key);
  let expandedOptsKeys = findAncestorKeys(filteredOptsKeys, keyEntities, false);
  if (prevExpandedKeys.length) {
    const prevExpandedValidKeys = prevExpandedKeys.filter(key => Boolean(keyEntities[key]));
    expandedOptsKeys = expandedOptsKeys.concat(prevExpandedValidKeys);
  }
  const shownChildKeys = findDescendantKeys(filteredOptsKeys, keyEntities, true);
  const filteredShownKeys = new Set([...shownChildKeys, ...expandedOptsKeys]);
  const flattenNodes = flattenTreeData(treeData, new Set(expandedOptsKeys), keyMaps, showFilteredOnly && filteredShownKeys);
  return {
    flattenNodes,
    filteredKeys: new Set(filteredOptsKeys),
    filteredExpandedKeys: new Set(expandedOptsKeys),
    filteredShownKeys
  };
}
// return data.value if data.value exist else fall back to key
function getValueOrKey(data, keyMaps) {
  const valueName = get_default()(keyMaps, 'value', 'value');
  const keyName = get_default()(keyMaps, 'key', 'key');
  if (Array.isArray(data)) {
    return data.map(item => get_default()(item, valueName, item[keyName]));
  }
  return get_default()(data, valueName, data[keyName]);
}
/* Convert value to string */
function normalizeValue(value, withObject, keyMaps) {
  if (withObject && treeUtil_isValid(value)) {
    return getValueOrKey(value, keyMaps);
  } else {
    return value;
  }
}
function updateKeys(keySet, keyEntities) {
  const keyArr = [...keySet];
  return keyArr.filter(key => key in keyEntities);
}
function calcDisabledKeys(keyEntities, keyMaps) {
  const disabledName = get_default()(keyMaps, 'disabled', 'disabled');
  const disabledKeys = Object.keys(keyEntities).filter(key => keyEntities[key].data[disabledName]);
  const {
    checkedKeys
  } = calcCheckedKeys(disabledKeys, keyEntities);
  return checkedKeys;
}
function calcDropRelativePosition(event, treeNode) {
  const {
    clientY
  } = event;
  const {
    top,
    bottom,
    height
  } = treeNode.nodeInstance.getBoundingClientRect();
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  if (clientY <= top + height * DRAG_OFFSET) {
    return -1;
  }
  if (clientY >= bottom - height * DRAG_OFFSET) {
    return 1;
  }
  return 0;
}
function getDragNodesKeys(key, keyEntities) {
  return findDescendantKeys([key], keyEntities, true);
}
function calcDropActualPosition(pos, relativeDropPos) {
  const posArr = pos.split('-');
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return relativeDropPos + Number(posArr[posArr.length - 1]);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tree/foundation.js




/**
 * The drag and drop handler implementation is referenced from rc-tree
 * https://github.com/react-component/tree
 */


class TreeFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.clearDragState = () => {
      this._adapter.updateState({
        dragOverNodeKey: '',
        dragging: false
      });
    };
  }
  _isMultiple() {
    return this.getProp('multiple');
  }
  _isAnimated() {
    return this.getProp('motion');
  }
  _isDisabled() {
    let treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.getProp('disabled') || treeNode.disabled;
  }
  _isExpandControlled() {
    return !isUndefined_default()(this.getProp('expandedKeys'));
  }
  _isLoadControlled() {
    return !isUndefined_default()(this.getProp('loadedKeys'));
  }
  _isFilterable() {
    // filter can be boolean or function
    return Boolean(this.getProp('filterTreeNode'));
  }
  _showFilteredOnly() {
    const {
      inputValue
    } = this.getStates();
    const {
      showFilteredOnly
    } = this.getProps();
    return Boolean(inputValue) && showFilteredOnly;
  }
  getTreeNodeProps(key) {
    const {
      expandedKeys = new Set([]),
      selectedKeys = [],
      checkedKeys = new Set([]),
      halfCheckedKeys = new Set([]),
      realCheckedKeys = new Set([]),
      keyEntities = {},
      filteredKeys = new Set([]),
      inputValue = '',
      loadedKeys = new Set([]),
      loadingKeys = new Set([]),
      filteredExpandedKeys = new Set([]),
      disabledKeys = new Set([])
    } = this.getStates();
    const {
      treeNodeFilterProp,
      checkRelation
    } = this.getProps();
    const entity = keyEntities[key];
    const notExist = !entity;
    if (notExist) {
      return null;
    }
    // if checkRelation is invalid, the checked status of node will be false
    let realChecked = false;
    let realHalfChecked = false;
    if (checkRelation === 'related') {
      realChecked = checkedKeys.has(key);
      realHalfChecked = halfCheckedKeys.has(key);
    } else if (checkRelation === 'unRelated') {
      realChecked = realCheckedKeys.has(key);
      realHalfChecked = false;
    }
    const isSearching = Boolean(inputValue);
    const treeNodeProps = {
      eventKey: key,
      expanded: isSearching ? filteredExpandedKeys.has(key) : expandedKeys.has(key),
      selected: selectedKeys.includes(key),
      checked: realChecked,
      halfChecked: realHalfChecked,
      pos: String(entity ? entity.pos : ''),
      level: entity.level,
      filtered: filteredKeys.has(key),
      loading: loadingKeys.has(key) && !loadedKeys.has(key),
      loaded: loadedKeys.has(key),
      keyword: inputValue,
      treeNodeFilterProp
    };
    if (this.getProp('disableStrictly') && disabledKeys.has(key)) {
      treeNodeProps.disabled = true;
    }
    return treeNodeProps;
  }
  notifyJsonChange(key, e) {
    const data = this.getProp('treeDataSimpleJson');
    const selectedPath = normalizedArr(key).map(i => i.replace('-', '.'));
    const value = pick_default()(data, selectedPath);
    this._adapter.notifyChange(value);
  }
  constructDataForValue(value) {
    const {
      keyMaps
    } = this.getProps();
    const keyName = get_default()(keyMaps, 'key', 'key');
    const labelName = get_default()(keyMaps, 'label', 'label');
    return {
      [keyName]: value,
      [labelName]: value
    };
  }
  findDataForValue(findValue) {
    const {
      value,
      defaultValue,
      keyMaps
    } = this.getProps();
    const realValueName = get_default()(keyMaps, 'value', 'value');
    const realKeyName = get_default()(keyMaps, 'key', 'key');
    let valueArr = [];
    if (value) {
      valueArr = Array.isArray(value) ? value : [value];
    } else if (defaultValue) {
      valueArr = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    }
    return valueArr.find(item => {
      return item[realValueName] === findValue || item[realKeyName] === findValue;
    });
  }
  getDataForKeyNotInKeyEntities(value) {
    const {
      onChangeWithObject
    } = this.getProps();
    if (onChangeWithObject) {
      return this.findDataForValue(value);
    } else {
      return this.constructDataForValue(value);
    }
  }
  notifyMultipleChange(key, e) {
    const {
      keyEntities
    } = this.getStates();
    const {
      leafOnly,
      checkRelation,
      keyMaps,
      autoMergeValue
    } = this.getProps();
    let value;
    let keyList = [];
    if (checkRelation === 'related') {
      keyList = autoMergeValue ? normalizeKeyList(key, keyEntities, leafOnly, true) : key;
    } else if (checkRelation === 'unRelated') {
      keyList = key;
    }
    const nodes = keyList.map(key => keyEntities[key] ? keyEntities[key].data : this.getDataForKeyNotInKeyEntities(key));
    if (this.getProp('onChangeWithObject')) {
      value = nodes;
    } else {
      value = getValueOrKey(nodes, keyMaps);
    }
    this._adapter.notifyChange(value);
  }
  notifyChange(key, e) {
    const isMultiple = this._isMultiple();
    const {
      keyMaps
    } = this.getProps();
    const {
      keyEntities
    } = this.getStates();
    if (this.getProp('treeDataSimpleJson')) {
      this.notifyJsonChange(key, e);
    } else if (isMultiple) {
      this.notifyMultipleChange(key, e);
    } else {
      let value;
      if (this.getProp('onChangeWithObject')) {
        value = get_default()(keyEntities, key).data;
      } else {
        const {
          data
        } = get_default()(keyEntities, key);
        value = getValueOrKey(data, keyMaps);
      }
      this._adapter.notifyChange(value);
    }
  }
  handleInputChange(sugInput) {
    // Input is a controlled component, so the value value needs to be updated
    this._adapter.updateInputValue(sugInput);
    const {
      expandedKeys,
      selectedKeys,
      keyEntities,
      treeData
    } = this.getStates();
    const {
      showFilteredOnly,
      filterTreeNode,
      treeNodeFilterProp,
      keyMaps
    } = this.getProps();
    const realFilterProp = treeNodeFilterProp !== 'label' ? treeNodeFilterProp : get_default()(keyMaps, 'label', 'label');
    let filteredOptsKeys = [];
    let expandedOptsKeys = [];
    let flattenNodes = [];
    let filteredShownKeys = new Set([]);
    if (!sugInput) {
      expandedOptsKeys = findAncestorKeys(selectedKeys, keyEntities);
      expandedOptsKeys.forEach(item => expandedKeys.add(item));
      flattenNodes = flattenTreeData(treeData, expandedKeys, keyMaps);
    } else {
      filteredOptsKeys = Object.values(keyEntities).filter(item => filter(sugInput, item.data, filterTreeNode, realFilterProp)).map(item => item.key);
      expandedOptsKeys = findAncestorKeys(filteredOptsKeys, keyEntities, false);
      const shownChildKeys = findDescendantKeys(filteredOptsKeys, keyEntities, true);
      filteredShownKeys = new Set([...shownChildKeys, ...expandedOptsKeys]);
      flattenNodes = flattenTreeData(treeData, new Set(expandedOptsKeys), keyMaps, showFilteredOnly && filteredShownKeys);
    }
    const newFilteredExpandedKeys = new Set(expandedOptsKeys);
    this._adapter.notifySearch(sugInput, Array.from(newFilteredExpandedKeys));
    this._adapter.updateState({
      expandedKeys,
      flattenNodes,
      motionKeys: new Set([]),
      filteredKeys: new Set(filteredOptsKeys),
      filteredExpandedKeys: newFilteredExpandedKeys,
      filteredShownKeys
    });
  }
  handleNodeSelect(e, treeNode) {
    const isDisabled = this._isDisabled(treeNode);
    if (isDisabled) {
      return;
    }
    if (!this._isMultiple()) {
      this.handleSingleSelect(e, treeNode);
    } else {
      this.handleMultipleSelect(e, treeNode);
    }
  }
  handleNodeRightClick(e, treeNode) {
    this._adapter.notifyRightClick(e, treeNode.data);
  }
  handleNodeDoubleClick(e, treeNode) {
    this._adapter.notifyDoubleClick(e, treeNode.data);
  }
  handleSingleSelect(e, treeNode) {
    let selectedKeys = [...this.getState('selectedKeys')];
    const {
      selected,
      eventKey,
      data
    } = treeNode;
    const targetSelected = !selected;
    this._adapter.notifySelect(eventKey, true, data);
    if (!targetSelected) {
      return;
    }
    if (!selectedKeys.includes(eventKey)) {
      selectedKeys = [eventKey];
      this.notifyChange(eventKey, e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          selectedKeys
        });
      }
    }
  }
  calcCheckedKeys(eventKey, targetStatus) {
    const {
      keyEntities
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const halfCheckedKeys = new Set(this.getState('halfCheckedKeys'));
    return targetStatus ? calcCheckedKeysForChecked(eventKey, keyEntities, checkedKeys, halfCheckedKeys) : calcCheckedKeysForUnchecked(eventKey, keyEntities, checkedKeys, halfCheckedKeys);
  }
  /*
  * Compute the checked state of the node
  */
  calcCheckedStatus(targetStatus, eventKey) {
    // From checked to unchecked, you can change it directly
    if (!targetStatus) {
      return targetStatus;
    }
    // Starting from unchecked, you need to judge according to the descendant nodes
    const {
      checkedKeys,
      keyEntities,
      disabledKeys
    } = this.getStates();
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    // If the descendant nodes are not disabled, they will be directly changed to checked
    if (!hasDisabled) {
      return targetStatus;
    }
    // If all descendant nodes that are not disabled are selected, return unchecked, otherwise, return checked
    const nonDisabledKeys = descendantKeys.filter(key => !disabledKeys.has(key));
    const allChecked = nonDisabledKeys.every(key => checkedKeys.has(key));
    return !allChecked;
  }
  /*
  * In strict disable mode, calculate the nodes of checked and halfCheckedKeys and return their corresponding keys
  */
  calcNonDisabledCheckedKeys(eventKey, targetStatus) {
    const {
      keyEntities,
      disabledKeys
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    // If none of the descendant nodes are disabled, follow the normal logic
    if (!hasDisabled) {
      return this.calcCheckedKeys(eventKey, targetStatus);
    }
    const nonDisabled = descendantKeys.filter(key => !disabledKeys.has(key));
    const newCheckedKeys = targetStatus ? [...nonDisabled, ...checkedKeys] : difference_default()(normalizeKeyList([...checkedKeys], keyEntities, true, true), nonDisabled);
    return calcCheckedKeys(newCheckedKeys, keyEntities);
  }
  /*
  * Handle the selection event in the case of multiple selection
  */
  handleMultipleSelect(e, treeNode) {
    const {
      disableStrictly,
      checkRelation
    } = this.getProps();
    const {
      realCheckedKeys
    } = this.getStates();
    // eventKey: The key value of the currently clicked node
    const {
      checked,
      eventKey,
      data
    } = treeNode;
    if (checkRelation === 'related') {
      // Find the checked state of the current node
      const targetStatus = disableStrictly ? this.calcCheckedStatus(!checked, eventKey) : !checked;
      const {
        checkedKeys,
        halfCheckedKeys
      } = disableStrictly ? this.calcNonDisabledCheckedKeys(eventKey, targetStatus) : this.calcCheckedKeys(eventKey, targetStatus);
      this._adapter.notifySelect(eventKey, targetStatus, data);
      this.notifyChange([...checkedKeys], e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          checkedKeys,
          halfCheckedKeys
        });
      }
    } else if (checkRelation === 'unRelated') {
      const newRealCheckedKeys = new Set(realCheckedKeys);
      let targetStatus;
      if (realCheckedKeys.has(eventKey)) {
        newRealCheckedKeys.delete(eventKey);
        targetStatus = false;
      } else {
        newRealCheckedKeys.add(eventKey);
        targetStatus = true;
      }
      this._adapter.notifySelect(eventKey, targetStatus, data);
      this.notifyChange([...newRealCheckedKeys], e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          realCheckedKeys: newRealCheckedKeys
        });
      }
    }
  }
  setExpandedStatus(treeNode) {
    const {
      inputValue,
      treeData,
      filteredShownKeys,
      keyEntities
    } = this.getStates();
    const {
      keyMaps
    } = this.getProps();
    const isSearching = Boolean(inputValue);
    const showFilteredOnly = this._showFilteredOnly();
    const expandedStateKey = isSearching ? 'filteredExpandedKeys' : 'expandedKeys';
    const expandedKeys = new Set(this.getState(expandedStateKey));
    let motionType = 'show';
    const {
      eventKey,
      expanded,
      data
    } = treeNode;
    if (!expanded) {
      expandedKeys.add(eventKey);
    } else if (expandedKeys.has(eventKey)) {
      expandedKeys.delete(eventKey);
      motionType = 'hide';
    }
    this._adapter.cacheFlattenNodes(motionType === 'hide' && this._isAnimated());
    if (!this._isExpandControlled()) {
      const flattenNodes = flattenTreeData(treeData, expandedKeys, keyMaps, isSearching && showFilteredOnly && filteredShownKeys);
      const motionKeys = this._isAnimated() ? getMotionKeys(eventKey, expandedKeys, keyEntities) : [];
      const newState = {
        [expandedStateKey]: expandedKeys,
        flattenNodes,
        motionKeys: new Set(motionKeys),
        motionType
      };
      this._adapter.updateState(newState);
    }
    return {
      expandedKeys,
      expanded: !expanded,
      data
    };
  }
  handleNodeExpand(e, treeNode) {
    const {
      loadData
    } = this.getProps();
    if (!loadData && (!treeNode.children || !treeNode.children.length)) {
      return;
    }
    const {
      expandedKeys,
      data,
      expanded
    } = this.setExpandedStatus(treeNode);
    this._adapter.notifyExpand(expandedKeys, {
      expanded,
      node: data
    });
  }
  handleNodeLoad(loadedKeys, loadingKeys, data, resolve) {
    const {
      loadData,
      onLoad
    } = this.getProps();
    const {
      key
    } = data;
    if (!loadData || loadedKeys.has(key) || loadingKeys.has(key)) {
      return {};
    }
    // Process the loaded data
    loadData(data).then(() => {
      const prevLoadedKeys = new Set(this.getState('loadedKeys'));
      const prevLoadingKeys = new Set(this.getState('loadingKeys'));
      const newLoadedKeys = prevLoadedKeys.add(key);
      const newLoadingKeys = new Set([...prevLoadingKeys]);
      newLoadingKeys.delete(key);
      // onLoad should be triggered before internal setState to avoid `loadData` being triggered twice
      onLoad && onLoad(newLoadedKeys, data);
      if (!this._isLoadControlled()) {
        this._adapter.updateState({
          loadedKeys: newLoadedKeys
        });
      }
      this._adapter.setState({
        loadingKeys: newLoadingKeys
      });
      resolve();
    });
    return {
      loadingKeys: loadingKeys.add(key)
    };
  }
  // Drag and drop related processing logic
  getDragEventNodeData(node) {
    return Object.assign(Object.assign({}, node.data), pick_default()(node, ['expanded', 'pos', 'children']));
  }
  triggerDragEvent(name, event, node) {
    let extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const callEvent = this.getProp(name);
    callEvent && callEvent(Object.assign({
      event,
      node: this.getDragEventNodeData(node)
    }, extra));
  }
  handleNodeDragStart(e, treeNode) {
    const {
      keyEntities
    } = this.getStates();
    const {
      hideDraggingNode,
      renderDraggingNode
    } = this.getProps();
    const {
      eventKey,
      nodeInstance,
      data
    } = treeNode;
    if (hideDraggingNode || renderDraggingNode) {
      let dragImg;
      if (typeof renderDraggingNode === 'function') {
        dragImg = renderDraggingNode(nodeInstance, data);
      } else if (hideDraggingNode) {
        dragImg = nodeInstance.cloneNode(true);
        dragImg.style.opacity = 0;
      }
      document.body.appendChild(dragImg);
      e.dataTransfer.setDragImage(dragImg, 0, 0);
    }
    this._adapter.setDragNode(treeNode);
    this._adapter.updateState({
      dragging: true,
      dragNodesKeys: new Set(getDragNodesKeys(eventKey, keyEntities))
    });
    this.triggerDragEvent('onDragStart', e, treeNode);
  }
  handleNodeDragEnter(e, treeNode, dragNode) {
    const {
      dragging,
      dragNodesKeys
    } = this.getStates();
    const {
      autoExpandWhenDragEnter
    } = this.getProps();
    const {
      pos,
      eventKey,
      expanded
    } = treeNode;
    if (!dragNode || dragNodesKeys.has(eventKey)) {
      return;
    }
    const dropPosition = calcDropRelativePosition(e, treeNode);
    // If the drag node is itself, skip
    if (dragNode.eventKey === eventKey && dropPosition === 0) {
      this._adapter.updateState({
        dragOverNodeKey: '',
        dropPosition: null
      });
      return;
    }
    // Trigger dragenter after clearing the prev state in dragleave
    setTimeout(() => {
      this._adapter.updateState({
        dragOverNodeKey: eventKey,
        dropPosition
      });
      // If autoExpand is already expanded or not allowed, trigger the event and return
      if (!autoExpandWhenDragEnter || expanded) {
        this.triggerDragEvent('onDragEnter', e, treeNode);
        return;
      }
      // Side effects of delayed drag
      if (!this.delayedDragEnterLogic) {
        this.delayedDragEnterLogic = {};
      }
      Object.keys(this.delayedDragEnterLogic).forEach(key => {
        clearTimeout(this.delayedDragEnterLogic[key]);
      });
      this.delayedDragEnterLogic[pos] = window.setTimeout(() => {
        if (!dragging) {
          return;
        }
        const {
          expandedKeys: newExpandedKeys
        } = this.setExpandedStatus(treeNode);
        this.triggerDragEvent('onDragEnter', e, treeNode, {
          expandedKeys: [...newExpandedKeys]
        });
      }, 400);
    }, 0);
  }
  handleNodeDragOver(e, treeNode, dragNode) {
    const {
      dropPosition,
      dragNodesKeys,
      dragOverNodeKey
    } = this.getStates();
    const {
      eventKey
    } = treeNode;
    if (dragNodesKeys.has(eventKey)) {
      return;
    }
    // Update the drag position
    if (dragNode && eventKey === dragOverNodeKey) {
      const newPos = calcDropRelativePosition(e, treeNode);
      if (dropPosition === newPos) {
        return;
      }
      this._adapter.updateState({
        dropPosition: newPos
      });
    }
    this.triggerDragEvent('onDragOver', e, treeNode);
  }
  handleNodeDragLeave(e, treeNode) {
    this._adapter.updateState({
      dragOverNodeKey: ''
    });
    this.triggerDragEvent('onDragLeave', e, treeNode);
  }
  handleNodeDragEnd(e, treeNode) {
    this.clearDragState();
    this.triggerDragEvent('onDragEnd', e, treeNode);
    this._adapter.setDragNode(null);
  }
  handleNodeDrop(e, treeNode, dragNode) {
    const {
      dropPosition,
      dragNodesKeys
    } = this.getStates();
    const {
      eventKey,
      pos
    } = treeNode;
    this.clearDragState();
    if (dragNodesKeys.has(eventKey)) {
      return;
    }
    const dropRes = {
      dragNode: dragNode ? this.getDragEventNodeData(dragNode) : null,
      dragNodesKeys: [...dragNodesKeys],
      dropPosition: calcDropActualPosition(pos, dropPosition),
      dropToGap: dropPosition !== 0
    };
    this.triggerDragEvent('onDrop', e, treeNode, dropRes);
    this._adapter.setDragNode(null);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tree/constants.js

const tree_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-tree`,
  PREFIX_OPTION: `${BASE_CLASS_PREFIX}-tree-option`
};
const tree_constants_strings = {
  EXPAND_ACTION: [false, 'click', 'doubleClick']
};
const tree_constants_numbers = {};

// EXTERNAL MODULE: ./node_modules/lodash/isPlainObject.js
var isPlainObject = __webpack_require__(68630);
var isPlainObject_default = /*#__PURE__*/__webpack_require__.n(isPlainObject);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/treeUtil.js



function treeUtil_cloneDeep(treeNodeList) {
  return cloneDeepWith_default()(treeNodeList, val => {
    // only clone treeNode inner data and skip user data
    if (isPlainObject_default()(val) && !val._innerDataTag) {
      return val;
    }
    if ( /*#__PURE__*/react.isValidElement(val)) {
      return val;
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/autoSizer.js





const autoSizer_prefixcls = tree_constants_cssClasses.PREFIX;
class AutoSizer extends react.PureComponent {
  constructor(props) {
    super(props);
    this._onResize = entries => {
      // observe parent node height
      const target = entries && entries[1] && entries[1].target;
      if (target) {
        const height = get_default()(target, 'offsetHeight') || 0;
        const style = window.getComputedStyle(target) || {};
        const paddingTop = parseInt(get_default()(style, 'paddingTop'), 10) || 0;
        const paddingBottom = parseInt(get_default()(style, 'paddingBottom'), 10) || 0;
        const newHeight = height - paddingTop - paddingBottom;
        if (this.state.height !== newHeight) {
          this.setState({
            height: height - paddingTop - paddingBottom
          });
        }
      }
    };
    this.state = {
      height: this.props.defaultHeight || 0
    };
  }
  componentDidMount() {
    const {
      height
    } = this.state;
    // if height is a number, pass it directly to virtual-list
    if (typeof height === 'number') {
      return;
    }
  }
  render() {
    const {
      children,
      defaultWidth,
      defaultHeight
    } = this.props;
    const {
      height
    } = this.state;
    // Avoid rendering children before the initial measurements have been collected.
    // At best this would just be wasting cycles. Refer to https://github.com/bvaughn/react-virtualized-auto-sizer/
    let bailoutOnChildren = false;
    if (height === 0 || typeof height !== 'number') {
      bailoutOnChildren = true;
    }
    return /*#__PURE__*/react.createElement(ReactResizeObserver, {
      observeParent: true,
      onResize: this._onResize
    }, /*#__PURE__*/react.createElement("div", {
      style: {
        height: defaultHeight,
        overflow: 'visible'
      },
      className: `${autoSizer_prefixcls}-auto-wrapper`
    }, !bailoutOnChildren && children({
      height,
      width: defaultWidth
    })));
  }
}
AutoSizer.propTypes = {
  defaultHeight: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  defaultWidth: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string])
};
AutoSizer.defaultProps = {
  defaultHeight: '100%',
  defaultWidth: '100%'
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/treeContext.js

const TreeContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var treeContext = (TreeContext);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconTreeTriangleDown.js


function IconTreeTriangleDown_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M20.5598 9.65618L12.7546 18.6322C12.3559 19.0906 11.644 19.0906 11.2453 18.6322L3.4401 9.65618C2.8773 9.00895 3.33701 8 4.19471 8L19.8052 8C20.6629 8 21.1226 9.00895 20.5598 9.65618Z",
    fill: "currentColor"
  }));
}
const IconTreeTriangleDown_IconComponent = (0,Icon/* convertIcon */.A)(IconTreeTriangleDown_SvgComponent, 'tree_triangle_down');
/* harmony default export */ var IconTreeTriangleDown = (IconTreeTriangleDown_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconFile.js


function IconFile_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12 1.44772 11.5523 1 11 1H6C4.89543 1 4 1.89543 4 3V21C4 22.1046 4.89543 23 6 23H18C19.1046 23 20 22.1046 20 21V10C20 9.44772 19.5523 9 19 9H14C12.8954 9 12 8.10457 12 7V2ZM7 8C7 7.44772 7.44772 7 8 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H8C7.44772 9 7 8.55228 7 8ZM7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13ZM8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18C17 17.4477 16.5523 17 16 17H8ZM19.0686 7.49999H14.5C13.9477 7.49999 13.5 7.05228 13.5 6.49999V1.93136C13.5 1.21864 14.3617 0.861707 14.8657 1.36568L19.6343 6.13431C20.1383 6.63828 19.7814 7.49999 19.0686 7.49999Z",
    fill: "currentColor"
  }));
}
const IconFile_IconComponent = (0,Icon/* convertIcon */.A)(IconFile_SvgComponent, 'file');
/* harmony default export */ var IconFile = (IconFile_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconFolderOpen.js


function IconFolderOpen_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.34315 3.34315 2 5 2H8.29844C8.75258 2 9.1932 2.15456 9.54783 2.43826L10.6783 3.34261C11.2102 3.76816 11.8711 4 12.5523 4H18C20 4 21 6 21 8H7.53361C6.62889 8 5.83683 8.60735 5.6021 9.48109L2.57151 20.7617C2.21202 20.2671 2 19.6583 2 19V5ZM22.1667 10H9.5C8.61111 10 7.82889 10.5867 7.58 11.44L4.87333 20.72C4.68667 21.36 5.16667 22 5.83333 22H18.5C19.3889 22 20.1711 21.4133 20.42 20.56L23.1267 11.28C23.3133 10.64 22.8333 10 22.1667 10Z",
    fill: "currentColor"
  }));
}
const IconFolderOpen_IconComponent = (0,Icon/* convertIcon */.A)(IconFolderOpen_SvgComponent, 'folder_open');
/* harmony default export */ var IconFolderOpen = (IconFolderOpen_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconFolder.js


function IconFolder_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V8H22C22 6 21 4 19 4H12.5523C11.8711 4 11.2102 3.76816 10.6783 3.34261L9.54783 2.43826C9.1932 2.15456 8.75258 2 8.29844 2H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22 10H2V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V10Z",
    fill: "currentColor"
  }));
}
const IconFolder_IconComponent = (0,Icon/* convertIcon */.A)(IconFolder_SvgComponent, 'folder');
/* harmony default export */ var IconFolder = (IconFolder_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/indent.js


const Indent = _ref => {
  let {
    prefixcls,
    level,
    isEnd,
    showLine
  } = _ref;
  const baseClassName = `${prefixcls}-indent-unit`;
  const list = [];
  for (let i = 0; i < level; i += 1) {
    list.push( /*#__PURE__*/react.createElement("span", {
      key: i,
      className: classnames_default()(baseClassName, {
        [`${baseClassName}-end`]: isEnd[i]
      })
    }));
  }
  return /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: classnames_default()(`${prefixcls}-indent`, {
      [`${prefixcls}-indent-show-line`]: showLine
    })
  }, list);
};
/* harmony default export */ var indent = (/*#__PURE__*/react.memo(Indent));
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/treeNode.js





var treeNode_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const treeNode_prefixcls = tree_constants_cssClasses.PREFIX_OPTION;
class TreeNode extends react.PureComponent {
  constructor(props) {
    super(props);
    this.onSelect = e => {
      const {
        onNodeSelect
      } = this.context;
      onNodeSelect(e, this.props);
    };
    this.onExpand = e => {
      const {
        onNodeExpand
      } = this.context;
      e && e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      onNodeExpand(e, this.props);
    };
    this.onCheck = e => {
      var _a, _b;
      if (this.isDisabled()) {
        return;
      }
      const {
        onNodeCheck
      } = this.context;
      e.stopPropagation();
      (_b = (_a = e.nativeEvent) === null || _a === void 0 ? void 0 : _a.stopImmediatePropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
      onNodeCheck(e, this.props);
    };
    /**
     * A11y: simulate checkbox click
     */
    this.handleCheckEnterPress = e => {
      if (utils_isEnterPress(e)) {
        this.onCheck(e);
      }
    };
    this.onContextMenu = e => {
      const {
        onNodeRightClick
      } = this.context;
      onNodeRightClick(e, this.props);
    };
    this.onClick = e => {
      const {
        expandAction
      } = this.context;
      if (expandAction === 'doubleClick') {
        this.debounceSelect(e);
        return;
      }
      this.onSelect(e);
      if (expandAction === 'click') {
        this.onExpand(e);
      }
    };
    /**
     * A11y: simulate li click
     */
    this.handleliEnterPress = e => {
      if (utils_isEnterPress(e)) {
        this.onClick(e);
      }
    };
    this.onDoubleClick = e => {
      const {
        expandAction,
        onNodeDoubleClick
      } = this.context;
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      if (isFunction_default()(onNodeDoubleClick)) {
        onNodeDoubleClick(e, this.props);
      }
      if (expandAction === 'doubleClick') {
        this.onExpand(e);
      }
    };
    this.onDragStart = e => {
      const {
        onNodeDragStart
      } = this.context;
      e.stopPropagation();
      onNodeDragStart(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
      try {
        // ie throw error
        // firefox-need-it
        e.dataTransfer.setData('text/plain', '');
      } catch (error) {
        // empty
      }
    };
    this.onDragEnter = e => {
      const {
        onNodeDragEnter
      } = this.context;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragEnter(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
    };
    this.onDragOver = e => {
      const {
        onNodeDragOver
      } = this.context;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragOver(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
    };
    this.onDragLeave = e => {
      const {
        onNodeDragLeave
      } = this.context;
      e.stopPropagation();
      onNodeDragLeave(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
    };
    this.onDragEnd = e => {
      const {
        onNodeDragEnd
      } = this.context;
      e.stopPropagation();
      onNodeDragEnd(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
    };
    this.onDrop = e => {
      const {
        onNodeDrop
      } = this.context;
      e.preventDefault();
      e.stopPropagation();
      onNodeDrop(e, Object.assign(Object.assign({}, this.props), {
        nodeInstance: this.refNode
      }));
    };
    this.getNodeChildren = () => {
      const {
        children
      } = this.props;
      return children || [];
    };
    this.isLeaf = () => {
      const {
        isLeaf,
        loaded
      } = this.props;
      const {
        loadData
      } = this.context;
      const hasChildren = this.getNodeChildren().length !== 0;
      if (isLeaf === false) {
        return false;
      }
      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
    };
    this.isDisabled = () => {
      const {
        disabled
      } = this.props;
      const {
        treeDisabled
      } = this.context;
      if (disabled === false) {
        return false;
      }
      return Boolean(treeDisabled || disabled);
    };
    // Switcher
    this.renderSwitcher = () => {
      if (this.isLeaf()) {
        // if switcherIconDom is null, no render switcher span
        return /*#__PURE__*/react.createElement("span", {
          className: classnames_default()(`${treeNode_prefixcls}-switcher`)
        }, /*#__PURE__*/react.createElement("span", {
          className: `${treeNode_prefixcls}-switcher-leaf-line`
        }));
      }
      return null;
    };
    this.renderRealLabel = () => {
      const {
        renderLabel
      } = this.context;
      const {
        label,
        keyword,
        data,
        filtered,
        treeNodeFilterProp
      } = this.props;
      if (isFunction_default()(renderLabel)) {
        return renderLabel(label, data);
      } else if (isString_default()(label) && filtered && keyword) {
        return getHighLightTextHTML({
          sourceString: label,
          searchWords: [keyword],
          option: {
            highlightTag: 'span',
            highlightClassName: `${treeNode_prefixcls}-highlight`
          }
        });
      } else {
        return label;
      }
    };
    this.setRef = node => {
      this.refNode = node;
    };
    this.state = {};
    this.debounceSelect = debounce_default()(this.onSelect, 500, {
      leading: true,
      trailing: false
    });
  }
  renderArrow() {
    const showIcon = !this.isLeaf();
    const {
      loading,
      expanded,
      showLine
    } = this.props;
    if (loading) {
      return /*#__PURE__*/react.createElement(spin, {
        wrapperClassName: `${treeNode_prefixcls}-spin-icon`
      });
    }
    if (showIcon) {
      return /*#__PURE__*/react.createElement(IconTreeTriangleDown, {
        role: 'button',
        "aria-label": `${expanded ? 'Expand' : 'Collapse'} the tree item`,
        className: `${treeNode_prefixcls}-expand-icon`,
        size: "small",
        onClick: this.onExpand
      });
    }
    if (showLine) {
      return this.renderSwitcher();
    }
    return /*#__PURE__*/react.createElement("span", {
      className: `${treeNode_prefixcls}-empty-icon`
    });
  }
  renderCheckbox() {
    const {
      checked,
      halfChecked,
      eventKey
    } = this.props;
    const disabled = this.isDisabled();
    return /*#__PURE__*/react.createElement("div", {
      role: 'none',
      onClick: this.onCheck,
      onKeyPress: this.handleCheckEnterPress
    }, /*#__PURE__*/react.createElement(checkbox_checkbox, {
      "aria-label": 'Toggle the checked state of checkbox',
      value: eventKey,
      indeterminate: halfChecked,
      checked: checked,
      disabled: Boolean(disabled)
    }));
  }
  renderIcon() {
    const {
      directory,
      treeIcon
    } = this.context;
    const {
      expanded,
      icon,
      data
    } = this.props;
    if (icon) {
      return icon;
    }
    if (treeIcon) {
      return typeof treeIcon === 'function' ? treeIcon(this.props) : treeIcon;
    }
    if (directory) {
      const hasChild = !this.isLeaf();
      if (!hasChild) {
        return /*#__PURE__*/react.createElement(IconFile, {
          className: `${treeNode_prefixcls}-item-icon`
        });
      } else {
        return expanded ? /*#__PURE__*/react.createElement(IconFolderOpen, {
          className: `${treeNode_prefixcls}-item-icon`
        }) : /*#__PURE__*/react.createElement(IconFolder, {
          className: `${treeNode_prefixcls}-item-icon`
        });
      }
    }
    return null;
  }
  renderEmptyNode() {
    const {
      emptyContent
    } = this.props;
    const wrapperCls = classnames_default()(treeNode_prefixcls, {
      [`${treeNode_prefixcls}-empty`]: true
    });
    return /*#__PURE__*/react.createElement("ul", {
      className: wrapperCls
    }, /*#__PURE__*/react.createElement("li", {
      className: `${treeNode_prefixcls}-label ${treeNode_prefixcls}-label-empty`,
      "x-semi-prop": "emptyContent"
    }, emptyContent));
  }
  render() {
    const _a = this.props,
      {
        eventKey,
        expanded,
        selected,
        checked,
        halfChecked,
        loading,
        active,
        level,
        empty,
        filtered,
        treeNodeFilterProp,
        display,
        style,
        isEnd,
        showLine
      } = _a,
      rest = treeNode_rest(_a, ["eventKey", "expanded", "selected", "checked", "halfChecked", "loading", "active", "level", "empty", "filtered", "treeNodeFilterProp", "display", "style", "isEnd", "showLine"]);
    if (empty) {
      return this.renderEmptyNode();
    }
    const {
      multiple,
      draggable,
      renderFullLabel,
      dragOverNodeKey,
      dropPosition,
      labelEllipsis
    } = this.context;
    const isEndNode = isEnd[isEnd.length - 1];
    const disabled = this.isDisabled();
    const dragOver = dragOverNodeKey === eventKey && dropPosition === 0;
    const dragOverGapTop = dragOverNodeKey === eventKey && dropPosition === -1;
    const dragOverGapBottom = dragOverNodeKey === eventKey && dropPosition === 1;
    const nodeCls = classnames_default()(treeNode_prefixcls, {
      [`${treeNode_prefixcls}-level-${level + 1}`]: true,
      [`${treeNode_prefixcls}-fullLabel-level-${level + 1}`]: renderFullLabel,
      [`${treeNode_prefixcls}-collapsed`]: !expanded,
      [`${treeNode_prefixcls}-disabled`]: Boolean(disabled),
      [`${treeNode_prefixcls}-selected`]: selected,
      [`${treeNode_prefixcls}-active`]: !multiple && active,
      [`${treeNode_prefixcls}-ellipsis`]: labelEllipsis,
      [`${treeNode_prefixcls}-drag-over`]: !disabled && dragOver,
      [`${treeNode_prefixcls}-draggable`]: !disabled && draggable && !renderFullLabel,
      // When draggable + renderFullLabel is enabled, the default style
      [`${treeNode_prefixcls}-fullLabel-draggable`]: !disabled && draggable && renderFullLabel,
      // When draggable + renderFullLabel is turned on, the style of dragover
      [`${treeNode_prefixcls}-fullLabel-drag-over-gap-top`]: !disabled && dragOverGapTop && renderFullLabel,
      [`${treeNode_prefixcls}-fullLabel-drag-over-gap-bottom`]: !disabled && dragOverGapBottom && renderFullLabel,
      [`${treeNode_prefixcls}-tree-node-last-leaf`]: isEndNode
    });
    const labelProps = {
      onClick: this.onClick,
      onContextMenu: this.onContextMenu,
      onDoubleClick: this.onDoubleClick,
      className: nodeCls,
      onExpand: this.onExpand,
      data: rest.data,
      level,
      onCheck: this.onCheck,
      style,
      expandIcon: this.renderArrow(),
      checkStatus: {
        checked,
        halfChecked
      },
      expandStatus: {
        expanded,
        loading
      },
      filtered,
      searchWord: rest.keyword
    };
    const dragProps = {
      onDoubleClick: this.onDoubleClick,
      onDragStart: draggable ? this.onDragStart : undefined,
      onDragEnter: draggable ? this.onDragEnter : undefined,
      onDragOver: draggable ? this.onDragOver : undefined,
      onDragLeave: draggable ? this.onDragLeave : undefined,
      onDrop: draggable ? this.onDrop : undefined,
      onDragEnd: draggable ? this.onDragEnd : undefined,
      draggable: !disabled && draggable || undefined
    };
    if (renderFullLabel) {
      const customLabel = renderFullLabel(Object.assign({}, labelProps));
      if (draggable) {
        // @ts-ignore skip cloneElement type check
        return /*#__PURE__*/react.cloneElement(customLabel, Object.assign({
          ref: this.setRef
        }, dragProps));
      } else {
        if (isEmpty_default()(style)) {
          return customLabel;
        } else {
          // In virtualization, props.style will contain location information
          // @ts-ignore skip cloneElement type check
          return /*#__PURE__*/react.cloneElement(customLabel, {
            style: Object.assign(Object.assign({}, get_default()(customLabel, ['props', 'style'])), style)
          });
        }
      }
    }
    const labelCls = classnames_default()(`${treeNode_prefixcls}-label`, {
      [`${treeNode_prefixcls}-drag-over-gap-top`]: !disabled && dragOverGapTop,
      [`${treeNode_prefixcls}-drag-over-gap-bottom`]: !disabled && dragOverGapBottom
    });
    const setsize = get_default()(rest, ['data', 'children', 'length']);
    const posinset = isString_default()(rest.pos) ? Number(rest.pos.split('-')[level + 1]) + 1 : 1;
    return /*#__PURE__*/react.createElement("li", Object.assign({
      className: nodeCls,
      role: "treeitem",
      "aria-disabled": disabled,
      "aria-checked": checked,
      "aria-selected": selected,
      "aria-setsize": setsize,
      "aria-posinset": posinset,
      "aria-expanded": expanded,
      "aria-level": level + 1,
      "data-key": eventKey,
      onClick: this.onClick,
      onKeyPress: this.handleliEnterPress,
      onContextMenu: this.onContextMenu,
      onDoubleClick: this.onDoubleClick,
      ref: this.setRef,
      style: style
    }, dragProps), /*#__PURE__*/react.createElement(indent, {
      showLine: showLine,
      prefixcls: treeNode_prefixcls,
      level: level,
      isEnd: isEnd
    }), this.renderArrow(), /*#__PURE__*/react.createElement("span", {
      className: labelCls
    }, multiple ? this.renderCheckbox() : null, this.renderIcon(), /*#__PURE__*/react.createElement("span", {
      className: `${treeNode_prefixcls}-label-text`
    }, this.renderRealLabel())));
  }
}
TreeNode.contextType = treeContext;
TreeNode.propTypes = {
  expanded: (prop_types_default()).bool,
  selected: (prop_types_default()).bool,
  checked: (prop_types_default()).bool,
  halfChecked: (prop_types_default()).bool,
  active: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  loaded: (prop_types_default()).bool,
  loading: (prop_types_default()).bool,
  isLeaf: (prop_types_default()).bool,
  pos: (prop_types_default()).string,
  children: prop_types_default().oneOfType([(prop_types_default()).array, (prop_types_default()).object]),
  icon: (prop_types_default()).node,
  directory: (prop_types_default()).bool,
  keyword: (prop_types_default()).string,
  treeNodeFilterProp: (prop_types_default()).string,
  selectedKey: (prop_types_default()).string,
  motionKey: prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]),
  isEnd: prop_types_default().arrayOf((prop_types_default()).bool),
  showLine: (prop_types_default()).bool
};
TreeNode.defaultProps = {
  selectedKey: '',
  motionKey: ''
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/nodeCollapsible.js
var nodeCollapsible_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function NodeCollapsible(props) {
  const {
      open,
      children
    } = props,
    rest = nodeCollapsible_rest(props, ["open", "children"]);
  const [isOpen, setIsOpen] = (0,react.useState)(props.open);
  (0,react.useEffect)(() => {
    // Why do we need to change isOPen value in setTimeout？
    // Because when NodeCollapsible ComponentDidMount, the domHeight in Collapsible has not been given
    setTimeout(() => {
      setIsOpen(!props.open);
    }, 0);
  }, []);
  return /*#__PURE__*/react.createElement(collapsible, Object.assign({}, rest, {
    isOpen: isOpen
  }), children);
}
/* harmony default export */ var nodeCollapsible = (NodeCollapsible);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/nodeList.js




const getTreeNodeKey = treeNode => {
  return treeNode.key;
};
class NodeList extends react.PureComponent {
  constructor(props) {
    super(props);
    this.onMotionEnd = () => {
      typeof this.props.onMotionEnd === 'function' && this.props.onMotionEnd();
      this.setState({
        transitionNodes: []
      });
    };
    this.state = {
      transitionNodes: []
    };
  }
  static getDerivedStateFromProps(props, prevState) {
    const {
      flattenNodes = [],
      motionKeys,
      motionType,
      flattenList = []
    } = props;
    const hasChanged = !isEqual_default()(prevState.cachedMotionKeys, motionKeys) || !isEqual_default()(prevState.cachedData.map(i => i.key), flattenNodes.map(i => i.key));
    const motionArr = [...motionKeys];
    if (!hasChanged || !motionArr.length) {
      return null;
    }
    const transitionNodes = [];
    const transitionRange = [];
    let rangeStart = 0;
    let newState = {};
    const lookUpTarget = motionType === 'hide' && flattenList ? flattenList : flattenNodes;
    lookUpTarget.forEach((treeNode, ind) => {
      const nodeKey = getTreeNodeKey(treeNode);
      if (motionKeys.has(nodeKey)) {
        transitionRange.push(treeNode);
        if (nodeKey === motionArr[0]) {
          rangeStart = ind;
        }
      } else {
        transitionNodes.push(treeNode);
      }
    });
    transitionNodes.splice(rangeStart, 0, transitionRange);
    newState = {
      transitionNodes,
      cachedData: flattenNodes,
      cachedMotionKeys: motionKeys,
      cachedMotionType: motionType
    };
    return newState;
  }
  render() {
    const {
      flattenNodes,
      motionType,
      searchTargetIsDeep,
      renderTreeNode
    } = this.props;
    const {
      transitionNodes
    } = this.state;
    const mapData = transitionNodes.length && !searchTargetIsDeep ? transitionNodes : flattenNodes;
    const options = mapData.map(treeNode => {
      const isMotionNode = Array.isArray(treeNode);
      if (isMotionNode && !treeNode.length) {
        return null;
      }
      if (isMotionNode && treeNode.length) {
        const nodeKey = getTreeNodeKey(treeNode[0]);
        return /*#__PURE__*/react.createElement(nodeCollapsible, {
          open: motionType === 'hide',
          duration: 200,
          motion: Boolean(motionType),
          key: `motion-${nodeKey}`,
          onMotionEnd: this.onMotionEnd
        }, treeNode.map(node => renderTreeNode(node)));
      }
      return renderTreeNode(treeNode);
    });
    return options;
  }
}
NodeList.contextType = treeContext;
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tree/index.js






var tree_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
















// import '@douyinfe/semi-foundation/lib/es/tree/tree.css';



const tree_prefixcls = tree_constants_cssClasses.PREFIX;
class Tree extends BaseComponent {
  constructor(props) {
    super(props);
    this.search = value => {
      this.foundation.handleInputChange(value);
    };
    this.scrollTo = scrollData => {
      var _a;
      const {
        key,
        align = 'center'
      } = scrollData;
      const {
        flattenNodes
      } = this.state;
      if (key) {
        const index = flattenNodes === null || flattenNodes === void 0 ? void 0 : flattenNodes.findIndex(node => {
          return node.key === key;
        });
        index >= 0 && ((_a = this.virtualizedListRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(index, align));
      }
    };
    this.renderEmpty = () => {
      const {
        emptyContent
      } = this.props;
      if (emptyContent) {
        return /*#__PURE__*/react.createElement(TreeNode, {
          empty: true,
          emptyContent: this.props.emptyContent
        });
      } else {
        return /*#__PURE__*/react.createElement(LocaleConsumer, {
          componentName: "Tree"
        }, locale => /*#__PURE__*/react.createElement(TreeNode, {
          empty: true,
          emptyContent: get_default()(locale, 'emptyText')
        }));
      }
    };
    this.onNodeSelect = (e, treeNode) => {
      this.foundation.handleNodeSelect(e, treeNode);
    };
    this.onNodeLoad = data => new Promise(resolve => {
      // We need to get the latest state of loading/loaded keys
      this.setState(_ref => {
        let {
          loadedKeys = new Set([]),
          loadingKeys = new Set([])
        } = _ref;
        return this.foundation.handleNodeLoad(loadedKeys, loadingKeys, data, resolve);
      });
    });
    this.onNodeCheck = (e, treeNode) => {
      this.foundation.handleNodeSelect(e, treeNode);
    };
    this.onNodeExpand = (e, treeNode) => {
      this.foundation.handleNodeExpand(e, treeNode);
    };
    this.onNodeRightClick = (e, treeNode) => {
      this.foundation.handleNodeRightClick(e, treeNode);
    };
    this.onNodeDoubleClick = (e, treeNode) => {
      this.foundation.handleNodeDoubleClick(e, treeNode);
    };
    this.onNodeDragStart = (e, treeNode) => {
      this.foundation.handleNodeDragStart(e, treeNode);
    };
    this.onNodeDragEnter = (e, treeNode) => {
      this.foundation.handleNodeDragEnter(e, treeNode, this.dragNode);
    };
    this.onNodeDragOver = (e, treeNode) => {
      this.foundation.handleNodeDragOver(e, treeNode, this.dragNode);
    };
    this.onNodeDragLeave = (e, treeNode) => {
      this.foundation.handleNodeDragLeave(e, treeNode);
    };
    this.onNodeDragEnd = (e, treeNode) => {
      this.foundation.handleNodeDragEnd(e, treeNode);
    };
    this.onNodeDrop = (e, treeNode) => {
      this.foundation.handleNodeDrop(e, treeNode, this.dragNode);
    };
    this.getTreeNodeRequiredProps = () => {
      const {
        expandedKeys,
        selectedKeys,
        checkedKeys,
        halfCheckedKeys,
        keyEntities,
        filteredKeys
      } = this.state;
      return {
        expandedKeys: expandedKeys || new Set(),
        selectedKeys: selectedKeys || [],
        checkedKeys: checkedKeys || new Set(),
        halfCheckedKeys: halfCheckedKeys || new Set(),
        filteredKeys: filteredKeys || new Set(),
        keyEntities
      };
    };
    this.getTreeNodeKey = treeNode => {
      const {
        data
      } = treeNode;
      const {
        key
      } = data;
      return key;
    };
    this.renderTreeNode = (treeNode, ind, style) => {
      const {
        data,
        key
      } = treeNode;
      const treeNodeProps = this.foundation.getTreeNodeProps(key);
      if (!treeNodeProps) {
        return null;
      }
      const {
        keyMaps,
        showLine
      } = this.props;
      const props = pick_default()(treeNode, ['key', 'label', 'disabled', 'isLeaf', 'icon', 'isEnd']);
      const children = data[get_default()(keyMaps, 'children', 'children')];
      !isUndefined_default()(children) && (props.children = children);
      return /*#__PURE__*/react.createElement(TreeNode, Object.assign({}, treeNodeProps, data, props, {
        showLine: showLine,
        data: data,
        style: isEmpty_default()(style) ? {} : style
      }));
    };
    this.itemKey = (index, data) => {
      // Find the item at the specified index.
      const item = data[index];
      // Return a value that uniquely identifies this item.
      return item.key;
    };
    this.option = _ref2 => {
      let {
        index,
        style,
        data
      } = _ref2;
      return this.renderTreeNode(data[index], index, style);
    };
    this.state = {
      inputValue: '',
      keyEntities: {},
      treeData: [],
      flattenNodes: [],
      selectedKeys: [],
      checkedKeys: new Set(),
      halfCheckedKeys: new Set(),
      realCheckedKeys: new Set([]),
      motionKeys: new Set([]),
      motionType: 'hide',
      expandedKeys: new Set(props.expandedKeys),
      filteredKeys: new Set(),
      filteredExpandedKeys: new Set(),
      filteredShownKeys: new Set(),
      prevProps: null,
      loadedKeys: new Set(),
      loadingKeys: new Set(),
      cachedFlattenNodes: undefined,
      cachedKeyValuePairs: {},
      disabledKeys: new Set(),
      dragging: false,
      dragNodesKeys: new Set(),
      dragOverNodeKey: null,
      dropPosition: null
    };
    this.inputRef = /*#__PURE__*/react.createRef();
    this.optionsRef = /*#__PURE__*/react.createRef();
    this.foundation = new TreeFoundation(this.adapter);
    this.dragNode = null;
    this.virtualizedListRef = /*#__PURE__*/react.createRef();
  }
  /**
   * Process of getDerivedStateFromProps was inspired by rc-tree
   * https://github.com/react-component/tree
   */
  static getDerivedStateFromProps(props, prevState) {
    var _a;
    const {
      prevProps
    } = prevState;
    const {
      keyMaps
    } = props;
    let treeData;
    let keyEntities = prevState.keyEntities || {};
    let valueEntities = prevState.cachedKeyValuePairs || {};
    const isSeaching = Boolean(props.filterTreeNode && prevState.inputValue && prevState.inputValue.length);
    const newState = {
      prevProps: props
    };
    const isExpandControlled = ('expandedKeys' in props);
    // Accept a props field as a parameter to determine whether to update the field
    const needUpdate = name => {
      const firstInProps = !prevProps && name in props;
      const nameHasChange = prevProps && !isEqual_default()(prevProps[name], props[name]);
      return firstInProps || nameHasChange;
    };
    // Determine whether treeData has changed
    const needUpdateData = () => {
      const firstInProps = !prevProps && 'treeData' in props;
      const treeDataHasChange = prevProps && prevProps.treeData !== props.treeData;
      return firstInProps || treeDataHasChange;
    };
    const needUpdateTreeData = needUpdate('treeData');
    const needUpdateSimpleJson = needUpdate('treeDataSimpleJson');
    // Update the data of tree in state
    if (needUpdateTreeData || props.draggable && needUpdateData()) {
      treeData = props.treeData;
      newState.treeData = treeData;
      const entitiesMap = convertDataToEntities(treeData, keyMaps);
      newState.keyEntities = Object.assign({}, entitiesMap.keyEntities);
      keyEntities = newState.keyEntities;
      newState.cachedKeyValuePairs = Object.assign({}, entitiesMap.valueEntities);
      valueEntities = newState.cachedKeyValuePairs;
    } else if (needUpdateSimpleJson) {
      // Convert treeDataSimpleJson to treeData
      treeData = convertJsonToData(props.treeDataSimpleJson);
      newState.treeData = treeData;
      const entitiesMap = convertDataToEntities(treeData, keyMaps);
      newState.keyEntities = Object.assign({}, entitiesMap.keyEntities);
      keyEntities = newState.keyEntities;
      newState.cachedKeyValuePairs = Object.assign({}, entitiesMap.valueEntities);
      valueEntities = newState.cachedKeyValuePairs;
    }
    // If treeData keys changes, we won't show animation
    if (treeData && props.motion) {
      if (prevProps && props.motion) {
        newState.motionKeys = new Set([]);
        newState.motionType = null;
      }
    }
    const dataUpdated = needUpdateSimpleJson || needUpdateTreeData;
    const expandAllWhenDataChange = dataUpdated && props.expandAll;
    if (!isSeaching) {
      // Update expandedKeys
      if (needUpdate('expandedKeys') || prevProps && needUpdate('autoExpandParent')) {
        newState.expandedKeys = calcExpandedKeys(props.expandedKeys, keyEntities, props.autoExpandParent || !prevProps);
        // only show animation when treeData does not change
        if (prevProps && props.motion && !treeData) {
          const {
            motionKeys,
            motionType
          } = calcMotionKeys(prevState.expandedKeys, newState.expandedKeys, keyEntities);
          newState.motionKeys = new Set(motionKeys);
          newState.motionType = motionType;
          if (motionType === 'hide') {
            // cache flatten nodes: expandedKeys changed may not be triggered by interaction
            newState.cachedFlattenNodes = treeUtil_cloneDeep(prevState.flattenNodes);
          }
        }
      } else if (!prevProps && (props.defaultExpandAll || props.expandAll) || expandAllWhenDataChange) {
        newState.expandedKeys = new Set(Object.keys(keyEntities));
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = calcExpandedKeys(props.defaultExpandedKeys, keyEntities);
      } else if (!prevProps && props.defaultValue) {
        newState.expandedKeys = calcExpandedKeysForValues(props.defaultValue, keyEntities, props.multiple, valueEntities);
      } else if (!prevProps && props.value) {
        newState.expandedKeys = calcExpandedKeysForValues(props.value, keyEntities, props.multiple, valueEntities);
      } else if (!isExpandControlled && dataUpdated && props.value) {
        // 当 treeData 已经设置具体的值，并且设置了 props.loadData ，则认为 treeData 的更新是因为 loadData 导致的
        // 如果是因为 loadData 导致 treeData改变， 此时在这里重新计算 key 会导致为未选中的展开项目被收起
        // 所以此时不需要重新计算 expandedKeys，因为在点击展开按钮时候已经把被展开的项添加到 expandedKeys 中
        // When treeData has a specific value and props.loadData is set, it is considered that the update of treeData is caused by loadData
        // If the treeData is changed because of loadData, recalculating the key here will cause the unselected expanded items to be collapsed
        // So there is no need to recalculate expandedKeys at this time, because the expanded item has been added to expandedKeys when the expand button is clicked
        if (!(prevState.treeData && ((_a = prevState.treeData) === null || _a === void 0 ? void 0 : _a.length) > 0 && props.loadData)) {
          newState.expandedKeys = calcExpandedKeysForValues(props.value, keyEntities, props.multiple, valueEntities);
        }
      }
      if (!newState.expandedKeys) {
        delete newState.expandedKeys;
      }
      // Update flattenNodes
      if (treeData || newState.expandedKeys) {
        const flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, keyMaps);
        newState.flattenNodes = flattenNodes;
      }
    } else {
      let filteredState;
      // treeData changed while searching
      if (treeData) {
        // Get filter data
        filteredState = filterTreeData({
          treeData,
          inputValue: prevState.inputValue,
          filterTreeNode: props.filterTreeNode,
          filterProps: props.treeNodeFilterProp,
          showFilteredOnly: props.showFilteredOnly,
          keyEntities: newState.keyEntities,
          prevExpandedKeys: [...prevState.filteredExpandedKeys],
          keyMaps: keyMaps
        });
        newState.flattenNodes = filteredState.flattenNodes;
        newState.motionKeys = new Set([]);
        newState.filteredKeys = filteredState.filteredKeys;
        newState.filteredShownKeys = filteredState.filteredShownKeys;
        newState.filteredExpandedKeys = filteredState.filteredExpandedKeys;
      }
      // expandedKeys changed while searching
      if (props.expandedKeys) {
        newState.filteredExpandedKeys = calcExpandedKeys(props.expandedKeys, keyEntities, props.autoExpandParent || !prevProps);
        if (prevProps && props.motion) {
          const prevKeys = prevState ? prevState.filteredExpandedKeys : new Set([]);
          // only show animation when treeData does not change
          if (!treeData) {
            const motionResult = calcMotionKeys(prevKeys, newState.filteredExpandedKeys, keyEntities);
            let {
              motionKeys
            } = motionResult;
            const {
              motionType
            } = motionResult;
            if (props.showFilteredOnly) {
              motionKeys = motionKeys.filter(key => prevState.filteredShownKeys.has(key));
            }
            if (motionType === 'hide') {
              // cache flatten nodes: expandedKeys changed may not be triggered by interaction
              newState.cachedFlattenNodes = treeUtil_cloneDeep(prevState.flattenNodes);
            }
            newState.motionKeys = new Set(motionKeys);
            newState.motionType = motionType;
          }
        }
        newState.flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.filteredExpandedKeys || prevState.filteredExpandedKeys, keyMaps, props.showFilteredOnly && prevState.filteredShownKeys);
      }
    }
    // Handle single selection and multiple selection in controlled mode
    const withObject = props.onChangeWithObject;
    const isMultiple = props.multiple;
    if (!isMultiple) {
      // When getting single selection, the selected node
      if (needUpdate('value')) {
        newState.selectedKeys = findKeysForValues(
        // In both cases whether withObject is turned on, the value is standardized to string
        normalizeValue(props.value, withObject, keyMaps), valueEntities, isMultiple);
      } else if (!prevProps && props.defaultValue) {
        newState.selectedKeys = findKeysForValues(normalizeValue(props.defaultValue, withObject, keyMaps), valueEntities, isMultiple);
      } else if (treeData) {
        // If `treeData` changed, we also need check it
        if (props.value) {
          newState.selectedKeys = findKeysForValues(normalizeValue(props.value, withObject, keyMaps) || '', valueEntities, isMultiple);
        }
      }
    } else {
      let checkedKeyValues;
      // Get the selected node during multiple selection
      if (needUpdate('value')) {
        checkedKeyValues = findKeysForValues(normalizeValue(props.value, withObject, keyMaps), valueEntities, isMultiple);
      } else if (!prevProps && props.defaultValue) {
        checkedKeyValues = findKeysForValues(normalizeValue(props.defaultValue, withObject, keyMaps), valueEntities, isMultiple);
      } else if (treeData) {
        // If `treeData` changed, we also need check it
        if (props.value) {
          checkedKeyValues = findKeysForValues(normalizeValue(props.value, withObject, keyMaps) || [], valueEntities, isMultiple);
        } else {
          checkedKeyValues = updateKeys(props.checkRelation === 'related' ? prevState.checkedKeys : prevState.realCheckedKeys, keyEntities);
        }
      }
      if (checkedKeyValues) {
        if (props.checkRelation === 'unRelated') {
          newState.realCheckedKeys = new Set(checkedKeyValues);
        } else if (props.checkRelation === 'related') {
          const {
            checkedKeys,
            halfCheckedKeys
          } = calcCheckedKeys(checkedKeyValues, keyEntities);
          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }
    }
    // update loadedKeys
    if (needUpdate('loadedKeys')) {
      newState.loadedKeys = new Set(props.loadedKeys);
    }
    // update disableStrictly
    if (treeData && props.disableStrictly && props.checkRelation === 'related') {
      newState.disabledKeys = calcDisabledKeys(keyEntities, keyMaps);
    }
    return newState;
  }
  get adapter() {
    const filterAdapter = {
      updateInputValue: value => {
        this.setState({
          inputValue: value
        });
      },
      focusInput: () => {
        const {
          preventScroll
        } = this.props;
        if (this.inputRef && this.inputRef.current) {
          this.inputRef.current.focus({
            preventScroll
          });
        }
      }
    };
    return Object.assign(Object.assign(Object.assign({}, super.adapter), filterAdapter), {
      updateState: states => {
        this.setState(Object.assign({}, states));
      },
      notifyExpand: (expandedKeys, _ref3) => {
        let {
          expanded: bool,
          node
        } = _ref3;
        this.props.onExpand && this.props.onExpand([...expandedKeys], {
          expanded: bool,
          node
        });
        if (bool && this.props.loadData) {
          this.onNodeLoad(node);
        }
      },
      notifySelect: (selectKey, bool, node) => {
        this.props.onSelect && this.props.onSelect(selectKey, bool, node);
      },
      notifyChange: value => {
        this.props.onChange && this.props.onChange(value);
      },
      notifySearch: (input, filteredExpandedKeys) => {
        this.props.onSearch && this.props.onSearch(input, filteredExpandedKeys);
      },
      notifyRightClick: (e, node) => {
        this.props.onContextMenu && this.props.onContextMenu(e, node);
      },
      notifyDoubleClick: (e, node) => {
        this.props.onDoubleClick && this.props.onDoubleClick(e, node);
      },
      cacheFlattenNodes: bool => {
        this.setState({
          cachedFlattenNodes: bool ? treeUtil_cloneDeep(this.state.flattenNodes) : undefined
        });
      },
      setDragNode: treeNode => {
        this.dragNode = treeNode;
      }
    });
  }
  renderInput() {
    const {
      searchClassName,
      searchStyle,
      searchRender,
      searchPlaceholder,
      showClear
    } = this.props;
    const inputcls = classnames_default()(`${tree_prefixcls}-input`);
    const {
      inputValue
    } = this.state;
    const inputProps = {
      value: inputValue,
      className: inputcls,
      onChange: value => this.search(value),
      prefix: /*#__PURE__*/react.createElement(IconSearch, null),
      showClear,
      placeholder: searchPlaceholder
    };
    const wrapperCls = classnames_default()(`${tree_prefixcls}-search-wrapper`, searchClassName);
    return /*#__PURE__*/react.createElement("div", {
      className: wrapperCls,
      style: searchStyle
    }, /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Tree"
    }, locale => {
      inputProps.placeholder = searchPlaceholder || get_default()(locale, 'searchPlaceholder');
      if (isFunction_default()(searchRender)) {
        return searchRender(Object.assign({}, inputProps));
      }
      if (searchRender === false) {
        return null;
      }
      return /*#__PURE__*/react.createElement(es_input, Object.assign({
        "aria-label": 'Filter Tree',
        ref: this.inputRef
      }, inputProps));
    }));
  }
  renderNodeList() {
    const {
      flattenNodes,
      cachedFlattenNodes,
      motionKeys,
      motionType
    } = this.state;
    const {
      virtualize,
      motion
    } = this.props;
    const {
      direction
    } = this.context;
    if (isEmpty_default()(flattenNodes)) {
      return undefined;
    }
    if (!virtualize || isEmpty_default()(virtualize)) {
      return /*#__PURE__*/react.createElement(NodeList, {
        flattenNodes: flattenNodes,
        flattenList: cachedFlattenNodes,
        motionKeys: motion ? motionKeys : new Set([]),
        motionType: motionType,
        onMotionEnd: this.onMotionEnd,
        renderTreeNode: this.renderTreeNode
      });
    }
    return /*#__PURE__*/react.createElement(AutoSizer, {
      defaultHeight: virtualize.height,
      defaultWidth: virtualize.width
    }, _ref4 => {
      let {
        height,
        width
      } = _ref4;
      return /*#__PURE__*/react.createElement(FixedSizeList, {
        ref: this.virtualizedListRef,
        itemCount: flattenNodes.length,
        itemSize: virtualize.itemSize,
        height: height,
        width: width,
        itemKey: this.itemKey,
        itemData: flattenNodes,
        className: `${tree_prefixcls}-virtual-list`,
        style: {
          direction
        }
      }, this.option);
    });
  }
  render() {
    const {
      keyEntities,
      motionKeys,
      motionType,
      inputValue,
      filteredKeys,
      dragOverNodeKey,
      dropPosition,
      checkedKeys,
      realCheckedKeys
    } = this.state;
    const _a = this.props,
      {
        blockNode,
        className,
        style,
        filterTreeNode,
        disabled,
        icon,
        directory,
        multiple,
        showFilteredOnly,
        showLine,
        motion,
        expandAction,
        loadData,
        renderLabel,
        draggable,
        renderFullLabel,
        labelEllipsis,
        virtualize,
        checkRelation
      } = _a,
      rest = tree_rest(_a, ["blockNode", "className", "style", "filterTreeNode", "disabled", "icon", "directory", "multiple", "showFilteredOnly", "showLine", "motion", "expandAction", "loadData", "renderLabel", "draggable", "renderFullLabel", "labelEllipsis", "virtualize", "checkRelation"]);
    const wrapperCls = classnames_default()(`${tree_prefixcls}-wrapper`, className);
    const listCls = classnames_default()(`${tree_prefixcls}-option-list`, {
      [`${tree_prefixcls}-option-list-block`]: blockNode
    });
    const searchNoRes = Boolean(inputValue) && !filteredKeys.size;
    const noData = isEmpty_default()(keyEntities) || showFilteredOnly && searchNoRes;
    const ariaAttr = {
      role: noData ? 'none' : 'tree'
    };
    if (ariaAttr.role === 'tree') {
      ariaAttr['aria-multiselectable'] = multiple ? true : false;
    }
    return /*#__PURE__*/react.createElement(treeContext.Provider, {
      value: {
        treeDisabled: disabled,
        treeIcon: icon,
        motion,
        motionKeys,
        motionType,
        filterTreeNode,
        keyEntities,
        onNodeClick: this.onNodeClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeRightClick: this.onNodeRightClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        renderTreeNode: this.renderTreeNode,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop,
        expandAction,
        directory,
        multiple,
        showFilteredOnly,
        isSearching: Boolean(inputValue),
        loadData,
        onNodeLoad: this.onNodeLoad,
        renderLabel,
        draggable,
        renderFullLabel,
        dragOverNodeKey,
        dropPosition,
        labelEllipsis: typeof labelEllipsis === 'undefined' ? virtualize : labelEllipsis
      }
    }, /*#__PURE__*/react.createElement("div", Object.assign({
      "aria-label": this.props['aria-label'],
      className: wrapperCls,
      style: style
    }, this.getDataAttr(rest)), filterTreeNode ? this.renderInput() : null, /*#__PURE__*/react.createElement("div", Object.assign({
      className: listCls
    }, ariaAttr), noData ? this.renderEmpty() : multiple ? /*#__PURE__*/react.createElement(checkboxGroup, {
      value: Array.from(checkRelation === 'related' ? checkedKeys : realCheckedKeys)
    }, this.renderNodeList()) : this.renderNodeList())));
  }
}
Tree.contextType = context;
Tree.propTypes = {
  autoMergeValue: (prop_types_default()).bool,
  blockNode: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  showClear: (prop_types_default()).bool,
  defaultExpandAll: (prop_types_default()).bool,
  defaultExpandedKeys: (prop_types_default()).array,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  directory: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  emptyContent: (prop_types_default()).node,
  expandAll: (prop_types_default()).bool,
  expandedKeys: (prop_types_default()).array,
  filterTreeNode: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  icon: (prop_types_default()).node,
  onChangeWithObject: (prop_types_default()).bool,
  motion: (prop_types_default()).bool,
  multiple: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  onExpand: (prop_types_default()).func,
  onSearch: (prop_types_default()).func,
  onSelect: (prop_types_default()).func,
  onContextMenu: (prop_types_default()).func,
  onDoubleClick: (prop_types_default()).func,
  searchClassName: (prop_types_default()).string,
  searchPlaceholder: (prop_types_default()).string,
  searchStyle: (prop_types_default()).object,
  selectedKey: (prop_types_default()).string,
  showFilteredOnly: (prop_types_default()).bool,
  showLine: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  treeData: prop_types_default().arrayOf(prop_types_default().shape({
    key: (prop_types_default()).string,
    value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    label: (prop_types_default()).any,
    isLeaf: (prop_types_default()).bool
  })),
  keyMaps: (prop_types_default()).object,
  treeDataSimpleJson: (prop_types_default()).object,
  treeNodeFilterProp: (prop_types_default()).string,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array, (prop_types_default()).object]),
  virtualize: (prop_types_default()).object,
  autoExpandParent: (prop_types_default()).bool,
  expandAction: prop_types_default().oneOf(tree_constants_strings.EXPAND_ACTION),
  searchRender: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  renderLabel: (prop_types_default()).func,
  renderFullLabel: (prop_types_default()).func,
  leafOnly: (prop_types_default()).bool,
  loadedKeys: (prop_types_default()).array,
  loadData: (prop_types_default()).func,
  onLoad: (prop_types_default()).func,
  disableStrictly: (prop_types_default()).bool,
  draggable: (prop_types_default()).bool,
  autoExpandWhenDragEnter: (prop_types_default()).bool,
  hideDraggingNode: (prop_types_default()).bool,
  renderDraggingNode: (prop_types_default()).func,
  onDragEnd: (prop_types_default()).func,
  onDragEnter: (prop_types_default()).func,
  onDragLeave: (prop_types_default()).func,
  onDragOver: (prop_types_default()).func,
  onDragStart: (prop_types_default()).func,
  onDrop: (prop_types_default()).func,
  labelEllipsis: (prop_types_default()).bool,
  checkRelation: (prop_types_default()).string,
  'aria-label': (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool
};
Tree.defaultProps = {
  showClear: true,
  disabled: false,
  blockNode: true,
  multiple: false,
  filterTreeNode: false,
  autoExpandParent: false,
  treeNodeFilterProp: 'label',
  defaultExpandAll: false,
  expandAll: false,
  onChangeWithObject: false,
  motion: true,
  leafOnly: false,
  showFilteredOnly: false,
  showLine: false,
  expandAction: false,
  disableStrictly: false,
  draggable: false,
  autoExpandWhenDragEnter: true,
  checkRelation: 'related',
  autoMergeValue: true
};
Tree.TreeNode = TreeNode;
/* harmony default export */ var tree = (Tree);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/treeSelect/constants.js

const treeSelect_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-tree-select`,
  PREFIX_TREE: `${BASE_CLASS_PREFIX}-tree`,
  PREFIX_OPTION: `${BASE_CLASS_PREFIX}-tree-select-option`
};
const treeSelect_constants_strings = {
  SIZE_SET: ['small', 'large', 'default'],
  SEARCH_POSITION_DROPDOWN: 'dropdown',
  SEARCH_POSITION_TRIGGER: 'trigger',
  STATUS: VALIDATE_STATUS
};
const treeSelect_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/treeSelect/foundation.js











class TreeSelectFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this._registerClickOutsideHandler = () => {
      this._adapter.registerClickOutsideHandler(e => {
        this.handlerTriggerBlur(e);
        this.close(e);
      });
    };
    this.clearInputValue = () => {
      const {
        inputValue
      } = this.getStates();
      inputValue && this._adapter.updateInputValue('');
    };
    this.onClickSingleTriggerSearchItem = e => {
      this.focusInput(true);
    };
  }
  init() {
    const {
      searchAutoFocus,
      searchPosition,
      filterTreeNode
    } = this.getProps();
    const triggerSearch = searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER && filterTreeNode;
    const triggerSearchAutoFocus = searchAutoFocus && triggerSearch;
    this._setDropdownWidth();
    const able = !this._isDisabled();
    const isOpen = (this.getProp('defaultOpen') || triggerSearchAutoFocus) && able;
    if (isOpen) {
      this.open();
      this._registerClickOutsideHandler();
    }
    if (triggerSearchAutoFocus && able) {
      this.handleTriggerFocus(null);
    }
  }
  destroy() {
    // Ensure that event monitoring will be uninstalled, and the user may not trigger closePanel
    this._adapter.unregisterClickOutsideHandler();
  }
  _setDropdownWidth() {
    const {
      style,
      dropdownMatchSelectWidth
    } = this.getProps();
    let width;
    if (dropdownMatchSelectWidth) {
      if (style && isNumber_default()(style.width)) {
        width = style.width;
      } else if (style && isString_default()(style.width) && !style.width.includes('%')) {
        width = style.width;
      } else {
        width = this._adapter.getTriggerWidth();
      }
      this._adapter.setOptionWrapperWidth(width);
    }
  }
  _isMultiple() {
    return this.getProp('multiple');
  }
  _isAnimated() {
    return this.getProp('motionExpand');
  }
  _isDisabled() {
    let treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.getProp('disabled') || treeNode.disabled;
  }
  _isExpandControlled() {
    return this.getProp('expandedKeys');
  }
  _isSelectToClose() {
    return !this.getProp('expandAction');
  }
  _isLoadControlled() {
    return this.getProp('loadedKeys');
  }
  _showFilteredOnly() {
    const {
      inputValue
    } = this.getStates();
    const {
      showFilteredOnly
    } = this.getProps();
    return Boolean(inputValue) && showFilteredOnly;
  }
  findDataForValue(findValue) {
    const {
      value,
      defaultValue,
      keyMaps
    } = this.getProps();
    const realValueName = get_default()(keyMaps, 'value', 'value');
    const realKeyName = get_default()(keyMaps, 'key', 'key');
    let valueArr = [];
    if (value) {
      valueArr = Array.isArray(value) ? value : [value];
    } else if (defaultValue) {
      valueArr = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    }
    return valueArr.find(item => {
      return item[realValueName] === findValue || item[realKeyName] === findValue;
    });
  }
  constructDataForValue(value) {
    const {
      treeNodeLabelProp,
      keyMaps
    } = this.getProps();
    const keyName = get_default()(keyMaps, 'key', 'key');
    const labelName = get_default()(keyMaps, 'label', treeNodeLabelProp);
    return {
      [keyName]: value,
      [labelName]: value
    };
  }
  getDataForKeyNotInKeyEntities(value) {
    const {
      onChangeWithObject
    } = this.getProps();
    if (onChangeWithObject) {
      return this.findDataForValue(value);
    } else {
      return this.constructDataForValue(value);
    }
  }
  getTreeNodeProps(key) {
    const {
      expandedKeys = new Set([]),
      selectedKeys = [],
      checkedKeys = new Set([]),
      halfCheckedKeys = new Set([]),
      realCheckedKeys = new Set([]),
      keyEntities = {},
      filteredKeys = new Set([]),
      inputValue = '',
      loadedKeys,
      loadingKeys,
      filteredExpandedKeys = new Set([]),
      disabledKeys = new Set([])
    } = this.getStates();
    const {
      treeNodeFilterProp,
      checkRelation
    } = this.getProps();
    const entity = keyEntities[key];
    const notExist = !entity;
    if (notExist) {
      return null;
    }
    // if checkRelation is invalid, the checked status of node will be false
    let realChecked = false;
    let realHalfChecked = false;
    if (checkRelation === 'related') {
      realChecked = checkedKeys.has(key);
      realHalfChecked = halfCheckedKeys.has(key);
    } else if (checkRelation === 'unRelated') {
      realChecked = realCheckedKeys.has(key);
      realHalfChecked = false;
    }
    const isSearching = Boolean(inputValue);
    const treeNodeProps = {
      eventKey: key,
      expanded: isSearching ? filteredExpandedKeys.has(key) : expandedKeys.has(key),
      selected: selectedKeys.includes(key),
      checked: realChecked,
      halfChecked: realHalfChecked,
      pos: String(entity ? entity.pos : ''),
      level: entity.level,
      filtered: filteredKeys.has(key),
      keyword: inputValue,
      treeNodeFilterProp,
      loading: loadingKeys.has(key) && !loadedKeys.has(key),
      loaded: loadedKeys.has(key)
    };
    if (this.getProp('disableStrictly') && disabledKeys.has(key)) {
      treeNodeProps.disabled = true;
    }
    return treeNodeProps;
  }
  handleNodeLoad(loadedKeys, loadingKeys, data, resolve) {
    const {
      loadData
    } = this.getProps();
    const {
      key
    } = data;
    if (!loadData || loadedKeys.has(key) || loadingKeys.has(key)) {
      return {};
    }
    loadData(data).then(() => {
      const prevLoadedKeys = new Set(this.getState('loadedKeys'));
      const prevLoadingKeys = new Set(this.getState('loadingKeys'));
      const newLoadedKeys = prevLoadedKeys.add(key);
      const newLoadingKeys = new Set([...prevLoadingKeys]);
      newLoadingKeys.delete(key);
      this._adapter.notifyLoad(newLoadedKeys, data);
      if (!this._isLoadControlled()) {
        this._adapter.updateState({
          loadedKeys: newLoadedKeys
        });
      }
      this._adapter.setState({
        loadingKeys: newLoadingKeys
      });
      resolve();
    });
    return {
      loadingKeys: loadingKeys.add(key)
    };
  }
  /* istanbul ignore next */
  focusInput(bool) {
    this._adapter.updateInputFocus(bool);
  }
  _notifyMultipleChange(key, e) {
    const {
      keyEntities
    } = this.getStates();
    const {
      leafOnly,
      checkRelation,
      keyMaps,
      autoMergeValue
    } = this.getProps();
    let keyList = [];
    if (checkRelation === 'related') {
      keyList = autoMergeValue ? normalizeKeyList(key, keyEntities, leafOnly, true) : key;
    } else if (checkRelation === 'unRelated') {
      keyList = key;
    }
    const nodes = keyList.map(key => keyEntities[key] && keyEntities[key].key === key ? keyEntities[key].data : this.getDataForKeyNotInKeyEntities(key));
    if (this.getProp('onChangeWithObject')) {
      this._adapter.notifyChangeWithObject(nodes, e);
    } else {
      const value = getValueOrKey(nodes, keyMaps);
      this._adapter.notifyChange(value, nodes, e);
    }
  }
  _notifyChange(key, e) {
    const {
      keyEntities
    } = this.getStates();
    const {
      keyMaps
    } = this.getProps();
    if (this._isMultiple() && Array.isArray(key)) {
      this._notifyMultipleChange(key, e);
    } else {
      const nodes = isUndefined_default()(key) ? key : keyEntities[key].data;
      const value = isUndefined_default()(key) ? key : getValueOrKey(nodes, keyMaps);
      if (this.getProp('onChangeWithObject')) {
        this._adapter.notifyChangeWithObject(nodes, e);
      } else {
        this._adapter.notifyChange(value, nodes, e);
      }
    }
  }
  // Scenes that may trigger focus:
  //  1、click selection
  _notifyFocus(e) {
    this._adapter.notifyFocus(e);
  }
  handleTriggerFocus(e) {
    this._adapter.updateIsFocus(true);
    this._notifyFocus(e);
    this._registerClickOutsideHandler();
  }
  // Scenes that may trigger blur
  //  1、clickOutSide
  //  2、click option / press enter, and then select complete（when multiple is false
  //  3、press esc when dropdown list open
  _notifyBlur(e) {
    this._adapter.notifyBlur(e);
  }
  handlerTriggerBlur(e) {
    const isFocus = this.getState('isFocus');
    if (!isFocus) {
      return;
    }
    this._adapter.updateIsFocus(false);
    this._notifyBlur(e);
    this._adapter.unregisterClickOutsideHandler();
  }
  toggleHoverState(bool) {
    this._adapter.toggleHovering(bool);
  }
  open() {
    this._adapter.openMenu();
    this._setDropdownWidth();
  }
  close(e) {
    this._adapter.closeMenu();
    if (this.getProp('motionExpand')) {
      this._adapter.updateState({
        motionKeys: new Set([])
      });
    }
  }
  handleClick(e) {
    const isDisabled = this._isDisabled();
    const {
      isOpen,
      inputValue,
      isFocus
    } = this.getStates();
    const {
      searchPosition,
      clickTriggerToHide
    } = this.getProps();
    if (isDisabled) {
      return;
    } else {
      if (!isFocus) {
        this.handleTriggerFocus(e);
      }
      if (isOpen) {
        if (searchPosition === 'trigger' && inputValue) {
          return;
        }
        clickTriggerToHide && this.close(e);
      } else {
        this.open();
      }
    }
  }
  /**
   * A11y: simulate selection click
   */
  /* istanbul ignore next */
  handleSelectionEnterPress(e) {
    if (utils_isEnterPress(e)) {
      this.handleClick(e);
    }
  }
  handleClear(e) {
    const {
      searchPosition,
      filterTreeNode
    } = this.getProps();
    const {
      inputValue,
      selectedKeys
    } = this.getStates();
    const isMultiple = this._isMultiple();
    const isControlled = this._isControlledComponent();
    const value = isMultiple ? [] : undefined;
    this._notifyChange(value, e);
    if (!isControlled) {
      // reposition dropdown when selected values change
      this._adapter.rePositionDropdown();
      this._adapter.updateState({
        selectedKeys: [],
        checkedKeys: new Set(),
        halfCheckedKeys: new Set(),
        realCheckedKeys: new Set([])
      });
    }
    // When triggerSearch, clicking the clear button will trigger to clear Input
    if (filterTreeNode && searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER) {
      if (inputValue !== '') {
        if (isEmpty_default()(selectedKeys)) {
          this.handleInputChange('');
        } else {
          this.clearInput();
        }
      }
    }
    this._adapter.notifyClear(e);
  }
  /**
   * A11y: simulate clear button click
   */
  /* istanbul ignore next */
  handleClearEnterPress(e) {
    if (utils_isEnterPress(e)) {
      this.handleClear(e);
    }
  }
  removeTag(eventKey) {
    const {
      disableStrictly,
      checkRelation,
      keyMaps
    } = this.getProps();
    const {
      keyEntities,
      disabledKeys,
      realCheckedKeys
    } = this.getStates();
    const item = keyEntities[eventKey] && keyEntities[eventKey].key === eventKey ? keyEntities[eventKey].data : this.getDataForKeyNotInKeyEntities(eventKey);
    const disabledName = get_default()(keyMaps, 'disabled', 'disabled');
    if (item[disabledName] || disableStrictly && disabledKeys.has(eventKey)) {
      return;
    }
    if (checkRelation === 'unRelated') {
      const newRealCheckedKeys = new Set(realCheckedKeys);
      newRealCheckedKeys.delete(eventKey);
      this._notifyChange([...newRealCheckedKeys], null);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          realCheckedKeys: newRealCheckedKeys
        });
        this._adapter.rePositionDropdown();
      }
    } else if (checkRelation === 'related') {
      const {
        checkedKeys,
        halfCheckedKeys
      } = this.calcCheckedKeys(eventKey, false);
      this._notifyChange([...checkedKeys], null);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          checkedKeys,
          halfCheckedKeys
        });
        this._adapter.rePositionDropdown();
      }
    }
    this._adapter.notifySelect(eventKey, false, item);
    // reposition dropdown when selected values change
    this._adapter.rePositionDropdown();
  }
  clearInput() {
    const {
      flattenNodes,
      expandedKeys,
      selectedKeys,
      keyEntities,
      treeData
    } = this.getStates();
    const {
      keyMaps
    } = this.getProps();
    const newExpandedKeys = new Set(expandedKeys);
    const isExpandControlled = this._isExpandControlled();
    const expandedOptsKeys = findAncestorKeys(selectedKeys, keyEntities, false);
    expandedOptsKeys.forEach(item => newExpandedKeys.add(item));
    const newFlattenNodes = flattenTreeData(treeData, newExpandedKeys, keyMaps);
    this._adapter.updateState({
      expandedKeys: newExpandedKeys,
      flattenNodes: newFlattenNodes,
      inputValue: '',
      motionKeys: new Set([]),
      filteredKeys: new Set([]),
      filteredExpandedKeys: new Set(expandedOptsKeys),
      filteredShownKeys: new Set([])
    });
    this._adapter.rePositionDropdown();
  }
  handleInputChange(sugInput) {
    // Input is used as controlled component
    this._adapter.updateInputValue(sugInput);
    const {
      flattenNodes,
      expandedKeys,
      selectedKeys,
      keyEntities,
      treeData
    } = this.getStates();
    const {
      showFilteredOnly,
      filterTreeNode,
      treeNodeFilterProp,
      keyMaps
    } = this.getProps();
    const realFilterProp = treeNodeFilterProp !== 'label' ? treeNodeFilterProp : get_default()(keyMaps, 'label', 'label');
    const newExpandedKeys = new Set(expandedKeys);
    let filteredNodes = [];
    let filteredOptsKeys = [];
    let expandedOptsKeys = [];
    let newFlattenNodes = [];
    let filteredShownKeys = new Set([]);
    if (!sugInput) {
      expandedOptsKeys = findAncestorKeys(selectedKeys, keyEntities, false);
      expandedOptsKeys.forEach(item => newExpandedKeys.add(item));
      newFlattenNodes = flattenTreeData(treeData, newExpandedKeys, keyMaps);
    } else {
      const filteredOpts = Object.values(keyEntities).filter(item => {
        const {
          data
        } = item;
        return filter(sugInput, data, filterTreeNode, realFilterProp);
      });
      filteredNodes = filteredOpts.map(item => item.data);
      filteredOptsKeys = filteredOpts.map(item => item.key);
      expandedOptsKeys = findAncestorKeys(filteredOptsKeys, keyEntities, false);
      const shownChildKeys = findDescendantKeys(filteredOptsKeys, keyEntities, true);
      filteredShownKeys = new Set([...shownChildKeys, ...expandedOptsKeys]);
      newFlattenNodes = flattenTreeData(treeData, new Set(expandedOptsKeys), keyMaps, showFilteredOnly && filteredShownKeys);
    }
    const newFilteredExpandedKeys = new Set(expandedOptsKeys);
    this._adapter.notifySearch(sugInput, Array.from(newFilteredExpandedKeys), filteredNodes);
    this._adapter.updateState({
      expandedKeys: newExpandedKeys,
      flattenNodes: newFlattenNodes,
      motionKeys: new Set([]),
      filteredKeys: new Set(filteredOptsKeys),
      filteredExpandedKeys: newFilteredExpandedKeys,
      filteredShownKeys
    });
    this._adapter.rePositionDropdown();
  }
  handleNodeSelect(e, treeNode) {
    const isDisabled = this._isDisabled(treeNode);
    if (isDisabled) {
      return;
    }
    if (!this._isMultiple()) {
      this.handleSingleSelect(e, treeNode);
    } else {
      this.handleMultipleSelect(e, treeNode);
    }
  }
  handleSingleSelect(e, treeNode) {
    let selectedKeys = [...this.getState('selectedKeys')];
    const {
      clickToHide
    } = this.getProps();
    const {
      selected,
      eventKey,
      data
    } = treeNode;
    this._adapter.notifySelect(eventKey, true, data);
    if (!selectedKeys.includes(eventKey) && !selected) {
      selectedKeys = [eventKey];
      this._notifyChange(eventKey, e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          selectedKeys
        });
      }
    }
    if (clickToHide && (this._isSelectToClose() || !data.children)) {
      this.close(e);
      this.handlerTriggerBlur(e);
    }
  }
  calcCheckedKeys(eventKey, targetStatus) {
    const {
      keyEntities
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const halfCheckedKeys = new Set(this.getState('halfCheckedKeys'));
    if (targetStatus) {
      return calcCheckedKeysForChecked(eventKey, keyEntities, checkedKeys, halfCheckedKeys);
    } else {
      return calcCheckedKeysForUnchecked(eventKey, keyEntities, checkedKeys, halfCheckedKeys);
    }
  }
  handleMultipleSelect(e, treeNode) {
    const {
      searchPosition,
      disableStrictly,
      checkRelation
    } = this.getProps();
    const {
      inputValue,
      realCheckedKeys
    } = this.getStates();
    const {
      checked,
      eventKey,
      data
    } = treeNode;
    if (checkRelation === 'related') {
      const targetStatus = disableStrictly ? this.calcCheckedStatus(!checked, eventKey) : !checked;
      const {
        checkedKeys,
        halfCheckedKeys
      } = disableStrictly ? this.calcNonDisabledCheckedKeys(eventKey, targetStatus) : this.calcCheckedKeys(eventKey, targetStatus);
      this._adapter.notifySelect(eventKey, targetStatus, data);
      this._notifyChange([...checkedKeys], e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          checkedKeys,
          halfCheckedKeys
        });
        this._adapter.rePositionDropdown();
      }
    } else if (checkRelation === 'unRelated') {
      const newRealCheckedKeys = new Set(realCheckedKeys);
      let targetStatus;
      if (realCheckedKeys.has(eventKey)) {
        newRealCheckedKeys.delete(eventKey);
        targetStatus = false;
      } else {
        newRealCheckedKeys.add(eventKey);
        targetStatus = true;
      }
      this._adapter.notifySelect(eventKey, targetStatus, data);
      this._notifyChange([...newRealCheckedKeys], e);
      if (!this._isControlledComponent()) {
        this._adapter.updateState({
          realCheckedKeys: newRealCheckedKeys
        });
        this._adapter.rePositionDropdown();
      }
    }
    if (searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER && inputValue !== '') {
      this._adapter.updateState({
        inputValue: ''
      });
    }
  }
  calcNonDisabledCheckedKeys(eventKey, targetStatus) {
    const {
      keyEntities,
      disabledKeys
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    if (!hasDisabled) {
      return this.calcCheckedKeys(eventKey, targetStatus);
    }
    const nonDisabled = descendantKeys.filter(key => !disabledKeys.has(key));
    const newCheckedKeys = targetStatus ? [...nonDisabled, ...checkedKeys] : difference_default()(normalizeKeyList([...checkedKeys], keyEntities, true, true), nonDisabled);
    return calcCheckedKeys(newCheckedKeys, keyEntities);
  }
  calcCheckedStatus(targetStatus, eventKey) {
    if (!targetStatus) {
      return targetStatus;
    }
    const {
      checkedKeys,
      keyEntities,
      disabledKeys
    } = this.getStates();
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    if (!hasDisabled) {
      return targetStatus;
    }
    const nonDisabledKeys = descendantKeys.filter(key => !disabledKeys.has(key));
    const allChecked = nonDisabledKeys.every(key => checkedKeys.has(key));
    return !allChecked;
  }
  handleNodeExpandInSearch(e, treeNode) {
    const {
      treeData,
      filteredShownKeys,
      keyEntities,
      keyMaps
    } = this.getStates();
    const showFilteredOnly = this._showFilteredOnly();
    // clone otherwise will be modified unexpectedly
    const filteredExpandedKeys = new Set(this.getState('filteredExpandedKeys'));
    let motionType = 'show';
    const {
      eventKey,
      expanded,
      data
    } = treeNode;
    // debugger;
    if (!expanded) {
      filteredExpandedKeys.add(eventKey);
    } else if (filteredExpandedKeys.has(eventKey)) {
      filteredExpandedKeys.delete(eventKey);
      motionType = 'hide';
    }
    // cache prev flattenNodes, otherwise the calculation will remove hidden items
    this._adapter.cacheFlattenNodes(motionType === 'hide' && this._isAnimated());
    if (!this._isExpandControlled()) {
      // debugger;
      const flattenNodes = flattenTreeData(treeData, filteredExpandedKeys, keyMaps, showFilteredOnly && filteredShownKeys);
      const motionKeys = this._isAnimated() ? getMotionKeys(eventKey, filteredExpandedKeys, keyEntities) : [];
      const newState = {
        filteredExpandedKeys,
        flattenNodes,
        motionKeys: new Set(motionKeys),
        motionType
      };
      this._adapter.updateState(newState);
    }
    this._adapter.notifyExpand(filteredExpandedKeys, {
      expanded: !expanded,
      node: data
    });
  }
  handleNodeExpand(e, treeNode) {
    // debugger;
    const {
      loadData,
      keyMaps
    } = this.getProps();
    const {
      inputValue,
      keyEntities
    } = this.getStates();
    const isSearching = Boolean(inputValue);
    if (!loadData && (!treeNode.children || !treeNode.children.length)) {
      return;
    }
    const isExpandControlled = this._isExpandControlled();
    if (isSearching) {
      this.handleNodeExpandInSearch(e, treeNode);
      return;
    }
    const {
      treeData
    } = this.getStates();
    // clone otherwise will be modified unexpectedly
    const expandedKeys = new Set(this.getState('expandedKeys'));
    let motionType = 'show';
    const {
      eventKey,
      expanded,
      data
    } = treeNode;
    if (!expanded) {
      expandedKeys.add(eventKey);
    } else if (expandedKeys.has(eventKey)) {
      expandedKeys.delete(eventKey);
      motionType = 'hide';
    }
    this._adapter.cacheFlattenNodes(motionType === 'hide' && this._isAnimated());
    if (!isExpandControlled) {
      // debugger;
      const flattenNodes = flattenTreeData(treeData, expandedKeys, keyMaps);
      const motionKeys = this._isAnimated() ? getMotionKeys(eventKey, expandedKeys, keyEntities) : [];
      const newState = {
        expandedKeys,
        flattenNodes,
        motionKeys: new Set(motionKeys),
        motionType
      };
      this._adapter.updateState(newState);
    }
    this._adapter.notifyExpand(expandedKeys, {
      expanded: !expanded,
      node: data
    });
  }
  /**
   * The selected items that need to be displayed in the search box when obtaining a single selection
   */
  getRenderTextInSingle() {
    const {
      renderSelectedItem: propRenderSelectedItem,
      treeNodeLabelProp,
      keyMaps
    } = this.getProps();
    const {
      selectedKeys,
      keyEntities
    } = this.getStates();
    const realLabelName = get_default()(keyMaps, 'label', treeNodeLabelProp);
    const renderSelectedItem = isFunction_default()(propRenderSelectedItem) ? propRenderSelectedItem : item => get_default()(item, realLabelName, null);
    let item;
    if (selectedKeys.length) {
      const key = selectedKeys[0];
      item = keyEntities[key] && keyEntities[key].key === key ? keyEntities[key].data : this.getDataForKeyNotInKeyEntities(key);
    }
    const renderText = item ? renderSelectedItem(item) : null;
    return renderText;
  }
  /**
   * When the search box is on the trigger, the blur event handling method
   */
  handleInputTriggerBlur() {
    this._adapter.updateState({
      inputTriggerFocus: false
    });
  }
  /**
   * When the search box is on the trigger, the focus event processing method
   */
  handleInputTriggerFocus() {
    const inputValue = this.getState('inputValue');
    inputValue && this.clearInput();
    this._adapter.updateState({
      inputTriggerFocus: true
    });
  }
  setLoadKeys(data, resolve) {
    this._adapter.updateLoadKeys(data, resolve);
  }
  handlePopoverVisibleChange(isVisible) {
    const {
      filterTreeNode,
      searchAutoFocus,
      searchPosition
    } = this.getProps();
    const inputValue = this.getState('inputValue');
    // 将 inputValue 清空，如果有选中值的话，选中项能够快速回显
    // Clear the inputValue. If there is a selected value, the selected item can be quickly echoed.
    if (isVisible === false && filterTreeNode) {
      inputValue && this._adapter.setClearInputFlag(true);
      this.clearInputValue();
    }
    if (filterTreeNode && searchPosition === treeSelect_constants_strings.SEARCH_POSITION_DROPDOWN && isVisible && searchAutoFocus) {
      this.focusInput(true);
    }
  }
  handleAfterClose() {
    // flattenNode 的变化将导致弹出层面板中的选项数目变化
    // 在弹层完全收起之后，再通过 clearInput 重新计算 state 中的 expandedKey， flattenNode
    // 防止在弹出层未收起时弹层面板中选项数目变化导致视觉上出现弹层闪动问题
    // Changes to flattenNode will cause the number of options in the popup panel to change
    // After the pop-up layer is completely closed, recalculate the expandedKey and flattenNode in the state through clearInput.
    // Prevent the pop-up layer from flickering visually due to changes in the number of options in the pop-up panel when the pop-up layer is not collapsed.
    const {
      filterTreeNode
    } = this.getProps();
    const shouldClear = this._adapter.getClearInputFlag();
    filterTreeNode && shouldClear && this.clearInput();
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tagInput/constants.js

const tagInput_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-tagInput`
};
const tagInput_constants_strings = {
  SIZE_SET: ['large', 'default', 'small'],
  STATUS: ["success", "default", "error", "warning"]
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tagInput/utils/getSplitedArray.js



/**
 * Get the splited array.
 * We expect separators to be string | string[] | null, but users
 * are also allowed to pass in other types.
 */
const getSplitedArray = (originString, separators) => {
  let splitedValue = [];
  if (isString_default()(separators) || isNumber_default()(separators)) {
    splitedValue = originString.split(separators);
  } else if (isArray_default()(separators)) {
    const tempChar = separators[0]; // temporary splitter
    splitedValue = originString;
    for (let i = 1; i < separators.length; i++) {
      splitedValue = splitedValue.split(separators[i]).join(tempChar);
    }
    splitedValue = splitedValue.split(tempChar);
  } else {
    splitedValue.push(originString);
  }
  return splitedValue;
};
/* harmony default export */ var utils_getSplitedArray = (getSplitedArray);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/arrayMove.js
function arrayMove(array, from, to) {
  const newArray = array.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
  return newArray;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/tagInput/foundation.js









class TagInputFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    /**
     * handler of input change
     */
    this.handleInputChange = e => {
      const {
        value
      } = e.target;
      const {
        entering
      } = this.getStates();
      if (entering) {
        // 如果处于输入法输入中，则先不检查输入是否有效，直接更新到inputValue，
        // 因为对于输入法输入中而言，此时更新到 inputValue 的不是最后的结果，比如对于中文，此时 inputValue 中的内容是拼音
        // 当输入法输入结束后，将在 handleInputCompositionEnd 中判断输入是否有效，处理结果
        // If it is composition session, it does not check whether the input is valid, and directly updates to inputValue,
        // Because for composition input, what is updated to inputValue at this time is not the final result.
        // For example, for Chinese, the content in inputValue is pinyin at this time
        // When the composition input is finished, it will be judged whether the input is valid in handleInputCompositionEnd and the result will be processed
        this._onInputChange(value, e);
      } else {
        this._checkInputChangeValid(value) && this._onInputChange(value, e);
      }
    };
    this.handleInputCompositionStart = e => {
      const {
        maxLength
      } = this.getProps();
      if (!isNumber_default()(maxLength)) {
        return;
      }
      this._adapter.setEntering(true);
    };
    this.handleInputCompositionEnd = e => {
      const {
        value
      } = e.target;
      const {
        maxLength,
        onInputExceed,
        separator
      } = this.getProps();
      if (!isNumber_default()(maxLength)) {
        return;
      }
      this._adapter.setEntering(false);
      let allowChange = true;
      const inputArr = utils_getSplitedArray(value, separator);
      let index = 0;
      for (; index < inputArr.length; index++) {
        if (inputArr[index].length > maxLength) {
          allowChange = false;
          isFunction_default()(onInputExceed) && onInputExceed(value);
          break;
        }
      }
      if (!allowChange) {
        const newInputArr = inputArr.slice(0, index);
        if (index < inputArr.length) {
          newInputArr.push(inputArr[index].slice(0, maxLength));
        }
        this._adapter.setInputValue(newInputArr.join(separator));
      } else {
        // Why does it need to be updated here instead of in onChange when the value meets the maxLength limit?
        // Because in firefox, the state change in InputCompositionEnd causes onChange to not be triggered after 
        // the composition input completes input.
        this._adapter.setInputValue(value);
      }
    };
    /**
     * check whether the input change is legal
     */
    this._checkInputChangeValid = value => {
      // e.target.value legitimacy judgment needs to be based on this.state.input Value
      const {
        maxLength,
        onInputExceed,
        separator
      } = this._adapter.getProps();
      const {
        inputValue
      } = this._adapter.getStates();
      let allowChange = true;
      if (isNumber_default()(maxLength)) {
        const valueArr = utils_getSplitedArray(value, separator);
        const inputArr = utils_getSplitedArray(inputValue, separator);
        const maxLen = Math.max(valueArr.length, inputArr.length);
        for (let i = 0; i < maxLen; i++) {
          // When the input length is increasing
          if (!isUndefined_default()(valueArr[i]) && (isUndefined_default()(inputArr[i]) || valueArr[i].length > inputArr[i].length)) {
            // When the input length exceeds maxLength
            if (valueArr[i].length > maxLength) {
              allowChange = false;
              isFunction_default()(onInputExceed) && onInputExceed(value);
              break;
            }
          }
        }
      }
      return allowChange;
    };
    /**
     * Input event handler when onKeyDown is triggered
     */
    this.handleKeyDown = e => {
      const {
        inputValue,
        tagsArray
      } = this._adapter.getStates();
      const code = e.keyCode;
      if (code === utils_keyCode.ENTER) {
        e.preventDefault(); // prevent trigger submit when using in form
        if (inputValue !== '') {
          this._handleAddTags(e);
        }
      }
      const {
        length
      } = tagsArray;
      if (code === utils_keyCode.BACKSPACE && inputValue === '' && length > 0) {
        const newTagList = tagsArray.slice(0, length - 1);
        const removedTag = tagsArray[length - 1];
        this._onRemove(newTagList, removedTag, length - 1);
      }
      this._adapter.notifyKeyDown(e);
    };
  }
  _handleAddTags(e) {
    const {
      separator,
      max,
      onExceed,
      allowDuplicates
    } = this._adapter.getProps();
    const {
      inputValue,
      tagsArray
    } = this._adapter.getStates();
    let addTags = utils_getSplitedArray(inputValue, separator);
    addTags = addTags.filter((item, idx) => {
      // If allowDuplicates is false, then filter duplicates
      if (!allowDuplicates) {
        if (tagsArray.includes(item) || addTags.indexOf(item) !== idx) {
          return false;
        }
      }
      // Filter empty strings and pure space strings in new items
      return isString_default()(item) && item.trim() !== '';
    });
    let newTagList = tagsArray.concat(addTags);
    if (isNumber_default()(max) && newTagList.length > max) {
      isFunction_default()(onExceed) && onExceed(newTagList);
      newTagList = newTagList.slice(0, max);
      addTags = addTags.slice(0, max - tagsArray.length);
    }
    if (addTags.length > 0) {
      this._onAdd(newTagList, addTags);
    }
    this._onInputChange('', e);
  }
  handleInputBlur(e) {
    const {
      addOnBlur
    } = this._adapter.getProps();
    if (addOnBlur === true) {
      this._handleAddTags(e);
    }
    this._adapter.setFocusing(false);
    this._adapter.notifyBlur(e);
  }
  handleInputFocus(e) {
    this._adapter.setFocusing(true);
    this._adapter.notifyFocus(e);
  }
  /**
   * A11y: simulate clear button click
   */
  /* istanbul ignore next */
  handleClearEnterPress(e) {
    if (utils_isEnterPress(e)) {
      this.handleClearBtn(e);
    }
  }
  handleClearBtn(e) {
    const {
      inputValue,
      tagsArray
    } = this._adapter.getStates();
    if (tagsArray.length > 0) {
      this._adapter.setTagsArray([]);
      this._adapter.notifyTagChange([]);
    }
    if (inputValue.length > 0) {
      this._onInputChange('', e);
    }
    // Prevent event propagate to TagInput outermost div
    e.stopPropagation();
  }
  handleTagClose(index) {
    const {
      tagsArray
    } = this._adapter.getStates();
    const newTagList = [...tagsArray];
    newTagList.splice(index, 1);
    const removedTag = tagsArray[index];
    this._onRemove(newTagList, removedTag, index);
  }
  handleInputMouseEnter() {
    this._adapter.setHovering(true);
  }
  handleInputMouseLeave() {
    this._adapter.setHovering(false);
  }
  handleClick(e) {
    const {
      disabled
    } = this.getProps();
    if (disabled) {
      return;
    }
    const clickOutsideHandler = this._adapter.getClickOutsideHandler();
    if (!clickOutsideHandler) {
      this._adapter.setActive(true);
      this._adapter.registerClickOutsideHandler(e => this.clickOutsideCallBack());
    }
  }
  clickOutsideCallBack() {
    this._adapter.unregisterClickOutsideHandler();
    this._adapter.setActive(false);
  }
  handleClickPrefixOrSuffix(e) {
    const {
      disabled
    } = this._adapter.getProps();
    const {
      isFocus
    } = this._adapter.getStates();
    if (!disabled && !isFocus) {
      this._adapter.toggleFocusing(true);
    }
  }
  handlePreventMouseDown(e) {
    if (e && isFunction_default()(e.preventDefault)) {
      e.preventDefault();
    }
  }
  /**
   * handler of delete tag
   */
  _onRemove(newTagList, removedTags, index) {
    if (!this._isControlledComponent()) {
      this._adapter.setTagsArray(newTagList);
    }
    this._adapter.notifyTagChange(newTagList);
    this._adapter.notifyTagRemove(removedTags, index);
  }
  /**
   * handler of add tag
   */
  _onAdd(newTagList, addTags) {
    if (!this._isControlledComponent()) {
      this._adapter.setTagsArray(newTagList);
    }
    this._adapter.notifyTagChange(newTagList);
    this._adapter.notifyTagAdd(addTags);
  }
  /**
   * handler of input change
   */
  _onInputChange(value, e) {
    this._adapter.setInputValue(value);
    this._adapter.notifyInputChange(value, e);
  }
  handleSortEnd(callbackProps) {
    const {
      oldIndex,
      newIndex
    } = callbackProps;
    const {
      tagsArray
    } = this.getStates();
    const newTagsArray = arrayMove(tagsArray, oldIndex, newIndex);
    if (!this._isControlledComponent()) {
      this._adapter.setTagsArray(newTagsArray);
    }
    this._adapter.notifyTagChange(newTagsArray);
  }
}
/* harmony default export */ var tagInput_foundation = (TagInputFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconHandle.js


function IconHandle_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M9 7C10.1046 7 11 6.10457 11 5C11 3.89543 10.1046 3 9 3C7.89543 3 7 3.89543 7 5C7 6.10457 7.89543 7 9 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11 19C11 20.1046 10.1046 21 9 21C7.89543 21 7 20.1046 7 19C7 17.8954 7.89543 17 9 17C10.1046 17 11 17.8954 11 19Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15 7C16.1046 7 17 6.10457 17 5C17 3.89543 16.1046 3 15 3C13.8954 3 13 3.89543 13 5C13 6.10457 13.8954 7 15 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15 21C16.1046 21 17 20.1046 17 19C17 17.8954 16.1046 17 15 17C13.8954 17 13 17.8954 13 19C13 20.1046 13.8954 21 15 21Z",
    fill: "currentColor"
  }));
}
const IconHandle_IconComponent = (0,Icon/* convertIcon */.A)(IconHandle_SvgComponent, 'handle');
/* harmony default export */ var IconHandle = (IconHandle_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@dnd-kit/utilities/dist/utilities.esm.js


function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return (0,react.useMemo)(() => node => {
    refs.forEach(ref => ref(node));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}

// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const canUseDOM = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

function isWindow(element) {
  const elementString = Object.prototype.toString.call(element);
  return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
  elementString === '[object global]';
}

function isNode(node) {
  return 'nodeType' in node;
}

function getWindow(target) {
  var _target$ownerDocument, _target$ownerDocument2;

  if (!target) {
    return window;
  }

  if (isWindow(target)) {
    return target;
  }

  if (!isNode(target)) {
    return window;
  }

  return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}

function isDocument(node) {
  const {
    Document
  } = getWindow(node);
  return node instanceof Document;
}

function isHTMLElement(node) {
  if (isWindow(node)) {
    return false;
  }

  return node instanceof getWindow(node).HTMLElement;
}

function isSVGElement(node) {
  return node instanceof getWindow(node).SVGElement;
}

function getOwnerDocument(target) {
  if (!target) {
    return document;
  }

  if (isWindow(target)) {
    return target.document;
  }

  if (!isNode(target)) {
    return document;
  }

  if (isDocument(target)) {
    return target;
  }

  if (isHTMLElement(target) || isSVGElement(target)) {
    return target.ownerDocument;
  }

  return document;
}

/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */

const useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;

function useEvent(handler) {
  const handlerRef = (0,react.useRef)(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return (0,react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}

function useInterval() {
  const intervalRef = (0,react.useRef)(null);
  const set = (0,react.useCallback)((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = (0,react.useCallback)(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set, clear];
}

function useLatestValue(value, dependencies) {
  if (dependencies === void 0) {
    dependencies = [value];
  }

  const valueRef = (0,react.useRef)(value);
  useIsomorphicLayoutEffect(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies);
  return valueRef;
}

function useLazyMemo(callback, dependencies) {
  const valueRef = (0,react.useRef)();
  return (0,react.useMemo)(() => {
    const newValue = callback(valueRef.current);
    valueRef.current = newValue;
    return newValue;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [...dependencies]);
}

function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node = (0,react.useRef)(null);
  const setNodeRef = (0,react.useCallback)(element => {
    if (element !== node.current) {
      onChangeHandler == null ? void 0 : onChangeHandler(element, node.current);
    }

    node.current = element;
  }, //eslint-disable-next-line
  []);
  return [node, setNodeRef];
}

function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

let ids = {};
function useUniqueId(prefix, value) {
  return (0,react.useMemo)(() => {
    if (value) {
      return value;
    }

    const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
    ids[prefix] = id;
    return prefix + "-" + id;
  }, [prefix, value]);
}

function createAdjustmentFn(modifier) {
  return function (object) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }

    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);

      for (const [key, valueAdjustment] of entries) {
        const value = accumulator[key];

        if (value != null) {
          accumulator[key] = value + modifier * valueAdjustment;
        }
      }

      return accumulator;
    }, { ...object
    });
  };
}

const add = /*#__PURE__*/createAdjustmentFn(1);
const subtract = /*#__PURE__*/createAdjustmentFn(-1);

function hasViewportRelativeCoordinates(event) {
  return 'clientX' in event && 'clientY' in event;
}

function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }

  const {
    KeyboardEvent
  } = getWindow(event.target);
  return KeyboardEvent && event instanceof KeyboardEvent;
}

function isTouchEvent(event) {
  if (!event) {
    return false;
  }

  const {
    TouchEvent
  } = getWindow(event.target);
  return TouchEvent && event instanceof TouchEvent;
}

/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */

function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.touches[0];
      return {
        x,
        y
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.changedTouches[0];
      return {
        x,
        y
      };
    }
  }

  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }

  return null;
}

const CSS = /*#__PURE__*/Object.freeze({
  Translate: {
    toString(transform) {
      if (!transform) {
        return;
      }

      const {
        x,
        y
      } = transform;
      return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
    }

  },
  Scale: {
    toString(transform) {
      if (!transform) {
        return;
      }

      const {
        scaleX,
        scaleY
      } = transform;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }

  },
  Transform: {
    toString(transform) {
      if (!transform) {
        return;
      }

      return [CSS.Translate.toString(transform), CSS.Scale.toString(transform)].join(' ');
    }

  },
  Transition: {
    toString(_ref) {
      let {
        property,
        duration,
        easing
      } = _ref;
      return property + " " + duration + "ms " + easing;
    }

  }
});

const SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function findFirstFocusableNode(element) {
  if (element.matches(SELECTOR)) {
    return element;
  }

  return element.querySelector(SELECTOR);
}


//# sourceMappingURL=utilities.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@dnd-kit/accessibility/dist/accessibility.esm.js


const hiddenStyles = {
  display: 'none'
};
function HiddenText(_ref) {
  let {
    id,
    value
  } = _ref;
  return react.createElement("div", {
    id: id,
    style: hiddenStyles
  }, value);
}

function LiveRegion(_ref) {
  let {
    id,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  // Hide element visually but keep it readable by screen readers
  const visuallyHidden = {
    position: 'fixed',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(100%)',
    whiteSpace: 'nowrap'
  };
  return react.createElement("div", {
    id: id,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}

function useAnnouncement() {
  const [announcement, setAnnouncement] = (0,react.useState)('');
  const announce = (0,react.useCallback)(value => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}


//# sourceMappingURL=accessibility.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@dnd-kit/core/dist/core.esm.js





const DndMonitorContext = /*#__PURE__*/(0,react.createContext)(null);

function useDndMonitor(listener) {
  const registerListener = (0,react.useContext)(DndMonitorContext);
  (0,react.useEffect)(() => {
    if (!registerListener) {
      throw new Error('useDndMonitor must be used within a children of <DndContext>');
    }

    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}

function useDndMonitorProvider() {
  const [listeners] = (0,react.useState)(() => new Set());
  const registerListener = (0,react.useCallback)(listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch = (0,react.useCallback)(_ref => {
    let {
      type,
      event
    } = _ref;
    listeners.forEach(listener => {
      var _listener$type;

      return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch, registerListener];
}

const defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active
    } = _ref;
    return "Picked up draggable item " + active.id + ".";
  },

  onDragOver(_ref2) {
    let {
      active,
      over
    } = _ref2;

    if (over) {
      return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
    }

    return "Draggable item " + active.id + " is no longer over a droppable area.";
  },

  onDragEnd(_ref3) {
    let {
      active,
      over
    } = _ref3;

    if (over) {
      return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
    }

    return "Draggable item " + active.id + " was dropped.";
  },

  onDragCancel(_ref4) {
    let {
      active
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
  }

};

function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setMounted(true);
  }, []);
  useDndMonitor((0,react.useMemo)(() => ({
    onDragStart(_ref2) {
      let {
        active
      } = _ref2;
      announce(announcements.onDragStart({
        active
      }));
    },

    onDragMove(_ref3) {
      let {
        active,
        over
      } = _ref3;

      if (announcements.onDragMove) {
        announce(announcements.onDragMove({
          active,
          over
        }));
      }
    },

    onDragOver(_ref4) {
      let {
        active,
        over
      } = _ref4;
      announce(announcements.onDragOver({
        active,
        over
      }));
    },

    onDragEnd(_ref5) {
      let {
        active,
        over
      } = _ref5;
      announce(announcements.onDragEnd({
        active,
        over
      }));
    },

    onDragCancel(_ref6) {
      let {
        active,
        over
      } = _ref6;
      announce(announcements.onDragCancel({
        active,
        over
      }));
    }

  }), [announce, announcements]));

  if (!mounted) {
    return null;
  }

  const markup = react.createElement(react.Fragment, null, react.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), react.createElement(LiveRegion, {
    id: liveRegionId,
    announcement: announcement
  }));
  return container ? (0,react_dom.createPortal)(markup, container) : markup;
}

var Action;

(function (Action) {
  Action["DragStart"] = "dragStart";
  Action["DragMove"] = "dragMove";
  Action["DragEnd"] = "dragEnd";
  Action["DragCancel"] = "dragCancel";
  Action["DragOver"] = "dragOver";
  Action["RegisterDroppable"] = "registerDroppable";
  Action["SetDroppableDisabled"] = "setDroppableDisabled";
  Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));

function core_esm_noop() {}

function useSensor(sensor, options) {
  return (0,react.useMemo)(() => ({
    sensor,
    options: options != null ? options : {}
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [sensor, options]);
}

function useSensors() {
  for (var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++) {
    sensors[_key] = arguments[_key];
  }

  return (0,react.useMemo)(() => [...sensors].filter(sensor => sensor != null), // eslint-disable-next-line react-hooks/exhaustive-deps
  [...sensors]);
}

const defaultCoordinates = /*#__PURE__*/Object.freeze({
  x: 0,
  y: 0
});

/**
 * Returns the distance between two points
 */
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}

function getRelativeTransformOrigin(event, rect) {
  const eventCoordinates = getEventCoordinates(event);

  if (!eventCoordinates) {
    return '0 0';
  }

  const transformOrigin = {
    x: (eventCoordinates.x - rect.left) / rect.width * 100,
    y: (eventCoordinates.y - rect.top) / rect.height * 100
  };
  return transformOrigin.x + "% " + transformOrigin.y + "%";
}

/**
 * Sort collisions from smallest to greatest value
 */
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a
    }
  } = _ref;
  let {
    data: {
      value: b
    }
  } = _ref2;
  return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */

function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a
    }
  } = _ref3;
  let {
    data: {
      value: b
    }
  } = _ref4;
  return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */

function cornersOfRectangle(_ref5) {
  let {
    left,
    top,
    height,
    width
  } = _ref5;
  return [{
    x: left,
    y: top
  }, {
    x: left + width,
    y: top
  }, {
    x: left,
    y: top + height
  }, {
    x: left + width,
    y: top + height
  }];
}
function getFirstCollision(collisions, property) {
  if (!collisions || collisions.length === 0) {
    return null;
  }

  const [firstCollision] = collisions;
  return property ? firstCollision[property] : firstCollision;
}

/**
 * Returns the coordinates of the center of a given ClientRect
 */

function centerOfRectangle(rect, left, top) {
  if (left === void 0) {
    left = rect.left;
  }

  if (top === void 0) {
    top = rect.top;
  }

  return {
    x: left + rect.width * 0.5,
    y: top + rect.height * 0.5
  };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */


const closestCenter = _ref => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: distBetween
        }
      });
    }
  }

  return collisions.sort(sortCollisionsAsc);
};

/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */

const closestCorners = _ref => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const corners = cornersOfRectangle(collisionRect);
  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const rectCorners = cornersOfRectangle(rect);
      const distances = corners.reduce((accumulator, corner, index) => {
        return accumulator + distanceBetween(rectCorners[index], corner);
      }, 0);
      const effectiveDistance = Number((distances / 4).toFixed(4));
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: effectiveDistance
        }
      });
    }
  }

  return collisions.sort(sortCollisionsAsc);
};

/**
 * Returns the intersecting rectangle area between two rectangles
 */

function getIntersectionRatio(entry, target) {
  const top = Math.max(target.top, entry.top);
  const left = Math.max(target.left, entry.left);
  const right = Math.min(target.left + target.width, entry.left + entry.width);
  const bottom = Math.min(target.top + target.height, entry.top + entry.height);
  const width = right - left;
  const height = bottom - top;

  if (left < right && top < bottom) {
    const targetArea = target.width * target.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width * height;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)


  return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */

const rectIntersection = _ref => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const intersectionRatio = getIntersectionRatio(rect, collisionRect);

      if (intersectionRatio > 0) {
        collisions.push({
          id,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }

  return collisions.sort(sortCollisionsDesc);
};

/**
 * Check if a given point is contained within a bounding rectangle
 */

function isPointWithinRect(point, rect) {
  const {
    top,
    left,
    bottom,
    right
  } = rect;
  return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */


const pointerWithin = _ref => {
  let {
    droppableContainers,
    droppableRects,
    pointerCoordinates
  } = _ref;

  if (!pointerCoordinates) {
    return [];
  }

  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect && isPointWithinRect(pointerCoordinates, rect)) {
      /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */
      const corners = cornersOfRectangle(rect);
      const distances = corners.reduce((accumulator, corner) => {
        return accumulator + distanceBetween(pointerCoordinates, corner);
      }, 0);
      const effectiveDistance = Number((distances / 4).toFixed(4));
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: effectiveDistance
        }
      });
    }
  }

  return collisions.sort(sortCollisionsAsc);
};

function adjustScale(transform, rect1, rect2) {
  return { ...transform,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}

function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}

function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }

    return adjustments.reduce((acc, adjustment) => ({ ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), { ...rect
    });
  };
}
const getAdjustedRect = /*#__PURE__*/createRectAdjustmentFn(1);

function parseTransform(transform) {
  if (transform.startsWith('matrix3d(')) {
    const transformArray = transform.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform.startsWith('matrix(')) {
    const transformArray = transform.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }

  return null;
}

function inverseTransform(rect, transform, transformOrigin) {
  const parsedTransform = parseTransform(transform);

  if (!parsedTransform) {
    return rect;
  }

  const {
    scaleX,
    scaleY,
    x: translateX,
    y: translateY
  } = parsedTransform;
  const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
  const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
  const w = scaleX ? rect.width / scaleX : rect.width;
  const h = scaleY ? rect.height / scaleY : rect.height;
  return {
    width: w,
    height: h,
    top: y,
    right: x + w,
    bottom: y + h,
    left: x
  };
}

const core_esm_defaultOptions = {
  ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */

function getClientRect(element, options) {
  if (options === void 0) {
    options = core_esm_defaultOptions;
  }

  let rect = element.getBoundingClientRect();

  if (options.ignoreTransform) {
    const {
      transform,
      transformOrigin
    } = getWindow(element).getComputedStyle(element);

    if (transform) {
      rect = inverseTransform(rect, transform, transformOrigin);
    }
  }

  const {
    top,
    left,
    width,
    height,
    bottom,
    right
  } = rect;
  return {
    top,
    left,
    width,
    height,
    bottom,
    right
  };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */

function getTransformAgnosticClientRect(element) {
  return getClientRect(element, {
    ignoreTransform: true
  });
}

function getWindowClientRect(element) {
  const width = element.innerWidth;
  const height = element.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width,
    bottom: height,
    width,
    height
  };
}

function isFixed(node, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(node).getComputedStyle(node);
  }

  return computedStyle.position === 'fixed';
}

function isScrollable(element, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(element).getComputedStyle(element);
  }

  const overflowRegex = /(auto|scroll|overlay)/;
  const properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.some(property => {
    const value = computedStyle[property];
    return typeof value === 'string' ? overflowRegex.test(value) : false;
  });
}

function getScrollableAncestors(element, limit) {
  const scrollParents = [];

  function findScrollableAncestors(node) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }

    if (!node) {
      return scrollParents;
    }

    if (isDocument(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
      scrollParents.push(node.scrollingElement);
      return scrollParents;
    }

    if (!isHTMLElement(node) || isSVGElement(node)) {
      return scrollParents;
    }

    if (scrollParents.includes(node)) {
      return scrollParents;
    }

    const computedStyle = getWindow(element).getComputedStyle(node);

    if (node !== element) {
      if (isScrollable(node, computedStyle)) {
        scrollParents.push(node);
      }
    }

    if (isFixed(node, computedStyle)) {
      return scrollParents;
    }

    return findScrollableAncestors(node.parentNode);
  }

  if (!element) {
    return scrollParents;
  }

  return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
  const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}

function getScrollableElement(element) {
  if (!canUseDOM || !element) {
    return null;
  }

  if (isWindow(element)) {
    return element;
  }

  if (!isNode(element)) {
    return null;
  }

  if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) {
    return window;
  }

  if (isHTMLElement(element)) {
    return element;
  }

  return null;
}

function getScrollXCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollX;
  }

  return element.scrollLeft;
}
function getScrollYCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollY;
  }

  return element.scrollTop;
}
function getScrollCoordinates(element) {
  return {
    x: getScrollXCoordinate(element),
    y: getScrollYCoordinate(element)
  };
}

var Direction;

(function (Direction) {
  Direction[Direction["Forward"] = 1] = "Forward";
  Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));

function isDocumentScrollingElement(element) {
  if (!canUseDOM || !element) {
    return false;
  }

  return element === document.scrollingElement;
}

function getScrollPosition(scrollingContainer) {
  const minScroll = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll
  };
}

const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top,
    left,
    right,
    bottom
  } = _ref;

  if (acceleration === void 0) {
    acceleration = 10;
  }

  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }

  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };

  if (!isTop && top <= scrollContainerRect.top + threshold.height) {
    // Scroll Up
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
  } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
    // Scroll Down
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
  }

  if (!isRight && right >= scrollContainerRect.right - threshold.width) {
    // Scroll Right
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
  } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
    // Scroll Left
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
  }

  return {
    direction,
    speed
  };
}

function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    const {
      innerWidth,
      innerHeight
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight,
      width: innerWidth,
      height: innerHeight
    };
  }

  const {
    top,
    left,
    right,
    bottom
  } = element.getBoundingClientRect();
  return {
    top,
    left,
    right,
    bottom,
    width: element.clientWidth,
    height: element.clientHeight
  };
}

function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return add(acc, getScrollCoordinates(node));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollXCoordinate(node);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollYCoordinate(node);
  }, 0);
}

function scrollIntoViewIfNeeded(element, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }

  if (!element) {
    return;
  }

  const {
    top,
    left,
    bottom,
    right
  } = measure(element);
  const firstScrollableAncestor = getFirstScrollableAncestor(element);

  if (!firstScrollableAncestor) {
    return;
  }

  if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) {
    element.scrollIntoView({
      block: 'center',
      inline: 'center'
    });
  }
}

const properties = [['x', ['left', 'right'], getScrollXOffset], ['y', ['top', 'bottom'], getScrollYOffset]];
class Rect {
  constructor(rect, element) {
    this.rect = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.right = void 0;
    this.left = void 0;
    const scrollableAncestors = getScrollableAncestors(element);
    const scrollOffsets = getScrollOffsets(scrollableAncestors);
    this.rect = { ...rect
    };
    this.width = rect.width;
    this.height = rect.height;

    for (const [axis, keys, getScrollOffset] of properties) {
      for (const key of keys) {
        Object.defineProperty(this, key, {
          get: () => {
            const currentOffsets = getScrollOffset(scrollableAncestors);
            const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
            return this.rect[key] + scrollOffsetsDeltla;
          },
          enumerable: true
        });
      }
    }

    Object.defineProperty(this, 'rect', {
      enumerable: false
    });
  }

}

class Listeners {
  constructor(target) {
    this.target = void 0;
    this.listeners = [];

    this.removeAll = () => {
      this.listeners.forEach(listener => {
        var _this$target;

        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };

    this.target = target;
  }

  add(eventName, handler, options) {
    var _this$target2;

    (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options);
    this.listeners.push([eventName, handler, options]);
  }

}

function getEventListenerTarget(target) {
  // If the `event.target` element is removed from the document events will still be targeted
  // at it, and hence won't always bubble up to the window or document anymore.
  // If there is any risk of an element being removed while it is being dragged,
  // the best practice is to attach the event listeners directly to the target.
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
  const {
    EventTarget
  } = getWindow(target);
  return target instanceof EventTarget ? target : getOwnerDocument(target);
}

function hasExceededDistance(delta, measurement) {
  const dx = Math.abs(delta.x);
  const dy = Math.abs(delta.y);

  if (typeof measurement === 'number') {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }

  if ('x' in measurement && 'y' in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }

  if ('x' in measurement) {
    return dx > measurement.x;
  }

  if ('y' in measurement) {
    return dy > measurement.y;
  }

  return false;
}

var EventName;

(function (EventName) {
  EventName["Click"] = "click";
  EventName["DragStart"] = "dragstart";
  EventName["Keydown"] = "keydown";
  EventName["ContextMenu"] = "contextmenu";
  EventName["Resize"] = "resize";
  EventName["SelectionChange"] = "selectionchange";
  EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));

function preventDefault(event) {
  event.preventDefault();
}
function core_esm_stopPropagation(event) {
  event.stopPropagation();
}

var KeyboardCode;

(function (KeyboardCode) {
  KeyboardCode["Space"] = "Space";
  KeyboardCode["Down"] = "ArrowDown";
  KeyboardCode["Right"] = "ArrowRight";
  KeyboardCode["Left"] = "ArrowLeft";
  KeyboardCode["Up"] = "ArrowUp";
  KeyboardCode["Esc"] = "Escape";
  KeyboardCode["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));

const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
};
const defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;

  switch (event.code) {
    case KeyboardCode.Right:
      return { ...currentCoordinates,
        x: currentCoordinates.x + 25
      };

    case KeyboardCode.Left:
      return { ...currentCoordinates,
        x: currentCoordinates.x - 25
      };

    case KeyboardCode.Down:
      return { ...currentCoordinates,
        y: currentCoordinates.y + 25
      };

    case KeyboardCode.Up:
      return { ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }

  return undefined;
};

class KeyboardSensor {
  constructor(props) {
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }

  attach() {
    this.handleStart();
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }

  handleStart() {
    const {
      activeNode,
      onStart
    } = this.props;
    const node = activeNode.node.current;

    if (node) {
      scrollIntoViewIfNeeded(node);
    }

    onStart(defaultCoordinates);
  }

  handleKeyDown(event) {
    if (isKeyboardEvent(event)) {
      const {
        active,
        context,
        options
      } = this.props;
      const {
        keyboardCodes = defaultKeyboardCodes,
        coordinateGetter = defaultKeyboardCoordinateGetter,
        scrollBehavior = 'smooth'
      } = options;
      const {
        code
      } = event;

      if (keyboardCodes.end.includes(code)) {
        this.handleEnd(event);
        return;
      }

      if (keyboardCodes.cancel.includes(code)) {
        this.handleCancel(event);
        return;
      }

      const {
        collisionRect
      } = context.current;
      const currentCoordinates = collisionRect ? {
        x: collisionRect.left,
        y: collisionRect.top
      } : defaultCoordinates;

      if (!this.referenceCoordinates) {
        this.referenceCoordinates = currentCoordinates;
      }

      const newCoordinates = coordinateGetter(event, {
        active,
        context: context.current,
        currentCoordinates
      });

      if (newCoordinates) {
        const coordinatesDelta = subtract(newCoordinates, currentCoordinates);
        const scrollDelta = {
          x: 0,
          y: 0
        };
        const {
          scrollableAncestors
        } = context.current;

        for (const scrollContainer of scrollableAncestors) {
          const direction = event.code;
          const {
            isTop,
            isRight,
            isLeft,
            isBottom,
            maxScroll,
            minScroll
          } = getScrollPosition(scrollContainer);
          const scrollElementRect = getScrollElementRect(scrollContainer);
          const clampedCoordinates = {
            x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
            y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
          };
          const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
          const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;

          if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
            const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
            const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;

            if (canScrollToNewCoordinates && !coordinatesDelta.y) {
              // We don't need to update coordinates, the scroll adjustment alone will trigger
              // logic to auto-detect the new container we are over
              scrollContainer.scrollTo({
                left: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }

            if (canScrollToNewCoordinates) {
              scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
            } else {
              scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
            }

            if (scrollDelta.x) {
              scrollContainer.scrollBy({
                left: -scrollDelta.x,
                behavior: scrollBehavior
              });
            }

            break;
          } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;

            if (canScrollToNewCoordinates && !coordinatesDelta.x) {
              // We don't need to update coordinates, the scroll adjustment alone will trigger
              // logic to auto-detect the new container we are over
              scrollContainer.scrollTo({
                top: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }

            if (canScrollToNewCoordinates) {
              scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
            } else {
              scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
            }

            if (scrollDelta.y) {
              scrollContainer.scrollBy({
                top: -scrollDelta.y,
                behavior: scrollBehavior
              });
            }

            break;
          }
        }

        this.handleMove(event, add(subtract(newCoordinates, this.referenceCoordinates), scrollDelta));
      }
    }
  }

  handleMove(event, coordinates) {
    const {
      onMove
    } = this.props;
    event.preventDefault();
    onMove(coordinates);
  }

  handleEnd(event) {
    const {
      onEnd
    } = this.props;
    event.preventDefault();
    this.detach();
    onEnd();
  }

  handleCancel(event) {
    const {
      onCancel
    } = this.props;
    event.preventDefault();
    this.detach();
    onCancel();
  }

  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
  }

}
KeyboardSensor.activators = [{
  eventName: 'onKeyDown',
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active
    } = _ref2;
    const {
      code
    } = event.nativeEvent;

    if (keyboardCodes.start.includes(code)) {
      const activator = active.activatorNode.current;

      if (activator && event.target !== activator) {
        return false;
      }

      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }

    return false;
  }
}];

function isDistanceConstraint(constraint) {
  return Boolean(constraint && 'distance' in constraint);
}

function isDelayConstraint(constraint) {
  return Boolean(constraint && 'delay' in constraint);
}

class AbstractPointerSensor {
  constructor(props, events, listenerTarget) {
    var _getEventCoordinates;

    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }

    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events;
    const {
      event
    } = props;
    const {
      target
    } = event;
    this.props = props;
    this.events = events;
    this.document = getOwnerDocument(target);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow(target));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }

  attach() {
    const {
      events,
      props: {
        options: {
          activationConstraint,
          bypassActivationConstraint
        }
      }
    } = this;
    this.listeners.add(events.move.name, this.handleMove, {
      passive: false
    });
    this.listeners.add(events.end.name, this.handleEnd);
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.DragStart, preventDefault);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    this.windowListeners.add(EventName.ContextMenu, preventDefault);
    this.documentListeners.add(EventName.Keydown, this.handleKeydown);

    if (activationConstraint) {
      if (bypassActivationConstraint != null && bypassActivationConstraint({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      })) {
        return this.handleStart();
      }

      if (isDelayConstraint(activationConstraint)) {
        this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
        return;
      }

      if (isDistanceConstraint(activationConstraint)) {
        return;
      }
    }

    this.handleStart();
  }

  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
    // This is necessary because we listen for `click` and `selection` events on the document

    setTimeout(this.documentListeners.removeAll, 50);

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  handleStart() {
    const {
      initialCoordinates
    } = this;
    const {
      onStart
    } = this.props;

    if (initialCoordinates) {
      this.activated = true; // Stop propagation of click events once activation constraints are met

      this.documentListeners.add(EventName.Click, core_esm_stopPropagation, {
        capture: true
      }); // Remove any text selection from the document

      this.removeTextSelection(); // Prevent further text selection while dragging

      this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
      onStart(initialCoordinates);
    }
  }

  handleMove(event) {
    var _getEventCoordinates2;

    const {
      activated,
      initialCoordinates,
      props
    } = this;
    const {
      onMove,
      options: {
        activationConstraint
      }
    } = props;

    if (!initialCoordinates) {
      return;
    }

    const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
    const delta = subtract(initialCoordinates, coordinates); // Constraint validation

    if (!activated && activationConstraint) {
      if (isDistanceConstraint(activationConstraint)) {
        if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }

        if (hasExceededDistance(delta, activationConstraint.distance)) {
          return this.handleStart();
        }
      }

      if (isDelayConstraint(activationConstraint)) {
        if (hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
      }

      return;
    }

    if (event.cancelable) {
      event.preventDefault();
    }

    onMove(coordinates);
  }

  handleEnd() {
    const {
      onEnd
    } = this.props;
    this.detach();
    onEnd();
  }

  handleCancel() {
    const {
      onCancel
    } = this.props;
    this.detach();
    onCancel();
  }

  handleKeydown(event) {
    if (event.code === KeyboardCode.Esc) {
      this.handleCancel();
    }
  }

  removeTextSelection() {
    var _this$document$getSel;

    (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
  }

}

const events = {
  move: {
    name: 'pointermove'
  },
  end: {
    name: 'pointerup'
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(props) {
    const {
      event
    } = props; // Pointer events stop firing if the target is unmounted while dragging
    // Therefore we attach listeners to the owner document instead

    const listenerTarget = getOwnerDocument(event.target);
    super(props, events, listenerTarget);
  }

}
PointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;

    if (!event.isPrimary || event.button !== 0) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

const events$1 = {
  move: {
    name: 'mousemove'
  },
  end: {
    name: 'mouseup'
  }
};
var MouseButton;

(function (MouseButton) {
  MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));

class MouseSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$1, getOwnerDocument(props.event.target));
  }

}
MouseSensor.activators = [{
  eventName: 'onMouseDown',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;

    if (event.button === MouseButton.RightClick) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

const events$2 = {
  move: {
    name: 'touchmove'
  },
  end: {
    name: 'touchend'
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$2);
  }

  static setup() {
    // Adding a non-capture and non-passive `touchmove` listener in order
    // to force `event.preventDefault()` calls to work in dynamically added
    // touchmove event handlers. This is required for iOS Safari.
    window.addEventListener(events$2.move.name, noop, {
      capture: false,
      passive: false
    });
    return function teardown() {
      window.removeEventListener(events$2.move.name, noop);
    }; // We create a new handler because the teardown function of another sensor
    // could remove our event listener if we use a referentially equal listener.

    function noop() {}
  }

}
TouchSensor.activators = [{
  eventName: 'onTouchStart',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;

    if (touches.length > 1) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

var AutoScrollActivator;

(function (AutoScrollActivator) {
  AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
  AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));

var TraversalOrder;

(function (TraversalOrder) {
  TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));

function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval = 5,
    order = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta,
    threshold
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = (0,react.useRef)({
    x: 0,
    y: 0
  });
  const scrollDirection = (0,react.useRef)({
    x: 0,
    y: 0
  });
  const rect = (0,react.useMemo)(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;

      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = (0,react.useRef)(null);
  const autoScroll = (0,react.useCallback)(() => {
    const scrollContainer = scrollContainerRef.current;

    if (!scrollContainer) {
      return;
    }

    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = (0,react.useMemo)(() => order === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order, scrollableAncestors]);
  (0,react.useEffect)(() => {
    if (!enabled || !scrollableAncestors.length || !rect) {
      clearAutoScrollInterval();
      return;
    }

    for (const scrollContainer of sortedScrollableAncestors) {
      if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
        continue;
      }

      const index = scrollableAncestors.indexOf(scrollContainer);
      const scrollContainerRect = scrollableAncestorRects[index];

      if (!scrollContainerRect) {
        continue;
      }

      const {
        direction,
        speed
      } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);

      for (const axis of ['x', 'y']) {
        if (!scrollIntent[axis][direction[axis]]) {
          speed[axis] = 0;
          direction[axis] = 0;
        }
      }

      if (speed.x > 0 || speed.y > 0) {
        clearAutoScrollInterval();
        scrollContainerRef.current = scrollContainer;
        setAutoScrollInterval(autoScroll, interval);
        scrollSpeed.current = speed;
        scrollDirection.current = direction;
        return;
      }
    }

    scrollSpeed.current = {
      x: 0,
      y: 0
    };
    scrollDirection.current = {
      x: 0,
      y: 0
    };
    clearAutoScrollInterval();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [acceleration, autoScroll, canScroll, clearAutoScrollInterval, enabled, interval, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(rect), // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(scrollIntent), setAutoScrollInterval, scrollableAncestors, sortedScrollableAncestors, scrollableAncestorRects, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(threshold)]);
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};

function useScrollIntent(_ref2) {
  let {
    delta,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta);
  return useLazyMemo(previousIntent => {
    if (disabled || !previousDelta || !previousIntent) {
      // Reset scroll intent tracking when auto-scrolling is disabled
      return defaultScrollIntent;
    }

    const direction = {
      x: Math.sign(delta.x - previousDelta.x),
      y: Math.sign(delta.y - previousDelta.y)
    }; // Keep track of the user intent to scroll in each direction for both axis

    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta, previousDelta]);
}

function useCachedNode(draggableNodes, id) {
  const draggableNode = id !== null ? draggableNodes.get(id) : undefined;
  const node = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo(cachedNode => {
    var _ref;

    if (id === null) {
      return null;
    } // In some cases, the draggable node can unmount while dragging
    // This is the case for virtualized lists. In those situations,
    // we fall back to the last known value for that node.


    return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
  }, [node, id]);
}

function useCombineActivators(sensors, getSyntheticHandler) {
  return (0,react.useMemo)(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map(activator => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}

var MeasuringStrategy;

(function (MeasuringStrategy) {
  MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
  MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));

var MeasuringFrequency;

(function (MeasuringFrequency) {
  MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));

const defaultValue = /*#__PURE__*/new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies,
    config
  } = _ref;
  const [queue, setQueue] = (0,react.useState)(null);
  const {
    frequency,
    measure,
    strategy
  } = config;
  const containersRef = (0,react.useRef)(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = (0,react.useCallback)(function (ids) {
    if (ids === void 0) {
      ids = [];
    }

    if (disabledRef.current) {
      return;
    }

    setQueue(value => {
      if (value === null) {
        return ids;
      }

      return value.concat(ids.filter(id => !value.includes(id)));
    });
  }, [disabledRef]);
  const timeoutId = (0,react.useRef)(null);
  const droppableRects = useLazyMemo(previousValue => {
    if (disabled && !dragging) {
      return defaultValue;
    }

    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
      const map = new Map();

      for (let container of containers) {
        if (!container) {
          continue;
        }

        if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
          // This container does not need to be re-measured
          map.set(container.id, container.rect.current);
          continue;
        }

        const node = container.node.current;
        const rect = node ? new Rect(measure(node), node) : null;
        container.rect.current = rect;

        if (rect) {
          map.set(container.id, rect);
        }
      }

      return map;
    }

    return previousValue;
  }, [containers, queue, dragging, disabled, measure]);
  (0,react.useEffect)(() => {
    containersRef.current = containers;
  }, [containers]);
  (0,react.useEffect)(() => {
    if (disabled) {
      return;
    }

    measureDroppableContainers();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [dragging, disabled]);
  (0,react.useEffect)(() => {
    if (queue && queue.length > 0) {
      setQueue(null);
    }
  }, //eslint-disable-next-line react-hooks/exhaustive-deps
  [JSON.stringify(queue)]);
  (0,react.useEffect)(() => {
    if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) {
      return;
    }

    timeoutId.current = setTimeout(() => {
      measureDroppableContainers();
      timeoutId.current = null;
    }, frequency);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [frequency, disabled, measureDroppableContainers, ...dependencies]);
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue != null
  };

  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;

      case MeasuringStrategy.BeforeDragging:
        return dragging;

      default:
        return !dragging;
    }
  }
}

function useInitialValue(value, computeFn) {
  return useLazyMemo(previousValue => {
    if (!value) {
      return null;
    }

    if (previousValue) {
      return previousValue;
    }

    return typeof computeFn === 'function' ? computeFn(value) : value;
  }, [computeFn, value]);
}

function useInitialRect(node, measure) {
  return useInitialValue(node, measure);
}

/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */

function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = (0,react.useMemo)(() => {
    if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') {
      return undefined;
    }

    const {
      MutationObserver
    } = window;
    return new MutationObserver(handleMutations);
  }, [handleMutations, disabled]);
  (0,react.useEffect)(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}

/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */

function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver = (0,react.useMemo)(() => {
    if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') {
      return undefined;
    }

    const {
      ResizeObserver
    } = window;
    return new ResizeObserver(handleResize);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled]);
  (0,react.useEffect)(() => {
    return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
  }, [resizeObserver]);
  return resizeObserver;
}

function defaultMeasure(element) {
  return new Rect(getClientRect(element), element);
}

function useRect(element, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }

  const [rect, measureRect] = (0,react.useReducer)(reducer, null);
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element) {
        return;
      }

      for (const record of records) {
        const {
          type,
          target
        } = record;

        if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
          measureRect();
          break;
        }
      }
    }

  });
  const resizeObserver = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect(() => {
    measureRect();

    if (element) {
      resizeObserver == null ? void 0 : resizeObserver.observe(element);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element]);
  return rect;

  function reducer(currentRect) {
    if (!element) {
      return null;
    }

    if (element.isConnected === false) {
      var _ref;

      // Fall back to last rect we measured if the element is
      // no longer connected to the DOM.
      return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
    }

    const newRect = measure(element);

    if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
      return currentRect;
    }

    return newRect;
  }
}

function useRectDelta(rect) {
  const initialRect = useInitialValue(rect);
  return getRectDelta(rect, initialRect);
}

const defaultValue$1 = [];
function useScrollableAncestors(node) {
  const previousNode = (0,react.useRef)(node);
  const ancestors = useLazyMemo(previousValue => {
    if (!node) {
      return defaultValue$1;
    }

    if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }

    return getScrollableAncestors(node);
  }, [node]);
  (0,react.useEffect)(() => {
    previousNode.current = node;
  }, [node]);
  return ancestors;
}

function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = (0,react.useState)(null);
  const prevElements = (0,react.useRef)(elements); // To-do: Throttle the handleScroll callback

  const handleScroll = (0,react.useCallback)(event => {
    const scrollingElement = getScrollableElement(event.target);

    if (!scrollingElement) {
      return;
    }

    setScrollCoordinates(scrollCoordinates => {
      if (!scrollCoordinates) {
        return null;
      }

      scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates);
    });
  }, []);
  (0,react.useEffect)(() => {
    const previousElements = prevElements.current;

    if (elements !== previousElements) {
      cleanup(previousElements);
      const entries = elements.map(element => {
        const scrollableElement = getScrollableElement(element);

        if (scrollableElement) {
          scrollableElement.addEventListener('scroll', handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }

        return null;
      }).filter(entry => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }

    return () => {
      cleanup(elements);
      cleanup(previousElements);
    };

    function cleanup(elements) {
      elements.forEach(element => {
        const scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener('scroll', handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return (0,react.useMemo)(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
    }

    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}

function useScrollOffsetsDelta(scrollOffsets, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  const initialScrollOffsets = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    initialScrollOffsets.current = null;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  dependencies);
  (0,react.useEffect)(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;

    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }

    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}

function useSensorSetup(sensors) {
  (0,react.useEffect)(() => {
    if (!canUseDOM) {
      return;
    }

    const teardownFns = sensors.map(_ref => {
      let {
        sensor
      } = _ref;
      return sensor.setup == null ? void 0 : sensor.setup();
    });
    return () => {
      for (const teardown of teardownFns) {
        teardown == null ? void 0 : teardown();
      }
    };
  }, // TO-DO: Sensors length could theoretically change which would not be a valid dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  sensors.map(_ref2 => {
    let {
      sensor
    } = _ref2;
    return sensor;
  }));
}

function useSyntheticListeners(listeners, id) {
  return (0,react.useMemo)(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;

      acc[eventName] = event => {
        handler(event, id);
      };

      return acc;
    }, {});
  }, [listeners, id]);
}

function useWindowRect(element) {
  return (0,react.useMemo)(() => element ? getWindowClientRect(element) : null, [element]);
}

const defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }

  const [firstElement] = elements;
  const windowRect = useWindowRect(firstElement ? getWindow(firstElement) : null);
  const [rects, measureRects] = (0,react.useReducer)(reducer, defaultValue$2);
  const resizeObserver = useResizeObserver({
    callback: measureRects
  });

  if (elements.length > 0 && rects === defaultValue$2) {
    measureRects();
  }

  useIsomorphicLayoutEffect(() => {
    if (elements.length) {
      elements.forEach(element => resizeObserver == null ? void 0 : resizeObserver.observe(element));
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      measureRects();
    }
  }, [elements]);
  return rects;

  function reducer() {
    if (!elements.length) {
      return defaultValue$2;
    }

    return elements.map(element => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
  }
}

function getMeasurableNode(node) {
  if (!node) {
    return null;
  }

  if (node.children.length > 1) {
    return node;
  }

  const firstChild = node.children[0];
  return isHTMLElement(firstChild) ? firstChild : node;
}

function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect, setRect] = (0,react.useState)(null);
  const handleResize = (0,react.useCallback)(entries => {
    for (const {
      target
    } of entries) {
      if (isHTMLElement(target)) {
        setRect(rect => {
          const newRect = measure(target);
          return rect ? { ...rect,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = (0,react.useCallback)(element => {
    const node = getMeasurableNode(element);
    resizeObserver == null ? void 0 : resizeObserver.disconnect();

    if (node) {
      resizeObserver == null ? void 0 : resizeObserver.observe(node);
    }

    setRect(node ? measure(node) : null);
  }, [measure, resizeObserver]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return (0,react.useMemo)(() => ({
    nodeRef,
    rect,
    setRef
  }), [rect, nodeRef, setRef]);
}

const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
const defaultData = {
  current: {}
};
const defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect
  }
};

class DroppableContainersMap extends Map {
  get(id) {
    var _super$get;

    return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
  }

  toArray() {
    return Array.from(this.values());
  }

  getEnabled() {
    return this.toArray().filter(_ref => {
      let {
        disabled
      } = _ref;
      return !disabled;
    });
  }

  getNodeFor(id) {
    var _this$get$node$curren, _this$get;

    return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
  }

}

const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /*#__PURE__*/new Map(),
  droppableRects: /*#__PURE__*/new Map(),
  droppableContainers: /*#__PURE__*/new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: core_esm_noop
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: core_esm_noop,
  windowRect: null,
  measuringScheduled: false
};
const defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ''
  },
  dispatch: core_esm_noop,
  draggableNodes: /*#__PURE__*/new Map(),
  over: null,
  measureDroppableContainers: core_esm_noop
};
const InternalContext = /*#__PURE__*/(0,react.createContext)(defaultInternalContext);
const PublicContext = /*#__PURE__*/(0,react.createContext)(defaultPublicContext);

function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return { ...state,
        draggable: { ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };

    case Action.DragMove:
      if (!state.draggable.active) {
        return state;
      }

      return { ...state,
        draggable: { ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };

    case Action.DragEnd:
    case Action.DragCancel:
      return { ...state,
        draggable: { ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };

    case Action.RegisterDroppable:
      {
        const {
          element
        } = action;
        const {
          id
        } = element;
        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.set(id, element);
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    case Action.SetDroppableDisabled:
      {
        const {
          id,
          key,
          disabled
        } = action;
        const element = state.droppable.containers.get(id);

        if (!element || key !== element.key) {
          return state;
        }

        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.set(id, { ...element,
          disabled
        });
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    case Action.UnregisterDroppable:
      {
        const {
          id,
          key
        } = action;
        const element = state.droppable.containers.get(id);

        if (!element || key !== element.key) {
          return state;
        }

        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.delete(id);
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    default:
      {
        return state;
      }
  }
}

function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active,
    activatorEvent,
    draggableNodes
  } = (0,react.useContext)(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node

  (0,react.useEffect)(() => {
    if (disabled) {
      return;
    }

    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }

      if (document.activeElement === previousActivatorEvent.target) {
        // No need to restore focus
        return;
      }

      const draggableNode = draggableNodes.get(previousActiveId);

      if (!draggableNode) {
        return;
      }

      const {
        activatorNode,
        node
      } = draggableNode;

      if (!activatorNode.current && !node.current) {
        return;
      }

      requestAnimationFrame(() => {
        for (const element of [activatorNode.current, node.current]) {
          if (!element) {
            continue;
          }

          const focusableNode = findFirstFocusableNode(element);

          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}

function applyModifiers(modifiers, _ref) {
  let {
    transform,
    ...args
  } = _ref;
  return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform) : transform;
}

function useMeasuringConfiguration(config) {
  return (0,react.useMemo)(() => ({
    draggable: { ...defaultMeasuringConfiguration.draggable,
      ...(config == null ? void 0 : config.draggable)
    },
    droppable: { ...defaultMeasuringConfiguration.droppable,
      ...(config == null ? void 0 : config.droppable)
    },
    dragOverlay: { ...defaultMeasuringConfiguration.dragOverlay,
      ...(config == null ? void 0 : config.dragOverlay)
    }
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [config == null ? void 0 : config.draggable, config == null ? void 0 : config.droppable, config == null ? void 0 : config.dragOverlay]);
}

function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config = true
  } = _ref;
  const initialized = (0,react.useRef)(false);
  const {
    x,
    y
  } = typeof config === 'boolean' ? {
    x: config,
    y: config
  } : config;
  useIsomorphicLayoutEffect(() => {
    const disabled = !x && !y;

    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }

    if (initialized.current || !initialRect) {
      // Return early if layout shift scroll compensation was already attempted
      // or if there is no initialRect to compare to.
      return;
    } // Get the most up to date node ref for the active draggable


    const node = activeNode == null ? void 0 : activeNode.node.current;

    if (!node || node.isConnected === false) {
      // Return early if there is no attached node ref or if the node is
      // disconnected from the document.
      return;
    }

    const rect = measure(node);
    const rectDelta = getRectDelta(rect, initialRect);

    if (!x) {
      rectDelta.x = 0;
    }

    if (!y) {
      rectDelta.y = 0;
    } // Only perform layout shift scroll compensation once


    initialized.current = true;

    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node);

      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x, y, initialRect, measure]);
}

const ActiveDraggableContext = /*#__PURE__*/(0,react.createContext)({ ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;

(function (Status) {
  Status[Status["Uninitialized"] = 0] = "Uninitialized";
  Status[Status["Initializing"] = 1] = "Initializing";
  Status[Status["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));

const DndContext = /*#__PURE__*/(0,react.memo)(function DndContext(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;

  let {
    id,
    accessibility,
    autoScroll = true,
    children,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers,
    ...props
  } = _ref;
  const store = (0,react.useReducer)(reducer, undefined, getInitialState);
  const [state, dispatch] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = (0,react.useState)(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node = activeId ? draggableNodes.get(activeId) : null;
  const activeRects = (0,react.useRef)({
    initial: null,
    translated: null
  });
  const active = (0,react.useMemo)(() => {
    var _node$data;

    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node]);
  const activeRef = (0,react.useRef)(null);
  const [activeSensor, setActiveSensor] = (0,react.useState)(null);
  const [activatorEvent, setActivatorEvent] = (0,react.useState)(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id);
  const enabledDroppableContainers = (0,react.useMemo)(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = (0,react.useMemo)(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = (0,react.useRef)({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  }); // Use the rect of the drag overlay if it is mounted

  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
  // is only relevant when there is no drag overlay

  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node

  const windowRect = useWindowRect(draggingNode ? getWindow(draggingNode) : null); // Get scrollable ancestors of the dragging node

  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors); // Apply modifiers

  const modifiedTranslate = applyModifiers(modifiers, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  });
  const pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated

  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured

  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active && collisionRect ? collisionDetection({
    active,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, 'id');
  const [over, setOver] = (0,react.useState)(null); // When there is no drag overlay used, we need to account for the
  // window scroll delta

  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add(modifiedTranslate, activeNodeScrollDelta);
  const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const instantiateSensor = (0,react.useCallback)((event, _ref2) => {
    let {
      sensor: Sensor,
      options
    } = _ref2;

    if (activeRef.current == null) {
      return;
    }

    const activeNode = draggableNodes.get(activeRef.current);

    if (!activeNode) {
      return;
    }

    const activatorEvent = event.nativeEvent;
    const sensorInstance = new Sensor({
      active: activeRef.current,
      activeNode,
      event: activatorEvent,
      options,
      // Sensors need to be instantiated with refs for arguments that change over time
      // otherwise they are frozen in time with the stale arguments
      context: sensorContext,

      onStart(initialCoordinates) {
        const id = activeRef.current;

        if (id == null) {
          return;
        }

        const draggableNode = draggableNodes.get(id);

        if (!draggableNode) {
          return;
        }

        const {
          onDragStart
        } = latestProps.current;
        const event = {
          active: {
            id,
            data: draggableNode.data,
            rect: activeRects
          }
        };
        (0,react_dom.unstable_batchedUpdates)(() => {
          onDragStart == null ? void 0 : onDragStart(event);
          setStatus(Status.Initializing);
          dispatch({
            type: Action.DragStart,
            initialCoordinates,
            active: id
          });
          dispatchMonitorEvent({
            type: 'onDragStart',
            event
          });
        });
      },

      onMove(coordinates) {
        dispatch({
          type: Action.DragMove,
          coordinates
        });
      },

      onEnd: createHandler(Action.DragEnd),
      onCancel: createHandler(Action.DragCancel)
    });
    (0,react_dom.unstable_batchedUpdates)(() => {
      setActiveSensor(sensorInstance);
      setActivatorEvent(event.nativeEvent);
    });

    function createHandler(type) {
      return async function handler() {
        const {
          active,
          collisions,
          over,
          scrollAdjustedTranslate
        } = sensorContext.current;
        let event = null;

        if (active && scrollAdjustedTranslate) {
          const {
            cancelDrop
          } = latestProps.current;
          event = {
            activatorEvent,
            active: active,
            collisions,
            delta: scrollAdjustedTranslate,
            over
          };

          if (type === Action.DragEnd && typeof cancelDrop === 'function') {
            const shouldCancel = await Promise.resolve(cancelDrop(event));

            if (shouldCancel) {
              type = Action.DragCancel;
            }
          }
        }

        activeRef.current = null;
        (0,react_dom.unstable_batchedUpdates)(() => {
          dispatch({
            type
          });
          setStatus(Status.Uninitialized);
          setOver(null);
          setActiveSensor(null);
          setActivatorEvent(null);
          const eventName = type === Action.DragEnd ? 'onDragEnd' : 'onDragCancel';

          if (event) {
            const handler = latestProps.current[eventName];
            handler == null ? void 0 : handler(event);
            dispatchMonitorEvent({
              type: eventName,
              event
            });
          }
        });
      };
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [draggableNodes]);
  const bindActivatorToSensorInstantiator = (0,react.useCallback)((handler, sensor) => {
    return (event, active) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active);

      if ( // Another sensor is already instantiating
      activeRef.current !== null || // No active draggable
      !activeDraggableNode || // Event has already been captured
      nativeEvent.dndKit || nativeEvent.defaultPrevented) {
        return;
      }

      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);

      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  (0,react.useEffect)(() => {
    const {
      onDragMove
    } = latestProps.current;
    const {
      active,
      activatorEvent,
      collisions,
      over
    } = sensorContext.current;

    if (!active || !activatorEvent) {
      return;
    }

    const event = {
      active,
      activatorEvent,
      collisions,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over
    };
    (0,react_dom.unstable_batchedUpdates)(() => {
      onDragMove == null ? void 0 : onDragMove(event);
      dispatchMonitorEvent({
        type: 'onDragMove',
        event
      });
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]);
  (0,react.useEffect)(() => {
    const {
      active,
      activatorEvent,
      collisions,
      droppableContainers,
      scrollAdjustedTranslate
    } = sensorContext.current;

    if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) {
      return;
    }

    const {
      onDragOver
    } = latestProps.current;
    const overContainer = droppableContainers.get(overId);
    const over = overContainer && overContainer.rect.current ? {
      id: overContainer.id,
      rect: overContainer.rect.current,
      data: overContainer.data,
      disabled: overContainer.disabled
    } : null;
    const event = {
      active,
      activatorEvent,
      collisions,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over
    };
    (0,react_dom.unstable_batchedUpdates)(() => {
      setOver(over);
      onDragOver == null ? void 0 : onDragOver(event);
      dispatchMonitorEvent({
        type: 'onDragOver',
        event
      });
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [overId]);
  useIsomorphicLayoutEffect(() => {
    sensorContext.current = {
      activatorEvent,
      active,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({ ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = (0,react.useMemo)(() => {
    const context = {
      active,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect
    };
    return context;
  }, [active, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect]);
  const internalContext = (0,react.useMemo)(() => {
    const context = {
      activatorEvent,
      activators,
      active,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active, activeNodeRect, dispatch, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return react.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, react.createElement(InternalContext.Provider, {
    value: internalContext
  }, react.createElement(PublicContext.Provider, {
    value: publicContext
  }, react.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), react.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), react.createElement(Accessibility, { ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));

  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;

    if (typeof autoScroll === 'object') {
      return { ...autoScroll,
        enabled
      };
    }

    return {
      enabled
    };
  }
});

const NullContext = /*#__PURE__*/(0,react.createContext)(null);
const defaultRole = 'button';
const ID_PREFIX = 'Droppable';
function useDraggable(_ref) {
  let {
    id,
    data,
    disabled = false,
    attributes
  } = _ref;
  const key = useUniqueId(ID_PREFIX);
  const {
    activators,
    activatorEvent,
    active,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = (0,react.useContext)(InternalContext);
  const {
    role = defaultRole,
    roleDescription = 'draggable',
    tabIndex = 0
  } = attributes != null ? attributes : {};
  const isDragging = (active == null ? void 0 : active.id) === id;
  const transform = (0,react.useContext)(isDragging ? ActiveDraggableContext : NullContext);
  const [node, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id);
  const dataRef = useLatestValue(data);
  useIsomorphicLayoutEffect(() => {
    draggableNodes.set(id, {
      id,
      key,
      node,
      activatorNode,
      data: dataRef
    });
    return () => {
      const node = draggableNodes.get(id);

      if (node && node.key === key) {
        draggableNodes.delete(id);
      }
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [draggableNodes, id]);
  const memoizedAttributes = (0,react.useMemo)(() => ({
    role,
    tabIndex,
    'aria-disabled': disabled,
    'aria-pressed': isDragging && role === defaultRole ? true : undefined,
    'aria-roledescription': roleDescription,
    'aria-describedby': ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? undefined : listeners,
    node,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform
  };
}

function useDndContext() {
  return (0,react.useContext)(PublicContext);
}

const ID_PREFIX$1 = 'Droppable';
const defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data,
    disabled = false,
    id,
    resizeObserverConfig
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1);
  const {
    active,
    dispatch,
    over,
    measureDroppableContainers
  } = (0,react.useContext)(InternalContext);
  const previous = (0,react.useRef)({
    disabled
  });
  const resizeObserverConnected = (0,react.useRef)(false);
  const rect = (0,react.useRef)(null);
  const callbackId = (0,react.useRef)(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = { ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id);
  const handleResize = (0,react.useCallback)(() => {
    if (!resizeObserverConnected.current) {
      // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
      // assuming the element is rendered and displayed.
      resizeObserverConnected.current = true;
      return;
    }

    if (callbackId.current != null) {
      clearTimeout(callbackId.current);
    }

    callbackId.current = setTimeout(() => {
      measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [ids.current]);
      callbackId.current = null;
    }, resizeObserverTimeout);
  }, //eslint-disable-next-line react-hooks/exhaustive-deps
  [resizeObserverTimeout]);
  const resizeObserver = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active
  });
  const handleNodeChange = (0,react.useCallback)((newElement, previousElement) => {
    if (!resizeObserver) {
      return;
    }

    if (previousElement) {
      resizeObserver.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }

    if (newElement) {
      resizeObserver.observe(newElement);
    }
  }, [resizeObserver]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data);
  (0,react.useEffect)(() => {
    if (!resizeObserver || !nodeRef.current) {
      return;
    }

    resizeObserver.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver.observe(nodeRef.current);
  }, [nodeRef, resizeObserver]);
  useIsomorphicLayoutEffect(() => {
    dispatch({
      type: Action.RegisterDroppable,
      element: {
        id,
        key,
        disabled,
        node: nodeRef,
        rect,
        data: dataRef
      }
    });
    return () => dispatch({
      type: Action.UnregisterDroppable,
      key,
      id
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [id]);
  (0,react.useEffect)(() => {
    if (disabled !== previous.current.disabled) {
      dispatch({
        type: Action.SetDroppableDisabled,
        id,
        key,
        disabled
      });
      previous.current.disabled = disabled;
    }
  }, [id, key, disabled, dispatch]);
  return {
    active,
    rect,
    isOver: (over == null ? void 0 : over.id) === id,
    node: nodeRef,
    over,
    setNodeRef
  };
}

function AnimationManager(_ref) {
  let {
    animation,
    children
  } = _ref;
  const [clonedChildren, setClonedChildren] = (0,react.useState)(null);
  const [element, setElement] = (0,react.useState)(null);
  const previousChildren = usePrevious(children);

  if (!children && !clonedChildren && previousChildren) {
    setClonedChildren(previousChildren);
  }

  useIsomorphicLayoutEffect(() => {
    if (!element) {
      return;
    }

    const key = clonedChildren == null ? void 0 : clonedChildren.key;
    const id = clonedChildren == null ? void 0 : clonedChildren.props.id;

    if (key == null || id == null) {
      setClonedChildren(null);
      return;
    }

    Promise.resolve(animation(id, element)).then(() => {
      setClonedChildren(null);
    });
  }, [animation, clonedChildren, element]);
  return react.createElement(react.Fragment, null, children, clonedChildren ? (0,react.cloneElement)(clonedChildren, {
    ref: setElement
  }) : null);
}

const defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(_ref) {
  let {
    children
  } = _ref;
  return react.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, react.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, children));
}

const baseStyles = {
  position: 'fixed',
  touchAction: 'none'
};

const defaultTransition = activatorEvent => {
  const isKeyboardActivator = isKeyboardEvent(activatorEvent);
  return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};

const PositionedOverlay = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    as,
    activatorEvent,
    adjustScale,
    children,
    className,
    rect,
    style,
    transform,
    transition = defaultTransition
  } = _ref;

  if (!rect) {
    return null;
  }

  const scaleAdjustedTransform = adjustScale ? transform : { ...transform,
    scaleX: 1,
    scaleY: 1
  };
  const styles = { ...baseStyles,
    width: rect.width,
    height: rect.height,
    top: rect.top,
    left: rect.left,
    transform: CSS.Transform.toString(scaleAdjustedTransform),
    transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : undefined,
    transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
    ...style
  };
  return react.createElement(as, {
    className,
    style: styles,
    ref
  }, children);
});

const defaultDropAnimationSideEffects = options => _ref => {
  let {
    active,
    dragOverlay
  } = _ref;
  const originalStyles = {};
  const {
    styles,
    className
  } = options;

  if (styles != null && styles.active) {
    for (const [key, value] of Object.entries(styles.active)) {
      if (value === undefined) {
        continue;
      }

      originalStyles[key] = active.node.style.getPropertyValue(key);
      active.node.style.setProperty(key, value);
    }
  }

  if (styles != null && styles.dragOverlay) {
    for (const [key, value] of Object.entries(styles.dragOverlay)) {
      if (value === undefined) {
        continue;
      }

      dragOverlay.node.style.setProperty(key, value);
    }
  }

  if (className != null && className.active) {
    active.node.classList.add(className.active);
  }

  if (className != null && className.dragOverlay) {
    dragOverlay.node.classList.add(className.dragOverlay);
  }

  return function cleanup() {
    for (const [key, value] of Object.entries(originalStyles)) {
      active.node.style.setProperty(key, value);
    }

    if (className != null && className.active) {
      active.node.classList.remove(className.active);
    }
  };
};

const defaultKeyframeResolver = _ref2 => {
  let {
    transform: {
      initial,
      final
    }
  } = _ref2;
  return [{
    transform: CSS.Transform.toString(initial)
  }, {
    transform: CSS.Transform.toString(final)
  }];
};

const defaultDropAnimationConfiguration = {
  duration: 250,
  easing: 'ease',
  keyframes: defaultKeyframeResolver,
  sideEffects: /*#__PURE__*/defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0'
      }
    }
  })
};
function useDropAnimation(_ref3) {
  let {
    config,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  } = _ref3;
  return useEvent((id, node) => {
    if (config === null) {
      return;
    }

    const activeDraggable = draggableNodes.get(id);

    if (!activeDraggable) {
      return;
    }

    const activeNode = activeDraggable.node.current;

    if (!activeNode) {
      return;
    }

    const measurableNode = getMeasurableNode(node);

    if (!measurableNode) {
      return;
    }

    const {
      transform
    } = getWindow(node).getComputedStyle(node);
    const parsedTransform = parseTransform(transform);

    if (!parsedTransform) {
      return;
    }

    const animation = typeof config === 'function' ? config : createDefaultDropAnimation(config);
    scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
    return animation({
      active: {
        id,
        data: activeDraggable.data,
        node: activeNode,
        rect: measuringConfiguration.draggable.measure(activeNode)
      },
      draggableNodes,
      dragOverlay: {
        node,
        rect: measuringConfiguration.dragOverlay.measure(measurableNode)
      },
      droppableContainers,
      measuringConfiguration,
      transform: parsedTransform
    });
  });
}

function createDefaultDropAnimation(options) {
  const {
    duration,
    easing,
    sideEffects,
    keyframes
  } = { ...defaultDropAnimationConfiguration,
    ...options
  };
  return _ref4 => {
    let {
      active,
      dragOverlay,
      transform,
      ...rest
    } = _ref4;

    if (!duration) {
      // Do not animate if animation duration is zero.
      return;
    }

    const delta = {
      x: dragOverlay.rect.left - active.rect.left,
      y: dragOverlay.rect.top - active.rect.top
    };
    const scale = {
      scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
      scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
    };
    const finalTransform = {
      x: transform.x - delta.x,
      y: transform.y - delta.y,
      ...scale
    };
    const animationKeyframes = keyframes({ ...rest,
      active,
      dragOverlay,
      transform: {
        initial: transform,
        final: finalTransform
      }
    });
    const [firstKeyframe] = animationKeyframes;
    const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];

    if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) {
      // The start and end keyframes are the same, infer that there is no animation needed.
      return;
    }

    const cleanup = sideEffects == null ? void 0 : sideEffects({
      active,
      dragOverlay,
      ...rest
    });
    const animation = dragOverlay.node.animate(animationKeyframes, {
      duration,
      easing,
      fill: 'forwards'
    });
    return new Promise(resolve => {
      animation.onfinish = () => {
        cleanup == null ? void 0 : cleanup();
        resolve();
      };
    });
  };
}

let core_esm_key = 0;
function useKey(id) {
  return (0,react.useMemo)(() => {
    if (id == null) {
      return;
    }

    core_esm_key++;
    return core_esm_key;
  }, [id]);
}

const DragOverlay = /*#__PURE__*/react.memo(_ref => {
  let {
    adjustScale = false,
    children,
    dropAnimation: dropAnimationConfig,
    style,
    transition,
    modifiers,
    wrapperElement = 'div',
    className,
    zIndex = 999
  } = _ref;
  const {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggableNodes,
    droppableContainers,
    dragOverlay,
    over,
    measuringConfiguration,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  } = useDndContext();
  const transform = (0,react.useContext)(ActiveDraggableContext);
  const key = useKey(active == null ? void 0 : active.id);
  const modifiedTransform = applyModifiers(modifiers, {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect: dragOverlay.rect,
    over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    transform,
    windowRect
  });
  const initialRect = useInitialValue(activeNodeRect);
  const dropAnimation = useDropAnimation({
    config: dropAnimationConfig,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  }); // We need to wait for the active node to be measured before connecting the drag overlay ref
  // otherwise collisions can be computed against a mispositioned drag overlay

  const ref = initialRect ? dragOverlay.setRef : undefined;
  return react.createElement(NullifiedContextProvider, null, react.createElement(AnimationManager, {
    animation: dropAnimation
  }, active && key ? react.createElement(PositionedOverlay, {
    key: key,
    id: active.id,
    ref: ref,
    as: wrapperElement,
    activatorEvent: activatorEvent,
    adjustScale: adjustScale,
    className: className,
    transition: transition,
    rect: initialRect,
    style: {
      zIndex,
      ...style
    },
    transform: modifiedTransform
  }, children) : null));
});


//# sourceMappingURL=core.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@dnd-kit/sortable/dist/sortable.esm.js




/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */
function sortable_esm_arrayMove(array, from, to) {
  const newArray = array.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
  return newArray;
}

/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */
function arraySwap(array, from, to) {
  const newArray = array.slice();
  newArray[from] = array[to];
  newArray[to] = array[from];
  return newArray;
}

function getSortedRects(items, rects) {
  return items.reduce((accumulator, id, index) => {
    const rect = rects.get(id);

    if (rect) {
      accumulator[index] = rect;
    }

    return accumulator;
  }, Array(items.length));
}

function isValidIndex(index) {
  return index !== null && index >= 0;
}

function itemsEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

function normalizeDisabled(disabled) {
  if (typeof disabled === 'boolean') {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }

  return disabled;
}

// To-do: We should be calculating scale transformation
const defaultScale = {
  scaleX: 1,
  scaleY: 1
};
const horizontalListSortingStrategy = _ref => {
  var _rects$activeIndex;

  let {
    rects,
    activeNodeRect: fallbackActiveRect,
    activeIndex,
    overIndex,
    index
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;

  if (!activeNodeRect) {
    return null;
  }

  const itemGap = getItemGap(rects, index, activeIndex);

  if (index === activeIndex) {
    const newIndexRect = rects[overIndex];

    if (!newIndexRect) {
      return null;
    }

    return {
      x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
      y: 0,
      ...defaultScale
    };
  }

  if (index > activeIndex && index <= overIndex) {
    return {
      x: -activeNodeRect.width - itemGap,
      y: 0,
      ...defaultScale
    };
  }

  if (index < activeIndex && index >= overIndex) {
    return {
      x: activeNodeRect.width + itemGap,
      y: 0,
      ...defaultScale
    };
  }

  return {
    x: 0,
    y: 0,
    ...defaultScale
  };
};

function getItemGap(rects, index, activeIndex) {
  const currentRect = rects[index];
  const previousRect = rects[index - 1];
  const nextRect = rects[index + 1];

  if (!currentRect || !previousRect && !nextRect) {
    return 0;
  }

  if (activeIndex < index) {
    return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
  }

  return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}

const rectSortingStrategy = _ref => {
  let {
    rects,
    activeIndex,
    overIndex,
    index
  } = _ref;
  const newRects = sortable_esm_arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index];
  const newRect = newRects[index];

  if (!newRect || !oldRect) {
    return null;
  }

  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};

const rectSwappingStrategy = _ref => {
  let {
    activeIndex,
    index,
    rects,
    overIndex
  } = _ref;
  let oldRect;
  let newRect;

  if (index === activeIndex) {
    oldRect = rects[index];
    newRect = rects[overIndex];
  }

  if (index === overIndex) {
    oldRect = rects[index];
    newRect = rects[activeIndex];
  }

  if (!newRect || !oldRect) {
    return null;
  }

  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};

// To-do: We should be calculating scale transformation
const defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
};
const verticalListSortingStrategy = _ref => {
  var _rects$activeIndex;

  let {
    activeIndex,
    activeNodeRect: fallbackActiveRect,
    index,
    rects,
    overIndex
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;

  if (!activeNodeRect) {
    return null;
  }

  if (index === activeIndex) {
    const overIndexRect = rects[overIndex];

    if (!overIndexRect) {
      return null;
    }

    return {
      x: 0,
      y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
      ...defaultScale$1
    };
  }

  const itemGap = getItemGap$1(rects, index, activeIndex);

  if (index > activeIndex && index <= overIndex) {
    return {
      x: 0,
      y: -activeNodeRect.height - itemGap,
      ...defaultScale$1
    };
  }

  if (index < activeIndex && index >= overIndex) {
    return {
      x: 0,
      y: activeNodeRect.height + itemGap,
      ...defaultScale$1
    };
  }

  return {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};

function getItemGap$1(clientRects, index, activeIndex) {
  const currentRect = clientRects[index];
  const previousRect = clientRects[index - 1];
  const nextRect = clientRects[index + 1];

  if (!currentRect) {
    return 0;
  }

  if (activeIndex < index) {
    return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
  }

  return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}

const sortable_esm_ID_PREFIX = 'Sortable';
const sortable_esm_Context = /*#__PURE__*/react.createContext({
  activeIndex: -1,
  containerId: sortable_esm_ID_PREFIX,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children,
    id,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(sortable_esm_ID_PREFIX, id);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items = (0,react.useMemo)(() => userDefinedItems.map(item => typeof item === 'object' && 'id' in item ? item.id : item), [userDefinedItems]);
  const isDragging = active != null;
  const activeIndex = active ? items.indexOf(active.id) : -1;
  const overIndex = over ? items.indexOf(over.id) : -1;
  const previousItemsRef = (0,react.useRef)(items);
  const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items);
    }
  }, [itemsHaveChanged, items, isDragging, measureDroppableContainers]);
  (0,react.useEffect)(() => {
    previousItemsRef.current = items;
  }, [items]);
  const contextValue = (0,react.useMemo)(() => ({
    activeIndex,
    containerId,
    disabled,
    disableTransforms,
    items,
    overIndex,
    useDragOverlay,
    sortedRects: getSortedRects(items, droppableRects),
    strategy
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items, overIndex, droppableRects, useDragOverlay, strategy]);
  return react.createElement(sortable_esm_Context.Provider, {
    value: contextValue
  }, children);
}

const defaultNewIndexGetter = _ref => {
  let {
    id,
    items,
    activeIndex,
    overIndex
  } = _ref;
  return sortable_esm_arrayMove(items, activeIndex, overIndex).indexOf(id);
};
const defaultAnimateLayoutChanges = _ref2 => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index,
    items,
    newIndex,
    previousItems,
    previousContainerId,
    transition
  } = _ref2;

  if (!transition || !wasDragging) {
    return false;
  }

  if (previousItems !== items && index === newIndex) {
    return false;
  }

  if (isSorting) {
    return true;
  }

  return newIndex !== index && containerId === previousContainerId;
};
const sortable_esm_defaultTransition = {
  duration: 200,
  easing: 'ease'
};
const transitionProperty = 'transform';
const disabledTransition = /*#__PURE__*/CSS.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: 'linear'
});
const defaultAttributes = {
  roleDescription: 'sortable'
};

/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */

function useDerivedTransform(_ref) {
  let {
    disabled,
    index,
    node,
    rect
  } = _ref;
  const [derivedTransform, setDerivedtransform] = (0,react.useState)(null);
  const previousIndex = (0,react.useRef)(index);
  useIsomorphicLayoutEffect(() => {
    if (!disabled && index !== previousIndex.current && node.current) {
      const initial = rect.current;

      if (initial) {
        const current = getClientRect(node.current, {
          ignoreTransform: true
        });
        const delta = {
          x: initial.left - current.left,
          y: initial.top - current.top,
          scaleX: initial.width / current.width,
          scaleY: initial.height / current.height
        };

        if (delta.x || delta.y) {
          setDerivedtransform(delta);
        }
      }
    }

    if (index !== previousIndex.current) {
      previousIndex.current = index;
    }
  }, [disabled, index, node, rect]);
  (0,react.useEffect)(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}

function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id,
    strategy: localStrategy,
    resizeObserverConfig,
    transition = sortable_esm_defaultTransition
  } = _ref;
  const {
    items,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = (0,react.useContext)(sortable_esm_Context);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index = items.indexOf(id);
  const data = (0,react.useMemo)(() => ({
    sortable: {
      containerId,
      index,
      items
    },
    ...customData
  }), [containerId, customData, index, items]);
  const itemsAfterCurrentSortable = (0,react.useMemo)(() => items.slice(items.indexOf(id)), [items, id]);
  const {
    rect,
    node,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id,
    data,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active,
    activatorEvent,
    activeNodeRect,
    attributes,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform
  } = useDraggable({
    id,
    data,
    attributes: { ...defaultAttributes,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id,
    items,
    activeIndex,
    overIndex
  }) : index;
  const activeId = active == null ? void 0 : active.id;
  const previous = (0,react.useRef)({
    activeId,
    items,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items !== previous.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active,
    containerId,
    isDragging,
    isSorting,
    id,
    index,
    items,
    newIndex: previous.current.newIndex,
    previousItems: previous.current.items,
    previousContainerId: previous.current.containerId,
    transition,
    wasDragging: previous.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index,
    node,
    rect
  });
  (0,react.useEffect)(() => {
    if (isSorting && previous.current.newIndex !== newIndex) {
      previous.current.newIndex = newIndex;
    }

    if (containerId !== previous.current.containerId) {
      previous.current.containerId = containerId;
    }

    if (items !== previous.current.items) {
      previous.current.items = items;
    }
  }, [isSorting, newIndex, containerId, items]);
  (0,react.useEffect)(() => {
    if (activeId === previous.current.activeId) {
      return;
    }

    if (activeId && !previous.current.activeId) {
      previous.current.activeId = activeId;
      return;
    }

    const timeoutId = setTimeout(() => {
      previous.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active,
    activeIndex,
    attributes,
    data,
    rect,
    index,
    newIndex,
    items,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };

  function getTransition() {
    if ( // Temporarily disable transitions for a single frame to set up derived transforms
    derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
    itemsHaveChanged && previous.current.newIndex === index) {
      return disabledTransition;
    }

    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) {
      return undefined;
    }

    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS.Transition.toString({ ...transition,
        property: transitionProperty
      });
    }

    return undefined;
  }
}

function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;

  if (typeof localDisabled === 'boolean') {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }

  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}

function hasSortableData(entry) {
  if (!entry) {
    return false;
  }

  const data = entry.data.current;

  if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) {
    return true;
  }

  return false;
}

const sortable_esm_directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
const sortableKeyboardCoordinates = (event, _ref) => {
  let {
    context: {
      active,
      collisionRect,
      droppableRects,
      droppableContainers,
      over,
      scrollableAncestors
    }
  } = _ref;

  if (sortable_esm_directions.includes(event.code)) {
    event.preventDefault();

    if (!active || !collisionRect) {
      return;
    }

    const filteredContainers = [];
    droppableContainers.getEnabled().forEach(entry => {
      if (!entry || entry != null && entry.disabled) {
        return;
      }

      const rect = droppableRects.get(entry.id);

      if (!rect) {
        return;
      }

      switch (event.code) {
        case KeyboardCode.Down:
          if (collisionRect.top < rect.top) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Up:
          if (collisionRect.top > rect.top) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Left:
          if (collisionRect.left > rect.left) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Right:
          if (collisionRect.left < rect.left) {
            filteredContainers.push(entry);
          }

          break;
      }
    });
    const collisions = closestCorners({
      active,
      collisionRect: collisionRect,
      droppableRects,
      droppableContainers: filteredContainers,
      pointerCoordinates: null
    });
    let closestId = getFirstCollision(collisions, 'id');

    if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) {
      closestId = collisions[1].id;
    }

    if (closestId != null) {
      const activeDroppable = droppableContainers.get(active.id);
      const newDroppable = droppableContainers.get(closestId);
      const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
      const newNode = newDroppable == null ? void 0 : newDroppable.node.current;

      if (newNode && newRect && activeDroppable && newDroppable) {
        const newScrollAncestors = getScrollableAncestors(newNode);
        const hasDifferentScrollAncestors = newScrollAncestors.some((element, index) => scrollableAncestors[index] !== element);
        const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
        const isAfterActive = isAfter(activeDroppable, newDroppable);
        const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
          x: 0,
          y: 0
        } : {
          x: isAfterActive ? collisionRect.width - newRect.width : 0,
          y: isAfterActive ? collisionRect.height - newRect.height : 0
        };
        const rectCoordinates = {
          x: newRect.left,
          y: newRect.top
        };
        const newCoordinates = offset.x && offset.y ? rectCoordinates : subtract(rectCoordinates, offset);
        return newCoordinates;
      }
    }
  }

  return undefined;
};

function isSameContainer(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }

  return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}

function isAfter(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }

  if (!isSameContainer(a, b)) {
    return false;
  }

  return a.data.current.sortable.index < b.data.current.sortable.index;
}


//# sourceMappingURL=sortable.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_sortable/index.js







const defaultPrefix = 'semi-sortable';
function DefaultContainer(props) {
  return /*#__PURE__*/react.createElement("div", Object.assign({
    style: {
      overflow: 'auto'
    }
  }, props));
}
const defaultKeyBoardOptions = {
  coordinateGetter: sortableKeyboardCoordinates
};
function Sortable(_ref) {
  let {
    items,
    onSortEnd,
    adjustScale,
    renderItem,
    transition,
    collisionDetection = closestCenter,
    strategy = rectSortingStrategy,
    useDragOverlay = true,
    dragOverlayCls,
    container: Container = DefaultContainer,
    prefix = defaultPrefix
  } = _ref;
  const [activeId, setActiveId] = (0,react.useState)(null);
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor), useSensor(KeyboardSensor, defaultKeyBoardOptions));
  const getIndex = (0,react.useCallback)(id => items.indexOf(id), [items]);
  const activeIndex = (0,react.useMemo)(() => activeId ? getIndex(activeId) : -1, [getIndex, activeId]);
  const onDragStart = (0,react.useCallback)(_ref2 => {
    let {
      active
    } = _ref2;
    if (!active) {
      return;
    }
    setActiveId(active.id);
  }, []);
  const onDragEnd = (0,react.useCallback)(_ref3 => {
    let {
      over
    } = _ref3;
    setActiveId(null);
    if (over) {
      const overIndex = getIndex(over.id);
      if (activeIndex !== overIndex) {
        onSortEnd({
          oldIndex: activeIndex,
          newIndex: overIndex
        });
      }
    }
  }, [activeIndex, getIndex, onSortEnd]);
  const onDragCancel = (0,react.useCallback)(() => {
    setActiveId(null);
  }, []);
  return /*#__PURE__*/react.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: collisionDetection,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    onDragCancel: onDragCancel,
    autoScroll: {
      order: TraversalOrder.ReversedTreeOrder
    }
  }, /*#__PURE__*/react.createElement(SortableContext, {
    items: items,
    strategy: strategy
  }, /*#__PURE__*/react.createElement(Container, null, items.map((value, index) => /*#__PURE__*/react.createElement(SortableItem, {
    key: value,
    id: value,
    index: index,
    renderItem: renderItem,
    useDragOverlay: useDragOverlay,
    prefix: prefix,
    transition: transition
  })))), useDragOverlay ? /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(DragOverlay, {
    adjustScale: adjustScale,
    // Set zIndex in style to undefined to override the default zIndex in DragOverlay, 
    // So that the zIndex of DragOverlay can be set by className
    style: {
      zIndex: undefined
    },
    className: dragOverlayCls
  }, activeId ? renderItem({
    id: activeId,
    sortableHandle: WrapperComponent => WrapperComponent
  }) : null), document.body) : null);
}
function SortableItem(_ref4) {
  let {
    animateLayoutChanges,
    id,
    renderItem,
    prefix,
    transition: animation
  } = _ref4;
  const {
    listeners,
    setNodeRef,
    transform,
    transition,
    active,
    isOver,
    attributes
  } = useSortable({
    id,
    animateLayoutChanges,
    transition: animation
  });
  const sortableHandle = (0,react.useCallback)(WrapperComponent => {
    // console.log('listeners', listeners);
    // 保证给出的接口的一致性，使用 span 包一层，保证用户能够通过同样的方式使用 handler
    // To ensure the consistency of the given interface
    // use a span package layer to ensure that users can use the handler in the same way
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    return () => /*#__PURE__*/react.createElement("span", Object.assign({}, listeners, {
      style: {
        lineHeight: 0
      },
      onMouseDown: e => {
        listeners.onMouseDown(e);
        // 阻止onMousedown的事件传递，
        // 防止元素在点击后被卸载导致tooltip/popover的弹出层意外关闭
        // Prevent the onMousedown event from being delivered, 
        // preventing the element from being unloaded after being clicked, 
        // causing the tooltip/popover pop-up layer to close unexpectedly
        e.preventDefault();
        e.stopPropagation();
      }
    }), /*#__PURE__*/react.createElement(WrapperComponent, null));
  }, [listeners]);
  const itemCls = classnames_default()(`${prefix}-sortable-item`, {
    [`${prefix}-sortable-item-over`]: isOver,
    [`${prefix}-sortable-item-active`]: (active === null || active === void 0 ? void 0 : active.id) === id
  });
  const wrapperStyle = (0,react.useMemo)(() => {
    return !isNull_default()(animation) ? {
      transform: CSS.Transform.toString(Object.assign(Object.assign({}, transform), {
        scaleX: 1,
        scaleY: 1
      })),
      transition: transition
    } : undefined;
  }, [animation, transform, transition]);
  return /*#__PURE__*/react.createElement("div", Object.assign({
    ref: setNodeRef,
    style: wrapperStyle,
    className: itemCls
  }, attributes), renderItem({
    id,
    sortableHandle
  }));
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/tagInput/index.js






var tagInput_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




// import '@douyinfe/semi-foundation/lib/es/tagInput/tagInput.css';









const tagInput_prefixCls = tagInput_constants_cssClasses.PREFIX;
function SortContainer(props) {
  return /*#__PURE__*/react.createElement("div", Object.assign({
    className: `${tagInput_prefixCls}-sortable-list`
  }, props));
}
class TagInput extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleInputChange = e => {
      this.foundation.handleInputChange(e);
    };
    this.handleKeyDown = e => {
      this.foundation.handleKeyDown(e);
    };
    this.handleInputFocus = e => {
      this.foundation.handleInputFocus(e);
    };
    this.handleInputBlur = e => {
      this.foundation.handleInputBlur(e);
    };
    this.handleClearBtn = e => {
      this.foundation.handleClearBtn(e);
    };
    /* istanbul ignore next */
    this.handleClearEnterPress = e => {
      this.foundation.handleClearEnterPress(e);
    };
    this.handleTagClose = idx => {
      this.foundation.handleTagClose(idx);
    };
    this.handleInputMouseLeave = e => {
      this.foundation.handleInputMouseLeave();
    };
    this.handleClick = e => {
      this.foundation.handleClick(e);
    };
    this.handleInputMouseEnter = e => {
      this.foundation.handleInputMouseEnter();
    };
    this.handleClickPrefixOrSuffix = e => {
      this.foundation.handleClickPrefixOrSuffix(e);
    };
    this.handlePreventMouseDown = e => {
      this.foundation.handlePreventMouseDown(e);
    };
    this.getAllTags = () => {
      const {
        tagsArray
      } = this.state;
      return tagsArray.map((value, index) => this.renderTag(value, index));
    };
    this.renderTag = (value, index, sortableHandle) => {
      const {
        size,
        disabled,
        renderTagItem,
        showContentTooltip,
        draggable
      } = this.props;
      const {
        active
      } = this.state;
      const showIconHandler = active && draggable;
      const tagCls = classnames_default()(`${tagInput_prefixCls}-wrapper-tag`, {
        [`${tagInput_prefixCls}-wrapper-tag-size-${size}`]: size,
        [`${tagInput_prefixCls}-wrapper-tag-icon`]: showIconHandler
      });
      const typoCls = classnames_default()(`${tagInput_prefixCls}-wrapper-typo`, {
        [`${tagInput_prefixCls}-wrapper-typo-disabled`]: disabled
      });
      const itemWrapperCls = classnames_default()({
        [`${tagInput_prefixCls}-drag-item`]: showIconHandler,
        [`${tagInput_prefixCls}-wrapper-tag-icon`]: showIconHandler
      });
      const DragHandle = sortableHandle && sortableHandle(() => /*#__PURE__*/react.createElement(IconHandle, {
        className: `${tagInput_prefixCls}-drag-handler`
      }));
      const elementKey = showIconHandler ? value : `${index}${value}`;
      const onClose = () => {
        !disabled && this.handleTagClose(index);
      };
      if (isFunction_default()(renderTagItem)) {
        return /*#__PURE__*/react.createElement("div", {
          className: itemWrapperCls,
          key: elementKey
        }, showIconHandler && sortableHandle ? /*#__PURE__*/react.createElement(DragHandle, null) : null, renderTagItem(value, index, onClose));
      } else {
        return /*#__PURE__*/react.createElement(Tag, {
          className: tagCls,
          color: "white",
          size: size === 'small' ? 'small' : 'large',
          type: "light",
          onClose: onClose,
          closable: !disabled,
          key: elementKey,
          visible: true,
          "aria-label": `${!disabled ? 'Closable ' : ''}Tag: ${value}`
        }, showIconHandler && sortableHandle ? /*#__PURE__*/react.createElement(DragHandle, null) : null, /*#__PURE__*/react.createElement(Paragraph, {
          className: typoCls,
          ellipsis: {
            showTooltip: showContentTooltip,
            rows: 1
          }
        }, value));
      }
    };
    this.renderSortTag = props => {
      const {
        id: item,
        sortableHandle
      } = props;
      const {
        tagsArray
      } = this.state;
      const index = tagsArray.indexOf(item);
      return this.renderTag(item, index, sortableHandle);
    };
    this.onSortEnd = callbackProps => {
      this.foundation.handleSortEnd(callbackProps);
    };
    this.handleInputCompositionStart = e => {
      this.foundation.handleInputCompositionStart(e);
    };
    this.handleInputCompositionEnd = e => {
      this.foundation.handleInputCompositionEnd(e);
    };
    this.foundation = new tagInput_foundation(this.adapter);
    this.state = {
      tagsArray: props.defaultValue || [],
      inputValue: '',
      focusing: false,
      hovering: false,
      active: false,
      entering: false
    };
    this.inputRef = /*#__PURE__*/react.createRef();
    this.tagInputRef = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      value,
      inputValue
    } = nextProps;
    const {
      tagsArray: prevTagsArray
    } = prevState;
    let tagsArray;
    if (isArray_default()(value)) {
      tagsArray = value;
    } else if ('value' in nextProps && !value) {
      tagsArray = [];
    } else {
      tagsArray = prevTagsArray;
    }
    return {
      tagsArray,
      inputValue: isString_default()(inputValue) ? inputValue : prevState.inputValue
    };
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setInputValue: inputValue => {
        this.setState({
          inputValue
        });
      },
      setTagsArray: tagsArray => {
        this.setState({
          tagsArray
        });
      },
      setFocusing: focusing => {
        this.setState({
          focusing
        });
      },
      toggleFocusing: isFocus => {
        const {
          preventScroll
        } = this.props;
        const input = this.inputRef && this.inputRef.current;
        if (isFocus) {
          input && input.focus({
            preventScroll
          });
        } else {
          input && input.blur();
        }
        this.setState({
          focusing: isFocus
        });
      },
      setHovering: hovering => {
        this.setState({
          hovering
        });
      },
      setActive: active => {
        this.setState({
          active
        });
      },
      setEntering: entering => {
        this.setState({
          entering
        });
      },
      getClickOutsideHandler: () => {
        return this.clickOutsideHandler;
      },
      notifyBlur: e => {
        this.props.onBlur(e);
      },
      notifyFocus: e => {
        this.props.onFocus(e);
      },
      notifyInputChange: (v, e) => {
        this.props.onInputChange(v, e);
      },
      notifyTagChange: v => {
        this.props.onChange(v);
      },
      notifyTagAdd: v => {
        this.props.onAdd(v);
      },
      notifyTagRemove: (v, idx) => {
        this.props.onRemove(v, idx);
      },
      notifyKeyDown: e => {
        this.props.onKeyDown(e);
      },
      registerClickOutsideHandler: cb => {
        const clickOutsideHandler = e => {
          const tagInputDom = this.tagInputRef && this.tagInputRef.current;
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (tagInputDom && !tagInputDom.contains(target) && !path.includes(tagInputDom)) {
            cb(e);
          }
        };
        this.clickOutsideHandler = clickOutsideHandler;
        document.addEventListener('click', clickOutsideHandler, false);
      },
      unregisterClickOutsideHandler: () => {
        document.removeEventListener('click', this.clickOutsideHandler, false);
        this.clickOutsideHandler = null;
      }
    });
  }
  componentDidMount() {
    const {
      disabled,
      autoFocus,
      preventScroll
    } = this.props;
    if (!disabled && autoFocus) {
      this.inputRef.current.focus({
        preventScroll
      });
      this.foundation.handleClick();
    }
    this.foundation.init();
  }
  renderClearBtn() {
    const {
      hovering,
      tagsArray,
      inputValue
    } = this.state;
    const {
      showClear,
      disabled,
      clearIcon
    } = this.props;
    const clearCls = classnames_default()(`${tagInput_prefixCls}-clearBtn`, {
      [`${tagInput_prefixCls}-clearBtn-invisible`]: !hovering || inputValue === '' && tagsArray.length === 0 || disabled
    });
    if (showClear) {
      return /*#__PURE__*/react.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": "Clear TagInput value",
        className: clearCls,
        onClick: e => this.handleClearBtn(e),
        onKeyPress: e => this.handleClearEnterPress(e)
      }, clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, null));
    }
    return null;
  }
  renderPrefix() {
    const {
      prefix,
      insetLabel,
      insetLabelId
    } = this.props;
    const labelNode = prefix || insetLabel;
    if (isNull_default()(labelNode) || isUndefined_default()(labelNode)) {
      return null;
    }
    const prefixWrapperCls = classnames_default()(`${tagInput_prefixCls}-prefix`, {
      [`${tagInput_prefixCls}-inset-label`]: insetLabel,
      [`${tagInput_prefixCls}-prefix-text`]: labelNode && isString_default()(labelNode),
      [`${tagInput_prefixCls}-prefix-icon`]: isSemiIcon(labelNode)
    });
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
      react.createElement("div", {
        className: prefixWrapperCls,
        onMouseDown: this.handlePreventMouseDown,
        onClick: this.handleClickPrefixOrSuffix,
        id: insetLabelId,
        "x-semi-prop": "prefix"
      }, labelNode)
    );
  }
  renderSuffix() {
    const {
      suffix
    } = this.props;
    if (isNull_default()(suffix) || isUndefined_default()(suffix)) {
      return null;
    }
    const suffixWrapperCls = classnames_default()(`${tagInput_prefixCls}-suffix`, {
      [`${tagInput_prefixCls}-suffix-text`]: suffix && isString_default()(suffix),
      [`${tagInput_prefixCls}-suffix-icon`]: isSemiIcon(suffix)
    });
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      react.createElement("div", {
        className: suffixWrapperCls,
        onMouseDown: this.handlePreventMouseDown,
        onClick: this.handleClickPrefixOrSuffix,
        "x-semi-prop": "suffix"
      }, suffix)
    );
  }
  renderTags() {
    const {
      disabled,
      maxTagCount,
      showRestTagsPopover,
      restTagsPopoverProps = {},
      draggable,
      expandRestTagsOnClick
    } = this.props;
    const {
      tagsArray,
      active
    } = this.state;
    const restTagsCls = classnames_default()(`${tagInput_prefixCls}-wrapper-n`, {
      [`${tagInput_prefixCls}-wrapper-n-disabled`]: disabled
    });
    const allTags = this.getAllTags();
    let restTags = [];
    let tags = [...allTags];
    if ((!active || !expandRestTagsOnClick) && maxTagCount && maxTagCount < allTags.length) {
      tags = allTags.slice(0, maxTagCount);
      restTags = allTags.slice(maxTagCount);
    }
    const restTagsContent = /*#__PURE__*/react.createElement("span", {
      className: restTagsCls
    }, "+", tagsArray.length - maxTagCount);
    const sortableListItems = allTags.map((item, index) => ({
      item: item,
      key: tagsArray[index]
    }));
    if (active && draggable && sortableListItems.length > 0) {
      return /*#__PURE__*/react.createElement(Sortable, {
        items: tagsArray,
        onSortEnd: this.onSortEnd,
        renderItem: this.renderSortTag,
        container: SortContainer,
        prefix: tagInput_prefixCls,
        transition: null,
        dragOverlayCls: `${tagInput_prefixCls}-right-item-drag-item-move`
      });
    }
    return /*#__PURE__*/react.createElement(react.Fragment, null, tags, restTags.length > 0 && (showRestTagsPopover ? /*#__PURE__*/react.createElement(popover, Object.assign({
      content: restTags,
      showArrow: true,
      trigger: "hover",
      position: "top",
      autoAdjustOverflow: true
    }, restTagsPopoverProps), restTagsContent) : restTagsContent));
  }
  blur() {
    this.inputRef.current.blur();
    // unregister clickOutside event
    this.foundation.clickOutsideCallBack();
  }
  focus() {
    const {
      preventScroll,
      disabled
    } = this.props;
    this.inputRef.current.focus({
      preventScroll
    });
    if (!disabled) {
      // register clickOutside event
      this.foundation.handleClick();
    }
  }
  render() {
    const _a = this.props,
      {
        size,
        style,
        className,
        disabled,
        placeholder,
        validateStatus,
        prefix,
        insetLabel,
        suffix
      } = _a,
      rest = tagInput_rest(_a, ["size", "style", "className", "disabled", "placeholder", "validateStatus", "prefix", "insetLabel", "suffix"]);
    const {
      focusing,
      hovering,
      tagsArray,
      inputValue,
      active
    } = this.state;
    const tagInputCls = classnames_default()(tagInput_prefixCls, className, {
      [`${tagInput_prefixCls}-focus`]: focusing || active,
      [`${tagInput_prefixCls}-disabled`]: disabled,
      [`${tagInput_prefixCls}-hover`]: hovering && !disabled,
      [`${tagInput_prefixCls}-error`]: validateStatus === 'error',
      [`${tagInput_prefixCls}-warning`]: validateStatus === 'warning',
      [`${tagInput_prefixCls}-small`]: size === 'small',
      [`${tagInput_prefixCls}-large`]: size === 'large',
      [`${tagInput_prefixCls}-with-prefix`]: !!prefix || !!insetLabel,
      [`${tagInput_prefixCls}-with-suffix`]: !!suffix
    });
    const inputCls = classnames_default()(`${tagInput_prefixCls}-wrapper-input`, `${tagInput_prefixCls}-wrapper-input-${size}`);
    const wrapperCls = classnames_default()(`${tagInput_prefixCls}-wrapper`);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      react.createElement("div", Object.assign({
        ref: this.tagInputRef,
        style: style,
        className: tagInputCls,
        "aria-disabled": disabled,
        "aria-label": this.props['aria-label'],
        "aria-invalid": validateStatus === 'error',
        onMouseEnter: e => {
          this.handleInputMouseEnter(e);
        },
        onMouseLeave: e => {
          this.handleInputMouseLeave(e);
        },
        onClick: e => {
          this.handleClick(e);
        }
      }, this.getDataAttr(rest)), this.renderPrefix(), /*#__PURE__*/react.createElement("div", {
        className: wrapperCls
      }, this.renderTags(), /*#__PURE__*/react.createElement(es_input, {
        "aria-label": 'input value',
        ref: this.inputRef,
        className: inputCls,
        disabled: disabled,
        value: inputValue,
        size: size,
        placeholder: tagsArray.length === 0 ? placeholder : '',
        onKeyDown: e => {
          this.handleKeyDown(e);
        },
        onChange: (v, e) => {
          this.handleInputChange(e);
        },
        onBlur: e => {
          this.handleInputBlur(e);
        },
        onFocus: e => {
          this.handleInputFocus(e);
        },
        onCompositionStart: this.handleInputCompositionStart,
        onCompositionEnd: this.handleInputCompositionEnd
      })), this.renderClearBtn(), this.renderSuffix())
    );
  }
}
TagInput.propTypes = {
  children: (prop_types_default()).node,
  clearIcon: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  disabled: (prop_types_default()).bool,
  allowDuplicates: (prop_types_default()).bool,
  max: (prop_types_default()).number,
  maxTagCount: (prop_types_default()).number,
  maxLength: (prop_types_default()).number,
  showRestTagsPopover: (prop_types_default()).bool,
  restTagsPopoverProps: (prop_types_default()).object,
  showContentTooltip: prop_types_default().oneOfType([prop_types_default().shape({
    type: (prop_types_default()).string,
    opts: (prop_types_default()).object
  }), (prop_types_default()).bool]),
  defaultValue: (prop_types_default()).array,
  value: (prop_types_default()).array,
  inputValue: (prop_types_default()).string,
  placeholder: (prop_types_default()).string,
  separator: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  showClear: (prop_types_default()).bool,
  addOnBlur: (prop_types_default()).bool,
  draggable: (prop_types_default()).bool,
  expandRestTagsOnClick: (prop_types_default()).bool,
  autoFocus: (prop_types_default()).bool,
  renderTagItem: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onInputChange: (prop_types_default()).func,
  onExceed: (prop_types_default()).func,
  onInputExceed: (prop_types_default()).func,
  onAdd: (prop_types_default()).func,
  onRemove: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  size: prop_types_default().oneOf(tagInput_constants_strings.SIZE_SET),
  validateStatus: prop_types_default().oneOf(tagInput_constants_strings.STATUS),
  prefix: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).node]),
  suffix: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).node]),
  'aria-label': (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool
};
TagInput.defaultProps = {
  showClear: false,
  addOnBlur: false,
  allowDuplicates: true,
  showRestTagsPopover: true,
  autoFocus: false,
  draggable: false,
  expandRestTagsOnClick: true,
  showContentTooltip: true,
  separator: ',',
  size: 'default',
  validateStatus: 'default',
  onBlur: (noop_default()),
  onFocus: (noop_default()),
  onChange: (noop_default()),
  onInputChange: (noop_default()),
  onExceed: (noop_default()),
  onInputExceed: (noop_default()),
  onAdd: (noop_default()),
  onRemove: (noop_default()),
  onKeyDown: (noop_default())
};
/* harmony default export */ var tagInput = (TagInput);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/treeSelect/index.js









var treeSelect_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









// import '@douyinfe/semi-foundation/lib/es/tree/tree.css';
// import '@douyinfe/semi-foundation/lib/es/treeSelect/treeSelect.css';


















const treeSelect_prefixcls = treeSelect_constants_cssClasses.PREFIX;
const prefixTree = treeSelect_constants_cssClasses.PREFIX_TREE;
const treeSelect_key = 0;
class TreeSelect extends BaseComponent {
  constructor(props) {
    super(props);
    this.renderSuffix = () => {
      const {
        suffix
      } = this.props;
      const suffixWrapperCls = classnames_default()({
        [`${treeSelect_prefixcls}-suffix`]: true,
        [`${treeSelect_prefixcls}-suffix-text`]: suffix && isString_default()(suffix),
        [`${treeSelect_prefixcls}-suffix-icon`]: isSemiIcon(suffix)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: suffixWrapperCls,
        "x-semi-prop": "suffix"
      }, suffix);
    };
    this.renderPrefix = () => {
      const {
        prefix,
        insetLabel,
        insetLabelId
      } = this.props;
      const labelNode = prefix || insetLabel;
      const prefixWrapperCls = classnames_default()({
        [`${treeSelect_prefixcls}-prefix`]: true,
        // to be doublechecked
        [`${treeSelect_prefixcls}-inset-label`]: insetLabel,
        [`${treeSelect_prefixcls}-prefix-text`]: labelNode && isString_default()(labelNode),
        [`${treeSelect_prefixcls}-prefix-icon`]: isSemiIcon(labelNode)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: prefixWrapperCls,
        id: insetLabelId,
        "x-semi-prop": "prefix,insetLabel"
      }, labelNode);
    };
    this.renderContent = () => {
      const {
        dropdownMinWidth
      } = this.state;
      const {
        dropdownStyle,
        dropdownClassName
      } = this.props;
      const style = Object.assign({
        minWidth: dropdownMinWidth
      }, dropdownStyle);
      const popoverCls = classnames_default()(dropdownClassName, `${treeSelect_prefixcls}-popover`);
      return /*#__PURE__*/react.createElement("div", {
        className: popoverCls,
        style: style
      }, this.renderTree());
    };
    this.removeTag = removedKey => {
      this.foundation.removeTag(removedKey);
    };
    this.handleClick = e => {
      this.foundation.handleClick(e);
    };
    this.getDataForKeyNotInKeyEntities = key => {
      return this.foundation.getDataForKeyNotInKeyEntities(key);
    };
    /* istanbul ignore next */
    this.handleSelectionEnterPress = e => {
      this.foundation.handleSelectionEnterPress(e);
    };
    this.hasValue = () => {
      const {
        multiple,
        checkRelation
      } = this.props;
      const {
        realCheckedKeys,
        checkedKeys,
        selectedKeys
      } = this.state;
      let hasValue = false;
      if (multiple) {
        if (checkRelation === 'related') {
          hasValue = Boolean(checkedKeys.size);
        } else if (checkRelation === 'unRelated') {
          hasValue = Boolean(realCheckedKeys.size);
        }
      } else {
        hasValue = Boolean(selectedKeys.length);
      }
      return hasValue;
    };
    this.showClearBtn = () => {
      const {
        showClear,
        disabled,
        searchPosition
      } = this.props;
      const {
        inputValue,
        isOpen,
        isHovering
      } = this.state;
      const triggerSearchHasInputValue = searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER && inputValue;
      return showClear && (this.hasValue() || triggerSearchHasInputValue) && !disabled && (isOpen || isHovering);
    };
    this.renderTagList = triggerRenderKeys => {
      const {
        keyEntities,
        disabledKeys
      } = this.state;
      const {
        treeNodeLabelProp,
        leafOnly,
        disabled,
        disableStrictly,
        size,
        renderSelectedItem: propRenderSelectedItem,
        keyMaps
      } = this.props;
      const realLabelName = get_default()(keyMaps, 'label', treeNodeLabelProp);
      const renderSelectedItem = isFunction_default()(propRenderSelectedItem) ? propRenderSelectedItem : item => ({
        isRenderInTag: true,
        content: get_default()(item, realLabelName, null)
      });
      const tagList = [];
      triggerRenderKeys.forEach((key, index) => {
        const item = keyEntities[key] && keyEntities[key].key === key ? keyEntities[key].data : this.getDataForKeyNotInKeyEntities(key);
        const onClose = (tagContent, e) => {
          if (e && typeof e.preventDefault === 'function') {
            // make sure that tag will not hidden immediately in controlled mode
            e.preventDefault();
          }
          this.removeTag(key);
        };
        const {
          content,
          isRenderInTag
        } = item ? renderSelectedItem(item, {
          index,
          onClose
        }) : {};
        if (isNull_default()(content) || isUndefined_default()(content)) {
          return;
        }
        const isDisabled = disabled || item.disabled || disableStrictly && disabledKeys.has(item.key);
        const tag = {
          closable: !isDisabled,
          color: 'white',
          visible: true,
          onClose,
          key: `tag-${key}-${index}`,
          size: size === 'small' ? 'small' : 'large'
        };
        if (isRenderInTag) {
          // pass ReactNode list to tagList when using tagGroup custom mode
          tagList.push( /*#__PURE__*/react.createElement(Tag, Object.assign({}, tag), content));
        } else {
          tagList.push(content);
        }
      });
      return tagList;
    };
    /**
     * When single selection and the search box is on trigger, the items displayed in the rendered search box
     */
    this.renderSingleTriggerSearchItem = () => {
      const {
        placeholder,
        disabled
      } = this.props;
      const {
        inputTriggerFocus
      } = this.state;
      const renderText = this.foundation.getRenderTextInSingle();
      const spanCls = classnames_default()(`${treeSelect_prefixcls}-selection-TriggerSearchItem`, {
        [`${treeSelect_prefixcls}-selection-TriggerSearchItem-placeholder`]: (inputTriggerFocus || !renderText) && !disabled,
        [`${treeSelect_prefixcls}-selection-TriggerSearchItem-disabled`]: disabled
      });
      return /*#__PURE__*/react.createElement("span", {
        className: spanCls,
        onClick: this.foundation.onClickSingleTriggerSearchItem
      }, renderText ? renderText : placeholder);
    };
    /**
     * Single selection and the search box content rendered when the search box is on trigger
     */
    this.renderSingleTriggerSearch = () => {
      const {
        inputValue
      } = this.state;
      return /*#__PURE__*/react.createElement(react.Fragment, null, this.renderInput(), !inputValue && this.renderSingleTriggerSearchItem());
    };
    this.renderSelectContent = triggerRenderKeys => {
      const {
        multiple,
        placeholder,
        maxTagCount,
        searchPosition,
        filterTreeNode,
        showRestTagsPopover,
        restTagsPopoverProps
      } = this.props;
      const isTriggerPositionSearch = filterTreeNode && searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER;
      // searchPosition = trigger
      if (isTriggerPositionSearch) {
        return multiple ? this.renderTagInput(triggerRenderKeys) : this.renderSingleTriggerSearch();
      }
      // searchPosition = dropdown and single seleciton
      if (!multiple || !this.hasValue()) {
        const renderText = this.foundation.getRenderTextInSingle();
        const spanCls = classnames_default()(`${treeSelect_prefixcls}-selection-content`, {
          [`${treeSelect_prefixcls}-selection-placeholder`]: !renderText
        });
        return /*#__PURE__*/react.createElement("span", {
          className: spanCls
        }, renderText ? renderText : placeholder);
      }
      // searchPosition = dropdown and multiple seleciton
      const tagList = this.renderTagList(triggerRenderKeys);
      // mode=custom to return tagList directly
      return /*#__PURE__*/react.createElement(TagGroup, {
        maxTagCount: maxTagCount,
        tagList: tagList,
        size: "large",
        mode: "custom",
        showPopover: showRestTagsPopover,
        popoverProps: restTagsPopoverProps
      });
    };
    this.handleClear = e => {
      e && e.stopPropagation();
      this.foundation.handleClear(e);
    };
    /* istanbul ignore next */
    this.handleClearEnterPress = e => {
      e && e.stopPropagation();
      this.foundation.handleClearEnterPress(e);
    };
    this.handleMouseOver = e => {
      this.foundation.toggleHoverState(true);
    };
    this.handleMouseLeave = e => {
      this.foundation.toggleHoverState(false);
    };
    this.search = value => {
      const {
        isOpen
      } = this.state;
      if (!isOpen) {
        this.foundation.open();
      }
      this.foundation.handleInputChange(value);
    };
    this.close = () => {
      this.foundation.close(null);
    };
    this.renderArrow = () => {
      const showClearBtn = this.showClearBtn();
      const {
        arrowIcon
      } = this.props;
      if (showClearBtn) {
        return null;
      }
      return arrowIcon ? /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(`${treeSelect_prefixcls}-arrow`),
        "x-semi-prop": "arrowIcon"
      }, arrowIcon) : null;
    };
    this.renderClearBtn = () => {
      const showClearBtn = this.showClearBtn();
      const {
        clearIcon
      } = this.props;
      const clearCls = classnames_default()(`${treeSelect_prefixcls}-clearbtn`);
      if (showClearBtn) {
        return /*#__PURE__*/react.createElement("div", {
          role: 'button',
          tabIndex: 0,
          "aria-label": "Clear TreeSelect value",
          className: clearCls,
          onClick: this.handleClear,
          onKeyPress: this.handleClearEnterPress
        }, clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, null));
      }
      return null;
    };
    this.renderSelection = () => {
      const _a = this.props,
        {
          disabled,
          multiple,
          filterTreeNode,
          validateStatus,
          prefix,
          suffix,
          style,
          size,
          insetLabel,
          className,
          placeholder,
          showClear,
          leafOnly,
          searchPosition,
          triggerRender,
          borderless,
          autoMergeValue,
          checkRelation
        } = _a,
        rest = treeSelect_rest(_a, ["disabled", "multiple", "filterTreeNode", "validateStatus", "prefix", "suffix", "style", "size", "insetLabel", "className", "placeholder", "showClear", "leafOnly", "searchPosition", "triggerRender", "borderless", "autoMergeValue", "checkRelation"]);
      const {
        inputValue,
        selectedKeys,
        checkedKeys,
        keyEntities,
        isFocus,
        realCheckedKeys
      } = this.state;
      const filterable = Boolean(filterTreeNode);
      const useCustomTrigger = typeof triggerRender === 'function';
      const mouseEvent = showClear ? {
        onMouseEnter: e => this.handleMouseOver(e),
        onMouseLeave: e => this.handleMouseLeave(e)
      } : {};
      const isTriggerPositionSearch = searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER && filterable;
      const isEmptyTriggerSearch = isTriggerPositionSearch && isEmpty_default()(checkedKeys);
      const isValueTriggerSearch = isTriggerPositionSearch && !isEmpty_default()(checkedKeys);
      const classNames = useCustomTrigger ? classnames_default()(className) : classnames_default()(treeSelect_prefixcls, {
        [`${treeSelect_prefixcls}-borderless`]: borderless,
        [`${treeSelect_prefixcls}-focus`]: isFocus,
        [`${treeSelect_prefixcls}-disabled`]: disabled,
        [`${treeSelect_prefixcls}-single`]: !multiple,
        [`${treeSelect_prefixcls}-multiple`]: multiple,
        [`${treeSelect_prefixcls}-multiple-tagInput-empty`]: multiple && isEmptyTriggerSearch,
        [`${treeSelect_prefixcls}-multiple-tagInput-notEmpty`]: multiple && isValueTriggerSearch,
        [`${treeSelect_prefixcls}-filterable`]: filterable,
        [`${treeSelect_prefixcls}-error`]: validateStatus === 'error',
        [`${treeSelect_prefixcls}-warning`]: validateStatus === 'warning',
        [`${treeSelect_prefixcls}-small`]: size === 'small',
        [`${treeSelect_prefixcls}-large`]: size === 'large',
        [`${treeSelect_prefixcls}-with-prefix`]: prefix || insetLabel,
        [`${treeSelect_prefixcls}-with-suffix`]: suffix,
        [`${treeSelect_prefixcls}-with-suffix`]: suffix
      }, className);
      let inner;
      let triggerRenderKeys = [];
      if (multiple) {
        if (!autoMergeValue) {
          triggerRenderKeys = [...checkedKeys];
        } else if (checkRelation === 'related') {
          triggerRenderKeys = normalizeKeyList([...checkedKeys], keyEntities, leafOnly, true);
        } else if (checkRelation === 'unRelated') {
          triggerRenderKeys = [...realCheckedKeys];
        }
      } else {
        triggerRenderKeys = selectedKeys;
      }
      if (useCustomTrigger) {
        inner = /*#__PURE__*/react.createElement(trigger, {
          inputValue: inputValue,
          value: triggerRenderKeys.map(key => get_default()(keyEntities, [key, 'data'])),
          disabled: disabled,
          placeholder: placeholder,
          onClear: this.handleClear,
          componentName: 'TreeSelect',
          triggerRender: triggerRender,
          componentProps: Object.assign({}, this.props),
          onSearch: this.search,
          onRemove: this.removeTag
        });
      } else {
        inner = [/*#__PURE__*/react.createElement(react.Fragment, {
          key: 'prefix'
        }, prefix || insetLabel ? this.renderPrefix() : null), /*#__PURE__*/react.createElement(react.Fragment, {
          key: 'selection'
        }, /*#__PURE__*/react.createElement("div", {
          className: `${treeSelect_prefixcls}-selection`
        }, this.renderSelectContent(triggerRenderKeys))), /*#__PURE__*/react.createElement(react.Fragment, {
          key: 'suffix'
        }, suffix ? this.renderSuffix() : null), /*#__PURE__*/react.createElement(react.Fragment, {
          key: 'clearBtn'
        }, showClear || isTriggerPositionSearch && inputValue ? this.renderClearBtn() : null), /*#__PURE__*/react.createElement(react.Fragment, {
          key: 'arrow'
        }, this.renderArrow())];
      }
      const tabIndex = disabled ? null : 0;
      /**
       * Reasons for disabling the a11y eslint rule:
       * The following attributes(aria-controls,aria-expanded) will be automatically added by Tooltip, no need to declare here
       */
      return /*#__PURE__*/react.createElement("div", Object.assign({
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: 'combobox',
        "aria-disabled": disabled,
        "aria-haspopup": "tree",
        tabIndex: tabIndex,
        className: classNames,
        style: style,
        ref: this.triggerRef,
        onClick: this.handleClick,
        onKeyPress: this.handleSelectionEnterPress,
        "aria-invalid": this.props['aria-invalid'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-required": this.props['aria-required']
      }, mouseEvent, this.getDataAttr(rest)), inner);
    };
    this.renderTagItem = (key, idx) => {
      const {
        keyEntities,
        disabledKeys
      } = this.state;
      const {
        size,
        leafOnly,
        disabled,
        disableStrictly,
        renderSelectedItem: propRenderSelectedItem,
        treeNodeLabelProp,
        keyMaps
      } = this.props;
      const realLabelName = get_default()(keyMaps, 'label', treeNodeLabelProp);
      const keyList = normalizeKeyList([key], keyEntities, leafOnly, true);
      const nodes = keyList.map(i => keyEntities[key] && keyEntities[key].key === key ? keyEntities[key].data : this.getDataForKeyNotInKeyEntities(key));
      const value = getValueOrKey(nodes, keyMaps);
      const tagCls = classnames_default()(`${treeSelect_prefixcls}-selection-tag`, {
        [`${treeSelect_prefixcls}-selection-tag-disabled`]: disabled
      });
      const nodeHaveData = !isEmpty_default()(nodes) && !isEmpty_default()(nodes[0]);
      const isDisableStrictlyNode = disableStrictly && nodeHaveData && disabledKeys.has(nodes[0].key);
      const closable = nodeHaveData && !nodes[0].disabled && !disabled && !isDisableStrictlyNode;
      const onClose = (tagChildren, e) => {
        // When value has not changed, prevent clicking tag closeBtn to close tag
        e.preventDefault();
        this.removeTag(key);
      };
      const tagProps = {
        size: size === 'small' ? 'small' : 'large',
        key: `tag-${value}-${idx}`,
        color: 'white',
        className: tagCls,
        closable,
        onClose
      };
      const item = nodes[0];
      const renderSelectedItem = isFunction_default()(propRenderSelectedItem) ? propRenderSelectedItem : selectedItem => ({
        isRenderInTag: true,
        content: get_default()(selectedItem, realLabelName, null)
      });
      if (isFunction_default()(renderSelectedItem)) {
        const {
          content,
          isRenderInTag
        } = item ? renderSelectedItem(item, {
          index: idx,
          onClose
        }) : {};
        if (isRenderInTag) {
          return /*#__PURE__*/react.createElement(Tag, Object.assign({}, tagProps), content);
        } else {
          return content;
        }
      }
      return /*#__PURE__*/react.createElement(Tag, Object.assign({}, tagProps), value);
    };
    this.renderTagInput = triggerRenderKeys => {
      const {
        disabled,
        size,
        searchAutoFocus,
        placeholder,
        maxTagCount,
        showRestTagsPopover,
        restTagsPopoverProps,
        searchPosition,
        filterTreeNode,
        preventScroll
      } = this.props;
      const {
        inputValue
      } = this.state;
      // auto focus search input divide into two parts
      // 1. filterTreeNode && searchPosition === strings.SEARCH_POSITION_TRIGGER
      //    Implemented by passing autofocus to the underlying input's autofocus
      // 2. filterTreeNode && searchPosition === strings.SEARCH_POSITION_DROPDOWN
      //    Due to the off-screen rendering in the tooltip implementation mechanism, if it is implemented through the 
      //    autofocus of the input, when the option panel is opened, the page will scroll to top, so it is necessary 
      //    to call the focus method through ref in the onVisibleChange callback of the Popover to achieve focus
      const autoFocus = filterTreeNode && searchPosition === treeSelect_constants_strings.SEARCH_POSITION_TRIGGER ? searchAutoFocus : undefined;
      return /*#__PURE__*/react.createElement(tagInput, {
        maxTagCount: maxTagCount,
        disabled: disabled,
        onInputChange: v => this.search(v),
        ref: this.tagInputRef,
        placeholder: placeholder,
        value: triggerRenderKeys,
        inputValue: inputValue,
        size: size,
        showRestTagsPopover: showRestTagsPopover,
        restTagsPopoverProps: restTagsPopoverProps,
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        renderTagItem: (itemKey, index) => this.renderTagItem(itemKey, index),
        onRemove: itemKey => this.removeTag(itemKey),
        expandRestTagsOnClick: false,
        preventScroll: preventScroll
      });
    };
    // render Tree
    this.renderInput = () => {
      const {
        searchPlaceholder,
        searchRender,
        showSearchClear,
        searchPosition,
        searchAutoFocus,
        multiple,
        disabled,
        preventScroll
      } = this.props;
      const isDropdownPositionSearch = searchPosition === treeSelect_constants_strings.SEARCH_POSITION_DROPDOWN;
      const inputcls = classnames_default()({
        [`${prefixTree}-input`]: isDropdownPositionSearch,
        [`${treeSelect_prefixcls}-inputTrigger`]: !isDropdownPositionSearch
      });
      const {
        inputValue
      } = this.state;
      const baseInputProps = {
        value: inputValue,
        className: inputcls,
        preventScroll,
        onChange: value => this.search(value)
      };
      const inputDropdownProps = {
        showClear: showSearchClear,
        prefix: /*#__PURE__*/react.createElement(IconSearch, null)
      };
      const inputTriggerProps = {
        autofocus: searchAutoFocus,
        onFocus: e => this.foundation.handleInputTriggerFocus(),
        onBlur: e => this.foundation.handleInputTriggerBlur(),
        disabled
      };
      const realInputProps = isDropdownPositionSearch ? inputDropdownProps : inputTriggerProps;
      const wrapperCls = classnames_default()({
        [`${prefixTree}-search-wrapper`]: isDropdownPositionSearch,
        [`${treeSelect_prefixcls}-triggerSingleSearch-wrapper`]: !isDropdownPositionSearch && !multiple
      });
      const useCusSearch = typeof searchRender === 'function' || typeof searchRender === 'boolean';
      if (useCusSearch && !searchRender) {
        return null;
      }
      return /*#__PURE__*/react.createElement("div", {
        className: wrapperCls
      }, /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "TreeSelect"
      }, locale => {
        const placeholder = isDropdownPositionSearch ? searchPlaceholder || locale.searchPlaceholder : '';
        if (useCusSearch) {
          return searchRender(Object.assign(Object.assign(Object.assign({}, realInputProps), baseInputProps), {
            placeholder
          }));
        }
        return /*#__PURE__*/react.createElement(es_input, Object.assign({
          "aria-label": 'Filter TreeSelect item',
          ref: this.inputRef,
          placeholder: placeholder
        }, baseInputProps, realInputProps));
      }));
    };
    this.renderEmpty = () => {
      const {
        emptyContent
      } = this.props;
      if (emptyContent) {
        return /*#__PURE__*/react.createElement(TreeNode, {
          empty: true,
          emptyContent: this.props.emptyContent
        });
      } else {
        return /*#__PURE__*/react.createElement(LocaleConsumer, {
          componentName: "Tree"
        }, locale => /*#__PURE__*/react.createElement(TreeNode, {
          empty: true,
          emptyContent: locale.emptyText
        }));
      }
    };
    this.onNodeLoad = data => new Promise(resolve => this.foundation.setLoadKeys(data, resolve));
    this.onNodeSelect = (e, treeNode) => {
      this.foundation.handleNodeSelect(e, treeNode);
    };
    this.onNodeCheck = (e, treeNode) => {
      this.foundation.handleNodeSelect(e, treeNode);
    };
    this.onNodeExpand = (e, treeNode) => {
      this.foundation.handleNodeExpand(e, treeNode);
    };
    this.getTreeNodeRequiredProps = () => {
      const {
        expandedKeys,
        selectedKeys,
        checkedKeys,
        halfCheckedKeys,
        keyEntities,
        filteredKeys
      } = this.state;
      return {
        expandedKeys: expandedKeys || new Set(),
        selectedKeys: selectedKeys || [],
        checkedKeys: checkedKeys || new Set(),
        halfCheckedKeys: halfCheckedKeys || new Set(),
        filteredKeys: filteredKeys || new Set(),
        keyEntities
      };
    };
    this.getTreeNodeKey = treeNode => {
      const {
        data
      } = treeNode;
      const {
        key
      } = data;
      return key;
    };
    /* Event handler function after popover visible change */
    this.handlePopoverVisibleChange = isVisible => {
      this.foundation.handlePopoverVisibleChange(isVisible);
    };
    this.afterClose = () => {
      this.foundation.handleAfterClose();
    };
    this.renderTreeNode = (treeNode, ind, style) => {
      const {
        data,
        key
      } = treeNode;
      const treeNodeProps = this.foundation.getTreeNodeProps(key);
      const {
        showLine
      } = this.props;
      if (!treeNodeProps) {
        return null;
      }
      const props = pick_default()(treeNode, ['key', 'label', 'disabled', 'isLeaf', 'icon', 'isEnd']);
      const {
        keyMaps
      } = this.props;
      const children = data[get_default()(keyMaps, 'children', 'children')];
      !isUndefined_default()(children) && (props.children = children);
      return /*#__PURE__*/react.createElement(TreeNode, Object.assign({}, treeNodeProps, data, props, {
        data: data,
        style: style,
        showLine: showLine
      }));
    };
    this.itemKey = (index, data) => {
      const {
        visibleOptions
      } = data;
      // Find the item at the specified index.
      const item = visibleOptions[index];
      // Return a value that uniquely identifies this item.
      return item.key;
    };
    this.renderNodeList = () => {
      const {
        flattenNodes,
        cachedFlattenNodes,
        motionKeys,
        motionType,
        filteredKeys
      } = this.state;
      const {
        direction
      } = this.context;
      const {
        virtualize,
        motionExpand
      } = this.props;
      const isExpandControlled = ('expandedKeys' in this.props);
      if (!virtualize || isEmpty_default()(virtualize)) {
        return /*#__PURE__*/react.createElement(NodeList, {
          flattenNodes: flattenNodes,
          flattenList: cachedFlattenNodes,
          motionKeys: motionExpand ? motionKeys : new Set([]),
          motionType: motionType,
          // When motionKeys is empty, but filteredKeys is not empty (that is, the search hits), this situation should be distinguished from ordinary motionKeys
          searchTargetIsDeep: isExpandControlled && motionExpand && isEmpty_default()(motionKeys) && !isEmpty_default()(filteredKeys),
          onMotionEnd: this.onMotionEnd,
          renderTreeNode: this.renderTreeNode
        });
      }
      const data = {
        visibleOptions: flattenNodes,
        renderOption: this.renderTreeNode
      };
      return /*#__PURE__*/react.createElement(AutoSizer, {
        defaultHeight: virtualize.height,
        defaultWidth: virtualize.width
      }, _ref => {
        let {
          height,
          width
        } = _ref;
        return /*#__PURE__*/react.createElement(FixedSizeList, {
          itemCount: flattenNodes.length,
          itemSize: virtualize.itemSize,
          height: height,
          width: width,
          // @ts-ignore avoid strict check of itemKey
          itemKey: this.itemKey,
          itemData: data,
          className: `${prefixTree}-virtual-list`,
          style: {
            direction
          }
        }, virtualRow);
      });
    };
    this.renderTree = () => {
      const {
        keyEntities,
        motionKeys,
        motionType,
        inputValue,
        filteredKeys,
        flattenNodes,
        checkedKeys,
        realCheckedKeys
      } = this.state;
      const {
        loadData,
        filterTreeNode,
        disabled,
        multiple,
        showFilteredOnly,
        motionExpand,
        outerBottomSlot,
        outerTopSlot,
        expandAction,
        labelEllipsis,
        virtualize,
        optionListStyle,
        searchPosition,
        renderLabel,
        renderFullLabel,
        checkRelation
      } = this.props;
      const wrapperCls = classnames_default()(`${prefixTree}-wrapper`);
      const listCls = classnames_default()(`${prefixTree}-option-list`, {
        [`${prefixTree}-option-list-block`]: true
      });
      const searchNoRes = Boolean(inputValue) && !filteredKeys.size;
      const noData = isEmpty_default()(flattenNodes) || showFilteredOnly && searchNoRes;
      const isDropdownPositionSearch = searchPosition === treeSelect_constants_strings.SEARCH_POSITION_DROPDOWN;
      return /*#__PURE__*/react.createElement(treeContext.Provider, {
        value: {
          loadData,
          treeDisabled: disabled,
          motion: motionExpand,
          motionKeys,
          motionType,
          expandAction,
          filterTreeNode,
          keyEntities,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          // tree node will call this function when treeNode is right clicked
          onNodeRightClick: (noop_default()),
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          renderTreeNode: this.renderTreeNode,
          multiple,
          showFilteredOnly,
          isSearching: Boolean(inputValue),
          renderLabel,
          renderFullLabel,
          labelEllipsis: typeof labelEllipsis === 'undefined' ? virtualize : labelEllipsis
        }
      }, /*#__PURE__*/react.createElement("div", {
        className: wrapperCls
      }, outerTopSlot, !outerTopSlot && filterTreeNode && isDropdownPositionSearch && this.renderInput(), /*#__PURE__*/react.createElement("div", {
        className: listCls,
        role: "tree",
        "aria-multiselectable": multiple ? true : false,
        style: optionListStyle
      }, noData ? this.renderEmpty() : multiple ? /*#__PURE__*/react.createElement(checkboxGroup, {
        value: Array.from(checkRelation === 'related' ? checkedKeys : realCheckedKeys)
      }, this.renderNodeList()) : this.renderNodeList()), outerBottomSlot));
    };
    this.state = {
      inputTriggerFocus: false,
      isOpen: false,
      isFocus: false,
      // isInput: false,
      rePosKey: treeSelect_key,
      dropdownMinWidth: null,
      inputValue: '',
      keyEntities: {},
      treeData: [],
      flattenNodes: [],
      cachedFlattenNodes: undefined,
      selectedKeys: [],
      checkedKeys: new Set(),
      halfCheckedKeys: new Set(),
      realCheckedKeys: new Set([]),
      disabledKeys: new Set(),
      motionKeys: new Set([]),
      motionType: 'hide',
      expandedKeys: new Set(props.expandedKeys),
      filteredKeys: new Set(),
      filteredExpandedKeys: new Set(),
      filteredShownKeys: new Set(),
      prevProps: null,
      isHovering: false,
      cachedKeyValuePairs: {},
      loadedKeys: new Set(),
      loadingKeys: new Set()
    };
    this.inputRef = /*#__PURE__*/react.createRef();
    this.tagInputRef = /*#__PURE__*/react.createRef();
    this.triggerRef = /*#__PURE__*/react.createRef();
    this.optionsRef = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
    this.clearInputFlag = false;
    this.foundation = new TreeSelectFoundation(this.adapter);
    this.treeSelectID = Math.random().toString(36).slice(2);
    this.onMotionEnd = () => {
      this.adapter.rePositionDropdown();
    };
  }
  static getDerivedStateFromProps(props, prevState) {
    const {
      prevProps,
      rePosKey
    } = prevState;
    const {
      keyMaps
    } = props;
    const needUpdate = name => !prevProps && name in props || prevProps && !isEqual_default()(prevProps[name], props[name]);
    let treeData;
    const withObject = props.onChangeWithObject;
    let keyEntities = prevState.keyEntities || {};
    let valueEntities = prevState.cachedKeyValuePairs || {};
    const newState = {
      prevProps: props
    };
    const needUpdateTreeData = needUpdate('treeData');
    const needUpdateExpandedKeys = needUpdate('expandedKeys');
    const isExpandControlled = ('expandedKeys' in props);
    const isSearching = Boolean(props.filterTreeNode && prevState.inputValue && prevState.inputValue.length);
    // TreeNode
    if (needUpdateTreeData) {
      treeData = props.treeData;
      newState.treeData = treeData;
      const entitiesMap = convertDataToEntities(treeData, keyMaps);
      newState.keyEntities = Object.assign({}, entitiesMap.keyEntities);
      keyEntities = newState.keyEntities;
      newState.cachedKeyValuePairs = Object.assign({}, entitiesMap.valueEntities);
      valueEntities = newState.cachedKeyValuePairs;
    }
    // if treeData keys changes, we won't show animation
    if (treeData && props.motion && !isEqual_default()(Object.keys(newState.keyEntities), Object.keys(prevState.keyEntities))) {
      if (prevProps && props.motion) {
        newState.motionKeys = new Set([]);
        newState.motionType = null;
      }
    }
    const expandAllWhenDataChange = needUpdateTreeData && props.expandAll;
    if (!isSearching) {
      // expandedKeys
      if (needUpdateExpandedKeys || prevProps && needUpdate('autoExpandParent')) {
        newState.expandedKeys = calcExpandedKeys(props.expandedKeys, keyEntities, props.autoExpandParent || !prevProps);
        // only show animation when treeData does not change
        if (prevProps && props.motion && !treeData) {
          const {
            motionKeys,
            motionType
          } = calcMotionKeys(prevState.expandedKeys, newState.expandedKeys, keyEntities);
          newState.motionKeys = new Set(motionKeys);
          newState.motionType = motionType;
          if (motionType === 'hide') {
            // cache flatten nodes: expandedKeys changed may not be triggered by interaction
            newState.cachedFlattenNodes = treeUtil_cloneDeep(prevState.flattenNodes);
          }
        }
      } else if (!prevProps && (props.defaultExpandAll || props.expandAll) || expandAllWhenDataChange) {
        newState.expandedKeys = new Set(Object.keys(keyEntities));
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = calcExpandedKeys(props.defaultExpandedKeys, keyEntities);
      } else if (!prevProps && props.defaultValue) {
        newState.expandedKeys = calcExpandedKeysForValues(normalizeValue(props.defaultValue, withObject, keyMaps), keyEntities, props.multiple, valueEntities);
      } else if (!prevProps && props.value) {
        newState.expandedKeys = calcExpandedKeysForValues(normalizeValue(props.value, withObject, keyMaps), keyEntities, props.multiple, valueEntities);
      }
      if (!newState.expandedKeys) {
        delete newState.expandedKeys;
      }
      if (treeData || newState.expandedKeys) {
        const flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, keyMaps);
        newState.flattenNodes = flattenNodes;
      }
    } else {
      let filteredState;
      // treeData changed while searching
      if (treeData) {
        // Get filter data
        filteredState = filterTreeData({
          treeData,
          inputValue: prevState.inputValue,
          filterTreeNode: props.filterTreeNode,
          filterProps: props.treeNodeFilterProp,
          showFilteredOnly: props.showFilteredOnly,
          keyEntities: newState.keyEntities,
          prevExpandedKeys: [...prevState.filteredExpandedKeys],
          keyMaps: keyMaps
        });
        newState.flattenNodes = filteredState.flattenNodes;
        newState.motionKeys = new Set([]);
        newState.filteredKeys = filteredState.filteredKeys;
        newState.filteredShownKeys = filteredState.filteredShownKeys;
        newState.filteredExpandedKeys = filteredState.filteredExpandedKeys;
      }
      // expandedKeys changed while searching
      if (props.expandedKeys) {
        newState.filteredExpandedKeys = calcExpandedKeys(props.expandedKeys, keyEntities, props.autoExpandParent || !prevProps);
        if (prevProps && props.motion) {
          const prevKeys = prevState ? prevState.filteredExpandedKeys : new Set([]);
          // only show animation when treeData does not change
          if (!treeData) {
            const motionResult = calcMotionKeys(prevKeys, newState.filteredExpandedKeys, keyEntities);
            let {
              motionKeys
            } = motionResult;
            const {
              motionType
            } = motionResult;
            if (props.showFilteredOnly) {
              motionKeys = motionKeys.filter(key => prevState.filteredShownKeys.has(key));
            }
            if (motionType === 'hide') {
              // cache flatten nodes: expandedKeys changed may not be triggered by interaction
              newState.cachedFlattenNodes = treeUtil_cloneDeep(prevState.flattenNodes);
            }
            newState.motionKeys = new Set(motionKeys);
            newState.motionType = motionType;
          }
        }
        newState.flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.filteredExpandedKeys || prevState.filteredExpandedKeys, keyMaps, props.showFilteredOnly && prevState.filteredShownKeys);
      }
    }
    // selectedKeys: single mode controlled
    const isMultiple = props.multiple;
    if (!isMultiple) {
      if (needUpdate('value')) {
        newState.selectedKeys = findKeysForValues(normalizeValue(props.value, withObject, keyMaps), valueEntities, isMultiple);
      } else if (!prevProps && props.defaultValue) {
        newState.selectedKeys = findKeysForValues(normalizeValue(props.defaultValue, withObject, keyMaps), valueEntities, isMultiple);
      } else if (treeData) {
        // If `treeData` changed, we also need check it
        if (props.value) {
          newState.selectedKeys = findKeysForValues(normalizeValue(props.value, withObject, keyMaps) || '', valueEntities, isMultiple);
        } else {
          newState.selectedKeys = updateKeys(prevState.selectedKeys, keyEntities);
        }
      }
    } else {
      // checkedKeys: multiple mode controlled || data changed
      let checkedKeyValues;
      if (needUpdate('value')) {
        checkedKeyValues = findKeysForValues(normalizeValue(props.value, withObject, keyMaps), valueEntities, isMultiple);
      } else if (!prevProps && props.defaultValue) {
        checkedKeyValues = findKeysForValues(normalizeValue(props.defaultValue, withObject, keyMaps), valueEntities, isMultiple);
      } else if (treeData) {
        // If `treeData` changed, we also need check it
        if (props.value) {
          checkedKeyValues = findKeysForValues(normalizeValue(props.value, withObject, keyMaps) || [], valueEntities, isMultiple);
        } else {
          checkedKeyValues = updateKeys(props.checkRelation === 'related' ? prevState.checkedKeys : prevState.realCheckedKeys, keyEntities);
        }
      }
      if (checkedKeyValues) {
        if (props.checkRelation === 'unRelated') {
          newState.realCheckedKeys = new Set(checkedKeyValues);
        } else if (props.checkRelation === 'related') {
          const {
            checkedKeys,
            halfCheckedKeys
          } = calcCheckedKeys(checkedKeyValues, keyEntities);
          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }
    }
    // loadedKeys
    if (needUpdate('loadedKeys')) {
      newState.loadedKeys = new Set(props.loadedKeys);
    }
    // ================== rePosKey ==================
    if (needUpdateTreeData || needUpdate('value')) {
      newState.rePosKey = rePosKey + 1;
    }
    // ================ disableStrictly =================
    if (treeData && props.disableStrictly && props.checkRelation === 'related') {
      newState.disabledKeys = calcDisabledKeys(keyEntities, keyMaps);
    }
    return newState;
  }
  get adapter() {
    var _this = this;
    const filterAdapter = {
      updateInputValue: value => {
        this.setState({
          inputValue: value
        });
      }
    };
    const treeSelectAdapter = {
      registerClickOutsideHandler: cb => {
        this.adapter.unregisterClickOutsideHandler();
        const clickOutsideHandler = e => {
          const optionInstance = this.optionsRef && this.optionsRef.current;
          const triggerDom = this.triggerRef && this.triggerRef.current;
          const optionsDom = react_dom.findDOMNode(optionInstance);
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (optionsDom && (!optionsDom.contains(target) || !optionsDom.contains(target.parentNode)) && triggerDom && !triggerDom.contains(target) && !(path.includes(triggerDom) || path.includes(optionsDom))) {
            cb(e);
          }
        };
        this.clickOutsideHandler = clickOutsideHandler;
        document.addEventListener('mousedown', clickOutsideHandler, false);
      },
      unregisterClickOutsideHandler: () => {
        if (!this.clickOutsideHandler) {
          return;
        }
        document.removeEventListener('mousedown', this.clickOutsideHandler, false);
        this.clickOutsideHandler = null;
      },
      rePositionDropdown: () => {
        let {
          rePosKey
        } = this.state;
        rePosKey = rePosKey + 1;
        this.setState({
          rePosKey
        });
      }
    };
    const treeAdapter = {
      updateState: states => {
        this.setState(Object.assign({}, states));
      },
      notifySelect: (selectKey, bool, node) => {
        this.props.onSelect && this.props.onSelect(selectKey, bool, node);
      },
      notifySearch: (input, filteredExpandedKeys, filteredNodes) => {
        this.props.onSearch && this.props.onSearch(input, filteredExpandedKeys, filteredNodes);
      },
      cacheFlattenNodes: bool => {
        this.setState({
          cachedFlattenNodes: bool ? treeUtil_cloneDeep(this.state.flattenNodes) : undefined
        });
      },
      notifyLoad: (newLoadedKeys, data) => {
        const {
          onLoad
        } = this.props;
        isFunction_default()(onLoad) && onLoad(newLoadedKeys, data);
      },
      notifyClear: e => {
        this.props.onClear && this.props.onClear(e);
      }
    };
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, super.adapter), filterAdapter), treeSelectAdapter), treeAdapter), {
      updateLoadKeys: (data, resolve) => {
        this.setState(_ref2 => {
          let {
            loadedKeys,
            loadingKeys
          } = _ref2;
          return this.foundation.handleNodeLoad(loadedKeys, loadingKeys, data, resolve);
        });
      },
      updateState: states => {
        this.setState(Object.assign({}, states));
      },
      openMenu: () => {
        this.setState({
          isOpen: true
        }, () => {
          this.props.onVisibleChange(true);
        });
      },
      closeMenu: cb => {
        this.setState({
          isOpen: false
        }, () => {
          cb && cb();
          this.props.onVisibleChange(false);
        });
      },
      getTriggerWidth: () => {
        const el = this.triggerRef.current;
        return el && el.getBoundingClientRect().width;
      },
      setOptionWrapperWidth: width => {
        this.setState({
          dropdownMinWidth: width
        });
      },
      notifyChange: (value, node, e) => {
        this.props.onChange && this.props.onChange(value, node, e);
      },
      notifyChangeWithObject: (node, e) => {
        this.props.onChange && this.props.onChange(node, e);
      },
      notifyExpand: (expandedKeys, _ref3) => {
        let {
          expanded: bool,
          node
        } = _ref3;
        this.props.onExpand && this.props.onExpand([...expandedKeys], {
          expanded: bool,
          node
        });
        if (bool && this.props.loadData) {
          this.onNodeLoad(node);
        }
      },
      notifyFocus: function () {
        _this.props.onFocus && _this.props.onFocus(...arguments);
      },
      notifyBlur: function () {
        _this.props.onBlur && _this.props.onBlur(...arguments);
      },
      toggleHovering: bool => {
        this.setState({
          isHovering: bool
        });
      },
      updateInputFocus: bool => {
        if (bool) {
          if (this.inputRef && this.inputRef.current) {
            const {
              preventScroll
            } = this.props;
            this.inputRef.current.focus({
              preventScroll
            });
          }
          if (this.tagInputRef && this.tagInputRef.current) {
            this.tagInputRef.current.focus();
          }
        } else {
          if (this.inputRef && this.inputRef.current) {
            this.inputRef.current.blur();
          }
          if (this.tagInputRef && this.tagInputRef.current) {
            this.tagInputRef.current.blur();
          }
        }
      },
      updateIsFocus: bool => {
        this.setState({
          isFocus: bool
        });
      },
      setClearInputFlag: flag => {
        this.clearInputFlag = flag;
      },
      getClearInputFlag: () => {
        return this.clearInputFlag;
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const content = this.renderContent();
    const {
      motion,
      zIndex,
      mouseLeaveDelay,
      mouseEnterDelay,
      autoAdjustOverflow,
      stopPropagation,
      getPopupContainer,
      dropdownMargin,
      position
    } = this.props;
    const {
      isOpen,
      rePosKey
    } = this.state;
    const selection = this.renderSelection();
    const pos = position ? position : 'bottomLeft';
    return /*#__PURE__*/react.createElement(popover, {
      stopPropagation: stopPropagation,
      getPopupContainer: getPopupContainer,
      zIndex: zIndex,
      motion: motion,
      margin: dropdownMargin,
      ref: this.optionsRef,
      content: content,
      visible: isOpen,
      trigger: "custom",
      rePosKey: rePosKey,
      position: pos,
      autoAdjustOverflow: autoAdjustOverflow,
      mouseLeaveDelay: mouseLeaveDelay,
      mouseEnterDelay: mouseEnterDelay,
      onVisibleChange: this.handlePopoverVisibleChange,
      afterClose: this.afterClose
    }, selection);
  }
}
TreeSelect.contextType = context;
TreeSelect.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  borderless: (prop_types_default()).bool,
  loadedKeys: prop_types_default().arrayOf((prop_types_default()).string),
  loadData: (prop_types_default()).func,
  onLoad: (prop_types_default()).func,
  arrowIcon: (prop_types_default()).node,
  clearIcon: (prop_types_default()).node,
  defaultOpen: (prop_types_default()).bool,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array, (prop_types_default()).object]),
  defaultExpandAll: (prop_types_default()).bool,
  defaultExpandedKeys: (prop_types_default()).array,
  expandAll: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  disableStrictly: (prop_types_default()).bool,
  // Whether to turn on the input box filtering function, when it is a function, it represents a custom filtering function
  filterTreeNode: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  multiple: (prop_types_default()).bool,
  searchPlaceholder: (prop_types_default()).string,
  searchAutoFocus: (prop_types_default()).bool,
  virtualize: (prop_types_default()).object,
  treeNodeFilterProp: (prop_types_default()).string,
  onChange: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  onSearch: (prop_types_default()).func,
  onSelect: (prop_types_default()).func,
  onExpand: (prop_types_default()).func,
  onChangeWithObject: (prop_types_default()).bool,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array, (prop_types_default()).object]),
  expandedKeys: (prop_types_default()).array,
  autoExpandParent: (prop_types_default()).bool,
  showClear: (prop_types_default()).bool,
  showSearchClear: (prop_types_default()).bool,
  autoAdjustOverflow: (prop_types_default()).bool,
  showFilteredOnly: (prop_types_default()).bool,
  showLine: (prop_types_default()).bool,
  motionExpand: (prop_types_default()).bool,
  emptyContent: (prop_types_default()).node,
  keyMaps: (prop_types_default()).object,
  leafOnly: (prop_types_default()).bool,
  treeData: prop_types_default().arrayOf(prop_types_default().shape({
    key: (prop_types_default()).string,
    value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    label: (prop_types_default()).any
  })),
  dropdownClassName: (prop_types_default()).string,
  dropdownStyle: (prop_types_default()).object,
  dropdownMargin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  motion: (prop_types_default()).bool,
  placeholder: (prop_types_default()).string,
  maxTagCount: (prop_types_default()).number,
  size: prop_types_default().oneOf(treeSelect_constants_strings.SIZE_SET),
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  treeNodeLabelProp: (prop_types_default()).string,
  suffix: (prop_types_default()).node,
  prefix: (prop_types_default()).node,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  zIndex: (prop_types_default()).number,
  getPopupContainer: (prop_types_default()).func,
  dropdownMatchSelectWidth: (prop_types_default()).bool,
  validateStatus: prop_types_default().oneOf(treeSelect_constants_strings.STATUS),
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  triggerRender: (prop_types_default()).func,
  stopPropagation: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  outerBottomSlot: (prop_types_default()).node,
  outerTopSlot: (prop_types_default()).node,
  onVisibleChange: (prop_types_default()).func,
  expandAction: prop_types_default().oneOf(['click', 'doubleClick', false]),
  searchPosition: prop_types_default().oneOf([treeSelect_constants_strings.SEARCH_POSITION_DROPDOWN, treeSelect_constants_strings.SEARCH_POSITION_TRIGGER]),
  clickToHide: (prop_types_default()).bool,
  renderLabel: (prop_types_default()).func,
  renderFullLabel: (prop_types_default()).func,
  labelEllipsis: (prop_types_default()).bool,
  optionListStyle: (prop_types_default()).object,
  searchRender: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  renderSelectedItem: (prop_types_default()).func,
  checkRelation: (prop_types_default()).string,
  'aria-label': (prop_types_default()).string,
  showRestTagsPopover: (prop_types_default()).bool,
  restTagsPopoverProps: (prop_types_default()).object,
  preventScroll: (prop_types_default()).bool,
  clickTriggerToHide: (prop_types_default()).bool,
  autoMergeValue: (prop_types_default()).bool
};
TreeSelect.defaultProps = {
  borderless: false,
  searchPosition: treeSelect_constants_strings.SEARCH_POSITION_DROPDOWN,
  arrowIcon: /*#__PURE__*/react.createElement(IconChevronDown, null),
  autoExpandParent: false,
  autoAdjustOverflow: true,
  stopPropagation: true,
  motion: true,
  motionExpand: true,
  expandAll: false,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  disableStrictly: false,
  multiple: false,
  filterTreeNode: false,
  size: 'default',
  treeNodeFilterProp: 'label',
  onChangeWithObject: false,
  treeNodeLabelProp: 'label',
  dropdownMatchSelectWidth: true,
  defaultOpen: false,
  showSearchClear: true,
  showClear: false,
  onVisibleChange: (noop_default()),
  expandAction: false,
  clickToHide: true,
  searchAutoFocus: false,
  checkRelation: 'related',
  'aria-label': 'TreeSelect',
  showRestTagsPopover: false,
  restTagsPopoverProps: {},
  clickTriggerToHide: true,
  autoMergeValue: true
};
/* harmony default export */ var treeSelect = (TreeSelect);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isObject.js
function isObject_isObject(obj) {
  return obj !== null && typeof obj === 'object';
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isPromise.js

function isPromise(value) {
  return isObject_isObject(value) && typeof value.then === 'function';
}
;// CONCATENATED MODULE: ./node_modules/async-validator/dist-web/index.js
/* provided dependency */ var dist_web_process = __webpack_require__(83454);
function dist_web_extends() {
  dist_web_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return dist_web_extends.apply(this, arguments);
}

function dist_web_inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  dist_web_setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function dist_web_setPrototypeOf(o, p) {
  dist_web_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return dist_web_setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) dist_web_setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return dist_web_setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/* eslint no-console:0 */
var formatRegExp = /%[sdj%]/g;
var dist_web_warning = function warning() {}; // don't print warning message when in production env or node runtime

if (typeof dist_web_process !== 'undefined' && dist_web_process.env && "production" !== 'production' && 0 && 0) {}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;

  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }

  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }

      if (i >= len) {
        return x;
      }

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

          break;

        default:
          return x;
      }
    });
    return str;
  }

  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }

  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }

  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }

  return false;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;

    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }

    var original = index;
    index = index + 1;

    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

var AsyncValidationError = /*#__PURE__*/function (_Error) {
  dist_web_inheritsLoose(AsyncValidationError, _Error);

  function AsyncValidationError(errors, fields) {
    var _this;

    _this = _Error.call(this, 'Async Validation Error') || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }

  return AsyncValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var _pending = new Promise(function (resolve, reject) {
      var next = function next(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve();
      };

      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });

    _pending["catch"](function (e) {
      return e;
    });

    return _pending;
  }

  var firstFields = option.firstFields || [];

  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }

  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;

      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve();
      }
    };

    if (!objArrKeys.length) {
      callback(results);
      resolve();
    }

    objArrKeys.forEach(function (key) {
      var arr = objArr[key];

      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function (e) {
    return e;
  });
  return pending;
}
function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }

    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];

        if (typeof value === 'object' && typeof target[s] === 'object') {
          target[s] = dist_web_extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }

  return target;
}

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
}

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
}

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var dist_web_types = {
  integer: function integer(value) {
    return dist_web_types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return dist_web_types.number(value) && !dist_web_types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }

    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }

    return typeof value === 'number';
  },
  object: function object(value) {
    return typeof value === 'object' && !dist_web_types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};
/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    required(rule, value, source, errors, options);
    return;
  }

  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;

  if (custom.indexOf(ruleType) > -1) {
    if (!dist_web_types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    } // straight typeof check

  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）

  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);

  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  } // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type


  if (!key) {
    return false;
  }

  if (arr) {
    val = value.length;
  }

  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }

  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

var ENUM = 'enum';
/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];

  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function pattern$1(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;

      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);

      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

var rules = {
  required: required,
  whitespace: whitespace,
  type: type,
  range: range,
  "enum": enumerable,
  pattern: pattern$1
};

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'string');

    if (!isEmptyValue(value, 'string')) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);

      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }

  callback(errors);
}

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (value === '') {
      value = undefined;
    }

    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function _boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if ((value === undefined || value === null) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'array');

    if (value !== undefined && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

var ENUM$1 = 'enum';
/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function enumerable$1(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules[ENUM$1](rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function pattern$2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'string')) {
      rules.pattern(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);

  if (validate) {
    if (isEmptyValue(value, 'date') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'date')) {
      var dateObject;

      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }

      rules.type(rule, dateObject, source, errors, options);

      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }

  callback(errors);
}

function required$1(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value;
  rules.required(rule, value, source, errors, options, type);
  callback(errors);
}

function type$1(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, ruleType);

    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Performs validation for any type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function any(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);
  }

  callback(errors);
}

var validators = {
  string: string,
  method: method,
  number: number,
  "boolean": _boolean,
  regexp: regexp,
  integer: integer,
  "float": floatFn,
  array: array,
  object: object,
  "enum": enumerable$1,
  pattern: pattern$2,
  date: date,
  url: type$1,
  hex: type$1,
  email: type$1,
  required: required$1,
  any: any
};

function newMessages() {
  return {
    "default": 'Validation error on field %s',
    required: '%s is required',
    "enum": '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      "boolean": '%s is not a %s',
      integer: '%s is not an %s',
      "float": '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */

function Schema(descriptor) {
  this.rules = null;
  this._messages = messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }

    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }

    if (typeof rules !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }

    this.rules = {};
    var z;
    var item;

    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_, o, oc) {
    var _this = this;

    if (o === void 0) {
      o = {};
    }

    if (oc === void 0) {
      oc = function oc() {};
    }

    var source = source_;
    var options = o;
    var callback = oc;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }

      return Promise.resolve();
    }

    function complete(results) {
      var i;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }

      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = convertFieldsError(errors);
      }

      callback(errors, fields);
    }

    if (options.messages) {
      var messages$1 = this.messages();

      if (messages$1 === messages) {
        messages$1 = newMessages();
      }

      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }

    var arr;
    var value;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;

        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = dist_web_extends({}, source);
          }

          value = source[z] = rule.transform(value);
        }

        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = dist_web_extends({}, rule);
        }

        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);

        if (!rule.validator) {
          return;
        }

        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return dist_web_extends({}, schema, {
          fullField: rule.fullField + "." + key
        });
      }

      function cb(e) {
        if (e === void 0) {
          e = [];
        }

        var errors = e;

        if (!Array.isArray(errors)) {
          errors = [errors];
        }

        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }

        if (errors.length && rule.message !== undefined) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(complementError(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }

        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message !== undefined) {
              errors = [].concat(rule.message).map(complementError(rule));
            } else if (options.error) {
              errors = [options.error(rule, format(options.messages.required, rule.field))];
            }

            return doIt(errors);
          }

          var fieldsSchema = {};

          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }

          fieldsSchema = dist_web_extends({}, fieldsSchema, data.rule.fields);

          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }

          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);

          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }

          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];

            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }

            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }

            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res;

      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);

        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }

      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }

    if (typeof rule.validator !== 'function' && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format('Unknown rule type %s', rule.type));
    }

    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }

    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');

    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }

    if (keys.length === 1 && keys[0] === 'required') {
      return validators.required;
    }

    return validators[this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }

  validators[type] = validator;
};

Schema.warning = dist_web_warning;
Schema.messages = messages;
Schema.validators = validators;

/* harmony default export */ var dist_web = (Schema);
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/form/constants.js

const form_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-form`
};
const form_constants_strings = {
  LAYOUT: ['horizontal', 'vertical'],
  LABEL_POS: ['left', 'top', 'inset'],
  LABEL_ALIGN: ['left', 'right'],
  EXTRA_POS: ['middle', 'bottom'],
  DEFAULT_TRIGGER: 'change'
};
const form_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/form/utils.js

var form_utils_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



/**
 *
 * @param WrappedComponent React.ComponentType | any
 */
function getDisplayName(WrappedComponent) {
  const originName = WrappedComponent.displayName || WrappedComponent.name;
  return originName ? `SemiField${originName}` : 'SemiField';
}
function generateValidatesFromRules(field) {
  let rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const descriptor = {};
  descriptor[field] = rules;
  const validator = new dist_web(descriptor);
  return validator;
}
function isRequired() {
  let rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let required = false;
  if (typeof rules === 'object' && 'required' in rules) {
    required = rules.required;
  } else if (Array.isArray(rules) && rules.length) {
    rules.forEach(rule => {
      rule.required ? required = true : null;
    });
  }
  return required;
}
function utils_isValid(errors) {
  let valid = true;
  if (typeof errors === 'string' && errors.length) {
    valid = false;
  } else if (Array.isArray(errors) && errors.length) {
    valid = errors.every(error => utils_isValid(error));
  } else if (typeof errors === 'boolean') {
    valid = errors;
  } else if (errors && typeof errors.$$typeof === 'symbol' && errors.$$typeof.toString() === 'Symbol(react.element)') {
    // when error message is reactNode
    // only work with React Adapter
    valid = false;
  }
  return valid;
}
/**
 * trigger transform rule
    1. If the user has set fieldProps, follow the user's fieldProps
    2. If the user does not set fieldProps, follow formProps
    3. If there is no formProps, follow the change
    4. If it is an array, follow the array, if it is not an array (pure string), convert it to a string array
 */
function transformTrigger(fieldTrigger, formTrigger) {
  let result = [];
  let finalResult = [];
  if (!isUndefined_default()(fieldTrigger)) {
    result = fieldTrigger;
  } else if (!isUndefined_default()(formTrigger)) {
    result = formTrigger;
  } else {
    result = form_constants_strings.DEFAULT_TRIGGER;
  }
  if (Array.isArray(result)) {
    finalResult = result;
  }
  if (typeof result === 'string') {
    finalResult[0] = result;
  }
  return finalResult;
}
function transformDefaultBooleanAPI(fieldProp, formProp) {
  let defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!isUndefined_default()(fieldProp)) {
    return fieldProp;
  } else if (!isUndefined_default()(formProp)) {
    return formProp;
  } else {
    return defaultVal;
  }
}
function mergeOptions(opts, props) {
  // Opts: different types of component identification value, value change callback function may be inconsistent, used to adapt 1, input, select 2, radio, checkbox 3, switch
  // valueKey: input, select class component control value props are value, and checkbox, switch is checked
  // eg：checkbox、radio   { valueKey: 'checked', onKeyChangeFnName: 'onChange', valuePath: 'target.value' }
  const defaultOpts = {
    valueKey: 'value',
    onKeyChangeFnName: 'onChange',
    valuePath: '',
    maintainCursor: false,
    shouldInject: true,
    shouldMemo: true
  };
  const options = Object.assign(Object.assign({}, defaultOpts), opts);
  // If the field attribute is declared, then the injection is carried out (mainly used to deal with the case where Checkbox and Radio are used separately from the Group); other cases are subject to options
  const shouldInject = 'field' in props ? true : options.shouldInject;
  return {
    options,
    shouldInject
  };
}
function mergeProps(props) {
  const defaultProps = {
    // validateStatus: 'default',
    allowEmptyString: false,
    allowEmpty: false,
    emptyValue: '',
    noLabel: false,
    noErrorMessage: false,
    isInInputGroup: false
  };
  let _a = Object.assign(Object.assign({}, defaultProps), props),
    {
      field,
      label,
      labelPosition,
      labelWidth,
      labelAlign,
      labelCol,
      wrapperCol,
      initValue,
      validate,
      /**
       * error、warning、default、success
       */
      validateStatus,
      /**
       * change、blur、custom、mount
       */
      trigger,
      allowEmptyString,
      allowEmpty,
      emptyValue,
      rules,
      onChange,
      keepState,
      // Conversion before validation
      transform,
      name,
      fieldClassName,
      fieldStyle,
      noLabel,
      noErrorMessage,
      isInInputGroup,
      stopValidateWithError,
      convert,
      showValidateIcon,
      helpText,
      extraText,
      extraTextPosition,
      pure,
      id
    } = _a,
    rest = form_utils_rest(_a, ["field", "label", "labelPosition", "labelWidth", "labelAlign", "labelCol", "wrapperCol", "initValue", "validate", "validateStatus", "trigger", "allowEmptyString", "allowEmpty", "emptyValue", "rules", "onChange", "keepState", "transform", "name", "fieldClassName", "fieldStyle", "noLabel", "noErrorMessage", "isInInputGroup", "stopValidateWithError", "convert", "showValidateIcon", "helpText", "extraText", "extraTextPosition", "pure", "id"]);
  // Form中的任何类型组件，初始值都统一通过initValue字段来传入，同时将可能会导致组件行为错误的props抽取出来，防止透传到组件中
  // For any type of field component in Form, the initial value is uniformly passed in through the initValue field.
  // At the same time, the props that may cause component behavior errors are extracted to prevent transparent transmission to the component.
  delete rest.defaultChecked;
  delete rest.defaultValue;
  delete rest.checked;
  if (typeof initValue !== 'undefined') {
    initValue = index(initValue);
  }
  const required = isRequired(rules);
  emptyValue = typeof emptyValue !== 'undefined' ? emptyValue : '';
  return {
    field,
    label,
    labelPosition,
    labelWidth,
    labelAlign,
    labelCol,
    wrapperCol,
    noLabel,
    noErrorMessage,
    isInInputGroup,
    initValue,
    validate,
    validateStatus,
    trigger,
    allowEmptyString,
    allowEmpty,
    emptyValue,
    rules,
    required,
    keepState,
    transform,
    name,
    fieldClassName,
    fieldStyle,
    convert,
    stopValidateWithError,
    showValidateIcon,
    helpText,
    extraText,
    extraTextPosition,
    pure,
    rest,
    id
  };
}
function bothEmptyArray(val, otherVal) {
  return Array.isArray(val) && Array.isArray(otherVal) && !val.length && !otherVal.length;
}
;// CONCATENATED MODULE: ./node_modules/compute-scroll-into-view/dist/index.mjs
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}var i=function(e,i){var o=window,l=i.scrollMode,d=i.block,f=i.inline,h=i.boundary,u=i.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var a,c,g=document.scrollingElement||document.documentElement,p=[],m=e;t(m)&&s(m);){if((m=null==(c=(a=m).parentElement)?a.getRootNode().host||null:c)===g){p.push(m);break}null!=m&&m===document.body&&n(m)&&!n(document.documentElement)||null!=m&&n(m,u)&&p.push(m)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<p.length;k++){var B=p[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?r(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:r(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?r(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:r(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }
  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: 'start',
    inline: 'nearest'
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? i(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(i(target, computeOptions), computeOptions.behavior);
}
/* harmony default export */ var es = (scrollIntoView);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/form/foundation.js








class FormFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    /*
        Also need to read initValue here, because the Form level can set the initial value,
        and the Field level can also set the initial value.
        The field set in the Form does not necessarily have a Field entity,
        so you cannot completely rely on the register moment to set the initial value
         这里也需要读一次initValue，因为Form级别可设置初始值，Field级别也可设置初始值.
        Form中设置的字段，不一定会存在Field实体，所以不能完全依赖register时刻来设置初始值
    */
    let {
      initValues
    } = this._adapter.getProps();
    initValues = this._adapter.cloneDeep(initValues);
    this.data = {
      values: initValues ? initValues : {},
      errors: {},
      touched: {}
      // invalid: false,
      // dirty: false,
    };
    // Map store all fields
    // key: fieldName
    // value:  { field, fieldApi, keepState, initValue}
    this.fields = new Map();
    // Record all registered fields
    this.registered = {};
    // Record all registered ArrayField
    this.registeredArrayField = new Map();
    this.register = this.register.bind(this);
    this.unRegister = this.unRegister.bind(this);
    this.registerArrayField = this.registerArrayField.bind(this);
    this.unRegisterArrayField = this.unRegisterArrayField.bind(this);
    this.getArrayField = this.getArrayField.bind(this);
    this.updateArrayField = this.updateArrayField.bind(this);
    this.getField = this.getField.bind(this);
    this.setValues = this.setValues.bind(this);
    this.updateStateValue = this.updateStateValue.bind(this);
    this.updateStateError = this.updateStateError.bind(this);
    this.updateStateTouched = this.updateStateTouched.bind(this);
    this.getFormState = this.getFormState.bind(this);
    this.getValue = this.getValue.bind(this);
    this.getError = this.getError.bind(this);
    this.getTouched = this.getTouched.bind(this);
    this.getInitValues = this.getInitValues.bind(this);
    this.getInitValue = this.getInitValue.bind(this);
    this.getFormProps = this.getFormProps.bind(this);
    this.getFieldExist = this.getFieldExist.bind(this);
    this.scrollToField = this.scrollToField.bind(this);
    this.scrollToError = this.scrollToError.bind(this);
  }
  init() {
    this._adapter.initFormId();
  }
  getField(field) {
    const targetField = this.fields.get(field);
    return targetField;
  }
  register(field, fieldState, fieldStuff) {
    // determine if this field has been register before
    const registered = this.registered[field];
    this.registered[field] = true;
    this.fields.set(field, fieldStuff);
    if (fieldStuff.keepState) {
      // TODO support keepState
    } else {
      const allowEmpty = fieldStuff.allowEmpty || false;
      const opts = {
        notNotify: true,
        notUpdate: false,
        allowEmpty
      };
      let fieldValue = fieldState.value;
      // When allowEmpty is false, 'is equivalent to undefined, and the key of the field does not need to be reflected on values
      if (!allowEmpty && fieldValue === '') {
        fieldValue = undefined;
      }
      this.updateStateValue(field, fieldValue, opts);
      if (fieldState.error) {
        this.updateStateError(field, fieldState.error, opts);
      }
    }
    // this.log(this.fields);
  }

  unRegister(field) {
    const targetField = this.fields.get(field);
    // delete data
    try {
      if (!targetField.keepState) {
        remove(this.data.values, field);
        remove(this.data.errors, field);
        remove(this.data.touched, field);
      }
    } catch (error) {
      console.error(`some thing wrong when unregister field:${field}`);
    }
    // delete field
    this.fields.delete(field);
    this._adapter.notifyChange(this.data);
    this._adapter.forceUpdate();
  }
  // in order to solve bytedance internal issue-289
  registerArrayField(arrayFieldPath, val) {
    this.updateArrayField(arrayFieldPath, {
      updateKey: new Date().valueOf(),
      initValue: val
    });
  }
  unRegisterArrayField(arrayField) {
    this.registeredArrayField.delete(arrayField);
  }
  getArrayField(arrayField) {
    return this.registeredArrayField.get(arrayField);
  }
  updateArrayField(arrayField, updateValue) {
    const mergeVal = Object.assign(Object.assign({}, this.registeredArrayField.get(arrayField)), updateValue);
    this.registeredArrayField.set(arrayField, mergeVal);
  }
  validate(fieldPaths) {
    const {
      validateFields
    } = this.getProps();
    if (validateFields && isFunction_default()(validateFields)) {
      return this._formValidate();
    } else {
      return this._fieldsValidate(fieldPaths);
    }
  }
  // form level validate
  _formValidate() {
    const {
      values
    } = this.data;
    const {
      validateFields
    } = this.getProps();
    return new Promise((resolve, reject) => {
      let maybePromisedErrors;
      try {
        maybePromisedErrors = validateFields(values);
      } catch (errors) {
        // error throw by sync validate directly
        maybePromisedErrors = errors;
      }
      if (!maybePromisedErrors) {
        const _values = this._adapter.cloneDeep(values);
        resolve(_values);
        this.injectErrorToField({});
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(result => {
          // validate success，clear error
          if (!result) {
            const _values = this._adapter.cloneDeep(values);
            resolve(_values);
            this.injectErrorToField({});
          } else {
            this.data.errors = result;
            this._adapter.notifyChange(this.data);
            this.injectErrorToField(result);
            this._adapter.forceUpdate();
            this._autoScroll(100);
            reject(result);
          }
        }, errors => {
          // validate failed
          // this._adapter.notifyChange(this.data);
          this._autoScroll(100);
          reject(errors);
        });
      } else {
        // TODO: current design, returning an empty object will be considered a checksum failure and will be rejected. Only returning an empty string will be considered a success, consider resetting it in 1.0?
        this.data.errors = maybePromisedErrors;
        this.injectErrorToField(maybePromisedErrors);
        this._adapter.notifyChange(this.data);
        this._adapter.forceUpdate();
        this._autoScroll(100);
        reject(maybePromisedErrors);
      }
    });
  }
  // field level validate
  _fieldsValidate(fieldPaths) {
    const {
      values
    } = this.data;
    // When there is no custom validation function at Form level, perform validation of each Field
    return new Promise((resolve, reject) => {
      let promiseSet = [];
      const targetFields = this._getOperateFieldMap(fieldPaths);
      targetFields.forEach((field, fieldPath) => {
        // Call each fieldApi for verification
        const fieldValue = this.getValue(fieldPath);
        // When centralized verification, no need to trigger forceUpdate and notify
        const opts = {
          notNotify: true,
          notUpdate: true
        };
        const validateResult = field.fieldApi.validate(fieldValue, opts);
        promiseSet.push(validateResult);
        field.fieldApi.setTouched(true, opts);
      });
      Promise.all(promiseSet).then(() => {
        // After the centralized verification is completed, trigger notify and forceUpdate once.
        this._adapter.notifyChange(this.data);
        this._adapter.forceUpdate();
        const errors = this.getError();
        if (this._isValid(targetFields)) {
          const _values = this._adapter.cloneDeep(values);
          resolve(_values);
        } else {
          this._autoScroll();
          reject(errors);
        }
      });
    });
  }
  submit(e) {
    const {
      values
    } = this.data;
    // validate form
    this.validate().then(resolveValues => {
      // if valid do submit
      const _values = this._adapter.cloneDeep(resolveValues);
      this._adapter.notifySubmit(_values, e);
    }).catch(errors => {
      const _errors = this._adapter.cloneDeep(errors);
      const _values = this._adapter.cloneDeep(values);
      this._adapter.notifySubmitFail(_errors, _values, e);
    });
  }
  /**
   * Case A：
   *      All fields: a[0]、a[1]、b.type、b.name[2]、b.name[0]
   *      input => output:
   *           a  => a[0]、a[1]
   *           b  => b.type、b.name[0]、b.name[2]
   *
   * Case B：
   *      All fields: activity.a[0]、activity.a[1]、activity.c、activity.d、other
   *      input => output:
   *           activity.a => activity.a[0]、activity.a[1]
   *
   */
  _getNestedField(path) {
    const allRegisterField = this.fields;
    const allFieldPath = [...allRegisterField].map(item => item[0]);
    let nestedFieldPath = new Map();
    allFieldPath.forEach(item => {
      let itemPath = toPath_default()(item);
      let targetPath = toPath_default()(path);
      if (targetPath.every((path, i) => targetPath[i] === itemPath[i])) {
        const realField = allRegisterField.get(item);
        nestedFieldPath.set(item, realField);
      }
    });
    return nestedFieldPath;
  }
  // get all operate fields, called by validate() / reset()
  _getOperateFieldMap(fieldPaths) {
    let targetFields = new Map();
    if (!isUndefined_default()(fieldPaths)) {
      // reset or validate specific fields
      fieldPaths.forEach(path => {
        const field = this.fields.get(path);
        // may be undefined, if exists two fields like 'a[0]'、'a[1]', but user directly call reset(['a']) / validate(['a'])
        if (isUndefined_default()(field)) {
          const nestedFields = this._getNestedField(path);
          targetFields = new Map([...targetFields, ...nestedFields]);
        } else {
          targetFields.set(path, field);
        }
      });
    } else {
      // reset or validate all fields
      targetFields = this.fields;
    }
    return targetFields;
  }
  // Reset the entire form, reset all fields and remove validation results
  reset(fieldPaths) {
    const targetFields = this._getOperateFieldMap(fieldPaths);
    targetFields.forEach(field => {
      field.fieldApi.reset();
    });
    if (this.registeredArrayField.size) {
      this._resetArrayField();
    }
    this._adapter.notifyChange(this.data);
    this._adapter.forceUpdate();
    this._adapter.notifyReset();
  }
  _resetArrayField() {
    /*
        When Reset, arrayField needs to be processed separately. Restore the key/value of arrayField in formState according to the initial value
        Update the key inside the arrayField to make it actively renderer
        Reset时，arrayField需要单独处理, 根据初始值还原 arrayField在formState中的key/value, 更新 arrayField内部的key，使其主动rerender
    */
    const arrayFieldPaths = [...this.registeredArrayField.keys()];
    arrayFieldPaths.forEach(path => {
      const arrayFieldState = this.registeredArrayField.get(path);
      const arrayFieldInitValue = arrayFieldState.initValue;
      this.updateStateValue(path, arrayFieldInitValue, {
        notNotify: true,
        notUpdate: true
      });
      this.updateArrayField(path, {
        updateKey: new Date().valueOf()
      });
    });
  }
  // After calling the form's custom validateFields function, reject the returned error to the corresponding field
  // 调用了Form的自定义validateFields函数后，将返回的错误展示到对应的field中
  injectErrorToField(errors) {
    this.fields.forEach(field => {
      const fieldError = object_get(errors, field.field);
      const opts = {
        notNotify: true,
        notUpdate: true
      };
      field.fieldApi.setError(fieldError, opts);
    });
  }
  getValue(field, opts) {
    const isAllField = typeof field === 'undefined';
    const needClone = opts && opts.needClone;
    let result, fieldValue;
    switch (true) {
      case !isAllField && !needClone:
        result = object_get(this.data.values, field);
        break;
      case !isAllField && needClone:
        fieldValue = object_get(this.data.values, field);
        result = this._adapter.cloneDeep(fieldValue);
        break;
      case isAllField && !needClone:
        result = Object.assign({}, this.data.values);
        break;
      case isAllField && needClone:
        result = this._adapter.cloneDeep(this.data.values);
        break;
      default:
        break;
    }
    return result;
  }
  setValues(values, _ref) {
    let {
      isOverride = false
    } = _ref;
    const _values = this._adapter.cloneDeep(values);
    this.fields.forEach(field => {
      const value = object_get(_values, field.field);
      // When calling setValues to override the values, only need to trigger onValueChange and onChange once, so setNotNotify of setValue to true
      // 调用setValues进行值的覆盖时，只需要回调一次onValueChange、onChange即可，所以此处将setValue的notNotify置为true
      const opts = {
        notNotify: true,
        notUpdate: true
      };
      field.fieldApi.setValue(value, opts);
    });
    // if there exists any arrayField component in this form
    if (this.registeredArrayField.size) {
      const arrayFieldPaths = [...this.registeredArrayField.keys()];
      arrayFieldPaths.forEach(path => {
        this.updateArrayField(path, {
          updateKey: new Date().valueOf()
        });
      });
    }
    // When isOverride is true, there may be a non-existent field in the values passed in, directly synchronized to formState.values
    // 当isOverride为true，传入的values中可能存在不存在的field时，直接将其同步到formState.values中
    if (isOverride) {
      this.data.values = _values;
    }
    // After completing the assignment, the unified callback can be done once.
    // 在完成赋值后，统一回调一次即可
    this._adapter.notifyChange(this.data);
    this._adapter.notifyValueChange(this.data.values, Object.assign({}, values));
    this._adapter.forceUpdate();
  }
  // update formState value
  updateStateValue(field, value, opts, callback) {
    const notNotify = opts && opts.notNotify;
    const notUpdate = opts && opts.notUpdate;
    const fieldAllowEmpty = opts && opts.fieldAllowEmpty;
    /**
     * 当Form.allowEmpty为true时，所有的field，key都会在formState.values中出现，如果值为空那么就是undefined
     * 当Form.allowEmpty为false时，只有有值的field，key才会在formState.values中出现
     * When F orm.allow Empty is true, all fields and keys will appear in the formS tate.values. If the value is empty, it is undefined
     * When F orm.allow Empty is false, only fields with values will key appear in the formS tate.values
     */
    const formAllowEmpty = this.getProp('allowEmpty');
    // priority at Field level
    const allowEmpty = fieldAllowEmpty ? fieldAllowEmpty : formAllowEmpty;
    object_set(this.data.values, field, value, allowEmpty);
    /**
     * When registering, setValue called when Field initValue is synchronized to FormState should not trigger notify
     * but need to trigger forceUpdate, otherwise useFormState, useFieldState initial rendering will have problems
     *
     * register时，Field中同步initValue到FormState时调用的setValue不应该触发notify
     * 但需要触发forceUpdate，否则useFormState、useFieldState初始渲染会有问题
     */
    if (!notNotify) {
      this._adapter.notifyChange(this.data);
      this._adapter.notifyValueChange(this.data.values, {
        [field]: value
      });
    }
    if (!notUpdate) {
      this._adapter.forceUpdate(callback);
    }
  }
  // get touched from formState
  getTouched(field) {
    if (typeof field === 'undefined') {
      return this.data.touched;
    }
    return object_get(this.data.touched, field);
  }
  // update formState touched
  updateStateTouched(field, isTouched, opts, callback) {
    const notNotify = opts && opts.notNotify;
    const notUpdate = opts && opts.notUpdate;
    object_set(this.data.touched, field, isTouched);
    if (!notNotify) {
      this._adapter.notifyChange(this.data);
    }
    if (!notUpdate) {
      this._adapter.forceUpdate(callback);
    }
  }
  // get error from formState
  getError(field) {
    if (typeof field === 'undefined') {
      return this.data.errors;
    }
    return object_get(this.data.errors, field);
  }
  // update formState error
  updateStateError(field, error, opts, callback) {
    const notNotify = opts && opts.notNotify;
    const notUpdate = opts && opts.notUpdate;
    object_set(this.data.errors, field, error);
    // The setError caused by centralized validation does not need to trigger notify, otherwise it will be called too frequently, as many times as there are fields
    // 集中validate时，引起的setError不需要触发notify，否则会过于频繁调用，有多少个field就调用了多少次
    if (!notNotify) {
      this._adapter.notifyChange(this.data);
    }
    if (!notUpdate) {
      this._adapter.forceUpdate(callback);
    }
  }
  // For internal use in the FormApi Operating Field
  getFieldSetterApi() {
    const setValue = (field, value, opts) => {
      const fieldApi = this.fields.get(field) ? this.fields.get(field).fieldApi : undefined;
      // DeepClone the value entered from the outside to avoid unexpected errors caused by not isolating the scope to the greatest extent. This setValue will be called in eg: ArrayField
      const newValue = this._adapter.cloneDeep(value);
      if (fieldApi) {
        // If there is a corresponding Field entity, call FieldApi to update the value
        fieldApi.setValue(newValue, opts);
      } else {
        // If you reset an entire array, such as Array Field, the array as a whole may actually have no Field entities (but each array element corresponds to a Field)
        // At this time, first modify formState directly, then find out the subordinate fields and drive them to update
        // Eg: peoples: [0, 2, 3]. Each value of the peoples array corresponds to an Input Field
        // When the user directly calls formA pi.set Value ('peoples', [2,3])
        this.updateStateValue(field, newValue, opts, () => {
          let nestedFields = this._getNestedField(field);
          if (nestedFields.size) {
            nestedFields.forEach(fieldStaff => {
              let fieldPath = fieldStaff.field;
              let newFieldVal = object_get(this.data.values, fieldPath);
              let nestedBatchUpdateOpts = {
                notNotify: true,
                notUpdate: true
              };
              fieldStaff.fieldApi.setValue(newFieldVal, nestedBatchUpdateOpts);
            });
          }
        });
        // If the reset happens to be, then update the updateKey corresponding to ArrayField to render it again
        if (this.getArrayField(field)) {
          this.updateArrayField(field, {
            updateKey: new Date().valueOf()
          });
        }
      }
    };
    const setError = (field, error, opts) => {
      const fieldApi = this.fields.get(field) ? this.fields.get(field).fieldApi : undefined;
      const newError = this._adapter.cloneDeep(error);
      if (fieldApi) {
        fieldApi.setError(newError, opts);
      } else {
        this.updateStateError(field, newError, opts, () => {
          let nestedFields = this._getNestedField(field);
          if (nestedFields.size) {
            nestedFields.forEach(fieldStaff => {
              let fieldPath = fieldStaff.field;
              let newFieldError = object_get(this.data.errors, fieldPath);
              let nestedBatchUpdateOpts = {
                notNotify: true,
                notUpdate: true
              };
              fieldStaff.fieldApi.setError(newFieldError, nestedBatchUpdateOpts);
            });
          }
        });
        if (this.getArrayField(field)) {
          this.updateArrayField(field, {
            updateKey: new Date().valueOf()
          });
        }
      }
    };
    const setTouched = (field, isTouched, opts) => {
      const fieldApi = this.fields.get(field) ? this.fields.get(field).fieldApi : undefined;
      // touched is boolean variable, no need to exec deepClone like setValue
      if (fieldApi) {
        fieldApi.setTouched(isTouched, opts);
      } else {
        this.updateStateTouched(field, isTouched, opts, () => {
          let nestedFields = this._getNestedField(field);
          if (nestedFields.size) {
            nestedFields.forEach(fieldStaff => {
              let fieldPath = fieldStaff.field;
              let newFieldTouch = object_get(this.data.touched, fieldPath);
              let nestedBatchUpdateOpts = {
                notNotify: true,
                notUpdate: true
              };
              fieldStaff.fieldApi.setTouched(newFieldTouch, nestedBatchUpdateOpts);
            });
          }
        });
        if (this.getArrayField(field)) {
          this.updateArrayField(field, {
            updateKey: new Date().valueOf()
          });
        }
      }
    };
    return {
      setValue,
      setError,
      setTouched
    };
  }
  // For Field and ArrayField to read and modify FormState
  getModifyFormStateApi() {
    return {
      register: this.register,
      unRegister: this.unRegister,
      updateStateValue: this.updateStateValue,
      updateStateError: this.updateStateError,
      updateStateTouched: this.updateStateTouched,
      getValue: this.getValue,
      getError: this.getError,
      getTouched: this.getTouched,
      getInitValues: this.getInitValues,
      getInitValue: this.getInitValue,
      getFormProps: this.getFormProps,
      getField: this.getField,
      registerArrayField: this.registerArrayField,
      unRegisterArrayField: this.unRegisterArrayField,
      getArrayField: this.getArrayField,
      updateArrayField: this.updateArrayField
    };
  }
  // Form APIs for external use, exposed to the user
  getFormApi() {
    const fieldSetterApi = this.getFieldSetterApi();
    return Object.assign(Object.assign({}, fieldSetterApi), {
      reset: fields => this.reset(fields),
      validate: fields => this.validate(fields),
      getValue: field => this.getValue(field, {
        needClone: true
      }),
      getValues: () => this.getValue(undefined, {
        needClone: true
      }),
      getFormState: () => this.getFormState(true),
      getFormProps: props => this.getFormProps(props),
      getInitValue: field => this.getInitValue(field),
      getInitValues: () => this.getInitValues(),
      getTouched: field => this.getTouched(field),
      getError: field => this.getError(field),
      setValues: (values, opts) => this.setValues(values, opts || {
        isOverride: false
      }),
      submitForm: () => this.submit(),
      getFieldExist: field => this.getFieldExist(field),
      scrollToField: (field, scrollOpts) => this.scrollToField(field, scrollOpts),
      scrollToError: opts => this.scrollToError(opts)
    });
  }
  getFormState() {
    let needClone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // NOTES：这里如果直接返回this.data，forceUpdate 触发 Form rerender 时，通过context传下去的formState会被认为是同一个对象【应该是浅对比的原因】
    // 使用了useFormState相关的component都不会触发重新渲染。所以使用...复制一次
    /*
        The reason for distinguishing deepClone: When semi is calling getFormState for internal consumption,
        the value of formState will not be modified, so deep cloning is not necessary, which can reduce performance loss
        But if the users use formApi.getFormState(), the behavior is unpredictable, and invasive modifications may be performed,
        so deep clones are used for isolation.
        对deepClone进行区分的原因：semi调用getFormState内部消费时，不会对formState的值进行修改，所以无需深克隆，节约开销
        但如果是业务方用formApi调用getFormState时，行为无法预料，有可能会进行侵入式修改，所以用深克隆进行隔离
    */
    if (!needClone) {
      return Object.assign({}, this.data);
    } else {
      return this._adapter.cloneDeep(this.data);
    }
  }
  _isValid(targetFields) {
    let valid = true;
    if (!targetFields) {
      valid = Boolean(empty(this.data.errors));
    } else {
      // when trigger partial validate
      const targetFieldStr = [...targetFields.keys()];
      targetFieldStr.forEach(fieldStr => {
        const fieldError = object_get(this.data.errors, fieldStr);
        if (!utils_isValid(fieldError)) {
          valid = false;
        }
      });
    }
    return valid;
  }
  // get form.props.initValues
  getInitValues() {
    return this._adapter.getInitValues();
  }
  getInitValue(field) {
    if (typeof field === 'undefined') {
      return this._adapter.getInitValues();
    }
    return object_get(this._adapter.getInitValues(), field);
  }
  getFormProps(keys) {
    return this._adapter.getFormProps(keys);
  }
  getFieldExist(field) {
    return Boolean(this.fields.has(field));
  }
  _autoScroll(timeout) {
    const {
      autoScrollToError
    } = this.getFormProps();
    if (!autoScrollToError) {
      return;
    }
    let scrollOpts = {
      behavior: 'smooth',
      block: 'start'
    };
    typeof autoScrollToError === 'object' ? scrollOpts = autoScrollToError : null;
    if (timeout) {
      setTimeout(() => this._getErrorFieldAndScroll(scrollOpts), 100);
    } else {
      this._getErrorFieldAndScroll(scrollOpts);
    }
  }
  _getErrorFieldAndScroll(scrollOpts) {
    const errorDOM = this._adapter.getAllErrorDOM();
    if (errorDOM && errorDOM.length) {
      try {
        const fieldDOM = errorDOM[0].parentNode.parentNode;
        es(fieldDOM, scrollOpts);
      } catch (error) {}
    }
  }
  scrollToField(field) {
    let scrollOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      behavior: 'smooth',
      block: 'start'
    };
    if (this.getFieldExist(field)) {
      const fieldDOM = this._adapter.getFieldDOM(field);
      es(fieldDOM, scrollOpts);
    }
  }
  scrollToError(config) {
    let scrollOpts = config && config.scrollOpts ? config.scrollOpts : {
      behavior: 'smooth',
      block: 'start'
    };
    let field = config && config.field;
    let index = config && config.index;
    let fieldDOM, errorDOM;
    if (typeof index === 'number') {
      const allErrorDOM = this._adapter.getAllErrorDOM();
      let errorDOM = allErrorDOM[index];
      if (errorDOM) {
        fieldDOM = errorDOM.parentNode.parentNode;
      }
    } else if (field) {
      // If field is specified, find the error dom of the corresponding field
      errorDOM = this._adapter.getFieldErrorDOM(field);
      if (errorDOM) {
        fieldDOM = errorDOM.parentNode.parentNode;
      }
    } else if (typeof field === 'undefined') {
      // If field is not specified, find all error doms and scroll to the first one
      let allErrorDOM = this._adapter.getAllErrorDOM();
      if (allErrorDOM && allErrorDOM.length) {
        fieldDOM = allErrorDOM[0].parentNode.parentNode;
      }
    }
    if (fieldDOM) {
      es(fieldDOM, scrollOpts);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/context.js

const FormStateContext = /*#__PURE__*/react.createContext({});
FormStateContext.displayName = 'FormState';
const FormApiContext = /*#__PURE__*/react.createContext({});
FormApiContext.displayName = 'FormApi';
const FormUpdaterContext = /*#__PURE__*/react.createContext({});
FormUpdaterContext.displayName = 'FormUpdater';
const ArrayFieldContext = /*#__PURE__*/react.createContext({
  shouldUseInitValue: true
});

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/_base/reactUtils.js
// https://stackoverflow.com/questions/33199959/how-to-detect-a-react-component-vs-a-react-element


function isClassComponent(component) {
  return typeof component === 'function' && Boolean(component.prototype.isReactComponent);
}
function isFunctionalComponent(Component) {
  return typeof Component === 'function' &&
  // can be various things
  !(Component.prototype && Component.prototype.isReactComponent // native arrows don't have prototypes
  );
}

function isReactComponent(component) {
  return isClassComponent(component) || isFunctionalComponent(component);
}
function reactUtils_isElement(element) {
  return /*#__PURE__*/react.isValidElement(element);
}
function isCompositeTypeElement(element) {
  return reactUtils_isElement(element) && typeof element.type === 'function';
}
function isEmptyChildren(children) {
  return react.Children.count(children) === 0;
}

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/grid/constants.js

const grid_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}`
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/grid/row.js
var row_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Implementation reference from: https://github.com/ant-design/ant-design/blob/master/components/grid/row.tsx
 */




// import '@douyinfe/semi-foundation/lib/es/grid/grid.css';

const responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const RowContext = /*#__PURE__*/react.createContext(null);
const responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
class Row extends react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      screens: {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
      }
    };
    this.unRegisters = [];
  }
  componentDidMount() {
    this.unRegisters = Object.keys(responsiveMap).map(screen => registerMediaQuery(responsiveMap[screen], {
      match: () => {
        if (typeof this.props.gutter !== 'object') {
          return;
        }
        this.setState(prevState => ({
          screens: Object.assign(Object.assign({}, prevState.screens), {
            [screen]: true
          })
        }));
      },
      unmatch: () => {
        if (typeof this.props.gutter !== 'object') {
          return;
        }
        this.setState(prevState => ({
          screens: Object.assign(Object.assign({}, prevState.screens), {
            [screen]: false
          })
        }));
      }
    }));
  }
  componentWillUnmount() {
    this.unRegisters.forEach(unRegister => unRegister());
  }
  getGutter() {
    const {
      gutter = 0
    } = this.props;
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter.slice(0, 2) : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === 'object') {
        for (let i = 0; i < responsiveArray.length; i++) {
          const breakpoint = responsiveArray[i];
          if (this.state.screens[breakpoint] && g[breakpoint] !== undefined) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  }
  render() {
    const _a = this.props,
      {
        prefixCls,
        type,
        justify,
        align,
        className,
        style,
        children
      } = _a,
      others = row_rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);
    const gutters = this.getGutter();
    const prefix = `${prefixCls}-row`;
    const classes = classnames_default()({
      [prefix]: type !== 'flex',
      [`${prefix}-${type}`]: type,
      [`${prefix}-${type}-${justify}`]: type && justify,
      [`${prefix}-${type}-${align}`]: type && align
    }, className);
    const rowStyle = Object.assign(Object.assign(Object.assign({}, gutters[0] > 0 ? {
      marginLeft: gutters[0] / -2,
      marginRight: gutters[0] / -2
    } : {}), gutters[1] > 0 ? {
      marginTop: gutters[1] / -2,
      marginBottom: gutters[1] / -2
    } : {}), style);
    const otherProps = Object.assign({}, others);
    delete otherProps.gutter;
    return /*#__PURE__*/react.createElement(RowContext.Provider, {
      value: {
        gutters
      }
    }, /*#__PURE__*/react.createElement("div", Object.assign({}, otherProps, {
      className: classes,
      style: rowStyle,
      "x-semi-prop": "children"
    }), children));
  }
}
Row.propTypes = {
  type: prop_types_default().oneOf(['flex']),
  align: prop_types_default().oneOf(['top', 'middle', 'bottom']),
  justify: prop_types_default().oneOf(['start', 'end', 'center', 'space-around', 'space-between']),
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  children: (prop_types_default()).node,
  gutter: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).number, (prop_types_default()).array]),
  prefixCls: (prop_types_default()).string
};
Row.defaultProps = {
  prefixCls: grid_constants_cssClasses.PREFIX
};
Row.RowContext = {
  gutters: (prop_types_default()).any
};
/* harmony default export */ var row = (Row);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/label.js





const label_prefixCls = form_constants_cssClasses.PREFIX;
class Label extends react.PureComponent {
  render() {
    const {
      children,
      required,
      text,
      disabled,
      name,
      width,
      align,
      style,
      className,
      extra,
      id,
      optional
    } = this.props;
    const labelCls = classnames_default()(className, {
      [`${label_prefixCls}-field-label`]: true,
      [`${label_prefixCls}-field-label-left`]: align === 'left',
      [`${label_prefixCls}-field-label-right`]: align === 'right',
      [`${label_prefixCls}-field-label-required`]: required,
      [`${label_prefixCls}-field-label-disabled`]: disabled,
      [`${label_prefixCls}-field-label-with-extra`]: extra
    });
    const labelStyle = style ? style : {};
    width ? labelStyle.width = width : null;
    const optionalText = /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Form"
    }, locale => /*#__PURE__*/react.createElement("span", {
      className: `${label_prefixCls}-field-label-optional-text`
    }, locale.optional));
    const textContent = /*#__PURE__*/react.createElement("div", {
      className: `${label_prefixCls}-field-label-text`,
      "x-semi-prop": "label"
    }, typeof text !== 'undefined' ? text : children, optional ? optionalText : null);
    const contentWithExtra = /*#__PURE__*/react.createElement(react.Fragment, null, textContent, /*#__PURE__*/react.createElement("div", {
      className: `${label_prefixCls}-field-label-extra`
    }, extra));
    return /*#__PURE__*/react.createElement("label", {
      className: labelCls,
      htmlFor: name,
      style: labelStyle,
      id: id
    }, extra ? contentWithExtra : textContent);
  }
}
Label.defaultProps = {
  required: false,
  name: '',
  align: 'left',
  className: '',
  optional: false
};
Label.propTypes = {
  id: (prop_types_default()).string,
  children: (prop_types_default()).node,
  required: (prop_types_default()).bool,
  text: (prop_types_default()).node,
  disabled: (prop_types_default()).bool,
  name: (prop_types_default()).string,
  align: (prop_types_default()).string,
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  extra: (prop_types_default()).node,
  optional: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/grid/col.js
var col_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Implementation reference from: https://github.com/ant-design/ant-design/blob/master/components/grid/col.tsx
 */





const objectOrNumber = prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).number]);
class Col extends react.Component {
  render() {
    const {
      props
    } = this;
    const {
        prefixCls,
        span,
        order,
        offset,
        push,
        pull,
        className,
        children
      } = props,
      others = col_rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);
    let sizeClassObj = {};
    const prefix = `${prefixCls}-col`;
    ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(size => {
      let sizeProps = {};
      if (typeof props[size] === 'number') {
        sizeProps.span = props[size];
      } else if (typeof props[size] === 'object') {
        sizeProps = props[size] || {};
      }
      delete others[size];
      sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
        [`${prefix}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
        [`${prefix}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
        [`${prefix}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
        [`${prefix}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
        [`${prefix}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
      });
    });
    const classes = classnames_default()(prefix, {
      [`${prefix}-${span}`]: span !== undefined,
      [`${prefix}-order-${order}`]: order,
      [`${prefix}-offset-${offset}`]: offset,
      [`${prefix}-push-${push}`]: push,
      [`${prefix}-pull-${pull}`]: pull
    }, className, sizeClassObj);
    let {
      style
    } = others;
    let gutters;
    try {
      gutters = this.context.gutters;
    } catch (error) {
      throw new Error('please make sure <Col> inside <Row>');
    }
    style = Object.assign(Object.assign(Object.assign({}, gutters[0] > 0 ? {
      paddingLeft: gutters[0] / 2,
      paddingRight: gutters[0] / 2
    } : {}), gutters[1] > 0 ? {
      paddingTop: gutters[1] / 2,
      paddingBottom: gutters[1] / 2
    } : {}), style);
    return /*#__PURE__*/react.createElement("div", Object.assign({}, others, {
      style: style,
      className: classes,
      "x-semi-prop": "children"
    }), children);
  }
}
Col.contextType = RowContext;
Col.propTypes = {
  span: (prop_types_default()).number,
  order: (prop_types_default()).number,
  offset: (prop_types_default()).number,
  push: (prop_types_default()).number,
  pull: (prop_types_default()).number,
  className: (prop_types_default()).string,
  children: (prop_types_default()).node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber,
  prefixCls: (prop_types_default()).string
};
Col.defaultProps = {
  prefixCls: grid_constants_cssClasses.PREFIX
};
/* harmony default export */ var col = (Col);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/errorMessage.js





const errorMessage_prefix = form_constants_cssClasses.PREFIX;
class ErrorMessage extends react.PureComponent {
  generatorText(error) {
    const {
      helpTextId,
      errorMessageId
    } = this.props;
    const propsError = this.props.error;
    let id = errorMessageId;
    if (!propsError) {
      id = helpTextId;
    }
    if (typeof error === 'string') {
      return /*#__PURE__*/react.createElement("span", {
        id: id
      }, error);
    } else if (Array.isArray(error)) {
      const err = error.filter(e => e);
      return err.length ? /*#__PURE__*/react.createElement("span", {
        id: id
      }, err.join(', ')) : null;
    } else if ( /*#__PURE__*/react.isValidElement(error)) {
      return error;
    }
    return null;
  }
  render() {
    const {
      error,
      className,
      style,
      validateStatus,
      helpText,
      showValidateIcon,
      isInInputGroup
    } = this.props;
    const cls = classnames_default()({
      [errorMessage_prefix + '-field-error-message']: Boolean(error),
      [errorMessage_prefix + '-field-help-text']: Boolean(helpText)
    }, className);
    if (!error && !helpText) {
      return null;
    }
    const iconMap = {
      warning: /*#__PURE__*/react.createElement(IconAlertTriangle, null),
      error: /*#__PURE__*/react.createElement(IconAlertCircle, null)
    };
    const text = error ? this.generatorText(error) : this.generatorText(helpText);
    const iconCls = `${errorMessage_prefix}-field-validate-status-icon`;
    let icon = null;
    if (isInInputGroup) {
      icon = /*#__PURE__*/react.createElement(IconAlertCircle, {
        className: iconCls
      });
    } else {
      if (iconMap[validateStatus]) {
        icon = /*#__PURE__*/react.cloneElement(iconMap[validateStatus], {
          className: iconCls
        });
      }
    }
    return /*#__PURE__*/react.createElement("div", {
      className: cls,
      style: style
    }, showValidateIcon && text ? icon : null, text);
  }
}
ErrorMessage.propTypes = {
  error: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string, (prop_types_default()).array, (prop_types_default()).node]),
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  validateStatus: (prop_types_default()).string,
  showValidateIcon: (prop_types_default()).bool,
  helpText: (prop_types_default()).node,
  isInInputGroup: (prop_types_default()).bool,
  // internal props
  errorMessageId: (prop_types_default()).string,
  helpTextId: (prop_types_default()).string
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/slot.js



var slot_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const slot_prefix = form_constants_cssClasses.PREFIX;
const FormSlot = props => {
  let labelCol, wrapperCol, labelWidth, labelAlign, content;
  let labelPosition = 'top';
  try {
    const updater = (0,react.useContext)(FormUpdaterContext);
    const formProps = updater.getFormProps(['labelPosition', 'labelWidth', 'labelAlign', 'labelCol', 'wrapperCol']);
    labelCol = formProps.labelCol;
    wrapperCol = formProps.wrapperCol;
    labelWidth = formProps.labelWidth;
    labelAlign = formProps.labelAlign;
    labelPosition = formProps.labelPosition ? formProps.labelPosition : labelPosition;
  } catch (error) {}
  props.labelPosition ? labelPosition = props.labelPosition : null;
  let {
      children,
      label,
      className,
      style,
      error,
      noLabel
    } = props,
    rest = slot_rest(props, ["children", "label", "className", "style", "error", "noLabel"]);
  const appendCol = labelCol && wrapperCol;
  const slotCls = classnames_default()({
    [`${slot_prefix}-field`]: true,
    [`${slot_prefix}-slot`]: true
  }, className);
  const labelColCls = classnames_default()({
    [`${slot_prefix}-col-${labelAlign}`]: true
  });
  switch (true) {
    case isObject_default()(label) && ! /*#__PURE__*/react.isValidElement(label):
      // do nothing
      break;
    case isString_default()(label) || isNumber_default()(label):
      // @ts-ignore skip type check, the actual type is already determined
      label = {
        text: label
      };
      break;
    case /*#__PURE__*/react.isValidElement(label):
      // @ts-ignore skip type check, the actual type is already determined
      label = {
        text: label
      };
      break;
    default:
      break;
  }
  let slotError = null;
  if (typeof error !== undefined) {
    let emProps = {};
    switch (true) {
      case isObject_default()(error) && ! /*#__PURE__*/react.isValidElement(error):
        // do nothing
        emProps = error;
        break;
      case isString_default()(error) || isNumber_default()(error):
        emProps = {
          error
        };
        break;
      case /*#__PURE__*/react.isValidElement(error):
        emProps = {
          error
        };
        break;
      default:
        break;
    }
    slotError = /*#__PURE__*/react.createElement(ErrorMessage, Object.assign({}, emProps));
  }
  let mergeLabelProps = Object.assign({
    align: labelAlign,
    width: labelWidth
  }, label);
  let mainCls = classnames_default()({
    [`${slot_prefix}-field-main`]: true,
    [`${slot_prefix}-slot-main`]: true
  });
  switch (true) {
    case !appendCol && !noLabel:
      content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Label, Object.assign({}, mergeLabelProps)), /*#__PURE__*/react.createElement("div", {
        className: mainCls
      }, children, slotError));
      break;
    case !appendCol && noLabel:
      content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        className: mainCls
      }, children, slotError));
      break;
    case appendCol && labelPosition === 'top':
      // When labelPosition is top, you need to add an overflow hidden div to the label, otherwise it will be arranged horizontally
      content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        style: {
          overflow: 'hidden'
        }
      }, /*#__PURE__*/react.createElement(col, Object.assign({}, labelCol, {
        className: labelColCls
      }), /*#__PURE__*/react.createElement(Label, Object.assign({}, mergeLabelProps)))), /*#__PURE__*/react.createElement(col, null, children, slotError));
      break;
    case appendCol && labelPosition !== 'top':
      content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(col, Object.assign({}, labelCol, {
        className: labelColCls
      }), /*#__PURE__*/react.createElement(Label, Object.assign({}, mergeLabelProps))), /*#__PURE__*/react.createElement(col, null, children, slotError));
      break;
    default:
      break;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: slotCls,
    "x-label-pos": labelPosition,
    style: style
  }, content);
};
/* harmony default export */ var slot = (FormSlot);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/section.js




const section_prefix = form_constants_cssClasses.PREFIX;
class Section extends react.PureComponent {
  render() {
    const {
      text,
      className,
      style,
      children
    } = this.props;
    const cls = classnames_default()({
      [section_prefix + '-section']: true
    }, className);
    const textCls = section_prefix + '-section-text';
    return /*#__PURE__*/react.createElement("section", {
      className: cls,
      style: style
    }, /*#__PURE__*/react.createElement("h5", {
      className: textCls
    }, text), children);
  }
}
Section.propTypes = {
  text: (prop_types_default()).node,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  children: (prop_types_default()).node
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/hooks/useFormState.js


function useFormState() {
  const formState = (0,react.useContext)(FormStateContext);
  return formState;
}
/* harmony default export */ var hooks_useFormState = (useFormState);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/input/inputGroup.js


var inputGroup_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







const inputGroup_prefixCls = input_constants_cssClasses.PREFIX;
const inputGroup_sizeSet = input_constants_strings.SIZE;
class inputGroup extends BaseComponent {
  renderGroupWithLabel(inner) {
    const _a = this.props,
      {
        size,
        className,
        label,
        labelPosition
      } = _a,
      rest = inputGroup_rest(_a, ["size", "className", "label", "labelPosition"]);
    const groupWrapperCls = classnames_default()({
      [`${inputGroup_prefixCls}-group-wrapper`]: true,
      [`${inputGroup_prefixCls}-group-wrapper-with-top-label`]: labelPosition === 'top',
      [`${inputGroup_prefixCls}-group-wrapper-with-left-label`]: labelPosition === 'left'
    });
    const groupCls = classnames_default()(`${inputGroup_prefixCls}-group`, className, {
      [`${inputGroup_prefixCls}-${size}`]: size !== 'default'
    });
    // const labelCls = cls(label.className, '');
    const defaultName = 'input-group';
    return /*#__PURE__*/react.createElement("div", {
      className: groupWrapperCls
    }, label && label.text ? /*#__PURE__*/react.createElement(Label, Object.assign({
      name: defaultName
    }, label)) : null, /*#__PURE__*/react.createElement("span", {
      role: "group",
      "aria-disabled": this.props.disabled,
      id: label && label.name || defaultName,
      className: groupCls,
      style: this.props.style,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur
    }, inner));
  }
  render() {
    const _a = this.props,
      {
        size,
        style,
        className,
        children,
        label,
        onBlur: groupOnBlur,
        onFocus: groupOnFocus,
        disabled: groupDisabled
      } = _a,
      rest = inputGroup_rest(_a, ["size", "style", "className", "children", "label", "onBlur", "onFocus", "disabled"]);
    const groupCls = classnames_default()(`${inputGroup_prefixCls}-group`, {
      [`${inputGroup_prefixCls}-${size}`]: size !== 'default'
    }, className);
    let inner;
    if (children) {
      inner = (Array.isArray(children) ? children : [children]).map((item, index) => {
        if (item) {
          const {
            onBlur: itemOnBlur,
            onFocus: itemOnFocus,
            disabled: itemDisabled
          } = item.props;
          const onBlur = isFunction_default()(itemOnBlur) && get_default()(itemOnBlur, 'name') !== 'noop' ? itemOnBlur : groupOnBlur;
          const onFocus = isFunction_default()(itemOnFocus) && get_default()(itemOnFocus, 'name') !== 'noop' ? itemOnFocus : groupOnFocus;
          const disabled = typeof itemDisabled === 'boolean' ? itemDisabled : groupDisabled;
          return /*#__PURE__*/react.cloneElement(item, Object.assign(Object.assign({
            key: index
          }, rest), {
            size,
            onBlur,
            onFocus,
            disabled
          }));
        }
        return null;
      });
    }
    if (label && label.text) {
      return this.renderGroupWithLabel(inner);
    }
    return /*#__PURE__*/react.createElement("span", {
      role: "group",
      "aria-label": "Input group",
      "aria-disabled": this.props.disabled,
      className: groupCls,
      style: style,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur
    }, inner);
  }
}
inputGroup.propTypes = {
  className: (prop_types_default()).string,
  children: (prop_types_default()).node,
  size: prop_types_default().oneOf(inputGroup_sizeSet),
  style: (prop_types_default()).object,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  label: (prop_types_default()).object,
  labelPosition: (prop_types_default()).string
};
inputGroup.defaultProps = {
  size: 'default',
  className: '',
  onBlur: function_noop,
  onFocus: function_noop
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/group.js

var group_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











const group_prefix = form_constants_cssClasses.PREFIX;
// Group component to remove Labels and ErrorMessages from its child fields
// Unified insertion of Labels and ErrorMessages from the group level
// Get Errors of all field in this group
const GroupError = props => {
  const {
    fieldSet
  } = props;
  const formState = hooks_useFormState();
  const error = fieldSet.map(field => object_get(formState.errors, field));
  if (utils_isValid(error)) {
    return null;
  }
  return /*#__PURE__*/react.createElement(ErrorMessage, {
    error: error,
    showValidateIcon: props.showValidateIcon,
    isInInputGroup: props.isInInputGroup
  });
};
class FormInputGroup extends react.Component {
  renderLabel(label, formProps) {
    if (label) {
      if (isString_default()(label)) {
        return /*#__PURE__*/react.createElement(Label, {
          width: formProps.labelWidth,
          text: label
        });
      } else {
        return /*#__PURE__*/react.createElement(Label, Object.assign({
          width: formProps.labelWidth
        }, label));
      }
    }
    return null;
  }
  render() {
    const _a = this.props,
      {
        children,
        label,
        extraText,
        extraTextPosition
      } = _a,
      rest = group_rest(_a, ["children", "label", "extraText", "extraTextPosition"]);
    const updater = this.context;
    const formProps = updater.getFormProps(['labelPosition', 'labelWidth', 'labelAlign', 'showValidateIcon', 'wrapperCol', 'labelCol', 'disabled']);
    const labelPosition = this.props.labelPosition || formProps.labelPosition;
    const groupFieldSet = [];
    const inner = react.Children.map(children, child => {
      if (child && child.props && child.props.field) {
        groupFieldSet.push(child.props.field);
        return /*#__PURE__*/react.cloneElement(child, {
          isInInputGroup: true
          // noErrorMessage: true,
          // noLabel: true
        });
      }

      return null;
    });
    const groupCls = classnames_default()({
      [`${group_prefix}-field-group`]: true
    });
    const labelCol = formProps.labelCol;
    const wrapperCol = formProps.wrapperCol;
    const labelAlign = formProps.labelAlign;
    const appendCol = labelCol && wrapperCol;
    const labelColCls = labelCol ? `${group_prefix}-col-${labelAlign}` : '';
    const labelContent = this.renderLabel(label, formProps);
    const inputGroupContent = /*#__PURE__*/react.createElement(inputGroup, Object.assign({
      disabled: formProps.disabled
    }, rest), inner);
    const groupErrorContent = /*#__PURE__*/react.createElement(GroupError, {
      fieldSet: groupFieldSet,
      showValidateIcon: formProps.showValidateIcon,
      isInInputGroup: true
    });
    const extraCls = classnames_default()(`${group_prefix}-field-extra`, {
      [`${group_prefix}-field-extra-string`]: typeof extraText === 'string',
      [`${group_prefix}-field-extra-middle`]: extraTextPosition === 'middle',
      [`${group_prefix}-field-extra-bottom`]: extraTextPosition === 'bottom'
    });
    const extraContent = extraText ? /*#__PURE__*/react.createElement("div", {
      className: extraCls,
      "x-semi-prop": "extraText"
    }, extraText) : null;
    let content;
    switch (true) {
      case !appendCol:
        content = /*#__PURE__*/react.createElement(react.Fragment, null, labelContent, /*#__PURE__*/react.createElement("div", null, extraTextPosition === 'middle' ? extraContent : null, inputGroupContent, extraTextPosition === 'bottom' ? extraContent : null, groupErrorContent));
        break;
      case appendCol && labelPosition === 'top':
        // When labelPosition is top, you need to add an overflow hidden div to the label, otherwise it will be arranged horizontally
        content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
          style: {
            overflow: 'hidden'
          }
        }, /*#__PURE__*/react.createElement(col, Object.assign({}, labelCol, {
          className: labelColCls
        }), labelContent)), /*#__PURE__*/react.createElement(col, Object.assign({}, wrapperCol), extraTextPosition === 'middle' ? extraContent : null, inputGroupContent, extraTextPosition === 'bottom' ? extraContent : null, groupErrorContent));
        break;
      case appendCol && labelPosition !== 'top':
        content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(col, Object.assign({}, labelCol, {
          className: labelColCls
        }), labelContent), /*#__PURE__*/react.createElement(col, Object.assign({}, wrapperCol), extraTextPosition === 'middle' ? extraContent : null, inputGroupContent, extraTextPosition === 'bottom' ? extraContent : null, groupErrorContent));
        break;
      default:
        break;
    }
    return /*#__PURE__*/react.createElement("div", {
      "x-label-pos": labelPosition,
      className: groupCls
    }, content);
  }
}
FormInputGroup.contextType = FormUpdaterContext;
/* harmony default export */ var group = (FormInputGroup);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/hooks/useFormUpdater.js


function useFormUpdater() {
  return (0,react.useContext)(FormUpdaterContext);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/hooks/useArrayFieldState.js


function useArrayFieldState() {
  const arrayFieldContext = (0,react.useContext)(ArrayFieldContext);
  return arrayFieldContext;
}
/* harmony default export */ var hooks_useArrayFieldState = (useArrayFieldState);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/hooks/useStateWithGetter.js

// https://github.com/facebook/react/issues/14543
function useStateWithGetter(initial) {
  const ref = (0,react.useRef)();
  const [state, setState] = (0,react.useState)(initial);
  ref.current = state;
  const set = value => {
    ref.current = value;
    setState(value);
  };
  const get = () => ref.current;
  return [state, set, get];
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/hoc/withField.js
/* eslint-disable react-hooks/rules-of-hooks */












const withField_prefix = form_constants_cssClasses.PREFIX;
// To avoid useLayoutEffect warning when ssr, refer: https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
// Fix issue 1140
const useIsomorphicEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
/**
 * withFiled is used to inject components
 * 1. Takes over the value and onChange of the component and synchronizes them to Form Foundation
 * 2. Insert <Label>
 * 3. Insert <ErrorMessage>
 */
function withField(Component, opts) {
  let SemiField = (props, ref) => {
    let {
      // condition,
      field,
      label,
      labelPosition,
      labelWidth,
      labelAlign,
      labelCol,
      wrapperCol,
      noLabel,
      noErrorMessage,
      isInInputGroup,
      initValue,
      validate,
      validateStatus,
      trigger,
      allowEmptyString,
      allowEmpty,
      emptyValue,
      rules,
      required,
      keepState,
      transform,
      name,
      fieldClassName,
      fieldStyle,
      convert,
      stopValidateWithError,
      helpText,
      extraText,
      extraTextPosition,
      pure,
      id,
      rest
    } = mergeProps(props);
    let {
      options,
      shouldInject
    } = mergeOptions(opts, props);
    warning(typeof field === 'undefined' && options.shouldInject, "[Semi Form]: 'field' is required, please check your props of Field Component");
    // 无需注入的直接返回，eg：Group内的checkbox、radio
    // Return without injection, eg: <Checkbox> / <Radio> inside CheckboxGroup/RadioGroup
    if (!shouldInject) {
      return /*#__PURE__*/react.createElement(Component, Object.assign({}, rest, {
        ref: ref
      }));
    }
    // grab formState from context
    const formState = hooks_useFormState();
    // grab formUpdater (the api for field to read/modify FormState) from context
    const updater = useFormUpdater();
    if (!updater.getFormProps) {
      warning(true, '[Semi Form]: Field Component must be use inside the Form, please check your dom declaration');
      return null;
    }
    let formProps = updater.getFormProps(['labelPosition', 'labelWidth', 'labelAlign', 'labelCol', 'wrapperCol', 'disabled', 'showValidateIcon', 'extraTextPosition', 'stopValidateWithError', 'trigger']);
    let mergeLabelPos = labelPosition || formProps.labelPosition;
    let mergeLabelWidth = labelWidth || formProps.labelWidth;
    let mergeLabelAlign = labelAlign || formProps.labelAlign;
    let mergeLabelCol = labelCol || formProps.labelCol;
    let mergeWrapperCol = wrapperCol || formProps.wrapperCol;
    let mergeExtraPos = extraTextPosition || formProps.extraTextPosition || 'bottom';
    let mergeStopValidateWithError = transformDefaultBooleanAPI(stopValidateWithError, formProps.stopValidateWithError, false);
    let mergeTrigger = transformTrigger(trigger, formProps.trigger);
    // To prevent user forgetting to pass the field, use undefined as the key, and updater.getValue will get the wrong value.
    let initValueInFormOpts = typeof field !== 'undefined' ? updater.getValue(field) : undefined; // Get the init value of form from formP rops.init Values Get the initial value set in the initValues of Form
    let initVal = typeof initValue !== 'undefined' ? initValue : initValueInFormOpts;
    // use arrayFieldState to fix issue 615
    let arrayFieldState;
    try {
      arrayFieldState = hooks_useArrayFieldState();
      if (arrayFieldState) {
        initVal = arrayFieldState.shouldUseInitValue && typeof initValue !== 'undefined' ? initValue : initValueInFormOpts;
      }
    } catch (err) {}
    // FIXME typeof initVal
    const [value, setValue, getVal] = useStateWithGetter(typeof initVal !== undefined ? initVal : null);
    const validateOnMount = mergeTrigger.includes('mount');
    allowEmpty = allowEmpty || updater.getFormProps().allowEmpty;
    // Error information: Array, String, undefined
    const [error, setError, getError] = useStateWithGetter();
    const [touched, setTouched] = (0,react.useState)();
    const [cursor, setCursor, getCursor] = useStateWithGetter(0);
    const [status, setStatus] = (0,react.useState)(validateStatus); // use props.validateStatus to init
    const isUnmounted = (0,react.useRef)(false);
    const rulesRef = (0,react.useRef)(rules);
    const validateRef = (0,react.useRef)(validate);
    const validatePromise = (0,react.useRef)(null);
    // notNotify is true means that the onChange of the Form does not need to be triggered
    // notUpdate is true means that this operation does not need to trigger the forceUpdate
    const updateTouched = (isTouched, callOpts) => {
      setTouched(isTouched);
      updater.updateStateTouched(field, isTouched, callOpts);
    };
    const updateError = (errors, callOpts) => {
      if (isUnmounted.current) {
        return;
      }
      if (errors === getError()) {
        // When the inspection result is unchanged, no need to update, saving a forceUpdate overhead
        // When errors is an array, deepEqual is not used, and it is always treated as a need to update
        // 检验结果不变时，无需更新，节省一次forceUpdate开销
        // errors为数组时，不做deepEqual，始终当做需要更新处理
        return;
      }
      setError(errors);
      updater.updateStateError(field, errors, callOpts);
      if (!utils_isValid(errors)) {
        setStatus('error');
      } else {
        setStatus('success');
      }
    };
    const updateValue = (val, callOpts) => {
      setValue(val);
      let newOpts = Object.assign(Object.assign({}, callOpts), {
        allowEmpty
      });
      updater.updateStateValue(field, val, newOpts);
    };
    const reset = () => {
      let callOpts = {
        notNotify: true,
        notUpdate: true
      };
      // reset is called by the FormFoundaion uniformly. The field level does not need to trigger notify and update.
      updateValue(initVal !== null ? initVal : undefined, callOpts);
      updateError(undefined, callOpts);
      updateTouched(undefined, callOpts);
      setStatus('default');
    };
    // Execute the validation rules specified by rules
    const _validateInternal = (val, callOpts) => {
      let latestRules = rulesRef.current || [];
      const validator = generateValidatesFromRules(field, latestRules);
      const model = {
        [field]: val
      };
      const rootPromise = new Promise((resolve, reject) => {
        validator.validate(model, {
          first: mergeStopValidateWithError
        }, (errors, fields) => {}).then(res => {
          if (isUnmounted.current || validatePromise.current !== rootPromise) {
            return;
          }
          // validation passed
          setStatus('success');
          updateError(undefined, callOpts);
          resolve({});
        }).catch(err => {
          if (isUnmounted.current || validatePromise.current !== rootPromise) {
            return;
          }
          let {
            errors,
            fields
          } = err;
          if (errors && fields) {
            let messages = errors.map(e => e.message);
            if (messages.length === 1) {
              messages = messages[0];
            }
            updateError(messages, callOpts);
            if (!utils_isValid(messages)) {
              setStatus('error');
              resolve(errors);
            }
          } else {
            // Some grammatical errors in rules
            setStatus('error');
            updateError(err.message, callOpts);
            resolve(err.message);
            throw err;
          }
        });
      });
      validatePromise.current = rootPromise;
      return rootPromise;
    };
    // execute custom validate function
    const _validate = (val, values, callOpts) => {
      const rootPromise = new Promise(resolve => {
        let maybePromisedErrors;
        // let errorThrowSync;
        try {
          maybePromisedErrors = validateRef.current(val, values);
        } catch (err) {
          // error throw by syncValidate
          maybePromisedErrors = err;
        }
        if (maybePromisedErrors === undefined) {
          resolve({});
          updateError(undefined, callOpts);
        } else if (isPromise(maybePromisedErrors)) {
          maybePromisedErrors.then(result => {
            // If the async validate is outdated (a newer validate occurs), the result should be discarded
            if (isUnmounted.current || validatePromise.current !== rootPromise) {
              return;
            }
            if (utils_isValid(result)) {
              // validate success，no need to do anything with result
              updateError(undefined, callOpts);
              resolve(null);
            } else {
              // validate failed
              updateError(result, callOpts);
              resolve(result);
            }
          });
        } else {
          if (utils_isValid(maybePromisedErrors)) {
            updateError(undefined, callOpts);
            resolve(null);
          } else {
            updateError(maybePromisedErrors, callOpts);
            resolve(maybePromisedErrors);
          }
        }
      });
      validatePromise.current = rootPromise;
      return rootPromise;
    };
    const fieldValidate = (val, callOpts) => {
      let finalVal = val;
      let latestRules = rulesRef.current;
      if (transform) {
        finalVal = transform(val);
      }
      if (validateRef.current) {
        return _validate(finalVal, updater.getValue(), callOpts);
      } else if (latestRules) {
        return _validateInternal(finalVal, callOpts);
      }
      return null;
    };
    /**
     * parse / format
     * validate when trigger
     *
     */
    const handleChange = function (newValue, e) {
      let fnKey = options.onKeyChangeFnName;
      if (fnKey in props && typeof props[options.onKeyChangeFnName] === 'function') {
        for (var _len = arguments.length, other = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          other[_key - 2] = arguments[_key];
        }
        props[options.onKeyChangeFnName](newValue, e, ...other);
      }
      // support various type component
      let val;
      if (!options.valuePath) {
        val = newValue;
      } else {
        val = object_get(newValue, options.valuePath);
      }
      // User can use convert function to updateValue before Component UI render
      if (typeof convert === 'function') {
        val = convert(val);
      }
      // TODO: allowEmptyString split into allowEmpty, emptyValue
      // Added abandonment warning
      // if (process.env.NODE_ENV !== 'production') {
      //     warning(allowEmptyString, `'allowEmptyString' will be de deprecated in next version, please replace with 'allowEmpty' & 'emptyValue'
      // `)
      // }
      // set value to undefined if it's an empty string
      // allowEmptyString={true} is equivalent to allowEmpty = {true} emptyValue = "
      if (allowEmptyString || allowEmpty) {
        if (val === '') {
          // do nothing
        }
      } else {
        if (val === emptyValue) {
          val = undefined;
        }
      }
      // maintain compoent cursor if needed
      try {
        if (e && e.target && e.target.selectionStart) {
          setCursor(e.target.selectionStart);
        }
      } catch (err) {}
      updateTouched(true, {
        notNotify: true,
        notUpdate: true
      });
      updateValue(val);
      // only validate when trigger includes change
      if (mergeTrigger.includes('change')) {
        fieldValidate(val);
      }
    };
    const handleBlur = function () {
      if (props.onBlur) {
        props.onBlur(...arguments);
      }
      if (!touched) {
        updateTouched(true);
      }
      if (mergeTrigger.includes('blur')) {
        let val = getVal();
        fieldValidate(val);
      }
    };
    /** Field level maintains a separate layer of data, which is convenient for Form to control Field to update the UI */
    // The field level maintains a separate layer of data, which is convenient for the Form to control the Field for UI updates.
    const fieldApi = {
      setValue: updateValue,
      setTouched: updateTouched,
      setError: updateError,
      reset,
      validate: fieldValidate
    };
    const fieldState = {
      value,
      error,
      touched,
      status
    };
    // avoid hooks capture value, fixed issue 346
    useIsomorphicEffect(() => {
      rulesRef.current = rules;
      validateRef.current = validate;
    }, [rules, validate]);
    useIsomorphicEffect(() => {
      isUnmounted.current = false;
      // exec validate once when trigger include 'mount'
      if (validateOnMount) {
        fieldValidate(value);
      }
      return () => {
        isUnmounted.current = true;
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // register when mounted，unregister when unmounted
    // register again when field change
    useIsomorphicEffect(() => {
      // register
      if (typeof field === 'undefined') {
        return () => {};
      }
      // log('register: ' + field);
      // field value may change after field component mounted, we use ref value here to get changed value
      const refValue = getVal();
      updater.register(field, {
        value: refValue,
        error,
        touched,
        status
      }, {
        field,
        fieldApi,
        keepState,
        allowEmpty: allowEmpty || allowEmptyString
      });
      // return unRegister cb
      return () => {
        updater.unRegister(field);
        // log('unRegister: ' + field);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field]);
    // id attribute to improve a11y
    const a11yId = id ? id : field;
    const labelId = `${a11yId}-label`;
    const helpTextId = `${a11yId}-helpText`;
    const extraTextId = `${a11yId}-extraText`;
    const errorMessageId = `${a11yId}-errormessage`;
    const FieldComponent = () => {
      // prefer to use validateStatus which pass by user throught props
      let blockStatus = validateStatus ? validateStatus : status;
      const extraCls = classnames_default()(`${withField_prefix}-field-extra`, {
        [`${withField_prefix}-field-extra-string`]: typeof extraText === 'string',
        [`${withField_prefix}-field-extra-middle`]: mergeExtraPos === 'middle',
        [`${withField_prefix}-field-extra-bottom`]: mergeExtraPos === 'bottom'
      });
      const extraContent = extraText ? /*#__PURE__*/react.createElement("div", {
        className: extraCls,
        id: extraTextId,
        "x-semi-prop": "extraText"
      }, extraText) : null;
      let newProps = Object.assign(Object.assign({
        id: a11yId,
        disabled: formProps.disabled
      }, rest), {
        ref,
        onBlur: handleBlur,
        [options.onKeyChangeFnName]: handleChange,
        [options.valueKey]: value,
        validateStatus: blockStatus,
        'aria-required': required,
        'aria-labelledby': labelId
      });
      if (name) {
        newProps['name'] = name;
      }
      if (helpText) {
        newProps['aria-describedby'] = extraText ? `${helpTextId} ${extraTextId}` : helpTextId;
      }
      if (extraText) {
        newProps['aria-describedby'] = helpText ? `${helpTextId} ${extraTextId}` : extraTextId;
      }
      if (status === 'error') {
        newProps['aria-errormessage'] = errorMessageId;
        newProps['aria-invalid'] = true;
      }
      const fieldCls = classnames_default()({
        [`${withField_prefix}-field`]: true,
        [`${withField_prefix}-field-${name}`]: Boolean(name),
        [fieldClassName]: Boolean(fieldClassName)
      });
      const fieldMaincls = classnames_default()({
        [`${withField_prefix}-field-main`]: true
      });
      if (mergeLabelPos === 'inset' && !noLabel) {
        newProps.insetLabel = label || field;
        newProps.insetLabelId = labelId;
        if (typeof label === 'object' && !reactUtils_isElement(label)) {
          newProps.insetLabel = label.text;
          newProps.insetLabelId = labelId;
        }
      }
      const com = /*#__PURE__*/react.createElement(Component, Object.assign({}, newProps));
      // when use in InputGroup, no need to insert <Label>、<ErrorMessage> inside Field, just add it at Group
      if (isInInputGroup) {
        return com;
      }
      if (pure) {
        let pureCls = classnames_default()(rest.className, {
          [`${withField_prefix}-field-pure`]: true,
          [`${withField_prefix}-field-${name}`]: Boolean(name),
          [fieldClassName]: Boolean(fieldClassName)
        });
        newProps.className = pureCls;
        return /*#__PURE__*/react.createElement(Component, Object.assign({}, newProps));
      }
      let withCol = mergeLabelCol && mergeWrapperCol;
      const labelColCls = mergeLabelAlign ? `${withField_prefix}-col-${mergeLabelAlign}` : '';
      // get label
      let labelContent = null;
      if (!noLabel && mergeLabelPos !== 'inset') {
        let needSpread = typeof label === 'object' && !reactUtils_isElement(label) ? label : {};
        labelContent = /*#__PURE__*/react.createElement(Label, Object.assign({
          text: label || field,
          id: labelId,
          required: required,
          name: a11yId || name || field,
          width: mergeLabelWidth,
          align: mergeLabelAlign
        }, needSpread));
      }
      const fieldMainContent = /*#__PURE__*/react.createElement("div", {
        className: fieldMaincls
      }, mergeExtraPos === 'middle' ? extraContent : null, com, !noErrorMessage ? /*#__PURE__*/react.createElement(ErrorMessage, {
        error: error,
        validateStatus: blockStatus,
        helpText: helpText,
        helpTextId: helpTextId,
        errorMessageId: errorMessageId,
        showValidateIcon: formProps.showValidateIcon
      }) : null, mergeExtraPos === 'bottom' ? extraContent : null);
      const withColContent = /*#__PURE__*/react.createElement(react.Fragment, null, mergeLabelPos === 'top' ? /*#__PURE__*/react.createElement("div", {
        style: {
          overflow: 'hidden'
        }
      }, /*#__PURE__*/react.createElement(col, Object.assign({}, mergeLabelCol, {
        className: labelColCls
      }), labelContent)) : /*#__PURE__*/react.createElement(col, Object.assign({}, mergeLabelCol, {
        className: labelColCls
      }), labelContent), /*#__PURE__*/react.createElement(col, Object.assign({}, mergeWrapperCol), fieldMainContent));
      return /*#__PURE__*/react.createElement("div", {
        className: fieldCls,
        style: fieldStyle,
        "x-label-pos": mergeLabelPos,
        "x-field-id": field,
        "x-extra-pos": mergeExtraPos
      }, withCol ? withColContent : /*#__PURE__*/react.createElement(react.Fragment, null, labelContent, fieldMainContent));
    };
    // !important optimization
    const shouldUpdate = [...Object.values(fieldState), ...Object.values(props), field, mergeLabelPos, mergeLabelAlign, formProps.disabled];
    if (options.shouldMemo) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      return (0,react.useMemo)(FieldComponent, [...shouldUpdate]);
    } else {
      // Some Custom Component with inner state shouldn't be memo, otherwise the component will not updated when the internal state is updated
      return FieldComponent();
    }
  };
  SemiField = /*#__PURE__*/(0,react.forwardRef)(SemiField);
  SemiField.displayName = getDisplayName(Component);
  return SemiField;
}
// eslint-disable-next-line
/* harmony default export */ var hoc_withField = (withField);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/input/util/calculateNodeHeight.js
// Reference to https://github.com/andreypopp/react-textarea-autosize/
let hiddenTextarea = null;
const HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
const forceHiddenStyles = node => {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(key => {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};
const getContentHeight = (node, sizingData) => {
  const height = node.scrollHeight;
  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  }
  // remove padding, since height = content
  return height - sizingData.paddingSize;
};
function calculateNodeHeight(sizingData, value) {
  let minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }
  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }
  const {
    paddingSize,
    borderSize,
    sizingStyle
  } = sizingData;
  const {
    boxSizing
  } = sizingStyle;
  Object.keys(sizingStyle).forEach(key => {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  let height = getContentHeight(hiddenTextarea, sizingData);
  // measure height of a textarea with a single row
  hiddenTextarea.value = 'x';
  // calc single row need to remove padding and border to avoid duplicated calc
  const rowHeight = getContentHeight(hiddenTextarea, sizingData) - paddingSize - borderSize;
  let minHeight = rowHeight * minRows;
  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }
  height = Math.max(minHeight, height);
  let maxHeight = rowHeight * maxRows;
  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }
  height = Math.min(maxHeight, height);
  return height;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/input/util/getSizingData.js
 // Reference to https://github.com/andreypopp/react-textarea-autosize/
const SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
// non-standard
'tabSize', 'textIndent',
// non-standard
'textRendering', 'textTransform', 'width'];
const getSizingData = node => {
  const style = window.getComputedStyle(node);
  if (style === null) {
    return null;
  }
  const sizingStyle = pick_default()(style, SIZING_STYLE);
  const {
    boxSizing
  } = sizingStyle;
  // probably node is detached from DOM, can't read computed dimensions
  if (boxSizing === '') {
    return null;
  }
  const paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  const borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle,
    paddingSize,
    borderSize
  };
};
/* harmony default export */ var util_getSizingData = (getSizingData);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/input/textareaFoundation.js







class TextAreaFoundation extends foundation {
  static get textAreaDefaultAdapter() {
    return {
      notifyChange: (noop_default()),
      setValue: (noop_default()),
      toggleFocusing: (noop_default()),
      toggleHovering: (noop_default()),
      notifyFocus: (noop_default()),
      notifyBlur: (noop_default()),
      notifyKeyDown: (noop_default()),
      notifyEnterPress: (noop_default())
    };
  }
  constructor(adapter) {
    super(Object.assign(Object.assign({}, TextAreaFoundation.textAreaDefaultAdapter), adapter));
    this.resizeTextarea = () => {
      var _a;
      const {
        height
      } = this.getStates();
      const {
        rows,
        autosize
      } = this.getProps();
      const node = this._adapter.getRef();
      const nodeSizingData = util_getSizingData(node);
      if (!nodeSizingData) {
        return;
      }
      const [minRows, maxRows] = autosize !== null && typeof autosize === 'object' ? [(_a = autosize === null || autosize === void 0 ? void 0 : autosize.minRows) !== null && _a !== void 0 ? _a : rows, autosize === null || autosize === void 0 ? void 0 : autosize.maxRows] : [rows];
      const newHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows);
      if (height !== newHeight) {
        this._adapter.notifyHeightUpdate(newHeight);
        node.style.height = `${newHeight}px`;
        return;
      }
    };
  }
  destroy() {}
  handleValueChange(v) {
    this._adapter.setValue(v);
  }
  handleChange(value, e) {
    const {
      maxLength,
      minLength,
      getValueLength
    } = this._adapter.getProps();
    let nextValue = value;
    if (maxLength && isFunction_default()(getValueLength)) {
      nextValue = this.handleVisibleMaxLength(value);
    }
    if (minLength && isFunction_default()(getValueLength)) {
      this.handleVisibleMinLength(nextValue);
    }
    if (this._isControlledComponent()) {
      this._adapter.notifyChange(nextValue, e);
    } else {
      this._adapter.setValue(nextValue);
      this._adapter.notifyChange(nextValue, e);
    }
  }
  /**
   * Modify minLength to trigger browser check for minimum length
   * Controlled mode is not checked
   * @param {String} value
   */
  handleVisibleMinLength(value) {
    const {
      minLength,
      getValueLength
    } = this._adapter.getProps();
    const {
      minLength: stateMinLength
    } = this._adapter.getStates();
    if (isNumber_default()(minLength) && minLength >= 0 && isFunction_default()(getValueLength) && isString_default()(value)) {
      const valueLength = getValueLength(value);
      if (valueLength < minLength) {
        const newMinLength = value.length + (minLength - valueLength);
        newMinLength !== stateMinLength && this._adapter.setMinLength(newMinLength);
      } else {
        stateMinLength !== minLength && this._adapter.setMinLength(minLength);
      }
    }
  }
  /**
   * Handle input emoji characters beyond maxLength
   * Controlled mode is not checked
   * @param {String} value
   */
  handleVisibleMaxLength(value) {
    const {
      maxLength,
      getValueLength
    } = this._adapter.getProps();
    if (isNumber_default()(maxLength) && maxLength >= 0 && isString_default()(value)) {
      if (isFunction_default()(getValueLength)) {
        const valueLength = getValueLength(value);
        if (valueLength > maxLength) {
          console.warn('[Semi TextArea] The input character is truncated because the input length exceeds the maximum length limit');
          const truncatedValue = this.handleTruncateValue(value, maxLength);
          return truncatedValue;
        }
      } else {
        if (value.length > maxLength) {
          console.warn('[Semi TextArea] The input character is truncated because the input length exceeds the maximum length limit');
          return value.slice(0, maxLength);
        }
      }
      return value;
    }
    return undefined;
  }
  /**
   * Truncate textarea values based on maximum length
   * @param {String} value
   * @param {Number} maxLength
   * @returns {String}
   */
  handleTruncateValue(value, maxLength) {
    const {
      getValueLength
    } = this._adapter.getProps();
    if (isFunction_default()(getValueLength)) {
      let truncatedValue = '';
      for (let i = 1, len = value.length; i <= len; i++) {
        const currentValue = value.slice(0, i);
        if (getValueLength(currentValue) > maxLength) {
          return truncatedValue;
        } else {
          truncatedValue = currentValue;
        }
      }
      return truncatedValue;
    } else {
      return value.slice(0, maxLength);
    }
  }
  handleFocus(e) {
    const {
      value
    } = this.getStates();
    this._adapter.toggleFocusing(true);
    this._adapter.notifyFocus(value, e);
  }
  handleBlur(e) {
    const {
      value
    } = this.getStates();
    const {
      maxLength
    } = this.getProps();
    let realValue = value;
    if (maxLength) {
      // 如果设置了 maxLength，在中文输输入过程中，如果点击外部触发 blur，则拼音字符的所有内容会回显，
      // 该表现不符合 maxLength 规定，因此需要在 blur 的时候二次确认
      // 详情见 https://github.com/DouyinFE/semi-design/issues/2005
      // If maxLength is set, during the Chinese input process, if you click outside to trigger blur, 
      // all the contents of the Pinyin characters will be echoed.
      // This behavior does not meet the maxLength requirement, so we need to confirm twice when blurring。
      // For details, see https://github.com/DouyinFE/semi-design/issues/2005
      realValue = this.handleVisibleMaxLength(value);
      if (realValue !== value) {
        if (!this._isControlledComponent()) {
          this._adapter.setValue(realValue);
        }
        this._adapter.notifyChange(realValue, e);
      }
    }
    this._adapter.toggleFocusing(false);
    this._adapter.notifyBlur(realValue, e);
  }
  handleKeyDown(e) {
    this._adapter.notifyKeyDown(e);
    if (e.keyCode === 13) {
      this._adapter.notifyPressEnter(e);
    }
  }
  // e: MouseEvent
  handleMouseEnter(e) {
    this._adapter.toggleHovering(true);
  }
  // e: MouseEvent
  handleMouseLeave(e) {
    this._adapter.toggleHovering(false);
  }
  isAllowClear() {
    const {
      value,
      isFocus,
      isHover
    } = this._adapter.getStates();
    const {
      showClear,
      disabled,
      readonly
    } = this._adapter.getProps();
    const allowClear = value && showClear && !disabled && (isFocus || isHover) && !readonly;
    return allowClear;
  }
  handleClear(e) {
    const {
      isFocus
    } = this.getStates();
    if (this._isControlledComponent('value')) {
      this._adapter.setState({
        isFocus: false
      });
    } else {
      this._adapter.setState({
        value: '',
        isFocus: false
      });
    }
    if (isFocus) {
      this._adapter.notifyBlur('', e);
    }
    this._adapter.notifyChange('', e);
    this._adapter.notifyClear(e);
    this.stopPropagation(e);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/input/textarea.js






var textarea_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






// import '@douyinfe/semi-foundation/lib/es/input/textarea.css';


const textarea_prefixCls = input_constants_cssClasses.PREFIX;
class TextArea extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleClear = e => {
      this.foundation.handleClear(e);
    };
    this.setRef = node => {
      this.libRef.current = node;
      const {
        forwardRef
      } = this.props;
      if (typeof forwardRef === 'function') {
        forwardRef(node);
      } else if (forwardRef && typeof forwardRef === 'object') {
        forwardRef.current = node;
      }
    };
    const initValue = 'value' in props ? props.value : props.defaultValue;
    this.state = {
      value: initValue,
      isFocus: false,
      isHover: false,
      height: 0,
      minLength: props.minLength,
      cachedValue: props.value
    };
    this.focusing = false;
    this.foundation = new TextAreaFoundation(this.adapter);
    this.libRef = /*#__PURE__*/react.createRef();
    this.throttledResizeTextarea = throttle_default()(this.foundation.resizeTextarea, 10);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setValue: value => this.setState({
        value
      }, () => {
        if (this.props.autosize) {
          this.foundation.resizeTextarea();
        }
      }),
      getRef: () => this.libRef.current,
      toggleFocusing: focusing => this.setState({
        isFocus: focusing
      }),
      toggleHovering: hovering => this.setState({
        isHover: hovering
      }),
      notifyChange: (val, e) => {
        this.props.onChange(val, e);
      },
      notifyClear: e => this.props.onClear(e),
      notifyBlur: (val, e) => this.props.onBlur(e),
      notifyFocus: (val, e) => this.props.onFocus(e),
      notifyKeyDown: e => {
        this.props.onKeyDown(e);
      },
      notifyHeightUpdate: height => {
        this.setState({
          height
        });
        this.props.onResize({
          height
        });
      },
      notifyPressEnter: e => {
        this.props.onEnterPress && this.props.onEnterPress(e);
      },
      setMinLength: minLength => this.setState({
        minLength
      })
    });
  }
  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    if (props.value !== state.cachedValue) {
      willUpdateStates.value = props.value;
      willUpdateStates.cachedValue = props.value;
    }
    return willUpdateStates;
  }
  componentWillUnmount() {
    var _a, _b;
    if (this.throttledResizeTextarea) {
      (_b = (_a = this.throttledResizeTextarea) === null || _a === void 0 ? void 0 : _a.cancel) === null || _b === void 0 ? void 0 : _b.call(_a);
      this.throttledResizeTextarea = null;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if ((this.props.value !== prevProps.value || this.props.placeholder !== prevProps.placeholder) && this.props.autosize) {
      this.foundation.resizeTextarea();
    }
  }
  renderClearBtn() {
    const {
      showClear
    } = this.props;
    const displayClearBtn = this.foundation.isAllowClear();
    const clearCls = classnames_default()(`${textarea_prefixCls}-clearbtn`, {
      [`${textarea_prefixCls}-clearbtn-hidden`]: !displayClearBtn
    });
    if (showClear) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        react.createElement("div", {
          className: clearCls,
          onClick: this.handleClear
        }, /*#__PURE__*/react.createElement(IconClear, null))
      );
    }
    return null;
  }
  renderCounter() {
    let counter, current, total, countCls;
    const {
      showCounter,
      maxCount,
      getValueLength
    } = this.props;
    if (showCounter || maxCount) {
      const {
        value
      } = this.state;
      // eslint-disable-next-line no-nested-ternary
      current = value ? isFunction_default()(getValueLength) ? getValueLength(value) : value.length : 0;
      total = maxCount || null;
      countCls = classnames_default()(`${textarea_prefixCls}-textarea-counter`, {
        [`${textarea_prefixCls}-textarea-counter-exceed`]: current > total
      });
      counter = /*#__PURE__*/react.createElement("div", {
        className: countCls
      }, current, total ? '/' : null, total);
    } else {
      counter = null;
    }
    return counter;
  }
  render() {
    const _a = this.props,
      {
        autosize,
        placeholder,
        onEnterPress,
        onResize,
        // resize,
        disabled,
        readonly,
        className,
        showCounter,
        validateStatus,
        maxCount,
        defaultValue,
        style,
        forwardRef,
        getValueLength,
        maxLength,
        minLength,
        showClear,
        borderless,
        autoFocus
      } = _a,
      rest = textarea_rest(_a, ["autosize", "placeholder", "onEnterPress", "onResize", "disabled", "readonly", "className", "showCounter", "validateStatus", "maxCount", "defaultValue", "style", "forwardRef", "getValueLength", "maxLength", "minLength", "showClear", "borderless", "autoFocus"]);
    const {
      isFocus,
      value,
      minLength: stateMinLength
    } = this.state;
    const wrapperCls = classnames_default()(className, `${textarea_prefixCls}-textarea-wrapper`, {
      [`${textarea_prefixCls}-textarea-borderless`]: borderless,
      [`${textarea_prefixCls}-textarea-wrapper-disabled`]: disabled,
      [`${textarea_prefixCls}-textarea-wrapper-readonly`]: readonly,
      [`${textarea_prefixCls}-textarea-wrapper-${validateStatus}`]: Boolean(validateStatus),
      [`${textarea_prefixCls}-textarea-wrapper-focus`]: isFocus
      // [`${prefixCls}-textarea-wrapper-resize`]: !autosize && resize,
    });
    // const ref = this.props.forwardRef || this.textAreaRef;
    const itemCls = classnames_default()(`${textarea_prefixCls}-textarea`, {
      [`${textarea_prefixCls}-textarea-disabled`]: disabled,
      [`${textarea_prefixCls}-textarea-readonly`]: readonly,
      [`${textarea_prefixCls}-textarea-autosize`]: isObject_default()(autosize) ? isUndefined_default()(autosize === null || autosize === void 0 ? void 0 : autosize.maxRows) : autosize,
      [`${textarea_prefixCls}-textarea-showClear`]: showClear
    });
    const itemProps = Object.assign(Object.assign({}, omit_default()(rest, 'insetLabel', 'insetLabelId', 'getValueLength', 'onClear', 'showClear')), {
      autoFocus: autoFocus || this.props['autofocus'],
      className: itemCls,
      disabled,
      readOnly: readonly,
      placeholder: !placeholder ? null : placeholder,
      onChange: e => this.foundation.handleChange(e.target.value, e),
      onFocus: e => this.foundation.handleFocus(e),
      onBlur: e => this.foundation.handleBlur(e.nativeEvent),
      onKeyDown: e => this.foundation.handleKeyDown(e),
      value: value === null || value === undefined ? '' : value
    });
    if (!isFunction_default()(getValueLength)) {
      itemProps.maxLength = maxLength;
    }
    if (stateMinLength) {
      itemProps.minLength = stateMinLength;
    }
    return /*#__PURE__*/react.createElement("div", {
      className: wrapperCls,
      style: style,
      onMouseEnter: e => this.foundation.handleMouseEnter(e),
      onMouseLeave: e => this.foundation.handleMouseLeave(e)
    }, autosize ? /*#__PURE__*/react.createElement(ReactResizeObserver, {
      onResize: this.throttledResizeTextarea
    }, /*#__PURE__*/react.createElement("textarea", Object.assign({}, itemProps, {
      ref: this.setRef
    }))) : /*#__PURE__*/react.createElement("textarea", Object.assign({}, itemProps, {
      ref: this.setRef
    })), this.renderClearBtn(), this.renderCounter());
  }
}
TextArea.propTypes = {
  autosize: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  borderless: (prop_types_default()).bool,
  placeholder: (prop_types_default()).string,
  value: (prop_types_default()).string,
  rows: (prop_types_default()).number,
  cols: (prop_types_default()).number,
  maxCount: (prop_types_default()).number,
  onEnterPress: (prop_types_default()).func,
  validateStatus: (prop_types_default()).string,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  showClear: (prop_types_default()).bool,
  onClear: (prop_types_default()).func,
  onResize: (prop_types_default()).func,
  getValueLength: (prop_types_default()).func
  // TODO
  // resize: PropTypes.bool,
};

TextArea.defaultProps = {
  autosize: false,
  borderless: false,
  rows: 4,
  cols: 20,
  showCounter: false,
  showClear: false,
  onEnterPress: (noop_default()),
  onChange: (noop_default()),
  onBlur: (noop_default()),
  onFocus: (noop_default()),
  onKeyDown: (noop_default()),
  onResize: (noop_default()),
  onClear: (noop_default())
  // resize: false,
};

const ForwardTextarea = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/react.createElement(TextArea, Object.assign({}, props, {
  forwardRef: ref
})));
/* harmony default export */ var input_textarea = (ForwardTextarea);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/radio/radioFoundation.js


class RadioFoundation extends foundation {
  constructor() {
    super(...arguments);
    this.handleFocusVisible = event => {
      const {
        target
      } = event;
      try {
        if (target.matches(':focus-visible')) {
          this._adapter.setFocusVisible(true);
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Radio] The current browser does not support the focus-visible');
      }
    };
    this.handleBlur = () => {
      this._adapter.setFocusVisible(false);
    };
  }
  init() {
    const {
      children,
      extra,
      extraId,
      addonId
    } = this._adapter.getProps();
    if (children && !addonId) {
      this._adapter.setAddonId();
    }
    if (extra && !extraId) {
      this._adapter.setExtraId();
    }
  }
  setHover(hover) {
    this._adapter.setHover(hover);
  }
  setChecked(checked) {
    this._adapter.setChecked(checked);
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/radio/constants.js

const radioClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-radio`,
  INNER: `${BASE_CLASS_PREFIX}-radio-inner`,
  TEXT: `${BASE_CLASS_PREFIX}-radio-text`,
  INPUT: `${BASE_CLASS_PREFIX}-radio-input`,
  CHECKED: `${BASE_CLASS_PREFIX}-radio-checked`,
  DISABLED: `${BASE_CLASS_PREFIX}-radio-disabled`,
  BUTTON: `${BASE_CLASS_PREFIX}-radio-button`
};
const radioGroupClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-radioGroup`,
  INNER: `${BASE_CLASS_PREFIX}-radioGroup-inner`,
  TEXT: `${BASE_CLASS_PREFIX}-radioGroup-text`,
  INPUT: `${BASE_CLASS_PREFIX}-radioGroup-input`,
  CHECKED: `${BASE_CLASS_PREFIX}-radioGroup-checked`,
  DISABLED: `${BASE_CLASS_PREFIX}-radioGroup-disabled`
};
const radio_constants_strings = {
  DIRECTION_SET: ['horizontal', 'vertical'],
  DEFAULT_DIRECTION: 'horizontal',
  MODE: ['advanced', ''],
  TYPE_DEFAULT: 'default',
  TYPE_BUTTON: 'button',
  TYPE_CARD: 'card',
  TYPE_PURECARD: 'pureCard',
  BUTTON_SIZE: ['middle', 'small', 'large']
};
const radio_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/radio/radioInnerFoundation.js

class RadioInnerFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    const checked = this._adapter.getProp('checked');
    const defaultChecked = this._adapter.getProp('defaultChecked');
    this.setChecked(checked || defaultChecked);
  }
  setChecked(checked) {
    this._adapter.setNativeControlChecked(checked);
  }
  getChecked() {
    return this._adapter.getProp('checked');
  }
  handleChange(e) {
    const isControlledMode = ('checked' in this.getProps());
    const {
      checked
    } = e.target;
    const stopPropagation = () => {
      e.stopPropagation();
    };
    const preventDefault = () => {
      e.preventDefault();
    };
    const cbValue = {
      target: Object.assign(Object.assign({}, this.getProps()), {
        checked
      }),
      stopPropagation,
      preventDefault
    };
    if (isControlledMode) {
      this._adapter.notifyChange(cbValue);
    } else {
      this.setChecked(checked);
      this._adapter.notifyChange(cbValue);
    }
  }
  destroy() {}
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/radio/context.js

const context_Context = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var radio_context = (context_Context);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconRadio.js


function IconRadio_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5,
    fill: "currentColor"
  }));
}
const IconRadio_IconComponent = (0,Icon/* convertIcon */.A)(IconRadio_SvgComponent, 'radio');
/* harmony default export */ var IconRadio = (IconRadio_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/radio/radioInner.js









class RadioInner extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: false
    };
    this.foundation = new RadioInnerFoundation(this.adapter);
    this.onChange = this.onChange.bind(this);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setNativeControlChecked: checked => {
        this.setState({
          checked
        });
      },
      notifyChange: e => {
        this.props.onChange(e);
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.foundation.setChecked(this.props.checked);
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  blur() {
    this.inputEntity.blur();
  }
  focus() {
    const {
      preventScroll
    } = this.props;
    this.inputEntity.focus({
      preventScroll
    });
  }
  onChange(e) {
    this.foundation.handleChange(e);
  }
  render() {
    const {
      disabled,
      mode,
      autoFocus,
      name,
      isButtonRadio,
      isPureCardRadioGroup,
      addonId,
      extraId,
      'aria-label': ariaLabel,
      focusInner,
      onInputFocus,
      onInputBlur
    } = this.props;
    const {
      checked
    } = this.state;
    const prefix = this.props.prefixCls || radioClasses.PREFIX;
    const wrapper = classnames_default()({
      [`${prefix}-inner`]: true,
      [`${prefix}-inner-checked`]: Boolean(checked),
      [`${prefix}-inner-buttonRadio`]: isButtonRadio,
      [`${prefix}-inner-pureCardRadio`]: isPureCardRadioGroup
    });
    const inner = classnames_default()({
      [`${prefix}-focus`]: focusInner,
      [`${prefix}-focus-border`]: focusInner && !checked,
      [`${prefix}-inner-display`]: !isButtonRadio
    });
    return /*#__PURE__*/react.createElement("span", {
      className: wrapper
    }, /*#__PURE__*/react.createElement("input", {
      ref: ref => {
        this.inputEntity = ref;
      },
      autoFocus: autoFocus,
      type: mode === 'advanced' ? 'checkbox' : 'radio',
      checked: Boolean(checked),
      disabled: disabled,
      onChange: this.onChange,
      name: name,
      "aria-label": ariaLabel,
      "aria-labelledby": addonId,
      "aria-describedby": extraId,
      onFocus: onInputFocus,
      onBlur: onInputBlur
    }), /*#__PURE__*/react.createElement("span", {
      className: inner
    }, checked ? /*#__PURE__*/react.createElement(IconRadio, null) : null));
  }
}
RadioInner.contextType = radio_context;
RadioInner.propTypes = {
  checked: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  isButtonRadio: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  mode: prop_types_default().oneOf(['advanced', '']),
  'aria-label': (prop_types_default()).string,
  focusInner: (prop_types_default()).bool,
  onInputFocus: (prop_types_default()).func,
  onInputBlur: (prop_types_default()).func,
  preventScroll: (prop_types_default()).bool
};
RadioInner.defaultProps = {
  onChange: (noop_default()),
  isButtonRadio: false
};
/* harmony default export */ var radioInner = (RadioInner);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/radio/radio.js



var radio_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






// import '@douyinfe/semi-foundation/lib/es/radio/radio.css';



class Radio extends BaseComponent {
  constructor(props) {
    super(props);
    this.onChange = e => {
      const {
        onChange
      } = this.props;
      if (this.isInGroup()) {
        const {
          radioGroup
        } = this.context;
        radioGroup.onChange && radioGroup.onChange(e);
      }
      !('checked' in this.props) && this.foundation.setChecked(e.target.checked);
      onChange && onChange(e);
    };
    this.handleMouseEnter = e => {
      this.props.onMouseEnter(e);
      this.foundation.setHover(true);
    };
    this.handleMouseLeave = e => {
      this.props.onMouseLeave(e);
      this.foundation.setHover(false);
    };
    this.handleFocusVisible = event => {
      this.foundation.handleFocusVisible(event);
    };
    this.handleBlur = event => {
      this.foundation.handleBlur();
    };
    this.state = {
      hover: false,
      addonId: props.addonId,
      extraId: props.extraId,
      checked: props.checked || props.defaultChecked || false
    };
    this.foundation = new RadioFoundation(this.adapter);
    this.radioEntity = null;
  }
  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      if (isUndefined_default()(this.props.checked)) {
        this.foundation.setChecked(false);
      } else if (isBoolean_default()(this.props.checked)) {
        this.foundation.setChecked(this.props.checked);
      }
    }
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setHover: hover => {
        this.setState({
          hover
        });
      },
      setAddonId: () => {
        this.setState({
          addonId: getUuidShort({
            prefix: 'addon'
          })
        });
      },
      setChecked: checked => {
        this.setState({
          checked
        });
      },
      setExtraId: () => {
        this.setState({
          extraId: getUuidShort({
            prefix: 'extra'
          })
        });
      },
      setFocusVisible: focusVisible => {
        this.setState({
          focusVisible
        });
      }
    });
  }
  isInGroup() {
    // eslint-disable-next-line react/destructuring-assignment
    return this.context && this.context.radioGroup;
  }
  focus() {
    this.radioEntity.focus();
  }
  blur() {
    this.radioEntity.blur();
  }
  render() {
    const _a = this.props,
      {
        addonClassName,
        addonStyle,
        disabled,
        style,
        className,
        prefixCls,
        displayMode,
        children,
        extra,
        mode,
        type,
        value: propValue,
        name
      } = _a,
      rest = radio_rest(_a, ["addonClassName", "addonStyle", "disabled", "style", "className", "prefixCls", "displayMode", "children", "extra", "mode", "type", "value", "name"]);
    let realChecked, isDisabled, realMode, isButtonRadioGroup, isCardRadioGroup, isPureCardRadioGroup, isButtonRadioComponent, buttonSize, realPrefixCls;
    const {
      hover: isHover,
      addonId,
      extraId,
      focusVisible,
      checked
    } = this.state;
    const props = {
      checked,
      disabled
    };
    if (this.isInGroup()) {
      realChecked = this.context.radioGroup.value === propValue;
      isDisabled = disabled || this.context.radioGroup.disabled;
      realMode = this.context.mode;
      isButtonRadioGroup = this.context.radioGroup.isButtonRadio;
      isCardRadioGroup = this.context.radioGroup.isCardRadio;
      isPureCardRadioGroup = this.context.radioGroup.isPureCardRadio;
      buttonSize = this.context.radioGroup.buttonSize;
      realPrefixCls = prefixCls || this.context.radioGroup.prefixCls;
      props.checked = realChecked;
      props.disabled = isDisabled;
    } else {
      realChecked = checked;
      isDisabled = disabled;
      realMode = mode;
      isButtonRadioComponent = type === 'button';
      realPrefixCls = prefixCls;
      isButtonRadioGroup = type === radio_constants_strings.TYPE_BUTTON;
      isPureCardRadioGroup = type === radio_constants_strings.TYPE_PURECARD;
      isCardRadioGroup = type === radio_constants_strings.TYPE_CARD || isPureCardRadioGroup;
    }
    const isButtonRadio = typeof isButtonRadioGroup === 'undefined' ? isButtonRadioComponent : isButtonRadioGroup;
    const prefix = realPrefixCls || radioClasses.PREFIX;
    const focusOuter = isCardRadioGroup || isPureCardRadioGroup || isButtonRadio;
    const wrapper = classnames_default()(prefix, {
      [`${prefix}-disabled`]: isDisabled,
      [`${prefix}-checked`]: realChecked,
      [`${prefix}-${displayMode}`]: Boolean(displayMode),
      [`${prefix}-buttonRadioComponent`]: isButtonRadioComponent,
      [`${prefix}-buttonRadioGroup`]: isButtonRadioGroup,
      [`${prefix}-buttonRadioGroup-${buttonSize}`]: isButtonRadioGroup && buttonSize,
      [`${prefix}-cardRadioGroup`]: isCardRadioGroup,
      [`${prefix}-cardRadioGroup_disabled`]: isDisabled && isCardRadioGroup,
      [`${prefix}-cardRadioGroup_checked`]: isCardRadioGroup && realChecked && !isDisabled,
      [`${prefix}-cardRadioGroup_checked_disabled`]: isCardRadioGroup && realChecked && isDisabled,
      [`${prefix}-cardRadioGroup_hover`]: isCardRadioGroup && !realChecked && isHover && !isDisabled,
      [className]: Boolean(className),
      [`${prefix}-focus`]: focusVisible && (isCardRadioGroup || isPureCardRadioGroup)
    });
    const groupName = this.isInGroup() && this.context.radioGroup.name;
    const addonCls = classnames_default()({
      [`${prefix}-addon`]: !isButtonRadio,
      [`${prefix}-addon-buttonRadio`]: isButtonRadio,
      [`${prefix}-addon-buttonRadio-checked`]: isButtonRadio && realChecked,
      [`${prefix}-addon-buttonRadio-disabled`]: isButtonRadio && isDisabled,
      [`${prefix}-addon-buttonRadio-hover`]: isButtonRadio && !realChecked && !isDisabled && isHover,
      [`${prefix}-addon-buttonRadio-${buttonSize}`]: isButtonRadio && buttonSize,
      [`${prefix}-focus`]: focusVisible && isButtonRadio
    }, addonClassName);
    const renderContent = () => {
      if (!children && !extra) {
        return null;
      }
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()([`${prefix}-content`, {
          [`${prefix}-isCardRadioGroup_content`]: isCardRadioGroup
        }])
      }, children ? /*#__PURE__*/react.createElement("span", {
        className: addonCls,
        style: addonStyle,
        id: addonId,
        "x-semi-prop": "children"
      }, children) : null, extra && !isButtonRadio ? /*#__PURE__*/react.createElement("div", {
        className: `${prefix}-extra`,
        id: extraId,
        "x-semi-prop": "extra"
      }, extra) : null);
    };
    return /*#__PURE__*/react.createElement("label", Object.assign({
      style: style,
      className: wrapper,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }, this.getDataAttr(rest)), /*#__PURE__*/react.createElement(radioInner, Object.assign({}, this.props, props, {
      mode: realMode,
      name: name !== null && name !== void 0 ? name : groupName,
      isButtonRadio: isButtonRadio,
      isPureCardRadioGroup: isPureCardRadioGroup,
      onChange: this.onChange,
      ref: ref => {
        this.radioEntity = ref;
      },
      addonId: children && addonId,
      extraId: extra && extraId,
      focusInner: focusVisible && !focusOuter,
      onInputFocus: this.handleFocusVisible,
      onInputBlur: this.handleBlur
    })), renderContent());
  }
}
Radio.contextType = radio_context;
Radio.propTypes = {
  autoFocus: (prop_types_default()).bool,
  checked: (prop_types_default()).bool,
  defaultChecked: (prop_types_default()).bool,
  value: (prop_types_default()).any,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  disabled: (prop_types_default()).bool,
  prefixCls: (prop_types_default()).string,
  displayMode: prop_types_default().oneOf(['vertical', '']),
  onChange: (prop_types_default()).func,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  mode: prop_types_default().oneOf(radio_constants_strings.MODE),
  extra: (prop_types_default()).node,
  addonStyle: (prop_types_default()).object,
  addonClassName: (prop_types_default()).string,
  type: prop_types_default().oneOf([radio_constants_strings.TYPE_DEFAULT, radio_constants_strings.TYPE_BUTTON, radio_constants_strings.TYPE_CARD, radio_constants_strings.TYPE_PURECARD]),
  'aria-label': (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool
};
Radio.defaultProps = {
  autoFocus: false,
  defaultChecked: false,
  value: undefined,
  style: undefined,
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default()),
  mode: '',
  type: 'default'
};
Radio.elementType = 'Radio';
/* harmony default export */ var radio_radio = (Radio);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/radio/radioGroupFoundation.js

class RadioGroupFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    const displayValue = this._getDisplayValue();
    this._setValue(displayValue);
  }
  _getDisplayValue() {
    const {
      value,
      defaultValue
    } = this.getProps();
    let displayValue;
    if ('value' in this.getProps()) {
      displayValue = value;
    } else if ('defaultValue' in this.getProps()) {
      displayValue = defaultValue;
    }
    return displayValue;
  }
  handleChange(evt) {
    const mode = this.getProp('mode');
    const lastValue = this.getState('value');
    const {
      checked,
      value
    } = evt.target;
    const isControlledComponent = this._adapter.isInProps('value');
    const cbValue = Object.assign(Object.assign({}, evt), {
      target: Object.assign(Object.assign({}, evt.target), {
        value
      })
    });
    if (mode === 'advanced' && !checked) {
      cbValue.target.value = undefined;
    }
    if (!isControlledComponent) {
      if (mode === 'advanced' && !checked) {
        this._setValue(undefined);
      } else {
        this._setValue(value);
      }
    }
    if (mode === 'advanced' || lastValue !== value) {
      this._adapter.notifyChange(cbValue);
    }
  }
  // call when prop.value change
  handlePropValueChange(propValue) {
    this._setValue(propValue);
  }
  _setValue(value) {
    this._adapter.setValue(value);
  }
  destroy() {}
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/radio/radioGroup.js

var radioGroup_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








class RadioGroup extends BaseComponent {
  constructor(props) {
    super(props);
    this.onChange = evt => {
      this.foundation.handleChange(evt);
    };
    this.getFormatName = () => this.props.name || 'default';
    this.state = {
      value: props.value || props.defaultValue
    };
    this.foundation = new RadioGroupFoundation(this.adapter);
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentDidUpdate(prevProps) {
    if (typeof prevProps.value === 'number' && isNaN(prevProps.value) && typeof this.props.value === 'number' && isNaN(this.props.value)) {
      // `NaN === NaN` returns false, and this will fail the next if check
      // therefore triggering an infinite loop
      return;
    }
    if (prevProps.value !== this.props.value) {
      this.foundation.handlePropValueChange(this.props.value);
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setValue: value => {
        this.setState({
          value
        });
      },
      getProps: () => this.props,
      isInProps: name => Boolean(name in this.props),
      notifyChange: evt => {
        this.props.onChange && this.props.onChange(evt);
      }
    });
  }
  render() {
    const _a = this.props,
      {
        children,
        options,
        mode,
        prefixCls,
        className,
        style,
        direction,
        type,
        buttonSize,
        id
      } = _a,
      rest = radioGroup_rest(_a, ["children", "options", "mode", "prefixCls", "className", "style", "direction", "type", "buttonSize", "id"]);
    const isButtonRadio = type === radio_constants_strings.TYPE_BUTTON;
    const isPureCardRadio = type === radio_constants_strings.TYPE_PURECARD;
    const isCardRadio = type === radio_constants_strings.TYPE_CARD || isPureCardRadio;
    const isDefaultRadio = type === radio_constants_strings.TYPE_DEFAULT;
    const prefix = prefixCls || radioGroupClasses.PREFIX;
    const prefixClsDisplay = classnames_default()(className, {
      [prefix]: true,
      [`${prefix}-wrapper`]: true,
      [`${prefix}-${direction}`]: direction && !isButtonRadio,
      [`${prefix}-${direction}-default`]: direction && isDefaultRadio,
      [`${prefix}-${direction}-card`]: direction && isCardRadio,
      [`${prefix}-buttonRadio`]: isButtonRadio
    });
    const realValue = this.state.value;
    let inner;
    if (options) {
      inner = (options || []).map((option, index) => {
        if (typeof option === 'string') {
          return /*#__PURE__*/react.createElement(radio_radio, {
            key: index,
            disabled: this.props.disabled,
            value: option
          }, option);
        } else {
          return /*#__PURE__*/react.createElement(radio_radio, {
            key: index,
            disabled: option.disabled || this.props.disabled,
            value: option.value,
            extra: option.extra,
            className: option.className,
            style: option.style
          }, option.label);
        }
      });
    } else if (children) {
      inner = react.Children.map(children, (itm, index) => /*#__PURE__*/react.isValidElement(itm) ? /*#__PURE__*/react.cloneElement(itm, {
        key: index
      }) : null);
    }
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: prefixClsDisplay,
      style: style,
      id: id,
      "aria-label": this.props['aria-label'],
      "aria-invalid": this.props['aria-invalid'],
      "aria-errormessage": this.props['aria-errormessage'],
      "aria-labelledby": this.props['aria-labelledby'],
      "aria-describedby": this.props['aria-describedby'],
      "aria-required": this.props['aria-required']
    }, this.getDataAttr(rest)), /*#__PURE__*/react.createElement(radio_context.Provider, {
      value: {
        radioGroup: {
          onChange: this.onChange,
          value: realValue,
          disabled: this.props.disabled,
          name: this.getFormatName(),
          isButtonRadio,
          isCardRadio,
          isPureCardRadio,
          buttonSize,
          prefixCls
        },
        mode
      }
    }, inner));
  }
}
RadioGroup.propTypes = {
  defaultValue: (prop_types_default()).any,
  disabled: (prop_types_default()).bool,
  name: (prop_types_default()).string,
  options: (prop_types_default()).array,
  buttonSize: prop_types_default().oneOf(radio_constants_strings.BUTTON_SIZE),
  type: prop_types_default().oneOf([radio_constants_strings.TYPE_DEFAULT, radio_constants_strings.TYPE_BUTTON, radio_constants_strings.TYPE_CARD, radio_constants_strings.TYPE_PURECARD]),
  value: (prop_types_default()).any,
  onChange: (prop_types_default()).func,
  children: (prop_types_default()).node,
  prefixCls: (prop_types_default()).string,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  direction: prop_types_default().oneOf(radio_constants_strings.DIRECTION_SET),
  mode: prop_types_default().oneOf(radio_constants_strings.MODE),
  'aria-label': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  id: (prop_types_default()).string
};
RadioGroup.defaultProps = {
  disabled: false,
  onChange: (noop_default()),
  direction: radio_constants_strings.DEFAULT_DIRECTION,
  mode: '',
  type: radio_constants_strings.TYPE_DEFAULT,
  buttonSize: 'middle'
};
/* harmony default export */ var radioGroup = (RadioGroup);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/constants.js


const dayItemClasses = {
  DAY_TODAY: `${BASE_CLASS_PREFIX}-datepicker-day-today`,
  DAY_IN_RANGE: `${BASE_CLASS_PREFIX}-datepicker-day-inrange`,
  DAY_HOVER: `${BASE_CLASS_PREFIX}-datepicker-day-inhover`,
  DAY_SELECTED: `${BASE_CLASS_PREFIX}-datepicker-day-selected`,
  DAY_SELECTED_START: `${BASE_CLASS_PREFIX}-datepicker-day-selected-start`,
  DAY_SELECTED_END: `${BASE_CLASS_PREFIX}-datepicker-day-selected-end`,
  DAY_DISABLED: `${BASE_CLASS_PREFIX}-datepicker-day-disabled`,
  DAY_HOVER_DAY: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday`,
  DAY_HOVER_DAY_OFFSET: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday-offset`,
  DAY_IN_OFFSET_RANGE: `${BASE_CLASS_PREFIX}-datepicker-day-inoffsetrange`,
  DAY_SELECTED_RANGE_HOVER: `${BASE_CLASS_PREFIX}-datepicker-day-selectedrange-hover`,
  DAY_OFFSET_RANGE_START: `${BASE_CLASS_PREFIX}-datepicker-day-offsetrange-start`,
  DAY_OFFSET_RANGE_END: `${BASE_CLASS_PREFIX}-datepicker-day-offsetrange-end`,
  DAY_SELECTED_START_AFTER_HOVER: `${BASE_CLASS_PREFIX}-datepicker-day-selected-start-afterhover`,
  DAY_SELECTED_END_BEFORE_HOVER: `${BASE_CLASS_PREFIX}-datepicker-day-selected-end-beforehover`,
  DAY_HOVER_DAY_BEFORE_RANGE: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday-beforerange`,
  DAY_HOVER_DAY_AFTER_RANGE: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday-afterrange`,
  DAY_HOVER_DAY_IN_RANGE: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday-inrange`,
  DAY_HOVER_DAY_AROUND_SINGLE_SELECTED: `${BASE_CLASS_PREFIX}-datepicker-day-hoverday-around-singleselected`
};
const datePicker_constants_cssClasses = Object.assign({
  PREFIX: `${BASE_CLASS_PREFIX}-datepicker`,
  NAVIGATION: `${BASE_CLASS_PREFIX}-datepicker-navigation`,
  PANEL_YAM: `${BASE_CLASS_PREFIX}-datepicker-panel-yam`,
  MONTH: `${BASE_CLASS_PREFIX}-datepicker-month`,
  WEEKDAY: `${BASE_CLASS_PREFIX}-datepicker-weekday`,
  WEEKS: `${BASE_CLASS_PREFIX}-datepicker-weeks`,
  WEEK: `${BASE_CLASS_PREFIX}-datepicker-week`,
  DAY: `${BASE_CLASS_PREFIX}-datepicker-day`
}, dayItemClasses);
const formatToken = {
  FORMAT_FULL_DATE: 'yyyy-MM-dd',
  FORMAT_TIME_PICKER: 'HH:mm:ss',
  FORMAT_DATE_TIME: 'yyyy-MM-dd HH:mm:ss',
  FORMAT_YEAR_MONTH: 'yyyy-MM'
};
const datePicker_constants_strings = Object.assign({
  DEFAULT_SEPARATOR_MULTIPLE: ',',
  DEFAULT_SEPARATOR_RANGE: ' ~ ',
  SIZE_SET: ['small', 'default', 'large'],
  TYPE_SET: ['date', 'dateRange', 'year', 'month', 'monthRange', 'dateTime', 'dateTimeRange'],
  PRESET_POSITION_SET: ['left', 'right', 'top', 'bottom'],
  DENSITY_SET: ['default', 'compact'],
  PANEL_TYPE_LEFT: 'left',
  PANEL_TYPE_RIGHT: 'right',
  STATUS: VALIDATE_STATUS,
  POSITION_SET: popover_constants_strings.POSITION_SET,
  POSITION_INLINE_INPUT: 'leftTopOver'
}, formatToken);
const datePicker_constants_numbers = {
  WEEK_START_ON: 0,
  WEEK_HEIGHT: 36,
  SPACING: constants_numbers.SPACING,
  SPACING_INSET_INPUT: 1
};

// EXTERNAL MODULE: ./node_modules/lodash/isDate.js
var isDate = __webpack_require__(47960);
var isDate_default = /*#__PURE__*/__webpack_require__.n(isDate);
// EXTERNAL MODULE: ./node_modules/lodash/stubFalse.js
var stubFalse = __webpack_require__(95062);
var stubFalse_default = /*#__PURE__*/__webpack_require__.n(stubFalse);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate_isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid_isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate_isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate_toDate(dirtyDate);
  return !isNaN(Number(date));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfSecond/index.js


/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  date.setMilliseconds(0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameSecond/index.js


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */
function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isEqual/index.js


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual_isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate_toDate(dirtyLeftDate);
  var dateRight = toDate_toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate_toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate_toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance_formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistance_formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var en_US_lib_formatDistance = (formatDistance_formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var formatLong_dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var formatLong_timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var formatLong_dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var en_US_lib_formatLong = (formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative_formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative_formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelative_formatRelativeLocale[token];
};
/* harmony default export */ var en_US_lib_formatRelative = (formatRelative_formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var localize_eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var localize_monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var localize_dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var localize_dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var localize_formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var localize_ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize_localize = {
  ordinalNumber: localize_ordinalNumber,
  era: buildLocalizeFn({
    values: localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: localize_monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var en_US_lib_localize = (localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var match_matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var match_parseOrdinalNumberPattern = /\d+/i;
var match_matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var match_parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var match_matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var match_parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var match_matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var match_parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var match_matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var match_parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: match_matchOrdinalNumberPattern,
    parsePattern: match_parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var en_US_lib_match = (match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var en_US_locale = {
  code: 'en-US',
  formatDistance: en_US_lib_formatDistance,
  formatLong: en_US_lib_formatLong,
  formatRelative: en_US_lib_formatRelative,
  localize: en_US_lib_localize,
  match: en_US_lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (en_US_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var _lib_defaultLocale = (en_US);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format_format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _lib_defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate_toDate(dirtyDate);
  if (!isValid_isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isValidDate.js
function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isNumber.js
function isNumber_isNumber(value) {
  return typeof value === 'number' || Object.prototype.toString.call(value) === '[object Number]';
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isTimestamp.js


function isTimestamp(ts) {
  return isNumber_isNumber(ts) && isValidDate(new Date(ts));
}
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/date-fns-extra.js


/**
 * Need to be IANA logo without daylight saving time
 */
const IANAOffsetMap = [[-11, ['Pacific/Midway']], [-10, ['Pacific/Honolulu']], [-9.5, ['Pacific/Marquesas']], [-9, ['Pacific/Gambier']], [-8, ['Pacific/Pitcairn']], [-7, ['America/Phoenix']], [-6, ['America/Tegucigalpa']], [-5, ['America/Bogota']], [-4, ['America/Puerto_Rico']], [-3.5, ['America/St_Johns']], [-3, ['America/Montevideo']], [-2, ['Atlantic/South_Georgia']], [-1, ['Atlantic/Cape_Verde']], [0, ['Africa/Accra']], [1, ['Africa/Bangui']], [2, ['Africa/Cairo']], [3, ['Asia/Bahrain', 'Indian/Antananarivo']], [3.5, ['Asia/Tehran']], [4, ['Asia/Dubai', 'Asia/Muscat']], [4.5, ['Asia/Kabul']], [5, ['Asia/Samarkand', 'Asia/Karachi']], [5.5, ['Asia/Kolkata']], [5.75, ['Asia/Kathmandu']], [6, ['Asia/Dhaka']], [6.5, ['Asia/Rangoon', 'Asia/Rangoon']], [7, ['Asia/Jakarta', 'Asia/Phnom_Penh', 'Asia/Bangkok']], [8, ['Asia/Shanghai', 'Asia/Singapore']], [8.75, ['Australia/Eucla']], [9, ['Asia/Tokyo', 'Asia/Seoul', 'Asia/Pyongyang']], [9.5, ['Australia/Darwin']], [10, ['Pacific/Guam']], [10.5, ['Australia/Adelaide']], [11, ['Pacific/Guadalcanal']], [12, ['Pacific/Funafuti']], [13, ['Pacific/Enderbury']], [13.75, ['Pacific/Chatham']], [14, ['Pacific/Kiritimati']]];
/**
 * Etc/GMT* no DST
 * @see https://data.iana.org/time-zones/tzdb/etcetera
 */
const IANAEtcGMTOffsetMap = {
  '0': 'Etc/GMT',
  '1': 'Etc/GMT-1',
  '2': 'Etc/GMT-2',
  '3': 'Etc/GMT-3',
  '4': 'Etc/GMT-4',
  '5': 'Etc/GMT-5',
  '6': 'Etc/GMT-6',
  '7': 'Etc/GMT-7',
  '8': 'Etc/GMT-8',
  '9': 'Etc/GMT-9',
  '10': 'Etc/GMT-10',
  '11': 'Etc/GMT-11',
  '12': 'Etc/GMT-12',
  '13': 'Etc/GMT-13',
  '14': 'Etc/GMT-14',
  '-1': 'Etc/GMT+1',
  '-2': 'Etc/GMT+2',
  '-3': 'Etc/GMT+3',
  '-4': 'Etc/GMT+4',
  '-5': 'Etc/GMT+5',
  '-6': 'Etc/GMT+6',
  '-7': 'Etc/GMT+7',
  '-8': 'Etc/GMT+8',
  '-9': 'Etc/GMT+9',
  '-10': 'Etc/GMT+10',
  '-11': 'Etc/GMT+11',
  '-12': 'Etc/GMT+12'
};
const GMTStringReg = /([\-\+]{1})(\d{2})\:(\d{2})/;
/**
 *
 * @param {string|number} tz
 * @returns {number|undefined}
 */
const toIANA = tz => {
  let matches = null;
  if (typeof tz === 'string') {
    matches = tz.match(GMTStringReg);
    if (!matches) {
      return tz;
    }
    const symbol = parseInt(matches[1] + 1, 10); // => -1 or 1
    const hourOffset = parseInt(matches[2], 10);
    const minuteOffset = parseInt(matches[3], 10);
    tz = symbol * (hourOffset + minuteOffset / 60);
  }
  if (typeof tz === 'number') {
    // if tz can be transformed to a Etc/GMT* and browser supports it
    if (tz in IANAEtcGMTOffsetMap) {
      const etcGMTtimeZone = IANAEtcGMTOffsetMap[tz];
      if (isValidTimezoneIANAString(etcGMTtimeZone)) {
        return etcGMTtimeZone;
      }
    }
    const found = IANAOffsetMap.find(item => item[0] === tz);
    return found && found[1][0];
  }
};
const validIANATimezoneCache = {};
/**
 * @see https://github.com/marnusw/date-fns-tz/blob/a92e0ad017d101a0c50e39a63ef5d322b4d849f6/src/_lib/tzParseTimezone/index.js#L137
 */
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true;
  try {
    new Intl.DateTimeFormat(undefined, {
      timeZone: timeZoneString
    });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}
/**
 *
 * @param {string | number | Date} date
 * @param {string} formatToken
 * @param {object} [options]
 * @param {string} [options.timeZone]
 * @returns {Date}
 */
/* istanbul ignore next */
const date_fns_extra_parse = (date, formatToken, options) => {
  if (typeof date === 'string') {
    date = dateFnsParse(date, formatToken, new Date(), options);
  }
  if (options && options.timeZone != null && options.timeZone !== '') {
    const timeZone = toIANA(options.timeZone);
    options = Object.assign(Object.assign({}, options), {
      timeZone
    });
  }
  return toDate(date, options);
};
/* istanbul ignore next */
const date_fns_extra_format = (date, formatToken, options) => {
  if (options && options.timeZone != null && options.timeZone !== '') {
    const timeZone = toIANA(options.timeZone);
    options = Object.assign(Object.assign({}, options), {
      timeZone
    });
    date = dateFnsUtcToZonedTime(date, timeZone, options);
  }
  return dateFnsFormat(date, formatToken, options);
};
/**
 * Returns a Date which will format as the local time of any time zone from a specific UTC time
 *
 * @example
 * ```javascript
 * import { utcToZonedTime } from 'date-fns-tz'
 * const { isoDate, timeZone } = fetchInitialValues() // 2014-06-25T10:00:00.000Z, America/New_York
 * const date = utcToZonedTime(isoDate, timeZone) // In June 10am UTC is 6am in New York (-04:00)
 * renderDatePicker(date) // 2014-06-25 06:00:00 (in the system time zone)
 * renderTimeZoneSelect(timeZone) // America/New_York
 * ```
 *
 * @see https://github.com/marnusw/date-fns-tz#utctozonedtime
 */
const utcToZonedTime = (date, timeZone, options) => (0,date_fns_tz.utcToZonedTime)(date, toIANA(timeZone), options);
/**
 * Given a date and any time zone, returns a Date with the equivalent UTC time
 *
 * @example
 * ```
 * import { zonedTimeToUtc } from 'date-fns-tz'
 * const date = getDatePickerValue() // e.g. 2014-06-25 10:00:00 (picked in any time zone)
 * const timeZone = getTimeZoneValue() // e.g. America/Los_Angeles
 * const utcDate = zonedTimeToUtc(date, timeZone) // In June 10am in Los Angeles is 5pm UTC
 * postToServer(utcDate.toISOString(), timeZone) // post 2014-06-25T17:00:00.000Z, America/Los_Angeles
 * ```
 *
 * @see https://github.com/marnusw/date-fns-tz#zonedtimetoutc
 */
const zonedTimeToUtc = (date, timeZone, options) => (0,date_fns_tz.zonedTimeToUtc)(date, toIANA(timeZone), options);
/**
 * return current system hour offset based on utc:
 *
 * ```
 * 8 => "GMT+08:00"
 * -9.5 => "GMT-09:30"
 * -8 => "GMT-08:00"
 * ```
 */
const getCurrentTimeZone = () => new Date().getTimezoneOffset() / 60;

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function getPrototypeOf_getPrototypeOf(o) {
  getPrototypeOf_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf_getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function isNativeReflectConstruct_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (isNativeReflectConstruct_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct_isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf_getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf_getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js






var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js




var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js







var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 140);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/constants/index.js
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js








// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js










// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js








 // ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js








var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js








var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js








var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js









var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js









var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js










 // Local week of year
var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js










 // ISO week of year
var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js









var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js









var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate_toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js







 // Day of week
var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js








 // Local day of week
var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js








 // Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate_toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js








 // ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js








var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js








var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js







 // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js









var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js









var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js









var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js









var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js









var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 60);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js









var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 50);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js








var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 30);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js








 // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js








 // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js








var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js








var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 20);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js













 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var parse_formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var parse_longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var parse_escapedStringRegExp = /^'([^]*?)'?$/;
var parse_doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var parse_unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse_parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _lib_defaultLocale;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return toDate_toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(parse_longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in format_longFormatters) {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(parse_formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(parse_unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = parse_cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate_toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function parse_cleanEscapedString(input) {
  return input.match(parse_escapedStringRegExp)[1].replace(parse_doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parseISO/index.js



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function parseISO_isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (parseISO_isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (parseISO_isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/parser.js
/**
 * @file
 * Various date-related analysis methods
 */

/**
 * Parsing value to Date object
 */
function compatibleParse(value, formatToken, baseDate, locale) {
  let result = null;
  if (value) {
    if (formatToken) {
      baseDate = baseDate || new Date();
      result = parse_parse(value, formatToken, baseDate, {
        locale
      });
    }
    if (!isValid_isValid(result)) {
      result = parseISO(value);
    }
    if (!isValid_isValid(result)) {
      result = new Date(Date.parse(value));
    }
    const yearInvalid = isValid_isValid(result) && String(result.getFullYear()).length > 4;
    if (!isValid_isValid(result) || yearInvalid) {
      result = null;
    }
  }
  return result;
}
/**
 * whether value can be parsed with date-fns `parse`
 *
 * @example
 * isValueParseValid({ value: '2021-01-01', formatToken: 'yyyy-MM-dd' }); // true
 * isValueParseValid({ value: '2021-01-0', formatToken: 'yyyy-MM-dd' }); // false
 * isValueParseValid({ value: '2021-01', formatToken: 'yyyy-MM-dd' }); // false
 */
function isValueParseValid(options) {
  const {
    value,
    locale,
    formatToken
  } = options;
  const baseDate = options.baseDate || new Date();
  const result = parse(value, formatToken, baseDate, {
    locale
  });
  return isValid(result);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getDefaultFormatToken.js

const defaultFormatTokens = {
  date: datePicker_constants_strings.FORMAT_FULL_DATE,
  dateTime: datePicker_constants_strings.FORMAT_DATE_TIME,
  dateRange: datePicker_constants_strings.FORMAT_FULL_DATE,
  dateTimeRange: datePicker_constants_strings.FORMAT_DATE_TIME,
  month: datePicker_constants_strings.FORMAT_YEAR_MONTH,
  monthRange: datePicker_constants_strings.FORMAT_YEAR_MONTH
};
const getDefaultFormatToken = type => defaultFormatTokens;
function getDefaultFormatTokenByType(type) {
  return type && defaultFormatTokens[type];
}
/* harmony default export */ var _utils_getDefaultFormatToken = (getDefaultFormatToken);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getInsetInputFormatToken.js

/**
 * 获取 insetInput 输入框的 placeholder
 * Get the placeholder of the insetInput input
 *
 * If type is time related, we only recognize the format like `dateFormat timeFormat`
 *  - 'yyyy-MM-dd HH:mm:ss' // ok
 *  - 'yyyy-MM-dd  HH:mm:ss' // bad format
 *
 * @example
 * 'yyyy-MM-dd' => 'yyyy-MM-dd'
 * 'yyyy-MM' => 'yyyy-MM'
 * 'yyyy-MM-dd HH:mm:ss' => 'yyyy-MM-dd HH:mm:ss'
 * 'yyyy-MM-dd HH:mm' => 'yyyy-MM-dd HH:mm'
 * 'Pp' => 'yyyy-MM-dd'
 */
function getInsetInputFormatToken(options) {
  const {
    format,
    type
  } = options;
  const dateReg = /([yMd]{0,4}[^a-z\s]*[yMd]{0,4}[^a-z\s]*[yMd]{0,4})/i;
  const dateTimeReg = /([yMd]{0,4}[^a-z\s]*[yMd]{0,4}[^a-z\s]*[yMd]{0,4}) (H{0,2}[^a-z\s]*m{0,2}[^a-z\s]*s{0,2})/i;
  const defaultToken = getDefaultFormatTokenByType(type);
  let insetInputFormat;
  switch (type) {
    case 'dateTime':
    case 'dateTimeRange':
      const dateTimeResult = dateTimeReg.exec(format);
      insetInputFormat = dateTimeResult && dateTimeResult[1] && dateTimeResult[2] ? `${dateTimeResult[1]} ${dateTimeResult[2]}` : defaultToken;
      break;
    case 'date':
    case 'month':
    case 'monthRange':
    case 'dateRange':
    default:
      const dateResult = dateReg.exec(format);
      insetInputFormat = dateResult && dateResult[1] || defaultToken;
      break;
  }
  return insetInputFormat;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getInsetInputValueFromInsetInputStr.js
/**
 * 从 insetInputStr 字符串解析出 insetInputValue 对象
 * Parse the insetInputValue object from the insetInputStr string
 *
 * @example
 * ```
 * '2022-02-01' => { monthLeft: { dateInput: '2022-02-01' } }
 * '2022-02-01 00:00:00' => { monthLeft: { dateInput: '2022-02-01', timeInput: '00:00:00' } }
 * '2022-02-01 00:00:00 ~ 2022-02-15 00:00:00' => { monthLeft: { dateInput: '2022-02-01', timeInput: '00:00:00'}, monthRight: { dateInput: '2022-02-15', timeInput: '00:00:00' } }
 *
 * '2022-0' => { monthLeft: { dateInput: '2022-0' } }
 * '2022-02-01 00:00:' => { monthLeft: { dateInput: '2022-02-01', timeInput: '00:00:' } }
 * '2022-02-01 00:00:00 ~ ' => { monthLeft: { dateInput: '2022-02-01', timeInput: '00:00:00'}, monthRight: { dateInput: '', timeInput: '' } }
 * ' ~ 2022-02-15 00:00:00' => { monthLeft: { dateInput: '', timeInput: '' }, monthRight: { dateInput: '2022-02-15', timeInput: '00:00:00' } }
 * ```
 */
function getInsetInputValueFromInsetInputStr(options) {
  const timeSeparator = ' ';
  const {
    inputValue = '',
    rangeSeparator,
    type
  } = options;
  let leftDateInput, leftTimeInput, rightDateInput, rightTimeInput;
  const insetInputValue = {
    monthLeft: {
      dateInput: '',
      timeInput: ''
    },
    monthRight: {
      dateInput: '',
      timeInput: ''
    }
  };
  switch (type) {
    case 'date':
    case 'month':
    case 'monthRange':
      insetInputValue.monthLeft.dateInput = inputValue;
      break;
    case 'dateRange':
      [leftDateInput = '', rightDateInput = ''] = inputValue.split(rangeSeparator);
      insetInputValue.monthLeft.dateInput = leftDateInput;
      insetInputValue.monthRight.dateInput = rightDateInput;
      break;
    case 'dateTime':
      [leftDateInput = '', leftTimeInput = ''] = inputValue.split(timeSeparator);
      insetInputValue.monthLeft.dateInput = leftDateInput;
      insetInputValue.monthLeft.timeInput = leftTimeInput;
      break;
    case 'dateTimeRange':
      const [leftInput = '', rightInput = ''] = inputValue.split(rangeSeparator);
      [leftDateInput = '', leftTimeInput = ''] = leftInput.split(timeSeparator);
      [rightDateInput = '', rightTimeInput = ''] = rightInput.split(timeSeparator);
      insetInputValue.monthLeft.dateInput = leftDateInput;
      insetInputValue.monthLeft.timeInput = leftTimeInput;
      insetInputValue.monthRight.dateInput = rightDateInput;
      insetInputValue.monthRight.timeInput = rightTimeInput;
      break;
  }
  return insetInputValue;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isValidTimeZone.js
function isValidTimeZone(timeZone) {
  return ['string', 'number'].includes(typeof timeZone) && timeZone !== '';
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/foundation.js


















/**
 * The datePicker foundation.js is responsible for maintaining the date value and the input box value, as well as the callback of both
 *  task 1. Accept the selected date change, update the date value, and update the input box value according to the date = > Notify the change
 *  task 2. When the input box changes, update the date value = > Notify the change
 */
class DatePickerFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    /**
     * clear range input focus when open is controlled
     * fixed github 1375
     */
    this.clearRangeInputFocus = () => {
      const {
        type
      } = this._adapter.getProps();
      const {
        rangeInputFocus
      } = this._adapter.getStates();
      if (type === 'dateTimeRange' && rangeInputFocus) {
        this._adapter.setRangeInputFocus(false);
      }
    };
    this._isRangeType = () => {
      const type = this._adapter.getProp('type');
      return /range/i.test(type);
    };
    this._isRangeValueComplete = value => {
      let result = false;
      if (Array.isArray(value)) {
        result = !value.some(date => isNullOrUndefined(date));
      }
      return result;
    };
  }
  init() {
    const timeZone = this.getProp('timeZone');
    if (this._isControlledComponent()) {
      this.initFromProps({
        timeZone,
        value: this.getProp('value')
      });
    } else if (this._isInProps('defaultValue')) {
      this.initFromProps({
        timeZone,
        value: this.getProp('defaultValue')
      });
    }
    this.initPanelOpenStatus(this.getProp('defaultOpen'));
  }
  initFromProps(_ref) {
    let {
      value,
      timeZone,
      prevTimeZone
    } = _ref;
    const _value = (Array.isArray(value) ? [...value] : (value || value === 0) && [value]) || [];
    const result = this.parseWithTimezone(_value, timeZone, prevTimeZone);
    this._adapter.updatePrevTimezone(prevTimeZone);
    // reset input value when value update
    this.clearInputValue();
    this._adapter.updateValue(result);
    this.resetCachedSelectedValue(result);
    this.initRangeInputFocus(result);
    if (this._adapter.needConfirm()) {
      this._adapter.updateCachedSelectedValue(result);
    }
  }
  /**
   * 如果用户传了一个空的 value，需要把 range input focus 设置为 rangeStart，这样用户可以清除完之后继续从开始选择
   *
   * If the user passes an empty value, you need to set the range input focus to rangeStart, so that the user can continue to select from the beginning after clearing
   */
  initRangeInputFocus(result) {
    const {
      triggerRender
    } = this.getProps();
    if (this._isRangeType() && isFunction_default()(triggerRender) && result.length === 0) {
      this._adapter.setRangeInputFocus('rangeStart');
    }
  }
  /**
   * value 可能是 UTC value 也可能是 zoned value
   *
   * UTC value -> 受控传入的 value
   *
   * zoned value -> statue.value，保存的是当前计算机时区下选择的日期
   *
   * 如果是时区变化，则需要将旧 zoned value 转为新时区下的 zoned value
   *
   * 如果是 value 变化，则不需要传入之前的时区，将 UTC value 转为 zoned value 即可
   *
   */
  parseWithTimezone(value, timeZone, prevTimeZone) {
    const result = [];
    if (Array.isArray(value) && value.length) {
      for (const v of value) {
        let parsedV = (v || v === 0) && this._parseValue(v);
        if (parsedV) {
          if (isValidTimeZone(prevTimeZone)) {
            parsedV = zonedTimeToUtc(parsedV, prevTimeZone);
          }
          result.push(isValidTimeZone(timeZone) ? utcToZonedTime(parsedV, timeZone) : parsedV);
        } else {
          warning(true, `[Semi DatePicker] value cannot be parsed, value: ${String(v)}`);
        }
      }
    }
    return result;
  }
  _isMultiple() {
    return Boolean(this.getProp('multiple'));
  }
  /**
   *
   *  Verify and parse the following three format inputs
   *
      1. Date object
      2. ISO 9601-compliant string
      3. ts timestamp
       Unified here to format the incoming value and output it as a Date object
   *
   */
  _parseValue(value) {
    const dateFnsLocale = this._adapter.getProp('dateFnsLocale');
    let dateObj;
    if (!value && value !== 0) {
      return new Date();
    }
    if (isValidDate(value)) {
      dateObj = value;
    } else if (isString_default()(value)) {
      dateObj = compatibleParse(value, this.getProp('format'), undefined, dateFnsLocale);
    } else if (isTimestamp(value)) {
      dateObj = new Date(value);
    } else {
      throw new TypeError('defaultValue should be valid Date object/timestamp or string');
    }
    return dateObj;
  }
  destroy() {
    // Ensure that event listeners will be uninstalled and users may not trigger closePanel
    this._adapter.togglePanel(false);
    this._adapter.unregisterClickOutSide();
  }
  initPanelOpenStatus(defaultOpen) {
    if ((this.getProp('open') || defaultOpen) && !this.getProp('disabled')) {
      this._adapter.togglePanel(true);
      this._adapter.registerClickOutSide();
    } else {
      this._adapter.togglePanel(false);
      this._adapter.unregisterClickOutSide();
    }
  }
  openPanel() {
    if (!this.getProp('disabled')) {
      if (!this._isControlledComponent('open')) {
        this.open();
      }
      this._adapter.notifyOpenChange(true);
    }
  }
  /**
   * clear inset input value when close panel
   */
  clearInsetInputValue() {
    const {
      insetInput
    } = this._adapter.getProps();
    if (insetInput) {
      this._adapter.updateInsetInputValue(null);
    }
  }
  /**
   * call it when change state value or input value
   */
  resetCachedSelectedValue(willUpdateDates) {
    const {
      value,
      cachedSelectedValue
    } = this._adapter.getStates();
    const newCachedSelectedValue = Array.isArray(willUpdateDates) ? willUpdateDates : value;
    if (!isEqual_default()(newCachedSelectedValue, cachedSelectedValue)) {
      this._adapter.updateCachedSelectedValue(newCachedSelectedValue);
    }
  }
  /**
   * timing to call closePanel
   *  1. click confirm button
   *  2. click cancel button
   *  3. select date, time, year, month
   *    - date type and not multiple, close panel after select date
   *    - dateRange type, close panel after select rangeStart and rangeEnd
   *  4. click outside
   * @param {Event} e
   * @param {String} inputValue
   * @param {Date[]} dates
   */
  closePanel(e) {
    let inputValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let dates = arguments.length > 2 ? arguments[2] : undefined;
    const {
      value
    } = this._adapter.getStates();
    const willUpdateDates = isNullOrUndefined(dates) ? value : dates;
    if (!this._isControlledComponent('open')) {
      this.close();
    } else {
      this.resetInnerSelectedStates(willUpdateDates);
    }
    this._adapter.notifyOpenChange(false);
  }
  open() {
    this._adapter.togglePanel(true);
    this._adapter.registerClickOutSide();
  }
  close() {
    this._adapter.togglePanel(false, () => this.resetInnerSelectedStates());
    this._adapter.unregisterClickOutSide();
  }
  focus(focusType) {
    if (this._isRangeType()) {
      const rangeInputFocus = focusType !== null && focusType !== void 0 ? focusType : 'rangeStart';
      this._adapter.setRangeInputFocus(rangeInputFocus);
    } else {
      this._adapter.setInputFocus();
    }
  }
  blur() {
    if (this._isRangeType()) {
      this._adapter.setRangeInputBlur();
    } else {
      this._adapter.setInputBlur();
    }
  }
  /**
   * reset cachedSelectedValue, inputValue when close panel
   */
  resetInnerSelectedStates(willUpdateDates) {
    const {
      value
    } = this._adapter.getStates();
    const needResetCachedSelectedValue = !this.isCachedSelectedValueValid(willUpdateDates) || this._adapter.needConfirm() && !this.clickConfirmButton;
    if (needResetCachedSelectedValue) {
      this.resetCachedSelectedValue(value);
    }
    this.resetFocus();
    this.clearInputValue();
    this.clickConfirmButton = false;
  }
  resetFocus(e) {
    this._adapter.setRangeInputFocus(false);
    this._adapter.notifyBlur(e);
  }
  /**
   * cachedSelectedValue can be `(Date|null)[]` or `null`
   */
  isCachedSelectedValueValid(dates) {
    const cachedSelectedValue = dates || this._adapter.getState('cachedSelectedValue');
    const {
      type
    } = this._adapter.getProps();
    let isValid = true;
    switch (true) {
      case type === 'dateRange':
      case type === 'dateTimeRange':
        if (!this._isRangeValueComplete(cachedSelectedValue)) {
          isValid = false;
        }
        break;
      default:
        const value = cachedSelectedValue === null || cachedSelectedValue === void 0 ? void 0 : cachedSelectedValue.filter(item => item);
        if (!(Array.isArray(value) && value.length)) {
          isValid = false;
        }
        break;
    }
    return isValid;
  }
  /**
   * 将输入框内容置空
   */
  clearInputValue() {
    this._adapter.updateInputValue(null);
    this._adapter.updateInsetInputValue(null);
  }
  /**
   * Callback when the content of the input box changes
   * Update the date panel if the changed value is a legal date, otherwise only update the input box
   * @param {String} input The value of the input box after the change
   * @param {Event} e
   */
  handleInputChange(input, e) {
    const result = this._isMultiple() ? this.parseMultipleInput(input) : this.parseInput(input);
    const {
      value: stateValue
    } = this.getStates();
    this._updateCachedSelectedValueFromInput(input);
    // Enter a valid date or empty
    if (result && result.length || input === '') {
      // If you click the clear button
      if (get_default()(e, input_constants_strings.CLEARBTN_CLICKED_EVENT_FLAG) && this._isControlledComponent('value')) {
        this._notifyChange(result);
        return;
      }
      this._updateValueAndInput(result, input === '', input);
      // Updates the selected value when entering a valid date
      const changedDates = this._getChangedDates(result);
      if (!this._someDateDisabled(changedDates, result)) {
        if (!isEqual_default()(result, stateValue)) {
          this._notifyChange(result);
        }
      }
    } else {
      this._adapter.updateInputValue(input);
    }
  }
  /**
   * inset input 变化时需要更新以下 state 状态
   *  - insetInputValue（总是）
   *  - inputValue（可以解析为合法日期时）
   *  - value（可以解析为合法日期时）
   */
  handleInsetInputChange(options) {
    const {
      insetInputStr,
      format,
      insetInputValue
    } = options;
    const _isMultiple = this._isMultiple();
    const result = _isMultiple ? this.parseMultipleInput(insetInputStr, format) : this.parseInput(insetInputStr, format);
    const {
      value: stateValue
    } = this.getStates();
    this._updateCachedSelectedValueFromInput(insetInputStr);
    if (result && result.length) {
      const changedDates = this._getChangedDates(result);
      if (!this._someDateDisabled(changedDates, result)) {
        if (!isEqual_default()(result, stateValue)) {
          if (!this._isControlledComponent() && !this._adapter.needConfirm()) {
            this._adapter.updateValue(result);
          }
          this._notifyChange(result);
        }
        const triggerInput = _isMultiple ? this.formatMultipleDates(result) : this.formatDates(result);
        this._adapter.updateInputValue(triggerInput);
      }
    }
    this._adapter.updateInsetInputValue(insetInputValue);
  }
  /**
   * when input change we reset cached selected value
   */
  _updateCachedSelectedValueFromInput(input) {
    const looseResult = this.getLooseDateFromInput(input);
    const changedLooseResult = this._getChangedDates(looseResult);
    if (!this._someDateDisabled(changedLooseResult, looseResult)) {
      this.resetCachedSelectedValue(looseResult);
    }
  }
  /**
   * Input box blur
   * @param {String} input
   * @param {Event} e
   */
  handleInputBlur() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let e = arguments.length > 1 ? arguments[1] : undefined;
  }
  /**
   * called when range type rangeEnd input tab press
   * @param {Event} e
   */
  handleRangeEndTabPress(e) {
    this._adapter.setRangeInputFocus(false);
  }
  /**
   * called when the input box is focused
   * @param {Event} e input focus event
   * @param {String} range 'rangeStart' or 'rangeEnd', use when type is range
   */
  handleInputFocus(e, range) {
    const rangeInputFocus = this._adapter.getState('rangeInputFocus');
    range && this._adapter.setRangeInputFocus(range);
    /**
     * rangeType: only notify when range is false
     * not rangeType: notify when focus
     */
    if (!range || !['rangeStart', 'rangeEnd'].includes(rangeInputFocus)) {
      this._adapter.notifyFocus(e, range);
    }
  }
  handleSetRangeFocus(rangeInputFocus) {
    this._adapter.setRangeInputFocus(rangeInputFocus);
  }
  handleInputClear(e) {
    this._adapter.notifyClear(e);
  }
  /**
   * 范围选择清除按钮回调
   * 因为清除按钮没有集成在Input内，因此需要手动清除 value、inputValue、cachedValue
   *
   * callback of range input clear button
   * Since the clear button is not integrated in Input, you need to manually clear value, inputValue, cachedValue
   */
  handleRangeInputClear(e) {
    const value = [];
    const inputValue = '';
    if (!this._isControlledComponent('value')) {
      this._updateValueAndInput(value, true, inputValue);
      this._adapter.updateInsetInputValue(null);
      this.resetCachedSelectedValue(value);
    }
    this._notifyChange(value);
    this._adapter.setRangeInputFocus(false);
    this._adapter.notifyClear(e);
  }
  handleRangeInputBlur(value, e) {}
  // Parses input only after user returns
  handleInputComplete() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // console.log(input);
    let parsedResult = input ? this._isMultiple() ? this.parseMultipleInput(input, ',', true) : this.parseInput(input) : [];
    parsedResult = parsedResult && parsedResult.length ? parsedResult : this.getState('value');
    // Use the current date as the value when the current input is empty and the last input is also empty
    if (!parsedResult || !parsedResult.length) {
      const nowDate = new Date();
      if (this._isRangeType()) {
        parsedResult = [nowDate, nowDate];
      } else {
        parsedResult = [nowDate];
      }
    }
    this._updateValueAndInput(parsedResult);
    const {
      value: stateValue
    } = this.getStates();
    const changedDates = this._getChangedDates(parsedResult);
    if (!this._someDateDisabled(changedDates, parsedResult) && !isEqual_default()(parsedResult, stateValue)) {
      this._notifyChange(parsedResult);
    }
  }
  /**
   * Parse the input, return the time object if it is valid,
   *  otherwise return "
   *
   * @param {string} input
   * @returns  {Date [] | '}
   */
  parseInput() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let format = arguments.length > 1 ? arguments[1] : undefined;
    let result = [];
    // console.log(input);
    const {
      dateFnsLocale,
      rangeSeparator
    } = this.getProps();
    if (input && input.length) {
      const type = this.getProp('type');
      const formatToken = format || this.getProp('format') || getDefaultFormatTokenByType(type);
      let parsedResult, formatedInput;
      const nowDate = new Date();
      switch (type) {
        case 'date':
        case 'dateTime':
        case 'month':
          parsedResult = input ? compatibleParse(input, formatToken, nowDate, dateFnsLocale) : '';
          formatedInput = parsedResult && isValid_isValid(parsedResult) && this.localeFormat(parsedResult, formatToken);
          if (parsedResult && formatedInput === input) {
            result = [parsedResult];
          }
          break;
        case 'dateRange':
        case 'dateTimeRange':
        case 'monthRange':
          const separator = rangeSeparator;
          const values = input.split(separator);
          parsedResult = values && values.reduce((arr, cur) => {
            const parsedVal = cur && compatibleParse(cur, formatToken, nowDate, dateFnsLocale);
            parsedVal && arr.push(parsedVal);
            return arr;
          }, []);
          formatedInput = parsedResult && parsedResult.map(v => v && isValid_isValid(v) && this.localeFormat(v, formatToken)).join(separator);
          if (parsedResult && formatedInput === input) {
            parsedResult.sort((d1, d2) => d1.getTime() - d2.getTime());
            result = parsedResult;
          }
          break;
        default:
          break;
      }
    }
    return result;
  }
  /**
   * get date which may include null from input
   */
  getLooseDateFromInput(input) {
    const value = this._isMultiple() ? this.parseMultipleInputLoose(input) : this.parseInputLoose(input);
    return value;
  }
  /**
   * parse input into `Array<Date|null>`, loose means return value includes `null`
   *
   * @example
   * ```javascript
   * parseInputLoose('2022-03-15 ~ '); // [Date, null]
   * parseInputLoose(' ~ 2022-03-15 '); // [null, Date]
   * parseInputLoose(''); // []
   * parseInputLoose('2022-03- ~ 2022-0'); // [null, null]
   * ```
   */
  parseInputLoose() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let result = [];
    const {
      dateFnsLocale,
      rangeSeparator,
      type,
      format
    } = this.getProps();
    if (input && input.length) {
      const formatToken = format || getDefaultFormatTokenByType(type);
      let parsedResult, formatedInput;
      const nowDate = new Date();
      switch (type) {
        case 'date':
        case 'dateTime':
        case 'month':
          const _parsedResult = compatibleParse(input, formatToken, nowDate, dateFnsLocale);
          if (isValidDate(_parsedResult)) {
            formatedInput = this.localeFormat(_parsedResult, formatToken);
            if (formatedInput === input) {
              parsedResult = _parsedResult;
            }
          } else {
            parsedResult = null;
          }
          result = [parsedResult];
          break;
        case 'dateRange':
        case 'dateTimeRange':
          const separator = rangeSeparator;
          const values = input.split(separator);
          parsedResult = values && values.reduce((arr, cur) => {
            let parsedVal = null;
            const _parsedResult = compatibleParse(cur, formatToken, nowDate, dateFnsLocale);
            if (isValidDate(_parsedResult)) {
              formatedInput = this.localeFormat(_parsedResult, formatToken);
              if (formatedInput === cur) {
                parsedVal = _parsedResult;
              }
            }
            arr.push(parsedVal);
            return arr;
          }, []);
          if (Array.isArray(parsedResult) && parsedResult.every(item => isValid_isValid(item))) {
            parsedResult.sort((d1, d2) => d1.getTime() - d2.getTime());
          }
          result = parsedResult;
          break;
        default:
          break;
      }
    }
    return result;
  }
  /**
   * parse multiple into `Array<Date|null>`, loose means return value includes `null`
   *
   * @example
   * ```javascript
   * parseMultipleInputLoose('2021-01-01,2021-10-15'); // [Date, Date];
   * parseMultipleInputLoose('2021-01-01,2021-10-'); // [Date, null];
   * parseMultipleInputLoose(''); // [];
   * ```
   */
  parseMultipleInputLoose() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datePicker_constants_strings.DEFAULT_SEPARATOR_MULTIPLE;
    let needDedupe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const max = this.getProp('max');
    const inputArr = input.split(separator);
    const result = [];
    for (const curInput of inputArr) {
      let tmpParsed = curInput && this.parseInputLoose(curInput);
      tmpParsed = Array.isArray(tmpParsed) ? tmpParsed : tmpParsed && [tmpParsed];
      if (tmpParsed && tmpParsed.length) {
        if (needDedupe) {
          !result.filter(r => Boolean(tmpParsed.find(tp => isSameSecond(r, tp)))) && result.push(...tmpParsed);
        } else {
          result.push(...tmpParsed);
        }
      } else {
        return [];
      }
      if (max && max > 0 && result.length > max) {
        return [];
      }
    }
    return result;
  }
  /**
   * Parses the input when multiple is true, if valid,
   *  returns a list of time objects, otherwise returns an array
   *
   * @param {string} [input='']
   * @param {string} [separator=',']
   * @param {boolean} [needDedupe=false]
   * @returns {Date[]}
   */
  parseMultipleInput() {
    let input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datePicker_constants_strings.DEFAULT_SEPARATOR_MULTIPLE;
    let needDedupe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const max = this.getProp('max');
    const inputArr = input.split(separator);
    const result = [];
    for (const curInput of inputArr) {
      let tmpParsed = curInput && this.parseInput(curInput);
      tmpParsed = Array.isArray(tmpParsed) ? tmpParsed : tmpParsed && [tmpParsed];
      if (tmpParsed && tmpParsed.length) {
        if (needDedupe) {
          // 20190519 TODO: needs to determine the case where multiple is true and range
          !result.filter(r => Boolean(tmpParsed.find(tp => isSameSecond(r, tp)))) && result.push(...tmpParsed);
        } else {
          result.push(...tmpParsed);
        }
      } else {
        return [];
      }
      if (max && max > 0 && result.length > max) {
        return [];
      }
    }
    return result;
  }
  /**
   * dates[] => string
   *
   * @param {Date[]} dates
   * @returns {string}
   */
  formatDates() {
    let dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let customFormat = arguments.length > 1 ? arguments[1] : undefined;
    let str = '';
    const rangeSeparator = this.getProp('rangeSeparator');
    if (Array.isArray(dates) && dates.length) {
      const type = this.getProp('type');
      const formatToken = customFormat || this.getProp('format') || getDefaultFormatTokenByType(type);
      switch (type) {
        case 'date':
        case 'dateTime':
        case 'month':
          str = this.localeFormat(dates[0], formatToken);
          break;
        case 'dateRange':
        case 'dateTimeRange':
        case 'monthRange':
          const startIsTruthy = !isNullOrUndefined(dates[0]);
          const endIsTruthy = !isNullOrUndefined(dates[1]);
          if (startIsTruthy && endIsTruthy) {
            str = `${this.localeFormat(dates[0], formatToken)}${rangeSeparator}${this.localeFormat(dates[1], formatToken)}`;
          } else {
            if (startIsTruthy) {
              str = `${this.localeFormat(dates[0], formatToken)}${rangeSeparator}`;
            } else if (endIsTruthy) {
              str = `${rangeSeparator}${this.localeFormat(dates[1], formatToken)}`;
            }
          }
          break;
        default:
          break;
      }
    }
    return str;
  }
  /**
   * dates[] => string
   *
   * @param {Date[]} dates
   * @returns {string}
   */
  formatMultipleDates() {
    let dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datePicker_constants_strings.DEFAULT_SEPARATOR_MULTIPLE;
    let customFormat = arguments.length > 2 ? arguments[2] : undefined;
    const strs = [];
    if (Array.isArray(dates) && dates.length) {
      const type = this.getProp('type');
      switch (type) {
        case 'date':
        case 'dateTime':
        case 'month':
          dates.forEach(date => strs.push(this.formatDates([date], customFormat)));
          break;
        case 'dateRange':
        case 'dateTimeRange':
        case 'monthRange':
          for (let i = 0; i < dates.length; i += 2) {
            strs.push(this.formatDates(dates.slice(i, i + 2), customFormat));
          }
          break;
        default:
          break;
      }
    }
    return strs.join(separator);
  }
  /**
   * Update date value and the value of the input box
   * 1. Select Update
   * 2. Input Update
   * @param {Date|''} value
   * @param {Boolean} forceUpdateValue
   * @param {String} input
   */
  _updateValueAndInput(value, forceUpdateValue, input) {
    let _value;
    if (forceUpdateValue || value) {
      if (!Array.isArray(value)) {
        _value = value ? [value] : [];
      } else {
        _value = value;
      }
      const changedDates = this._getChangedDates(_value);
      // You cannot update the value directly when needConfirm, you can only change the value through handleConfirm
      if (!this._isControlledComponent() && !this._someDateDisabled(changedDates, _value) && !this._adapter.needConfirm()) {
        this._adapter.updateValue(_value);
      }
    }
    this._adapter.updateInputValue(input);
  }
  /**
   * when changing the selected value through the date panel
   * @param {*} value
   * @param {*} options
   */
  handleSelectedChange(value, options) {
    const {
      type,
      format,
      rangeSeparator,
      insetInput
    } = this._adapter.getProps();
    const {
      value: stateValue
    } = this.getStates();
    const controlled = this._isControlledComponent();
    const fromPreset = isObject_default()(options) ? options.fromPreset : options;
    const closePanel = get_default()(options, 'closePanel', true);
    /**
     * It is used to determine whether the panel can be stowed. In a Range type component, it is necessary to select both starting Time and endTime before stowing.
     * To determine whether both starting Time and endTime have been selected, it is used to judge whether the two inputs have been Focused.
     * This variable is used to indicate whether such a judgment is required. In the scene with shortcut operations, it is not required.
     */
    const needCheckFocusRecord = get_default()(options, 'needCheckFocusRecord', true);
    const dates = Array.isArray(value) ? [...value] : value ? [value] : [];
    const changedDates = this._getChangedDates(dates);
    let inputValue, insetInputValue;
    if (!this._someDateDisabled(changedDates, dates)) {
      this.resetCachedSelectedValue(dates);
      inputValue = this._isMultiple() ? this.formatMultipleDates(dates) : this.formatDates(dates);
      if (insetInput) {
        const insetInputFormatToken = getInsetInputFormatToken({
          format,
          type
        });
        const insetInputStr = this._isMultiple() ? this.formatMultipleDates(dates, undefined, insetInputFormatToken) : this.formatDates(dates, insetInputFormatToken);
        insetInputValue = getInsetInputValueFromInsetInputStr({
          inputValue: insetInputStr,
          type,
          rangeSeparator
        });
      }
      const isRangeTypeAndInputIncomplete = this._isRangeType() && !this._isRangeValueComplete(dates);
      /**
       * If the input is incomplete when under control, the notifyChange is not triggered because
       * You need to update the value of the input box, otherwise there will be a problem that a date is selected but the input box does not show the date #1357
       *
       * 受控时如果输入不完整，由于没有触发 notifyChange
       * 需要组件内更新一下输入框的值，否则会出现选了一个日期但是输入框没有回显日期的问题 #1357
       */
      if (isRangeTypeAndInputIncomplete) {
        // do not change value when selected value is incomplete
        this._adapter.updateInputValue(inputValue);
        this._adapter.updateInsetInputValue(insetInputValue);
        return;
      } else {
        if (!controlled || fromPreset) {
          this._updateValueAndInput(dates, true, inputValue);
          this._adapter.updateInsetInputValue(insetInputValue);
        }
      }
      if (!isEqual_default()(value, stateValue)) {
        this._notifyChange(value);
      }
    }
    const focusRecordChecked = !needCheckFocusRecord || needCheckFocusRecord && this._adapter.couldPanelClosed();
    if (type === 'date' && !this._isMultiple() && closePanel || type === 'dateRange' && this._isRangeValueComplete(dates) && closePanel && focusRecordChecked) {
      this.closePanel(undefined, inputValue, dates);
    }
  }
  /**
   * when changing the year and month through the panel when the type is year or month or monthRange
   * @param {*} item
   */
  handleYMSelectedChange() {
    let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // console.log(item);
    const {
      currentMonth,
      currentYear
    } = item;
    const {
      type
    } = this.getProps();
    if (type === 'month') {
      const date = new Date(currentYear['left'], currentMonth['left'] - 1);
      this.handleSelectedChange([date]);
    } else {
      const dateLeft = new Date(currentYear['left'], currentMonth['left'] - 1);
      const dateRight = new Date(currentYear['right'], currentMonth['right'] - 1);
      this.handleSelectedChange([dateLeft, dateRight]);
    }
  }
  handleConfirm() {
    this.clickConfirmButton = true;
    const {
      cachedSelectedValue,
      value
    } = this._adapter.getStates();
    const isRangeValueComplete = this._isRangeValueComplete(cachedSelectedValue);
    const newValue = isRangeValueComplete ? cachedSelectedValue : value;
    if (this._adapter.needConfirm() && !this._isControlledComponent()) {
      this._adapter.updateValue(newValue);
    }
    // If the input is incomplete, the legal date of the last input is used
    this.closePanel(undefined, undefined, newValue);
    if (isRangeValueComplete) {
      const {
        notifyValue,
        notifyDate
      } = this.disposeCallbackArgs(cachedSelectedValue);
      this._adapter.notifyConfirm(notifyDate, notifyValue);
    }
  }
  handleCancel() {
    this.closePanel();
    const value = this.getState('value');
    const {
      notifyValue,
      notifyDate
    } = this.disposeCallbackArgs(value);
    this._adapter.notifyCancel(notifyDate, notifyValue);
  }
  handlePresetClick(item, e) {
    const {
      type,
      timeZone
    } = this.getProps();
    const prevTimeZone = this.getState('prevTimezone');
    const start = typeof item.start === 'function' ? item.start() : item.start;
    const end = typeof item.end === 'function' ? item.end() : item.end;
    let value;
    switch (type) {
      case 'month':
      case 'dateTime':
      case 'date':
        value = this.parseWithTimezone([start], timeZone, prevTimeZone);
        this.handleSelectedChange(value);
        break;
      case 'dateTimeRange':
      case 'dateRange':
        value = this.parseWithTimezone([start, end], timeZone, prevTimeZone);
        this.handleSelectedChange(value, {
          needCheckFocusRecord: false
        });
        break;
      default:
        break;
    }
    this._adapter.notifyPresetsClick(item, e);
  }
  /**
   * 根据 type 处理 onChange 返回的参数
   *
   *  - 返回的日期需要把用户时间转换为设置的时区时间
   *      - 用户时间：用户计算机系统时间
   *      - 时区时间：通过 ConfigProvider 设置的 timeZone
   *  - 例子：用户设置时区为+9，计算机所在时区为+8区，然后用户选择了22:00
   *      - DatePicker 内部保存日期 state 为 +8 的 22:00 => a = new Date("2021-05-25 22:00:00")
   *      - 传出去时，需要把 +8 的 22:00 => +9 的 22:00 => b = zonedTimeToUtc(a, "+09:00");
   *
   * According to the type processing onChange returned parameters
   *
   *   - the returned date needs to convert the user time to the set time zone time
   *       - user time: user computer system time
   *       - time zone time: timeZone set by ConfigProvider
   *   - example: the user sets the time zone to + 9, the computer's time zone is + 8 zone, and then the user selects 22:00
   *       - DatePicker internal save date state is + 8 22:00 = > a = new Date ("2021-05-25 22:00:00")
   *       - when passed out, you need to + 8 22:00 = > + 9 22:00 = > b = zonedTimeToUtc (a, "+ 09:00");
   *
   *  e.g.
   *  let a = new Date ("2021-05-25 22:00:00");
   *       = > Tue May 25 2021 22:00:00 GMT + 0800 (China Standard Time)
   *  let b = zonedTimeToUtc (a, "+ 09:00");
   *       = > Tue May 25 2021 21:00:00 GMT + 0800 (China Standard Time)
   *
   * @param {Date|Date[]} value
   * @return {{ notifyDate: Date|Date[], notifyValue: string|string[]}}
   */
  disposeCallbackArgs(value) {
    let _value = Array.isArray(value) ? value : value && [value] || [];
    const timeZone = this.getProp('timeZone');
    if (isValidTimeZone(timeZone)) {
      _value = _value.map(date => zonedTimeToUtc(date, timeZone));
    }
    const type = this.getProp('type');
    const formatToken = this.getProp('format') || getDefaultFormatTokenByType(type);
    let notifyValue, notifyDate;
    switch (type) {
      case 'date':
      case 'dateTime':
      case 'month':
        if (!this._isMultiple()) {
          notifyValue = _value[0] && this.localeFormat(_value[0], formatToken);
          [notifyDate] = _value;
        } else {
          notifyValue = _value.map(v => v && this.localeFormat(v, formatToken));
          notifyDate = [..._value];
        }
        break;
      case 'dateRange':
      case 'dateTimeRange':
      case 'monthRange':
        notifyValue = _value.map(v => v && this.localeFormat(v, formatToken));
        notifyDate = [..._value];
        break;
      default:
        break;
    }
    return {
      notifyValue,
      notifyDate
    };
  }
  /**
   * Notice: Check whether the date is the same as the state value before calling
   * @param {Date[]} value
   */
  _notifyChange(value) {
    if (this._isRangeType() && !this._isRangeValueComplete(value)) {
      return;
    }
    const {
      onChangeWithDateFirst
    } = this.getProps();
    const {
      notifyValue,
      notifyDate
    } = this.disposeCallbackArgs(value);
    if (onChangeWithDateFirst) {
      this._adapter.notifyChange(notifyDate, notifyValue);
    } else {
      this._adapter.notifyChange(notifyValue, notifyDate);
    }
  }
  /**
   * Get the date changed through the date panel or enter
   */
  _getChangedDates(dates) {
    const type = this._adapter.getProp('type');
    const {
      cachedSelectedValue: lastDate
    } = this._adapter.getStates();
    const changedDates = [];
    switch (type) {
      case 'dateRange':
      case 'dateTimeRange':
        const [lastStart, lastEnd] = lastDate;
        const [start, end] = dates;
        if (!isEqual_isEqual(start, lastStart)) {
          changedDates.push(start);
        }
        if (!isEqual_isEqual(end, lastEnd)) {
          changedDates.push(end);
        }
        break;
      default:
        const lastValueSet = new Set();
        lastDate.forEach(value => lastValueSet.add(isDate_isDate(value) && value.valueOf()));
        for (const date of dates) {
          if (!lastValueSet.has(isDate_isDate(date) && date.valueOf())) {
            changedDates.push(date);
          }
        }
    }
    return changedDates;
  }
  /**
   * Whether a date is disabled
   * @param value The date that needs to be judged whether to disable
   * @param selectedValue Selected date, when selecting a range, pass this date to the second parameter of `disabledDate`
   */
  _someDateDisabled(value, selectedValue) {
    const {
      rangeInputFocus
    } = this.getStates();
    const disabledOptions = {
      rangeStart: '',
      rangeEnd: '',
      rangeInputFocus
    };
    // DisabledDate needs to pass the second parameter
    if (this._isRangeType() && Array.isArray(selectedValue)) {
      if (isValid_isValid(selectedValue[0])) {
        const rangeStart = format_format(selectedValue[0], 'yyyy-MM-dd');
        disabledOptions.rangeStart = rangeStart;
      }
      if (isValid_isValid(selectedValue[1])) {
        const rangeEnd = format_format(selectedValue[1], 'yyyy-MM-dd');
        disabledOptions.rangeEnd = rangeEnd;
      }
    }
    let isSomeDateDisabled = false;
    for (const date of value) {
      // skip check if date is null
      if (!isNullOrUndefined(date) && this.disabledDisposeDate(date, disabledOptions)) {
        isSomeDateDisabled = true;
        break;
      }
    }
    return isSomeDateDisabled;
  }
  /**
   * Format locale date
   * locale get from LocaleProvider
   * @param {Date} date
   * @param {String} token
   */
  localeFormat(date, token) {
    const dateFnsLocale = this._adapter.getProp('dateFnsLocale');
    return format_format(date, token, {
      locale: dateFnsLocale
    });
  }
  /**
   * Convert computer date to UTC date
   * Before passing the date to the user, you need to convert the date to UTC time
   * dispose date from computer date to utc date
   * When given timeZone prop, you should convert computer date to utc date before passing to user
   * @param {(date: Date) => Boolean} fn
   * @param {Date|Date[]} date
   * @returns {Boolean}
   */
  disposeDateFn(fn, date) {
    const {
      notifyDate
    } = this.disposeCallbackArgs(date);
    const dateIsArray = Array.isArray(date);
    const notifyDateIsArray = Array.isArray(notifyDate);
    let disposeDate;
    if (dateIsArray === notifyDateIsArray) {
      disposeDate = notifyDate;
    } else {
      disposeDate = dateIsArray ? [notifyDate] : notifyDate[0];
    }
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    return fn(disposeDate, ...rest);
  }
  /**
   * Determine whether the date is disabled
   * Whether the date is disabled
   * @param {Date} date
   * @returns {Boolean}
   */
  disabledDisposeDate(date) {
    const {
      disabledDate
    } = this.getProps();
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    return this.disposeDateFn(disabledDate, date, ...rest);
  }
  /**
   * Determine whether the date is disabled
   * Whether the date time is disabled
   * @param {Date|Date[]} date
   * @returns {Object}
   */
  disabledDisposeTime(date) {
    const {
      disabledTime
    } = this.getProps();
    for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      rest[_key3 - 1] = arguments[_key3];
    }
    return this.disposeDateFn(disabledTime, date, ...rest);
  }
  /**
   * Trigger wrapper needs to do two things:
   *  1. Open Panel when clicking trigger;
   *  2. When clicking on a child but the child does not listen to the focus event, manually trigger focus
   *
   * @param {Event} e
   * @returns
   */
  handleTriggerWrapperClick(e) {
    const {
      disabled,
      triggerRender
    } = this._adapter.getProps();
    const {
      rangeInputFocus
    } = this._adapter.getStates();
    if (disabled) {
      return;
    }
    /**
     * - 非范围选择时，trigger 为原生输入框，已在组件内处理了 focus 逻辑
     * - isEventTarget 函数用于判断触发事件的是否为 input wrapper。如果是冒泡上来的不用处理，因为在子级已经处理了 focus 逻辑。
     *
     * - When type is not range type, Input component will automatically focus in the same case
     * - isEventTarget is used to judge whether the event is a bubbling event
     */
    if (this._isRangeType() && !rangeInputFocus) {
      if (this._adapter.isEventTarget(e)) {
        setTimeout(() => {
          // using setTimeout get correct state value 'rangeInputFocus'
          this.handleInputFocus(e, 'rangeStart');
        }, 0);
      } else if (isFunction_default()(triggerRender)) {
        // 如果是 triggerRender 场景，因为没有 input，因此打开面板时默认 focus 在 rangeStart
        // If it is a triggerRender scene, because there is no input, the default focus is rangeStart when the panel is opened
        this._adapter.setRangeInputFocus('rangeStart');
      }
      this.openPanel();
    } else {
      this.openPanel();
    }
  }
  handlePanelVisibleChange(visible) {
    if (visible) {
      this._adapter.setInsetInputFocus();
      /**
       * After the panel is closed, the trigger input is disabled
       * 面板关闭后，trigger input 禁用
       */
      setTimeout(() => {
        this._adapter.setTriggerDisabled(true);
      }, 0);
    } else {
      this._adapter.setTriggerDisabled(false);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/formatter.js
/**
 * @file
 * Date-related formatting display method
 */


/**
 * Formats the displayed date text
 * @param {string[]|Date[]} values
 * @param {string} formatToken
 * @param {Object} groupOptions
 * @param {Object} locale
 * @returns {string}
 */
function formatDateValues(values, formatToken) {
  let {
    groupInnerSeparator = datePicker_constants_strings.DEFAULT_SEPARATOR_RANGE,
    groupSize = 1,
    groupSeparator = datePicker_constants_strings.DEFAULT_SEPARATOR_MULTIPLE
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let locale = arguments.length > 3 ? arguments[3] : undefined;
  let text = '';
  (groupSize <= 0 || typeof groupSize !== 'number') && (groupSize = 1);
  // console.log(values, formatToken, groupInnerSeparator, groupSize, groupSeparator);
  if (Array.isArray(values) && values.length) {
    const groups = [];
    const {
      length
    } = values;
    // chunk
    for (let i = 0; i < length; i++) {
      if (i % groupSize === 0) {
        groups.push([]);
      }
      const curArrIdx = Math.floor(i / groupSize);
      groups[curArrIdx].push(values[i]);
    }
    text = groups.map(arr => arr.map(v => {
      if (v) {
        // console.log(`formatDateValues() -> formatDateValues: ${v}`);
        return format_format(v, formatToken, {
          locale
        });
      } else {
        return '';
      }
    }).join(groupInnerSeparator)).join(groupSeparator);
  }
  return text;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getDefaultPickerDate.js




/**
 * get left panel picker date and right panel picker date
 */
function getDefaultPickerDate(options) {
  const {
    defaultPickerValue,
    format,
    dateFnsLocale
  } = options;
  let nowDate = Array.isArray(defaultPickerValue) ? defaultPickerValue[0] : defaultPickerValue;
  let nextDate = Array.isArray(defaultPickerValue) ? defaultPickerValue[1] : undefined;
  switch (true) {
    case isValidDate(nowDate):
      break;
    case isTimestamp(nowDate):
      nowDate = new Date(nowDate);
      break;
    case typeof nowDate === 'string':
      nowDate = compatibleParse(nowDate, format, undefined, dateFnsLocale);
      break;
    default:
      nowDate = new Date();
      break;
  }
  switch (true) {
    case isValidDate(nextDate):
      break;
    case isTimestamp(nextDate):
      nextDate = new Date(nextDate);
      break;
    case typeof nextDate === 'string':
      nextDate = compatibleParse(nextDate, format, undefined, dateFnsLocale);
      break;
    default:
      nextDate = addMonths(nowDate, 1);
      break;
  }
  return {
    nowDate: nowDate,
    nextDate: nextDate
  };
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/inputFoundation.js














const KEY_CODE_ENTER = 'Enter';
const KEY_CODE_TAB = 'Tab';
class inputFoundation_InputFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {}
  destroy() {}
  handleClick(e) {
    this._adapter.notifyClick(e);
  }
  handleChange(value, e) {
    this._adapter.notifyChange(value, e);
  }
  handleInputComplete(e) {
    /**
     * onKeyPress, e.key Code gets a value of 0 instead of 13
     * Here key is used to judge the button
     */
    if (e.key === KEY_CODE_ENTER) {
      this._adapter.notifyEnter(e.target.value);
    }
  }
  handleInputClear(e) {
    this._adapter.notifyClear(e);
  }
  handleRangeInputClear(e) {
    // prevent trigger click outside
    this.stopPropagation(e);
    this._adapter.notifyRangeInputClear(e);
  }
  handleRangeInputEnterPress(e, rangeInputValue) {
    if (e.key === KEY_CODE_ENTER) {
      this._adapter.notifyEnter(rangeInputValue);
    }
  }
  handleRangeInputEndKeyPress(e) {
    if (e.key === KEY_CODE_TAB) {
      this._adapter.notifyTabPress(e);
    }
  }
  handleRangeInputFocus(e, rangeType) {
    this._adapter.notifyRangeInputFocus(e, rangeType);
  }
  formatShowText(value, customFormat) {
    const {
      type,
      dateFnsLocale,
      format,
      rangeSeparator
    } = this._adapter.getProps();
    const formatToken = customFormat || format || getDefaultFormatTokenByType(type);
    let text = '';
    switch (type) {
      case 'date':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;
      case 'dateRange':
        text = formatDateValues(value, formatToken, {
          groupSize: 2,
          groupInnerSeparator: rangeSeparator
        }, dateFnsLocale);
        break;
      case 'dateTime':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;
      case 'dateTimeRange':
        text = formatDateValues(value, formatToken, {
          groupSize: 2,
          groupInnerSeparator: rangeSeparator
        }, dateFnsLocale);
        break;
      case 'month':
        text = formatDateValues(value, formatToken, undefined, dateFnsLocale);
        break;
      case 'monthRange':
        text = formatDateValues(value, formatToken, {
          groupSize: 2,
          groupInnerSeparator: rangeSeparator
        }, dateFnsLocale);
        break;
      default:
        break;
    }
    return text;
  }
  handleInsetInputChange(options) {
    const {
      value,
      valuePath,
      insetInputValue
    } = options;
    const {
      format,
      type,
      rangeSeparator
    } = this._adapter.getProps();
    const insetFormatToken = getInsetInputFormatToken({
      type,
      format
    });
    const newInsetInputValue = set_default()(index(insetInputValue), valuePath, value);
    const insetInputStr = this.concatInsetInputValue({
      insetInputValue: newInsetInputValue
    });
    const parsedInsetInputValueFromInputStr = getInsetInputValueFromInsetInputStr({
      inputValue: insetInputStr,
      type,
      rangeSeparator
    });
    const filledTimeInsetInputValue = this._autoFillTimeToInsetInputValue({
      insetInputValue: parsedInsetInputValueFromInputStr,
      valuePath,
      format: insetFormatToken
    });
    const finalInsetInputStr = this.concatInsetInputValue({
      insetInputValue: filledTimeInsetInputValue
    });
    this._adapter.notifyInsetInputChange({
      insetInputValue: filledTimeInsetInputValue,
      format: insetFormatToken,
      insetInputStr: finalInsetInputStr
    });
  }
  _autoFillTimeToInsetInputValue(options) {
    const {
      valuePath,
      insetInputValue,
      format
    } = options;
    const {
      type,
      defaultPickerValue,
      dateFnsLocale
    } = this._adapter.getProps();
    const insetInputValueWithTime = index(insetInputValue);
    const {
      nowDate,
      nextDate
    } = getDefaultPickerDate({
      defaultPickerValue,
      format,
      dateFnsLocale
    });
    if (type.includes('Time')) {
      let timeStr = '';
      const dateFormatToken = get_default()(format.split(' '), '0', datePicker_constants_strings.FORMAT_FULL_DATE);
      const timeFormatToken = get_default()(format.split(' '), '1', datePicker_constants_strings.FORMAT_TIME_PICKER);
      switch (valuePath) {
        case 'monthLeft.dateInput':
          const dateLeftStr = insetInputValueWithTime.monthLeft.dateInput;
          if (!insetInputValueWithTime.monthLeft.timeInput && dateLeftStr.length === dateFormatToken.length) {
            const dateLeftParsed = compatibleParse(insetInputValueWithTime.monthLeft.dateInput, dateFormatToken);
            if (isValidDate(dateLeftParsed)) {
              timeStr = format_format(nowDate, timeFormatToken);
              insetInputValueWithTime.monthLeft.timeInput = timeStr;
            }
          }
          break;
        case 'monthRight.dateInput':
          const dateRightStr = insetInputValueWithTime.monthRight.dateInput;
          if (!insetInputValueWithTime.monthRight.timeInput && dateRightStr.length === dateFormatToken.length) {
            const dateRightParsed = compatibleParse(dateRightStr, dateFormatToken);
            if (isValidDate(dateRightParsed)) {
              timeStr = format_format(nextDate, timeFormatToken);
              insetInputValueWithTime.monthRight.timeInput = timeStr;
            }
          }
          break;
        default:
          break;
      }
    }
    return insetInputValueWithTime;
  }
  /**
   * 只有传入的 format 符合 formatReg 时，才会使用用户传入的 format
   * 否则会使用默认的 format 作为 placeholder
   *
   * The format passed in by the user will be used only if the incoming format conforms to formatReg
   * Otherwise the default format will be used as placeholder
   */
  getInsetInputPlaceholder() {
    const {
      type,
      format,
      rangeSeparator
    } = this._adapter.getProps();
    const insetInputFormat = getInsetInputFormatToken({
      type,
      format
    });
    let datePlaceholder, timePlaceholder;
    switch (type) {
      case 'date':
      case 'month':
      case 'dateRange':
        datePlaceholder = insetInputFormat;
        break;
      case 'dateTime':
      case 'dateTimeRange':
        [datePlaceholder, timePlaceholder] = insetInputFormat.split(' ');
        break;
      case 'monthRange':
        datePlaceholder = insetInputFormat + rangeSeparator + insetInputFormat;
        break;
    }
    return {
      datePlaceholder,
      timePlaceholder
    };
  }
  /**
   * 从当前日期值或 inputValue 中解析出 insetInputValue
   *
   * Parse out insetInputValue from current date value or inputValue
   */
  getInsetInputValue(_ref) {
    let {
      value,
      insetInputValue
    } = _ref;
    const {
      type,
      rangeSeparator,
      format
    } = this._adapter.getProps();
    let inputValueStr = '';
    if (isObject_default()(insetInputValue)) {
      inputValueStr = this.concatInsetInputValue({
        insetInputValue
      });
    } else {
      const insetInputFormat = getInsetInputFormatToken({
        format,
        type
      });
      inputValueStr = this.formatShowText(value, insetInputFormat);
    }
    const newInsetInputValue = getInsetInputValueFromInsetInputStr({
      inputValue: inputValueStr,
      type,
      rangeSeparator
    });
    return newInsetInputValue;
  }
  concatInsetDateAndTime(_ref2) {
    let {
      date,
      time
    } = _ref2;
    return `${date} ${time}`;
  }
  concatInsetDateRange(_ref3) {
    let {
      rangeStart,
      rangeEnd
    } = _ref3;
    const {
      rangeSeparator
    } = this._adapter.getProps();
    return `${rangeStart}${rangeSeparator}${rangeEnd}`;
  }
  concatInsetInputValue(_ref4) {
    let {
      insetInputValue
    } = _ref4;
    const {
      type
    } = this._adapter.getProps();
    let inputValue = '';
    switch (type) {
      case 'date':
      case 'month':
      case 'monthRange':
        inputValue = insetInputValue.monthLeft.dateInput;
        break;
      case 'dateRange':
        inputValue = this.concatInsetDateRange({
          rangeStart: insetInputValue.monthLeft.dateInput,
          rangeEnd: insetInputValue.monthRight.dateInput
        });
        break;
      case 'dateTime':
        inputValue = this.concatInsetDateAndTime({
          date: insetInputValue.monthLeft.dateInput,
          time: insetInputValue.monthLeft.timeInput
        });
        break;
      case 'dateTimeRange':
        const rangeStart = this.concatInsetDateAndTime({
          date: insetInputValue.monthLeft.dateInput,
          time: insetInputValue.monthLeft.timeInput
        });
        const rangeEnd = this.concatInsetDateAndTime({
          date: insetInputValue.monthRight.dateInput,
          time: insetInputValue.monthRight.timeInput
        });
        inputValue = this.concatInsetDateRange({
          rangeStart,
          rangeEnd
        });
        break;
    }
    return inputValue;
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconCalendar.js


function IconCalendar_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20V8H20V20H4ZM2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM6 10.5C6 10.2239 6.22386 10 6.5 10H8.5C8.77614 10 9 10.2239 9 10.5V12.5C9 12.7761 8.77614 13 8.5 13H6.5C6.22386 13 6 12.7761 6 12.5V10.5ZM6.5 15C6.22386 15 6 15.2239 6 15.5V17.5C6 17.7761 6.22386 18 6.5 18H8.5C8.77614 18 9 17.7761 9 17.5V15.5C9 15.2239 8.77614 15 8.5 15H6.5ZM10.5 10.5C10.5 10.2239 10.7239 10 11 10H13C13.2761 10 13.5 10.2239 13.5 10.5V12.5C13.5 12.7761 13.2761 13 13 13H11C10.7239 13 10.5 12.7761 10.5 12.5V10.5ZM11 15C10.7239 15 10.5 15.2239 10.5 15.5V17.5C10.5 17.7761 10.7239 18 11 18H13C13.2761 18 13.5 17.7761 13.5 17.5V15.5C13.5 15.2239 13.2761 15 13 15H11ZM15 10.5C15 10.2239 15.2239 10 15.5 10H17.5C17.7761 10 18 10.2239 18 10.5V12.5C18 12.7761 17.7761 13 17.5 13H15.5C15.2239 13 15 12.7761 15 12.5V10.5ZM15.5 15C15.2239 15 15 15.2239 15 15.5V17.5C15 17.7761 15.2239 18 15.5 18H17.5C17.7761 18 18 17.7761 18 17.5V15.5C18 15.2239 17.7761 15 17.5 15H15.5Z",
    fill: "currentColor"
  }));
}
const IconCalendar_IconComponent = (0,Icon/* convertIcon */.A)(IconCalendar_SvgComponent, 'calendar');
/* harmony default export */ var IconCalendar = (IconCalendar_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconCalendarClock.js


function IconCalendarClock_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M2 5V19C2 20.6569 3.34315 22 5 22H12.101C11.5151 21.4259 11.0297 20.7496 10.6736 20H6C4.89543 20 4 19.1046 4 18V8C4 7.44772 4.44772 7 5 7H19C19.5523 7 20 7.44772 20 8V10.6736C20.7496 11.0297 21.4259 11.5151 22 12.101V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16 10H17C16.4614 10 15.9369 10.0608 15.4332 10.176C15.5943 10.065 15.7896 10 16 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.4981 10.9376C13.4659 10.4144 13.0313 10 12.5 10H11.5C10.9477 10 10.5 10.4477 10.5 11V12C10.5 12.4742 10.83 12.8712 11.2729 12.9741C11.857 12.1446 12.6168 11.4478 13.4981 10.9376Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7 10C6.44772 10 6 10.4477 6 11V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V11C9 10.4477 8.55228 10 8 10H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6 16C6 15.4477 6.44772 15 7 15H8C8.55228 15 9 15.4477 9 16V17C9 17.5523 8.55228 18 8 18H7C6.44772 18 6 17.5523 6 17V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17C12 14.2386 14.2386 12 17 12C19.7614 12 22 14.2386 22 17ZM18 15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15V17C16 17.2652 16.1054 17.5196 16.2929 17.7071L17.7929 19.2071C18.1834 19.5976 18.8166 19.5976 19.2071 19.2071C19.5976 18.8166 19.5976 18.1834 19.2071 17.7929L18 16.5858V15Z",
    fill: "currentColor"
  }));
}
const IconCalendarClock_IconComponent = (0,Icon/* convertIcon */.A)(IconCalendarClock_SvgComponent, 'calendar_clock');
/* harmony default export */ var IconCalendarClock = (IconCalendarClock_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/insetInput.js



function InsetDateInput(props) {
  const {
    insetInputValue,
    valuePath,
    onFocus,
    onChange,
    placeholder,
    forwardRef
  } = props;
  const value = get_default()(insetInputValue, valuePath);
  return /*#__PURE__*/react.createElement(es_input, {
    value: value,
    onChange: (value, event) => {
      onChange({
        value,
        event,
        insetInputValue,
        valuePath
      });
    },
    onFocus: onFocus,
    placeholder: placeholder,
    ref: forwardRef
  });
}
function InsetTimeInput(props) {
  const {
    insetInputValue,
    valuePath,
    type,
    onFocus,
    onChange,
    placeholder,
    disabled
  } = props;
  const _isTimeType = type.includes('Time');
  if (!_isTimeType) {
    return null;
  }
  const value = get_default()(insetInputValue, valuePath);
  return /*#__PURE__*/react.createElement(es_input, {
    value: value,
    onChange: (value, event) => {
      onChange({
        value,
        event,
        insetInputValue,
        valuePath
      });
    },
    onFocus: onFocus,
    placeholder: placeholder,
    disabled: disabled
  });
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/dateInput.js

var dateInput_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */











// eslint-disable-next-line @typescript-eslint/ban-types
class DateInput extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleChange = (value, e) => this.foundation.handleChange(value, e);
    this.handleEnterPress = e => this.foundation.handleInputComplete(e);
    this.handleInputClear = e => this.foundation.handleInputClear(e);
    this.handleRangeInputChange = (rangeStart, rangeEnd, e) => {
      const rangeInputValue = this.getRangeInputValue(rangeStart, rangeEnd);
      this.foundation.handleChange(rangeInputValue, e);
    };
    this.handleRangeInputClear = e => {
      this.foundation.handleRangeInputClear(e);
    };
    this.handleRangeInputEnterPress = (e, rangeStart, rangeEnd) => {
      const rangeInputValue = this.getRangeInputValue(rangeStart, rangeEnd);
      this.foundation.handleRangeInputEnterPress(e, rangeInputValue);
    };
    this.handleRangeInputEndKeyPress = e => {
      this.foundation.handleRangeInputEndKeyPress(e);
    };
    this.handleRangeInputFocus = (e, rangeType) => {
      this.foundation.handleRangeInputFocus(e, rangeType);
    };
    this.handleRangeStartFocus = e => {
      this.handleRangeInputFocus(e, 'rangeStart');
    };
    this.handleInsetInputChange = options => {
      this.foundation.handleInsetInputChange(options);
    };
    this.getRangeInputValue = (rangeStart, rangeEnd) => {
      const {
        rangeSeparator
      } = this.props;
      const rangeInputValue = `${rangeStart}${rangeSeparator}${rangeEnd}`;
      return rangeInputValue;
    };
    this.foundation = new inputFoundation_InputFoundation(this.adapter);
  }
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      updateIsFocusing: isFocusing => this.setState({
        isFocusing
      }),
      notifyClick: function () {
        return _this.props.onClick(...arguments);
      },
      notifyChange: function () {
        return _this.props.onChange(...arguments);
      },
      notifyEnter: function () {
        return _this.props.onEnterPress(...arguments);
      },
      notifyBlur: function () {
        return _this.props.onBlur(...arguments);
      },
      notifyClear: function () {
        return _this.props.onClear(...arguments);
      },
      notifyFocus: function () {
        return _this.props.onFocus(...arguments);
      },
      notifyRangeInputClear: function () {
        return _this.props.onRangeClear(...arguments);
      },
      notifyRangeInputFocus: function () {
        return _this.props.onFocus(...arguments);
      },
      notifyTabPress: function () {
        return _this.props.onRangeEndTabPress(...arguments);
      },
      notifyInsetInputChange: options => this.props.onInsetInputChange(options)
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  formatText(value) {
    return value && value.length ? this.foundation.formatShowText(value) : '';
  }
  renderRangePrefix() {
    const {
      prefix,
      insetLabel,
      prefixCls,
      disabled,
      rangeInputFocus
    } = this.props;
    const labelNode = prefix || insetLabel;
    return labelNode ? /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-range-input-prefix`,
      onClick: e => !disabled && !rangeInputFocus && this.handleRangeStartFocus(e),
      "x-semi-prop": "prefix,insetLabel"
    }, labelNode) : null;
  }
  renderRangeSeparator(rangeStart, rangeEnd) {
    const {
      disabled,
      rangeSeparator
    } = this.props;
    const separatorCls = classnames_default()({
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-separator`]: true,
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-separator-active`]: (rangeStart || rangeEnd) && !disabled
    });
    return /*#__PURE__*/react.createElement("span", {
      onClick: e => !disabled && this.handleRangeStartFocus(e),
      className: separatorCls
    }, rangeSeparator);
  }
  renderRangeClearBtn(rangeStart, rangeEnd) {
    const {
      showClear,
      prefixCls,
      disabled,
      clearIcon,
      showClearIgnoreDisabled
    } = this.props;
    const isRealDisabled = disabled && !showClearIgnoreDisabled;
    const allowClear = (rangeStart || rangeEnd) && showClear && !isRealDisabled;
    return allowClear ? /*#__PURE__*/react.createElement("div", {
      role: "button",
      tabIndex: 0,
      "aria-label": "Clear range input value",
      className: `${prefixCls}-range-input-clearbtn`,
      onMouseDown: e => this.handleRangeInputClear(e)
    }, clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, {
      "aria-hidden": true
    })) : null;
  }
  renderRangeSuffix(suffix) {
    const {
      prefixCls,
      disabled,
      rangeInputFocus
    } = this.props;
    const rangeSuffix = suffix ? /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-range-input-suffix`,
      onClick: e => !disabled && !rangeInputFocus && this.handleRangeStartFocus(e)
    }, suffix) : null;
    return rangeSuffix;
  }
  renderRangeInput(rangeProps) {
    const {
      // this.props
      placeholder,
      inputStyle,
      disabled,
      inputReadOnly,
      autofocus,
      size,
      // compute props
      text,
      suffix,
      inputCls,
      // range only props
      rangeInputStartRef,
      rangeInputEndRef,
      rangeInputFocus,
      prefixCls,
      rangeSeparator,
      borderless
    } = rangeProps;
    const [rangeStart, rangeEnd = ''] = text.split(rangeSeparator) || [];
    const rangeSize = size === 'large' ? 'default' : 'small';
    const rangePlaceholder = Array.isArray(placeholder) ? placeholder : [placeholder, placeholder];
    const [rangeStartPlaceholder, rangeEndPlaceholder] = rangePlaceholder;
    const inputLeftWrapperCls = classnames_default()(`${prefixCls}-range-input-wrapper-start`, `${prefixCls}-range-input-wrapper`, {
      [`${prefixCls}-range-input-wrapper-active`]: rangeInputFocus === 'rangeStart' && !disabled,
      [`${prefixCls}-range-input-wrapper-start-with-prefix`]: this.props.prefix || this.props.insetLabel,
      [`${prefixCls}-borderless`]: borderless
    });
    const inputRightWrapperCls = classnames_default()(`${prefixCls}-range-input-wrapper-end`, `${prefixCls}-range-input-wrapper`, {
      [`${prefixCls}-range-input-wrapper-active`]: rangeInputFocus === 'rangeEnd' && !disabled,
      [`${prefixCls}-borderless`]: borderless
    });
    return /*#__PURE__*/react.createElement(react.Fragment, null, this.renderRangePrefix(), /*#__PURE__*/react.createElement("div", {
      onClick: e => !disabled && this.handleRangeInputFocus(e, 'rangeStart'),
      className: `${inputCls} ${inputLeftWrapperCls}`
    }, /*#__PURE__*/react.createElement(es_input, {
      borderless: borderless,
      size: rangeSize,
      style: inputStyle,
      disabled: disabled,
      readonly: inputReadOnly,
      placeholder: rangeStartPlaceholder,
      value: rangeStart,
      // range input onBlur function is called when panel is closed
      // onBlur={noop}
      onChange: (rangeStartValue, e) => this.handleRangeInputChange(rangeStartValue, rangeEnd, e),
      onEnterPress: e => this.handleRangeInputEnterPress(e, rangeStart, rangeEnd),
      onFocus: e => this.handleRangeInputFocus(e, 'rangeStart'),
      autoFocus: autofocus,
      ref: rangeInputStartRef
    })), this.renderRangeSeparator(rangeStart, rangeEnd), /*#__PURE__*/react.createElement("div", {
      className: `${inputCls} ${inputRightWrapperCls}`,
      onClick: e => !disabled && this.handleRangeInputFocus(e, 'rangeEnd')
    }, /*#__PURE__*/react.createElement(es_input, {
      borderless: borderless,
      size: rangeSize,
      style: inputStyle,
      disabled: disabled,
      readonly: inputReadOnly,
      placeholder: rangeEndPlaceholder,
      value: rangeEnd,
      // range input onBlur function is called when panel is closed
      // onBlur={noop}
      onChange: (rangeEndValue, e) => this.handleRangeInputChange(rangeStart, rangeEndValue, e),
      onEnterPress: e => this.handleRangeInputEnterPress(e, rangeStart, rangeEnd),
      onFocus: e => this.handleRangeInputFocus(e, 'rangeEnd'),
      onKeyDown: this.handleRangeInputEndKeyPress,
      ref: rangeInputEndRef
    })), this.renderRangeClearBtn(rangeStart, rangeEnd), this.renderRangeSuffix(suffix));
  }
  isRenderMultipleInputs() {
    const {
      type
    } = this.props;
    // isRange and not monthRange render multiple inputs
    return type.includes('Range') && type !== 'monthRange';
  }
  renderInputInset() {
    const {
      type,
      handleInsetDateFocus,
      handleInsetTimeFocus,
      value,
      insetInputValue,
      prefixCls,
      rangeInputStartRef,
      rangeInputEndRef,
      density,
      insetInput
    } = this.props;
    const newInsetInputValue = this.foundation.getInsetInputValue({
      value,
      insetInputValue
    });
    const {
      dateStart,
      dateEnd,
      timeStart,
      timeEnd
    } = get_default()(insetInput, 'placeholder', {});
    const {
      datePlaceholder,
      timePlaceholder
    } = this.foundation.getInsetInputPlaceholder();
    const insetInputWrapperCls = `${prefixCls}-inset-input-wrapper`;
    const separatorCls = `${prefixCls}-inset-input-separator`;
    return /*#__PURE__*/react.createElement("div", {
      className: insetInputWrapperCls,
      "x-type": type
    }, /*#__PURE__*/react.createElement(InsetDateInput, {
      forwardRef: rangeInputStartRef,
      insetInputValue: newInsetInputValue,
      placeholder: dateStart !== null && dateStart !== void 0 ? dateStart : datePlaceholder,
      valuePath: 'monthLeft.dateInput',
      onChange: this.handleInsetInputChange,
      onFocus: e => handleInsetDateFocus(e, 'rangeStart')
    }), /*#__PURE__*/react.createElement(InsetTimeInput, {
      disabled: !newInsetInputValue.monthLeft.dateInput,
      insetInputValue: newInsetInputValue,
      placeholder: timeStart !== null && timeStart !== void 0 ? timeStart : timePlaceholder,
      type: type,
      valuePath: 'monthLeft.timeInput',
      onChange: this.handleInsetInputChange,
      onFocus: handleInsetTimeFocus
    }), this.isRenderMultipleInputs() && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: separatorCls
    }, density === 'compact' ? null : '-'), /*#__PURE__*/react.createElement(InsetDateInput, {
      forwardRef: rangeInputEndRef,
      insetInputValue: newInsetInputValue,
      placeholder: dateEnd !== null && dateEnd !== void 0 ? dateEnd : datePlaceholder,
      valuePath: 'monthRight.dateInput',
      onChange: this.handleInsetInputChange,
      onFocus: e => handleInsetDateFocus(e, 'rangeEnd')
    }), /*#__PURE__*/react.createElement(InsetTimeInput, {
      disabled: !newInsetInputValue.monthRight.dateInput,
      insetInputValue: newInsetInputValue,
      placeholder: timeEnd !== null && timeEnd !== void 0 ? timeEnd : timePlaceholder,
      type: type,
      valuePath: 'monthRight.timeInput',
      onChange: this.handleInsetInputChange,
      onFocus: handleInsetTimeFocus
    })));
  }
  renderTriggerInput() {
    const _a = this.props,
      {
        placeholder,
        type,
        value,
        inputValue,
        inputStyle,
        disabled,
        showClear,
        inputReadOnly,
        insetLabel,
        validateStatus,
        block,
        prefixCls,
        multiple,
        // Whether to allow multiple values for email and file types
        dateFnsLocale,
        // No need to pass to input
        onBlur,
        onClear,
        onFocus,
        prefix,
        autofocus,
        size,
        inputRef,
        // range input support props, no need passing to not range type
        rangeInputStartRef,
        rangeInputEndRef,
        onRangeClear,
        onRangeBlur,
        onRangeEndTabPress,
        rangeInputFocus,
        rangeSeparator,
        insetInput,
        insetInputValue,
        defaultPickerValue,
        showClearIgnoreDisabled
      } = _a,
      rest = dateInput_rest(_a, ["placeholder", "type", "value", "inputValue", "inputStyle", "disabled", "showClear", "inputReadOnly", "insetLabel", "validateStatus", "block", "prefixCls", "multiple", "dateFnsLocale", "onBlur", "onClear", "onFocus", "prefix", "autofocus", "size", "inputRef", "rangeInputStartRef", "rangeInputEndRef", "onRangeClear", "onRangeBlur", "onRangeEndTabPress", "rangeInputFocus", "rangeSeparator", "insetInput", "insetInputValue", "defaultPickerValue", "showClearIgnoreDisabled"]);
    const dateIcon = /*#__PURE__*/react.createElement(IconCalendar, {
      "aria-hidden": true
    });
    const dateTimeIcon = /*#__PURE__*/react.createElement(IconCalendarClock, {
      "aria-hidden": true
    });
    const suffix = type.includes('Time') ? dateTimeIcon : dateIcon;
    let text = '';
    if (!isNullOrUndefined(inputValue)) {
      text = inputValue;
    } else if (value) {
      text = this.formatText(value);
    }
    const inputCls = classnames_default()({
      [`${prefixCls}-input-readonly`]: inputReadOnly,
      [`${prefixCls}-monthRange-input`]: type === 'monthRange'
    });
    const rangeProps = Object.assign(Object.assign({}, this.props), {
      text,
      suffix,
      inputCls
    });
    return this.isRenderMultipleInputs() ? this.renderRangeInput(rangeProps) : /*#__PURE__*/react.createElement(es_input, Object.assign({}, rest, {
      ref: inputRef,
      insetLabel: insetLabel,
      disabled: disabled,
      showClearIgnoreDisabled: showClearIgnoreDisabled,
      readonly: inputReadOnly,
      className: inputCls,
      style: inputStyle,
      hideSuffix: showClear,
      placeholder: type === 'monthRange' && Array.isArray(placeholder) ? placeholder[0] + rangeSeparator + placeholder[1] : placeholder,
      onEnterPress: this.handleEnterPress,
      onChange: this.handleChange,
      onClear: this.handleInputClear,
      suffix: suffix,
      showClear: showClear,
      value: text,
      validateStatus: validateStatus,
      prefix: prefix,
      autoFocus: autofocus,
      size: size,
      onBlur: onBlur,
      onFocus: onFocus
    }));
  }
  render() {
    const {
      insetInput
    } = this.props;
    return insetInput ? this.renderInputInset() : this.renderTriggerInput();
  }
}
DateInput.propTypes = {
  borderless: (prop_types_default()).bool,
  onClick: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onEnterPress: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  value: (prop_types_default()).array,
  disabled: (prop_types_default()).bool,
  type: prop_types_default().oneOf(datePicker_constants_strings.TYPE_SET),
  showClear: (prop_types_default()).bool,
  format: (prop_types_default()).string,
  inputStyle: (prop_types_default()).object,
  inputReadOnly: (prop_types_default()).bool,
  insetLabel: (prop_types_default()).node,
  validateStatus: (prop_types_default()).string,
  prefix: (prop_types_default()).node,
  prefixCls: (prop_types_default()).string,
  dateFnsLocale: (prop_types_default()).object.isRequired,
  placeholder: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  rangeInputFocus: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).bool]),
  rangeInputStartRef: (prop_types_default()).object,
  rangeInputEndRef: (prop_types_default()).object,
  rangeSeparator: (prop_types_default()).string,
  insetInput: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  insetInputValue: (prop_types_default()).object,
  defaultPickerValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object, (prop_types_default()).array])
};
DateInput.defaultProps = {
  borderless: false,
  showClear: true,
  onClick: function_noop,
  onChange: function_noop,
  onEnterPress: function_noop,
  onBlur: function_noop,
  onClear: function_noop,
  onFocus: function_noop,
  type: 'date',
  inputStyle: {},
  inputReadOnly: false,
  prefixCls: datePicker_constants_cssClasses.PREFIX,
  rangeSeparator: datePicker_constants_strings.DEFAULT_SEPARATOR_RANGE
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
// EXTERNAL MODULE: ./node_modules/lodash/isSet.js
var isSet = __webpack_require__(72928);
var isSet_default = /*#__PURE__*/__webpack_require__.n(isSet);
// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__(64721);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate_toDate(dirtyDateLeft);
  var dateRight = toDate_toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarYears/index.js


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate_toDate(dirtyDateLeft);
  var dateRight = toDate_toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subYears/index.js



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/set/index.js





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set_set(dirtyDate, values) {
  requiredArgs(2, arguments);
  if (_typeof(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = toDate_toDate(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = setMonth(date, values.month);
  }
  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }
  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }
  return date;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getFullDateOffset.js



/**
 * Calculate the date string offset from the date
 * @param {*} fn
 * @param {*} date
 */
const getFullDateOffset = (fn, date) => {
  if (!date) {
    return '';
  }
  const getDate = new Date(date);
  const offsetDate = isFunction_default()(fn) ? fn(getDate) : getDate;
  return format_format(new Date(offsetDate), datePicker_constants_strings.FORMAT_FULL_DATE);
};
/* harmony default export */ var _utils_getFullDateOffset = (getFullDateOffset);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var dateToCompare = toDate_toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/isString.js
/* harmony default export */ function utils_isString(str) {
  return typeof str === 'string';
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isBefore.js


function isBefore_isBefore(date, dateToCompare) {
  const dayOne = utils_isString(date) ? parseISO(date) : date;
  const dayTwo = utils_isString(dateToCompare) ? parseISO(dateToCompare) : dateToCompare;
  return isBefore(dayOne, dayTwo);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getMonthTable.js
/**
 *
 * @param {string} month
 */

function formatFullDate() {
  let year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let month = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let day = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let dateStr = '';
  const monthFull = typeof month === 'number' && month < 10 ? `0${month}` : month.toString();
  const dayNumberFull = typeof day === 'number' && day < 10 ? `0${day}` : day.toString();
  dateStr = `${String(year)}-${monthFull}-${dayNumberFull}`;
  return dateStr;
}
function getWeeks(date) {
  let weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const weekDayNotInMonth = {
    dayNumber: '',
    dateNumberFull: '',
    fullDate: ''
  }; // For the first or last week epmtyDays
  const daysInMonth = getDaysInMonth(date); // Get the total number of days in the month
  const year = format_format(date, 'yyyy');
  const month = format_format(date, 'MM');
  const lastday = lastDayOfMonth(date); // Get the last day of the month
  const firstDay = startOfMonth(date); // Get the first day of the month
  // Const firstDayInWeek = getDay (firstDay);//The first day belongs to the day of the week
  // What is the first day of the month in the first row?
  const firstDayInWeek = Number(format_format(firstDay, 'e', {
    weekStartsOn
  }));
  const weeks = [];
  let week = [];
  // add empty days to set first day in correct position
  for (let s = 1; s < firstDayInWeek; s++) {
    week.push(weekDayNotInMonth);
  }
  for (let d = 0; d < daysInMonth; d++) {
    const dayNumber = d + 1;
    const dayNumberFull = dayNumber < 10 ? `0${dayNumber}` : dayNumber.toString();
    const fullDate = formatFullDate(year, month, dayNumber);
    week.push({
      dayNumber,
      dayNumberFull,
      fullDate
    });
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    } else if (fullDate === format_format(lastday, 'yyyy-MM-dd')) {
      // Last week alone
      weeks.push(week);
      week = [];
    }
  }
  return weeks;
}
const getMonthTable = (month, weekStartsOn) => {
  const weeks = getWeeks(month, weekStartsOn);
  const monthText = format_format(month, 'yyyy-MM');
  return {
    monthText,
    weeks,
    month
  };
};
/* harmony default export */ var _utils_getMonthTable = (getMonthTable);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/monthsGridFoundation.js












const dateDiffFns = {
  month: differenceInCalendarMonths,
  year: differenceInCalendarYears
};
const dateCalcFns = {
  prevMonth: subMonths,
  nextMonth: addMonths,
  prevYear: subYears,
  nextYear: addYears
};
class MonthsGridFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    // Date change data when double panels
    this.newBiMonthPanelDate = [this.getState('monthLeft').pickerDate, this.getState('monthRight').pickerDate];
  }
  init() {
    const defaultValue = this.getProp('defaultValue');
    this.initDefaultPickerValue();
    this.updateSelectedFromProps(defaultValue);
  }
  initDefaultPickerValue() {
    const defaultPickerValue = compatibleParse(this.getProp('defaultPickerValue'));
    if (defaultPickerValue && isValidDate(defaultPickerValue)) {
      this._updatePanelDetail(datePicker_constants_strings.PANEL_TYPE_LEFT, {
        pickerDate: defaultPickerValue
      });
      this._updatePanelDetail(datePicker_constants_strings.PANEL_TYPE_RIGHT, {
        pickerDate: addMonths(defaultPickerValue, 1)
      });
    }
  }
  updateSelectedFromProps(values) {
    let refreshPicker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const type = this.getProp('type');
    const {
      selected,
      rangeStart,
      rangeEnd
    } = this.getStates();
    if (values && (values === null || values === void 0 ? void 0 : values.length)) {
      switch (type) {
        case 'date':
          this._initDatePickerFromValue(values, refreshPicker);
          break;
        case 'dateRange':
          this._initDateRangePickerFromValue(values);
          break;
        case 'dateTime':
          this._initDateTimePickerFromValue(values);
          break;
        case 'dateTimeRange':
          this._initDateTimeRangePickerFormValue(values);
          break;
        default:
          break;
      }
    } else if (Array.isArray(values) && !values.length || !values) {
      // Empty panel when value is empty Select date
      if (isSet_default()(selected) && selected.size) {
        this._adapter.updateDaySelected(new Set());
      }
      if (rangeStart) {
        this._adapter.setRangeStart('');
      }
      if (rangeEnd) {
        this._adapter.setRangeEnd('');
      }
    }
  }
  calcDisabledTime(panelType) {
    const {
      disabledTime,
      type
    } = this.getProps();
    if (typeof disabledTime === 'function' && panelType && ['dateTime', 'dateTimeRange'].includes(type)) {
      const {
        rangeStart,
        rangeEnd,
        monthLeft
      } = this.getStates();
      const selected = [];
      if (type === 'dateTimeRange') {
        if (rangeStart) {
          selected.push(rangeStart);
        }
        if (rangeStart && rangeEnd) {
          selected.push(rangeEnd);
        }
      } else if (monthLeft && monthLeft.showDate) {
        selected.push(monthLeft.showDate);
      }
      const selectedDates = selected.map(str => str instanceof Date ? str : parseISO(str));
      const cbDates = type === 'dateTimeRange' ? selectedDates : selectedDates[0];
      return disabledTime(cbDates, panelType);
    }
  }
  _initDatePickerFromValue(values) {
    let refreshPicker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const {
      monthLeft
    } = this._adapter.getStates();
    const newMonthLeft = Object.assign({}, monthLeft);
    // REMOVE:
    this._adapter.updateMonthOnLeft(newMonthLeft);
    const newSelected = new Set();
    const isMultiple = this._isMultiple();
    if (!isMultiple) {
      values[0] && newSelected.add(format_format(values[0], datePicker_constants_strings.FORMAT_FULL_DATE));
    } else {
      values.forEach(date => {
        date && newSelected.add(format_format(date, datePicker_constants_strings.FORMAT_FULL_DATE));
      });
    }
    if (refreshPicker) {
      if (isMultiple) {
        const leftPickerDateInSelected = values === null || values === void 0 ? void 0 : values.some(item => item && differenceInCalendarMonths(item, monthLeft.pickerDate) === 0);
        !leftPickerDateInSelected && this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_LEFT, values[0] || newMonthLeft.pickerDate);
      } else {
        this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_LEFT, values[0] || newMonthLeft.pickerDate);
      }
    } else {
      // FIXME:
      this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_LEFT, newMonthLeft.pickerDate);
    }
    this._adapter.updateDaySelected(newSelected);
  }
  _initDateRangePickerFromValue(values) {
    let withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // init month panel
    const monthLeft = this.getState('monthLeft');
    const monthRight = this.getState('monthRight');
    const adjustResult = this._autoAdjustMonth(Object.assign(Object.assign({}, monthLeft), {
      pickerDate: values[0] || monthLeft.pickerDate
    }), Object.assign(Object.assign({}, monthRight), {
      pickerDate: values[1] || monthRight.pickerDate
    }));
    const validValue = Array.isArray(values) && values.filter(item => item).length > 1;
    if (validValue) {
      this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_LEFT, adjustResult.monthLeft.pickerDate);
      this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_RIGHT, adjustResult.monthRight.pickerDate);
    } else {
      const selectedDate = values.find(item => item);
      // 如果日期不完整且输入日期不在面板范围内，则更新面板
      if (selectedDate) {
        const notLeftPanelDate = Math.abs(differenceInCalendarMonths(selectedDate, monthLeft.pickerDate)) > 0;
        const notRightPanelDate = Math.abs(differenceInCalendarMonths(selectedDate, monthRight.pickerDate)) > 0;
        if (notLeftPanelDate && notRightPanelDate) {
          this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_LEFT, adjustResult.monthLeft.pickerDate);
          this.handleShowDateAndTime(datePicker_constants_strings.PANEL_TYPE_RIGHT, adjustResult.monthRight.pickerDate);
        }
      }
    }
    // init range
    const formatToken = withTime ? datePicker_constants_strings.FORMAT_DATE_TIME : datePicker_constants_strings.FORMAT_FULL_DATE;
    let rangeStart = values[0] && format_format(values[0], formatToken);
    let rangeEnd = values[1] && format_format(values[1], formatToken);
    if (this._isNeedSwap(rangeStart, rangeEnd)) {
      [rangeStart, rangeEnd] = [rangeEnd, rangeStart];
    }
    this._adapter.setRangeStart(rangeStart);
    this._adapter.setRangeEnd(rangeEnd);
    this._adapter.setHoverDay(rangeEnd);
  }
  _initDateTimePickerFromValue(values) {
    this._initDatePickerFromValue(values);
  }
  _initDateTimeRangePickerFormValue(values) {
    this._initDateRangePickerFromValue(values, true);
  }
  destroy() {}
  /**
   * sync change another panel month when change months from the else yam panel
   * call it when
   *  - current change panel targe date month is same with another panel date
   *
   * @example
   *  - panelType=right, target=new Date('2022-09-01') and left panel is in '2022-09' => call it, left panel minus one month to '2022-08'
   *  - panelType=left, target=new Date('2021-12-01') and right panel is in '2021-12' => call it, right panel add one month to '2021-01'
   */
  handleSyncChangeMonths(options) {
    const {
      panelType,
      target
    } = options;
    const {
      type
    } = this._adapter.getProps();
    const {
      monthLeft,
      monthRight
    } = this._adapter.getStates();
    if (this.isRangeType(type)) {
      if (panelType === 'right' && differenceInCalendarMonths(target, monthLeft.pickerDate) === 0) {
        this.handleYearOrMonthChange('prevMonth', 'left', 1, true);
      } else if (panelType === 'left' && differenceInCalendarMonths(monthRight.pickerDate, target) === 0) {
        this.handleYearOrMonthChange('nextMonth', 'right', 1, true);
      }
    }
  }
  /**
   * Get the target date based on the panel type and switch type
   */
  getTargetChangeDate(options) {
    const {
      panelType,
      switchType
    } = options;
    const {
      monthRight,
      monthLeft
    } = this._adapter.getStates();
    const currentDate = panelType === 'left' ? monthLeft.pickerDate : monthRight.pickerDate;
    let target;
    switch (switchType) {
      case 'prevMonth':
        target = addMonths(currentDate, -1);
        break;
      case 'nextMonth':
        target = addMonths(currentDate, 1);
        break;
      case 'prevYear':
        target = addYears(currentDate, -1);
        break;
      case 'nextYear':
        target = addYears(currentDate, 1);
        break;
    }
    return target;
  }
  /**
   * Change month by yam panel
   */
  toMonth(panelType, target) {
    const {
      type
    } = this._adapter.getProps();
    const diff = this._getDiff('month', target, panelType);
    this.handleYearOrMonthChange(diff < 0 ? 'prevMonth' : 'nextMonth', panelType, Math.abs(diff), false);
    if (this.isRangeType(type)) {
      this.handleSyncChangeMonths({
        panelType,
        target
      });
    }
  }
  toYear(panelType, target) {
    const diff = this._getDiff('year', target, panelType);
    this.handleYearOrMonthChange(diff < 0 ? 'prevYear' : 'nextYear', panelType, Math.abs(diff), false);
  }
  toYearMonth(panelType, target) {
    this.toYear(panelType, target);
    this.toMonth(panelType, target);
  }
  isRangeType(type) {
    const {
      type: typeFromProp
    } = this.getProps();
    const realType = type ? type : typeFromProp;
    return typeof realType === 'string' && /range/i.test(realType);
  }
  handleSwitchMonthOrYear(switchType, panelType) {
    const {
      type,
      syncSwitchMonth
    } = this.getProps();
    const rangeType = this.isRangeType(type);
    // range type and syncSwitchMonth, we should change panels at same time
    if (rangeType && syncSwitchMonth) {
      this.handleYearOrMonthChange(switchType, 'left', 1, true);
      this.handleYearOrMonthChange(switchType, 'right', 1, true);
    } else {
      this.handleYearOrMonthChange(switchType, panelType);
      /**
       * default behavior (v2.2.0)
       * In order to prevent the two panels from being the same month, this will confuse the user when selecting the range
       * https://github.com/DouyinFE/semi-design/issues/260
       */
      if (rangeType) {
        const target = this.getTargetChangeDate({
          panelType,
          switchType
        });
        this.handleSyncChangeMonths({
          panelType,
          target
        });
      }
    }
  }
  prevMonth(panelType) {
    this.handleSwitchMonthOrYear('prevMonth', panelType);
  }
  nextMonth(panelType) {
    this.handleSwitchMonthOrYear('nextMonth', panelType);
  }
  prevYear(panelType) {
    this.handleSwitchMonthOrYear('prevYear', panelType);
  }
  nextYear(panelType) {
    this.handleSwitchMonthOrYear('nextYear', panelType);
  }
  /**
   * Calculate the year and month difference
   */
  _getDiff(type, target, panelType) {
    const panelDetail = this._getPanelDetail(panelType);
    const diff = dateDiffFns[type] && dateDiffFns[type](target, panelDetail.pickerDate);
    return diff;
  }
  _getPanelDetail(panelType) {
    return panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT ? this.getState('monthRight') : this.getState('monthLeft');
  }
  /**
   * Format locale date
   * locale get from LocaleProvider
   * @param {Date} date
   * @param {String} token
   * @returns
   */
  localeFormat(date, token) {
    const dateFnsLocale = this._adapter.getProp('dateFnsLocale');
    return format_format(date, token, {
      locale: dateFnsLocale
    });
  }
  /**
   * 根据 type 处理 onChange 返回的参数
   *
   *  - 返回的日期需要把用户时间转换为设置的时区时间
   *      - 用户时间：用户计算机系统时间
   *      - 时区时间：通过 ConfigProvider 设置的 timeZone
   *  - 例子：用户设置时区为+9，计算机所在时区为+8区，然后用户选择了22:00
   *      - DatePicker 内部保存日期 state 为 +8 的 22:00 => a = new Date("2021-05-25 22:00:00")
   *      - 传出去时，需要把 +8 的 22:00 => +9 的 22:00 => b = zonedTimeToUtc(a, "+09:00");
   *
   * The parameters returned by onChange are processed according to type
   *
   *  -The returned date needs to convert the user time to the set time zone time
   *      -User time: user computer system time
   *      -Time zone: timeZone set by ConfigProvider
   *  -Example: The user sets the time zone to + 9, and the time zone where the computer is located is + 8, and then the user selects 22:00
   *      -DatePicker internal save date state is + 8 22:00 = > a = new Date ("2021-05-25 22:00:00")
   *      -When passing out, you need to put + 8's 22:00 = > + 9's 22:00 = > b = zonedTimeToUtc (a, "+ 09:00");
   *
   *  e.g.
   *  let a = new Date ("2021-05-25 22:00:00");
   *       = > Tue May 25 2021 22:00:00 GMT + 0800 (China Standard Time)
   *  let b = zonedTimeToUtc (a, "+ 09:00");
   *       = > Tue May 25 2021 21:00:00 GMT + 0800 (China Standard Time)
   *
   * @param {Date|Date[]} value
   */
  disposeCallbackArgs(value) {
    let _value = Array.isArray(value) ? value : value && [value] || [];
    const timeZone = this.getProp('timeZone');
    if (isValidTimeZone(timeZone)) {
      _value = _value.map(date => zonedTimeToUtc(date, timeZone));
    }
    const type = this.getProp('type');
    const formatToken = this.getProp('format') || getDefaultFormatTokenByType(type);
    let notifyValue, notifyDate;
    switch (type) {
      case 'date':
      case 'dateTime':
      case 'month':
        if (!this._isMultiple()) {
          notifyValue = _value[0] && this.localeFormat(_value[0], formatToken);
          [notifyDate] = _value;
        } else {
          notifyValue = _value.map(v => v && this.localeFormat(v, formatToken));
          notifyDate = [..._value];
        }
        break;
      case 'dateRange':
      case 'dateTimeRange':
        notifyValue = _value.map(v => v && this.localeFormat(v, formatToken));
        notifyDate = [..._value];
        break;
      default:
        break;
    }
    return {
      notifyValue,
      notifyDate
    };
  }
  handleYearOrMonthChange(type) {
    let panelType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datePicker_constants_strings.PANEL_TYPE_LEFT;
    let step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    let notSeparateInRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const {
      autoSwitchDate,
      type: datePanelType
    } = this.getProps();
    const {
      monthLeft,
      monthRight
    } = this.getStates();
    const isRangeType = this.isRangeType(datePanelType);
    const isLeftPanelInRange = isRangeType && panelType === datePicker_constants_strings.PANEL_TYPE_LEFT;
    const panelDetail = this._getPanelDetail(panelType);
    const {
      pickerDate
    } = panelDetail;
    const fn = dateCalcFns[type];
    const targetMonth = fn(pickerDate, step);
    // Determine if the date has changed
    const panelDateHasUpdate = panelType === datePicker_constants_strings.PANEL_TYPE_LEFT && !isEqual_default()(targetMonth, monthLeft.pickerDate) || panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT && !isEqual_default()(targetMonth, monthRight.pickerDate);
    this._updatePanelDetail(panelType, {
      pickerDate: targetMonth
    });
    if (panelDateHasUpdate) {
      // When the date changes
      if (!isRangeType) {
        // Single Panel Type
        const {
          notifyValue,
          notifyDate
        } = this.disposeCallbackArgs(targetMonth);
        this._adapter.notifyPanelChange(notifyDate, notifyValue);
      } else {
        // Double Panel Type
        if (isLeftPanelInRange) {
          // Left panel
          this.newBiMonthPanelDate[0] = targetMonth;
        } else {
          // Right panel
          this.newBiMonthPanelDate[1] = targetMonth;
        }
        if (!(isLeftPanelInRange && notSeparateInRange)) {
          // Not synchronously switching the left panel in the scene
          const {
            notifyValue,
            notifyDate
          } = this.disposeCallbackArgs(this.newBiMonthPanelDate);
          this._adapter.notifyPanelChange(notifyDate, notifyValue);
        }
      }
    }
    if (autoSwitchDate) {
      this.updateDateAfterChangeYM(type, targetMonth);
    }
  }
  /**
   * You have chosen to switch the year and month in the future to directly update the Date without closing the date panel
   * @param {*} type
   * @param {*} targetDate
   */
  updateDateAfterChangeYM(type, targetDate) {
    const {
      multiple,
      disabledDate,
      type: dateType
    } = this.getProps();
    const {
      selected: selectedSet,
      rangeStart,
      rangeEnd,
      monthLeft
    } = this.getStates();
    // FIXME:
    const includeRange = ['dateRange', 'dateTimeRange'].includes(type);
    const options = {
      closePanel: false
    };
    if (!multiple && !includeRange && selectedSet.size) {
      const selectedStr = Array.from(selectedSet)[0];
      const selectedDate = new Date(selectedStr);
      const year = targetDate.getFullYear();
      const month = targetDate.getMonth();
      let fullDate = set_set(selectedDate, {
        year,
        month
      });
      if (dateType === 'dateTime') {
        /**
         * 如果是 type dateTime 切换月份要读取只取的time
         * 无论 monthLeft 还是 monthRight 他们的 time 是不变的，所以只取 monthLeft 即可
         */
        fullDate = this._mergeDateAndTime(fullDate, monthLeft.pickerDate);
      }
      if (disabledDate(fullDate, {
        rangeStart,
        rangeEnd
      })) {
        return;
      }
      this._adapter.notifySelectedChange([fullDate], options);
    }
  }
  _isMultiple() {
    return Boolean(this.getProp('multiple')) && this.getProp('type') === 'date';
  }
  _isRange() {
    // return this._adapter.getProp('type') === dateRangeTypeKey;
  }
  handleDayClick(day, panelType) {
    const type = this.getProp('type');
    switch (true) {
      case type === 'date' || type === 'dateTime':
        this.handleDateSelected(day, panelType);
        break;
      case type === 'dateRange' || type === 'dateTimeRange':
        this.handleRangeSelected(day);
        break;
      default:
        break;
    }
  }
  handleDateSelected(day, panelType) {
    const {
      max,
      type,
      isControlledComponent,
      dateFnsLocale
    } = this.getProps();
    const multiple = this._isMultiple();
    const {
      selected
    } = this.getStates();
    const monthDetail = this._getPanelDetail(panelType);
    const newSelected = new Set(multiple ? [...selected] : []);
    const {
      fullDate
    } = day;
    const time = monthDetail.pickerDate;
    const dateStr = type === 'dateTime' ? this._mergeDateAndTime(fullDate, time) : fullDate;
    if (!multiple) {
      newSelected.add(dateStr);
    } else {
      if (newSelected.has(dateStr)) {
        newSelected.delete(dateStr);
      } else if (max && newSelected.size === max) {
        this._adapter.notifyMaxLimit();
      } else {
        newSelected.add(dateStr);
      }
    }
    const dateFormat = this.getValidDateFormat();
    // When passed to the upper layer, it is converted into a Date object to ensure that the input parameter format of initFormDefaultValue is consistent
    const newSelectedDates = [...newSelected].map(_dateStr => compatibleParse(_dateStr, dateFormat, undefined, dateFnsLocale));
    this.handleShowDateAndTime(panelType, time);
    if (!isControlledComponent) {
      // Uncontrolled components, update internal values when operating, and notify external
      // MonthGrid internally uses string to represent fullDate for easy rendering
      this._adapter.updateDaySelected(newSelected);
    }
    this._adapter.notifySelectedChange(newSelectedDates);
  }
  handleShowDateAndTime(panelType, pickerDate, showDate) {
    const _showDate = showDate || pickerDate;
    this._updatePanelDetail(panelType, {
      showDate: _showDate,
      pickerDate
    });
  }
  /**
   * link date and time
   *
   * @param {Date|string} date
   * @param {Date|string} time
   * @returns {Date}
   */
  _mergeDateAndTime(date, time) {
    const dateFnsLocale = this._adapter.getProp('dateFnsLocale');
    const dateStr = format_format(isValidDate(date) ? date : compatibleParse(date, datePicker_constants_strings.FORMAT_FULL_DATE, undefined, dateFnsLocale), datePicker_constants_strings.FORMAT_FULL_DATE);
    const timeStr = format_format(isValidDate(time) ? time : compatibleParse(time, datePicker_constants_strings.FORMAT_TIME_PICKER, undefined, dateFnsLocale), datePicker_constants_strings.FORMAT_TIME_PICKER);
    const timeFormat = this.getValidTimeFormat();
    return compatibleParse(`${dateStr} ${timeStr}`, timeFormat, undefined, dateFnsLocale);
  }
  handleRangeSelected(day) {
    let {
      rangeStart,
      rangeEnd
    } = this.getStates();
    const {
      startDateOffset,
      endDateOffset,
      type,
      dateFnsLocale,
      rangeInputFocus,
      triggerRender
    } = this._adapter.getProps();
    const {
      fullDate
    } = day;
    let rangeStartReset = false;
    let rangeEndReset = false;
    const isDateRangeAndHasOffset = (startDateOffset || endDateOffset) && type === 'dateRange';
    if (isDateRangeAndHasOffset) {
      rangeStart = _utils_getFullDateOffset(startDateOffset, fullDate);
      rangeEnd = _utils_getFullDateOffset(endDateOffset, fullDate);
    } else {
      if (rangeInputFocus === 'rangeEnd') {
        rangeEnd = fullDate;
        // rangStart Parten in dateTime: 'yyyy-MM-dd HH:MM:SS', rangeEnd parten: 'yyyy-MM-dd'
        if (rangeStart && rangeEnd && isBefore_isBefore(rangeEnd, rangeStart.trim().split(/\s+/)[0])) {
          rangeStart = null;
          rangeStartReset = true;
        }
        // Compatible to select date after opening the panel without click input
      } else if (rangeInputFocus === 'rangeStart' || !rangeInputFocus) {
        rangeStart = fullDate;
        // rangEnd Parten in dateTime: 'yyyy-MM-dd HH:MM:SS', rangeStart parten: 'yyyy-MM-dd'
        if (rangeStart && rangeEnd && isBefore_isBefore(rangeEnd.trim().split(/\s+/)[0], rangeStart)) {
          rangeEnd = null;
          rangeEndReset = true;
        }
      }
    }
    // next focus logic
    const isRangeType = /range/i.test(type);
    if (isRangeType) {
      if (isDateRangeAndHasOffset) {
        this._adapter.setRangeStart(rangeStart);
        this._adapter.setRangeEnd(rangeEnd);
      } else {
        if (rangeInputFocus === 'rangeEnd') {
          this._adapter.setRangeEnd(rangeEnd);
          if (rangeStartReset) {
            this._adapter.setRangeStart(rangeStart);
          }
          if (!this._adapter.isAnotherPanelHasOpened('rangeEnd') || !rangeStart) {
            this._adapter.setRangeInputFocus('rangeStart');
          }
        } else if (rangeInputFocus === 'rangeStart' || !rangeInputFocus) {
          this._adapter.setRangeStart(rangeStart);
          if (rangeEndReset) {
            this._adapter.setRangeEnd(rangeEnd);
          }
          if (!this._adapter.isAnotherPanelHasOpened('rangeStart') || !rangeEnd) {
            this._adapter.setRangeInputFocus('rangeEnd');
          }
        }
      }
    }
    const dateFormat = this.getValidDateFormat();
    // only notify when choose completed
    if (rangeStart || rangeEnd) {
      const [startDate, endDate] = [compatibleParse(rangeStart, dateFormat, undefined, dateFnsLocale), compatibleParse(rangeEnd, dateFormat, undefined, dateFnsLocale)];
      let date = [startDate, endDate];
      // If the type is dateRangeTime, add the value of time
      if (type === 'dateTimeRange') {
        const startTime = this.getState('monthLeft').pickerDate;
        const endTime = this.getState('monthRight').pickerDate;
        const start = rangeStart ? this._mergeDateAndTime(rangeStart, startTime) : null;
        const end = rangeEnd ? this._mergeDateAndTime(rangeEnd, endTime) : null;
        if (isSameDay(startDate, endDate) && isBefore_isBefore(end, start)) {
          date = [start, start];
        } else {
          date = [start, end];
        }
      }
      /**
       * no need to check focus then
       *  - dateRange and isDateRangeAndHasOffset
       */
      const needCheckFocusRecord = !(type === 'dateRange' && isDateRangeAndHasOffset);
      this._adapter.notifySelectedChange(date, {
        needCheckFocusRecord
      });
    }
  }
  _isNeedSwap(rangeStart, rangeEnd) {
    // Check whether the start and end are reasonable and whether they need to be reversed
    return rangeStart && rangeEnd && isBefore_isBefore(rangeEnd, rangeStart);
  }
  /**
   * Day may be empty, this is unhover state
   * @param {*} day
   */
  handleDayHover() {
    let day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      fullDate: ''
    };
    let panelType = arguments.length > 1 ? arguments[1] : undefined;
    const {
      fullDate
    } = day;
    const {
      startDateOffset,
      endDateOffset,
      type
    } = this.getProps();
    this._adapter.setHoverDay(fullDate);
    if ((startDateOffset || endDateOffset) && type === 'dateRange') {
      const offsetRangeStart = _utils_getFullDateOffset(startDateOffset, fullDate);
      const offsetRangeEnd = _utils_getFullDateOffset(endDateOffset, fullDate);
      this._adapter.setOffsetRangeStart(offsetRangeStart);
      this._adapter.setOffsetRangeEnd(offsetRangeEnd);
    }
  }
  // Guarantee that monthLeft, monthRight will not appear in the same month or monthLeft is greater than MonthRight
  _autoAdjustMonth(monthLeft, monthRight) {
    let newMonthLeft = monthLeft;
    let newMonthRight = monthRight;
    const difference = differenceInCalendarMonths(monthLeft.pickerDate, monthRight.pickerDate);
    if (difference > 0) {
      // The month on the left is larger than the month on the right, swap
      newMonthLeft = Object.assign({}, monthRight);
      newMonthRight = Object.assign({}, monthLeft);
    } else if (difference === 0) {
      // Around the same month, the number of months on the right + 1
      newMonthLeft = monthLeft;
      newMonthRight = Object.assign(Object.assign({}, monthRight), {
        pickerDate: addMonths(monthRight.pickerDate, 1)
      });
    }
    return {
      monthLeft: newMonthLeft,
      monthRight: newMonthRight
    };
  }
  getValidTimeFormat() {
    const formatProp = this.getProp('format') || datePicker_constants_strings.FORMAT_TIME_PICKER;
    const timeFormatTokens = [];
    if (includes_default()(formatProp, 'h') || includes_default()(formatProp, 'H')) {
      timeFormatTokens.push('HH');
    }
    if (includes_default()(formatProp, 'm')) {
      timeFormatTokens.push('mm');
    }
    if (includes_default()(formatProp, 's')) {
      timeFormatTokens.push('ss');
    }
    return timeFormatTokens.join(':');
  }
  getValidDateFormat() {
    return this.getProp('format') || _utils_getDefaultFormatToken(this.getProp('type'));
  }
  handleTimeChange(newTime, panelType) {
    const {
      rangeEnd,
      rangeStart
    } = this.getStates();
    const dateFnsLocale = this.getProp('dateFnsLocale');
    const ts = newTime.timeStampValue;
    const type = this.getProp('type');
    const panelDetail = this._getPanelDetail(panelType);
    const {
      showDate
    } = panelDetail;
    const timeDate = new Date(ts);
    const dateFormat = this.getValidDateFormat();
    const destRange = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT ? rangeEnd : rangeStart;
    let year, monthNo, date;
    // if (pickerDate && isValidDate(pickerDate)) {
    //     year = pickerDate.getFullYear();
    //     monthNo = pickerDate.getMonth();
    //     date = pickerDate.getDate();
    // } else
    if (type === 'dateTimeRange' && destRange) {
      const rangeDate = compatibleParse(destRange, dateFormat, undefined, dateFnsLocale);
      year = rangeDate.getFullYear();
      monthNo = rangeDate.getMonth();
      date = rangeDate.getDate();
    } else {
      year = showDate.getFullYear();
      monthNo = showDate.getMonth();
      date = showDate.getDate();
    }
    const hours = timeDate.getHours();
    const minutes = timeDate.getMinutes();
    const seconds = timeDate.getSeconds();
    const milSeconds = timeDate.getMilliseconds();
    const dateArgs = [year, monthNo, date, hours, minutes, seconds, milSeconds];
    const fullValidDate = new Date(...dateArgs);
    if (type === 'dateTimeRange') {
      this.handleShowDateAndTime(panelType, fullValidDate, showDate);
      this._updateTimeInDateRange(panelType, fullValidDate);
    } else {
      const fullDate = formatFullDate(year, monthNo + 1, date);
      this.handleDateSelected({
        fullDate,
        fullValidDate
      }, panelType);
      this.handleShowDateAndTime(panelType, fullValidDate);
      this._adapter.notifySelectedChange([fullValidDate]);
    }
  }
  /**
   * Update the time part in the range
   * @param {string} panelType
   * @param {Date} timeDate
   */
  _updateTimeInDateRange(panelType, timeDate) {
    const {
      isControlledComponent,
      dateFnsLocale
    } = this.getProps();
    let rangeStart = this.getState('rangeStart');
    let rangeEnd = this.getState('rangeEnd');
    const dateFormat = this.getValidDateFormat();
    // TODO: Modify a time individually
    if (rangeStart && rangeEnd) {
      let startDate = compatibleParse(rangeStart, dateFormat, undefined, dateFnsLocale);
      let endDate = compatibleParse(rangeEnd, dateFormat, undefined, dateFnsLocale);
      // console.log('_updateTimeInDateRange()', rangeStart, rangeEnd, startDate, endDate);
      if (panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT) {
        endDate = this._mergeDateAndTime(timeDate, timeDate);
        rangeEnd = format_format(endDate, datePicker_constants_strings.FORMAT_DATE_TIME);
        if (this._isNeedSwap(rangeStart, rangeEnd)) {
          [rangeStart, rangeEnd] = [rangeEnd, rangeStart];
          [startDate, endDate] = [endDate, startDate];
        }
        if (!isControlledComponent) {
          this._adapter.setRangeEnd(rangeEnd);
        }
      } else {
        startDate = this._mergeDateAndTime(timeDate, timeDate);
        rangeStart = format_format(startDate, datePicker_constants_strings.FORMAT_DATE_TIME);
        if (this._isNeedSwap(rangeStart, rangeEnd)) {
          [rangeStart, rangeEnd] = [rangeEnd, rangeStart];
          [startDate, endDate] = [endDate, startDate];
        }
        if (!isControlledComponent) {
          this._adapter.setRangeStart(rangeStart);
        }
      }
      // console.log('_updateTimeInDateRange()', rangeStart, rangeEnd, startDate, endDate);
      this._adapter.notifySelectedChange([startDate, endDate]);
    }
  }
  _updatePanelDetail(panelType, kvs) {
    const {
      monthLeft,
      monthRight
    } = this.getStates();
    if (panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT) {
      this._adapter.updateMonthOnRight(Object.assign(Object.assign({}, monthRight), kvs));
    } else {
      this._adapter.updateMonthOnLeft(Object.assign(Object.assign({}, monthLeft), kvs));
    }
  }
  showYearPicker(panelType) {
    this._updatePanelDetail(panelType, {
      isTimePickerOpen: false,
      isYearPickerOpen: true
    });
  }
  showTimePicker(panelType, opt) {
    if (this.getProp('disabledTimePicker')) {
      return;
    }
    this._updatePanelDetail(panelType, {
      isTimePickerOpen: true,
      isYearPickerOpen: false
    });
  }
  showDatePanel(panelType) {
    this._updatePanelDetail(panelType, {
      isTimePickerOpen: false,
      isYearPickerOpen: false
    });
  }
  /**
   * Get year and month panel open type
   *
   * It is useful info to set minHeight of weeks.
   *  - When yam open type is 'left' or 'right', weeks minHeight should be set
   *    If the minHeight is not set, the change of the number of weeks will cause the scrollList to be unstable
   */
  getYAMOpenType() {
    const {
      monthLeft,
      monthRight
    } = this._adapter.getStates();
    const leftYearPickerOpen = monthLeft.isYearPickerOpen;
    const rightYearPickerOpen = monthRight.isYearPickerOpen;
    if (leftYearPickerOpen && rightYearPickerOpen) {
      return 'both';
    } else if (leftYearPickerOpen) {
      return 'left';
    } else if (rightYearPickerOpen) {
      return 'right';
    } else {
      return 'none';
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconDoubleChevronLeft.js


function IconDoubleChevronLeft_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6185 4.39653C13.1272 4.92524 13.1272 5.78245 12.6185 6.31116L7.14483 12L12.6185 17.6888C13.1272 18.2176 13.1272 19.0748 12.6185 19.6035C12.1098 20.1322 11.285 20.1322 10.7763 19.6035L4.38153 12.9573C3.87282 12.4286 3.87282 11.5714 4.38153 11.0427L10.7763 4.39653C11.285 3.86782 12.1098 3.86782 12.6185 4.39653Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6185 4.39653C20.1272 4.92524 20.1272 5.78245 19.6185 6.31116L14.1448 12L19.6185 17.6888C20.1272 18.2176 20.1272 19.0748 19.6185 19.6035C19.1098 20.1322 18.285 20.1322 17.7763 19.6035L11.3815 12.9573C10.8728 12.4286 10.8728 11.5714 11.3815 11.0427L17.7763 4.39653C18.285 3.86782 19.1098 3.86782 19.6185 4.39653Z",
    fill: "currentColor"
  }));
}
const IconDoubleChevronLeft_IconComponent = (0,Icon/* convertIcon */.A)(IconDoubleChevronLeft_SvgComponent, 'double_chevron_left');
/* harmony default export */ var IconDoubleChevronLeft = (IconDoubleChevronLeft_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconDoubleChevronRight.js


function IconDoubleChevronRight_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38153 4.39653C4.89024 3.86782 5.71502 3.86782 6.22373 4.39653L12.6185 11.0427C13.1272 11.5714 13.1272 12.4286 12.6185 12.9573L6.22373 19.6035C5.71502 20.1322 4.89024 20.1322 4.38153 19.6035C3.87282 19.0748 3.87282 18.2176 4.38153 17.6888L9.85517 12L4.38153 6.31116C3.87282 5.78245 3.87282 4.92524 4.38153 4.39653Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3815 4.39653C11.8902 3.86782 12.715 3.86782 13.2237 4.39653L19.6185 11.0427C20.1272 11.5714 20.1272 12.4286 19.6185 12.9573L13.2237 19.6035C12.715 20.1322 11.8902 20.1322 11.3815 19.6035C10.8728 19.0748 10.8728 18.2176 11.3815 17.6888L16.8552 12L11.3815 6.31116C10.8728 5.78245 10.8728 4.92524 11.3815 4.39653Z",
    fill: "currentColor"
  }));
}
const IconDoubleChevronRight_IconComponent = (0,Icon/* convertIcon */.A)(IconDoubleChevronRight_SvgComponent, 'double_chevron_right');
/* harmony default export */ var IconDoubleChevronRight = (IconDoubleChevronRight_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/navigation.js


// import cls from 'classnames';





const navigation_prefixCls = datePicker_constants_cssClasses.NAVIGATION;
class Navigation extends react.PureComponent {
  constructor(props) {
    super(props);
    this.navRef = /*#__PURE__*/react.createRef();
  }
  render() {
    const {
      forwardRef,
      monthText,
      onMonthClick,
      onNextMonth,
      onPrevMonth,
      onPrevYear,
      onNextYear,
      density,
      shouldBimonthSwitch,
      panelType
    } = this.props;
    const btnTheme = 'borderless';
    const iconBtnSize = density === 'compact' ? 'default' : 'large';
    const btnNoHorizontalPadding = true;
    const buttonSize = density === 'compact' ? 'small' : 'default';
    const isLeftPanel = panelType === datePicker_constants_strings.PANEL_TYPE_LEFT;
    const isRightPanel = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT;
    // syncSwitchMonth and the current panel is the left
    const hiddenLeftPanelRightButtons = shouldBimonthSwitch && isLeftPanel;
    // syncSwitchMonth and the current panel is the right
    const hiddenRightPanelLeftButtons = shouldBimonthSwitch && isRightPanel;
    // `visibility: hidden` will keep the icon in position
    const leftButtonStyle = {};
    const rightButtonStyle = {};
    if (hiddenRightPanelLeftButtons) {
      leftButtonStyle.visibility = 'hidden';
    }
    if (hiddenLeftPanelRightButtons) {
      rightButtonStyle.visibility = 'hidden';
    }
    const ref = forwardRef || this.navRef;
    return /*#__PURE__*/react.createElement("div", {
      className: navigation_prefixCls,
      ref: ref
    }, /*#__PURE__*/react.createElement(iconButton, {
      key: "double-chevron-left",
      "aria-label": "Previous year",
      icon: /*#__PURE__*/react.createElement(IconDoubleChevronLeft, {
        "aria-hidden": true,
        size: iconBtnSize
      }),
      size: buttonSize,
      theme: btnTheme,
      noHorizontalPadding: btnNoHorizontalPadding,
      onClick: onPrevYear,
      style: leftButtonStyle
    }), /*#__PURE__*/react.createElement(iconButton, {
      key: "chevron-left",
      "aria-label": "Previous month",
      icon: /*#__PURE__*/react.createElement(IconChevronLeft/* default */.Z, {
        "aria-hidden": true,
        size: iconBtnSize
      }),
      size: buttonSize,
      onClick: onPrevMonth,
      theme: btnTheme,
      noHorizontalPadding: btnNoHorizontalPadding,
      style: leftButtonStyle
    }), /*#__PURE__*/react.createElement("div", {
      className: `${navigation_prefixCls}-month`
    }, /*#__PURE__*/react.createElement(es_button, {
      onClick: onMonthClick,
      theme: btnTheme,
      size: buttonSize
    }, /*#__PURE__*/react.createElement("span", null, monthText))), /*#__PURE__*/react.createElement(iconButton, {
      key: "chevron-right",
      "aria-label": "Next month",
      icon: /*#__PURE__*/react.createElement(IconChevronRight, {
        "aria-hidden": true,
        size: iconBtnSize
      }),
      size: buttonSize,
      onClick: onNextMonth,
      theme: btnTheme,
      noHorizontalPadding: btnNoHorizontalPadding,
      style: rightButtonStyle
    }), /*#__PURE__*/react.createElement(iconButton, {
      key: "double-chevron-right",
      "aria-label": "Next year",
      icon: /*#__PURE__*/react.createElement(IconDoubleChevronRight, {
        "aria-hidden": true,
        size: iconBtnSize
      }),
      size: buttonSize,
      theme: btnTheme,
      noHorizontalPadding: btnNoHorizontalPadding,
      onClick: onNextYear,
      style: rightButtonStyle
    }));
  }
}
Navigation.propTypes = {
  monthText: (prop_types_default()).string,
  density: (prop_types_default()).string,
  onMonthClick: (prop_types_default()).func,
  onNextMonth: (prop_types_default()).func,
  onPrevMonth: (prop_types_default()).func,
  onNextYear: (prop_types_default()).func,
  onPrevYear: (prop_types_default()).func,
  navPrev: (prop_types_default()).node,
  navNext: (prop_types_default()).node,
  // Whether to switch synchronously for two panels
  shouldBimonthSwitch: (prop_types_default()).bool,
  // Panel type, divided into left panel and right panel
  panelType: prop_types_default().oneOf([datePicker_constants_strings.PANEL_TYPE_LEFT, datePicker_constants_strings.PANEL_TYPE_RIGHT])
};
Navigation.defaultProps = {
  monthText: '',
  onMonthClick: (noop_default()),
  onNextMonth: (noop_default()),
  onPrevMonth: (noop_default()),
  onNextYear: (noop_default()),
  onPrevYear: (noop_default())
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getDayOfWeek.js
/**
 *
 * @param {number} weekStartsOn
 * the index of the first day of the week （0-Sunday，1-Monday, etc）
 *
 */
const getDayofWeek = _ref => {
  let {
    weekStartsOn = 0
  } = _ref;
  const weekDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  for (let index = 0; index < weekStartsOn; index++) {
    weekDay.push(weekDay.shift());
  }
  return weekDay;
};
/* harmony default export */ var getDayOfWeek = (getDayofWeek);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/monthFoundation.js

// import { cssClasses, strings } from './constants';




class CalendarMonthFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    this._getToday();
    this.getMonthTable();
  }
  _getToday() {
    const today = new Date();
    const todayText = format_format(today, 'yyyy-MM-dd');
    this._adapter.updateToday(todayText);
  }
  getMonthTable() {
    const month = this._adapter.getProp('month');
    const weeksRowNum = this.getState('weeksRowNum');
    if (month) {
      this.updateWeekDays();
      const weekStartsOn = this._adapter.getProp('weekStartsOn');
      const monthTable = _utils_getMonthTable(month, weekStartsOn);
      const {
        weeks
      } = monthTable;
      this._adapter.updateMonthTable(monthTable);
      if (isNullOrUndefined(weeksRowNum)) {
        this._adapter.setWeeksRowNum(weeks.length);
      } else if (Array.isArray(weeks) && weeks.length !== weeksRowNum) {
        this._adapter.setWeeksRowNum(weeks.length, () => {
          this._adapter.notifyWeeksRowNumChange(weeks.length);
        });
      }
    }
  }
  updateWeekDays() {
    const weekStartsOn = this._adapter.getProp('weekStartsOn');
    const weekdays = getDayOfWeek({
      weekStartsOn
    });
    this._adapter.setWeekDays(weekdays);
  }
  destroy() {}
  handleClick(day) {
    this._adapter.notifyDayClick(day);
  }
  handleHover(day) {
    this._adapter.notifyDayHover(day);
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter_isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var dateToCompare = toDate_toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isAfter.js


function _utils_isAfter_isAfter(date, dateToCompare) {
  const dayOne = utils_isString(date) ? parseISO(date) : date;
  const dayTwo = utils_isString(dateToCompare) ? parseISO(dateToCompare) : dateToCompare;
  return isAfter_isAfter(dayOne, dayTwo);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isSameDay.js


function isSameDay_isSameDay(date, dateToCompare) {
  const dayOne = utils_isString(date) ? parseISO(date) : date;
  const dayTwo = utils_isString(dateToCompare) ? parseISO(dateToCompare) : dateToCompare;
  return isSameDay(dayOne, dayTwo);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate_toDate(dirtyDate).getTime();
  var startTime = toDate_toDate(interval.start).getTime();
  var endTime = toDate_toDate(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/isBetween.js


/**
 * is the date between start and end?(not including start and end)
 *   - if start > end, return false
 * @param {String|Date} day
 * @param {Object} { start: string|Date, end: string|Date}
 * @returns {Boolean}
 */
function isBetween(day, _ref) {
  let {
    start,
    end
  } = _ref;
  const d = utils_isString(day) ? parseISO(day) : day;
  const s = utils_isString(start) ? parseISO(start) : start;
  const e = utils_isString(end) ? parseISO(end) : end;
  return isBefore(s, e) && isWithinInterval(d, {
    start: s,
    end: e
  }) && !isEqual_isEqual(d, s) && !isEqual_isEqual(d, e);
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/month.js



/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */








const month_prefixCls = datePicker_constants_cssClasses.PREFIX;
class Month extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      weekdays: [],
      month: {
        weeks: [],
        monthText: ''
      },
      todayText: '',
      weeksRowNum: props.weeksRowNum
    };
    this.monthRef = /*#__PURE__*/react.createRef();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      updateToday: todayText => this.setState({
        todayText
      }),
      setWeekDays: weekdays => this.setState({
        weekdays
      }),
      setWeeksRowNum: (weeksRowNum, callback) => this.setState({
        weeksRowNum
      }, callback),
      updateMonthTable: month => this.setState({
        month
      }),
      notifyDayClick: day => this.props.onDayClick(day),
      notifyDayHover: day => this.props.onDayHover(day),
      notifyWeeksRowNumChange: weeksRowNum => this.props.onWeeksRowNumChange(weeksRowNum)
    });
  }
  componentDidMount() {
    this.foundation = new CalendarMonthFoundation(this.adapter);
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.month !== this.props.month) {
      this.foundation.getMonthTable();
    }
  }
  getSingleDayStatus(options) {
    const {
      rangeInputFocus
    } = this.props;
    const {
      fullDate,
      todayText,
      selected,
      disabledDate,
      rangeStart,
      rangeEnd
    } = options;
    const disabledOptions = {
      rangeStart,
      rangeEnd,
      rangeInputFocus
    };
    const isToday = fullDate === todayText;
    const isSelected = selected.has(fullDate);
    let isDisabled = disabledDate && disabledDate(parseISO(fullDate), disabledOptions);
    if (!isDisabled && this.props.rangeInputFocus === 'rangeStart' && rangeEnd && this.props.focusRecordsRef && this.props.focusRecordsRef.current.rangeEnd) {
      // The reason for splitting is that the dateRangeTime format: 'yyyy-MM-dd HH:MM:SS'
      isDisabled = _utils_isAfter_isAfter(fullDate, rangeEnd.trim().split(/\s+/)[0]);
    }
    if (!isDisabled && this.props.rangeInputFocus === 'rangeEnd' && rangeStart && this.props.focusRecordsRef && this.props.focusRecordsRef.current.rangeStart) {
      // The reason for splitting is that the dateRangeTime format: 'yyyy-MM-dd HH:MM:SS'
      isDisabled = isBefore_isBefore(fullDate, rangeStart.trim().split(/\s+/)[0]);
    }
    return {
      isToday,
      isSelected,
      isDisabled // Disabled
    };
  }

  getDateRangeStatus(options) {
    const {
      rangeStart,
      rangeEnd,
      fullDate,
      hoverDay,
      offsetRangeStart,
      offsetRangeEnd,
      rangeInputFocus
    } = options;
    // If no item is selected, return the empty object directly
    const _isDateRangeAnySelected = Boolean(rangeStart || rangeEnd);
    const _isDateRangeSelected = Boolean(rangeStart && rangeEnd);
    const _isOffsetDateRangeAnyExist = offsetRangeStart || offsetRangeEnd;
    if (!_isDateRangeAnySelected) {
      return {};
    }
    // The range selects the hover date, and the normal hover is .semi-datepicker-main: hover
    const _isHoverDay = isSameDay_isSameDay(hoverDay, fullDate);
    // When one is selected
    let _isHoverAfterStart, _isHoverBeforeEnd, isSelectedStart, isSelectedEnd, isHoverDayAroundOneSelected;
    if (rangeStart) {
      isSelectedStart = isSameDay_isSameDay(fullDate, rangeStart);
      if (rangeInputFocus === 'rangeEnd') {
        _isHoverAfterStart = isBetween(fullDate, {
          start: rangeStart,
          end: hoverDay
        });
      }
    }
    if (rangeEnd) {
      isSelectedEnd = isSameDay_isSameDay(fullDate, rangeEnd);
      if (rangeInputFocus === 'rangeStart') {
        _isHoverBeforeEnd = isBetween(fullDate, {
          start: hoverDay,
          end: rangeEnd
        });
      }
    }
    if (!_isDateRangeSelected && _isDateRangeAnySelected) {
      isHoverDayAroundOneSelected = _isHoverDay;
    }
    let isHover;
    if (!_isOffsetDateRangeAnyExist) {
      isHover = _isHoverAfterStart || _isHoverBeforeEnd || _isHoverDay;
    }
    // Select all
    let isInRange, isSelectedStartAfterHover, isSelectedEndBeforeHover, isHoverDayInStartSelection, isHoverDayInEndSelection, isHoverDayInRange;
    if (_isDateRangeSelected) {
      isInRange = isBetween(fullDate, {
        start: rangeStart,
        end: rangeEnd
      });
      if (!_isOffsetDateRangeAnyExist) {
        isSelectedStartAfterHover = isSelectedStart && _utils_isAfter_isAfter(rangeStart, hoverDay);
        isSelectedEndBeforeHover = isSelectedEnd && isBefore_isBefore(rangeEnd, hoverDay);
        isHoverDayInStartSelection = _isHoverDay && rangeInputFocus === 'rangeStart';
        isHoverDayInEndSelection = _isHoverDay && rangeInputFocus === 'rangeEnd';
        isHoverDayInRange = _isHoverDay && isBetween(hoverDay, {
          start: rangeStart,
          end: rangeEnd
        });
      }
    }
    return {
      isHoverDay: _isHoverDay,
      isSelectedStart,
      isSelectedEnd,
      isInRange,
      isHover,
      isSelectedStartAfterHover,
      isSelectedEndBeforeHover,
      isHoverDayInRange,
      isHoverDayInStartSelection,
      isHoverDayInEndSelection,
      isHoverDayAroundOneSelected // Hover date and select a date
    };
  }

  getOffsetDateStatus(options) {
    const {
      offsetRangeStart,
      offsetRangeEnd,
      rangeStart,
      rangeEnd,
      fullDate,
      hoverDay
    } = options;
    // When there is no offset, return the empty object directly
    const _isOffsetDateRangeNull = !(offsetRangeStart || offsetRangeEnd);
    if (_isOffsetDateRangeNull) {
      return {};
    }
    // Range Select base date
    const _isInRange = isBetween(fullDate, {
      start: rangeStart,
      end: rangeEnd
    });
    const _isHoverDay = isSameDay_isSameDay(hoverDay, fullDate);
    const _isSelectedStart = rangeStart && isSameDay_isSameDay(fullDate, rangeStart);
    const _isSelectedEnd = rangeEnd && isSameDay_isSameDay(fullDate, rangeEnd);
    const _isDateRangeSelected = Boolean(rangeStart && rangeEnd);
    // Determine whether it is offsetStart or offsetRangeEnd
    const isOffsetRangeStart = isSameDay_isSameDay(fullDate, offsetRangeStart);
    const isOffsetRangeEnd = isSameDay_isSameDay(fullDate, offsetRangeEnd);
    const isHoverDayOffset = _isHoverDay;
    // When selected
    let isHoverInOffsetRange, isInOffsetRange;
    if (_isDateRangeSelected) {
      isHoverInOffsetRange = _isInRange && _isHoverDay;
    }
    // When there is an offset area
    const _isOffsetDateRangeSelected = Boolean(offsetRangeStart && offsetRangeEnd);
    if (_isOffsetDateRangeSelected) {
      isInOffsetRange = _isSelectedStart || isBetween(fullDate, {
        start: offsetRangeStart,
        end: offsetRangeEnd
      }) || _isSelectedEnd;
    }
    return {
      isOffsetRangeStart,
      isOffsetRangeEnd,
      isHoverInOffsetRange,
      isHoverDayOffset,
      isInOffsetRange // Include start and end within the week selection (start and end styles are the same as other dates, so start and end are included)
    };
  }
  /**
   * get day current status
   * @param {Object} fullDate
   * @param {Object} options
   * @returns {Object}
   */
  getDayStatus(currentDay, options) {
    const {
      fullDate
    } = currentDay;
    const {
      hoverDay,
      rangeStart,
      rangeEnd,
      todayText,
      offsetRangeStart,
      offsetRangeEnd,
      disabledDate,
      selected,
      rangeInputFocus
    } = options;
    const singleDayStatus = this.getSingleDayStatus({
      fullDate,
      todayText,
      hoverDay,
      selected,
      disabledDate,
      rangeStart,
      rangeEnd
    });
    const dateRangeStatus = this.getDateRangeStatus(Object.assign({
      fullDate,
      rangeStart,
      rangeEnd,
      hoverDay,
      offsetRangeStart,
      offsetRangeEnd,
      rangeInputFocus
    }, singleDayStatus));
    const offsetDataStatus = this.getOffsetDateStatus(Object.assign(Object.assign({
      offsetRangeStart,
      offsetRangeEnd,
      rangeStart,
      rangeEnd,
      fullDate,
      hoverDay
    }, singleDayStatus), dateRangeStatus));
    // this parameter will pass to the user when given renderFullDate function, do not delete or modify its key
    const dayStatus = Object.assign(Object.assign(Object.assign({}, singleDayStatus), dateRangeStatus), offsetDataStatus);
    return dayStatus;
  }
  renderDayOfWeek() {
    const {
      locale
    } = this.props;
    const weekdayCls = classnames_default()(datePicker_constants_cssClasses.WEEKDAY);
    const weekdayItemCls = classnames_default()(`${month_prefixCls}-weekday-item`);
    const {
      weekdays
    } = this.state;
    // i18n
    const weekdaysText = weekdays.map(key => locale.weeks[key]);
    return /*#__PURE__*/react.createElement("div", {
      role: "row",
      className: weekdayCls
    }, weekdaysText.map((E, i) => /*#__PURE__*/react.createElement("div", {
      role: "columnheader",
      key: E + i,
      className: weekdayItemCls
    }, E)));
  }
  renderWeeks() {
    const {
      month
    } = this.state;
    const {
      weeks
    } = month;
    const {
      weeksRowNum
    } = this.props;
    let style = {};
    if (weeksRowNum) {
      const height = weeksRowNum * datePicker_constants_numbers.WEEK_HEIGHT;
      style = {
        height
      };
    }
    const weeksCls = classnames_default()(datePicker_constants_cssClasses.WEEKS);
    return /*#__PURE__*/react.createElement("div", {
      className: weeksCls,
      style: style
    }, weeks.map((week, weekIndex) => this.renderWeek(week, weekIndex)));
  }
  renderWeek(week, weekIndex) {
    const weekCls = datePicker_constants_cssClasses.WEEK;
    return /*#__PURE__*/react.createElement("div", {
      role: "row",
      className: weekCls,
      key: weekIndex
    }, week.map((day, dayIndex) => this.renderDay(day, dayIndex)));
  }
  renderDay(day, dayIndex) {
    const {
      todayText
    } = this.state;
    const {
      renderFullDate,
      renderDate
    } = this.props;
    const {
      fullDate,
      dayNumber
    } = day;
    if (!fullDate) {
      return /*#__PURE__*/react.createElement("div", {
        role: "gridcell",
        tabIndex: -1,
        key: dayNumber + dayIndex,
        className: datePicker_constants_cssClasses.DAY
      }, /*#__PURE__*/react.createElement("span", null));
    }
    const dayStatus = this.getDayStatus(day, Object.assign({
      todayText
    }, this.props));
    const dayCls = classnames_default()(datePicker_constants_cssClasses.DAY, {
      [datePicker_constants_cssClasses.DAY_TODAY]: dayStatus.isToday,
      [datePicker_constants_cssClasses.DAY_IN_RANGE]: dayStatus.isInRange,
      [datePicker_constants_cssClasses.DAY_HOVER]: dayStatus.isHover,
      [datePicker_constants_cssClasses.DAY_SELECTED]: dayStatus.isSelected,
      [datePicker_constants_cssClasses.DAY_SELECTED_START]: dayStatus.isSelectedStart,
      [datePicker_constants_cssClasses.DAY_SELECTED_END]: dayStatus.isSelectedEnd,
      [datePicker_constants_cssClasses.DAY_DISABLED]: dayStatus.isDisabled,
      // offsetDate class
      [datePicker_constants_cssClasses.DAY_HOVER_DAY]: dayStatus.isHoverDayOffset,
      [datePicker_constants_cssClasses.DAY_IN_OFFSET_RANGE]: dayStatus.isInOffsetRange,
      [datePicker_constants_cssClasses.DAY_SELECTED_RANGE_HOVER]: dayStatus.isHoverInOffsetRange,
      [datePicker_constants_cssClasses.DAY_OFFSET_RANGE_START]: dayStatus.isOffsetRangeStart,
      [datePicker_constants_cssClasses.DAY_OFFSET_RANGE_END]: dayStatus.isOffsetRangeEnd,
      // range input class
      [datePicker_constants_cssClasses.DAY_SELECTED_START_AFTER_HOVER]: dayStatus.isSelectedStartAfterHover,
      [datePicker_constants_cssClasses.DAY_SELECTED_END_BEFORE_HOVER]: dayStatus.isSelectedEndBeforeHover,
      [datePicker_constants_cssClasses.DAY_HOVER_DAY_BEFORE_RANGE]: dayStatus.isHoverDayInStartSelection,
      [datePicker_constants_cssClasses.DAY_HOVER_DAY_AFTER_RANGE]: dayStatus.isHoverDayInEndSelection,
      [datePicker_constants_cssClasses.DAY_HOVER_DAY_AROUND_SINGLE_SELECTED]: dayStatus.isHoverDayAroundOneSelected
    });
    const dayMainCls = classnames_default()({
      [`${datePicker_constants_cssClasses.DAY}-main`]: true
    });
    const fullDateArgs = [dayNumber, fullDate, dayStatus];
    const customRender = isFunction_default()(renderFullDate);
    return /*#__PURE__*/react.createElement("div", {
      role: "gridcell",
      tabIndex: dayStatus.isDisabled ? -1 : 0,
      "aria-disabled": dayStatus.isDisabled,
      "aria-selected": dayStatus.isSelected,
      "aria-label": fullDate,
      className: !customRender ? dayCls : datePicker_constants_cssClasses.DAY,
      title: fullDate,
      key: dayNumber + dayIndex,
      onClick: e => !dayStatus.isDisabled && this.foundation.handleClick(day),
      onMouseEnter: () => this.foundation.handleHover(day),
      onMouseLeave: () => this.foundation.handleHover()
    }, customRender ? renderFullDate(...fullDateArgs) : /*#__PURE__*/react.createElement("div", {
      className: dayMainCls
    }, isFunction_default()(renderDate) ? renderDate(dayNumber, fullDate) : /*#__PURE__*/react.createElement("span", null, dayNumber)));
  }
  render() {
    const {
      forwardRef,
      multiple
    } = this.props;
    const weekday = this.renderDayOfWeek();
    const weeks = this.renderWeeks();
    const monthCls = classnames_default()(datePicker_constants_cssClasses.MONTH);
    const ref = forwardRef || this.monthRef;
    return /*#__PURE__*/react.createElement("div", {
      role: "grid",
      "aria-multiselectable": multiple,
      ref: ref,
      className: monthCls
    }, weekday, weeks);
  }
}
Month.propTypes = {
  month: (prop_types_default()).object,
  selected: (prop_types_default()).object,
  rangeStart: (prop_types_default()).string,
  rangeEnd: (prop_types_default()).string,
  offsetRangeStart: (prop_types_default()).string,
  offsetRangeEnd: (prop_types_default()).string,
  onDayClick: (prop_types_default()).func,
  onDayHover: (prop_types_default()).func,
  weekStartsOn: (prop_types_default()).number,
  disabledDate: (prop_types_default()).func,
  weeksRowNum: (prop_types_default()).number,
  onWeeksRowNumChange: (prop_types_default()).func,
  renderDate: (prop_types_default()).func,
  renderFullDate: (prop_types_default()).func,
  hoverDay: (prop_types_default()).string,
  startDateOffset: (prop_types_default()).func,
  endDateOffset: (prop_types_default()).func,
  rangeInputFocus: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).bool]),
  focusRecordsRef: (prop_types_default()).object,
  multiple: (prop_types_default()).bool
};
Month.defaultProps = {
  month: new Date(),
  selected: new Set(),
  rangeStart: '',
  rangeEnd: '',
  onDayClick: (noop_default()),
  onDayHover: (noop_default()),
  onWeeksRowNumChange: (noop_default()),
  weekStartsOn: datePicker_constants_numbers.WEEK_START_ON,
  disabledDate: (stubFalse_default()),
  weeksRowNum: 0
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/timePicker/constants.js


const TYPE_TIME_PICKER = 'time';
const TYPE_TIME_RANGE_PICKER = 'timeRange';
const DEFAULT_RANGE_SEPARATOR = ' ~ ';
const DEFAULT_MULTIPLE_SEPARATOR = ',';
const timePicker_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-timepicker`,
  RANGE_PICKER: `${BASE_CLASS_PREFIX}-timepicker-range-panel`,
  RANGE_PANEL_LISTS: `${BASE_CLASS_PREFIX}-timepicker-lists`
};
const timePicker_constants_strings = {
  TYPES: [TYPE_TIME_PICKER, TYPE_TIME_RANGE_PICKER],
  TYPE_TIME_PICKER,
  TYPE_TIME_RANGE_PICKER,
  DEFAULT_TYPE: TYPE_TIME_PICKER,
  DEFAULT_RANGE_SEPARATOR,
  DEFAULT_MULTIPLE_SEPARATOR,
  SIZE: input_constants_strings.SIZE,
  DEFAULT_FORMAT: 'HH:mm:ss',
  DEFAULT_FORMAT_A: 'a h:mm:ss',
  STATUS: VALIDATE_STATUS,
  DEFAULT_POSITION: {
    [TYPE_TIME_PICKER]: 'bottomLeft',
    [TYPE_TIME_RANGE_PICKER]: 'bottomLeft'
  }
};
const timePicker_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/scrollList/constants.js

const scrollList_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-scrolllist`,
  SELECTED: `${BASE_CLASS_PREFIX}-scrolllist-item-selected`
};
const scrollList_constants_strings = {
  MODE: ['normal', 'wheel']
};
const scrollList_constants_numbers = {
  DEFAULT_ITEM_HEIGHT: 36,
  DEFAULT_SCROLL_DURATION: 120
};

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var lodash_findIndex = __webpack_require__(30998);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(lodash_findIndex);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(35161);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(13311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/lodash/slice.js
var slice = __webpack_require__(12571);
var slice_default = /*#__PURE__*/__webpack_require__.n(slice);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/scrollList/itemFoundation.js






class ItemFoundation extends foundation {
  constructor() {
    super(...arguments);
    this._cachedSelectedNode = null;
  }
  selectIndex(index, listWrapper) {
    const {
      type,
      list
    } = this.getProps();
    if (index > -1 && Array.isArray(list) && list.length && isElement(listWrapper)) {
      const indexInData = index % list.length;
      const item = list[indexInData];
      const node = listWrapper.children[index];
      this._adapter.setSelectedNode(node);
      this._adapter.notifySelectItem(Object.assign(Object.assign({}, item), {
        value: item.value,
        type,
        index: indexInData
      }));
    }
  }
  selectNode(node, listWrapper) {
    const {
      type,
      list: data
    } = this.getProps();
    if (isElement(node) && isElement(listWrapper)) {
      const indexInList = findIndex_default()(listWrapper.children, ele => ele === node);
      const indexInData = indexInList % data.length;
      const cachedIndexInList = findIndex_default()(listWrapper.children, ele => ele === this._cachedSelectedNode);
      const cachedIndexData = cachedIndexInList % data.length;
      const item = data[indexInData];
      this._adapter.setSelectedNode(node);
      this._adapter.scrollToCenter(node);
      // Avoid triggerring notifySelectItem twice,
      // because that scroll event will be trigger
      // when you click to select an item.
      if (this._cachedSelectedNode !== node) {
        this._cachedSelectedNode = node;
        if (cachedIndexData !== indexInData) {
          this._adapter.notifySelectItem(Object.assign(Object.assign({}, item), {
            value: item.value,
            type,
            index: indexInData
          }));
        }
      }
    }
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   * @param {HTMLElement} scrollWrapper
   * @param {number} ratio
   * @returns {boolean}
   */
  shouldAppend(listWrapper, scrollWrapper) {
    let ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    const tag = 'li';
    if (isElement(listWrapper) && isElement(scrollWrapper)) {
      const itemNodes = listWrapper.querySelectorAll(tag);
      const lastNode = itemNodes[itemNodes.length - 1];
      const {
        list
      } = this.getProps();
      if (lastNode) {
        const scrollRect = scrollWrapper.getBoundingClientRect();
        const lastRect = lastNode.getBoundingClientRect();
        const listHeight = lastRect.height * list.length;
        let baseTop = lastRect.top;
        let count = 0;
        while (baseTop <= scrollRect.top + scrollRect.height * ratio) {
          count += 1;
          baseTop += listHeight;
        }
        return count;
      }
    }
    return false;
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   * @param {HTMLElement} scrollWrapper
   * @param {number} ratio
   *
   * @returns {boolean}
   */
  shouldPrepend(listWrapper, scrollWrapper) {
    let ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    const tag = 'li';
    if (isElement(listWrapper) && isElement(scrollWrapper)) {
      const itemNodes = listWrapper.querySelectorAll(tag);
      const firstNode = itemNodes[0];
      const {
        list
      } = this.getProps();
      if (firstNode) {
        const scrollRect = scrollWrapper.getBoundingClientRect();
        const firstRect = firstNode.getBoundingClientRect();
        const listHeight = firstRect.height * list.length;
        let baseTop = firstRect.top;
        let count = 0;
        while (baseTop + firstRect.height >= scrollRect.top - scrollRect.height * ratio) {
          count += 1;
          baseTop -= listHeight;
        }
        return count;
      }
    }
    return 0;
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   * @param {HTMLElement} wrapper
   * @param {Function} [callback]
   */
  initWheelList(listWrapper, wrapper, callback) {
    const {
      list
    } = this.getProps();
    if (isElement(wrapper) && isElement(listWrapper) && list && list.length) {
      const allNodes = listWrapper.children;
      const baseNodes = slice_default()(allNodes, 0, list.length);
      const prependCount = this.shouldPrepend(listWrapper, wrapper);
      const appendCount = this.shouldAppend(listWrapper, wrapper);
      // this._adapter.setPrependCount(prependCount);
      // this._adapter.setAppendCount(appendCount);
      this._adapter.setState({
        prependCount,
        appendCount
      }, callback);
    }
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   * @param {HTMLElement} wrapper
   * @param {HTMLElement} [nearestNode]
   */
  adjustInfiniteList(listWrapper, wrapper, nearestNode) {
    const {
      list
    } = this.getProps();
    const nodeTag = 'li';
    if (isElement(wrapper) && isElement(listWrapper) && list && list.length) {
      const allNodes = listWrapper.querySelectorAll(nodeTag);
      const total = allNodes.length;
      const ratio = 1;
      const prependCount = this.shouldPrepend(listWrapper, wrapper, ratio);
      const appendCount = this.shouldAppend(listWrapper, wrapper, ratio);
      // while (this.shouldPrepend(listWrapper, wrapper, nearestNode)) {
      if (prependCount) {
        // move last nodes to first position
        for (let i = 0; i < prependCount; i++) {
          const nodes = slice_default()(allNodes, total - list.length * (i + 1), total - list.length * i);
          prepend(listWrapper, ...nodes);
        }
      }
      // while (this.shouldAppend(listWrapper, wrapper, nearestNode)) {
      if (appendCount) {
        for (let i = 0; i < appendCount; i++) {
          const nodes = slice_default()(allNodes, i * list.length, (i + 1) * list.length);
          append(listWrapper, ...nodes);
        }
      }
    }
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   * @param {HTMLElement} selector
   *
   */
  getNearestNodeInfo(listWrapper, selector) {
    if (isElement(listWrapper) && isElement(selector)) {
      const selectorRect = selector.getBoundingClientRect();
      const selectorTop = selectorRect.top;
      const itemNodes = listWrapper.querySelectorAll('li');
      let nearestNode = null;
      let nearestIndex = -1;
      let nearestDistance = Infinity;
      Array.from(itemNodes).map((node, index) => {
        const rect = node.getBoundingClientRect();
        const rectTop = rect.top;
        const absDistance = Math.abs(rectTop - selectorTop);
        if (absDistance < nearestDistance && !this._adapter.isDisabledIndex(index)) {
          nearestDistance = absDistance;
          nearestNode = node;
          nearestIndex = index;
        }
      });
      return {
        nearestNode,
        nearestIndex
      };
    }
    return undefined;
  }
  /**
   *
   * @param {HTMLElement} listWrapper
   *
   * @param {HTMLElement|null}
   */
  getTargetNode(e, listWrapper) {
    if (e && isElement(listWrapper)) {
      const targetTagName = 'li';
      const currentTarget = e.target;
      const itemNodes = listWrapper.querySelectorAll(targetTagName);
      const list = this.getProp('list');
      const length = Array.isArray(list) ? list.length : 0;
      let targetIndex = -1;
      let indexInList = -1;
      let infoInList = null;
      const targetNode = find_default()(itemNodes, (node, index) => {
        if (node === currentTarget || node.contains(currentTarget)) {
          targetIndex = index;
          if (length > 0) {
            indexInList = index % length;
          }
          return true;
        }
        return undefined;
      });
      if (indexInList > -1) {
        infoInList = list[indexInList];
      }
      return {
        targetNode,
        targetIndex,
        indexInList,
        infoInList
      };
    }
    return null;
  }
}
// EXTERNAL MODULE: ./node_modules/bezier-easing/src/index.js
var src = __webpack_require__(73431);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/getEasing.js

function minMax(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
function parseEasingParameters(string) {
  const match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(',').map(p => parseFloat(p)) : [];
}
// Elastic easing adapted from jQueryUI http://api.jqueryui.com/easings/
function elastic() {
  let amplitude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  const a = minMax(amplitude, 1, 10);
  const p = minMax(period, 0.1, 2);
  return t => t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
}
// anime.js/src/index.js
const easingMap = (() => {
  const names = ['Quad', 'Cubic', 'Quart', 'Quint', 'Sine', 'Expo', 'Circ', 'Back', 'Elastic'];
  // Approximated Penner equations http://matthewlein.com/ceaser/
  const curves = {
    In: [[0.55, 0.085, 0.68, 0.53] /* inQuad */, [0.55, 0.055, 0.675, 0.19] /* inCubic */, [0.895, 0.03, 0.685, 0.22] /* inQuart */, [0.755, 0.05, 0.855, 0.06] /* inQuint */, [0.47, 0.0, 0.745, 0.715] /* inSine */, [0.95, 0.05, 0.795, 0.035] /* inExpo */, [0.6, 0.04, 0.98, 0.335] /* inCirc */, [0.6, -0.28, 0.735, 0.045] /* inBack */, elastic /* inElastic */],

    Out: [[0.25, 0.46, 0.45, 0.94] /* outQuad */, [0.215, 0.61, 0.355, 1.0] /* outCubic */, [0.165, 0.84, 0.44, 1.0] /* outQuart */, [0.23, 1.0, 0.32, 1.0] /* outQuint */, [0.39, 0.575, 0.565, 1.0] /* outSine */, [0.19, 1.0, 0.22, 1.0] /* outExpo */, [0.075, 0.82, 0.165, 1.0] /* outCirc */, [0.175, 0.885, 0.32, 1.275] /* outBack */, (a, p) => t => 1 - elastic(a, p)(1 - t) /* outElastic */],

    InOut: [[0.455, 0.03, 0.515, 0.955] /* inOutQuad */, [0.645, 0.045, 0.355, 1.0] /* inOutCubic */, [0.77, 0.0, 0.175, 1.0] /* inOutQuart */, [0.86, 0.0, 0.07, 1.0] /* inOutQuint */, [0.445, 0.05, 0.55, 0.95] /* inOutSine */, [1.0, 0.0, 0.0, 1.0] /* inOutExpo */, [0.785, 0.135, 0.15, 0.86] /* inOutCirc */, [0.68, -0.55, 0.265, 1.55] /* inOutBack */, (a, p) => t => t < 0.5 ? elastic(a, p)(t * 2) / 2 : 1 - elastic(a, p)(t * -2 + 2) / 2 /* inOutElastic */]
  };

  const eases = {
    linear: [0.25, 0.25, 0.75, 0.75]
  };
  for (const coords of Object.keys(curves)) {
    curves[coords].forEach((ease, i) => {
      eases['ease' + coords + names[i]] = ease;
    });
  }
  return eases;
})();
/**
 * get easing function
 * @param {string|Function} easing
 * @returns {Function}
 */
function getEasing(easing) {
  if (typeof easing === 'function') {
    return easing;
  }
  if (!easing || typeof easing !== 'string') {
    easing = 'linear';
  } else {
    easing = easing.trim();
  }
  let name = easing.split('(')[0];
  const args = parseEasingParameters(easing);
  let ease;
  if (name === 'cubic-bezier' || name === 'cubicBezier') {
    return src_default()(...(args.length ? args : easingMap.linear));
  } else {
    if (!name || typeof name !== 'string' || typeof name === 'string' && easingMap[name] == null) {
      name = 'linear';
    }
    ease = easingMap[name];
    if (typeof ease === 'function') {
      return ease(...args);
    } else if (args.length) {
      return src_default()(...args);
    } else {
      return src_default()(...ease);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/utils/Event.js
class Event_Event {
  constructor() {
    this._eventMap = new Map();
  }
  on(event, callback) {
    if (event && typeof callback === 'function') {
      this._eventMap.has(event) || this._eventMap.set(event, []);
      this._eventMap.get(event).push(callback);
    }
    return this;
  }
  once(event, callback) {
    var _this = this;
    if (event && typeof callback === 'function') {
      const fn = function () {
        callback(...arguments);
        _this.off(event, fn);
      };
      this.on(event, fn);
    }
  }
  off(event, callback) {
    if (event) {
      if (typeof callback === 'function') {
        const callbacks = this._eventMap.get(event);
        if (Array.isArray(callbacks) && callbacks.length) {
          let index = -1;
          while ((index = callbacks.findIndex(cb => cb === callback)) > -1) {
            callbacks.splice(index, 1);
          }
        }
      } else if (callback == null) {
        this._eventMap.delete(event);
      }
    }
    return this;
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!this._eventMap.has(event)) {
      return false;
    }
    this._eventMap.get(event).forEach(callback => callback(...args));
    return true;
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/shouldUseBezier.js
function shouldUseBezier(config) {
  return Boolean(config && typeof config === 'object' && (config.duration > 0 || typeof config.easing === 'string' || typeof config.easing === 'function'));
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/shouldStopAnimation.js

/**
 * usage assumption: currentStyle values have already been rendered but it says
 * nothing of whether currentStyle is stale (see unreadPropStyle)
 *
 * @param {object} currentStyle
 * @param {object} style
 * @param {object} currentVelocity
 * @param {number} startTime
 * @param {number} nowTime
 *
 * @returns {boolean}
 */
function shouldStopAnimation(currentStyle, style, currentVelocity, startTime, nowTime) {
  for (const key of Object.keys(style)) {
    const styleValue = style[key];
    const value = typeof styleValue === 'number' ? styleValue : styleValue.val;
    if (typeof styleValue === 'object' && styleValue.done) {
      continue;
    }
    if (shouldUseBezier(styleValue) && startTime && nowTime && styleValue.duration) {
      if (styleValue.duration + startTime <= nowTime || value !== currentStyle[key]) {
        return false;
      }
    } else if (typeof currentVelocity[key] === 'number' && currentVelocity[key] !== 0) {
      return false;
    }
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== value) {
      return false;
    }
  }
  return true;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/stripStyle.js
function stripStyle(style) {
  const ret = {};
  for (const key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/stepper.js
/**
 * @file
 *
 * react-motion/src/stepper.js
 */
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
// array reference around.
const reusedTuple = [0, 0];
/**
 *
 * @param {number} secondPerFrame
 * @param {number} x
 * @param {number} v
 * @param {number} destX
 * @param {number} k
 * @param {number} b
 * @param {number} precision
 */
function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2
  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  const Fspring = -k * (x - destX);
  // Damping, in kg / s
  const Fdamper = -b * v;
  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  const a = Fspring + Fdamper;
  const newV = v + a * secondPerFrame;
  const newX = x + newV * secondPerFrame;
  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }
  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/mapToZero.js
// currently used to initiate the velocity style object to 0
function mapToZero(obj) {
  const ret = {};
  const objKeys = obj && Object.keys(obj) || [];
  for (const key of objKeys) {
    ret[key] = 0;
  }
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/presets.js
/**
 * stiffness is like tension
 * damping is like friction
 */
/* harmony default export */ var presets = ({
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
});
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/wrapValue.js



const wrapValue_defaultConfig = Object.assign(Object.assign({}, presets["default"]), {
  precision: 0.01
});
function wrapValue(val) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (shouldUseBezier(config)) {
    const easing = getEasing(config.easing);
    const duration = typeof config.duration === 'number' && config.duration > 0 ? config.duration : 1000;
    config = Object.assign(Object.assign({}, config), {
      easing,
      duration
    });
  }
  let wrapped = Object.assign(Object.assign(Object.assign({}, wrapValue_defaultConfig), config), {
    done: false
  });
  if (val && typeof val === 'object' && 'val' in val) {
    if (shouldUseBezier(val)) {
      const easing = getEasing(val.easing);
      const duration = typeof val.duration === 'number' && val.duration > 0 ? val.duration : parseInt(config.duration) || 1000;
      val = Object.assign(Object.assign({}, val), {
        easing,
        duration
      });
    }
    wrapped = Object.assign(Object.assign({}, wrapped), val);
  } else {
    wrapped = Object.assign(Object.assign({}, wrapped), {
      val
    });
  }
  return wrapped;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/src/Animation.js







const Animation_now = () => Date.now();
const msPerFrame = 1000 / 60;
/**
 * @summary
 *
 * Lifecycle hook:
 * start, pause, resume, stop, frame, rest
 *
 * Binding method:
 * const animation = new Animation (); animation.on ('start | frame | rest ', () => {});
 */
class Animation extends Event_Event {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    this._props = Object.assign({}, props);
    this._config = Object.assign({}, config);
    this.initStates();
  }
  _wrapConfig(object, config) {
    config = config && typeof config === 'object' ? config : this._config;
    const ret = {};
    for (const key of Object.keys(object)) {
      ret[key] = wrapValue(object[key], config);
    }
    return ret;
  }
  initStates(props, config) {
    props = props && typeof props === 'object' ? props : this._props;
    config = config && typeof config === 'object' ? config : this._config;
    const {
      from,
      to
    } = props;
    this._from = {};
    if (from && typeof from) {
      for (const key of Object.keys(from)) {
        this._from[key] = typeof from[key] === 'object' && from[key].val ? from[key].val : from[key];
      }
    }
    this._to = this._wrapConfig(to, config);
    this._delay = parseInt(config.delay) || 0;
    const currentStyle = this._from && stripStyle(this._from) || stripStyle(this._to);
    const currentVelocity = mapToZero(currentStyle);
    this._currentStyle = Object.assign({}, currentStyle);
    this._currentVelocity = Object.assign({}, currentVelocity);
    this._lastIdealStyle = Object.assign({}, currentStyle);
    this._lastIdealVelocity = Object.assign({}, currentVelocity);
    this.resetPlayStates();
    this._frameCount = 0;
    this._prevTime = 0;
  }
  animate() {
    if (this._timer != null) {
      return;
    }
    this._timer = requestAnimationFrame(timestamp => {
      const nowTime = Animation_now();
      // stop animation and emit onRest event
      if (shouldStopAnimation(this._currentStyle, this._to, this._currentVelocity, this._startedTime || nowTime, nowTime) || this._ended || this._stopped) {
        if (this._wasAnimating && !this._ended && !this._stopped) {
          // should emit reset in settimeout for delay msPerframe
          this._timer = setTimeout(() => {
            clearTimeout(this._timer);
            this._timer = null;
            this._ended = true;
            this.emit('rest', this.getCurrentStates());
          }, msPerFrame);
        }
        this.resetPlayStates();
        return;
      }
      if (!this._started) {
        this._started = true;
        this.emit('start', this.getCurrentStates());
      }
      this._stopped = false;
      this._paused = false;
      this._wasAnimating = true;
      if (this._startedTime === 0) {
        this._startedTime = nowTime;
      }
      const currentTime = nowTime;
      const timeDelta = currentTime - this._prevTime;
      this._prevTime = currentTime;
      if (currentTime - this._startedTime < this._delay) {
        this._timer = null;
        this.animate();
      }
      const newLastIdealStyle = {};
      const newLastIdealVelocity = {};
      const newCurrentStyle = {};
      const newCurrentVelocity = {};
      const toKeys = this._to && Object.keys(this._to) || [];
      for (const key of toKeys) {
        const styleValue = this._to[key];
        this._accumulatedTime[key] = typeof this._accumulatedTime[key] !== 'number' ? timeDelta : this._accumulatedTime[key] + timeDelta;
        const from = this._from[key] != null && typeof this._from[key] === 'object' ? this._from[key].val : this._from[key];
        const to = styleValue.val;
        if (typeof styleValue === 'number') {
          newCurrentStyle[key] = styleValue;
          newCurrentVelocity[key] = 0;
          newLastIdealStyle[key] = styleValue;
          newLastIdealVelocity[key] = 0;
        } else {
          let newLastIdealStyleValue = this._lastIdealStyle[key];
          let newLastIdealVelocityValue = this._lastIdealVelocity[key];
          if (shouldUseBezier(this._config) || shouldUseBezier(styleValue)) {
            // easing
            const {
              easing,
              duration
            } = styleValue;
            newLastIdealStyleValue = from + easing((currentTime - this._startedTime) / duration) * (to - from);
            if (currentTime >= this._startedTime + duration) {
              newLastIdealStyleValue = to;
              styleValue.done = true;
            }
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newCurrentStyle[key] = newLastIdealStyleValue;
          } else if (to != null && to === this._currentStyle[key]) {
            newCurrentStyle[key] = to;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = to;
            newLastIdealVelocity[key] = 0;
          } else {
            // spring
            const currentFrameCompletion = (this._accumulatedTime[key] - Math.floor(this._accumulatedTime[key] / msPerFrame) * msPerFrame) / msPerFrame;
            const framesToCatchUp = Math.floor(this._accumulatedTime[key] / msPerFrame);
            for (let i = 0; i < framesToCatchUp; i++) {
              [newLastIdealStyleValue, newLastIdealVelocityValue] = stepper(msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.tension, styleValue.friction, styleValue.precision);
            }
            const [nextIdealX, nextIdealV] = stepper(msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.tension, styleValue.friction, styleValue.precision);
            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
            this._accumulatedTime[key] -= framesToCatchUp * msPerFrame;
          }
        }
      }
      this._timer = null;
      this._currentStyle = Object.assign({}, newCurrentStyle);
      this._currentVelocity = Object.assign({}, newCurrentVelocity);
      this._lastIdealStyle = Object.assign({}, newLastIdealStyle);
      this._lastIdealVelocity = Object.assign({}, newLastIdealVelocity);
      // console.log(newCurrentStyle);
      if (!this._destroyed) {
        this.emit('frame', this.getCurrentStates());
        this.animate();
      }
    });
  }
  start() {
    this._prevTime = Animation_now();
    this._startedTime = Animation_now();
    this.animate();
  }
  end() {
    if (!this._ended) {
      this._ended = true;
      this._currentStyle = this.getFinalStates();
      this.emit('frame', this.getFinalStates());
      this.emit('rest', this.getFinalStates());
    }
    this.destroy();
  }
  pause() {
    if (!this._paused) {
      this._pausedTime = Animation_now();
      this._paused = true;
      this.emit('pause', this.getCurrentStates());
      this.destroy();
      this._destroyed = false;
    }
  }
  resume() {
    if (this._started && this._paused) {
      const nowTime = Animation_now();
      const pausedDuration = nowTime - this._pausedTime;
      this._paused = false;
      // should add with pausedDuration
      this._startedTime += pausedDuration;
      this._prevTime += pausedDuration;
      this._pausedTime = 0;
      this.emit('resume', this.getCurrentStates());
      this.animate();
    }
  }
  stop() {
    this.destroy();
    if (!this._stopped) {
      this._stopped = true;
      // this.emit('frame', this.getInitialStates());
      this.emit('stop', this.getInitialStates());
      this.initStates();
    }
  }
  destroy() {
    cancelAnimationFrame(this._timer);
    clearTimeout(this._timer);
    this._timer = null;
    this._destroyed = true;
  }
  resetPlayStates() {
    this._started = false;
    this._stopped = false;
    this._ended = false;
    this._paused = false;
    this._destroyed = false;
    this._timer = null;
    this._wasAnimating = false;
    this._accumulatedTime = {};
    this._startedTime = 0;
    this._pausedTime = 0;
  }
  reset() {
    this.destroy();
    this.initStates();
  }
  reverse() {
    this.destroy();
    const props = Object.assign({}, this._props);
    const [from, to] = [props.to, props.from];
    props.from = from;
    props.to = to;
    this._props = Object.assign({}, props);
    this.initStates();
  }
  getCurrentStates() {
    return Object.assign({}, this._currentStyle);
  }
  getInitialStates() {
    return Object.assign({}, stripStyle(this._props.from));
  }
  getFinalStates() {
    return Object.assign({}, stripStyle(this._props.to));
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-animation/lib/es/index.js






;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/scrollList/scrollTo.js

const scrollTo = (element, to, duration) => {
  const animation = new Animation({
    from: {
      scrollTop: element.scrollTop
    },
    to: {
      scrollTop: to
    }
  }, {
    duration
  });
  animation.on('frame', _ref => {
    let {
      scrollTop
    } = _ref;
    element.scrollTop = scrollTop;
  });
  // animation.start();
  return animation;
};
/* harmony default export */ var scrollList_scrollTo = (scrollTo);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/scrollList/scrollItem.js















const scrollItem_msPerFrame = 1000 / 60;
const blankReg = /^\s*$/;
const wheelMode = 'wheel';
class ScrollItem extends BaseComponent {
  constructor() {
    var _this;
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(props);
    _this = this;
    this._cacheNode = (name, node) => name && node && Object.prototype.hasOwnProperty.call(this, name) && (this[name] = node);
    this._cacheSelectedNode = selectedNode => this._cacheNode('selectedNode', selectedNode);
    this._cacheWillSelectNode = node => this._cacheNode('willSelectNode', node);
    this._cacheListNode = list => this._cacheNode('list', list);
    this._cacheSelectorNode = selector => this._cacheNode('selector', selector);
    this._cacheWrapperNode = wrapper => this._cacheNode('wrapper', wrapper);
    /* istanbul ignore next */
    this._isFirst = node => {
      const {
        list
      } = this;
      if (isElement(node) && isElement(list)) {
        const chilren = list.children;
        const index = findIndex_default()(chilren, node);
        return index === 0;
      }
      return false;
    };
    /* istanbul ignore next */
    this._isLast = node => {
      const {
        list
      } = this;
      if (isElement(node) && isElement(list)) {
        const {
          children
        } = list;
        const index = findIndex_default()(children, node);
        return index === children.length - 1;
      }
      return false;
    };
    this.indexIsSame = (index1, index2) => {
      const {
        list
      } = this.props;
      if (list.length) {
        return index1 % list.length === index2 % list.length;
      }
      return undefined;
    };
    this.isDisabledIndex = index => {
      const {
        list
      } = this.props;
      if (Array.isArray(list) && list.length && index > -1) {
        const size = list.length;
        const indexInData = index % size;
        return this.isDisabledData(list[indexInData]);
      }
      return false;
    };
    this.isDisabledNode = node => {
      const listWrapper = this.list;
      if (isElement(node) && isElement(listWrapper)) {
        const index = findIndex_default()(listWrapper.children, child => child === node);
        return this.isDisabledIndex(index);
      }
      return false;
    };
    this.isDisabledData = data => data && typeof data === 'object' && data.disabled;
    this.isWheelMode = () => this.props.mode === wheelMode;
    this.addClassToNode = function (selectedNode) {
      let selectedCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scrollList_constants_cssClasses.SELECTED;
      const {
        list
      } = _this;
      selectedNode = selectedNode || _this.selectedNode;
      if (isElement(selectedNode) && isElement(list)) {
        const {
          children
        } = list;
        const reg = new RegExp(`\\s*${selectedCls}\\s*`, 'g');
        map_default()(children, node => {
          node.className = node.className && node.className.replace(reg, ' ');
          if (blankReg.test(node.className)) {
            node.className = '';
          }
        });
        if (selectedNode.className && !blankReg.test(selectedNode.className)) {
          selectedNode.className += ` ${selectedCls}`;
        } else {
          selectedNode.className = selectedCls;
        }
      }
    };
    this.getIndexByNode = node => findIndex_default()(this.list.children, node);
    this.getNodeByIndex = index => {
      if (index > -1) {
        return find_default()(this.list.children, (node, idx) => idx === index);
      }
      const defaultSelectedNode = find_default()(this.list.children, child => !this.isDisabledNode(child));
      return defaultSelectedNode;
    };
    this.scrollToIndex = (selectedIndex, duration) => {
      // move to selected item
      duration = typeof duration === 'number' ? duration : scrollList_constants_numbers.DEFAULT_SCROLL_DURATION;
      selectedIndex = selectedIndex == null ? this.props.selectedIndex : selectedIndex;
      // this.isWheelMode() && this.addClassToNode();
      this.scrollToNode(this.selectedNode, duration);
    };
    this.scrollToNode = (node, duration) => {
      const {
        wrapper
      } = this;
      const wrapperHeight = wrapper.offsetHeight;
      const itemHeight = this.getItmHeight(node);
      const targetTop = (node.offsetTop || this.list.children.length * itemHeight / 2) - (wrapperHeight - itemHeight) / 2;
      this.scrollToPos(targetTop, duration);
    };
    this.scrollToPos = function (targetTop) {
      let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scrollList_constants_numbers.DEFAULT_SCROLL_DURATION;
      const {
        wrapper
      } = _this;
      // this.isWheelMode() && this.addClassToNode();
      if (duration && _this.props.motion) {
        if (_this.scrollAnimation) {
          _this.scrollAnimation.destroy();
          _this.scrolling = false;
        }
        if (wrapper.scrollTop === targetTop) {
          if (_this.isWheelMode()) {
            const nodeInfo = _this.foundation.getNearestNodeInfo(_this.list, _this.selector);
            _this.addClassToNode(nodeInfo.nearestNode);
          }
        } else {
          _this.scrollAnimation = scrollList_scrollTo(wrapper, targetTop, duration);
          _this.scrollAnimation.on('rest', () => {
            if (_this.isWheelMode()) {
              const nodeInfo = _this.foundation.getNearestNodeInfo(_this.list, _this.selector);
              _this.addClassToNode(nodeInfo.nearestNode);
            }
          });
          _this.scrollAnimation.start();
        }
      } else {
        wrapper.scrollTop = targetTop;
      }
    };
    this.scrollToSelectItem = e => {
      const {
        nearestNode
      } = this.foundation.getNearestNodeInfo(this.list, this.selector);
      if (this.props.cycled) {
        this.throttledAdjustList(e, nearestNode);
      }
      this.debouncedSelect(e, nearestNode);
    };
    /**
     *
     * reset position to center of the scrollWrapper
     *
     * @param {HTMLElement} selectedNode
     * @param {HTMLElement} scrollWnumber
     * @param {number} duration
     */
    this.scrollToCenter = (selectedNode, scrollWrapper, duration) => {
      selectedNode = selectedNode || this.selectedNode;
      scrollWrapper = scrollWrapper || this.wrapper;
      if (isElement(selectedNode) && isElement(scrollWrapper)) {
        const scrollRect = scrollWrapper.getBoundingClientRect();
        const selectedRect = selectedNode.getBoundingClientRect();
        const targetTop = scrollWrapper.scrollTop + (selectedRect.top - (scrollRect.top + scrollRect.height / 2 - selectedRect.height / 2));
        this.scrollToPos(targetTop, typeof duration === 'number' ? duration : scrollList_constants_numbers.DEFAULT_SCROLL_DURATION);
      }
    };
    this.clickToSelectItem = e => {
      // const index = this.foundation.selectNearestIndex(e.nativeEvent, this.list);
      e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
      const {
        targetNode: node,
        infoInList
      } = this.foundation.getTargetNode(e, this.list);
      if (node && infoInList && !infoInList.disabled) {
        this.debouncedSelect(null, node);
      }
    };
    this.getItmHeight = itm => itm && itm.offsetHeight || scrollList_constants_numbers.DEFAULT_ITEM_HEIGHT;
    this.renderItemList = function () {
      let prefixKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const {
        selectedIndex,
        mode,
        transform: commonTrans,
        list
      } = _this.props;
      return list.map((item, index) => {
        const {
          transform: itemTrans
        } = item;
        const transform = typeof itemTrans === 'function' ? itemTrans : commonTrans;
        const selected = selectedIndex === index;
        const cls = classnames_default()({
          [`${scrollList_constants_cssClasses.PREFIX}-item-sel`]: selected && mode !== wheelMode,
          [`${scrollList_constants_cssClasses.PREFIX}-item-disabled`]: Boolean(item.disabled)
        });
        let text = '';
        if (selected) {
          if (typeof transform === 'function') {
            text = transform(item.value, item.text);
          } else {
            text = item.text == null ? item.value : item.text;
          }
        } else {
          text = item.text == null ? item.value : item.text;
        }
        const events = {};
        if (!_this.isWheelMode() && !item.disabled) {
          events.onClick = () => _this.foundation.selectIndex(index, _this.list);
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
          react.createElement("li", Object.assign({
            key: prefixKey + index
          }, events, {
            className: cls,
            role: "option",
            "aria-selected": selected,
            "aria-disabled": item.disabled
          }), text)
        );
      });
    };
    this.renderNormalList = () => {
      const {
        list,
        className,
        style
      } = this.props;
      const inner = this.renderItemList();
      const wrapperCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-item`, className);
      return /*#__PURE__*/react.createElement("div", {
        style: style,
        className: wrapperCls,
        ref: this._cacheWrapperNode
      }, /*#__PURE__*/react.createElement("ul", {
        role: "listbox",
        "aria-multiselectable": false,
        "aria-label": this.props['aria-label'],
        ref: this._cacheListNode
      }, inner));
    };
    /**
     * List of Rendering Unlimited Modes
     */
    this.renderInfiniteList = () => {
      const {
        list,
        cycled,
        className,
        style
      } = this.props;
      const {
        prependCount,
        appendCount
      } = this.state;
      const prependList = times_default()(prependCount).reduce((arr, num) => {
        const items = this.renderItemList(`pre_${num}_`);
        arr.unshift(...items);
        return arr;
      }, []);
      const appendList = times_default()(appendCount).reduce((arr, num) => {
        const items = this.renderItemList(`app_${num}_`);
        arr.push(...items);
        return arr;
      }, []);
      const inner = this.renderItemList();
      const listWrapperCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-list-outer`, {
        [`${scrollList_constants_cssClasses.PREFIX}-list-outer-nocycle`]: !cycled
      });
      const wrapperCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-item-wheel`, className);
      const selectorCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-selector`);
      const preShadeCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-shade`, `${scrollList_constants_cssClasses.PREFIX}-shade-pre`);
      const postShadeCls = classnames_default()(`${scrollList_constants_cssClasses.PREFIX}-shade`, `${scrollList_constants_cssClasses.PREFIX}-shade-post`);
      return /*#__PURE__*/react.createElement("div", {
        className: wrapperCls,
        style: style
      }, /*#__PURE__*/react.createElement("div", {
        className: preShadeCls
      }), /*#__PURE__*/react.createElement("div", {
        className: selectorCls,
        ref: this._cacheSelectorNode
      }), /*#__PURE__*/react.createElement("div", {
        className: postShadeCls
      }), /*#__PURE__*/react.createElement("div", {
        className: listWrapperCls,
        ref: this._cacheWrapperNode,
        onScroll: this.scrollToSelectItem
      }, /*#__PURE__*/react.createElement("ul", {
        role: "listbox",
        "aria-label": this.props['aria-label'],
        "aria-multiselectable": false,
        ref: this._cacheListNode,
        onClick: this.clickToSelectItem
      }, prependList, inner, appendList)));
    };
    this.state = {
      prependCount: 0,
      appendCount: 0
      // selectedIndex: props.selectedIndex,
      // fakeSelectedIndex: props.selectedIndex,
    };

    this.selectedNode = null;
    this.willSelectNode = null;
    this.list = null;
    this.wrapper = null;
    this.selector = null;
    this.scrollAnimation = null;
    // cache if select action comes from outside
    this.foundation = new ItemFoundation(this.adapter);
    this.throttledAdjustList = throttle_default()((e, nearestNode) => {
      this.foundation.adjustInfiniteList(this.list, this.wrapper, nearestNode);
    }, scrollItem_msPerFrame);
    this.debouncedSelect = debounce_default()((e, nearestNode) => {
      this._cacheSelectedNode(nearestNode);
      this.foundation.selectNode(nearestNode, this.list);
    }, scrollItem_msPerFrame * 2);
  }
  get adapter() {
    var _this2 = this;
    return Object.assign(Object.assign({}, super.adapter), {
      setState: (states, callback) => this.setState(Object.assign({}, states), callback),
      setPrependCount: prependCount => this.setState({
        prependCount
      }),
      setAppendCount: appendCount => this.setState({
        appendCount
      }),
      isDisabledIndex: this.isDisabledIndex,
      setSelectedNode: selectedNode => this._cacheWillSelectNode(selectedNode),
      notifySelectItem: function () {
        return _this2.props.onSelect(...arguments);
      },
      scrollToCenter: this.scrollToCenter
    });
  }
  componentWillUnmount() {
    if (this.props.cycled) {
      this.throttledAdjustList.cancel();
      this.debouncedSelect.cancel();
    }
  }
  componentDidMount() {
    this.foundation.init();
    const {
      mode,
      cycled,
      selectedIndex,
      list
    } = this.props;
    const selectedNode = this.getNodeByIndex(typeof selectedIndex === 'number' && selectedIndex > -1 ? selectedIndex : 0);
    this._cacheSelectedNode(selectedNode);
    this._cacheWillSelectNode(selectedNode);
    if (mode === wheelMode && cycled) {
      this.foundation.initWheelList(this.list, this.wrapper, () => {
        // we have to scroll in next tick
        // setTimeout(() => {
        this.scrollToNode(selectedNode, 0);
        // });
      });
    } else {
      this.scrollToNode(selectedNode, 0);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      selectedIndex
    } = this.props;
    // smooth scroll to selected option
    if (prevProps.selectedIndex !== selectedIndex) {
      const willSelectIndex = this.getIndexByNode(this.willSelectNode);
      if (!this.indexIsSame(willSelectIndex, selectedIndex)) {
        const newSelectedNode = this.getNodeByOffset(this.selectedNode, selectedIndex - prevProps.selectedIndex, this.list);
        this._cacheWillSelectNode(newSelectedNode);
      }
      this._cacheSelectedNode(this.willSelectNode);
      this.scrollToIndex(selectedIndex);
    }
  }
  /**
   *
   * @param {HTMLElement} refNode
   * @param {number} offset
   * @param {HTMLElement} listWrapper
   *
   * @returns {HTMLElement}
   */
  getNodeByOffset(refNode, offset, listWrapper) {
    const {
      list
    } = this.props;
    if (isElement(refNode) && isElement(listWrapper) && typeof offset === 'number' && Array.isArray(list) && list.length) {
      offset = offset % list.length;
      const refIndex = this.getIndexByNode(refNode);
      let targetIndex = refIndex + offset;
      while (targetIndex < 0) {
        targetIndex += list.length;
      }
      if (offset) {
        return this.getNodeByIndex(targetIndex);
      }
    }
    return refNode;
  }
  render() {
    return this.isWheelMode() ? this.renderInfiniteList() : this.renderNormalList();
  }
}
ScrollItem.propTypes = {
  mode: prop_types_default().oneOf(scrollList_constants_strings.MODE),
  cycled: (prop_types_default()).bool,
  list: (prop_types_default()).array,
  selectedIndex: (prop_types_default()).number,
  onSelect: (prop_types_default()).func,
  transform: (prop_types_default()).func,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  motion: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  type: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
ScrollItem.defaultProps = {
  selectedIndex: 0,
  motion: true,
  // transform: identity,
  list: [],
  onSelect: (noop_default()),
  cycled: false,
  mode: wheelMode
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/scrollList/foundation.js

class ScrollListFoundation extends foundation {}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/scrollList/index.js
var scrollList_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







// import '@douyinfe/semi-foundation/lib/es/scrollList/scrollList.css';
// eslint-disable-next-line @typescript-eslint/ban-types
class ScrollList extends BaseComponent {
  constructor(props) {
    super(props);
    this.foundation = new ScrollListFoundation(this.adapter);
  }
  render() {
    const _a = this.props,
      {
        children,
        header,
        footer,
        prefixCls,
        bodyHeight,
        className,
        style
      } = _a,
      rest = scrollList_rest(_a, ["children", "header", "footer", "prefixCls", "bodyHeight", "className", "style"]);
    const clsWrapper = classnames_default()(className, {
      [prefixCls || scrollList_constants_cssClasses.PREFIX]: true
    });
    const clsHeader = classnames_default()({
      [`${prefixCls || scrollList_constants_cssClasses.PREFIX}-header`]: true
    });
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: clsWrapper,
      style: style
    }, this.getDataAttr(rest)), header ? /*#__PURE__*/react.createElement("div", {
      className: clsHeader
    }, /*#__PURE__*/react.createElement("div", {
      className: `${clsHeader}-title`,
      "x-semi-prop": this.props['x-semi-header-alias'] || "header"
    }, header), /*#__PURE__*/react.createElement("div", {
      className: `${clsWrapper}-line`
    })) : null, /*#__PURE__*/react.createElement("div", {
      className: `${clsWrapper}-body`,
      style: {
        height: bodyHeight ? bodyHeight : ''
      },
      "x-semi-prop": "children"
    }, children), footer ? /*#__PURE__*/react.createElement("div", {
      className: `${clsWrapper}-footer`,
      "x-semi-prop": this.props['x-semi-footer-alias'] || "footer"
    }, footer) : null);
  }
}
ScrollList.Item = ScrollItem;
ScrollList.propTypes = {
  className: (prop_types_default()).string,
  header: (prop_types_default()).node,
  footer: (prop_types_default()).node,
  children: (prop_types_default()).node,
  bodyHeight: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string])
};
/* harmony default export */ var scrollList = (ScrollList);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/timePicker/ComboxFoundation.js




const HOUR = 1000 * 60 * 60;
const DAY = 24 * HOUR;
// TODO: move to utils
const formatOption = (option, disabledOptions) => {
  let value = `${option}`;
  if (option < 10) {
    value = `0${option}`;
  }
  let disabled = false;
  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }
  return {
    value,
    disabled
  };
};
function generateOptions(length, disabledOptions, hideDisabledOptions) {
  let step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  const arr = [];
  for (let value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }
  return arr;
}
class ComboboxFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  isAM() {
    return this.getProp('isAM');
  }
  initData() {
    const {
      timeStampValue,
      hourStep,
      disabledMinutes,
      disabledSeconds,
      hideDisabledOptions,
      minuteStep,
      secondStep
    } = this.getProps();
    const format = this.getValidFormat();
    const dateTime = this.getDisplayDateFromTimeStamp(timeStampValue);
    const disabledHourOptions = this.disabledHours();
    const disabledMinuteOptions = disabledMinutes(dateTime ? dateTime.getHours() : null);
    const disabledSecondOptions = disabledSeconds(dateTime ? dateTime.getHours() : null, dateTime ? dateTime.getMinutes() : null);
    const hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
    const minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
    const secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
    return {
      showHour: Boolean(format.match(/HH|hh|H|h/g)),
      showMinute: Boolean(format.match(/mm/g)),
      showSecond: Boolean(format.match(/ss/g)),
      hourOptions,
      minuteOptions,
      secondOptions
    };
  }
  getPosition() {
    const position = this.getProp('position');
    const type = this.getProp('type') || timePicker_constants_strings.DEFAULT_TYPE;
    return position || timePicker_constants_strings.DEFAULT_POSITION[type];
  }
  getDefaultFormatIfNeed() {
    if (this._isInProps('format')) {
      return this.getProp('format');
    } else if (this.getProp('use12Hours')) {
      return timePicker_constants_strings.DEFAULT_FORMAT_A;
    } else {
      return timePicker_constants_strings.DEFAULT_FORMAT;
    }
  }
  disabledHours() {
    const {
      use12Hours,
      disabledHours
    } = this.getProps();
    let disabledOptions = disabledHours && disabledHours();
    if (use12Hours && Array.isArray(disabledOptions)) {
      if (this.isAM()) {
        disabledOptions = disabledOptions.filter(h => h < 12).map(h => h === 0 ? 12 : h);
      } else {
        disabledOptions = disabledOptions.map(h => h === 12 ? 12 : h - 12);
      }
    }
    return disabledOptions;
  }
  getValidFormat(format) {
    let _format = isNullOrUndefined(format) ? this.getProp('format') : format;
    _format = this.getDefaultFormatIfNeed();
    _format = typeof _format === 'string' ? _format : timePicker_constants_strings.DEFAULT_FORMAT;
    // if (use12Hours) {
    //     format = format.replace(/H/g, 'h');
    //     if (!/(\s+)a/i.test(format)) {
    //         format += ' a';
    //     } else {
    //         format = format.replace(/(\s+)A/i, '$1a');
    //     }
    // }
    return _format;
  }
  /**
   * from 13-bit timestamp  -> get display date
   * by combobox use
   */
  getDisplayDateFromTimeStamp(timeStamp) {
    let date;
    if (timeStamp) {
      date = new Date(timeStamp);
    }
    if (!timeStamp || !isValidDate(date)) {
      return this.createDateDefault();
    }
    return date;
  }
  /**
   * create a date at 00:00:00
   */
  createDateDefault() {
    return new Date(parseInt(String(Date.now() / DAY), 10) * DAY - 8 * HOUR);
  }
}
/* harmony default export */ var ComboxFoundation = (ComboboxFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/Combobox.js










class Combobox extends BaseComponent {
  constructor(props) {
    super(props);
    this.cacheRefCurrent = (key, current) => {
      if (key && typeof key === 'string') {
        this.adapter.setCache(key, current);
      }
    };
    this.reselect = () => {
      const currentKeys = ['ampm', 'hour', 'minute', 'second'];
      currentKeys.forEach(key => {
        const current = this.adapter.getCache(key);
        if (current && current.scrollToIndex) {
          current.scrollToIndex();
        }
      });
    };
    this.onItemChange = _ref => {
      let {
        type,
        value,
        disabled
      } = _ref;
      let {
        onChange,
        use12Hours,
        isAM,
        format,
        timeStampValue
      } = this.props;
      const transformValue = this.foundation.getDisplayDateFromTimeStamp(timeStampValue);
      // TODO: foundation
      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            transformValue.setHours(Number(value) % 12);
          } else {
            transformValue.setHours(Number(value) % 12 + 12);
          }
        } else {
          transformValue.setHours(Number(value));
        }
      } else if (type === 'minute') {
        transformValue.setMinutes(Number(value));
      } else if (type === 'ampm') {
        const ampm = value.toUpperCase();
        if (use12Hours) {
          if (ampm === 'PM') {
            isAM = false;
            transformValue.getHours() < 12 && transformValue.setHours(transformValue.getHours() % 12 + 12);
          }
          if (ampm === 'AM') {
            isAM = true;
            transformValue.getHours() >= 12 && transformValue.setHours(transformValue.getHours() - 12);
          }
        }
      } else {
        transformValue.setSeconds(Number(value));
      }
      onChange && onChange({
        isAM,
        value: format_format(transformValue, format && format.replace(/(\s+)A/g, '$1a')),
        timeStampValue: Number(transformValue)
      });
    };
    this.onEnterSelectPanel = range => {
      const {
        onCurrentSelectPanelChange
      } = this.props;
      onCurrentSelectPanelChange(range);
    };
    this.getDisplayDateFromTimeStamp = timeStampValue => this.foundation.getDisplayDateFromTimeStamp(timeStampValue);
    this.foundation = new ComboxFoundation(this.adapter);
    this.state = Object.assign({}, this.foundation.initData());
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timeStampValue !== this.props.timeStampValue || prevProps.format !== this.props.format) {
      this.setState(Object.assign({}, this.foundation.initData()));
    }
  }
  componentWillUnmount() {
    // this.foundation.destroy();
  }
  componentDidMount() {
    // this.foundation.init();
  }
  renderHourSelect(hour, locale) {
    const {
      prefixCls,
      disabledHours,
      use12Hours,
      scrollItemProps
    } = this.props;
    const {
      showHour,
      hourOptions
    } = this.state;
    if (!showHour) {
      return null;
    }
    const disabledOptions = disabledHours();
    let hourOptionsAdj, hourAdj;
    if (use12Hours) {
      hourOptionsAdj = [12].concat(hourOptions.filter(h => h < 12 && h > 0));
      hourAdj = hour % 12 || 12;
    } else {
      hourOptionsAdj = hourOptions;
      hourAdj = hour;
    }
    const transformHour = value => value + locale.hour;
    const className = `${prefixCls}-list-hour`;
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: current => this.cacheRefCurrent('hour', current),
      mode: 'normal',
      transform: transformHour,
      className: className,
      list: hourOptionsAdj.map(option => formatOption(option, disabledOptions)),
      selectedIndex: hourOptionsAdj.indexOf(hourAdj),
      type: "hour",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }
  renderMinuteSelect(minute, locale) {
    const {
      prefixCls,
      disabledMinutes,
      timeStampValue,
      scrollItemProps
    } = this.props;
    const {
      showMinute,
      minuteOptions
    } = this.state;
    if (!showMinute) {
      return null;
    }
    const value = new Date(timeStampValue);
    const disabledOptions = disabledMinutes && disabledMinutes(value.getHours());
    const className = `${prefixCls}-list-minute`;
    const transformMinute = min => min + locale.minute;
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: current => this.cacheRefCurrent('minute', current),
      mode: 'normal',
      transform: transformMinute,
      list: minuteOptions.map(option => formatOption(option, disabledOptions)),
      selectedIndex: minuteOptions.indexOf(minute),
      type: "minute",
      onSelect: this.onItemChange,
      className: className
    }, scrollItemProps));
  }
  renderSecondSelect(second, locale) {
    const {
      prefixCls,
      disabledSeconds,
      timeStampValue,
      scrollItemProps
    } = this.props;
    const {
      showSecond,
      secondOptions
    } = this.state;
    if (!showSecond) {
      return null;
    }
    const value = new Date(timeStampValue);
    const disabledOptions = disabledSeconds && disabledSeconds(value.getHours(), value.getMinutes());
    const className = `${prefixCls}-list-second`;
    const transformSecond = sec => String(sec) + locale.second;
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: current => this.cacheRefCurrent('second', current),
      mode: 'normal',
      transform: transformSecond,
      list: secondOptions.map(option => formatOption(option, disabledOptions)),
      selectedIndex: secondOptions.indexOf(second),
      className: className,
      type: "second",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }
  renderAMPMSelect(locale, localeCode) {
    const {
      prefixCls,
      use12Hours,
      isAM,
      scrollItemProps
    } = this.props;
    if (!use12Hours) {
      return null;
    }
    const AMPMOptions = [{
      value: 'AM',
      text: locale.AM || '上午'
    }, {
      value: 'PM',
      text: locale.PM || '下午'
    }];
    const selected = isAM ? 0 : 1;
    const className = `${prefixCls}-list-ampm`;
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: current => this.cacheRefCurrent('ampm', current),
      mode: 'normal',
      className: className,
      list: AMPMOptions,
      selectedIndex: selected,
      type: "ampm",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }
  render() {
    const {
      timeStampValue,
      panelHeader,
      panelFooter
    } = this.props;
    const value = this.getDisplayDateFromTimeStamp(timeStampValue);
    return /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "TimePicker"
    }, (locale, localeCode) => /*#__PURE__*/react.createElement(scrollList, {
      header: panelHeader,
      footer: panelFooter,
      "x-semi-header-alias": "panelHeader",
      "x-semi-footer-alias": "panelFooter"
    }, this.renderAMPMSelect(locale, localeCode), this.renderHourSelect(value.getHours(), locale), this.renderMinuteSelect(value.getMinutes(), locale), this.renderSecondSelect(value.getSeconds(), locale)));
  }
}
Combobox.propTypes = {
  format: (prop_types_default()).string,
  defaultOpenValue: (prop_types_default()).object,
  prefixCls: (prop_types_default()).string,
  onChange: (prop_types_default()).func,
  showHour: (prop_types_default()).bool,
  showMinute: (prop_types_default()).bool,
  showSecond: (prop_types_default()).bool,
  disabledHours: (prop_types_default()).func,
  disabledMinutes: (prop_types_default()).func,
  disabledSeconds: (prop_types_default()).func,
  hideDisabledOptions: (prop_types_default()).bool,
  onCurrentSelectPanelChange: (prop_types_default()).func,
  use12Hours: (prop_types_default()).bool,
  isAM: (prop_types_default()).bool,
  timeStampValue: (prop_types_default()).any,
  scrollItemProps: (prop_types_default()).object
};
Combobox.defaultProps = {
  disabledHours: (noop_default()),
  disabledMinutes: (noop_default()),
  disabledSeconds: (noop_default()),
  format: timePicker_constants_strings.DEFAULT_FORMAT
};
/* harmony default export */ var timePicker_Combobox = (Combobox);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate_toDate(dirtyDate);
  var year = toInteger(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/yearAndMonthFoundation.js




class YearAndMonthFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {}
  destroy() {}
  selectYear(item, panelType) {
    // const year = item.value;
    const {
      currentYear,
      currentMonth
    } = this.getStates();
    const {
      type
    } = this.getProps();
    const left = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const right = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    const year = index(currentYear);
    year[panelType] = item.value;
    // make sure the right panel time is always less than the left panel time
    if (type === 'monthRange') {
      const isSameYearIllegalDate = year[left] === year[right] && currentMonth[left] > currentMonth[right];
      if (panelType === left && item.value > year[right] || panelType === left && isSameYearIllegalDate) {
        // 1. select left year and left year > right year
        // 2. select left year, left year = right year, but left date > right date
        year[right] = item.value + 1;
      } else if (panelType === right && isSameYearIllegalDate) {
        // 1. select right year, left year = right year, but left date > right date
        year[left] = item.value - 1;
      }
    }
    this._adapter.setCurrentYear(year, () => this.autoSelectMonth(item, panelType, year));
    this._adapter.notifySelectYear(year);
  }
  selectMonth(item, panelType) {
    const {
      currentMonth,
      currentYear
    } = this.getStates();
    const {
      type
    } = this.getProps();
    const left = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const right = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    const month = index(currentMonth);
    month[panelType] = item.month;
    // make sure the right panel time is always less than the left panel time
    if (type === 'monthRange' && panelType === left && currentYear[left] === currentYear[right] && item.value > month[right]) {
      month[right] = item.month + 1;
    }
    this._adapter.setCurrentMonth(month);
    this._adapter.notifySelectMonth(month);
  }
  /**
   * After selecting a year, if the currentMonth is disabled, automatically select a non-disabled month
   */
  autoSelectMonth(item, panelType, year) {
    const {
      disabledDate,
      locale
    } = this._adapter.getProps();
    const {
      months,
      currentMonth
    } = this._adapter.getStates();
    const currentDate = setYear(Date.now(), item.year);
    const isCurrentMonthDisabled = disabledDate(setMonth(currentDate, currentMonth[panelType] - 1));
    if (isCurrentMonthDisabled) {
      const currentIndex = months.findIndex(_ref => {
        let {
          month
        } = _ref;
        return month === currentMonth[panelType];
      });
      let validMonth;
      // First look in the back, if you can't find it in the back, then look in the front
      validMonth = months.slice(currentIndex).find(_ref2 => {
        let {
          month
        } = _ref2;
        return !disabledDate(setMonth(currentDate, month - 1));
      });
      if (!validMonth) {
        validMonth = months.slice(0, currentIndex).find(_ref3 => {
          let {
            month
          } = _ref3;
          return !disabledDate(setMonth(currentDate, month - 1));
        });
      }
      if (validMonth) {
        const month = index(currentMonth);
        month[panelType] = validMonth.month;
        // change year and month same time
        this._adapter.setCurrentYearAndMonth(year, month);
        this._adapter.notifySelectYearAndMonth(year, month);
      }
    }
  }
  backToMain() {
    this._adapter.notifyBackToMain();
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/datePicker/_utils/getYears.js
const getYears = (startYear, endYear) => {
  const currentYear = new Date().getFullYear();
  let start = typeof startYear === 'number' ? startYear : currentYear - 100;
  let end = typeof endYear === 'number' ? endYear : currentYear + 100;
  if (end < start) {
    [start, end] = [end, start];
  }
  return Array.from({
    length: end - start + 1
  }, (v, i) => start + i);
};
/* harmony default export */ var _utils_getYears = (getYears);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/yearAndMonth.js















const yearAndMonth_prefixCls = `${BASE_CLASS_PREFIX}-datepicker`;
class YearAndMonth extends BaseComponent {
  constructor(props) {
    super(props);
    this.selectYear = (item, panelType) => {
      this.foundation.selectYear(item, panelType);
    };
    this.selectMonth = (item, panelType) => {
      this.foundation.selectMonth(item, panelType);
    };
    this.reselect = () => {
      const refKeys = ['yearRef', 'monthRef'];
      refKeys.forEach(key => {
        const ref = this[key];
        if (ref && ref.current && ref.current.scrollToIndex) {
          ref.current.scrollToIndex();
        }
      });
    };
    this.backToMain = e => {
      e.nativeEvent.stopImmediatePropagation();
      this.foundation.backToMain();
    };
    const now = new Date();
    let {
      currentYear,
      currentMonth
    } = props;
    this.state = {
      years: _utils_getYears(props.startYear, props.endYear).map(year => ({
        value: year,
        year
      })),
      months: Array(12).fill(0).map((v, idx) => ({
        value: idx + 1,
        month: idx + 1
      })),
      currentYear: {
        left: currentYear.left || now.getFullYear(),
        right: currentYear.right || now.getFullYear()
      },
      currentMonth: {
        left: currentMonth.left || now.getMonth() + 1,
        right: currentMonth.right || now.getMonth() + 2
      }
    };
    this.yearRef = /*#__PURE__*/react.createRef();
    this.monthRef = /*#__PURE__*/react.createRef();
    this.foundation = new YearAndMonthFoundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      // updateYears: years => this.setState({ years }),
      // updateMonths: months => this.setState({ months }),
      setCurrentYear: (currentYear, cb) => this.setState({
        currentYear
      }, cb),
      setCurrentMonth: currentMonth => this.setState({
        currentMonth
      }),
      setCurrentYearAndMonth: (currentYear, currentMonth) => this.setState({
        currentYear,
        currentMonth
      }),
      notifySelectYear: year => this.props.onSelect({
        currentMonth: this.state.currentMonth,
        currentYear: year
      }),
      notifySelectMonth: month => this.props.onSelect({
        currentYear: this.state.currentYear,
        currentMonth: month
      }),
      notifySelectYearAndMonth: (year, month) => this.props.onSelect({
        currentYear: year,
        currentMonth: month
      }),
      notifyBackToMain: () => this.props.onBackToMain()
    });
  }
  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    if (!isEqual_default()(props.currentYear, state.currentYear)) {
      const nowYear = new Date().getFullYear();
      willUpdateStates.currentYear = {
        left: props.currentYear.left || nowYear,
        right: props.currentYear.right || nowYear
      };
    }
    if (!isEqual_default()(props.currentMonth, state.currentMonth)) {
      const nowMonth = new Date().getMonth();
      willUpdateStates.currentMonth = {
        left: props.currentMonth.left || nowMonth + 1,
        right: props.currentMonth.right || nowMonth + 2
      };
    }
    return willUpdateStates;
  }
  renderColYear(panelType) {
    const {
      years,
      currentYear,
      currentMonth,
      months
    } = this.state;
    const {
      disabledDate,
      localeCode,
      yearCycled,
      yearAndMonthOpts
    } = this.props;
    const currentDate = setMonth(Date.now(), currentMonth[panelType] - 1);
    const left = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const right = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    const needDisabled = year => {
      if (panelType === right && currentYear[left]) {
        return currentYear[left] > year;
      }
      return false;
    };
    const list = years.map(_ref => {
      let {
        value,
        year
      } = _ref;
      const isAllMonthDisabled = months.every(_ref2 => {
        let {
          month
        } = _ref2;
        return disabledDate(set_set(currentDate, {
          year,
          month: month - 1
        }));
      });
      const isRightPanelDisabled = needDisabled(year);
      return {
        year,
        value,
        disabled: isAllMonthDisabled || isRightPanelDisabled
      };
    });
    let transform = val => val;
    if (localeCode === 'zh-CN' || localeCode === 'zh-TW') {
      // Only Chinese needs to add [year] after the selected year
      transform = val => `${val}年`;
    }
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: this.yearRef,
      cycled: yearCycled,
      list: list,
      transform: transform,
      selectedIndex: years.findIndex(item => item.value === currentYear[panelType]),
      type: "year",
      onSelect: item => this.selectYear(item, panelType),
      mode: "normal"
    }, yearAndMonthOpts));
  }
  renderColMonth(panelType) {
    const {
      months,
      currentMonth,
      currentYear
    } = this.state;
    const {
      locale,
      localeCode,
      monthCycled,
      disabledDate,
      yearAndMonthOpts
    } = this.props;
    let transform = val => val;
    const currentDate = setYear(Date.now(), currentYear[panelType]);
    const left = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const right = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    if (localeCode === 'zh-CN' || localeCode === 'zh-TW') {
      // Only Chinese needs to add [month] after the selected month
      transform = val => `${val}月`;
    }
    // i18n
    const list = months.map(_ref3 => {
      let {
        value,
        month
      } = _ref3;
      const isRightPanelDisabled = panelType === right && currentMonth[left] && currentYear[left] === currentYear[right] && currentMonth[left] > month;
      return {
        month,
        disabled: disabledDate(setMonth(currentDate, month - 1)) || isRightPanelDisabled,
        value: locale.fullMonths[value] // Actual rendered text
      };
    });

    const selectedIndex = list.findIndex(item => item.month === currentMonth[panelType]);
    return /*#__PURE__*/react.createElement(ScrollItem, Object.assign({
      ref: this.monthRef,
      cycled: monthCycled,
      list: list,
      transform: transform,
      selectedIndex: selectedIndex,
      type: "month",
      onSelect: item => this.selectMonth(item, panelType),
      mode: 'normal'
    }, yearAndMonthOpts));
  }
  renderPanel(panelType) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(scrollList, null, this.renderColYear(panelType), this.renderColMonth(panelType)));
  }
  render() {
    const {
      locale,
      noBackBtn,
      density,
      presetPosition,
      renderQuickControls,
      renderDateInput,
      type
    } = this.props;
    const prefix = `${yearAndMonth_prefixCls}-yearmonth-header`;
    const bodyCls = `${yearAndMonth_prefixCls}-yearmonth-body`;
    // i18n
    const selectDateText = locale.selectDate;
    const iconSize = density === 'compact' ? 'default' : 'large';
    const buttonSize = density === 'compact' ? 'small' : 'default';
    const panelTypeLeft = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const panelTypeRight = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    let content = null;
    if (type === 'month') {
      content = this.renderPanel(panelTypeLeft);
    } else {
      content = /*#__PURE__*/react.createElement("div", {
        className: bodyCls
      }, this.renderPanel(panelTypeLeft), this.renderPanel(panelTypeRight));
    }
    return /*#__PURE__*/react.createElement(react.Fragment, null, noBackBtn ? null : /*#__PURE__*/react.createElement("div", {
      className: prefix
    }, /*#__PURE__*/react.createElement(iconButton, {
      noHorizontalPadding: false,
      icon: /*#__PURE__*/react.createElement(IconChevronLeft/* default */.Z, {
        "aria-hidden": true,
        size: iconSize
      }),
      size: buttonSize,
      onClick: this.backToMain
    }, /*#__PURE__*/react.createElement("span", null, selectDateText))), presetPosition ? /*#__PURE__*/react.createElement("div", {
      style: {
        display: 'flex'
      }
    }, presetPosition === "left" && type !== 'monthRange' && renderQuickControls, /*#__PURE__*/react.createElement("div", null, renderDateInput, content), presetPosition === "right" && type !== 'monthRange' && renderQuickControls) : /*#__PURE__*/react.createElement(react.Fragment, null, renderDateInput, content));
  }
}
YearAndMonth.propTypes = {
  currentYear: (prop_types_default()).object,
  currentMonth: (prop_types_default()).object,
  onSelect: (prop_types_default()).func,
  locale: (prop_types_default()).object,
  localeCode: (prop_types_default()).string,
  monthCycled: (prop_types_default()).bool,
  yearCycled: (prop_types_default()).bool,
  noBackBtn: (prop_types_default()).bool,
  disabledDate: (prop_types_default()).func,
  density: (prop_types_default()).string,
  presetPosition: prop_types_default().oneOf(datePicker_constants_strings.PRESET_POSITION_SET),
  renderQuickControls: (prop_types_default()).node,
  renderDateInput: (prop_types_default()).node,
  type: prop_types_default().oneOf(datePicker_constants_strings.TYPE_SET),
  startYear: (prop_types_default()).number,
  endYear: (prop_types_default()).number
};
YearAndMonth.defaultProps = {
  disabledDate: (stubFalse_default()),
  monthCycled: false,
  yearCycled: false,
  noBackBtn: false,
  onSelect: (noop_default()),
  type: 'month'
};
/* harmony default export */ var yearAndMonth = (YearAndMonth);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconClock.js


function IconClock_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM13.5 6.5V11.3787L17.0607 14.9393C17.6464 15.5251 17.6464 16.4749 17.0607 17.0607C16.4749 17.6464 15.5251 17.6464 14.9393 17.0607L10.9393 13.0607C10.658 12.7794 10.5 12.3978 10.5 12V6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5Z",
    fill: "currentColor"
  }));
}
const IconClock_IconComponent = (0,Icon/* convertIcon */.A)(IconClock_SvgComponent, 'clock');
/* harmony default export */ var IconClock = (IconClock_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/monthsGrid.js


/* eslint-disable jsx-a11y/interactive-supports-focus */















const monthsGrid_prefixCls = datePicker_constants_cssClasses.PREFIX;
class MonthsGrid extends BaseComponent {
  constructor(props) {
    super(props);
    this.cacheRefCurrent = (key, current) => {
      if (typeof key === 'string' && key.length) {
        this.adapter.setCache(key, current);
      }
    };
    this.leftIsYearOrTime = state => {
      const {
        monthLeft
      } = state || this.state;
      if (monthLeft && (monthLeft.isTimePickerOpen || monthLeft.isYearPickerOpen)) {
        return true;
      } else {
        return false;
      }
    };
    this.rightIsYearOrTime = state => {
      const {
        monthRight
      } = state || this.state;
      if (monthRight && (monthRight.isTimePickerOpen || monthRight.isYearPickerOpen)) {
        return true;
      } else {
        return false;
      }
    };
    /**
     * Calculate the height of the scrolling list, if the animation is not over, return 0
     */
    this.calcScrollListHeight = () => {
      const wrapLeft = this.adapter.getCache(`wrap-${datePicker_constants_strings.PANEL_TYPE_LEFT}`);
      const wrapRight = this.adapter.getCache(`wrap-${datePicker_constants_strings.PANEL_TYPE_RIGHT}`);
      const switchLeft = this.adapter.getCache(`switch-${datePicker_constants_strings.PANEL_TYPE_LEFT}`);
      const switchRight = this.adapter.getCache(`switch-${datePicker_constants_strings.PANEL_TYPE_RIGHT}`);
      const leftRect = wrapLeft && wrapLeft.getBoundingClientRect();
      const rightRect = wrapRight && wrapRight.getBoundingClientRect();
      let leftHeight = leftRect && leftRect.height || 0;
      let rightHeight = rightRect && rightRect.height || 0;
      if (switchLeft) {
        leftHeight += switchLeft.getBoundingClientRect().height;
      }
      if (switchRight) {
        rightHeight += switchRight.getBoundingClientRect().height;
      }
      return Math.max(leftHeight, rightHeight);
    };
    this.handleWeeksRowNumChange = (weeksRowNum, panelType) => {
      const isLeft = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT;
      const isRight = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT;
      const allIsYearOrTime = this.leftIsYearOrTime() && this.rightIsYearOrTime();
      if (this.foundation.isRangeType() && !allIsYearOrTime) {
        const states = {
          weeksRowNum,
          currentPanelHeight: this.calcScrollListHeight()
        };
        this.setState(states, () => {
          if (this.leftIsYearOrTime() && isRight || this.rightIsYearOrTime() && isLeft) {
            this.reselect();
          }
        });
      }
    };
    this.reselect = () => {
      const refKeys = [`timepicker-${datePicker_constants_strings.PANEL_TYPE_LEFT}`, `timepicker-${datePicker_constants_strings.PANEL_TYPE_RIGHT}`, `yam-${datePicker_constants_strings.PANEL_TYPE_LEFT}`, `yam-${datePicker_constants_strings.PANEL_TYPE_RIGHT}`];
      refKeys.forEach(key => {
        const current = this.adapter.getCache(key);
        if (current && typeof current.reselect === 'function') {
          current.reselect();
        }
      });
    };
    this.getYAMOpenType = () => {
      return this.foundation.getYAMOpenType();
    };
    const validFormat = props.format || getDefaultFormatTokenByType(props.type);
    const {
      nowDate,
      nextDate
    } = getDefaultPickerDate({
      defaultPickerValue: props.defaultPickerValue,
      format: validFormat,
      dateFnsLocale: props.dateFnsLocale
    });
    const dateState = {
      // Direct use of full date string storage, mainly considering the month rendering comparison to save a conversion
      // The selected value for single or multiple selection, full date string, eg. {'2019-10-01', '2019-10-02'}
      selected: new Set()
    };
    const rangeState = {
      monthLeft: {
        pickerDate: nowDate,
        showDate: nowDate,
        isTimePickerOpen: false,
        isYearPickerOpen: false
      },
      monthRight: {
        pickerDate: nextDate,
        showDate: nextDate,
        isTimePickerOpen: false,
        isYearPickerOpen: false
      },
      maxWeekNum: 0,
      hoverDay: '',
      rangeStart: props.rangeStart,
      rangeEnd: '',
      currentPanelHeight: 0,
      offsetRangeStart: '',
      offsetRangeEnd: ''
    };
    this.state = Object.assign(Object.assign({}, dateState), rangeState);
    this.foundation = new MonthsGridFoundation(this.adapter);
  }
  get dateAdapter() {
    return {
      updateDaySelected: selected => this.setState({
        selected
      })
    };
  }
  get rangeAdapter() {
    return {
      setRangeStart: rangeStart => this.setState({
        rangeStart
      }),
      setRangeEnd: rangeEnd => this.setState({
        rangeEnd
      }),
      setHoverDay: hoverDay => this.setState({
        hoverDay
      }),
      setWeeksHeight: maxWeekNum => this.setState({
        maxWeekNum
      }),
      setOffsetRangeStart: offsetRangeStart => this.setState({
        offsetRangeStart
      }),
      setOffsetRangeEnd: offsetRangeEnd => this.setState({
        offsetRangeEnd
      })
    };
  }
  get adapter() {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, super.adapter), this.dateAdapter), this.rangeAdapter), {
      updateMonthOnLeft: v => this.setState({
        monthLeft: v
      }),
      updateMonthOnRight: v => this.setState({
        monthRight: v
      }),
      notifySelectedChange: (value, options) => this.props.onChange(value, options),
      notifyMaxLimit: v => this.props.onMaxSelect(v),
      notifyPanelChange: (date, dateString) => this.props.onPanelChange(date, dateString),
      setRangeInputFocus: rangeInputFocus => this.props.setRangeInputFocus(rangeInputFocus),
      isAnotherPanelHasOpened: currentRangeInput => this.props.isAnotherPanelHasOpened(currentRangeInput)
    });
  }
  componentDidMount() {
    super.componentDidMount();
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      defaultValue,
      defaultPickerValue
    } = this.props;
    if (prevProps.defaultValue !== defaultValue) {
      // we should always update panel state when value changes
      this.foundation.updateSelectedFromProps(defaultValue);
    }
    if (prevProps.defaultPickerValue !== defaultPickerValue) {
      this.foundation.initDefaultPickerValue();
    }
    const isRange = this.foundation.isRangeType();
    if (isRange) {
      /**
       * we have to add these code to ensure that scroll list's selector places center
       */
      const prevAll = this.leftIsYearOrTime(prevState) && this.rightIsYearOrTime(prevState);
      const prevSome = this.leftIsYearOrTime(prevState) && !this.rightIsYearOrTime(prevState) || !this.leftIsYearOrTime(prevState) && this.rightIsYearOrTime(prevState);
      const nowAll = this.leftIsYearOrTime() && this.rightIsYearOrTime();
      const nowSome = this.leftIsYearOrTime() && !this.rightIsYearOrTime() || !this.leftIsYearOrTime() && this.rightIsYearOrTime();
      const prevAllToSome = prevAll && nowSome;
      const prevSomeToAll = prevSome && nowAll;
      if (prevSomeToAll) {
        this.setState({
          currentPanelHeight: this.calcScrollListHeight()
        }, this.reselect);
      } else if (prevAllToSome) {
        this.reselect();
      }
    }
  }
  renderPanel(month, panelType) {
    let monthCls = classnames_default()(`${monthsGrid_prefixCls}-month-grid-${panelType}`);
    const {
      monthLeft,
      monthRight,
      currentPanelHeight
    } = this.state;
    const {
      insetInput
    } = this.props;
    const panelDetail = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT ? monthRight : monthLeft;
    const {
      isTimePickerOpen,
      isYearPickerOpen
    } = panelDetail;
    const panelContent = this.renderMonth(month, panelType);
    const yearAndMonthLayer = isYearPickerOpen ? /*#__PURE__*/react.createElement("div", {
      className: `${monthsGrid_prefixCls}-yam`
    }, this.renderYearAndMonth(panelType, panelDetail)) : null;
    const timePickerLayer = isTimePickerOpen ? /*#__PURE__*/react.createElement("div", {
      className: `${monthsGrid_prefixCls}-tpk`
    }, this.renderTimePicker(panelType, panelDetail)) : null;
    const style = {};
    const wrapLeft = this.adapter.getCache(`wrap-${datePicker_constants_strings.PANEL_TYPE_LEFT}`);
    const wrapRight = this.adapter.getCache(`wrap-${datePicker_constants_strings.PANEL_TYPE_RIGHT}`);
    const wrap = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT ? wrapRight : wrapLeft;
    if (this.foundation.isRangeType()) {
      if (isYearPickerOpen || isTimePickerOpen) {
        style.minWidth = wrap.getBoundingClientRect().width;
      }
      if (this.leftIsYearOrTime() && this.rightIsYearOrTime() && !insetInput) {
        /**
         * left和right同时为tpk时，panel会有一个minHeight
         * 如果缓存的currentPanelHeight为0，则需要计算滚动列表的高度
         * 如果有缓存的值则使用currentPanelHeight（若此高度<实际值，则会影响ScrollList中渲染列表的循环次数）
         * 详见 packages/semi-foundation/scrollList/itemFoundation.js initWheelList函数
         *
         * When left and right are tpk at the same time, the panel will have a minHeight
         * If the cached currentPanelHeight is 0, you need to calculate the height of the scrolling list
         * If there is a cached value, use currentPanelHeight (if this height is less than the actual value, it will affect the number of cycles in the ScrollList to render the list)
         * See packages/semi-foundation/scrollList/itemFoundation.js initWheelList function
         */
        style.minHeight = currentPanelHeight ? currentPanelHeight : this.calcScrollListHeight();
      }
    } else if (this.props.type !== 'year' && this.props.type !== 'month' && (isTimePickerOpen || isYearPickerOpen)) {
      monthCls = classnames_default()(monthCls, `${monthsGrid_prefixCls}-yam-showing`);
    }
    const _isDatePanelOpen = !(isYearPickerOpen || isTimePickerOpen);
    const xOpenType = _isDatePanelOpen ? 'date' : isYearPickerOpen ? 'year' : 'time';
    return /*#__PURE__*/react.createElement("div", {
      className: monthCls,
      key: panelType,
      style: style,
      "x-open-type": xOpenType
    }, yearAndMonthLayer, timePickerLayer, this.foundation.isRangeType() ? panelContent : isYearPickerOpen || isTimePickerOpen ? null : panelContent, this.renderSwitch(panelType));
  }
  showYearPicker(panelType, e) {
    // e.stopPropagation();
    // When switching to the year and month, the e.target at this time is generated from Navigation, and the Navigation module will be removed from the DOM after switching
    // If you do not prevent the event from spreading to index.jsx, panel.contain (e.target) in clickOutSide will call closePanel because there is no Nav in the Panel and think this click is clickOutSide
    // Cause the entire component pop-up window to be closed by mistake
    // console.log(this.navRef.current.clientHeight, this.monthRef.current.clientHeight);
    // this.wrapRef.current.style.height = this.wrapRef.current.clientHeight + 'px';
    // this.wrapRef.current.style.overflow = 'hidden';
    e.nativeEvent.stopImmediatePropagation();
    this.foundation.showYearPicker(panelType);
  }
  renderMonth(month, panelType) {
    const {
      selected,
      rangeStart,
      rangeEnd,
      hoverDay,
      maxWeekNum,
      offsetRangeStart,
      offsetRangeEnd
    } = this.state;
    const {
      weekStartsOn,
      disabledDate,
      locale,
      localeCode,
      renderDate,
      renderFullDate,
      startDateOffset,
      endDateOffset,
      density,
      rangeInputFocus,
      syncSwitchMonth,
      multiple
    } = this.props;
    let monthText = '';
    // i18n monthText
    if (month) {
      // Get the absolute value of the year and month
      const yearNumber = month ? format_format(month, 'yyyy') : '';
      const monthNumber = month ? format_format(month, 'L') : '';
      // Display the month as the corresponding language text
      const mText = locale.months[monthNumber];
      const monthFormatToken = locale.monthText;
      // Display the year and month in a specific language format order
      monthText = monthFormatToken.replace('${year}', yearNumber).replace('${month}', mText);
    }
    let style = {};
    const detail = panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT ? this.state.monthRight : this.state.monthLeft;
    // Whether to select type for range
    const isRangeType = this.foundation.isRangeType();
    // Whether to switch synchronously for two panels
    const shouldBimonthSwitch = isRangeType && syncSwitchMonth;
    if (isRangeType && detail && (detail.isYearPickerOpen || detail.isTimePickerOpen)) {
      style = {
        visibility: 'hidden',
        position: 'absolute',
        pointerEvents: 'none'
      };
    }
    return /*#__PURE__*/react.createElement("div", {
      ref: current => this.cacheRefCurrent(`wrap-${panelType}`, current),
      style: style
    }, /*#__PURE__*/react.createElement(Navigation, {
      forwardRef: current => this.cacheRefCurrent(`nav-${panelType}`, current),
      monthText: monthText,
      density: density,
      onMonthClick: e => this.showYearPicker(panelType, e),
      onPrevMonth: () => this.foundation.prevMonth(panelType),
      onNextMonth: () => this.foundation.nextMonth(panelType),
      onNextYear: () => this.foundation.nextYear(panelType),
      onPrevYear: () => this.foundation.prevYear(panelType),
      shouldBimonthSwitch: shouldBimonthSwitch,
      panelType: panelType
    }), /*#__PURE__*/react.createElement(Month, {
      locale: locale,
      localeCode: localeCode,
      forwardRef: current => this.cacheRefCurrent(`month-${panelType}`, current),
      disabledDate: disabledDate,
      weekStartsOn: weekStartsOn,
      month: month,
      selected: selected,
      rangeStart: rangeStart,
      rangeEnd: rangeEnd,
      rangeInputFocus: rangeInputFocus,
      offsetRangeStart: offsetRangeStart,
      offsetRangeEnd: offsetRangeEnd,
      hoverDay: hoverDay,
      weeksRowNum: maxWeekNum,
      renderDate: renderDate,
      renderFullDate: renderFullDate,
      onDayClick: day => this.foundation.handleDayClick(day, panelType),
      onDayHover: day => this.foundation.handleDayHover(day, panelType),
      onWeeksRowNumChange: weeksRowNum => this.handleWeeksRowNumChange(weeksRowNum, panelType),
      startDateOffset: startDateOffset,
      endDateOffset: endDateOffset,
      focusRecordsRef: this.props.focusRecordsRef,
      multiple: multiple
    }));
  }
  renderTimePicker(panelType, panelDetail) {
    const {
      type,
      locale,
      format,
      hideDisabledOptions,
      timePickerOpts,
      dateFnsLocale
    } = this.props;
    const {
      pickerDate
    } = panelDetail;
    const timePanelCls = classnames_default()(`${monthsGrid_prefixCls}-time`);
    const restProps = Object.assign(Object.assign({}, timePickerOpts), {
      hideDisabledOptions
    });
    const disabledOptions = this.foundation.calcDisabledTime(panelType);
    if (disabledOptions) {
      ['disabledHours', 'disabledMinutes', 'disabledSeconds'].forEach(key => {
        if (disabledOptions[key]) {
          restProps[key] = disabledOptions[key];
        }
      });
    }
    const {
      rangeStart,
      rangeEnd
    } = this.state;
    const dateFormat = this.foundation.getValidDateFormat();
    let startDate, endDate;
    if (type === 'dateTimeRange' && rangeStart && rangeEnd && isSameDay(startDate = compatibleParse(rangeStart, dateFormat, undefined, dateFnsLocale), endDate = compatibleParse(rangeEnd, dateFormat, undefined, dateFnsLocale))) {
      if (panelType === datePicker_constants_strings.PANEL_TYPE_RIGHT) {
        rangeStart && (restProps.startDate = startDate);
      } else {
        rangeEnd && (restProps.endDate = endDate);
      }
    }
    // i18n placeholder
    const placeholder = locale.selectTime;
    return /*#__PURE__*/react.createElement("div", {
      className: timePanelCls
    }, /*#__PURE__*/react.createElement(timePicker_Combobox, Object.assign({
      ref: current => this.cacheRefCurrent(`timepicker-${panelType}`, current),
      panelHeader: placeholder,
      format: format || datePicker_constants_strings.FORMAT_TIME_PICKER,
      timeStampValue: pickerDate,
      onChange: newTime => this.foundation.handleTimeChange(newTime, panelType)
    }, restProps)));
  }
  renderYearAndMonth(panelType, panelDetail) {
    const {
      pickerDate
    } = panelDetail;
    const {
      locale,
      localeCode,
      density,
      yearAndMonthOpts,
      startYear,
      endYear
    } = this.props;
    const y = pickerDate.getFullYear();
    const m = pickerDate.getMonth() + 1;
    return /*#__PURE__*/react.createElement(yearAndMonth, {
      ref: current => this.cacheRefCurrent(`yam-${panelType}`, current),
      locale: locale,
      localeCode: localeCode,
      // currentYear={y}
      // currentMonth={m}
      currentYear: {
        left: y,
        right: 0
      },
      currentMonth: {
        left: m,
        right: 0
      },
      onSelect: item => this.foundation.toYearMonth(panelType, new Date(item.currentYear.left, item.currentMonth.left - 1)),
      onBackToMain: () => {
        this.foundation.showDatePanel(panelType);
        const wrapCurrent = this.adapter.getCache(`wrap-${panelType}`);
        if (wrapCurrent) {
          wrapCurrent.style.height = 'auto';
        }
      },
      density: density,
      yearAndMonthOpts: yearAndMonthOpts,
      startYear: startYear,
      endYear: endYear
    });
  }
  renderSwitch(panelType) {
    const {
      rangeStart,
      rangeEnd,
      monthLeft,
      monthRight
    } = this.state;
    const {
      type,
      locale,
      disabledTimePicker,
      density,
      dateFnsLocale,
      insetInput
    } = this.props;
    // Type: date, dateRange, year, month, inset input no rendering required
    if (!type.includes('Time') || insetInput) {
      return null;
    }
    // switch year/month & time
    let panelDetail, dateText;
    // i18n
    const {
      FORMAT_SWITCH_DATE
    } = locale.localeFormatToken;
    // Timepicker format is constant and does not change with language
    // const FORMAT_TIME_PICKER = strings.FORMAT_TIME_PICKER;
    const formatTimePicker = this.foundation.getValidTimeFormat();
    const dateFormat = this.foundation.getValidDateFormat();
    if (panelType === datePicker_constants_strings.PANEL_TYPE_LEFT) {
      panelDetail = monthLeft;
      dateText = rangeStart ? format_format(compatibleParse(rangeStart, dateFormat, undefined, dateFnsLocale), FORMAT_SWITCH_DATE) : '';
    } else {
      panelDetail = monthRight;
      dateText = rangeEnd ? format_format(compatibleParse(rangeEnd, dateFormat, undefined, dateFnsLocale), FORMAT_SWITCH_DATE) : '';
    }
    const {
      isTimePickerOpen,
      showDate
    } = panelDetail;
    const monthText = showDate ? format_format(showDate, FORMAT_SWITCH_DATE) : '';
    const timeText = showDate ? format_format(showDate, formatTimePicker) : '';
    const showSwitchIcon = ['default'].includes(density);
    const switchCls = classnames_default()(`${monthsGrid_prefixCls}-switch`);
    const dateCls = classnames_default()({
      [`${monthsGrid_prefixCls}-switch-date`]: true,
      [`${monthsGrid_prefixCls}-switch-date-active`]: !isTimePickerOpen
    });
    const timeCls = classnames_default()({
      [`${monthsGrid_prefixCls}-switch-time`]: true,
      [`${monthsGrid_prefixCls}-switch-time-disabled`]: disabledTimePicker,
      [`${monthsGrid_prefixCls}-switch-date-active`]: isTimePickerOpen
    });
    const textCls = classnames_default()(`${monthsGrid_prefixCls}-switch-text`);
    return /*#__PURE__*/react.createElement("div", {
      className: switchCls,
      ref: current => this.adapter.setCache(`switch-${panelType}`, current)
    }, /*#__PURE__*/react.createElement("div", {
      role: "button",
      "aria-label": "Switch to date panel",
      className: dateCls,
      onClick: e => this.foundation.showDatePanel(panelType)
    }, showSwitchIcon && /*#__PURE__*/react.createElement(IconCalendar, {
      "aria-hidden": true
    }), /*#__PURE__*/react.createElement("span", {
      className: textCls
    }, dateText || monthText)), /*#__PURE__*/react.createElement("div", {
      role: "button",
      "aria-label": "Switch to time panel",
      className: timeCls,
      onClick: e => this.foundation.showTimePicker(panelType, true)
    }, showSwitchIcon && /*#__PURE__*/react.createElement(IconClock, {
      "aria-hidden": true
    }), /*#__PURE__*/react.createElement("span", {
      className: textCls
    }, timeText)));
  }
  render() {
    const {
      monthLeft,
      monthRight
    } = this.state;
    const {
      type,
      insetInput,
      presetPosition,
      renderQuickControls,
      renderDateInput
    } = this.props;
    const monthGridCls = classnames_default()({
      [`${monthsGrid_prefixCls}-month-grid`]: true
    });
    const panelTypeLeft = datePicker_constants_strings.PANEL_TYPE_LEFT;
    const panelTypeRight = datePicker_constants_strings.PANEL_TYPE_RIGHT;
    let content = null;
    if (type === 'date' || type === 'dateTime') {
      content = this.renderPanel(monthLeft.pickerDate, panelTypeLeft);
    } else if (type === 'dateRange' || type === 'dateTimeRange') {
      content = [this.renderPanel(monthLeft.pickerDate, panelTypeLeft), this.renderPanel(monthRight.pickerDate, panelTypeRight)];
    } else if (type === 'year' || type === 'month') {
      content = 'year month';
    }
    const yearOpenType = this.getYAMOpenType();
    return /*#__PURE__*/react.createElement("div", {
      style: {
        display: 'flex'
      }
    }, presetPosition === "left" && renderQuickControls, /*#__PURE__*/react.createElement("div", null, renderDateInput, /*#__PURE__*/react.createElement("div", {
      className: monthGridCls,
      "x-type": type,
      "x-panel-yearandmonth-open-type": yearOpenType,
      "x-insetinput": insetInput ? "true" : "false",
      "x-preset-position": renderQuickControls === null ? 'null' : presetPosition,
      ref: current => this.cacheRefCurrent('monthGrid', current)
    }, content)), presetPosition === "right" && renderQuickControls);
  }
}
MonthsGrid.propTypes = {
  type: prop_types_default().oneOf(datePicker_constants_strings.TYPE_SET),
  defaultValue: (prop_types_default()).array,
  defaultPickerValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object, (prop_types_default()).array]),
  multiple: (prop_types_default()).bool,
  max: (prop_types_default()).number,
  weekStartsOn: (prop_types_default()).number,
  disabledDate: (prop_types_default()).func,
  disabledTime: (prop_types_default()).func,
  disabledTimePicker: (prop_types_default()).bool,
  hideDisabledOptions: (prop_types_default()).bool,
  navPrev: (prop_types_default()).node,
  navNext: (prop_types_default()).node,
  onMaxSelect: (prop_types_default()).func,
  timePickerOpts: (prop_types_default()).object,
  // Whether the outer datePicker is a controlled component
  isControlledComponent: (prop_types_default()).bool,
  rangeStart: prop_types_default().oneOfType([(prop_types_default()).string]),
  rangeInputFocus: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  locale: (prop_types_default()).object,
  localeCode: (prop_types_default()).string,
  format: (prop_types_default()).string,
  renderDate: (prop_types_default()).func,
  renderFullDate: (prop_types_default()).func,
  startDateOffset: (prop_types_default()).func,
  endDateOffset: (prop_types_default()).func,
  autoSwitchDate: (prop_types_default()).bool,
  density: (prop_types_default()).string,
  dateFnsLocale: (prop_types_default()).object.isRequired,
  timeZone: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  // Support synchronous switching of months
  syncSwitchMonth: (prop_types_default()).bool,
  // Callback function for panel date switching
  onPanelChange: (prop_types_default()).func,
  focusRecordsRef: (prop_types_default()).object,
  triggerRender: (prop_types_default()).func,
  presetPosition: prop_types_default().oneOf(datePicker_constants_strings.PRESET_POSITION_SET),
  renderQuickControls: (prop_types_default()).node,
  renderDateInput: (prop_types_default()).node
};
MonthsGrid.defaultProps = {
  type: 'date',
  rangeStart: '',
  multiple: false,
  weekStartsOn: datePicker_constants_numbers.WEEK_START_ON,
  disabledDate: (stubFalse_default()),
  onMaxSelect: (noop_default()),
  locale: {}
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/quickControl.js
/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */







const quickControl_prefixCls = datePicker_constants_cssClasses.PREFIX;
const {
  Text: quickControl_Text
} = es_typography;
class QuickControl extends react.PureComponent {
  render() {
    const {
      presets,
      onPresetClick,
      type,
      presetPosition,
      insetInput,
      locale
    } = this.props;
    const isTypeRange = type === 'dateRange' || type === 'dateTimeRange';
    const isPanelTopAndBottom = presetPosition === 'top' || presetPosition === 'bottom';
    const isMonth = type === 'month';
    const isTopAndBottomRange = isPanelTopAndBottom && isTypeRange;
    const isTopAndBottomMonth = isPanelTopAndBottom && isMonth;
    const wrapperCls = classnames_default()(`${quickControl_prefixCls}-quick-control`, {
      [`${quickControl_prefixCls}-quick-control-${type}`]: type,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}`]: true
    });
    const headerCls = classnames_default()({
      [`${quickControl_prefixCls}-quick-control-header`]: true
    });
    const contentWrapperCls = classnames_default()({
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-content-wrapper`]: true
    });
    const contentCls = classnames_default()({
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-content`]: !isTopAndBottomRange && !isTopAndBottomMonth,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-range-content`]: isTopAndBottomRange,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-month-content`]: isTopAndBottomMonth
    });
    const itemCls = classnames_default()({
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-content-item`]: !isTopAndBottomRange && !isTopAndBottomMonth,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-range-content-item`]: isTopAndBottomRange,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-month-content-item`]: isTopAndBottomMonth
    });
    const ellipsisCls = classnames_default()({
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-content-item-ellipsis`]: !isTopAndBottomRange && !isTopAndBottomMonth,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-range-content-item-ellipsis`]: isTopAndBottomRange,
      [`${quickControl_prefixCls}-quick-control-${presetPosition}-month-content-item-ellipsis`]: isTopAndBottomMonth
    });
    if (!presets.length) {
      return null;
    }
    return /*#__PURE__*/react.createElement("div", {
      className: wrapperCls,
      "x-insetinput": insetInput ? "true" : "false"
    }, !isPanelTopAndBottom && /*#__PURE__*/react.createElement("div", {
      className: headerCls
    }, locale.presets), /*#__PURE__*/react.createElement("div", {
      className: contentWrapperCls
    }, /*#__PURE__*/react.createElement("div", {
      className: contentCls
    }, presets.map((item, index) => {
      const _item = typeof item === 'function' ? item() : item;
      return /*#__PURE__*/react.createElement(es_button, {
        size: "small",
        type: "primary",
        onClick: e => onPresetClick(_item, e),
        key: index
      }, /*#__PURE__*/react.createElement("div", {
        className: itemCls
      }, /*#__PURE__*/react.createElement(quickControl_Text, {
        ellipsis: {
          showTooltip: true
        },
        className: ellipsisCls
      }, _item.text)));
    }))));
  }
}
QuickControl.propTypes = {
  presets: (prop_types_default()).array,
  presetPosition: prop_types_default().oneOf(datePicker_constants_strings.PRESET_POSITION_SET),
  onPresetClick: (prop_types_default()).func,
  type: (prop_types_default()).string,
  insetInput: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  locale: (prop_types_default()).object
};
QuickControl.defaultProps = {
  presets: [],
  presetPosition: 'bottom',
  onPresetClick: function_noop
};
/* harmony default export */ var quickControl = (QuickControl);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/footer.js




function Footer() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    prefixCls,
    locale,
    onCancelClick,
    onConfirmClick
  } = props;
  const wrapCls = classnames_default()(`${prefixCls}-footer`);
  return /*#__PURE__*/react.createElement("div", {
    className: wrapCls
  }, /*#__PURE__*/react.createElement(es_button, {
    theme: "borderless",
    onClick: onCancelClick
  }, get_default()(locale, 'footer.cancel', '')), /*#__PURE__*/react.createElement(es_button, {
    theme: "solid",
    onClick: onConfirmClick
  }, get_default()(locale, 'footer.confirm', '')));
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/datePicker.js







var datePicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */















// import '@douyinfe/semi-foundation/lib/es/datePicker/datePicker.css';

class DatePicker extends BaseComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.setTriggerRef = node => this.triggerElRef.current = node;
    // Called when changes are selected by clicking on the selected date
    this.handleSelectedChange = (v, options) => this.foundation.handleSelectedChange(v, options);
    // Called when the year and month change
    this.handleYMSelectedChange = item => this.foundation.handleYMSelectedChange(item);
    this.disabledDisposeDate = function (date) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return _this.foundation.disabledDisposeDate(date, ...rest);
    };
    this.disabledDisposeTime = function (date) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      return _this.foundation.disabledDisposeTime(date, ...rest);
    };
    this.handleOpenPanel = () => this.foundation.openPanel();
    this.handleInputChange = function () {
      return _this.foundation.handleInputChange(...arguments);
    };
    this.handleInsetInputChange = options => this.foundation.handleInsetInputChange(options);
    this.handleInputComplete = v => this.foundation.handleInputComplete(v);
    this.handleInputBlur = e => this.foundation.handleInputBlur(get_default()(e, 'nativeEvent.target.value'), e);
    this.handleInputFocus = function () {
      return _this.foundation.handleInputFocus(...arguments);
    };
    this.handleInputClear = e => this.foundation.handleInputClear(e);
    this.handleTriggerWrapperClick = e => this.foundation.handleTriggerWrapperClick(e);
    this.handleSetRangeFocus = rangeInputFocus => this.foundation.handleSetRangeFocus(rangeInputFocus);
    this.handleRangeInputBlur = (value, e) => this.foundation.handleRangeInputBlur(value, e);
    this.handleRangeInputClear = e => this.foundation.handleRangeInputClear(e);
    this.handleRangeEndTabPress = e => this.foundation.handleRangeEndTabPress(e);
    this.isAnotherPanelHasOpened = currentRangeInput => {
      if (currentRangeInput === 'rangeStart') {
        return this.focusRecordsRef.current.rangeEnd;
      } else {
        return this.focusRecordsRef.current.rangeStart;
      }
    };
    this.handleInsetDateFocus = (e, rangeType) => {
      const monthGridFoundation = get_default()(this, 'monthGrid.current.foundation');
      if (monthGridFoundation) {
        monthGridFoundation.showDatePanel(datePicker_constants_strings.PANEL_TYPE_LEFT);
        monthGridFoundation.showDatePanel(datePicker_constants_strings.PANEL_TYPE_RIGHT);
      }
      this.handleInputFocus(e, rangeType);
    };
    this.handleInsetTimeFocus = () => {
      const monthGridFoundation = get_default()(this, 'monthGrid.current.foundation');
      if (monthGridFoundation) {
        monthGridFoundation.showTimePicker(datePicker_constants_strings.PANEL_TYPE_LEFT);
        monthGridFoundation.showTimePicker(datePicker_constants_strings.PANEL_TYPE_RIGHT);
      }
    };
    this.handlePanelVisibleChange = visible => {
      this.foundation.handlePanelVisibleChange(visible);
    };
    this.handleConfirm = e => this.foundation.handleConfirm();
    this.handleCancel = e => this.foundation.handleCancel();
    this.renderFooter = (locale, localeCode) => {
      if (this.adapter.needConfirm()) {
        return /*#__PURE__*/react.createElement(Footer, Object.assign({}, this.props, {
          locale: locale,
          localeCode: localeCode,
          onConfirmClick: this.handleConfirm,
          onCancelClick: this.handleCancel
        }));
      }
      return null;
    };
    this.renderPanel = (locale, localeCode, dateFnsLocale) => {
      const {
        dropdownClassName,
        dropdownStyle,
        density,
        topSlot,
        bottomSlot,
        presetPosition,
        type
      } = this.props;
      const wrapCls = classnames_default()(datePicker_constants_cssClasses.PREFIX, {
        [datePicker_constants_cssClasses.PANEL_YAM]: this.adapter.typeIsYearOrMonth(),
        [`${datePicker_constants_cssClasses.PREFIX}-compact`]: density === 'compact'
      }, dropdownClassName);
      return /*#__PURE__*/react.createElement("div", {
        ref: this.panelRef,
        className: wrapCls,
        style: dropdownStyle,
        "x-type": type
      }, topSlot && /*#__PURE__*/react.createElement("div", {
        className: `${datePicker_constants_cssClasses.PREFIX}-topSlot`,
        "x-semi-prop": "topSlot"
      }, topSlot), presetPosition === "top" && type !== 'monthRange' && this.renderQuickControls(), this.adapter.typeIsYearOrMonth() ? this.renderYearMonthPanel(locale, localeCode) : this.renderMonthGrid(locale, localeCode, dateFnsLocale), presetPosition === "bottom" && type !== 'monthRange' && this.renderQuickControls(), bottomSlot && /*#__PURE__*/react.createElement("div", {
        className: `${datePicker_constants_cssClasses.PREFIX}-bottomSlot`,
        "x-semi-prop": "bottomSlot"
      }, bottomSlot), this.renderFooter(locale, localeCode));
    };
    this.renderYearMonthPanel = (locale, localeCode) => {
      const {
        density,
        presetPosition,
        yearAndMonthOpts,
        type,
        startYear,
        endYear
      } = this.props;
      const date = this.state.value[0];
      const year = {
        left: 0,
        right: 0
      };
      const month = {
        left: 0,
        right: 0
      };
      if (isDate_default()(date)) {
        year.left = date.getFullYear();
        month.left = date.getMonth() + 1;
      }
      if (type === 'monthRange') {
        const dateRight = this.state.value[1];
        if (isDate_default()(dateRight)) {
          year.right = dateRight.getFullYear();
          month.right = dateRight.getMonth() + 1;
        }
      }
      return /*#__PURE__*/react.createElement(yearAndMonth, {
        locale: locale,
        localeCode: localeCode,
        disabledDate: this.disabledDisposeDate,
        noBackBtn: true,
        monthCycled: true,
        onSelect: this.handleYMSelectedChange,
        currentYear: year,
        currentMonth: month,
        density: density,
        presetPosition: presetPosition,
        renderQuickControls: this.renderQuickControls(),
        renderDateInput: this.renderDateInput(),
        type: type,
        yearAndMonthOpts: yearAndMonthOpts,
        startYear: startYear,
        endYear: endYear
      });
    };
    this.wrapPopover = children => {
      const {
        panelShow
      } = this.state;
      // rtl changes the default position
      const {
        direction
      } = this.context;
      const defaultPosition = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
      const {
        motion,
        zIndex,
        position = defaultPosition,
        getPopupContainer,
        locale,
        localeCode,
        dateFnsLocale,
        stopPropagation,
        autoAdjustOverflow,
        spacing,
        dropdownMargin
      } = this.props;
      return /*#__PURE__*/react.createElement(popover, {
        getPopupContainer: getPopupContainer,
        // wrapWhenSpecial={false}
        autoAdjustOverflow: autoAdjustOverflow,
        zIndex: zIndex,
        motion: motion,
        margin: dropdownMargin,
        content: this.renderPanel(locale, localeCode, dateFnsLocale),
        trigger: "custom",
        position: position,
        visible: panelShow,
        stopPropagation: stopPropagation,
        spacing: spacing,
        onVisibleChange: this.handlePanelVisibleChange
      }, children);
    };
    this.state = {
      panelShow: props.open || props.defaultOpen,
      isRange: false,
      inputValue: null,
      value: [],
      cachedSelectedValue: [],
      prevTimeZone: null,
      rangeInputFocus: undefined,
      autofocus: props.autoFocus || this.isRangeType(props.type, props.triggerRender) && (props.open || props.defaultOpen),
      insetInputValue: null,
      triggerDisabled: undefined
    };
    this.triggerElRef = /*#__PURE__*/react.createRef();
    this.panelRef = /*#__PURE__*/react.createRef();
    this.monthGrid = /*#__PURE__*/react.createRef();
    this.inputRef = /*#__PURE__*/react.createRef();
    this.rangeInputStartRef = /*#__PURE__*/react.createRef();
    this.rangeInputEndRef = /*#__PURE__*/react.createRef();
    this.focusRecordsRef = /*#__PURE__*/react.createRef();
    // @ts-ignore ignore readonly
    this.focusRecordsRef.current = {
      rangeStart: false,
      rangeEnd: false
    };
    this.foundation = new DatePickerFoundation(this.adapter);
  }
  get adapter() {
    var _this2 = this;
    return Object.assign(Object.assign({}, super.adapter), {
      togglePanel: (panelShow, cb) => {
        this.setState({
          panelShow
        }, cb);
        if (!panelShow) {
          this.focusRecordsRef.current.rangeEnd = false;
          this.focusRecordsRef.current.rangeStart = false;
        }
      },
      registerClickOutSide: () => {
        if (this.clickOutSideHandler) {
          this.adapter.unregisterClickOutSide();
          this.clickOutSideHandler = null;
        }
        this.clickOutSideHandler = e => {
          const triggerEl = this.triggerElRef && this.triggerElRef.current;
          const panelEl = this.panelRef && this.panelRef.current;
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (!(triggerEl && triggerEl.contains(target)) && !(panelEl && panelEl.contains(target)) && !(path.includes(triggerEl) || path.includes(panelEl))) {
            this.props.onClickOutSide();
            if (!this.adapter.needConfirm()) {
              this.foundation.closePanel(e);
            }
          }
        };
        document.addEventListener('mousedown', this.clickOutSideHandler);
      },
      unregisterClickOutSide: () => {
        document.removeEventListener('mousedown', this.clickOutSideHandler);
      },
      notifyBlur: function () {
        return _this2.props.onBlur(...arguments);
      },
      notifyFocus: function () {
        return _this2.props.onFocus(...arguments);
      },
      notifyClear: function () {
        return _this2.props.onClear(...arguments);
      },
      notifyChange: function () {
        return _this2.props.onChange(...arguments);
      },
      notifyCancel: function () {
        return _this2.props.onCancel(...arguments);
      },
      notifyConfirm: function () {
        return _this2.props.onConfirm(...arguments);
      },
      notifyOpenChange: function () {
        return _this2.props.onOpenChange(...arguments);
      },
      notifyPresetsClick: function () {
        return _this2.props.onPresetClick(...arguments);
      },
      updateValue: value => this.setState({
        value
      }),
      updatePrevTimezone: prevTimeZone => this.setState({
        prevTimeZone
      }),
      updateCachedSelectedValue: cachedSelectedValue => {
        let _cachedSelectedValue = cachedSelectedValue;
        if (cachedSelectedValue && !Array.isArray(cachedSelectedValue)) {
          _cachedSelectedValue = [...cachedSelectedValue];
        }
        this.setState({
          cachedSelectedValue: _cachedSelectedValue
        });
      },
      updateInputValue: inputValue => {
        this.setState({
          inputValue
        });
      },
      updateInsetInputValue: insetInputValue => {
        const {
          insetInput
        } = this.props;
        if (insetInput && !isEqual_default()(insetInputValue, this.state.insetInputValue)) {
          this.setState({
            insetInputValue
          });
        }
      },
      needConfirm: () => ['dateTime', 'dateTimeRange'].includes(this.props.type) && this.props.needConfirm === true,
      typeIsYearOrMonth: () => ['month', 'year', 'monthRange'].includes(this.props.type),
      setRangeInputFocus: rangeInputFocus => {
        const {
          preventScroll
        } = this.props;
        if (rangeInputFocus !== this.state.rangeInputFocus) {
          this.setState({
            rangeInputFocus
          });
        }
        switch (rangeInputFocus) {
          case 'rangeStart':
            const inputStartNode = get_default()(this, 'rangeInputStartRef.current');
            inputStartNode && inputStartNode.focus({
              preventScroll
            });
            /**
             * 解决选择完startDate，切换到endDate后panel被立马关闭的问题。
             * 用户打开panel，选了startDate后，会执行setRangeInputFocus('rangeEnd'),focus到endDateInput，
             * 同时会走到datePicker/foundation.js中的handleSelectedChange方法，在这个方法里会根据focusRecordsRef来判断是否可以关闭panel。
             * 如果在setRangeInputFocus里同步修改了focusRecordsRef的状态为true，那在handleSelectedChange里会误判startDate和endDate都已经完成选择，
             * 导致endDate还没选就关闭了panel
             *
             * Fix the problem that the panel is closed immediately after switching to endDate after starting Date is selected.
             * The user opens the panel and after starting Date is selected, setRangeInputFocus ('rangeEnd') will be executed, focus to endDateInput,
             * At the same time, it will go to the handleSelectedChange method in datePicker/foundation.js, where it will be determined whether the panel can be closed according to focusRecordsRef.
             * If the status of focusRecordsRef is modified synchronously in setRangeInputFocus to true, then in handleSelectedChange it will be misjudged that both begDate and endDate have completed the selection,
             * resulting in the panel being closed before endDate is selected
             */
            setTimeout(() => {
              this.focusRecordsRef.current.rangeStart = true;
            }, 0);
            break;
          case 'rangeEnd':
            const inputEndNode = get_default()(this, 'rangeInputEndRef.current');
            inputEndNode && inputEndNode.focus({
              preventScroll
            });
            /**
             * 解决选择完startDate，切换到endDate后panel被立马关闭的问题。
             * 用户打开panel，选了startDate后，会执行setRangeInputFocus('rangeEnd'),focus到endDateInput，
             * 同时会走到datePicker/foundation.js中的handleSelectedChange方法，在这个方法里会根据focusRecordsRef来判断是否可以关闭panel。
             * 如果在setRangeInputFocus里同步修改了focusRecordsRef的状态为true，那在handleSelectedChange里会误判startDate和endDate都已经完成选择，
             * 导致endDate还没选就关闭了panel
             *
             * Fix the problem that the panel is closed immediately after switching to endDate after starting Date is selected.
             * The user opens the panel and after starting Date is selected, setRangeInputFocus ('rangeEnd') will be executed, focus to endDateInput,
             * At the same time, it will go to the handleSelectedChange method in datePicker/foundation.js, where it will be determined whether the panel can be closed according to focusRecordsRef.
             * If the status of focusRecordsRef is modified synchronously in setRangeInputFocus to true, then in handleSelectedChange it will be misjudged that both begDate and endDate have completed the selection,
             * resulting in the panel being closed before endDate is selected
             */
            setTimeout(() => {
              this.focusRecordsRef.current.rangeEnd = true;
            }, 0);
            break;
          default:
            return;
        }
      },
      couldPanelClosed: () => this.focusRecordsRef.current.rangeStart && this.focusRecordsRef.current.rangeEnd,
      isEventTarget: e => e && e.target === e.currentTarget,
      setInsetInputFocus: () => {
        const {
          preventScroll
        } = this.props;
        const {
          rangeInputFocus
        } = this.state;
        switch (rangeInputFocus) {
          case 'rangeEnd':
            if (document.activeElement !== this.rangeInputEndRef.current) {
              const inputEndNode = get_default()(this, 'rangeInputEndRef.current');
              inputEndNode && inputEndNode.focus({
                preventScroll
              });
            }
            break;
          case 'rangeStart':
          default:
            if (document.activeElement !== this.rangeInputStartRef.current) {
              const inputStartNode = get_default()(this, 'rangeInputStartRef.current');
              inputStartNode && inputStartNode.focus({
                preventScroll
              });
            }
            break;
        }
      },
      setInputFocus: () => {
        const {
          preventScroll
        } = this.props;
        const inputNode = get_default()(this, 'inputRef.current');
        inputNode && inputNode.focus({
          preventScroll
        });
      },
      setInputBlur: () => {
        const inputNode = get_default()(this, 'inputRef.current');
        inputNode && inputNode.blur();
      },
      setRangeInputBlur: () => {
        const {
          rangeInputFocus
        } = this.state;
        if (rangeInputFocus === 'rangeStart') {
          const inputStartNode = get_default()(this, 'rangeInputStartRef.current');
          inputStartNode && inputStartNode.blur();
        } else if (rangeInputFocus === 'rangeEnd') {
          const inputEndNode = get_default()(this, 'rangeInputEndRef.current');
          inputEndNode && inputEndNode.blur();
        }
        this.adapter.setRangeInputFocus(false);
      },
      setTriggerDisabled: disabled => {
        this.setState({
          triggerDisabled: disabled
        });
      }
    });
  }
  isRangeType(type, triggerRender) {
    return /range/i.test(type) && !isFunction_default()(triggerRender);
  }
  componentDidUpdate(prevProps) {
    if (!isEqual_default()(prevProps.value, this.props.value)) {
      this.foundation.initFromProps(Object.assign({}, this.props));
    } else if (this.props.timeZone !== prevProps.timeZone) {
      this.foundation.initFromProps({
        value: this.state.value,
        timeZone: this.props.timeZone,
        prevTimeZone: prevProps.timeZone
      });
    }
    if (prevProps.open !== this.props.open) {
      this.foundation.initPanelOpenStatus();
      if (!this.props.open) {
        this.foundation.clearRangeInputFocus();
      }
    }
  }
  componentDidMount() {
    this._mounted = true;
    super.componentDidMount();
  }
  componentWillUnmount() {
    this._mounted = false;
    super.componentWillUnmount();
  }
  open() {
    this.foundation.open();
  }
  close() {
    this.foundation.close();
  }
  /**
   *
   * When selecting a range, the default focus is on the start input box, passing in `rangeEnd` can focus on the end input box
   *
   * When `insetInput` is `true`, due to trigger disabled, the cursor will focus on the input box of the popup layer panel
   *
   * 范围选择时，默认聚焦在开始输入框，传入 `rangeEnd` 可以聚焦在结束输入框
   *
   * `insetInput` 打开时，由于 trigger 禁用，会把焦点放在弹出面板的输入框上
   */
  focus(focusType) {
    this.foundation.focus(focusType);
  }
  blur() {
    this.foundation.blur();
  }
  renderMonthGrid(locale, localeCode, dateFnsLocale) {
    const {
      type,
      multiple,
      max,
      weekStartsOn,
      timePickerOpts,
      defaultPickerValue,
      format,
      hideDisabledOptions,
      disabledTimePicker,
      renderDate,
      renderFullDate,
      startDateOffset,
      endDateOffset,
      autoSwitchDate,
      density,
      syncSwitchMonth,
      onPanelChange,
      timeZone,
      triggerRender,
      insetInput,
      presetPosition,
      yearAndMonthOpts,
      startYear,
      endYear
    } = this.props;
    const {
      cachedSelectedValue,
      rangeInputFocus
    } = this.state;
    const defaultValue = cachedSelectedValue;
    return /*#__PURE__*/react.createElement(MonthsGrid, {
      ref: this.monthGrid,
      locale: locale,
      localeCode: localeCode,
      dateFnsLocale: dateFnsLocale,
      weekStartsOn: weekStartsOn,
      type: type,
      multiple: multiple,
      max: max,
      format: format,
      disabledDate: this.disabledDisposeDate,
      hideDisabledOptions: hideDisabledOptions,
      disabledTimePicker: disabledTimePicker,
      disabledTime: this.disabledDisposeTime,
      defaultValue: defaultValue,
      defaultPickerValue: defaultPickerValue,
      timePickerOpts: timePickerOpts,
      isControlledComponent: !this.adapter.needConfirm() && this.isControlled('value'),
      onChange: this.handleSelectedChange,
      renderDate: renderDate,
      renderFullDate: renderFullDate,
      startDateOffset: startDateOffset,
      endDateOffset: endDateOffset,
      autoSwitchDate: autoSwitchDate,
      density: density,
      rangeInputFocus: rangeInputFocus,
      setRangeInputFocus: this.handleSetRangeFocus,
      isAnotherPanelHasOpened: this.isAnotherPanelHasOpened,
      syncSwitchMonth: syncSwitchMonth,
      onPanelChange: onPanelChange,
      timeZone: timeZone,
      focusRecordsRef: this.focusRecordsRef,
      triggerRender: triggerRender,
      insetInput: insetInput,
      presetPosition: presetPosition,
      renderQuickControls: this.renderQuickControls(),
      renderDateInput: this.renderDateInput(),
      yearAndMonthOpts: yearAndMonthOpts,
      startYear: startYear,
      endYear: endYear
    });
  }
  renderQuickControls() {
    const {
      presets,
      type,
      presetPosition,
      insetInput,
      locale
    } = this.props;
    return /*#__PURE__*/react.createElement(quickControl, {
      type: type,
      presets: presets,
      insetInput: insetInput,
      presetPosition: presetPosition,
      onPresetClick: (item, e) => this.foundation.handlePresetClick(item, e),
      locale: locale
    });
  }
  renderDateInput() {
    const {
      insetInput,
      dateFnsLocale,
      density,
      type,
      format,
      rangeSeparator,
      defaultPickerValue
    } = this.props;
    const {
      insetInputValue,
      value
    } = this.state;
    const props = {
      dateFnsLocale,
      format,
      insetInputValue,
      rangeSeparator,
      type,
      value: value,
      handleInsetDateFocus: this.handleInsetDateFocus,
      handleInsetTimeFocus: this.handleInsetTimeFocus,
      onInsetInputChange: this.handleInsetInputChange,
      rangeInputStartRef: this.rangeInputStartRef,
      rangeInputEndRef: this.rangeInputEndRef,
      density,
      defaultPickerValue
    };
    return insetInput ? /*#__PURE__*/react.createElement(DateInput, Object.assign({}, props, {
      insetInput: insetInput
    })) : null;
  }
  renderInner(extraProps) {
    const {
      clearIcon,
      type,
      format,
      multiple,
      disabled,
      showClear,
      insetLabel,
      insetLabelId,
      placeholder,
      validateStatus,
      inputStyle,
      prefix,
      locale,
      dateFnsLocale,
      triggerRender,
      size,
      inputReadOnly,
      rangeSeparator,
      insetInput,
      defaultPickerValue,
      borderless
    } = this.props;
    const {
      value,
      inputValue,
      rangeInputFocus,
      triggerDisabled
    } = this.state;
    // This class is not needed when triggerRender is function
    const isRangeType = this.isRangeType(type, triggerRender);
    const inputDisabled = disabled || insetInput && triggerDisabled;
    const inputCls = classnames_default()(`${datePicker_constants_cssClasses.PREFIX}-input`, {
      [`${datePicker_constants_cssClasses.PREFIX}-range-input`]: isRangeType,
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-${size}`]: isRangeType && size,
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-active`]: isRangeType && rangeInputFocus && !inputDisabled,
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-disabled`]: isRangeType && inputDisabled,
      [`${datePicker_constants_cssClasses.PREFIX}-range-input-${validateStatus}`]: isRangeType && validateStatus,
      [`${datePicker_constants_cssClasses.PREFIX}-borderless`]: borderless
    });
    const phText = placeholder || locale.placeholder[type]; // i18n
    // These values should be passed to triggerRender, do not delete any key if it is not necessary
    const props = Object.assign(Object.assign({}, extraProps), {
      showClearIgnoreDisabled: Boolean(insetInput),
      placeholder: phText,
      clearIcon,
      disabled: inputDisabled,
      inputValue,
      value: value,
      defaultPickerValue,
      onChange: this.handleInputChange,
      onEnterPress: this.handleInputComplete,
      // TODO: remove in next major version
      block: true,
      inputStyle,
      showClear,
      insetLabel,
      insetLabelId,
      type,
      format,
      multiple,
      validateStatus,
      inputReadOnly: inputReadOnly || Boolean(insetInput),
      // onClick: this.handleOpenPanel,
      onBlur: this.handleInputBlur,
      onFocus: this.handleInputFocus,
      onClear: this.handleInputClear,
      prefix,
      size,
      autofocus: this.state.autofocus,
      dateFnsLocale,
      rangeInputFocus,
      rangeSeparator,
      onRangeBlur: this.handleRangeInputBlur,
      onRangeClear: this.handleRangeInputClear,
      onRangeEndTabPress: this.handleRangeEndTabPress,
      rangeInputStartRef: insetInput ? null : this.rangeInputStartRef,
      rangeInputEndRef: insetInput ? null : this.rangeInputEndRef,
      inputRef: this.inputRef
    });
    return /*#__PURE__*/react.createElement("div", {
      // tooltip will mount a11y props to children
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      role: "combobox",
      "aria-label": Array.isArray(value) && value.length ? "Change date" : "Choose date",
      "aria-disabled": disabled,
      onClick: this.handleTriggerWrapperClick,
      className: inputCls
    }, typeof triggerRender === 'function' ? /*#__PURE__*/react.createElement(trigger, Object.assign({}, props, {
      triggerRender: triggerRender,
      componentName: "DatePicker",
      componentProps: Object.assign({}, this.props)
    })) : /*#__PURE__*/react.createElement(DateInput, Object.assign({}, props)));
  }
  render() {
    const _a = this.props,
      {
        style,
        className,
        prefixCls,
        type
      } = _a,
      rest = datePicker_rest(_a, ["style", "className", "prefixCls", "type"]);
    const outerProps = Object.assign({
      style,
      className: classnames_default()(className, {
        [prefixCls]: true
      }),
      ref: this.setTriggerRef,
      'aria-invalid': this.props['aria-invalid'],
      'aria-errormessage': this.props['aria-errormessage'],
      'aria-labelledby': this.props['aria-labelledby'],
      'aria-describedby': this.props['aria-describedby'],
      'aria-required': this.props['aria-required']
    }, this.getDataAttr(rest));
    const innerPropKeys = [];
    if (!type.toLowerCase().includes("range")) {
      innerPropKeys.push("borderless");
    }
    const inner = this.renderInner(pick_default()(this.props, innerPropKeys));
    const wrappedInner = this.wrapPopover(inner);
    return /*#__PURE__*/react.createElement("div", Object.assign({}, outerProps), wrappedInner);
  }
}
DatePicker.contextType = context;
DatePicker.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  borderless: (prop_types_default()).bool,
  type: prop_types_default().oneOf(datePicker_constants_strings.TYPE_SET),
  size: prop_types_default().oneOf(datePicker_constants_strings.SIZE_SET),
  clearIcon: (prop_types_default()).node,
  density: prop_types_default().oneOf(datePicker_constants_strings.DENSITY_SET),
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object, (prop_types_default()).array]),
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object, (prop_types_default()).array]),
  defaultPickerValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object, (prop_types_default()).array]),
  disabledTime: (prop_types_default()).func,
  disabledTimePicker: (prop_types_default()).bool,
  hideDisabledOptions: (prop_types_default()).bool,
  format: (prop_types_default()).string,
  disabled: (prop_types_default()).bool,
  multiple: (prop_types_default()).bool,
  max: (prop_types_default()).number,
  placeholder: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  presets: (prop_types_default()).array,
  presetPosition: prop_types_default().oneOf(datePicker_constants_strings.PRESET_POSITION_SET),
  onChange: (prop_types_default()).func,
  onChangeWithDateFirst: (prop_types_default()).bool,
  weekStartsOn: (prop_types_default()).number,
  disabledDate: (prop_types_default()).func,
  timePickerOpts: (prop_types_default()).object,
  showClear: (prop_types_default()).bool,
  onOpenChange: (prop_types_default()).func,
  open: (prop_types_default()).bool,
  defaultOpen: (prop_types_default()).bool,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  className: (prop_types_default()).string,
  prefixCls: (prop_types_default()).string,
  prefix: (prop_types_default()).node,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  zIndex: (prop_types_default()).number,
  position: prop_types_default().oneOf(popover_constants_strings.POSITION_SET),
  getPopupContainer: (prop_types_default()).func,
  onCancel: (prop_types_default()).func,
  onConfirm: (prop_types_default()).func,
  needConfirm: (prop_types_default()).bool,
  inputStyle: (prop_types_default()).object,
  timeZone: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  triggerRender: (prop_types_default()).func,
  stopPropagation: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  autoAdjustOverflow: (prop_types_default()).bool,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  style: (prop_types_default()).object,
  autoFocus: (prop_types_default()).bool,
  inputReadOnly: (prop_types_default()).bool,
  validateStatus: prop_types_default().oneOf(datePicker_constants_strings.STATUS),
  renderDate: (prop_types_default()).func,
  renderFullDate: (prop_types_default()).func,
  spacing: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  startDateOffset: (prop_types_default()).func,
  endDateOffset: (prop_types_default()).func,
  autoSwitchDate: (prop_types_default()).bool,
  dropdownClassName: (prop_types_default()).string,
  dropdownStyle: (prop_types_default()).object,
  dropdownMargin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  topSlot: (prop_types_default()).node,
  bottomSlot: (prop_types_default()).node,
  dateFnsLocale: (prop_types_default()).object,
  // Support synchronous switching of months
  syncSwitchMonth: (prop_types_default()).bool,
  // Callback function for panel date switching
  onPanelChange: (prop_types_default()).func,
  rangeSeparator: (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool,
  yearAndMonthOpts: (prop_types_default()).object,
  onClickOutSide: (prop_types_default()).func
};
DatePicker.__SemiComponentName__ = "DatePicker";
DatePicker.defaultProps = getDefaultPropsFromGlobalConfig(DatePicker.__SemiComponentName__, {
  onChangeWithDateFirst: true,
  borderless: false,
  autoAdjustOverflow: true,
  stopPropagation: true,
  motion: true,
  prefixCls: datePicker_constants_cssClasses.PREFIX,
  presetPosition: 'bottom',
  // position: 'bottomLeft',
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  type: 'date',
  size: 'default',
  density: 'default',
  multiple: false,
  defaultOpen: false,
  disabledHours: (noop_default()),
  disabledMinutes: (noop_default()),
  disabledSeconds: (noop_default()),
  hideDisabledOptions: false,
  onBlur: (noop_default()),
  onFocus: (noop_default()),
  onClear: (noop_default()),
  onCancel: (noop_default()),
  onConfirm: (noop_default()),
  onChange: (noop_default()),
  onOpenChange: (noop_default()),
  onPanelChange: (noop_default()),
  onPresetClick: (noop_default()),
  weekStartsOn: datePicker_constants_numbers.WEEK_START_ON,
  disabledDate: (stubFalse_default()),
  disabledTime: (stubFalse_default()),
  inputReadOnly: false,
  spacing: datePicker_constants_numbers.SPACING,
  autoSwitchDate: true,
  syncSwitchMonth: false,
  rangeSeparator: datePicker_constants_strings.DEFAULT_SEPARATOR_RANGE,
  insetInput: false,
  onClickOutSide: (noop_default())
});
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/datePicker/index.js






/* harmony default export */ var datePicker = (forwardStatics( /*#__PURE__*/react.forwardRef((props, ref) => {
  const propsObj = Object.assign({}, props);
  const {
    type,
    format,
    rangeSeparator
  } = propsObj;
  if (typeof format === 'string' && format) {
    if (!/[Hhms]+/.test(format)) {
      if (type === 'dateTime') {
        propsObj.type = 'date';
      } else if (type === 'dateTimeRange') {
        propsObj.type = 'dateRange';
      }
    }
  }
  // Add spaces at both ends to prevent conflicts with characters in the date when separating
  if (rangeSeparator && typeof rangeSeparator === 'string') {
    propsObj.rangeSeparator = ` ${rangeSeparator.trim()} `;
  }
  if (propsObj.insetInput) {
    if (!propsObj.position) {
      propsObj.position = datePicker_constants_strings.POSITION_INLINE_INPUT;
    }
    /**
     * When insetInput is `true` and `position` includes `over`, use 1px `spacing` to solve the problem of border-radius leakage in the upper left corner
     *
     * @see https://user-images.githubusercontent.com/26477537/158817185-126a5f33-41f7-414a-8e36-8d1be2dda5cd.png
     */
    if (propsObj.position.includes('Over') && !propsObj.spacing) {
      propsObj.spacing = datePicker_constants_numbers.SPACING_INSET_INPUT;
    }
  }
  return /*#__PURE__*/react.createElement(context.Consumer, null, _ref => {
    let {
      timeZone
    } = _ref;
    return /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: 'DatePicker'
    }, (locale, localeCode, dateFnsLocale) => /*#__PURE__*/react.createElement(DatePicker, Object.assign({
      timeZone: timeZone,
      localeCode: localeCode,
      locale: locale,
      dateFnsLocale: dateFnsLocale
    }, propsObj, {
      ref: ref
    })));
  });
}), DatePicker));
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/switch/foundation.js


class SwitchFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.handleFocusVisible = event => {
      const {
        target
      } = event;
      try {
        if (target.matches(':focus-visible')) {
          this._adapter.setFocusVisible(true);
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Switch] The current browser does not support the focus-visible');
      }
    };
    this.handleBlur = () => {
      this._adapter.setFocusVisible(false);
    };
  }
  init() {
    const {
      disabled
    } = this.getProps();
    this.setDisabled(disabled);
  }
  setChecked(checked) {
    this._adapter.setNativeControlChecked(checked);
  }
  setDisabled(disabled) {
    this._adapter.setNativeControlDisabled(disabled);
  }
  handleChange(checked, e) {
    const propChecked = this.getProps().checked;
    const isControlledComponent = typeof propChecked !== 'undefined';
    if (isControlledComponent) {
      this._adapter.notifyChange(checked, e);
    } else {
      this._adapter.setNativeControlChecked(checked);
      this._adapter.notifyChange(checked, e);
    }
  }
  destroy() {}
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/switch/constants.js

const switch_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-switch`,
  FOCUS: `${BASE_CLASS_PREFIX}-switch-focus`,
  LARGE: `${BASE_CLASS_PREFIX}-switch-large`,
  SMALL: `${BASE_CLASS_PREFIX}-switch-small`,
  CHECKED: `${BASE_CLASS_PREFIX}-switch-checked`,
  DISABLED: `${BASE_CLASS_PREFIX}-switch-disabled`,
  ACTIVE: `${BASE_CLASS_PREFIX}-switch-active`,
  KNOB: `${BASE_CLASS_PREFIX}-switch-knob`,
  NATIVE_CONTROL: `${BASE_CLASS_PREFIX}-switch-native-control`,
  CHECKED_TEXT: `${BASE_CLASS_PREFIX}-switch-checked-text`,
  UNCHECKED_TEXT: `${BASE_CLASS_PREFIX}-switch-unchecked-text`,
  LOADING_SPIN: `${BASE_CLASS_PREFIX}-switch-loading-spin`,
  LOADING: `${BASE_CLASS_PREFIX}-switch-loading`
};
const switch_constants_strings = {
  SIZE_MAP: ['default', 'small', 'large']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/switch/index.js

var switch_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






// import '@douyinfe/semi-foundation/lib/es/switch/switch.css';

class Switch extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleFocusVisible = event => {
      this.foundation.handleFocusVisible(event);
    };
    this.handleBlur = event => {
      this.foundation.handleBlur();
    };
    this.state = {
      nativeControlChecked: props.defaultChecked || props.checked,
      nativeControlDisabled: false,
      focusVisible: false
    };
    this.switchRef = /*#__PURE__*/react.createRef();
    this.foundation = new SwitchFoundation(this.adapter);
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      this.foundation.setChecked(this.props.checked);
    }
    if (this.props.disabled !== prevProps.disabled) {
      this.foundation.setDisabled(this.props.disabled);
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setNativeControlChecked: nativeControlChecked => {
        this.setState({
          nativeControlChecked
        });
      },
      setNativeControlDisabled: nativeControlDisabled => {
        this.setState({
          nativeControlDisabled
        });
      },
      setFocusVisible: focusVisible => {
        this.setState({
          focusVisible
        });
      },
      notifyChange: (checked, e) => {
        this.props.onChange(checked, e);
      }
    });
  }
  render() {
    const {
      nativeControlChecked,
      nativeControlDisabled,
      focusVisible
    } = this.state;
    const _a = this.props,
      {
        className,
        style,
        onMouseEnter,
        onMouseLeave,
        size,
        checkedText,
        uncheckedText,
        loading,
        id
      } = _a,
      rest = switch_rest(_a, ["className", "style", "onMouseEnter", "onMouseLeave", "size", "checkedText", "uncheckedText", "loading", "id"]);
    const wrapperCls = classnames_default()(className, {
      [switch_constants_cssClasses.PREFIX]: true,
      [switch_constants_cssClasses.CHECKED]: nativeControlChecked,
      [switch_constants_cssClasses.DISABLED]: nativeControlDisabled,
      [switch_constants_cssClasses.LARGE]: size === 'large',
      [switch_constants_cssClasses.SMALL]: size === 'small',
      [switch_constants_cssClasses.LOADING]: loading,
      [switch_constants_cssClasses.FOCUS]: focusVisible
    });
    const switchProps = {
      type: 'checkbox',
      className: switch_constants_cssClasses.NATIVE_CONTROL,
      disabled: nativeControlDisabled || loading,
      checked: nativeControlChecked || false
    };
    const showCheckedText = checkedText && nativeControlChecked && size !== 'small';
    const showUncheckedText = uncheckedText && !nativeControlChecked && size !== 'small';
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: wrapperCls,
      style: style,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, this.getDataAttr(rest)), loading ? /*#__PURE__*/react.createElement(spin, {
      wrapperClassName: switch_constants_cssClasses.LOADING_SPIN,
      size: size === 'default' ? 'middle' : size
    }) : /*#__PURE__*/react.createElement("div", {
      className: switch_constants_cssClasses.KNOB,
      "aria-hidden": true
    }), showCheckedText ? /*#__PURE__*/react.createElement("div", {
      className: switch_constants_cssClasses.CHECKED_TEXT,
      "x-semi-prop": "checkedText"
    }, checkedText) : null, showUncheckedText ? /*#__PURE__*/react.createElement("div", {
      className: switch_constants_cssClasses.UNCHECKED_TEXT,
      "x-semi-prop": "uncheckedText"
    }, uncheckedText) : null, /*#__PURE__*/react.createElement("input", Object.assign({}, switchProps, {
      ref: this.switchRef,
      id: id,
      role: "switch",
      "aria-checked": nativeControlChecked,
      "aria-invalid": this.props['aria-invalid'],
      "aria-errormessage": this.props['aria-errormessage'],
      "aria-label": this.props['aria-label'],
      "aria-labelledby": this.props['aria-labelledby'],
      "aria-describedby": this.props['aria-describedby'],
      "aria-disabled": this.props['disabled'],
      onChange: e => this.foundation.handleChange(e.target.checked, e),
      onFocus: e => this.handleFocusVisible(e),
      onBlur: e => this.handleBlur(e)
    })));
  }
}
Switch.propTypes = {
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  className: (prop_types_default()).string,
  checked: (prop_types_default()).bool,
  checkedText: (prop_types_default()).node,
  defaultChecked: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  loading: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  onMouseEnter: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  style: (prop_types_default()).object,
  size: prop_types_default().oneOf(switch_constants_strings.SIZE_MAP),
  uncheckedText: (prop_types_default()).node,
  id: (prop_types_default()).string
};
Switch.defaultProps = {
  disabled: false,
  className: '',
  onChange: (noop_default()),
  loading: false,
  onMouseEnter: (noop_default()),
  onMouseLeave: (noop_default()),
  size: 'default'
};
/* harmony default export */ var es_switch = (Switch);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/slider/constants.js

const slider_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-slider`,
  DISABLED: `${BASE_CLASS_PREFIX}-slider-disabled`,
  VERTICAL: `${BASE_CLASS_PREFIX}-slider-vertical`,
  TRACK: `${BASE_CLASS_PREFIX}-slider-track`,
  DOTS: `${BASE_CLASS_PREFIX}-slider-dots`,
  MARKS: `${BASE_CLASS_PREFIX}-slider-marks`,
  HANDLE: `${BASE_CLASS_PREFIX}-slider-handle`,
  HANDLE_DOT: `${BASE_CLASS_PREFIX}-slider-handle-dot`
};
const slider_constants_strings = {
  SIZE: ['small', 'large', 'default'],
  POSITION: ['top', 'bottom'],
  OPTIONS: ['children', 'option']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/utils/touchPolyfill.js

const touchEventPolyfill = (touch, touchEvent) => {
  /* Touch is the first point of multi-touch. In order to minimize the change of slider code to support touch,
  some methods that will be used on touchEvent are mounted on the multi-touch Touch object.*/
  // polyfill for firefox
  if (!globalThis.Touch || !(touch instanceof Touch)) {
    return touch;
  }
  const keysNeedPolyfill = ['stopPropagation', 'preventDefault'];
  keysNeedPolyfill.forEach(key => {
    let value = touchEvent[key];
    if (value) {
      if (typeof value === 'function') {
        // bind 'this' for function of touchEvent running in Touch Point Object
        value = function () {
          return touchEvent[key](...arguments);
        };
      }
      if (touch[key]) {
        warning(true, `"The key ${key}" exist in Touch.`);
      } else {
        touch[key] = value;
      }
    }
  });
  return touch;
};
/* harmony default export */ var touchPolyfill = (touchEventPolyfill);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/slider/foundation.js




class SliderFoundation extends foundation {
  constructor(adapter) {
    var _this;
    /**
     * Calculate the percentage corresponding to the current value for style calculation
     * @{}
     *
     * @memberof SliderFoundation
     */
    super(Object.assign(Object.assign({}, SliderFoundation.defaultAdapter), adapter));
    _this = this;
    this.getMinAndMaxPercent = value => {
      // debugger
      const {
        range,
        min,
        max
      } = this._adapter.getProps();
      const minPercent = range ? (value[0] - min) / (max - min) : (value - min) / (max - min);
      const maxPercent = range ? (value[1] - min) / (max - min) : 1;
      return {
        min: this._checkValidity(minPercent),
        max: this._checkValidity(maxPercent)
      };
    };
    /**
     * Check if value is out of range
     * @memberof SliderFoundation
     */
    this._checkValidity = function (value) {
      let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      const checked = value > max ? max : value < min ? min : value;
      return checked;
    };
    /**
     * When render handle, the display and content of the tooltip are calculated according to the conditions
     * @visible:  props passed in by the component
     * @formatter: tooltip content formatting function
     * @memberof SliderFoundation
     */
    this.computeHandleVisibleVal = (visible, formatter, range) => {
      // debugger;
      const {
        focusPos,
        currentValue
      } = this._adapter.getStates();
      const tipVisible = {
        min: false,
        max: false
      };
      let tipChildren;
      if (formatter) {
        tipChildren = {
          min: range ? formatter(this.outPutValue(currentValue[0])) : formatter(this.outPutValue(currentValue)),
          max: range ? formatter(this.outPutValue(currentValue[1])) : null
        };
      } else {
        tipChildren = {
          min: range ? this.outPutValue(currentValue[0]) : this.outPutValue(currentValue),
          max: range ? this.outPutValue(currentValue[1]) : null
        };
      }
      if (visible) {
        tipVisible.min = true;
        tipVisible.max = true;
      } else if (typeof visible === 'undefined' && formatter) {
        if (focusPos === 'min') {
          tipVisible.min = true;
        } else if (focusPos === 'max') {
          tipVisible.max = true;
        }
      }
      const result = {
        tipVisible,
        tipChildren
      };
      return result;
    };
    /**
     * Calculate whether the value passed in is valid
     *
     * @memberof SliderFoundation
     */
    this.valueFormatIsCorrect = value => {
      if (Array.isArray(value)) {
        return typeof value[0] === 'number' && typeof value[0] === 'number';
      } else {
        return typeof value === 'number';
      }
    };
    /**
     * Fix the mouse position to position the parent container relative to the position
     *
     * @memberof SliderFoundation
     */
    this.handleMousePos = (clientX, clientY) => {
      const parentRect = this._adapter.getParentRect();
      const scrollParent = this._adapter.getScrollParentVal();
      const parentX = parentRect ? parentRect.left : 0;
      const parentY = parentRect ? parentRect.top : 0;
      return {
        x: clientX - parentX + scrollParent.scrollLeft,
        y: clientY - parentY + scrollParent.scrollTop
      };
    };
    /**
     * Provides the nearest scrollable parent node of the current node, which is used to calculate the scrollTop and scrollLeft attributes
     *
     * @memberof SliderFoundation
     */
    this.getScrollParent = element => {
      // TODO: move window document out of foundation.
      const el = element;
      const regex = /(auto|scroll)/;
      const style = (node, prop) => window.getComputedStyle(node, null).getPropertyValue(prop);
      const scroll = node => regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
      const scrollParent = node => !node || node === document.body || !(node instanceof Element) ? document.body : scroll(node) ? node : scrollParent(node.parentNode);
      return scrollParent(el);
    };
    /**
     * Fixed the event location, beyond the maximum, minimum, left and right, etc. directly modified to the effective location
     *
     * @memberof SliderFoundation
     */
    this.checkMeetMinMax = position => {
      // Returns the length of the distance to the left
      const {
        vertical,
        verticalReverse,
        range
      } = this._adapter.getProps();
      const value = this._adapter.getState('currentValue');
      const currentPos = this.transValueToPos(value);
      const {
        sliderX,
        sliderY,
        sliderWidth,
        sliderHeight
      } = this._adapter.getSliderLengths();
      const {
        chooseMovePos,
        isDrag
      } = this._adapter.getStates();
      const len = vertical ? sliderHeight : sliderWidth;
      let startPos;
      if (vertical && verticalReverse) {
        startPos = sliderY + len;
      } else {
        startPos = vertical ? sliderY : sliderX;
      }
      //  startPos = chooseMovePos === 'max' && isDrag ? currentPos[0] : startPos;
      let endPos;
      if (vertical && verticalReverse) {
        endPos = sliderY;
      } else {
        endPos = vertical ? sliderY + sliderHeight : sliderX + sliderWidth;
      }
      //   endPos = chooseMovePos === 'min' && isDrag && range ? currentPos[1] : endPos;
      if (vertical && verticalReverse) {
        if (position >= startPos) {
          position = startPos;
        } else if (position <= endPos) {
          position = endPos;
        }
      } else {
        if (position <= startPos) {
          position = startPos;
        } else if (position >= endPos) {
          position = endPos;
        }
      }
      return position;
    };
    /**
     * Converting location information to value requires processing if step is not 1 (invalid move returns false)
     *
     * @memberof SliderFoundation
     */
    this.transPosToValue = (mousePos, isMin) => {
      const pos = this.checkMeetMinMax(mousePos);
      const {
        min,
        max,
        currentValue
      } = this._adapter.getStates();
      const {
        range,
        vertical,
        step,
        verticalReverse
      } = this._adapter.getProps();
      const {
        sliderX,
        sliderY,
        sliderWidth,
        sliderHeight
      } = this._adapter.getSliderLengths();
      const startPos = vertical ? sliderY : sliderX;
      const len = vertical ? sliderHeight : sliderWidth;
      let stepValue;
      if (vertical && verticalReverse) {
        //isMin = !isMin;
        stepValue = (startPos + len - pos) / len * (max - min) + min;
      } else {
        stepValue = (pos - startPos) / len * (max - min) + min;
      }
      let compareValue;
      if (range) {
        compareValue = isMin ? currentValue[0] : currentValue[1];
      } else {
        compareValue = currentValue;
      }
      if (step !== 1) {
        // Find nearest step point
        stepValue = Math.round(stepValue / step) * step;
      }
      if (range && stepValue !== compareValue) {
        return isMin ? [stepValue, currentValue[1]] : [currentValue[0], stepValue];
      } else if (!range && stepValue !== compareValue) {
        return stepValue;
      } else {
        return false;
      }
    };
    /**
     * Convert value values into location information
     *
     * @memberof SliderFoundation
     */
    this.transValueToPos = value => {
      const {
        min,
        max
      } = this._adapter.getStates();
      const {
        vertical,
        range,
        verticalReverse
      } = this._adapter.getProps();
      const {
        sliderX,
        sliderY,
        sliderWidth,
        sliderHeight
      } = this._adapter.getSliderLengths();
      const startPos = vertical ? sliderY : sliderX;
      const len = vertical ? sliderHeight : sliderWidth;
      if (range) {
        return [(value[0] - min) * len / (max - min) + startPos, (value[1] - min) * len / (max - min) + startPos];
      } else {
        return (value - min) * len / (max - min) + startPos;
      }
    };
    /**
     * Determine whether the mark should be highlighted: valid interval and include = false
     *
     * @memberof SliderFoundation
     */
    this.isMarkActive = mark => {
      const {
        min,
        max,
        range,
        included
      } = this._adapter.getProps();
      const currentValue = this._adapter.getState('currentValue');
      if (typeof (mark / 1) === 'number' && mark >= min && mark <= max) {
        if (range) {
          return (mark > currentValue[1] || mark < currentValue[0]) && included ? 'unActive' : 'active';
        } else {
          return mark <= currentValue && included ? 'active' : 'unActive';
        }
      } else {
        return false;
      }
    };
    /**
     * onchange output conversion, default rounding without decimal, step less than 1 has decimal
     *
     * @memberof SliderFoundation
     */
    this.outPutValue = inputValue => {
      const checkHowManyDecimals = num => {
        var _a, _b;
        const reg = /^\d+(\.\d+)?$/;
        if (reg.test(String(num))) {
          return (_b = (_a = num.toString().split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }
        return 0;
      };
      const step = this._adapter.getProp('step');
      const transWay = (() => {
        const decimals = checkHowManyDecimals(step);
        const multipler = Math.pow(10, decimals);
        return value => {
          return Math.round(value * multipler) / multipler;
        };
      })();
      if (Array.isArray(inputValue)) {
        return [transWay(inputValue[0]), transWay(inputValue[1])];
      } else {
        return transWay(inputValue);
      }
    };
    this.handleDisabledChange = disabled => {
      this._adapter.updateDisabled(disabled);
    };
    this.checkAndUpdateIsInRenderTreeState = () => this._adapter.checkAndUpdateIsInRenderTreeState();
    this.calculateOutputValue = (position, isMin) => {
      const moveValue = this.transPosToValue(position, isMin);
      if (moveValue === false) {
        return undefined;
      }
      return this.outPutValue(moveValue);
    };
    /**
     *
     *
     * @memberof SliderFoundation
     */
    this.handleValueChange = (prevValue, nextValue) => {
      const {
        min,
        max
      } = this._adapter.getStates();
      let resultState = null;
      const disableState = {};
      if (this.valueFormatIsCorrect(nextValue)) {
        if (Array.isArray(prevValue) && Array.isArray(nextValue)) {
          nextValue = [nextValue[0] < min ? min : nextValue[0], nextValue[1] > max ? max : nextValue[1] // Math.round(nextValue[1])
          ];
          // this._adapter.notifyChange(this.outPutValue(nextValue));
          resultState = Object.assign(disableState, {
            currentValue: nextValue
          });
        }
        if (typeof prevValue === 'number' && typeof nextValue === 'number') {
          if (nextValue > max) {
            nextValue = max;
          } else {
            nextValue = nextValue < min ? min : nextValue; // Math.round(nextValue);
          }
          // this._adapter.notifyChange(this.outPutValue(nextValue));
          resultState = Object.assign(disableState, {
            currentValue: nextValue
          });
        }
      } else {
        resultState = disableState;
      }
      if (resultState) {
        this._adapter.transNewPropsToState(resultState);
      }
    };
    this.onHandleDown = (e, handler) => {
      this._adapter.onHandleDown(e);
      const disabled = this._adapter.getState('disabled');
      const {
        vertical
      } = this._adapter.getProps();
      const {
        dragging
      } = this._adapter.getOverallVars();
      if (disabled) {
        return false;
      }
      this._adapter.setStateVal('isDrag', true);
      this._adapter.setStateVal('chooseMovePos', handler);
      if (handler === 'min') {
        this._adapter.setDragging([true, dragging[1]]);
      } else {
        this._adapter.setDragging([dragging[0], true]);
      }
      const mousePos = this.handleMousePos(e.clientX, e.clientY);
      let pos = vertical ? mousePos.y : mousePos.x;
      if (!this._adapter.isEventFromHandle(e)) {
        this._dragOffset = 0;
      } else {
        const handlePosition = this._getHandleCenterPosition(vertical, e.target);
        this._dragOffset = vertical ? pos - handlePosition : pos - handlePosition;
        pos = handlePosition;
      }
      return true;
    };
    this.onHandleMove = e => {
      this._adapter.setEventDefault(e);
      const {
        disabled,
        chooseMovePos
      } = this._adapter.getStates();
      const {
        vertical
      } = this._adapter.getProps();
      const {
        dragging
      } = this._adapter.getOverallVars();
      if (disabled) {
        return false;
      }
      this.onHandleEnter(chooseMovePos);
      const mousePos = this.handleMousePos(e.clientX, e.clientY);
      let pagePos = vertical ? mousePos.y : mousePos.x;
      pagePos = pagePos - this._dragOffset;
      if (chooseMovePos === 'min' && dragging[0] || chooseMovePos === 'max' && dragging[1]) {
        const outPutValue = this.calculateOutputValue(pagePos, chooseMovePos === 'min');
        if (outPutValue === undefined) {
          return false;
        }
        this._adapter.notifyChange(outPutValue);
        // allow drag for controlled component, so no _isControlledComponent check
        this._adapter.onHandleMove(pagePos, chooseMovePos === 'min', undefined, false, outPutValue);
      }
      return true;
    };
    // run when user touch left or right handle.
    this.onHandleTouchStart = (e, handler) => {
      const handleMinDom = this._adapter.getMinHandleEl();
      const handleMaxDom = this._adapter.getMaxHandleEl();
      if (e.target === handleMinDom || e.target === handleMaxDom) {
        handlePrevent(e);
        const touch = touchPolyfill(e.touches[0], e);
        this.onHandleDown(touch, handler);
      }
    };
    this.onHandleTouchMove = e => {
      const handleMinDom = this._adapter.getMinHandleEl();
      const handleMaxDom = this._adapter.getMaxHandleEl();
      if (e.target === handleMinDom || e.target === handleMaxDom) {
        const touch = touchPolyfill(e.touches[0], e);
        this.onHandleMove(touch);
      }
    };
    this.onHandleEnter = pos => {
      // debugger;
      // this._adapter.setEventDefault(e);
      const {
        disabled,
        focusPos
      } = this._adapter.getStates();
      if (!disabled) {
        if (!focusPos && pos !== focusPos) {
          this._adapter.onHandleEnter(pos);
        }
      }
    };
    this.onHandleLeave = () => {
      // this._adapter.setEventDefault(e);
      const disabled = this._adapter.getState('disabled');
      const isDrag = this._adapter.getState('isDrag');
      if (!disabled && !isDrag) {
        this._adapter.onHandleLeave();
      }
    };
    this.onHandleUp = e => {
      this._adapter.onHandleUpBefore(e);
      // const value = this._adapter.getProp('value');
      const {
        disabled,
        chooseMovePos
      } = this._adapter.getStates();
      const {
        dragging
      } = this._adapter.getOverallVars();
      if (disabled) {
        return false;
      }
      if (chooseMovePos === 'min') {
        this._adapter.setDragging([false, dragging[1]]);
      } else {
        this._adapter.setDragging([dragging[0], false]);
      }
      this._adapter.setStateVal('isDrag', false);
      this._adapter.onHandleLeave();
      this._adapter.onHandleUpAfter();
      return true;
    };
    this._handleValueDecreaseWithKeyBoard = (step, handler) => {
      const {
        min,
        currentValue
      } = this.getStates();
      const {
        range
      } = this.getProps();
      if (handler === 'min') {
        if (range) {
          let newMinValue = currentValue[0] - step;
          newMinValue = newMinValue < min ? min : newMinValue;
          return [newMinValue, currentValue[1]];
        } else {
          let newMinValue = currentValue - step;
          newMinValue = newMinValue < min ? min : newMinValue;
          return newMinValue;
        }
      } else {
        let newMaxValue = currentValue[1] - step;
        newMaxValue = newMaxValue < currentValue[0] ? currentValue[0] : newMaxValue;
        return [currentValue[0], newMaxValue];
      }
    };
    this._handleValueIncreaseWithKeyBoard = (step, handler) => {
      const {
        max,
        currentValue
      } = this.getStates();
      const {
        range
      } = this.getProps();
      if (handler === 'min') {
        if (range) {
          let newMinValue = currentValue[0] + step;
          newMinValue = newMinValue > currentValue[1] ? currentValue[1] : newMinValue;
          return [newMinValue, currentValue[1]];
        } else {
          let newMinValue = currentValue + step;
          newMinValue = newMinValue > max ? max : newMinValue;
          return newMinValue;
        }
      } else {
        let newMaxValue = currentValue[1] + step;
        newMaxValue = newMaxValue > max ? max : newMaxValue;
        return [currentValue[0], newMaxValue];
      }
    };
    this._handleHomeKey = handler => {
      const {
        min,
        currentValue
      } = this.getStates();
      const {
        range
      } = this.getProps();
      if (handler === 'min') {
        if (range) {
          return [min, currentValue[1]];
        } else {
          return min;
        }
      } else {
        return [currentValue[0], currentValue[0]];
      }
    };
    this._handleEndKey = handler => {
      const {
        max,
        currentValue
      } = this.getStates();
      const {
        range
      } = this.getProps();
      if (handler === 'min') {
        if (range) {
          return [currentValue[1], currentValue[1]];
        } else {
          return max;
        }
      } else {
        return [currentValue[0], max];
      }
    };
    this.handleKeyDown = (event, handler) => {
      const {
        min,
        max,
        currentValue
      } = this.getStates();
      const {
        step,
        range
      } = this.getProps();
      let outputValue;
      switch (event.key) {
        case "ArrowLeft":
        case "ArrowDown":
          outputValue = this._handleValueDecreaseWithKeyBoard(step, handler);
          break;
        case "ArrowRight":
        case "ArrowUp":
          outputValue = this._handleValueIncreaseWithKeyBoard(step, handler);
          break;
        case "PageUp":
          outputValue = this._handleValueIncreaseWithKeyBoard(10 * step, handler);
          break;
        case "PageDown":
          outputValue = this._handleValueDecreaseWithKeyBoard(10 * step, handler);
          break;
        case "Home":
          outputValue = this._handleHomeKey(handler);
          break;
        case "End":
          outputValue = this._handleEndKey(handler);
          break;
        case 'default':
          break;
      }
      if (["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "PageUp", "PageDown", "Home", "End"].includes(event.key)) {
        let update = true;
        if (Array.isArray(currentValue)) {
          update = !(currentValue[0] === outputValue[0] && currentValue[1] === outputValue[1]);
        } else {
          update = currentValue !== outputValue;
        }
        if (update) {
          this._adapter.updateCurrentValue(outputValue);
          this._adapter.notifyChange(outputValue);
        }
        handlePrevent(event);
      }
    };
    this.onFocus = (e, handler) => {
      handlePrevent(e);
      const {
        target
      } = e;
      try {
        if (target.matches(':focus-visible')) {
          if (handler === 'min') {
            this._adapter.setStateVal('firstDotFocusVisible', true);
          } else {
            this._adapter.setStateVal('secondDotFocusVisible', true);
          }
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Slider] The current browser does not support the focus-visible');
      }
    };
    this.onBlur = (e, handler) => {
      const {
        firstDotFocusVisible,
        secondDotFocusVisible
      } = this.getStates();
      if (handler === 'min') {
        firstDotFocusVisible && this._adapter.setStateVal('firstDotFocusVisible', false);
      } else {
        secondDotFocusVisible && this._adapter.setStateVal('secondDotFocusVisible', false);
      }
    };
    this.handleWrapClick = e => {
      const {
        disabled,
        isDrag
      } = this._adapter.getStates();
      if (isDrag || disabled || this._adapter.isEventFromHandle(e)) {
        return;
      }
      const {
        vertical
      } = this.getProps();
      const mousePos = this.handleMousePos(e.clientX, e.clientY);
      const position = vertical ? mousePos.y : mousePos.x;
      const isMin = this.checkWhichHandle(position);
      const outPutValue = this.calculateOutputValue(position, isMin);
      if (outPutValue === undefined) {
        return;
      }
      this._adapter.notifyChange(outPutValue);
      // check if is controlled component
      if (this._isControlledComponent()) {
        // only perform callback ops, skip UI update
        return;
      }
      // trigger UI state update
      this.setHandlePos(position, isMin, true, outPutValue);
    };
    /**
     * Move the slider to the current click position
     *
     * @memberof SliderFoundation
     */
    this.setHandlePos = function (position, isMin) {
      let clickTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let outPutValue = arguments.length > 3 ? arguments[3] : undefined;
      _this._adapter.onHandleMove(position, isMin, () => _this._adapter.onHandleUpAfter(), clickTrack, outPutValue);
    };
    /**
     * Determine which slider should be moved currently
     *
     * @memberof SliderFoundation
     */
    this.checkWhichHandle = pagePos => {
      const {
        vertical,
        verticalReverse
      } = this.getProps();
      const {
        currentValue
      } = this._adapter.getStates();
      const currentPos = this.transValueToPos(currentValue);
      let isMin = true;
      if (Array.isArray(currentPos)) {
        // Slide on both sides
        if (pagePos > currentPos[1] || Math.abs(pagePos - currentPos[0]) > Math.abs(pagePos - currentPos[1])) {
          isMin = false;
        }
      }
      if (vertical && verticalReverse) {
        isMin = !isMin;
      }
      return isMin;
    };
    this.handleWrapperEnter = () => {
      this._adapter.setStateVal('showBoundary', true);
    };
    this.handleWrapperLeave = () => {
      this._adapter.setStateVal('showBoundary', false);
    };
  }
  init() {
    this._checkCurrentValue();
    this._dragOffset = 0;
  }
  _checkCurrentValue() {
    const {
      currentValue,
      min,
      max
    } = this.getStates();
    let checked;
    if (Array.isArray(currentValue)) {
      checked = [];
      checked[0] = this._checkValidity(currentValue[0], min, max);
      checked[1] = this._checkValidity(currentValue[1], min, max);
    } else {
      checked = this._checkValidity(currentValue, min, max);
    }
    this._adapter.updateCurrentValue(checked);
  }
  /**
   * Untie event
   * @memberof SliderFoundation
   */
  destroy() {
    // debugger
    this._adapter.unSubscribeEventListener();
  }
  _getHandleCenterPosition(vertical, handle) {
    const pos = handle.getBoundingClientRect();
    const {
      x,
      y
    } = this.handleMousePos(pos.left + pos.width * 0.5, pos.top + pos.height * 0.5);
    return vertical ? y : x;
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/slider/index.js


var slider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








// import '@douyinfe/semi-foundation/lib/es/slider/slider.css';
const slider_prefixCls = slider_constants_cssClasses.PREFIX;
function domIsInRenderTree(e) {
  if (!e) {
    return false;
  }
  return Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}
class Slider extends BaseComponent {
  constructor(props) {
    super(props);
    this.renderHandle = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const {
        vertical,
        range,
        tooltipVisible,
        tipFormatter,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-valuetext': ariaValueText,
        getAriaValueText,
        disabled
      } = this.props;
      const {
        chooseMovePos,
        isDrag,
        isInRenderTree,
        firstDotFocusVisible,
        secondDotFocusVisible
      } = this.state;
      const stylePos = vertical ? 'top' : 'left';
      const percentInfo = this.foundation.getMinAndMaxPercent(this.state.currentValue);
      const minPercent = percentInfo.min;
      const maxPercent = percentInfo.max;
      const {
        tipVisible,
        tipChildren
      } = this.foundation.computeHandleVisibleVal(tooltipVisible && isInRenderTree, tipFormatter, range);
      const minClass = classnames_default()(slider_constants_cssClasses.HANDLE, {
        [`${slider_constants_cssClasses.HANDLE}-clicked`]: chooseMovePos === 'min' && isDrag
      });
      const maxClass = classnames_default()(slider_constants_cssClasses.HANDLE, {
        [`${slider_constants_cssClasses.HANDLE}-clicked`]: chooseMovePos === 'max' && isDrag
      });
      const {
        min,
        max,
        currentValue
      } = this.state;
      const commonAria = {
        'aria-label': ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : disabled ? 'Disabled Slider' : undefined,
        'aria-labelledby': ariaLabelledby,
        'aria-disabled': disabled
      };
      vertical && Object.assign(commonAria, {
        'aria-orientation': 'vertical'
      });
      const handleContents = !range ? /*#__PURE__*/react.createElement(Tooltip, {
        content: tipChildren.min,
        showArrow: this.props.showArrow,
        position: "top",
        trigger: "custom",
        rePosKey: minPercent,
        visible: isInRenderTree && (tipVisible.min || firstDotFocusVisible),
        className: `${slider_constants_cssClasses.HANDLE}-tooltip`
      }, /*#__PURE__*/react.createElement("span", Object.assign({
        onMouseOver: this.foundation.checkAndUpdateIsInRenderTreeState,
        ref: this.minHanleEl,
        className: minClass,
        style: {
          [stylePos]: `${minPercent * 100}%`,
          zIndex: chooseMovePos === 'min' && isDrag ? 2 : 1
        },
        onMouseDown: e => {
          this.foundation.onHandleDown(e, 'min');
        },
        onMouseEnter: () => {
          this.foundation.onHandleEnter('min');
        },
        onTouchStart: e => {
          this.foundation.onHandleTouchStart(e, 'min');
        },
        onMouseLeave: () => {
          this.foundation.onHandleLeave();
        },
        onKeyUp: e => {
          this.foundation.onHandleUp(e);
        },
        onTouchEnd: e => {
          this.foundation.onHandleUp(e);
        },
        onKeyDown: e => {
          this.foundation.handleKeyDown(e, 'min');
        },
        onFocus: e => {
          this.foundation.onFocus(e, 'min');
        },
        onBlur: e => {
          this.foundation.onBlur(e, 'min');
        },
        role: "slider",
        "aria-valuetext": getAriaValueText ? getAriaValueText(currentValue, 0) : ariaValueText,
        tabIndex: disabled ? -1 : 0
      }, commonAria, {
        "aria-valuenow": currentValue,
        "aria-valuemax": max,
        "aria-valuemin": min
      }), this.props.handleDot && /*#__PURE__*/react.createElement("div", {
        className: slider_constants_cssClasses.HANDLE_DOT,
        style: Object.assign(Object.assign({}, ((_a = this.props.handleDot) === null || _a === void 0 ? void 0 : _a.size) ? {
          width: this.props.handleDot.size,
          height: this.props.handleDot.size
        } : {}), ((_b = this.props.handleDot) === null || _b === void 0 ? void 0 : _b.color) ? {
          backgroundColor: this.props.handleDot.color
        } : {})
      }))) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Tooltip, {
        content: tipChildren.min,
        position: "top",
        trigger: "custom",
        rePosKey: minPercent,
        visible: isInRenderTree && (tipVisible.min || firstDotFocusVisible),
        className: `${slider_constants_cssClasses.HANDLE}-tooltip`
      }, /*#__PURE__*/react.createElement("span", Object.assign({
        ref: this.minHanleEl,
        className: minClass,
        style: {
          [stylePos]: `${minPercent * 100}%`,
          zIndex: chooseMovePos === 'min' ? 2 : 1
        },
        onMouseDown: e => {
          this.foundation.onHandleDown(e, 'min');
        },
        onMouseEnter: () => {
          this.foundation.onHandleEnter('min');
        },
        onTouchStart: e => {
          this.foundation.onHandleTouchStart(e, 'min');
        },
        onMouseLeave: () => {
          this.foundation.onHandleLeave();
        },
        onKeyUp: e => {
          this.foundation.onHandleUp(e);
        },
        onTouchEnd: e => {
          this.foundation.onHandleUp(e);
        },
        onKeyDown: e => {
          this.foundation.handleKeyDown(e, 'min');
        },
        onFocus: e => {
          this.foundation.onFocus(e, 'min');
        },
        onBlur: e => {
          this.foundation.onBlur(e, 'min');
        },
        role: "slider",
        tabIndex: disabled ? -1 : 0
      }, commonAria, {
        "aria-valuetext": getAriaValueText ? getAriaValueText(currentValue[0], 0) : ariaValueText,
        "aria-valuenow": currentValue[0],
        "aria-valuemax": currentValue[1],
        "aria-valuemin": min
      }), ((_c = this.props.handleDot) === null || _c === void 0 ? void 0 : _c[0]) && /*#__PURE__*/react.createElement("div", {
        className: slider_constants_cssClasses.HANDLE_DOT,
        style: Object.assign(Object.assign({}, ((_d = this.props.handleDot[0]) === null || _d === void 0 ? void 0 : _d.size) ? {
          width: this.props.handleDot[0].size,
          height: this.props.handleDot[0].size
        } : {}), ((_e = this.props.handleDot[0]) === null || _e === void 0 ? void 0 : _e.color) ? {
          backgroundColor: this.props.handleDot[0].color
        } : {})
      }))), /*#__PURE__*/react.createElement(Tooltip, {
        content: tipChildren.max,
        position: "top",
        trigger: "custom",
        rePosKey: maxPercent,
        visible: isInRenderTree && (tipVisible.max || secondDotFocusVisible),
        className: `${slider_constants_cssClasses.HANDLE}-tooltip`
      }, /*#__PURE__*/react.createElement("span", Object.assign({
        ref: this.maxHanleEl,
        className: maxClass,
        style: {
          [stylePos]: `${maxPercent * 100}%`,
          zIndex: chooseMovePos === 'max' ? 2 : 1
        },
        onMouseDown: e => {
          this.foundation.onHandleDown(e, 'max');
        },
        onMouseEnter: () => {
          this.foundation.onHandleEnter('max');
        },
        onMouseLeave: () => {
          this.foundation.onHandleLeave();
        },
        onKeyUp: e => {
          this.foundation.onHandleUp(e);
        },
        onTouchStart: e => {
          this.foundation.onHandleTouchStart(e, 'max');
        },
        onTouchEnd: e => {
          this.foundation.onHandleUp(e);
        },
        onKeyDown: e => {
          this.foundation.handleKeyDown(e, 'max');
        },
        onFocus: e => {
          this.foundation.onFocus(e, 'max');
        },
        onBlur: e => {
          this.foundation.onBlur(e, 'max');
        },
        role: "slider",
        tabIndex: disabled ? -1 : 0
      }, commonAria, {
        "aria-valuetext": getAriaValueText ? getAriaValueText(currentValue[1], 1) : ariaValueText,
        "aria-valuenow": currentValue[1],
        "aria-valuemax": max,
        "aria-valuemin": currentValue[0]
      }), ((_f = this.props.handleDot) === null || _f === void 0 ? void 0 : _f[1]) && /*#__PURE__*/react.createElement("div", {
        className: slider_constants_cssClasses.HANDLE_DOT,
        style: Object.assign(Object.assign({}, ((_g = this.props.handleDot[1]) === null || _g === void 0 ? void 0 : _g.size) ? {
          width: this.props.handleDot[1].size,
          height: this.props.handleDot[1].size
        } : {}), ((_h = this.props.handleDot[1]) === null || _h === void 0 ? void 0 : _h.color) ? {
          backgroundColor: this.props.handleDot[1].color
        } : {})
      }))));
      return handleContents;
    };
    this.renderTrack = () => {
      const {
        range,
        included,
        vertical
      } = this.props;
      const percentInfo = this.foundation.getMinAndMaxPercent(this.state.currentValue);
      const minPercent = percentInfo.min;
      const maxPercent = percentInfo.max;
      let trackStyle = !vertical ? {
        width: range ? `${Math.abs(maxPercent - minPercent) * 100}%` : `${minPercent * 100}%`,
        left: range ? `${Math.min(minPercent, maxPercent) * 100}%` : 0
      } : {
        height: range ? `${Math.abs(maxPercent - minPercent) * 100}%` : `${minPercent * 100}%`,
        top: range ? `${Math.min(minPercent, maxPercent) * 100}%` : 0
      };
      trackStyle = included ? trackStyle : {};
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        react.createElement("div", {
          className: slider_constants_cssClasses.TRACK,
          style: trackStyle,
          onClick: this.foundation.handleWrapClick
        })
      );
    };
    this.renderStepDot = () => {
      const {
        min,
        max,
        vertical,
        marks
      } = this.props;
      const stylePos = vertical ? 'top' : 'left';
      const labelContent = marks && Object.keys(marks).length > 0 ? /*#__PURE__*/react.createElement("div", {
        className: slider_constants_cssClasses.DOTS
      }, Object.keys(marks).map(mark => {
        const activeResult = this.foundation.isMarkActive(Number(mark));
        const markClass = classnames_default()(`${slider_prefixCls}-dot`, {
          [`${slider_prefixCls}-dot-active`]: this.foundation.isMarkActive(Number(mark)) === 'active'
        });
        const markPercent = (Number(mark) - min) / (max - min);
        const dotDOM =
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        react.createElement("span", {
          key: mark,
          onClick: this.foundation.handleWrapClick,
          className: markClass,
          style: {
            [stylePos]: `calc(${markPercent * 100}% - 2px)`
          }
        });
        return activeResult ? this.props.tooltipOnMark ? /*#__PURE__*/react.createElement(Tooltip, {
          content: marks[mark]
        }, dotDOM) : dotDOM : null;
      })) : null;
      return labelContent;
    };
    this.renderLabel = () => {
      if (!this.props.showMarkLabel) {
        return null;
      }
      const {
        min,
        max,
        vertical,
        marks,
        verticalReverse
      } = this.props;
      const stylePos = vertical ? 'top' : 'left';
      const labelContent = marks && Object.keys(marks).length > 0 ? /*#__PURE__*/react.createElement("div", {
        className: slider_constants_cssClasses.MARKS + (vertical && verticalReverse ? '-reverse' : '')
      }, Object.keys(marks).map(mark => {
        const activeResult = this.foundation.isMarkActive(Number(mark));
        const markPercent = (Number(mark) - min) / (max - min);
        return activeResult ?
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        react.createElement("span", {
          key: mark,
          className: classnames_default()(`${slider_prefixCls}-mark${vertical && verticalReverse ? '-reverse' : ''}`),
          style: {
            [stylePos]: `${markPercent * 100}%`
          },
          onClick: this.foundation.handleWrapClick
        }, marks[mark]) : null;
      })) : null;
      return labelContent;
    };
    this._getAriaValueText = (value, index) => {
      const {
        getAriaValueText
      } = this.props;
      return getAriaValueText ? getAriaValueText(value, index) : value;
    };
    let {
      value
    } = this.props;
    if (!value) {
      value = this.props.defaultValue;
    }
    this.state = {
      currentValue: value ? value : this.props.range ? [0, 0] : 0,
      min: this.props.min || 0,
      max: this.props.max || 0,
      focusPos: '',
      onChange: this.props.onChange,
      disabled: this.props.disabled || false,
      chooseMovePos: '',
      isDrag: false,
      clickValue: 0,
      showBoundary: false,
      isInRenderTree: true,
      firstDotFocusVisible: false,
      secondDotFocusVisible: false
    };
    this.sliderEl = /*#__PURE__*/react.createRef();
    this.minHanleEl = /*#__PURE__*/react.createRef();
    this.maxHanleEl = /*#__PURE__*/react.createRef();
    this.dragging = [false, false];
    this.foundation = new SliderFoundation(this.adapter);
    this.eventListenerSet = new Set();
    this.handleDownEventListenerSet = new Set();
  }
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      getSliderLengths: () => {
        var _a;
        if (this.sliderEl && this.sliderEl.current) {
          const rect = this.sliderEl.current.getBoundingClientRect();
          const offsetParentRect = (_a = this.sliderEl.current.offsetParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
          const offset = {
            x: offsetParentRect ? rect.left - offsetParentRect.left : this.sliderEl.current.offsetLeft,
            y: offsetParentRect ? rect.top - offsetParentRect.top : this.sliderEl.current.offsetTop
          };
          return {
            sliderX: offset.x,
            sliderY: offset.y,
            sliderWidth: rect.width,
            sliderHeight: rect.height
          };
        }
        return {
          sliderX: 0,
          sliderY: 0,
          sliderWidth: 0,
          sliderHeight: 0
        };
      },
      getParentRect: () => {
        const parentObj = this.sliderEl && this.sliderEl.current && this.sliderEl.current.offsetParent;
        if (!parentObj) {
          return undefined;
        }
        return parentObj.getBoundingClientRect();
      },
      getScrollParentVal: () => {
        const scrollParent = this.foundation.getScrollParent(this.sliderEl.current);
        return {
          scrollTop: scrollParent.scrollTop,
          scrollLeft: scrollParent.scrollLeft
        };
      },
      isEventFromHandle: e => {
        const handles = [this.minHanleEl, this.maxHanleEl];
        let flag = false;
        handles.forEach(handle => {
          if (!handle) {
            return;
          }
          const handleInstance = handle && handle.current;
          const handleDom = react_dom.findDOMNode(handleInstance);
          if (handleDom && handleDom.contains(e.target)) {
            flag = true;
          }
        });
        return flag;
      },
      getOverallVars: () => ({
        dragging: this.dragging
      }),
      updateDisabled: disabled => {
        this.setState({
          disabled
        });
      },
      transNewPropsToState(stateObj) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (noop_default());
        this.setState(stateObj, callback);
      },
      notifyChange: cbValue => {
        this.props.onChange(Array.isArray(cbValue) ? [...cbValue].sort() : cbValue);
      },
      setDragging: value => {
        this.dragging = value;
      },
      updateCurrentValue: value => {
        const {
          currentValue
        } = this.state;
        if (value !== currentValue) {
          this.setState({
            currentValue: value
          });
        }
      },
      setOverallVars: (key, value) => {
        this[key] = value;
      },
      getMinHandleEl: () => this.minHanleEl.current,
      getMaxHandleEl: () => this.maxHanleEl.current,
      onHandleDown: e => {
        this.handleDownEventListenerSet.add(this._addEventListener(document.body, 'mousemove', this.foundation.onHandleMove, false));
        this.handleDownEventListenerSet.add(this._addEventListener(window, 'mouseup', this.foundation.onHandleUp, false));
        this.handleDownEventListenerSet.add(this._addEventListener(document.body, 'touchmove', this.foundation.onHandleTouchMove, false));
      },
      onHandleMove: function (mousePos, isMin) {
        let stateChangeCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (noop_default());
        let clickTrack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        let outPutValue = arguments.length > 4 ? arguments[4] : undefined;
        const sliderDOMIsInRenderTree = _this.foundation.checkAndUpdateIsInRenderTreeState();
        if (!sliderDOMIsInRenderTree) {
          return;
        }
        const {
          value
        } = _this.props;
        let finalOutPutValue = outPutValue;
        if (finalOutPutValue === undefined) {
          const moveValue = _this.foundation.transPosToValue(mousePos, isMin);
          if (moveValue === false) {
            return;
          }
          finalOutPutValue = _this.foundation.outPutValue(moveValue);
        }
        const {
          currentValue
        } = _this.state;
        if (!isEqual_default()(_this.foundation.outPutValue(currentValue), finalOutPutValue)) {
          if (!clickTrack && _this.foundation.valueFormatIsCorrect(value)) {
            // still require afterChangeCallback when click on the track directly, need skip here
            return false;
          }
          _this.setState({
            currentValue: finalOutPutValue
          }, stateChangeCallback);
        }
      },
      setEventDefault: e => {
        e.stopPropagation();
        e.preventDefault();
      },
      setStateVal: (name, val) => {
        this.setState({
          [name]: val
        });
      },
      checkAndUpdateIsInRenderTreeState: () => {
        const sliderDOMIsInRenderTree = domIsInRenderTree(this.sliderEl.current);
        if (sliderDOMIsInRenderTree !== this.state.isInRenderTree) {
          this.setState({
            isInRenderTree: sliderDOMIsInRenderTree
          });
        }
        return sliderDOMIsInRenderTree;
      },
      onHandleEnter: pos => {
        this.setState({
          focusPos: pos
        });
      },
      onHandleLeave: () => {
        this.setState({
          focusPos: ''
        });
      },
      onHandleUpBefore: e => {
        var _a, _b;
        (_b = (_a = this.props).onMouseUp) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        e.stopPropagation();
        e.preventDefault();
        Array.from(this.handleDownEventListenerSet).forEach(clear => clear());
        this.handleDownEventListenerSet.clear();
      },
      onHandleUpAfter: () => {
        const {
          currentValue
        } = this.state;
        const value = this.foundation.outPutValue(currentValue);
        this.props.onAfterChange(value);
      },
      unSubscribeEventListener: () => {
        Array.from(this.eventListenerSet).forEach(clear => clear());
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentDidUpdate(prevProps, prevState) {
    const hasPropValueChange = !isEqual_default()(this.props.value, prevProps.value);
    const hasPropDisabledChange = this.props.disabled !== prevProps.disabled;
    if (hasPropDisabledChange) {
      this.foundation.handleDisabledChange(this.props.disabled);
    }
    if (hasPropValueChange) {
      const nextValue = this.props.value;
      const prevValue = this.state.currentValue;
      this.foundation.handleValueChange(prevValue, nextValue);
      // trigger onAfterChange when value is controlled and changed
      this.props.onAfterChange(this.props.value);
    }
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const {
      disabled,
      currentValue,
      min,
      max
    } = this.state;
    const _a = this.props,
      {
        vertical,
        verticalReverse,
        style,
        railStyle,
        range,
        className
      } = _a,
      rest = slider_rest(_a, ["vertical", "verticalReverse", "style", "railStyle", "range", "className"]);
    const wrapperClass = classnames_default()(`${slider_prefixCls}-wrapper`, {
      [`${slider_prefixCls}-disabled`]: disabled,
      [`${slider_constants_cssClasses.VERTICAL}-wrapper`]: vertical,
      [`${slider_prefixCls}-reverse`]: vertical && verticalReverse
    }, className);
    const boundaryClass = classnames_default()(`${slider_prefixCls}-boundary`, {
      [`${slider_prefixCls}-boundary-show`]: this.props.showBoundary && this.state.showBoundary
    });
    const sliderCls = classnames_default()({
      [`${slider_prefixCls}`]: !vertical,
      [slider_constants_cssClasses.VERTICAL]: vertical
    });
    const fixedCurrentValue = Array.isArray(currentValue) ? [...currentValue].sort() : currentValue;
    const ariaLabel = range ? `Range: ${this._getAriaValueText(fixedCurrentValue[0], 0)} to ${this._getAriaValueText(fixedCurrentValue[1], 1)}` : undefined;
    const slider = /*#__PURE__*/react.createElement("div", Object.assign({
      className: wrapperClass,
      style: style,
      ref: this.sliderEl,
      "aria-label": ariaLabel,
      onMouseEnter: () => this.foundation.handleWrapperEnter(),
      onMouseLeave: () => this.foundation.handleWrapperLeave()
    }, this.getDataAttr(rest)), /*#__PURE__*/react.createElement("div", {
      className: `${slider_prefixCls}-rail`,
      onClick: this.foundation.handleWrapClick,
      style: railStyle
    }), this.renderTrack(), this.renderStepDot(), /*#__PURE__*/react.createElement("div", null, this.renderHandle()), this.renderLabel(), /*#__PURE__*/react.createElement("div", {
      className: boundaryClass
    }, /*#__PURE__*/react.createElement("span", {
      className: `${slider_prefixCls}-boundary-min`
    }, min), /*#__PURE__*/react.createElement("span", {
      className: `${slider_prefixCls}-boundary-max`
    }, max)));
    if (!vertical) {
      return /*#__PURE__*/react.createElement("div", {
        className: sliderCls
      }, slider);
    }
    return slider;
  }
  _addEventListener(target, eventName, callback) {
    if (target.addEventListener) {
      for (var _len = arguments.length, rests = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rests[_key - 3] = arguments[_key];
      }
      target.addEventListener(eventName, callback, ...rests);
      const clearSelf = () => {
        target === null || target === void 0 ? void 0 : target.removeEventListener(eventName, callback);
        Promise.resolve().then(() => {
          this.eventListenerSet.delete(clearSelf);
        });
      };
      this.eventListenerSet.add(clearSelf);
      return clearSelf;
    } else {
      return (noop_default());
    }
  }
}
Slider.propTypes = {
  // allowClear: PropTypes.bool,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).array]),
  disabled: (prop_types_default()).bool,
  showMarkLabel: (prop_types_default()).bool,
  included: (prop_types_default()).bool,
  marks: (prop_types_default()).object,
  max: (prop_types_default()).number,
  min: (prop_types_default()).number,
  range: (prop_types_default()).bool,
  step: (prop_types_default()).number,
  tipFormatter: (prop_types_default()).func,
  value: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).array]),
  vertical: (prop_types_default()).bool,
  onAfterChange: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onMouseUp: (prop_types_default()).func,
  tooltipOnMark: (prop_types_default()).bool,
  tooltipVisible: (prop_types_default()).bool,
  showArrow: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  showBoundary: (prop_types_default()).bool,
  railStyle: (prop_types_default()).object,
  verticalReverse: (prop_types_default()).bool,
  getAriaValueText: (prop_types_default()).func,
  handleDot: prop_types_default().oneOfType([prop_types_default().shape({
    size: (prop_types_default()).string,
    color: (prop_types_default()).string
  }), prop_types_default().arrayOf(prop_types_default().shape({
    size: (prop_types_default()).string,
    color: (prop_types_default()).string
  }))])
};
Slider.defaultProps = {
  // allowClear: false,
  disabled: false,
  showMarkLabel: true,
  tooltipOnMark: false,
  included: true,
  max: 100,
  min: 0,
  range: false,
  showArrow: true,
  step: 1,
  tipFormatter: value => value,
  vertical: false,
  showBoundary: false,
  onAfterChange: value => {
    // console.log(value);
  },
  onChange: value => {
    // console.log(value);
  },
  verticalReverse: false
};
// EXTERNAL MODULE: ./node_modules/lodash/split.js
var split = __webpack_require__(71640);
var split_default = /*#__PURE__*/__webpack_require__.n(split);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/timePicker/utils/index.js





/**
 *
 * @param {string|Date|number} input
 * @param {string} formatToken
 * @param {object} dateFnsLocale
 * @returns {Date}
 */
const parseToDate = function (input) {
  let formatToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : timePicker_constants_strings.DEFAULT_FORMAT;
  let dateFnsLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : zh_CN;
  if (input instanceof Date) {
    return input;
  } else if (typeof input === 'number') {
    return new Date(toNumber_default()(input));
  } else if (typeof input === 'string') {
    let curDate = new Date();
    // console.log(input, formatToken);
    curDate = parse_parse(input, formatToken, curDate, {
      locale: dateFnsLocale
    });
    // console.log(curDate, formatToken);
    return curDate;
  } else if (typeof input === 'undefined') {
    return undefined;
  }
  return new Date();
};
/**
 *
 * @param {string|Date|number} input
 * @returns {number}
 */
const parseToTimestamp = function (input) {
  let formatToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : strings.DEFAULT_FORMAT;
  let dateFnsLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultLocale;
  return Number(parseToDate(input, formatToken, dateFnsLocale));
};
/**
 *
 * @param {Date|number} dateOrTimestamp
 * @param {string} formatToken
 * @returns {string}
 */
const formatToString = function (dateOrTimestamp) {
  let formatToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : timePicker_constants_strings.DEFAULT_FORMAT;
  let dateFnsLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : zh_CN;
  return format_format(dateOrTimestamp, formatToken, {
    locale: dateFnsLocale
  });
};
const hourIsDisabled = (disabledHours, hour) => {
  if (typeof disabledHours === 'function') {
    const disabledOptions = disabledHours();
    if (Array.isArray(disabledOptions) && !isNullOrUndefined(hour) && disabledOptions.some(v => toNumber_default()(v) === toNumber_default()(hour))) {
      return true;
    }
  }
  return false;
};
const minuteIsDisabled = (disabledMinutes, hour, minute) => {
  if (typeof disabledMinutes === 'function') {
    const disabledOptions = disabledMinutes(hour);
    if (Array.isArray(disabledOptions) && !isNullOrUndefined(hour) && !isNullOrUndefined(minute) && disabledOptions.some(v => toNumber_default()(v) === toNumber_default()(minute))) {
      return true;
    }
  }
  return false;
};
const secondIsDisabled = (disabledSeconds, hour, minute, second) => {
  if (typeof disabledSeconds === 'function') {
    const disabledOptions = disabledSeconds(hour, minute);
    if (Array.isArray(disabledOptions) && !isNullOrUndefined(hour) && !isNullOrUndefined(minute) && !isNullOrUndefined(second) && disabledOptions.some(v => toNumber_default()(v) === toNumber_default()(second))) {
      return true;
    }
  }
  return false;
};
const transformToArray = value => {
  if (!Array.isArray(value)) {
    return [];
  } else {
    return [...value];
  }
};
/**
 * Determine whether the time length is the same as the format
 * e.g.
 *  format      | time      | return
 *  HH:mm       | 12:00     | true
 *  HH:mm:ss    | 12:00:00  | true
 *  yyyy HH:mm  | 2021 12:00| true
 *  HH          | 1         | false
 *  HH:mm       | 12:0      | false
 *  HH          | 1         | false
 *  HH:mm:ss    | 12:00:0   | false
 * @param {String} time  e.g. 12:0
 * @param {String} formatToken e.g. HH:mm
 * @returns {Boolean}
 */
const isTimeFormatLike = (time, formatToken) => {
  let isLike = true;
  const dateFnsSupportFormatCh = 'BDEGHKLMOPQRSTXYabcehimopqstuwxyz'; // dateFns support format character
  const formatSupportChReg = new RegExp(`[${dateFnsSupportFormatCh}]`, 'g');
  const formatNotSupportChReg = new RegExp(`[^${dateFnsSupportFormatCh}]`, 'g');
  const hmsReg = /[H|m|s]{1,2}/;
  const formatSplitted = formatToken.split(formatNotSupportChReg); // => ['HH', 'mm'];
  const timeSeparator = formatToken.replace(formatSupportChReg, ''); // => :
  const timeReg = new RegExp(`[${timeSeparator}]`, 'g'); // => /[:]/g
  const timeSplitted = time.split(timeReg); // => ['12', '0]
  if (formatSplitted.length !== timeSplitted.length) {
    isLike = false;
  } else {
    for (let i = 0, len = timeSplitted.length; i < len; i++) {
      const formatStr = formatSplitted[i];
      const timeStr = timeSplitted[i];
      // Returns false if the current character corresponds to minutes and seconds and the length is less than format
      // when i=1 => '0'.length < 'mm'.length
      if (hmsReg.test(formatStr) && timeStr.length < formatStr.length) {
        isLike = false;
        break;
      }
    }
  }
  return isLike;
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getHours/index.js


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate_toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/timePicker/foundation.js








// TODO: split, timePicker different components cannot share a foundation
class TimePickerFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    this.initDataFromDefaultValue();
    const open = this._isControlledComponent('open') ? this.getProp('open') : this.getProp('defaultOpen');
    if (open && !this._isControlledComponent('open')) {
      this._adapter.registerClickOutSide();
    }
  }
  getPosition() {
    const position = this.getProp('position');
    const type = this.getProp('type') || timePicker_constants_strings.DEFAULT_TYPE;
    // rtl change default position
    const direction = this.getContext('direction');
    const rtlDirection = direction === 'rtl' ? 'bottomRight' : '';
    return position || rtlDirection || timePicker_constants_strings.DEFAULT_POSITION[type];
  }
  isDisabledHMS(_ref) {
    let {
      hours,
      minutes,
      seconds
    } = _ref;
    const {
      disabledHours,
      disabledMinutes,
      disabledSeconds
    } = this.getProps();
    const hDis = !isNullOrUndefined(hours) && hourIsDisabled(disabledHours, hours);
    const mDis = !isNullOrUndefined(hours) && !isNullOrUndefined(minutes) && minuteIsDisabled(disabledMinutes, hours, minutes);
    const sDis = !isNullOrUndefined(hours) && !isNullOrUndefined(minutes) && !isNullOrUndefined(seconds) && secondIsDisabled(disabledSeconds, hours, minutes, seconds);
    return hDis || mDis || sDis;
  }
  isValidTimeZone(timeZone) {
    return ['string', 'number'].includes(typeof timeZone) && timeZone !== '';
  }
  getDefaultFormatIfNeed() {
    if (this._isInProps('format')) {
      return this.getProp('format');
    } else if (this.getProp('use12Hours')) {
      return timePicker_constants_strings.DEFAULT_FORMAT_A;
    } else {
      return timePicker_constants_strings.DEFAULT_FORMAT;
    }
  }
  /**
   * User input value => save timestamp
   */
  initDataFromDefaultValue() {
    const defaultValue = this.getProp('defaultValue');
    let value = this.getProp('value');
    const timeZone = this.getProp('timeZone');
    const formatToken = this.getValidFormat();
    const {
      rangeSeparator,
      dateFnsLocale
    } = this.getProps();
    value = value || defaultValue;
    if (!Array.isArray(value)) {
      value = value ? [value] : [];
    }
    const parsedValues = [];
    let invalid = false;
    value.forEach(v => {
      const pv = parseToDate(v, formatToken, dateFnsLocale);
      if (!isNaN(pv.getTime())) {
        parsedValues.push(this.isValidTimeZone(timeZone) ? utcToZonedTime(pv, timeZone) : pv);
      }
    });
    const isAM = [true, false];
    parsedValues.map((item, idx) => {
      isAM[idx] = getHours(item) < 12;
    });
    if (parsedValues.length === value.length) {
      value = parsedValues;
    } else {
      value = [];
      if (value.length) {
        invalid = true;
      }
    }
    let inputValue = '';
    if (!invalid) {
      inputValue = value.map(v => formatToString(v, formatToken, dateFnsLocale)).join(rangeSeparator);
    }
    this.setState({
      isAM,
      value,
      inputValue,
      invalid
    });
  }
  getValidFormat(validFormat) {
    let _format = validFormat;
    if (isNullOrUndefined(_format)) {
      _format = this.getDefaultFormatIfNeed();
    }
    if (typeof _format !== 'string') {
      _format = timePicker_constants_strings.DEFAULT_FORMAT;
    }
    return _format;
  }
  handlePanelChange(result) {
    let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // console.log(result, index);
    const formatToken = this.getValidFormat();
    const dateFnsLocale = this.getProp('dateFnsLocale');
    const oldValue = this.getState('value');
    let isAM = this.getState('isAM');
    const value = transformToArray(oldValue);
    isAM = transformToArray(isAM);
    if (result) {
      const panelIsAM = Boolean(result.isAM);
      const date = parseToDate(result.timeStampValue, formatToken, dateFnsLocale);
      value[index] = date;
      isAM[index] = panelIsAM;
      const inputValue = this.formatValue(value);
      if (this.getState('isAM')[index] !== result.isAM) {
        this.setState({
          isAM
        });
      }
      if (!this._isControlledComponent('value')) {
        const invalid = this.validateDates(value);
        this.setState({
          isAM,
          value,
          inputValue,
          invalid
        });
      }
      if (this._hasChanged(value, oldValue)) {
        this._notifyChange(value, inputValue);
      }
    }
  }
  refreshProps() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      value,
      timeZone,
      __prevTimeZone
    } = props;
    let dates = this.parseValue(value);
    let invalid = dates.some(d => isNaN(Number(d)));
    if (!invalid) {
      if (this.isValidTimeZone(timeZone)) {
        dates = dates.map(date => utcToZonedTime(this.isValidTimeZone(__prevTimeZone) ? zonedTimeToUtc(date, __prevTimeZone) : date, timeZone));
      }
      invalid = dates.some(d => this.isDisabledHMS({
        hours: d.getHours(),
        minutes: d.getMinutes(),
        seconds: d.getSeconds()
      }));
    }
    const inputValue = this.formatValue(dates);
    this.setState({
      value: dates,
      invalid,
      inputValue
    });
  }
  handleFocus(e) {
    if (!this.getState('open')) {
      this.handlePanelOpen();
    }
    this._adapter.notifyFocus(e);
  }
  setPanel(open) {
    this._adapter.togglePanel(open);
  }
  destroy() {
    this._adapter.unregisterClickOutSide();
  }
  handlePanelOpen() {
    if (!this._isControlledComponent('open')) {
      this._adapter.registerClickOutSide();
      this.setPanel(true);
    }
    this._adapter.notifyOpenChange(true);
  }
  handlePanelClose(clickedOutside, e) {
    if (!this._isControlledComponent('open')) {
      this._adapter.unregisterClickOutSide();
      this.setPanel(false);
    }
    this._adapter.notifyOpenChange(false);
    this._adapter.notifyBlur(e);
  }
  /* istanbul ignore next */
  handleVisibleChange(visible) {
    if (!this._isControlledComponent('open')) {
      this._adapter.togglePanel(visible);
    }
    this._adapter.notifyOpenChange(visible);
  }
  handleInputChange(input) {
    this._adapter.setInputValue(input);
    const rangeSeparator = this.getProp('rangeSeparator');
    const inputValues = split_default()(input, rangeSeparator);
    const formatToken = this.getValidFormat();
    /**
     * 如果输入的字符串不是formatLike则不进行下一步操作，以免输入过程被打断
     * 特殊case
     *  - 清空时，input 为 ''，此时需要跳过isTimeFormatLike判断
     *
     * If the input string is not formatLike, do not proceed to the next operation to avoid interruption of the input process
     *  special case
     *  -when emptying, the input is "', at this time you need to skip isTimeFormatLike judgment
     */
    if (input !== '' && inputValues.some(time => !isTimeFormatLike(time, formatToken))) {
      return;
    }
    const dates = this.parseInput(input);
    const invalid = this.validateDates(dates);
    const states = {
      invalid
    };
    const oldValue = this.getState('value');
    let value = transformToArray(oldValue);
    if (!invalid) {
      states.value = dates;
      value = [...dates];
    }
    if (!this._isControlledComponent('value')) {
      this.setState(states);
    }
    if (this._hasChanged(value, oldValue)) {
      this._notifyChange(value, input);
    }
  }
  /* istanbul ignore next */
  doValidate(args) {
    if (typeof args === 'string') {
      return this.validateStr(args);
    } else if (Array.isArray(args)) {
      return this.validateDates(args);
    }
    return undefined;
  }
  validateStr() {
    let inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const dates = this.parseInput(inputValue);
    return this.validateDates(dates);
  }
  validateDates() {
    let dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let invalid = dates.some(d => isNaN(Number(d)));
    if (!invalid) {
      invalid = dates.some(d => this.isDisabledHMS({
        hours: d.getHours(),
        minutes: d.getMinutes(),
        seconds: d.getSeconds()
      }));
    }
    return invalid;
  }
  handleInputBlur(e) {
    const invalid = this.getState('invalid');
    const inputValue = this.getState('inputValue');
    const value = this.getState('value');
    if (inputValue) {
      if (invalid) {
        this.setState({
          inputValue: this.formatValue(value),
          invalid: false
        });
      } else {
        this.setState({
          inputValue: this.formatValue(value)
        });
      }
    } else {
      this.setState({
        inputValue: '',
        value: [],
        invalid: false
      });
    }
  }
  formatValue(dates) {
    const validFormat = this.getValidFormat();
    const rangeSeparator = this.getProp('rangeSeparator');
    const dateFnsLocale = this.getProp('dateFnsLocale');
    let _dates = dates;
    if (_dates && !Array.isArray(_dates)) {
      _dates = _dates[_dates];
    }
    if (_dates && Array.isArray(_dates)) {
      const result = _dates.map(date => {
        let str;
        if (isUndefined_default()(date)) {
          str = '';
        } else {
          str = formatToString(date, validFormat, dateFnsLocale);
        }
        return str;
      });
      return result.join(rangeSeparator);
    }
    return undefined;
  }
  parseInput(str) {
    const validFormat = this.getValidFormat();
    const rangeSeparator = this.getProp('rangeSeparator');
    const dateFnsLocale = this.getProp('dateFnsLocale');
    if (str && typeof str === 'string') {
      return split_default()(str, rangeSeparator).map(v => parseToDate(v, validFormat, dateFnsLocale));
    }
    return [];
  }
  parseValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const formatToken = this.getValidFormat();
    const dateFnsLocale = this.getProp('dateFnsLocale');
    let _value = value;
    if (!Array.isArray(_value)) {
      _value = _value ? [_value] : [];
    }
    if (Array.isArray(_value)) {
      return _value.map(v => parseToDate(v, formatToken, dateFnsLocale));
    }
    return [];
  }
  _notifyChange(value, inputValue) {
    let str = inputValue;
    let _value = value;
    const timeZone = this.getProp('timeZone');
    if (this._adapter.isRangePicker()) {
      const rangeSeparator = this.getProp('rangeSeparator');
      str = split_default()(inputValue, rangeSeparator);
    } else {
      _value = Array.isArray(_value) ? _value[0] : _value;
    }
    if (this.isValidTimeZone(timeZone) && _value) {
      const formatToken = this.getValidFormat();
      if (Array.isArray(_value)) {
        _value = _value.map(v => zonedTimeToUtc(v, timeZone));
        str = _value.map(v => format_format(v, formatToken));
      } else {
        _value = zonedTimeToUtc(_value, timeZone);
        str = format_format(_value, formatToken);
      }
    }
    const onChangeWithDateFirst = this.getProp('onChangeWithDateFirst');
    if (onChangeWithDateFirst) {
      this._adapter.notifyChange(_value, str);
    } else {
      this._adapter.notifyChange(str, _value);
    }
  }
  _hasChanged() {
    let dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let oldDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const formatToken = this.getValidFormat();
    const dateFnsLocale = this.getProp('dateFnsLocale');
    return dates.length !== oldDates.length || dates.some((date, index) => {
      const oldDate = oldDates[index];
      if (isValid_isValid(date) && isValid_isValid(oldDate) && formatToString(date, formatToken, dateFnsLocale) === formatToString(oldDate, formatToken, dateFnsLocale)) {
        return false;
      }
      return true;
    });
  }
}
/* harmony default export */ var timePicker_foundation = (TimePickerFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/timePicker/inputFoundation.js


class inputFoundation_TimePickerFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {}
  destroy() {}
  handleFocus(e) {
    this.storeCursor();
    this._adapter.notifyFocus(e);
  }
  handleChange(v) {
    this.storeCursor();
    this._adapter.notifyChange(v);
  }
  handleBlur(e) {
    this.clearCursor();
    this._adapter.notifyBlur(e);
  }
  storeCursor() {
    const inputNode = this.getCache('inputNode');
    if (inputNode) {
      const {
        selectionStart: start
      } = inputNode;
      // const beforeStr = typeof value === 'string' ? value.substr(0, start) : null;
      // const afterStr = typeof value === 'string' ? value.substr(start, value.length - start + 1) : null;
      // console.log(start, beforeStr, afterStr);
      this.setCache('cursorIndex', start);
    }
  }
  restoreCursor() {
    const inputNode = this.getCache('inputNode');
    const cursorIndex = this.getCache('cursorIndex');
    if (inputNode && !isNullOrUndefined(cursorIndex)) {
      inputNode.selectionStart = cursorIndex;
      inputNode.selectionEnd = cursorIndex;
    }
  }
  clearCursor() {
    this.setCache('cursorIndex', null);
    this.setCache('beforeStr', null);
    this.setCache('afterStr', null);
  }
}
/* harmony default export */ var inputFoundation = (inputFoundation_TimePickerFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/TimeInput.js

var TimeInput_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








class TimeInput extends BaseComponent {
  constructor(props) {
    super(props);
    this.setRef = node => this.adapter.setCache('inputNode', node);
    this.handleClick = e => this.props.onClick(e);
    this.handleFocus = e => this.foundation.handleFocus(e);
    this.handleBlur = e => this.foundation.handleBlur(e);
    this.handleChange = v => this.foundation.handleChange(v);
    this.foundation = new inputFoundation(this.adapter);
    this.state = {
      // focusing: props.focusOnOpen,
    };
  }
  componentDidMount() {
    super.componentDidMount();
    const {
      focusOnOpen,
      preventScroll
    } = this.props;
    if (focusOnOpen) {
      const requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
      requestAnimationFrame(() => {
        const inputNode = this.adapter.getCache('inputNode');
        if (inputNode) {
          inputNode.focus({
            preventScroll
          });
          inputNode.select();
        }
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      timeStampValue
    } = this.props;
    if (this.isControlled('timeStampValue') && timeStampValue !== this.state.timeStampValue) {
      this.foundation.restoreCursor();
    }
    if (this.props.value !== prevProps.value) {
      this.foundation.restoreCursor();
    }
  }
  get adapter() {
    var _this = this;
    return Object.assign(Object.assign({}, super.adapter), {
      notifyChange: function () {
        return _this.props.onChange(...arguments);
      },
      notifyFocus: function () {
        return _this.props.onFocus(...arguments);
      },
      notifyBlur: function () {
        return _this.props.onBlur(...arguments);
      }
    });
  }
  getInput() {
    const _a = this.props,
      {
        prefixCls,
        placeholder,
        inputReadOnly,
        onFocus,
        disabled,
        type,
        locale,
        localeCode,
        insetLabel,
        validateStatus,
        value,
        onChange,
        invalid,
        format,
        clearText,
        disabledHours,
        disabledMinutes,
        disabledSeconds,
        onEsc,
        defaultOpenValue,
        currentSelectPanel,
        focusOnOpen,
        timeStampValue,
        timeZone,
        defaultOpen,
        dateFnsLocale
      } = _a,
      rest = TimeInput_rest(_a, ["prefixCls", "placeholder", "inputReadOnly", "onFocus", "disabled", "type", "locale", "localeCode", "insetLabel", "validateStatus", "value", "onChange", "invalid", "format", "clearText", "disabledHours", "disabledMinutes", "disabledSeconds", "onEsc", "defaultOpenValue", "currentSelectPanel", "focusOnOpen", "timeStampValue", "timeZone", "defaultOpen", "dateFnsLocale"]);
    // const { focusing } = this.state;
    const inputCls = classnames_default()(`${prefixCls}-input`, {
      [`${prefixCls}-input-invalid`]: invalid,
      [`${prefixCls}-input-readonly`]: inputReadOnly
    });
    const mergeValidateStatus = invalid ? 'error' : validateStatus;
    return /*#__PURE__*/react.createElement(es_input, Object.assign({}, rest, {
      hideSuffix: true,
      className: inputCls,
      ref: this.setRef,
      value: value,
      placeholder: placeholder || locale.placeholder[type],
      readonly: Boolean(inputReadOnly),
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      suffix: /*#__PURE__*/react.createElement(IconClock, {
        onClick: this.handleClick
      }),
      validateStatus: mergeValidateStatus,
      disabled: disabled,
      insetLabel: insetLabel
    }));
  }
  render() {
    const {
      prefixCls
    } = this.props;
    return /*#__PURE__*/react.createElement("div", {
      className: `${prefixCls}-input-wrap`
    }, this.getInput());
  }
}
TimeInput.propTypes = {
  borderless: (prop_types_default()).bool,
  format: (prop_types_default()).string,
  prefixCls: (prop_types_default()).string,
  placeholder: (prop_types_default()).string,
  clearText: (prop_types_default()).string,
  inputReadOnly: (prop_types_default()).bool,
  hourOptions: (prop_types_default()).array,
  minuteOptions: (prop_types_default()).array,
  secondOptions: (prop_types_default()).array,
  disabledHours: (prop_types_default()).func,
  disabledMinutes: (prop_types_default()).func,
  disabledSeconds: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onEsc: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  defaultOpenValue: (prop_types_default()).object,
  currentSelectPanel: (prop_types_default()).string,
  focusOnOpen: (prop_types_default()).bool,
  timeStampValue: (prop_types_default()).any,
  locale: (prop_types_default()).object,
  localeCode: (prop_types_default()).string,
  insetLabel: (prop_types_default()).node,
  validateStatus: (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool
};
TimeInput.defaultProps = {
  borderless: false,
  inputReadOnly: false,
  onChange: (noop_default()),
  onBlur: (noop_default()),
  onFocus: (noop_default()),
  onClick: (noop_default()),
  disabledHours: (noop_default()),
  disabledMinutes: (noop_default()),
  disabledSeconds: (noop_default()),
  format: timePicker_constants_strings.DEFAULT_FORMAT
};
/* harmony default export */ var timePicker_TimeInput = (TimeInput);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/PanelShape.js

const PanelShape = {
  panelHeader: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).string]),
  panelFooter: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).string])
};
const PanelShapeDefaults = {};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/TimeShape.js

const PlainTimeShape = [(prop_types_default()).string, (prop_types_default()).number, prop_types_default().instanceOf(Date)];
/**
 * Can be
 * - 12:00:12
 * - \[12:00:12]
 * - \[12:00:12, 12:21:12]
 * - \[[12:00:12, 12:21:12], [12:11:12, 12:32:12]]
 */
const TimeShape = prop_types_default().oneOfType([...PlainTimeShape, prop_types_default().arrayOf((prop_types_default()).string), prop_types_default().arrayOf((prop_types_default()).number), prop_types_default().arrayOf(prop_types_default().instanceOf(Date))]);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/TimePicker.js


var TimePicker_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};














// import '@douyinfe/semi-foundation/lib/es/timePicker/timePicker.css';

class TimePicker extends BaseComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.onCurrentSelectPanelChange = currentSelectPanel => {
      this.setState({
        currentSelectPanel
      });
    };
    this.handlePanelChange = (value, index) => this.foundation.handlePanelChange(value, index);
    this.handleInput = value => this.foundation.handleInputChange(value);
    this.createPanelProps = function () {
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const {
        panels,
        panelFooter,
        panelHeader,
        locale
      } = _this.props;
      const panelProps = {
        panelHeader,
        panelFooter
      };
      if (_this.adapter.isRangePicker()) {
        const defaultHeaderMap = {
          0: locale.begin,
          1: locale.end
        };
        panelProps.panelHeader = get_default()(panels, index, isNullOrUndefined(panelHeader) ? get_default()(defaultHeaderMap, index, null) : Array.isArray(panelHeader) ? panelHeader[index] : panelHeader);
        panelProps.panelFooter = get_default()(panels, index, Array.isArray(panelFooter) ? panelFooter[index] : panelFooter);
      }
      return panelProps;
    };
    /* istanbul ignore next */
    this.handlePanelVisibleChange = visible => this.foundation.handleVisibleChange(visible);
    this.openPanel = () => {
      this.foundation.handlePanelOpen();
    };
    this.handleFocus = e => {
      this.foundation.handleFocus(e);
    };
    this.handleBlur = e => this.foundation.handleInputBlur(e);
    this.setTimePickerRef = node => this.timePickerRef.current = node;
    const {
      format = timePicker_constants_strings.DEFAULT_FORMAT
    } = props;
    this.state = {
      open: props.open || props.defaultOpen || false,
      value: [],
      inputValue: '',
      currentSelectPanel: 0,
      isAM: [true, false],
      showHour: Boolean(format.match(/HH|hh|H|h/g)),
      showMinute: Boolean(format.match(/mm/g)),
      showSecond: Boolean(format.match(/ss/g)),
      invalid: undefined
    };
    this.foundation = new timePicker_foundation(this.adapter);
    this.timePickerRef = /*#__PURE__*/react.createRef();
    this.savePanelRef = /*#__PURE__*/react.createRef();
    this.useCustomTrigger = typeof this.props.triggerRender === 'function';
  }
  get adapter() {
    var _this2 = this;
    return Object.assign(Object.assign({}, super.adapter), {
      togglePanel: show => {
        this.setState({
          open: show
        });
      },
      registerClickOutSide: () => {
        if (this.clickOutSideHandler) {
          this.adapter.unregisterClickOutSide();
        }
        this.clickOutSideHandler = e => {
          const panel = this.savePanelRef && this.savePanelRef.current;
          const trigger = this.timePickerRef && this.timePickerRef.current;
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (!(panel && panel.contains(target)) && !(trigger && trigger.contains(target)) && !(path.includes(trigger) || path.includes(panel))) {
            this.foundation.handlePanelClose(true, e);
          }
        };
        document.addEventListener('mousedown', this.clickOutSideHandler);
      },
      setInputValue: (inputValue, cb) => this.setState({
        inputValue
      }, cb),
      unregisterClickOutSide: () => {
        if (this.clickOutSideHandler) {
          document.removeEventListener('mousedown', this.clickOutSideHandler);
          this.clickOutSideHandler = null;
        }
      },
      notifyOpenChange: function () {
        return _this2.props.onOpenChange(...arguments);
      },
      notifyChange: (agr1, arg2) => this.props.onChange && this.props.onChange(agr1, arg2),
      notifyFocus: function () {
        return _this2.props.onFocus && _this2.props.onFocus(...arguments);
      },
      notifyBlur: function () {
        return _this2.props.onBlur && _this2.props.onBlur(...arguments);
      },
      isRangePicker: () => this.props.type === timePicker_constants_strings.TYPE_TIME_RANGE_PICKER
    });
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if ('open' in nextProps && nextProps.open !== prevState.open) {
      return {
        open: nextProps.open
      };
    }
    return null;
  }
  componentDidUpdate(prevProps) {
    // if (this.isControlled('open') && this.props.open != null && this.props.open !== prevProps.open) {
    //     this.foundation.setPanel(this.props.open);
    // }
    if (this.isControlled('value') && this.props.value !== prevProps.value) {
      this.foundation.refreshProps(Object.assign({}, this.props));
    } else if (this.props.timeZone !== prevProps.timeZone) {
      this.foundation.refreshProps({
        timeZone: this.props.timeZone,
        __prevTimeZone: prevProps.timeZone,
        value: this.state.value
      });
    }
  }
  getPanelElement() {
    const {
      prefixCls,
      type
    } = this.props;
    const {
      isAM,
      value
    } = this.state;
    const format = this.foundation.getDefaultFormatIfNeed();
    const timePanels = [/*#__PURE__*/react.createElement(timePicker_Combobox, Object.assign({}, this.props, {
      key: 0,
      format: format,
      isAM: isAM[0],
      timeStampValue: value[0],
      prefixCls: `${prefixCls}-panel`,
      onChange: v => this.handlePanelChange(v, 0),
      onCurrentSelectPanelChange: this.onCurrentSelectPanelChange
    }, this.createPanelProps(0)))];
    if (type === timePicker_constants_strings.TYPE_TIME_RANGE_PICKER) {
      timePanels.push( /*#__PURE__*/react.createElement(timePicker_Combobox, Object.assign({}, this.props, {
        key: 1,
        format: format,
        isAM: isAM[1],
        timeStampValue: value[1],
        prefixCls: `${prefixCls}-panel`,
        onChange: v => this.handlePanelChange(v, 1),
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange
      }, this.createPanelProps(1))));
    }
    const wrapCls = classnames_default()({
      [timePicker_constants_cssClasses.RANGE_PANEL_LISTS]: this.adapter.isRangePicker()
    });
    return /*#__PURE__*/react.createElement("div", {
      ref: this.savePanelRef,
      className: wrapCls
    }, timePanels.map(panel => panel));
  }
  getPopupClassName() {
    const {
      use12Hours,
      prefixCls,
      popupClassName
    } = this.props;
    const {
      showHour,
      showMinute,
      showSecond
    } = this.state;
    let selectColumnCount = 0;
    if (showHour) {
      selectColumnCount += 1;
    }
    if (showMinute) {
      selectColumnCount += 1;
    }
    if (showSecond) {
      selectColumnCount += 1;
    }
    if (use12Hours) {
      selectColumnCount += 1;
    }
    return classnames_default()(`${prefixCls}-panel`, popupClassName, {
      [`${prefixCls}-panel-narrow`]: (!showHour || !showMinute || !showSecond) && !use12Hours,
      [timePicker_constants_cssClasses.RANGE_PICKER]: this.adapter.isRangePicker()
    }, `${prefixCls}-panel-column-${selectColumnCount}`);
  }
  focus() {
    // TODO this.picker is undefined, confirm keep this func or not
    // this.picker.focus();
  }
  blur() {
    // TODO this.picker is undefined, confirm keep this func or not
    // this.picker.blur();
  }
  render() {
    const _a = this.props,
      {
        prefixCls,
        placeholder,
        disabled,
        defaultValue,
        dropdownMargin,
        className,
        popupStyle,
        size,
        style,
        locale,
        localeCode,
        zIndex,
        getPopupContainer,
        insetLabel,
        insetLabelId,
        inputStyle,
        showClear,
        panelHeader,
        panelFooter,
        rangeSeparator,
        onOpenChange,
        onChangeWithDateFirst,
        popupClassName: propPopupClassName,
        hideDisabledOptions,
        use12Hours,
        minuteStep,
        hourStep,
        secondStep,
        scrollItemProps,
        triggerRender,
        motion,
        autoAdjustOverflow,
        stopPropagation
      } = _a,
      rest = TimePicker_rest(_a, ["prefixCls", "placeholder", "disabled", "defaultValue", "dropdownMargin", "className", "popupStyle", "size", "style", "locale", "localeCode", "zIndex", "getPopupContainer", "insetLabel", "insetLabelId", "inputStyle", "showClear", "panelHeader", "panelFooter", "rangeSeparator", "onOpenChange", "onChangeWithDateFirst", "popupClassName", "hideDisabledOptions", "use12Hours", "minuteStep", "hourStep", "secondStep", "scrollItemProps", "triggerRender", "motion", "autoAdjustOverflow", "stopPropagation"]);
    const format = this.foundation.getDefaultFormatIfNeed();
    const position = this.foundation.getPosition();
    const {
      open,
      inputValue,
      invalid,
      value
    } = this.state;
    const popupClassName = this.getPopupClassName();
    const headerPrefix = classnames_default()({
      [`${prefixCls}-header`]: true
    });
    const panelPrefix = classnames_default()({
      [`${prefixCls}-panel`]: true,
      [`${prefixCls}-panel-${size}`]: size
    });
    const inputProps = Object.assign(Object.assign({}, rest), {
      disabled,
      prefixCls,
      size,
      showClear: disabled ? false : showClear,
      style: inputStyle,
      value: inputValue,
      onFocus: this.handleFocus,
      insetLabel,
      insetLabelId,
      format,
      locale,
      localeCode,
      invalid,
      placeholder,
      onChange: this.handleInput,
      onBlur: this.handleBlur
    });
    const outerProps = {};
    if (this.useCustomTrigger) {
      outerProps.onClick = this.openPanel;
    }
    return /*#__PURE__*/react.createElement("div", Object.assign({
      ref: this.setTimePickerRef,
      className: classnames_default()({
        [prefixCls]: true
      }, className),
      style: style
    }, outerProps), /*#__PURE__*/react.createElement(popover, {
      getPopupContainer: getPopupContainer,
      zIndex: zIndex,
      prefixCls: panelPrefix,
      contentClassName: popupClassName,
      style: popupStyle,
      content: this.getPanelElement(),
      trigger: 'custom',
      position: position,
      visible: disabled ? false : Boolean(open),
      motion: motion,
      margin: dropdownMargin,
      autoAdjustOverflow: autoAdjustOverflow,
      stopPropagation: stopPropagation
    }, this.useCustomTrigger ? /*#__PURE__*/react.createElement(trigger, {
      triggerRender: triggerRender,
      disabled: disabled,
      value: value,
      inputValue: inputValue,
      onChange: this.handleInput,
      placeholder: placeholder,
      componentName: 'TimePicker',
      componentProps: Object.assign({}, this.props)
    }) : /*#__PURE__*/react.createElement("span", {
      className: headerPrefix
    }, /*#__PURE__*/react.createElement(timePicker_TimeInput, Object.assign({}, inputProps)))));
  }
}
TimePicker.contextType = context;
TimePicker.propTypes = Object.assign(Object.assign({
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  prefixCls: (prop_types_default()).string,
  borderless: (prop_types_default()).bool,
  clearText: (prop_types_default()).string,
  clearIcon: (prop_types_default()).node,
  value: TimeShape,
  inputReadOnly: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  showClear: (prop_types_default()).bool,
  defaultValue: TimeShape,
  open: (prop_types_default()).bool,
  defaultOpen: (prop_types_default()).bool,
  onOpenChange: (prop_types_default()).func,
  position: (prop_types_default()).any,
  getPopupContainer: (prop_types_default()).func,
  placeholder: (prop_types_default()).string,
  format: (prop_types_default()).string,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  popupClassName: (prop_types_default()).string,
  popupStyle: (prop_types_default()).object,
  disabledHours: (prop_types_default()).func,
  disabledMinutes: (prop_types_default()).func,
  disabledSeconds: (prop_types_default()).func,
  dropdownMargin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  hideDisabledOptions: (prop_types_default()).bool,
  onChange: (prop_types_default()).func,
  use12Hours: (prop_types_default()).bool,
  hourStep: (prop_types_default()).number,
  minuteStep: (prop_types_default()).number,
  secondStep: (prop_types_default()).number,
  focusOnOpen: (prop_types_default()).bool,
  autoFocus: (prop_types_default()).bool,
  size: prop_types_default().oneOf(timePicker_constants_strings.SIZE),
  stopPropagation: (prop_types_default()).bool,
  panels: prop_types_default().arrayOf(prop_types_default().shape(PanelShape)),
  onFocus: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  locale: (prop_types_default()).object,
  localeCode: (prop_types_default()).string,
  dateFnsLocale: (prop_types_default()).object,
  zIndex: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  validateStatus: prop_types_default().oneOf(timePicker_constants_strings.STATUS),
  type: prop_types_default().oneOf(timePicker_constants_strings.TYPES),
  rangeSeparator: (prop_types_default()).string,
  triggerRender: (prop_types_default()).func,
  timeZone: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  scrollItemProps: (prop_types_default()).object,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  autoAdjustOverflow: (prop_types_default()).bool
}, PanelShape), {
  inputStyle: (prop_types_default()).object,
  preventScroll: (prop_types_default()).bool
});
TimePicker.defaultProps = Object.assign({
  autoAdjustOverflow: true,
  borderless: false,
  getPopupContainer: () => document.body,
  showClear: true,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  rangeSeparator: timePicker_constants_strings.DEFAULT_RANGE_SEPARATOR,
  onOpenChange: (noop_default()),
  clearText: 'clear',
  prefixCls: timePicker_constants_cssClasses.PREFIX,
  inputReadOnly: false,
  style: {},
  stopPropagation: true,
  className: '',
  popupClassName: '',
  popupStyle: {
    left: '0px',
    top: '0px'
  },
  disabledHours: () => [],
  disabledMinutes: () => [],
  disabledSeconds: () => [],
  hideDisabledOptions: false,
  // position: 'bottomLeft',
  onFocus: (noop_default()),
  onBlur: (noop_default()),
  onChange: (noop_default()),
  onChangeWithDateFirst: true,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: (noop_default()),
  size: 'default',
  type: timePicker_constants_strings.DEFAULT_TYPE,
  motion: true
}, PanelShapeDefaults);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/timePicker/index.js






class LocaleTimePicker extends react.PureComponent {
  render() {
    const {
      type
    } = this.props;
    return /*#__PURE__*/react.createElement(context.Consumer, null, _ref => {
      let {
        timeZone
      } = _ref;
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "TimePicker"
      }, (locale, localeCode, dateFnsLocale) => /*#__PURE__*/react.createElement(TimePicker, Object.assign({
        timeZone: timeZone,
        placeholder: get_default()(locale, ['placeholder', type])
      }, this.props, {
        locale: locale,
        localeCode: localeCode,
        dateFnsLocale: dateFnsLocale
      })));
    });
  }
}
LocaleTimePicker.propTypes = TimePicker.propTypes;
LocaleTimePicker.__SemiComponentName__ = "TimePicker";
LocaleTimePicker.defaultProps = getDefaultPropsFromGlobalConfig(LocaleTimePicker.__SemiComponentName__, TimePicker.defaultProps);
// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(28583);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/cascader/constants.js

const cascader_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-cascader`,
  PREFIX_OPTION: `${BASE_CLASS_PREFIX}-cascader-option`
};
const cascader_constants_strings = {
  SIZE_SET: ['small', 'large', 'default'],
  VALIDATE_STATUS: ['success', 'default', 'error', 'warning'],
  IS_KEY: 'isKey',
  IS_VALUE: 'isValue',
  SHOW_NEXT_BY_CLICK: 'click',
  SHOW_NEXT_BY_HOVER: 'hover',
  /* Merge Type */
  LEAF_ONLY_MERGE_TYPE: 'leafOnly',
  AUTO_MERGE_VALUE_MERGE_TYPE: 'autoMergeValue',
  NONE_MERGE_TYPE: 'none',
  SEARCH_POSITION_TRIGGER: 'trigger',
  SEARCH_POSITION_CUSTOM: 'custom'
};
const cascader_constants_numbers = {};

const constants_VALUE_SPLIT = '_SEMI_CASCADER_SPLIT_';
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/cascader/util.js



function util_getPosition(level, index) {
  return `${level}-${index}`;
}
function util_isValid(val) {
  return !isNull_default()(val) && !isUndefined_default()(val);
}
function util_normalizedArr(val) {
  if (!Array.isArray(val)) {
    return [val];
  } else {
    return val;
  }
}
/**
 * @returns whether option includes sugInput.
 * When filterTreeNode is a function,returns the result of filterTreeNode which called with (sugInput, target, option).
 */
function util_filter(sugInput, option, filterTreeNode, filteredPath) {
  if (!filterTreeNode) {
    return true;
  }
  let filterFn = filterTreeNode;
  let target;
  if (typeof filterTreeNode === 'boolean') {
    filterFn = (targetVal, val) => {
      const input = targetVal.toLowerCase();
      return val.toLowerCase().includes(input);
    };
    // 当 filterTreeNode 是 bool 类型时，由 Cascader 内部判断是否符合筛选条件，使用 join('') 修复搜索英文逗号导致所有数据被匹配问题
    // When the type of of filterTreeNode is bool, Cascader internally determines whether it meets the filtering conditions.
    // Use join('') to fix the problem that searching for English commas causes all data to be matched.
    target = filteredPath.join('');
  } else {
    // 当 filterTreeNode 为函数类型时，由用户判断是否符合筛选条件，使用 join(), 和原来保持一致
    // When the type of of filterTreeNode is function, the user determines whether it meets the filtering conditions, 
    // uses join() to be consistent with the previous version.
    target = filteredPath.join();
  }
  return filterFn(sugInput, target, option);
}
/**
 * Traverse all the data by `treeData`.
 */
function util_traverseDataNodes(treeNodes, callback) {
  const processNode = (node, ind, parent) => {
    const children = node ? node.children : treeNodes;
    let item = null;
    // Process node if is not root
    if (node) {
      const key = parent ? `${parent.key}${constants_VALUE_SPLIT}${node.value}` : `${node.value}`;
      const pos = parent ? util_getPosition(parent.pos, ind) : `${ind}`;
      item = {
        data: Object.assign({}, node),
        ind,
        key,
        pos,
        level: parent ? parent.level + 1 : 0,
        parentKey: parent ? parent.key : null,
        path: parent ? [...parent.path, key] : [key],
        valuePath: parent ? [...parent.valuePath, node.value] : [node.value]
      };
      callback(item);
    }
    // Process children node
    if (children) {
      children.forEach((subNode, subIndex) => {
        processNode(subNode, subIndex, item);
      });
    }
  };
  processNode(null);
}
function getKeysByValuePath(valuePath) {
  if (valuePath === null || valuePath === void 0 ? void 0 : valuePath.length) {
    if (Array.isArray(valuePath[0])) {
      return valuePath.map(item => getKeyByValuePath(item));
    } else {
      return [getKeyByValuePath(valuePath)];
    }
  }
  return [];
}
function getKeyByValuePath(valuePath) {
  return valuePath.join(constants_VALUE_SPLIT);
}
function getValuePathByKey(key) {
  return key.split(VALUE_SPLIT);
}
function getKeyByPos(pos, treeData) {
  const posArr = pos.split('-').map(item => Number(item));
  let resultData = treeData;
  let valuePath = [];
  posArr.forEach((item, index) => {
    var _a;
    resultData = index === 0 ? resultData[item] : (_a = resultData === null || resultData === void 0 ? void 0 : resultData.children) === null || _a === void 0 ? void 0 : _a[item];
    valuePath.push(resultData === null || resultData === void 0 ? void 0 : resultData.value);
  });
  return getKeyByValuePath(valuePath);
}
function util_convertDataToEntities(dataNodes) {
  const keyEntities = {};
  util_traverseDataNodes(dataNodes, data => {
    const {
      key,
      parentKey
    } = data;
    const entity = Object.assign({}, data);
    keyEntities[key] = entity;
    // Fill children
    entity.parent = keyEntities[parentKey];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
  });
  return keyEntities;
}
function calcMergeType(autoMergeValue, leafOnly) {
  let mergeType;
  if (leafOnly) {
    mergeType = cascader_constants_strings.LEAF_ONLY_MERGE_TYPE;
  } else if (autoMergeValue) {
    mergeType = cascader_constants_strings.AUTO_MERGE_VALUE_MERGE_TYPE;
  } else {
    mergeType = cascader_constants_strings.NONE_MERGE_TYPE;
  }
  return mergeType;
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/cascader/foundation.js















class CascaderFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.updateSearching = isSearching => {
      this._adapter.updateStates({
        isSearching: false
      });
    };
    this.handleTagRemoveByKey = key => {
      var _a, _b;
      const {
        keyEntities
      } = this.getStates();
      const {
        disabled
      } = this.getProps();
      if (disabled) {
        /* istanbul ignore next */
        return;
      }
      const removedItem = (_a = keyEntities[key]) !== null && _a !== void 0 ? _a : {};
      !((_b = removedItem === null || removedItem === void 0 ? void 0 : removedItem.data) === null || _b === void 0 ? void 0 : _b.disable) && this._handleMultipleSelect(removedItem);
    };
    this.handleTagRemoveInTrigger = pos => {
      const {
        treeData
      } = this.getStates();
      const key = getKeyByPos(pos, treeData);
      this.handleTagRemoveByKey(key);
    };
  }
  init() {
    const isOpen = this.getProp('open') || this.getProp('defaultOpen');
    this.collectOptions(true);
    this._adapter.updateLoadingKeyRefValue(new Set());
    this._adapter.updateLoadedKeyRefValue(new Set());
    if (isOpen && !this._isDisabled()) {
      this.open();
    }
  }
  destroy() {
    this._adapter.unregisterClickOutsideHandler();
  }
  _isDisabled() {
    return this.getProp('disabled');
  }
  _isFilterable() {
    return Boolean(this.getProp('filterTreeNode')); // filter can be boolean or function
  }

  _notifyChange(item) {
    const {
      onChangeWithObject,
      multiple
    } = this.getProps();
    const valueProp = onChangeWithObject ? [] : 'value';
    if (multiple) {
      const valuePath = [];
      // @ts-ignore
      item.forEach(checkedKey => {
        const valuePathItem = this.getItemPropPath(checkedKey, valueProp);
        valuePath.push(valuePathItem);
      });
      this._adapter.notifyChange(valuePath);
    } else {
      const valuePath = isUndefined_default()(item) || !('key' in item) ? [] : this.getItemPropPath(item.key, valueProp);
      this._adapter.notifyChange(valuePath);
    }
  }
  _isLeaf(item) {
    if (this.getProp('loadData')) {
      return Boolean(item.isLeaf);
    }
    return !item.children || !item.children.length;
  }
  _clearInput() {
    this._adapter.updateInputValue('');
  }
  // Scenes that may trigger blur:
  //  1、clickOutSide
  _notifyBlur(e) {
    this._adapter.notifyBlur(e);
  }
  // Scenes that may trigger focus:
  //  1、click selection
  _notifyFocus(e) {
    this._adapter.notifyFocus(e);
  }
  _isOptionDisabled(key, keyEntities) {
    const isDisabled = findAncestorKeys([key], keyEntities, true).some(item => keyEntities[item].data.disabled);
    return isDisabled;
  }
  // prop: is array, return all data
  getItemPropPath(selectedKey, prop, keyEntities) {
    const searchMap = keyEntities || this.getState('keyEntities');
    const selectedItem = searchMap[selectedKey];
    let path = [];
    if (!selectedItem) {
      // do nothing
    } else if (selectedItem._notExist) {
      path = selectedItem.path;
    } else {
      const keyPath = selectedItem.path;
      path = Array.isArray(prop) ? keyPath.map(key => searchMap[key].data) : keyPath.map(key => searchMap[key].data[prop]);
    }
    return path;
  }
  _getCacheValue(keyEntities) {
    const {
      selectedKeys
    } = this.getStates();
    const selectedKey = Array.from(selectedKeys)[0];
    let cacheValue;
    /* selectedKeys does not match keyEntities */
    if (isEmpty_default()(keyEntities[selectedKey])) {
      if (includes_default()(selectedKey, 'not-exist-')) {
        /* Get the value behind not-exist- */
        const targetValue = selectedKey.match(/not-exist-(\S*)/)[1];
        if (isEmpty_default()(keyEntities[targetValue])) {
          cacheValue = targetValue;
        } else {
          /**
           * 典型的场景是: 假设我们选中了 0-0 这个节点，此时 selectedKeys=Set('0-0')，
           * 输入框会显示 0-0 的 label。当 treeData 发生更新，假设此时 0-0 在 treeData
           * 中不存在，则 selectedKeys=Set('not-exist-0-0')，此时输入框显示的是 0-0，
           * 也就是显示 not-exist- 后的内容。当treeData再次更新，假设此时 0-0 在 treeData
           * 中存在，则 selectedKeys=Set('0-0')，此时输入框显示 0-0 的 label。 这个地
           * 方做的操作就是，为了例子中第二次更新后 0-0 label 能够正常显示。
           */
          /**
           * The typical scenario is: suppose we select the 0-0 node, at this time
           *  selectedKeys=Set('0-0'), the input box will display a 0-0 label. When
           *  treeData is updated, assuming 0-0 does not exist in treeData at this
           *  time, then selectedKeys=Set('not-exist-0-0'), at this time the input
           *  box displays 0-0, which means not-exist -After the content. When treeData
           *  is updated again, assuming that 0-0 exists in treeData at this time,
           *  then selectedKeys=Set('0-0'), and the input box displays a label of
           *  0-0 at this time. The operation done here is for the 0-0 label to be
           *  displayed normally after the second update in the example.
           */
          cacheValue = keyEntities[targetValue].valuePath;
        }
      } else {
        cacheValue = selectedKey;
      }
      /* selectedKeys match keyEntities */
    } else {
      /* selectedKeys match keyEntities */
      cacheValue = keyEntities[selectedKey].valuePath;
    }
    return cacheValue;
  }
  collectOptions() {
    let init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const {
      treeData,
      value,
      defaultValue
    } = this.getProps();
    const keyEntities = util_convertDataToEntities(treeData);
    this._adapter.rePositionDropdown();
    let cacheValue;
    /* when mount */
    if (init) {
      cacheValue = defaultValue;
    } else if (!isEmpty_default()(keyEntities)) {
      cacheValue = this._getCacheValue(keyEntities);
    }
    const selectedValue = !this._isControlledComponent() ? cacheValue : isUndefined_default()(value) ? [] : value;
    if (util_isValid(selectedValue)) {
      this.updateSelectedKey(selectedValue, keyEntities);
    } else {
      this._adapter.updateStates({
        keyEntities
      });
    }
  }
  // call when props.value change
  handleValueChange(value) {
    const {
      keyEntities
    } = this.getStates();
    this.updateSelectedKey(value, keyEntities);
  }
  /**
   * When single selection, the clear objects of
   * selectedKeys, activeKeys, filteredKeys, input, etc.
   */
  _getClearSelectedKey(filterable) {
    const updateStates = {};
    const {
      searchPlaceholder,
      placeholder,
      multiple
    } = this.getProps();
    updateStates.selectedKeys = new Set([]);
    updateStates.activeKeys = new Set([]);
    updateStates.filteredKeys = new Set([]);
    if (filterable && !multiple) {
      updateStates.inputPlaceHolder = searchPlaceholder || placeholder || '';
      updateStates.inputValue = '';
    }
    return updateStates;
  }
  updateSelectedKey(value, keyEntities) {
    const {
      changeOnSelect,
      onChangeWithObject,
      multiple
    } = this.getProps();
    const {
      activeKeys,
      loading,
      keyEntities: keyEntityState,
      selectedKeys: selectedKeysState
    } = this.getStates();
    const loadingKeys = this._adapter.getLoadingKeyRefValue();
    const filterable = this._isFilterable();
    const loadingActive = [...activeKeys].filter(i => loadingKeys.has(i));
    const normalizedValue = util_normalizedArr(value);
    const valuePath = onChangeWithObject && isObject_default()(normalizedValue[0]) ? normalizedValue.map(i => i.value) : normalizedValue;
    const selectedKeys = getKeysByValuePath(valuePath);
    let updateStates = {};
    const selectedKey = selectedKeys.length > 0 ? selectedKeys[0] : undefined;
    const selectedItem = selectedKey ? keyEntities[selectedKey] : undefined;
    if (selectedItem) {
      /**
       * When changeOnSelect is turned on, or the target option is a leaf option,
       * the option is considered to be selected, even if the option is disabled
       */
      if (changeOnSelect || this._isLeaf(selectedItem.data)) {
        updateStates.selectedKeys = new Set([selectedKey]);
        if (!loadingActive.length) {
          updateStates.activeKeys = new Set(selectedItem.path);
        }
        if (filterable && !multiple) {
          const displayText = this.renderDisplayText(selectedKey, keyEntities);
          updateStates.inputPlaceHolder = displayText;
          /*
           *  displayText should not be assign to inputValue,
           *  cause inputValue should only change by user enter
           */
          // updateStates.inputValue = displayText;
        }
        /**
         * If selectedKeys does not meet the update conditions,
         * and state.selectedKeys is the same as selectedKeys
         * at this time, state.selectedKeys should be cleared.
         * A typical scenario is:
         * The originally selected node is the leaf node, but
         * after props.treeData is dynamically updated, the node
         * is a non-leaf node. At this point, selectedKeys should
         * be cleared.
         */
      } else if (isEqual_default()(selectedKeys, Array.from(selectedKeysState))) {
        updateStates = this._getClearSelectedKey(filterable);
      }
    } else if (value && value.length) {
      const val = valuePath[valuePath.length - 1];
      const key = `not-exist-${val}`;
      const optionNotExist = {
        data: {
          label: val,
          value: val
        },
        key,
        path: valuePath,
        _notExist: true
      };
      updateStates.selectedKeys = new Set([key]);
      if (filterable && !multiple) {
        const displayText = this._defaultRenderText(valuePath);
        updateStates.inputPlaceHolder = displayText;
        /*
         *  displayText should not be assign to inputValue,
         *  cause inputValue should only change by user enter
         */
        // updateStates.inputValue = displayText;
      }

      keyEntities[key] = optionNotExist;
      // Fix: 1155, if the data is loaded asynchronously to update treeData, the emptying operation should not be done when entering the updateSelectedKey method
    } else if (loading) {
      // Use assign to avoid overwriting the'not-exist- * 'property of keyEntities after asynchronous loading
      // Overwriting'not-exist- * 'will cause selectionContent to be emptied unexpectedly when clicking on a dropDown item
      updateStates.keyEntities = assign_default()(keyEntityState, keyEntities);
      this._adapter.updateStates(updateStates);
      return;
    } else {
      updateStates = this._getClearSelectedKey(filterable);
    }
    updateStates.keyEntities = keyEntities;
    this._adapter.updateStates(updateStates);
  }
  open() {
    const filterable = this._isFilterable();
    const {
      multiple
    } = this.getProps();
    this._adapter.openMenu();
    if (filterable) {
      this._clearInput();
      !multiple && this.toggle2SearchInput(true);
    }
    if (this._isControlledComponent()) {
      this.reCalcActiveKeys();
    }
    this._adapter.notifyDropdownVisibleChange(true);
    this._adapter.registerClickOutsideHandler(e => this.close(e));
  }
  reCalcActiveKeys() {
    const {
      selectedKeys,
      activeKeys,
      keyEntities
    } = this.getStates();
    const selectedKey = [...selectedKeys][0];
    const selectedItem = keyEntities[selectedKey];
    if (!selectedItem) {
      return;
    }
    const newActiveKeys = new Set(selectedItem.path);
    if (!isEqual_default()(newActiveKeys, activeKeys)) {
      this._adapter.updateStates({
        activeKeys: newActiveKeys
      });
    }
  }
  close(e, key) {
    const {
      multiple
    } = this.getProps();
    this._adapter.closeMenu();
    this._adapter.notifyDropdownVisibleChange(false);
    this._adapter.unregisterClickOutsideHandler();
    if (this._isFilterable()) {
      const {
        selectedKeys,
        isSearching
      } = this.getStates();
      let inputValue = '';
      if (key && !multiple) {
        inputValue = this.renderDisplayText(key);
      } else if (selectedKeys.size && !multiple) {
        inputValue = this.renderDisplayText([...selectedKeys][0]);
      }
      this._adapter.updateStates({
        inputValue
      });
      !multiple && this.toggle2SearchInput(false);
      !multiple && this._adapter.updateFocusState(false);
    }
    this._notifyBlur(e);
  }
  focus() {
    const {
      filterTreeNode
    } = this.getProps();
    if (filterTreeNode) {
      this._adapter.focusInput();
    }
    this._adapter.updateFocusState(true);
  }
  blur() {
    const {
      filterTreeNode
    } = this.getProps();
    if (filterTreeNode) {
      this._adapter.blurInput();
    }
    this._adapter.updateFocusState(false);
  }
  toggle2SearchInput(isShow) {
    if (isShow) {
      this._adapter.toggleInputShow(isShow, () => this.focus());
    } else {
      this._adapter.toggleInputShow(isShow, () => undefined);
    }
  }
  handleItemClick(e, item) {
    const isDisabled = this._isDisabled();
    if (isDisabled) {
      return;
    }
    this.handleSingleSelect(e, item);
    this._adapter.rePositionDropdown();
  }
  handleItemHover(e, item) {
    const isDisabled = this._isDisabled();
    if (isDisabled) {
      return;
    }
    this.handleShowNextByHover(item);
  }
  handleShowNextByHover(item) {
    const {
      keyEntities
    } = this.getStates();
    const {
      data,
      key
    } = item;
    const isLeaf = this._isLeaf(data);
    const activeKeys = keyEntities[key].path;
    this._adapter.updateStates({
      activeKeys: new Set(activeKeys)
    });
    if (!isLeaf) {
      this.notifyIfLoadData(item);
    }
  }
  onItemCheckboxClick(item) {
    const isDisabled = this._isDisabled();
    if (isDisabled) {
      return;
    }
    this._handleMultipleSelect(item);
    this._adapter.rePositionDropdown();
  }
  handleClick(e) {
    const isDisabled = this._isDisabled();
    const isFilterable = this._isFilterable();
    const {
      isOpen
    } = this.getStates();
    if (isDisabled) {
      return;
    } else if (!isOpen) {
      this.open();
      this._notifyFocus(e);
    } else if (isOpen && !isFilterable) {
      this.close(e);
    }
  }
  /**
   * A11y: simulate selection click
   */
  /* istanbul ignore next */
  handleSelectionEnterPress(keyboardEvent) {
    if (utils_isEnterPress(keyboardEvent)) {
      this.handleClick(keyboardEvent);
    }
  }
  toggleHoverState(bool) {
    this._adapter.toggleHovering(bool);
  }
  _defaultRenderText(path, displayRender) {
    const separator = this.getProp('separator');
    if (displayRender && typeof displayRender === 'function') {
      return displayRender(path);
    } else {
      return path.join(separator);
    }
  }
  renderDisplayText(targetKey, keyEntities) {
    const renderFunc = this.getProp('displayRender');
    const displayProp = this.getProp('displayProp');
    const displayPath = this.getItemPropPath(targetKey, displayProp, keyEntities);
    return this._defaultRenderText(displayPath, renderFunc);
  }
  handleNodeLoad(item) {
    const {
      data,
      key
    } = item;
    const prevLoadingKeys = new Set(this._adapter.getLoadingKeyRefValue());
    const prevLoadedKeys = new Set(this._adapter.getLoadedKeyRefValue());
    const newLoadedKeys = prevLoadedKeys.add(key);
    const newLoadingKeys = new Set([...prevLoadingKeys]);
    newLoadingKeys.delete(key);
    // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
    this._adapter.notifyOnLoad(newLoadedKeys, data);
    this._adapter.updateLoadingKeyRefValue(newLoadingKeys);
    this._adapter.updateLoadedKeyRefValue(newLoadedKeys);
    this._adapter.updateStates({
      loadingKeys: newLoadingKeys,
      loadedKeys: newLoadedKeys
    });
  }
  notifyIfLoadData(item) {
    const {
      data,
      key
    } = item;
    this._adapter.updateStates({
      loading: false
    });
    if (!data.isLeaf && !data.children && this.getProp('loadData')) {
      const loadedKeys = this._adapter.getLoadedKeyRefValue();
      const loadingKeys = new Set(this._adapter.getLoadingKeyRefValue());
      if (loadedKeys.has(key) || loadingKeys.has(key)) {
        return;
      }
      this._adapter.updateStates({
        loading: true
      });
      const {
        keyEntities
      } = this.getStates();
      const optionPath = this.getItemPropPath(key, [], keyEntities);
      const newLoadingKeys = loadingKeys.add(key);
      this._adapter.updateLoadingKeyRefValue(newLoadingKeys);
      this._adapter.updateStates({
        loadingKeys: newLoadingKeys
      });
      this._adapter.notifyLoadData(optionPath, this.handleNodeLoad.bind(this, item));
    }
  }
  handleSingleSelect(e, item) {
    const {
      changeOnSelect: allowChange,
      filterLeafOnly,
      multiple,
      enableLeafClick
    } = this.getProps();
    const {
      keyEntities,
      selectedKeys,
      isSearching
    } = this.getStates();
    const filterable = this._isFilterable();
    const {
      data,
      key
    } = item;
    const isLeaf = this._isLeaf(data);
    const activeKeys = keyEntities[key].path;
    const selectedKey = [key];
    const hasChanged = key !== [...selectedKeys][0];
    if (!isLeaf && !allowChange && !isSearching) {
      this._adapter.updateStates({
        activeKeys: new Set(activeKeys)
      });
      this.notifyIfLoadData(item);
      return;
    }
    if (multiple) {
      this._adapter.updateStates({
        activeKeys: new Set(activeKeys)
      });
      if (isLeaf && enableLeafClick) {
        this.onItemCheckboxClick(item);
      }
    } else {
      this._adapter.notifySelect(data.value);
      if (hasChanged) {
        this._notifyChange(item);
        this.notifyIfLoadData(item);
        if (this._isControlledComponent()) {
          this._adapter.updateStates({
            activeKeys: new Set(activeKeys)
          });
          if (isLeaf) {
            this.close(e);
          }
          return;
        }
        this._adapter.updateStates({
          activeKeys: new Set(activeKeys),
          selectedKeys: new Set(selectedKey)
        });
        const displayText = this.renderDisplayText(key);
        if (filterable) {
          this._adapter.updateInputPlaceHolder(displayText);
        }
        if (isLeaf) {
          this.close(e, key);
        } else if (!filterLeafOnly && isSearching) {
          this.close(e, key);
        }
      } else {
        this.close(e);
      }
    }
  }
  _handleMultipleSelect(item) {
    const {
      key
    } = item;
    const {
      checkedKeys,
      keyEntities,
      resolvedCheckedKeys
    } = this.getStates();
    const {
      autoMergeValue,
      max,
      disableStrictly,
      leafOnly
    } = this.getProps();
    // prev checked status
    const prevCheckedStatus = checkedKeys.has(key);
    // next checked status
    const curCheckedStatus = disableStrictly ? this.calcCheckedStatus(!prevCheckedStatus, key) : !prevCheckedStatus;
    // calculate all key of nodes that are checked or half checked
    const {
      checkedKeys: curCheckedKeys,
      halfCheckedKeys: curHalfCheckedKeys
    } = disableStrictly ? this.calcNonDisabledCheckedKeys(key, curCheckedStatus) : this.calcCheckedKeys(key, curCheckedStatus);
    const mergeType = calcMergeType(autoMergeValue, leafOnly);
    const isLeafOnlyMerge = mergeType === cascader_constants_strings.LEAF_ONLY_MERGE_TYPE;
    const isNoneMerge = mergeType === cascader_constants_strings.NONE_MERGE_TYPE;
    const curResolvedCheckedKeys = new Set(normalizeKeyList(curCheckedKeys, keyEntities, isLeafOnlyMerge));
    const curRealCheckedKeys = isNoneMerge ? curCheckedKeys : curResolvedCheckedKeys;
    if (isNumber_default()(max)) {
      if (!isNoneMerge) {
        // When it exceeds max, the quantity is allowed to be reduced, and no further increase is allowed
        if (resolvedCheckedKeys.size < curResolvedCheckedKeys.size && curResolvedCheckedKeys.size > max) {
          const checkedEntities = [];
          curResolvedCheckedKeys.forEach(itemKey => {
            checkedEntities.push(keyEntities[itemKey]);
          });
          this._adapter.notifyOnExceed(checkedEntities);
          return;
        }
      } else {
        // When it exceeds max, the quantity is allowed to be reduced, and no further increase is allowed
        if (checkedKeys.size < curCheckedKeys.size && curCheckedKeys.size > max) {
          const checkedEntities = [];
          curCheckedKeys.forEach(itemKey => {
            checkedEntities.push(keyEntities[itemKey]);
          });
          this._adapter.notifyOnExceed(checkedEntities);
          return;
        }
      }
    }
    if (!this._isControlledComponent()) {
      this._adapter.updateStates({
        checkedKeys: curCheckedKeys,
        halfCheckedKeys: curHalfCheckedKeys,
        resolvedCheckedKeys: curResolvedCheckedKeys
      });
    }
    // The click event during multiple selection will definitely cause the checked state of node to change,
    // so there is no need to judge the value to change.
    this._notifyChange(curRealCheckedKeys);
    if (curCheckedStatus) {
      this._notifySelect(curRealCheckedKeys);
    }
    this._adapter.updateStates({
      inputValue: ''
    });
  }
  calcNonDisabledCheckedKeys(eventKey, targetStatus) {
    const {
      keyEntities,
      disabledKeys
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    if (!hasDisabled) {
      return this.calcCheckedKeys(eventKey, targetStatus);
    }
    const nonDisabled = descendantKeys.filter(key => !disabledKeys.has(key));
    const newCheckedKeys = targetStatus ? [...nonDisabled, ...checkedKeys] : difference_default()(normalizeKeyList([...checkedKeys], keyEntities, true), nonDisabled);
    return calcCheckedKeys(newCheckedKeys, keyEntities);
  }
  calcCheckedStatus(targetStatus, eventKey) {
    if (!targetStatus) {
      return targetStatus;
    }
    const {
      checkedKeys,
      keyEntities,
      disabledKeys
    } = this.getStates();
    const descendantKeys = normalizeKeyList(findDescendantKeys([eventKey], keyEntities, false), keyEntities, true);
    const hasDisabled = descendantKeys.some(key => disabledKeys.has(key));
    if (!hasDisabled) {
      return targetStatus;
    }
    const nonDisabledKeys = descendantKeys.filter(key => !disabledKeys.has(key));
    const allChecked = nonDisabledKeys.every(key => checkedKeys.has(key));
    return !allChecked;
  }
  _notifySelect(keys) {
    const {
      keyEntities
    } = this.getStates();
    const values = [];
    keys.forEach(key => {
      var _a, _b;
      const valueItem = (_b = (_a = keyEntities[key]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value;
      valueItem !== undefined && values.push(valueItem);
    });
    const formatValue = values.length === 1 ? values[0] : values;
    this._adapter.notifySelect(formatValue);
  }
  /**
   * calculate all key of nodes that are checked or half checked
   * @param {string} key key of node
   * @param {boolean} curCheckedStatus checked status of node
   */
  calcCheckedKeys(key, curCheckedStatus) {
    const {
      keyEntities
    } = this.getStates();
    const checkedKeys = new Set(this.getState('checkedKeys'));
    const halfCheckedKeys = new Set(this.getState('halfCheckedKeys'));
    return curCheckedStatus ? calcCheckedKeysForChecked(key, keyEntities, checkedKeys, halfCheckedKeys) : calcCheckedKeysForUnchecked(key, keyEntities, checkedKeys, halfCheckedKeys);
  }
  handleInputChange(sugInput) {
    this._adapter.updateInputValue(sugInput);
    const {
      keyEntities
    } = this.getStates();
    const {
      treeNodeFilterProp,
      filterTreeNode,
      filterLeafOnly
    } = this.getProps();
    let filteredKeys = [];
    if (sugInput) {
      filteredKeys = Object.values(keyEntities).filter(item => {
        const {
          key,
          _notExist,
          data
        } = item;
        if (_notExist) {
          return false;
        }
        const filteredPath = this.getItemPropPath(key, treeNodeFilterProp);
        return util_filter(sugInput, data, filterTreeNode, filteredPath);
      }).filter(item => filterTreeNode && !filterLeafOnly || this._isLeaf(item)).map(item => item.key);
    }
    this._adapter.updateStates({
      isSearching: Boolean(sugInput),
      filteredKeys: new Set(filteredKeys)
    });
    this._adapter.notifyOnSearch(sugInput);
  }
  handleClear() {
    const {
      isSearching
    } = this.getStates();
    const {
      searchPlaceholder,
      placeholder,
      multiple
    } = this.getProps();
    const isFilterable = this._isFilterable();
    const isControlled = this._isControlledComponent();
    const newState = {};
    if (multiple) {
      newState.isSearching = false;
      this._adapter.updateInputValue('');
      this._adapter.notifyOnSearch('');
      newState.checkedKeys = new Set([]);
      newState.halfCheckedKeys = new Set([]);
      newState.selectedKeys = new Set([]);
      newState.activeKeys = new Set([]);
      newState.resolvedCheckedKeys = new Set([]);
      this._adapter.notifyChange([]);
    } else {
      // if click clearBtn when not searching, clear selected and active values as well
      if (isFilterable && isSearching) {
        newState.isSearching = false;
        this._adapter.updateInputValue('');
        this._adapter.notifyOnSearch('');
      } else {
        if (isFilterable) {
          newState.inputValue = '';
          newState.inputPlaceHolder = searchPlaceholder || placeholder || '';
          this._adapter.updateInputValue('');
          this._adapter.notifyOnSearch('');
        }
        if (!isControlled) {
          newState.selectedKeys = new Set([]);
        }
        newState.activeKeys = new Set([]);
        newState.filteredKeys = new Set([]);
        this._adapter.notifyChange([]);
      }
    }
    this._adapter.updateStates(newState);
    this._adapter.notifyClear();
    this._adapter.rePositionDropdown();
  }
  /**
   * A11y: simulate clear button click
   */
  /* istanbul ignore next */
  handleClearEnterPress(keyboardEvent) {
    if (utils_isEnterPress(keyboardEvent)) {
      this.handleClear();
    }
  }
  getRenderData() {
    const {
      keyEntities,
      isSearching
    } = this.getStates();
    const isFilterable = this._isFilterable();
    if (isSearching && isFilterable) {
      return this.getFilteredData();
    }
    return Object.values(keyEntities).filter(item => item.parentKey === null && !item._notExist)
    // @ts-ignore
    .sort((a, b) => parseInt(a.ind, 10) - parseInt(b.ind, 10));
  }
  getFilteredData() {
    const {
      treeNodeFilterProp,
      filterSorter
    } = this.getProps();
    const {
      filteredKeys,
      keyEntities,
      inputValue
    } = this.getStates();
    const filteredList = [];
    const filteredKeyArr = [...filteredKeys];
    filteredKeyArr.forEach(key => {
      const item = keyEntities[key];
      if (!item) {
        return;
      }
      const pathData = this.getItemPropPath(key, []);
      const itemSearchPath = pathData.map(item => item[treeNodeFilterProp]);
      const isDisabled = this._isOptionDisabled(key, keyEntities);
      filteredList.push({
        data: item.data,
        pathData,
        key,
        disabled: isDisabled,
        searchText: itemSearchPath
      });
    });
    if (isFunction_default()(filterSorter)) {
      filteredList.sort((a, b) => {
        return filterSorter(a.pathData, b.pathData, inputValue);
      });
    }
    return filteredList;
  }
  handleListScroll(e, ind) {
    const {
      activeKeys,
      keyEntities
    } = this.getStates();
    const lastActiveKey = [...activeKeys][activeKeys.size - 1];
    const data = lastActiveKey ? get_default()(keyEntities, [lastActiveKey, 'data'], null) : null;
    this._adapter.notifyListScroll(e, {
      panelIndex: ind,
      activeNode: data
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/cascader/virtualRow.js
const virtualRow_VirtualRow = _ref => {
  let {
    index,
    data,
    style
  } = _ref;
  const {
    visibleOptions,
    renderOption
  } = data;
  const option = visibleOptions[index];
  return renderOption(option, index, style);
};
/* harmony default export */ var cascader_virtualRow = (virtualRow_VirtualRow);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/cascader/item.js













const item_prefixcls = cascader_constants_cssClasses.PREFIX_OPTION;
class Item extends react.PureComponent {
  constructor() {
    super(...arguments);
    this.onClick = (e, item) => {
      const {
        onItemClick
      } = this.props;
      if (item.data.disabled || 'disabled' in item && item.disabled) {
        return;
      }
      onItemClick(e, item);
    };
    /**
     * A11y: simulate item click
     */
    this.handleItemEnterPress = (keyboardEvent, item) => {
      if (utils_isEnterPress(keyboardEvent)) {
        this.onClick(keyboardEvent, item);
      }
    };
    this.onHover = (e, item) => {
      const {
        showNext,
        onItemHover
      } = this.props;
      if (item.data.disabled) {
        return;
      }
      if (showNext === cascader_constants_strings.SHOW_NEXT_BY_HOVER) {
        onItemHover(e, item);
      }
    };
    this.onCheckboxChange = (e, item) => {
      const {
        onItemCheckboxClick
      } = this.props;
      // Prevent Checkbox's click event bubbling to trigger the li click event
      e.stopPropagation();
      if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
        e.nativeEvent.stopImmediatePropagation();
      }
      onItemCheckboxClick(item);
    };
    this.getItemStatus = key => {
      const {
        activeKeys,
        selectedKeys,
        loadedKeys,
        loadingKeys
      } = this.props;
      const state = {
        active: false,
        selected: false,
        loading: false
      };
      if (activeKeys.has(key)) {
        state.active = true;
      }
      if (selectedKeys.has(key)) {
        state.selected = true;
      }
      if (loadingKeys.has(key) && !loadedKeys.has(key)) {
        state.loading = true;
      }
      return state;
    };
    this.renderIcon = function (type) {
      let haveMarginLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const finalCls = style => {
        return style + (haveMarginLeft ? ` ${item_prefixcls}-icon-left` : '');
      };
      switch (type) {
        case 'child':
          return /*#__PURE__*/react.createElement(IconChevronRight, {
            className: finalCls(`${item_prefixcls}-icon ${item_prefixcls}-icon-expand`)
          });
        case 'tick':
          return /*#__PURE__*/react.createElement(IconTick, {
            className: finalCls(`${item_prefixcls}-icon ${item_prefixcls}-icon-active`)
          });
        case 'loading':
          return /*#__PURE__*/react.createElement(spin, {
            wrapperClassName: finalCls(`${item_prefixcls}-spin-icon`)
          });
        case 'empty':
          return /*#__PURE__*/react.createElement("span", {
            "aria-hidden": true,
            className: finalCls(`${item_prefixcls}-icon ${item_prefixcls}-icon-empty`)
          });
        default:
          return null;
      }
    };
    this.highlight = searchText => {
      const content = [];
      const {
        keyword,
        separator
      } = this.props;
      searchText.forEach((item, idx) => {
        if (typeof item === 'string' && includes_default()(item, keyword)) {
          item.split(keyword).forEach((node, index) => {
            if (index > 0) {
              content.push( /*#__PURE__*/react.createElement("span", {
                className: `${item_prefixcls}-label-highlight`,
                key: `${index}-${idx}`
              }, keyword));
            }
            content.push(node);
          });
        } else {
          content.push(item);
        }
        if (idx !== searchText.length - 1) {
          content.push(separator);
        }
      });
      return content;
    };
    this.renderFlattenOptionItem = (data, index, style) => {
      var _a;
      const {
        multiple,
        selectedKeys,
        checkedKeys,
        halfCheckedKeys,
        keyword,
        filterRender,
        virtualize
      } = this.props;
      const {
        searchText,
        key,
        disabled,
        pathData
      } = data;
      const selected = selectedKeys.has(key);
      const className = classnames_default()(item_prefixcls, {
        [`${item_prefixcls}-flatten`]:  true && !filterRender,
        [`${item_prefixcls}-disabled`]: disabled,
        [`${item_prefixcls}-select`]: selected && !multiple
      });
      const onClick = e => {
        this.onClick(e, data);
      };
      const onKeyPress = e => this.handleItemEnterPress(e, data);
      const onCheck = e => this.onCheckboxChange(e, data);
      if (filterRender) {
        const props = {
          className,
          inputValue: keyword,
          disabled,
          data: pathData,
          checkStatus: {
            checked: checkedKeys.has(data.key),
            halfChecked: halfCheckedKeys.has(data.key)
          },
          selected,
          onClick,
          onCheck
        };
        const item = filterRender(props);
        const otherProps = virtualize ? {
          key,
          style: Object.assign(Object.assign({}, (_a = item.props.style) !== null && _a !== void 0 ? _a : {}), style)
        } : {
          key
        };
        return /*#__PURE__*/react.cloneElement(item, otherProps);
      }
      return /*#__PURE__*/react.createElement("li", {
        role: 'menuitem',
        className: className,
        style: style,
        key: key,
        onClick: onClick,
        onKeyPress: onKeyPress
      }, /*#__PURE__*/react.createElement("span", {
        className: `${item_prefixcls}-label`
      }, !multiple && this.renderIcon('empty'), multiple && /*#__PURE__*/react.createElement(es_checkbox, {
        onChange: onCheck,
        disabled: disabled,
        indeterminate: halfCheckedKeys.has(data.key),
        checked: checkedKeys.has(data.key),
        className: `${item_prefixcls}-label-checkbox`
      }), this.highlight(searchText)));
    };
    this.renderFlattenOption = data => {
      const {
        virtualize
      } = this.props;
      const content = /*#__PURE__*/react.createElement("ul", {
        className: `${item_prefixcls}-list`,
        key: 'flatten-list'
      }, virtualize ? this.renderVirtualizeList(data) : data.map(item => this.renderFlattenOptionItem(item)));
      return content;
    };
    this.renderVirtualizeList = visibleOptions => {
      var _a;
      const {
        direction
      } = this.context;
      const {
        virtualize
      } = this.props;
      return /*#__PURE__*/react.createElement(FixedSizeList, {
        height: virtualize.height,
        itemCount: visibleOptions.length,
        itemSize: virtualize.itemSize,
        itemData: {
          visibleOptions,
          renderOption: this.renderFlattenOptionItem
        },
        width: (_a = virtualize.width) !== null && _a !== void 0 ? _a : '100%',
        style: {
          direction
        }
      }, cascader_virtualRow);
    };
  }
  renderItem(renderData) {
    let content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const {
      multiple,
      checkedKeys,
      halfCheckedKeys
    } = this.props;
    let showChildItem;
    const ind = content.length;
    content.push( /*#__PURE__*/react.createElement("ul", {
      role: 'menu',
      className: `${item_prefixcls}-list`,
      key: renderData[0].key,
      onScroll: e => this.props.onListScroll(e, ind)
    }, renderData.map(item => {
      const {
        data,
        key,
        parentKey
      } = item;
      const {
        children,
        label,
        disabled,
        isLeaf
      } = data;
      const {
        active,
        selected,
        loading
      } = this.getItemStatus(key);
      const hasChild = Boolean(children) && children.length;
      const showExpand = hasChild || this.props.loadData && !isLeaf;
      if (active && hasChild) {
        showChildItem = item;
      }
      const className = classnames_default()(item_prefixcls, {
        [`${item_prefixcls}-active`]: active && !selected,
        [`${item_prefixcls}-select`]: selected && !multiple,
        [`${item_prefixcls}-disabled`]: disabled
      });
      const otherAriaProps = parentKey ? {
        ['aria-owns']: `cascaderItem-${parentKey}`
      } : {};
      return /*#__PURE__*/react.createElement("li", Object.assign({
        role: 'menuitem',
        id: `cascaderItem-${key}`,
        "aria-expanded": active,
        "aria-haspopup": Boolean(showExpand),
        "aria-disabled": disabled
      }, otherAriaProps, {
        className: className,
        key: key,
        onClick: e => {
          this.onClick(e, item);
        },
        onKeyPress: e => this.handleItemEnterPress(e, item),
        onMouseEnter: e => {
          this.onHover(e, item);
        }
      }), /*#__PURE__*/react.createElement("span", {
        className: `${item_prefixcls}-label`
      }, selected && !multiple && this.renderIcon('tick'), !selected && !multiple && this.renderIcon('empty'), multiple && /*#__PURE__*/react.createElement(es_checkbox, {
        onChange: e => this.onCheckboxChange(e, item),
        disabled: disabled,
        indeterminate: halfCheckedKeys.has(item.key),
        checked: checkedKeys.has(item.key),
        className: `${item_prefixcls}-label-checkbox`
      }), /*#__PURE__*/react.createElement("span", null, label)), showExpand ? this.renderIcon(loading ? 'loading' : 'child', true) : null);
    })));
    if (showChildItem) {
      content.concat(this.renderItem(showChildItem.children, content));
    }
    return content;
  }
  renderEmpty() {
    const {
      emptyContent
    } = this.props;
    return /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Cascader"
    }, locale => /*#__PURE__*/react.createElement("ul", {
      className: `${item_prefixcls} ${item_prefixcls}-empty`,
      key: 'empty-list'
    }, /*#__PURE__*/react.createElement("span", {
      className: `${item_prefixcls}-label`,
      "x-semi-prop": "emptyContent"
    }, emptyContent || locale.emptyText)));
  }
  render() {
    const {
      data,
      searchable
    } = this.props;
    const {
      direction
    } = this.context;
    const isEmpty = !data || !data.length;
    let content;
    const listsCls = classnames_default()({
      [`${item_prefixcls}-lists`]: true,
      [`${item_prefixcls}-lists-rtl`]: direction === 'rtl',
      [`${item_prefixcls}-lists-empty`]: isEmpty
    });
    if (isEmpty) {
      content = this.renderEmpty();
    } else {
      content = searchable ? this.renderFlattenOption(data) : this.renderItem(data);
    }
    return /*#__PURE__*/react.createElement("div", {
      className: listsCls
    }, content);
  }
}
Item.contextType = context;
Item.propTypes = {
  data: (prop_types_default()).array,
  emptyContent: (prop_types_default()).node,
  searchable: (prop_types_default()).bool,
  onItemClick: (prop_types_default()).func,
  onItemHover: (prop_types_default()).func,
  multiple: (prop_types_default()).bool,
  showNext: prop_types_default().oneOf([cascader_constants_strings.SHOW_NEXT_BY_CLICK, cascader_constants_strings.SHOW_NEXT_BY_HOVER]),
  checkedKeys: (prop_types_default()).object,
  halfCheckedKeys: (prop_types_default()).object,
  onItemCheckboxClick: (prop_types_default()).func,
  separator: (prop_types_default()).string,
  keyword: (prop_types_default()).string,
  virtualize: (prop_types_default()).object
};
Item.defaultProps = {
  empty: false
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/cascader/index.js















// import '@douyinfe/semi-foundation/lib/es/cascader/cascader.css';












const cascader_prefixcls = cascader_constants_cssClasses.PREFIX;
const resetkey = 0;
class Cascader extends BaseComponent {
  constructor(props) {
    super(props);
    // ref method
    this.search = value => {
      this.handleInputChange(value);
    };
    this.handleInputChange = value => {
      this.foundation.handleInputChange(value);
    };
    this.handleTagRemoveInTrigger = pos => {
      this.foundation.handleTagRemoveInTrigger(pos);
    };
    this.handleTagClose = (tagChildren, e, tagKey) => {
      // When value has not changed, prevent clicking tag closeBtn to close tag
      e.preventDefault();
      this.foundation.handleTagRemoveByKey(tagKey);
    };
    this.renderTagItem = (nodeKey, idx) => {
      const {
        keyEntities,
        disabledKeys
      } = this.state;
      const {
        size,
        disabled,
        displayProp,
        displayRender,
        disableStrictly
      } = this.props;
      if (keyEntities[nodeKey]) {
        const isDisabled = disabled || keyEntities[nodeKey].data.disabled || disableStrictly && disabledKeys.has(nodeKey);
        const tagCls = classnames_default()(`${cascader_prefixcls}-selection-tag`, {
          [`${cascader_prefixcls}-selection-tag-disabled`]: isDisabled
        });
        // custom render tags
        if (isFunction_default()(displayRender)) {
          return displayRender(keyEntities[nodeKey], idx);
          // default render tags
        } else {
          return /*#__PURE__*/react.createElement(Tag, {
            size: size === 'default' ? 'large' : size,
            key: `tag-${nodeKey}-${idx}`,
            color: "white",
            tagKey: nodeKey,
            className: tagCls,
            closable: true,
            onClose: this.handleTagClose
          }, keyEntities[nodeKey].data[displayProp]);
        }
      }
      return null;
    };
    this.onRemoveInTagInput = v => {
      this.foundation.handleTagRemoveByKey(v);
    };
    this.handleItemClick = (e, item) => {
      this.foundation.handleItemClick(e, item);
    };
    this.handleItemHover = (e, item) => {
      this.foundation.handleItemHover(e, item);
    };
    this.onItemCheckboxClick = item => {
      this.foundation.onItemCheckboxClick(item);
    };
    this.handleListScroll = (e, ind) => {
      this.foundation.handleListScroll(e, ind);
    };
    this.renderContent = () => {
      const {
        inputValue,
        isSearching,
        activeKeys,
        selectedKeys,
        checkedKeys,
        halfCheckedKeys,
        loadedKeys,
        loadingKeys
      } = this.state;
      const {
        filterTreeNode,
        dropdownClassName,
        dropdownStyle,
        loadData,
        emptyContent,
        separator,
        topSlot,
        bottomSlot,
        showNext,
        multiple,
        filterRender,
        virtualizeInSearch
      } = this.props;
      const searchable = Boolean(filterTreeNode) && isSearching;
      const popoverCls = classnames_default()(dropdownClassName, `${cascader_prefixcls}-popover`);
      const renderData = this.foundation.getRenderData();
      const content = /*#__PURE__*/react.createElement("div", {
        className: popoverCls,
        role: "listbox",
        style: dropdownStyle
      }, topSlot, /*#__PURE__*/react.createElement(Item, {
        activeKeys: activeKeys,
        selectedKeys: selectedKeys,
        separator: separator,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        onItemClick: this.handleItemClick,
        onItemHover: this.handleItemHover,
        showNext: showNext,
        onItemCheckboxClick: this.onItemCheckboxClick,
        onListScroll: this.handleListScroll,
        searchable: searchable,
        keyword: inputValue,
        emptyContent: emptyContent,
        loadData: loadData,
        data: renderData,
        multiple: multiple,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        filterRender: filterRender,
        virtualize: virtualizeInSearch
      }), bottomSlot);
      return content;
    };
    this.renderPlusN = hiddenTag => {
      const {
        disabled,
        showRestTagsPopover,
        restTagsPopoverProps
      } = this.props;
      const plusNCls = classnames_default()(`${cascader_prefixcls}-selection-n`, {
        [`${cascader_prefixcls}-selection-n-disabled`]: disabled
      });
      const renderPlusNChildren = /*#__PURE__*/react.createElement("span", {
        className: plusNCls
      }, "+", hiddenTag.length);
      return showRestTagsPopover ? /*#__PURE__*/react.createElement(popover, Object.assign({
        content: hiddenTag,
        showArrow: true,
        trigger: "hover",
        position: "top",
        autoAdjustOverflow: true
      }, restTagsPopoverProps), renderPlusNChildren) : renderPlusNChildren;
    };
    this.renderMultipleTags = () => {
      const {
        autoMergeValue,
        maxTagCount
      } = this.props;
      const {
        checkedKeys,
        resolvedCheckedKeys
      } = this.state;
      const realKeys = this.mergeType === cascader_constants_strings.NONE_MERGE_TYPE ? checkedKeys : resolvedCheckedKeys;
      const displayTag = [];
      const hiddenTag = [];
      [...realKeys].forEach((checkedKey, idx) => {
        const notExceedMaxTagCount = !isNumber_default()(maxTagCount) || maxTagCount >= idx + 1;
        const item = this.renderTagItem(checkedKey, idx);
        if (notExceedMaxTagCount) {
          displayTag.push(item);
        } else {
          hiddenTag.push(item);
        }
      });
      return /*#__PURE__*/react.createElement(react.Fragment, null, displayTag, !isEmpty_default()(hiddenTag) && this.renderPlusN(hiddenTag));
    };
    this.renderDisplayText = () => {
      const {
        displayProp,
        separator,
        displayRender
      } = this.props;
      const {
        selectedKeys
      } = this.state;
      let displayText = '';
      if (selectedKeys.size) {
        const displayPath = this.foundation.getItemPropPath([...selectedKeys][0], displayProp);
        if (displayRender && typeof displayRender === 'function') {
          displayText = displayRender(displayPath);
        } else {
          displayText = displayPath.map((path, index) => /*#__PURE__*/react.createElement(react.Fragment, {
            key: `${path}-${index}`
          }, index < displayPath.length - 1 ? /*#__PURE__*/react.createElement(react.Fragment, null, path, separator) : path));
        }
      }
      return displayText;
    };
    this.renderSelectContent = () => {
      const {
        placeholder,
        filterTreeNode,
        multiple,
        searchPosition
      } = this.props;
      const {
        checkedKeys
      } = this.state;
      const searchable = Boolean(filterTreeNode) && searchPosition === cascader_constants_strings.SEARCH_POSITION_TRIGGER;
      if (!searchable) {
        if (multiple) {
          if (checkedKeys.size === 0) {
            return /*#__PURE__*/react.createElement("span", {
              className: `${cascader_prefixcls}-selection-placeholder`
            }, placeholder);
          }
          return this.renderMultipleTags();
        } else {
          const displayText = this.renderDisplayText();
          const spanCls = classnames_default()({
            [`${cascader_prefixcls}-selection-placeholder`]: !displayText
          });
          return /*#__PURE__*/react.createElement("span", {
            className: spanCls
          }, displayText ? displayText : placeholder);
        }
      }
      const input = multiple ? this.renderTagInput() : this.renderInput();
      return input;
    };
    this.renderSuffix = () => {
      const {
        suffix
      } = this.props;
      const suffixWrapperCls = classnames_default()({
        [`${cascader_prefixcls}-suffix`]: true,
        [`${cascader_prefixcls}-suffix-text`]: suffix && isString_default()(suffix),
        [`${cascader_prefixcls}-suffix-icon`]: isSemiIcon(suffix)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: suffixWrapperCls,
        "x-semi-prop": "suffix"
      }, suffix);
    };
    this.renderPrefix = () => {
      const {
        prefix,
        insetLabel,
        insetLabelId
      } = this.props;
      const labelNode = prefix || insetLabel;
      const prefixWrapperCls = classnames_default()({
        [`${cascader_prefixcls}-prefix`]: true,
        // to be doublechecked
        [`${cascader_prefixcls}-inset-label`]: insetLabel,
        [`${cascader_prefixcls}-prefix-text`]: labelNode && isString_default()(labelNode),
        [`${cascader_prefixcls}-prefix-icon`]: isSemiIcon(labelNode)
      });
      return /*#__PURE__*/react.createElement("div", {
        className: prefixWrapperCls,
        id: insetLabelId,
        "x-semi-prop": "prefix,insetLabel"
      }, labelNode);
    };
    this.renderCustomTrigger = () => {
      var _a;
      const {
        disabled,
        triggerRender,
        multiple
      } = this.props;
      const {
        selectedKeys,
        inputValue,
        inputPlaceHolder,
        resolvedCheckedKeys,
        checkedKeys,
        keyEntities
      } = this.state;
      let realValue;
      if (multiple) {
        if (this.mergeType === cascader_constants_strings.NONE_MERGE_TYPE) {
          realValue = new Set();
          checkedKeys.forEach(key => {
            var _a;
            realValue.add((_a = keyEntities[key]) === null || _a === void 0 ? void 0 : _a.pos);
          });
        } else {
          realValue = new Set();
          resolvedCheckedKeys.forEach(key => {
            var _a;
            realValue.add((_a = keyEntities[key]) === null || _a === void 0 ? void 0 : _a.pos);
          });
        }
      } else {
        realValue = (_a = keyEntities[[...selectedKeys][0]]) === null || _a === void 0 ? void 0 : _a.pos;
      }
      return /*#__PURE__*/react.createElement(trigger, {
        value: realValue,
        inputValue: inputValue,
        onChange: this.handleInputChange,
        onClear: this.handleClear,
        placeholder: inputPlaceHolder,
        disabled: disabled,
        triggerRender: triggerRender,
        componentName: 'Cascader',
        componentProps: Object.assign({}, this.props),
        onSearch: this.handleInputChange,
        onRemove: this.handleTagRemoveInTrigger
      });
    };
    this.handleMouseOver = () => {
      this.foundation.toggleHoverState(true);
    };
    this.handleMouseLeave = () => {
      this.foundation.toggleHoverState(false);
    };
    this.handleClear = e => {
      e && e.stopPropagation();
      this.foundation.handleClear();
    };
    /**
     * A11y: simulate clear button click
     */
    /* istanbul ignore next */
    this.handleClearEnterPress = e => {
      e && e.stopPropagation();
      this.foundation.handleClearEnterPress(e);
    };
    this.showClearBtn = () => {
      const {
        showClear,
        disabled,
        multiple
      } = this.props;
      const {
        selectedKeys,
        isOpen,
        isHovering,
        checkedKeys,
        inputValue
      } = this.state;
      const hasValue = selectedKeys.size;
      const multipleWithHaveValue = multiple && checkedKeys.size;
      return showClear && (inputValue || hasValue || multipleWithHaveValue) && !disabled && (isOpen || isHovering);
    };
    this.renderClearBtn = () => {
      const clearCls = classnames_default()(`${cascader_prefixcls}-clearbtn`);
      const {
        clearIcon
      } = this.props;
      const allowClear = this.showClearBtn();
      if (allowClear) {
        return /*#__PURE__*/react.createElement("div", {
          className: clearCls,
          onClick: this.handleClear,
          onKeyPress: this.handleClearEnterPress,
          role: "button",
          tabIndex: 0
        }, clearIcon ? clearIcon : /*#__PURE__*/react.createElement(IconClear, null));
      }
      return null;
    };
    this.renderArrow = () => {
      const {
        arrowIcon
      } = this.props;
      const showClearBtn = this.showClearBtn();
      if (showClearBtn) {
        return null;
      }
      return arrowIcon ? /*#__PURE__*/react.createElement("div", {
        className: classnames_default()(`${cascader_prefixcls}-arrow`),
        "x-semi-prop": "arrowIcon"
      }, arrowIcon) : null;
    };
    this.renderSelection = () => {
      const {
        disabled,
        multiple,
        filterTreeNode,
        style,
        size,
        className,
        validateStatus,
        prefix,
        suffix,
        insetLabel,
        triggerRender,
        showClear,
        id,
        borderless
      } = this.props;
      const {
        isOpen,
        isFocus,
        isInput,
        checkedKeys
      } = this.state;
      const filterable = Boolean(filterTreeNode);
      const useCustomTrigger = typeof triggerRender === 'function';
      const classNames = useCustomTrigger ? classnames_default()(className) : classnames_default()(cascader_prefixcls, className, {
        [`${cascader_prefixcls}-borderless`]: borderless,
        [`${cascader_prefixcls}-focus`]: isFocus || isOpen && !isInput,
        [`${cascader_prefixcls}-disabled`]: disabled,
        [`${cascader_prefixcls}-single`]: true,
        [`${cascader_prefixcls}-filterable`]: filterable,
        [`${cascader_prefixcls}-error`]: validateStatus === 'error',
        [`${cascader_prefixcls}-warning`]: validateStatus === 'warning',
        [`${cascader_prefixcls}-small`]: size === 'small',
        [`${cascader_prefixcls}-large`]: size === 'large',
        [`${cascader_prefixcls}-with-prefix`]: prefix || insetLabel,
        [`${cascader_prefixcls}-with-suffix`]: suffix
      });
      const mouseEvent = showClear ? {
        onMouseEnter: () => this.handleMouseOver(),
        onMouseLeave: () => this.handleMouseLeave()
      } : {};
      const sectionCls = classnames_default()(`${cascader_prefixcls}-selection`, {
        [`${cascader_prefixcls}-selection-multiple`]: multiple && !isEmpty_default()(checkedKeys)
      });
      const inner = useCustomTrigger ? this.renderCustomTrigger() : [/*#__PURE__*/react.createElement(react.Fragment, {
        key: 'prefix'
      }, prefix || insetLabel ? this.renderPrefix() : null), /*#__PURE__*/react.createElement(react.Fragment, {
        key: 'selection'
      }, /*#__PURE__*/react.createElement("div", {
        className: sectionCls
      }, this.renderSelectContent())), /*#__PURE__*/react.createElement(react.Fragment, {
        key: 'clearbtn'
      }, this.renderClearBtn()), /*#__PURE__*/react.createElement(react.Fragment, {
        key: 'suffix'
      }, suffix ? this.renderSuffix() : null), /*#__PURE__*/react.createElement(react.Fragment, {
        key: 'arrow'
      }, this.renderArrow())];
      /**
       * Reasons for disabling the a11y eslint rule:
       * The following attributes(aria-controls,aria-expanded) will be automatically added by Tooltip, no need to declare here
       */
      return /*#__PURE__*/react.createElement("div", Object.assign({
        className: classNames,
        style: style,
        ref: this.triggerRef,
        onClick: e => this.foundation.handleClick(e),
        onKeyPress: e => this.foundation.handleSelectionEnterPress(e),
        "aria-invalid": this.props['aria-invalid'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-required": this.props['aria-required'],
        id: id
      }, mouseEvent, {
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox",
        tabIndex: 0
      }, this.getDataAttr(this.props)), inner);
    };
    this.state = {
      disabledKeys: new Set(),
      isOpen: props.defaultOpen,
      /* By changing rePosKey, the dropdown position can be refreshed */
      rePosKey: resetkey,
      /* A data structure for storing cascader data items */
      keyEntities: {},
      /* Selected and show tick icon */
      selectedKeys: new Set([]),
      /* The key of the activated node */
      activeKeys: new Set([]),
      /* The key of the filtered node */
      filteredKeys: new Set([]),
      /* Value of input box */
      inputValue: '',
      /* Is searching */
      isSearching: false,
      /* The placeholder of input box */
      inputPlaceHolder: props.searchPlaceholder || props.placeholder,
      /* Cache props */
      prevProps: {},
      /* Is hovering */
      isHovering: false,
      /* Key of checked node, when multiple */
      checkedKeys: new Set([]),
      /* Key of half checked node, when multiple */
      halfCheckedKeys: new Set([]),
      /* Auto merged checkedKeys or leaf checkedKeys, when multiple */
      resolvedCheckedKeys: new Set([]),
      /* Keys of loaded item */
      loadedKeys: new Set(),
      /* Keys of loading item */
      loadingKeys: new Set(),
      /* Mark whether this rendering has triggered asynchronous loading of data */
      loading: false,
      showInput: false
    };
    this.options = {};
    this.isEmpty = false;
    this.mergeType = calcMergeType(props.autoMergeValue, props.leafOnly);
    this.inputRef = /*#__PURE__*/react.createRef();
    this.triggerRef = /*#__PURE__*/react.createRef();
    this.optionsRef = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
    this.foundation = new CascaderFoundation(this.adapter);
    this.loadingKeysRef = /*#__PURE__*/react.createRef();
    this.loadedKeysRef = /*#__PURE__*/react.createRef();
  }
  get adapter() {
    var _this = this;
    const filterAdapter = {
      updateInputValue: value => {
        this.setState({
          inputValue: value
        });
      },
      updateInputPlaceHolder: value => {
        this.setState({
          inputPlaceHolder: value
        });
      },
      focusInput: () => {
        const {
          preventScroll
        } = this.props;
        if (this.inputRef && this.inputRef.current) {
          // TODO: check the reason
          this.inputRef.current.focus({
            preventScroll
          });
        }
      },
      blurInput: () => {
        if (this.inputRef && this.inputRef.current) {
          this.inputRef.current.blur();
        }
      }
    };
    const cascaderAdapter = {
      registerClickOutsideHandler: cb => {
        const clickOutsideHandler = e => {
          const optionInstance = this.optionsRef && this.optionsRef.current;
          const triggerDom = this.triggerRef && this.triggerRef.current;
          const optionsDom = react_dom.findDOMNode(optionInstance);
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (optionsDom && (!optionsDom.contains(target) || !optionsDom.contains(target.parentNode)) && triggerDom && !triggerDom.contains(target) && !(path.includes(triggerDom) || path.includes(optionsDom))) {
            cb(e);
          }
        };
        this.clickOutsideHandler = clickOutsideHandler;
        document.addEventListener('mousedown', clickOutsideHandler, false);
      },
      unregisterClickOutsideHandler: () => {
        document.removeEventListener('mousedown', this.clickOutsideHandler, false);
      },
      rePositionDropdown: () => {
        let {
          rePosKey
        } = this.state;
        rePosKey = rePosKey + 1;
        this.setState({
          rePosKey
        });
      }
    };
    return Object.assign(Object.assign(Object.assign(Object.assign({}, super.adapter), filterAdapter), cascaderAdapter), {
      updateStates: states => {
        this.setState(Object.assign({}, states));
      },
      openMenu: () => {
        this.setState({
          isOpen: true
        });
      },
      closeMenu: cb => {
        this.setState({
          isOpen: false
        }, () => {
          cb && cb();
        });
      },
      updateSelection: selectedKeys => this.setState({
        selectedKeys
      }),
      notifyChange: value => {
        this.props.onChange && this.props.onChange(value);
      },
      notifySelect: selected => {
        this.props.onSelect && this.props.onSelect(selected);
      },
      notifyOnSearch: input => {
        this.props.onSearch && this.props.onSearch(input);
      },
      notifyFocus: function () {
        _this.props.onFocus && _this.props.onFocus(...arguments);
      },
      notifyBlur: function () {
        _this.props.onBlur && _this.props.onBlur(...arguments);
      },
      notifyDropdownVisibleChange: visible => {
        this.props.onDropdownVisibleChange(visible);
      },
      toggleHovering: bool => {
        this.setState({
          isHovering: bool
        });
      },
      notifyLoadData: (selectedOpt, callback) => {
        const {
          loadData
        } = this.props;
        if (loadData) {
          new Promise(resolve => {
            loadData(selectedOpt).then(() => {
              callback();
              this.setState({
                loading: false
              });
              resolve();
            });
          });
        }
      },
      notifyOnLoad: (newLoadedKeys, data) => {
        const {
          onLoad
        } = this.props;
        onLoad && onLoad(newLoadedKeys, data);
      },
      notifyListScroll: (e, _ref) => {
        let {
          panelIndex,
          activeNode
        } = _ref;
        this.props.onListScroll(e, {
          panelIndex,
          activeNode
        });
      },
      notifyOnExceed: data => this.props.onExceed(data),
      notifyClear: () => this.props.onClear(),
      toggleInputShow: (showInput, cb) => {
        this.setState({
          showInput
        }, () => {
          cb();
        });
      },
      updateFocusState: isFocus => {
        this.setState({
          isFocus
        });
      },
      updateLoadingKeyRefValue: keys => {
        this.loadingKeysRef.current = keys;
      },
      getLoadingKeyRefValue: () => {
        return this.loadingKeysRef.current;
      },
      updateLoadedKeyRefValue: keys => {
        this.loadedKeysRef.current = keys;
      },
      getLoadedKeyRefValue: () => {
        return this.loadedKeysRef.current;
      }
    });
  }
  static getDerivedStateFromProps(props, prevState) {
    const {
      multiple,
      value,
      defaultValue,
      onChangeWithObject,
      leafOnly,
      autoMergeValue
    } = props;
    const {
      prevProps
    } = prevState;
    let keyEntities = prevState.keyEntities || {};
    const newState = {};
    const needUpdate = name => {
      const firstInProps = isEmpty_default()(prevProps) && name in props;
      const nameHasChange = prevProps && !isEqual_default()(prevProps[name], props[name]);
      return firstInProps || nameHasChange;
    };
    const needUpdateData = () => {
      const firstInProps = !prevProps && 'treeData' in props;
      const treeDataHasChange = prevProps && prevProps.treeData !== props.treeData;
      return firstInProps || treeDataHasChange;
    };
    const getRealKeys = (realValue, keyEntities) => {
      // normalizedValue is used to save the value in two-dimensional array format
      let normalizedValue = [];
      if (Array.isArray(realValue)) {
        normalizedValue = Array.isArray(realValue[0]) ? realValue : [realValue];
      } else {
        if (realValue !== undefined) {
          normalizedValue = [[realValue]];
        }
      }
      // formatValuePath is used to save value of valuePath
      const formatValuePath = [];
      normalizedValue.forEach(valueItem => {
        const formatItem = onChangeWithObject && isObject_default()(valueItem[0]) ? valueItem.map(i => i === null || i === void 0 ? void 0 : i.value) : valueItem;
        formatItem.length > 0 && formatValuePath.push(formatItem);
      });
      // formatKeys is used to save key of value
      const formatKeys = formatValuePath.reduce((acc, cur) => {
        const key = getKeyByValuePath(cur);
        keyEntities[key] && acc.push(key);
        return acc;
      }, []);
      return formatKeys;
    };
    if (multiple) {
      const needUpdateTreeData = needUpdate('treeData') || needUpdateData();
      const needUpdateValue = needUpdate('value') || isEmpty_default()(prevProps) && defaultValue;
      // when value and treedata need updated
      if (needUpdateTreeData || needUpdateValue) {
        // update state.keyEntities
        if (needUpdateTreeData) {
          newState.treeData = props.treeData;
          keyEntities = util_convertDataToEntities(props.treeData);
          newState.keyEntities = keyEntities;
        }
        let realKeys = prevState.checkedKeys;
        // when data was updated
        if (needUpdateValue) {
          const realValue = needUpdate('value') ? value : defaultValue;
          realKeys = getRealKeys(realValue, keyEntities);
        } else {
          // needUpdateValue is false
          // if treeData is updated & Cascader is controlled, realKeys should be recalculated
          if (needUpdateTreeData && 'value' in props) {
            const realValue = value;
            realKeys = getRealKeys(realValue, keyEntities);
          }
        }
        if (isSet_default()(realKeys)) {
          realKeys = [...realKeys];
        }
        const calRes = calcCheckedKeys(realKeys, keyEntities);
        const checkedKeys = new Set(calRes.checkedKeys);
        const halfCheckedKeys = new Set(calRes.halfCheckedKeys);
        // disableStrictly
        if (props.disableStrictly) {
          newState.disabledKeys = calcDisabledKeys(keyEntities);
        }
        const isLeafOnlyMerge = calcMergeType(autoMergeValue, leafOnly) === cascader_constants_strings.LEAF_ONLY_MERGE_TYPE;
        newState.prevProps = props;
        newState.checkedKeys = checkedKeys;
        newState.halfCheckedKeys = halfCheckedKeys;
        newState.resolvedCheckedKeys = new Set(normalizeKeyList(checkedKeys, keyEntities, isLeafOnlyMerge));
      }
    }
    return newState;
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  componentDidUpdate(prevProps) {
    if (this.props.multiple) {
      return;
    }
    let isOptionsChanged = false;
    if (!isEqual_default()(prevProps.treeData, this.props.treeData)) {
      isOptionsChanged = true;
      this.foundation.collectOptions();
    }
    if (prevProps.value !== this.props.value && !isOptionsChanged) {
      this.foundation.handleValueChange(this.props.value);
    }
  }
  renderTagInput() {
    const {
      size,
      disabled,
      placeholder,
      maxTagCount,
      showRestTagsPopover,
      restTagsPopoverProps
    } = this.props;
    const {
      inputValue,
      checkedKeys,
      keyEntities,
      resolvedCheckedKeys
    } = this.state;
    const tagInputcls = classnames_default()(`${cascader_prefixcls}-tagInput-wrapper`);
    const realKeys = this.mergeType === cascader_constants_strings.NONE_MERGE_TYPE ? checkedKeys : resolvedCheckedKeys;
    return /*#__PURE__*/react.createElement(tagInput, {
      className: tagInputcls,
      ref: this.inputRef,
      disabled: disabled,
      size: size,
      value: [...realKeys],
      showRestTagsPopover: showRestTagsPopover,
      restTagsPopoverProps: restTagsPopoverProps,
      maxTagCount: maxTagCount,
      renderTagItem: this.renderTagItem,
      inputValue: inputValue,
      onInputChange: this.handleInputChange,
      // TODO Modify logic, not modify type
      onRemove: this.onRemoveInTagInput,
      placeholder: placeholder,
      expandRestTagsOnClick: false
    });
  }
  renderInput() {
    const {
      size,
      disabled
    } = this.props;
    const inputcls = classnames_default()(`${cascader_prefixcls}-input`);
    const {
      inputValue,
      inputPlaceHolder,
      showInput
    } = this.state;
    const inputProps = {
      disabled,
      value: inputValue,
      className: inputcls,
      onChange: this.handleInputChange
    };
    const wrappercls = classnames_default()({
      [`${cascader_prefixcls}-search-wrapper`]: true,
      [`${cascader_prefixcls}-search-wrapper-${size}`]: size !== 'default'
    });
    const displayText = this.renderDisplayText();
    const spanCls = classnames_default()({
      [`${cascader_prefixcls}-selection-placeholder`]: !displayText,
      [`${cascader_prefixcls}-selection-text-hide`]: showInput && inputValue,
      [`${cascader_prefixcls}-selection-text-inactive`]: showInput && !inputValue
    });
    return /*#__PURE__*/react.createElement("div", {
      className: wrappercls
    }, /*#__PURE__*/react.createElement("span", {
      className: spanCls
    }, displayText ? displayText : inputPlaceHolder), showInput && /*#__PURE__*/react.createElement(es_input, Object.assign({
      ref: this.inputRef,
      size: size
    }, inputProps)));
  }
  close() {
    this.foundation.close();
  }
  open() {
    this.foundation.open();
  }
  focus() {
    this.foundation.focus();
  }
  blur() {
    this.foundation.blur();
  }
  render() {
    const {
      zIndex,
      getPopupContainer,
      autoAdjustOverflow,
      stopPropagation,
      mouseLeaveDelay,
      mouseEnterDelay,
      position,
      motion,
      dropdownMargin
    } = this.props;
    const {
      isOpen,
      rePosKey
    } = this.state;
    const {
      direction
    } = this.context;
    const content = this.renderContent();
    const selection = this.renderSelection();
    const pos = position !== null && position !== void 0 ? position : direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    return /*#__PURE__*/react.createElement(popover, {
      getPopupContainer: getPopupContainer,
      zIndex: zIndex,
      motion: motion,
      margin: dropdownMargin,
      ref: this.optionsRef,
      content: content,
      visible: isOpen,
      trigger: "custom",
      rePosKey: rePosKey,
      position: pos,
      autoAdjustOverflow: autoAdjustOverflow,
      stopPropagation: stopPropagation,
      mouseLeaveDelay: mouseLeaveDelay,
      mouseEnterDelay: mouseEnterDelay,
      afterClose: () => this.foundation.updateSearching(false)
    }, selection);
  }
}
Cascader.__SemiComponentName__ = "Cascader";
Cascader.contextType = context;
Cascader.propTypes = {
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  'aria-label': (prop_types_default()).string,
  arrowIcon: (prop_types_default()).node,
  borderless: (prop_types_default()).bool,
  clearIcon: (prop_types_default()).node,
  changeOnSelect: (prop_types_default()).bool,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  disabled: (prop_types_default()).bool,
  dropdownClassName: (prop_types_default()).string,
  dropdownStyle: (prop_types_default()).object,
  dropdownMargin: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).object]),
  emptyContent: (prop_types_default()).node,
  motion: (prop_types_default()).bool,
  /* show search input, if passed in a function, used as custom filter */
  filterTreeNode: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).bool]),
  filterLeafOnly: (prop_types_default()).bool,
  placeholder: (prop_types_default()).string,
  searchPlaceholder: (prop_types_default()).string,
  size: prop_types_default().oneOf(cascader_constants_strings.SIZE_SET),
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  treeData: prop_types_default().arrayOf(prop_types_default().shape({
    value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    label: (prop_types_default()).any
  })),
  treeNodeFilterProp: (prop_types_default()).string,
  suffix: (prop_types_default()).node,
  prefix: (prop_types_default()).node,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  id: (prop_types_default()).string,
  displayProp: (prop_types_default()).string,
  displayRender: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onSearch: (prop_types_default()).func,
  onSelect: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  children: (prop_types_default()).node,
  getPopupContainer: (prop_types_default()).func,
  zIndex: (prop_types_default()).number,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).array]),
  validateStatus: prop_types_default().oneOf(cascader_constants_strings.VALIDATE_STATUS),
  showNext: prop_types_default().oneOf([cascader_constants_strings.SHOW_NEXT_BY_CLICK, cascader_constants_strings.SHOW_NEXT_BY_HOVER]),
  stopPropagation: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  showClear: (prop_types_default()).bool,
  defaultOpen: (prop_types_default()).bool,
  autoAdjustOverflow: (prop_types_default()).bool,
  onDropdownVisibleChange: (prop_types_default()).func,
  triggerRender: (prop_types_default()).func,
  onListScroll: (prop_types_default()).func,
  onChangeWithObject: (prop_types_default()).bool,
  bottomSlot: (prop_types_default()).node,
  topSlot: (prop_types_default()).node,
  multiple: (prop_types_default()).bool,
  autoMergeValue: (prop_types_default()).bool,
  maxTagCount: (prop_types_default()).number,
  showRestTagsPopover: (prop_types_default()).bool,
  restTagsPopoverProps: (prop_types_default()).object,
  max: (prop_types_default()).number,
  separator: (prop_types_default()).string,
  onExceed: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  loadData: (prop_types_default()).func,
  onLoad: (prop_types_default()).func,
  loadedKeys: (prop_types_default()).array,
  disableStrictly: (prop_types_default()).bool,
  leafOnly: (prop_types_default()).bool,
  enableLeafClick: (prop_types_default()).bool,
  preventScroll: (prop_types_default()).bool,
  position: (prop_types_default()).string,
  searchPosition: (prop_types_default()).string
};
Cascader.defaultProps = getDefaultPropsFromGlobalConfig(Cascader.__SemiComponentName__, {
  borderless: false,
  leafOnly: false,
  arrowIcon: /*#__PURE__*/react.createElement(IconChevronDown, null),
  stopPropagation: true,
  motion: true,
  defaultOpen: false,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  showClear: false,
  autoClearSearchValue: true,
  changeOnSelect: false,
  disableStrictly: false,
  autoMergeValue: true,
  multiple: false,
  filterTreeNode: false,
  filterLeafOnly: true,
  showRestTagsPopover: false,
  restTagsPopoverProps: {},
  separator: ' / ',
  size: 'default',
  treeNodeFilterProp: 'label',
  displayProp: 'label',
  treeData: [],
  showNext: cascader_constants_strings.SHOW_NEXT_BY_CLICK,
  onExceed: (noop_default()),
  onClear: (noop_default()),
  onDropdownVisibleChange: (noop_default()),
  onListScroll: (noop_default()),
  enableLeafClick: false,
  'aria-label': 'Cascader',
  searchPosition: cascader_constants_strings.SEARCH_POSITION_TRIGGER
});
/* harmony default export */ var cascader = (Cascader);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/rating/constants.js

const rating_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-rating`
};
const rating_constants_strings = {
  SIZE_SET: ['default', 'small']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconStar.js


function IconStar_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M10.7525 1.90411C11.1451 0.698628 12.8549 0.698631 13.2475 1.90411L15.2395 8.01946H21.6858C22.9565 8.01946 23.4848 9.64143 22.4568 10.3865L17.2417 14.1659L19.2337 20.2813C19.6263 21.4868 18.2431 22.4892 17.2151 21.7442L12 17.9647L6.78489 21.7442C5.75687 22.4892 4.37368 21.4868 4.76635 20.2813L6.75834 14.1659L1.54323 10.3865C0.515206 9.64142 1.04354 8.01946 2.31425 8.01946H8.76048L10.7525 1.90411Z",
    fill: "currentColor"
  }));
}
const IconStar_IconComponent = (0,Icon/* convertIcon */.A)(IconStar_SvgComponent, 'star');
/* harmony default export */ var IconStar = (IconStar_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/rating/foundation.js


class RatingFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, RatingFoundation.defaultAdapter), adapter));
    this.handleStarFocusVisible = event => {
      const {
        target
      } = event;
      const {
        count
      } = this.getProps();
      // when rating 0 is focus visible
      try {
        if (target.matches(':focus-visible')) {
          this._adapter.setEmptyStarFocusVisible(true);
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Rating] The current browser does not support the focus-visible');
      }
    };
    // e: FocusEvent
    this.handleStarBlur = e => {
      const {
        emptyStarFocusVisible
      } = this.getStates();
      if (emptyStarFocusVisible) {
        this._adapter.setEmptyStarFocusVisible(false);
      }
    };
  }
  init() {
    const {
      autoFocus,
      disabled
    } = this.getProps();
    if (autoFocus && !disabled) {
      this._adapter.focus();
    }
  }
  _getScroll(w, top) {
    let ret = top ? w.pageYOffset : w.pageXOffset;
    const method = top ? 'scrollTop' : 'scrollLeft';
    if (typeof ret !== 'number') {
      const d = w.document;
      // ie6,7,8 standard mode
      ret = d.documentElement[method];
      if (typeof ret !== 'number') {
        // quirks mode
        ret = d.body[method];
      }
    }
    return ret;
  }
  _getClientPosition(elem) {
    let x, y;
    const doc = elem.ownerDocument;
    const {
      body
    } = doc;
    const docElem = doc && doc.documentElement;
    const box = elem.getBoundingClientRect();
    x = box.left;
    y = box.top;
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
      left: x,
      top: y
    };
  }
  _getOffsetLeft(el) {
    const pos = this._getClientPosition(el);
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += this._getScroll(w);
    return pos.left;
  }
  getStarValue(index, pos) {
    const {
      allowHalf
    } = this.getProps();
    const direction = this._adapter.getContext('direction');
    const reverse = direction === 'rtl';
    let value = index + 1;
    if (allowHalf) {
      const starEle = this._adapter.getStarDOM(index);
      const leftDis = this._getOffsetLeft(starEle);
      const width = starEle.clientWidth;
      if (reverse && pos - leftDis > width / 2) {
        value -= 0.5;
      } else if (!reverse && pos - leftDis < width / 2) {
        value -= 0.5;
      }
    }
    return value;
  }
  handleHover(event, index) {
    const currValue = this.getStarValue(index, event.pageX);
    const {
      clearedValue,
      hoverValue
    } = this.getStates();
    if (currValue !== hoverValue && currValue !== clearedValue) {
      this._adapter.notifyHoverChange(currValue, null);
    }
  }
  handleMouseLeave() {
    this._adapter.notifyHoverChange(undefined, null);
  }
  handleClick(event, index) {
    const {
      allowClear
    } = this.getProps();
    const {
      value
    } = this.getStates();
    const newValue = this.getStarValue(index, event.pageX);
    const isReset = allowClear ? newValue === value : false;
    this._adapter.updateValue(isReset ? 0 : newValue);
    if (isReset) {
      this._adapter.notifyHoverChange(undefined, newValue);
    } else {
      this._adapter.clearValue(null);
    }
  }
  handleFocus(e) {
    this._adapter.notifyFocus(e);
  }
  handleBlur(e) {
    this._adapter.notifyBlur(e);
  }
  handleKeyDown(event, value) {
    const {
      key
    } = event;
    const {
      count,
      allowHalf
    } = this.getProps();
    const direction = this._adapter.getContext('direction');
    const reverse = direction === 'rtl';
    const step = allowHalf ? 0.5 : 1;
    let tempValue;
    let newValue;
    if (key === 'ArrowRight' || key === 'ArrowUp') {
      tempValue = value + (reverse ? -step : step);
    } else if (key === 'ArrowLeft' || key === 'ArrowDown') {
      tempValue = value + (reverse ? step : -step);
    }
    if (tempValue > count) {
      newValue = 0;
    } else if (tempValue < 0) {
      newValue = count;
    } else {
      newValue = tempValue;
    }
    if (['ArrowRight', 'ArrowUp', 'ArrowLeft', 'ArrowDown'].includes(key)) {
      this._adapter.notifyKeyDown(event);
      this._adapter.updateValue(newValue);
      this.changeFocusStar(newValue, event);
      event.preventDefault();
      this._adapter.notifyHoverChange(undefined, null);
    }
  }
  changeFocusStar(value, event) {
    const {
      count,
      allowHalf,
      preventScroll
    } = this.getProps();
    const index = Math.ceil(value) - 1;
    const starElement = [...event.currentTarget.childNodes].map(item => item.childNodes[0].childNodes);
    if (index < 0) {
      starElement[count][0].focus({
        preventScroll
      });
    } else {
      starElement[index][allowHalf ? value * 10 % 10 === 5 ? 0 : 1 : 0].focus({
        preventScroll
      });
    }
  }
}
class RatingItemFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign(Object.assign({}, RatingItemFoundation.defaultAdapter), adapter));
    this.handleFocusVisible = (event, star) => {
      const {
        target
      } = event;
      // when rating 0 is focus visible
      try {
        if (target.matches(':focus-visible')) {
          if (star === 'first') {
            this._adapter.setFirstStarFocus(true);
          } else {
            this._adapter.setSecondStarFocus(true);
          }
        }
      } catch (error) {
        warning(true, 'Warning: [Semi Rating] The current browser does not support the focus-visible');
      }
    };
    // e: FocusEvent
    this.handleBlur = (e, star) => {
      const {
        firstStarFocus,
        secondStarFocus
      } = this.getStates();
      if (star === 'first') {
        firstStarFocus && this._adapter.setFirstStarFocus(false);
      } else {
        secondStarFocus && this._adapter.setSecondStarFocus(false);
      }
    };
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/rating/item.js




// import '@douyinfe/semi-foundation/lib/es/rating/rating.css';



class item_Item extends BaseComponent {
  constructor(props) {
    super(props);
    this.firstStar = null;
    this.secondStar = null;
    this.onHover = e => {
      const {
        onHover,
        index
      } = this.props;
      onHover(e, index);
    };
    this.onClick = e => {
      const {
        onClick,
        index
      } = this.props;
      onClick(e, index);
    };
    this.onFocus = (e, star) => {
      const {
        onFocus
      } = this.props;
      onFocus && onFocus(e);
      this.foundation.handleFocusVisible(e, star);
    };
    this.onBlur = (e, star) => {
      const {
        onBlur
      } = this.props;
      onBlur && onBlur(e);
      this.foundation.handleBlur(e, star);
    };
    this.onKeyDown = e => {
      const {
        onClick,
        index
      } = this.props;
      if (e.keyCode === 13) {
        onClick(e, index);
      }
    };
    this.starFocus = () => {
      const {
        value,
        index,
        preventScroll
      } = this.props;
      if (value - index === 0.5) {
        this.firstStar.focus({
          preventScroll
        });
      } else {
        this.secondStar.focus({
          preventScroll
        });
      }
    };
    this.saveFirstStar = node => {
      this.firstStar = node;
    };
    this.saveSecondStar = node => {
      this.secondStar = node;
    };
    this.state = {
      firstStarFocus: false,
      secondStarFocus: false
    };
    this.foundation = new RatingItemFoundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      setFirstStarFocus: value => {
        this.setState({
          firstStarFocus: value
        });
      },
      setSecondStarFocus: value => {
        this.setState({
          secondStarFocus: value
        });
      }
    });
  }
  render() {
    const {
      index,
      prefixCls,
      character,
      count,
      value,
      disabled,
      allowHalf,
      focused,
      size,
      ariaLabelPrefix
    } = this.props;
    const {
      firstStarFocus,
      secondStarFocus
    } = this.state;
    const starValue = index + 1;
    const diff = starValue - value;
    // const isHalf = allowHalf && value + 0.5 === starValue;
    const isHalf = allowHalf && diff < 1 && diff > 0;
    const firstWidth = 1 - diff;
    const isFull = starValue <= value;
    const isCustomSize = typeof size === 'number';
    const starCls = classnames_default()(prefixCls, {
      [`${prefixCls}-half`]: isHalf,
      [`${prefixCls}-full`]: isFull,
      [`${prefixCls}-${size}`]: !isCustomSize
    });
    const sizeStyle = isCustomSize ? {
      width: size,
      height: size,
      fontSize: size
    } : {};
    const iconSize = isCustomSize ? 'inherit' : size === 'small' ? 'default' : 'extra-large';
    const content = character ? character : /*#__PURE__*/react.createElement(IconStar, {
      size: iconSize,
      style: {
        display: 'block'
      }
    });
    const isEmpty = index === count;
    const starWrapCls = classnames_default()(`${prefixCls}-wrapper`, {
      [`${prefixCls}-disabled`]: disabled,
      [`${rating_constants_cssClasses.PREFIX}-focus`]: (firstStarFocus || secondStarFocus) && value !== 0
    });
    const starWrapProps = {
      onClick: disabled ? null : this.onClick,
      onKeyDown: disabled ? null : this.onKeyDown,
      onMouseMove: disabled ? null : this.onHover,
      className: starWrapCls
    };
    const AriaSetSize = allowHalf ? count * 2 + 1 : count + 1;
    const firstStarProps = {
      ref: this.saveFirstStar,
      role: "radio",
      'aria-checked': value === index + 0.5,
      'aria-posinset': 2 * index + 1,
      'aria-setsize': AriaSetSize,
      'aria-disabled': disabled,
      'aria-label': `${index + 0.5} ${ariaLabelPrefix}s`,
      'aria-labelledby': this.props['aria-describedby'],
      'aria-describedby': this.props['aria-describedby'],
      className: classnames_default()(`${prefixCls}-first`, `${rating_constants_cssClasses.PREFIX}-no-focus`),
      tabIndex: !disabled && value === index + 0.5 ? 0 : -1,
      onFocus: e => {
        this.onFocus(e, 'first');
      },
      onBlur: e => {
        this.onBlur(e, 'first');
      }
    };
    const secondStarTabIndex = !disabled && (value === index + 1 || isEmpty && value === 0) ? 0 : -1;
    const secondStarProps = {
      ref: this.saveSecondStar,
      role: "radio",
      'aria-checked': isEmpty ? value === 0 : value === index + 1,
      'aria-posinset': allowHalf ? 2 * (index + 1) : index + 1,
      'aria-setsize': AriaSetSize,
      'aria-disabled': disabled,
      'aria-label': `${isEmpty ? 0 : index + 1} ${ariaLabelPrefix}${index === 0 ? '' : 's'}`,
      'aria-labelledby': this.props['aria-describedby'],
      'aria-describedby': this.props['aria-describedby'],
      className: classnames_default()(`${prefixCls}-second`, `${rating_constants_cssClasses.PREFIX}-no-focus`),
      tabIndex: secondStarTabIndex,
      onFocus: e => {
        this.onFocus(e, 'second');
      },
      onBlur: e => {
        this.onBlur(e, 'second');
      }
    };
    return /*#__PURE__*/react.createElement("li", {
      className: starCls,
      style: Object.assign({}, sizeStyle),
      key: index
    }, /*#__PURE__*/react.createElement("div", Object.assign({}, starWrapProps), allowHalf && !isEmpty && /*#__PURE__*/react.createElement("div", Object.assign({}, firstStarProps, {
      style: {
        width: `${firstWidth * 100}%`
      }
    }), content), /*#__PURE__*/react.createElement("div", Object.assign({}, secondStarProps, {
      "x-semi-prop": "character"
    }), content)));
  }
}
item_Item.propTypes = {
  value: (prop_types_default()).number,
  index: (prop_types_default()).number,
  prefixCls: (prop_types_default()).string,
  allowHalf: (prop_types_default()).bool,
  onHover: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  character: (prop_types_default()).node,
  focused: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  count: (prop_types_default()).number,
  ariaLabelPrefix: (prop_types_default()).string,
  size: prop_types_default().oneOfType([prop_types_default().oneOf(rating_constants_strings.SIZE_SET), (prop_types_default()).number]),
  'aria-describedby': (prop_types_default()).string,
  onFocus: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  preventScroll: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/rating/index.js
var rating_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











// import '@douyinfe/semi-foundation/lib/es/rating/rating.css';
class Rating extends BaseComponent {
  constructor(props) {
    super(props);
    this.rate = null;
    this.onHover = (event, index) => {
      this.foundation.handleHover(event, index);
    };
    this.onMouseLeave = () => {
      this.foundation.handleMouseLeave();
    };
    this.onClick = (event, index) => {
      this.foundation.handleClick(event, index);
    };
    this.onFocus = e => {
      this.foundation.handleFocus(e);
    };
    this.onBlur = e => {
      this.foundation.handleBlur(e);
    };
    this.onKeyDown = event => {
      const {
        value
      } = this.state;
      this.foundation.handleKeyDown(event, value);
    };
    this.focus = () => {
      const {
        disabled,
        preventScroll
      } = this.props;
      if (!disabled) {
        this.rate.focus({
          preventScroll
        });
      }
    };
    this.blur = () => {
      const {
        disabled
      } = this.props;
      if (!disabled) {
        this.rate.blur();
      }
    };
    this.saveRef = index => node => {
      this.stars[index] = node;
    };
    this.saveRate = node => {
      this.rate = node;
    };
    this.handleStarFocusVisible = event => {
      this.foundation.handleStarFocusVisible(event);
    };
    this.handleStarBlur = event => {
      this.foundation.handleStarBlur(event);
    };
    this.getAriaLabelPrefix = () => {
      if (this.props['aria-label']) {
        return this.props['aria-label'];
      }
      let prefix = 'star';
      const {
        character
      } = this.props;
      if (typeof character === 'string') {
        prefix = character;
      }
      return prefix;
    };
    this.getItemList = ariaLabelPrefix => {
      const {
        count,
        allowHalf,
        prefixCls,
        disabled,
        character,
        size,
        tooltips
      } = this.props;
      const {
        value,
        hoverValue,
        focused
      } = this.state;
      // index == count is for Empty rating
      const itemList = [...Array(count + 1).keys()].map(ind => {
        const content = /*#__PURE__*/react.createElement(item_Item, {
          ref: this.saveRef(ind),
          index: ind,
          count: count,
          prefixCls: `${prefixCls}-star`,
          allowHalf: allowHalf,
          value: hoverValue === undefined ? value : hoverValue,
          onClick: disabled ? function_noop : this.onClick,
          onHover: disabled ? function_noop : this.onHover,
          key: ind,
          disabled: disabled,
          character: character,
          focused: focused,
          size: ind === count ? 0 : size,
          ariaLabelPrefix: ariaLabelPrefix,
          onFocus: disabled || count !== ind ? function_noop : this.handleStarFocusVisible,
          onBlur: disabled || count !== ind ? function_noop : this.handleStarBlur
        });
        if (tooltips) {
          const text = tooltips[ind] ? tooltips[ind] : '';
          const showTips = hoverValue - 1 === ind;
          return /*#__PURE__*/react.createElement(Tooltip, {
            visible: showTips,
            trigger: "custom",
            content: text,
            key: `${ind}-${showTips}`
          }, content);
        }
        return content;
      });
      return itemList;
    };
    const value = props.value === undefined ? props.defaultValue : props.value;
    this.stars = {};
    this.state = {
      value,
      focused: false,
      hoverValue: undefined,
      clearedValue: null,
      emptyStarFocusVisible: false
    };
    this.foundation = new RatingFoundation(this.adapter);
  }
  static getDerivedStateFromProps(nextProps, state) {
    if ('value' in nextProps && nextProps.value !== undefined) {
      return Object.assign(Object.assign({}, state), {
        value: nextProps.value
      });
    }
    return state;
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      focus: () => {
        const {
          disabled,
          count
        } = this.props;
        const {
          value
        } = this.state;
        if (!disabled) {
          const index = Math.ceil(value) - 1;
          this.stars[index < 0 ? count : index].starFocus();
        }
      },
      getStarDOM: index => {
        const instance = this.stars && this.stars[index];
        return react_dom.findDOMNode(instance);
      },
      notifyHoverChange: (hoverValue, clearedValue) => {
        const {
          onHoverChange
        } = this.props;
        this.setState({
          hoverValue,
          clearedValue
        });
        onHoverChange(hoverValue);
      },
      updateValue: value => {
        const {
          onChange
        } = this.props;
        if (!('value' in this.props)) {
          this.setState({
            value
          });
        }
        onChange(value);
      },
      clearValue: clearedValue => {
        this.setState({
          clearedValue
        });
      },
      notifyFocus: e => {
        const {
          onFocus
        } = this.props;
        this.setState({
          focused: true
        });
        onFocus && onFocus(e);
      },
      notifyBlur: e => {
        const {
          onBlur
        } = this.props;
        this.setState({
          focused: false
        });
        onBlur && onBlur(e);
      },
      notifyKeyDown: e => {
        const {
          onKeyDown
        } = this.props;
        this.setState({
          focused: false
        });
        onKeyDown && onKeyDown(e);
      },
      setEmptyStarFocusVisible: focusVisible => {
        this.setState({
          emptyStarFocusVisible: focusVisible
        });
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const _a = this.props,
      {
        style,
        prefixCls,
        disabled,
        className,
        id,
        count,
        tabIndex
      } = _a,
      rest = rating_rest(_a, ["style", "prefixCls", "disabled", "className", "id", "count", "tabIndex"]);
    const {
      value,
      emptyStarFocusVisible
    } = this.state;
    const ariaLabelPrefix = this.getAriaLabelPrefix();
    const ariaLabel = `Rating: ${value} of ${count} ${ariaLabelPrefix}${value === 1 ? '' : 's'},`;
    const itemList = this.getItemList(ariaLabelPrefix);
    const listCls = classnames_default()(prefixCls, {
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-focus`]: emptyStarFocusVisible
    }, className);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      react.createElement("ul", Object.assign({
        "aria-label": ariaLabel,
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        className: listCls,
        style: style,
        onMouseLeave: disabled ? function_noop : this.onMouseLeave,
        tabIndex: disabled ? -1 : tabIndex,
        onFocus: disabled ? function_noop : this.onFocus,
        onBlur: disabled ? function_noop : this.onBlur,
        onKeyDown: disabled ? function_noop : this.onKeyDown,
        ref: this.saveRate,
        id: id
      }, this.getDataAttr(rest)), itemList)
    );
  }
}
Rating.contextType = context;
Rating.propTypes = {
  'aria-describedby': (prop_types_default()).string,
  'aria-errormessage': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  value: (prop_types_default()).number,
  defaultValue: (prop_types_default()).number,
  count: (prop_types_default()).number,
  allowHalf: (prop_types_default()).bool,
  allowClear: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  prefixCls: (prop_types_default()).string,
  onChange: (prop_types_default()).func,
  onHoverChange: (prop_types_default()).func,
  className: (prop_types_default()).string,
  character: (prop_types_default()).node,
  tabIndex: (prop_types_default()).number,
  onFocus: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  autoFocus: (prop_types_default()).bool,
  size: prop_types_default().oneOfType([prop_types_default().oneOf(rating_constants_strings.SIZE_SET), (prop_types_default()).number]),
  tooltips: prop_types_default().arrayOf((prop_types_default()).string),
  id: (prop_types_default()).string,
  preventScroll: (prop_types_default()).bool
};
Rating.defaultProps = {
  defaultValue: 0,
  count: 5,
  allowHalf: false,
  allowClear: true,
  style: {},
  prefixCls: rating_constants_cssClasses.PREFIX,
  onChange: function_noop,
  onHoverChange: function_noop,
  tabIndex: -1,
  size: 'default'
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/autoComplete/constants.js


const autoComplete_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-autocomplete`,
  PREFIX_OPTION: `${BASE_CLASS_PREFIX}-autoComplete-option`,
  PREFIX_GROUP: `${BASE_CLASS_PREFIX}-autoComplete-group`
};
const autoComplete_constants_strings = {
  SIZE: ['small', 'large', 'default'],
  POSITION: tooltip_constants_strings.POSITION_SET,
  OPTIONS: ['children', 'value'],
  STATUS: VALIDATE_STATUS
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/autoComplete/foundation.js







class AutoCompleteFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.isPanelOpen = false;
  }
  init() {
    this._setDropdownWidth();
    const {
      defaultOpen,
      data,
      defaultValue,
      value
    } = this.getProps();
    if (data && data.length) {
      const initOptions = this._generateList(data);
      this._adapter.updateOptionList(initOptions);
    }
    if (defaultOpen) {
      this.openDropdown();
    }
    // When both defaultValue and value exist, finally the value of value will be taken as initValue
    let initValue;
    if (typeof defaultValue !== 'undefined') {
      initValue = defaultValue;
    }
    if (typeof value !== 'undefined') {
      initValue = value;
    }
    if (typeof initValue !== 'undefined') {
      this.handleValueChange(initValue);
    }
  }
  destroy() {
    this._adapter.unregisterClickOutsideHandler();
    // this.unBindKeyBoardEvent();
  }

  _setDropdownWidth() {
    const {
      style,
      dropdownMatchSelectWidth
    } = this.getProps();
    let width;
    if (dropdownMatchSelectWidth) {
      if (style && isNumber_default()(style.width)) {
        width = style.width;
      } else if (style && isString_default()(style.width) && !style.width.includes('%')) {
        width = style.width;
      } else {
        width = this._adapter.getTriggerWidth();
      }
      this._adapter.setOptionWrapperWidth(width);
    }
  }
  handleInputClick(e) {
    const {
      options
    } = this.getStates();
    const {
      disabled
    } = this.getProps();
    if (!disabled) {
      if (this.isPanelOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }
  }
  openDropdown() {
    this.isPanelOpen = true;
    this._adapter.toggleListVisible(true);
    this._setDropdownWidth();
    this._adapter.registerClickOutsideHandler(e => this.closeDropdown(e));
    this._adapter.notifyDropdownVisibleChange(true);
    this._modifyFocusIndexOnPanelOpen();
  }
  closeDropdown(e) {
    this.isPanelOpen = false;
    this._adapter.toggleListVisible(false);
    this._adapter.unregisterClickOutsideHandler();
    this._adapter.notifyDropdownVisibleChange(false);
    // After closing the panel, you can still open the panel by pressing the enter key
    // this.unBindKeyBoardEvent();
  }
  // props.data => optionList
  _generateList(data) {
    const {
      renderItem
    } = this.getProps();
    const options = [];
    if (data && data.length) {
      data.forEach((item, i) => {
        const key = String(new Date().getTime()) + i;
        let option = {};
        if (isString_default()(item) || isNumber_default()(item)) {
          option = {
            value: item,
            key,
            label: item,
            show: true
          };
        } else if (isObject_default()(item) && !isUndefined_default()(item.value)) {
          option = Object.assign({
            show: true
          }, item);
        }
        if (renderItem && typeof renderItem === 'function') {
          option.label = renderItem(item);
        }
        options.push(option);
      });
    }
    return options;
  }
  handleSearch(inputValue) {
    this._adapter.updateInputValue(inputValue);
    this._adapter.notifySearch(inputValue);
    this._adapter.notifyChange(inputValue);
    this._modifyFocusIndex(inputValue);
    if (!this.isPanelOpen) {
      this.openDropdown();
    }
  }
  handleSelect(option, optionIndex) {
    const {
      renderSelectedItem
    } = this.getProps();
    let newInputValue = '';
    if (renderSelectedItem && typeof renderSelectedItem === 'function') {
      newInputValue = renderSelectedItem(option);
      warning(typeof newInputValue !== 'string', 'Warning: [Semi AutoComplete] renderSelectedItem must return string, please check your function return');
    } else {
      newInputValue = option.value;
    }
    // 1. trigger onSelect
    // 2. close Dropdown
    if (this._isControlledComponent()) {
      this.closeDropdown();
      this.notifySelect(option);
    } else {
      // 1. update Input
      // 2. update Selection
      // 3. trigger onSelect
      // 4. close Dropdown
      this._adapter.updateInputValue(newInputValue);
      this.updateSelection(option);
      this.notifySelect(option);
      this.closeDropdown();
    }
    this._adapter.notifyChange(newInputValue);
    this._adapter.updateFocusIndex(optionIndex);
  }
  updateSelection(option) {
    const selection = new Map();
    if (option) {
      selection.set(option.label, option);
    }
    this._adapter.updateSelection(selection);
  }
  notifySelect(option) {
    if (this._backwardLabelInValue()) {
      this._adapter.notifySelect(option);
    } else {
      this._adapter.notifySelect(option.value);
    }
  }
  _backwardLabelInValue() {
    const props = this.getProps();
    let {
      onSelectWithObject
    } = props;
    return onSelectWithObject;
  }
  handleDataChange(newData) {
    const options = this._generateList(newData);
    this._adapter.updateOptionList(options);
    this._adapter.rePositionDropdown();
  }
  handleValueChange(propValue) {
    let {
      data,
      defaultActiveFirstOption
    } = this.getProps();
    let selectedValue = '';
    if (this._backwardLabelInValue() && Object.prototype.toString.call(propValue) === '[object Object]') {
      selectedValue = propValue.value;
    } else {
      selectedValue = propValue;
    }
    let renderSelectedItem = this._getRenderSelectedItem();
    const options = this._generateList(data);
    // Get the option whose value match from options
    let selectedOption = options.length ? options.filter(option => renderSelectedItem(option) === selectedValue) : [];
    const canMatchInData = selectedOption.length;
    const selectedOptionIndex = options.findIndex(option => renderSelectedItem(option) === selectedValue);
    let inputValue = '';
    if (canMatchInData) {
      selectedOption = selectedOption[0];
      inputValue = renderSelectedItem(selectedOption);
    } else {
      const cbItem = this._backwardLabelInValue() ? propValue : {
        label: selectedValue,
        value: selectedValue
      };
      inputValue = renderSelectedItem(cbItem);
    }
    this._adapter.updateInputValue(inputValue);
    this.updateSelection(canMatchInData ? selectedOption : null);
    if (selectedOptionIndex === -1 && defaultActiveFirstOption) {
      this._adapter.updateFocusIndex(0);
    } else {
      this._adapter.updateFocusIndex(selectedOptionIndex);
    }
  }
  _modifyFocusIndex(searchValue) {
    let {
      focusIndex
    } = this.getStates();
    let {
      data,
      defaultActiveFirstOption
    } = this.getProps();
    let selectedOptionIndex = -1;
    if (searchValue) {
      let renderSelectedItem = this._getRenderSelectedItem();
      const options = this._generateList(data);
      selectedOptionIndex = options.findIndex(option => renderSelectedItem(option) === searchValue);
    }
    if (selectedOptionIndex === -1 && defaultActiveFirstOption) {
      if (focusIndex !== 0) {
        this._adapter.updateFocusIndex(0);
      }
    } else {
      if (selectedOptionIndex !== focusIndex) {
        this._adapter.updateFocusIndex(selectedOptionIndex);
      }
    }
  }
  _modifyFocusIndexOnPanelOpen() {
    let {
      inputValue
    } = this.getStates();
    this._modifyFocusIndex(inputValue);
  }
  _getRenderSelectedItem() {
    let {
      renderSelectedItem
    } = this.getProps();
    if (typeof renderSelectedItem === 'undefined') {
      renderSelectedItem = option => {
        return option === null || option === void 0 ? void 0 : option.value;
      };
    } else if (renderSelectedItem && typeof renderSelectedItem === 'function') {
      // do nothing
    }
    return renderSelectedItem;
  }
  handleClear() {
    this._adapter.notifyClear();
  }
  bindKeyBoardEvent() {
    this._keydownHandler = event => {
      this._handleKeyDown(event);
    };
    this._adapter.registerKeyDown(this._keydownHandler);
  }
  // unBindKeyBoardEvent() {
  //     if (this._keydownHandler) {
  //         this._adapter.unregisterKeyDown(this._keydownHandler);
  //     }
  // }
  _handleKeyDown(event) {
    const key = event.keyCode;
    const {
      visible
    } = this.getStates();
    switch (key) {
      case utils_keyCode.UP:
        // Prevent Input's cursor from following the movement
        event.preventDefault();
        this._handleArrowKeyDown(-1);
        break;
      case utils_keyCode.DOWN:
        // Prevent Input's cursor from following the movement
        event.preventDefault();
        this._handleArrowKeyDown(1);
        break;
      case utils_keyCode.ENTER:
        // when custom trigger, prevent outer open panel again
        event.preventDefault();
        this._handleEnterKeyDown();
        break;
      case utils_keyCode.ESC:
        this.closeDropdown();
        break;
      case utils_keyCode.TAB:
        this.closeDropdown();
        break;
      default:
        break;
    }
    this._adapter.notifyKeyDown(event);
  }
  _getEnableFocusIndex(offset) {
    const {
      focusIndex,
      options
    } = this.getStates();
    const visibleOptions = options.filter(item => item.show);
    const optionsLength = visibleOptions.length;
    let index = focusIndex + offset;
    if (index < 0) {
      index = optionsLength - 1;
    }
    if (index >= optionsLength) {
      index = 0;
    }
    // avoid newIndex option is disabled
    if (offset > 0) {
      let nearestActiveOption = -1;
      for (let i = 0; i < visibleOptions.length; i++) {
        const optionIsActive = !visibleOptions[i].disabled;
        if (optionIsActive) {
          nearestActiveOption = i;
        }
        if (nearestActiveOption >= index) {
          break;
        }
      }
      index = nearestActiveOption;
    } else {
      let nearestActiveOption = visibleOptions.length;
      for (let i = optionsLength - 1; i >= 0; i--) {
        const optionIsActive = !visibleOptions[i].disabled;
        if (optionIsActive) {
          nearestActiveOption = i;
        }
        if (nearestActiveOption <= index) {
          break;
        }
      }
      index = nearestActiveOption;
    }
    this._adapter.updateFocusIndex(index);
  }
  _handleArrowKeyDown(offset) {
    const {
      visible
    } = this.getStates();
    if (!visible) {
      this.openDropdown();
    } else {
      this._getEnableFocusIndex(offset);
    }
  }
  _handleEnterKeyDown() {
    const {
      visible,
      options,
      focusIndex
    } = this.getStates();
    if (!visible) {
      this.openDropdown();
    } else {
      if (focusIndex !== undefined && focusIndex !== -1 && options.length !== 0) {
        const visibleOptions = options.filter(item => item.show);
        const selectedOption = visibleOptions[focusIndex];
        this.handleSelect(selectedOption, focusIndex);
      } else {
        this.closeDropdown();
      }
    }
  }
  handleOptionMouseEnter(optionIndex) {
    this._adapter.updateFocusIndex(optionIndex);
  }
  handleFocus(e) {
    // If you get the focus through the tab key, you need to manually bind keyboard events
    // Then you can open the panel by pressing the enter key
    this.bindKeyBoardEvent();
    this._adapter.notifyFocus(e);
  }
  handleBlur(e) {
    // only need persist on react adapter
    // https://reactjs.org/docs/legacy-event-pooling.html
    this._persistEvent(e);
    this._adapter.notifyBlur(e);
  }
}
/* harmony default export */ var autoComplete_foundation = (AutoCompleteFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/autoComplete/option.js

var autoComplete_option_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};







class option_Option extends react.PureComponent {
  onClick(_a, event) {
    var {
        value,
        label,
        children
      } = _a,
      rest = autoComplete_option_rest(_a, ["value", "label", "children"]);
    const {
      props
    } = this;
    const isDisabled = props.disabled;
    if (!isDisabled) {
      props.onSelect(Object.assign(Object.assign({}, rest), {
        value,
        label: label || children
      }), event);
    }
  }
  renderOptionContent(_ref) {
    let {
      config,
      children,
      inputValue,
      prefixCls
    } = _ref;
    if (isString_default()(children) && inputValue) {
      return getHighLightTextHTML(config);
    }
    return children;
  }
  render() {
    const _a = this.props,
      {
        children,
        disabled,
        value,
        selected,
        label,
        empty,
        emptyContent,
        onSelect,
        focused,
        showTick,
        className,
        style,
        onMouseEnter,
        prefixCls,
        renderOptionItem,
        inputValue
      } = _a,
      rest = autoComplete_option_rest(_a, ["children", "disabled", "value", "selected", "label", "empty", "emptyContent", "onSelect", "focused", "showTick", "className", "style", "onMouseEnter", "prefixCls", "renderOptionItem", "inputValue"]);
    const optionClassName = classnames_default()(prefixCls, {
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-selected`]: selected,
      [`${prefixCls}-focused`]: focused,
      [`${prefixCls}-empty`]: empty,
      [className]: className
    });
    const selectedIconClassName = classnames_default()([`${prefixCls}-icon`]);
    if (empty) {
      if (emptyContent === null) {
        return null;
      }
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Select"
      }, locale => /*#__PURE__*/react.createElement("div", {
        className: optionClassName,
        "x-semi-prop": "emptyContent"
      }, emptyContent || locale.emptyText));
    }
    // Since there are empty, locale and other logic, the custom renderOptionItem is directly converged to the internal option instead of being placed in Select/index
    if (typeof renderOptionItem === 'function') {
      return renderOptionItem(Object.assign({
        disabled,
        focused,
        selected,
        style,
        label,
        value,
        inputValue,
        onMouseEnter: e => onMouseEnter(e),
        onClick: e => this.onClick(Object.assign({
          value,
          label,
          children
        }, rest), e)
      }, rest));
    }
    const config = {
      searchWords: inputValue,
      sourceString: children,
      option: {
        highlightClassName: `${prefixCls}-keyword`
      }
    };
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events
      react.createElement("div", {
        className: optionClassName,
        onClick: e => {
          this.onClick(Object.assign({
            value,
            label,
            children
          }, rest), e);
        },
        onMouseEnter: e => onMouseEnter && onMouseEnter(e),
        role: "option",
        "aria-selected": selected ? "true" : "false",
        "aria-disabled": disabled ? "true" : "false",
        style: style
      }, showTick ? /*#__PURE__*/react.createElement("div", {
        className: selectedIconClassName
      }, /*#__PURE__*/react.createElement(IconTick, null)) : null, isString_default()(children) ? /*#__PURE__*/react.createElement("div", {
        className: `${prefixCls}-text`
      }, this.renderOptionContent({
        children,
        config,
        inputValue,
        prefixCls
      })) : children)
    );
  }
}
option_Option.isSelectOption = true;
option_Option.propTypes = {
  children: (prop_types_default()).node,
  disabled: (prop_types_default()).bool,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  selected: (prop_types_default()).bool,
  label: (prop_types_default()).node,
  empty: (prop_types_default()).bool,
  emptyContent: (prop_types_default()).node,
  onSelect: (prop_types_default()).func,
  focused: (prop_types_default()).bool,
  showTick: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  style: (prop_types_default()).object,
  onMouseEnter: (prop_types_default()).func,
  prefixCls: (prop_types_default()).string,
  renderOptionItem: (prop_types_default()).func,
  inputValue: (prop_types_default()).string
};
option_Option.defaultProps = {
  prefixCls: autoComplete_constants_cssClasses.PREFIX_OPTION
};
/* harmony default export */ var autoComplete_option = (option_Option);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/autoComplete/index.js















// import '@douyinfe/semi-foundation/lib/es/autoComplete/autoComplete.css';


const autoComplete_prefixCls = autoComplete_constants_cssClasses.PREFIX;
const autoComplete_sizeSet = autoComplete_constants_strings.SIZE;
const autoComplete_positionSet = autoComplete_constants_strings.POSITION;
const autoComplete_statusSet = autoComplete_constants_strings.STATUS;
class AutoComplete extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSelect = (option, optionIndex, e) => {
      this.foundation.handleSelect(option, optionIndex);
    };
    this.onSearch = value => {
      this.foundation.handleSearch(value);
    };
    this.onBlur = e => this.foundation.handleBlur(e);
    this.onFocus = e => this.foundation.handleFocus(e);
    this.onInputClear = () => this.foundation.handleClear();
    this.handleInputClick = e => this.foundation.handleInputClick(e);
    this.foundation = new autoComplete_foundation(this.adapter);
    const initRePosKey = 1;
    this.state = {
      dropdownMinWidth: null,
      inputValue: '',
      // option list
      options: [],
      // popover visible
      visible: false,
      // current focus option index
      focusIndex: props.defaultActiveFirstOption ? 0 : -1,
      // current selected options
      selection: new Map(),
      rePosKey: initRePosKey
    };
    this.triggerRef = /*#__PURE__*/react.createRef();
    this.optionsRef = /*#__PURE__*/react.createRef();
    this.clickOutsideHandler = null;
    warning('triggerRender' in this.props && typeof this.props.triggerRender === 'function', `[Semi AutoComplete]
            - If you are using the following props: 'suffix', 'prefix', 'showClear', 'validateStatus', and 'size',
            please notice that they will be removed in the next major version.
            Please use 'componentProps' to retrieve these props instead.
            - If you are using 'onBlur', 'onFocus', please try to avoid using them and look for changes in the future.`);
  }
  get adapter() {
    const keyboardAdapter = {
      registerKeyDown: cb => {
        const keyboardEventSet = {
          onKeyDown: cb
        };
        this.setState({
          keyboardEventSet
        });
      },
      unregisterKeyDown: cb => {
        this.setState({
          keyboardEventSet: {}
        });
      },
      updateFocusIndex: focusIndex => {
        this.setState({
          focusIndex
        });
      }
    };
    return Object.assign(Object.assign(Object.assign({}, super.adapter), keyboardAdapter), {
      getTriggerWidth: () => {
        const el = this.triggerRef.current;
        return el && el.getBoundingClientRect().width;
      },
      setOptionWrapperWidth: width => {
        this.setState({
          dropdownMinWidth: width
        });
      },
      updateInputValue: inputValue => {
        this.setState({
          inputValue
        });
      },
      toggleListVisible: isShow => {
        this.setState({
          visible: isShow
        });
      },
      updateOptionList: optionList => {
        this.setState({
          options: optionList
        });
      },
      updateSelection: selection => {
        this.setState({
          selection
        });
      },
      notifySearch: inputValue => {
        this.props.onSearch(inputValue);
      },
      notifyChange: value => {
        this.props.onChange(value);
      },
      notifySelect: option => {
        this.props.onSelect(option);
      },
      notifyDropdownVisibleChange: isVisible => {
        this.props.onDropdownVisibleChange(isVisible);
      },
      notifyClear: () => {
        this.props.onClear();
      },
      notifyFocus: event => {
        this.props.onFocus(event);
      },
      notifyBlur: event => {
        this.props.onBlur(event);
      },
      notifyKeyDown: e => {
        this.props.onKeyDown(e);
      },
      rePositionDropdown: () => {
        let {
          rePosKey
        } = this.state;
        rePosKey = rePosKey + 1;
        this.setState({
          rePosKey
        });
      },
      registerClickOutsideHandler: cb => {
        const clickOutsideHandler = e => {
          const optionInstance = this.optionsRef && this.optionsRef.current;
          const triggerDom = this.triggerRef && this.triggerRef.current;
          const optionsDom = react_dom.findDOMNode(optionInstance);
          const target = e.target;
          const path = e.composedPath && e.composedPath() || [target];
          if (optionsDom && (!optionsDom.contains(target) || !optionsDom.contains(target.parentNode)) && triggerDom && !triggerDom.contains(target) && !(path.includes(triggerDom) || path.includes(optionsDom))) {
            cb(e);
          }
        };
        this.clickOutsideHandler = clickOutsideHandler;
        document.addEventListener('mousedown', clickOutsideHandler, false);
      },
      unregisterClickOutsideHandler: () => {
        if (this.clickOutsideHandler) {
          document.removeEventListener('mousedown', this.clickOutsideHandler, false);
        }
      }
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  componentDidUpdate(prevProps, prevState) {
    if (!isEqual_default()(this.props.data, prevProps.data)) {
      this.foundation.handleDataChange(this.props.data);
    }
    if (this.props.value !== prevProps.value) {
      this.foundation.handleValueChange(this.props.value);
    }
  }
  renderInput() {
    const {
      size,
      prefix,
      insetLabel,
      insetLabelId,
      suffix,
      placeholder,
      style,
      className,
      showClear,
      disabled,
      triggerRender,
      validateStatus,
      autoFocus,
      value,
      id,
      clearIcon
    } = this.props;
    const {
      inputValue,
      keyboardEventSet,
      selection
    } = this.state;
    const useCustomTrigger = typeof triggerRender === 'function';
    const outerProps = Object.assign(Object.assign(Object.assign({
      style,
      className: useCustomTrigger ? classnames_default()(className) : classnames_default()({
        [autoComplete_prefixCls]: true,
        [`${autoComplete_prefixCls}-disabled`]: disabled
      }, className),
      onClick: this.handleInputClick,
      ref: this.triggerRef,
      id
    }, keyboardEventSet), {
      // tooltip give tabindex 0 to children by default, autoComplete just need the input get focus, so outer div's tabindex set to -1
      tabIndex: -1
    }), this.getDataAttr(this.props));
    const innerProps = {
      disabled,
      placeholder,
      autoFocus: autoFocus,
      onChange: this.onSearch,
      onClear: this.onInputClear,
      'aria-label': this.props['aria-label'],
      'aria-labelledby': this.props['aria-labelledby'],
      'aria-invalid': this.props['aria-invalid'],
      'aria-errormessage': this.props['aria-errormessage'],
      'aria-describedby': this.props['aria-describedby'],
      'aria-required': this.props['aria-required'],
      // TODO: remove in next major version
      suffix,
      prefix: prefix || insetLabel,
      insetLabelId,
      showClear,
      validateStatus,
      size,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      clearIcon
    };
    return /*#__PURE__*/react.createElement("div", Object.assign({}, outerProps), typeof triggerRender === 'function' ? /*#__PURE__*/react.createElement(trigger, Object.assign({}, innerProps, {
      inputValue: typeof value !== 'undefined' ? value : inputValue,
      value: Array.from(selection.values()),
      triggerRender: triggerRender,
      componentName: "AutoComplete",
      componentProps: Object.assign({}, this.props)
    })) : /*#__PURE__*/react.createElement(es_input, Object.assign({}, innerProps, {
      value: typeof value !== 'undefined' ? value : inputValue
    })));
  }
  renderLoading() {
    const loadingWrapperCls = `${autoComplete_prefixCls}-loading-wrapper`;
    return /*#__PURE__*/react.createElement("div", {
      className: loadingWrapperCls
    }, /*#__PURE__*/react.createElement(spin, null));
  }
  renderOption(option, optionIndex) {
    const {
      focusIndex
    } = this.state;
    const isFocused = optionIndex === focusIndex;
    return /*#__PURE__*/react.createElement(autoComplete_option, Object.assign({
      showTick: false,
      onSelect: (v, e) => this.onSelect(v, optionIndex, e),
      // selected={selection.has(option.label)}
      focused: isFocused,
      onMouseEnter: () => this.foundation.handleOptionMouseEnter(optionIndex),
      key: option.key || option.label + option.value + optionIndex
    }, option), option.label);
  }
  renderOptionList() {
    const {
      maxHeight,
      dropdownStyle,
      dropdownClassName,
      loading,
      emptyContent
    } = this.props;
    const {
      options,
      dropdownMinWidth
    } = this.state;
    const listCls = classnames_default()({
      [`${autoComplete_prefixCls}-option-list`]: true
    }, dropdownClassName);
    let optionsNode;
    if (options.length === 0) {
      optionsNode = emptyContent;
    } else {
      optionsNode = options.filter(option => option.show).map((option, i) => this.renderOption(option, i));
    }
    const style = Object.assign({
      maxHeight: maxHeight,
      minWidth: dropdownMinWidth
    }, dropdownStyle);
    return /*#__PURE__*/react.createElement("div", {
      className: listCls,
      role: "listbox",
      style: style
    }, !loading ? optionsNode : this.renderLoading());
  }
  render() {
    const {
      position,
      motion,
      zIndex,
      mouseEnterDelay,
      mouseLeaveDelay,
      autoAdjustOverflow,
      stopPropagation,
      getPopupContainer
    } = this.props;
    const {
      visible,
      rePosKey
    } = this.state;
    const input = this.renderInput();
    const optionList = this.renderOptionList();
    return /*#__PURE__*/react.createElement(popover, {
      mouseEnterDelay: mouseEnterDelay,
      mouseLeaveDelay: mouseLeaveDelay,
      autoAdjustOverflow: autoAdjustOverflow,
      trigger: "custom",
      motion: motion,
      visible: visible,
      content: optionList,
      position: position,
      ref: this.optionsRef,
      // TransformFromCenter TODO: need to confirm
      zIndex: zIndex,
      stopPropagation: stopPropagation,
      getPopupContainer: getPopupContainer,
      rePosKey: rePosKey
    }, input);
  }
}
AutoComplete.propTypes = {
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-invalid': (prop_types_default()).bool,
  'aria-errormessage': (prop_types_default()).string,
  'aria-describedby': (prop_types_default()).string,
  'aria-required': (prop_types_default()).bool,
  autoFocus: (prop_types_default()).bool,
  autoAdjustOverflow: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  clearIcon: (prop_types_default()).node,
  children: (prop_types_default()).node,
  data: (prop_types_default()).array,
  defaultOpen: (prop_types_default()).bool,
  defaultValue: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  defaultActiveFirstOption: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  dropdownMatchSelectWidth: (prop_types_default()).bool,
  dropdownClassName: (prop_types_default()).string,
  dropdownStyle: (prop_types_default()).object,
  emptyContent: (prop_types_default()).node,
  id: (prop_types_default()).string,
  insetLabel: (prop_types_default()).node,
  insetLabelId: (prop_types_default()).string,
  onSearch: (prop_types_default()).func,
  onSelect: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  onBlur: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  position: prop_types_default().oneOf(autoComplete_positionSet),
  placeholder: (prop_types_default()).string,
  prefix: (prop_types_default()).node,
  onChangeWithObject: (prop_types_default()).bool,
  onSelectWithObject: (prop_types_default()).bool,
  renderItem: (prop_types_default()).func,
  renderSelectedItem: (prop_types_default()).func,
  suffix: (prop_types_default()).node,
  showClear: (prop_types_default()).bool,
  size: prop_types_default().oneOf(autoComplete_sizeSet),
  style: (prop_types_default()).object,
  stopPropagation: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  maxHeight: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  mouseEnterDelay: (prop_types_default()).number,
  mouseLeaveDelay: (prop_types_default()).number,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  getPopupContainer: (prop_types_default()).func,
  triggerRender: (prop_types_default()).func,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  validateStatus: prop_types_default().oneOf(autoComplete_statusSet),
  zIndex: (prop_types_default()).number
};
AutoComplete.Option = autoComplete_option;
AutoComplete.__SemiComponentName__ = "AutoComplete";
AutoComplete.defaultProps = getDefaultPropsFromGlobalConfig(AutoComplete.__SemiComponentName__, {
  stopPropagation: true,
  motion: true,
  zIndex: constants_numbers.DEFAULT_Z_INDEX,
  position: 'bottomLeft',
  data: [],
  showClear: false,
  size: 'default',
  onFocus: (noop_default()),
  onSearch: (noop_default()),
  onClear: (noop_default()),
  onBlur: (noop_default()),
  onSelect: (noop_default()),
  onChange: (noop_default()),
  onSelectWithObject: false,
  onDropdownVisibleChange: (noop_default()),
  defaultActiveFirstOption: false,
  dropdownMatchSelectWidth: true,
  loading: false,
  maxHeight: 300,
  validateStatus: 'default',
  autoFocus: false,
  emptyContent: null,
  onKeyDown: (noop_default())
  // onPressEnter: () => undefined,
  // defaultOpen: false,
});

/* harmony default export */ var autoComplete = (AutoComplete);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/upload/constants.js

const upload_constants_PREFIX = `${BASE_CLASS_PREFIX}-upload`;
const FILE_LIST_PIC = 'picture';
const FILE_LIST_DEFAULT = 'list';
const PROGRESS_COEFFICIENT = 0.95;
const upload_constants_cssClasses = {
  PREFIX: upload_constants_PREFIX,
  // WRAPPER: `${PREFIX}-wrapper`,
  LIST: `${upload_constants_PREFIX}-list`
};
const TRIGGER_AUTO = 'auto';
const TRIGGER_CUSTOM = 'custom';
const upload_constants_strings = {
  FILE_STATUS_UPLOADING: 'uploading',
  FILE_STATUS_SUCCESS: 'success',
  FILE_STATUS_UPLOAD_FAIL: 'uploadFail',
  FILE_STATUS_VALIDATING: 'validating',
  FILE_STATUS_VALID_FAIL: 'validateFail',
  FILE_STATUS_WAIT_UPLOAD: 'wait',
  FILE_LIST_PIC,
  FILE_LIST_DEFAULT,
  LIST_TYPE: [FILE_LIST_PIC, FILE_LIST_DEFAULT],
  imageTypes: ['image', 'webp', 'png', 'svg', 'gif', 'jpg', 'jpeg', 'bmp', 'dpg'],
  DRAG_AREA_DEFAULT: 'default',
  DRAG_AREA_LEGAL: 'legal',
  DRAG_AREA_ILLEGAL: 'illegal',
  TRIGGER_AUTO,
  TRIGGER_CUSTOM,
  UPLOAD_TRIGGER: [TRIGGER_AUTO, TRIGGER_CUSTOM],
  VALIDATE_STATUS: VALIDATE_STATUS,
  PROMPT_POSITION: ['left', 'right', 'bottom']
};
const upload_constants_numbers = {
  PROGRESS_COEFFICIENT
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/upload/utils.js
var utils_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const byteKB = 1024;
const byteMB = 1048576;
function getFileSize(number) {
  if (number < byteKB) {
    return `${(number / byteKB).toFixed(2)}KB`;
  } else if (number >= byteKB && number < byteMB) {
    return `${(number / byteKB).toFixed(1)}KB`;
  } else if (number >= byteMB) {
    return `${(number / byteMB).toFixed(1)}MB`;
  }
  return undefined;
}
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}
function loopFiles(item) {
  return utils_awaiter(this, void 0, void 0, function* () {
    return new Promise((res, rej) => {
      const dirReader = item.createReader();
      let fileList = [];
      function sequence() {
        dirReader.readEntries(entries => {
          const entryList = Array.prototype.slice.apply(entries);
          fileList = fileList.concat(entryList);
          // Check if all the file has been viewed
          const isFinished = !entryList.length;
          if (isFinished) {
            res(fileList);
          } else {
            sequence();
          }
        }, rej);
      }
      sequence();
    });
  });
}
function mapFileTree(items) {
  return utils_awaiter(this, void 0, void 0, function* () {
    const promises = [];
    const _traverseFileTree = (item, path) => utils_awaiter(this, void 0, void 0, function* () {
      path = path || '';
      //@ts-ignore add path property into item
      item.path = path;
      if (item.isFile) {
        promises.push(new Promise((res, rej) => {
          item.file(file => {
            if (item.fullPath && !file.webkitRelativePath) {
              // This file is provided to the user based on the relative path of the drag and drop folder
              // If you drag the Upload folder, the path of the internal file may be Upload/File/a.png, etc
              Object.defineProperties(file, {
                webkitRelativePath: {
                  writable: true
                }
              });
              //@ts-ignore add webkitRelativePath property into file
              file.webkitRelativePath = item.fullPath.replace(/^\//, '');
              Object.defineProperties(file, {
                webkitRelativePath: {
                  writable: false
                }
              });
            }
            res(file);
          }, rej);
        }));
      } else if (item.isDirectory) {
        const entries = yield loopFiles(item);
        for (let index = 0; index < entries.length; index++) {
          const entry = entries[index];
          yield _traverseFileTree(entry, `${path}${item.name}/`);
        }
      }
    });
    try {
      const batches = items.map(i => _traverseFileTree(i.webkitGetAsEntry()));
      // Perform asynchronous operations to add the required promises to the queue
      yield Promise.all(batches);
      // Execution queue
      const result = yield Promise.all(promises);
      return result;
    } catch (error) {
      console.warn('Captured error while loop directory.');
      console.error(error);
      return [];
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/upload/foundation.js
var foundation_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};





const {
  FILE_STATUS_UPLOADING,
  FILE_STATUS_SUCCESS,
  FILE_STATUS_UPLOAD_FAIL,
  FILE_STATUS_VALID_FAIL,
  FILE_STATUS_WAIT_UPLOAD,
  DRAG_AREA_DEFAULT,
  DRAG_AREA_LEGAL,
  TRIGGER_AUTO: foundation_TRIGGER_AUTO
} = upload_constants_strings;
class UploadFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  init() {
    const {
      disabled,
      addOnPasting
    } = this.getProps();
    if (addOnPasting && !disabled) {
      this.bindPastingHandler();
    }
  }
  destroy() {
    const {
      disabled,
      addOnPasting
    } = this.getProps();
    this.releaseMemory();
    if (!disabled) {
      this.unbindPastingHandler();
    }
  }
  getError(_ref) {
    let {
      action,
      xhr,
      message,
      fileName
    } = _ref;
    const status = xhr ? xhr.status : 0;
    const msg = message || `cannot post ${fileName} to ${action}, xhr status: ${status}'`;
    const err = new Error(msg);
    err.status = status;
    err.method = 'post';
    err.url = action;
    return err;
  }
  getBody(xhr) {
    if (!xhr) {
      return;
    }
    const text = xhr.responseText || xhr.response;
    if (!text) {
      return text;
    }
    try {
      return JSON.parse(text);
    } catch (error) {
      return text;
    }
  }
  checkFileSize(file) {
    const {
      size
    } = file;
    const {
      maxSize,
      minSize
    } = this.getProps();
    let isIllegal = false;
    if (size > maxSize * byteKB || size < minSize * byteKB) {
      isIllegal = true;
    }
    return isIllegal;
  }
  /**
   * 1. 选择文件
   * 2. transform转换. 添加uid
   * 3. 检查文件个数是否超出
   *   若超出，不添加到list中，触发onExceed，中止流程
   *   若未超出，执行以下流程
   * 4. 检查文件尺寸，添加尺寸是否合法的标识
   * 5. 检查uploadTrigger是否为'auto'，若是执行步骤6-8
   * 6. 遍历文件列表触发上传
   *    - 对尺寸不合适的不需要触发上传
   * 7. beforeUpload
   *    - 对beforeUpload中设为不合法的不需要触发上传
   * 8. TODO: check
   * 9. afterUpload
   *
   * 1. Select file
   * 2. transform, add uid
   * 3. Check whether the number of files exceeds
   *   If it exceeds, it is not added to the list, trigger onExceed, and abort the process
   *   If it is not exceeded, execute the following process
   * 4. check the file size, add the size is legal logo
   * 5. Check whether the uploadTrigger is'auto ', if so, perform steps 6-8
   * 6. Traversing the file list triggers upload
   *    - No need to trigger uploads for inappropriate sizes
   * 7. beforeUpload
   *    - no need to trigger upload if beforeUpload is not set to be valid
   * 8. TODO: check
   * 9. afterUpload
   */
  handleChange(currentFileList) {
    const invalidFiles = [];
    const {
      limit,
      transformFile,
      accept
    } = this.getProps();
    const {
      fileList
    } = this.getStates();
    let files = Array.from(currentFileList); // When the selected file
    if (typeof accept !== 'undefined') {
      files = files.filter(item => {
        const isValid = this.checkFileFormat(accept, item);
        if (!isValid) {
          invalidFiles.push(item);
        }
        return isValid;
      });
      if (invalidFiles.length !== 0) {
        this._adapter.notifyAcceptInvalid(invalidFiles);
      }
      if (files.length === 0) {
        return;
      }
    }
    files = files.map(file => {
      if (transformFile) {
        file = transformFile(file);
      }
      if (!file.uid) {
        file.uid = getUuidv4();
      }
      if (this.checkFileSize(file)) {
        file._sizeInvalid = true;
        file.status = FILE_STATUS_VALID_FAIL;
        this._adapter.notifySizeError(file, fileList);
      }
      return file;
    });
    const total = fileList.length + files.length;
    if (typeof limit !== 'undefined') {
      // Determine whether the limit is exceeded
      if (total > limit) {
        this._adapter.notifyExceed(files);
        if (limit === 1) {
          // Replace the current file with the last file
          files = files.slice(-1);
          this._adapter.notifyFileSelect(files);
          this._adapter.resetInput();
          this.replaceFileList(files);
          return;
        }
        // If the limit is exceeded, the calculation can add a few more files and continue uploading the remaining files
        const restNum = limit - fileList.length;
        files = files.slice(0, restNum);
      }
    }
    this._adapter.notifyFileSelect(files);
    this._adapter.resetInput();
    this.addFilesToList(files);
  }
  // Triggered when replacing a single file
  handleReplaceChange(currentFileList) {
    if (currentFileList.length === 0) {
      return;
    }
    const {
      transformFile,
      uploadTrigger,
      accept
    } = this.getProps();
    const {
      replaceIdx,
      fileList
    } = this.getStates();
    let newFile = Array.from(currentFileList).pop();
    if (typeof accept !== 'undefined') {
      if (!this.checkFileFormat(accept, newFile)) {
        this._adapter.notifyAcceptInvalid([newFile]);
        return;
      }
    }
    if (transformFile) {
      newFile = transformFile(newFile);
    }
    if (!newFile.uid) {
      newFile.uid = getUuidv4();
    }
    if (this.checkFileSize(newFile)) {
      newFile._sizeInvalid = true;
      newFile.status = FILE_STATUS_VALID_FAIL;
      this._adapter.notifySizeError(newFile, fileList);
    }
    this._adapter.notifyFileSelect([newFile]);
    const newFileItem = this.buildFileItem(newFile, uploadTrigger);
    const newFileList = [...fileList];
    newFileList.splice(replaceIdx, 1, newFileItem);
    this._adapter.notifyChange({
      currentFile: newFileItem,
      fileList: newFileList
    });
    this._adapter.updateFileList(newFileList, () => {
      this._adapter.resetReplaceInput();
      if (!newFileItem._sizeInvalid) {
        this.upload(newFileItem);
      }
    });
  }
  buildFileItem(fileInstance, uploadTrigger) {
    const {
      _sizeInvalid,
      status
    } = fileInstance;
    try {
      // can't use ... to get rest property on File Object
      delete fileInstance._sizeInvalid;
      delete fileInstance.status;
    } catch (error) {}
    const _file = {
      status: status ? status : uploadTrigger === foundation_TRIGGER_AUTO ? FILE_STATUS_UPLOADING : FILE_STATUS_WAIT_UPLOAD,
      name: fileInstance.name,
      size: getFileSize(fileInstance.size),
      uid: fileInstance.uid,
      percent: 0,
      fileInstance,
      url: this._createURL(fileInstance)
    };
    if (_sizeInvalid) {
      _file._sizeInvalid = true;
    }
    // If it is an image, preview; if it is a pdf, you can jump to
    if (this.isImage(fileInstance)) {
      _file.preview = true;
    }
    return _file;
  }
  replaceFileList(files) {
    const {
      uploadTrigger
    } = this.getProps();
    const currentFiles = files.map(item => this.buildFileItem(item, uploadTrigger));
    this._adapter.notifyChange({
      fileList: currentFiles,
      currentFile: currentFiles[0]
    });
    this._adapter.updateFileList(currentFiles, () => {
      if (uploadTrigger === foundation_TRIGGER_AUTO) {
        this.startUpload(currentFiles);
      }
    });
  }
  addFilesToList(files) {
    const fileList = this.getState('fileList').slice();
    const {
      uploadTrigger
    } = this.getProps();
    const currentFiles = files.map(item => this.buildFileItem(item, uploadTrigger));
    currentFiles.forEach(file => {
      const index = fileList.findIndex(item => item.uid === file.uid);
      if (index !== -1) {
        fileList[index] = file;
      } else {
        fileList.push(file);
        this._adapter.notifyChange({
          fileList,
          currentFile: file
        });
      }
    });
    this._adapter.updateFileList(fileList, () => {
      if (uploadTrigger === foundation_TRIGGER_AUTO) {
        this.startUpload(currentFiles);
      }
    });
  }
  // 插入多个文件到指定位置
  // Insert files to the specified location
  insertFileToList(files, index) {
    const {
      limit,
      transformFile,
      accept,
      uploadTrigger
    } = this.getProps();
    const {
      fileList
    } = this.getStates();
    const unAcceptFileList = [];
    // 当次选中的文件
    // current selected file
    let currentFileList = Array.from(files);
    if (typeof accept !== 'undefined') {
      currentFileList = currentFileList.filter(item => {
        const isValid = this.checkFileFormat(accept, item);
        if (!isValid) {
          unAcceptFileList.push(item);
        }
        return isValid;
      });
      if (unAcceptFileList.length !== 0) {
        this._adapter.notifyAcceptInvalid(unAcceptFileList);
      }
      if (currentFileList.length === 0) {
        return;
      }
    }
    currentFileList = currentFileList.map(file => {
      if (!file.uid) {
        file.uid = getUuidv4();
      }
      if (this.checkFileSize(file)) {
        file._sizeInvalid = true;
        file.status = FILE_STATUS_VALID_FAIL;
        this._adapter.notifySizeError(file, fileList);
      }
      if (transformFile) {
        file = transformFile(file);
      }
      return file;
    });
    const total = fileList.length + currentFileList.length;
    if (typeof limit !== 'undefined') {
      // 判断是否超出限制
      // Determine whether the limit is exceeded
      if (total > limit) {
        if (limit === 1) {
          // 使用最后面的文件对当前文件进行替换
          // Use the last file to replace the current file
          currentFileList = currentFileList.slice(-1);
          this._adapter.notifyFileSelect(currentFileList);
          this._adapter.resetInput();
          this.replaceFileList(currentFileList);
          return;
        }
        // 如果超出了限制，则计算还能添加几个文件，将剩余的文件继续上传
        // If the limit is exceeded, several files can be added to the calculation, and the remaining files will continue to be uploaded
        const restNum = limit - fileList.length;
        currentFileList = currentFileList.slice(0, restNum);
        this._adapter.notifyExceed(currentFileList);
      }
    }
    const fileItemList = currentFileList.map(file => this.buildFileItem(file, uploadTrigger));
    const newFileList = fileList.slice();
    if (typeof index !== 'undefined') {
      newFileList.splice(index, 0, ...fileItemList);
    } else {
      newFileList.push(...fileItemList);
    }
    this._adapter.notifyFileSelect(currentFileList);
    this._adapter.notifyChange({
      fileList: newFileList,
      currentFile: null
    });
    this._adapter.updateFileList(newFileList, () => {
      if (uploadTrigger === foundation_TRIGGER_AUTO) {
        this.startUpload(fileItemList);
      }
    });
  }
  /* istanbul ignore next */
  manualUpload() {
    // find the list of files that have not been uploaded
    const waitToUploadFileList = this.getState('fileList').filter(item => item.status === FILE_STATUS_WAIT_UPLOAD);
    this.startUpload(waitToUploadFileList);
  }
  startUpload(fileList) {
    fileList.forEach(file => {
      if (!file._sizeInvalid) {
        this.upload(file);
      }
    });
  }
  upload(file) {
    const {
      beforeUpload
    } = this.getProps();
    if (typeof beforeUpload === 'undefined') {
      this.post(file);
      return;
    }
    if (typeof beforeUpload === 'function') {
      const {
        fileList
      } = this.getStates();
      const buResult = this._adapter.notifyBeforeUpload({
        file,
        fileList
      });
      switch (true) {
        // sync validate - boolean
        case buResult === true:
          {
            this.post(file);
            break;
          }
        case buResult === false:
          {
            const newResult = {
              shouldUpload: false,
              status: upload_constants_strings.FILE_STATUS_VALID_FAIL
            };
            this.handleBeforeUploadResultInObject(newResult, file);
            break;
          }
        // async validate
        case buResult && isPromise(buResult):
          {
            Promise.resolve(buResult).then(resolveData => {
              let newResult = {
                shouldUpload: true
              };
              const typeOfResolveData = Object.prototype.toString.call(resolveData).slice(8, -1);
              if (typeOfResolveData === 'Object') {
                newResult = Object.assign(Object.assign({}, newResult), resolveData);
              }
              this.handleBeforeUploadResultInObject(newResult, file);
            }, rejectVal => {
              let newResult = {
                shouldUpload: false,
                status: upload_constants_strings.FILE_STATUS_VALID_FAIL
              };
              const typeOfRejectData = Object.prototype.toString.call(rejectVal).slice(8, -1);
              if (typeOfRejectData === 'Object') {
                newResult = Object.assign(Object.assign({}, newResult), rejectVal);
              }
              this.handleBeforeUploadResultInObject(newResult, file);
            });
            break;
          }
        // sync validate - object
        case typeof buResult === 'object':
          // inject to fileList
          this.handleBeforeUploadResultInObject(buResult, file);
          break;
        default:
          break;
      }
    }
  }
  // handle beforeUpload result when it's an object
  handleBeforeUploadResultInObject(buResult, file) {
    const {
      shouldUpload,
      status,
      autoRemove,
      validateMessage,
      fileInstance
    } = buResult;
    let newFileList = this.getState('fileList').slice();
    if (autoRemove) {
      newFileList = newFileList.filter(item => item.uid !== file.uid);
    } else {
      const index = this._getFileIndex(file, newFileList);
      if (index < 0) {
        return;
      }
      status ? newFileList[index].status = status : null;
      validateMessage ? newFileList[index].validateMessage = validateMessage : null;
      if (fileInstance) {
        fileInstance.uid = file.uid; // reuse recent file uid
        newFileList[index].fileInstance = fileInstance;
        newFileList[index].size = getFileSize(fileInstance.size);
        newFileList[index].name = fileInstance.name;
        newFileList[index].url = this._createURL(fileInstance);
      }
      newFileList[index].shouldUpload = shouldUpload;
    }
    this._adapter.updateFileList(newFileList);
    this._adapter.notifyChange({
      fileList: newFileList,
      currentFile: file
    });
    if (shouldUpload) {
      this.post(file);
    }
  }
  post(file) {
    const {
      fileInstance
    } = file;
    const option = this.getProps();
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    const xhr = new XMLHttpRequest();
    const formData = new FormData();
    const {
      action
    } = option;
    // add data
    let {
      data
    } = option;
    if (data) {
      if (typeof data === 'function') {
        data = data(fileInstance);
      }
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
    }
    // add file
    const fileName = option.name || option.fileName || fileInstance.name;
    if (option.customRequest) {
      return option.customRequest({
        fileName,
        data,
        file,
        fileInstance,
        onProgress: e => this.handleProgress({
          e,
          fileInstance
        }),
        onError: (userXhr, e) => this.handleError({
          e,
          xhr: userXhr,
          fileInstance
        }),
        onSuccess: (response, e) => this.handleSuccess({
          response,
          fileInstance,
          e,
          isCustomRequest: true
        }),
        withCredentials: option.withCredentials,
        action: option.action
      });
    }
    formData.append(fileName, fileInstance);
    xhr.open('post', action, true);
    if (option.withCredentials && 'withCredentials' in xhr) {
      xhr.withCredentials = true;
    }
    if (xhr.upload) {
      xhr.upload.onprogress = e => this.handleProgress({
        e,
        fileInstance
      });
    }
    // Callback function after upload is completed
    xhr.onload = e => this.handleOnLoad({
      e,
      xhr,
      fileInstance
    });
    xhr.onerror = e => this.handleError({
      e,
      xhr,
      fileInstance
    });
    // add headers
    let headers = option.headers || {};
    if (typeof headers === 'function') {
      headers = headers(fileInstance);
    }
    for (const item in headers) {
      if (Object.prototype.hasOwnProperty.call(headers, item) && headers[item] !== null) {
        xhr.setRequestHeader(item, headers[item]);
      }
    }
    xhr.send(formData);
  }
  handleProgress(_ref2) {
    let {
      e,
      fileInstance
    } = _ref2;
    const {
      fileList
    } = this.getStates();
    const newFileList = fileList.slice();
    let percent = 0;
    if (e.total > 0) {
      percent = Number((e.loaded / e.total * 100 * upload_constants_numbers.PROGRESS_COEFFICIENT).toFixed(0)) || 0;
    }
    const index = this._getFileIndex(fileInstance, newFileList);
    if (index < 0) {
      return;
    }
    newFileList[index].percent = percent;
    newFileList[index].status = FILE_STATUS_UPLOADING;
    this._adapter.notifyProgress(percent, fileInstance, newFileList);
    this._adapter.updateFileList(newFileList);
    this._adapter.notifyChange({
      fileList: newFileList,
      currentFile: newFileList[index]
    });
  }
  handleOnLoad(_ref3) {
    let {
      e,
      xhr,
      fileInstance
    } = _ref3;
    const {
      fileList
    } = this.getStates();
    const index = this._getFileIndex(fileInstance, fileList);
    if (index < 0) {
      return;
    }
    if (xhr.status < 200 || xhr.status >= 300) {
      this.handleError({
        e,
        xhr,
        fileInstance
      });
    } else {
      this.handleSuccess({
        e,
        xhr,
        fileInstance,
        index
      });
    }
  }
  handleSuccess(_ref4) {
    let {
      e,
      fileInstance,
      isCustomRequest = false,
      xhr,
      response
    } = _ref4;
    const {
      fileList
    } = this.getStates();
    let body = null;
    const index = this._getFileIndex(fileInstance, fileList);
    if (index < 0) {
      return;
    }
    if (isCustomRequest) {
      // use when pass customRequest
      body = response;
    } else {
      body = this.getBody(xhr);
    }
    const newFileList = fileList.slice();
    const {
      afterUpload
    } = this.getProps();
    newFileList[index].status = FILE_STATUS_SUCCESS;
    newFileList[index].percent = 100;
    this._adapter.notifyProgress(100, fileInstance, newFileList);
    newFileList[index].response = body;
    e ? newFileList[index].event = e : null;
    if (afterUpload && typeof afterUpload === 'function') {
      const {
        autoRemove,
        status,
        validateMessage,
        name
      } = this._adapter.notifyAfterUpload({
        response: body,
        file: newFileList[index],
        fileList: newFileList
      }) || {};
      status ? newFileList[index].status = status : null;
      validateMessage ? newFileList[index].validateMessage = validateMessage : null;
      name ? newFileList[index].name = name : null;
      autoRemove ? newFileList.splice(index, 1) : null;
    }
    this._adapter.notifySuccess(body, fileInstance, newFileList);
    this._adapter.notifyChange({
      fileList: newFileList,
      currentFile: newFileList[index]
    });
    this._adapter.updateFileList(newFileList);
  }
  _getFileIndex(file, fileList) {
    return fileList.findIndex(item => item.uid === file.uid);
  }
  handleRemove(file) {
    const {
      disabled
    } = this.getProps();
    if (disabled) {
      return;
    }
    const {
      fileList
    } = this.getStates();
    Promise.resolve(this._adapter.notifyBeforeRemove(file, fileList)).then(res => {
      // prevent remove while user return false
      if (res === false) {
        return;
      }
      const newFileList = fileList.slice();
      const index = this._getFileIndex(file, fileList);
      if (index < 0) {
        return;
      }
      newFileList.splice(index, 1);
      this._adapter.notifyRemove(file.fileInstance, newFileList, file);
      this._adapter.updateFileList(newFileList);
      this._adapter.notifyChange({
        fileList: newFileList,
        currentFile: file
      });
    });
  }
  handleError(_ref5) {
    let {
      e,
      xhr,
      fileInstance
    } = _ref5;
    const {
      fileList
    } = this.getStates();
    const index = this._getFileIndex(fileInstance, fileList);
    if (index < 0) {
      return;
    }
    const {
      action
    } = this.getProps();
    const newFileList = fileList.slice();
    const error = this.getError({
      action,
      xhr,
      fileName: fileInstance.name
    });
    newFileList[index].status = FILE_STATUS_UPLOAD_FAIL;
    newFileList[index].response = error;
    newFileList[index].event = e;
    this._adapter.notifyError(error, fileInstance, newFileList, xhr);
    this._adapter.updateFileList(newFileList);
    this._adapter.notifyChange({
      currentFile: newFileList[index],
      fileList: newFileList
    });
  }
  handleClear() {
    const {
      disabled
    } = this.getProps();
    const {
      fileList
    } = this.getStates();
    if (disabled) {
      return;
    }
    Promise.resolve(this._adapter.notifyBeforeClear(fileList)).then(res => {
      if (res === false) {
        return;
      }
      this._adapter.updateFileList([]);
      this._adapter.notifyClear();
      this._adapter.notifyChange({
        fileList: []
      });
    }).catch(error => {
      // if user pass reject promise, no need to do anything
    });
  }
  _createURL(fileInstance) {
    // https://stackoverflow.com/questions/31742072/filereader-vs-window-url-createobjecturl
    const url = URL.createObjectURL(fileInstance);
    const {
      localUrls
    } = this.getStates();
    const newUrls = localUrls.slice();
    newUrls.push(url);
    this._adapter.updateLocalUrls(newUrls);
    return url;
  }
  // 释放预览文件所占用的内存
  // Release memory used by preview files
  releaseMemory() {
    const {
      localUrls
    } = this.getStates();
    localUrls.forEach(url => {
      this._releaseBlob(url);
    });
  }
  _releaseBlob(url) {
    try {
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  }
  isImage(file) {
    return /(webp|svg|png|gif|jpg|jpeg|bmp|dpg)$/i.test(file.type);
  }
  /* istanbul ignore next */
  isMultiple() {
    return Boolean(this.getProp('multiple'));
  }
  handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    this._dragEnterTarget = e.currentTarget;
    const {
      disabled
    } = this.getProps();
    if (!disabled) {
      this._adapter.updateDragAreaStatus(DRAG_AREA_LEGAL);
    }
  }
  handleDirectoryDrop(e) {
    return foundation_awaiter(this, void 0, void 0, function* () {
      const fileList = this.getState('fileList').slice();
      const items = [].slice.call(e.dataTransfer.items);
      const files = yield mapFileTree(items);
      this.handleChange(files);
      this._adapter.updateDragAreaStatus(DRAG_AREA_DEFAULT);
      this._adapter.notifyDrop(e, files, fileList);
    });
  }
  handleDrop(e) {
    // Block file opening in browser
    e.preventDefault();
    e.stopPropagation();
    const {
      disabled,
      directory
    } = this.getProps();
    const fileList = this.getState('fileList').slice();
    if (!disabled) {
      if (directory) {
        this.handleDirectoryDrop(e);
        return;
      }
      const files = Array.from(e.dataTransfer.files);
      this.handleChange(files);
      this._adapter.updateDragAreaStatus(DRAG_AREA_DEFAULT);
      this._adapter.notifyDrop(e, files, fileList);
    }
  }
  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    // 防止拖拽进入子元素时触发的dragLeave也被处理
    // Prevent dragLeave triggered when dragging into a child element is also handled
    // https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
    if (this._dragEnterTarget === e.target) {
      this._adapter.updateDragAreaStatus(DRAG_AREA_DEFAULT);
    }
  }
  // 拖拽上传时，需要对文件的格式进行校验
  // When dragging and uploading, you need to verify the file format
  checkFileFormat(accept, file) {
    const acceptTypes = accept.split(',').map(type => type.trim()).filter(type => type);
    const mimeType = file.type || '';
    // Get the large class to which MIMEtype belongs, eg: image/jpeg = > image, application/= > application
    const baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptTypes.some(type => {
      // When accepted as a suffix filename such as [.jpeg]
      if (type.charAt(0) === '.') {
        const fileName = file.name || '';
        const acceptExtension = type.split('.').pop().toLowerCase();
        return endsWith(fileName.toLowerCase(), acceptExtension);
      }
      // When accepted as a general class such as [image/*] or [video/*]
      if (/\/\*$/.test(type)) {
        const acceptBaseMimeType = type.replace(/\/.*$/, '');
        return baseMimeType === acceptBaseMimeType;
      }
      // When accepted as a full MIME types string
      if (/^[^\/]+\/[^\/]+$/.test(type)) {
        return mimeType === type;
      }
      return false;
    });
  }
  retry(fileItem) {
    const {
      onRetry
    } = this.getProps();
    if (onRetry && typeof onRetry === 'function') {
      onRetry(fileItem);
    }
    this.post(fileItem);
  }
  handlePreviewClick(fileItem) {
    this._adapter.notifyPreviewClick(fileItem);
  }
  readFileFromClipboard(clipboardItems) {
    for (const clipboardItem of clipboardItems) {
      for (const type of clipboardItem.types) {
        // types maybe: text/plain, image/png, text/html
        if (type.startsWith('image')) {
          clipboardItem.getType(type).then(blob => {
            return blob.arrayBuffer();
          }).then(buffer => {
            const format = type.split('/')[1];
            const file = new File([buffer], `upload.${format}`, {
              type
            });
            this.handleChange([file]);
          });
        }
      }
    }
  }
  handlePasting(e) {
    const isMac = this._adapter.isMac();
    const isCombineKeydown = isMac ? e.metaKey : e.ctrlKey;
    const {
      addOnPasting
    } = this.getProps();
    if (addOnPasting) {
      if (isCombineKeydown && e.code === 'KeyV' && e.target === document.body) {
        // https://github.com/microsoft/TypeScript/issues/33923
        const permissionName = 'clipboard-read';
        // The main thread should not be blocked by clipboard, so callback writing is required here. No await here
        navigator.permissions.query({
          name: permissionName
        }).then(result => {
          if (result.state === 'granted' || result.state === 'prompt') {
            // user has authorized or will authorize
            navigator.clipboard.read().then(clipboardItems => {
              // Process the data read from the pasteboard
              // Check the returned data type to determine if it is image data, and process accordingly
              this.readFileFromClipboard(clipboardItems);
            });
          } else {
            this._adapter.notifyPastingError(result);
          }
        }).catch(error => {
          this._adapter.notifyPastingError(error);
        });
      }
    }
  }
  bindPastingHandler() {
    this._adapter.registerPastingHandler(event => this.handlePasting(event));
  }
  unbindPastingHandler() {
    this._adapter.unRegisterPastingHandler();
  }
}
/* harmony default export */ var upload_foundation = (UploadFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/upload/fileCardFoundation.js

class FileCardFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  }
  handleImageError(error) {
    this._adapter.updateFallbackPreview(true);
  }
}
/* harmony default export */ var fileCardFoundation = (FileCardFoundation);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconRefresh.js


function IconRefresh_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49993 11.9998C4.49993 7.85775 7.85775 4.49993 11.9998 4.49993C14.6403 4.49993 16.9645 5.86506 18.3012 7.9305L16.2939 7.52902C15.4815 7.36656 14.6913 7.89337 14.5288 8.7057C14.3664 9.51803 14.8932 10.3083 15.7055 10.4707L20.7055 11.4707C21.4643 11.6225 22.214 11.1721 22.4363 10.4309L23.9363 5.43095C24.1744 4.63747 23.7241 3.80126 22.9307 3.56321C22.1372 3.32517 21.301 3.77543 21.0629 4.56891L20.6287 6.01635C18.7332 3.28781 15.5765 1.49998 11.9998 1.49998C6.20092 1.49998 1.49998 6.20092 1.49998 11.9998C1.49998 17.7987 6.20092 22.4997 11.9998 22.4997C16.5739 22.4997 20.4611 19.5757 21.9018 15.4996C22.1779 14.7186 21.7685 13.8616 20.9874 13.5855C20.2064 13.3095 19.3494 13.7189 19.0733 14.4999C18.0431 17.4149 15.263 19.4997 11.9998 19.4997C7.85775 19.4997 4.49993 16.1419 4.49993 11.9998Z",
    fill: "currentColor"
  }));
}
const IconRefresh_IconComponent = (0,Icon/* convertIcon */.A)(IconRefresh_SvgComponent, 'refresh');
/* harmony default export */ var IconRefresh = (IconRefresh_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/progress/constants.js

const progress_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-progress`
};
const progress_constants_strings = {
  types: ['line', 'circle'],
  DEFAULT_TYPE: 'line',
  STROKE_DEFAULT: 'var(--semi-color-success)',
  strokeLineCap: ['square', 'round'],
  DEFAULT_LINECAP: 'round',
  sizes: ['default', 'small', 'large'],
  DEFAULT_SIZE: 'default',
  directions: ['vertical', 'horizontal'],
  DEFAULT_DIRECTION: 'horizontal'
};
const progress_constants_numbers = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/progress/generates.js

function generateColor(s, percent, gradient) {
  try {
    const gradientColorArr = generate(s, percent, gradient);
    if (gradientColorArr.length !== 0) return gradientColorArr;
  } catch (e) {
    return undefined;
  }
  return undefined;
}
function generate(s, percent, gradient) {
  s.sort((a, b) => a.percent - b.percent);
  if (s[0].percent > percent) {
    return progress_constants_strings.STROKE_DEFAULT;
  }
  const endS = s[s.length - 1];
  if (endS.percent < percent) {
    return formatToHex(endS.color);
  }
  for (const [index, item] of s.entries()) {
    if (item.percent === percent) {
      return formatToHex(item.color);
    }
    if (percent > item.percent) continue;
    const oldItem = s[index - 1];
    if (!gradient) {
      return formatToHex(oldItem.color);
    }
    return generateGradients({
      startColor: formatToHex(oldItem.color),
      endColor: formatToHex(item.color),
      size: item.percent - oldItem.percent - 1
    }, percent - oldItem.percent - 1);
  }
  return undefined;
}
function generateGradients(g, index) {
  const {
    startColor,
    endColor,
    size
  } = g;
  const sA = startColor.split('');
  const eA = endColor.split('');
  const rC = [parseInt(`${sA[1]}${sA[2]}`, 16), parseInt(`${eA[1]}${eA[2]}`, 16)];
  const gC = [parseInt(`${sA[3]}${sA[4]}`, 16), parseInt(`${eA[3]}${eA[4]}`, 16)];
  const bC = [parseInt(`${sA[5]}${sA[6]}`, 16), parseInt(`${eA[5]}${eA[6]}`, 16)];
  const aC = [parseInt(`${sA[7]}${sA[8]}`, 16), parseInt(`${eA[7]}${eA[8]}`, 16)];
  const rStep = (rC[0] - rC[1]) / (size + 1);
  const gStep = (gC[0] - gC[1]) / (size + 1);
  const bStep = (bC[0] - bC[1]) / (size + 1);
  const aStep = (aC[0] - aC[1]) / (size + 1);
  function tHex(i) {
    const rS = Math.round(rC[0] - rStep * (i + 1)).toString(16);
    const gS = Math.round(gC[0] - gStep * (i + 1)).toString(16);
    const bS = Math.round(bC[0] - bStep * (i + 1)).toString(16);
    const h = `${padTwo(rS)}${padTwo(gS)}${padTwo(bS)}`;
    const t = Math.floor(aStep * (i + 1) + aC[1]).toString(16);
    return toHex.Hex(`#${h}`, t);
  }
  function padTwo(s) {
    if (s.length === 1) {
      return `0${s}`;
    }
    if (s.length === 0) {
      return '00';
    }
    return s;
  }
  if (typeof index === 'undefined') {
    const gradientColorArr = [startColor];
    for (let i = 0; i < size; i += 1) {
      gradientColorArr.push(tHex(i));
    }
    return gradientColorArr;
  }
  return tHex(index);
}
// Resolve the colour type contained within `ColorType` to Hex
function formatToHex(color) {
  color = color.trim().toLowerCase();
  // Hex
  if (REG_S.hex.test(color)) {
    return toHex.Hex(color, undefined);
  }
  // Hsl or Hsla
  if (REG_S.hslA.test(color)) {
    return toHex.Hex(toHex.HslA(color), undefined);
  }
  // Rgb or Rgba
  if (REG_S.rgbA.test(color)) {
    return toHex.Hex(toHex.RgbA(color), undefined);
  }
  // Semi Design Tokens
  if (REG_S.semiDesignTokens.test(color)) {
    if (SEMI_DESIGN_TOKENS.ALONG.indexOf(color) !== -1) {
      return toHex.SemiDesignToken(color);
    }
    if (SEMI_DESIGN_TOKENS.SEQUENCE.indexOf(color) !== -1) {
      return toHex.SemiDesignToken(`${color}-5`);
    }
    return toHex.SemiDesignToken(`${color}`);
  }
  return undefined;
}
const toHex = {
  Hex(color, transparency) {
    color = color.replace('#', '');
    if (color.length === 8) return `#${color}`;
    if (color.length === 6) return `#${color}${transparency || 'ff'}`;
    if (color.length === 3) {
      color = color.split('').map(c => c + c).join('');
    }
    return `#${color}${transparency || 'ff'}`;
  },
  SemiDesignToken(color) {
    // ! Only produces effects when used, the conditions for running need to occur after the real DOM is rendered
    if (typeof window === 'undefined') {
      return undefined;
    }
    const variable = getComputedStyle(document.body).getPropertyValue(`--semi-${color}`);
    if (variable === '') return undefined;
    const rgba = `rgba(${variable}, 1)`;
    return toHex.RgbA(rgba);
  },
  HslA(color) {
    const hsla = REG_S.hslA.exec(color);
    const h = parseInt(hsla[2]);
    const s = parseInt(hsla[3]) / 100;
    const l = parseInt(hsla[4]) / 100;
    const a = hsla[5];
    const c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs(h / 60 % 2 - 1)),
      m = l - c / 2;
    let r = 0,
      g = 0,
      b = 0;
    if (0 <= h && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (60 <= h && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (120 <= h && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (180 <= h && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (240 <= h && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else if (300 <= h && h < 360) {
      r = c;
      g = 0;
      b = x;
    }
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);
    return toHex.utils.pAL(r, g, b, a);
  },
  RgbA(color) {
    const rgba = REG_S.rgbA.exec(color);
    const r = parseInt(rgba[2], 10).toString(16),
      g = parseInt(rgba[3], 10).toString(16),
      b = parseInt(rgba[4], 10).toString(16),
      a = rgba[5];
    return toHex.utils.pAL(r, g, b, a);
  },
  utils: {
    pAL(r, g, b, a) {
      if (r.length == 1) r = '0' + r;
      if (g.length == 1) g = '0' + g;
      if (b.length == 1) b = '0' + b;
      if (typeof a !== 'undefined') {
        a = Math.round(parseInt(a) * 255).toString(16);
        if (a.length == 1) a = '0' + a;
        return '#' + r + g + b + a;
      }
      return '#' + r + g + b;
    }
  }
};
const REG_S = {
  hex: /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/,
  hslA: /(hsl)a?\(\s*?(\d+),?\s*?(\d+)%,?\s*?(\d+)%,?\s*?\/?(\s*?[\d.]+)?\s*?\)/,
  rgbA: /(rgb)a?\(\s*?(\d+),?\s*?(\d+),?\s*?(\d+),?\s*?\/?(\s*?[\d.]+)?\s*?\)/,
  semiDesignTokens: /(\w+)?-?(\w+)-?(\d)?/
};
// From src/components/palette.js
const SEMI_DESIGN_TOKENS = {
  // No sequence
  ALONG: ["black", "white"],
  // Sequence: 0-9
  SEQUENCE: ["amber", "blue", "cyan", "green", "grey", "indigo", "light-blue", "light-green", "lime", "orange", "pink", "purple", "red", "teal", "violet", "yellow"]
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/progress/index.js
var progress_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





// import '@douyinfe/semi-foundation/lib/es/progress/progress.css';


const progress_prefixCls = progress_constants_cssClasses.PREFIX;
class Progress extends react.Component {
  constructor(props) {
    super(props);
    this._mounted = true;
    this._mounted = true;
    this.state = {
      percentNumber: this.props.percent // Specially used for animation of numbers
    };
  }

  componentDidUpdate(prevProps) {
    if (isNaN(this.props.percent) || isNaN(prevProps.percent)) {
      throw new Error('[Semi Progress]:percent can not be NaN');
      return;
    }
    if (prevProps.percent !== this.props.percent) {
      if (!this.props.motion) {
        this.setState({
          percentNumber: this.props.percent
        });
        return;
      }
      if (this.animation && this.animation.destroy) {
        this.animation.destroy();
      }
      this.animation = new Animation({
        from: {
          value: prevProps.percent
        },
        to: {
          value: this.props.percent
        }
      }, {
        // easing: 'cubic-bezier(0, .68, .3, 1)'
        easing: 'linear',
        duration: 300
      });
      this.animation.on('frame', props => {
        // prevent setState while component is unmounted but this timer is called
        if (this._mounted === false) {
          return;
        }
        // let percentNumber = Number.isInteger(props.value) ? props.value : Math.floor(props.value * 100) / 100;
        const percentNumber = parseInt(props.value);
        this.setState({
          percentNumber
        });
      });
      this.animation.on('rest', () => {
        // prevent setState while component is unmounted but this timer is called
        if (this._mounted === false) {
          return;
        }
        this.setState({
          percentNumber: this.props.percent
        });
      });
      this.animation.start();
    }
  }
  componentWillUnmount() {
    this.animation && this.animation.destroy();
    this._mounted = false;
  }
  renderCircleProgress() {
    const _a = this.props,
      {
        strokeLinecap,
        style,
        className,
        strokeWidth,
        format,
        size,
        stroke,
        strokeGradient,
        showInfo,
        percent,
        orbitStroke,
        id
      } = _a,
      rest = progress_rest(_a, ["strokeLinecap", "style", "className", "strokeWidth", "format", "size", "stroke", "strokeGradient", "showInfo", "percent", "orbitStroke", "id"]);
    const ariaLabel = this.props['aria-label'];
    const ariaLabelledBy = this.props['aria-labelledby'];
    const ariaValueText = this.props['aria-valuetext'];
    const {
      percentNumber
    } = this.state;
    const classNames = {
      wrapper: classnames_default()(`${progress_prefixCls}-circle`, className),
      svg: classnames_default()(`${progress_prefixCls}-circle-ring`),
      circle: classnames_default()(`${progress_prefixCls}-circle-ring-inner`)
    };
    const perc = this.calcPercent(percent);
    const percNumber = this.calcPercent(percentNumber);
    let width;
    if (this.props.width) {
      width = this.props.width;
    } else {
      size === progress_constants_strings.DEFAULT_SIZE ? width = 72 : width = 24;
    }
    // parse stroke & generate gradients
    const _stroke = this.selectStroke(stroke, percent, strokeGradient);
    // cx, cy is circle center
    const cy = width / 2;
    const cx = width / 2;
    const radius = (width - strokeWidth) / 2; // radius
    const circumference = radius * 2 * Math.PI;
    const strokeDashoffset = (1 - perc / 100) * circumference; // Offset
    const strokeDasharray = `${circumference} ${circumference}`;
    const text = format(percNumber);
    return /*#__PURE__*/react.createElement("div", Object.assign({
      id: id,
      className: classNames.wrapper,
      style: style,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": percNumber,
      "aria-labelledby": ariaLabelledBy,
      "aria-label": ariaLabel,
      "aria-valuetext": ariaValueText
    }, getDataAttr(rest)), /*#__PURE__*/react.createElement("svg", {
      key: size,
      className: classNames.svg,
      height: width,
      width: width,
      "aria-hidden": true
    }, /*#__PURE__*/react.createElement("circle", {
      strokeDashoffset: 0,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      strokeLinecap: strokeLinecap,
      fill: "transparent",
      stroke: orbitStroke,
      r: radius,
      cx: cx,
      cy: cy,
      "aria-hidden": true
    }), /*#__PURE__*/react.createElement("circle", {
      className: classNames.circle,
      strokeDashoffset: strokeDashoffset,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      strokeLinecap: strokeLinecap,
      fill: "transparent",
      stroke: _stroke,
      r: radius,
      cx: cx,
      cy: cy,
      "aria-hidden": true
    })), showInfo && size !== 'small' ? /*#__PURE__*/react.createElement("span", {
      className: `${progress_prefixCls}-circle-text`
    }, text) : null);
  }
  calcPercent(percent) {
    let perc;
    if (percent > 100) {
      perc = 100;
    } else if (percent < 0) {
      perc = 0;
    } else {
      perc = percent;
    }
    return perc;
  }
  selectStroke(stroke, percent, strokeGradient) {
    if (typeof stroke === 'string') {
      return stroke;
    }
    const color = generateColor(stroke, percent, strokeGradient);
    if (typeof color !== 'undefined') {
      return color;
    }
    return progress_constants_strings.STROKE_DEFAULT;
  }
  renderLineProgress() {
    const _a = this.props,
      {
        className,
        style,
        stroke,
        strokeGradient,
        direction,
        format,
        showInfo,
        size,
        percent,
        orbitStroke,
        id
      } = _a,
      rest = progress_rest(_a, ["className", "style", "stroke", "strokeGradient", "direction", "format", "showInfo", "size", "percent", "orbitStroke", "id"]);
    const ariaLabel = this.props['aria-label'];
    const ariaLabelledBy = this.props['aria-labelledby'];
    const ariaValueText = this.props['aria-valuetext'];
    const {
      percentNumber
    } = this.state;
    const progressWrapperCls = classnames_default()(progress_prefixCls, className, {
      [`${progress_prefixCls}-horizontal`]: direction === progress_constants_strings.DEFAULT_DIRECTION,
      [`${progress_prefixCls}-vertical`]: direction !== progress_constants_strings.DEFAULT_DIRECTION,
      [`${progress_prefixCls}-large`]: size === 'large'
    });
    const progressTrackCls = classnames_default()({
      [`${progress_prefixCls}-track`]: true
    });
    const innerCls = classnames_default()(`${progress_prefixCls}-track-inner`);
    const perc = this.calcPercent(percent);
    const percNumber = this.calcPercent(percentNumber);
    // parse stroke & generate gradients
    const _stroke = this.selectStroke(stroke, percent, strokeGradient);
    const innerStyle = {
      background: _stroke
    };
    if (direction === progress_constants_strings.DEFAULT_DIRECTION) {
      innerStyle.width = `${perc}%`;
    } else {
      innerStyle.height = `${perc}%`;
    }
    const text = format(percNumber);
    return /*#__PURE__*/react.createElement("div", Object.assign({
      id: id,
      className: progressWrapperCls,
      style: style,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": perc,
      "aria-labelledby": ariaLabelledBy,
      "aria-label": ariaLabel,
      "aria-valuetext": ariaValueText
    }, getDataAttr(rest)), /*#__PURE__*/react.createElement("div", {
      className: progressTrackCls,
      style: orbitStroke ? {
        backgroundColor: orbitStroke
      } : {},
      "aria-hidden": true
    }, /*#__PURE__*/react.createElement("div", {
      className: innerCls,
      style: innerStyle,
      "aria-hidden": true
    })), showInfo ? /*#__PURE__*/react.createElement("div", {
      className: `${progress_prefixCls}-line-text`
    }, text) : null);
  }
  render() {
    const {
      type
    } = this.props;
    if (type === 'line') {
      return this.renderLineProgress();
    } else {
      return this.renderCircleProgress();
    }
  }
}
Progress.propTypes = {
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  'aria-valuetext': (prop_types_default()).string,
  className: (prop_types_default()).string,
  direction: prop_types_default().oneOf(progress_constants_strings.directions),
  format: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).node]),
  id: (prop_types_default()).string,
  motion: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func, (prop_types_default()).object]),
  orbitStroke: (prop_types_default()).string,
  percent: (prop_types_default()).number,
  scale: (prop_types_default()).number,
  showInfo: (prop_types_default()).bool,
  size: prop_types_default().oneOf(progress_constants_strings.sizes),
  stroke: prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().arrayOf(prop_types_default().shape({
    percent: (prop_types_default()).number,
    color: (prop_types_default()).string
  }))]),
  strokeGradient: (prop_types_default()).bool,
  strokeLinecap: prop_types_default().oneOf(progress_constants_strings.strokeLineCap),
  strokeWidth: (prop_types_default()).number,
  style: (prop_types_default()).object,
  type: prop_types_default().oneOf(progress_constants_strings.types),
  width: (prop_types_default()).number
};
Progress.defaultProps = {
  className: '',
  direction: progress_constants_strings.DEFAULT_DIRECTION,
  format: text => `${text}%`,
  motion: true,
  orbitStroke: 'var(--semi-color-fill-0)',
  percent: 0,
  showInfo: false,
  size: progress_constants_strings.DEFAULT_SIZE,
  stroke: progress_constants_strings.STROKE_DEFAULT,
  strokeGradient: false,
  strokeLinecap: progress_constants_strings.DEFAULT_LINECAP,
  strokeWidth: 4,
  style: {},
  type: progress_constants_strings.DEFAULT_TYPE
};
/* harmony default export */ var progress = (Progress);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/upload/fileCard.js














const fileCard_prefixCls = upload_constants_cssClasses.PREFIX;
const ErrorSvg = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    focusable: false,
    "aria-hidden": true,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "7.99992",
    cy: "7.99992",
    r: "6.66667",
    fill: "white"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3332 8.00008C15.3332 12.0502 12.0499 15.3334 7.99984 15.3334C3.94975 15.3334 0.666504 12.0502 0.666504 8.00008C0.666504 3.94999 3.94975 0.666748 7.99984 0.666748C12.0499 0.666748 15.3332 3.94999 15.3332 8.00008ZM8.99984 11.6667C8.99984 11.1145 8.55212 10.6667 7.99984 10.6667C7.44755 10.6667 6.99984 11.1145 6.99984 11.6667C6.99984 12.219 7.44755 12.6667 7.99984 12.6667C8.55212 12.6667 8.99984 12.219 8.99984 11.6667ZM7.99984 3.33341C7.27573 3.33341 6.7003 3.94171 6.74046 4.66469L6.94437 8.33495C6.97549 8.89513 7.4388 9.33341 7.99984 9.33341C8.56087 9.33341 9.02419 8.89513 9.05531 8.33495L9.25921 4.66469C9.29938 3.94171 8.72394 3.33341 7.99984 3.33341Z",
    fill: "#F93920"
  }));
};
const ReplaceSvg = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    focusable: false,
    "aria-hidden": true,
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "14",
    fill: "#16161A",
    fillOpacity: "0.6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9 10.25V18.25L10.25 13.25H17.875V11.75C17.875 11.4739 17.6511 11.25 17.375 11.25H14L12.75 9.75H9.5C9.22386 9.75 9 9.97386 9 10.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18 18.25L19 13.25H10.2031L9 18.25H18Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
const DirectorySvg = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    focusable: false,
    "aria-hidden": true,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M6 17V7.58824C6 7.26336 6.26863 7 6.6 7H10.5L12 8.76471H16.05C16.3814 8.76471 16.65 9.02806 16.65 9.35294V11.1176H7.5L6 17ZM6 17L7.44375 11.1176H18L16.8 17L6 17Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
class FileCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fallbackPreview: false
    };
    this.foundation = new fileCardFoundation(this.adapter);
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      updateFallbackPreview: fallbackPreview => this.setState({
        fallbackPreview
      })
    });
  }
  transSize(size) {
    if (typeof size === 'number') {
      return getFileSize(size);
    }
    return size;
  }
  renderValidateMessage() {
    const {
      status,
      validateMessage
    } = this.props;
    let content = null;
    switch (true) {
      case typeof validateMessage === 'string' && status === upload_constants_strings.FILE_STATUS_VALIDATING:
        content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(spin, {
          size: "small",
          wrapperClassName: `${fileCard_prefixCls}-file-card-icon-loading`
        }), validateMessage);
        break;
      case typeof validateMessage === 'string':
        content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(IconAlertCircle, {
          className: `${fileCard_prefixCls}-file-card-icon-error`
        }), validateMessage);
        break;
      case reactUtils_isElement(validateMessage):
        content = validateMessage;
        break;
      default:
        break;
    }
    return content;
  }
  renderPicValidateMsg() {
    const {
      status,
      validateMessage
    } = this.props;
    let icon = null;
    switch (true) {
      case validateMessage && status === upload_constants_strings.FILE_STATUS_VALIDATING:
        icon = /*#__PURE__*/react.createElement(spin, {
          size: "small",
          wrapperClassName: `${fileCard_prefixCls}-picture-file-card-icon-loading`
        });
        break;
      case validateMessage && (status === upload_constants_strings.FILE_STATUS_VALID_FAIL || status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL):
        icon = /*#__PURE__*/react.createElement("div", {
          className: `${fileCard_prefixCls}-picture-file-card-icon-error`
        }, /*#__PURE__*/react.createElement(ErrorSvg, null));
        break;
      default:
        break;
    }
    return icon ? /*#__PURE__*/react.createElement(Tooltip, {
      content: validateMessage,
      trigger: "hover",
      position: "bottom"
    }, icon) : null;
  }
  renderPic(locale) {
    const {
      fallbackPreview
    } = this.state;
    const {
      url,
      percent,
      status,
      disabled,
      style,
      onPreviewClick,
      showPicInfo,
      renderPicInfo,
      renderPicPreviewIcon,
      renderThumbnail,
      name,
      index,
      picHeight,
      picWidth
    } = this.props;
    const showProgress = status === upload_constants_strings.FILE_STATUS_UPLOADING && percent !== 100;
    const showRetry = status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL && this.props.showRetry;
    const showReplace = status === upload_constants_strings.FILE_STATUS_SUCCESS && this.props.showReplace;
    const showPreview = status === upload_constants_strings.FILE_STATUS_SUCCESS && !this.props.showReplace;
    const filePicCardCls = classnames_default()({
      [`${fileCard_prefixCls}-picture-file-card`]: true,
      [`${fileCard_prefixCls}-picture-file-card-preview-fallback`]: fallbackPreview,
      [`${fileCard_prefixCls}-picture-file-card-disabled`]: disabled,
      [`${fileCard_prefixCls}-picture-file-card-show-pointer`]: typeof onPreviewClick !== 'undefined',
      [`${fileCard_prefixCls}-picture-file-card-error`]: status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL,
      [`${fileCard_prefixCls}-picture-file-card-uploading`]: showProgress
    });
    const retry = /*#__PURE__*/react.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: `${fileCard_prefixCls}-picture-file-card-retry`,
      onClick: e => this.onRetry(e)
    }, /*#__PURE__*/react.createElement(IconRefresh, {
      className: `${fileCard_prefixCls}-picture-file-card-icon-retry`
    }));
    const replace = /*#__PURE__*/react.createElement(Tooltip, {
      trigger: "hover",
      position: "top",
      content: locale.replace,
      showArrow: false,
      spacing: 4
    }, /*#__PURE__*/react.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: `${fileCard_prefixCls}-picture-file-card-replace`,
      onClick: e => this.onReplace(e)
    }, /*#__PURE__*/react.createElement(ReplaceSvg, {
      className: `${fileCard_prefixCls}-picture-file-card-icon-replace`
    })));
    const preview = /*#__PURE__*/react.createElement("div", {
      className: `${fileCard_prefixCls}-picture-file-card-preview`
    }, typeof renderPicPreviewIcon === 'function' ? renderPicPreviewIcon(this.props) : null);
    const close = /*#__PURE__*/react.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: `${fileCard_prefixCls}-picture-file-card-close`,
      onClick: e => this.onRemove(e)
    }, /*#__PURE__*/react.createElement(IconClear, {
      className: `${fileCard_prefixCls}-picture-file-card-icon-close`
    }));
    const picInfo = typeof renderPicInfo === 'function' ? renderPicInfo(this.props) : /*#__PURE__*/react.createElement("div", {
      className: `${fileCard_prefixCls}-picture-file-card-pic-info`
    }, index + 1);
    let imgStyle = {};
    let itemStyle = style ? Object.assign({}, style) : {};
    if (picHeight) {
      itemStyle.height = picHeight;
      imgStyle.height = picHeight;
    }
    if (picWidth) {
      itemStyle.width = picWidth;
      imgStyle.width = picWidth;
    }
    const defaultThumbTail = !fallbackPreview ? /*#__PURE__*/react.createElement("img", {
      src: url,
      alt: name,
      onError: error => this.foundation.handleImageError(error),
      style: imgStyle
    }) : /*#__PURE__*/react.createElement(IconFile, {
      size: "large"
    });
    const thumbnail = typeof renderThumbnail === 'function' ? renderThumbnail(this.props) : defaultThumbTail;
    return /*#__PURE__*/react.createElement("div", {
      role: "listitem",
      className: filePicCardCls,
      style: itemStyle,
      onClick: onPreviewClick
    }, thumbnail, showProgress ? /*#__PURE__*/react.createElement(progress, {
      percent: percent,
      type: "circle",
      size: "small",
      orbitStroke: '#FFF',
      "aria-label": "uploading file progress"
    }) : null, showRetry ? retry : null, showReplace && replace, showPreview && preview, showPicInfo && picInfo, !disabled && close, this.renderPicValidateMsg());
  }
  renderFile(locale) {
    const {
      name,
      size,
      percent,
      url,
      showRetry: propsShowRetry,
      showReplace: propsShowReplace,
      preview,
      previewFile,
      status,
      style,
      onPreviewClick,
      renderFileOperation
    } = this.props;
    const {
      fallbackPreview
    } = this.state;
    const fileCardCls = classnames_default()({
      [`${fileCard_prefixCls}-file-card`]: true,
      [`${fileCard_prefixCls}-file-card-fail`]: status === upload_constants_strings.FILE_STATUS_VALID_FAIL || status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL,
      [`${fileCard_prefixCls}-file-card-show-pointer`]: typeof onPreviewClick !== 'undefined'
    });
    const previewCls = classnames_default()({
      [`${fileCard_prefixCls}-file-card-preview`]: true,
      [`${fileCard_prefixCls}-file-card-preview-placeholder`]: !preview || previewFile || fallbackPreview
    });
    const infoCls = `${fileCard_prefixCls}-file-card-info`;
    const closeCls = `${fileCard_prefixCls}-file-card-close`;
    const replaceCls = `${fileCard_prefixCls}-file-card-replace`;
    const showProgress = !(percent === 100 || typeof percent === 'undefined') && status === upload_constants_strings.FILE_STATUS_UPLOADING;
    // only show retry when upload fail & showRetry is true, no need to show during validate fail
    const showRetry = status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL && propsShowRetry;
    const showReplace = status === upload_constants_strings.FILE_STATUS_SUCCESS && propsShowReplace;
    const fileSize = this.transSize(size);
    let previewContent = preview && !fallbackPreview ? /*#__PURE__*/react.createElement("img", {
      src: url,
      alt: name,
      onError: error => this.foundation.handleImageError(error)
    }) : /*#__PURE__*/react.createElement(IconFile, {
      size: "large"
    });
    if (previewFile) {
      previewContent = previewFile(this.props);
    }
    const operation = typeof renderFileOperation === 'function' ? renderFileOperation(this.props) : /*#__PURE__*/react.createElement(es_button, {
      onClick: e => this.onRemove(e),
      type: "tertiary",
      icon: /*#__PURE__*/react.createElement(IconClose, null),
      theme: "borderless",
      size: "small",
      className: closeCls
    });
    return /*#__PURE__*/react.createElement("div", {
      role: "listitem",
      className: fileCardCls,
      style: style,
      onClick: onPreviewClick
    }, /*#__PURE__*/react.createElement("div", {
      className: previewCls
    }, previewContent), /*#__PURE__*/react.createElement("div", {
      className: `${infoCls}-main`
    }, /*#__PURE__*/react.createElement("div", {
      className: `${infoCls}-main-text`
    }, /*#__PURE__*/react.createElement("span", {
      className: `${infoCls}-name`
    }, name), /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("span", {
      className: `${infoCls}-size`
    }, fileSize), showReplace && /*#__PURE__*/react.createElement(Tooltip, {
      trigger: "hover",
      position: "top",
      showArrow: false,
      content: locale.replace
    }, /*#__PURE__*/react.createElement(es_button, {
      onClick: e => this.onReplace(e),
      type: "tertiary",
      theme: "borderless",
      size: "small",
      icon: /*#__PURE__*/react.createElement(DirectorySvg, null),
      className: replaceCls
    })))), showProgress ? /*#__PURE__*/react.createElement(progress, {
      percent: percent,
      style: {
        width: '100%'
      },
      "aria-label": "uploading file progress"
    }) : null, /*#__PURE__*/react.createElement("div", {
      className: `${infoCls}-main-control`
    }, /*#__PURE__*/react.createElement("span", {
      className: `${infoCls}-validate-message`
    }, this.renderValidateMessage()), showRetry ? /*#__PURE__*/react.createElement("span", {
      role: "button",
      tabIndex: 0,
      className: `${infoCls}-retry`,
      onClick: e => this.onRetry(e)
    }, locale.retry) : null)), operation);
  }
  onRemove(e) {
    e.stopPropagation();
    this.props.onRemove();
  }
  onReplace(e) {
    e.stopPropagation();
    this.props.onReplace();
  }
  onRetry(e) {
    e.stopPropagation();
    this.props.onRetry();
  }
  render() {
    const {
      listType
    } = this.props;
    if (listType === upload_constants_strings.FILE_LIST_PIC) {
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Upload"
      }, locale => this.renderPic(locale));
    }
    if (listType === upload_constants_strings.FILE_LIST_DEFAULT) {
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Upload"
      }, locale => this.renderFile(locale));
    }
    return null;
  }
}
FileCard.propTypes = {
  className: (prop_types_default()).string,
  disabled: (prop_types_default()).bool,
  listType: (prop_types_default()).string,
  name: (prop_types_default()).string,
  onPreviewClick: (prop_types_default()).func,
  onRemove: (prop_types_default()).func,
  onReplace: (prop_types_default()).func,
  onRetry: (prop_types_default()).func,
  percent: (prop_types_default()).number,
  preview: (prop_types_default()).bool,
  previewFile: (prop_types_default()).func,
  picWidth: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  picHeight: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  showReplace: (prop_types_default()).bool,
  showRetry: (prop_types_default()).bool,
  size: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  status: (prop_types_default()).string,
  style: (prop_types_default()).object,
  url: (prop_types_default()).string,
  validateMessage: (prop_types_default()).node,
  index: (prop_types_default()).number
};
FileCard.defaultProps = {
  listType: upload_constants_strings.FILE_LIST_DEFAULT,
  name: '',
  onRemove: () => undefined,
  onRetry: () => undefined,
  preview: false,
  size: ''
};
/* harmony default export */ var fileCard = (FileCard);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconUpload.js


function IconUpload_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8395 8.05827C17.1837 5.16226 14.5944 3 11.5 3C7.91015 3 5 5.91015 5 9.5C5 10.0204 5.06115 10.5264 5.17665 11.0114C2.84229 11.1772 1 13.1234 1 15.5C1 17.9853 3.01469 20 5.49995 20H17C20.3137 20 23 17.3137 23 14C23 10.9712 20.7558 8.46659 17.8395 8.05827ZM12.3201 8.26674C12.1347 8.11222 11.8653 8.11222 11.6799 8.26674L6.53047 12.5579C6.35084 12.7076 6.45669 13 6.69051 13H10V17.5C10 17.7761 10.2239 18 10.5 18H13.5C13.7761 18 14 17.7761 14 17.5V13H17.3095C17.5433 13 17.6492 12.7076 17.4695 12.5579L12.3201 8.26674Z",
    fill: "currentColor"
  }));
}
const IconUpload_IconComponent = (0,Icon/* convertIcon */.A)(IconUpload_SvgComponent, 'upload');
/* harmony default export */ var IconUpload = (IconUpload_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/upload/index.js


var upload_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









// import '@douyinfe/semi-foundation/lib/es/upload/upload.css';
const upload_prefixCls = upload_constants_cssClasses.PREFIX;
class Upload extends BaseComponent {
  constructor(props) {
    super(props);
    this.inputRef = null;
    this.replaceInputRef = null;
    this.onClick = () => {
      const {
        inputRef,
        props
      } = this;
      const {
        onOpenFileDialog
      } = props;
      const isDisabled = Boolean(this.props.disabled);
      if (isDisabled || !inputRef || !inputRef.current) {
        return;
      }
      inputRef.current.click();
      if (onOpenFileDialog && typeof onOpenFileDialog) {
        onOpenFileDialog();
      }
    };
    this.onChange = e => {
      const {
        files
      } = e.target;
      this.foundation.handleChange(files);
    };
    this.replace = index => {
      this.setState({
        replaceIdx: index
      }, () => {
        this.replaceInputRef.current.click();
      });
    };
    this.onReplaceChange = e => {
      const {
        files
      } = e.target;
      this.foundation.handleReplaceChange(files);
    };
    this.clear = () => {
      this.foundation.handleClear();
    };
    this.remove = fileItem => {
      this.foundation.handleRemove(fileItem);
    };
    /**
     * ref method
     * insert files at index
     * @param files Array<CustomFile>
     * @param index number
     * @returns
     */
    this.insert = (files, index) => {
      return this.foundation.insertFileToList(files, index);
    };
    /**
     * ref method
     * manual upload by user
     */
    this.upload = () => {
      this.foundation.manualUpload();
    };
    /**
     * ref method
     * manual open file select dialog
     */
    this.openFileDialog = () => {
      this.onClick();
    };
    this.renderFile = (file, index, locale) => {
      const {
        name,
        status,
        validateMessage,
        _sizeInvalid,
        uid
      } = file;
      const {
        previewFile,
        listType,
        itemStyle,
        showPicInfo,
        renderPicInfo,
        renderPicPreviewIcon,
        renderFileOperation,
        renderFileItem,
        renderThumbnail,
        disabled,
        onPreviewClick,
        picWidth,
        picHeight
      } = this.props;
      const onRemove = () => this.remove(file);
      const onRetry = () => {
        this.foundation.retry(file);
      };
      const onReplace = () => {
        this.replace(index);
      };
      const fileCardProps = Object.assign(Object.assign(Object.assign({}, pick_default()(this.props, ['showRetry', 'showReplace', ''])), file), {
        previewFile,
        listType,
        onRemove,
        onRetry,
        index,
        key: uid || `${name}${index}`,
        style: itemStyle,
        disabled,
        showPicInfo,
        renderPicInfo,
        renderPicPreviewIcon,
        renderFileOperation,
        renderThumbnail,
        onReplace,
        onPreviewClick: typeof onPreviewClick !== 'undefined' ? () => this.foundation.handlePreviewClick(file) : undefined,
        picWidth,
        picHeight
      });
      if (status === upload_constants_strings.FILE_STATUS_UPLOAD_FAIL && !validateMessage) {
        fileCardProps.validateMessage = locale.fail;
      }
      if (_sizeInvalid && !validateMessage) {
        fileCardProps.validateMessage = locale.illegalSize;
      }
      if (typeof renderFileItem === 'undefined') {
        return /*#__PURE__*/react.createElement(fileCard, Object.assign({}, fileCardProps));
      } else {
        return renderFileItem(fileCardProps);
      }
    };
    this.renderFileList = () => {
      const {
        listType
      } = this.props;
      if (listType === upload_constants_strings.FILE_LIST_PIC) {
        return this.renderFileListPic();
      }
      if (listType === upload_constants_strings.FILE_LIST_DEFAULT) {
        return this.renderFileListDefault();
      }
      return null;
    };
    this.renderFileListPic = () => {
      const {
        showUploadList,
        limit,
        disabled,
        children,
        draggable,
        hotSpotLocation,
        picHeight,
        picWidth
      } = this.props;
      const {
        fileList: stateFileList,
        dragAreaStatus
      } = this.state;
      const fileList = this.props.fileList || stateFileList;
      const showAddTriggerInList = limit ? limit > fileList.length : true;
      const dragAreaBaseCls = `${upload_prefixCls}-drag-area`;
      const uploadAddCls = classnames_default()(`${upload_prefixCls}-add`, {
        [`${upload_prefixCls}-picture-add`]: true,
        [`${upload_prefixCls}-picture-add-disabled`]: disabled
      });
      const fileListCls = classnames_default()(`${upload_prefixCls}-file-list`, {
        [`${upload_prefixCls}-picture-file-list`]: true
      });
      const dragAreaCls = classnames_default()({
        [`${dragAreaBaseCls}-legal`]: dragAreaStatus === upload_constants_strings.DRAG_AREA_LEGAL,
        [`${dragAreaBaseCls}-illegal`]: dragAreaStatus === upload_constants_strings.DRAG_AREA_ILLEGAL
      });
      const mainCls = `${upload_prefixCls}-file-list-main`;
      const addContentProps = {
        role: 'button',
        className: uploadAddCls,
        onClick: this.onClick,
        style: {
          height: picHeight,
          width: picWidth
        }
      };
      const containerProps = {
        className: fileListCls
      };
      const draggableProps = {
        onDrop: this.onDrop,
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDragEnter: this.onDragEnter
      };
      if (draggable) {
        Object.assign(addContentProps, draggableProps, {
          className: classnames_default()(uploadAddCls, dragAreaCls)
        });
      }
      const addContent = /*#__PURE__*/react.createElement("div", Object.assign({}, addContentProps, {
        "x-semi-prop": "children"
      }), children);
      if (!showUploadList || !fileList.length) {
        if (showAddTriggerInList) {
          return addContent;
        }
        return null;
      }
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Upload"
      }, locale => /*#__PURE__*/react.createElement("div", Object.assign({}, containerProps), /*#__PURE__*/react.createElement("div", {
        className: mainCls,
        role: "list",
        "aria-label": "picture list"
      }, showAddTriggerInList && hotSpotLocation === 'start' ? addContent : null, fileList.map((file, index) => this.renderFile(file, index, locale)), showAddTriggerInList && hotSpotLocation === 'end' ? addContent : null)));
    };
    this.renderFileListDefault = () => {
      const {
        showUploadList,
        limit,
        disabled
      } = this.props;
      const {
        fileList: stateFileList
      } = this.state;
      const fileList = this.props.fileList || stateFileList;
      const fileListCls = classnames_default()(`${upload_prefixCls}-file-list`);
      const titleCls = `${upload_prefixCls}-file-list-title`;
      const mainCls = `${upload_prefixCls}-file-list-main`;
      const showTitle = limit !== 1 && fileList.length;
      const showClear = this.props.showClear && !disabled;
      const containerProps = {
        className: fileListCls
      };
      if (!showUploadList || !fileList.length) {
        return null;
      }
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Upload"
      }, locale => /*#__PURE__*/react.createElement("div", Object.assign({}, containerProps), showTitle ? /*#__PURE__*/react.createElement("div", {
        className: titleCls
      }, /*#__PURE__*/react.createElement("span", {
        className: `${titleCls}-choosen`
      }, locale.selectedFiles), showClear ? /*#__PURE__*/react.createElement("span", {
        role: "button",
        tabIndex: 0,
        onClick: this.clear,
        className: `${titleCls}-clear`
      }, locale.clear) : null) : null, /*#__PURE__*/react.createElement("div", {
        className: mainCls,
        role: "list",
        "aria-label": "file list"
      }, fileList.map((file, index) => this.renderFile(file, index, locale)))));
    };
    this.onDrop = e => {
      this.foundation.handleDrop(e);
    };
    this.onDragOver = e => {
      // When a drag element moves within the target element
      this.foundation.handleDragOver(e);
    };
    this.onDragLeave = e => {
      this.foundation.handleDragLeave(e);
    };
    this.onDragEnter = e => {
      this.foundation.handleDragEnter(e);
    };
    this.renderAddContent = () => {
      const {
        draggable,
        children,
        listType,
        disabled
      } = this.props;
      const uploadAddCls = classnames_default()(`${upload_prefixCls}-add`);
      if (listType === upload_constants_strings.FILE_LIST_PIC) {
        return null;
      }
      if (draggable) {
        return this.renderDragArea();
      }
      return /*#__PURE__*/react.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-disabled": disabled,
        className: uploadAddCls,
        onClick: this.onClick
      }, children);
    };
    this.renderDragArea = () => {
      const {
        dragAreaStatus
      } = this.state;
      const {
        children,
        dragIcon,
        dragMainText,
        dragSubText,
        disabled
      } = this.props;
      const dragAreaBaseCls = `${upload_prefixCls}-drag-area`;
      const dragAreaCls = classnames_default()(dragAreaBaseCls, {
        [`${dragAreaBaseCls}-legal`]: dragAreaStatus === upload_constants_strings.DRAG_AREA_LEGAL,
        [`${dragAreaBaseCls}-illegal`]: dragAreaStatus === upload_constants_strings.DRAG_AREA_ILLEGAL,
        [`${dragAreaBaseCls}-custom`]: children
      });
      return /*#__PURE__*/react.createElement(LocaleConsumer, {
        componentName: "Upload"
      }, locale => /*#__PURE__*/react.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-disabled": disabled,
        className: dragAreaCls,
        onDrop: this.onDrop,
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDragEnter: this.onDragEnter,
        onClick: this.onClick
      }, children ? children : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        className: `${dragAreaBaseCls}-icon`,
        "x-semi-prop": "dragIcon"
      }, dragIcon || /*#__PURE__*/react.createElement(IconUpload, {
        size: "extra-large"
      })), /*#__PURE__*/react.createElement("div", {
        className: `${dragAreaBaseCls}-text`
      }, /*#__PURE__*/react.createElement("div", {
        className: `${dragAreaBaseCls}-main-text`,
        "x-semi-prop": "dragMainText"
      }, dragMainText || locale.mainText), /*#__PURE__*/react.createElement("div", {
        className: `${dragAreaBaseCls}-sub-text`,
        "x-semi-prop": "dragSubText"
      }, dragSubText), /*#__PURE__*/react.createElement("div", {
        className: `${dragAreaBaseCls}-tips`
      }, dragAreaStatus === upload_constants_strings.DRAG_AREA_LEGAL && /*#__PURE__*/react.createElement("span", {
        className: `${dragAreaBaseCls}-tips-legal`
      }, locale.legalTips), dragAreaStatus === upload_constants_strings.DRAG_AREA_ILLEGAL && /*#__PURE__*/react.createElement("span", {
        className: `${dragAreaBaseCls}-tips-illegal`
      }, locale.illegalTips))))));
    };
    this.state = {
      fileList: props.defaultFileList || [],
      replaceIdx: -1,
      inputKey: Math.random(),
      replaceInputKey: Math.random(),
      // Status of the drag zone
      dragAreaStatus: 'default',
      localUrls: []
    };
    this.foundation = new upload_foundation(this.adapter);
    this.inputRef = /*#__PURE__*/react.createRef();
    this.replaceInputRef = /*#__PURE__*/react.createRef();
  }
  /**
   * Notes:
   *   The input parameter and return value here do not declare the type, otherwise tsc may report an error in form/fields.tsx when wrap after withField
   *   `The types of the parameters "props" and "nextProps" are incompatible.
         The attribute "action" is missing in the type "Readonly<any>", but it is required in the type "UploadProps".`
   *   which seems to be a bug, remove props type declare here
   */
  static getDerivedStateFromProps(props) {
    const {
      fileList
    } = props;
    if ('fileList' in props) {
      return {
        fileList: fileList || []
      };
    }
    return null;
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      notifyFileSelect: files => this.props.onFileChange(files),
      notifyError: (error, fileInstance, fileList, xhr) => this.props.onError(error, fileInstance, fileList, xhr),
      notifySuccess: (responseBody, file, fileList) => this.props.onSuccess(responseBody, file, fileList),
      notifyProgress: (percent, file, fileList) => this.props.onProgress(percent, file, fileList),
      notifyRemove: (file, fileList, fileItem) => this.props.onRemove(file, fileList, fileItem),
      notifySizeError: (file, fileList) => this.props.onSizeError(file, fileList),
      notifyExceed: fileList => this.props.onExceed(fileList),
      updateFileList: (fileList, cb) => {
        if (typeof cb === 'function') {
          this.setState({
            fileList
          }, cb);
        } else {
          this.setState({
            fileList
          });
        }
      },
      notifyBeforeUpload: _ref => {
        let {
          file,
          fileList
        } = _ref;
        return this.props.beforeUpload({
          file,
          fileList
        });
      },
      notifyAfterUpload: _ref2 => {
        let {
          response,
          file,
          fileList
        } = _ref2;
        return this.props.afterUpload({
          response,
          file,
          fileList
        });
      },
      resetInput: () => {
        this.setState(prevState => ({
          inputKey: Math.random()
        }));
      },
      resetReplaceInput: () => {
        this.setState(prevState => ({
          replaceInputKey: Math.random()
        }));
      },
      isMac: () => {
        return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      },
      registerPastingHandler: cb => {
        document.body.addEventListener('keydown', cb);
        this.pastingCb = cb;
      },
      unRegisterPastingHandler: () => {
        if (this.pastingCb) {
          document.body.removeEventListener('keydown', this.pastingCb);
        }
      },
      notifyPastingError: error => this.props.onPastingError(error),
      updateDragAreaStatus: dragAreaStatus => this.setState({
        dragAreaStatus
      }),
      notifyChange: _ref3 => {
        let {
          currentFile,
          fileList
        } = _ref3;
        return this.props.onChange({
          currentFile,
          fileList
        });
      },
      updateLocalUrls: urls => this.setState({
        localUrls: urls
      }),
      notifyClear: () => this.props.onClear(),
      notifyPreviewClick: file => this.props.onPreviewClick(file),
      notifyDrop: (e, files, fileList) => this.props.onDrop(e, files, fileList),
      notifyAcceptInvalid: invalidFiles => this.props.onAcceptInvalid(invalidFiles),
      notifyBeforeRemove: (file, fileList) => this.props.beforeRemove(file, fileList),
      notifyBeforeClear: fileList => this.props.beforeClear(fileList)
    });
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  render() {
    const _a = this.props,
      {
        style,
        className,
        multiple,
        accept,
        disabled,
        children,
        capture,
        listType,
        prompt,
        promptPosition,
        draggable,
        validateMessage,
        validateStatus,
        directory
      } = _a,
      rest = upload_rest(_a, ["style", "className", "multiple", "accept", "disabled", "children", "capture", "listType", "prompt", "promptPosition", "draggable", "validateMessage", "validateStatus", "directory"]);
    const uploadCls = classnames_default()(upload_prefixCls, {
      [`${upload_prefixCls}-picture`]: listType === upload_constants_strings.FILE_LIST_PIC,
      [`${upload_prefixCls}-disabled`]: disabled,
      [`${upload_prefixCls}-default`]: validateStatus === 'default',
      [`${upload_prefixCls}-error`]: validateStatus === 'error',
      [`${upload_prefixCls}-warning`]: validateStatus === 'warning',
      [`${upload_prefixCls}-success`]: validateStatus === 'success'
    }, className);
    const inputCls = classnames_default()(`${upload_prefixCls}-hidden-input`);
    const inputReplaceCls = classnames_default()(`${upload_prefixCls}-hidden-input-replace`);
    const promptCls = classnames_default()(`${upload_prefixCls}-prompt`);
    const validateMsgCls = classnames_default()(`${upload_prefixCls}-validate-message`);
    const dirProps = directory ? {
      directory: 'directory',
      webkitdirectory: 'webkitdirectory'
    } : {};
    return /*#__PURE__*/react.createElement("div", Object.assign({
      className: uploadCls,
      style: style,
      "x-prompt-pos": promptPosition
    }, this.getDataAttr(rest)), /*#__PURE__*/react.createElement("input", Object.assign({
      key: this.state.inputKey,
      capture: capture,
      multiple: multiple,
      accept: accept,
      onChange: this.onChange,
      type: "file",
      autoComplete: "off",
      tabIndex: -1,
      className: inputCls,
      ref: this.inputRef
    }, dirProps)), /*#__PURE__*/react.createElement("input", {
      key: this.state.replaceInputKey,
      multiple: false,
      accept: accept,
      onChange: this.onReplaceChange,
      type: "file",
      autoComplete: "off",
      tabIndex: -1,
      className: inputReplaceCls,
      ref: this.replaceInputRef
    }), this.renderAddContent(), prompt ? /*#__PURE__*/react.createElement("div", {
      className: promptCls,
      "x-semi-prop": "prompt"
    }, prompt) : null, validateMessage ? /*#__PURE__*/react.createElement("div", {
      className: validateMsgCls,
      "x-semi-prop": "validateMessage"
    }, validateMessage) : null, this.renderFileList());
  }
}
Upload.propTypes = {
  accept: (prop_types_default()).string,
  action: (prop_types_default()).string.isRequired,
  addOnPasting: (prop_types_default()).bool,
  afterUpload: (prop_types_default()).func,
  beforeClear: (prop_types_default()).func,
  beforeRemove: (prop_types_default()).func,
  beforeUpload: (prop_types_default()).func,
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  customRequest: (prop_types_default()).func,
  data: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).func]),
  defaultFileList: (prop_types_default()).array,
  directory: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  dragIcon: (prop_types_default()).node,
  dragMainText: (prop_types_default()).node,
  dragSubText: (prop_types_default()).node,
  draggable: (prop_types_default()).bool,
  fileList: (prop_types_default()).array,
  fileName: (prop_types_default()).string,
  headers: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).func]),
  hotSpotLocation: prop_types_default().oneOf(['start', 'end']),
  itemStyle: (prop_types_default()).object,
  limit: (prop_types_default()).number,
  listType: prop_types_default().oneOf(upload_constants_strings.LIST_TYPE),
  maxSize: (prop_types_default()).number,
  minSize: (prop_types_default()).number,
  multiple: (prop_types_default()).bool,
  name: (prop_types_default()).string,
  onAcceptInvalid: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onClear: (prop_types_default()).func,
  onDrop: (prop_types_default()).func,
  onError: (prop_types_default()).func,
  onExceed: (prop_types_default()).func,
  onFileChange: (prop_types_default()).func,
  onOpenFileDialog: (prop_types_default()).func,
  onPreviewClick: (prop_types_default()).func,
  onProgress: (prop_types_default()).func,
  onRemove: (prop_types_default()).func,
  onRetry: (prop_types_default()).func,
  onSizeError: (prop_types_default()).func,
  onSuccess: (prop_types_default()).func,
  onPastingError: (prop_types_default()).func,
  previewFile: (prop_types_default()).func,
  prompt: (prop_types_default()).node,
  promptPosition: prop_types_default().oneOf(upload_constants_strings.PROMPT_POSITION),
  picWidth: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  picHeight: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  renderFileItem: (prop_types_default()).func,
  renderPicPreviewIcon: (prop_types_default()).func,
  renderFileOperation: (prop_types_default()).func,
  renderPicInfo: (prop_types_default()).func,
  renderThumbnail: (prop_types_default()).func,
  showClear: (prop_types_default()).bool,
  showPicInfo: (prop_types_default()).bool,
  showReplace: (prop_types_default()).bool,
  showRetry: (prop_types_default()).bool,
  showUploadList: (prop_types_default()).bool,
  style: (prop_types_default()).object,
  timeout: (prop_types_default()).number,
  transformFile: (prop_types_default()).func,
  uploadTrigger: prop_types_default().oneOf(upload_constants_strings.UPLOAD_TRIGGER),
  validateMessage: (prop_types_default()).node,
  validateStatus: prop_types_default().oneOf(upload_constants_strings.VALIDATE_STATUS),
  withCredentials: (prop_types_default()).bool
};
Upload.defaultProps = {
  defaultFileList: [],
  disabled: false,
  listType: 'list',
  hotSpotLocation: 'end',
  multiple: false,
  onAcceptInvalid: (noop_default()),
  onChange: (noop_default()),
  beforeRemove: () => true,
  beforeClear: () => true,
  onClear: (noop_default()),
  onDrop: (noop_default()),
  onError: (noop_default()),
  onExceed: (noop_default()),
  onFileChange: (noop_default()),
  onOpenFileDialog: (noop_default()),
  onProgress: (noop_default()),
  onRemove: (noop_default()),
  onRetry: (noop_default()),
  onSizeError: (noop_default()),
  onSuccess: (noop_default()),
  onPastingError: (noop_default()),
  promptPosition: 'right',
  showClear: true,
  showPicInfo: false,
  showReplace: false,
  showRetry: true,
  showUploadList: true,
  uploadTrigger: 'auto',
  withCredentials: false
};
Upload.FileCard = fileCard;
/* harmony default export */ var upload = (Upload);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/field.js

// Basic component


















const FormInput = hoc_withField(es_input, {
  maintainCursor: true
});
const FormInputNumber = hoc_withField(inputNumber, {
  maintainCursor: true
});
const FormTextArea = hoc_withField(input_textarea, {
  maintainCursor: true
});
const FormSelect = hoc_withField(es_select);
// Select after withField is a new Component, without the Option attribute, it needs to be manually assigned once
FormSelect.Option = es_select.Option;
FormSelect.OptGroup = es_select.OptGroup;
const FormCheckboxGroup = hoc_withField(checkboxGroup);
const FormCheckbox = hoc_withField(checkbox_checkbox, {
  valueKey: 'checked',
  valuePath: 'target.checked',
  shouldInject: false
});
const FormRadioGroup = hoc_withField(radioGroup, {
  valuePath: 'target.value'
});
const FormRadio = hoc_withField(radio_radio, {
  valueKey: 'checked',
  valuePath: 'target.checked',
  shouldInject: false
});
const FormDatePicker = hoc_withField(datePicker);
const FormSwitch = hoc_withField(es_switch, {
  valueKey: 'checked'
});
const FormSlider = hoc_withField(Slider);
const FormTimePicker = hoc_withField(LocaleTimePicker);
const FormTreeSelect = hoc_withField(treeSelect);
const FormCascader = hoc_withField(cascader);
const FormRating = hoc_withField(Rating);
const FormAutoComplete = hoc_withField(autoComplete, {
  valueKey: 'value',
  onKeyChangeFnName: 'onChange'
});
const FormUpload = hoc_withField(upload, {
  valueKey: 'fileList',
  valuePath: 'fileList',
  onKeyChangeFnName: 'onChange'
});
const FormTagInput = hoc_withField(tagInput);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/form/baseForm.js

var baseForm_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















// import '@douyinfe/semi-foundation/lib/es/form/form.css';

const baseForm_prefix = form_constants_cssClasses.PREFIX;
class Form extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      formId: ''
    };
    warning(Boolean(props.component && props.render), '[Semi Form] You should not use <Form component> and <Form render> in ths same time; <Form render> will be ignored');
    warning(props.component && props.children && !isEmptyChildren(props.children), '[Semi Form] You should not use <Form component> and <Form>{children}</Form> in ths same time; <Form>{children}</Form> will be ignored');
    warning(props.render && props.children && !isEmptyChildren(props.children), '[Semi Form] You should not use <Form render> and <Form>{children}</Form> in ths same time; <Form>{children}</Form> will be ignored');
    this.submit = this.submit.bind(this);
    this.reset = this.reset.bind(this);
    this.foundation = new FormFoundation(this.adapter);
    this.formApi = this.foundation.getFormApi();
    if (this.props.getFormApi) {
      this.props.getFormApi(this.formApi);
    }
  }
  componentDidMount() {
    this.foundation.init();
  }
  componentWillUnmount() {
    this.foundation.destroy();
  }
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      cloneDeep: cloneDeep,
      notifySubmit: (values, e) => {
        this.props.onSubmit(values, e);
      },
      notifySubmitFail: (errors, values, e) => {
        this.props.onSubmitFail(errors, values, e);
      },
      forceUpdate: callback => {
        this.forceUpdate(callback);
      },
      notifyChange: formState => {
        this.props.onChange(formState);
      },
      notifyValueChange: (values, changedValues) => {
        this.props.onValueChange(values, changedValues);
      },
      notifyReset: () => {
        this.props.onReset();
      },
      initFormId: () => {
        this.setState({
          formId: getUuidv4()
        });
      },
      getInitValues: () => this.props.initValues,
      getFormProps: keys => {
        if (typeof keys === 'undefined') {
          return this.props;
        } else if (typeof keys === 'string') {
          return this.props[keys];
        } else {
          const props = {};
          keys.forEach(key => {
            props[key] = this.props[key];
          });
          return props;
        }
      },
      getAllErrorDOM: () => {
        const {
          formId
        } = this.state;
        const {
          id
        } = this.props;
        const xId = id ? id : formId;
        return document.querySelectorAll(`form[x-form-id="${xId}"] .${form_constants_cssClasses.PREFIX}-field-error-message`);
      },
      getFieldDOM: field => document.querySelector(`.${form_constants_cssClasses.PREFIX}-field[x-field-id="${field}"]`),
      getFieldErrorDOM: field => {
        const {
          formId
        } = this.state;
        const {
          id
        } = this.props;
        const xId = id ? id : formId;
        let selector = `form[x-form-id="${xId}"] .${form_constants_cssClasses.PREFIX}-field[x-field-id="${field}"] .${form_constants_cssClasses.PREFIX}-field-error-message`;
        return document.querySelector(selector);
      }
    });
  }
  get content() {
    const {
      children,
      component,
      render
    } = this.props;
    const formState = this.foundation.getFormState();
    const props = {
      formState,
      formApi: this.foundation.getFormApi(),
      values: formState.values
    };
    if (component) {
      return /*#__PURE__*/react.createElement(component, props);
    }
    if (render) {
      return render(props);
    }
    if (typeof children === 'function') {
      return children(props);
    }
    return children;
  }
  submit(e) {
    e.preventDefault();
    this.foundation.submit(e);
  }
  reset(e) {
    e.preventDefault();
    this.foundation.reset();
  }
  render() {
    const needClone = false;
    const formState = this.foundation.getFormState(needClone);
    const updaterApi = this.foundation.getModifyFormStateApi();
    const {
      formId
    } = this.state;
    const _a = this.props,
      {
        children,
        getFormApi,
        onChange,
        onSubmit,
        onSubmitFail,
        onValueChange,
        component,
        render,
        validateFields,
        initValues,
        layout,
        style,
        className,
        labelPosition,
        labelWidth,
        labelAlign,
        labelCol,
        wrapperCol,
        allowEmpty,
        autoScrollToError,
        showValidateIcon,
        stopValidateWithError,
        extraTextPosition,
        id,
        trigger
      } = _a,
      rest = baseForm_rest(_a, ["children", "getFormApi", "onChange", "onSubmit", "onSubmitFail", "onValueChange", "component", "render", "validateFields", "initValues", "layout", "style", "className", "labelPosition", "labelWidth", "labelAlign", "labelCol", "wrapperCol", "allowEmpty", "autoScrollToError", "showValidateIcon", "stopValidateWithError", "extraTextPosition", "id", "trigger"]);
    const formCls = classnames_default()(baseForm_prefix, className, {
      [baseForm_prefix + '-vertical']: layout === 'vertical',
      [baseForm_prefix + '-horizontal']: layout === 'horizontal'
    });
    const shouldAppendRow = wrapperCol && labelCol;
    const formContent = /*#__PURE__*/react.createElement("form", Object.assign({
      style: style
    }, rest, {
      onReset: this.reset,
      onSubmit: this.submit,
      className: formCls,
      "x-form-id": id ? id : formId
    }), this.content);
    const withRowForm = /*#__PURE__*/react.createElement(row, null, formContent);
    return /*#__PURE__*/react.createElement(FormUpdaterContext.Provider, {
      value: updaterApi
    }, /*#__PURE__*/react.createElement(FormApiContext.Provider, {
      value: this.formApi
    }, /*#__PURE__*/react.createElement(FormStateContext.Provider, {
      value: formState
    }, shouldAppendRow ? withRowForm : formContent)));
  }
}
Form.propTypes = {
  'aria-label': (prop_types_default()).string,
  onSubmit: (prop_types_default()).func,
  onSubmitFail: (prop_types_default()).func,
  /* Triggered from update, including field mount/unmount/value change/blur/verification status change/error prompt change, input parameter is formState, currentField */
  onChange: (prop_types_default()).func,
  onReset: (prop_types_default()).func,
  // Triggered when the value of the form is updated, only when the value of the subfield changes. The entry parameter is formState.values
  onValueChange: (prop_types_default()).func,
  autoScrollToError: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  allowEmpty: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  component: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  disabled: (prop_types_default()).bool,
  extraTextPosition: prop_types_default().oneOf(form_constants_strings.EXTRA_POS),
  getFormApi: (prop_types_default()).func,
  initValues: (prop_types_default()).object,
  validateFields: (prop_types_default()).func,
  layout: prop_types_default().oneOf(form_constants_strings.LAYOUT),
  labelPosition: prop_types_default().oneOf(form_constants_strings.LABEL_POS),
  labelWidth: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  labelAlign: prop_types_default().oneOf(form_constants_strings.LABEL_ALIGN),
  labelCol: (prop_types_default()).object,
  render: (prop_types_default()).func,
  style: (prop_types_default()).object,
  showValidateIcon: (prop_types_default()).bool,
  stopValidateWithError: (prop_types_default()).bool,
  id: (prop_types_default()).string,
  wrapperCol: (prop_types_default()).object,
  trigger: prop_types_default().oneOfType([prop_types_default().oneOf(['blur', 'change', 'custom', 'mount']), prop_types_default().arrayOf(prop_types_default().oneOf(['blur', 'change', 'custom', 'mount']))])
};
Form.defaultProps = {
  onChange: (noop_default()),
  onSubmitFail: (noop_default()),
  onSubmit: (noop_default()),
  onReset: (noop_default()),
  onValueChange: (noop_default()),
  layout: 'vertical',
  labelPosition: 'top',
  allowEmpty: false,
  autoScrollToError: false,
  showValidateIcon: true
};
Form.Input = FormInput;
Form.TextArea = FormTextArea;
Form.InputNumber = FormInputNumber;
Form.Select = FormSelect;
Form.Checkbox = FormCheckbox;
Form.CheckboxGroup = FormCheckboxGroup;
Form.Radio = FormRadio;
Form.RadioGroup = FormRadioGroup;
Form.DatePicker = FormDatePicker;
Form.TimePicker = FormTimePicker;
Form.Switch = FormSwitch;
Form.Slider = FormSlider;
Form.TreeSelect = FormTreeSelect;
Form.Cascader = FormCascader;
Form.Rating = FormRating;
Form.AutoComplete = FormAutoComplete;
Form.Upload = FormUpload;
Form.TagInput = FormTagInput;
Form.Slot = slot;
Form.ErrorMessage = ErrorMessage;
Form.InputGroup = group;
Form.Label = Label;
Form.Section = Section;
/* harmony default export */ var baseForm = (Form);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/constants.js

const image_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-image`
};
const image_constants_numbers = {
  DEFAULT_Z_INDEX: 1070
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconUploadError.js


function IconUploadError_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9998 12.0001C22.9998 18.0753 18.0749 23.0001 11.9998 23.0001C5.92463 23.0001 0.999756 18.0753 0.999756 12.0001C0.999756 5.92499 5.92463 1.00012 11.9998 1.00012C18.0749 1.00012 22.9998 5.92499 22.9998 12.0001ZM13.4998 17.5C13.4998 16.6718 12.8282 16.0001 11.9998 16.0001C11.1713 16.0001 10.4998 16.6718 10.4998 17.5C10.4998 18.3285 11.1713 19 11.9998 19C12.8282 19 13.4998 18.3285 13.4998 17.5ZM11.9998 5.00011C10.9136 5.00011 10.0505 5.91257 10.1107 6.99704L10.4166 12.5024C10.4632 13.3427 11.1582 14.0001 11.9998 14.0001C12.8413 14.0001 13.5363 13.3427 13.583 12.5024L13.8888 6.99704C13.9491 5.91257 13.0859 5.00011 11.9998 5.00011Z",
    fill: "currentColor"
  }));
}
const IconUploadError_IconComponent = (0,Icon/* convertIcon */.A)(IconUploadError_SvgComponent, 'upload_error');
/* harmony default export */ var IconUploadError = (IconUploadError_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconArrowLeft.js


function IconArrowLeft_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 12.8284 22.3284 13.5 21.5 13.5L6.12132 13.5L12.5607 19.9393C13.1464 20.5251 13.1464 21.4749 12.5607 22.0607C11.9749 22.6464 11.0251 22.6464 10.4393 22.0607L1.43934 13.0607C0.853554 12.4749 0.853554 11.5251 1.43934 10.9393L10.4393 1.93934C11.0251 1.35355 11.9749 1.35355 12.5607 1.93934C13.1464 2.52513 13.1464 3.47487 12.5607 4.06066L6.12132 10.5L21.5 10.5C22.3284 10.5 23 11.1716 23 12Z",
    fill: "currentColor"
  }));
}
const IconArrowLeft_IconComponent = (0,Icon/* convertIcon */.A)(IconArrowLeft_SvgComponent, 'arrow_left');
/* harmony default export */ var IconArrowLeft = (IconArrowLeft_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconArrowRight.js


function IconArrowRight_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 11.1716 1.67157 10.5 2.5 10.5L17.8787 10.5L11.4393 4.06066C10.8536 3.47487 10.8536 2.52513 11.4393 1.93934C12.0251 1.35355 12.9749 1.35355 13.5607 1.93934L22.5607 10.9393C23.1464 11.5251 23.1464 12.4749 22.5607 13.0607L13.5607 22.0607C12.9749 22.6464 12.0251 22.6464 11.4393 22.0607C10.8536 21.4749 10.8536 20.5251 11.4393 19.9393L17.8787 13.5L2.5 13.5C1.67157 13.5 1 12.8284 1 12Z",
    fill: "currentColor"
  }));
}
const IconArrowRight_IconComponent = (0,Icon/* convertIcon */.A)(IconArrowRight_SvgComponent, 'arrow_right');
/* harmony default export */ var IconArrowRight = (IconArrowRight_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/previewContext.js

const PreviewContext = /*#__PURE__*/(0,react.createContext)({});
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/previewHeader.js





const previewHeader_prefixCls = `${image_constants_cssClasses.PREFIX}-preview-header`;
const Header = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    onClose,
    titleStyle,
    className,
    renderHeader,
    closable
  } = _ref;
  return /*#__PURE__*/react.createElement(PreviewContext.Consumer, null, _ref2 => {
    let {
      currentIndex,
      titles
    } = _ref2;
    let title;
    if (titles && typeof currentIndex === "number") {
      title = titles[currentIndex];
    }
    return /*#__PURE__*/react.createElement("section", {
      ref: ref,
      className: classnames_default()(previewHeader_prefixCls, className)
    }, /*#__PURE__*/react.createElement("section", {
      className: `${previewHeader_prefixCls}-title`,
      style: titleStyle
    }, renderHeader ? renderHeader(title) : title), closable && /*#__PURE__*/react.createElement("section", {
      className: `${previewHeader_prefixCls}-close`,
      onMouseUp: onClose
    }, /*#__PURE__*/react.createElement(IconClose, null)));
  });
});
/* harmony default export */ var previewHeader = (Header);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconMinus.js


function IconMinus_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M2 12C2 11.1716 2.67157 10.5 3.5 10.5H20.5C21.3284 10.5 22 11.1716 22 12C22 12.8284 21.3284 13.5 20.5 13.5H3.5C2.67157 13.5 2 12.8284 2 12Z",
    fill: "currentColor"
  }));
}
const IconMinus_IconComponent = (0,Icon/* convertIcon */.A)(IconMinus_SvgComponent, 'minus');
/* harmony default export */ var IconMinus = (IconMinus_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconPlus.js


function IconPlus_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M20.5 13.5C21.3284 13.5 22 12.8284 22 12C22 11.1716 21.3284 10.5 20.5 10.5L13.5 10.5L13.5 3.5C13.5 2.67157 12.8284 2 12 2C11.1716 2 10.5 2.67157 10.5 3.5L10.5 10.5L3.5 10.5C2.67157 10.5 2 11.1716 2 12C2 12.8284 2.67157 13.5 3.5 13.5L10.5 13.5V20.5C10.5 21.3284 11.1716 22 12 22C12.8284 22 13.5 21.3284 13.5 20.5V13.5L20.5 13.5Z",
    fill: "currentColor"
  }));
}
const IconPlus_IconComponent = (0,Icon/* convertIcon */.A)(IconPlus_SvgComponent, 'plus');
/* harmony default export */ var IconPlus = (IconPlus_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconRealSizeStroked.js


function IconRealSizeStroked_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6ZM21 6L3 6V18H21V6ZM5 9C5 8.44772 5.44772 8 6 8H7.5C8.05228 8 8.5 8.44772 8.5 9V15C8.5 15.5523 8.05228 16 7.5 16C6.94772 16 6.5 15.5523 6.5 15V10H6C5.44772 10 5 9.55228 5 9ZM16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10H16.5V15C16.5 15.5523 16.9477 16 17.5 16C18.0523 16 18.5 15.5523 18.5 15V9C18.5 8.44772 18.0523 8 17.5 8H16ZM13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15Z",
    fill: "currentColor"
  }));
}
const IconRealSizeStroked_IconComponent = (0,Icon/* convertIcon */.A)(IconRealSizeStroked_SvgComponent, 'real_size_stroked');
/* harmony default export */ var IconRealSizeStroked = (IconRealSizeStroked_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconWindowAdaptionStroked.js


function IconWindowAdaptionStroked_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55229 21.5523 10 21 10C20.4477 10 20 9.55229 20 9V4H15C14.4477 4 14 3.55229 14 3ZM10 21C10 21.5523 9.55229 22 9 22H3C2.44772 22 2 21.5523 2 21V15C2 14.4477 2.44772 14 3 14C3.55228 14 4 14.4477 4 15L4 20H9C9.55229 20 10 20.4477 10 21ZM2 9C2 9.55228 2.44772 10 3 10C3.55229 10 4 9.55228 4 9L4 4L9 4C9.55229 4 10 3.55228 10 3C10 2.44771 9.55229 2 9 2H3C2.44772 2 2 2.44772 2 3V9ZM21 14C21.5523 14 22 14.4477 22 15V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21C14 20.4477 14.4477 20 15 20H20V15C20 14.4477 20.4477 14 21 14ZM8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5V15.5C7.5 16.0523 7.94772 16.5 8.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V8.5C16.5 7.94772 16.0523 7.5 15.5 7.5H8.5ZM9.5 14.5V9.5H14.5V14.5H9.5Z",
    fill: "currentColor"
  }));
}
const IconWindowAdaptionStroked_IconComponent = (0,Icon/* convertIcon */.A)(IconWindowAdaptionStroked_SvgComponent, 'window_adaption_stroked');
/* harmony default export */ var IconWindowAdaptionStroked = (IconWindowAdaptionStroked_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconRotate.js


function IconRotate_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M14.2071 2.20711C14.5976 1.81658 14.5976 1.18342 14.2071 0.792893C13.8166 0.402369 13.1834 0.402369 12.7929 0.792893L10.2929 3.29289C9.90237 3.68342 9.90237 4.31658 10.2929 4.70711L12.7929 7.20711C13.1834 7.59763 13.8166 7.59763 14.2071 7.20711C14.5976 6.81658 14.5976 6.18342 14.2071 5.79289L13.4142 5H16C18.7614 5 21 7.23858 21 10V12C21 12.5523 21.4477 13 22 13C22.5523 13 23 12.5523 23 12V10C23 6.13401 19.866 3 16 3H13.4142L14.2071 2.20711Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M3 10C3 8.89543 3.89543 8 5 8H17C18.1046 8 19 8.89543 19 10V20C19 21.1046 18.1046 22 17 22H5C3.89543 22 3 21.1046 3 20V10Z",
    fill: "currentColor"
  }));
}
const IconRotate_IconComponent = (0,Icon/* convertIcon */.A)(IconRotate_SvgComponent, 'rotate');
/* harmony default export */ var IconRotate = (IconRotate_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconDownload.js


function IconDownload_SvgComponent(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8395 8.05827C17.1837 5.16226 14.5944 3 11.5 3C7.91015 3 5 5.91015 5 9.5C5 10.0204 5.06115 10.5264 5.17665 11.0114C2.84229 11.1772 1 13.1234 1 15.5C1 17.9853 3.01469 20 5.49995 20H17C20.3137 20 23 17.3137 23 14C23 10.9712 20.7558 8.46659 17.8395 8.05827ZM11.6799 17.7333C11.8653 17.8878 12.1347 17.8878 12.3201 17.7333L17.4695 13.4421C17.6492 13.2924 17.5433 13 17.3095 13H14V9.5C14 9.22386 13.7761 9 13.5 9H10.5C10.2239 9 10 9.22386 10 9.5V13H6.69051C6.45669 13 6.35084 13.2924 6.53047 13.4421L11.6799 17.7333Z",
    fill: "currentColor"
  }));
}
const IconDownload_IconComponent = (0,Icon/* convertIcon */.A)(IconDownload_SvgComponent, 'download');
/* harmony default export */ var IconDownload = (IconDownload_IconComponent);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/divider/constants.js

const divider_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}`
};
const divider_constants_strings = {
  LAYOUT: ['vertical', 'horizontal']
};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/divider/index.js
var divider_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



// import '@douyinfe/semi-foundation/lib/es/divider/divider.css';
const divider_prefixCls = divider_constants_cssClasses.PREFIX;
const Divider = props => {
  const {
      layout = 'horizontal',
      dashed,
      align = 'center',
      className,
      margin,
      style,
      children
    } = props,
    rest = divider_rest(props, ["layout", "dashed", "align", "className", "margin", "style", "children"]);
  const dividerClassNames = classnames_default()(`${divider_prefixCls}-divider`, className, {
    [`${divider_prefixCls}-divider-horizontal`]: layout === 'horizontal',
    [`${divider_prefixCls}-divider-vertical`]: layout === 'vertical',
    [`${divider_prefixCls}-divider-dashed`]: !!dashed,
    [`${divider_prefixCls}-divider-with-text`]: children && layout === 'horizontal',
    [`${divider_prefixCls}-divider-with-text-${align}`]: children && layout === 'horizontal'
  });
  let overrideDefaultStyle = {};
  if (margin !== undefined) {
    if (layout === 'vertical') {
      overrideDefaultStyle = {
        'marginLeft': margin,
        'marginRight': margin
      };
    } else if (layout === 'horizontal') {
      overrideDefaultStyle = {
        'marginTop': margin,
        'marginBottom': margin
      };
    }
  }
  return /*#__PURE__*/react.createElement("div", Object.assign({}, rest, {
    className: dividerClassNames,
    style: Object.assign(Object.assign({}, overrideDefaultStyle), style)
  }), children && layout === 'horizontal' ? typeof children === 'string' ? /*#__PURE__*/react.createElement("span", {
    className: `${divider_prefixCls}-divider_inner-text`,
    "x-semi-prop": "children"
  }, children) : children : null);
};
/* harmony default export */ var divider = (Divider);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/previewFooterFoundation.js

class PreviewFooterFoundation extends foundation {
  constructor() {
    super(...arguments);
    this.changeSliderValue = type => {
      const {
        zoom,
        step,
        min,
        max
      } = this.getProps();
      let newValue = type === "plus" ? zoom + step : zoom - step;
      if (newValue > max) {
        newValue = max;
      } else if (newValue < min) {
        newValue = min;
      }
      this.handleValueChange(newValue);
    };
    this.handleValueChange = value => {
      const {
        onZoomIn,
        onZoomOut,
        zoom
      } = this.getProps();
      if (value > zoom) {
        onZoomIn(Number((value / 100).toFixed(2)));
      } else {
        onZoomOut(Number((value / 100).toFixed(2)));
      }
    };
    this.handleRatioClick = () => {
      const {
        ratio,
        onAdjustRatio
      } = this.getProps();
      const type = ratio === "adaptation" ? "realSize" : "adaptation";
      onAdjustRatio(type);
    };
    this.handleRotate = direction => {
      const {
        onRotate
      } = this.getProps();
      onRotate && onRotate(direction);
    };
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/previewFooter.js












const previewFooter_prefixCls = image_constants_cssClasses.PREFIX;
const footerPrefixCls = `${image_constants_cssClasses.PREFIX}-preview-footer`;
class previewFooter_Footer extends BaseComponent {
  get adapter() {
    return Object.assign({}, super.adapter);
  }
  constructor(props) {
    super(props);
    this.changeSliderValue = type => {
      this.foundation.changeSliderValue(type);
    };
    this.handleMinusClick = () => {
      this.changeSliderValue("minus");
    };
    this.handlePlusClick = () => {
      this.changeSliderValue("plus");
    };
    this.handleRotateLeft = () => {
      this.foundation.handleRotate("left");
    };
    this.handleRotateRight = () => {
      this.foundation.handleRotate("right");
    };
    this.handleSlideChange = throttle_default()(value => {
      this.foundation.handleValueChange(value);
    }, 50);
    this.handleRatioClick = () => {
      this.foundation.handleRatioClick();
    };
    this.customRenderViewMenu = () => {
      const {
        min,
        max,
        step,
        curPage,
        totalNum,
        ratio,
        zoom,
        disabledPrev,
        disabledNext,
        disableDownload,
        onNext,
        onPrev,
        onDownload,
        renderPreviewMenu
      } = this.props;
      const props = {
        min,
        max,
        step,
        curPage,
        totalNum,
        ratio,
        zoom,
        disabledPrev,
        disabledNext,
        disableDownload,
        onNext,
        onPrev,
        onDownload,
        onRotateLeft: this.handleRotateLeft,
        onRotateRight: this.handleRotateRight,
        disabledZoomIn: zoom === max,
        disabledZoomOut: zoom === min,
        onRatioClick: this.handleRatioClick,
        onZoomIn: this.handlePlusClick,
        onZoomOut: this.handleMinusClick,
        menuItems: this.getMenu()
      };
      return renderPreviewMenu(props);
    };
    // According to showTooltip in props, decide whether to use Tooltip to pack a layer
    // 根据 props 中的 showTooltip 决定是否使用 Tooltip 包一层
    this.getFinalIconElement = (element, content, key) => {
      const {
        showTooltip,
        zIndex
      } = this.props;
      return showTooltip ? /*#__PURE__*/react.createElement(Tooltip, {
        content: content,
        key: `tooltip-${key}`,
        zIndex: zIndex + 1
      }, element) : element;
    };
    this.getLocalTextByKey = key => /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Image"
    }, locale => locale[key]);
    this.getIconChevronLeft = () => {
      const {
        disabledPrev,
        onPrev,
        prevTip
      } = this.props;
      const icon = /*#__PURE__*/react.createElement(IconChevronLeft/* default */.Z, {
        key: "chevron-left",
        size: "large",
        className: disabledPrev ? `${footerPrefixCls}-disabled` : "",
        onClick: !disabledPrev ? onPrev : undefined
      });
      const content = prevTip !== null && prevTip !== void 0 ? prevTip : this.getLocalTextByKey("prevTip");
      return this.getFinalIconElement(icon, content, 'chevron-left');
    };
    this.getIconChevronRight = () => {
      const {
        disabledNext,
        onNext,
        nextTip
      } = this.props;
      const icon = /*#__PURE__*/react.createElement(IconChevronRight, {
        key: "chevron-right",
        size: "large",
        className: disabledNext ? `${footerPrefixCls}-disabled` : "",
        onClick: !disabledNext ? onNext : undefined
      });
      const content = nextTip !== null && nextTip !== void 0 ? nextTip : this.getLocalTextByKey("nextTip");
      return this.getFinalIconElement(icon, content, 'chevron-right');
    };
    this.getIconMinus = () => {
      const {
        zoomOutTip,
        zoom,
        min
      } = this.props;
      const disabledZoomOut = zoom === min;
      const icon = /*#__PURE__*/react.createElement(IconMinus, {
        key: "minus",
        size: "large",
        onClick: !disabledZoomOut ? this.handleMinusClick : undefined,
        className: disabledZoomOut ? `${footerPrefixCls}-disabled` : ""
      });
      const content = zoomOutTip !== null && zoomOutTip !== void 0 ? zoomOutTip : this.getLocalTextByKey("zoomOutTip");
      return this.getFinalIconElement(icon, content, 'minus');
    };
    this.getIconPlus = () => {
      const {
        zoomInTip,
        zoom,
        max
      } = this.props;
      const disabledZoomIn = zoom === max;
      const icon = /*#__PURE__*/react.createElement(IconPlus, {
        key: "plus",
        size: "large",
        onClick: !disabledZoomIn ? this.handlePlusClick : undefined,
        className: disabledZoomIn ? `${footerPrefixCls}-disabled` : ""
      });
      const content = zoomInTip !== null && zoomInTip !== void 0 ? zoomInTip : this.getLocalTextByKey("zoomInTip");
      return this.getFinalIconElement(icon, content, 'plus');
    };
    this.getIconRatio = () => {
      const {
        ratio,
        originTip,
        adaptiveTip
      } = this.props;
      const props = {
        key: "ratio",
        size: "large",
        className: classnames_default()(`${footerPrefixCls}-gap`),
        onClick: this.handleRatioClick
      };
      const icon = ratio === "adaptation" ? /*#__PURE__*/react.createElement(IconRealSizeStroked, Object.assign({}, props)) : /*#__PURE__*/react.createElement(IconWindowAdaptionStroked, Object.assign({}, props));
      let content;
      if (ratio === "adaptation") {
        content = originTip !== null && originTip !== void 0 ? originTip : this.getLocalTextByKey("originTip");
      } else {
        content = adaptiveTip !== null && adaptiveTip !== void 0 ? adaptiveTip : this.getLocalTextByKey("adaptiveTip");
      }
      return this.getFinalIconElement(icon, content, 'ratio');
    };
    this.getIconRotate = () => {
      const {
        rotateTip
      } = this.props;
      const icon = /*#__PURE__*/react.createElement(IconRotate, {
        key: "rotate",
        size: "large",
        onClick: this.handleRotateLeft
      });
      const content = rotateTip !== null && rotateTip !== void 0 ? rotateTip : this.getLocalTextByKey("rotateTip");
      return this.getFinalIconElement(icon, content, 'rotate');
    };
    this.getIconDownload = () => {
      const {
        downloadTip,
        onDownload,
        disableDownload
      } = this.props;
      const icon = /*#__PURE__*/react.createElement(IconDownload, {
        key: 'download',
        size: "large",
        onClick: !disableDownload ? onDownload : undefined,
        className: classnames_default()(`${footerPrefixCls}-gap`, {
          [`${footerPrefixCls}-disabled`]: disableDownload
        })
      });
      const content = downloadTip !== null && downloadTip !== void 0 ? downloadTip : this.getLocalTextByKey("downloadTip");
      return this.getFinalIconElement(icon, content, 'download');
    };
    this.getNumberInfo = () => {
      const {
        curPage,
        totalNum
      } = this.props;
      return /*#__PURE__*/react.createElement("div", {
        className: `${footerPrefixCls}-page`,
        key: 'info'
      }, curPage, "/", totalNum);
    };
    this.getSlider = () => {
      const {
        zoom,
        min,
        max,
        step,
        showTooltip
      } = this.props;
      return /*#__PURE__*/react.createElement(Slider, {
        key: 'slider',
        value: zoom,
        min: min,
        max: max,
        step: step,
        tipFormatter: v => `${v}%`,
        tooltipVisible: showTooltip ? undefined : false,
        onChange: this.handleSlideChange
      });
    };
    this.getMenu = () => [this.getIconChevronLeft(), this.getNumberInfo(), this.getIconChevronRight(), this.getIconMinus(), this.getSlider(), this.getIconPlus(), this.getIconRatio(), this.getIconRotate(), this.getIconDownload()];
    this.getFooterMenu = () => {
      const menuItems = this.getMenu();
      menuItems.splice(3, 0, /*#__PURE__*/react.createElement(divider, {
        layout: "vertical",
        key: "divider-first"
      }));
      menuItems.splice(8, 0, /*#__PURE__*/react.createElement(divider, {
        layout: "vertical",
        key: "divider-second"
      }));
      return menuItems;
    };
    this.foundation = new PreviewFooterFoundation(this.adapter);
  }
  render() {
    const {
      className,
      renderPreviewMenu,
      forwardRef
    } = this.props;
    const menuCls = classnames_default()(footerPrefixCls, `${footerPrefixCls}-wrapper`, className, {
      [`${footerPrefixCls}-content`]: !Boolean(renderPreviewMenu)
    });
    return /*#__PURE__*/react.createElement("section", {
      className: menuCls,
      ref: forwardRef
    }, renderPreviewMenu ? this.customRenderViewMenu() : this.getFooterMenu());
  }
}
previewFooter_Footer.propTypes = {
  curPage: (prop_types_default()).number,
  totalNum: (prop_types_default()).number,
  disabledPrev: (prop_types_default()).bool,
  disabledNext: (prop_types_default()).bool,
  disableDownload: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  zoom: (prop_types_default()).number,
  ratio: (prop_types_default()).string,
  prevTip: (prop_types_default()).string,
  nextTip: (prop_types_default()).string,
  zoomInTip: (prop_types_default()).string,
  zoomOutTip: (prop_types_default()).string,
  rotateTip: (prop_types_default()).string,
  downloadTip: (prop_types_default()).string,
  adaptiveTip: (prop_types_default()).string,
  originTip: (prop_types_default()).string,
  showTooltip: (prop_types_default()).bool,
  onZoomIn: (prop_types_default()).func,
  onZoomOut: (prop_types_default()).func,
  onPrev: (prop_types_default()).func,
  onNext: (prop_types_default()).func,
  onAdjustRatio: (prop_types_default()).func,
  onRotateLeft: (prop_types_default()).func,
  onDownload: (prop_types_default()).func
};
previewFooter_Footer.defaultProps = {
  min: 10,
  max: 500,
  step: 10,
  showTooltip: false,
  disableDownload: false
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/previewImageFoundation.js

const DefaultDOMRect = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
  toJSON: () => ({})
};
class PreviewImageFoundation extends foundation {
  constructor(adapter) {
    var _this;
    super(Object.assign({}, adapter));
    _this = this;
    this.startMouseOffset = {
      x: 0,
      y: 0
    };
    this.originImageWidth = null;
    this.originImageHeight = null;
    this._isImageVertical = () => this.getProp("rotation") % 180 !== 0;
    this._getImageBounds = () => {
      const imageDOM = this._adapter.getImage();
      if (imageDOM) {
        return imageDOM.getBoundingClientRect();
      }
      return DefaultDOMRect;
    };
    this._getContainerBounds = () => {
      const containerDOM = this._adapter.getContainer();
      if (containerDOM) {
        return containerDOM.getBoundingClientRect();
      }
      return DefaultDOMRect;
    };
    this._getOffset = e => {
      const {
        left,
        top
      } = this._getImageBounds();
      return {
        x: e.clientX - left,
        y: e.clientY - top
      };
    };
    this.setLoading = loading => {
      this._adapter.setLoading(loading);
    };
    this.handleWindowResize = () => {
      if (this.originImageWidth && this.originImageHeight) {
        this.handleResizeImage();
      }
    };
    this.handleLoad = e => {
      if (e.target) {
        const {
          naturalWidth: w,
          naturalHeight: h
        } = e.target;
        this.originImageHeight = h;
        this.originImageWidth = w;
        this.setState({
          loading: false
        });
        // 图片初次加载，计算 zoom，zoom 改变不需要通过回调透出
        // When the image is loaded for the first time, zoom is calculated, and zoom changes do not need to be exposed through callbacks.
        this.handleResizeImage(false);
      }
      const {
        src,
        onLoad
      } = this.getProps();
      onLoad && onLoad(src);
    };
    this.handleError = e => {
      const {
        onError,
        src
      } = this.getProps();
      this.setState({
        loading: false
      });
      onError && onError(src);
    };
    this.handleResizeImage = function () {
      let notify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const horizontal = !_this._isImageVertical();
      const {
        currZoom
      } = _this.getStates();
      const imgWidth = horizontal ? _this.originImageWidth : _this.originImageHeight;
      const imgHeight = horizontal ? _this.originImageHeight : _this.originImageWidth;
      const {
        onZoom,
        setRatio,
        ratio
      } = _this.getProps();
      const containerDOM = _this._adapter.getContainer();
      if (containerDOM) {
        const {
          width: containerWidth,
          height: containerHeight
        } = _this._getContainerBounds();
        const reservedWidth = containerWidth - 80;
        const reservedHeight = containerHeight - 80;
        let _zoom = 1;
        if (imgWidth > reservedWidth || imgHeight > reservedHeight) {
          _zoom = Number(Math.min(reservedWidth / imgWidth, reservedHeight / imgHeight).toFixed(2));
        }
        if (currZoom === _zoom) {
          _this.calculatePreviewImage(_zoom, null);
        } else {
          onZoom(_zoom, notify);
        }
      }
    };
    this.handleRatioChange = () => {
      if (this.originImageWidth && this.originImageHeight) {
        const {
          currZoom
        } = this.getStates();
        const {
          ratio,
          onZoom
        } = this.getProps();
        let _zoom;
        if (ratio === 'adaptation') {
          const horizontal = !this._isImageVertical();
          const imgWidth = horizontal ? this.originImageWidth : this.originImageHeight;
          const imgHeight = horizontal ? this.originImageHeight : this.originImageWidth;
          const {
            width: containerWidth,
            height: containerHeight
          } = this._getContainerBounds();
          const reservedWidth = containerWidth - 80;
          const reservedHeight = containerHeight - 80;
          _zoom = Number(Math.min(reservedWidth / imgWidth, reservedHeight / imgHeight).toFixed(2));
        } else {
          _zoom = 1;
        }
        if (currZoom !== _zoom) {
          onZoom(_zoom);
        }
      }
    };
    this.handleRightClickImage = e => {
      const {
        disableDownload
      } = this.getProps();
      if (disableDownload) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      } else {
        return true;
      }
    };
    this.calcCanDragDirection = () => {
      const {
        width,
        height
      } = this.getStates();
      const {
        rotation
      } = this.getProps();
      const {
        width: containerWidth,
        height: containerHeight
      } = this._getContainerBounds();
      let canDragHorizontal = width > containerWidth;
      let canDragVertical = height > containerHeight;
      if (this._isImageVertical()) {
        canDragHorizontal = height > containerWidth;
        canDragVertical = width > containerHeight;
      }
      return {
        canDragVertical,
        canDragHorizontal
      };
    };
    this.calculatePreviewImage = (newZoom, e) => {
      const imageDOM = this._adapter.getImage();
      const {
        canDragVertical,
        canDragHorizontal
      } = this.calcCanDragDirection();
      const canDrag = canDragVertical || canDragHorizontal;
      const {
        width: containerWidth,
        height: containerHeight
      } = this._getContainerBounds();
      const newWidth = Math.floor(this.originImageWidth * newZoom);
      const newHeight = Math.floor(this.originImageHeight * newZoom);
      // debugger;
      let _offset;
      const horizontal = !this._isImageVertical();
      let newTop = 0;
      let newLeft = 0;
      if (horizontal) {
        _offset = {
          x: 0.5 * (containerWidth - newWidth),
          y: 0.5 * (containerHeight - newHeight)
        };
        newLeft = _offset.x;
        newTop = _offset.y;
      } else {
        _offset = {
          x: 0.5 * (containerWidth - newHeight),
          y: 0.5 * (containerHeight - newWidth)
        };
        newLeft = _offset.x - (newWidth - newHeight) / 2;
        newTop = _offset.y + (newWidth - newHeight) / 2;
      }
      this.setState({
        width: newWidth,
        height: newHeight,
        offset: _offset,
        left: newLeft,
        top: newTop,
        currZoom: newZoom
      });
      if (imageDOM) {
        this._adapter.setImageCursor(canDrag);
      }
    };
    this.calcExtremeBounds = () => {
      const {
        width,
        height
      } = this.getStates();
      const {
        width: containerWidth,
        height: containerHeight
      } = this._getContainerBounds();
      let extremeLeft = containerWidth - width;
      let extremeTop = containerHeight - height;
      if (this._isImageVertical()) {
        extremeLeft = containerWidth - height;
        extremeTop = containerHeight - width;
      }
      return {
        left: extremeLeft,
        top: extremeTop
      };
    };
    this.handleMoveImage = e => {
      const {
        offset,
        width,
        height
      } = this.getStates();
      const {
        canDragVertical,
        canDragHorizontal
      } = this.calcCanDragDirection();
      // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
      const mouseLeftPress = e.buttons === 1;
      if (mouseLeftPress && (canDragVertical || canDragHorizontal)) {
        const {
          clientX,
          clientY
        } = e;
        const {
          left: containerLeft,
          top: containerTop
        } = this._getContainerBounds();
        const {
          left: extremeLeft,
          top: extremeTop
        } = this.calcExtremeBounds();
        let newX = canDragHorizontal ? clientX - containerLeft - this.startMouseOffset.x : offset.x;
        let newY = canDragVertical ? clientY - containerTop - this.startMouseOffset.y : offset.y;
        if (canDragHorizontal) {
          newX = newX > 0 ? 0 : newX < extremeLeft ? extremeLeft : newX;
        }
        if (canDragVertical) {
          newY = newY > 0 ? 0 : newY < extremeTop ? extremeTop : newY;
        }
        const _offset = {
          x: newX,
          y: newY
        };
        this.setState({
          offset: _offset,
          left: this._isImageVertical() ? _offset.x - (width - height) / 2 : _offset.x,
          top: this._isImageVertical() ? _offset.y + (width - height) / 2 : _offset.y
        });
      }
    };
    this.handleImageMouseDown = e => {
      this.startMouseOffset = this._getOffset(e);
    };
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/previewImage.js






const previewImage_prefixCls = image_constants_cssClasses.PREFIX;
const preViewImgPrefixCls = `${previewImage_prefixCls}-preview-image`;
class PreviewImage extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      getContainer: () => {
        return this.containerRef.current;
      },
      getImage: () => {
        return this.imageRef.current;
      },
      setLoading: loading => {
        this.setState({
          loading
        });
      },
      setImageCursor: canDrag => {
        this.imageRef.current.style.cursor = canDrag ? "grab" : "default";
      }
    });
  }
  constructor(props) {
    super(props);
    this.onWindowResize = () => {
      this.foundation.handleWindowResize();
    };
    // Determine the response method of right click according to the disableDownload parameter in props
    this.handleRightClickImage = e => {
      this.foundation.handleRightClickImage(e);
    };
    this.handleLoad = e => {
      this.foundation.handleLoad(e);
    };
    this.handleError = e => {
      this.foundation.handleError(e);
    };
    this.handleMoveImage = e => {
      this.foundation.handleMoveImage(e);
    };
    this.onImageMouseDown = e => {
      this.foundation.handleImageMouseDown(e);
    };
    this.state = {
      width: 0,
      height: 0,
      loading: true,
      offset: {
        x: 0,
        y: 0
      },
      currZoom: 0,
      top: 0,
      left: 0
    };
    this.containerRef = /*#__PURE__*/react.createRef();
    this.imageRef = /*#__PURE__*/react.createRef();
    this.foundation = new PreviewImageFoundation(this.adapter);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onWindowResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
  }
  componentDidUpdate(prevProps, prevStates) {
    // If src changes, start a new loading
    const zoomChange = "zoom" in this.props && this.props.zoom !== this.state.currZoom;
    const srcChange = this.props.src && this.props.src !== prevProps.src;
    if (srcChange) {
      this.foundation.setLoading(true);
    }
    // If the incoming zoom changes, other content changes are determined based on the new zoom value
    if (zoomChange) {
      this.foundation.calculatePreviewImage(this.props.zoom, null);
    }
    if (!zoomChange && !srcChange && prevProps) {
      if ("ratio" in this.props && this.props.ratio !== prevProps.ratio) {
        this.foundation.handleRatioChange();
      }
      if ("rotation" in this.props && this.props.rotation !== prevProps.rotation) {
        this.onWindowResize();
      }
    }
  }
  render() {
    const {
      src,
      rotation,
      crossOrigin
    } = this.props;
    const {
      loading,
      width,
      height,
      top,
      left
    } = this.state;
    const imgStyle = {
      position: "absolute",
      visibility: loading ? "hidden" : "visible",
      transform: `rotate(${-rotation}deg)`,
      top,
      left,
      width,
      height
    };
    return /*#__PURE__*/react.createElement("div", {
      className: `${preViewImgPrefixCls}`,
      ref: this.containerRef
    }, /*#__PURE__*/react.createElement("img", {
      ref: this.imageRef,
      src: src,
      alt: "previewImag",
      className: `${preViewImgPrefixCls}-img`,
      key: src,
      onMouseMove: this.handleMoveImage,
      onMouseDown: this.onImageMouseDown,
      onContextMenu: this.handleRightClickImage,
      onDragStart: e => e.preventDefault(),
      onLoad: this.handleLoad,
      onError: this.handleError,
      style: imgStyle,
      crossOrigin: crossOrigin
    }), loading && /*#__PURE__*/react.createElement(spin, {
      size: "large",
      wrapperClassName: `${preViewImgPrefixCls}-spin`
    }));
  }
}
PreviewImage.propTypes = {
  src: (prop_types_default()).string,
  rotation: (prop_types_default()).number,
  style: (prop_types_default()).object,
  // maxZoom: PropTypes.number,
  // minZoom: PropTypes.number,
  // zoomStep: PropTypes.number,
  zoom: (prop_types_default()).number,
  ratio: (prop_types_default()).string,
  disableDownload: (prop_types_default()).bool,
  clickZoom: (prop_types_default()).number,
  setRatio: (prop_types_default()).func,
  onZoom: (prop_types_default()).func,
  onLoad: (prop_types_default()).func,
  onError: (prop_types_default()).func
};
PreviewImage.defaultProps = {
  // maxZoom: 5,
  // minZoom: 0.1,
  // zoomStep: 0.1,
  zoom: undefined
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/utils.js
var image_utils_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const isTargetEmit = (event, targetClasses) => {
  // event.path usage is discouraged, use event.composedPath() as it's standard and is more future-proof
  // path is the event-triggered bubbling path, which stores each node through which bubbling passes.
  // path.length-4 is to remove elements above the root node, such as body, html, document, window
  const path = event === null || event === void 0 ? void 0 : event.composedPath();
  const isTarget = path === null || path === void 0 ? void 0 : path.slice(0, path.length - 4).some(node => {
    if (node.className && typeof node.className === "string") {
      return targetClasses.some(c => node.className.includes(c));
    }
    return false;
  });
  return isTarget;
};
const downloadImage = (src, filename, downloadErrorCb) => image_utils_awaiter(void 0, void 0, void 0, function* () {
  try {
    const response = yield fetch(src);
    if (response.ok) {
      const blob = yield response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    } else {
      downloadErrorCb(src);
    }
  } catch (error) {
    downloadErrorCb(src);
  }
});
const crossMerge = function () {
  let leftArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let rightArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let newArr = [];
  const leftLen = leftArr.length;
  const rightLen = rightArr.length;
  const crossLength = leftLen <= rightLen ? leftLen : rightLen;
  new Array(crossLength).fill(0).forEach((item, index) => {
    newArr.push(rightArr[index]);
    newArr.push(leftArr[index]);
  });
  if (leftLen > rightLen) {
    newArr = newArr.concat(leftArr.slice(rightLen, leftLen));
  } else if (leftLen < rightLen) {
    newArr = newArr.concat(rightArr.slice(leftLen, rightLen));
  }
  return newArr;
};
const getPreloadImagArr = (imgSrc, currentIndex, preLoadGap, infinite) => {
  const beginIndex = currentIndex - preLoadGap;
  const endIndex = currentIndex + preLoadGap;
  const srcLength = imgSrc.length;
  let leftArr = [];
  let rightArr = [];
  if (preLoadGap >= Math.floor(srcLength / 2)) {
    if (infinite) {
      leftArr = imgSrc.concat(imgSrc).slice(beginIndex + srcLength < 0 ? 0 : beginIndex + srcLength, currentIndex + srcLength);
      rightArr = imgSrc.concat(imgSrc).slice(currentIndex + 1, endIndex + 1 < 2 * srcLength ? endIndex + 1 : 2 * srcLength);
    } else {
      leftArr = imgSrc.slice(0, currentIndex);
      rightArr = imgSrc.slice(currentIndex + 1, srcLength);
    }
  } else {
    if (infinite) {
      leftArr = imgSrc.concat(imgSrc).slice(beginIndex + srcLength, currentIndex + srcLength);
      rightArr = imgSrc.concat(imgSrc).slice(currentIndex + 1, endIndex + 1);
    } else {
      if (beginIndex >= 0 && endIndex < srcLength) {
        leftArr = imgSrc.slice(beginIndex, currentIndex);
        rightArr = imgSrc.slice(currentIndex + 1, endIndex + 1);
      } else if (beginIndex < 0) {
        leftArr = imgSrc.slice(0, currentIndex);
        rightArr = imgSrc.slice(currentIndex + 1, 2 * preLoadGap + 1);
      } else {
        rightArr = imgSrc.slice(currentIndex + 1, srcLength);
        leftArr = imgSrc.slice(srcLength - 2 * preLoadGap - 1, currentIndex);
      }
    }
  }
  const result = crossMerge(leftArr.reverse(), rightArr);
  const duplicateResult = Array.from(new Set(result));
  return duplicateResult;
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/previewInnerFoundation.js






const NOT_CLOSE_TARGETS = ["icon", "footer"];
const STOP_CLOSE_TARGET = (/* unused pure expression or super */ null && (["icon", "footer", "header"]));
class PreviewInnerFoundation extends foundation {
  constructor(adapter) {
    var _this;
    super(Object.assign({}, adapter));
    _this = this;
    this._timer = null;
    this._startMouseDown = {
      x: 0,
      y: 0
    };
    this.handleViewVisibleChange = () => {
      const {
        viewerVisible
      } = this.getStates();
      if (viewerVisible) {
        this.setState({
          viewerVisible: false
        });
        this.clearTimer();
      }
    };
    this.handleMouseMove = e => {
      this._persistEvent(e);
      this.mouseMoveHandler(e);
    };
    this.mouseMoveHandler = throttle_default()(e => {
      const {
        viewerVisible
      } = this.getStates();
      const isValidTarget = this._adapter.isValidTarget(e);
      if (isValidTarget) {
        if (!viewerVisible) {
          this.setState({
            viewerVisible: true
          });
        }
        this.updateTimer();
      } else {
        this.clearTimer();
      }
    }, 50);
    this.updateTimer = () => {
      const {
        viewerVisibleDelay
      } = this.getProps();
      this.clearTimer();
      this._timer = setTimeout(this.handleViewVisibleChange, viewerVisibleDelay);
    };
    this.clearTimer = () => {
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    };
    this.handleWheel = e => {
      this.onWheel(e);
      handlePrevent(e);
    };
    this.onWheel = e => {
      const {
        zoomStep,
        maxZoom,
        minZoom
      } = this.getProps();
      const {
        zoom: currZoom
      } = this.getStates();
      let _zoom;
      if (e.deltaY < 0) {
        /* zoom in */
        if (currZoom + zoomStep <= maxZoom) {
          _zoom = Number((currZoom + zoomStep).toFixed(2));
        }
      } else if (e.deltaY > 0) {
        /* zoom out */
        if (currZoom - zoomStep >= minZoom) {
          _zoom = Number((currZoom - zoomStep).toFixed(2));
        }
      }
      if (!isUndefined_default()(_zoom)) {
        this.handleZoomImage(_zoom);
      }
    };
    this.handleMouseUp = e => {
      const {
        maskClosable
      } = this.getProps();
      let couldClose = !isTargetEmit(e, NOT_CLOSE_TARGETS);
      const {
        clientX,
        clientY
      } = e;
      const {
        x,
        y
      } = this._startMouseDown;
      // 对鼠标移动做容错处理，当 x 和 y 方向在 mouseUp 的时候移动距离都小于等于 5px 时候就可以关闭预览
      // Error-tolerant processing of mouse movement, when the movement distance in the x and y directions is less than or equal to 5px in mouseUp, the preview can be closed
      // 不做容错处理的话，直接用 clientX !== x || y !== clientY 做判断，鼠标在用户点击时候无意识的轻微移动无法关闭预览，不符合用户预期
      // If you do not do fault-tolerant processing, but directly use clientX !== x || y !== clientY to make judgments, the slight movement of the mouse when the user clicks will not be able to close the preview, which does not meet the user's expectations.
      if (Math.abs(clientX - x) > 5 || Math.abs(y - clientY) > 5) {
        couldClose = false;
      }
      if (couldClose && maskClosable) {
        this._adapter.notifyVisibleChange(false);
      }
    };
    this.handleMouseDown = e => {
      const {
        clientX,
        clientY
      } = e;
      this._startMouseDown = {
        x: clientX,
        y: clientY
      };
    };
    this.handleKeyDown = e => {
      const {
        closeOnEsc
      } = this.getProps();
      if (closeOnEsc && e.keyCode === utils_keyCode.ESC) {
        e.stopPropagation();
        this._adapter.notifyVisibleChange(false);
        this._adapter.notifyClose();
        return;
      }
    };
    this.handleSwitchImage = direction => {
      const step = direction === "prev" ? -1 : 1;
      const {
        imgSrc,
        currentIndex: currentIndexInState
      } = this.getStates();
      const srcLength = imgSrc.length;
      const newIndex = (currentIndexInState + step + srcLength) % srcLength;
      if ("currentIndex" in this.getProps()) {
        if (this._adapter.getIsInGroup()) {
          const setCurrentIndex = this._adapter.getContext("setCurrentIndex");
          setCurrentIndex(newIndex);
        }
      } else {
        this.setState({
          currentIndex: newIndex
        });
      }
      this._adapter.notifyChange(newIndex, direction);
      this.setState({
        direction,
        rotation: 0
      });
    };
    this.handleDownload = () => {
      const {
        currentIndex,
        imgSrc
      } = this.getStates();
      const setDownloadName = this._adapter.getSetDownloadFunc();
      const downloadSrc = imgSrc[currentIndex];
      const downloadName = setDownloadName ? setDownloadName(downloadSrc) : downloadSrc.slice(downloadSrc.lastIndexOf("/") + 1).split('?')[0];
      downloadImage(downloadSrc, downloadName, this._adapter.notifyDownloadError);
      this._adapter.notifyDownload(downloadSrc, currentIndex);
    };
    this.handlePreviewClose = e => {
      this._adapter.notifyVisibleChange(false);
      this._adapter.notifyClose();
      handlePrevent(e);
    };
    this.handleAdjustRatio = type => {
      this.setState({
        ratio: type
      });
      this._adapter.notifyRatioChange(type);
    };
    this.handleRotateImage = direction => {
      const {
        rotation
      } = this.getStates();
      const newRotation = rotation + (direction === "left" ? 90 : -90);
      this.setState({
        rotation: newRotation
      });
      this._adapter.notifyRotateChange(newRotation);
    };
    this.handleZoomImage = function (newZoom) {
      let notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const {
        zoom
      } = _this.getStates();
      if (zoom !== newZoom) {
        notify && _this._adapter.notifyZoom(newZoom, newZoom > zoom);
        _this.setState({
          zoom: newZoom
        });
      }
    };
    // 当 visible 改变之后，预览组件完成首张图片加载后，启动预加载
    // 如： 1，2，3，4，5，6，7，8张图片， 点击第 4 张图片，preLoadGap 为 2
    // 当 visible 从 false 变为 true ，首先加载第 4 张图片，当第 4 张图片加载完成后，
    // 再按照 5，3，6，2的顺序预先加载这几张图片
    // When visible changes, the preview component finishes loading the first image and starts preloading
    // Such as: 1, 2, 3, 4, 5, 6, 7, 8 pictures, click the 4th picture, preLoadGap is 2
    // When visible changes from false to true , load the 4th image first, when the 4th image is loaded,
    // Preload these pictures in the order of 5, 3, 6, 2
    this.preloadGapImage = () => {
      const {
        preLoad,
        preLoadGap,
        infinite,
        currentIndex
      } = this.getProps();
      const {
        imgSrc
      } = this.getStates();
      if (!preLoad || typeof preLoadGap !== "number" || preLoadGap < 1) {
        return;
      }
      const preloadImages = getPreloadImagArr(imgSrc, currentIndex, preLoadGap, infinite);
      if (preloadImages.length === 0) {
        return;
      }
      const Img = new Image();
      let index = 0;
      function callback(e) {
        index++;
        if (index < preloadImages.length) {
          Img.src = preloadImages[index];
        }
      }
      Img.onload = e => {
        this.setLoadSuccessStatus(Img.src);
        callback(e);
      };
      Img.onerror = callback;
      Img.src = preloadImages[0];
    };
    // 在切换左右图片时，当被切换图片完成加载后，根据方向决定下一个预加载的图片
    // 如： 1，2，3，4，5，6，7，8张图片
    // 当 preLoadGap 为 2， 从第 5 张图片进行切换
    // - 如果向 右 切换到第 6 张，则第 6 张图片加载动作结束后（无论加载成功 or 失败），会预先加载第 8 张；
    // - 如果向 左 切换到第 4 张，则第 4 张图片加载动作结束后（无论加载成功 or 失败），会预先加载第 2 张；
    // When switching the left and right pictures, when the switched picture is loaded, the next preloaded picture is determined according to the direction
    // Such as: 1, 2, 3, 4, 5, 6, 7, 8 pictures
    // When preLoadGap is 2, switch from the 5th picture
    // - If you switch to the 6th image(direction is next), the 8th image will be preloaded after the 6th image is loaded (whether it succeeds or fails to load);
    // - If you switch to the 4th image(direction is prev), the second image will be preloaded after the 4th image is loaded (whether it succeeds or fails to load);
    this.preloadSingleImage = () => {
      const {
        preLoad,
        preLoadGap,
        infinite
      } = this.getProps();
      const {
        imgSrc,
        currentIndex,
        direction,
        imgLoadStatus
      } = this.getStates();
      if (!preLoad || typeof preLoadGap !== "number" || preLoadGap < 1) {
        return;
      }
      // 根据方向决定preload那个index
      // Determine the index of preload according to the direction
      let preloadIndex = currentIndex + (direction === "prev" ? -1 : 1) * preLoadGap;
      if (preloadIndex < 0 || preloadIndex >= imgSrc.length) {
        if (infinite) {
          preloadIndex = (preloadIndex + imgSrc.length) % imgSrc.length;
        } else {
          return;
        }
      }
      // 如果图片没有加载成功过，则进行预加载
      // If the image has not been loaded successfully, preload it
      if (!imgLoadStatus[preloadIndex]) {
        const Img = new Image();
        Img.onload = e => {
          this.setLoadSuccessStatus(imgSrc[preloadIndex]);
        };
        Img.src = imgSrc[preloadIndex];
      }
    };
    this.setLoadSuccessStatus = src => {
      const {
        imgLoadStatus
      } = this.getStates();
      const status = Object.assign({}, imgLoadStatus);
      status[src] = true;
      this.setState({
        imgLoadStatus: status
      });
    };
    this.onImageLoad = src => {
      const {
        preloadAfterVisibleChange
      } = this.getStates();
      this.setLoadSuccessStatus(src);
      // 当 preview 中当前加载的图片加载完成后，
      // 如果是在visible change之后的第一次加载，则启动加载该currentIndex左右preloadGap范围的图片
      // 如果是非第一次加载，是在左右切换图片，则根据方向预先加载单张图片
      // When the currently loaded image in Preview is loaded,
      // - It is the first load after visible change, start loading the images in the preloadGap range around the currentIndex
      // - It is not the first load, the image is switched left and right, and a single image is preloaded according to the direction
      if (preloadAfterVisibleChange) {
        this.preloadGapImage();
        this.setState({
          preloadAfterVisibleChange: false
        });
      } else {
        this.preloadSingleImage();
      }
    };
  }
  beforeShow() {
    this._adapter.registerKeyDownListener();
    this._adapter.disabledBodyScroll();
    this.updateTimer();
  }
  afterHide() {
    this._adapter.unregisterKeyDownListener();
    this._adapter.enabledBodyScroll();
    this.clearTimer();
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/previewInner.js















const previewInner_prefixCls = image_constants_cssClasses.PREFIX;
class PreviewInner extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      getIsInGroup: () => this.isInGroup(),
      disabledBodyScroll: () => {
        const {
          getPopupContainer
        } = this.props;
        this.bodyOverflow = document.body.style.overflow || '';
        if (!getPopupContainer && this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = 'hidden';
          document.body.style.width = `calc(${this.originBodyWidth || '100%'} - ${this.scrollBarWidth}px)`;
        }
      },
      enabledBodyScroll: () => {
        const {
          getPopupContainer
        } = this.props;
        if (!getPopupContainer && this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = this.bodyOverflow;
          document.body.style.width = this.originBodyWidth;
        }
      },
      notifyChange: (index, direction) => {
        const {
          onChange,
          onPrev,
          onNext
        } = this.props;
        isFunction_default()(onChange) && onChange(index);
        if (direction === "prev") {
          onPrev && onPrev(index);
        } else {
          onNext && onNext(index);
        }
      },
      notifyZoom: (zoom, increase) => {
        const {
          onZoomIn,
          onZoomOut
        } = this.props;
        if (increase) {
          isFunction_default()(onZoomIn) && onZoomIn(zoom);
        } else {
          isFunction_default()(onZoomOut) && onZoomOut(zoom);
        }
      },
      notifyClose: () => {
        const {
          onClose
        } = this.props;
        isFunction_default()(onClose) && onClose();
      },
      notifyVisibleChange: visible => {
        const {
          onVisibleChange
        } = this.props;
        isFunction_default()(onVisibleChange) && onVisibleChange(visible);
      },
      notifyRatioChange: type => {
        const {
          onRatioChange
        } = this.props;
        isFunction_default()(onRatioChange) && onRatioChange(type);
      },
      notifyRotateChange: angle => {
        const {
          onRotateLeft
        } = this.props;
        isFunction_default()(onRotateLeft) && onRotateLeft(angle);
      },
      notifyDownload: (src, index) => {
        const {
          onDownload
        } = this.props;
        isFunction_default()(onDownload) && onDownload(src, index);
      },
      notifyDownloadError: src => {
        const {
          onDownloadError
        } = this.props;
        isFunction_default()(onDownloadError) && onDownloadError(src);
      },
      registerKeyDownListener: () => {
        window && window.addEventListener("keydown", this.handleKeyDown);
      },
      unregisterKeyDownListener: () => {
        window && window.removeEventListener("keydown", this.handleKeyDown);
      },
      getSetDownloadFunc: () => {
        var _a, _b;
        return (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.setDownloadName) !== null && _b !== void 0 ? _b : this.props.setDownloadName;
      },
      isValidTarget: e => {
        const headerDom = this.headerRef && this.headerRef.current;
        const footerDom = this.footerRef && this.footerRef.current;
        const leftIconDom = this.leftIconRef && this.leftIconRef.current;
        const rightIconDom = this.rightIconRef && this.rightIconRef.current;
        const target = e.target;
        if (headerDom && headerDom.contains(target) || footerDom && footerDom.contains(target) || leftIconDom && leftIconDom.contains(target) || rightIconDom && rightIconDom.contains(target)) {
          // Move in the operation area, return false
          return false;
        }
        // Move in the preview area except the operation area, return true
        return true;
      }
    });
  }
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.viewVisibleChange = () => {
      this.foundation.handleViewVisibleChange();
    };
    this.handleSwitchImage = direction => {
      this.foundation.handleSwitchImage(direction);
    };
    this.handleDownload = () => {
      this.foundation.handleDownload();
    };
    this.handlePreviewClose = e => {
      this.foundation.handlePreviewClose(e);
    };
    this.handleAdjustRatio = type => {
      this.foundation.handleAdjustRatio(type);
    };
    this.handleRotateImage = direction => {
      this.foundation.handleRotateImage(direction);
    };
    this.handleZoomImage = function (newZoom) {
      let notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this.foundation.handleZoomImage(newZoom, notify);
    };
    this.handleMouseUp = e => {
      this.foundation.handleMouseUp(e.nativeEvent);
    };
    this.handleMouseMove = e => {
      this.foundation.handleMouseMove(e);
    };
    this.handleKeyDown = e => {
      this.foundation.handleKeyDown(e);
    };
    this.onImageError = () => {
      this.foundation.preloadSingleImage();
    };
    this.onImageLoad = src => {
      this.foundation.onImageLoad(src);
    };
    this.handleMouseDown = e => {
      this.foundation.handleMouseDown(e);
    };
    this.handleWheel = e => {
      this.foundation.handleWheel(e);
    };
    // 为什么通过 addEventListener 注册 wheel 事件而不是使用 onWheel 事件？
    // 因为 Passive Event Listeners（https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#improving_scrolling_performance_with_passive_listeners）
    // Passive Event Listeners 是一种优化技术，用于提高滚动性能。在默认情况下，浏览器会假设事件的监听器不会调用 
    // preventDefault() 方法来阻止事件的默认行为，从而允许进行一些优化操作，例如滚动平滑。
    // 对于 Image 而言，如果使用触控板，双指朝不同方向分开放大图片，则需要  preventDefault 防止页面整体放大。
    // Why register wheel event through addEventListener instead of using onWheel event？
    // Because of Passive Event Listeners(an optimization technique used to improve scrolling performance. By default, 
    // the browser will assume that event listeners will not call preventDefault() method to prevent the default behavior of the event, 
    // allowing some optimization operations such as scroll smoothing.)
    // For Image, if we use the trackpad and spread your fingers in different directions to enlarge the image, we need to preventDefault
    // to prevent the page from being enlarged as a whole.
    this.registryImageWrapRef = ref => {
      if (this.imageWrapRef) {
        this.imageWrapRef.removeEventListener("wheel", this.handleWheel);
      }
      if (ref) {
        ref.addEventListener("wheel", this.handleWheel, {
          passive: false
        });
      }
      this.imageWrapRef = ref;
    };
    this.state = {
      imgSrc: [],
      imgLoadStatus: new Map(),
      zoom: 0.1,
      currentIndex: 0,
      ratio: "adaptation",
      rotation: 0,
      viewerVisible: true,
      visible: false,
      preloadAfterVisibleChange: true,
      direction: ""
    };
    this.foundation = new PreviewInnerFoundation(this.adapter);
    this.bodyOverflow = '';
    this.originBodyWidth = '100%';
    this.scrollBarWidth = 0;
    this.imageWrapRef = null;
    this.headerRef = /*#__PURE__*/react.createRef();
    this.footerRef = /*#__PURE__*/react.createRef();
    this.leftIconRef = /*#__PURE__*/react.createRef();
    this.rightIconRef = /*#__PURE__*/react.createRef();
  }
  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    let src = [];
    if (props.visible) {
      // if src in props
      src = Array.isArray(props.src) ? props.src : [props.src];
    }
    if (!isEqual_default()(src, state.imgSrc)) {
      willUpdateStates.imgSrc = src;
    }
    if (props.visible !== state.visible) {
      willUpdateStates.visible = props.visible;
      if (props.visible) {
        willUpdateStates.preloadAfterVisibleChange = true;
        willUpdateStates.viewerVisible = true;
        willUpdateStates.rotation = 0;
        willUpdateStates.ratio = 'adaptation';
      }
    }
    if ("currentIndex" in props && props.currentIndex !== state.currentIndex) {
      willUpdateStates.currentIndex = props.currentIndex;
      // ratio will set to adaptation when change picture, 
      // attention: If the ratio is controlled, the ratio should not change as the index changes
      willUpdateStates.ratio = 'adaptation';
    }
    return willUpdateStates;
  }
  componentDidMount() {
    this.scrollBarWidth = getScrollbarWidth();
    this.originBodyWidth = document.body.style.width;
    if (this.props.visible) {
      this.foundation.beforeShow();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.src !== this.props.src) {
      this.foundation.updateTimer();
    }
    // hide => show
    if (!prevProps.visible && this.props.visible) {
      this.foundation.beforeShow();
    }
    // show => hide
    if (prevProps.visible && !this.props.visible) {
      this.foundation.afterHide();
    }
  }
  componentWillUnmount() {
    this.foundation.clearTimer();
  }
  isInGroup() {
    return Boolean(this.context && this.context.isGroup);
  }
  render() {
    const {
      getPopupContainer,
      closable,
      zIndex,
      visible,
      className,
      style,
      infinite,
      zoomStep,
      crossOrigin,
      prevTip,
      nextTip,
      zoomInTip,
      zoomOutTip,
      rotateTip,
      downloadTip,
      adaptiveTip,
      originTip,
      showTooltip,
      disableDownload,
      renderPreviewMenu,
      renderHeader
    } = this.props;
    const {
      currentIndex,
      imgSrc,
      zoom,
      ratio,
      rotation,
      viewerVisible
    } = this.state;
    let wrapperStyle = {
      zIndex
    };
    if (getPopupContainer) {
      wrapperStyle = {
        zIndex,
        position: "static"
      };
    }
    const previewPrefixCls = `${previewInner_prefixCls}-preview`;
    const previewWrapperCls = classnames_default()(previewPrefixCls, {
      [`${previewInner_prefixCls}-hide`]: !visible,
      [`${previewPrefixCls}-popup`]: getPopupContainer
    }, className);
    const hideViewerCls = !viewerVisible ? `${previewPrefixCls}-hide` : "";
    const total = imgSrc.length;
    const showPrev = total !== 1 && (infinite || currentIndex !== 0);
    const showNext = total !== 1 && (infinite || currentIndex !== total - 1);
    return visible && /*#__PURE__*/react.createElement(_portal, {
      getPopupContainer: getPopupContainer,
      style: wrapperStyle
    }, /*#__PURE__*/react.createElement("div", {
      className: previewWrapperCls,
      style: style,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      ref: this.registryImageWrapRef,
      onMouseMove: this.handleMouseMove
    }, /*#__PURE__*/react.createElement(previewHeader, {
      ref: this.headerRef,
      className: classnames_default()(hideViewerCls),
      onClose: this.handlePreviewClose,
      renderHeader: renderHeader,
      closable: closable
    }), /*#__PURE__*/react.createElement(PreviewImage, {
      src: imgSrc[currentIndex],
      onZoom: this.handleZoomImage,
      disableDownload: disableDownload,
      setRatio: this.handleAdjustRatio,
      zoom: zoom,
      ratio: ratio,
      rotation: rotation,
      crossOrigin: crossOrigin,
      onError: this.onImageError,
      onLoad: this.onImageLoad
    }), showPrev &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    react.createElement("div", {
      ref: this.leftIconRef,
      className: classnames_default()(`${previewPrefixCls}-icon`, `${previewPrefixCls}-prev`, hideViewerCls),
      onClick: () => this.handleSwitchImage("prev")
    }, /*#__PURE__*/react.createElement(IconArrowLeft, {
      size: "large"
    })), showNext &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    react.createElement("div", {
      ref: this.rightIconRef,
      className: classnames_default()(`${previewPrefixCls}-icon`, `${previewPrefixCls}-next`, hideViewerCls),
      onClick: () => this.handleSwitchImage("next")
    }, /*#__PURE__*/react.createElement(IconArrowRight, {
      size: "large"
    })), /*#__PURE__*/react.createElement(previewFooter_Footer, {
      forwardRef: this.footerRef,
      className: hideViewerCls,
      totalNum: total,
      curPage: currentIndex + 1,
      disabledPrev: !showPrev,
      disabledNext: !showNext,
      zoom: zoom * 100,
      step: zoomStep * 100,
      showTooltip: showTooltip,
      ratio: ratio,
      prevTip: prevTip,
      nextTip: nextTip,
      zIndex: zIndex,
      zoomInTip: zoomInTip,
      zoomOutTip: zoomOutTip,
      rotateTip: rotateTip,
      downloadTip: downloadTip,
      disableDownload: disableDownload,
      adaptiveTip: adaptiveTip,
      originTip: originTip,
      onPrev: () => this.handleSwitchImage("prev"),
      onNext: () => this.handleSwitchImage("next"),
      onZoomIn: this.handleZoomImage,
      onZoomOut: this.handleZoomImage,
      onDownload: this.handleDownload,
      onRotate: this.handleRotateImage,
      onAdjustRatio: this.handleAdjustRatio,
      renderPreviewMenu: renderPreviewMenu
    })));
  }
}
PreviewInner.contextType = PreviewContext;
PreviewInner.propTypes = {
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  visible: (prop_types_default()).bool,
  src: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
  currentIndex: (prop_types_default()).number,
  defaultCurrentIndex: (prop_types_default()).number,
  defaultVisible: (prop_types_default()).bool,
  maskClosable: (prop_types_default()).bool,
  closable: (prop_types_default()).bool,
  zoomStep: (prop_types_default()).number,
  infinite: (prop_types_default()).bool,
  showTooltip: (prop_types_default()).bool,
  closeOnEsc: (prop_types_default()).bool,
  prevTip: (prop_types_default()).string,
  nextTip: (prop_types_default()).string,
  zoomInTip: (prop_types_default()).string,
  zoomOutTip: (prop_types_default()).string,
  downloadTip: (prop_types_default()).string,
  adaptiveTip: (prop_types_default()).string,
  originTip: (prop_types_default()).string,
  lazyLoad: (prop_types_default()).bool,
  preLoad: (prop_types_default()).bool,
  preLoadGap: (prop_types_default()).number,
  disableDownload: (prop_types_default()).bool,
  viewerVisibleDelay: (prop_types_default()).number,
  zIndex: (prop_types_default()).number,
  maxZoom: (prop_types_default()).number,
  minZoom: (prop_types_default()).number,
  renderHeader: (prop_types_default()).func,
  renderPreviewMenu: (prop_types_default()).func,
  getPopupContainer: (prop_types_default()).func,
  onVisibleChange: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onClose: (prop_types_default()).func,
  onZoomIn: (prop_types_default()).func,
  onZoomOut: (prop_types_default()).func,
  onPrev: (prop_types_default()).func,
  onNext: (prop_types_default()).func,
  onDownload: (prop_types_default()).func,
  onRatioChange: (prop_types_default()).func,
  onRotateLeft: (prop_types_default()).func
};
PreviewInner.defaultProps = {
  showTooltip: false,
  zoomStep: 0.1,
  infinite: false,
  closeOnEsc: true,
  lazyLoad: false,
  preLoad: true,
  preLoadGap: 2,
  zIndex: image_constants_numbers.DEFAULT_Z_INDEX,
  maskClosable: true,
  viewerVisibleDelay: 10000,
  maxZoom: 5,
  minZoom: 0.1
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/image/imageFoundation.js


class ImageFoundation extends foundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
    this.handleClick = e => {
      const {
        imageID,
        preview
      } = this.getProps();
      // if preview = false, then it cannot preview
      if (!preview) {
        return;
      }
      // if image in group, then use group's Preview components
      if (this._adapter.getIsInGroup()) {
        const {
          setCurrentIndex,
          handleVisibleChange
        } = this._adapter.getContexts();
        setCurrentIndex(imageID);
        handleVisibleChange(true);
      } else {
        // image isn't in group, then use it's own Preview components
        this.handlePreviewVisibleChange(true);
      }
    };
    this.handleLoaded = e => {
      const {
        onLoad
      } = this.getProps();
      onLoad && onLoad(e);
      this.setState({
        loadStatus: "success"
      });
    };
    this.handleError = e => {
      const {
        onError
      } = this.getProps();
      onError && onError(e);
      this.setState({
        loadStatus: "error"
      });
    };
    this.handlePreviewVisibleChange = newVisible => {
      const {
        preview
      } = this.getProps();
      if (isObject_default()(preview)) {
        const {
          onVisibleChange
        } = preview;
        onVisibleChange && onVisibleChange(newVisible);
        if (!("visible" in preview)) {
          this.setState({
            previewVisible: newVisible
          });
        }
      } else {
        this.setState({
          previewVisible: newVisible
        });
      }
    };
  }
}
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-foundation/lib/es/skeleton/constants.js

const skeleton_constants_cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-skeleton`
};
const skeleton_constants_strings = {};

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/skeleton/item.js
var skeleton_item_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





// import '@douyinfe/semi-foundation/lib/es/skeleton/skeleton.css';
const item_sizeSet = avatar_constants_strings.SIZE;
const item_shapeSet = avatar_constants_strings.SHAPE;
const generator = type => BasicComponent => props => /*#__PURE__*/react.createElement(BasicComponent, Object.assign({
  type: type
}, props));
class Generic extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        prefixCls,
        className,
        type,
        size,
        shape
      } = _a,
      others = skeleton_item_rest(_a, ["prefixCls", "className", "type", "size", "shape"]);
    const classString = classnames_default()(className, `${prefixCls}-${type}`, {
      [`${prefixCls}-${type}-${size}`]: type.toUpperCase() === 'AVATAR'
    }, {
      [`${prefixCls}-${type}-${shape}`]: type.toUpperCase() === 'AVATAR'
    });
    return /*#__PURE__*/react.createElement('div', Object.assign({
      className: classString
    }, others));
  }
}
Generic.propTypes = {
  type: (prop_types_default()).string,
  prefixCls: (prop_types_default()).string,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  size: prop_types_default().oneOf(item_sizeSet),
  shape: prop_types_default().oneOf(item_shapeSet)
};
Generic.defaultProps = {
  prefixCls: skeleton_constants_cssClasses.PREFIX,
  size: 'medium',
  shape: 'circle'
};
const item_Avatar = generator('avatar')(Generic);
const item_Image = generator('image')(Generic);
const item_Title = generator('title')(Generic);
const item_Button = generator('button')(Generic);
class item_Paragraph extends react.PureComponent {
  render() {
    const {
      prefixCls,
      className,
      style,
      rows
    } = this.props;
    const classString = classnames_default()(className, `${prefixCls}-paragraph`);
    return /*#__PURE__*/react.createElement("ul", {
      className: classString,
      style: style
    }, [...Array(rows)].map((e, i) => /*#__PURE__*/react.createElement("li", {
      key: i
    })));
  }
}
item_Paragraph.propTypes = {
  rows: (prop_types_default()).number,
  prefixCls: (prop_types_default()).string,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string
};
item_Paragraph.defaultProps = {
  prefixCls: skeleton_constants_cssClasses.PREFIX,
  rows: 4
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/skeleton/index.js
var skeleton_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




// import '@douyinfe/semi-foundation/lib/es/skeleton/skeleton.css';

const skeleton_prefixCls = skeleton_constants_cssClasses.PREFIX;
class Skeleton extends react.PureComponent {
  render() {
    const _a = this.props,
      {
        placeholder,
        active,
        children,
        className,
        loading,
        style
      } = _a,
      others = skeleton_rest(_a, ["placeholder", "active", "children", "className", "loading", "style"]);
    const skCls = classnames_default()(skeleton_prefixCls, {
      [`${skeleton_prefixCls}-active`]: Boolean(active)
    }, className);
    let content;
    if (loading) {
      content = /*#__PURE__*/react.createElement("div", Object.assign({
        className: skCls,
        style: style
      }, others, {
        "x-semi-prop": "placeholder"
      }), placeholder);
    } else {
      content = children;
    }
    return content;
  }
}
Skeleton.Avatar = item_Avatar;
Skeleton.Title = item_Title;
Skeleton.Button = item_Button;
Skeleton.Paragraph = item_Paragraph;
Skeleton.Image = item_Image;
Skeleton.defaultProps = {
  loading: true
};
Skeleton.propTypes = {
  active: (prop_types_default()).bool,
  placeholder: (prop_types_default()).node,
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  loading: (prop_types_default()).bool,
  children: (prop_types_default()).node
};
/* harmony default export */ var skeleton = (Skeleton);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/image.js




var image_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};











// import '@douyinfe/semi-foundation/lib/es/image/image.css';
const image_prefixCls = image_constants_cssClasses.PREFIX;
class image_Image extends BaseComponent {
  get adapter() {
    return Object.assign(Object.assign({}, super.adapter), {
      getIsInGroup: () => this.isInGroup()
    });
  }
  constructor(props) {
    super(props);
    this.handleClick = e => {
      this.foundation.handleClick(e);
    };
    this.handleLoaded = e => {
      this.foundation.handleLoaded(e);
    };
    this.handleError = e => {
      this.foundation.handleError(e);
    };
    this.handlePreviewVisibleChange = visible => {
      this.foundation.handlePreviewVisibleChange(visible);
    };
    this.renderDefaultLoading = () => {
      const {
        width,
        height
      } = this.props;
      return /*#__PURE__*/react.createElement(skeleton.Image, {
        style: {
          width,
          height
        }
      });
    };
    this.renderDefaultError = () => {
      const prefixClsName = `${image_prefixCls}-status`;
      return /*#__PURE__*/react.createElement("div", {
        className: prefixClsName
      }, /*#__PURE__*/react.createElement(IconUploadError, {
        size: "extra-large"
      }));
    };
    this.renderLoad = () => {
      const prefixClsName = `${image_prefixCls}-status`;
      const {
        placeholder
      } = this.props;
      return placeholder ? /*#__PURE__*/react.createElement("div", {
        className: prefixClsName
      }, placeholder) : this.renderDefaultLoading();
    };
    this.renderError = () => {
      const {
        fallback
      } = this.props;
      const prefixClsName = `${image_prefixCls}-status`;
      const fallbackNode = typeof fallback === "string" ? /*#__PURE__*/react.createElement("img", {
        style: {
          width: "100%",
          height: "100%"
        },
        src: fallback,
        alt: "fallback"
      }) : fallback;
      return fallback ? /*#__PURE__*/react.createElement("div", {
        className: prefixClsName
      }, fallbackNode) : this.renderDefaultError();
    };
    this.renderExtra = () => {
      const {
        loadStatus
      } = this.state;
      return /*#__PURE__*/react.createElement("div", {
        className: `${image_prefixCls}-overlay`
      }, loadStatus === "error" && this.renderError(), loadStatus === "loading" && this.renderLoad());
    };
    this.getLocalTextByKey = key => /*#__PURE__*/react.createElement(LocaleConsumer, {
      componentName: "Image"
    }, locale => locale[key]);
    this.renderMask = () => /*#__PURE__*/react.createElement("div", {
      className: `${image_prefixCls}-mask`
    }, /*#__PURE__*/react.createElement("div", {
      className: `${image_prefixCls}-mask-info`
    }, /*#__PURE__*/react.createElement(IconEyeOpened, {
      size: "extra-large"
    }), /*#__PURE__*/react.createElement("span", {
      className: `${image_prefixCls}-mask-info-text`
    }, this.getLocalTextByKey("preview"))));
    this.state = {
      src: "",
      loadStatus: "loading",
      previewVisible: false
    };
    this.foundation = new ImageFoundation(this.adapter);
    this.imgRef = /*#__PURE__*/react.createRef();
  }
  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    if (props.src !== state.src) {
      willUpdateStates.src = props.src;
      willUpdateStates.loadStatus = "loading";
    }
    if (isObject_default()(props.preview)) {
      const {
        visible
      } = props.preview;
      if (isBoolean_default()(visible)) {
        willUpdateStates.previewVisible = visible;
      }
    }
    return willUpdateStates;
  }
  isInGroup() {
    return Boolean(this.context && this.context.isGroup);
  }
  isLazyLoad() {
    if (this.context) {
      return this.context.lazyLoad;
    }
    return false;
  }
  render() {
    var _a;
    const {
      src,
      loadStatus,
      previewVisible
    } = this.state;
    const _b = this.props,
      {
        src: picSrc,
        width,
        height,
        alt,
        style,
        className,
        crossOrigin,
        preview,
        fallback,
        placeholder,
        imageID,
        setDownloadName,
        imgCls,
        imgStyle
      } = _b,
      restProps = image_rest(_b, ["src", "width", "height", "alt", "style", "className", "crossOrigin", "preview", "fallback", "placeholder", "imageID", "setDownloadName", "imgCls", "imgStyle"]);
    const outerStyle = Object.assign({
      width,
      height
    }, style);
    const outerCls = classnames_default()(image_prefixCls, className);
    const canPreview = loadStatus === "success" && preview && !this.isInGroup();
    const showPreviewCursor = preview && loadStatus === "success";
    const previewSrc = isObject_default()(preview) ? (_a = preview.src) !== null && _a !== void 0 ? _a : src : src;
    const previewProps = isObject_default()(preview) && canPreview ? Object.assign(Object.assign({}, omit_default()(preview, ['className', 'style', 'previewCls', 'previewStyle'])), {
      className: preview === null || preview === void 0 ? void 0 : preview.previewCls,
      style: preview === null || preview === void 0 ? void 0 : preview.previewStyle
    }) : {};
    return /*#__PURE__*/react.createElement("div", {
      style: outerStyle,
      className: outerCls,
      onClick: this.handleClick
    }, /*#__PURE__*/react.createElement("img", Object.assign({
      ref: this.imgRef
    }, restProps, {
      src: this.isInGroup() && this.isLazyLoad() ? undefined : src,
      "data-src": src,
      alt: alt,
      style: imgStyle,
      className: classnames_default()(`${image_prefixCls}-img`, {
        [`${image_prefixCls}-img-preview`]: showPreviewCursor,
        [`${image_prefixCls}-img-error`]: loadStatus === "error",
        [imgCls]: Boolean(imgCls)
      }),
      width: width,
      height: height,
      crossOrigin: crossOrigin,
      onError: this.handleError,
      onLoad: this.handleLoaded
    })), loadStatus !== "success" && this.renderExtra(), canPreview && /*#__PURE__*/react.createElement(PreviewInner, Object.assign({}, previewProps, {
      src: previewSrc,
      visible: previewVisible,
      onVisibleChange: this.handlePreviewVisibleChange,
      crossOrigin: !isUndefined_default()(crossOrigin) ? crossOrigin : previewProps === null || previewProps === void 0 ? void 0 : previewProps.crossOrigin,
      setDownloadName: setDownloadName
    })));
  }
}
image_Image.isSemiImage = true;
image_Image.contextType = PreviewContext;
image_Image.propTypes = {
  style: (prop_types_default()).object,
  className: (prop_types_default()).string,
  src: (prop_types_default()).string,
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  height: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  alt: (prop_types_default()).string,
  placeholder: (prop_types_default()).node,
  fallback: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).node]),
  preview: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  onLoad: (prop_types_default()).func,
  onError: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  crossOrigin: (prop_types_default()).string,
  imageID: (prop_types_default()).number
};
image_Image.defaultProps = {
  preview: true
};
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/image/index.js



// import '@douyinfe/semi-foundation/lib/es/image/image.css';
/* harmony default export */ var es_image = (image_Image);

;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/index.js
// import './_base/base.css';


















































































/** Form */





/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 73431:
/***/ (function(module) {

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

function LinearEasing (x) {
  return x;
}

module.exports = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  if (mX1 === mY1 && mX2 === mY2) {
    return LinearEasing;
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  for (var i = 0; i < kSplineTableSize; ++i) {
    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};


/***/ }),

/***/ 735:
/***/ (function(module) {

"use strict";


const copyTextToClipboard = (input, {target = document.body} = {}) => {
	const element = document.createElement('textarea');
	const previouslyFocusedElement = document.activeElement;

	element.value = input;

	// Prevent keyboard from showing on mobile
	element.setAttribute('readonly', '');

	element.style.contain = 'strict';
	element.style.position = 'absolute';
	element.style.left = '-9999px';
	element.style.fontSize = '12pt'; // Prevent zooming on iOS

	const selection = document.getSelection();
	let originalRange = false;
	if (selection.rangeCount > 0) {
		originalRange = selection.getRangeAt(0);
	}

	target.append(element);
	element.select();

	// Explicit selection workaround for iOS
	element.selectionStart = 0;
	element.selectionEnd = input.length;

	let isSuccess = false;
	try {
		isSuccess = document.execCommand('copy');
	} catch (_) {}

	element.remove();

	if (originalRange) {
		selection.removeAllRanges();
		selection.addRange(originalRange);
	}

	// Get the focus back on the previously focused element, if any
	if (previouslyFocusedElement) {
		previouslyFocusedElement.focus();
	}

	return isSuccess;
};

module.exports = copyTextToClipboard;
// TODO: Remove this for the next major release
module.exports["default"] = copyTextToClipboard;


/***/ }),

/***/ 87394:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
module.exports = exports.default;

/***/ }),

/***/ 88609:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assign;
function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
module.exports = exports.default;

/***/ }),

/***/ 46420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = cloneObject;
var _index = _interopRequireDefault(__webpack_require__(88609));
function cloneObject(object) {
  return (0, _index.default)({}, object);
}
module.exports = exports.default;

/***/ }),

/***/ 97561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(82512));
var _default = _index.default;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 98729:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 52084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(21603));
var _index2 = _interopRequireDefault(__webpack_require__(91354));
var _index3 = _interopRequireDefault(__webpack_require__(81370));
var _index4 = _interopRequireDefault(__webpack_require__(60623));
var _index5 = _interopRequireDefault(__webpack_require__(66226));
var _index6 = _interopRequireDefault(__webpack_require__(87394));
var _index7 = _interopRequireDefault(__webpack_require__(62699));
var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return _index7.default.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0, _index5.default)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index6.default)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return (0, _index6.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0, _index3.default)(date);

    // Padding
    return (0, _index6.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return (0, _index6.default)(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return _index7.default.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return (0, _index6.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0, _index4.default)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0, _index2.default)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return _index7.default.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = (0, _index.default)(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return (0, _index6.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return (0, _index6.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return (0, _index6.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return (0, _index6.default)(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return _index7.default.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return _index7.default.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return _index7.default.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return _index7.default.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return _index7.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index6.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index6.default)(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index6.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 62699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(87394));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 95209:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 93561:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

/***/ }),

/***/ 21603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCDayOfYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 91354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(80079));
var _index3 = _interopRequireDefault(__webpack_require__(94275));
var _index4 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 81370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(80079));
function getUTCISOWeekYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 60623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(69209));
var _index3 = _interopRequireDefault(__webpack_require__(34118));
var _index4 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 66226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(69209));
var _index4 = _interopRequireDefault(__webpack_require__(82084));
var _index5 = __webpack_require__(98729);
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 56736:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 68734:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
module.exports = exports.default;

/***/ }),

/***/ 80079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 94275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(81370));
var _index2 = _interopRequireDefault(__webpack_require__(80079));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 69209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(82084));
var _index4 = __webpack_require__(98729);
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index4.getDefaultOptions)();
  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 34118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(66226));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(69209));
var _index4 = _interopRequireDefault(__webpack_require__(82084));
var _index5 = __webpack_require__(98729);
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0, _index.default)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, options);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 82084:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(82084));
var _index2 = _interopRequireDefault(__webpack_require__(71171));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}
module.exports = exports.default;

/***/ }),

/***/ 15616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var _index = _interopRequireDefault(__webpack_require__(39989));
var _index2 = _interopRequireDefault(__webpack_require__(33239));
var _index3 = _interopRequireDefault(__webpack_require__(71171));
var _index4 = _interopRequireDefault(__webpack_require__(52084));
var _index5 = _interopRequireDefault(__webpack_require__(95209));
var _index6 = _interopRequireDefault(__webpack_require__(93561));
var _index7 = __webpack_require__(56736);
var _index8 = _interopRequireDefault(__webpack_require__(82084));
var _index9 = _interopRequireDefault(__webpack_require__(68734));
var _index10 = __webpack_require__(98729);
var _index11 = _interopRequireDefault(__webpack_require__(97561));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0, _index9.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0, _index10.getDefaultOptions)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0, _index3.default)(dirtyDate);
  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0, _index6.default)(originalDate);
  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index5.default[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = _index4.default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

/***/ }),

/***/ 62382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _index = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0, _index.default)(1, arguments);
  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = exports.default;

/***/ }),

/***/ 39989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValid;
var _index = _interopRequireDefault(__webpack_require__(62382));
var _index2 = _interopRequireDefault(__webpack_require__(71171));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index3.default)(1, arguments);
  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0, _index2.default)(dirtyDate);
  return !isNaN(Number(date));
}
module.exports = exports.default;

/***/ }),

/***/ 20289:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
module.exports = exports.default;

/***/ }),

/***/ 16245:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
module.exports = exports.default;

/***/ }),

/***/ 43421:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
module.exports = exports.default;

/***/ }),

/***/ 78926:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
module.exports = exports.default;

/***/ }),

/***/ 71924:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var _default = formatDistance;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 76469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(20289));
var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 5102:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var _default = formatRelative;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 87839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(16245));
var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 9796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(43421));
var _index2 = _interopRequireDefault(__webpack_require__(78926));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index2.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0, _index.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 82512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(71924));
var _index2 = _interopRequireDefault(__webpack_require__(76469));
var _index3 = _interopRequireDefault(__webpack_require__(5102));
var _index4 = _interopRequireDefault(__webpack_require__(87839));
var _index5 = _interopRequireDefault(__webpack_require__(9796));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 33239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(5065));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(82084));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index2.default)(2, arguments);
  var amount = (0, _index3.default)(dirtyAmount);
  return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

/***/ }),

/***/ 71171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _index = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
module.exports = exports.default;

/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 44286:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 86556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 20731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    arrayMap = __webpack_require__(29932),
    baseUnary = __webpack_require__(7518),
    cacheHas = __webpack_require__(74757);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 56029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 53325:
/***/ (function(module) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),

/***/ 78565:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 41761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 23933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 42980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    assignMergeValue = __webpack_require__(86556),
    baseFor = __webpack_require__(28483),
    baseMergeDeep = __webpack_require__(59783),
    isObject = __webpack_require__(13218),
    keysIn = __webpack_require__(81704),
    safeGet = __webpack_require__(36390);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 59783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(86556),
    cloneBuffer = __webpack_require__(64626),
    cloneTypedArray = __webpack_require__(77133),
    copyArray = __webpack_require__(278),
    initCloneObject = __webpack_require__(38517),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLikeObject = __webpack_require__(29246),
    isBuffer = __webpack_require__(44144),
    isFunction = __webpack_require__(23560),
    isObject = __webpack_require__(13218),
    isPlainObject = __webpack_require__(68630),
    isTypedArray = __webpack_require__(36719),
    safeGet = __webpack_require__(36390),
    toPlainObject = __webpack_require__(59881);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 25970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePickBy = __webpack_require__(63012),
    hasIn = __webpack_require__(79095);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 63012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSet = __webpack_require__(10611),
    castPath = __webpack_require__(71811);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 10611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    castPath = __webpack_require__(71811),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 40180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 21463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 67740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    isArrayLike = __webpack_require__(98612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 60696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 36390:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 83140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(44286),
    hasUnicode = __webpack_require__(62689),
    unicodeToArray = __webpack_require__(676);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 676:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 28583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    copyObject = __webpack_require__(98363),
    createAssigner = __webpack_require__(21463),
    isArrayLike = __webpack_require__(98612),
    isPrototype = __webpack_require__(25726),
    keys = __webpack_require__(3674);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ 53888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 91966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseDifference = __webpack_require__(20731),
    baseFlatten = __webpack_require__(21078),
    baseRest = __webpack_require__(5976),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),

/***/ 66073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84486);


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 13311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(67740),
    findIndex = __webpack_require__(30998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 30998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIteratee = __webpack_require__(67206),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 84486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(77412),
    baseEach = __webpack_require__(89881),
    castFunction = __webpack_require__(54290),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 18721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(78565),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 64721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118),
    isArrayLike = __webpack_require__(98612),
    isString = __webpack_require__(47037),
    toInteger = __webpack_require__(40554),
    values = __webpack_require__(52628);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 51584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 47960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsDate = __webpack_require__(41761),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 45220:
/***/ (function(module) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ 81763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 96347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(23933),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 52353:
/***/ (function(module) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 35161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 6162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseExtremum = __webpack_require__(56029),
    baseGt = __webpack_require__(53325),
    identity = __webpack_require__(6557);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

module.exports = max;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 82492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(42980),
    createAssigner = __webpack_require__(21463);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(60696),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 78718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePick = __webpack_require__(25970),
    flatRest = __webpack_require__(99021);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 36968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(10611);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 12571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259),
    isIterateeCall = __webpack_require__(16612),
    toInteger = __webpack_require__(40554);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ 71640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531),
    castSlice = __webpack_require__(40180),
    hasUnicode = __webpack_require__(62689),
    isIterateeCall = __webpack_require__(16612),
    isRegExp = __webpack_require__(96347),
    stringToArray = __webpack_require__(83140),
    toString = __webpack_require__(79833);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 30084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    copyArray = __webpack_require__(278),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448),
    stringToPath = __webpack_require__(55514),
    toKey = __webpack_require__(40327),
    toString = __webpack_require__(79833);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ 59881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 44908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 98601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUnset = __webpack_require__(57406);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(49052);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 60357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(1045).style;


/***/ }),

/***/ 49052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "getMenuCurrent": function() { return /* binding */ getMenuCurrent; },
  "getMenuParent": function() { return /* binding */ getMenuParent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(10797);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/esm/production/react.js + 16 modules
var react = __webpack_require__(48143);
// EXTERNAL MODULE: ./stores/index.tsx
var stores = __webpack_require__(62010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/index.js + 488 modules
var es = __webpack_require__(85957);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/components/Icon.js + 1 modules
var Icon = __webpack_require__(86360);
;// CONCATENATED MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconMailStroked1.js


function SvgComponent(props) {
  return /*#__PURE__*/node_modules_react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/node_modules_react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8.0412L13.3183 12.405C12.6314 12.7706 11.7962 12.7706 11.1093 12.405L3 7.79829L3 18H21V8.0412ZM4.29229 6L12.2138 10.5L20.1353 6H4.29229ZM1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V6.90481L23.0001 6.90499L23 6.90505V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6Z",
    fill: "currentColor"
  }));
}
const IconComponent = (0,Icon/* convertIcon */.A)(SvgComponent, 'mail_stroked_1');
/* harmony default export */ var IconMailStroked1 = (IconComponent);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-icons/lib/es/icons/IconChevronLeft.js
var IconChevronLeft = __webpack_require__(52689);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/esm/production/react-client/index.js
var react_client = __webpack_require__(81627);
// EXTERNAL MODULE: ./components/navbar/styles.module.scss
var styles_module = __webpack_require__(9181);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/useRequest.tsx
var useRequest = __webpack_require__(54013);
;// CONCATENATED MODULE: ./components/navbar/index.tsx

















/* harmony default export */ function navbar(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router.useRouter)();
    var t = (0,react_client/* useTranslations */.T_)();
    var request = (0,useRequest/* default */.Z)();
    var ref = (0,node_modules_react.useContext)(stores/* IndexContext */.Z), menuList = ref.menuList, menuCurrent = ref.menuCurrent, menuParent = ref.menuParent, webInfo = ref.webInfo;
    var difference = (0,node_modules_react.useMemo)(function() {
        var ref;
        var exhibition_start_time = Number((ref = webInfo === null || webInfo === void 0 ? void 0 : webInfo.find(function(item) {
            return item.code === "exhibition_start_time";
        })) === null || ref === void 0 ? void 0 : ref.content);
        var _difference = String(Math.ceil((exhibition_start_time - Date.now()) / (1000 * 60 * 60 * 24)));
        return _difference;
    }, [
        webInfo
    ]);
    var ref1 = (0,node_modules_react.useState)(false), isShowMenu = ref1[0], setIsShowMenu = ref1[1];
    var changeLang = (0,node_modules_react.useCallback)(function(locale) {
        router.push(router.asPath, router.asPath, {
            locale: locale
        });
    }, [
        router
    ]);
    var getTreeData = (0,node_modules_react.useCallback)(function(data) {
        return data === null || data === void 0 ? void 0 : data.map(function(item) {
            return (0,_object_spread/* default */.Z)({
                label: item === null || item === void 0 ? void 0 : item.title,
                key: String(item === null || item === void 0 ? void 0 : item.id),
                children: getTreeData((item === null || item === void 0 ? void 0 : item.childlist) || [])
            }, item);
        });
    }, []);
    var renderFullLabel = (0,node_modules_react.useCallback)(function(param) {
        var className = param.className, data = param.data, expandIcon = param.expandIcon, onClick = param.onClick, onExpand = param.onExpand;
        var isLeaf = !(data.children && data.children.length);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: className,
            role: "treeitem",
            onClick: isLeaf ? onClick : onExpand,
            children: [
                isLeaf ? null : expandIcon,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: data === null || data === void 0 ? void 0 : data.label
                })
            ]
        });
    }, []);
    var gotoPage = (0,node_modules_react.useCallback)(function(item) {
        setIsShowMenu(false);
        if ((item === null || item === void 0 ? void 0 : item._target) == "_blank") {
            window.open(item === null || item === void 0 ? void 0 : item._href, "_blank");
        } else {
            router.push(item === null || item === void 0 ? void 0 : item._href, item === null || item === void 0 ? void 0 : item._href, {});
        }
    }, []);
    var ref2 = (0,node_modules_react.useState)({
        truename: "",
        mobile: "",
        email: "",
        company: ""
    }), formModel = ref2[0], setFormModel = ref2[1];
    var ref3 = (0,node_modules_react.useState)(true), isShowMessage = ref3[0], setIsShowMessage = ref3[1];
    var submitMessage = (0,node_modules_react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(formModel === null || formModel === void 0 ? void 0 : formModel.truename) || router.locale === "cn" && !(formModel === null || formModel === void 0 ? void 0 : formModel.mobile) || router.locale === "en" && !(formModel === null || formModel === void 0 ? void 0 : formModel.email) || !(formModel === null || formModel === void 0 ? void 0 : formModel.company)) {
                        return [
                            2,
                            es/* Toast.error */.FN.error({
                                content: t("common.message.fill")
                            })
                        ];
                    }
                    return [
                        4,
                        request.post("/addMessageBoard", (0,_object_spread/* default */.Z)({}, formModel))
                    ];
                case 1:
                    data = _state.sent().data;
                    if ((data === null || data === void 0 ? void 0 : data.code) == 200) {
                        es/* Toast.success */.FN.success({
                            content: t("common.message.success")
                        });
                        setFormModel({
                            truename: "",
                            mobile: "",
                            email: "",
                            company: ""
                        });
                    } else {
                        es/* Toast.error */.FN.error({
                            content: data.msg
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        formModel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "jsx-c203098bf89b2062" + " " + (classnames_default()((styles_module_default()).header, router.locale === "en" && (styles_module_default()).en) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).logo || ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://img.ipbexpo.com/editor/20260107/5d22555ed4f42918d3e8cebc75b155aa695e1074dfcf5.png",
                        alt: "",
                        className: "jsx-c203098bf89b2062"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).menu || ""),
                children: menuList === null || menuList === void 0 ? void 0 : menuList.map(function(item, index) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).childs || ""),
                            children: item === null || item === void 0 ? void 0 : (ref = item.childlist) === null || ref === void 0 ? void 0 : ref.map(function(child) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    className: "jsx-c203098bf89b2062",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (child === null || child === void 0 ? void 0 : child._href) || "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: (child === null || child === void 0 ? void 0 : child._target) || "_self",
                                            className: "jsx-c203098bf89b2062" + " " + (classnames_default()([
                                                (styles_module_default()).child,
                                                ((child === null || child === void 0 ? void 0 : child._href) == (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._href) || (child === null || child === void 0 ? void 0 : child.id) == (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent.id)) && (styles_module_default()).active
                                            ]) || ""),
                                            children: child.title
                                        })
                                    })
                                }, child === null || child === void 0 ? void 0 : child.id);
                            })
                        }),
                        getPopupContainer: function() {
                            return document.getElementById("item_".concat(item === null || item === void 0 ? void 0 : item.id));
                        },
                        showArrow: true,
                        style: {
                            display: (item === null || item === void 0 ? void 0 : (ref1 = item.childlist) === null || ref1 === void 0 ? void 0 : ref1.length) ? "block" : "none"
                        },
                        trigger: "hover",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            id: "item_".concat(item === null || item === void 0 ? void 0 : item.id),
                            className: "jsx-c203098bf89b2062" + " " + (classnames_default()([
                                (styles_module_default()).item,
                                ((item === null || item === void 0 ? void 0 : item._href) == (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._href) || (item === null || item === void 0 ? void 0 : item.id) == (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent.pid)) && (styles_module_default()).active
                            ]) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (item === null || item === void 0 ? void 0 : item._href) || "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: (item === null || item === void 0 ? void 0 : item._target) || "_self",
                                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).link || ""),
                                        children: item.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    style: {
                                        display: "none"
                                    },
                                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).childs || ""),
                                    children: item === null || item === void 0 ? void 0 : (ref2 = item.childlist) === null || ref2 === void 0 ? void 0 : ref2.map(function(child) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-c203098bf89b2062",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (child === null || child === void 0 ? void 0 : child._href) || "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: (child === null || child === void 0 ? void 0 : child._target) || "_self",
                                                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).child || ""),
                                                    children: child.title
                                                })
                                            })
                                        }, child === null || child === void 0 ? void 0 : child.id);
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).btns || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "lang",
                        onClick: function() {
                            return changeLang(router.locale === "en" ? "cn" : "en");
                        },
                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).lang || ""),
                        children: router.locale === "en" ? "中文" : "English"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).countdown || ""),
                        children: [
                            t("common.cout"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-c203098bf89b2062",
                                children: difference
                            }),
                            t("common.day")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/image/menu.png",
                alt: "",
                onClick: function() {
                    return setIsShowMenu(!isShowMenu);
                },
                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).nav || "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SideSheet */.Uu, {
                title: "IPB 2027",
                placement: "left",
                visible: isShowMenu,
                width: "75%",
                onCancel: function() {
                    return setIsShowMenu(!isShowMenu);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tree */.mp, {
                    treeData: getTreeData(menuList),
                    renderFullLabel: renderFullLabel,
                    onSelect: function(selectedKey, selected, selectedNode) {
                        gotoPage(selectedNode);
                    }
                })
            }),
            isShowMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).message || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/image/engineer2.png",
                        alt: "",
                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).elf || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/image/icon-close.png",
                        alt: "",
                        onClick: function() {
                            return setIsShowMessage(false);
                        },
                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).close || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).wrap || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).hint || ""),
                                children: t("common.message.hint")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                className: (styles_module_default()).input,
                                value: formModel.truename,
                                onChange: function(value) {
                                    return setFormModel((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formModel), {
                                        truename: value
                                    }));
                                },
                                placeholder: t("common.message.truename"),
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/image/icon-user.png",
                                    alt: "",
                                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).icon || "")
                                })
                            }),
                            router.locale == "cn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                className: (styles_module_default()).input,
                                value: formModel.mobile,
                                onChange: function(value) {
                                    return setFormModel((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formModel), {
                                        mobile: value
                                    }));
                                },
                                placeholder: t("common.message.mobile"),
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/image/icon-phone.png",
                                    alt: "",
                                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).icon || "")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                className: (styles_module_default()).input,
                                value: formModel.email,
                                onChange: function(value) {
                                    return setFormModel((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formModel), {
                                        email: value
                                    }));
                                },
                                placeholder: t("common.message.email"),
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMailStroked1, {
                                    className: (styles_module_default()).icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                className: (styles_module_default()).input,
                                value: formModel.company,
                                onChange: function(value) {
                                    return setFormModel((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formModel), {
                                        company: value
                                    }));
                                },
                                placeholder: t("common.message.company"),
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/image/icon-office.png",
                                    alt: "",
                                    className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).icon || "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: (styles_module_default()).btn,
                                onClick: submitMessage,
                                children: t("common.message.submit")
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setIsShowMessage(true);
                },
                className: "jsx-c203098bf89b2062" + " " + ((styles_module_default()).spread || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronLeft/* default */.Z, {})
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "c203098bf89b2062",
                children: ".semi-portal{z-index:10000!important}.semi-sidesheet-title{width:80%}.semi-tree-option{padding:8px 12px!important}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/footer/styles.module.scss
var footer_styles_module = __webpack_require__(50969);
var footer_styles_module_default = /*#__PURE__*/__webpack_require__.n(footer_styles_module);
;// CONCATENATED MODULE: ./components/footer/index.tsx












/* harmony default export */ function footer(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router.useRouter)();
    var t = (0,react_client/* useTranslations */.T_)();
    var request = (0,useRequest/* default */.Z)();
    var ref = (0,node_modules_react.useState)({
        company: "",
        truename: "",
        email: ""
    }), formData = ref[0], setFormData = ref[1];
    var onChage = (0,node_modules_react.useCallback)(function(e, type) {
        var data = (0,_object_spread/* default */.Z)({}, formData);
        data[type] = e.target.value;
        setFormData(data);
    }, [
        formData
    ]);
    var subscribe = (0,node_modules_react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var regex, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!formData.company || !formData.truename || !formData.email) {
                        es/* Toast.error */.FN.error({
                            content: t("common.tips.all"),
                            duration: 3
                        });
                        return [
                            2
                        ];
                    }
                    regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!regex.test(formData.email)) {
                        es/* Toast.error */.FN.error({
                            content: t("common.tips.email"),
                            duration: 3
                        });
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        request.post("/addSubscribe", {
                            company: formData.company,
                            truename: formData.truename,
                            email: formData.email
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    if (data.code === 200) {
                        es/* Toast.success */.FN.success({
                            content: data === null || data === void 0 ? void 0 : data.msg,
                            duration: 3
                        });
                    } else {
                        es/* Toast.error */.FN.error({
                            content: data === null || data === void 0 ? void 0 : data.msg,
                            duration: 3
                        });
                    }
                    if (data === null || data === void 0 ? void 0 : data.code) {
                        setFormData({
                            company: "",
                            truename: "",
                            email: ""
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        formData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (footer_styles_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_styles_module_default()).subscribe,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: (footer_styles_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/image/subscribe-icon.png",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (footer_styles_module_default()).tips,
                        children: [
                            t("common.subscribe1"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t("common.getNew")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (footer_styles_module_default()).form,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (footer_styles_module_default()).input,
                                type: "text",
                                placeholder: t("common.placeholder.company"),
                                value: formData.company,
                                onChange: function(e) {
                                    return onChage(e, "company");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: (footer_styles_module_default()).line
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (footer_styles_module_default()).input,
                                type: "text",
                                placeholder: t("common.placeholder.name"),
                                value: formData.truename,
                                onChange: function(e) {
                                    return onChage(e, "truename");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: (footer_styles_module_default()).line
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (footer_styles_module_default()).input,
                                type: "text",
                                placeholder: t("common.placeholder.email"),
                                value: formData.email,
                                onChange: function(e) {
                                    return onChage(e, "email");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (footer_styles_module_default()).button,
                                onClick: subscribe,
                                children: t("common.subscribe")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_styles_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((footer_styles_module_default()).top, "m-1480"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (footer_styles_module_default()).logo,
                                src: "/image/footer-logo.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_styles_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (footer_styles_module_default()).left,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (footer_styles_module_default()).time,
                                                children: t("common.time")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).site,
                                                children: [
                                                    t("common.site"),
                                                    router.locale === "en" && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    t("common.location")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (footer_styles_module_default()).middle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).unit,
                                                children: [
                                                    t("common.organizers"),
                                                    "：",
                                                    t("common.organizer1")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).phone,
                                                children: [
                                                    t("common.telephone"),
                                                    "：",
                                                    router.locale === "en" ? "+86 " : "",
                                                    "021-6036-5871"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).email,
                                                children: [
                                                    t("common.email"),
                                                    "：ipb@nm-china.com.cn"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).address,
                                                children: [
                                                    t("common.companySite"),
                                                    "：",
                                                    t("common.companySite1")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (footer_styles_module_default()).middle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).unit,
                                                children: [
                                                    t("common.organizers"),
                                                    "：",
                                                    t("common.organizer2")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).phone,
                                                children: [
                                                    t("common.telephone"),
                                                    "：010-62647647/62647657"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).email,
                                                children: [
                                                    t("common.email"),
                                                    "：klxh@ipe.ac.cn"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (footer_styles_module_default()).address,
                                                children: [
                                                    t("common.companySite"),
                                                    "：",
                                                    t("common.companySite2")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (footer_styles_module_default()).right,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (footer_styles_module_default()).follow,
                                                children: t("common.attention")
                                            }),
                                            router.locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (footer_styles_module_default()).icons,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://www.linkedin.com/company/ipb-%E2%80%93-international-processing-trade-fair-for-powder-bulk-solids-and-fluids",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/image/linkedin.png",
                                                            alt: "linkedin"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://www.facebook.com/profile.php?id=61570741266909",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/image/facebook.png",
                                                            alt: "facebook"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (footer_styles_module_default()).list,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (footer_styles_module_default()).item,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/image/wxcode.png",
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("common.wxOfficial")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (footer_styles_module_default()).item,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/image/video-code.png",
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("common.wxVideo")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((footer_styles_module_default()).bottom, "m-1480"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    t("common.organizers"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/image/sponsor1.png",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/image/sponsor2.png",
                                        alt: ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    t("common.powered"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/image/sponsor3.png",
                                        alt: ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    t("common.supported1"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/image/sponsor4.png",
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_styles_module_default()).copyright,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (footer_styles_module_default()).privacy,
                        href: "".concat(router.locale === "en" ? "/en" : "", "/privacypolicy"),
                        target: "_blank",
                        children: t("common.privacy")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("common.copyright"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                href: "https://beian.miit.gov.cn/#/Integrated/index",
                                children: " \xa9 2026 沪ICP备09011147号-16"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/layout/styles.module.scss
var layout_styles_module = __webpack_require__(95504);
var layout_styles_module_default = /*#__PURE__*/__webpack_require__.n(layout_styles_module);
;// CONCATENATED MODULE: ./components/layout/index.tsx






/* harmony default export */ function layout(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var headerBlackList = [];
    var footerBlackList = [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((layout_styles_module_default()).layout, router.locale === "en" ? (layout_styles_module_default()).en : "cn"),
        children: [
            !headerBlackList.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (layout_styles_module_default()).main,
                children: children
            }),
            !footerBlackList.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};

// EXTERNAL MODULE: ./utils/request.ts
var request = __webpack_require__(45844);
// EXTERNAL MODULE: ./pages/global.scss
var global = __webpack_require__(32797);
;// CONCATENATED MODULE: ./pages/_app.tsx












var processMenu = function(menu, locale) {
    return menu.map(function(item) {
        var ref, ref1, ref2, ref3, ref4;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            _href: (item === null || item === void 0 ? void 0 : item.out_link) || ((item === null || item === void 0 ? void 0 : (ref = item.childlist) === null || ref === void 0 ? void 0 : ref.length) > 0 ? ((ref1 = item === null || item === void 0 ? void 0 : item.childlist[0]) === null || ref1 === void 0 ? void 0 : ref1.out_link) || ((ref2 = item === null || item === void 0 ? void 0 : item.childlist[0]) === null || ref2 === void 0 ? void 0 : ref2.path) : item === null || item === void 0 ? void 0 : item.path),
            _target: (item === null || item === void 0 ? void 0 : item.out_link) ? item === null || item === void 0 ? void 0 : item.target : (item === null || item === void 0 ? void 0 : (ref3 = item.childlist) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? (ref4 = item === null || item === void 0 ? void 0 : item.childlist[0]) === null || ref4 === void 0 ? void 0 : ref4.target : item === null || item === void 0 ? void 0 : item.target,
            childlist: (0,_to_consumable_array/* default */.Z)(processMenu(item === null || item === void 0 ? void 0 : item.childlist, locale))
        });
    });
};
var getMenuCurrent = function(menu, path) {
    for(var i = 0; i < (menu === null || menu === void 0 ? void 0 : menu.length); i++){
        var item = menu[i];
        if (item.path === path) {
            return item;
        }
        if (item.childlist && Array.isArray(item.childlist)) {
            var child = getMenuCurrent(item.childlist, path);
            if (child) {
                return child;
            }
        }
    }
    return null;
};
var getMenuParent = function(menu, pid) {
    for(var i = 0; i < (menu === null || menu === void 0 ? void 0 : menu.length); i++){
        var item = menu[i];
        if (item.childlist && Array.isArray(item.childlist)) {
            if (item.id === pid) {
                return item;
            }
        }
    }
    return null;
};
function MyApp(data) {
    var Component = data.Component, pageProps = data.pageProps, router = data.router, locale = data.locale, messages = data.messages, menuList = data.menuList, webInfo = data.webInfo;
    var menuCurrent = getMenuCurrent(menuList, router.pathname);
    var menuParent = getMenuParent(menuList, menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent.pid);
    console.log("MyApp", menuList, menuCurrent, menuParent);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "IPB国际粉体、散料、流体加工展览会"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "IPB国际粉体、散料、流体加工展览会"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "IPB国际粉体、散料、流体加工展览会"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "thumbnail",
                        content: "/image/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: "/image/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "baidu-site-verification",
                        content: "codeva-woSxZfgccH"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        defer: true,
                        dangerouslySetInnerHTML: {
                            __html: ' \n              var _hmt = _hmt || [];\n              (function() {\n                var hm = document.createElement("script");\n                hm.src = "https://hm.baidu.com/hm.js?9b7475c8f53ba3c89d5c6afc1eb987b5";\n                var s = document.getElementsByTagName("script")[0]; \n                s.parentNode.insertBefore(hm, s);\n              })();\n            '
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* IntlProvider */.Pj, {
                locale: locale,
                messages: messages,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stores/* IndexContextProvider */.F, {
                    value: {
                        menuList: menuList,
                        menuCurrent: menuCurrent,
                        menuParent: menuParent,
                        webInfo: webInfo
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                    })
                })
            })
        ]
    });
}
MyApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, locale, data, ref1, info, messages;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = context === null || context === void 0 ? void 0 : (ref = context.ctx) === null || ref === void 0 ? void 0 : ref.locale;
                    return [
                        4,
                        request/* default.get */.Z.get("/getHomeMenuList", {
                            headers: {
                                lang: locale || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        4,
                        request/* default.get */.Z.get("/getWebInfo", {
                            headers: {
                                lang: locale || "cn"
                            }
                        })
                    ];
                case 2:
                    ref1 = _state.sent(), info = ref1.data;
                    return [
                        4,
                        __webpack_require__(87179)("./".concat(locale, "/common.json"))
                    ];
                case 3:
                    messages = _state.sent();
                    // console.log("getInitialProps", messages);
                    return [
                        2,
                        {
                            locale: locale,
                            messages: messages,
                            menuList: processMenu((data === null || data === void 0 ? void 0 : data.data) || [], locale) || [],
                            webInfo: (info === null || info === void 0 ? void 0 : info.data) || {}
                        }
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 62010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ IndexContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ IndexContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10797);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54013);










var IndexContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var IndexContextProvider = function(param) {
    var children = param.children, value = param.value;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), nav = ref[0], setNav = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isHeadFoot = ref1[0], setIsHeadFoot = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBecome = ref2[0], setIsBecome = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), webInfo = ref3[0], setWebInfo = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("cn"), lang = ref4[0], setLang = ref4[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var transTree = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(root) {
        if (!root.length) return [];
        return root.map(function(item) {
            var id = item.id, title = item.title, path = item.path, pid = item.pid, childlist = item.childlist, arg = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(item, [
                "id",
                "title",
                "path",
                "pid",
                "childlist"
            ]);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, arg), {
                id: id,
                name: title,
                path: path,
                parent: pid,
                children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(transTree(childlist))
            });
        });
    }, [
        router
    ]);
    var getNav = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(lang) {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.get("/getHomeMenuList", {
                                headers: {
                                    lang: lang
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        setNav(transTree(data.data));
                        return [
                            2
                        ];
                }
            });
        });
        return function(lang) {
            return _ref.apply(this, arguments);
        };
    }(), [
        request,
        router
    ]);
    var getWebInfo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/getWebInfo")
                    ];
                case 1:
                    data = _state.sent().data;
                    setWebInfo(data.data);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getNav(router.locale || "cn");
        getWebInfo();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IndexContext.Provider, {
        value: {
            nav: nav,
            webInfo: value === null || value === void 0 ? void 0 : value.webInfo,
            menuList: value === null || value === void 0 ? void 0 : value.menuList,
            menuCurrent: value === null || value === void 0 ? void 0 : value.menuCurrent,
            menuParent: value === null || value === void 0 ? void 0 : value.menuParent,
            isBecome: isBecome,
            isHeadFoot: isHeadFoot,
            getNav: function(lang) {
                getNav(lang);
            },
            setIsHeadFoot: function(_isHeadFoot) {
                setIsHeadFoot(_isHeadFoot);
            },
            setIsBecome: function(_isBecome) {
                setIsBecome(_isBecome);
            }
        },
        children: children
    });
};


/***/ }),

/***/ 45844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var instance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    // 服务端请求添加baseURL（因为服务端请求不会在路径前加上当前域名）
    baseURL:  false ? 0 : ""
});
instance.interceptors.request.use(function(config) {
    // console.log("请求拦截", config);
    return config;
}, function(error) {
    return Promise.reject(error);
});
instance.interceptors.response.use(function(response) {
    // console.log("响应拦截", response);
    return response;
}, function(error) {
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (instance);


/***/ }),

/***/ 54013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var useRequest = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var request = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var lang = router.locale;
    // 创建axios实例
    request.current = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: "/axiosapi",
        timeout: 80000,
        withCredentials: true
    });
    // request拦截器
    request.current.interceptors.request.use(function(config) {
        // 获取token
        // let token = localStorage.getItem("token");
        // if (token) {
        //   // 添加请求头
        //   config.headers["token"] = token
        // }
        if (!config.headers.lang) {
            config.headers["lang"] = lang;
        }
        return config;
    }, function(error) {
        return Promise.reject(error);
    });
    // response 拦截器
    request.current.interceptors.response.use(function(response) {
        var ref, ref1, ref2;
        if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.code) === 500) {}
        if (((ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.code) === 208 || ((ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.code) === 207) {}
        // if (response.data instanceof Blob) {
        //   const reader = new FileReader() as any;
        //   reader.readAsText(response.data, 'utf-8');
        //   reader.onload = function () {
        //     const res = reader.result[0] !== '{' ? 200 : JSON.parse(reader.result)
        //     if (res?.code === 500) {
        //     }
        //   }
        //   return response
        // }
        return response;
    }, function(error) {
        if (error.response.status == 401) {} else if (error.response.status === 500) {}
        return Promise.reject(error);
    });
    return request.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (useRequest);


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 50969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__V98HG","footer":"styles_footer__dvZbv","subscribe":"styles_subscribe__dqVrn","icon":"styles_icon__nYvZi","tips":"styles_tips__6YW0M","form":"styles_form__BMUGd","input":"styles_input__xATYp","line":"styles_line__3RaY0","button":"styles_button__62UhB","info":"styles_info__Ix0dm","top":"styles_top__tmjBR","logo":"styles_logo__5WlNI","content":"styles_content__MIRXx","left":"styles_left___39WB","time":"styles_time__T4ttu","site":"styles_site__jTDBK","middle":"styles_middle__elrNv","unit":"styles_unit__Xh6Ad","phone":"styles_phone__4j49v","email":"styles_email__90Jop","address":"styles_address__xqVLc","right":"styles_right__GJxYP","follow":"styles_follow__Jjo20","list":"styles_list__0NO1p","item":"styles_item__Yfyef","icons":"styles_icons__lyvE5","bottom":"styles_bottom__3_bnr","copyright":"styles_copyright__5tnsS"};

/***/ }),

/***/ 95504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__9nb8q","layout":"styles_layout__ewyWz","en":"styles_en__kc7Rp","main":"styles_main__NgTls"};

/***/ }),

/***/ 9181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__ORnKh","header":"styles_header__JFYX5","en":"styles_en__O1mwW","menu":"styles_menu__lEzIn","item":"styles_item__klbMG","logo":"styles_logo__XEomT","active":"styles_active__TbPbc","link":"styles_link__LZbXw","childs":"styles_childs__FYJbE","child":"styles_child__CiQMp","btns":"styles_btns__cGIFc","lang":"styles_lang__o813r","langs":"styles_langs__e19xT","countdown":"styles_countdown__BK0MH","nav":"styles_nav__Wvtw7","message":"styles_message__bcg_7","elf":"styles_elf__UuSEh","close":"styles_close__W9ckR","wrap":"styles_wrap__Nz2GZ","hint":"styles_hint__Ziwyv","input":"styles_input__VdmsC","icon":"styles_icon__j1fkw","btn":"styles_btn__ht2ps","spread":"styles_spread__cgSyv"};

/***/ }),

/***/ 32797:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 55721:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = newDateUTC;

/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}

module.exports = exports.default;

/***/ }),

/***/ 25855:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzIntlTimeZoneName;

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);

  for (var i = formatted.length - 1; i >= 0; --i) {
    if (formatted[i].type === 'timeZoneName') {
      return formatted[i].value;
    }
  }
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : '';
} // If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.


function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  }

  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length
  });
}

module.exports = exports.default;

/***/ }),

/***/ 32734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzParseTimezone;

var _index = _interopRequireDefault(__webpack_require__(2712));

var _index2 = _interopRequireDefault(__webpack_require__(55721));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
}; // Parse various time zone offset formats to an offset in milliseconds

function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset; // Empty string

  if (!timezoneString) {
    return 0;
  } // Z


  token = patterns.timezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  }

  var hours; // ±hh

  token = patterns.timezoneHH.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);

    if (!validateTimezone(hours)) {
      return NaN;
    }

    return -(hours * MILLISECONDS_IN_HOUR);
  } // ±hh:mm or ±hhmm


  token = patterns.timezoneHHMM.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    return hours > 0 ? -absoluteOffset : absoluteOffset;
  } // IANA time zone


  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);
    var offset = calcOffset(utcDate, timezoneString);
    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
    return -fixedOffset;
  }

  return NaN;
}

function toUtcDate(date) {
  return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

function calcOffset(date, timezoneString) {
  var tokens = (0, _index.default)(date, timezoneString); // ms dropped because it's not provided by tzTokenizeDate

  var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS;
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime(); // Our UTC time is just a guess because our offset is just a guess

  var utcGuess = localTS - offset; // Test whether the zone matches the offset for this ts

  var o2 = calcOffset(new Date(utcGuess), timezoneString); // If so, offset didn't change, and we're done

  if (offset === o2) {
    return offset;
  } // If not, change the ts by the difference in the offset


  utcGuess -= o2 - offset; // If that gives us the local time we want, we're done

  var o3 = calcOffset(new Date(utcGuess), timezoneString);

  if (o2 === o3) {
    return o2;
  } // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time


  return Math.max(o2, o3);
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}

var validIANATimezoneCache = {};

function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true;

  try {
    new Intl.DateTimeFormat(undefined, {
      timeZone: timeZoneString
    });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 7048:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var _default = tzPattern;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 2712:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzTokenizeDate;

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date);
    var filled = [];

    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }

    return filled;
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN];
    }

    throw error;
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted); // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]

  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
} // Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.


var dtfCache = {};

function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  return dtfCache[timeZone];
}

module.exports = exports.default;

/***/ }),

/***/ 33826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(25855));

var _index2 = _interopRequireDefault(__webpack_require__(32734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_MINUTE = 60 * 1000;
var formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return (0, _index.default)('short', originalDate, options);
      // Long

      case 'zzzz':
      default:
        return (0, _index.default)('long', originalDate, options);
    }
  }
};

function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone ? (0, _index2.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();

  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError('Invalid time zone specified: ' + timeZone);
  }

  return timeZoneOffset;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes;
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimeter);
}

function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}

var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 56558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;

var _index = _interopRequireDefault(__webpack_require__(15616));

var _index2 = _interopRequireDefault(__webpack_require__(33826));

var _index3 = _interopRequireDefault(__webpack_require__(21476));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var matches = formatStr.match(tzFormattingTokensRegExp);

  if (matches) {
    var date = (0, _index3.default)(dirtyDate, options); // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.

    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result; // This is a quoted portion, matched only to ensure we don't match inside it
      }

      var pos = result.indexOf(token);
      var precededByQuotedSection = result[pos - 1] === "'";
      var replaced = result.replace(token, "'" + _index2.default[token[0]](date, token, null, options) + "'"); // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed, so it doesn't look like an escaped quote.

      return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
    }, formatStr);
  }

  return (0, _index.default)(dirtyDate, formatStr, options);
}

module.exports = exports.default;

/***/ }),

/***/ 26645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatInTimeZone;

var _index = _interopRequireDefault(__webpack_require__(46420));

var _index2 = _interopRequireDefault(__webpack_require__(56558));

var _index3 = _interopRequireDefault(__webpack_require__(1132));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name formatInTimeZone
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @param {Date|String|Number} date - the date representing the local time / real UTC time
 * @param {String} timeZone - the time zone this date should be formatted for; can be an offset or IANA time zone
 * @param {String} formatStr - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 */
function formatInTimeZone(date, timeZone, formatStr, options) {
  var extendedOptions = (0, _index.default)(options);
  extendedOptions.timeZone = timeZone;
  return (0, _index2.default)((0, _index3.default)(date, timeZone), formatStr, extendedOptions);
}

module.exports = exports.default;

/***/ }),

/***/ 24992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffset;

var _index = _interopRequireDefault(__webpack_require__(32734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getTimezoneOffset
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @description
 * Returns the time zone offset from UTC time in milliseconds for IANA time zones as well
 * as other time zone offset string formats.
 *
 * For time zones where daylight savings time is applicable a `Date` should be passed on
 * the second parameter to ensure the offset correctly accounts for DST at that time of
 * year. When omitted, the current date is used.
 *
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {Date|Number} [date] - the date with values representing the local time
 * @returns {Number} the time zone offset in milliseconds
 *
 * @example
 * const result = getTimezoneOffset('-07:00')
 *   //=> -18000000 (-7 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('Africa/Johannesburg')
 *   //=> 7200000 (2 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 0, 1))
 *   //=> -18000000 (-5 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 6, 1))
 *   //=> -14400000 (-4 * 60 * 60 * 1000)
 */
function getTimezoneOffset(timeZone, date) {
  return -(0, _index.default)(timeZone, date);
}

module.exports = exports.default;

/***/ }),

/***/ 70722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
module.exports = {
  format: __webpack_require__(56558),
  formatInTimeZone: __webpack_require__(26645),
  getTimezoneOffset: __webpack_require__(24992),
  toDate: __webpack_require__(21476),
  utcToZonedTime: __webpack_require__(1132),
  zonedTimeToUtc: __webpack_require__(68516)
};

/***/ }),

/***/ 21476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(93561));

var _index3 = _interopRequireDefault(__webpack_require__(32734));

var _index4 = _interopRequireDefault(__webpack_require__(7048));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: _index4.default
};
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  } // Clone the date


  if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = (0, _index2.default)(new Date(timestamp + time));
      offset = (0, _index2.default)(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);

    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = patterns.MM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = patterns.DDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // yyyy-MM-dd or YYYYMMDD


  token = patterns.MMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = patterns.Www.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = patterns.WwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = patterns.HH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR;
  } // hh:mm or hhmm


  token = patterns.HHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  } // hh:mm:ss or hhmmss


  token = patterns.HHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions


var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }

    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);

  if (isLeapYear && dayOfYear > 366) {
    return false;
  }

  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

module.exports = exports.default;

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = utcToZonedTime;

var _index = _interopRequireDefault(__webpack_require__(32734));

var _index2 = _interopRequireDefault(__webpack_require__(21476));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = (0, _index2.default)(dirtyDate, options);
  var offsetMilliseconds = (0, _index.default)(timeZone, date, true);
  var d = new Date(date.getTime() - offsetMilliseconds);
  var resultDate = new Date(0);
  resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
  return resultDate;
}

module.exports = exports.default;

/***/ }),

/***/ 68516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = zonedTimeToUtc;

var _index = _interopRequireDefault(__webpack_require__(46420));

var _index2 = _interopRequireDefault(__webpack_require__(21476));

var _index3 = _interopRequireDefault(__webpack_require__(7048));

var _index4 = _interopRequireDefault(__webpack_require__(32734));

var _index5 = _interopRequireDefault(__webpack_require__(55721));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name zonedTimeToUtc
 * @category Time Zone Helpers
 * @summary Get the UTC date/time from a date representing local time in a given time zone
 *
 * @description
 * Returns a date instance with the UTC time of the provided date of which the values
 * represented the local time in the time zone specified. In other words, if the input
 * date represented local time in time time zone, the timestamp of the output date will
 * give the equivalent UTC of that local time regardless of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am in Los Angeles is 5pm UTC
 * const result = zonedTimeToUtc(new Date(2014, 5, 25, 10, 0, 0), 'America/Los_Angeles')
 * //=> 2014-06-25T17:00:00.000Z
 */
function zonedTimeToUtc(date, timeZone, options) {
  if (typeof date === 'string' && !date.match(_index3.default)) {
    var extendedOptions = (0, _index.default)(options);
    extendedOptions.timeZone = timeZone;
    return (0, _index2.default)(date, extendedOptions);
  }

  var d = (0, _index2.default)(date, options);
  var utc = (0, _index5.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
  var offsetMilliseconds = (0, _index4.default)(timeZone, new Date(utc));
  return new Date(utc + offsetMilliseconds);
}

module.exports = exports.default;

/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 10797:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 81627:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T_": function() { return /* binding */ e; }
/* harmony export */ });
/* unused harmony export useFormatter */
/* harmony import */ var use_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48143);
function o(r,t){return(...r)=>{try{return t(...r)}catch{throw new Error(void 0)}}}const e=o(0,use_intl__WEBPACK_IMPORTED_MODULE_0__/* .useTranslations */ .T_),n=o(0,use_intl__WEBPACK_IMPORTED_MODULE_0__/* .useFormatter */ .Gb);


/***/ }),

/***/ 48143:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Pj": function() { return /* binding */ w; },
  "Gb": function() { return /* binding */ react_I; },
  "T_": function() { return /* binding */ p; }
});

// UNUSED EXPORTS: useLocale, useMessages, useNow, useTimeZone

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@formatjs/fast-memoize/lib/index.js
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
var ObjectWithoutPrototypeCache = /** @class */ (function () {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function (key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}());
var cacheDefault = {
    create: function create() {
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var types_TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(types_TYPE || (types_TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === types_TYPE.literal;
}
function types_isArgumentElement(el) {
    return el.type === types_TYPE.argument;
}
function types_isNumberElement(el) {
    return el.type === types_TYPE.number;
}
function types_isDateElement(el) {
    return el.type === types_TYPE.date;
}
function types_isTimeElement(el) {
    return el.type === types_TYPE.time;
}
function types_isSelectElement(el) {
    return el.type === types_TYPE.select;
}
function types_isPluralElement(el) {
    return el.type === types_TYPE.plural;
}
function isPoundElement(el) {
    return el.type === types_TYPE.pound;
}
function types_isTagElement(el) {
    return el.type === types_TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: types_TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: types_TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: milliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var parser_Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: types_TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: types_TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: types_TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: types_TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: types_TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: types_TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? types_TYPE.date : types_TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? types_TYPE.number
                            : argType === 'date'
                                ? types_TYPE.date
                                : types_TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6.__assign)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: types_TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: types_TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/manipulator.js


function cloneDeep(obj) {
    if (Array.isArray(obj)) {
        // @ts-expect-error meh
        return __spreadArray([], obj.map(cloneDeep), true);
    }
    if (obj !== null && typeof obj === 'object') {
        // @ts-expect-error meh
        return Object.keys(obj).reduce(function (cloned, k) {
            // @ts-expect-error meh
            cloned[k] = cloneDeep(obj[k]);
            return cloned;
        }, {});
    }
    return obj;
}
function hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function (all, k) {
        var newValue = hoistSelectors(__spreadArray(__spreadArray(__spreadArray([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue,
        };
        return all;
    }, {});
    return cloned;
}
function isPluralOrSelectElement(el) {
    return isPluralElement(el) || isSelectElement(el);
}
function findPluralOrSelectElement(ast) {
    return !!ast.find(function (el) {
        if (isPluralOrSelectElement(el)) {
            return true;
        }
        if (isTagElement(el)) {
            return findPluralOrSelectElement(el.children);
        }
        return false;
    });
}
/**
 * Hoist all selectors to the beginning of the AST & flatten the
 * resulting options. E.g:
 * "I have {count, plural, one{a dog} other{many dogs}}"
 * becomes "{count, plural, one{I have a dog} other{I have many dogs}}".
 * If there are multiple selectors, the order of which one is hoisted 1st
 * is non-deterministic.
 * The goal is to provide as many full sentences as possible since fragmented
 * sentences are not translator-friendly
 * @param ast AST
 */
function hoistSelectors(ast) {
    for (var i = 0; i < ast.length; i++) {
        var el = ast[i];
        if (isPluralOrSelectElement(el)) {
            return [hoistPluralOrSelectElement(ast, el, i)];
        }
        if (isTagElement(el) && findPluralOrSelectElement([el])) {
            throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
        }
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */
function collectVariables(ast, vars) {
    if (vars === void 0) { vars = new Map(); }
    ast.forEach(function (el) {
        if (isArgumentElement(el) ||
            isDateElement(el) ||
            isTimeElement(el) ||
            isNumberElement(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) {
                throw new Error("Variable ".concat(el.value, " has conflicting types"));
            }
            vars.set(el.value, el.type);
        }
        if (isPluralElement(el) || isSelectElement(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function (k) {
                collectVariables(el.options[k].value, vars);
            });
        }
        if (isTagElement(el)) {
            vars.set(el.value, el.type);
            collectVariables(el.children, vars);
        }
    });
}
/**
 * Check if 2 ASTs are structurally the same. This primarily means that
 * they have the same variables with the same type
 * @param a
 * @param b
 * @returns
 */
function isStructurallySame(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    collectVariables(a, aVars);
    collectVariables(b, bVars);
    if (aVars.size !== bVars.size) {
        return {
            success: false,
            error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]")),
        };
    }
    return Array.from(aVars.entries()).reduce(function (result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) {
            return result;
        }
        var bType = bVars.get(key);
        if (bType == null) {
            return {
                success: false,
                error: new Error("Missing variable ".concat(key, " in message")),
            };
        }
        if (bType !== type) {
            return {
                success: false,
                error: new Error("Variable ".concat(key, " has conflicting types: ").concat(TYPE[type], " vs ").concat(TYPE[bType])),
            };
        }
        return result;
    }, { success: true });
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (types_isSelectElement(el) || types_isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (types_isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((types_isDateElement(el) || types_isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (types_isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new parser_Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

// only for testing
var _Parser = (/* unused pure expression or super */ null && (Parser));


;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/error.js

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));


;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (types_isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (types_isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (types_isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (types_isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (types_isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (types_isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (types_isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

;// CONCATENATED MODULE: ./node_modules/intl-messageformat/lib/src/core.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib_es6.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib_es6.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0,tslib_es6.__rest)(_a, ["formatters"]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, parseOpts), { locale: this.resolvedLocale }));
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());


;// CONCATENATED MODULE: ./node_modules/use-intl/dist/esm/production/initializeConfig-zfMDfl5R.js
class initializeConfig_zfMDfl5R_a extends Error{constructor(e,t){let r=e;t&&(r+=": "+t),super(r),this.code=e,t&&(this.originalMessage=t)}}var initializeConfig_zfMDfl5R_s=function(e){return e.MISSING_MESSAGE="MISSING_MESSAGE",e.MISSING_FORMAT="MISSING_FORMAT",e.ENVIRONMENT_FALLBACK="ENVIRONMENT_FALLBACK",e.INSUFFICIENT_PATH="INSUFFICIENT_PATH",e.INVALID_MESSAGE="INVALID_MESSAGE",e.INVALID_KEY="INVALID_KEY",e.FORMATTING_ERROR="FORMATTING_ERROR",e}(initializeConfig_zfMDfl5R_s||{});function i(...e){return e.filter(Boolean).join(".")}function u(e){return i(e.namespace,e.key)}function c(e){console.error(e)}function initializeConfig_zfMDfl5R_m(){return{dateTime:{},number:{},message:{},relativeTime:{},pluralRules:{},list:{},displayNames:{}}}function f(e,t){return memoize(e,{cache:(r=t,{create:()=>({get:e=>r[e],set(e,t){r[e]=t}})}),strategy:strategies.variadic});var r}function l(e,t){return f(((...t)=>new e(...t)),t)}function g(e){return{getDateTimeFormat:l(Intl.DateTimeFormat,e.dateTime),getNumberFormat:l(Intl.NumberFormat,e.number),getPluralRules:l(Intl.PluralRules,e.pluralRules),getRelativeTimeFormat:l(Intl.RelativeTimeFormat,e.relativeTime),getListFormat:l(Intl.ListFormat,e.list),getDisplayNames:l(Intl.DisplayNames,e.displayNames)}}function I(e,t,r,n){const o=i(n,r);if(!t)throw new Error(o);let a=t;return r.split(".").forEach((t=>{const r=a[t];if(null==t||null==r)throw new Error(o+` (${e})`);a=r})),a}function E(n){const o=function(e,t,r,n=c){try{if(!t)throw new Error(void 0);const n=r?I(e,t,r):t;if(!n)throw new Error(r);return n}catch(e){const t=new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.MISSING_MESSAGE,e.message);return n(t),t}}(n.locale,n.messages,n.namespace,n.onError);return function({cache:n,formats:o,formatters:i,getMessageFallback:c=u,locale:m,messagesOrError:l,namespace:g,onError:E,timeZone:S}){const T=l instanceof initializeConfig_zfMDfl5R_a;function N(e,t,r){const n=new initializeConfig_zfMDfl5R_a(t,r);return E(n),c({error:n,key:e,namespace:g})}function y(a,u,E){if(T)return c({error:l,key:a,namespace:g});const y=l;let A,M;try{A=I(m,y,a,g)}catch(e){return N(a,initializeConfig_zfMDfl5R_s.MISSING_MESSAGE,e.message)}if("object"==typeof A){let e,t;return e=Array.isArray(A)?initializeConfig_zfMDfl5R_s.INVALID_MESSAGE:initializeConfig_zfMDfl5R_s.INSUFFICIENT_PATH,N(a,e,t)}const F=function(e,t){return t?void 0:e}(A,u);if(F)return F;i.getMessageFormat||(i.getMessageFormat=function(t,r){return f(((...t)=>new IntlMessageFormat(t[0],t[1],t[2],{formatters:r,...t[3]})),t.message)}(n,i));try{M=i.getMessageFormat(A,m,function(t,r,n){const o=IntlMessageFormat.formats.date,a=IntlMessageFormat.formats.time,s={...t?.dateTime,...r?.dateTime},i={date:{...o,...s},time:{...a,...s},number:{...t?.number,...r?.number}};return n&&["date","time"].forEach((e=>{const t=i[e];for(const[e,r]of Object.entries(t))t[e]={timeZone:n,...r}})),i}(o,E,S),{formatters:{...i,getDateTimeFormat:(e,t)=>i.getDateTimeFormat(e,{timeZone:S,...t})}})}catch(e){const t=e;return N(a,initializeConfig_zfMDfl5R_s.INVALID_MESSAGE,t.message)}try{const e=M.format(u?function(e){const n={};return Object.keys(e).forEach((o=>{let a=0;const s=e[o];let i;i="function"==typeof s?e=>{const n=s(e);return (0,react.isValidElement)(n)?(0,react.cloneElement)(n,{key:o+a++}):n}:s,n[o]=i})),n}(u):u);if(null==e)throw new Error(void 0);return (0,react.isValidElement)(e)||Array.isArray(e)||"string"==typeof e?e:String(e)}catch(e){return N(a,initializeConfig_zfMDfl5R_s.FORMATTING_ERROR,e.message)}}function A(e,t,r){const n=y(e,t,r);return"string"!=typeof n?N(e,initializeConfig_zfMDfl5R_s.INVALID_MESSAGE,void 0):n}return A.rich=y,A.markup=(e,t,r)=>y(e,t,r),A.raw=e=>{if(T)return c({error:l,key:e,namespace:g});const t=l;try{return I(m,t,e,g)}catch(t){return N(e,initializeConfig_zfMDfl5R_s.MISSING_MESSAGE,t.message)}},A.has=e=>{if(T)return!1;try{return I(m,l,e,g),!0}catch{return!1}},A}({...n,messagesOrError:o})}function S(e,t){return e===t?void 0:e.slice((t+".").length)}const T=3600,N=86400,y=7*N,A=2628e3,M=7884e3,F=365*N,R={second:1,seconds:1,minute:60,minutes:60,hour:T,hours:T,day:N,days:N,week:y,weeks:y,month:A,months:A,quarter:M,quarters:M,year:F,years:F};function d(e){const{_cache:t=initializeConfig_zfMDfl5R_m(),_formatters:r=g(t),formats:n,locale:o,onError:i=c,timeZone:u}=e;function f(e){return e?.timeZone||(u?e={...e,timeZone:u}:i(new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.ENVIRONMENT_FALLBACK,void 0))),e}function l(e,t,r,n,o){let u;try{u=function(e,t,r){let n;if("string"==typeof t){const r=t;if(n=e?.[r],!n){const e=new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.MISSING_FORMAT,void 0);throw i(e),e}}else n=t;return r&&(n={...n,...r}),n}(r,e,t)}catch{return o()}try{return n(u)}catch(e){return i(new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.FORMATTING_ERROR,e.message)),o()}}function I(e,t,a){return l(t,a,n?.dateTime,(t=>(t=f(t),r.getDateTimeFormat(o,t).format(e))),(()=>String(e)))}function E(){return e.now?e.now:(i(new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.ENVIRONMENT_FALLBACK,void 0)),new Date)}return{dateTime:I,number:function(e,t,a){return l(t,a,n?.number,(t=>r.getNumberFormat(o,t).format(e)),(()=>String(e)))},relativeTime:function(e,t){try{let n,a;const s={};t instanceof Date||"number"==typeof t?n=new Date(t):t&&(n=null!=t.now?new Date(t.now):E(),a=t.unit,s.style=t.style,s.numberingSystem=t.numberingSystem),n||(n=E());const i=(new Date(e).getTime()-n.getTime())/1e3;a||(a=function(e){const t=Math.abs(e);return t<60?"second":t<T?"minute":t<N?"hour":t<y?"day":t<A?"week":t<F?"month":"year"}(i)),s.numeric="second"===a?"auto":"always";const u=function(e,t){return Math.round(e/R[t])}(i,a);return r.getRelativeTimeFormat(o,s).format(u,a)}catch(t){return i(new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.FORMATTING_ERROR,t.message)),String(e)}},list:function(e,t,a){const s=[],i=new Map;let u=0;for(const t of e){let e;"object"==typeof t?(e=String(u),i.set(e,t)):e=String(t),s.push(e),u++}return l(t,a,n?.list,(e=>{const t=r.getListFormat(o,e).formatToParts(s).map((e=>"literal"===e.type?e.value:i.get(e.value)||e.value));return i.size>0?t:t.join("")}),(()=>String(e)))},dateTimeRange:function(e,t,a,s){return l(a,s,n?.dateTime,(n=>(n=f(n),r.getDateTimeFormat(o,n).formatRange(e,t))),(()=>[I(e),I(t)].join(" – ")))}}}function initializeConfig_zfMDfl5R_h({formats:e,getMessageFallback:t,messages:r,onError:n,...o}){return{...o,formats:e||void 0,messages:r||void 0,onError:n||c,getMessageFallback:t||u}}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/use-intl/dist/esm/production/react.js
const react_d=(0,react.createContext)(void 0);function w({children:e,formats:t,getMessageFallback:n,locale:i,messages:m,now:f,onError:l,timeZone:u}){const w=(0,react.useContext)(react_d),v=(0,react.useMemo)((()=>w?.cache||initializeConfig_zfMDfl5R_m()),[i,w?.cache]),E=(0,react.useMemo)((()=>w?.formatters||g(v)),[v,w?.formatters]),h=(0,react.useMemo)((()=>({...initializeConfig_zfMDfl5R_h({locale:i,formats:void 0===t?w?.formats:t,getMessageFallback:n||w?.getMessageFallback,messages:void 0===m?w?.messages:m,now:f||w?.now,onError:l||w?.onError,timeZone:u||w?.timeZone}),formatters:E,cache:v})),[v,t,E,n,i,m,f,l,w,u]);return (0,jsx_runtime.jsx)(react_d.Provider,{value:h,children:e})}function v(){const e=(0,react.useContext)(react_d);if(!e)throw new Error(void 0);return e}let react_E=!1;const h="undefined"==typeof window;function p(e){return function(e,r,t){const{cache:n,formats:a,formatters:s,getMessageFallback:c,locale:u,onError:g,timeZone:d}=v(),w=e[t],p=S(r,t);return d||react_E||!h||(react_E=!0,g(new initializeConfig_zfMDfl5R_a(initializeConfig_zfMDfl5R_s.ENVIRONMENT_FALLBACK,void 0))),(0,react.useMemo)((()=>E({cache:n,formatters:s,getMessageFallback:c,messages:w,namespace:p,onError:g,formats:a,locale:u,timeZone:d})),[n,s,c,w,p,g,a,u,d])}({"!":v().messages},e?`!.${e}`:"!","!")}function Z(){return v().locale}function b(){return new Date}function react_F(e){const r=e?.updateInterval,{now:o}=v(),[a,s]=t(o||b());return n((()=>{if(!r)return;const e=setInterval((()=>{s(b())}),r);return()=>{clearInterval(e)}}),[o,r]),null==r&&o?o:a}function react_M(){return v().timeZone}function k(){const e=v();if(!e.messages)throw new Error(void 0);return e.messages}function react_I(){const{formats:e,formatters:r,locale:t,now:n,onError:a,timeZone:s}=v();return (0,react.useMemo)((()=>d({formats:e,locale:t,now:n,onError:a,timeZone:s,_formatters:r})),[e,r,n,t,a,s])}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);